export interface SubDistrict {
  subDistrict: Array<{
    id: string,
    zipcode: number,
    text: string,
    value: string,
    name: {
      th: string,
      en: string,
    },
    districtId: number,
  }>
}

export function getSubDistrict(): SubDistrict {
  return {
    subDistrict: [
      {
        id: '100101',
        zipcode: 10200,
        text: 'พระบรมมหาราชวัง',
        value: 'พระบรมมหาราชวัง',
        name: {
          th: 'พระบรมมหาราชวัง',
          en: 'Phra Borom Maha Ratchawang',
        },
        districtId: 1,
      },
      {
        id: '100102',
        zipcode: 10200,
        text: 'วังบูรพาภิรมย์',
        value: 'วังบูรพาภิรมย์',
        name: {
          th: 'วังบูรพาภิรมย์',
          en: 'Wang Burapha Phirom',
        },
        districtId: 1,
      },
      {
        id: '100103',
        zipcode: 10200,
        text: 'วัดราชบพิธ',
        value: 'วัดราชบพิธ',
        name: {
          th: 'วัดราชบพิธ',
          en: 'Wat Ratchabophit',
        },
        districtId: 1,
      },
      {
        id: '100104',
        zipcode: 10200,
        text: 'สำราญราษฎร์',
        value: 'สำราญราษฎร์',
        name: {
          th: 'สำราญราษฎร์',
          en: 'Samran Rat',
        },
        districtId: 1,
      },
      {
        id: '100105',
        zipcode: 10200,
        text: 'ศาลเจ้าพ่อเสือ',
        value: 'ศาลเจ้าพ่อเสือ',
        name: {
          th: 'ศาลเจ้าพ่อเสือ',
          en: 'San Chao Pho Suea',
        },
        districtId: 1,
      },
      {
        id: '100106',
        zipcode: 10200,
        text: 'เสาชิงช้า',
        value: 'เสาชิงช้า',
        name: {
          th: 'เสาชิงช้า',
          en: 'Sao Chingcha',
        },
        districtId: 1,
      },
      {
        id: '100107',
        zipcode: 10200,
        text: 'บวรนิเวศ',
        value: 'บวรนิเวศ',
        name: {
          th: 'บวรนิเวศ',
          en: 'Bowon Niwet',
        },
        districtId: 1,
      },
      {
        id: '100108',
        zipcode: 10200,
        text: 'ตลาดยอด',
        value: 'ตลาดยอด',
        name: {
          th: 'ตลาดยอด',
          en: 'Talat Yot',
        },
        districtId: 1,
      },
      {
        id: '100109',
        zipcode: 10200,
        text: 'ชนะสงคราม',
        value: 'ชนะสงคราม',
        name: {
          th: 'ชนะสงคราม',
          en: 'Chana Songkhram',
        },
        districtId: 1,
      },
      {
        id: '100110',
        zipcode: 10200,
        text: 'บ้านพานถม',
        value: 'บ้านพานถม',
        name: {
          th: 'บ้านพานถม',
          en: 'Ban Phan Thom',
        },
        districtId: 1,
      },
      {
        id: '100111',
        zipcode: 10200,
        text: 'บางขุนพรหม',
        value: 'บางขุนพรหม',
        name: {
          th: 'บางขุนพรหม',
          en: 'Bang Khun Phrom',
        },
        districtId: 1,
      },
      {
        id: '100112',
        zipcode: 10200,
        text: 'วัดสามพระยา',
        value: 'วัดสามพระยา',
        name: {
          th: 'วัดสามพระยา',
          en: 'Wat Sam Phraya',
        },
        districtId: 1,
      },
      {
        id: '100201',
        zipcode: 10300,
        text: 'ดุสิต',
        value: 'ดุสิต',
        name: {
          th: 'ดุสิต',
          en: 'Dusit',
        },
        districtId: 2,
      },
      {
        id: '100202',
        zipcode: 10300,
        text: 'วชิรพยาบาล',
        value: 'วชิรพยาบาล',
        name: {
          th: 'วชิรพยาบาล',
          en: 'Wachiraphayaban',
        },
        districtId: 2,
      },
      {
        id: '100203',
        zipcode: 10300,
        text: 'สวนจิตรลดา',
        value: 'สวนจิตรลดา',
        name: {
          th: 'สวนจิตรลดา',
          en: 'Suan Chit Lada',
        },
        districtId: 2,
      },
      {
        id: '100204',
        zipcode: 10300,
        text: 'สี่แยกมหานาค',
        value: 'สี่แยกมหานาค',
        name: {
          th: 'สี่แยกมหานาค',
          en: 'Si Yaek Maha Nak',
        },
        districtId: 2,
      },
      {
        id: '100206',
        zipcode: 10300,
        text: 'ถนนนครไชยศรี',
        value: 'ถนนนครไชยศรี',
        name: {
          th: 'ถนนนครไชยศรี',
          en: 'Thanon Nakhon Chai Si',
        },
        districtId: 2,
      },
      {
        id: '100301',
        zipcode: 10530,
        text: 'กระทุ่มราย',
        value: 'กระทุ่มราย',
        name: {
          th: 'กระทุ่มราย',
          en: 'Krathum Rai',
        },
        districtId: 3,
      },
      {
        id: '100302',
        zipcode: 10530,
        text: 'หนองจอก',
        value: 'หนองจอก',
        name: {
          th: 'หนองจอก',
          en: 'Nong Chok',
        },
        districtId: 3,
      },
      {
        id: '100303',
        zipcode: 10530,
        text: 'คลองสิบ',
        value: 'คลองสิบ',
        name: {
          th: 'คลองสิบ',
          en: 'Khlong Sip',
        },
        districtId: 3,
      },
      {
        id: '100304',
        zipcode: 10530,
        text: 'คลองสิบสอง',
        value: 'คลองสิบสอง',
        name: {
          th: 'คลองสิบสอง',
          en: 'Khlong Sip Song',
        },
        districtId: 3,
      },
      {
        id: '100305',
        zipcode: 10530,
        text: 'โคกแฝด',
        value: 'โคกแฝด',
        name: {
          th: 'โคกแฝด',
          en: 'Khok Faet',
        },
        districtId: 3,
      },
      {
        id: '100306',
        zipcode: 10530,
        text: 'คู้ฝั่งเหนือ',
        value: 'คู้ฝั่งเหนือ',
        name: {
          th: 'คู้ฝั่งเหนือ',
          en: 'Khu Fang Nuea',
        },
        districtId: 3,
      },
      {
        id: '100307',
        zipcode: 10530,
        text: 'ลำผักชี',
        value: 'ลำผักชี',
        name: {
          th: 'ลำผักชี',
          en: 'Lam Phak Chi',
        },
        districtId: 3,
      },
      {
        id: '100308',
        zipcode: 10530,
        text: 'ลำต้อยติ่ง',
        value: 'ลำต้อยติ่ง',
        name: {
          th: 'ลำต้อยติ่ง',
          en: 'Lam Toiting',
        },
        districtId: 3,
      },
      {
        id: '100401',
        zipcode: 10500,
        text: 'มหาพฤฒาราม',
        value: 'มหาพฤฒาราม',
        name: {
          th: 'มหาพฤฒาราม',
          en: 'Maha Phruettharam',
        },
        districtId: 4,
      },
      {
        id: '100402',
        zipcode: 10500,
        text: 'สีลม',
        value: 'สีลม',
        name: {
          th: 'สีลม',
          en: 'Si Lom',
        },
        districtId: 4,
      },
      {
        id: '100403',
        zipcode: 10500,
        text: 'สุริยวงศ์',
        value: 'สุริยวงศ์',
        name: {
          th: 'สุริยวงศ์',
          en: 'Suriyawong',
        },
        districtId: 4,
      },
      {
        id: '100404',
        zipcode: 10500,
        text: 'บางรัก',
        value: 'บางรัก',
        name: {
          th: 'บางรัก',
          en: 'Bang Rak',
        },
        districtId: 4,
      },
      {
        id: '100405',
        zipcode: 10500,
        text: 'สี่พระยา',
        value: 'สี่พระยา',
        name: {
          th: 'สี่พระยา',
          en: 'Si Phraya',
        },
        districtId: 4,
      },
      {
        id: '100502',
        zipcode: 10220,
        text: 'อนุสาวรีย์',
        value: 'อนุสาวรีย์',
        name: {
          th: 'อนุสาวรีย์',
          en: 'Anusawari',
        },
        districtId: 5,
      },
      {
        id: '100508',
        zipcode: 10220,
        text: 'ท่าแร้ง',
        value: 'ท่าแร้ง',
        name: {
          th: 'ท่าแร้ง',
          en: 'Tha Raeng',
        },
        districtId: 5,
      },
      {
        id: '100601',
        zipcode: 10240,
        text: 'คลองจั่น',
        value: 'คลองจั่น',
        name: {
          th: 'คลองจั่น',
          en: 'Khlong Chan',
        },
        districtId: 6,
      },
      {
        id: '100608',
        zipcode: 10240,
        text: 'หัวหมาก',
        value: 'หัวหมาก',
        name: {
          th: 'หัวหมาก',
          en: 'Hua Mak',
        },
        districtId: 6,
      },
      {
        id: '100701',
        zipcode: 10330,
        text: 'รองเมือง',
        value: 'รองเมือง',
        name: {
          th: 'รองเมือง',
          en: 'Rong Mueang',
        },
        districtId: 7,
      },
      {
        id: '100702',
        zipcode: 10330,
        text: 'วังใหม่',
        value: 'วังใหม่',
        name: {
          th: 'วังใหม่',
          en: 'Wang Mai',
        },
        districtId: 7,
      },
      {
        id: '100703',
        zipcode: 10330,
        text: 'ปทุมวัน',
        value: 'ปทุมวัน',
        name: {
          th: 'ปทุมวัน',
          en: 'Pathum Wan',
        },
        districtId: 7,
      },
      {
        id: '100704',
        zipcode: 10330,
        text: 'ลุมพินี',
        value: 'ลุมพินี',
        name: {
          th: 'ลุมพินี',
          en: 'Lumphini',
        },
        districtId: 7,
      },
      {
        id: '100801',
        zipcode: 10100,
        text: 'ป้อมปราบ',
        value: 'ป้อมปราบ',
        name: {
          th: 'ป้อมปราบ',
          en: 'Pom Prap',
        },
        districtId: 8,
      },
      {
        id: '100802',
        zipcode: 10100,
        text: 'วัดเทพศิรินทร์',
        value: 'วัดเทพศิรินทร์',
        name: {
          th: 'วัดเทพศิรินทร์',
          en: 'Wat Thep Sirin',
        },
        districtId: 8,
      },
      {
        id: '100803',
        zipcode: 10100,
        text: 'คลองมหานาค',
        value: 'คลองมหานาค',
        name: {
          th: 'คลองมหานาค',
          en: 'Khlong Maha Nak',
        },
        districtId: 8,
      },
      {
        id: '100804',
        zipcode: 10100,
        text: 'บ้านบาตร',
        value: 'บ้านบาตร',
        name: {
          th: 'บ้านบาตร',
          en: 'Ban Bat',
        },
        districtId: 8,
      },
      {
        id: '100805',
        zipcode: 10100,
        text: 'วัดโสมนัส',
        value: 'วัดโสมนัส',
        name: {
          th: 'วัดโสมนัส',
          en: 'Wat Sommanat',
        },
        districtId: 8,
      },
      {
        id: '100905',
        zipcode: 10260,
        text: 'บางจาก',
        value: 'บางจาก',
        name: {
          th: 'บางจาก',
          en: 'Bang Chak',
        },
        districtId: 9,
      },
      {
        id: '101001',
        zipcode: 10510,
        text: 'มีนบุรี',
        value: 'มีนบุรี',
        name: {
          th: 'มีนบุรี',
          en: 'Min Buri',
        },
        districtId: 10,
      },
      {
        id: '101002',
        zipcode: 10510,
        text: 'แสนแสบ',
        value: 'แสนแสบ',
        name: {
          th: 'แสนแสบ',
          en: 'Saen Saep',
        },
        districtId: 10,
      },
      {
        id: '101101',
        zipcode: 10520,
        text: 'ลาดกระบัง',
        value: 'ลาดกระบัง',
        name: {
          th: 'ลาดกระบัง',
          en: 'Lat Krabang',
        },
        districtId: 11,
      },
      {
        id: '101102',
        zipcode: 10520,
        text: 'คลองสองต้นนุ่น',
        value: 'คลองสองต้นนุ่น',
        name: {
          th: 'คลองสองต้นนุ่น',
          en: 'Khlong Song Ton Nun',
        },
        districtId: 11,
      },
      {
        id: '101103',
        zipcode: 10520,
        text: 'คลองสามประเวศ',
        value: 'คลองสามประเวศ',
        name: {
          th: 'คลองสามประเวศ',
          en: 'Khlong Sam Prawet',
        },
        districtId: 11,
      },
      {
        id: '101104',
        zipcode: 10520,
        text: 'ลำปลาทิว',
        value: 'ลำปลาทิว',
        name: {
          th: 'ลำปลาทิว',
          en: 'Lam Pla Thio',
        },
        districtId: 11,
      },
      {
        id: '101105',
        zipcode: 10520,
        text: 'ทับยาว',
        value: 'ทับยาว',
        name: {
          th: 'ทับยาว',
          en: 'Thap Yao',
        },
        districtId: 11,
      },
      {
        id: '101106',
        zipcode: 10520,
        text: 'ขุมทอง',
        value: 'ขุมทอง',
        name: {
          th: 'ขุมทอง',
          en: 'Khum Thong',
        },
        districtId: 11,
      },
      {
        id: '101203',
        zipcode: 10120,
        text: 'ช่องนนทรี',
        value: 'ช่องนนทรี',
        name: {
          th: 'ช่องนนทรี',
          en: 'Chong Nonsi',
        },
        districtId: 12,
      },
      {
        id: '101204',
        zipcode: 10120,
        text: 'บางโพงพาง',
        value: 'บางโพงพาง',
        name: {
          th: 'บางโพงพาง',
          en: 'Bang Phongphang',
        },
        districtId: 12,
      },
      {
        id: '101301',
        zipcode: 10100,
        text: 'จักรวรรดิ',
        value: 'จักรวรรดิ',
        name: {
          th: 'จักรวรรดิ',
          en: 'Chakkrawat',
        },
        districtId: 13,
      },
      {
        id: '101302',
        zipcode: 10100,
        text: 'สัมพันธวงศ์',
        value: 'สัมพันธวงศ์',
        name: {
          th: 'สัมพันธวงศ์',
          en: 'Samphanthawong',
        },
        districtId: 13,
      },
      {
        id: '101303',
        zipcode: 10100,
        text: 'ตลาดน้อย',
        value: 'ตลาดน้อย',
        name: {
          th: 'ตลาดน้อย',
          en: 'Talat Noi',
        },
        districtId: 13,
      },
      {
        id: '101401',
        zipcode: 10400,
        text: 'สามเสนใน',
        value: 'สามเสนใน',
        name: {
          th: 'สามเสนใน',
          en: 'Samsen Nai',
        },
        districtId: 14,
      },
      {
        id: '101501',
        zipcode: 10600,
        text: 'วัดกัลยาณ์',
        value: 'วัดกัลยาณ์',
        name: {
          th: 'วัดกัลยาณ์',
          en: 'Wat Kanlaya',
        },
        districtId: 15,
      },
      {
        id: '101502',
        zipcode: 10600,
        text: 'หิรัญรูจี',
        value: 'หิรัญรูจี',
        name: {
          th: 'หิรัญรูจี',
          en: 'Hiran Ruchi',
        },
        districtId: 15,
      },
      {
        id: '101503',
        zipcode: 10600,
        text: 'บางยี่เรือ',
        value: 'บางยี่เรือ',
        name: {
          th: 'บางยี่เรือ',
          en: 'Bang Yi Ruea',
        },
        districtId: 15,
      },
      {
        id: '101504',
        zipcode: 10600,
        text: 'บุคคโล',
        value: 'บุคคโล',
        name: {
          th: 'บุคคโล',
          en: 'Bukkhalo',
        },
        districtId: 15,
      },
      {
        id: '101505',
        zipcode: 10600,
        text: 'ตลาดพลู',
        value: 'ตลาดพลู',
        name: {
          th: 'ตลาดพลู',
          en: 'Talat Phlu',
        },
        districtId: 15,
      },
      {
        id: '101506',
        zipcode: 10600,
        text: 'ดาวคะนอง',
        value: 'ดาวคะนอง',
        name: {
          th: 'ดาวคะนอง',
          en: 'Dao Khanong',
        },
        districtId: 15,
      },
      {
        id: '101507',
        zipcode: 10600,
        text: 'สำเหร่',
        value: 'สำเหร่',
        name: {
          th: 'สำเหร่',
          en: 'Samre',
        },
        districtId: 15,
      },
      {
        id: '101601',
        zipcode: 10600,
        text: 'วัดอรุณ',
        value: 'วัดอรุณ',
        name: {
          th: 'วัดอรุณ',
          en: 'Wat Arun',
        },
        districtId: 16,
      },
      {
        id: '101602',
        zipcode: 10600,
        text: 'วัดท่าพระ',
        value: 'วัดท่าพระ',
        name: {
          th: 'วัดท่าพระ',
          en: 'Wat Tha Phra',
        },
        districtId: 16,
      },
      {
        id: '101701',
        zipcode: 10310,
        text: 'ห้วยขวาง',
        value: 'ห้วยขวาง',
        name: {
          th: 'ห้วยขวาง',
          en: 'Huai Khwang',
        },
        districtId: 17,
      },
      {
        id: '101702',
        zipcode: 10310,
        text: 'บางกะปิ',
        value: 'บางกะปิ',
        name: {
          th: 'บางกะปิ',
          en: 'Bang Kapi',
        },
        districtId: 17,
      },
      {
        id: '101704',
        zipcode: 10310,
        text: 'สามเสนนอก',
        value: 'สามเสนนอก',
        name: {
          th: 'สามเสนนอก',
          en: 'Samsen Nok',
        },
        districtId: 17,
      },
      {
        id: '101801',
        zipcode: 10600,
        text: 'สมเด็จเจ้าพระยา',
        value: 'สมเด็จเจ้าพระยา',
        name: {
          th: 'สมเด็จเจ้าพระยา',
          en: 'Somdet Chao Phraya',
        },
        districtId: 18,
      },
      {
        id: '101802',
        zipcode: 10600,
        text: 'คลองสาน',
        value: 'คลองสาน',
        name: {
          th: 'คลองสาน',
          en: 'Khlong San',
        },
        districtId: 18,
      },
      {
        id: '101803',
        zipcode: 10600,
        text: 'บางลำภูล่าง',
        value: 'บางลำภูล่าง',
        name: {
          th: 'บางลำภูล่าง',
          en: 'Bang Lamphu Lang',
        },
        districtId: 18,
      },
      {
        id: '101804',
        zipcode: 10600,
        text: 'คลองต้นไทร',
        value: 'คลองต้นไทร',
        name: {
          th: 'คลองต้นไทร',
          en: 'Khlong Ton Sai',
        },
        districtId: 18,
      },
      {
        id: '101901',
        zipcode: 10170,
        text: 'คลองชักพระ',
        value: 'คลองชักพระ',
        name: {
          th: 'คลองชักพระ',
          en: 'Khlong Chak Phra',
        },
        districtId: 19,
      },
      {
        id: '101902',
        zipcode: 10170,
        text: 'ตลิ่งชัน',
        value: 'ตลิ่งชัน',
        name: {
          th: 'ตลิ่งชัน',
          en: 'Taling Chan',
        },
        districtId: 19,
      },
      {
        id: '101903',
        zipcode: 10170,
        text: 'ฉิมพลี',
        value: 'ฉิมพลี',
        name: {
          th: 'ฉิมพลี',
          en: 'Chimphli',
        },
        districtId: 19,
      },
      {
        id: '101904',
        zipcode: 10170,
        text: 'บางพรม',
        value: 'บางพรม',
        name: {
          th: 'บางพรม',
          en: 'Bang Phrom',
        },
        districtId: 19,
      },
      {
        id: '101905',
        zipcode: 10170,
        text: 'บางระมาด',
        value: 'บางระมาด',
        name: {
          th: 'บางระมาด',
          en: 'Bang Ramat',
        },
        districtId: 19,
      },
      {
        id: '101907',
        zipcode: 10170,
        text: 'บางเชือกหนัง',
        value: 'บางเชือกหนัง',
        name: {
          th: 'บางเชือกหนัง',
          en: 'Bang Chueak Nang',
        },
        districtId: 19,
      },
      {
        id: '102004',
        zipcode: 10700,
        text: 'ศิริราช',
        value: 'ศิริราช',
        name: {
          th: 'ศิริราช',
          en: 'Siri Rat',
        },
        districtId: 20,
      },
      {
        id: '102005',
        zipcode: 10700,
        text: 'บ้านช่างหล่อ',
        value: 'บ้านช่างหล่อ',
        name: {
          th: 'บ้านช่างหล่อ',
          en: 'Ban Chang Lo',
        },
        districtId: 20,
      },
      {
        id: '102006',
        zipcode: 10700,
        text: 'บางขุนนนท์',
        value: 'บางขุนนนท์',
        name: {
          th: 'บางขุนนนท์',
          en: 'Bang Khun Non',
        },
        districtId: 20,
      },
      {
        id: '102007',
        zipcode: 10700,
        text: 'บางขุนศรี',
        value: 'บางขุนศรี',
        name: {
          th: 'บางขุนศรี',
          en: 'Bang Khun Si',
        },
        districtId: 20,
      },
      {
        id: '102009',
        zipcode: 10700,
        text: 'อรุณอมรินทร์',
        value: 'อรุณอมรินทร์',
        name: {
          th: 'อรุณอมรินทร์',
          en: 'Arun Ammarin',
        },
        districtId: 20,
      },
      {
        id: '102105',
        zipcode: 10150,
        text: 'ท่าข้าม',
        value: 'ท่าข้าม',
        name: {
          th: 'ท่าข้าม',
          en: 'Tha Kham',
        },
        districtId: 21,
      },
      {
        id: '102107',
        zipcode: 10150,
        text: 'แสมดำ',
        value: 'แสมดำ',
        name: {
          th: 'แสมดำ',
          en: 'Samae Dam',
        },
        districtId: 21,
      },
      {
        id: '102201',
        zipcode: 10160,
        text: 'บางหว้า',
        value: 'บางหว้า',
        name: {
          th: 'บางหว้า',
          en: 'Bang Wa',
        },
        districtId: 22,
      },
      {
        id: '102202',
        zipcode: 10160,
        text: 'บางด้วน',
        value: 'บางด้วน',
        name: {
          th: 'บางด้วน',
          en: 'Bang Duan',
        },
        districtId: 22,
      },
      {
        id: '102203',
        zipcode: 10160,
        text: 'บางแค',
        value: 'บางแค',
        name: {
          th: 'บางแค',
          en: 'Bang Kae',
        },
        districtId: 22,
      },
      {
        id: '102204',
        zipcode: 10160,
        text: 'บางแคเหนือ',
        value: 'บางแคเหนือ',
        name: {
          th: 'บางแคเหนือ',
          en: 'Bang Kae Nua',
        },
        districtId: 22,
      },
      {
        id: '102205',
        zipcode: 10160,
        text: 'บางไผ่',
        value: 'บางไผ่',
        name: {
          th: 'บางไผ่',
          en: 'Bang Phai',
        },
        districtId: 22,
      },
      {
        id: '102206',
        zipcode: 10160,
        text: 'บางจาก',
        value: 'บางจาก',
        name: {
          th: 'บางจาก',
          en: 'Bang Chak',
        },
        districtId: 22,
      },
      {
        id: '102207',
        zipcode: 10160,
        text: 'บางแวก',
        value: 'บางแวก',
        name: {
          th: 'บางแวก',
          en: 'Bang Waek',
        },
        districtId: 22,
      },
      {
        id: '102208',
        zipcode: 10160,
        text: 'คลองขวาง',
        value: 'คลองขวาง',
        name: {
          th: 'คลองขวาง',
          en: 'Khlong Khwang',
        },
        districtId: 22,
      },
      {
        id: '102209',
        zipcode: 10160,
        text: 'ปากคลองภาษีเจริญ',
        value: 'ปากคลองภาษีเจริญ',
        name: {
          th: 'ปากคลองภาษีเจริญ',
          en: 'Pak Khlong Phasi Charoen',
        },
        districtId: 22,
      },
      {
        id: '102210',
        zipcode: 10160,
        text: 'คูหาสวรรค์',
        value: 'คูหาสวรรค์',
        name: {
          th: 'คูหาสวรรค์',
          en: 'Khuha Sawan',
        },
        districtId: 22,
      },
      {
        id: '102302',
        zipcode: 10160,
        text: 'หนองแขม',
        value: 'หนองแขม',
        name: {
          th: 'หนองแขม',
          en: 'Nong Khaem',
        },
        districtId: 23,
      },
      {
        id: '102303',
        zipcode: 10160,
        text: 'หนองค้างพลู',
        value: 'หนองค้างพลู',
        name: {
          th: 'หนองค้างพลู',
          en: 'Nong Khang Phlu',
        },
        districtId: 23,
      },
      {
        id: '102401',
        zipcode: 10140,
        text: 'ราษฎร์บูรณะ',
        value: 'ราษฎร์บูรณะ',
        name: {
          th: 'ราษฎร์บูรณะ',
          en: 'Rat Burana',
        },
        districtId: 24,
      },
      {
        id: '102402',
        zipcode: 10140,
        text: 'บางปะกอก',
        value: 'บางปะกอก',
        name: {
          th: 'บางปะกอก',
          en: 'Bang Pakok',
        },
        districtId: 24,
      },
      {
        id: '102403',
        zipcode: 10140,
        text: 'บางมด*',
        value: 'บางมด*',
        name: {
          th: 'บางมด*',
          en: 'Bang Mod*',
        },
        districtId: 24,
      },
      {
        id: '102404',
        zipcode: 10140,
        text: 'ทุ่งครุ*',
        value: 'ทุ่งครุ*',
        name: {
          th: 'ทุ่งครุ*',
          en: 'Thung Khru*',
        },
        districtId: 24,
      },
      {
        id: '102501',
        zipcode: 10700,
        text: 'บางพลัด',
        value: 'บางพลัด',
        name: {
          th: 'บางพลัด',
          en: 'Bang Phlat',
        },
        districtId: 25,
      },
      {
        id: '102502',
        zipcode: 10700,
        text: 'บางอ้อ',
        value: 'บางอ้อ',
        name: {
          th: 'บางอ้อ',
          en: 'Bang O',
        },
        districtId: 25,
      },
      {
        id: '102503',
        zipcode: 10700,
        text: 'บางบำหรุ',
        value: 'บางบำหรุ',
        name: {
          th: 'บางบำหรุ',
          en: 'Bang Bamru',
        },
        districtId: 25,
      },
      {
        id: '102504',
        zipcode: 10700,
        text: 'บางยี่ขัน',
        value: 'บางยี่ขัน',
        name: {
          th: 'บางยี่ขัน',
          en: 'Bang Yi Khan',
        },
        districtId: 25,
      },
      {
        id: '102601',
        zipcode: 10400,
        text: 'ดินแดง',
        value: 'ดินแดง',
        name: {
          th: 'ดินแดง',
          en: 'Din Daeng',
        },
        districtId: 26,
      },
      {
        id: '102701',
        zipcode: 10240,
        text: 'คลองกุ่ม',
        value: 'คลองกุ่ม',
        name: {
          th: 'คลองกุ่ม',
          en: 'Khlong Kum',
        },
        districtId: 27,
      },
      {
        id: '102702',
        zipcode: 10240,
        text: 'สะพานสูง',
        value: 'สะพานสูง',
        name: {
          th: 'สะพานสูง',
          en: 'Saphan Sung',
        },
        districtId: 27,
      },
      {
        id: '102703',
        zipcode: 10240,
        text: 'คันนายาว',
        value: 'คันนายาว',
        name: {
          th: 'คันนายาว',
          en: 'Khan Na Yao',
        },
        districtId: 27,
      },
      {
        id: '102801',
        zipcode: 10120,
        text: 'ทุ่งวัดดอน',
        value: 'ทุ่งวัดดอน',
        name: {
          th: 'ทุ่งวัดดอน',
          en: 'Thung Wat Don',
        },
        districtId: 28,
      },
      {
        id: '102802',
        zipcode: 10120,
        text: 'ยานนาวา',
        value: 'ยานนาวา',
        name: {
          th: 'ยานนาวา',
          en: 'Yan Nawa',
        },
        districtId: 28,
      },
      {
        id: '102803',
        zipcode: 10120,
        text: 'ทุ่งมหาเมฆ',
        value: 'ทุ่งมหาเมฆ',
        name: {
          th: 'ทุ่งมหาเมฆ',
          en: 'Thung Maha Mek',
        },
        districtId: 28,
      },
      {
        id: '102901',
        zipcode: 10800,
        text: 'บางซื่อ',
        value: 'บางซื่อ',
        name: {
          th: 'บางซื่อ',
          en: 'Bang Sue',
        },
        districtId: 29,
      },
      {
        id: '103001',
        zipcode: 10900,
        text: 'ลาดยาว',
        value: 'ลาดยาว',
        name: {
          th: 'ลาดยาว',
          en: 'Lat Yao',
        },
        districtId: 30,
      },
      {
        id: '103002',
        zipcode: 10900,
        text: 'เสนานิคม',
        value: 'เสนานิคม',
        name: {
          th: 'เสนานิคม',
          en: 'Sena Nikhom',
        },
        districtId: 30,
      },
      {
        id: '103003',
        zipcode: 10900,
        text: 'จันทรเกษม',
        value: 'จันทรเกษม',
        name: {
          th: 'จันทรเกษม',
          en: 'Chan Kasem',
        },
        districtId: 30,
      },
      {
        id: '103004',
        zipcode: 10900,
        text: 'จอมพล',
        value: 'จอมพล',
        name: {
          th: 'จอมพล',
          en: 'Chom Phon',
        },
        districtId: 30,
      },
      {
        id: '103005',
        zipcode: 10900,
        text: 'จตุจักร',
        value: 'จตุจักร',
        name: {
          th: 'จตุจักร',
          en: 'Chatuchak',
        },
        districtId: 30,
      },
      {
        id: '103101',
        zipcode: 10120,
        text: 'บางคอแหลม',
        value: 'บางคอแหลม',
        name: {
          th: 'บางคอแหลม',
          en: 'Bang Kho Laem',
        },
        districtId: 31,
      },
      {
        id: '103102',
        zipcode: 10120,
        text: 'วัดพระยาไกร',
        value: 'วัดพระยาไกร',
        name: {
          th: 'วัดพระยาไกร',
          en: 'Wat Phraya Krai',
        },
        districtId: 31,
      },
      {
        id: '103103',
        zipcode: 10120,
        text: 'บางโคล่',
        value: 'บางโคล่',
        name: {
          th: 'บางโคล่',
          en: 'Bang Khlo',
        },
        districtId: 31,
      },
      {
        id: '103201',
        zipcode: 10250,
        text: 'ประเวศ',
        value: 'ประเวศ',
        name: {
          th: 'ประเวศ',
          en: 'Prawet',
        },
        districtId: 32,
      },
      {
        id: '103202',
        zipcode: 10250,
        text: 'หนองบอน',
        value: 'หนองบอน',
        name: {
          th: 'หนองบอน',
          en: 'Nong Bon',
        },
        districtId: 32,
      },
      {
        id: '103203',
        zipcode: 10250,
        text: 'ดอกไม้',
        value: 'ดอกไม้',
        name: {
          th: 'ดอกไม้',
          en: 'Dokmai',
        },
        districtId: 32,
      },
      {
        id: '103204',
        zipcode: 10250,
        text: 'สวนหลวง',
        value: 'สวนหลวง',
        name: {
          th: 'สวนหลวง',
          en: 'Suan Luang',
        },
        districtId: 32,
      },
      {
        id: '103301',
        zipcode: 10110,
        text: 'คลองเตย',
        value: 'คลองเตย',
        name: {
          th: 'คลองเตย',
          en: 'Khlong Toei',
        },
        districtId: 33,
      },
      {
        id: '103302',
        zipcode: 10110,
        text: 'คลองตัน',
        value: 'คลองตัน',
        name: {
          th: 'คลองตัน',
          en: 'Khlong Tan',
        },
        districtId: 33,
      },
      {
        id: '103303',
        zipcode: 10110,
        text: 'พระโขนง',
        value: 'พระโขนง',
        name: {
          th: 'พระโขนง',
          en: 'Phra Khanong',
        },
        districtId: 33,
      },
      {
        id: '103304',
        zipcode: 10110,
        text: 'คลองเตยเหนือ',
        value: 'คลองเตยเหนือ',
        name: {
          th: 'คลองเตยเหนือ',
          en: 'Khlong Toei Nua',
        },
        districtId: 33,
      },
      {
        id: '103305',
        zipcode: 10110,
        text: 'คลองตันเหนือ',
        value: 'คลองตันเหนือ',
        name: {
          th: 'คลองตันเหนือ',
          en: 'Khlong Tan Nua',
        },
        districtId: 33,
      },
      {
        id: '103306',
        zipcode: 10110,
        text: 'พระโขนงเหนือ',
        value: 'พระโขนงเหนือ',
        name: {
          th: 'พระโขนงเหนือ',
          en: 'Phra Khanong Nua',
        },
        districtId: 33,
      },
      {
        id: '103401',
        zipcode: 10250,
        text: 'สวนหลวง',
        value: 'สวนหลวง',
        name: {
          th: 'สวนหลวง',
          en: 'Suan Luang',
        },
        districtId: 34,
      },
      {
        id: '103501',
        zipcode: 10150,
        text: 'บางขุนเทียน',
        value: 'บางขุนเทียน',
        name: {
          th: 'บางขุนเทียน',
          en: 'Bang Khun Thian',
        },
        districtId: 35,
      },
      {
        id: '103502',
        zipcode: 10150,
        text: 'บางค้อ',
        value: 'บางค้อ',
        name: {
          th: 'บางค้อ',
          en: 'Bang Kho',
        },
        districtId: 35,
      },
      {
        id: '103503',
        zipcode: 10150,
        text: 'บางมด',
        value: 'บางมด',
        name: {
          th: 'บางมด',
          en: 'Bang Mot',
        },
        districtId: 35,
      },
      {
        id: '103504',
        zipcode: 10150,
        text: 'จอมทอง',
        value: 'จอมทอง',
        name: {
          th: 'จอมทอง',
          en: 'Chom Thong',
        },
        districtId: 35,
      },
      {
        id: '103602',
        zipcode: 10210,
        text: 'สีกัน',
        value: 'สีกัน',
        name: {
          th: 'สีกัน',
          en: 'Si Kan',
        },
        districtId: 36,
      },
      {
        id: '103701',
        zipcode: 10400,
        text: 'ทุ่งพญาไท',
        value: 'ทุ่งพญาไท',
        name: {
          th: 'ทุ่งพญาไท',
          en: 'Thung Phaya Thai',
        },
        districtId: 37,
      },
      {
        id: '103702',
        zipcode: 10400,
        text: 'ถนนพญาไท',
        value: 'ถนนพญาไท',
        name: {
          th: 'ถนนพญาไท',
          en: 'Thanon Phaya Thai',
        },
        districtId: 37,
      },
      {
        id: '103703',
        zipcode: 10400,
        text: 'ถนนเพชรบุรี',
        value: 'ถนนเพชรบุรี',
        name: {
          th: 'ถนนเพชรบุรี',
          en: 'Thanon Phetchaburi',
        },
        districtId: 37,
      },
      {
        id: '103704',
        zipcode: 10400,
        text: 'มักกะสัน',
        value: 'มักกะสัน',
        name: {
          th: 'มักกะสัน',
          en: 'Makkasan',
        },
        districtId: 37,
      },
      {
        id: '103801',
        zipcode: 10230,
        text: 'ลาดพร้าว',
        value: 'ลาดพร้าว',
        name: {
          th: 'ลาดพร้าว',
          en: 'Lat Phrao',
        },
        districtId: 38,
      },
      {
        id: '103802',
        zipcode: 10230,
        text: 'จรเข้บัว',
        value: 'จรเข้บัว',
        name: {
          th: 'จรเข้บัว',
          en: 'Chorakhe Bua',
        },
        districtId: 38,
      },
      {
        id: '103901',
        zipcode: 10110,
        text: 'คลองเตยเหนือ',
        value: 'คลองเตยเหนือ',
        name: {
          th: 'คลองเตยเหนือ',
          en: 'Khlong Toei Nuea',
        },
        districtId: 39,
      },
      {
        id: '103902',
        zipcode: 10110,
        text: 'คลองตันเหนือ',
        value: 'คลองตันเหนือ',
        name: {
          th: 'คลองตันเหนือ',
          en: 'Khlong Tan Nuea',
        },
        districtId: 39,
      },
      {
        id: '103903',
        zipcode: 10110,
        text: 'พระโขนงเหนือ',
        value: 'พระโขนงเหนือ',
        name: {
          th: 'พระโขนงเหนือ',
          en: 'Phra Khanong Nuea',
        },
        districtId: 39,
      },
      {
        id: '104001',
        zipcode: 10160,
        text: 'บางแค',
        value: 'บางแค',
        name: {
          th: 'บางแค',
          en: 'Bang Khae',
        },
        districtId: 40,
      },
      {
        id: '104002',
        zipcode: 10160,
        text: 'บางแคเหนือ',
        value: 'บางแคเหนือ',
        name: {
          th: 'บางแคเหนือ',
          en: 'Bang Khae Nuea',
        },
        districtId: 40,
      },
      {
        id: '104003',
        zipcode: 10160,
        text: 'บางไผ่',
        value: 'บางไผ่',
        name: {
          th: 'บางไผ่',
          en: 'Bang Phai',
        },
        districtId: 40,
      },
      {
        id: '104004',
        zipcode: 10160,
        text: 'หลักสอง',
        value: 'หลักสอง',
        name: {
          th: 'หลักสอง',
          en: 'Lak Song',
        },
        districtId: 40,
      },
      {
        id: '104101',
        zipcode: 10210,
        text: 'ทุ่งสองห้อง',
        value: 'ทุ่งสองห้อง',
        name: {
          th: 'ทุ่งสองห้อง',
          en: 'Thung Song Hong',
        },
        districtId: 41,
      },
      {
        id: '104102',
        zipcode: 10210,
        text: 'ตลาดบางเขน',
        value: 'ตลาดบางเขน',
        name: {
          th: 'ตลาดบางเขน',
          en: 'Talat Bang Khen',
        },
        districtId: 41,
      },
      {
        id: '104201',
        zipcode: 10220,
        text: 'สายไหม',
        value: 'สายไหม',
        name: {
          th: 'สายไหม',
          en: 'Sai Mai',
        },
        districtId: 42,
      },
      {
        id: '104202',
        zipcode: 10220,
        text: 'ออเงิน',
        value: 'ออเงิน',
        name: {
          th: 'ออเงิน',
          en: 'O Ngoen',
        },
        districtId: 42,
      },
      {
        id: '104203',
        zipcode: 10220,
        text: 'คลองถนน',
        value: 'คลองถนน',
        name: {
          th: 'คลองถนน',
          en: 'Khlong Thanon',
        },
        districtId: 42,
      },
      {
        id: '104301',
        zipcode: 10230,
        text: 'คันนายาว',
        value: 'คันนายาว',
        name: {
          th: 'คันนายาว',
          en: 'Khan Na Yao',
        },
        districtId: 43,
      },
      {
        id: '104401',
        zipcode: 10240,
        text: 'สะพานสูง',
        value: 'สะพานสูง',
        name: {
          th: 'สะพานสูง',
          en: 'Sapan Sung',
        },
        districtId: 44,
      },
      {
        id: '104501',
        zipcode: 10310,
        text: 'วังทองหลาง',
        value: 'วังทองหลาง',
        name: {
          th: 'วังทองหลาง',
          en: 'Wang Thonglang',
        },
        districtId: 45,
      },
      {
        id: '104601',
        zipcode: 10510,
        text: 'สามวาตะวันตก',
        value: 'สามวาตะวันตก',
        name: {
          th: 'สามวาตะวันตก',
          en: 'Sam Wa Tawantok',
        },
        districtId: 46,
      },
      {
        id: '104602',
        zipcode: 10510,
        text: 'สามวาตะวันออก',
        value: 'สามวาตะวันออก',
        name: {
          th: 'สามวาตะวันออก',
          en: 'Sam Wa Tawan-ok',
        },
        districtId: 46,
      },
      {
        id: '104603',
        zipcode: 10510,
        text: 'บางชัน',
        value: 'บางชัน',
        name: {
          th: 'บางชัน',
          en: 'Bang Chan',
        },
        districtId: 46,
      },
      {
        id: '104604',
        zipcode: 10510,
        text: 'ทรายกองดิน',
        value: 'ทรายกองดิน',
        name: {
          th: 'ทรายกองดิน',
          en: 'Sai Kong Din',
        },
        districtId: 46,
      },
      {
        id: '104605',
        zipcode: 10510,
        text: 'ทรายกองดินใต้',
        value: 'ทรายกองดินใต้',
        name: {
          th: 'ทรายกองดินใต้',
          en: 'Sai Kong Din Tai',
        },
        districtId: 46,
      },
      {
        id: '104701',
        zipcode: 10260,
        text: 'บางนา',
        value: 'บางนา',
        name: {
          th: 'บางนา',
          en: 'Bang Na',
        },
        districtId: 47,
      },
      {
        id: '104801',
        zipcode: 10170,
        text: 'ทวีวัฒนา',
        value: 'ทวีวัฒนา',
        name: {
          th: 'ทวีวัฒนา',
          en: 'Thawi Watthana',
        },
        districtId: 48,
      },
      {
        id: '104802',
        zipcode: 10170,
        text: 'ศาลาธรรมสพน์',
        value: 'ศาลาธรรมสพน์',
        name: {
          th: 'ศาลาธรรมสพน์',
          en: 'Sala Thammasop',
        },
        districtId: 48,
      },
      {
        id: '104901',
        zipcode: 10140,
        text: 'บางมด',
        value: 'บางมด',
        name: {
          th: 'บางมด',
          en: 'Bang Mot',
        },
        districtId: 49,
      },
      {
        id: '104902',
        zipcode: 10140,
        text: 'ทุ่งครุ',
        value: 'ทุ่งครุ',
        name: {
          th: 'ทุ่งครุ',
          en: 'Thung Khru',
        },
        districtId: 49,
      },
      {
        id: '105001',
        zipcode: 10150,
        text: 'บางบอน',
        value: 'บางบอน',
        name: {
          th: 'บางบอน',
          en: 'Bang Bon',
        },
        districtId: 50,
      },
      {
        id: '110101',
        zipcode: 10270,
        text: 'ปากน้ำ',
        value: 'ปากน้ำ',
        name: {
          th: 'ปากน้ำ',
          en: 'Pak Nam',
        },
        districtId: 52,
      },
      {
        id: '110102',
        zipcode: 10270,
        text: 'สำโรงเหนือ',
        value: 'สำโรงเหนือ',
        name: {
          th: 'สำโรงเหนือ',
          en: 'Samrong Nuea',
        },
        districtId: 52,
      },
      {
        id: '110103',
        zipcode: 10270,
        text: 'บางเมือง',
        value: 'บางเมือง',
        name: {
          th: 'บางเมือง',
          en: 'Bang Mueang',
        },
        districtId: 52,
      },
      {
        id: '110104',
        zipcode: 10280,
        text: 'ท้ายบ้าน',
        value: 'ท้ายบ้าน',
        name: {
          th: 'ท้ายบ้าน',
          en: 'Thai Ban',
        },
        districtId: 52,
      },
      {
        id: '110108',
        zipcode: 10280,
        text: 'บางปูใหม่',
        value: 'บางปูใหม่',
        name: {
          th: 'บางปูใหม่',
          en: 'Bang Pu Mai',
        },
        districtId: 52,
      },
      {
        id: '110110',
        zipcode: 10280,
        text: 'แพรกษา',
        value: 'แพรกษา',
        name: {
          th: 'แพรกษา',
          en: 'Phraek Sa',
        },
        districtId: 52,
      },
      {
        id: '110111',
        zipcode: 10270,
        text: 'บางโปรง',
        value: 'บางโปรง',
        name: {
          th: 'บางโปรง',
          en: 'Bang Prong',
        },
        districtId: 52,
      },
      {
        id: '110112',
        zipcode: 10270,
        text: 'บางปู',
        value: 'บางปู',
        name: {
          th: 'บางปู',
          en: 'Bang Pu',
        },
        districtId: 52,
      },
      {
        id: '110113',
        zipcode: 10270,
        text: 'บางด้วน',
        value: 'บางด้วน',
        name: {
          th: 'บางด้วน',
          en: 'Bang Duan',
        },
        districtId: 52,
      },
      {
        id: '110114',
        zipcode: 10270,
        text: 'บางเมืองใหม่',
        value: 'บางเมืองใหม่',
        name: {
          th: 'บางเมืองใหม่',
          en: 'Bang Mueang Mai',
        },
        districtId: 52,
      },
      {
        id: '110115',
        zipcode: 10270,
        text: 'เทพารักษ์',
        value: 'เทพารักษ์',
        name: {
          th: 'เทพารักษ์',
          en: 'Thepharak',
        },
        districtId: 52,
      },
      {
        id: '110116',
        zipcode: 10280,
        text: 'ท้ายบ้านใหม่',
        value: 'ท้ายบ้านใหม่',
        name: {
          th: 'ท้ายบ้านใหม่',
          en: 'Thai Ban Mai',
        },
        districtId: 52,
      },
      {
        id: '110117',
        zipcode: 10280,
        text: 'แพรกษาใหม่',
        value: 'แพรกษาใหม่',
        name: {
          th: 'แพรกษาใหม่',
          en: 'Phraek Sa Mai',
        },
        districtId: 52,
      },
      {
        id: '110201',
        zipcode: 10560,
        text: 'บางบ่อ',
        value: 'บางบ่อ',
        name: {
          th: 'บางบ่อ',
          en: 'Bang Bo',
        },
        districtId: 53,
      },
      {
        id: '110202',
        zipcode: 10560,
        text: 'บ้านระกาศ',
        value: 'บ้านระกาศ',
        name: {
          th: 'บ้านระกาศ',
          en: 'Ban Rakat',
        },
        districtId: 53,
      },
      {
        id: '110203',
        zipcode: 10560,
        text: 'บางพลีน้อย',
        value: 'บางพลีน้อย',
        name: {
          th: 'บางพลีน้อย',
          en: 'Bang Phli Noi',
        },
        districtId: 53,
      },
      {
        id: '110204',
        zipcode: 10560,
        text: 'บางเพรียง',
        value: 'บางเพรียง',
        name: {
          th: 'บางเพรียง',
          en: 'Bang Phriang',
        },
        districtId: 53,
      },
      {
        id: '110205',
        zipcode: 10550,
        text: 'คลองด่าน',
        value: 'คลองด่าน',
        name: {
          th: 'คลองด่าน',
          en: 'Khlong Dan',
        },
        districtId: 53,
      },
      {
        id: '110206',
        zipcode: 10560,
        text: 'คลองสวน',
        value: 'คลองสวน',
        name: {
          th: 'คลองสวน',
          en: 'Khlong Suan',
        },
        districtId: 53,
      },
      {
        id: '110207',
        zipcode: 10560,
        text: 'เปร็ง',
        value: 'เปร็ง',
        name: {
          th: 'เปร็ง',
          en: 'Preng',
        },
        districtId: 53,
      },
      {
        id: '110208',
        zipcode: 10560,
        text: 'คลองนิยมยาตรา',
        value: 'คลองนิยมยาตรา',
        name: {
          th: 'คลองนิยมยาตรา',
          en: 'Khlong Niyom Yattra',
        },
        districtId: 53,
      },
      {
        id: '110301',
        zipcode: 10540,
        text: 'บางพลีใหญ่',
        value: 'บางพลีใหญ่',
        name: {
          th: 'บางพลีใหญ่',
          en: 'Bang Phli Yai',
        },
        districtId: 54,
      },
      {
        id: '110302',
        zipcode: 10540,
        text: 'บางแก้ว',
        value: 'บางแก้ว',
        name: {
          th: 'บางแก้ว',
          en: 'Bang Kaeo',
        },
        districtId: 54,
      },
      {
        id: '110303',
        zipcode: 10540,
        text: 'บางปลา',
        value: 'บางปลา',
        name: {
          th: 'บางปลา',
          en: 'Bang Pla',
        },
        districtId: 54,
      },
      {
        id: '110304',
        zipcode: 10540,
        text: 'บางโฉลง',
        value: 'บางโฉลง',
        name: {
          th: 'บางโฉลง',
          en: 'Bang Chalong',
        },
        districtId: 54,
      },
      {
        id: '110308',
        zipcode: 10540,
        text: 'ราชาเทวะ',
        value: 'ราชาเทวะ',
        name: {
          th: 'ราชาเทวะ',
          en: 'Racha Thewa',
        },
        districtId: 54,
      },
      {
        id: '110309',
        zipcode: 10540,
        text: 'หนองปรือ',
        value: 'หนองปรือ',
        name: {
          th: 'หนองปรือ',
          en: 'Nong Prue',
        },
        districtId: 54,
      },
      {
        id: '110401',
        zipcode: 10130,
        text: 'ตลาด',
        value: 'ตลาด',
        name: {
          th: 'ตลาด',
          en: 'Talat',
        },
        districtId: 55,
      },
      {
        id: '110402',
        zipcode: 10130,
        text: 'บางพึ่ง',
        value: 'บางพึ่ง',
        name: {
          th: 'บางพึ่ง',
          en: 'Bang Phueng',
        },
        districtId: 55,
      },
      {
        id: '110403',
        zipcode: 10130,
        text: 'บางจาก',
        value: 'บางจาก',
        name: {
          th: 'บางจาก',
          en: 'Bang Chak',
        },
        districtId: 55,
      },
      {
        id: '110404',
        zipcode: 10130,
        text: 'บางครุ',
        value: 'บางครุ',
        name: {
          th: 'บางครุ',
          en: 'Bang Khru',
        },
        districtId: 55,
      },
      {
        id: '110405',
        zipcode: 10130,
        text: 'บางหญ้าแพรก',
        value: 'บางหญ้าแพรก',
        name: {
          th: 'บางหญ้าแพรก',
          en: 'Bang Ya Phraek',
        },
        districtId: 55,
      },
      {
        id: '110406',
        zipcode: 10130,
        text: 'บางหัวเสือ',
        value: 'บางหัวเสือ',
        name: {
          th: 'บางหัวเสือ',
          en: 'Bang Hua Suea',
        },
        districtId: 55,
      },
      {
        id: '110407',
        zipcode: 10130,
        text: 'สำโรงใต้',
        value: 'สำโรงใต้',
        name: {
          th: 'สำโรงใต้',
          en: 'Samrong Tai',
        },
        districtId: 55,
      },
      {
        id: '110408',
        zipcode: 10130,
        text: 'บางยอ',
        value: 'บางยอ',
        name: {
          th: 'บางยอ',
          en: 'Bang Yo',
        },
        districtId: 55,
      },
      {
        id: '110409',
        zipcode: 10130,
        text: 'บางกะเจ้า',
        value: 'บางกะเจ้า',
        name: {
          th: 'บางกะเจ้า',
          en: 'Bang Kachao',
        },
        districtId: 55,
      },
      {
        id: '110410',
        zipcode: 10130,
        text: 'บางน้ำผึ้ง',
        value: 'บางน้ำผึ้ง',
        name: {
          th: 'บางน้ำผึ้ง',
          en: 'Bang Namphueng',
        },
        districtId: 55,
      },
      {
        id: '110411',
        zipcode: 10130,
        text: 'บางกระสอบ',
        value: 'บางกระสอบ',
        name: {
          th: 'บางกระสอบ',
          en: 'Bang Krasop',
        },
        districtId: 55,
      },
      {
        id: '110412',
        zipcode: 10130,
        text: 'บางกอบัว',
        value: 'บางกอบัว',
        name: {
          th: 'บางกอบัว',
          en: 'Bang Ko Bua',
        },
        districtId: 55,
      },
      {
        id: '110413',
        zipcode: 10130,
        text: 'ทรงคนอง',
        value: 'ทรงคนอง',
        name: {
          th: 'ทรงคนอง',
          en: 'Song Khanong',
        },
        districtId: 55,
      },
      {
        id: '110414',
        zipcode: 10130,
        text: 'สำโรง',
        value: 'สำโรง',
        name: {
          th: 'สำโรง',
          en: 'Samrong',
        },
        districtId: 55,
      },
      {
        id: '110415',
        zipcode: 10130,
        text: 'สำโรงกลาง',
        value: 'สำโรงกลาง',
        name: {
          th: 'สำโรงกลาง',
          en: 'Samrong Klang',
        },
        districtId: 55,
      },
      {
        id: '110501',
        zipcode: 10290,
        text: 'นาเกลือ',
        value: 'นาเกลือ',
        name: {
          th: 'นาเกลือ',
          en: 'Na Kluea',
        },
        districtId: 56,
      },
      {
        id: '110502',
        zipcode: 10290,
        text: 'บ้านคลองสวน',
        value: 'บ้านคลองสวน',
        name: {
          th: 'บ้านคลองสวน',
          en: 'Ban Khlong Suan',
        },
        districtId: 56,
      },
      {
        id: '110503',
        zipcode: 10290,
        text: 'แหลมฟ้าผ่า',
        value: 'แหลมฟ้าผ่า',
        name: {
          th: 'แหลมฟ้าผ่า',
          en: 'Laem Fa Pha',
        },
        districtId: 56,
      },
      {
        id: '110504',
        zipcode: 10290,
        text: 'ปากคลองบางปลากด',
        value: 'ปากคลองบางปลากด',
        name: {
          th: 'ปากคลองบางปลากด',
          en: 'Pak Klong Bang Pla Kot',
        },
        districtId: 56,
      },
      {
        id: '110505',
        zipcode: 10290,
        text: 'ในคลองบางปลากด',
        value: 'ในคลองบางปลากด',
        name: {
          th: 'ในคลองบางปลากด',
          en: 'Nai Khlong Bang Pla Kot',
        },
        districtId: 56,
      },
      {
        id: '110601',
        zipcode: 10540,
        text: 'บางเสาธง',
        value: 'บางเสาธง',
        name: {
          th: 'บางเสาธง',
          en: 'Bang Sao Thong',
        },
        districtId: 57,
      },
      {
        id: '110602',
        zipcode: 10540,
        text: 'ศีรษะจรเข้น้อย',
        value: 'ศีรษะจรเข้น้อย',
        name: {
          th: 'ศีรษะจรเข้น้อย',
          en: 'Sisa Chorakhe Noi',
        },
        districtId: 57,
      },
      {
        id: '110603',
        zipcode: 10540,
        text: 'ศีรษะจรเข้ใหญ่',
        value: 'ศีรษะจรเข้ใหญ่',
        name: {
          th: 'ศีรษะจรเข้ใหญ่',
          en: 'Sisa Chorakhe Yai',
        },
        districtId: 57,
      },
      {
        id: '120101',
        zipcode: 11000,
        text: 'สวนใหญ่',
        value: 'สวนใหญ่',
        name: {
          th: 'สวนใหญ่',
          en: 'Suan Yai',
        },
        districtId: 58,
      },
      {
        id: '120102',
        zipcode: 11000,
        text: 'ตลาดขวัญ',
        value: 'ตลาดขวัญ',
        name: {
          th: 'ตลาดขวัญ',
          en: 'Talat Khwan',
        },
        districtId: 58,
      },
      {
        id: '120103',
        zipcode: 11000,
        text: 'บางเขน',
        value: 'บางเขน',
        name: {
          th: 'บางเขน',
          en: 'Bang Khen',
        },
        districtId: 58,
      },
      {
        id: '120104',
        zipcode: 11000,
        text: 'บางกระสอ',
        value: 'บางกระสอ',
        name: {
          th: 'บางกระสอ',
          en: 'Bang Kraso',
        },
        districtId: 58,
      },
      {
        id: '120105',
        zipcode: 11000,
        text: 'ท่าทราย',
        value: 'ท่าทราย',
        name: {
          th: 'ท่าทราย',
          en: 'Tha Sai',
        },
        districtId: 58,
      },
      {
        id: '120106',
        zipcode: 11000,
        text: 'บางไผ่',
        value: 'บางไผ่',
        name: {
          th: 'บางไผ่',
          en: 'Bang Phai',
        },
        districtId: 58,
      },
      {
        id: '120107',
        zipcode: 11000,
        text: 'บางศรีเมือง',
        value: 'บางศรีเมือง',
        name: {
          th: 'บางศรีเมือง',
          en: 'Bang Si Mueang',
        },
        districtId: 58,
      },
      {
        id: '120108',
        zipcode: 11000,
        text: 'บางกร่าง',
        value: 'บางกร่าง',
        name: {
          th: 'บางกร่าง',
          en: 'Bang Krang',
        },
        districtId: 58,
      },
      {
        id: '120109',
        zipcode: 11000,
        text: 'ไทรม้า',
        value: 'ไทรม้า',
        name: {
          th: 'ไทรม้า',
          en: 'Sai Ma',
        },
        districtId: 58,
      },
      {
        id: '120110',
        zipcode: 11000,
        text: 'บางรักน้อย',
        value: 'บางรักน้อย',
        name: {
          th: 'บางรักน้อย',
          en: 'Bang Rak Noi',
        },
        districtId: 58,
      },
      {
        id: '120201',
        zipcode: 11130,
        text: 'วัดชลอ',
        value: 'วัดชลอ',
        name: {
          th: 'วัดชลอ',
          en: 'Wat Chalo',
        },
        districtId: 59,
      },
      {
        id: '120202',
        zipcode: 11130,
        text: 'บางกรวย',
        value: 'บางกรวย',
        name: {
          th: 'บางกรวย',
          en: 'Bang Kruai',
        },
        districtId: 59,
      },
      {
        id: '120203',
        zipcode: 11130,
        text: 'บางสีทอง',
        value: 'บางสีทอง',
        name: {
          th: 'บางสีทอง',
          en: 'Bang Si Thong',
        },
        districtId: 59,
      },
      {
        id: '120204',
        zipcode: 11130,
        text: 'บางขนุน',
        value: 'บางขนุน',
        name: {
          th: 'บางขนุน',
          en: 'Bang Khanun',
        },
        districtId: 59,
      },
      {
        id: '120205',
        zipcode: 11130,
        text: 'บางขุนกอง',
        value: 'บางขุนกอง',
        name: {
          th: 'บางขุนกอง',
          en: 'Bang Khun Kong',
        },
        districtId: 59,
      },
      {
        id: '120206',
        zipcode: 11130,
        text: 'บางคูเวียง',
        value: 'บางคูเวียง',
        name: {
          th: 'บางคูเวียง',
          en: 'Bang Khu Wiang',
        },
        districtId: 59,
      },
      {
        id: '120207',
        zipcode: 11130,
        text: 'มหาสวัสดิ์',
        value: 'มหาสวัสดิ์',
        name: {
          th: 'มหาสวัสดิ์',
          en: 'Maha Sawat',
        },
        districtId: 59,
      },
      {
        id: '120208',
        zipcode: 11130,
        text: 'ปลายบาง',
        value: 'ปลายบาง',
        name: {
          th: 'ปลายบาง',
          en: 'Plai Bang',
        },
        districtId: 59,
      },
      {
        id: '120209',
        zipcode: 11130,
        text: 'ศาลากลาง',
        value: 'ศาลากลาง',
        name: {
          th: 'ศาลากลาง',
          en: 'Sala Klang',
        },
        districtId: 59,
      },
      {
        id: '120301',
        zipcode: 11140,
        text: 'บางม่วง',
        value: 'บางม่วง',
        name: {
          th: 'บางม่วง',
          en: 'Bang Muang',
        },
        districtId: 60,
      },
      {
        id: '120302',
        zipcode: 11140,
        text: 'บางแม่นาง',
        value: 'บางแม่นาง',
        name: {
          th: 'บางแม่นาง',
          en: 'Bang Mae Nang',
        },
        districtId: 60,
      },
      {
        id: '120303',
        zipcode: 11140,
        text: 'บางเลน',
        value: 'บางเลน',
        name: {
          th: 'บางเลน',
          en: 'Bang Len',
        },
        districtId: 60,
      },
      {
        id: '120304',
        zipcode: 11140,
        text: 'เสาธงหิน',
        value: 'เสาธงหิน',
        name: {
          th: 'เสาธงหิน',
          en: 'Sao Thong Hin',
        },
        districtId: 60,
      },
      {
        id: '120305',
        zipcode: 11140,
        text: 'บางใหญ่',
        value: 'บางใหญ่',
        name: {
          th: 'บางใหญ่',
          en: 'Bang Yai',
        },
        districtId: 60,
      },
      {
        id: '120306',
        zipcode: 11140,
        text: 'บ้านใหม่',
        value: 'บ้านใหม่',
        name: {
          th: 'บ้านใหม่',
          en: 'Ban Mai',
        },
        districtId: 60,
      },
      {
        id: '120401',
        zipcode: 11110,
        text: 'โสนลอย',
        value: 'โสนลอย',
        name: {
          th: 'โสนลอย',
          en: 'Sano Loi',
        },
        districtId: 61,
      },
      {
        id: '120402',
        zipcode: 11110,
        text: 'บางบัวทอง',
        value: 'บางบัวทอง',
        name: {
          th: 'บางบัวทอง',
          en: 'Bang Bua Thong',
        },
        districtId: 61,
      },
      {
        id: '120403',
        zipcode: 11110,
        text: 'บางรักใหญ่',
        value: 'บางรักใหญ่',
        name: {
          th: 'บางรักใหญ่',
          en: 'Bang Rak Yai',
        },
        districtId: 61,
      },
      {
        id: '120404',
        zipcode: 11110,
        text: 'บางคูรัด',
        value: 'บางคูรัด',
        name: {
          th: 'บางคูรัด',
          en: 'Bang Khu Rat',
        },
        districtId: 61,
      },
      {
        id: '120405',
        zipcode: 11110,
        text: 'ละหาร',
        value: 'ละหาร',
        name: {
          th: 'ละหาร',
          en: 'Lahan',
        },
        districtId: 61,
      },
      {
        id: '120406',
        zipcode: 11110,
        text: 'ลำโพ',
        value: 'ลำโพ',
        name: {
          th: 'ลำโพ',
          en: 'Lam Pho',
        },
        districtId: 61,
      },
      {
        id: '120407',
        zipcode: 11110,
        text: 'พิมลราช',
        value: 'พิมลราช',
        name: {
          th: 'พิมลราช',
          en: 'Phimon Rat',
        },
        districtId: 61,
      },
      {
        id: '120408',
        zipcode: 11110,
        text: 'บางรักพัฒนา',
        value: 'บางรักพัฒนา',
        name: {
          th: 'บางรักพัฒนา',
          en: 'Bang Rak Phatthana',
        },
        districtId: 61,
      },
      {
        id: '120501',
        zipcode: 11150,
        text: 'ไทรน้อย',
        value: 'ไทรน้อย',
        name: {
          th: 'ไทรน้อย',
          en: 'Sai Noi',
        },
        districtId: 62,
      },
      {
        id: '120502',
        zipcode: 11150,
        text: 'ราษฎร์นิยม',
        value: 'ราษฎร์นิยม',
        name: {
          th: 'ราษฎร์นิยม',
          en: 'Rat Niyom',
        },
        districtId: 62,
      },
      {
        id: '120503',
        zipcode: 11150,
        text: 'หนองเพรางาย',
        value: 'หนองเพรางาย',
        name: {
          th: 'หนองเพรางาย',
          en: 'Nong Phrao Ngai',
        },
        districtId: 62,
      },
      {
        id: '120504',
        zipcode: 11150,
        text: 'ไทรใหญ่',
        value: 'ไทรใหญ่',
        name: {
          th: 'ไทรใหญ่',
          en: 'Sai Yai',
        },
        districtId: 62,
      },
      {
        id: '120505',
        zipcode: 11150,
        text: 'ขุนศรี',
        value: 'ขุนศรี',
        name: {
          th: 'ขุนศรี',
          en: 'Khun Si',
        },
        districtId: 62,
      },
      {
        id: '120506',
        zipcode: 11150,
        text: 'คลองขวาง',
        value: 'คลองขวาง',
        name: {
          th: 'คลองขวาง',
          en: 'Khlong Khwang',
        },
        districtId: 62,
      },
      {
        id: '120507',
        zipcode: 11150,
        text: 'ทวีวัฒนา',
        value: 'ทวีวัฒนา',
        name: {
          th: 'ทวีวัฒนา',
          en: 'Thawi Watthana',
        },
        districtId: 62,
      },
      {
        id: '120601',
        zipcode: 11120,
        text: 'ปากเกร็ด',
        value: 'ปากเกร็ด',
        name: {
          th: 'ปากเกร็ด',
          en: 'Pak Kret',
        },
        districtId: 63,
      },
      {
        id: '120602',
        zipcode: 11120,
        text: 'บางตลาด',
        value: 'บางตลาด',
        name: {
          th: 'บางตลาด',
          en: 'Bang Talat',
        },
        districtId: 63,
      },
      {
        id: '120603',
        zipcode: 11120,
        text: 'บ้านใหม่',
        value: 'บ้านใหม่',
        name: {
          th: 'บ้านใหม่',
          en: 'Ban Mai',
        },
        districtId: 63,
      },
      {
        id: '120604',
        zipcode: 11120,
        text: 'บางพูด',
        value: 'บางพูด',
        name: {
          th: 'บางพูด',
          en: 'Bang Phut',
        },
        districtId: 63,
      },
      {
        id: '120605',
        zipcode: 11120,
        text: 'บางตะไนย์',
        value: 'บางตะไนย์',
        name: {
          th: 'บางตะไนย์',
          en: 'Bang Tanai',
        },
        districtId: 63,
      },
      {
        id: '120606',
        zipcode: 11120,
        text: 'คลองพระอุดม',
        value: 'คลองพระอุดม',
        name: {
          th: 'คลองพระอุดม',
          en: 'Khlong Phra Udom',
        },
        districtId: 63,
      },
      {
        id: '120607',
        zipcode: 11120,
        text: 'ท่าอิฐ',
        value: 'ท่าอิฐ',
        name: {
          th: 'ท่าอิฐ',
          en: 'Tha It',
        },
        districtId: 63,
      },
      {
        id: '120608',
        zipcode: 11120,
        text: 'เกาะเกร็ด',
        value: 'เกาะเกร็ด',
        name: {
          th: 'เกาะเกร็ด',
          en: 'Ko Kret',
        },
        districtId: 63,
      },
      {
        id: '120609',
        zipcode: 11120,
        text: 'อ้อมเกร็ด',
        value: 'อ้อมเกร็ด',
        name: {
          th: 'อ้อมเกร็ด',
          en: 'Om Kret',
        },
        districtId: 63,
      },
      {
        id: '120610',
        zipcode: 11120,
        text: 'คลองข่อย',
        value: 'คลองข่อย',
        name: {
          th: 'คลองข่อย',
          en: 'Khlong Khoi',
        },
        districtId: 63,
      },
      {
        id: '120611',
        zipcode: 11120,
        text: 'บางพลับ',
        value: 'บางพลับ',
        name: {
          th: 'บางพลับ',
          en: 'Bang Phlap',
        },
        districtId: 63,
      },
      {
        id: '120612',
        zipcode: 11120,
        text: 'คลองเกลือ',
        value: 'คลองเกลือ',
        name: {
          th: 'คลองเกลือ',
          en: 'Khlong Kluea',
        },
        districtId: 63,
      },
      {
        id: '130101',
        zipcode: 12000,
        text: 'บางปรอก',
        value: 'บางปรอก',
        name: {
          th: 'บางปรอก',
          en: 'Bang Parok',
        },
        districtId: 66,
      },
      {
        id: '130102',
        zipcode: 12000,
        text: 'บ้านใหม่',
        value: 'บ้านใหม่',
        name: {
          th: 'บ้านใหม่',
          en: 'Ban Mai',
        },
        districtId: 66,
      },
      {
        id: '130103',
        zipcode: 12000,
        text: 'บ้านกลาง',
        value: 'บ้านกลาง',
        name: {
          th: 'บ้านกลาง',
          en: 'Ban Klang',
        },
        districtId: 66,
      },
      {
        id: '130104',
        zipcode: 12000,
        text: 'บ้านฉาง',
        value: 'บ้านฉาง',
        name: {
          th: 'บ้านฉาง',
          en: 'Ban Chang',
        },
        districtId: 66,
      },
      {
        id: '130105',
        zipcode: 12000,
        text: 'บ้านกระแชง',
        value: 'บ้านกระแชง',
        name: {
          th: 'บ้านกระแชง',
          en: 'Ban Krachaeng',
        },
        districtId: 66,
      },
      {
        id: '130106',
        zipcode: 12000,
        text: 'บางขะแยง',
        value: 'บางขะแยง',
        name: {
          th: 'บางขะแยง',
          en: 'Bang Khayaeng',
        },
        districtId: 66,
      },
      {
        id: '130107',
        zipcode: 12000,
        text: 'บางคูวัด',
        value: 'บางคูวัด',
        name: {
          th: 'บางคูวัด',
          en: 'Bang Khu Wat',
        },
        districtId: 66,
      },
      {
        id: '130108',
        zipcode: 12000,
        text: 'บางหลวง',
        value: 'บางหลวง',
        name: {
          th: 'บางหลวง',
          en: 'Bang Luang',
        },
        districtId: 66,
      },
      {
        id: '130109',
        zipcode: 12000,
        text: 'บางเดื่อ',
        value: 'บางเดื่อ',
        name: {
          th: 'บางเดื่อ',
          en: 'Bang Duea',
        },
        districtId: 66,
      },
      {
        id: '130110',
        zipcode: 12000,
        text: 'บางพูด',
        value: 'บางพูด',
        name: {
          th: 'บางพูด',
          en: 'Bang Phut',
        },
        districtId: 66,
      },
      {
        id: '130111',
        zipcode: 12000,
        text: 'บางพูน',
        value: 'บางพูน',
        name: {
          th: 'บางพูน',
          en: 'Bang Phun',
        },
        districtId: 66,
      },
      {
        id: '130112',
        zipcode: 12000,
        text: 'บางกะดี',
        value: 'บางกะดี',
        name: {
          th: 'บางกะดี',
          en: 'Bang Kadi',
        },
        districtId: 66,
      },
      {
        id: '130113',
        zipcode: 12000,
        text: 'สวนพริกไทย',
        value: 'สวนพริกไทย',
        name: {
          th: 'สวนพริกไทย',
          en: 'Suan Phrikthai',
        },
        districtId: 66,
      },
      {
        id: '130114',
        zipcode: 12000,
        text: 'หลักหก',
        value: 'หลักหก',
        name: {
          th: 'หลักหก',
          en: 'Lak Hok',
        },
        districtId: 66,
      },
      {
        id: '130201',
        zipcode: 12120,
        text: 'คลองหนึ่ง',
        value: 'คลองหนึ่ง',
        name: {
          th: 'คลองหนึ่ง',
          en: 'Khlong Nueng',
        },
        districtId: 67,
      },
      {
        id: '130202',
        zipcode: 12120,
        text: 'คลองสอง',
        value: 'คลองสอง',
        name: {
          th: 'คลองสอง',
          en: 'Khlong Song',
        },
        districtId: 67,
      },
      {
        id: '130203',
        zipcode: 12120,
        text: 'คลองสาม',
        value: 'คลองสาม',
        name: {
          th: 'คลองสาม',
          en: 'Khlong Sam',
        },
        districtId: 67,
      },
      {
        id: '130204',
        zipcode: 12120,
        text: 'คลองสี่',
        value: 'คลองสี่',
        name: {
          th: 'คลองสี่',
          en: 'Khlong Si',
        },
        districtId: 67,
      },
      {
        id: '130205',
        zipcode: 12120,
        text: 'คลองห้า',
        value: 'คลองห้า',
        name: {
          th: 'คลองห้า',
          en: 'Khlong Ha',
        },
        districtId: 67,
      },
      {
        id: '130206',
        zipcode: 12120,
        text: 'คลองหก',
        value: 'คลองหก',
        name: {
          th: 'คลองหก',
          en: 'Khlong Hok',
        },
        districtId: 67,
      },
      {
        id: '130207',
        zipcode: 12120,
        text: 'คลองเจ็ด',
        value: 'คลองเจ็ด',
        name: {
          th: 'คลองเจ็ด',
          en: 'Khlong Chet',
        },
        districtId: 67,
      },
      {
        id: '130301',
        zipcode: 12130,
        text: 'ประชาธิปัตย์',
        value: 'ประชาธิปัตย์',
        name: {
          th: 'ประชาธิปัตย์',
          en: 'Prachathipat',
        },
        districtId: 68,
      },
      {
        id: '130302',
        zipcode: 12130,
        text: 'บึงยี่โถ',
        value: 'บึงยี่โถ',
        name: {
          th: 'บึงยี่โถ',
          en: 'Bueng Yitho',
        },
        districtId: 68,
      },
      {
        id: '130303',
        zipcode: 12110,
        text: 'รังสิต',
        value: 'รังสิต',
        name: {
          th: 'รังสิต',
          en: 'Rangsit',
        },
        districtId: 68,
      },
      {
        id: '130304',
        zipcode: 12110,
        text: 'ลำผักกูด',
        value: 'ลำผักกูด',
        name: {
          th: 'ลำผักกูด',
          en: 'Lam Phak Kut',
        },
        districtId: 68,
      },
      {
        id: '130305',
        zipcode: 12110,
        text: 'บึงสนั่น',
        value: 'บึงสนั่น',
        name: {
          th: 'บึงสนั่น',
          en: 'Bueng Sanan',
        },
        districtId: 68,
      },
      {
        id: '130306',
        zipcode: 12110,
        text: 'บึงน้ำรักษ์',
        value: 'บึงน้ำรักษ์',
        name: {
          th: 'บึงน้ำรักษ์',
          en: 'Bueng Nam Rak',
        },
        districtId: 68,
      },
      {
        id: '130401',
        zipcode: 12170,
        text: 'บึงบา',
        value: 'บึงบา',
        name: {
          th: 'บึงบา',
          en: 'Bueng Ba',
        },
        districtId: 69,
      },
      {
        id: '130402',
        zipcode: 12170,
        text: 'บึงบอน',
        value: 'บึงบอน',
        name: {
          th: 'บึงบอน',
          en: 'Bueng Bon',
        },
        districtId: 69,
      },
      {
        id: '130403',
        zipcode: 12170,
        text: 'บึงกาสาม',
        value: 'บึงกาสาม',
        name: {
          th: 'บึงกาสาม',
          en: 'Bueng Ka Sam',
        },
        districtId: 69,
      },
      {
        id: '130404',
        zipcode: 12170,
        text: 'บึงชำอ้อ',
        value: 'บึงชำอ้อ',
        name: {
          th: 'บึงชำอ้อ',
          en: 'Bueng Cham O',
        },
        districtId: 69,
      },
      {
        id: '130405',
        zipcode: 12170,
        text: 'หนองสามวัง',
        value: 'หนองสามวัง',
        name: {
          th: 'หนองสามวัง',
          en: 'Nong Sam Wang',
        },
        districtId: 69,
      },
      {
        id: '130406',
        zipcode: 12170,
        text: 'ศาลาครุ',
        value: 'ศาลาครุ',
        name: {
          th: 'ศาลาครุ',
          en: 'Sala Khru',
        },
        districtId: 69,
      },
      {
        id: '130407',
        zipcode: 12170,
        text: 'นพรัตน์',
        value: 'นพรัตน์',
        name: {
          th: 'นพรัตน์',
          en: 'Noppharat',
        },
        districtId: 69,
      },
      {
        id: '130501',
        zipcode: 12140,
        text: 'ระแหง',
        value: 'ระแหง',
        name: {
          th: 'ระแหง',
          en: 'Rahaeng',
        },
        districtId: 70,
      },
      {
        id: '130502',
        zipcode: 12140,
        text: 'ลาดหลุมแก้ว',
        value: 'ลาดหลุมแก้ว',
        name: {
          th: 'ลาดหลุมแก้ว',
          en: 'Lat Lum Kaeo',
        },
        districtId: 70,
      },
      {
        id: '130503',
        zipcode: 12140,
        text: 'คูบางหลวง',
        value: 'คูบางหลวง',
        name: {
          th: 'คูบางหลวง',
          en: 'Khu Bang Luang',
        },
        districtId: 70,
      },
      {
        id: '130504',
        zipcode: 12140,
        text: 'คูขวาง',
        value: 'คูขวาง',
        name: {
          th: 'คูขวาง',
          en: 'Khu Khwang',
        },
        districtId: 70,
      },
      {
        id: '130505',
        zipcode: 12140,
        text: 'คลองพระอุดม',
        value: 'คลองพระอุดม',
        name: {
          th: 'คลองพระอุดม',
          en: 'Khlong Phra Udom',
        },
        districtId: 70,
      },
      {
        id: '130506',
        zipcode: 12140,
        text: 'บ่อเงิน',
        value: 'บ่อเงิน',
        name: {
          th: 'บ่อเงิน',
          en: 'Bo Ngoen',
        },
        districtId: 70,
      },
      {
        id: '130507',
        zipcode: 12140,
        text: 'หน้าไม้',
        value: 'หน้าไม้',
        name: {
          th: 'หน้าไม้',
          en: 'Na Mai',
        },
        districtId: 70,
      },
      {
        id: '130601',
        zipcode: 12130,
        text: 'คูคต',
        value: 'คูคต',
        name: {
          th: 'คูคต',
          en: 'Khu Khot',
        },
        districtId: 71,
      },
      {
        id: '130602',
        zipcode: 12150,
        text: 'ลาดสวาย',
        value: 'ลาดสวาย',
        name: {
          th: 'ลาดสวาย',
          en: 'Lat Sawai',
        },
        districtId: 71,
      },
      {
        id: '130603',
        zipcode: 12150,
        text: 'บึงคำพร้อย',
        value: 'บึงคำพร้อย',
        name: {
          th: 'บึงคำพร้อย',
          en: 'Bueng Kham Phroi',
        },
        districtId: 71,
      },
      {
        id: '130604',
        zipcode: 12150,
        text: 'ลำลูกกา',
        value: 'ลำลูกกา',
        name: {
          th: 'ลำลูกกา',
          en: 'Lam Luk Ka',
        },
        districtId: 71,
      },
      {
        id: '130605',
        zipcode: 12150,
        text: 'บึงทองหลาง',
        value: 'บึงทองหลาง',
        name: {
          th: 'บึงทองหลาง',
          en: 'Bueng Thonglang',
        },
        districtId: 71,
      },
      {
        id: '130606',
        zipcode: 12150,
        text: 'ลำไทร',
        value: 'ลำไทร',
        name: {
          th: 'ลำไทร',
          en: 'Lam Sai',
        },
        districtId: 71,
      },
      {
        id: '130607',
        zipcode: 12150,
        text: 'บึงคอไห',
        value: 'บึงคอไห',
        name: {
          th: 'บึงคอไห',
          en: 'Bueng Kho Hai',
        },
        districtId: 71,
      },
      {
        id: '130608',
        zipcode: 12150,
        text: 'พืชอุดม',
        value: 'พืชอุดม',
        name: {
          th: 'พืชอุดม',
          en: 'Phuet Udom',
        },
        districtId: 71,
      },
      {
        id: '130701',
        zipcode: 12160,
        text: 'บางเตย',
        value: 'บางเตย',
        name: {
          th: 'บางเตย',
          en: 'Bang Toei',
        },
        districtId: 72,
      },
      {
        id: '130702',
        zipcode: 12160,
        text: 'คลองควาย',
        value: 'คลองควาย',
        name: {
          th: 'คลองควาย',
          en: 'Khlong Khwai',
        },
        districtId: 72,
      },
      {
        id: '130703',
        zipcode: 12160,
        text: 'สามโคก',
        value: 'สามโคก',
        name: {
          th: 'สามโคก',
          en: 'Sam Khok',
        },
        districtId: 72,
      },
      {
        id: '130704',
        zipcode: 12160,
        text: 'กระแชง',
        value: 'กระแชง',
        name: {
          th: 'กระแชง',
          en: 'Krachaeng',
        },
        districtId: 72,
      },
      {
        id: '130705',
        zipcode: 12160,
        text: 'บางโพธิ์เหนือ',
        value: 'บางโพธิ์เหนือ',
        name: {
          th: 'บางโพธิ์เหนือ',
          en: 'Bang Pho Nuea',
        },
        districtId: 72,
      },
      {
        id: '130706',
        zipcode: 12160,
        text: 'เชียงรากใหญ่',
        value: 'เชียงรากใหญ่',
        name: {
          th: 'เชียงรากใหญ่',
          en: 'Chiang Rak Yai',
        },
        districtId: 72,
      },
      {
        id: '130707',
        zipcode: 12160,
        text: 'บ้านปทุม',
        value: 'บ้านปทุม',
        name: {
          th: 'บ้านปทุม',
          en: 'Ban Pathum',
        },
        districtId: 72,
      },
      {
        id: '130708',
        zipcode: 12160,
        text: 'บ้านงิ้ว',
        value: 'บ้านงิ้ว',
        name: {
          th: 'บ้านงิ้ว',
          en: 'Ban Ngio',
        },
        districtId: 72,
      },
      {
        id: '130709',
        zipcode: 12160,
        text: 'เชียงรากน้อย',
        value: 'เชียงรากน้อย',
        name: {
          th: 'เชียงรากน้อย',
          en: 'Chiang Rak Noi',
        },
        districtId: 72,
      },
      {
        id: '130710',
        zipcode: 12160,
        text: 'บางกระบือ',
        value: 'บางกระบือ',
        name: {
          th: 'บางกระบือ',
          en: 'Bang Krabue',
        },
        districtId: 72,
      },
      {
        id: '130711',
        zipcode: 12160,
        text: 'ท้ายเกาะ',
        value: 'ท้ายเกาะ',
        name: {
          th: 'ท้ายเกาะ',
          en: 'Thai Ko',
        },
        districtId: 72,
      },
      {
        id: '140101',
        zipcode: 13000,
        text: 'ประตูชัย',
        value: 'ประตูชัย',
        name: {
          th: 'ประตูชัย',
          en: 'Pratu Chai',
        },
        districtId: 74,
      },
      {
        id: '140102',
        zipcode: 13000,
        text: 'กะมัง',
        value: 'กะมัง',
        name: {
          th: 'กะมัง',
          en: 'Kamang',
        },
        districtId: 74,
      },
      {
        id: '140103',
        zipcode: 13000,
        text: 'หอรัตนไชย',
        value: 'หอรัตนไชย',
        name: {
          th: 'หอรัตนไชย',
          en: 'Ho Rattanachai',
        },
        districtId: 74,
      },
      {
        id: '140104',
        zipcode: 13000,
        text: 'หัวรอ',
        value: 'หัวรอ',
        name: {
          th: 'หัวรอ',
          en: 'Hua Ro',
        },
        districtId: 74,
      },
      {
        id: '140105',
        zipcode: 13000,
        text: 'ท่าวาสุกรี',
        value: 'ท่าวาสุกรี',
        name: {
          th: 'ท่าวาสุกรี',
          en: 'Tha Wasukri',
        },
        districtId: 74,
      },
      {
        id: '140106',
        zipcode: 13000,
        text: 'ไผ่ลิง',
        value: 'ไผ่ลิง',
        name: {
          th: 'ไผ่ลิง',
          en: 'Phai Ling',
        },
        districtId: 74,
      },
      {
        id: '140107',
        zipcode: 13000,
        text: 'ปากกราน',
        value: 'ปากกราน',
        name: {
          th: 'ปากกราน',
          en: 'Pak Kran',
        },
        districtId: 74,
      },
      {
        id: '140108',
        zipcode: 13000,
        text: 'ภูเขาทอง',
        value: 'ภูเขาทอง',
        name: {
          th: 'ภูเขาทอง',
          en: 'Phukhao Thong',
        },
        districtId: 74,
      },
      {
        id: '140109',
        zipcode: 13000,
        text: 'สำเภาล่ม',
        value: 'สำเภาล่ม',
        name: {
          th: 'สำเภาล่ม',
          en: 'Samphao Lom',
        },
        districtId: 74,
      },
      {
        id: '140110',
        zipcode: 13000,
        text: 'สวนพริก',
        value: 'สวนพริก',
        name: {
          th: 'สวนพริก',
          en: 'Suan Phrik',
        },
        districtId: 74,
      },
      {
        id: '140111',
        zipcode: 13000,
        text: 'คลองตะเคียน',
        value: 'คลองตะเคียน',
        name: {
          th: 'คลองตะเคียน',
          en: 'Khlong Takhian',
        },
        districtId: 74,
      },
      {
        id: '140112',
        zipcode: 13000,
        text: 'วัดตูม',
        value: 'วัดตูม',
        name: {
          th: 'วัดตูม',
          en: 'Wat Tum',
        },
        districtId: 74,
      },
      {
        id: '140113',
        zipcode: 13000,
        text: 'หันตรา',
        value: 'หันตรา',
        name: {
          th: 'หันตรา',
          en: 'Hantra',
        },
        districtId: 74,
      },
      {
        id: '140114',
        zipcode: 13000,
        text: 'ลุมพลี',
        value: 'ลุมพลี',
        name: {
          th: 'ลุมพลี',
          en: 'Lumphli',
        },
        districtId: 74,
      },
      {
        id: '140115',
        zipcode: 13000,
        text: 'บ้านใหม่',
        value: 'บ้านใหม่',
        name: {
          th: 'บ้านใหม่',
          en: 'Ban Mai',
        },
        districtId: 74,
      },
      {
        id: '140116',
        zipcode: 13000,
        text: 'บ้านเกาะ',
        value: 'บ้านเกาะ',
        name: {
          th: 'บ้านเกาะ',
          en: 'Ban Ko',
        },
        districtId: 74,
      },
      {
        id: '140117',
        zipcode: 13000,
        text: 'คลองสวนพลู',
        value: 'คลองสวนพลู',
        name: {
          th: 'คลองสวนพลู',
          en: 'Khlong Suan Phlu',
        },
        districtId: 74,
      },
      {
        id: '140118',
        zipcode: 13000,
        text: 'คลองสระบัว',
        value: 'คลองสระบัว',
        name: {
          th: 'คลองสระบัว',
          en: 'Khlong Sa Bua',
        },
        districtId: 74,
      },
      {
        id: '140119',
        zipcode: 13000,
        text: 'เกาะเรียน',
        value: 'เกาะเรียน',
        name: {
          th: 'เกาะเรียน',
          en: 'Ko Rian',
        },
        districtId: 74,
      },
      {
        id: '140120',
        zipcode: 13000,
        text: 'บ้านป้อม',
        value: 'บ้านป้อม',
        name: {
          th: 'บ้านป้อม',
          en: 'Ban Pom',
        },
        districtId: 74,
      },
      {
        id: '140121',
        zipcode: 13000,
        text: 'บ้านรุน',
        value: 'บ้านรุน',
        name: {
          th: 'บ้านรุน',
          en: 'Ban Run',
        },
        districtId: 74,
      },
      {
        id: '140201',
        zipcode: 13130,
        text: 'ท่าเรือ',
        value: 'ท่าเรือ',
        name: {
          th: 'ท่าเรือ',
          en: 'Tha Ruea',
        },
        districtId: 75,
      },
      {
        id: '140202',
        zipcode: 13130,
        text: 'จำปา',
        value: 'จำปา',
        name: {
          th: 'จำปา',
          en: 'Champa',
        },
        districtId: 75,
      },
      {
        id: '140203',
        zipcode: 13130,
        text: 'ท่าหลวง',
        value: 'ท่าหลวง',
        name: {
          th: 'ท่าหลวง',
          en: 'Tha Luang',
        },
        districtId: 75,
      },
      {
        id: '140204',
        zipcode: 13130,
        text: 'บ้านร่อม',
        value: 'บ้านร่อม',
        name: {
          th: 'บ้านร่อม',
          en: 'Ban Rom',
        },
        districtId: 75,
      },
      {
        id: '140205',
        zipcode: 13130,
        text: 'ศาลาลอย',
        value: 'ศาลาลอย',
        name: {
          th: 'ศาลาลอย',
          en: 'Sala Loi',
        },
        districtId: 75,
      },
      {
        id: '140206',
        zipcode: 13130,
        text: 'วังแดง',
        value: 'วังแดง',
        name: {
          th: 'วังแดง',
          en: 'Wang Daeng',
        },
        districtId: 75,
      },
      {
        id: '140207',
        zipcode: 13130,
        text: 'โพธิ์เอน',
        value: 'โพธิ์เอน',
        name: {
          th: 'โพธิ์เอน',
          en: 'Pho En',
        },
        districtId: 75,
      },
      {
        id: '140208',
        zipcode: 13130,
        text: 'ปากท่า',
        value: 'ปากท่า',
        name: {
          th: 'ปากท่า',
          en: 'Pak Tha',
        },
        districtId: 75,
      },
      {
        id: '140209',
        zipcode: 13130,
        text: 'หนองขนาก',
        value: 'หนองขนาก',
        name: {
          th: 'หนองขนาก',
          en: 'Nong Khanak',
        },
        districtId: 75,
      },
      {
        id: '140210',
        zipcode: 13130,
        text: 'ท่าเจ้าสนุก',
        value: 'ท่าเจ้าสนุก',
        name: {
          th: 'ท่าเจ้าสนุก',
          en: 'Tha Chao Sanuk',
        },
        districtId: 75,
      },
      {
        id: '140301',
        zipcode: 13260,
        text: 'นครหลวง',
        value: 'นครหลวง',
        name: {
          th: 'นครหลวง',
          en: 'Nakhon Luang',
        },
        districtId: 76,
      },
      {
        id: '140302',
        zipcode: 13260,
        text: 'ท่าช้าง',
        value: 'ท่าช้าง',
        name: {
          th: 'ท่าช้าง',
          en: 'Tha Chang',
        },
        districtId: 76,
      },
      {
        id: '140303',
        zipcode: 13260,
        text: 'บ่อโพง',
        value: 'บ่อโพง',
        name: {
          th: 'บ่อโพง',
          en: 'Bo Phong',
        },
        districtId: 76,
      },
      {
        id: '140304',
        zipcode: 13260,
        text: 'บ้านชุ้ง',
        value: 'บ้านชุ้ง',
        name: {
          th: 'บ้านชุ้ง',
          en: 'Ban Chung',
        },
        districtId: 76,
      },
      {
        id: '140305',
        zipcode: 13260,
        text: 'ปากจั่น',
        value: 'ปากจั่น',
        name: {
          th: 'ปากจั่น',
          en: 'Pak Chan',
        },
        districtId: 76,
      },
      {
        id: '140306',
        zipcode: 13260,
        text: 'บางระกำ',
        value: 'บางระกำ',
        name: {
          th: 'บางระกำ',
          en: 'Bang Rakam',
        },
        districtId: 76,
      },
      {
        id: '140307',
        zipcode: 13260,
        text: 'บางพระครู',
        value: 'บางพระครู',
        name: {
          th: 'บางพระครู',
          en: 'Bang Phra Khru',
        },
        districtId: 76,
      },
      {
        id: '140308',
        zipcode: 13260,
        text: 'แม่ลา',
        value: 'แม่ลา',
        name: {
          th: 'แม่ลา',
          en: 'Mae La',
        },
        districtId: 76,
      },
      {
        id: '140309',
        zipcode: 13260,
        text: 'หนองปลิง',
        value: 'หนองปลิง',
        name: {
          th: 'หนองปลิง',
          en: 'Nong Pling',
        },
        districtId: 76,
      },
      {
        id: '140310',
        zipcode: 13260,
        text: 'คลองสะแก',
        value: 'คลองสะแก',
        name: {
          th: 'คลองสะแก',
          en: 'Khlong Sakae',
        },
        districtId: 76,
      },
      {
        id: '140311',
        zipcode: 13260,
        text: 'สามไถ',
        value: 'สามไถ',
        name: {
          th: 'สามไถ',
          en: 'Sam Thai',
        },
        districtId: 76,
      },
      {
        id: '140312',
        zipcode: 13260,
        text: 'พระนอน',
        value: 'พระนอน',
        name: {
          th: 'พระนอน',
          en: 'Phra Non',
        },
        districtId: 76,
      },
      {
        id: '140401',
        zipcode: 13190,
        text: 'บางไทร',
        value: 'บางไทร',
        name: {
          th: 'บางไทร',
          en: 'Bang Sai',
        },
        districtId: 77,
      },
      {
        id: '140402',
        zipcode: 13190,
        text: 'บางพลี',
        value: 'บางพลี',
        name: {
          th: 'บางพลี',
          en: 'Bang Phli',
        },
        districtId: 77,
      },
      {
        id: '140403',
        zipcode: 13190,
        text: 'สนามชัย',
        value: 'สนามชัย',
        name: {
          th: 'สนามชัย',
          en: 'Sanam Chai',
        },
        districtId: 77,
      },
      {
        id: '140404',
        zipcode: 13190,
        text: 'บ้านแป้ง',
        value: 'บ้านแป้ง',
        name: {
          th: 'บ้านแป้ง',
          en: 'Ban Paeng',
        },
        districtId: 77,
      },
      {
        id: '140405',
        zipcode: 13190,
        text: 'หน้าไม้',
        value: 'หน้าไม้',
        name: {
          th: 'หน้าไม้',
          en: 'Na Mai',
        },
        districtId: 77,
      },
      {
        id: '140406',
        zipcode: 13190,
        text: 'บางยี่โท',
        value: 'บางยี่โท',
        name: {
          th: 'บางยี่โท',
          en: 'Bang Yi Tho',
        },
        districtId: 77,
      },
      {
        id: '140407',
        zipcode: 13190,
        text: 'แคออก',
        value: 'แคออก',
        name: {
          th: 'แคออก',
          en: 'Khae Ok',
        },
        districtId: 77,
      },
      {
        id: '140408',
        zipcode: 13190,
        text: 'แคตก',
        value: 'แคตก',
        name: {
          th: 'แคตก',
          en: 'Khae Tok',
        },
        districtId: 77,
      },
      {
        id: '140409',
        zipcode: 13190,
        text: 'ช่างเหล็ก',
        value: 'ช่างเหล็ก',
        name: {
          th: 'ช่างเหล็ก',
          en: 'Chang Lek',
        },
        districtId: 77,
      },
      {
        id: '140410',
        zipcode: 13190,
        text: 'กระแชง',
        value: 'กระแชง',
        name: {
          th: 'กระแชง',
          en: 'Krachaeng',
        },
        districtId: 77,
      },
      {
        id: '140411',
        zipcode: 13190,
        text: 'บ้านกลึง',
        value: 'บ้านกลึง',
        name: {
          th: 'บ้านกลึง',
          en: 'Ban Klueng',
        },
        districtId: 77,
      },
      {
        id: '140412',
        zipcode: 13190,
        text: 'ช้างน้อย',
        value: 'ช้างน้อย',
        name: {
          th: 'ช้างน้อย',
          en: 'Chang Noi',
        },
        districtId: 77,
      },
      {
        id: '140413',
        zipcode: 13190,
        text: 'ห่อหมก',
        value: 'ห่อหมก',
        name: {
          th: 'ห่อหมก',
          en: 'Homok',
        },
        districtId: 77,
      },
      {
        id: '140414',
        zipcode: 13190,
        text: 'ไผ่พระ',
        value: 'ไผ่พระ',
        name: {
          th: 'ไผ่พระ',
          en: 'Phai Phra',
        },
        districtId: 77,
      },
      {
        id: '140415',
        zipcode: 13190,
        text: 'กกแก้วบูรพา',
        value: 'กกแก้วบูรพา',
        name: {
          th: 'กกแก้วบูรพา',
          en: 'Kok Kaeo Burapha',
        },
        districtId: 77,
      },
      {
        id: '140416',
        zipcode: 13190,
        text: 'ไม้ตรา',
        value: 'ไม้ตรา',
        name: {
          th: 'ไม้ตรา',
          en: 'Mai Tra',
        },
        districtId: 77,
      },
      {
        id: '140417',
        zipcode: 13190,
        text: 'บ้านม้า',
        value: 'บ้านม้า',
        name: {
          th: 'บ้านม้า',
          en: 'Ban Ma',
        },
        districtId: 77,
      },
      {
        id: '140418',
        zipcode: 13190,
        text: 'บ้านเกาะ',
        value: 'บ้านเกาะ',
        name: {
          th: 'บ้านเกาะ',
          en: 'Ban Ko',
        },
        districtId: 77,
      },
      {
        id: '140419',
        zipcode: 13290,
        text: 'ราชคราม',
        value: 'ราชคราม',
        name: {
          th: 'ราชคราม',
          en: 'Ratchakhram',
        },
        districtId: 77,
      },
      {
        id: '140420',
        zipcode: 13290,
        text: 'ช้างใหญ่',
        value: 'ช้างใหญ่',
        name: {
          th: 'ช้างใหญ่',
          en: 'Chang Yai',
        },
        districtId: 77,
      },
      {
        id: '140421',
        zipcode: 13290,
        text: 'โพแตง',
        value: 'โพแตง',
        name: {
          th: 'โพแตง',
          en: 'Pho Taeng',
        },
        districtId: 77,
      },
      {
        id: '140422',
        zipcode: 13290,
        text: 'เชียงรากน้อย',
        value: 'เชียงรากน้อย',
        name: {
          th: 'เชียงรากน้อย',
          en: 'Chiang Rak Noi',
        },
        districtId: 77,
      },
      {
        id: '140423',
        zipcode: 13190,
        text: 'โคกช้าง',
        value: 'โคกช้าง',
        name: {
          th: 'โคกช้าง',
          en: 'Khok Chang',
        },
        districtId: 77,
      },
      {
        id: '140501',
        zipcode: 13250,
        text: 'บางบาล',
        value: 'บางบาล',
        name: {
          th: 'บางบาล',
          en: 'Bang Ban',
        },
        districtId: 78,
      },
      {
        id: '140502',
        zipcode: 13250,
        text: 'วัดยม',
        value: 'วัดยม',
        name: {
          th: 'วัดยม',
          en: 'Wat Yom',
        },
        districtId: 78,
      },
      {
        id: '140503',
        zipcode: 13250,
        text: 'ไทรน้อย',
        value: 'ไทรน้อย',
        name: {
          th: 'ไทรน้อย',
          en: 'Sai Noi',
        },
        districtId: 78,
      },
      {
        id: '140504',
        zipcode: 13250,
        text: 'สะพานไทย',
        value: 'สะพานไทย',
        name: {
          th: 'สะพานไทย',
          en: 'Saphan Thai',
        },
        districtId: 78,
      },
      {
        id: '140505',
        zipcode: 13250,
        text: 'มหาพราหมณ์',
        value: 'มหาพราหมณ์',
        name: {
          th: 'มหาพราหมณ์',
          en: 'Maha Phram',
        },
        districtId: 78,
      },
      {
        id: '140506',
        zipcode: 13250,
        text: 'กบเจา',
        value: 'กบเจา',
        name: {
          th: 'กบเจา',
          en: 'Kop Chao',
        },
        districtId: 78,
      },
      {
        id: '140507',
        zipcode: 13250,
        text: 'บ้านคลัง',
        value: 'บ้านคลัง',
        name: {
          th: 'บ้านคลัง',
          en: 'Ban Khlang',
        },
        districtId: 78,
      },
      {
        id: '140508',
        zipcode: 13250,
        text: 'พระขาว',
        value: 'พระขาว',
        name: {
          th: 'พระขาว',
          en: 'Phra Khao',
        },
        districtId: 78,
      },
      {
        id: '140509',
        zipcode: 13250,
        text: 'น้ำเต้า',
        value: 'น้ำเต้า',
        name: {
          th: 'น้ำเต้า',
          en: 'Namtao',
        },
        districtId: 78,
      },
      {
        id: '140510',
        zipcode: 13250,
        text: 'ทางช้าง',
        value: 'ทางช้าง',
        name: {
          th: 'ทางช้าง',
          en: 'Thang Chang',
        },
        districtId: 78,
      },
      {
        id: '140511',
        zipcode: 13250,
        text: 'วัดตะกู',
        value: 'วัดตะกู',
        name: {
          th: 'วัดตะกู',
          en: 'Wat Taku',
        },
        districtId: 78,
      },
      {
        id: '140512',
        zipcode: 13250,
        text: 'บางหลวง',
        value: 'บางหลวง',
        name: {
          th: 'บางหลวง',
          en: 'Bang Luang',
        },
        districtId: 78,
      },
      {
        id: '140513',
        zipcode: 13250,
        text: 'บางหลวงโดด',
        value: 'บางหลวงโดด',
        name: {
          th: 'บางหลวงโดด',
          en: 'Bang Luang Dot',
        },
        districtId: 78,
      },
      {
        id: '140514',
        zipcode: 13250,
        text: 'บางหัก',
        value: 'บางหัก',
        name: {
          th: 'บางหัก',
          en: 'Bang Hak',
        },
        districtId: 78,
      },
      {
        id: '140515',
        zipcode: 13250,
        text: 'บางชะนี',
        value: 'บางชะนี',
        name: {
          th: 'บางชะนี',
          en: 'Bang Chani',
        },
        districtId: 78,
      },
      {
        id: '140516',
        zipcode: 13250,
        text: 'บ้านกุ่ม',
        value: 'บ้านกุ่ม',
        name: {
          th: 'บ้านกุ่ม',
          en: 'Ban Kum',
        },
        districtId: 78,
      },
      {
        id: '140601',
        zipcode: 13160,
        text: 'บ้านเลน',
        value: 'บ้านเลน',
        name: {
          th: 'บ้านเลน',
          en: 'Ban Len',
        },
        districtId: 79,
      },
      {
        id: '140602',
        zipcode: 13180,
        text: 'เชียงรากน้อย',
        value: 'เชียงรากน้อย',
        name: {
          th: 'เชียงรากน้อย',
          en: 'Chiang Rak Noi',
        },
        districtId: 79,
      },
      {
        id: '140603',
        zipcode: 13160,
        text: 'บ้านโพ',
        value: 'บ้านโพ',
        name: {
          th: 'บ้านโพ',
          en: 'Ban Pho',
        },
        districtId: 79,
      },
      {
        id: '140604',
        zipcode: 13160,
        text: 'บ้านกรด',
        value: 'บ้านกรด',
        name: {
          th: 'บ้านกรด',
          en: 'Ban Krot',
        },
        districtId: 79,
      },
      {
        id: '140605',
        zipcode: 13160,
        text: 'บางกระสั้น',
        value: 'บางกระสั้น',
        name: {
          th: 'บางกระสั้น',
          en: 'Bang Krasan',
        },
        districtId: 79,
      },
      {
        id: '140606',
        zipcode: 13160,
        text: 'คลองจิก',
        value: 'คลองจิก',
        name: {
          th: 'คลองจิก',
          en: 'Khlong Chik',
        },
        districtId: 79,
      },
      {
        id: '140607',
        zipcode: 13160,
        text: 'บ้านหว้า',
        value: 'บ้านหว้า',
        name: {
          th: 'บ้านหว้า',
          en: 'Ban Wa',
        },
        districtId: 79,
      },
      {
        id: '140608',
        zipcode: 13160,
        text: 'วัดยม',
        value: 'วัดยม',
        name: {
          th: 'วัดยม',
          en: 'Wat Yom',
        },
        districtId: 79,
      },
      {
        id: '140609',
        zipcode: 13160,
        text: 'บางประแดง',
        value: 'บางประแดง',
        name: {
          th: 'บางประแดง',
          en: 'Bang Pradaeng',
        },
        districtId: 79,
      },
      {
        id: '140610',
        zipcode: 13160,
        text: 'สามเรือน',
        value: 'สามเรือน',
        name: {
          th: 'สามเรือน',
          en: 'Sam Ruean',
        },
        districtId: 79,
      },
      {
        id: '140611',
        zipcode: 13160,
        text: 'เกาะเกิด',
        value: 'เกาะเกิด',
        name: {
          th: 'เกาะเกิด',
          en: 'Ko Koet',
        },
        districtId: 79,
      },
      {
        id: '140612',
        zipcode: 13160,
        text: 'บ้านพลับ',
        value: 'บ้านพลับ',
        name: {
          th: 'บ้านพลับ',
          en: 'Ban Phlap',
        },
        districtId: 79,
      },
      {
        id: '140613',
        zipcode: 13160,
        text: 'บ้านแป้ง',
        value: 'บ้านแป้ง',
        name: {
          th: 'บ้านแป้ง',
          en: 'Ban Paeng',
        },
        districtId: 79,
      },
      {
        id: '140614',
        zipcode: 13160,
        text: 'คุ้งลาน',
        value: 'คุ้งลาน',
        name: {
          th: 'คุ้งลาน',
          en: 'Khung Lan',
        },
        districtId: 79,
      },
      {
        id: '140615',
        zipcode: 13160,
        text: 'ตลิ่งชัน',
        value: 'ตลิ่งชัน',
        name: {
          th: 'ตลิ่งชัน',
          en: 'Taling Chan',
        },
        districtId: 79,
      },
      {
        id: '140616',
        zipcode: 13170,
        text: 'บ้านสร้าง',
        value: 'บ้านสร้าง',
        name: {
          th: 'บ้านสร้าง',
          en: 'Ban Sang',
        },
        districtId: 79,
      },
      {
        id: '140617',
        zipcode: 13160,
        text: 'ตลาดเกรียบ',
        value: 'ตลาดเกรียบ',
        name: {
          th: 'ตลาดเกรียบ',
          en: 'Talat Kriap',
        },
        districtId: 79,
      },
      {
        id: '140618',
        zipcode: 13160,
        text: 'ขนอนหลวง',
        value: 'ขนอนหลวง',
        name: {
          th: 'ขนอนหลวง',
          en: 'Khanon Luang',
        },
        districtId: 79,
      },
      {
        id: '140701',
        zipcode: 13220,
        text: 'บางปะหัน',
        value: 'บางปะหัน',
        name: {
          th: 'บางปะหัน',
          en: 'Bang Pahan',
        },
        districtId: 80,
      },
      {
        id: '140702',
        zipcode: 13220,
        text: 'ขยาย',
        value: 'ขยาย',
        name: {
          th: 'ขยาย',
          en: 'Khayai',
        },
        districtId: 80,
      },
      {
        id: '140703',
        zipcode: 13220,
        text: 'บางเดื่อ',
        value: 'บางเดื่อ',
        name: {
          th: 'บางเดื่อ',
          en: 'Bang Duea',
        },
        districtId: 80,
      },
      {
        id: '140704',
        zipcode: 13220,
        text: 'เสาธง',
        value: 'เสาธง',
        name: {
          th: 'เสาธง',
          en: 'Sao Thong',
        },
        districtId: 80,
      },
      {
        id: '140705',
        zipcode: 13220,
        text: 'ทางกลาง',
        value: 'ทางกลาง',
        name: {
          th: 'ทางกลาง',
          en: 'Thang Klang',
        },
        districtId: 80,
      },
      {
        id: '140706',
        zipcode: 13220,
        text: 'บางเพลิง',
        value: 'บางเพลิง',
        name: {
          th: 'บางเพลิง',
          en: 'Bang Phloeng',
        },
        districtId: 80,
      },
      {
        id: '140707',
        zipcode: 13220,
        text: 'หันสัง',
        value: 'หันสัง',
        name: {
          th: 'หันสัง',
          en: 'Hansang',
        },
        districtId: 80,
      },
      {
        id: '140708',
        zipcode: 13220,
        text: 'บางนางร้า',
        value: 'บางนางร้า',
        name: {
          th: 'บางนางร้า',
          en: 'Bang Nang Ra',
        },
        districtId: 80,
      },
      {
        id: '140709',
        zipcode: 13220,
        text: 'ตานิม',
        value: 'ตานิม',
        name: {
          th: 'ตานิม',
          en: 'Ta Nim',
        },
        districtId: 80,
      },
      {
        id: '140710',
        zipcode: 13220,
        text: 'ทับน้ำ',
        value: 'ทับน้ำ',
        name: {
          th: 'ทับน้ำ',
          en: 'Thap Nam',
        },
        districtId: 80,
      },
      {
        id: '140711',
        zipcode: 13220,
        text: 'บ้านม้า',
        value: 'บ้านม้า',
        name: {
          th: 'บ้านม้า',
          en: 'Ban Ma',
        },
        districtId: 80,
      },
      {
        id: '140712',
        zipcode: 13220,
        text: 'ขวัญเมือง',
        value: 'ขวัญเมือง',
        name: {
          th: 'ขวัญเมือง',
          en: 'Khwan Mueang',
        },
        districtId: 80,
      },
      {
        id: '140713',
        zipcode: 13220,
        text: 'บ้านลี่',
        value: 'บ้านลี่',
        name: {
          th: 'บ้านลี่',
          en: 'Ban Li',
        },
        districtId: 80,
      },
      {
        id: '140714',
        zipcode: 13220,
        text: 'โพธิ์สามต้น',
        value: 'โพธิ์สามต้น',
        name: {
          th: 'โพธิ์สามต้น',
          en: 'Pho Sam Ton',
        },
        districtId: 80,
      },
      {
        id: '140715',
        zipcode: 13220,
        text: 'พุทเลา',
        value: 'พุทเลา',
        name: {
          th: 'พุทเลา',
          en: 'Phutlao',
        },
        districtId: 80,
      },
      {
        id: '140716',
        zipcode: 13220,
        text: 'ตาลเอน',
        value: 'ตาลเอน',
        name: {
          th: 'ตาลเอน',
          en: 'Tan En',
        },
        districtId: 80,
      },
      {
        id: '140717',
        zipcode: 13220,
        text: 'บ้านขล้อ',
        value: 'บ้านขล้อ',
        name: {
          th: 'บ้านขล้อ',
          en: 'Ban Khlo',
        },
        districtId: 80,
      },
      {
        id: '140801',
        zipcode: 13120,
        text: 'ผักไห่',
        value: 'ผักไห่',
        name: {
          th: 'ผักไห่',
          en: 'Phak Hai',
        },
        districtId: 81,
      },
      {
        id: '140802',
        zipcode: 13120,
        text: 'อมฤต',
        value: 'อมฤต',
        name: {
          th: 'อมฤต',
          en: 'Ammarit',
        },
        districtId: 81,
      },
      {
        id: '140803',
        zipcode: 13120,
        text: 'บ้านแค',
        value: 'บ้านแค',
        name: {
          th: 'บ้านแค',
          en: 'Ban Khae',
        },
        districtId: 81,
      },
      {
        id: '140804',
        zipcode: 13120,
        text: 'ลาดน้ำเค็ม',
        value: 'ลาดน้ำเค็ม',
        name: {
          th: 'ลาดน้ำเค็ม',
          en: 'Lat Nam Khem',
        },
        districtId: 81,
      },
      {
        id: '140805',
        zipcode: 13120,
        text: 'ตาลาน',
        value: 'ตาลาน',
        name: {
          th: 'ตาลาน',
          en: 'Ta Lan',
        },
        districtId: 81,
      },
      {
        id: '140806',
        zipcode: 13120,
        text: 'ท่าดินแดง',
        value: 'ท่าดินแดง',
        name: {
          th: 'ท่าดินแดง',
          en: 'Tha Din Daeng',
        },
        districtId: 81,
      },
      {
        id: '140807',
        zipcode: 13280,
        text: 'ดอนลาน',
        value: 'ดอนลาน',
        name: {
          th: 'ดอนลาน',
          en: 'Don Lan',
        },
        districtId: 81,
      },
      {
        id: '140808',
        zipcode: 13280,
        text: 'นาคู',
        value: 'นาคู',
        name: {
          th: 'นาคู',
          en: 'Na Khu',
        },
        districtId: 81,
      },
      {
        id: '140809',
        zipcode: 13120,
        text: 'กุฎี',
        value: 'กุฎี',
        name: {
          th: 'กุฎี',
          en: 'Kudi',
        },
        districtId: 81,
      },
      {
        id: '140810',
        zipcode: 13280,
        text: 'ลำตะเคียน',
        value: 'ลำตะเคียน',
        name: {
          th: 'ลำตะเคียน',
          en: 'Lam Takhian',
        },
        districtId: 81,
      },
      {
        id: '140811',
        zipcode: 13120,
        text: 'โคกช้าง',
        value: 'โคกช้าง',
        name: {
          th: 'โคกช้าง',
          en: 'Khok Chang',
        },
        districtId: 81,
      },
      {
        id: '140812',
        zipcode: 13280,
        text: 'จักราช',
        value: 'จักราช',
        name: {
          th: 'จักราช',
          en: 'Chakkarat',
        },
        districtId: 81,
      },
      {
        id: '140813',
        zipcode: 13280,
        text: 'หนองน้ำใหญ่',
        value: 'หนองน้ำใหญ่',
        name: {
          th: 'หนองน้ำใหญ่',
          en: 'Nong Nam Yai',
        },
        districtId: 81,
      },
      {
        id: '140814',
        zipcode: 13120,
        text: 'ลาดชิด',
        value: 'ลาดชิด',
        name: {
          th: 'ลาดชิด',
          en: 'Lat Chit',
        },
        districtId: 81,
      },
      {
        id: '140815',
        zipcode: 13120,
        text: 'หน้าโคก',
        value: 'หน้าโคก',
        name: {
          th: 'หน้าโคก',
          en: 'Na Khok',
        },
        districtId: 81,
      },
      {
        id: '140816',
        zipcode: 13120,
        text: 'บ้านใหญ่',
        value: 'บ้านใหญ่',
        name: {
          th: 'บ้านใหญ่',
          en: 'Ban Yai',
        },
        districtId: 81,
      },
      {
        id: '140901',
        zipcode: 13140,
        text: 'ภาชี',
        value: 'ภาชี',
        name: {
          th: 'ภาชี',
          en: 'Phachi',
        },
        districtId: 82,
      },
      {
        id: '140902',
        zipcode: 13140,
        text: 'โคกม่วง',
        value: 'โคกม่วง',
        name: {
          th: 'โคกม่วง',
          en: 'Khok Muang',
        },
        districtId: 82,
      },
      {
        id: '140903',
        zipcode: 13140,
        text: 'ระโสม',
        value: 'ระโสม',
        name: {
          th: 'ระโสม',
          en: 'Rasom',
        },
        districtId: 82,
      },
      {
        id: '140904',
        zipcode: 13140,
        text: 'หนองน้ำใส',
        value: 'หนองน้ำใส',
        name: {
          th: 'หนองน้ำใส',
          en: 'Nong Nam Sai',
        },
        districtId: 82,
      },
      {
        id: '140905',
        zipcode: 13140,
        text: 'ดอนหญ้านาง',
        value: 'ดอนหญ้านาง',
        name: {
          th: 'ดอนหญ้านาง',
          en: 'Don Ya Nang',
        },
        districtId: 82,
      },
      {
        id: '140906',
        zipcode: 13140,
        text: 'ไผ่ล้อม',
        value: 'ไผ่ล้อม',
        name: {
          th: 'ไผ่ล้อม',
          en: 'Phai Lom',
        },
        districtId: 82,
      },
      {
        id: '140907',
        zipcode: 13140,
        text: 'กระจิว',
        value: 'กระจิว',
        name: {
          th: 'กระจิว',
          en: 'Krachio',
        },
        districtId: 82,
      },
      {
        id: '140908',
        zipcode: 13140,
        text: 'พระแก้ว',
        value: 'พระแก้ว',
        name: {
          th: 'พระแก้ว',
          en: 'Phra Kaeo',
        },
        districtId: 82,
      },
      {
        id: '141001',
        zipcode: 13230,
        text: 'ลาดบัวหลวง',
        value: 'ลาดบัวหลวง',
        name: {
          th: 'ลาดบัวหลวง',
          en: 'Lat Bua Luang',
        },
        districtId: 83,
      },
      {
        id: '141002',
        zipcode: 13230,
        text: 'หลักชัย',
        value: 'หลักชัย',
        name: {
          th: 'หลักชัย',
          en: 'Lak Chai',
        },
        districtId: 83,
      },
      {
        id: '141003',
        zipcode: 13230,
        text: 'สามเมือง',
        value: 'สามเมือง',
        name: {
          th: 'สามเมือง',
          en: 'Sam Mueang',
        },
        districtId: 83,
      },
      {
        id: '141004',
        zipcode: 13230,
        text: 'พระยาบันลือ',
        value: 'พระยาบันลือ',
        name: {
          th: 'พระยาบันลือ',
          en: 'Phraya Banlue',
        },
        districtId: 83,
      },
      {
        id: '141005',
        zipcode: 13230,
        text: 'สิงหนาท',
        value: 'สิงหนาท',
        name: {
          th: 'สิงหนาท',
          en: 'Singhanat',
        },
        districtId: 83,
      },
      {
        id: '141006',
        zipcode: 13230,
        text: 'คู้สลอด',
        value: 'คู้สลอด',
        name: {
          th: 'คู้สลอด',
          en: 'Khu Salot',
        },
        districtId: 83,
      },
      {
        id: '141007',
        zipcode: 13230,
        text: 'คลองพระยาบันลือ',
        value: 'คลองพระยาบันลือ',
        name: {
          th: 'คลองพระยาบันลือ',
          en: 'Khlong Phraya Banlue',
        },
        districtId: 83,
      },
      {
        id: '141101',
        zipcode: 13170,
        text: 'ลำตาเสา',
        value: 'ลำตาเสา',
        name: {
          th: 'ลำตาเสา',
          en: 'Lam Ta Sao',
        },
        districtId: 84,
      },
      {
        id: '141102',
        zipcode: 13170,
        text: 'บ่อตาโล่',
        value: 'บ่อตาโล่',
        name: {
          th: 'บ่อตาโล่',
          en: 'Bo Ta Lo',
        },
        districtId: 84,
      },
      {
        id: '141103',
        zipcode: 13170,
        text: 'วังน้อย',
        value: 'วังน้อย',
        name: {
          th: 'วังน้อย',
          en: 'Wang Noi',
        },
        districtId: 84,
      },
      {
        id: '141104',
        zipcode: 13170,
        text: 'ลำไทร',
        value: 'ลำไทร',
        name: {
          th: 'ลำไทร',
          en: 'Lam Sai',
        },
        districtId: 84,
      },
      {
        id: '141105',
        zipcode: 13170,
        text: 'สนับทึบ',
        value: 'สนับทึบ',
        name: {
          th: 'สนับทึบ',
          en: 'Sanap Thuep',
        },
        districtId: 84,
      },
      {
        id: '141106',
        zipcode: 13170,
        text: 'พยอม',
        value: 'พยอม',
        name: {
          th: 'พยอม',
          en: 'Phayom',
        },
        districtId: 84,
      },
      {
        id: '141107',
        zipcode: 13170,
        text: 'หันตะเภา',
        value: 'หันตะเภา',
        name: {
          th: 'หันตะเภา',
          en: 'Han Taphao',
        },
        districtId: 84,
      },
      {
        id: '141108',
        zipcode: 13170,
        text: 'วังจุฬา',
        value: 'วังจุฬา',
        name: {
          th: 'วังจุฬา',
          en: 'Wang Chula',
        },
        districtId: 84,
      },
      {
        id: '141109',
        zipcode: 13170,
        text: 'ข้าวงาม',
        value: 'ข้าวงาม',
        name: {
          th: 'ข้าวงาม',
          en: 'Khao Ngam',
        },
        districtId: 84,
      },
      {
        id: '141110',
        zipcode: 13170,
        text: 'ชะแมบ',
        value: 'ชะแมบ',
        name: {
          th: 'ชะแมบ',
          en: 'Chamaep',
        },
        districtId: 84,
      },
      {
        id: '141201',
        zipcode: 13110,
        text: 'เสนา',
        value: 'เสนา',
        name: {
          th: 'เสนา',
          en: 'Sena',
        },
        districtId: 85,
      },
      {
        id: '141202',
        zipcode: 13110,
        text: 'บ้านแพน',
        value: 'บ้านแพน',
        name: {
          th: 'บ้านแพน',
          en: 'Ban Phaen',
        },
        districtId: 85,
      },
      {
        id: '141203',
        zipcode: 13110,
        text: 'เจ้าเจ็ด',
        value: 'เจ้าเจ็ด',
        name: {
          th: 'เจ้าเจ็ด',
          en: 'Chao Chet',
        },
        districtId: 85,
      },
      {
        id: '141204',
        zipcode: 13110,
        text: 'สามกอ',
        value: 'สามกอ',
        name: {
          th: 'สามกอ',
          en: 'Sam Ko',
        },
        districtId: 85,
      },
      {
        id: '141205',
        zipcode: 13110,
        text: 'บางนมโค',
        value: 'บางนมโค',
        name: {
          th: 'บางนมโค',
          en: 'Bang Nom Kho',
        },
        districtId: 85,
      },
      {
        id: '141206',
        zipcode: 13110,
        text: 'หัวเวียง',
        value: 'หัวเวียง',
        name: {
          th: 'หัวเวียง',
          en: 'Hua Wiang',
        },
        districtId: 85,
      },
      {
        id: '141207',
        zipcode: 13110,
        text: 'มารวิชัย',
        value: 'มารวิชัย',
        name: {
          th: 'มารวิชัย',
          en: 'Manrawichai',
        },
        districtId: 85,
      },
      {
        id: '141208',
        zipcode: 13110,
        text: 'บ้านโพธิ์',
        value: 'บ้านโพธิ์',
        name: {
          th: 'บ้านโพธิ์',
          en: 'Ban Pho',
        },
        districtId: 85,
      },
      {
        id: '141209',
        zipcode: 13110,
        text: 'รางจรเข้',
        value: 'รางจรเข้',
        name: {
          th: 'รางจรเข้',
          en: 'Rang Chorakhe',
        },
        districtId: 85,
      },
      {
        id: '141210',
        zipcode: 13110,
        text: 'บ้านกระทุ่ม',
        value: 'บ้านกระทุ่ม',
        name: {
          th: 'บ้านกระทุ่ม',
          en: 'Ban Krathum',
        },
        districtId: 85,
      },
      {
        id: '141211',
        zipcode: 13110,
        text: 'บ้านแถว',
        value: 'บ้านแถว',
        name: {
          th: 'บ้านแถว',
          en: 'Ban Thaeo',
        },
        districtId: 85,
      },
      {
        id: '141212',
        zipcode: 13110,
        text: 'ชายนา',
        value: 'ชายนา',
        name: {
          th: 'ชายนา',
          en: 'Chai Na',
        },
        districtId: 85,
      },
      {
        id: '141213',
        zipcode: 13110,
        text: 'สามตุ่ม',
        value: 'สามตุ่ม',
        name: {
          th: 'สามตุ่ม',
          en: 'Sam Tum',
        },
        districtId: 85,
      },
      {
        id: '141214',
        zipcode: 13110,
        text: 'ลาดงา',
        value: 'ลาดงา',
        name: {
          th: 'ลาดงา',
          en: 'Lat Nga',
        },
        districtId: 85,
      },
      {
        id: '141215',
        zipcode: 13110,
        text: 'ดอนทอง',
        value: 'ดอนทอง',
        name: {
          th: 'ดอนทอง',
          en: 'Don Thong',
        },
        districtId: 85,
      },
      {
        id: '141216',
        zipcode: 13110,
        text: 'บ้านหลวง',
        value: 'บ้านหลวง',
        name: {
          th: 'บ้านหลวง',
          en: 'Ban Luang',
        },
        districtId: 85,
      },
      {
        id: '141217',
        zipcode: 13110,
        text: 'เจ้าเสด็จ',
        value: 'เจ้าเสด็จ',
        name: {
          th: 'เจ้าเสด็จ',
          en: 'Chao Sadet',
        },
        districtId: 85,
      },
      {
        id: '141301',
        zipcode: 13270,
        text: 'บางซ้าย',
        value: 'บางซ้าย',
        name: {
          th: 'บางซ้าย',
          en: 'Bang Sai',
        },
        districtId: 86,
      },
      {
        id: '141302',
        zipcode: 13270,
        text: 'แก้วฟ้า',
        value: 'แก้วฟ้า',
        name: {
          th: 'แก้วฟ้า',
          en: 'Kaeo Fa',
        },
        districtId: 86,
      },
      {
        id: '141303',
        zipcode: 13270,
        text: 'เต่าเล่า',
        value: 'เต่าเล่า',
        name: {
          th: 'เต่าเล่า',
          en: 'Tao Lao',
        },
        districtId: 86,
      },
      {
        id: '141304',
        zipcode: 13270,
        text: 'ปลายกลัด',
        value: 'ปลายกลัด',
        name: {
          th: 'ปลายกลัด',
          en: 'Plai Klat',
        },
        districtId: 86,
      },
      {
        id: '141305',
        zipcode: 13270,
        text: 'เทพมงคล',
        value: 'เทพมงคล',
        name: {
          th: 'เทพมงคล',
          en: 'Thep Mongkhon',
        },
        districtId: 86,
      },
      {
        id: '141306',
        zipcode: 13270,
        text: 'วังพัฒนา',
        value: 'วังพัฒนา',
        name: {
          th: 'วังพัฒนา',
          en: 'Wang Phatthana',
        },
        districtId: 86,
      },
      {
        id: '141401',
        zipcode: 13210,
        text: 'คานหาม',
        value: 'คานหาม',
        name: {
          th: 'คานหาม',
          en: 'Khan Ham',
        },
        districtId: 87,
      },
      {
        id: '141402',
        zipcode: 13210,
        text: 'บ้านช้าง',
        value: 'บ้านช้าง',
        name: {
          th: 'บ้านช้าง',
          en: 'Ban Chang',
        },
        districtId: 87,
      },
      {
        id: '141403',
        zipcode: 13210,
        text: 'สามบัณฑิต',
        value: 'สามบัณฑิต',
        name: {
          th: 'สามบัณฑิต',
          en: 'Sam Bandit',
        },
        districtId: 87,
      },
      {
        id: '141404',
        zipcode: 13210,
        text: 'บ้านหีบ',
        value: 'บ้านหีบ',
        name: {
          th: 'บ้านหีบ',
          en: 'Ban Hip',
        },
        districtId: 87,
      },
      {
        id: '141405',
        zipcode: 13210,
        text: 'หนองไม้ซุง',
        value: 'หนองไม้ซุง',
        name: {
          th: 'หนองไม้ซุง',
          en: 'Nong Mai Sung',
        },
        districtId: 87,
      },
      {
        id: '141406',
        zipcode: 13210,
        text: 'อุทัย',
        value: 'อุทัย',
        name: {
          th: 'อุทัย',
          en: 'Uthai',
        },
        districtId: 87,
      },
      {
        id: '141407',
        zipcode: 13210,
        text: 'เสนา',
        value: 'เสนา',
        name: {
          th: 'เสนา',
          en: 'Sena',
        },
        districtId: 87,
      },
      {
        id: '141408',
        zipcode: 13210,
        text: 'หนองน้ำส้ม',
        value: 'หนองน้ำส้ม',
        name: {
          th: 'หนองน้ำส้ม',
          en: 'Nong Nam Som',
        },
        districtId: 87,
      },
      {
        id: '141409',
        zipcode: 13210,
        text: 'โพสาวหาญ',
        value: 'โพสาวหาญ',
        name: {
          th: 'โพสาวหาญ',
          en: 'Pho Sao Han',
        },
        districtId: 87,
      },
      {
        id: '141410',
        zipcode: 13210,
        text: 'ธนู',
        value: 'ธนู',
        name: {
          th: 'ธนู',
          en: 'Thanu',
        },
        districtId: 87,
      },
      {
        id: '141411',
        zipcode: 13210,
        text: 'ข้าวเม่า',
        value: 'ข้าวเม่า',
        name: {
          th: 'ข้าวเม่า',
          en: 'Khao Mao',
        },
        districtId: 87,
      },
      {
        id: '141501',
        zipcode: 13150,
        text: 'หัวไผ่',
        value: 'หัวไผ่',
        name: {
          th: 'หัวไผ่',
          en: 'Hua Phai',
        },
        districtId: 88,
      },
      {
        id: '141502',
        zipcode: 13150,
        text: 'กะทุ่ม',
        value: 'กะทุ่ม',
        name: {
          th: 'กะทุ่ม',
          en: 'Kathum',
        },
        districtId: 88,
      },
      {
        id: '141503',
        zipcode: 13150,
        text: 'มหาราช',
        value: 'มหาราช',
        name: {
          th: 'มหาราช',
          en: 'Maha Rat',
        },
        districtId: 88,
      },
      {
        id: '141504',
        zipcode: 13150,
        text: 'น้ำเต้า',
        value: 'น้ำเต้า',
        name: {
          th: 'น้ำเต้า',
          en: 'Namtao',
        },
        districtId: 88,
      },
      {
        id: '141505',
        zipcode: 13150,
        text: 'บางนา',
        value: 'บางนา',
        name: {
          th: 'บางนา',
          en: 'Bang Na',
        },
        districtId: 88,
      },
      {
        id: '141506',
        zipcode: 13150,
        text: 'โรงช้าง',
        value: 'โรงช้าง',
        name: {
          th: 'โรงช้าง',
          en: 'Rong Chang',
        },
        districtId: 88,
      },
      {
        id: '141507',
        zipcode: 13150,
        text: 'เจ้าปลุก',
        value: 'เจ้าปลุก',
        name: {
          th: 'เจ้าปลุก',
          en: 'Chao Pluk',
        },
        districtId: 88,
      },
      {
        id: '141508',
        zipcode: 13150,
        text: 'พิตเพียน',
        value: 'พิตเพียน',
        name: {
          th: 'พิตเพียน',
          en: 'Phitphian',
        },
        districtId: 88,
      },
      {
        id: '141509',
        zipcode: 13150,
        text: 'บ้านนา',
        value: 'บ้านนา',
        name: {
          th: 'บ้านนา',
          en: 'Ban Na',
        },
        districtId: 88,
      },
      {
        id: '141510',
        zipcode: 13150,
        text: 'บ้านขวาง',
        value: 'บ้านขวาง',
        name: {
          th: 'บ้านขวาง',
          en: 'Ban Khwang',
        },
        districtId: 88,
      },
      {
        id: '141511',
        zipcode: 13150,
        text: 'ท่าตอ',
        value: 'ท่าตอ',
        name: {
          th: 'ท่าตอ',
          en: 'Tha To',
        },
        districtId: 88,
      },
      {
        id: '141512',
        zipcode: 13150,
        text: 'บ้านใหม่',
        value: 'บ้านใหม่',
        name: {
          th: 'บ้านใหม่',
          en: 'Ban Mai',
        },
        districtId: 88,
      },
      {
        id: '141601',
        zipcode: 13240,
        text: 'บ้านแพรก',
        value: 'บ้านแพรก',
        name: {
          th: 'บ้านแพรก',
          en: 'Ban Phraek',
        },
        districtId: 89,
      },
      {
        id: '141602',
        zipcode: 13240,
        text: 'บ้านใหม่',
        value: 'บ้านใหม่',
        name: {
          th: 'บ้านใหม่',
          en: 'Ban Mai',
        },
        districtId: 89,
      },
      {
        id: '141603',
        zipcode: 13240,
        text: 'สำพะเนียง',
        value: 'สำพะเนียง',
        name: {
          th: 'สำพะเนียง',
          en: 'Sam Phaniang',
        },
        districtId: 89,
      },
      {
        id: '141604',
        zipcode: 13240,
        text: 'คลองน้อย',
        value: 'คลองน้อย',
        name: {
          th: 'คลองน้อย',
          en: 'Khlong Noi',
        },
        districtId: 89,
      },
      {
        id: '141605',
        zipcode: 13240,
        text: 'สองห้อง',
        value: 'สองห้อง',
        name: {
          th: 'สองห้อง',
          en: 'Song Hong',
        },
        districtId: 89,
      },
      {
        id: '150101',
        zipcode: 14000,
        text: 'ตลาดหลวง',
        value: 'ตลาดหลวง',
        name: {
          th: 'ตลาดหลวง',
          en: 'Talat Luang',
        },
        districtId: 90,
      },
      {
        id: '150102',
        zipcode: 14000,
        text: 'บางแก้ว',
        value: 'บางแก้ว',
        name: {
          th: 'บางแก้ว',
          en: 'Bang Kaeo',
        },
        districtId: 90,
      },
      {
        id: '150103',
        zipcode: 14000,
        text: 'ศาลาแดง',
        value: 'ศาลาแดง',
        name: {
          th: 'ศาลาแดง',
          en: 'Sala Daeng',
        },
        districtId: 90,
      },
      {
        id: '150104',
        zipcode: 14000,
        text: 'ป่างิ้ว',
        value: 'ป่างิ้ว',
        name: {
          th: 'ป่างิ้ว',
          en: 'Pa Ngio',
        },
        districtId: 90,
      },
      {
        id: '150105',
        zipcode: 14000,
        text: 'บ้านแห',
        value: 'บ้านแห',
        name: {
          th: 'บ้านแห',
          en: 'Ban Hae',
        },
        districtId: 90,
      },
      {
        id: '150106',
        zipcode: 14000,
        text: 'ตลาดกรวด',
        value: 'ตลาดกรวด',
        name: {
          th: 'ตลาดกรวด',
          en: 'Talat Kruat',
        },
        districtId: 90,
      },
      {
        id: '150107',
        zipcode: 14000,
        text: 'มหาดไทย',
        value: 'มหาดไทย',
        name: {
          th: 'มหาดไทย',
          en: 'Mahatthai',
        },
        districtId: 90,
      },
      {
        id: '150108',
        zipcode: 14000,
        text: 'บ้านอิฐ',
        value: 'บ้านอิฐ',
        name: {
          th: 'บ้านอิฐ',
          en: 'Ban It',
        },
        districtId: 90,
      },
      {
        id: '150109',
        zipcode: 14000,
        text: 'หัวไผ่',
        value: 'หัวไผ่',
        name: {
          th: 'หัวไผ่',
          en: 'Hua Phai',
        },
        districtId: 90,
      },
      {
        id: '150110',
        zipcode: 14000,
        text: 'จำปาหล่อ',
        value: 'จำปาหล่อ',
        name: {
          th: 'จำปาหล่อ',
          en: 'Champa Lo',
        },
        districtId: 90,
      },
      {
        id: '150111',
        zipcode: 14000,
        text: 'โพสะ',
        value: 'โพสะ',
        name: {
          th: 'โพสะ',
          en: 'Phosa',
        },
        districtId: 90,
      },
      {
        id: '150112',
        zipcode: 14000,
        text: 'บ้านรี',
        value: 'บ้านรี',
        name: {
          th: 'บ้านรี',
          en: 'Ban Ri',
        },
        districtId: 90,
      },
      {
        id: '150113',
        zipcode: 14000,
        text: 'คลองวัว',
        value: 'คลองวัว',
        name: {
          th: 'คลองวัว',
          en: 'Khlong Wua',
        },
        districtId: 90,
      },
      {
        id: '150114',
        zipcode: 14000,
        text: 'ย่านซื่อ',
        value: 'ย่านซื่อ',
        name: {
          th: 'ย่านซื่อ',
          en: 'Yan Sue',
        },
        districtId: 90,
      },
      {
        id: '150201',
        zipcode: 14140,
        text: 'จรเข้ร้อง',
        value: 'จรเข้ร้อง',
        name: {
          th: 'จรเข้ร้อง',
          en: 'Chorakhe Rong',
        },
        districtId: 91,
      },
      {
        id: '150202',
        zipcode: 14140,
        text: 'ไชยภูมิ',
        value: 'ไชยภูมิ',
        name: {
          th: 'ไชยภูมิ',
          en: 'Chaiyaphum',
        },
        districtId: 91,
      },
      {
        id: '150203',
        zipcode: 14140,
        text: 'ชัยฤทธิ์',
        value: 'ชัยฤทธิ์',
        name: {
          th: 'ชัยฤทธิ์',
          en: 'Chaiyarit',
        },
        districtId: 91,
      },
      {
        id: '150204',
        zipcode: 14140,
        text: 'เทวราช',
        value: 'เทวราช',
        name: {
          th: 'เทวราช',
          en: 'Thewarat',
        },
        districtId: 91,
      },
      {
        id: '150205',
        zipcode: 14140,
        text: 'ราชสถิตย์',
        value: 'ราชสถิตย์',
        name: {
          th: 'ราชสถิตย์',
          en: 'Ratchasathit',
        },
        districtId: 91,
      },
      {
        id: '150206',
        zipcode: 14140,
        text: 'ไชโย',
        value: 'ไชโย',
        name: {
          th: 'ไชโย',
          en: 'Chaiyo',
        },
        districtId: 91,
      },
      {
        id: '150207',
        zipcode: 14140,
        text: 'หลักฟ้า',
        value: 'หลักฟ้า',
        name: {
          th: 'หลักฟ้า',
          en: 'Lak Fa',
        },
        districtId: 91,
      },
      {
        id: '150208',
        zipcode: 14140,
        text: 'ชะไว',
        value: 'ชะไว',
        name: {
          th: 'ชะไว',
          en: 'Chawai',
        },
        districtId: 91,
      },
      {
        id: '150209',
        zipcode: 14140,
        text: 'ตรีณรงค์',
        value: 'ตรีณรงค์',
        name: {
          th: 'ตรีณรงค์',
          en: 'Tri Narong',
        },
        districtId: 91,
      },
      {
        id: '150301',
        zipcode: 14130,
        text: 'บางปลากด',
        value: 'บางปลากด',
        name: {
          th: 'บางปลากด',
          en: 'Bang Pla Kot',
        },
        districtId: 92,
      },
      {
        id: '150302',
        zipcode: 14130,
        text: 'ป่าโมก',
        value: 'ป่าโมก',
        name: {
          th: 'ป่าโมก',
          en: 'Pa Mok',
        },
        districtId: 92,
      },
      {
        id: '150303',
        zipcode: 14130,
        text: 'สายทอง',
        value: 'สายทอง',
        name: {
          th: 'สายทอง',
          en: 'Sai Thong',
        },
        districtId: 92,
      },
      {
        id: '150304',
        zipcode: 14130,
        text: 'โรงช้าง',
        value: 'โรงช้าง',
        name: {
          th: 'โรงช้าง',
          en: 'Rong Chang',
        },
        districtId: 92,
      },
      {
        id: '150305',
        zipcode: 14130,
        text: 'บางเสด็จ',
        value: 'บางเสด็จ',
        name: {
          th: 'บางเสด็จ',
          en: 'Bang Sadet',
        },
        districtId: 92,
      },
      {
        id: '150306',
        zipcode: 14130,
        text: 'นรสิงห์',
        value: 'นรสิงห์',
        name: {
          th: 'นรสิงห์',
          en: 'Norasing',
        },
        districtId: 92,
      },
      {
        id: '150307',
        zipcode: 14130,
        text: 'เอกราช',
        value: 'เอกราช',
        name: {
          th: 'เอกราช',
          en: 'Ekkarat',
        },
        districtId: 92,
      },
      {
        id: '150308',
        zipcode: 14130,
        text: 'โผงเผง',
        value: 'โผงเผง',
        name: {
          th: 'โผงเผง',
          en: 'Phong Pheng',
        },
        districtId: 92,
      },
      {
        id: '150401',
        zipcode: 14120,
        text: 'อ่างแก้ว',
        value: 'อ่างแก้ว',
        name: {
          th: 'อ่างแก้ว',
          en: 'Ang Kaeo',
        },
        districtId: 93,
      },
      {
        id: '150402',
        zipcode: 14120,
        text: 'อินทประมูล',
        value: 'อินทประมูล',
        name: {
          th: 'อินทประมูล',
          en: 'Inthapramun',
        },
        districtId: 93,
      },
      {
        id: '150403',
        zipcode: 14120,
        text: 'บางพลับ',
        value: 'บางพลับ',
        name: {
          th: 'บางพลับ',
          en: 'Bang Phlap',
        },
        districtId: 93,
      },
      {
        id: '150404',
        zipcode: 14120,
        text: 'หนองแม่ไก่',
        value: 'หนองแม่ไก่',
        name: {
          th: 'หนองแม่ไก่',
          en: 'Nong Mae Kai',
        },
        districtId: 93,
      },
      {
        id: '150405',
        zipcode: 14120,
        text: 'รำมะสัก',
        value: 'รำมะสัก',
        name: {
          th: 'รำมะสัก',
          en: 'Ram Ma Sak',
        },
        districtId: 93,
      },
      {
        id: '150406',
        zipcode: 14120,
        text: 'บางระกำ',
        value: 'บางระกำ',
        name: {
          th: 'บางระกำ',
          en: 'Bang Rakam',
        },
        districtId: 93,
      },
      {
        id: '150407',
        zipcode: 14120,
        text: 'โพธิ์รังนก',
        value: 'โพธิ์รังนก',
        name: {
          th: 'โพธิ์รังนก',
          en: 'Pho Rang Nok',
        },
        districtId: 93,
      },
      {
        id: '150408',
        zipcode: 14120,
        text: 'องครักษ์',
        value: 'องครักษ์',
        name: {
          th: 'องครักษ์',
          en: 'Ongkharak',
        },
        districtId: 93,
      },
      {
        id: '150409',
        zipcode: 14120,
        text: 'โคกพุทรา',
        value: 'โคกพุทรา',
        name: {
          th: 'โคกพุทรา',
          en: 'Khok Phutsa',
        },
        districtId: 93,
      },
      {
        id: '150410',
        zipcode: 14120,
        text: 'ยางช้าย',
        value: 'ยางช้าย',
        name: {
          th: 'ยางช้าย',
          en: 'Yang Chai',
        },
        districtId: 93,
      },
      {
        id: '150411',
        zipcode: 14120,
        text: 'บ่อแร่',
        value: 'บ่อแร่',
        name: {
          th: 'บ่อแร่',
          en: 'Bo Rae',
        },
        districtId: 93,
      },
      {
        id: '150412',
        zipcode: 14120,
        text: 'ทางพระ',
        value: 'ทางพระ',
        name: {
          th: 'ทางพระ',
          en: 'Thang Phra',
        },
        districtId: 93,
      },
      {
        id: '150413',
        zipcode: 14120,
        text: 'สามง่าม',
        value: 'สามง่าม',
        name: {
          th: 'สามง่าม',
          en: 'Sam Ngam',
        },
        districtId: 93,
      },
      {
        id: '150414',
        zipcode: 14120,
        text: 'บางเจ้าฉ่า',
        value: 'บางเจ้าฉ่า',
        name: {
          th: 'บางเจ้าฉ่า',
          en: 'Bang Chao Cha',
        },
        districtId: 93,
      },
      {
        id: '150415',
        zipcode: 14120,
        text: 'คำหยาด',
        value: 'คำหยาด',
        name: {
          th: 'คำหยาด',
          en: 'Kham Yat',
        },
        districtId: 93,
      },
      {
        id: '150501',
        zipcode: 14150,
        text: 'แสวงหา',
        value: 'แสวงหา',
        name: {
          th: 'แสวงหา',
          en: 'Sawaeng Ha',
        },
        districtId: 94,
      },
      {
        id: '150502',
        zipcode: 14150,
        text: 'ศรีพราน',
        value: 'ศรีพราน',
        name: {
          th: 'ศรีพราน',
          en: 'Si Phran',
        },
        districtId: 94,
      },
      {
        id: '150503',
        zipcode: 14150,
        text: 'บ้านพราน',
        value: 'บ้านพราน',
        name: {
          th: 'บ้านพราน',
          en: 'Ban Phran',
        },
        districtId: 94,
      },
      {
        id: '150504',
        zipcode: 14150,
        text: 'วังน้ำเย็น',
        value: 'วังน้ำเย็น',
        name: {
          th: 'วังน้ำเย็น',
          en: 'Wang Nam Yen',
        },
        districtId: 94,
      },
      {
        id: '150505',
        zipcode: 14150,
        text: 'สีบัวทอง',
        value: 'สีบัวทอง',
        name: {
          th: 'สีบัวทอง',
          en: 'Si Bua Thong',
        },
        districtId: 94,
      },
      {
        id: '150506',
        zipcode: 14150,
        text: 'ห้วยไผ่',
        value: 'ห้วยไผ่',
        name: {
          th: 'ห้วยไผ่',
          en: 'Huai Phai',
        },
        districtId: 94,
      },
      {
        id: '150507',
        zipcode: 14150,
        text: 'จำลอง',
        value: 'จำลอง',
        name: {
          th: 'จำลอง',
          en: 'Chamlong',
        },
        districtId: 94,
      },
      {
        id: '150601',
        zipcode: 14110,
        text: 'ไผ่จำศิล',
        value: 'ไผ่จำศิล',
        name: {
          th: 'ไผ่จำศิล',
          en: 'Phai Cham Sin',
        },
        districtId: 95,
      },
      {
        id: '150602',
        zipcode: 14110,
        text: 'ศาลเจ้าโรงทอง',
        value: 'ศาลเจ้าโรงทอง',
        name: {
          th: 'ศาลเจ้าโรงทอง',
          en: 'San Chao Rong Thong',
        },
        districtId: 95,
      },
      {
        id: '150603',
        zipcode: 14110,
        text: 'ไผ่ดำพัฒนา',
        value: 'ไผ่ดำพัฒนา',
        name: {
          th: 'ไผ่ดำพัฒนา',
          en: 'Phai Dam Phatthana',
        },
        districtId: 95,
      },
      {
        id: '150604',
        zipcode: 14110,
        text: 'สาวร้องไห้',
        value: 'สาวร้องไห้',
        name: {
          th: 'สาวร้องไห้',
          en: 'Sao Rong Hai',
        },
        districtId: 95,
      },
      {
        id: '150605',
        zipcode: 14110,
        text: 'ท่าช้าง',
        value: 'ท่าช้าง',
        name: {
          th: 'ท่าช้าง',
          en: 'Tha Chang',
        },
        districtId: 95,
      },
      {
        id: '150606',
        zipcode: 14110,
        text: 'ยี่ล้น',
        value: 'ยี่ล้น',
        name: {
          th: 'ยี่ล้น',
          en: 'Yi Lon',
        },
        districtId: 95,
      },
      {
        id: '150607',
        zipcode: 14110,
        text: 'บางจัก',
        value: 'บางจัก',
        name: {
          th: 'บางจัก',
          en: 'Bang Chak',
        },
        districtId: 95,
      },
      {
        id: '150608',
        zipcode: 14110,
        text: 'ห้วยคันแหลน',
        value: 'ห้วยคันแหลน',
        name: {
          th: 'ห้วยคันแหลน',
          en: 'Huai Khan Laen',
        },
        districtId: 95,
      },
      {
        id: '150609',
        zipcode: 14110,
        text: 'คลองขนาก',
        value: 'คลองขนาก',
        name: {
          th: 'คลองขนาก',
          en: 'Khlong Khanak',
        },
        districtId: 95,
      },
      {
        id: '150610',
        zipcode: 14110,
        text: 'ไผ่วง',
        value: 'ไผ่วง',
        name: {
          th: 'ไผ่วง',
          en: 'Phai Wong',
        },
        districtId: 95,
      },
      {
        id: '150611',
        zipcode: 14110,
        text: 'สี่ร้อย',
        value: 'สี่ร้อย',
        name: {
          th: 'สี่ร้อย',
          en: 'Si Roi',
        },
        districtId: 95,
      },
      {
        id: '150612',
        zipcode: 14110,
        text: 'ม่วงเตี้ย',
        value: 'ม่วงเตี้ย',
        name: {
          th: 'ม่วงเตี้ย',
          en: 'Muang Tia',
        },
        districtId: 95,
      },
      {
        id: '150613',
        zipcode: 14110,
        text: 'หัวตะพาน',
        value: 'หัวตะพาน',
        name: {
          th: 'หัวตะพาน',
          en: 'Hua Taphan',
        },
        districtId: 95,
      },
      {
        id: '150614',
        zipcode: 14110,
        text: 'หลักแก้ว',
        value: 'หลักแก้ว',
        name: {
          th: 'หลักแก้ว',
          en: 'Lak Kaeo',
        },
        districtId: 95,
      },
      {
        id: '150615',
        zipcode: 14110,
        text: 'ตลาดใหม่',
        value: 'ตลาดใหม่',
        name: {
          th: 'ตลาดใหม่',
          en: 'Talat Mai',
        },
        districtId: 95,
      },
      {
        id: '150701',
        zipcode: 14160,
        text: 'สามโก้',
        value: 'สามโก้',
        name: {
          th: 'สามโก้',
          en: 'Samko',
        },
        districtId: 96,
      },
      {
        id: '150702',
        zipcode: 14160,
        text: 'ราษฎรพัฒนา',
        value: 'ราษฎรพัฒนา',
        name: {
          th: 'ราษฎรพัฒนา',
          en: 'Ratsadon Phatthana',
        },
        districtId: 96,
      },
      {
        id: '150703',
        zipcode: 14160,
        text: 'อบทม',
        value: 'อบทม',
        name: {
          th: 'อบทม',
          en: 'Op Thom',
        },
        districtId: 96,
      },
      {
        id: '150704',
        zipcode: 14160,
        text: 'โพธิ์ม่วงพันธ์',
        value: 'โพธิ์ม่วงพันธ์',
        name: {
          th: 'โพธิ์ม่วงพันธ์',
          en: 'Pho Muang Phan',
        },
        districtId: 96,
      },
      {
        id: '150705',
        zipcode: 14160,
        text: 'มงคลธรรมนิมิต',
        value: 'มงคลธรรมนิมิต',
        name: {
          th: 'มงคลธรรมนิมิต',
          en: 'Mongkhon Tham Nimit',
        },
        districtId: 96,
      },
      {
        id: '160101',
        zipcode: 15000,
        text: 'ทะเลชุบศร',
        value: 'ทะเลชุบศร',
        name: {
          th: 'ทะเลชุบศร',
          en: 'Thale Chup Son',
        },
        districtId: 97,
      },
      {
        id: '160102',
        zipcode: 15000,
        text: 'ท่าหิน',
        value: 'ท่าหิน',
        name: {
          th: 'ท่าหิน',
          en: 'Tha Hin',
        },
        districtId: 97,
      },
      {
        id: '160103',
        zipcode: 15000,
        text: 'กกโก',
        value: 'กกโก',
        name: {
          th: 'กกโก',
          en: 'Kok Ko',
        },
        districtId: 97,
      },
      {
        id: '160104',
        zipcode: 13240,
        text: 'โก่งธนู',
        value: 'โก่งธนู',
        name: {
          th: 'โก่งธนู',
          en: 'Kong Thanu',
        },
        districtId: 97,
      },
      {
        id: '160105',
        zipcode: 15000,
        text: 'เขาพระงาม',
        value: 'เขาพระงาม',
        name: {
          th: 'เขาพระงาม',
          en: 'Khao Phra Ngam',
        },
        districtId: 97,
      },
      {
        id: '160106',
        zipcode: 15000,
        text: 'เขาสามยอด',
        value: 'เขาสามยอด',
        name: {
          th: 'เขาสามยอด',
          en: 'Khao Sam Yot',
        },
        districtId: 97,
      },
      {
        id: '160107',
        zipcode: 15000,
        text: 'โคกกะเทียม',
        value: 'โคกกะเทียม',
        name: {
          th: 'โคกกะเทียม',
          en: 'Khok Kathiam',
        },
        districtId: 97,
      },
      {
        id: '160108',
        zipcode: 15000,
        text: 'โคกลำพาน',
        value: 'โคกลำพาน',
        name: {
          th: 'โคกลำพาน',
          en: 'Khok Lam Phan',
        },
        districtId: 97,
      },
      {
        id: '160109',
        zipcode: 15210,
        text: 'โคกตูม',
        value: 'โคกตูม',
        name: {
          th: 'โคกตูม',
          en: 'Khok Tum',
        },
        districtId: 97,
      },
      {
        id: '160110',
        zipcode: 15000,
        text: 'งิ้วราย',
        value: 'งิ้วราย',
        name: {
          th: 'งิ้วราย',
          en: 'Ngio Rai',
        },
        districtId: 97,
      },
      {
        id: '160111',
        zipcode: 15000,
        text: 'ดอนโพธิ์',
        value: 'ดอนโพธิ์',
        name: {
          th: 'ดอนโพธิ์',
          en: 'Don Pho',
        },
        districtId: 97,
      },
      {
        id: '160112',
        zipcode: 15000,
        text: 'ตะลุง',
        value: 'ตะลุง',
        name: {
          th: 'ตะลุง',
          en: 'Talung',
        },
        districtId: 97,
      },
      {
        id: '160114',
        zipcode: 15000,
        text: 'ท่าแค',
        value: 'ท่าแค',
        name: {
          th: 'ท่าแค',
          en: 'Tha Khae',
        },
        districtId: 97,
      },
      {
        id: '160115',
        zipcode: 15000,
        text: 'ท่าศาลา',
        value: 'ท่าศาลา',
        name: {
          th: 'ท่าศาลา',
          en: 'Tha Sala',
        },
        districtId: 97,
      },
      {
        id: '160116',
        zipcode: 15000,
        text: 'นิคมสร้างตนเอง',
        value: 'นิคมสร้างตนเอง',
        name: {
          th: 'นิคมสร้างตนเอง',
          en: 'Nikhom Sang Ton-eng',
        },
        districtId: 97,
      },
      {
        id: '160117',
        zipcode: 15000,
        text: 'บางขันหมาก',
        value: 'บางขันหมาก',
        name: {
          th: 'บางขันหมาก',
          en: 'Bang Khan Mak',
        },
        districtId: 97,
      },
      {
        id: '160118',
        zipcode: 15000,
        text: 'บ้านข่อย',
        value: 'บ้านข่อย',
        name: {
          th: 'บ้านข่อย',
          en: 'Ban Khoi',
        },
        districtId: 97,
      },
      {
        id: '160119',
        zipcode: 15000,
        text: 'ท้ายตลาด',
        value: 'ท้ายตลาด',
        name: {
          th: 'ท้ายตลาด',
          en: 'Thai Talat',
        },
        districtId: 97,
      },
      {
        id: '160120',
        zipcode: 15000,
        text: 'ป่าตาล',
        value: 'ป่าตาล',
        name: {
          th: 'ป่าตาล',
          en: 'Pa Tan',
        },
        districtId: 97,
      },
      {
        id: '160121',
        zipcode: 15000,
        text: 'พรหมมาสตร์',
        value: 'พรหมมาสตร์',
        name: {
          th: 'พรหมมาสตร์',
          en: 'Phrommat',
        },
        districtId: 97,
      },
      {
        id: '160122',
        zipcode: 15000,
        text: 'โพธิ์เก้าต้น',
        value: 'โพธิ์เก้าต้น',
        name: {
          th: 'โพธิ์เก้าต้น',
          en: 'Pho Kao Ton',
        },
        districtId: 97,
      },
      {
        id: '160123',
        zipcode: 15000,
        text: 'โพธิ์ตรุ',
        value: 'โพธิ์ตรุ',
        name: {
          th: 'โพธิ์ตรุ',
          en: 'Pho Tru',
        },
        districtId: 97,
      },
      {
        id: '160124',
        zipcode: 15000,
        text: 'สี่คลอง',
        value: 'สี่คลอง',
        name: {
          th: 'สี่คลอง',
          en: 'Si Khlong',
        },
        districtId: 97,
      },
      {
        id: '160125',
        zipcode: 15000,
        text: 'ถนนใหญ่',
        value: 'ถนนใหญ่',
        name: {
          th: 'ถนนใหญ่',
          en: 'Thanon Yai',
        },
        districtId: 97,
      },
      {
        id: '160201',
        zipcode: 15140,
        text: 'พัฒนานิคม',
        value: 'พัฒนานิคม',
        name: {
          th: 'พัฒนานิคม',
          en: 'Phatthana Nikhom',
        },
        districtId: 98,
      },
      {
        id: '160202',
        zipcode: 15220,
        text: 'ช่องสาริกา',
        value: 'ช่องสาริกา',
        name: {
          th: 'ช่องสาริกา',
          en: 'Chong Sarika',
        },
        districtId: 98,
      },
      {
        id: '160203',
        zipcode: 15140,
        text: 'มะนาวหวาน',
        value: 'มะนาวหวาน',
        name: {
          th: 'มะนาวหวาน',
          en: 'Manao Wan',
        },
        districtId: 98,
      },
      {
        id: '160204',
        zipcode: 15220,
        text: 'ดีลัง',
        value: 'ดีลัง',
        name: {
          th: 'ดีลัง',
          en: 'Di Lang',
        },
        districtId: 98,
      },
      {
        id: '160205',
        zipcode: 15140,
        text: 'โคกสลุง',
        value: 'โคกสลุง',
        name: {
          th: 'โคกสลุง',
          en: 'Khok Salung',
        },
        districtId: 98,
      },
      {
        id: '160206',
        zipcode: 15140,
        text: 'ชอนน้อย',
        value: 'ชอนน้อย',
        name: {
          th: 'ชอนน้อย',
          en: 'Chon Noi',
        },
        districtId: 98,
      },
      {
        id: '160207',
        zipcode: 15140,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 98,
      },
      {
        id: '160208',
        zipcode: 18220,
        text: 'ห้วยขุนราม',
        value: 'ห้วยขุนราม',
        name: {
          th: 'ห้วยขุนราม',
          en: 'Huai Khun Ram',
        },
        districtId: 98,
      },
      {
        id: '160209',
        zipcode: 15140,
        text: 'น้ำสุด',
        value: 'น้ำสุด',
        name: {
          th: 'น้ำสุด',
          en: 'Nam Sut',
        },
        districtId: 98,
      },
      {
        id: '160301',
        zipcode: 15120,
        text: 'โคกสำโรง',
        value: 'โคกสำโรง',
        name: {
          th: 'โคกสำโรง',
          en: 'Khok Samrong',
        },
        districtId: 99,
      },
      {
        id: '160302',
        zipcode: 15120,
        text: 'เกาะแก้ว',
        value: 'เกาะแก้ว',
        name: {
          th: 'เกาะแก้ว',
          en: 'Ko Kaeo',
        },
        districtId: 99,
      },
      {
        id: '160303',
        zipcode: 15120,
        text: 'ถลุงเหล็ก',
        value: 'ถลุงเหล็ก',
        name: {
          th: 'ถลุงเหล็ก',
          en: 'Thalung Lek',
        },
        districtId: 99,
      },
      {
        id: '160304',
        zipcode: 15120,
        text: 'หลุมข้าว',
        value: 'หลุมข้าว',
        name: {
          th: 'หลุมข้าว',
          en: 'Lum Khao',
        },
        districtId: 99,
      },
      {
        id: '160305',
        zipcode: 15120,
        text: 'ห้วยโป่ง',
        value: 'ห้วยโป่ง',
        name: {
          th: 'ห้วยโป่ง',
          en: 'Huai Pong',
        },
        districtId: 99,
      },
      {
        id: '160306',
        zipcode: 15120,
        text: 'คลองเกตุ',
        value: 'คลองเกตุ',
        name: {
          th: 'คลองเกตุ',
          en: 'Khlong Ket',
        },
        districtId: 99,
      },
      {
        id: '160307',
        zipcode: 15120,
        text: 'สะแกราบ',
        value: 'สะแกราบ',
        name: {
          th: 'สะแกราบ',
          en: 'Sakae Rap',
        },
        districtId: 99,
      },
      {
        id: '160308',
        zipcode: 15120,
        text: 'เพนียด',
        value: 'เพนียด',
        name: {
          th: 'เพนียด',
          en: 'Phaniat',
        },
        districtId: 99,
      },
      {
        id: '160309',
        zipcode: 15120,
        text: 'วังเพลิง',
        value: 'วังเพลิง',
        name: {
          th: 'วังเพลิง',
          en: 'Wang Phloeng',
        },
        districtId: 99,
      },
      {
        id: '160310',
        zipcode: 15120,
        text: 'ดงมะรุม',
        value: 'ดงมะรุม',
        name: {
          th: 'ดงมะรุม',
          en: 'Dong Marum',
        },
        districtId: 99,
      },
      {
        id: '160318',
        zipcode: 15120,
        text: 'วังขอนขว้าง',
        value: 'วังขอนขว้าง',
        name: {
          th: 'วังขอนขว้าง',
          en: 'Wang Khon Khwang',
        },
        districtId: 99,
      },
      {
        id: '160320',
        zipcode: 15120,
        text: 'วังจั่น',
        value: 'วังจั่น',
        name: {
          th: 'วังจั่น',
          en: 'Wang Chan',
        },
        districtId: 99,
      },
      {
        id: '160322',
        zipcode: 15120,
        text: 'หนองแขม',
        value: 'หนองแขม',
        name: {
          th: 'หนองแขม',
          en: 'Nong Khaem',
        },
        districtId: 99,
      },
      {
        id: '160401',
        zipcode: 15130,
        text: 'ลำนารายณ์',
        value: 'ลำนารายณ์',
        name: {
          th: 'ลำนารายณ์',
          en: 'Lam Narai',
        },
        districtId: 100,
      },
      {
        id: '160402',
        zipcode: 15130,
        text: 'ชัยนารายณ์',
        value: 'ชัยนารายณ์',
        name: {
          th: 'ชัยนารายณ์',
          en: 'Chai Narai',
        },
        districtId: 100,
      },
      {
        id: '160403',
        zipcode: 15130,
        text: 'ศิลาทิพย์',
        value: 'ศิลาทิพย์',
        name: {
          th: 'ศิลาทิพย์',
          en: 'Sila Thip',
        },
        districtId: 100,
      },
      {
        id: '160404',
        zipcode: 15130,
        text: 'ห้วยหิน',
        value: 'ห้วยหิน',
        name: {
          th: 'ห้วยหิน',
          en: 'Huai Hin',
        },
        districtId: 100,
      },
      {
        id: '160405',
        zipcode: 15230,
        text: 'ม่วงค่อม',
        value: 'ม่วงค่อม',
        name: {
          th: 'ม่วงค่อม',
          en: 'Muang Khom',
        },
        districtId: 100,
      },
      {
        id: '160406',
        zipcode: 15130,
        text: 'บัวชุม',
        value: 'บัวชุม',
        name: {
          th: 'บัวชุม',
          en: 'Bua Chum',
        },
        districtId: 100,
      },
      {
        id: '160407',
        zipcode: 15130,
        text: 'ท่าดินดำ',
        value: 'ท่าดินดำ',
        name: {
          th: 'ท่าดินดำ',
          en: 'Tha Din Dam',
        },
        districtId: 100,
      },
      {
        id: '160408',
        zipcode: 15230,
        text: 'มะกอกหวาน',
        value: 'มะกอกหวาน',
        name: {
          th: 'มะกอกหวาน',
          en: 'Makok Wan',
        },
        districtId: 100,
      },
      {
        id: '160409',
        zipcode: 15130,
        text: 'ซับตะเคียน',
        value: 'ซับตะเคียน',
        name: {
          th: 'ซับตะเคียน',
          en: 'Sap Takhian',
        },
        districtId: 100,
      },
      {
        id: '160410',
        zipcode: 15190,
        text: 'นาโสม',
        value: 'นาโสม',
        name: {
          th: 'นาโสม',
          en: 'Na Som',
        },
        districtId: 100,
      },
      {
        id: '160411',
        zipcode: 15130,
        text: 'หนองยายโต๊ะ',
        value: 'หนองยายโต๊ะ',
        name: {
          th: 'หนองยายโต๊ะ',
          en: 'Nong Yai To',
        },
        districtId: 100,
      },
      {
        id: '160412',
        zipcode: 15130,
        text: 'เกาะรัง',
        value: 'เกาะรัง',
        name: {
          th: 'เกาะรัง',
          en: 'Ko Rang',
        },
        districtId: 100,
      },
      {
        id: '160414',
        zipcode: 15130,
        text: 'ท่ามะนาว',
        value: 'ท่ามะนาว',
        name: {
          th: 'ท่ามะนาว',
          en: 'Tha Manao',
        },
        districtId: 100,
      },
      {
        id: '160417',
        zipcode: 15130,
        text: 'นิคมลำนารายณ์',
        value: 'นิคมลำนารายณ์',
        name: {
          th: 'นิคมลำนารายณ์',
          en: 'Nikhom Lam Narai',
        },
        districtId: 100,
      },
      {
        id: '160418',
        zipcode: 15230,
        text: 'ชัยบาดาล',
        value: 'ชัยบาดาล',
        name: {
          th: 'ชัยบาดาล',
          en: 'Chai Badan',
        },
        districtId: 100,
      },
      {
        id: '160419',
        zipcode: 15130,
        text: 'บ้านใหม่สามัคคี',
        value: 'บ้านใหม่สามัคคี',
        name: {
          th: 'บ้านใหม่สามัคคี',
          en: 'Ban Mai Samakkhi',
        },
        districtId: 100,
      },
      {
        id: '160422',
        zipcode: 15130,
        text: 'เขาแหลม',
        value: 'เขาแหลม',
        name: {
          th: 'เขาแหลม',
          en: 'Khao Laem',
        },
        districtId: 100,
      },
      {
        id: '160501',
        zipcode: 15150,
        text: 'ท่าวุ้ง',
        value: 'ท่าวุ้ง',
        name: {
          th: 'ท่าวุ้ง',
          en: 'Tha Wung',
        },
        districtId: 101,
      },
      {
        id: '160502',
        zipcode: 15150,
        text: 'บางคู้',
        value: 'บางคู้',
        name: {
          th: 'บางคู้',
          en: 'Bang Khu',
        },
        districtId: 101,
      },
      {
        id: '160503',
        zipcode: 15150,
        text: 'โพตลาดแก้ว',
        value: 'โพตลาดแก้ว',
        name: {
          th: 'โพตลาดแก้ว',
          en: 'Pho Talat Kaeo',
        },
        districtId: 101,
      },
      {
        id: '160504',
        zipcode: 15150,
        text: 'บางลี่',
        value: 'บางลี่',
        name: {
          th: 'บางลี่',
          en: 'Bang Li',
        },
        districtId: 101,
      },
      {
        id: '160505',
        zipcode: 15150,
        text: 'บางงา',
        value: 'บางงา',
        name: {
          th: 'บางงา',
          en: 'Bang Nga',
        },
        districtId: 101,
      },
      {
        id: '160506',
        zipcode: 15150,
        text: 'โคกสลุด',
        value: 'โคกสลุด',
        name: {
          th: 'โคกสลุด',
          en: 'Khok Salut',
        },
        districtId: 101,
      },
      {
        id: '160507',
        zipcode: 15180,
        text: 'เขาสมอคอน',
        value: 'เขาสมอคอน',
        name: {
          th: 'เขาสมอคอน',
          en: 'Khao Samo Khon',
        },
        districtId: 101,
      },
      {
        id: '160508',
        zipcode: 15150,
        text: 'หัวสำโรง',
        value: 'หัวสำโรง',
        name: {
          th: 'หัวสำโรง',
          en: 'Hua Samrong',
        },
        districtId: 101,
      },
      {
        id: '160509',
        zipcode: 15150,
        text: 'ลาดสาลี่',
        value: 'ลาดสาลี่',
        name: {
          th: 'ลาดสาลี่',
          en: 'Lat Sali',
        },
        districtId: 101,
      },
      {
        id: '160510',
        zipcode: 15150,
        text: 'บ้านเบิก',
        value: 'บ้านเบิก',
        name: {
          th: 'บ้านเบิก',
          en: 'Ban Boek',
        },
        districtId: 101,
      },
      {
        id: '160511',
        zipcode: 15150,
        text: 'มุจลินท์',
        value: 'มุจลินท์',
        name: {
          th: 'มุจลินท์',
          en: 'Mutchalin',
        },
        districtId: 101,
      },
      {
        id: '160601',
        zipcode: 15110,
        text: 'ไผ่ใหญ่',
        value: 'ไผ่ใหญ่',
        name: {
          th: 'ไผ่ใหญ่',
          en: 'Phai Yai',
        },
        districtId: 102,
      },
      {
        id: '160602',
        zipcode: 15110,
        text: 'บ้านทราย',
        value: 'บ้านทราย',
        name: {
          th: 'บ้านทราย',
          en: 'Ban Sai',
        },
        districtId: 102,
      },
      {
        id: '160603',
        zipcode: 15110,
        text: 'บ้านกล้วย',
        value: 'บ้านกล้วย',
        name: {
          th: 'บ้านกล้วย',
          en: 'Ban Kluai',
        },
        districtId: 102,
      },
      {
        id: '160604',
        zipcode: 15110,
        text: 'ดงพลับ',
        value: 'ดงพลับ',
        name: {
          th: 'ดงพลับ',
          en: 'Dong Phlap',
        },
        districtId: 102,
      },
      {
        id: '160605',
        zipcode: 15180,
        text: 'บ้านชี',
        value: 'บ้านชี',
        name: {
          th: 'บ้านชี',
          en: 'Ban Chi',
        },
        districtId: 102,
      },
      {
        id: '160606',
        zipcode: 15110,
        text: 'พุคา',
        value: 'พุคา',
        name: {
          th: 'พุคา',
          en: 'Phu Kha',
        },
        districtId: 102,
      },
      {
        id: '160607',
        zipcode: 15110,
        text: 'หินปัก',
        value: 'หินปัก',
        name: {
          th: 'หินปัก',
          en: 'Hin Pak',
        },
        districtId: 102,
      },
      {
        id: '160608',
        zipcode: 15110,
        text: 'บางพึ่ง',
        value: 'บางพึ่ง',
        name: {
          th: 'บางพึ่ง',
          en: 'Bang Phueng',
        },
        districtId: 102,
      },
      {
        id: '160609',
        zipcode: 15110,
        text: 'หนองทรายขาว',
        value: 'หนองทรายขาว',
        name: {
          th: 'หนองทรายขาว',
          en: 'Nong Sai Khao',
        },
        districtId: 102,
      },
      {
        id: '160610',
        zipcode: 15110,
        text: 'บางกะพี้',
        value: 'บางกะพี้',
        name: {
          th: 'บางกะพี้',
          en: 'Bang Kaphi',
        },
        districtId: 102,
      },
      {
        id: '160611',
        zipcode: 15110,
        text: 'หนองเต่า',
        value: 'หนองเต่า',
        name: {
          th: 'หนองเต่า',
          en: 'Nong Tao',
        },
        districtId: 102,
      },
      {
        id: '160612',
        zipcode: 15110,
        text: 'โพนทอง',
        value: 'โพนทอง',
        name: {
          th: 'โพนทอง',
          en: 'Phon Thong',
        },
        districtId: 102,
      },
      {
        id: '160613',
        zipcode: 15180,
        text: 'บางขาม',
        value: 'บางขาม',
        name: {
          th: 'บางขาม',
          en: 'Bang Kham',
        },
        districtId: 102,
      },
      {
        id: '160614',
        zipcode: 15110,
        text: 'ดอนดึง',
        value: 'ดอนดึง',
        name: {
          th: 'ดอนดึง',
          en: 'Don Dueng',
        },
        districtId: 102,
      },
      {
        id: '160615',
        zipcode: 15110,
        text: 'ชอนม่วง',
        value: 'ชอนม่วง',
        name: {
          th: 'ชอนม่วง',
          en: 'Chon Muang',
        },
        districtId: 102,
      },
      {
        id: '160616',
        zipcode: 15110,
        text: 'หนองกระเบียน',
        value: 'หนองกระเบียน',
        name: {
          th: 'หนองกระเบียน',
          en: 'Nong Krabian',
        },
        districtId: 102,
      },
      {
        id: '160617',
        zipcode: 15110,
        text: 'สายห้วยแก้ว',
        value: 'สายห้วยแก้ว',
        name: {
          th: 'สายห้วยแก้ว',
          en: 'Sai Huai Kaeo',
        },
        districtId: 102,
      },
      {
        id: '160618',
        zipcode: 15110,
        text: 'มหาสอน',
        value: 'มหาสอน',
        name: {
          th: 'มหาสอน',
          en: 'Maha Son',
        },
        districtId: 102,
      },
      {
        id: '160619',
        zipcode: 15110,
        text: 'บ้านหมี่',
        value: 'บ้านหมี่',
        name: {
          th: 'บ้านหมี่',
          en: 'Ban Mi',
        },
        districtId: 102,
      },
      {
        id: '160620',
        zipcode: 15110,
        text: 'เชียงงา',
        value: 'เชียงงา',
        name: {
          th: 'เชียงงา',
          en: 'Chiang Nga',
        },
        districtId: 102,
      },
      {
        id: '160621',
        zipcode: 15110,
        text: 'หนองเมือง',
        value: 'หนองเมือง',
        name: {
          th: 'หนองเมือง',
          en: 'Nong Mueang',
        },
        districtId: 102,
      },
      {
        id: '160622',
        zipcode: 15110,
        text: 'สนามแจง',
        value: 'สนามแจง',
        name: {
          th: 'สนามแจง',
          en: 'Sanam Chaeng',
        },
        districtId: 102,
      },
      {
        id: '160701',
        zipcode: 15230,
        text: 'ท่าหลวง',
        value: 'ท่าหลวง',
        name: {
          th: 'ท่าหลวง',
          en: 'Tha Luang',
        },
        districtId: 103,
      },
      {
        id: '160702',
        zipcode: 15230,
        text: 'แก่งผักกูด',
        value: 'แก่งผักกูด',
        name: {
          th: 'แก่งผักกูด',
          en: 'Kaeng Phak Kut',
        },
        districtId: 103,
      },
      {
        id: '160703',
        zipcode: 15230,
        text: 'ซับจำปา',
        value: 'ซับจำปา',
        name: {
          th: 'ซับจำปา',
          en: 'Sap Champa',
        },
        districtId: 103,
      },
      {
        id: '160704',
        zipcode: 15230,
        text: 'หนองผักแว่น',
        value: 'หนองผักแว่น',
        name: {
          th: 'หนองผักแว่น',
          en: 'Nong Phak Waen',
        },
        districtId: 103,
      },
      {
        id: '160705',
        zipcode: 15230,
        text: 'ทะเลวังวัด',
        value: 'ทะเลวังวัด',
        name: {
          th: 'ทะเลวังวัด',
          en: 'Thale Wang Wat',
        },
        districtId: 103,
      },
      {
        id: '160706',
        zipcode: 15230,
        text: 'หัวลำ',
        value: 'หัวลำ',
        name: {
          th: 'หัวลำ',
          en: 'Hua Lam',
        },
        districtId: 103,
      },
      {
        id: '160801',
        zipcode: 15240,
        text: 'สระโบสถ์',
        value: 'สระโบสถ์',
        name: {
          th: 'สระโบสถ์',
          en: 'Sa Bot',
        },
        districtId: 104,
      },
      {
        id: '160802',
        zipcode: 15240,
        text: 'มหาโพธิ',
        value: 'มหาโพธิ',
        name: {
          th: 'มหาโพธิ',
          en: 'Maha Phot',
        },
        districtId: 104,
      },
      {
        id: '160803',
        zipcode: 15240,
        text: 'ทุ่งท่าช้าง',
        value: 'ทุ่งท่าช้าง',
        name: {
          th: 'ทุ่งท่าช้าง',
          en: 'Thung Tha Chang',
        },
        districtId: 104,
      },
      {
        id: '160804',
        zipcode: 15240,
        text: 'ห้วยใหญ่',
        value: 'ห้วยใหญ่',
        name: {
          th: 'ห้วยใหญ่',
          en: 'Huai Yai',
        },
        districtId: 104,
      },
      {
        id: '160805',
        zipcode: 15240,
        text: 'นิยมชัย',
        value: 'นิยมชัย',
        name: {
          th: 'นิยมชัย',
          en: 'Niyom Chai',
        },
        districtId: 104,
      },
      {
        id: '160901',
        zipcode: 15250,
        text: 'โคกเจริญ',
        value: 'โคกเจริญ',
        name: {
          th: 'โคกเจริญ',
          en: 'Khok Charoen',
        },
        districtId: 105,
      },
      {
        id: '160902',
        zipcode: 15250,
        text: 'ยางราก',
        value: 'ยางราก',
        name: {
          th: 'ยางราก',
          en: 'Yang Rak',
        },
        districtId: 105,
      },
      {
        id: '160903',
        zipcode: 15250,
        text: 'หนองมะค่า',
        value: 'หนองมะค่า',
        name: {
          th: 'หนองมะค่า',
          en: 'Nong Makha',
        },
        districtId: 105,
      },
      {
        id: '160904',
        zipcode: 15250,
        text: 'วังทอง',
        value: 'วังทอง',
        name: {
          th: 'วังทอง',
          en: 'Wang Thong',
        },
        districtId: 105,
      },
      {
        id: '160905',
        zipcode: 15250,
        text: 'โคกแสมสาร',
        value: 'โคกแสมสาร',
        name: {
          th: 'โคกแสมสาร',
          en: 'Khok Samae San',
        },
        districtId: 105,
      },
      {
        id: '161001',
        zipcode: 15190,
        text: 'ลำสนธิ',
        value: 'ลำสนธิ',
        name: {
          th: 'ลำสนธิ',
          en: 'Lam Sonthi',
        },
        districtId: 106,
      },
      {
        id: '161002',
        zipcode: 15190,
        text: 'ซับสมบูรณ์',
        value: 'ซับสมบูรณ์',
        name: {
          th: 'ซับสมบูรณ์',
          en: 'Sap Sombun',
        },
        districtId: 106,
      },
      {
        id: '161003',
        zipcode: 15190,
        text: 'หนองรี',
        value: 'หนองรี',
        name: {
          th: 'หนองรี',
          en: 'Nong Ri',
        },
        districtId: 106,
      },
      {
        id: '161004',
        zipcode: 15190,
        text: 'กุดตาเพชร',
        value: 'กุดตาเพชร',
        name: {
          th: 'กุดตาเพชร',
          en: 'Kut Ta Phet',
        },
        districtId: 106,
      },
      {
        id: '161005',
        zipcode: 15190,
        text: 'เขารวก',
        value: 'เขารวก',
        name: {
          th: 'เขารวก',
          en: 'Khao Ruak',
        },
        districtId: 106,
      },
      {
        id: '161006',
        zipcode: 15130,
        text: 'เขาน้อย',
        value: 'เขาน้อย',
        name: {
          th: 'เขาน้อย',
          en: 'Khao Noi',
        },
        districtId: 106,
      },
      {
        id: '161101',
        zipcode: 15170,
        text: 'หนองม่วง',
        value: 'หนองม่วง',
        name: {
          th: 'หนองม่วง',
          en: 'Nong Muang',
        },
        districtId: 107,
      },
      {
        id: '161102',
        zipcode: 15170,
        text: 'บ่อทอง',
        value: 'บ่อทอง',
        name: {
          th: 'บ่อทอง',
          en: 'Bo Thong',
        },
        districtId: 107,
      },
      {
        id: '161103',
        zipcode: 15170,
        text: 'ดงดินแดง',
        value: 'ดงดินแดง',
        name: {
          th: 'ดงดินแดง',
          en: 'Dong Din Daeng',
        },
        districtId: 107,
      },
      {
        id: '161104',
        zipcode: 15170,
        text: 'ชอนสมบูรณ์',
        value: 'ชอนสมบูรณ์',
        name: {
          th: 'ชอนสมบูรณ์',
          en: 'Chon Sombun',
        },
        districtId: 107,
      },
      {
        id: '161105',
        zipcode: 15170,
        text: 'ยางโทน',
        value: 'ยางโทน',
        name: {
          th: 'ยางโทน',
          en: 'Yang Thon',
        },
        districtId: 107,
      },
      {
        id: '161106',
        zipcode: 15170,
        text: 'ชอนสารเดช',
        value: 'ชอนสารเดช',
        name: {
          th: 'ชอนสารเดช',
          en: 'Chon Saradet',
        },
        districtId: 107,
      },
      {
        id: '170101',
        zipcode: 16000,
        text: 'บางพุทรา',
        value: 'บางพุทรา',
        name: {
          th: 'บางพุทรา',
          en: 'Bang Phutsa',
        },
        districtId: 109,
      },
      {
        id: '170102',
        zipcode: 16000,
        text: 'บางมัญ',
        value: 'บางมัญ',
        name: {
          th: 'บางมัญ',
          en: 'Bang Man',
        },
        districtId: 109,
      },
      {
        id: '170103',
        zipcode: 16000,
        text: 'โพกรวม',
        value: 'โพกรวม',
        name: {
          th: 'โพกรวม',
          en: 'Phok Ruam',
        },
        districtId: 109,
      },
      {
        id: '170104',
        zipcode: 16000,
        text: 'ม่วงหมู่',
        value: 'ม่วงหมู่',
        name: {
          th: 'ม่วงหมู่',
          en: 'Muang Mu',
        },
        districtId: 109,
      },
      {
        id: '170105',
        zipcode: 16000,
        text: 'หัวไผ่',
        value: 'หัวไผ่',
        name: {
          th: 'หัวไผ่',
          en: 'Hua Phai',
        },
        districtId: 109,
      },
      {
        id: '170106',
        zipcode: 16000,
        text: 'ต้นโพธิ์',
        value: 'ต้นโพธิ์',
        name: {
          th: 'ต้นโพธิ์',
          en: 'Ton Pho',
        },
        districtId: 109,
      },
      {
        id: '170107',
        zipcode: 16000,
        text: 'จักรสีห์',
        value: 'จักรสีห์',
        name: {
          th: 'จักรสีห์',
          en: 'Chaksi',
        },
        districtId: 109,
      },
      {
        id: '170108',
        zipcode: 16000,
        text: 'บางกระบือ',
        value: 'บางกระบือ',
        name: {
          th: 'บางกระบือ',
          en: 'Bang Krabue',
        },
        districtId: 109,
      },
      {
        id: '170201',
        zipcode: 16130,
        text: 'สิงห์',
        value: 'สิงห์',
        name: {
          th: 'สิงห์',
          en: 'Sing',
        },
        districtId: 110,
      },
      {
        id: '170202',
        zipcode: 16130,
        text: 'ไม้ดัด',
        value: 'ไม้ดัด',
        name: {
          th: 'ไม้ดัด',
          en: 'Mai Dat',
        },
        districtId: 110,
      },
      {
        id: '170203',
        zipcode: 16130,
        text: 'เชิงกลัด',
        value: 'เชิงกลัด',
        name: {
          th: 'เชิงกลัด',
          en: 'Choeng Klat',
        },
        districtId: 110,
      },
      {
        id: '170204',
        zipcode: 16130,
        text: 'โพชนไก่',
        value: 'โพชนไก่',
        name: {
          th: 'โพชนไก่',
          en: 'Pho Chon Kai',
        },
        districtId: 110,
      },
      {
        id: '170205',
        zipcode: 16130,
        text: 'แม่ลา',
        value: 'แม่ลา',
        name: {
          th: 'แม่ลา',
          en: 'Mae La',
        },
        districtId: 110,
      },
      {
        id: '170206',
        zipcode: 16130,
        text: 'บ้านจ่า',
        value: 'บ้านจ่า',
        name: {
          th: 'บ้านจ่า',
          en: 'Ban Cha',
        },
        districtId: 110,
      },
      {
        id: '170207',
        zipcode: 16130,
        text: 'พักทัน',
        value: 'พักทัน',
        name: {
          th: 'พักทัน',
          en: 'Phak Than',
        },
        districtId: 110,
      },
      {
        id: '170208',
        zipcode: 16130,
        text: 'สระแจง',
        value: 'สระแจง',
        name: {
          th: 'สระแจง',
          en: 'Sa Chaeng',
        },
        districtId: 110,
      },
      {
        id: '170301',
        zipcode: 16150,
        text: 'โพทะเล',
        value: 'โพทะเล',
        name: {
          th: 'โพทะเล',
          en: 'Pho Thale',
        },
        districtId: 111,
      },
      {
        id: '170302',
        zipcode: 16150,
        text: 'บางระจัน',
        value: 'บางระจัน',
        name: {
          th: 'บางระจัน',
          en: 'Bang Rachan',
        },
        districtId: 111,
      },
      {
        id: '170303',
        zipcode: 16150,
        text: 'โพสังโฆ',
        value: 'โพสังโฆ',
        name: {
          th: 'โพสังโฆ',
          en: 'Pho Sangkho',
        },
        districtId: 111,
      },
      {
        id: '170304',
        zipcode: 16150,
        text: 'ท่าข้าม',
        value: 'ท่าข้าม',
        name: {
          th: 'ท่าข้าม',
          en: 'Tha Kham',
        },
        districtId: 111,
      },
      {
        id: '170305',
        zipcode: 16150,
        text: 'คอทราย',
        value: 'คอทราย',
        name: {
          th: 'คอทราย',
          en: 'Kho Sai',
        },
        districtId: 111,
      },
      {
        id: '170306',
        zipcode: 16150,
        text: 'หนองกระทุ่ม',
        value: 'หนองกระทุ่ม',
        name: {
          th: 'หนองกระทุ่ม',
          en: 'Nong Krathum',
        },
        districtId: 111,
      },
      {
        id: '170401',
        zipcode: 16120,
        text: 'พระงาม',
        value: 'พระงาม',
        name: {
          th: 'พระงาม',
          en: 'Phra Ngam',
        },
        districtId: 112,
      },
      {
        id: '170402',
        zipcode: 16160,
        text: 'พรหมบุรี',
        value: 'พรหมบุรี',
        name: {
          th: 'พรหมบุรี',
          en: 'Phrom Buri',
        },
        districtId: 112,
      },
      {
        id: '170403',
        zipcode: 16120,
        text: 'บางน้ำเชี่ยว',
        value: 'บางน้ำเชี่ยว',
        name: {
          th: 'บางน้ำเชี่ยว',
          en: 'Bang Nam Chiao',
        },
        districtId: 112,
      },
      {
        id: '170404',
        zipcode: 16120,
        text: 'บ้านหม้อ',
        value: 'บ้านหม้อ',
        name: {
          th: 'บ้านหม้อ',
          en: 'Ban Mo',
        },
        districtId: 112,
      },
      {
        id: '170405',
        zipcode: 16120,
        text: 'บ้านแป้ง',
        value: 'บ้านแป้ง',
        name: {
          th: 'บ้านแป้ง',
          en: 'Ban Paeng',
        },
        districtId: 112,
      },
      {
        id: '170406',
        zipcode: 16120,
        text: 'หัวป่า',
        value: 'หัวป่า',
        name: {
          th: 'หัวป่า',
          en: 'Hua Pa',
        },
        districtId: 112,
      },
      {
        id: '170407',
        zipcode: 16120,
        text: 'โรงช้าง',
        value: 'โรงช้าง',
        name: {
          th: 'โรงช้าง',
          en: 'Rong Chang',
        },
        districtId: 112,
      },
      {
        id: '170501',
        zipcode: 16140,
        text: 'ถอนสมอ',
        value: 'ถอนสมอ',
        name: {
          th: 'ถอนสมอ',
          en: 'Thon Samo',
        },
        districtId: 113,
      },
      {
        id: '170502',
        zipcode: 16140,
        text: 'โพประจักษ์',
        value: 'โพประจักษ์',
        name: {
          th: 'โพประจักษ์',
          en: 'Pho Prachak',
        },
        districtId: 113,
      },
      {
        id: '170503',
        zipcode: 16140,
        text: 'วิหารขาว',
        value: 'วิหารขาว',
        name: {
          th: 'วิหารขาว',
          en: 'Wihan Khao',
        },
        districtId: 113,
      },
      {
        id: '170504',
        zipcode: 16140,
        text: 'พิกุลทอง',
        value: 'พิกุลทอง',
        name: {
          th: 'พิกุลทอง',
          en: 'Phikun Thong',
        },
        districtId: 113,
      },
      {
        id: '170601',
        zipcode: 16110,
        text: 'อินทร์บุรี',
        value: 'อินทร์บุรี',
        name: {
          th: 'อินทร์บุรี',
          en: 'In Buri',
        },
        districtId: 114,
      },
      {
        id: '170602',
        zipcode: 16110,
        text: 'ประศุก',
        value: 'ประศุก',
        name: {
          th: 'ประศุก',
          en: 'Prasuk',
        },
        districtId: 114,
      },
      {
        id: '170603',
        zipcode: 16110,
        text: 'ทับยา',
        value: 'ทับยา',
        name: {
          th: 'ทับยา',
          en: 'Thap Ya',
        },
        districtId: 114,
      },
      {
        id: '170604',
        zipcode: 16110,
        text: 'งิ้วราย',
        value: 'งิ้วราย',
        name: {
          th: 'งิ้วราย',
          en: 'Ngio Rai',
        },
        districtId: 114,
      },
      {
        id: '170605',
        zipcode: 16110,
        text: 'ชีน้ำร้าย',
        value: 'ชีน้ำร้าย',
        name: {
          th: 'ชีน้ำร้าย',
          en: 'Chi Nam Rai',
        },
        districtId: 114,
      },
      {
        id: '170606',
        zipcode: 16110,
        text: 'ท่างาม',
        value: 'ท่างาม',
        name: {
          th: 'ท่างาม',
          en: 'Tha Ngam',
        },
        districtId: 114,
      },
      {
        id: '170607',
        zipcode: 16110,
        text: 'น้ำตาล',
        value: 'น้ำตาล',
        name: {
          th: 'น้ำตาล',
          en: 'Namtan',
        },
        districtId: 114,
      },
      {
        id: '170608',
        zipcode: 16110,
        text: 'ทองเอน',
        value: 'ทองเอน',
        name: {
          th: 'ทองเอน',
          en: 'Thong En',
        },
        districtId: 114,
      },
      {
        id: '170609',
        zipcode: 16110,
        text: 'ห้วยชัน',
        value: 'ห้วยชัน',
        name: {
          th: 'ห้วยชัน',
          en: 'Huai Chan',
        },
        districtId: 114,
      },
      {
        id: '170610',
        zipcode: 16110,
        text: 'โพธิ์ชัย',
        value: 'โพธิ์ชัย',
        name: {
          th: 'โพธิ์ชัย',
          en: 'Pho Chai',
        },
        districtId: 114,
      },
      {
        id: '180101',
        zipcode: 17000,
        text: 'ในเมือง',
        value: 'ในเมือง',
        name: {
          th: 'ในเมือง',
          en: 'Nai Mueang',
        },
        districtId: 115,
      },
      {
        id: '180102',
        zipcode: 17000,
        text: 'บ้านกล้วย',
        value: 'บ้านกล้วย',
        name: {
          th: 'บ้านกล้วย',
          en: 'Ban Kluai',
        },
        districtId: 115,
      },
      {
        id: '180103',
        zipcode: 17000,
        text: 'ท่าชัย',
        value: 'ท่าชัย',
        name: {
          th: 'ท่าชัย',
          en: 'Tha Chai',
        },
        districtId: 115,
      },
      {
        id: '180104',
        zipcode: 17000,
        text: 'ชัยนาท',
        value: 'ชัยนาท',
        name: {
          th: 'ชัยนาท',
          en: 'Chai Nat',
        },
        districtId: 115,
      },
      {
        id: '180105',
        zipcode: 17000,
        text: 'เขาท่าพระ',
        value: 'เขาท่าพระ',
        name: {
          th: 'เขาท่าพระ',
          en: 'Khao Tha Phra',
        },
        districtId: 115,
      },
      {
        id: '180106',
        zipcode: 17000,
        text: 'หาดท่าเสา',
        value: 'หาดท่าเสา',
        name: {
          th: 'หาดท่าเสา',
          en: 'Hat Tha Sao',
        },
        districtId: 115,
      },
      {
        id: '180107',
        zipcode: 17000,
        text: 'ธรรมามูล',
        value: 'ธรรมามูล',
        name: {
          th: 'ธรรมามูล',
          en: 'Thammamun',
        },
        districtId: 115,
      },
      {
        id: '180108',
        zipcode: 17000,
        text: 'เสือโฮก',
        value: 'เสือโฮก',
        name: {
          th: 'เสือโฮก',
          en: 'Suea Hok',
        },
        districtId: 115,
      },
      {
        id: '180109',
        zipcode: 17000,
        text: 'นางลือ',
        value: 'นางลือ',
        name: {
          th: 'นางลือ',
          en: 'Nang Lue',
        },
        districtId: 115,
      },
      {
        id: '180201',
        zipcode: 17110,
        text: 'คุ้งสำเภา',
        value: 'คุ้งสำเภา',
        name: {
          th: 'คุ้งสำเภา',
          en: 'Khung Samphao',
        },
        districtId: 116,
      },
      {
        id: '180202',
        zipcode: 17110,
        text: 'วัดโคก',
        value: 'วัดโคก',
        name: {
          th: 'วัดโคก',
          en: 'Wat Khok',
        },
        districtId: 116,
      },
      {
        id: '180203',
        zipcode: 17110,
        text: 'ศิลาดาน',
        value: 'ศิลาดาน',
        name: {
          th: 'ศิลาดาน',
          en: 'Sila Dan',
        },
        districtId: 116,
      },
      {
        id: '180204',
        zipcode: 17110,
        text: 'ท่าฉนวน',
        value: 'ท่าฉนวน',
        name: {
          th: 'ท่าฉนวน',
          en: 'Tha Chanuan',
        },
        districtId: 116,
      },
      {
        id: '180205',
        zipcode: 17170,
        text: 'หางน้ำสาคร',
        value: 'หางน้ำสาคร',
        name: {
          th: 'หางน้ำสาคร',
          en: 'Hang Nam Sakhon',
        },
        districtId: 116,
      },
      {
        id: '180206',
        zipcode: 17170,
        text: 'ไร่พัฒนา',
        value: 'ไร่พัฒนา',
        name: {
          th: 'ไร่พัฒนา',
          en: 'Rai Phatthana',
        },
        districtId: 116,
      },
      {
        id: '180207',
        zipcode: 17170,
        text: 'อู่ตะเภา',
        value: 'อู่ตะเภา',
        name: {
          th: 'อู่ตะเภา',
          en: 'U Taphao',
        },
        districtId: 116,
      },
      {
        id: '180301',
        zipcode: 17120,
        text: 'วัดสิงห์',
        value: 'วัดสิงห์',
        name: {
          th: 'วัดสิงห์',
          en: 'Wat Sing',
        },
        districtId: 117,
      },
      {
        id: '180302',
        zipcode: 17120,
        text: 'มะขามเฒ่า',
        value: 'มะขามเฒ่า',
        name: {
          th: 'มะขามเฒ่า',
          en: 'Makham Thao',
        },
        districtId: 117,
      },
      {
        id: '180303',
        zipcode: 17120,
        text: 'หนองน้อย',
        value: 'หนองน้อย',
        name: {
          th: 'หนองน้อย',
          en: 'Nong Noi',
        },
        districtId: 117,
      },
      {
        id: '180304',
        zipcode: 17120,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 117,
      },
      {
        id: '180306',
        zipcode: 17120,
        text: 'หนองขุ่น',
        value: 'หนองขุ่น',
        name: {
          th: 'หนองขุ่น',
          en: 'Bo Rae',
        },
        districtId: 117,
      },
      {
        id: '180307',
        zipcode: 17120,
        text: 'บ่อแร่',
        value: 'บ่อแร่',
        name: {
          th: 'บ่อแร่',
          en: 'Wang Man',
        },
        districtId: 117,
      },
      {
        id: '180311',
        zipcode: 17120,
        text: 'วังหมัน',
        value: 'วังหมัน',
        name: {
          th: 'วังหมัน',
          en: 'Wang Man',
        },
        districtId: 117,
      },
      {
        id: '180401',
        zipcode: 17150,
        text: 'สรรพยา',
        value: 'สรรพยา',
        name: {
          th: 'สรรพยา',
          en: 'Sapphaya',
        },
        districtId: 118,
      },
      {
        id: '180402',
        zipcode: 17150,
        text: 'ตลุก',
        value: 'ตลุก',
        name: {
          th: 'ตลุก',
          en: 'Taluk',
        },
        districtId: 118,
      },
      {
        id: '180403',
        zipcode: 17150,
        text: 'เขาแก้ว',
        value: 'เขาแก้ว',
        name: {
          th: 'เขาแก้ว',
          en: 'Khao Kaeo',
        },
        districtId: 118,
      },
      {
        id: '180404',
        zipcode: 17150,
        text: 'โพนางดำตก',
        value: 'โพนางดำตก',
        name: {
          th: 'โพนางดำตก',
          en: 'Pho Nang Dam Tok',
        },
        districtId: 118,
      },
      {
        id: '180405',
        zipcode: 17150,
        text: 'โพนางดำออก',
        value: 'โพนางดำออก',
        name: {
          th: 'โพนางดำออก',
          en: 'Pho Nang Dam Ok',
        },
        districtId: 118,
      },
      {
        id: '180406',
        zipcode: 17150,
        text: 'บางหลวง',
        value: 'บางหลวง',
        name: {
          th: 'บางหลวง',
          en: 'Bang Luang',
        },
        districtId: 118,
      },
      {
        id: '180407',
        zipcode: 17150,
        text: 'หาดอาษา',
        value: 'หาดอาษา',
        name: {
          th: 'หาดอาษา',
          en: 'Hat Asa',
        },
        districtId: 118,
      },
      {
        id: '180501',
        zipcode: 17140,
        text: 'แพรกศรีราชา',
        value: 'แพรกศรีราชา',
        name: {
          th: 'แพรกศรีราชา',
          en: 'Phraek Si Racha',
        },
        districtId: 119,
      },
      {
        id: '180502',
        zipcode: 17140,
        text: 'เที่ยงแท้',
        value: 'เที่ยงแท้',
        name: {
          th: 'เที่ยงแท้',
          en: 'Thiang Thae',
        },
        districtId: 119,
      },
      {
        id: '180503',
        zipcode: 17140,
        text: 'ห้วยกรด',
        value: 'ห้วยกรด',
        name: {
          th: 'ห้วยกรด',
          en: 'Huai Krot',
        },
        districtId: 119,
      },
      {
        id: '180504',
        zipcode: 17140,
        text: 'โพงาม',
        value: 'โพงาม',
        name: {
          th: 'โพงาม',
          en: 'Pho Ngam',
        },
        districtId: 119,
      },
      {
        id: '180505',
        zipcode: 17140,
        text: 'บางขุด',
        value: 'บางขุด',
        name: {
          th: 'บางขุด',
          en: 'Bang Khut',
        },
        districtId: 119,
      },
      {
        id: '180506',
        zipcode: 17140,
        text: 'ดงคอน',
        value: 'ดงคอน',
        name: {
          th: 'ดงคอน',
          en: 'Dong Khon',
        },
        districtId: 119,
      },
      {
        id: '180507',
        zipcode: 17140,
        text: 'ดอนกำ',
        value: 'ดอนกำ',
        name: {
          th: 'ดอนกำ',
          en: 'Don Kam',
        },
        districtId: 119,
      },
      {
        id: '180508',
        zipcode: 17140,
        text: 'ห้วยกรดพัฒนา',
        value: 'ห้วยกรดพัฒนา',
        name: {
          th: 'ห้วยกรดพัฒนา',
          en: 'Huai Krot Phatthana',
        },
        districtId: 119,
      },
      {
        id: '180601',
        zipcode: 17130,
        text: 'หันคา',
        value: 'หันคา',
        name: {
          th: 'หันคา',
          en: 'Hankha',
        },
        districtId: 120,
      },
      {
        id: '180602',
        zipcode: 17130,
        text: 'บ้านเชี่ยน',
        value: 'บ้านเชี่ยน',
        name: {
          th: 'บ้านเชี่ยน',
          en: 'Ban Chian',
        },
        districtId: 120,
      },
      {
        id: '180605',
        zipcode: 17130,
        text: 'ไพรนกยูง',
        value: 'ไพรนกยูง',
        name: {
          th: 'ไพรนกยูง',
          en: 'Phrai Nok Yung',
        },
        districtId: 120,
      },
      {
        id: '180606',
        zipcode: 17160,
        text: 'หนองแซง',
        value: 'หนองแซง',
        name: {
          th: 'หนองแซง',
          en: 'Nong Saeng',
        },
        districtId: 120,
      },
      {
        id: '180607',
        zipcode: 17160,
        text: 'ห้วยงู',
        value: 'ห้วยงู',
        name: {
          th: 'ห้วยงู',
          en: 'Huai Ngu',
        },
        districtId: 120,
      },
      {
        id: '180608',
        zipcode: 17130,
        text: 'วังไก่เถื่อน',
        value: 'วังไก่เถื่อน',
        name: {
          th: 'วังไก่เถื่อน',
          en: 'Wang Kai Thuean',
        },
        districtId: 120,
      },
      {
        id: '180609',
        zipcode: 17130,
        text: 'เด่นใหญ่',
        value: 'เด่นใหญ่',
        name: {
          th: 'เด่นใหญ่',
          en: 'Den Yai',
        },
        districtId: 120,
      },
      {
        id: '180611',
        zipcode: 17160,
        text: 'สามง่ามท่าโบสถ์',
        value: 'สามง่ามท่าโบสถ์',
        name: {
          th: 'สามง่ามท่าโบสถ์',
          en: 'Sam Ngam Tha Bot',
        },
        districtId: 120,
      },
      {
        id: '180701',
        zipcode: 17120,
        text: 'หนองมะโมง',
        value: 'หนองมะโมง',
        name: {
          th: 'หนองมะโมง',
          en: 'Nong Mamong',
        },
        districtId: 121,
      },
      {
        id: '180702',
        zipcode: 17120,
        text: 'วังตะเคียน',
        value: 'วังตะเคียน',
        name: {
          th: 'วังตะเคียน',
          en: 'Wang Takhian',
        },
        districtId: 121,
      },
      {
        id: '180703',
        zipcode: 17120,
        text: 'สะพานหิน',
        value: 'สะพานหิน',
        name: {
          th: 'สะพานหิน',
          en: 'Saphan Hin',
        },
        districtId: 121,
      },
      {
        id: '180704',
        zipcode: 17120,
        text: 'กุดจอก',
        value: 'กุดจอก',
        name: {
          th: 'กุดจอก',
          en: 'Kut Chok',
        },
        districtId: 121,
      },
      {
        id: '180801',
        zipcode: 17130,
        text: 'เนินขาม',
        value: 'เนินขาม',
        name: {
          th: 'เนินขาม',
          en: 'Noen Kham',
        },
        districtId: 122,
      },
      {
        id: '180802',
        zipcode: 17130,
        text: 'กะบกเตี้ย',
        value: 'กะบกเตี้ย',
        name: {
          th: 'กะบกเตี้ย',
          en: 'Kabok Tia',
        },
        districtId: 122,
      },
      {
        id: '180803',
        zipcode: 17130,
        text: 'สุขเดือนห้า',
        value: 'สุขเดือนห้า',
        name: {
          th: 'สุขเดือนห้า',
          en: 'Suk Duean Ha',
        },
        districtId: 122,
      },
      {
        id: '190101',
        zipcode: 18000,
        text: 'ปากเพรียว',
        value: 'ปากเพรียว',
        name: {
          th: 'ปากเพรียว',
          en: 'Pak Phriao',
        },
        districtId: 123,
      },
      {
        id: '190105',
        zipcode: 18000,
        text: 'ดาวเรือง',
        value: 'ดาวเรือง',
        name: {
          th: 'ดาวเรือง',
          en: 'Dao Rueang',
        },
        districtId: 123,
      },
      {
        id: '190106',
        zipcode: 18000,
        text: 'นาโฉง',
        value: 'นาโฉง',
        name: {
          th: 'นาโฉง',
          en: 'Na Chong',
        },
        districtId: 123,
      },
      {
        id: '190107',
        zipcode: 18000,
        text: 'โคกสว่าง',
        value: 'โคกสว่าง',
        name: {
          th: 'โคกสว่าง',
          en: 'Khok Sawang',
        },
        districtId: 123,
      },
      {
        id: '190108',
        zipcode: 18000,
        text: 'หนองโน',
        value: 'หนองโน',
        name: {
          th: 'หนองโน',
          en: 'Nong No',
        },
        districtId: 123,
      },
      {
        id: '190109',
        zipcode: 18000,
        text: 'หนองยาว',
        value: 'หนองยาว',
        name: {
          th: 'หนองยาว',
          en: 'Nong Yao',
        },
        districtId: 123,
      },
      {
        id: '190110',
        zipcode: 18000,
        text: 'ปากข้าวสาร',
        value: 'ปากข้าวสาร',
        name: {
          th: 'ปากข้าวสาร',
          en: 'Pak Khao San',
        },
        districtId: 123,
      },
      {
        id: '190111',
        zipcode: 18000,
        text: 'หนองปลาไหล',
        value: 'หนองปลาไหล',
        name: {
          th: 'หนองปลาไหล',
          en: 'Nong Pla Lai',
        },
        districtId: 123,
      },
      {
        id: '190112',
        zipcode: 18000,
        text: 'กุดนกเปล้า',
        value: 'กุดนกเปล้า',
        name: {
          th: 'กุดนกเปล้า',
          en: 'Kut Nok Plao',
        },
        districtId: 123,
      },
      {
        id: '190113',
        zipcode: 18000,
        text: 'ตลิ่งชัน',
        value: 'ตลิ่งชัน',
        name: {
          th: 'ตลิ่งชัน',
          en: 'Taling Chan',
        },
        districtId: 123,
      },
      {
        id: '190114',
        zipcode: 18000,
        text: 'ตะกุด',
        value: 'ตะกุด',
        name: {
          th: 'ตะกุด',
          en: 'Takut',
        },
        districtId: 123,
      },
      {
        id: '190201',
        zipcode: 18110,
        text: 'แก่งคอย',
        value: 'แก่งคอย',
        name: {
          th: 'แก่งคอย',
          en: 'Kaeng Khoi',
        },
        districtId: 124,
      },
      {
        id: '190202',
        zipcode: 18260,
        text: 'ทับกวาง',
        value: 'ทับกวาง',
        name: {
          th: 'ทับกวาง',
          en: 'Thap Kwang',
        },
        districtId: 124,
      },
      {
        id: '190203',
        zipcode: 18110,
        text: 'ตาลเดี่ยว',
        value: 'ตาลเดี่ยว',
        name: {
          th: 'ตาลเดี่ยว',
          en: 'Tan Diao',
        },
        districtId: 124,
      },
      {
        id: '190204',
        zipcode: 18110,
        text: 'ห้วยแห้ง',
        value: 'ห้วยแห้ง',
        name: {
          th: 'ห้วยแห้ง',
          en: 'Huai Haeng',
        },
        districtId: 124,
      },
      {
        id: '190205',
        zipcode: 18110,
        text: 'ท่าคล้อ',
        value: 'ท่าคล้อ',
        name: {
          th: 'ท่าคล้อ',
          en: 'Tha Khlo',
        },
        districtId: 124,
      },
      {
        id: '190206',
        zipcode: 18110,
        text: 'หินซ้อน',
        value: 'หินซ้อน',
        name: {
          th: 'หินซ้อน',
          en: 'Hin Son',
        },
        districtId: 124,
      },
      {
        id: '190207',
        zipcode: 18110,
        text: 'บ้านธาตุ',
        value: 'บ้านธาตุ',
        name: {
          th: 'บ้านธาตุ',
          en: 'Ban That',
        },
        districtId: 124,
      },
      {
        id: '190208',
        zipcode: 18110,
        text: 'บ้านป่า',
        value: 'บ้านป่า',
        name: {
          th: 'บ้านป่า',
          en: 'Ban Pa',
        },
        districtId: 124,
      },
      {
        id: '190209',
        zipcode: 18110,
        text: 'ท่าตูม',
        value: 'ท่าตูม',
        name: {
          th: 'ท่าตูม',
          en: 'Tha Tum',
        },
        districtId: 124,
      },
      {
        id: '190210',
        zipcode: 18110,
        text: 'ชะอม',
        value: 'ชะอม',
        name: {
          th: 'ชะอม',
          en: 'Cha-om',
        },
        districtId: 124,
      },
      {
        id: '190211',
        zipcode: 18110,
        text: 'สองคอน',
        value: 'สองคอน',
        name: {
          th: 'สองคอน',
          en: 'Song Khon',
        },
        districtId: 124,
      },
      {
        id: '190212',
        zipcode: 18110,
        text: 'เตาปูน',
        value: 'เตาปูน',
        name: {
          th: 'เตาปูน',
          en: 'Tao Pun',
        },
        districtId: 124,
      },
      {
        id: '190213',
        zipcode: 18110,
        text: 'ชำผักแพว',
        value: 'ชำผักแพว',
        name: {
          th: 'ชำผักแพว',
          en: 'Cham Phak Phaeo',
        },
        districtId: 124,
      },
      {
        id: '190215',
        zipcode: 18110,
        text: 'ท่ามะปราง',
        value: 'ท่ามะปราง',
        name: {
          th: 'ท่ามะปราง',
          en: 'Tha Maprang',
        },
        districtId: 124,
      },
      {
        id: '190301',
        zipcode: 18140,
        text: 'หนองแค',
        value: 'หนองแค',
        name: {
          th: 'หนองแค',
          en: 'Nong Khae',
        },
        districtId: 125,
      },
      {
        id: '190302',
        zipcode: 18140,
        text: 'กุ่มหัก',
        value: 'กุ่มหัก',
        name: {
          th: 'กุ่มหัก',
          en: 'Kum Hak',
        },
        districtId: 125,
      },
      {
        id: '190303',
        zipcode: 18250,
        text: 'คชสิทธิ์',
        value: 'คชสิทธิ์',
        name: {
          th: 'คชสิทธิ์',
          en: 'Khotchasit',
        },
        districtId: 125,
      },
      {
        id: '190304',
        zipcode: 18250,
        text: 'โคกตูม',
        value: 'โคกตูม',
        name: {
          th: 'โคกตูม',
          en: 'Khok Tum',
        },
        districtId: 125,
      },
      {
        id: '190305',
        zipcode: 18230,
        text: 'โคกแย้',
        value: 'โคกแย้',
        name: {
          th: 'โคกแย้',
          en: 'Khok Yae',
        },
        districtId: 125,
      },
      {
        id: '190306',
        zipcode: 18230,
        text: 'บัวลอย',
        value: 'บัวลอย',
        name: {
          th: 'บัวลอย',
          en: 'Bua Loi',
        },
        districtId: 125,
      },
      {
        id: '190307',
        zipcode: 18140,
        text: 'ไผ่ต่ำ',
        value: 'ไผ่ต่ำ',
        name: {
          th: 'ไผ่ต่ำ',
          en: 'Phai Tam',
        },
        districtId: 125,
      },
      {
        id: '190308',
        zipcode: 18250,
        text: 'โพนทอง',
        value: 'โพนทอง',
        name: {
          th: 'โพนทอง',
          en: 'Phon Thong',
        },
        districtId: 125,
      },
      {
        id: '190309',
        zipcode: 18230,
        text: 'ห้วยขมิ้น',
        value: 'ห้วยขมิ้น',
        name: {
          th: 'ห้วยขมิ้น',
          en: 'Huai Khamin',
        },
        districtId: 125,
      },
      {
        id: '190310',
        zipcode: 18230,
        text: 'ห้วยทราย',
        value: 'ห้วยทราย',
        name: {
          th: 'ห้วยทราย',
          en: 'Huai Sai',
        },
        districtId: 125,
      },
      {
        id: '190311',
        zipcode: 18140,
        text: 'หนองไข่น้ำ',
        value: 'หนองไข่น้ำ',
        name: {
          th: 'หนองไข่น้ำ',
          en: 'Nong Khai Nam',
        },
        districtId: 125,
      },
      {
        id: '190312',
        zipcode: 18140,
        text: 'หนองแขม',
        value: 'หนองแขม',
        name: {
          th: 'หนองแขม',
          en: 'Nong Khaem',
        },
        districtId: 125,
      },
      {
        id: '190313',
        zipcode: 18230,
        text: 'หนองจิก',
        value: 'หนองจิก',
        name: {
          th: 'หนองจิก',
          en: 'Nong Chik',
        },
        districtId: 125,
      },
      {
        id: '190314',
        zipcode: 18140,
        text: 'หนองจรเข้',
        value: 'หนองจรเข้',
        name: {
          th: 'หนองจรเข้',
          en: 'Nong Chorakhe',
        },
        districtId: 125,
      },
      {
        id: '190315',
        zipcode: 18230,
        text: 'หนองนาก',
        value: 'หนองนาก',
        name: {
          th: 'หนองนาก',
          en: 'Nong Nak',
        },
        districtId: 125,
      },
      {
        id: '190316',
        zipcode: 18140,
        text: 'หนองปลาหมอ',
        value: 'หนองปลาหมอ',
        name: {
          th: 'หนองปลาหมอ',
          en: 'Nong Pla Mo',
        },
        districtId: 125,
      },
      {
        id: '190317',
        zipcode: 18140,
        text: 'หนองปลิง',
        value: 'หนองปลิง',
        name: {
          th: 'หนองปลิง',
          en: 'Nong Pling',
        },
        districtId: 125,
      },
      {
        id: '190318',
        zipcode: 18140,
        text: 'หนองโรง',
        value: 'หนองโรง',
        name: {
          th: 'หนองโรง',
          en: 'Nong Rong',
        },
        districtId: 125,
      },
      {
        id: '190401',
        zipcode: 18150,
        text: 'หนองหมู',
        value: 'หนองหมู',
        name: {
          th: 'หนองหมู',
          en: 'Nong Mu',
        },
        districtId: 126,
      },
      {
        id: '190402',
        zipcode: 18150,
        text: 'บ้านลำ',
        value: 'บ้านลำ',
        name: {
          th: 'บ้านลำ',
          en: 'Ban Lam',
        },
        districtId: 126,
      },
      {
        id: '190403',
        zipcode: 18150,
        text: 'คลองเรือ',
        value: 'คลองเรือ',
        name: {
          th: 'คลองเรือ',
          en: 'Khlong Ruea',
        },
        districtId: 126,
      },
      {
        id: '190404',
        zipcode: 18150,
        text: 'วิหารแดง',
        value: 'วิหารแดง',
        name: {
          th: 'วิหารแดง',
          en: 'Wihan Daeng',
        },
        districtId: 126,
      },
      {
        id: '190405',
        zipcode: 18150,
        text: 'หนองสรวง',
        value: 'หนองสรวง',
        name: {
          th: 'หนองสรวง',
          en: 'Nong Suang',
        },
        districtId: 126,
      },
      {
        id: '190406',
        zipcode: 18150,
        text: 'เจริญธรรม',
        value: 'เจริญธรรม',
        name: {
          th: 'เจริญธรรม',
          en: 'Charoen Tham',
        },
        districtId: 126,
      },
      {
        id: '190501',
        zipcode: 18170,
        text: 'หนองแซง',
        value: 'หนองแซง',
        name: {
          th: 'หนองแซง',
          en: 'Nong Saeng',
        },
        districtId: 127,
      },
      {
        id: '190502',
        zipcode: 18170,
        text: 'หนองควายโซ',
        value: 'หนองควายโซ',
        name: {
          th: 'หนองควายโซ',
          en: 'Nong Khwai So',
        },
        districtId: 127,
      },
      {
        id: '190503',
        zipcode: 18170,
        text: 'หนองหัวโพ',
        value: 'หนองหัวโพ',
        name: {
          th: 'หนองหัวโพ',
          en: 'Nong Hua Pho',
        },
        districtId: 127,
      },
      {
        id: '190504',
        zipcode: 18170,
        text: 'หนองสีดา',
        value: 'หนองสีดา',
        name: {
          th: 'หนองสีดา',
          en: 'Nong Sida',
        },
        districtId: 127,
      },
      {
        id: '190505',
        zipcode: 18170,
        text: 'หนองกบ',
        value: 'หนองกบ',
        name: {
          th: 'หนองกบ',
          en: 'Nong Kop',
        },
        districtId: 127,
      },
      {
        id: '190506',
        zipcode: 18170,
        text: 'ไก่เส่า',
        value: 'ไก่เส่า',
        name: {
          th: 'ไก่เส่า',
          en: 'Kai Sao',
        },
        districtId: 127,
      },
      {
        id: '190507',
        zipcode: 18170,
        text: 'โคกสะอาด',
        value: 'โคกสะอาด',
        name: {
          th: 'โคกสะอาด',
          en: 'Khok Sa-at',
        },
        districtId: 127,
      },
      {
        id: '190508',
        zipcode: 18170,
        text: 'ม่วงหวาน',
        value: 'ม่วงหวาน',
        name: {
          th: 'ม่วงหวาน',
          en: 'Muang Wan',
        },
        districtId: 127,
      },
      {
        id: '190509',
        zipcode: 18170,
        text: 'เขาดิน',
        value: 'เขาดิน',
        name: {
          th: 'เขาดิน',
          en: 'Khao Din',
        },
        districtId: 127,
      },
      {
        id: '190601',
        zipcode: 18130,
        text: 'บ้านหมอ',
        value: 'บ้านหมอ',
        name: {
          th: 'บ้านหมอ',
          en: 'Ban Mo',
        },
        districtId: 128,
      },
      {
        id: '190602',
        zipcode: 18130,
        text: 'บางโขมด',
        value: 'บางโขมด',
        name: {
          th: 'บางโขมด',
          en: 'Bang Khamot',
        },
        districtId: 128,
      },
      {
        id: '190603',
        zipcode: 18130,
        text: 'สร่างโศก',
        value: 'สร่างโศก',
        name: {
          th: 'สร่างโศก',
          en: 'Sang Sok',
        },
        districtId: 128,
      },
      {
        id: '190604',
        zipcode: 18130,
        text: 'ตลาดน้อย',
        value: 'ตลาดน้อย',
        name: {
          th: 'ตลาดน้อย',
          en: 'Talat Noi',
        },
        districtId: 128,
      },
      {
        id: '190605',
        zipcode: 18130,
        text: 'หรเทพ',
        value: 'หรเทพ',
        name: {
          th: 'หรเทพ',
          en: 'Horathep',
        },
        districtId: 128,
      },
      {
        id: '190606',
        zipcode: 18130,
        text: 'โคกใหญ่',
        value: 'โคกใหญ่',
        name: {
          th: 'โคกใหญ่',
          en: 'Khok Yai',
        },
        districtId: 128,
      },
      {
        id: '190607',
        zipcode: 18130,
        text: 'ไผ่ขวาง',
        value: 'ไผ่ขวาง',
        name: {
          th: 'ไผ่ขวาง',
          en: 'Phai Khwang',
        },
        districtId: 128,
      },
      {
        id: '190608',
        zipcode: 18270,
        text: 'บ้านครัว',
        value: 'บ้านครัว',
        name: {
          th: 'บ้านครัว',
          en: 'Ban Khrua',
        },
        districtId: 128,
      },
      {
        id: '190609',
        zipcode: 18130,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 128,
      },
      {
        id: '190701',
        zipcode: 18210,
        text: 'ดอนพุด',
        value: 'ดอนพุด',
        name: {
          th: 'ดอนพุด',
          en: 'Don Phut',
        },
        districtId: 129,
      },
      {
        id: '190702',
        zipcode: 18210,
        text: 'ไผ่หลิ่ว',
        value: 'ไผ่หลิ่ว',
        name: {
          th: 'ไผ่หลิ่ว',
          en: 'Phai Lio',
        },
        districtId: 129,
      },
      {
        id: '190703',
        zipcode: 18210,
        text: 'บ้านหลวง',
        value: 'บ้านหลวง',
        name: {
          th: 'บ้านหลวง',
          en: 'Ban Luang',
        },
        districtId: 129,
      },
      {
        id: '190704',
        zipcode: 18210,
        text: 'ดงตะงาว',
        value: 'ดงตะงาว',
        name: {
          th: 'ดงตะงาว',
          en: 'Dong Ta-ngao',
        },
        districtId: 129,
      },
      {
        id: '190801',
        zipcode: 18190,
        text: 'หนองโดน',
        value: 'หนองโดน',
        name: {
          th: 'หนองโดน',
          en: 'Nong Don',
        },
        districtId: 130,
      },
      {
        id: '190802',
        zipcode: 18190,
        text: 'บ้านกลับ',
        value: 'บ้านกลับ',
        name: {
          th: 'บ้านกลับ',
          en: 'Ban Klap',
        },
        districtId: 130,
      },
      {
        id: '190803',
        zipcode: 18190,
        text: 'ดอนทอง',
        value: 'ดอนทอง',
        name: {
          th: 'ดอนทอง',
          en: 'Don Thong',
        },
        districtId: 130,
      },
      {
        id: '190804',
        zipcode: 18190,
        text: 'บ้านโปร่ง',
        value: 'บ้านโปร่ง',
        name: {
          th: 'บ้านโปร่ง',
          en: 'Ban Prong',
        },
        districtId: 130,
      },
      {
        id: '190901',
        zipcode: 18120,
        text: 'พระพุทธบาท',
        value: 'พระพุทธบาท',
        name: {
          th: 'พระพุทธบาท',
          en: 'Phra Phutthabat',
        },
        districtId: 131,
      },
      {
        id: '190902',
        zipcode: 18120,
        text: 'ขุนโขลน',
        value: 'ขุนโขลน',
        name: {
          th: 'ขุนโขลน',
          en: 'Khun Khlon',
        },
        districtId: 131,
      },
      {
        id: '190903',
        zipcode: 18120,
        text: 'ธารเกษม',
        value: 'ธารเกษม',
        name: {
          th: 'ธารเกษม',
          en: 'Than Kasem',
        },
        districtId: 131,
      },
      {
        id: '190904',
        zipcode: 18120,
        text: 'นายาว',
        value: 'นายาว',
        name: {
          th: 'นายาว',
          en: 'Na Yao',
        },
        districtId: 131,
      },
      {
        id: '190905',
        zipcode: 18120,
        text: 'พุคำจาน',
        value: 'พุคำจาน',
        name: {
          th: 'พุคำจาน',
          en: 'Phu Kham Chan',
        },
        districtId: 131,
      },
      {
        id: '190906',
        zipcode: 18120,
        text: 'เขาวง',
        value: 'เขาวง',
        name: {
          th: 'เขาวง',
          en: 'Khao Wong',
        },
        districtId: 131,
      },
      {
        id: '190907',
        zipcode: 18120,
        text: 'ห้วยป่าหวาย',
        value: 'ห้วยป่าหวาย',
        name: {
          th: 'ห้วยป่าหวาย',
          en: 'Huai Pa Wai',
        },
        districtId: 131,
      },
      {
        id: '190908',
        zipcode: 18120,
        text: 'พุกร่าง',
        value: 'พุกร่าง',
        name: {
          th: 'พุกร่าง',
          en: 'Phu Krang',
        },
        districtId: 131,
      },
      {
        id: '190909',
        zipcode: 18120,
        text: 'หนองแก',
        value: 'หนองแก',
        name: {
          th: 'หนองแก',
          en: 'Nong Kae',
        },
        districtId: 131,
      },
      {
        id: '191001',
        zipcode: 18160,
        text: 'เสาไห้',
        value: 'เสาไห้',
        name: {
          th: 'เสาไห้',
          en: 'Sao Hai',
        },
        districtId: 132,
      },
      {
        id: '191002',
        zipcode: 18160,
        text: 'บ้านยาง',
        value: 'บ้านยาง',
        name: {
          th: 'บ้านยาง',
          en: 'Ban Yang',
        },
        districtId: 132,
      },
      {
        id: '191003',
        zipcode: 18160,
        text: 'หัวปลวก',
        value: 'หัวปลวก',
        name: {
          th: 'หัวปลวก',
          en: 'Hua Pluak',
        },
        districtId: 132,
      },
      {
        id: '191004',
        zipcode: 18160,
        text: 'งิ้วงาม',
        value: 'งิ้วงาม',
        name: {
          th: 'งิ้วงาม',
          en: 'Ngio Ngam',
        },
        districtId: 132,
      },
      {
        id: '191005',
        zipcode: 18160,
        text: 'ศาลารีไทย',
        value: 'ศาลารีไทย',
        name: {
          th: 'ศาลารีไทย',
          en: 'Sala Ri Thai',
        },
        districtId: 132,
      },
      {
        id: '191006',
        zipcode: 18160,
        text: 'ต้นตาล',
        value: 'ต้นตาล',
        name: {
          th: 'ต้นตาล',
          en: 'Ton Tan',
        },
        districtId: 132,
      },
      {
        id: '191007',
        zipcode: 18160,
        text: 'ท่าช้าง',
        value: 'ท่าช้าง',
        name: {
          th: 'ท่าช้าง',
          en: 'Tha Chang',
        },
        districtId: 132,
      },
      {
        id: '191008',
        zipcode: 18160,
        text: 'พระยาทด',
        value: 'พระยาทด',
        name: {
          th: 'พระยาทด',
          en: 'Phraya Thot',
        },
        districtId: 132,
      },
      {
        id: '191009',
        zipcode: 18160,
        text: 'ม่วงงาม',
        value: 'ม่วงงาม',
        name: {
          th: 'ม่วงงาม',
          en: 'Muang Ngam',
        },
        districtId: 132,
      },
      {
        id: '191010',
        zipcode: 18160,
        text: 'เริงราง',
        value: 'เริงราง',
        name: {
          th: 'เริงราง',
          en: 'Roeng Rang',
        },
        districtId: 132,
      },
      {
        id: '191011',
        zipcode: 18160,
        text: 'เมืองเก่า',
        value: 'เมืองเก่า',
        name: {
          th: 'เมืองเก่า',
          en: 'Mueang Kao',
        },
        districtId: 132,
      },
      {
        id: '191012',
        zipcode: 18160,
        text: 'สวนดอกไม้',
        value: 'สวนดอกไม้',
        name: {
          th: 'สวนดอกไม้',
          en: 'Suan Dok Mai',
        },
        districtId: 132,
      },
      {
        id: '191101',
        zipcode: 18180,
        text: 'มวกเหล็ก',
        value: 'มวกเหล็ก',
        name: {
          th: 'มวกเหล็ก',
          en: 'Muak Lek',
        },
        districtId: 133,
      },
      {
        id: '191102',
        zipcode: 18180,
        text: 'มิตรภาพ',
        value: 'มิตรภาพ',
        name: {
          th: 'มิตรภาพ',
          en: 'Mittraphap',
        },
        districtId: 133,
      },
      {
        id: '191104',
        zipcode: 18180,
        text: 'หนองย่างเสือ',
        value: 'หนองย่างเสือ',
        name: {
          th: 'หนองย่างเสือ',
          en: 'Nong Yang Suea',
        },
        districtId: 133,
      },
      {
        id: '191105',
        zipcode: 18180,
        text: 'ลำสมพุง',
        value: 'ลำสมพุง',
        name: {
          th: 'ลำสมพุง',
          en: 'Lam Somphung',
        },
        districtId: 133,
      },
      {
        id: '191107',
        zipcode: 18180,
        text: 'ลำพญากลาง',
        value: 'ลำพญากลาง',
        name: {
          th: 'ลำพญากลาง',
          en: 'Lam Phaya Klang',
        },
        districtId: 133,
      },
      {
        id: '191109',
        zipcode: 18220,
        text: 'ซับสนุ่น',
        value: 'ซับสนุ่น',
        name: {
          th: 'ซับสนุ่น',
          en: 'Sap Sanun',
        },
        districtId: 133,
      },
      {
        id: '191201',
        zipcode: 18220,
        text: 'แสลงพัน',
        value: 'แสลงพัน',
        name: {
          th: 'แสลงพัน',
          en: 'Salaeng Phan',
        },
        districtId: 134,
      },
      {
        id: '191202',
        zipcode: 18220,
        text: 'คำพราน',
        value: 'คำพราน',
        name: {
          th: 'คำพราน',
          en: 'Kham Phran',
        },
        districtId: 134,
      },
      {
        id: '191203',
        zipcode: 18220,
        text: 'วังม่วง',
        value: 'วังม่วง',
        name: {
          th: 'วังม่วง',
          en: 'Wang Muang',
        },
        districtId: 134,
      },
      {
        id: '191301',
        zipcode: 18000,
        text: 'เขาดินพัฒนา',
        value: 'เขาดินพัฒนา',
        name: {
          th: 'เขาดินพัฒนา',
          en: 'Khao Din Phatthana',
        },
        districtId: 135,
      },
      {
        id: '191302',
        zipcode: 18000,
        text: 'บ้านแก้ง',
        value: 'บ้านแก้ง',
        name: {
          th: 'บ้านแก้ง',
          en: 'Ban Kaeng',
        },
        districtId: 135,
      },
      {
        id: '191303',
        zipcode: 18000,
        text: 'ผึ้งรวง',
        value: 'ผึ้งรวง',
        name: {
          th: 'ผึ้งรวง',
          en: 'Phueng Ruang',
        },
        districtId: 135,
      },
      {
        id: '191304',
        zipcode: 18240,
        text: 'พุแค',
        value: 'พุแค',
        name: {
          th: 'พุแค',
          en: 'Phu Khae',
        },
        districtId: 135,
      },
      {
        id: '191305',
        zipcode: 18000,
        text: 'ห้วยบง',
        value: 'ห้วยบง',
        name: {
          th: 'ห้วยบง',
          en: 'Huai Bong',
        },
        districtId: 135,
      },
      {
        id: '191306',
        zipcode: 18240,
        text: 'หน้าพระลาน',
        value: 'หน้าพระลาน',
        name: {
          th: 'หน้าพระลาน',
          en: 'Na Phra Lan',
        },
        districtId: 135,
      },
      {
        id: '200101',
        zipcode: 20000,
        text: 'บางปลาสร้อย',
        value: 'บางปลาสร้อย',
        name: {
          th: 'บางปลาสร้อย',
          en: 'Bang Pla Soi',
        },
        districtId: 136,
      },
      {
        id: '200102',
        zipcode: 20000,
        text: 'มะขามหย่ง',
        value: 'มะขามหย่ง',
        name: {
          th: 'มะขามหย่ง',
          en: 'Makham Yong',
        },
        districtId: 136,
      },
      {
        id: '200103',
        zipcode: 20000,
        text: 'บ้านโขด',
        value: 'บ้านโขด',
        name: {
          th: 'บ้านโขด',
          en: 'Ban Khot',
        },
        districtId: 136,
      },
      {
        id: '200104',
        zipcode: 20000,
        text: 'แสนสุข',
        value: 'แสนสุข',
        name: {
          th: 'แสนสุข',
          en: 'Saen Suk',
        },
        districtId: 136,
      },
      {
        id: '200105',
        zipcode: 20000,
        text: 'บ้านสวน',
        value: 'บ้านสวน',
        name: {
          th: 'บ้านสวน',
          en: 'Ban Suan',
        },
        districtId: 136,
      },
      {
        id: '200106',
        zipcode: 20000,
        text: 'หนองรี',
        value: 'หนองรี',
        name: {
          th: 'หนองรี',
          en: 'Nong Ri',
        },
        districtId: 136,
      },
      {
        id: '200107',
        zipcode: 20000,
        text: 'นาป่า',
        value: 'นาป่า',
        name: {
          th: 'นาป่า',
          en: 'Na Pa',
        },
        districtId: 136,
      },
      {
        id: '200108',
        zipcode: 20000,
        text: 'หนองข้างคอก',
        value: 'หนองข้างคอก',
        name: {
          th: 'หนองข้างคอก',
          en: 'Nong Khang Khok',
        },
        districtId: 136,
      },
      {
        id: '200109',
        zipcode: 20000,
        text: 'ดอนหัวฬ่อ',
        value: 'ดอนหัวฬ่อ',
        name: {
          th: 'ดอนหัวฬ่อ',
          en: 'Don Hua Lo',
        },
        districtId: 136,
      },
      {
        id: '200110',
        zipcode: 20000,
        text: 'หนองไม้แดง',
        value: 'หนองไม้แดง',
        name: {
          th: 'หนองไม้แดง',
          en: 'Nong Mai Daeng',
        },
        districtId: 136,
      },
      {
        id: '200111',
        zipcode: 20000,
        text: 'บางทราย',
        value: 'บางทราย',
        name: {
          th: 'บางทราย',
          en: 'Bang Sai',
        },
        districtId: 136,
      },
      {
        id: '200112',
        zipcode: 20000,
        text: 'คลองตำหรุ',
        value: 'คลองตำหรุ',
        name: {
          th: 'คลองตำหรุ',
          en: 'Khlong Tamru',
        },
        districtId: 136,
      },
      {
        id: '200113',
        zipcode: 20130,
        text: 'เหมือง',
        value: 'เหมือง',
        name: {
          th: 'เหมือง',
          en: 'Mueang',
        },
        districtId: 136,
      },
      {
        id: '200114',
        zipcode: 20130,
        text: 'บ้านปึก',
        value: 'บ้านปึก',
        name: {
          th: 'บ้านปึก',
          en: 'Ban Puek',
        },
        districtId: 136,
      },
      {
        id: '200115',
        zipcode: 20000,
        text: 'ห้วยกะปิ',
        value: 'ห้วยกะปิ',
        name: {
          th: 'ห้วยกะปิ',
          en: 'Huai Kapi',
        },
        districtId: 136,
      },
      {
        id: '200116',
        zipcode: 20130,
        text: 'เสม็ด',
        value: 'เสม็ด',
        name: {
          th: 'เสม็ด',
          en: 'Samet',
        },
        districtId: 136,
      },
      {
        id: '200117',
        zipcode: 20000,
        text: 'อ่างศิลา',
        value: 'อ่างศิลา',
        name: {
          th: 'อ่างศิลา',
          en: 'Ang Sila',
        },
        districtId: 136,
      },
      {
        id: '200118',
        zipcode: 20000,
        text: 'สำนักบก',
        value: 'สำนักบก',
        name: {
          th: 'สำนักบก',
          en: 'Samnak Bok',
        },
        districtId: 136,
      },
      {
        id: '200201',
        zipcode: 20170,
        text: 'บ้านบึง',
        value: 'บ้านบึง',
        name: {
          th: 'บ้านบึง',
          en: 'Ban Bueng',
        },
        districtId: 137,
      },
      {
        id: '200202',
        zipcode: 20220,
        text: 'คลองกิ่ว',
        value: 'คลองกิ่ว',
        name: {
          th: 'คลองกิ่ว',
          en: 'Khlong Kio',
        },
        districtId: 137,
      },
      {
        id: '200203',
        zipcode: 20170,
        text: 'มาบไผ่',
        value: 'มาบไผ่',
        name: {
          th: 'มาบไผ่',
          en: 'Map Phai',
        },
        districtId: 137,
      },
      {
        id: '200204',
        zipcode: 20170,
        text: 'หนองซ้ำซาก',
        value: 'หนองซ้ำซาก',
        name: {
          th: 'หนองซ้ำซาก',
          en: 'Nong Samsak',
        },
        districtId: 137,
      },
      {
        id: '200205',
        zipcode: 20170,
        text: 'หนองบอนแดง',
        value: 'หนองบอนแดง',
        name: {
          th: 'หนองบอนแดง',
          en: 'Nong Bon Daeng',
        },
        districtId: 137,
      },
      {
        id: '200206',
        zipcode: 20170,
        text: 'หนองชาก',
        value: 'หนองชาก',
        name: {
          th: 'หนองชาก',
          en: 'Nong Chak',
        },
        districtId: 137,
      },
      {
        id: '200207',
        zipcode: 20220,
        text: 'หนองอิรุณ',
        value: 'หนองอิรุณ',
        name: {
          th: 'หนองอิรุณ',
          en: 'Nong Irun',
        },
        districtId: 137,
      },
      {
        id: '200208',
        zipcode: 20220,
        text: 'หนองไผ่แก้ว',
        value: 'หนองไผ่แก้ว',
        name: {
          th: 'หนองไผ่แก้ว',
          en: 'Nong Phai Kaeo',
        },
        districtId: 137,
      },
      {
        id: '200301',
        zipcode: 20190,
        text: 'หนองใหญ่',
        value: 'หนองใหญ่',
        name: {
          th: 'หนองใหญ่',
          en: 'Nong Yai',
        },
        districtId: 138,
      },
      {
        id: '200302',
        zipcode: 20190,
        text: 'คลองพลู',
        value: 'คลองพลู',
        name: {
          th: 'คลองพลู',
          en: 'Khlong Phlu',
        },
        districtId: 138,
      },
      {
        id: '200303',
        zipcode: 20190,
        text: 'หนองเสือช้าง',
        value: 'หนองเสือช้าง',
        name: {
          th: 'หนองเสือช้าง',
          en: 'Nong Suea Chang',
        },
        districtId: 138,
      },
      {
        id: '200304',
        zipcode: 20190,
        text: 'ห้างสูง',
        value: 'ห้างสูง',
        name: {
          th: 'ห้างสูง',
          en: 'Hang Sung',
        },
        districtId: 138,
      },
      {
        id: '200305',
        zipcode: 20190,
        text: 'เขาซก',
        value: 'เขาซก',
        name: {
          th: 'เขาซก',
          en: 'Khao Sok',
        },
        districtId: 138,
      },
      {
        id: '200401',
        zipcode: 20150,
        text: 'บางละมุง',
        value: 'บางละมุง',
        name: {
          th: 'บางละมุง',
          en: 'Bang Lamung',
        },
        districtId: 139,
      },
      {
        id: '200402',
        zipcode: 20150,
        text: 'หนองปรือ',
        value: 'หนองปรือ',
        name: {
          th: 'หนองปรือ',
          en: 'Nong Prue',
        },
        districtId: 139,
      },
      {
        id: '200403',
        zipcode: 20150,
        text: 'หนองปลาไหล',
        value: 'หนองปลาไหล',
        name: {
          th: 'หนองปลาไหล',
          en: 'Nong Pla Lai',
        },
        districtId: 139,
      },
      {
        id: '200404',
        zipcode: 20150,
        text: 'โป่ง',
        value: 'โป่ง',
        name: {
          th: 'โป่ง',
          en: 'Pong',
        },
        districtId: 139,
      },
      {
        id: '200405',
        zipcode: 20150,
        text: 'เขาไม้แก้ว',
        value: 'เขาไม้แก้ว',
        name: {
          th: 'เขาไม้แก้ว',
          en: 'Khao Mai Kaeo',
        },
        districtId: 139,
      },
      {
        id: '200406',
        zipcode: 20150,
        text: 'ห้วยใหญ่',
        value: 'ห้วยใหญ่',
        name: {
          th: 'ห้วยใหญ่',
          en: 'Huai Yai',
        },
        districtId: 139,
      },
      {
        id: '200407',
        zipcode: 20150,
        text: 'ตะเคียนเตี้ย',
        value: 'ตะเคียนเตี้ย',
        name: {
          th: 'ตะเคียนเตี้ย',
          en: 'Takhian Tia',
        },
        districtId: 139,
      },
      {
        id: '200408',
        zipcode: 20150,
        text: 'นาเกลือ',
        value: 'นาเกลือ',
        name: {
          th: 'นาเกลือ',
          en: 'Na Kluea',
        },
        districtId: 139,
      },
      {
        id: '200501',
        zipcode: 20160,
        text: 'พานทอง',
        value: 'พานทอง',
        name: {
          th: 'พานทอง',
          en: 'Phan Thong',
        },
        districtId: 140,
      },
      {
        id: '200502',
        zipcode: 20160,
        text: 'หนองตำลึง',
        value: 'หนองตำลึง',
        name: {
          th: 'หนองตำลึง',
          en: 'Nong Tamlueng',
        },
        districtId: 140,
      },
      {
        id: '200503',
        zipcode: 20160,
        text: 'มาบโป่ง',
        value: 'มาบโป่ง',
        name: {
          th: 'มาบโป่ง',
          en: 'Map Pong',
        },
        districtId: 140,
      },
      {
        id: '200504',
        zipcode: 20160,
        text: 'หนองกะขะ',
        value: 'หนองกะขะ',
        name: {
          th: 'หนองกะขะ',
          en: 'Nong Kakha',
        },
        districtId: 140,
      },
      {
        id: '200505',
        zipcode: 20160,
        text: 'หนองหงษ์',
        value: 'หนองหงษ์',
        name: {
          th: 'หนองหงษ์',
          en: 'Nong Hong',
        },
        districtId: 140,
      },
      {
        id: '200506',
        zipcode: 20160,
        text: 'โคกขี้หนอน',
        value: 'โคกขี้หนอน',
        name: {
          th: 'โคกขี้หนอน',
          en: 'Khok Khi Non',
        },
        districtId: 140,
      },
      {
        id: '200507',
        zipcode: 20160,
        text: 'บ้านเก่า',
        value: 'บ้านเก่า',
        name: {
          th: 'บ้านเก่า',
          en: 'Ban Kao',
        },
        districtId: 140,
      },
      {
        id: '200508',
        zipcode: 20160,
        text: 'หน้าประดู่',
        value: 'หน้าประดู่',
        name: {
          th: 'หน้าประดู่',
          en: 'Na Pradu',
        },
        districtId: 140,
      },
      {
        id: '200509',
        zipcode: 20160,
        text: 'บางนาง',
        value: 'บางนาง',
        name: {
          th: 'บางนาง',
          en: 'Bang Nang',
        },
        districtId: 140,
      },
      {
        id: '200510',
        zipcode: 20160,
        text: 'เกาะลอย',
        value: 'เกาะลอย',
        name: {
          th: 'เกาะลอย',
          en: 'Ko Loi',
        },
        districtId: 140,
      },
      {
        id: '200511',
        zipcode: 20160,
        text: 'บางหัก',
        value: 'บางหัก',
        name: {
          th: 'บางหัก',
          en: 'Bang Hak',
        },
        districtId: 140,
      },
      {
        id: '200601',
        zipcode: 20140,
        text: 'พนัสนิคม',
        value: 'พนัสนิคม',
        name: {
          th: 'พนัสนิคม',
          en: 'Phanat Nikhom',
        },
        districtId: 141,
      },
      {
        id: '200602',
        zipcode: 20140,
        text: 'หน้าพระธาตุ',
        value: 'หน้าพระธาตุ',
        name: {
          th: 'หน้าพระธาตุ',
          en: 'Na Phra That',
        },
        districtId: 141,
      },
      {
        id: '200603',
        zipcode: 20140,
        text: 'วัดหลวง',
        value: 'วัดหลวง',
        name: {
          th: 'วัดหลวง',
          en: 'Wat Luang',
        },
        districtId: 141,
      },
      {
        id: '200604',
        zipcode: 20140,
        text: 'บ้านเซิด',
        value: 'บ้านเซิด',
        name: {
          th: 'บ้านเซิด',
          en: 'Ban Soet',
        },
        districtId: 141,
      },
      {
        id: '200605',
        zipcode: 20140,
        text: 'นาเริก',
        value: 'นาเริก',
        name: {
          th: 'นาเริก',
          en: 'Na Roek',
        },
        districtId: 141,
      },
      {
        id: '200606',
        zipcode: 20140,
        text: 'หมอนนาง',
        value: 'หมอนนาง',
        name: {
          th: 'หมอนนาง',
          en: 'Mon Nang',
        },
        districtId: 141,
      },
      {
        id: '200607',
        zipcode: 20140,
        text: 'สระสี่เหลี่ยม',
        value: 'สระสี่เหลี่ยม',
        name: {
          th: 'สระสี่เหลี่ยม',
          en: 'Sa Si Liam',
        },
        districtId: 141,
      },
      {
        id: '200608',
        zipcode: 20140,
        text: 'วัดโบสถ์',
        value: 'วัดโบสถ์',
        name: {
          th: 'วัดโบสถ์',
          en: 'Wat Bot',
        },
        districtId: 141,
      },
      {
        id: '200609',
        zipcode: 20140,
        text: 'กุฎโง้ง',
        value: 'กุฎโง้ง',
        name: {
          th: 'กุฎโง้ง',
          en: 'Kut Ngong',
        },
        districtId: 141,
      },
      {
        id: '200610',
        zipcode: 20140,
        text: 'หัวถนน',
        value: 'หัวถนน',
        name: {
          th: 'หัวถนน',
          en: 'Hua Thanon',
        },
        districtId: 141,
      },
      {
        id: '200611',
        zipcode: 20140,
        text: 'ท่าข้าม',
        value: 'ท่าข้าม',
        name: {
          th: 'ท่าข้าม',
          en: 'Tha Kham',
        },
        districtId: 141,
      },
      {
        id: '200613',
        zipcode: 20140,
        text: 'หนองปรือ',
        value: 'หนองปรือ',
        name: {
          th: 'หนองปรือ',
          en: 'Nong Prue',
        },
        districtId: 141,
      },
      {
        id: '200614',
        zipcode: 20140,
        text: 'หนองขยาด',
        value: 'หนองขยาด',
        name: {
          th: 'หนองขยาด',
          en: 'Nong Khayat',
        },
        districtId: 141,
      },
      {
        id: '200615',
        zipcode: 20140,
        text: 'ทุ่งขวาง',
        value: 'ทุ่งขวาง',
        name: {
          th: 'ทุ่งขวาง',
          en: 'Thung Khwang',
        },
        districtId: 141,
      },
      {
        id: '200616',
        zipcode: 20140,
        text: 'หนองเหียง',
        value: 'หนองเหียง',
        name: {
          th: 'หนองเหียง',
          en: 'Nong Hiang',
        },
        districtId: 141,
      },
      {
        id: '200617',
        zipcode: 20140,
        text: 'นาวังหิน',
        value: 'นาวังหิน',
        name: {
          th: 'นาวังหิน',
          en: 'Na Wang Hin',
        },
        districtId: 141,
      },
      {
        id: '200618',
        zipcode: 20140,
        text: 'บ้านช้าง',
        value: 'บ้านช้าง',
        name: {
          th: 'บ้านช้าง',
          en: 'Ban Chang',
        },
        districtId: 141,
      },
      {
        id: '200620',
        zipcode: 20140,
        text: 'โคกเพลาะ',
        value: 'โคกเพลาะ',
        name: {
          th: 'โคกเพลาะ',
          en: 'Khok Phlo',
        },
        districtId: 141,
      },
      {
        id: '200621',
        zipcode: 20140,
        text: 'ไร่หลักทอง',
        value: 'ไร่หลักทอง',
        name: {
          th: 'ไร่หลักทอง',
          en: 'Rai Lak Thong',
        },
        districtId: 141,
      },
      {
        id: '200622',
        zipcode: 20140,
        text: 'นามะตูม',
        value: 'นามะตูม',
        name: {
          th: 'นามะตูม',
          en: 'Na Matum',
        },
        districtId: 141,
      },
      {
        id: '200701',
        zipcode: 20110,
        text: 'ศรีราชา',
        value: 'ศรีราชา',
        name: {
          th: 'ศรีราชา',
          en: 'Si Racha',
        },
        districtId: 142,
      },
      {
        id: '200702',
        zipcode: 20110,
        text: 'สุรศักดิ์',
        value: 'สุรศักดิ์',
        name: {
          th: 'สุรศักดิ์',
          en: 'Surasak',
        },
        districtId: 142,
      },
      {
        id: '200703',
        zipcode: 20230,
        text: 'ทุ่งสุขลา',
        value: 'ทุ่งสุขลา',
        name: {
          th: 'ทุ่งสุขลา',
          en: 'Thung Sukhla',
        },
        districtId: 142,
      },
      {
        id: '200704',
        zipcode: 20230,
        text: 'บึง',
        value: 'บึง',
        name: {
          th: 'บึง',
          en: 'Bueng',
        },
        districtId: 142,
      },
      {
        id: '200705',
        zipcode: 20110,
        text: 'หนองขาม',
        value: 'หนองขาม',
        name: {
          th: 'หนองขาม',
          en: 'Nong Kham',
        },
        districtId: 142,
      },
      {
        id: '200706',
        zipcode: 20110,
        text: 'เขาคันทรง',
        value: 'เขาคันทรง',
        name: {
          th: 'เขาคันทรง',
          en: 'Khao Khansong',
        },
        districtId: 142,
      },
      {
        id: '200707',
        zipcode: 20110,
        text: 'บางพระ',
        value: 'บางพระ',
        name: {
          th: 'บางพระ',
          en: 'Bang Phra',
        },
        districtId: 142,
      },
      {
        id: '200708',
        zipcode: 20230,
        text: 'บ่อวิน',
        value: 'บ่อวิน',
        name: {
          th: 'บ่อวิน',
          en: 'Bo Win',
        },
        districtId: 142,
      },
      {
        id: '200801',
        zipcode: 20120,
        text: 'ท่าเทววงษ์',
        value: 'ท่าเทววงษ์',
        name: {
          th: 'ท่าเทววงษ์',
          en: 'Tha Tewatong',
        },
        districtId: 143,
      },
      {
        id: '200901',
        zipcode: 20180,
        text: 'สัตหีบ',
        value: 'สัตหีบ',
        name: {
          th: 'สัตหีบ',
          en: 'Sattahip',
        },
        districtId: 144,
      },
      {
        id: '200902',
        zipcode: 20250,
        text: 'นาจอมเทียน',
        value: 'นาจอมเทียน',
        name: {
          th: 'นาจอมเทียน',
          en: 'Na Chom Thian',
        },
        districtId: 144,
      },
      {
        id: '200903',
        zipcode: 20180,
        text: 'พลูตาหลวง',
        value: 'พลูตาหลวง',
        name: {
          th: 'พลูตาหลวง',
          en: 'Phlu Ta Luang',
        },
        districtId: 144,
      },
      {
        id: '200904',
        zipcode: 20250,
        text: 'บางเสร่',
        value: 'บางเสร่',
        name: {
          th: 'บางเสร่',
          en: 'Bang Sare',
        },
        districtId: 144,
      },
      {
        id: '200905',
        zipcode: 20180,
        text: 'แสมสาร',
        value: 'แสมสาร',
        name: {
          th: 'แสมสาร',
          en: 'Samaesan',
        },
        districtId: 144,
      },
      {
        id: '201001',
        zipcode: 20270,
        text: 'บ่อทอง',
        value: 'บ่อทอง',
        name: {
          th: 'บ่อทอง',
          en: 'Bo Thong',
        },
        districtId: 145,
      },
      {
        id: '201002',
        zipcode: 20270,
        text: 'วัดสุวรรณ',
        value: 'วัดสุวรรณ',
        name: {
          th: 'วัดสุวรรณ',
          en: 'Wat Suwan',
        },
        districtId: 145,
      },
      {
        id: '201003',
        zipcode: 20270,
        text: 'บ่อกวางทอง',
        value: 'บ่อกวางทอง',
        name: {
          th: 'บ่อกวางทอง',
          en: 'Bo Kwang Thong',
        },
        districtId: 145,
      },
      {
        id: '201004',
        zipcode: 20270,
        text: 'ธาตุทอง',
        value: 'ธาตุทอง',
        name: {
          th: 'ธาตุทอง',
          en: 'That Thong',
        },
        districtId: 145,
      },
      {
        id: '201005',
        zipcode: 20270,
        text: 'เกษตรสุวรรณ',
        value: 'เกษตรสุวรรณ',
        name: {
          th: 'เกษตรสุวรรณ',
          en: 'Kaset Suwan',
        },
        districtId: 145,
      },
      {
        id: '201006',
        zipcode: 20270,
        text: 'พลวงทอง',
        value: 'พลวงทอง',
        name: {
          th: 'พลวงทอง',
          en: 'Phluang Thong',
        },
        districtId: 145,
      },
      {
        id: '201101',
        zipcode: 20240,
        text: 'เกาะจันทร์',
        value: 'เกาะจันทร์',
        name: {
          th: 'เกาะจันทร์',
          en: 'Ko Chan',
        },
        districtId: 146,
      },
      {
        id: '201102',
        zipcode: 20240,
        text: 'ท่าบุญมี',
        value: 'ท่าบุญมี',
        name: {
          th: 'ท่าบุญมี',
          en: 'Tha Bun Mi',
        },
        districtId: 146,
      },
      {
        id: '210101',
        zipcode: 21000,
        text: 'ท่าประดู่',
        value: 'ท่าประดู่',
        name: {
          th: 'ท่าประดู่',
          en: 'Tha Pradu',
        },
        districtId: 151,
      },
      {
        id: '210102',
        zipcode: 21000,
        text: 'เชิงเนิน',
        value: 'เชิงเนิน',
        name: {
          th: 'เชิงเนิน',
          en: 'Choeng Noen',
        },
        districtId: 151,
      },
      {
        id: '210103',
        zipcode: 21000,
        text: 'ตะพง',
        value: 'ตะพง',
        name: {
          th: 'ตะพง',
          en: 'Taphong',
        },
        districtId: 151,
      },
      {
        id: '210104',
        zipcode: 21000,
        text: 'ปากน้ำ',
        value: 'ปากน้ำ',
        name: {
          th: 'ปากน้ำ',
          en: 'Pak Nam',
        },
        districtId: 151,
      },
      {
        id: '210105',
        zipcode: 21160,
        text: 'เพ',
        value: 'เพ',
        name: {
          th: 'เพ',
          en: 'Phe',
        },
        districtId: 151,
      },
      {
        id: '210106',
        zipcode: 21160,
        text: 'แกลง',
        value: 'แกลง',
        name: {
          th: 'แกลง',
          en: 'Klaeng',
        },
        districtId: 151,
      },
      {
        id: '210107',
        zipcode: 21000,
        text: 'บ้านแลง',
        value: 'บ้านแลง',
        name: {
          th: 'บ้านแลง',
          en: 'Ban Laeng',
        },
        districtId: 151,
      },
      {
        id: '210108',
        zipcode: 21000,
        text: 'นาตาขวัญ',
        value: 'นาตาขวัญ',
        name: {
          th: 'นาตาขวัญ',
          en: 'Na Ta Khwan',
        },
        districtId: 151,
      },
      {
        id: '210109',
        zipcode: 21000,
        text: 'เนินพระ',
        value: 'เนินพระ',
        name: {
          th: 'เนินพระ',
          en: 'Noen Phra',
        },
        districtId: 151,
      },
      {
        id: '210110',
        zipcode: 21100,
        text: 'กะเฉด',
        value: 'กะเฉด',
        name: {
          th: 'กะเฉด',
          en: 'Kachet',
        },
        districtId: 151,
      },
      {
        id: '210111',
        zipcode: 21000,
        text: 'ทับมา',
        value: 'ทับมา',
        name: {
          th: 'ทับมา',
          en: 'Thap Ma',
        },
        districtId: 151,
      },
      {
        id: '210112',
        zipcode: 21000,
        text: 'น้ำคอก',
        value: 'น้ำคอก',
        name: {
          th: 'น้ำคอก',
          en: 'Nam Khok',
        },
        districtId: 151,
      },
      {
        id: '210113',
        zipcode: 21150,
        text: 'ห้วยโป่ง',
        value: 'ห้วยโป่ง',
        name: {
          th: 'ห้วยโป่ง',
          en: 'Huai Pong',
        },
        districtId: 151,
      },
      {
        id: '210114',
        zipcode: 21150,
        text: 'มาบตาพุด',
        value: 'มาบตาพุด',
        name: {
          th: 'มาบตาพุด',
          en: 'Map Ta Phut',
        },
        districtId: 151,
      },
      {
        id: '210115',
        zipcode: 21100,
        text: 'สำนักทอง',
        value: 'สำนักทอง',
        name: {
          th: 'สำนักทอง',
          en: 'Samnak Thong',
        },
        districtId: 151,
      },
      {
        id: '210201',
        zipcode: 21130,
        text: 'สำนักท้อน',
        value: 'สำนักท้อน',
        name: {
          th: 'สำนักท้อน',
          en: 'Samnak Thon',
        },
        districtId: 152,
      },
      {
        id: '210202',
        zipcode: 21130,
        text: 'พลา',
        value: 'พลา',
        name: {
          th: 'พลา',
          en: 'Phla',
        },
        districtId: 152,
      },
      {
        id: '210203',
        zipcode: 21130,
        text: 'บ้านฉาง',
        value: 'บ้านฉาง',
        name: {
          th: 'บ้านฉาง',
          en: 'Ban Chang',
        },
        districtId: 152,
      },
      {
        id: '210301',
        zipcode: 21110,
        text: 'ทางเกวียน',
        value: 'ทางเกวียน',
        name: {
          th: 'ทางเกวียน',
          en: 'Thang Kwian',
        },
        districtId: 153,
      },
      {
        id: '210302',
        zipcode: 21110,
        text: 'วังหว้า',
        value: 'วังหว้า',
        name: {
          th: 'วังหว้า',
          en: 'Wang Wa',
        },
        districtId: 153,
      },
      {
        id: '210303',
        zipcode: 21110,
        text: 'ชากโดน',
        value: 'ชากโดน',
        name: {
          th: 'ชากโดน',
          en: 'Chak Don',
        },
        districtId: 153,
      },
      {
        id: '210304',
        zipcode: 21110,
        text: 'เนินฆ้อ',
        value: 'เนินฆ้อ',
        name: {
          th: 'เนินฆ้อ',
          en: 'Noen Kho',
        },
        districtId: 153,
      },
      {
        id: '210305',
        zipcode: 21190,
        text: 'กร่ำ',
        value: 'กร่ำ',
        name: {
          th: 'กร่ำ',
          en: 'Kram',
        },
        districtId: 153,
      },
      {
        id: '210306',
        zipcode: 21190,
        text: 'ชากพง',
        value: 'ชากพง',
        name: {
          th: 'ชากพง',
          en: 'Chak Phong',
        },
        districtId: 153,
      },
      {
        id: '210307',
        zipcode: 21110,
        text: 'กระแสบน',
        value: 'กระแสบน',
        name: {
          th: 'กระแสบน',
          en: 'Krasae Bon',
        },
        districtId: 153,
      },
      {
        id: '210308',
        zipcode: 21110,
        text: 'บ้านนา',
        value: 'บ้านนา',
        name: {
          th: 'บ้านนา',
          en: 'Ban Na',
        },
        districtId: 153,
      },
      {
        id: '210309',
        zipcode: 21110,
        text: 'ทุ่งควายกิน',
        value: 'ทุ่งควายกิน',
        name: {
          th: 'ทุ่งควายกิน',
          en: 'Thung Khwai Kin',
        },
        districtId: 153,
      },
      {
        id: '210310',
        zipcode: 22160,
        text: 'กองดิน',
        value: 'กองดิน',
        name: {
          th: 'กองดิน',
          en: 'Kong Din',
        },
        districtId: 153,
      },
      {
        id: '210311',
        zipcode: 21170,
        text: 'คลองปูน',
        value: 'คลองปูน',
        name: {
          th: 'คลองปูน',
          en: 'Khlong Pun',
        },
        districtId: 153,
      },
      {
        id: '210312',
        zipcode: 21110,
        text: 'พังราด',
        value: 'พังราด',
        name: {
          th: 'พังราด',
          en: 'Phang Rat',
        },
        districtId: 153,
      },
      {
        id: '210313',
        zipcode: 21170,
        text: 'ปากน้ำกระแส',
        value: 'ปากน้ำกระแส',
        name: {
          th: 'ปากน้ำกระแส',
          en: 'Pak Nam Krasae',
        },
        districtId: 153,
      },
      {
        id: '210317',
        zipcode: 21110,
        text: 'ห้วยยาง',
        value: 'ห้วยยาง',
        name: {
          th: 'ห้วยยาง',
          en: 'Huai Yang',
        },
        districtId: 153,
      },
      {
        id: '210318',
        zipcode: 21110,
        text: 'สองสลึง',
        value: 'สองสลึง',
        name: {
          th: 'สองสลึง',
          en: 'Song Salueng',
        },
        districtId: 153,
      },
      {
        id: '210401',
        zipcode: 21210,
        text: 'วังจันทร์',
        value: 'วังจันทร์',
        name: {
          th: 'วังจันทร์',
          en: 'Wang Chan',
        },
        districtId: 154,
      },
      {
        id: '210402',
        zipcode: 21210,
        text: 'ชุมแสง',
        value: 'ชุมแสง',
        name: {
          th: 'ชุมแสง',
          en: 'Chum Saeng',
        },
        districtId: 154,
      },
      {
        id: '210403',
        zipcode: 21210,
        text: 'ป่ายุบใน',
        value: 'ป่ายุบใน',
        name: {
          th: 'ป่ายุบใน',
          en: 'Pa Yup Nai',
        },
        districtId: 154,
      },
      {
        id: '210404',
        zipcode: 21210,
        text: 'พลงตาเอี่ยม',
        value: 'พลงตาเอี่ยม',
        name: {
          th: 'พลงตาเอี่ยม',
          en: 'Phlong Ta Iam',
        },
        districtId: 154,
      },
      {
        id: '210501',
        zipcode: 21120,
        text: 'บ้านค่าย',
        value: 'บ้านค่าย',
        name: {
          th: 'บ้านค่าย',
          en: 'Ban Khai',
        },
        districtId: 155,
      },
      {
        id: '210502',
        zipcode: 21120,
        text: 'หนองละลอก',
        value: 'หนองละลอก',
        name: {
          th: 'หนองละลอก',
          en: 'Nong Lalok',
        },
        districtId: 155,
      },
      {
        id: '210503',
        zipcode: 21120,
        text: 'หนองตะพาน',
        value: 'หนองตะพาน',
        name: {
          th: 'หนองตะพาน',
          en: 'Nong Taphan',
        },
        districtId: 155,
      },
      {
        id: '210504',
        zipcode: 21120,
        text: 'ตาขัน',
        value: 'ตาขัน',
        name: {
          th: 'ตาขัน',
          en: 'Ta Khan',
        },
        districtId: 155,
      },
      {
        id: '210505',
        zipcode: 21120,
        text: 'บางบุตร',
        value: 'บางบุตร',
        name: {
          th: 'บางบุตร',
          en: 'Bang But',
        },
        districtId: 155,
      },
      {
        id: '210506',
        zipcode: 21120,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 155,
      },
      {
        id: '210507',
        zipcode: 21120,
        text: 'ชากบก',
        value: 'ชากบก',
        name: {
          th: 'ชากบก',
          en: 'Chak Bok',
        },
        districtId: 155,
      },
      {
        id: '210601',
        zipcode: 21140,
        text: 'ปลวกแดง',
        value: 'ปลวกแดง',
        name: {
          th: 'ปลวกแดง',
          en: 'Pluak Daeng',
        },
        districtId: 156,
      },
      {
        id: '210602',
        zipcode: 21140,
        text: 'ตาสิทธิ์',
        value: 'ตาสิทธิ์',
        name: {
          th: 'ตาสิทธิ์',
          en: 'Ta Sit',
        },
        districtId: 156,
      },
      {
        id: '210603',
        zipcode: 21140,
        text: 'ละหาร',
        value: 'ละหาร',
        name: {
          th: 'ละหาร',
          en: 'Lahan',
        },
        districtId: 156,
      },
      {
        id: '210604',
        zipcode: 21140,
        text: 'แม่น้ำคู้',
        value: 'แม่น้ำคู้',
        name: {
          th: 'แม่น้ำคู้',
          en: 'Maenam Khu',
        },
        districtId: 156,
      },
      {
        id: '210605',
        zipcode: 21140,
        text: 'มาบยางพร',
        value: 'มาบยางพร',
        name: {
          th: 'มาบยางพร',
          en: 'Map Yang Phon',
        },
        districtId: 156,
      },
      {
        id: '210606',
        zipcode: 21140,
        text: 'หนองไร่',
        value: 'หนองไร่',
        name: {
          th: 'หนองไร่',
          en: 'Nong Rai',
        },
        districtId: 156,
      },
      {
        id: '210701',
        zipcode: 21110,
        text: 'น้ำเป็น',
        value: 'น้ำเป็น',
        name: {
          th: 'น้ำเป็น',
          en: 'Nam Pen',
        },
        districtId: 157,
      },
      {
        id: '210702',
        zipcode: 21110,
        text: 'ห้วยทับมอญ',
        value: 'ห้วยทับมอญ',
        name: {
          th: 'ห้วยทับมอญ',
          en: 'Huai Thap Mon',
        },
        districtId: 157,
      },
      {
        id: '210703',
        zipcode: 21110,
        text: 'ชำฆ้อ',
        value: 'ชำฆ้อ',
        name: {
          th: 'ชำฆ้อ',
          en: 'Cham Kho',
        },
        districtId: 157,
      },
      {
        id: '210704',
        zipcode: 21110,
        text: 'เขาน้อย',
        value: 'เขาน้อย',
        name: {
          th: 'เขาน้อย',
          en: 'Khao Noy',
        },
        districtId: 157,
      },
      {
        id: '210801',
        zipcode: 21180,
        text: 'นิคมพัฒนา',
        value: 'นิคมพัฒนา',
        name: {
          th: 'นิคมพัฒนา',
          en: 'Nikhom Phatthana',
        },
        districtId: 158,
      },
      {
        id: '210802',
        zipcode: 21180,
        text: 'มาบข่า',
        value: 'มาบข่า',
        name: {
          th: 'มาบข่า',
          en: 'Map Kha',
        },
        districtId: 158,
      },
      {
        id: '210803',
        zipcode: 21180,
        text: 'พนานิคม',
        value: 'พนานิคม',
        name: {
          th: 'พนานิคม',
          en: 'Phana Nikhom',
        },
        districtId: 158,
      },
      {
        id: '210804',
        zipcode: 21180,
        text: 'มะขามคู่',
        value: 'มะขามคู่',
        name: {
          th: 'มะขามคู่',
          en: 'Makham Khu',
        },
        districtId: 158,
      },
      {
        id: '220101',
        zipcode: 22000,
        text: 'ตลาด',
        value: 'ตลาด',
        name: {
          th: 'ตลาด',
          en: 'Talat',
        },
        districtId: 160,
      },
      {
        id: '220102',
        zipcode: 22000,
        text: 'วัดใหม่',
        value: 'วัดใหม่',
        name: {
          th: 'วัดใหม่',
          en: 'Wat Mai',
        },
        districtId: 160,
      },
      {
        id: '220103',
        zipcode: 22000,
        text: 'คลองนารายณ์',
        value: 'คลองนารายณ์',
        name: {
          th: 'คลองนารายณ์',
          en: 'Khlong Narai',
        },
        districtId: 160,
      },
      {
        id: '220104',
        zipcode: 22000,
        text: 'เกาะขวาง',
        value: 'เกาะขวาง',
        name: {
          th: 'เกาะขวาง',
          en: 'Ko Khwang',
        },
        districtId: 160,
      },
      {
        id: '220105',
        zipcode: 22000,
        text: 'คมบาง',
        value: 'คมบาง',
        name: {
          th: 'คมบาง',
          en: 'Khom Bang',
        },
        districtId: 160,
      },
      {
        id: '220106',
        zipcode: 22000,
        text: 'ท่าช้าง',
        value: 'ท่าช้าง',
        name: {
          th: 'ท่าช้าง',
          en: 'Tha Chang',
        },
        districtId: 160,
      },
      {
        id: '220107',
        zipcode: 22000,
        text: 'จันทนิมิต',
        value: 'จันทนิมิต',
        name: {
          th: 'จันทนิมิต',
          en: 'Chanthanimit',
        },
        districtId: 160,
      },
      {
        id: '220108',
        zipcode: 22000,
        text: 'บางกะจะ',
        value: 'บางกะจะ',
        name: {
          th: 'บางกะจะ',
          en: 'Bang Kacha',
        },
        districtId: 160,
      },
      {
        id: '220109',
        zipcode: 22000,
        text: 'แสลง',
        value: 'แสลง',
        name: {
          th: 'แสลง',
          en: 'Salaeng',
        },
        districtId: 160,
      },
      {
        id: '220110',
        zipcode: 22000,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 160,
      },
      {
        id: '220111',
        zipcode: 22000,
        text: 'พลับพลา',
        value: 'พลับพลา',
        name: {
          th: 'พลับพลา',
          en: 'Phlapphla',
        },
        districtId: 160,
      },
      {
        id: '220201',
        zipcode: 22110,
        text: 'ขลุง',
        value: 'ขลุง',
        name: {
          th: 'ขลุง',
          en: 'Khlung',
        },
        districtId: 161,
      },
      {
        id: '220202',
        zipcode: 22110,
        text: 'บ่อ',
        value: 'บ่อ',
        name: {
          th: 'บ่อ',
          en: 'Bo',
        },
        districtId: 161,
      },
      {
        id: '220203',
        zipcode: 22110,
        text: 'เกวียนหัก',
        value: 'เกวียนหัก',
        name: {
          th: 'เกวียนหัก',
          en: 'Kwian Hak',
        },
        districtId: 161,
      },
      {
        id: '220204',
        zipcode: 22110,
        text: 'ตะปอน',
        value: 'ตะปอน',
        name: {
          th: 'ตะปอน',
          en: 'Tapon',
        },
        districtId: 161,
      },
      {
        id: '220205',
        zipcode: 22110,
        text: 'บางชัน',
        value: 'บางชัน',
        name: {
          th: 'บางชัน',
          en: 'Bang Chan',
        },
        districtId: 161,
      },
      {
        id: '220206',
        zipcode: 22110,
        text: 'วันยาว',
        value: 'วันยาว',
        name: {
          th: 'วันยาว',
          en: 'Wan Yao',
        },
        districtId: 161,
      },
      {
        id: '220207',
        zipcode: 22110,
        text: 'ซึ้ง',
        value: 'ซึ้ง',
        name: {
          th: 'ซึ้ง',
          en: 'Sueng',
        },
        districtId: 161,
      },
      {
        id: '220208',
        zipcode: 22110,
        text: 'มาบไพ',
        value: 'มาบไพ',
        name: {
          th: 'มาบไพ',
          en: 'Map Phai',
        },
        districtId: 161,
      },
      {
        id: '220209',
        zipcode: 22110,
        text: 'วังสรรพรส',
        value: 'วังสรรพรส',
        name: {
          th: 'วังสรรพรส',
          en: 'Wang Sappharot',
        },
        districtId: 161,
      },
      {
        id: '220210',
        zipcode: 22110,
        text: 'ตรอกนอง',
        value: 'ตรอกนอง',
        name: {
          th: 'ตรอกนอง',
          en: 'Trok Nong',
        },
        districtId: 161,
      },
      {
        id: '220211',
        zipcode: 22110,
        text: 'ตกพรม',
        value: 'ตกพรม',
        name: {
          th: 'ตกพรม',
          en: 'Tok Phrom',
        },
        districtId: 161,
      },
      {
        id: '220212',
        zipcode: 22150,
        text: 'บ่อเวฬุ',
        value: 'บ่อเวฬุ',
        name: {
          th: 'บ่อเวฬุ',
          en: 'Bo Welu',
        },
        districtId: 161,
      },
      {
        id: '220301',
        zipcode: 22120,
        text: 'ท่าใหม่',
        value: 'ท่าใหม่',
        name: {
          th: 'ท่าใหม่',
          en: 'Tha Mai',
        },
        districtId: 162,
      },
      {
        id: '220302',
        zipcode: 22120,
        text: 'ยายร้า',
        value: 'ยายร้า',
        name: {
          th: 'ยายร้า',
          en: 'Yai Ra',
        },
        districtId: 162,
      },
      {
        id: '220303',
        zipcode: 22120,
        text: 'สีพยา',
        value: 'สีพยา',
        name: {
          th: 'สีพยา',
          en: 'Si Phaya',
        },
        districtId: 162,
      },
      {
        id: '220304',
        zipcode: 22120,
        text: 'บ่อพุ',
        value: 'บ่อพุ',
        name: {
          th: 'บ่อพุ',
          en: 'Bo Phu',
        },
        districtId: 162,
      },
      {
        id: '220305',
        zipcode: 22120,
        text: 'พลอยแหวน',
        value: 'พลอยแหวน',
        name: {
          th: 'พลอยแหวน',
          en: 'Phloi Waen',
        },
        districtId: 162,
      },
      {
        id: '220306',
        zipcode: 22120,
        text: 'เขาวัว',
        value: 'เขาวัว',
        name: {
          th: 'เขาวัว',
          en: 'Khao Wua',
        },
        districtId: 162,
      },
      {
        id: '220307',
        zipcode: 22120,
        text: 'เขาบายศรี',
        value: 'เขาบายศรี',
        name: {
          th: 'เขาบายศรี',
          en: 'Khao Baisi',
        },
        districtId: 162,
      },
      {
        id: '220308',
        zipcode: 22120,
        text: 'สองพี่น้อง',
        value: 'สองพี่น้อง',
        name: {
          th: 'สองพี่น้อง',
          en: 'Song Phi Nong',
        },
        districtId: 162,
      },
      {
        id: '220309',
        zipcode: 22170,
        text: 'ทุ่งเบญจา',
        value: 'ทุ่งเบญจา',
        name: {
          th: 'ทุ่งเบญจา',
          en: 'Ramphan',
        },
        districtId: 162,
      },
      {
        id: '220311',
        zipcode: 22170,
        text: 'รำพัน',
        value: 'รำพัน',
        name: {
          th: 'รำพัน',
          en: 'Ramphan',
        },
        districtId: 162,
      },
      {
        id: '220312',
        zipcode: 22170,
        text: 'โขมง',
        value: 'โขมง',
        name: {
          th: 'โขมง',
          en: 'Khamong',
        },
        districtId: 162,
      },
      {
        id: '220313',
        zipcode: 22120,
        text: 'ตะกาดเง้า',
        value: 'ตะกาดเง้า',
        name: {
          th: 'ตะกาดเง้า',
          en: 'Takat Ngao',
        },
        districtId: 162,
      },
      {
        id: '220314',
        zipcode: 22120,
        text: 'คลองขุด',
        value: 'คลองขุด',
        name: {
          th: 'คลองขุด',
          en: 'Khlong Khut',
        },
        districtId: 162,
      },
      {
        id: '220324',
        zipcode: 22170,
        text: 'เขาแก้ว',
        value: 'เขาแก้ว',
        name: {
          th: 'เขาแก้ว',
          en: 'Khao Kaeo',
        },
        districtId: 162,
      },
      {
        id: '220401',
        zipcode: 22140,
        text: 'ทับไทร',
        value: 'ทับไทร',
        name: {
          th: 'ทับไทร',
          en: 'Thap Sai',
        },
        districtId: 163,
      },
      {
        id: '220402',
        zipcode: 22140,
        text: 'โป่งน้ำร้อน',
        value: 'โป่งน้ำร้อน',
        name: {
          th: 'โป่งน้ำร้อน',
          en: 'Pong Nam Ron',
        },
        districtId: 163,
      },
      {
        id: '220404',
        zipcode: 22140,
        text: 'หนองตาคง',
        value: 'หนองตาคง',
        name: {
          th: 'หนองตาคง',
          en: 'Nong Ta Khong',
        },
        districtId: 163,
      },
      {
        id: '220409',
        zipcode: 22140,
        text: 'เทพนิมิต',
        value: 'เทพนิมิต',
        name: {
          th: 'เทพนิมิต',
          en: 'Thep Nimit',
        },
        districtId: 163,
      },
      {
        id: '220410',
        zipcode: 22140,
        text: 'คลองใหญ่',
        value: 'คลองใหญ่',
        name: {
          th: 'คลองใหญ่',
          en: 'Khlong Yai',
        },
        districtId: 163,
      },
      {
        id: '220501',
        zipcode: 22150,
        text: 'มะขาม',
        value: 'มะขาม',
        name: {
          th: 'มะขาม',
          en: 'Makham',
        },
        districtId: 164,
      },
      {
        id: '220502',
        zipcode: 22150,
        text: 'ท่าหลวง',
        value: 'ท่าหลวง',
        name: {
          th: 'ท่าหลวง',
          en: 'Tha Luang',
        },
        districtId: 164,
      },
      {
        id: '220503',
        zipcode: 22150,
        text: 'ปัถวี',
        value: 'ปัถวี',
        name: {
          th: 'ปัถวี',
          en: 'Patthawi',
        },
        districtId: 164,
      },
      {
        id: '220504',
        zipcode: 22150,
        text: 'วังแซ้ม',
        value: 'วังแซ้ม',
        name: {
          th: 'วังแซ้ม',
          en: 'Wang Saem',
        },
        districtId: 164,
      },
      {
        id: '220506',
        zipcode: 22150,
        text: 'ฉมัน',
        value: 'ฉมัน',
        name: {
          th: 'ฉมัน',
          en: 'Chaman',
        },
        districtId: 164,
      },
      {
        id: '220508',
        zipcode: 22150,
        text: 'อ่างคีรี',
        value: 'อ่างคีรี',
        name: {
          th: 'อ่างคีรี',
          en: 'Ang Khiri',
        },
        districtId: 164,
      },
      {
        id: '220601',
        zipcode: 22130,
        text: 'ปากน้ำแหลมสิงห์',
        value: 'ปากน้ำแหลมสิงห์',
        name: {
          th: 'ปากน้ำแหลมสิงห์',
          en: 'Pak Nam Laem Sing',
        },
        districtId: 165,
      },
      {
        id: '220602',
        zipcode: 22130,
        text: 'เกาะเปริด',
        value: 'เกาะเปริด',
        name: {
          th: 'เกาะเปริด',
          en: 'Ko Proet',
        },
        districtId: 165,
      },
      {
        id: '220603',
        zipcode: 22130,
        text: 'หนองชิ่ม',
        value: 'หนองชิ่ม',
        name: {
          th: 'หนองชิ่ม',
          en: 'Nong Chim',
        },
        districtId: 165,
      },
      {
        id: '220604',
        zipcode: 22190,
        text: 'พลิ้ว',
        value: 'พลิ้ว',
        name: {
          th: 'พลิ้ว',
          en: 'Phlio',
        },
        districtId: 165,
      },
      {
        id: '220605',
        zipcode: 22190,
        text: 'คลองน้ำเค็ม',
        value: 'คลองน้ำเค็ม',
        name: {
          th: 'คลองน้ำเค็ม',
          en: 'Khlong Nam Khem',
        },
        districtId: 165,
      },
      {
        id: '220606',
        zipcode: 22190,
        text: 'บางสระเก้า',
        value: 'บางสระเก้า',
        name: {
          th: 'บางสระเก้า',
          en: 'Bang Sa Kao',
        },
        districtId: 165,
      },
      {
        id: '220607',
        zipcode: 22120,
        text: 'บางกะไชย',
        value: 'บางกะไชย',
        name: {
          th: 'บางกะไชย',
          en: 'Bang Kachai',
        },
        districtId: 165,
      },
      {
        id: '220701',
        zipcode: 22180,
        text: 'ปะตง',
        value: 'ปะตง',
        name: {
          th: 'ปะตง',
          en: 'Patong',
        },
        districtId: 166,
      },
      {
        id: '220702',
        zipcode: 22180,
        text: 'ทุ่งขนาน',
        value: 'ทุ่งขนาน',
        name: {
          th: 'ทุ่งขนาน',
          en: 'Thung Khanan',
        },
        districtId: 166,
      },
      {
        id: '220703',
        zipcode: 22180,
        text: 'ทับช้าง',
        value: 'ทับช้าง',
        name: {
          th: 'ทับช้าง',
          en: 'Thap Chang',
        },
        districtId: 166,
      },
      {
        id: '220704',
        zipcode: 22180,
        text: 'ทรายขาว',
        value: 'ทรายขาว',
        name: {
          th: 'ทรายขาว',
          en: 'Sai Khao',
        },
        districtId: 166,
      },
      {
        id: '220705',
        zipcode: 22180,
        text: 'สะตอน',
        value: 'สะตอน',
        name: {
          th: 'สะตอน',
          en: 'Saton',
        },
        districtId: 166,
      },
      {
        id: '220801',
        zipcode: 22160,
        text: 'แก่งหางแมว',
        value: 'แก่งหางแมว',
        name: {
          th: 'แก่งหางแมว',
          en: 'Kaeng Hang Maeo',
        },
        districtId: 167,
      },
      {
        id: '220802',
        zipcode: 22160,
        text: 'ขุนซ่อง',
        value: 'ขุนซ่อง',
        name: {
          th: 'ขุนซ่อง',
          en: 'Khun Song',
        },
        districtId: 167,
      },
      {
        id: '220803',
        zipcode: 22160,
        text: 'สามพี่น้อง',
        value: 'สามพี่น้อง',
        name: {
          th: 'สามพี่น้อง',
          en: 'Sam Phi Nong',
        },
        districtId: 167,
      },
      {
        id: '220804',
        zipcode: 22160,
        text: 'พวา',
        value: 'พวา',
        name: {
          th: 'พวา',
          en: 'Phawa',
        },
        districtId: 167,
      },
      {
        id: '220805',
        zipcode: 22160,
        text: 'เขาวงกต',
        value: 'เขาวงกต',
        name: {
          th: 'เขาวงกต',
          en: 'Khao Wongkot',
        },
        districtId: 167,
      },
      {
        id: '220901',
        zipcode: 22160,
        text: 'นายายอาม',
        value: 'นายายอาม',
        name: {
          th: 'นายายอาม',
          en: 'Na Yai Am',
        },
        districtId: 168,
      },
      {
        id: '220902',
        zipcode: 22170,
        text: 'วังโตนด',
        value: 'วังโตนด',
        name: {
          th: 'วังโตนด',
          en: 'Wang Tanot',
        },
        districtId: 168,
      },
      {
        id: '220903',
        zipcode: 22170,
        text: 'กระแจะ',
        value: 'กระแจะ',
        name: {
          th: 'กระแจะ',
          en: 'Krachae',
        },
        districtId: 168,
      },
      {
        id: '220904',
        zipcode: 22170,
        text: 'สนามไชย',
        value: 'สนามไชย',
        name: {
          th: 'สนามไชย',
          en: 'Sanam Chai',
        },
        districtId: 168,
      },
      {
        id: '220905',
        zipcode: 22160,
        text: 'ช้างข้าม',
        value: 'ช้างข้าม',
        name: {
          th: 'ช้างข้าม',
          en: 'Chang Kham',
        },
        districtId: 168,
      },
      {
        id: '220906',
        zipcode: 22170,
        text: 'วังใหม่',
        value: 'วังใหม่',
        name: {
          th: 'วังใหม่',
          en: 'Wang Mai',
        },
        districtId: 168,
      },
      {
        id: '221001',
        zipcode: 22210,
        text: 'ชากไทย',
        value: 'ชากไทย',
        name: {
          th: 'ชากไทย',
          en: 'Chak Thai',
        },
        districtId: 169,
      },
      {
        id: '221002',
        zipcode: 22210,
        text: 'พลวง',
        value: 'พลวง',
        name: {
          th: 'พลวง',
          en: 'Phluang',
        },
        districtId: 169,
      },
      {
        id: '221003',
        zipcode: 22210,
        text: 'ตะเคียนทอง',
        value: 'ตะเคียนทอง',
        name: {
          th: 'ตะเคียนทอง',
          en: 'Takhian Thong',
        },
        districtId: 169,
      },
      {
        id: '221004',
        zipcode: 22210,
        text: 'คลองพลู',
        value: 'คลองพลู',
        name: {
          th: 'คลองพลู',
          en: 'Khlong Phlu',
        },
        districtId: 169,
      },
      {
        id: '221005',
        zipcode: 22210,
        text: 'จันทเขลม',
        value: 'จันทเขลม',
        name: {
          th: 'จันทเขลม',
          en: 'Chanthakhlem',
        },
        districtId: 169,
      },
      {
        id: '230101',
        zipcode: 23000,
        text: 'บางพระ',
        value: 'บางพระ',
        name: {
          th: 'บางพระ',
          en: 'Bang Phra',
        },
        districtId: 171,
      },
      {
        id: '230102',
        zipcode: 23000,
        text: 'หนองเสม็ด',
        value: 'หนองเสม็ด',
        name: {
          th: 'หนองเสม็ด',
          en: 'Nong Samet',
        },
        districtId: 171,
      },
      {
        id: '230103',
        zipcode: 23000,
        text: 'หนองโสน',
        value: 'หนองโสน',
        name: {
          th: 'หนองโสน',
          en: 'Nong Sano',
        },
        districtId: 171,
      },
      {
        id: '230104',
        zipcode: 23000,
        text: 'หนองคันทรง',
        value: 'หนองคันทรง',
        name: {
          th: 'หนองคันทรง',
          en: 'Nong Khan Song',
        },
        districtId: 171,
      },
      {
        id: '230105',
        zipcode: 23000,
        text: 'ห้วงน้ำขาว',
        value: 'ห้วงน้ำขาว',
        name: {
          th: 'ห้วงน้ำขาว',
          en: 'Huang Nam Khao',
        },
        districtId: 171,
      },
      {
        id: '230106',
        zipcode: 23000,
        text: 'อ่าวใหญ่',
        value: 'อ่าวใหญ่',
        name: {
          th: 'อ่าวใหญ่',
          en: 'Ao Yai',
        },
        districtId: 171,
      },
      {
        id: '230107',
        zipcode: 23000,
        text: 'วังกระแจะ',
        value: 'วังกระแจะ',
        name: {
          th: 'วังกระแจะ',
          en: 'Wang Krachae',
        },
        districtId: 171,
      },
      {
        id: '230108',
        zipcode: 23000,
        text: 'ห้วยแร้ง',
        value: 'ห้วยแร้ง',
        name: {
          th: 'ห้วยแร้ง',
          en: 'Huai Raeng',
        },
        districtId: 171,
      },
      {
        id: '230109',
        zipcode: 23000,
        text: 'เนินทราย',
        value: 'เนินทราย',
        name: {
          th: 'เนินทราย',
          en: 'Noen Sai',
        },
        districtId: 171,
      },
      {
        id: '230110',
        zipcode: 23000,
        text: 'ท่าพริก',
        value: 'ท่าพริก',
        name: {
          th: 'ท่าพริก',
          en: 'Tha Phrik',
        },
        districtId: 171,
      },
      {
        id: '230111',
        zipcode: 23000,
        text: 'ท่ากุ่ม',
        value: 'ท่ากุ่ม',
        name: {
          th: 'ท่ากุ่ม',
          en: 'Tha Kum',
        },
        districtId: 171,
      },
      {
        id: '230112',
        zipcode: 23000,
        text: 'ตะกาง',
        value: 'ตะกาง',
        name: {
          th: 'ตะกาง',
          en: 'Takang',
        },
        districtId: 171,
      },
      {
        id: '230113',
        zipcode: 23000,
        text: 'ชำราก',
        value: 'ชำราก',
        name: {
          th: 'ชำราก',
          en: 'Chamrak',
        },
        districtId: 171,
      },
      {
        id: '230114',
        zipcode: 23000,
        text: 'แหลมกลัด',
        value: 'แหลมกลัด',
        name: {
          th: 'แหลมกลัด',
          en: 'Laem Klat',
        },
        districtId: 171,
      },
      {
        id: '230201',
        zipcode: 23110,
        text: 'คลองใหญ่',
        value: 'คลองใหญ่',
        name: {
          th: 'คลองใหญ่',
          en: 'Khlong Yai',
        },
        districtId: 172,
      },
      {
        id: '230202',
        zipcode: 23110,
        text: 'ไม้รูด',
        value: 'ไม้รูด',
        name: {
          th: 'ไม้รูด',
          en: 'Mai Rut',
        },
        districtId: 172,
      },
      {
        id: '230203',
        zipcode: 23110,
        text: 'หาดเล็ก',
        value: 'หาดเล็ก',
        name: {
          th: 'หาดเล็ก',
          en: 'Hat Lek',
        },
        districtId: 172,
      },
      {
        id: '230301',
        zipcode: 23130,
        text: 'เขาสมิง',
        value: 'เขาสมิง',
        name: {
          th: 'เขาสมิง',
          en: 'Khao Saming',
        },
        districtId: 173,
      },
      {
        id: '230302',
        zipcode: 23150,
        text: 'แสนตุ้ง',
        value: 'แสนตุ้ง',
        name: {
          th: 'แสนตุ้ง',
          en: 'Saen Tung',
        },
        districtId: 173,
      },
      {
        id: '230303',
        zipcode: 23130,
        text: 'วังตะเคียน',
        value: 'วังตะเคียน',
        name: {
          th: 'วังตะเคียน',
          en: 'Wang Takhian',
        },
        districtId: 173,
      },
      {
        id: '230304',
        zipcode: 23150,
        text: 'ท่าโสม',
        value: 'ท่าโสม',
        name: {
          th: 'ท่าโสม',
          en: 'Tha Som',
        },
        districtId: 173,
      },
      {
        id: '230305',
        zipcode: 23150,
        text: 'สะตอ',
        value: 'สะตอ',
        name: {
          th: 'สะตอ',
          en: 'Sato',
        },
        districtId: 173,
      },
      {
        id: '230306',
        zipcode: 23150,
        text: 'ประณีต',
        value: 'ประณีต',
        name: {
          th: 'ประณีต',
          en: 'Pranit',
        },
        districtId: 173,
      },
      {
        id: '230307',
        zipcode: 23150,
        text: 'เทพนิมิต',
        value: 'เทพนิมิต',
        name: {
          th: 'เทพนิมิต',
          en: 'Thep Nimit',
        },
        districtId: 173,
      },
      {
        id: '230308',
        zipcode: 23130,
        text: 'ทุ่งนนทรี',
        value: 'ทุ่งนนทรี',
        name: {
          th: 'ทุ่งนนทรี',
          en: 'Thung Nonsi',
        },
        districtId: 173,
      },
      {
        id: '230401',
        zipcode: 23140,
        text: 'บ่อพลอย',
        value: 'บ่อพลอย',
        name: {
          th: 'บ่อพลอย',
          en: 'Bo Phloi',
        },
        districtId: 174,
      },
      {
        id: '230402',
        zipcode: 23140,
        text: 'ช้างทูน',
        value: 'ช้างทูน',
        name: {
          th: 'ช้างทูน',
          en: 'Chang Thun',
        },
        districtId: 174,
      },
      {
        id: '230403',
        zipcode: 23140,
        text: 'ด่านชุมพล',
        value: 'ด่านชุมพล',
        name: {
          th: 'ด่านชุมพล',
          en: 'Dan Chumphon',
        },
        districtId: 174,
      },
      {
        id: '230404',
        zipcode: 23140,
        text: 'หนองบอน',
        value: 'หนองบอน',
        name: {
          th: 'หนองบอน',
          en: 'Nong Bon',
        },
        districtId: 174,
      },
      {
        id: '230405',
        zipcode: 23140,
        text: 'นนทรีย์',
        value: 'นนทรีย์',
        name: {
          th: 'นนทรีย์',
          en: 'Nonsi',
        },
        districtId: 174,
      },
      {
        id: '230501',
        zipcode: 23120,
        text: 'แหลมงอบ',
        value: 'แหลมงอบ',
        name: {
          th: 'แหลมงอบ',
          en: 'Laem Ngop',
        },
        districtId: 175,
      },
      {
        id: '230502',
        zipcode: 23120,
        text: 'น้ำเชี่ยว',
        value: 'น้ำเชี่ยว',
        name: {
          th: 'น้ำเชี่ยว',
          en: 'Nam Chiao',
        },
        districtId: 175,
      },
      {
        id: '230503',
        zipcode: 23120,
        text: 'บางปิด',
        value: 'บางปิด',
        name: {
          th: 'บางปิด',
          en: 'Bang Pit',
        },
        districtId: 175,
      },
      {
        id: '230507',
        zipcode: 23120,
        text: 'คลองใหญ่',
        value: 'คลองใหญ่',
        name: {
          th: 'คลองใหญ่',
          en: 'Khlong Yai',
        },
        districtId: 175,
      },
      {
        id: '230601',
        zipcode: 23000,
        text: 'เกาะหมาก',
        value: 'เกาะหมาก',
        name: {
          th: 'เกาะหมาก',
          en: 'Ko Mak',
        },
        districtId: 176,
      },
      {
        id: '230602',
        zipcode: 23000,
        text: 'เกาะกูด',
        value: 'เกาะกูด',
        name: {
          th: 'เกาะกูด',
          en: 'Ko Kut',
        },
        districtId: 176,
      },
      {
        id: '230701',
        zipcode: 23170,
        text: 'เกาะช้าง',
        value: 'เกาะช้าง',
        name: {
          th: 'เกาะช้าง',
          en: 'Ko Chang',
        },
        districtId: 177,
      },
      {
        id: '230702',
        zipcode: 23170,
        text: 'เกาะช้างใต้',
        value: 'เกาะช้างใต้',
        name: {
          th: 'เกาะช้างใต้',
          en: 'Ko Chang Tai',
        },
        districtId: 177,
      },
      {
        id: '240101',
        zipcode: 24000,
        text: 'หน้าเมือง',
        value: 'หน้าเมือง',
        name: {
          th: 'หน้าเมือง',
          en: 'Na Mueang',
        },
        districtId: 178,
      },
      {
        id: '240102',
        zipcode: 24000,
        text: 'ท่าไข่',
        value: 'ท่าไข่',
        name: {
          th: 'ท่าไข่',
          en: 'Tha Khai',
        },
        districtId: 178,
      },
      {
        id: '240103',
        zipcode: 24000,
        text: 'บ้านใหม่',
        value: 'บ้านใหม่',
        name: {
          th: 'บ้านใหม่',
          en: 'Ban Mai',
        },
        districtId: 178,
      },
      {
        id: '240104',
        zipcode: 24000,
        text: 'คลองนา',
        value: 'คลองนา',
        name: {
          th: 'คลองนา',
          en: 'Khlong Na',
        },
        districtId: 178,
      },
      {
        id: '240105',
        zipcode: 24000,
        text: 'บางตีนเป็ด',
        value: 'บางตีนเป็ด',
        name: {
          th: 'บางตีนเป็ด',
          en: 'Khlong Na',
        },
        districtId: 178,
      },
      {
        id: '240106',
        zipcode: 24000,
        text: 'บางไผ่',
        value: 'บางไผ่',
        name: {
          th: 'บางไผ่',
          en: 'Bang Phai',
        },
        districtId: 178,
      },
      {
        id: '240107',
        zipcode: 24000,
        text: 'คลองจุกกระเฌอ',
        value: 'คลองจุกกระเฌอ',
        name: {
          th: 'คลองจุกกระเฌอ',
          en: 'Khlong Chuk Krachoe',
        },
        districtId: 178,
      },
      {
        id: '240108',
        zipcode: 24000,
        text: 'บางแก้ว',
        value: 'บางแก้ว',
        name: {
          th: 'บางแก้ว',
          en: 'Bang Kaeo',
        },
        districtId: 178,
      },
      {
        id: '240109',
        zipcode: 24000,
        text: 'บางขวัญ',
        value: 'บางขวัญ',
        name: {
          th: 'บางขวัญ',
          en: 'Bang Khwan',
        },
        districtId: 178,
      },
      {
        id: '240110',
        zipcode: 24000,
        text: 'คลองนครเนื่องเขต',
        value: 'คลองนครเนื่องเขต',
        name: {
          th: 'คลองนครเนื่องเขต',
          en: 'Khlong Nakhon Nueang Khet',
        },
        districtId: 178,
      },
      {
        id: '240111',
        zipcode: 24000,
        text: 'วังตะเคียน',
        value: 'วังตะเคียน',
        name: {
          th: 'วังตะเคียน',
          en: 'Wang Takhian',
        },
        districtId: 178,
      },
      {
        id: '240112',
        zipcode: 24000,
        text: 'โสธร',
        value: 'โสธร',
        name: {
          th: 'โสธร',
          en: 'Sothon',
        },
        districtId: 178,
      },
      {
        id: '240113',
        zipcode: 24000,
        text: 'บางพระ',
        value: 'บางพระ',
        name: {
          th: 'บางพระ',
          en: 'Bang Phra',
        },
        districtId: 178,
      },
      {
        id: '240114',
        zipcode: 24000,
        text: 'บางกะไห',
        value: 'บางกะไห',
        name: {
          th: 'บางกะไห',
          en: 'Bang Kahai',
        },
        districtId: 178,
      },
      {
        id: '240115',
        zipcode: 24000,
        text: 'หนามแดง',
        value: 'หนามแดง',
        name: {
          th: 'หนามแดง',
          en: 'Nam Daeng',
        },
        districtId: 178,
      },
      {
        id: '240116',
        zipcode: 24000,
        text: 'คลองเปรง',
        value: 'คลองเปรง',
        name: {
          th: 'คลองเปรง',
          en: 'Khlong Preng',
        },
        districtId: 178,
      },
      {
        id: '240117',
        zipcode: 24000,
        text: 'คลองอุดมชลจร',
        value: 'คลองอุดมชลจร',
        name: {
          th: 'คลองอุดมชลจร',
          en: 'Khlong Udom Chonlachon',
        },
        districtId: 178,
      },
      {
        id: '240118',
        zipcode: 24000,
        text: 'คลองหลวงแพ่ง',
        value: 'คลองหลวงแพ่ง',
        name: {
          th: 'คลองหลวงแพ่ง',
          en: 'Khlong Luang Phaeng',
        },
        districtId: 178,
      },
      {
        id: '240119',
        zipcode: 24000,
        text: 'บางเตย',
        value: 'บางเตย',
        name: {
          th: 'บางเตย',
          en: 'Bang Toei',
        },
        districtId: 178,
      },
      {
        id: '240201',
        zipcode: 24110,
        text: 'บางคล้า',
        value: 'บางคล้า',
        name: {
          th: 'บางคล้า',
          en: 'Bang Khla',
        },
        districtId: 179,
      },
      {
        id: '240204',
        zipcode: 24110,
        text: 'บางสวน',
        value: 'บางสวน',
        name: {
          th: 'บางสวน',
          en: 'Bang Suan',
        },
        districtId: 179,
      },
      {
        id: '240208',
        zipcode: 24110,
        text: 'บางกระเจ็ด',
        value: 'บางกระเจ็ด',
        name: {
          th: 'บางกระเจ็ด',
          en: 'Bang Krachet',
        },
        districtId: 179,
      },
      {
        id: '240209',
        zipcode: 24110,
        text: 'ปากน้ำ',
        value: 'ปากน้ำ',
        name: {
          th: 'ปากน้ำ',
          en: 'Pak Nam',
        },
        districtId: 179,
      },
      {
        id: '240210',
        zipcode: 24110,
        text: 'ท่าทองหลาง',
        value: 'ท่าทองหลาง',
        name: {
          th: 'ท่าทองหลาง',
          en: 'Tha Thonglang',
        },
        districtId: 179,
      },
      {
        id: '240211',
        zipcode: 24110,
        text: 'สาวชะโงก',
        value: 'สาวชะโงก',
        name: {
          th: 'สาวชะโงก',
          en: 'Sao Cha-ngok',
        },
        districtId: 179,
      },
      {
        id: '240212',
        zipcode: 24110,
        text: 'เสม็ดเหนือ',
        value: 'เสม็ดเหนือ',
        name: {
          th: 'เสม็ดเหนือ',
          en: 'Samet Nuea',
        },
        districtId: 179,
      },
      {
        id: '240213',
        zipcode: 24110,
        text: 'เสม็ดใต้',
        value: 'เสม็ดใต้',
        name: {
          th: 'เสม็ดใต้',
          en: 'Samet Tai',
        },
        districtId: 179,
      },
      {
        id: '240214',
        zipcode: 24110,
        text: 'หัวไทร',
        value: 'หัวไทร',
        name: {
          th: 'หัวไทร',
          en: 'Hua Sai',
        },
        districtId: 179,
      },
      {
        id: '240301',
        zipcode: 24150,
        text: 'บางน้ำเปรี้ยว',
        value: 'บางน้ำเปรี้ยว',
        name: {
          th: 'บางน้ำเปรี้ยว',
          en: 'Bang Nam Priao',
        },
        districtId: 180,
      },
      {
        id: '240302',
        zipcode: 24150,
        text: 'บางขนาก',
        value: 'บางขนาก',
        name: {
          th: 'บางขนาก',
          en: 'Bang Khanak',
        },
        districtId: 180,
      },
      {
        id: '240303',
        zipcode: 24150,
        text: 'สิงโตทอง',
        value: 'สิงโตทอง',
        name: {
          th: 'สิงโตทอง',
          en: 'Singto Thong',
        },
        districtId: 180,
      },
      {
        id: '240304',
        zipcode: 24150,
        text: 'หมอนทอง',
        value: 'หมอนทอง',
        name: {
          th: 'หมอนทอง',
          en: 'Mon Thong',
        },
        districtId: 180,
      },
      {
        id: '240305',
        zipcode: 24170,
        text: 'บึงน้ำรักษ์',
        value: 'บึงน้ำรักษ์',
        name: {
          th: 'บึงน้ำรักษ์',
          en: 'Bueng Nam Rak',
        },
        districtId: 180,
      },
      {
        id: '240306',
        zipcode: 24170,
        text: 'ดอนเกาะกา',
        value: 'ดอนเกาะกา',
        name: {
          th: 'ดอนเกาะกา',
          en: 'Don Ko Ka',
        },
        districtId: 180,
      },
      {
        id: '240307',
        zipcode: 24150,
        text: 'โยธะกา',
        value: 'โยธะกา',
        name: {
          th: 'โยธะกา',
          en: 'Yothaka',
        },
        districtId: 180,
      },
      {
        id: '240308',
        zipcode: 24170,
        text: 'ดอนฉิมพลี',
        value: 'ดอนฉิมพลี',
        name: {
          th: 'ดอนฉิมพลี',
          en: 'Don Chimphli',
        },
        districtId: 180,
      },
      {
        id: '240309',
        zipcode: 24000,
        text: 'ศาลาแดง',
        value: 'ศาลาแดง',
        name: {
          th: 'ศาลาแดง',
          en: 'Sala Daeng',
        },
        districtId: 180,
      },
      {
        id: '240310',
        zipcode: 24150,
        text: 'โพรงอากาศ',
        value: 'โพรงอากาศ',
        name: {
          th: 'โพรงอากาศ',
          en: 'Phrong Akat',
        },
        districtId: 180,
      },
      {
        id: '240401',
        zipcode: 24130,
        text: 'บางปะกง',
        value: 'บางปะกง',
        name: {
          th: 'บางปะกง',
          en: 'Bang Pakong',
        },
        districtId: 181,
      },
      {
        id: '240402',
        zipcode: 24130,
        text: 'ท่าสะอ้าน',
        value: 'ท่าสะอ้าน',
        name: {
          th: 'ท่าสะอ้าน',
          en: 'Tha Sa-an',
        },
        districtId: 181,
      },
      {
        id: '240403',
        zipcode: 24180,
        text: 'บางวัว',
        value: 'บางวัว',
        name: {
          th: 'บางวัว',
          en: 'Bang Wua',
        },
        districtId: 181,
      },
      {
        id: '240404',
        zipcode: 24180,
        text: 'บางสมัคร',
        value: 'บางสมัคร',
        name: {
          th: 'บางสมัคร',
          en: 'Bang Samak',
        },
        districtId: 181,
      },
      {
        id: '240405',
        zipcode: 24130,
        text: 'บางผึ้ง',
        value: 'บางผึ้ง',
        name: {
          th: 'บางผึ้ง',
          en: 'Bang Phueng',
        },
        districtId: 181,
      },
      {
        id: '240406',
        zipcode: 24180,
        text: 'บางเกลือ',
        value: 'บางเกลือ',
        name: {
          th: 'บางเกลือ',
          en: 'Bang Kluea',
        },
        districtId: 181,
      },
      {
        id: '240407',
        zipcode: 24130,
        text: 'สองคลอง',
        value: 'สองคลอง',
        name: {
          th: 'สองคลอง',
          en: 'Song Khlong',
        },
        districtId: 181,
      },
      {
        id: '240408',
        zipcode: 24130,
        text: 'หนองจอก',
        value: 'หนองจอก',
        name: {
          th: 'หนองจอก',
          en: 'Nong Chok',
        },
        districtId: 181,
      },
      {
        id: '240409',
        zipcode: 24130,
        text: 'พิมพา',
        value: 'พิมพา',
        name: {
          th: 'พิมพา',
          en: 'Phimpha',
        },
        districtId: 181,
      },
      {
        id: '240410',
        zipcode: 24130,
        text: 'ท่าข้าม',
        value: 'ท่าข้าม',
        name: {
          th: 'ท่าข้าม',
          en: 'Tha Kham',
        },
        districtId: 181,
      },
      {
        id: '240411',
        zipcode: 24180,
        text: 'หอมศีล',
        value: 'หอมศีล',
        name: {
          th: 'หอมศีล',
          en: 'Hom Sin',
        },
        districtId: 181,
      },
      {
        id: '240412',
        zipcode: 24130,
        text: 'เขาดิน',
        value: 'เขาดิน',
        name: {
          th: 'เขาดิน',
          en: 'Khao Din',
        },
        districtId: 181,
      },
      {
        id: '240501',
        zipcode: 24140,
        text: 'บ้านโพธิ์',
        value: 'บ้านโพธิ์',
        name: {
          th: 'บ้านโพธิ์',
          en: 'Ban Pho',
        },
        districtId: 182,
      },
      {
        id: '240502',
        zipcode: 24140,
        text: 'เกาะไร่',
        value: 'เกาะไร่',
        name: {
          th: 'เกาะไร่',
          en: 'Ko Rai',
        },
        districtId: 182,
      },
      {
        id: '240503',
        zipcode: 24140,
        text: 'คลองขุด',
        value: 'คลองขุด',
        name: {
          th: 'คลองขุด',
          en: 'Khlong Khut',
        },
        districtId: 182,
      },
      {
        id: '240504',
        zipcode: 24140,
        text: 'คลองบ้านโพธิ์',
        value: 'คลองบ้านโพธิ์',
        name: {
          th: 'คลองบ้านโพธิ์',
          en: 'Khlong Ban Pho',
        },
        districtId: 182,
      },
      {
        id: '240505',
        zipcode: 24140,
        text: 'คลองประเวศ',
        value: 'คลองประเวศ',
        name: {
          th: 'คลองประเวศ',
          en: 'Khlong Prawet',
        },
        districtId: 182,
      },
      {
        id: '240506',
        zipcode: 24140,
        text: 'ดอนทราย',
        value: 'ดอนทราย',
        name: {
          th: 'ดอนทราย',
          en: 'Don Sai',
        },
        districtId: 182,
      },
      {
        id: '240507',
        zipcode: 24140,
        text: 'เทพราช',
        value: 'เทพราช',
        name: {
          th: 'เทพราช',
          en: 'Theppharat',
        },
        districtId: 182,
      },
      {
        id: '240508',
        zipcode: 24140,
        text: 'ท่าพลับ',
        value: 'ท่าพลับ',
        name: {
          th: 'ท่าพลับ',
          en: 'Tha Phlap',
        },
        districtId: 182,
      },
      {
        id: '240509',
        zipcode: 24140,
        text: 'หนองตีนนก',
        value: 'หนองตีนนก',
        name: {
          th: 'หนองตีนนก',
          en: 'Nong Tin Nok',
        },
        districtId: 182,
      },
      {
        id: '240510',
        zipcode: 24140,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 182,
      },
      {
        id: '240511',
        zipcode: 24140,
        text: 'บางซ่อน',
        value: 'บางซ่อน',
        name: {
          th: 'บางซ่อน',
          en: 'Bang Son',
        },
        districtId: 182,
      },
      {
        id: '240512',
        zipcode: 24140,
        text: 'บางกรูด',
        value: 'บางกรูด',
        name: {
          th: 'บางกรูด',
          en: 'Bang Krut',
        },
        districtId: 182,
      },
      {
        id: '240513',
        zipcode: 24140,
        text: 'แหลมประดู่',
        value: 'แหลมประดู่',
        name: {
          th: 'แหลมประดู่',
          en: 'Laem Pradu',
        },
        districtId: 182,
      },
      {
        id: '240514',
        zipcode: 24140,
        text: 'ลาดขวาง',
        value: 'ลาดขวาง',
        name: {
          th: 'ลาดขวาง',
          en: 'Lat Khwang',
        },
        districtId: 182,
      },
      {
        id: '240515',
        zipcode: 24140,
        text: 'สนามจันทร์',
        value: 'สนามจันทร์',
        name: {
          th: 'สนามจันทร์',
          en: 'Sanam Chan',
        },
        districtId: 182,
      },
      {
        id: '240516',
        zipcode: 24140,
        text: 'แสนภูดาษ',
        value: 'แสนภูดาษ',
        name: {
          th: 'แสนภูดาษ',
          en: 'Saen Phu Dat',
        },
        districtId: 182,
      },
      {
        id: '240517',
        zipcode: 24140,
        text: 'สิบเอ็ดศอก',
        value: 'สิบเอ็ดศอก',
        name: {
          th: 'สิบเอ็ดศอก',
          en: 'Sip Et Sok',
        },
        districtId: 182,
      },
      {
        id: '240601',
        zipcode: 24120,
        text: 'เกาะขนุน',
        value: 'เกาะขนุน',
        name: {
          th: 'เกาะขนุน',
          en: 'Ko Khanun',
        },
        districtId: 183,
      },
      {
        id: '240602',
        zipcode: 24120,
        text: 'บ้านซ่อง',
        value: 'บ้านซ่อง',
        name: {
          th: 'บ้านซ่อง',
          en: 'Ban Song',
        },
        districtId: 183,
      },
      {
        id: '240603',
        zipcode: 24120,
        text: 'พนมสารคาม',
        value: 'พนมสารคาม',
        name: {
          th: 'พนมสารคาม',
          en: 'Phanom Sarakham',
        },
        districtId: 183,
      },
      {
        id: '240604',
        zipcode: 24120,
        text: 'เมืองเก่า',
        value: 'เมืองเก่า',
        name: {
          th: 'เมืองเก่า',
          en: 'Mueang Kao',
        },
        districtId: 183,
      },
      {
        id: '240605',
        zipcode: 24120,
        text: 'หนองยาว',
        value: 'หนองยาว',
        name: {
          th: 'หนองยาว',
          en: 'Nong Yao',
        },
        districtId: 183,
      },
      {
        id: '240606',
        zipcode: 24120,
        text: 'ท่าถ่าน',
        value: 'ท่าถ่าน',
        name: {
          th: 'ท่าถ่าน',
          en: 'Tha Than',
        },
        districtId: 183,
      },
      {
        id: '240607',
        zipcode: 24120,
        text: 'หนองแหน',
        value: 'หนองแหน',
        name: {
          th: 'หนองแหน',
          en: 'Nong Nae',
        },
        districtId: 183,
      },
      {
        id: '240608',
        zipcode: 24120,
        text: 'เขาหินซ้อน',
        value: 'เขาหินซ้อน',
        name: {
          th: 'เขาหินซ้อน',
          en: 'Khao Hin Son',
        },
        districtId: 183,
      },
      {
        id: '240701',
        zipcode: 24120,
        text: 'บางคา',
        value: 'บางคา',
        name: {
          th: 'บางคา',
          en: 'Bang Kha',
        },
        districtId: 184,
      },
      {
        id: '240702',
        zipcode: 24120,
        text: 'เมืองใหม่',
        value: 'เมืองใหม่',
        name: {
          th: 'เมืองใหม่',
          en: 'Mueang Mai',
        },
        districtId: 184,
      },
      {
        id: '240703',
        zipcode: 24120,
        text: 'ดงน้อย',
        value: 'ดงน้อย',
        name: {
          th: 'ดงน้อย',
          en: 'Dong Noi',
        },
        districtId: 184,
      },
      {
        id: '240801',
        zipcode: 24160,
        text: 'คู้ยายหมี',
        value: 'คู้ยายหมี',
        name: {
          th: 'คู้ยายหมี',
          en: 'Khu Yai Mi',
        },
        districtId: 185,
      },
      {
        id: '240802',
        zipcode: 24160,
        text: 'ท่ากระดาน',
        value: 'ท่ากระดาน',
        name: {
          th: 'ท่ากระดาน',
          en: 'Tha Kradan',
        },
        districtId: 185,
      },
      {
        id: '240803',
        zipcode: 24160,
        text: 'ทุ่งพระยา',
        value: 'ทุ่งพระยา',
        name: {
          th: 'ทุ่งพระยา',
          en: 'Thung Phraya',
        },
        districtId: 185,
      },
      {
        id: '240805',
        zipcode: 24160,
        text: 'ลาดกระทิง',
        value: 'ลาดกระทิง',
        name: {
          th: 'ลาดกระทิง',
          en: 'Lat Krathing',
        },
        districtId: 185,
      },
      {
        id: '240901',
        zipcode: 24190,
        text: 'แปลงยาว',
        value: 'แปลงยาว',
        name: {
          th: 'แปลงยาว',
          en: 'Plaeng Yao',
        },
        districtId: 186,
      },
      {
        id: '240902',
        zipcode: 24190,
        text: 'วังเย็น',
        value: 'วังเย็น',
        name: {
          th: 'วังเย็น',
          en: 'Wang Yen',
        },
        districtId: 186,
      },
      {
        id: '240903',
        zipcode: 24190,
        text: 'หัวสำโรง',
        value: 'หัวสำโรง',
        name: {
          th: 'หัวสำโรง',
          en: 'Hua Samrong',
        },
        districtId: 186,
      },
      {
        id: '240904',
        zipcode: 24190,
        text: 'หนองไม้แก่น',
        value: 'หนองไม้แก่น',
        name: {
          th: 'หนองไม้แก่น',
          en: 'Nong Mai Kaen',
        },
        districtId: 186,
      },
      {
        id: '241001',
        zipcode: 24160,
        text: 'ท่าตะเกียบ',
        value: 'ท่าตะเกียบ',
        name: {
          th: 'ท่าตะเกียบ',
          en: 'Tha Takiap',
        },
        districtId: 187,
      },
      {
        id: '241002',
        zipcode: 24160,
        text: 'คลองตะเกรา',
        value: 'คลองตะเกรา',
        name: {
          th: 'คลองตะเกรา',
          en: 'Khlong Takrao',
        },
        districtId: 187,
      },
      {
        id: '241101',
        zipcode: 24000,
        text: 'ก้อนแก้ว',
        value: 'ก้อนแก้ว',
        name: {
          th: 'ก้อนแก้ว',
          en: 'Kon Kaeo',
        },
        districtId: 188,
      },
      {
        id: '241102',
        zipcode: 24000,
        text: 'คลองเขื่อน',
        value: 'คลองเขื่อน',
        name: {
          th: 'คลองเขื่อน',
          en: 'Khlong Khuean',
        },
        districtId: 188,
      },
      {
        id: '241103',
        zipcode: 24000,
        text: 'บางเล่า',
        value: 'บางเล่า',
        name: {
          th: 'บางเล่า',
          en: 'Bang Lao',
        },
        districtId: 188,
      },
      {
        id: '241104',
        zipcode: 24000,
        text: 'บางโรง',
        value: 'บางโรง',
        name: {
          th: 'บางโรง',
          en: 'Bang Rong',
        },
        districtId: 188,
      },
      {
        id: '241105',
        zipcode: 24110,
        text: 'บางตลาด',
        value: 'บางตลาด',
        name: {
          th: 'บางตลาด',
          en: 'Bang Talat',
        },
        districtId: 188,
      },
      {
        id: '250101',
        zipcode: 25000,
        text: 'หน้าเมือง',
        value: 'หน้าเมือง',
        name: {
          th: 'หน้าเมือง',
          en: 'Na Mueang',
        },
        districtId: 189,
      },
      {
        id: '250102',
        zipcode: 25000,
        text: 'รอบเมือง',
        value: 'รอบเมือง',
        name: {
          th: 'รอบเมือง',
          en: 'Na Mueang',
        },
        districtId: 189,
      },
      {
        id: '250103',
        zipcode: 25000,
        text: 'วัดโบสถ์',
        value: 'วัดโบสถ์',
        name: {
          th: 'วัดโบสถ์',
          en: 'Wat Bot',
        },
        districtId: 189,
      },
      {
        id: '250104',
        zipcode: 25000,
        text: 'บางเดชะ',
        value: 'บางเดชะ',
        name: {
          th: 'บางเดชะ',
          en: 'Bang Decha',
        },
        districtId: 189,
      },
      {
        id: '250105',
        zipcode: 25000,
        text: 'ท่างาม',
        value: 'ท่างาม',
        name: {
          th: 'ท่างาม',
          en: 'Tha Ngam',
        },
        districtId: 189,
      },
      {
        id: '250106',
        zipcode: 25000,
        text: 'บางบริบูรณ์',
        value: 'บางบริบูรณ์',
        name: {
          th: 'บางบริบูรณ์',
          en: 'Bang Boribun',
        },
        districtId: 189,
      },
      {
        id: '250107',
        zipcode: 25000,
        text: 'ดงพระราม',
        value: 'ดงพระราม',
        name: {
          th: 'ดงพระราม',
          en: 'Dong Phra Ram',
        },
        districtId: 189,
      },
      {
        id: '250108',
        zipcode: 25230,
        text: 'บ้านพระ',
        value: 'บ้านพระ',
        name: {
          th: 'บ้านพระ',
          en: 'Ban Phra',
        },
        districtId: 189,
      },
      {
        id: '250109',
        zipcode: 25230,
        text: 'โคกไม้ลาย',
        value: 'โคกไม้ลาย',
        name: {
          th: 'โคกไม้ลาย',
          en: 'Khok Mai Lai',
        },
        districtId: 189,
      },
      {
        id: '250110',
        zipcode: 25230,
        text: 'ไม้เค็ด',
        value: 'ไม้เค็ด',
        name: {
          th: 'ไม้เค็ด',
          en: 'Mai Khet',
        },
        districtId: 189,
      },
      {
        id: '250111',
        zipcode: 25000,
        text: 'ดงขี้เหล็ก',
        value: 'ดงขี้เหล็ก',
        name: {
          th: 'ดงขี้เหล็ก',
          en: 'Dong Khilek',
        },
        districtId: 189,
      },
      {
        id: '250112',
        zipcode: 25230,
        text: 'เนินหอม',
        value: 'เนินหอม',
        name: {
          th: 'เนินหอม',
          en: 'Noen Hom',
        },
        districtId: 189,
      },
      {
        id: '250113',
        zipcode: 25000,
        text: 'โนนห้อม',
        value: 'โนนห้อม',
        name: {
          th: 'โนนห้อม',
          en: 'Non Hom',
        },
        districtId: 189,
      },
      {
        id: '250201',
        zipcode: 25110,
        text: 'กบินทร์',
        value: 'กบินทร์',
        name: {
          th: 'กบินทร์',
          en: 'Kabin',
        },
        districtId: 190,
      },
      {
        id: '250202',
        zipcode: 25240,
        text: 'เมืองเก่า',
        value: 'เมืองเก่า',
        name: {
          th: 'เมืองเก่า',
          en: 'Mueang Kao',
        },
        districtId: 190,
      },
      {
        id: '250203',
        zipcode: 25110,
        text: 'วังดาล',
        value: 'วังดาล',
        name: {
          th: 'วังดาล',
          en: 'Wang Dan',
        },
        districtId: 190,
      },
      {
        id: '250204',
        zipcode: 25110,
        text: 'นนทรี',
        value: 'นนทรี',
        name: {
          th: 'นนทรี',
          en: 'Nonsi',
        },
        districtId: 190,
      },
      {
        id: '250205',
        zipcode: 25110,
        text: 'ย่านรี',
        value: 'ย่านรี',
        name: {
          th: 'ย่านรี',
          en: 'Yan Ri',
        },
        districtId: 190,
      },
      {
        id: '250206',
        zipcode: 25110,
        text: 'วังตะเคียน',
        value: 'วังตะเคียน',
        name: {
          th: 'วังตะเคียน',
          en: 'Wang Takhian',
        },
        districtId: 190,
      },
      {
        id: '250207',
        zipcode: 25110,
        text: 'หาดนางแก้ว',
        value: 'หาดนางแก้ว',
        name: {
          th: 'หาดนางแก้ว',
          en: 'Hat Nang Kaeo',
        },
        districtId: 190,
      },
      {
        id: '250208',
        zipcode: 25110,
        text: 'ลาดตะเคียน',
        value: 'ลาดตะเคียน',
        name: {
          th: 'ลาดตะเคียน',
          en: 'Lat Takhian',
        },
        districtId: 190,
      },
      {
        id: '250209',
        zipcode: 25110,
        text: 'บ้านนา',
        value: 'บ้านนา',
        name: {
          th: 'บ้านนา',
          en: 'Ban Na',
        },
        districtId: 190,
      },
      {
        id: '250210',
        zipcode: 25110,
        text: 'บ่อทอง',
        value: 'บ่อทอง',
        name: {
          th: 'บ่อทอง',
          en: 'Bo Thong',
        },
        districtId: 190,
      },
      {
        id: '250211',
        zipcode: 25110,
        text: 'หนองกี่',
        value: 'หนองกี่',
        name: {
          th: 'หนองกี่',
          en: 'Nong Ki',
        },
        districtId: 190,
      },
      {
        id: '250212',
        zipcode: 25110,
        text: 'นาแขม',
        value: 'นาแขม',
        name: {
          th: 'นาแขม',
          en: 'Na Khaem',
        },
        districtId: 190,
      },
      {
        id: '250213',
        zipcode: 25110,
        text: 'เขาไม้แก้ว',
        value: 'เขาไม้แก้ว',
        name: {
          th: 'เขาไม้แก้ว',
          en: 'Khao Mai Kaeo',
        },
        districtId: 190,
      },
      {
        id: '250214',
        zipcode: 25110,
        text: 'วังท่าช้าง',
        value: 'วังท่าช้าง',
        name: {
          th: 'วังท่าช้าง',
          en: 'Wang Tha Chang',
        },
        districtId: 190,
      },
      {
        id: '250301',
        zipcode: 25220,
        text: 'นาดี',
        value: 'นาดี',
        name: {
          th: 'นาดี',
          en: 'Na Di',
        },
        districtId: 191,
      },
      {
        id: '250302',
        zipcode: 25220,
        text: 'สำพันตา',
        value: 'สำพันตา',
        name: {
          th: 'สำพันตา',
          en: 'Samphan Ta',
        },
        districtId: 191,
      },
      {
        id: '250303',
        zipcode: 25220,
        text: 'สะพานหิน',
        value: 'สะพานหิน',
        name: {
          th: 'สะพานหิน',
          en: 'Saphan Hin',
        },
        districtId: 191,
      },
      {
        id: '250304',
        zipcode: 25220,
        text: 'ทุ่งโพธิ์',
        value: 'ทุ่งโพธิ์',
        name: {
          th: 'ทุ่งโพธิ์',
          en: 'Thung Pho',
        },
        districtId: 191,
      },
      {
        id: '250305',
        zipcode: 25220,
        text: 'แก่งดินสอ',
        value: 'แก่งดินสอ',
        name: {
          th: 'แก่งดินสอ',
          en: 'Kaeng Dinso',
        },
        districtId: 191,
      },
      {
        id: '250306',
        zipcode: 25220,
        text: 'บุพราหมณ์',
        value: 'บุพราหมณ์',
        name: {
          th: 'บุพราหมณ์',
          en: 'Bu Phram',
        },
        districtId: 191,
      },
      {
        id: '250601',
        zipcode: 25150,
        text: 'บ้านสร้าง',
        value: 'บ้านสร้าง',
        name: {
          th: 'บ้านสร้าง',
          en: 'Ban Sang',
        },
        districtId: 194,
      },
      {
        id: '250602',
        zipcode: 25150,
        text: 'บางกระเบา',
        value: 'บางกระเบา',
        name: {
          th: 'บางกระเบา',
          en: 'Bang Krabao',
        },
        districtId: 194,
      },
      {
        id: '250603',
        zipcode: 25150,
        text: 'บางเตย',
        value: 'บางเตย',
        name: {
          th: 'บางเตย',
          en: 'Bang Toei',
        },
        districtId: 194,
      },
      {
        id: '250604',
        zipcode: 25150,
        text: 'บางยาง',
        value: 'บางยาง',
        name: {
          th: 'บางยาง',
          en: 'Bang Yang',
        },
        districtId: 194,
      },
      {
        id: '250605',
        zipcode: 25150,
        text: 'บางแตน',
        value: 'บางแตน',
        name: {
          th: 'บางแตน',
          en: 'Bang Taen',
        },
        districtId: 194,
      },
      {
        id: '250606',
        zipcode: 25150,
        text: 'บางพลวง',
        value: 'บางพลวง',
        name: {
          th: 'บางพลวง',
          en: 'Bang Phluang',
        },
        districtId: 194,
      },
      {
        id: '250607',
        zipcode: 25150,
        text: 'บางปลาร้า',
        value: 'บางปลาร้า',
        name: {
          th: 'บางปลาร้า',
          en: 'Bang Pla Ra',
        },
        districtId: 194,
      },
      {
        id: '250608',
        zipcode: 25150,
        text: 'บางขาม',
        value: 'บางขาม',
        name: {
          th: 'บางขาม',
          en: 'Bang Kham',
        },
        districtId: 194,
      },
      {
        id: '250609',
        zipcode: 25150,
        text: 'กระทุ่มแพ้ว',
        value: 'กระทุ่มแพ้ว',
        name: {
          th: 'กระทุ่มแพ้ว',
          en: 'Krathum Phaeo)',
        },
        districtId: 194,
      },
      {
        id: '250701',
        zipcode: 25130,
        text: 'ประจันตคาม',
        value: 'ประจันตคาม',
        name: {
          th: 'ประจันตคาม',
          en: 'Prachantakham',
        },
        districtId: 195,
      },
      {
        id: '250702',
        zipcode: 25130,
        text: 'เกาะลอย',
        value: 'เกาะลอย',
        name: {
          th: 'เกาะลอย',
          en: 'Ko Loi',
        },
        districtId: 195,
      },
      {
        id: '250703',
        zipcode: 25130,
        text: 'บ้านหอย',
        value: 'บ้านหอย',
        name: {
          th: 'บ้านหอย',
          en: 'Ban Hoi',
        },
        districtId: 195,
      },
      {
        id: '250704',
        zipcode: 25130,
        text: 'หนองแสง',
        value: 'หนองแสง',
        name: {
          th: 'หนองแสง',
          en: 'Nong Saeng',
        },
        districtId: 195,
      },
      {
        id: '250705',
        zipcode: 25130,
        text: 'ดงบัง',
        value: 'ดงบัง',
        name: {
          th: 'ดงบัง',
          en: 'Dong Bang',
        },
        districtId: 195,
      },
      {
        id: '250706',
        zipcode: 25130,
        text: 'คำโตนด',
        value: 'คำโตนด',
        name: {
          th: 'คำโตนด',
          en: 'Kham Tanot',
        },
        districtId: 195,
      },
      {
        id: '250707',
        zipcode: 25130,
        text: 'บุฝ้าย',
        value: 'บุฝ้าย',
        name: {
          th: 'บุฝ้าย',
          en: 'Bu Fai',
        },
        districtId: 195,
      },
      {
        id: '250708',
        zipcode: 25130,
        text: 'หนองแก้ว',
        value: 'หนองแก้ว',
        name: {
          th: 'หนองแก้ว',
          en: 'Nong Kaeo',
        },
        districtId: 195,
      },
      {
        id: '250709',
        zipcode: 25130,
        text: 'โพธิ์งาม',
        value: 'โพธิ์งาม',
        name: {
          th: 'โพธิ์งาม',
          en: 'Pho Ngam',
        },
        districtId: 195,
      },
      {
        id: '250801',
        zipcode: 25140,
        text: 'ศรีมหาโพธิ',
        value: 'ศรีมหาโพธิ',
        name: {
          th: 'ศรีมหาโพธิ',
          en: 'Si Maha Phot',
        },
        districtId: 196,
      },
      {
        id: '250802',
        zipcode: 25140,
        text: 'สัมพันธ์',
        value: 'สัมพันธ์',
        name: {
          th: 'สัมพันธ์',
          en: 'Samphan',
        },
        districtId: 196,
      },
      {
        id: '250803',
        zipcode: 25140,
        text: 'บ้านทาม',
        value: 'บ้านทาม',
        name: {
          th: 'บ้านทาม',
          en: 'Ban Tham',
        },
        districtId: 196,
      },
      {
        id: '250804',
        zipcode: 25140,
        text: 'ท่าตูม',
        value: 'ท่าตูม',
        name: {
          th: 'ท่าตูม',
          en: 'Tha Tum',
        },
        districtId: 196,
      },
      {
        id: '250805',
        zipcode: 25140,
        text: 'บางกุ้ง',
        value: 'บางกุ้ง',
        name: {
          th: 'บางกุ้ง',
          en: 'Bang Kung',
        },
        districtId: 196,
      },
      {
        id: '250806',
        zipcode: 25140,
        text: 'ดงกระทงยาม',
        value: 'ดงกระทงยาม',
        name: {
          th: 'ดงกระทงยาม',
          en: 'Dong Krathong Yam',
        },
        districtId: 196,
      },
      {
        id: '250807',
        zipcode: 25140,
        text: 'หนองโพรง',
        value: 'หนองโพรง',
        name: {
          th: 'หนองโพรง',
          en: 'Nong Phrong',
        },
        districtId: 196,
      },
      {
        id: '250808',
        zipcode: 25140,
        text: 'หัวหว้า',
        value: 'หัวหว้า',
        name: {
          th: 'หัวหว้า',
          en: 'Hua Wa',
        },
        districtId: 196,
      },
      {
        id: '250809',
        zipcode: 25140,
        text: 'หาดยาง',
        value: 'หาดยาง',
        name: {
          th: 'หาดยาง',
          en: 'Hat Yang',
        },
        districtId: 196,
      },
      {
        id: '250810',
        zipcode: 25140,
        text: 'กรอกสมบูรณ์',
        value: 'กรอกสมบูรณ์',
        name: {
          th: 'กรอกสมบูรณ์',
          en: 'Krok Sombun',
        },
        districtId: 196,
      },
      {
        id: '250901',
        zipcode: 25190,
        text: 'โคกปีบ',
        value: 'โคกปีบ',
        name: {
          th: 'โคกปีบ',
          en: 'Khok Pip',
        },
        districtId: 197,
      },
      {
        id: '250902',
        zipcode: 25190,
        text: 'โคกไทย',
        value: 'โคกไทย',
        name: {
          th: 'โคกไทย',
          en: 'Khok Thai',
        },
        districtId: 197,
      },
      {
        id: '250903',
        zipcode: 25190,
        text: 'คู้ลำพัน',
        value: 'คู้ลำพัน',
        name: {
          th: 'คู้ลำพัน',
          en: 'Khu Lam Phan',
        },
        districtId: 197,
      },
      {
        id: '250904',
        zipcode: 25190,
        text: 'ไผ่ชะเลือด',
        value: 'ไผ่ชะเลือด',
        name: {
          th: 'ไผ่ชะเลือด',
          en: 'Phai Cha Lueat',
        },
        districtId: 197,
      },
      {
        id: '260101',
        zipcode: 26000,
        text: 'นครนายก',
        value: 'นครนายก',
        name: {
          th: 'นครนายก',
          en: 'Nakhon Nayok',
        },
        districtId: 202,
      },
      {
        id: '260102',
        zipcode: 26000,
        text: 'ท่าช้าง',
        value: 'ท่าช้าง',
        name: {
          th: 'ท่าช้าง',
          en: 'Tha Chang',
        },
        districtId: 202,
      },
      {
        id: '260103',
        zipcode: 26000,
        text: 'บ้านใหญ่',
        value: 'บ้านใหญ่',
        name: {
          th: 'บ้านใหญ่',
          en: 'Ban Yai',
        },
        districtId: 202,
      },
      {
        id: '260104',
        zipcode: 26000,
        text: 'วังกระโจม',
        value: 'วังกระโจม',
        name: {
          th: 'วังกระโจม',
          en: 'Wang Krachom',
        },
        districtId: 202,
      },
      {
        id: '260105',
        zipcode: 26000,
        text: 'ท่าทราย',
        value: 'ท่าทราย',
        name: {
          th: 'ท่าทราย',
          en: 'Tha Sai',
        },
        districtId: 202,
      },
      {
        id: '260106',
        zipcode: 26000,
        text: 'ดอนยอ',
        value: 'ดอนยอ',
        name: {
          th: 'ดอนยอ',
          en: 'Don Yo',
        },
        districtId: 202,
      },
      {
        id: '260107',
        zipcode: 26000,
        text: 'ศรีจุฬา',
        value: 'ศรีจุฬา',
        name: {
          th: 'ศรีจุฬา',
          en: 'Si Chula',
        },
        districtId: 202,
      },
      {
        id: '260108',
        zipcode: 26000,
        text: 'ดงละคร',
        value: 'ดงละคร',
        name: {
          th: 'ดงละคร',
          en: 'Dong Lakhon',
        },
        districtId: 202,
      },
      {
        id: '260109',
        zipcode: 26000,
        text: 'ศรีนาวา',
        value: 'ศรีนาวา',
        name: {
          th: 'ศรีนาวา',
          en: 'Si Nawa',
        },
        districtId: 202,
      },
      {
        id: '260110',
        zipcode: 26000,
        text: 'สาริกา',
        value: 'สาริกา',
        name: {
          th: 'สาริกา',
          en: 'Sarika',
        },
        districtId: 202,
      },
      {
        id: '260111',
        zipcode: 26000,
        text: 'หินตั้ง',
        value: 'หินตั้ง',
        name: {
          th: 'หินตั้ง',
          en: 'Hin Tang',
        },
        districtId: 202,
      },
      {
        id: '260112',
        zipcode: 26000,
        text: 'เขาพระ',
        value: 'เขาพระ',
        name: {
          th: 'เขาพระ',
          en: 'Khao Phra',
        },
        districtId: 202,
      },
      {
        id: '260113',
        zipcode: 26000,
        text: 'พรหมณี',
        value: 'พรหมณี',
        name: {
          th: 'พรหมณี',
          en: 'Phrommani',
        },
        districtId: 202,
      },
      {
        id: '260201',
        zipcode: 26130,
        text: 'เกาะหวาย',
        value: 'เกาะหวาย',
        name: {
          th: 'เกาะหวาย',
          en: 'Ko Wai',
        },
        districtId: 203,
      },
      {
        id: '260202',
        zipcode: 26130,
        text: 'เกาะโพธิ์',
        value: 'เกาะโพธิ์',
        name: {
          th: 'เกาะโพธิ์',
          en: 'Ko Pho',
        },
        districtId: 203,
      },
      {
        id: '260203',
        zipcode: 26130,
        text: 'ปากพลี',
        value: 'ปากพลี',
        name: {
          th: 'ปากพลี',
          en: 'Pak Phli',
        },
        districtId: 203,
      },
      {
        id: '260204',
        zipcode: 26130,
        text: 'โคกกรวด',
        value: 'โคกกรวด',
        name: {
          th: 'โคกกรวด',
          en: 'Khok Kruat',
        },
        districtId: 203,
      },
      {
        id: '260205',
        zipcode: 26130,
        text: 'ท่าเรือ',
        value: 'ท่าเรือ',
        name: {
          th: 'ท่าเรือ',
          en: 'Tha Ruea',
        },
        districtId: 203,
      },
      {
        id: '260206',
        zipcode: 26130,
        text: 'หนองแสง',
        value: 'หนองแสง',
        name: {
          th: 'หนองแสง',
          en: 'Nong Saeng',
        },
        districtId: 203,
      },
      {
        id: '260207',
        zipcode: 26130,
        text: 'นาหินลาด',
        value: 'นาหินลาด',
        name: {
          th: 'นาหินลาด',
          en: 'Na Hin Lat',
        },
        districtId: 203,
      },
      {
        id: '260301',
        zipcode: 26110,
        text: 'บ้านนา',
        value: 'บ้านนา',
        name: {
          th: 'บ้านนา',
          en: 'Ban Na',
        },
        districtId: 204,
      },
      {
        id: '260302',
        zipcode: 26110,
        text: 'บ้านพร้าว',
        value: 'บ้านพร้าว',
        name: {
          th: 'บ้านพร้าว',
          en: 'Ban Phrao',
        },
        districtId: 204,
      },
      {
        id: '260303',
        zipcode: 26110,
        text: 'บ้านพริก',
        value: 'บ้านพริก',
        name: {
          th: 'บ้านพริก',
          en: 'Ban Phrik',
        },
        districtId: 204,
      },
      {
        id: '260304',
        zipcode: 26110,
        text: 'อาษา',
        value: 'อาษา',
        name: {
          th: 'อาษา',
          en: 'Asa',
        },
        districtId: 204,
      },
      {
        id: '260305',
        zipcode: 26110,
        text: 'ทองหลาง',
        value: 'ทองหลาง',
        name: {
          th: 'ทองหลาง',
          en: 'Thonglang',
        },
        districtId: 204,
      },
      {
        id: '260306',
        zipcode: 26110,
        text: 'บางอ้อ',
        value: 'บางอ้อ',
        name: {
          th: 'บางอ้อ',
          en: 'Bang O',
        },
        districtId: 204,
      },
      {
        id: '260307',
        zipcode: 26110,
        text: 'พิกุลออก',
        value: 'พิกุลออก',
        name: {
          th: 'พิกุลออก',
          en: 'Phikun Ok',
        },
        districtId: 204,
      },
      {
        id: '260308',
        zipcode: 26110,
        text: 'ป่าขะ',
        value: 'ป่าขะ',
        name: {
          th: 'ป่าขะ',
          en: 'Pa Kha',
        },
        districtId: 204,
      },
      {
        id: '260309',
        zipcode: 26110,
        text: 'เขาเพิ่ม',
        value: 'เขาเพิ่ม',
        name: {
          th: 'เขาเพิ่ม',
          en: 'Khao Phoem',
        },
        districtId: 204,
      },
      {
        id: '260310',
        zipcode: 26110,
        text: 'ศรีกะอาง',
        value: 'ศรีกะอาง',
        name: {
          th: 'ศรีกะอาง',
          en: 'Si Ka-ang',
        },
        districtId: 204,
      },
      {
        id: '260401',
        zipcode: 26120,
        text: 'พระอาจารย์',
        value: 'พระอาจารย์',
        name: {
          th: 'พระอาจารย์',
          en: 'Phra Achan',
        },
        districtId: 205,
      },
      {
        id: '260402',
        zipcode: 26120,
        text: 'บึงศาล',
        value: 'บึงศาล',
        name: {
          th: 'บึงศาล',
          en: 'Bueng San',
        },
        districtId: 205,
      },
      {
        id: '260403',
        zipcode: 26120,
        text: 'ศีรษะกระบือ',
        value: 'ศีรษะกระบือ',
        name: {
          th: 'ศีรษะกระบือ',
          en: 'Sisa Krabue',
        },
        districtId: 205,
      },
      {
        id: '260404',
        zipcode: 26120,
        text: 'โพธิ์แทน',
        value: 'โพธิ์แทน',
        name: {
          th: 'โพธิ์แทน',
          en: 'Pho Thaen',
        },
        districtId: 205,
      },
      {
        id: '260405',
        zipcode: 26120,
        text: 'บางสมบูรณ์',
        value: 'บางสมบูรณ์',
        name: {
          th: 'บางสมบูรณ์',
          en: 'Bang Sombun',
        },
        districtId: 205,
      },
      {
        id: '260406',
        zipcode: 26120,
        text: 'ทรายมูล',
        value: 'ทรายมูล',
        name: {
          th: 'ทรายมูล',
          en: 'Sai Mun',
        },
        districtId: 205,
      },
      {
        id: '260407',
        zipcode: 26120,
        text: 'บางปลากด',
        value: 'บางปลากด',
        name: {
          th: 'บางปลากด',
          en: 'Bang Pla Kot',
        },
        districtId: 205,
      },
      {
        id: '260408',
        zipcode: 26120,
        text: 'บางลูกเสือ',
        value: 'บางลูกเสือ',
        name: {
          th: 'บางลูกเสือ',
          en: 'Bang Luk Suea',
        },
        districtId: 205,
      },
      {
        id: '260409',
        zipcode: 26120,
        text: 'องครักษ์',
        value: 'องครักษ์',
        name: {
          th: 'องครักษ์',
          en: 'Ongkharak',
        },
        districtId: 205,
      },
      {
        id: '260410',
        zipcode: 26120,
        text: 'ชุมพล',
        value: 'ชุมพล',
        name: {
          th: 'ชุมพล',
          en: 'Chumphon',
        },
        districtId: 205,
      },
      {
        id: '260411',
        zipcode: 26120,
        text: 'คลองใหญ่',
        value: 'คลองใหญ่',
        name: {
          th: 'คลองใหญ่',
          en: 'Khlong Yai',
        },
        districtId: 205,
      },
      {
        id: '270101',
        zipcode: 27000,
        text: 'สระแก้ว',
        value: 'สระแก้ว',
        name: {
          th: 'สระแก้ว',
          en: 'Sa Kaeo',
        },
        districtId: 206,
      },
      {
        id: '270102',
        zipcode: 27000,
        text: 'บ้านแก้ง',
        value: 'บ้านแก้ง',
        name: {
          th: 'บ้านแก้ง',
          en: 'Ban Kaeng',
        },
        districtId: 206,
      },
      {
        id: '270103',
        zipcode: 27000,
        text: 'ศาลาลำดวน',
        value: 'ศาลาลำดวน',
        name: {
          th: 'ศาลาลำดวน',
          en: 'Sala Lamduan',
        },
        districtId: 206,
      },
      {
        id: '270104',
        zipcode: 27000,
        text: 'โคกปี่ฆ้อง',
        value: 'โคกปี่ฆ้อง',
        name: {
          th: 'โคกปี่ฆ้อง',
          en: 'Khok Pi Khong',
        },
        districtId: 206,
      },
      {
        id: '270105',
        zipcode: 27000,
        text: 'ท่าแยก',
        value: 'ท่าแยก',
        name: {
          th: 'ท่าแยก',
          en: 'Tha Yaek',
        },
        districtId: 206,
      },
      {
        id: '270106',
        zipcode: 27000,
        text: 'ท่าเกษม',
        value: 'ท่าเกษม',
        name: {
          th: 'ท่าเกษม',
          en: 'Tha Kasem',
        },
        districtId: 206,
      },
      {
        id: '270108',
        zipcode: 27000,
        text: 'สระขวัญ',
        value: 'สระขวัญ',
        name: {
          th: 'สระขวัญ',
          en: 'Sa Khwan',
        },
        districtId: 206,
      },
      {
        id: '270111',
        zipcode: 27000,
        text: 'หนองบอน',
        value: 'หนองบอน',
        name: {
          th: 'หนองบอน',
          en: 'Nong Bon',
        },
        districtId: 206,
      },
      {
        id: '270201',
        zipcode: 27260,
        text: 'คลองหาด',
        value: 'คลองหาด',
        name: {
          th: 'คลองหาด',
          en: 'Khlong Hat',
        },
        districtId: 207,
      },
      {
        id: '270202',
        zipcode: 27260,
        text: 'ไทยอุดม',
        value: 'ไทยอุดม',
        name: {
          th: 'ไทยอุดม',
          en: 'Thai Udom',
        },
        districtId: 207,
      },
      {
        id: '270203',
        zipcode: 27260,
        text: 'ซับมะกรูด',
        value: 'ซับมะกรูด',
        name: {
          th: 'ซับมะกรูด',
          en: 'Sap Makrut',
        },
        districtId: 207,
      },
      {
        id: '270204',
        zipcode: 27260,
        text: 'ไทรเดี่ยว',
        value: 'ไทรเดี่ยว',
        name: {
          th: 'ไทรเดี่ยว',
          en: 'Sai Diao',
        },
        districtId: 207,
      },
      {
        id: '270205',
        zipcode: 27260,
        text: 'คลองไก่เถื่อน',
        value: 'คลองไก่เถื่อน',
        name: {
          th: 'คลองไก่เถื่อน',
          en: 'Khlong Kai Thuean',
        },
        districtId: 207,
      },
      {
        id: '270206',
        zipcode: 27260,
        text: 'เบญจขร',
        value: 'เบญจขร',
        name: {
          th: 'เบญจขร',
          en: 'Benchakhon',
        },
        districtId: 207,
      },
      {
        id: '270207',
        zipcode: 27260,
        text: 'ไทรทอง',
        value: 'ไทรทอง',
        name: {
          th: 'ไทรทอง',
          en: 'Sai Thong',
        },
        districtId: 207,
      },
      {
        id: '270301',
        zipcode: 27180,
        text: 'ตาพระยา',
        value: 'ตาพระยา',
        name: {
          th: 'ตาพระยา',
          en: 'Ta Phraya',
        },
        districtId: 208,
      },
      {
        id: '270302',
        zipcode: 27180,
        text: 'ทัพเสด็จ',
        value: 'ทัพเสด็จ',
        name: {
          th: 'ทัพเสด็จ',
          en: 'Thap Sadet',
        },
        districtId: 208,
      },
      {
        id: '270306',
        zipcode: 27180,
        text: 'ทัพราช',
        value: 'ทัพราช',
        name: {
          th: 'ทัพราช',
          en: 'Thap Rat',
        },
        districtId: 208,
      },
      {
        id: '270307',
        zipcode: 27180,
        text: 'ทัพไทย',
        value: 'ทัพไทย',
        name: {
          th: 'ทัพไทย',
          en: 'Thap Thai',
        },
        districtId: 208,
      },
      {
        id: '270309',
        zipcode: 27180,
        text: 'โคคลาน',
        value: 'โคคลาน',
        name: {
          th: 'โคคลาน',
          en: 'Kho Khlan',
        },
        districtId: 208,
      },
      {
        id: '270401',
        zipcode: 27210,
        text: 'วังน้ำเย็น',
        value: 'วังน้ำเย็น',
        name: {
          th: 'วังน้ำเย็น',
          en: 'Wang Nam Yen',
        },
        districtId: 209,
      },
      {
        id: '270403',
        zipcode: 27210,
        text: 'ตาหลังใน',
        value: 'ตาหลังใน',
        name: {
          th: 'ตาหลังใน',
          en: 'Ta Lang Nai',
        },
        districtId: 209,
      },
      {
        id: '270405',
        zipcode: 27210,
        text: 'คลองหินปูน',
        value: 'คลองหินปูน',
        name: {
          th: 'คลองหินปูน',
          en: 'Khlong Hin Pun',
        },
        districtId: 209,
      },
      {
        id: '270406',
        zipcode: 27210,
        text: 'ทุ่งมหาเจริญ',
        value: 'ทุ่งมหาเจริญ',
        name: {
          th: 'ทุ่งมหาเจริญ',
          en: 'Thung Maha Charoen',
        },
        districtId: 209,
      },
      {
        id: '270501',
        zipcode: 27160,
        text: 'วัฒนานคร',
        value: 'วัฒนานคร',
        name: {
          th: 'วัฒนานคร',
          en: 'Watthana Nakhon',
        },
        districtId: 210,
      },
      {
        id: '270502',
        zipcode: 27160,
        text: 'ท่าเกวียน',
        value: 'ท่าเกวียน',
        name: {
          th: 'ท่าเกวียน',
          en: 'Tha Kwian',
        },
        districtId: 210,
      },
      {
        id: '270503',
        zipcode: 27160,
        text: 'ผักขะ',
        value: 'ผักขะ',
        name: {
          th: 'ผักขะ',
          en: 'Phak Kha',
        },
        districtId: 210,
      },
      {
        id: '270504',
        zipcode: 27160,
        text: 'โนนหมากเค็ง',
        value: 'โนนหมากเค็ง',
        name: {
          th: 'โนนหมากเค็ง',
          en: 'Non Mak Kheng',
        },
        districtId: 210,
      },
      {
        id: '270505',
        zipcode: 27160,
        text: 'หนองน้ำใส',
        value: 'หนองน้ำใส',
        name: {
          th: 'หนองน้ำใส',
          en: 'Nong Nam Sai',
        },
        districtId: 210,
      },
      {
        id: '270506',
        zipcode: 27160,
        text: 'ช่องกุ่ม',
        value: 'ช่องกุ่ม',
        name: {
          th: 'ช่องกุ่ม',
          en: 'Chong Kum',
        },
        districtId: 210,
      },
      {
        id: '270507',
        zipcode: 27160,
        text: 'หนองแวง',
        value: 'หนองแวง',
        name: {
          th: 'หนองแวง',
          en: 'Nong Waeng',
        },
        districtId: 210,
      },
      {
        id: '270508',
        zipcode: 27160,
        text: 'แซร์ออ',
        value: 'แซร์ออ',
        name: {
          th: 'แซร์ออ',
          en: 'Sae-o',
        },
        districtId: 210,
      },
      {
        id: '270509',
        zipcode: 27160,
        text: 'หนองหมากฝ้าย',
        value: 'หนองหมากฝ้าย',
        name: {
          th: 'หนองหมากฝ้าย',
          en: 'Nong Mak Fai',
        },
        districtId: 210,
      },
      {
        id: '270510',
        zipcode: 27160,
        text: 'หนองตะเคียนบอน',
        value: 'หนองตะเคียนบอน',
        name: {
          th: 'หนองตะเคียนบอน',
          en: 'Nong Takhian Bon',
        },
        districtId: 210,
      },
      {
        id: '270511',
        zipcode: 27160,
        text: 'ห้วยโจด',
        value: 'ห้วยโจด',
        name: {
          th: 'ห้วยโจด',
          en: 'Huai Chot',
        },
        districtId: 210,
      },
      {
        id: '270601',
        zipcode: 27120,
        text: 'อรัญประเทศ',
        value: 'อรัญประเทศ',
        name: {
          th: 'อรัญประเทศ',
          en: 'Aranprathet',
        },
        districtId: 211,
      },
      {
        id: '270602',
        zipcode: 27120,
        text: 'เมืองไผ่',
        value: 'เมืองไผ่',
        name: {
          th: 'เมืองไผ่',
          en: 'Mueang Phai',
        },
        districtId: 211,
      },
      {
        id: '270603',
        zipcode: 27120,
        text: 'หันทราย',
        value: 'หันทราย',
        name: {
          th: 'หันทราย',
          en: 'Han Sai',
        },
        districtId: 211,
      },
      {
        id: '270604',
        zipcode: 27120,
        text: 'คลองน้ำใส',
        value: 'คลองน้ำใส',
        name: {
          th: 'คลองน้ำใส',
          en: 'Khlong Nam Sai',
        },
        districtId: 211,
      },
      {
        id: '270605',
        zipcode: 27120,
        text: 'ท่าข้าม',
        value: 'ท่าข้าม',
        name: {
          th: 'ท่าข้าม',
          en: 'Tha Kham',
        },
        districtId: 211,
      },
      {
        id: '270606',
        zipcode: 27120,
        text: 'ป่าไร่',
        value: 'ป่าไร่',
        name: {
          th: 'ป่าไร่',
          en: 'Pa Rai',
        },
        districtId: 211,
      },
      {
        id: '270607',
        zipcode: 27120,
        text: 'ทับพริก',
        value: 'ทับพริก',
        name: {
          th: 'ทับพริก',
          en: 'Thap Phrik',
        },
        districtId: 211,
      },
      {
        id: '270608',
        zipcode: 27120,
        text: 'บ้านใหม่หนองไทร',
        value: 'บ้านใหม่หนองไทร',
        name: {
          th: 'บ้านใหม่หนองไทร',
          en: 'Ban Mai Nong Sai',
        },
        districtId: 211,
      },
      {
        id: '270609',
        zipcode: 27120,
        text: 'ผ่านศึก',
        value: 'ผ่านศึก',
        name: {
          th: 'ผ่านศึก',
          en: 'Phan Suek',
        },
        districtId: 211,
      },
      {
        id: '270610',
        zipcode: 27120,
        text: 'หนองสังข์',
        value: 'หนองสังข์',
        name: {
          th: 'หนองสังข์',
          en: 'Nong Sang',
        },
        districtId: 211,
      },
      {
        id: '270611',
        zipcode: 27120,
        text: 'คลองทับจันทร์',
        value: 'คลองทับจันทร์',
        name: {
          th: 'คลองทับจันทร์',
          en: 'Khlong Thap Chan',
        },
        districtId: 211,
      },
      {
        id: '270612',
        zipcode: 27120,
        text: 'ฟากห้วย',
        value: 'ฟากห้วย',
        name: {
          th: 'ฟากห้วย',
          en: 'Fak Huai',
        },
        districtId: 211,
      },
      {
        id: '270613',
        zipcode: 27120,
        text: 'บ้านด่าน',
        value: 'บ้านด่าน',
        name: {
          th: 'บ้านด่าน',
          en: 'Ban Dan',
        },
        districtId: 211,
      },
      {
        id: '270701',
        zipcode: 27000,
        text: 'เขาฉกรรจ์',
        value: 'เขาฉกรรจ์',
        name: {
          th: 'เขาฉกรรจ์',
          en: 'Khao Chakan',
        },
        districtId: 212,
      },
      {
        id: '270702',
        zipcode: 27000,
        text: 'หนองหว้า',
        value: 'หนองหว้า',
        name: {
          th: 'หนองหว้า',
          en: 'Nong Wa',
        },
        districtId: 212,
      },
      {
        id: '270703',
        zipcode: 27000,
        text: 'พระเพลิง',
        value: 'พระเพลิง',
        name: {
          th: 'พระเพลิง',
          en: 'Phra Phloeng',
        },
        districtId: 212,
      },
      {
        id: '270704',
        zipcode: 27000,
        text: 'เขาสามสิบ',
        value: 'เขาสามสิบ',
        name: {
          th: 'เขาสามสิบ',
          en: 'Khao Sam Sip',
        },
        districtId: 212,
      },
      {
        id: '270801',
        zipcode: 27120,
        text: 'โคกสูง',
        value: 'โคกสูง',
        name: {
          th: 'โคกสูง',
          en: 'Khok Sung',
        },
        districtId: 213,
      },
      {
        id: '270802',
        zipcode: 27180,
        text: 'หนองม่วง',
        value: 'หนองม่วง',
        name: {
          th: 'หนองม่วง',
          en: 'Nong Muang',
        },
        districtId: 213,
      },
      {
        id: '270803',
        zipcode: 27180,
        text: 'หนองแวง',
        value: 'หนองแวง',
        name: {
          th: 'หนองแวง',
          en: 'Nong Waeng',
        },
        districtId: 213,
      },
      {
        id: '270804',
        zipcode: 27120,
        text: 'โนนหมากมุ่น',
        value: 'โนนหมากมุ่น',
        name: {
          th: 'โนนหมากมุ่น',
          en: 'Non Mak Mun',
        },
        districtId: 213,
      },
      {
        id: '270901',
        zipcode: 27250,
        text: 'วังสมบูรณ์',
        value: 'วังสมบูรณ์',
        name: {
          th: 'วังสมบูรณ์',
          en: 'Wang Sombun',
        },
        districtId: 214,
      },
      {
        id: '270902',
        zipcode: 27250,
        text: 'วังใหม่',
        value: 'วังใหม่',
        name: {
          th: 'วังใหม่',
          en: 'Wang Mai',
        },
        districtId: 214,
      },
      {
        id: '270903',
        zipcode: 27250,
        text: 'วังทอง',
        value: 'วังทอง',
        name: {
          th: 'วังทอง',
          en: 'Wang Thong',
        },
        districtId: 214,
      },
      {
        id: '300101',
        zipcode: 30000,
        text: 'ในเมือง',
        value: 'ในเมือง',
        name: {
          th: 'ในเมือง',
          en: 'Nai Mueang',
        },
        districtId: 215,
      },
      {
        id: '300102',
        zipcode: 30000,
        text: 'โพธิ์กลาง',
        value: 'โพธิ์กลาง',
        name: {
          th: 'โพธิ์กลาง',
          en: 'Pho Klang',
        },
        districtId: 215,
      },
      {
        id: '300103',
        zipcode: 30000,
        text: 'หนองจะบก',
        value: 'หนองจะบก',
        name: {
          th: 'หนองจะบก',
          en: 'Nong Chabok',
        },
        districtId: 215,
      },
      {
        id: '300104',
        zipcode: 30310,
        text: 'โคกสูง',
        value: 'โคกสูง',
        name: {
          th: 'โคกสูง',
          en: 'Khok Sung',
        },
        districtId: 215,
      },
      {
        id: '300105',
        zipcode: 30000,
        text: 'มะเริง',
        value: 'มะเริง',
        name: {
          th: 'มะเริง',
          en: 'Maroeng',
        },
        districtId: 215,
      },
      {
        id: '300106',
        zipcode: 30000,
        text: 'หนองระเวียง',
        value: 'หนองระเวียง',
        name: {
          th: 'หนองระเวียง',
          en: 'Nong Rawiang',
        },
        districtId: 215,
      },
      {
        id: '300107',
        zipcode: 30000,
        text: 'ปรุใหญ่',
        value: 'ปรุใหญ่',
        name: {
          th: 'ปรุใหญ่',
          en: 'Pru Yai',
        },
        districtId: 215,
      },
      {
        id: '300108',
        zipcode: 30000,
        text: 'หมื่นไวย',
        value: 'หมื่นไวย',
        name: {
          th: 'หมื่นไวย',
          en: 'Muen Wai',
        },
        districtId: 215,
      },
      {
        id: '300109',
        zipcode: 30000,
        text: 'พลกรัง',
        value: 'พลกรัง',
        name: {
          th: 'พลกรัง',
          en: 'Phon Krang',
        },
        districtId: 215,
      },
      {
        id: '300110',
        zipcode: 30000,
        text: 'หนองไผ่ล้อม',
        value: 'หนองไผ่ล้อม',
        name: {
          th: 'หนองไผ่ล้อม',
          en: 'Nong Phai Lom',
        },
        districtId: 215,
      },
      {
        id: '300111',
        zipcode: 30000,
        text: 'หัวทะเล',
        value: 'หัวทะเล',
        name: {
          th: 'หัวทะเล',
          en: 'Hua Thale',
        },
        districtId: 215,
      },
      {
        id: '300112',
        zipcode: 30000,
        text: 'บ้านเกาะ',
        value: 'บ้านเกาะ',
        name: {
          th: 'บ้านเกาะ',
          en: 'Ban Ko',
        },
        districtId: 215,
      },
      {
        id: '300113',
        zipcode: 30000,
        text: 'บ้านใหม่',
        value: 'บ้านใหม่',
        name: {
          th: 'บ้านใหม่',
          en: 'Ban Mai',
        },
        districtId: 215,
      },
      {
        id: '300114',
        zipcode: 30000,
        text: 'พุดซา',
        value: 'พุดซา',
        name: {
          th: 'พุดซา',
          en: 'Phutsa',
        },
        districtId: 215,
      },
      {
        id: '300115',
        zipcode: 30310,
        text: 'บ้านโพธิ์',
        value: 'บ้านโพธิ์',
        name: {
          th: 'บ้านโพธิ์',
          en: 'Ban Pho',
        },
        districtId: 215,
      },
      {
        id: '300116',
        zipcode: 30310,
        text: 'จอหอ',
        value: 'จอหอ',
        name: {
          th: 'จอหอ',
          en: 'Cho Ho',
        },
        districtId: 215,
      },
      {
        id: '300117',
        zipcode: 30280,
        text: 'โคกกรวด',
        value: 'โคกกรวด',
        name: {
          th: 'โคกกรวด',
          en: 'Khok Kruat',
        },
        districtId: 215,
      },
      {
        id: '300118',
        zipcode: 30000,
        text: 'ไชยมงคล',
        value: 'ไชยมงคล',
        name: {
          th: 'ไชยมงคล',
          en: 'Chai Mongkhon',
        },
        districtId: 215,
      },
      {
        id: '300119',
        zipcode: 30000,
        text: 'หนองบัวศาลา',
        value: 'หนองบัวศาลา',
        name: {
          th: 'หนองบัวศาลา',
          en: 'Nong Bua Sala',
        },
        districtId: 215,
      },
      {
        id: '300120',
        zipcode: 30000,
        text: 'สุรนารี',
        value: 'สุรนารี',
        name: {
          th: 'สุรนารี',
          en: 'Suranari',
        },
        districtId: 215,
      },
      {
        id: '300121',
        zipcode: 30000,
        text: 'สีมุม',
        value: 'สีมุม',
        name: {
          th: 'สีมุม',
          en: 'Si Mum',
        },
        districtId: 215,
      },
      {
        id: '300122',
        zipcode: 30310,
        text: 'ตลาด',
        value: 'ตลาด',
        name: {
          th: 'ตลาด',
          en: 'Talat',
        },
        districtId: 215,
      },
      {
        id: '300123',
        zipcode: 30000,
        text: 'พะเนา',
        value: 'พะเนา',
        name: {
          th: 'พะเนา',
          en: 'Phanao',
        },
        districtId: 215,
      },
      {
        id: '300124',
        zipcode: 30000,
        text: 'หนองกระทุ่ม',
        value: 'หนองกระทุ่ม',
        name: {
          th: 'หนองกระทุ่ม',
          en: 'Nong Krathum',
        },
        districtId: 215,
      },
      {
        id: '300125',
        zipcode: 30310,
        text: 'หนองไข่น้ำ',
        value: 'หนองไข่น้ำ',
        name: {
          th: 'หนองไข่น้ำ',
          en: 'Nong Khai Nam',
        },
        districtId: 215,
      },
      {
        id: '300201',
        zipcode: 30250,
        text: 'แชะ',
        value: 'แชะ',
        name: {
          th: 'แชะ',
          en: 'Chae',
        },
        districtId: 216,
      },
      {
        id: '300202',
        zipcode: 30250,
        text: 'เฉลียง',
        value: 'เฉลียง',
        name: {
          th: 'เฉลียง',
          en: 'Chaliang',
        },
        districtId: 216,
      },
      {
        id: '300203',
        zipcode: 30250,
        text: 'ครบุรี',
        value: 'ครบุรี',
        name: {
          th: 'ครบุรี',
          en: 'Khon Buri',
        },
        districtId: 216,
      },
      {
        id: '300204',
        zipcode: 30250,
        text: 'โคกกระชาย',
        value: 'โคกกระชาย',
        name: {
          th: 'โคกกระชาย',
          en: 'Khok Krachai',
        },
        districtId: 216,
      },
      {
        id: '300205',
        zipcode: 30250,
        text: 'จระเข้หิน',
        value: 'จระเข้หิน',
        name: {
          th: 'จระเข้หิน',
          en: 'Chorakhe Hin',
        },
        districtId: 216,
      },
      {
        id: '300206',
        zipcode: 30250,
        text: 'มาบตะโกเอน',
        value: 'มาบตะโกเอน',
        name: {
          th: 'มาบตะโกเอน',
          en: 'Map Tako En',
        },
        districtId: 216,
      },
      {
        id: '300207',
        zipcode: 30250,
        text: 'อรพิมพ์',
        value: 'อรพิมพ์',
        name: {
          th: 'อรพิมพ์',
          en: 'Oraphim',
        },
        districtId: 216,
      },
      {
        id: '300208',
        zipcode: 30250,
        text: 'บ้านใหม่',
        value: 'บ้านใหม่',
        name: {
          th: 'บ้านใหม่',
          en: 'Ban Mai',
        },
        districtId: 216,
      },
      {
        id: '300209',
        zipcode: 30250,
        text: 'ลำเพียก',
        value: 'ลำเพียก',
        name: {
          th: 'ลำเพียก',
          en: 'Lam Phiak',
        },
        districtId: 216,
      },
      {
        id: '300210',
        zipcode: 30250,
        text: 'ครบุรีใต้',
        value: 'ครบุรีใต้',
        name: {
          th: 'ครบุรีใต้',
          en: 'Khon Buri Tai',
        },
        districtId: 216,
      },
      {
        id: '300211',
        zipcode: 30250,
        text: 'ตะแบกบาน',
        value: 'ตะแบกบาน',
        name: {
          th: 'ตะแบกบาน',
          en: 'Tabaek Ban',
        },
        districtId: 216,
      },
      {
        id: '300212',
        zipcode: 30250,
        text: 'สระว่านพระยา',
        value: 'สระว่านพระยา',
        name: {
          th: 'สระว่านพระยา',
          en: 'Sa Wan Phraya',
        },
        districtId: 216,
      },
      {
        id: '300301',
        zipcode: 30330,
        text: 'เสิงสาง',
        value: 'เสิงสาง',
        name: {
          th: 'เสิงสาง',
          en: 'Soeng Sang',
        },
        districtId: 217,
      },
      {
        id: '300302',
        zipcode: 30330,
        text: 'สระตะเคียน',
        value: 'สระตะเคียน',
        name: {
          th: 'สระตะเคียน',
          en: 'Sa Takhian',
        },
        districtId: 217,
      },
      {
        id: '300303',
        zipcode: 30330,
        text: 'โนนสมบูรณ์',
        value: 'โนนสมบูรณ์',
        name: {
          th: 'โนนสมบูรณ์',
          en: 'Non Sombun',
        },
        districtId: 217,
      },
      {
        id: '300304',
        zipcode: 30330,
        text: 'กุดโบสถ์',
        value: 'กุดโบสถ์',
        name: {
          th: 'กุดโบสถ์',
          en: 'Kut Bot',
        },
        districtId: 217,
      },
      {
        id: '300305',
        zipcode: 30330,
        text: 'สุขไพบูลย์',
        value: 'สุขไพบูลย์',
        name: {
          th: 'สุขไพบูลย์',
          en: 'Suk Phaibun',
        },
        districtId: 217,
      },
      {
        id: '300306',
        zipcode: 30330,
        text: 'บ้านราษฎร์',
        value: 'บ้านราษฎร์',
        name: {
          th: 'บ้านราษฎร์',
          en: 'Ban Rat',
        },
        districtId: 217,
      },
      {
        id: '300401',
        zipcode: 30260,
        text: 'เมืองคง',
        value: 'เมืองคง',
        name: {
          th: 'เมืองคง',
          en: 'Mueang Khong',
        },
        districtId: 218,
      },
      {
        id: '300402',
        zipcode: 30260,
        text: 'คูขาด',
        value: 'คูขาด',
        name: {
          th: 'คูขาด',
          en: 'Khu Khat',
        },
        districtId: 218,
      },
      {
        id: '300403',
        zipcode: 30260,
        text: 'เทพาลัย',
        value: 'เทพาลัย',
        name: {
          th: 'เทพาลัย',
          en: 'Thephalai',
        },
        districtId: 218,
      },
      {
        id: '300404',
        zipcode: 30260,
        text: 'ตาจั่น',
        value: 'ตาจั่น',
        name: {
          th: 'ตาจั่น',
          en: 'Ta Chan',
        },
        districtId: 218,
      },
      {
        id: '300405',
        zipcode: 30260,
        text: 'บ้านปรางค์',
        value: 'บ้านปรางค์',
        name: {
          th: 'บ้านปรางค์',
          en: 'Ban Prang',
        },
        districtId: 218,
      },
      {
        id: '300406',
        zipcode: 30260,
        text: 'หนองมะนาว',
        value: 'หนองมะนาว',
        name: {
          th: 'หนองมะนาว',
          en: 'Nong Manao',
        },
        districtId: 218,
      },
      {
        id: '300407',
        zipcode: 30260,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 218,
      },
      {
        id: '300408',
        zipcode: 30260,
        text: 'โนนเต็ง',
        value: 'โนนเต็ง',
        name: {
          th: 'โนนเต็ง',
          en: 'Non Teng',
        },
        districtId: 218,
      },
      {
        id: '300409',
        zipcode: 30260,
        text: 'ดอนใหญ่',
        value: 'ดอนใหญ่',
        name: {
          th: 'ดอนใหญ่',
          en: 'Don Yai',
        },
        districtId: 218,
      },
      {
        id: '300410',
        zipcode: 30260,
        text: 'ขามสมบูรณ์',
        value: 'ขามสมบูรณ์',
        name: {
          th: 'ขามสมบูรณ์',
          en: 'Kham Sombun',
        },
        districtId: 218,
      },
      {
        id: '300501',
        zipcode: 30350,
        text: 'บ้านเหลื่อม',
        value: 'บ้านเหลื่อม',
        name: {
          th: 'บ้านเหลื่อม',
          en: 'Ban Lueam',
        },
        districtId: 219,
      },
      {
        id: '300502',
        zipcode: 30350,
        text: 'วังโพธิ์',
        value: 'วังโพธิ์',
        name: {
          th: 'วังโพธิ์',
          en: 'Wang Pho',
        },
        districtId: 219,
      },
      {
        id: '300503',
        zipcode: 30350,
        text: 'โคกกระเบื้อง',
        value: 'โคกกระเบื้อง',
        name: {
          th: 'โคกกระเบื้อง',
          en: 'Khok Krabueang',
        },
        districtId: 219,
      },
      {
        id: '300504',
        zipcode: 30350,
        text: 'ช่อระกา',
        value: 'ช่อระกา',
        name: {
          th: 'ช่อระกา',
          en: 'Cho Raka',
        },
        districtId: 219,
      },
      {
        id: '300601',
        zipcode: 30230,
        text: 'จักราช',
        value: 'จักราช',
        name: {
          th: 'จักราช',
          en: 'Chakkarat',
        },
        districtId: 220,
      },
      {
        id: '300602',
        zipcode: 30230,
        text: 'ท่าช้าง',
        value: 'ท่าช้าง',
        name: {
          th: 'ท่าช้าง',
          en: 'Tha Chang',
        },
        districtId: 220,
      },
      {
        id: '300603',
        zipcode: 30230,
        text: 'ทองหลาง',
        value: 'ทองหลาง',
        name: {
          th: 'ทองหลาง',
          en: 'Thonglang',
        },
        districtId: 220,
      },
      {
        id: '300604',
        zipcode: 30230,
        text: 'สีสุก',
        value: 'สีสุก',
        name: {
          th: 'สีสุก',
          en: 'Si Suk',
        },
        districtId: 220,
      },
      {
        id: '300605',
        zipcode: 30230,
        text: 'หนองขาม',
        value: 'หนองขาม',
        name: {
          th: 'หนองขาม',
          en: 'Nong Kham',
        },
        districtId: 220,
      },
      {
        id: '300606',
        zipcode: 30230,
        text: 'หนองงูเหลือม',
        value: 'หนองงูเหลือม',
        name: {
          th: 'หนองงูเหลือม',
          en: 'Nong Ngu Luam',
        },
        districtId: 220,
      },
      {
        id: '300607',
        zipcode: 30230,
        text: 'หนองพลวง',
        value: 'หนองพลวง',
        name: {
          th: 'หนองพลวง',
          en: 'Nong Phluang',
        },
        districtId: 220,
      },
      {
        id: '300608',
        zipcode: 30230,
        text: 'หนองยาง',
        value: 'หนองยาง',
        name: {
          th: 'หนองยาง',
          en: 'Nong Yang',
        },
        districtId: 220,
      },
      {
        id: '300609',
        zipcode: 30230,
        text: 'พระพุทธ',
        value: 'พระพุทธ',
        name: {
          th: 'พระพุทธ',
          en: 'Phra Phut',
        },
        districtId: 220,
      },
      {
        id: '300610',
        zipcode: 30230,
        text: 'ศรีละกอ',
        value: 'ศรีละกอ',
        name: {
          th: 'ศรีละกอ',
          en: 'Si Lako',
        },
        districtId: 220,
      },
      {
        id: '300611',
        zipcode: 30230,
        text: 'คลองเมือง',
        value: 'คลองเมือง',
        name: {
          th: 'คลองเมือง',
          en: 'Khlong Mueang',
        },
        districtId: 220,
      },
      {
        id: '300612',
        zipcode: 30230,
        text: 'ช้างทอง',
        value: 'ช้างทอง',
        name: {
          th: 'ช้างทอง',
          en: 'Chang Thong',
        },
        districtId: 220,
      },
      {
        id: '300613',
        zipcode: 30230,
        text: 'หินโคน',
        value: 'หินโคน',
        name: {
          th: 'หินโคน',
          en: 'Hin Khon',
        },
        districtId: 220,
      },
      {
        id: '300701',
        zipcode: 30190,
        text: 'กระโทก',
        value: 'กระโทก',
        name: {
          th: 'กระโทก',
          en: 'Krathok',
        },
        districtId: 221,
      },
      {
        id: '300702',
        zipcode: 30190,
        text: 'พลับพลา',
        value: 'พลับพลา',
        name: {
          th: 'พลับพลา',
          en: 'Phlapphla',
        },
        districtId: 221,
      },
      {
        id: '300703',
        zipcode: 30190,
        text: 'ท่าอ่าง',
        value: 'ท่าอ่าง',
        name: {
          th: 'ท่าอ่าง',
          en: 'Tha Ang',
        },
        districtId: 221,
      },
      {
        id: '300704',
        zipcode: 30190,
        text: 'ทุ่งอรุณ',
        value: 'ทุ่งอรุณ',
        name: {
          th: 'ทุ่งอรุณ',
          en: 'Thung Arun',
        },
        districtId: 221,
      },
      {
        id: '300705',
        zipcode: 30190,
        text: 'ท่าลาดขาว',
        value: 'ท่าลาดขาว',
        name: {
          th: 'ท่าลาดขาว',
          en: 'Tha Lat Khao',
        },
        districtId: 221,
      },
      {
        id: '300706',
        zipcode: 30190,
        text: 'ท่าจะหลุง',
        value: 'ท่าจะหลุง',
        name: {
          th: 'ท่าจะหลุง',
          en: 'Tha Chalung',
        },
        districtId: 221,
      },
      {
        id: '300707',
        zipcode: 30190,
        text: 'ท่าเยี่ยม',
        value: 'ท่าเยี่ยม',
        name: {
          th: 'ท่าเยี่ยม',
          en: 'Tha Yiam',
        },
        districtId: 221,
      },
      {
        id: '300708',
        zipcode: 30190,
        text: 'โชคชัย',
        value: 'โชคชัย',
        name: {
          th: 'โชคชัย',
          en: 'Chok Chai',
        },
        districtId: 221,
      },
      {
        id: '300709',
        zipcode: 30190,
        text: 'ละลมใหม่พัฒนา',
        value: 'ละลมใหม่พัฒนา',
        name: {
          th: 'ละลมใหม่พัฒนา',
          en: 'Lalom Mai Phatthana',
        },
        districtId: 221,
      },
      {
        id: '300710',
        zipcode: 30190,
        text: 'ด่านเกวียน',
        value: 'ด่านเกวียน',
        name: {
          th: 'ด่านเกวียน',
          en: 'Dan Kwian',
        },
        districtId: 221,
      },
      {
        id: '300801',
        zipcode: 30210,
        text: 'กุดพิมาน',
        value: 'กุดพิมาน',
        name: {
          th: 'กุดพิมาน',
          en: 'Kut Phiman',
        },
        districtId: 222,
      },
      {
        id: '300802',
        zipcode: 30210,
        text: 'ด่านขุนทด',
        value: 'ด่านขุนทด',
        name: {
          th: 'ด่านขุนทด',
          en: 'Dan Khun Thot',
        },
        districtId: 222,
      },
      {
        id: '300803',
        zipcode: 30210,
        text: 'ด่านนอก',
        value: 'ด่านนอก',
        name: {
          th: 'ด่านนอก',
          en: 'Dan Nok',
        },
        districtId: 222,
      },
      {
        id: '300804',
        zipcode: 30210,
        text: 'ด่านใน',
        value: 'ด่านใน',
        name: {
          th: 'ด่านใน',
          en: 'Dan Nai',
        },
        districtId: 222,
      },
      {
        id: '300805',
        zipcode: 30210,
        text: 'ตะเคียน',
        value: 'ตะเคียน',
        name: {
          th: 'ตะเคียน',
          en: 'Takhian',
        },
        districtId: 222,
      },
      {
        id: '300806',
        zipcode: 30210,
        text: 'บ้านเก่า',
        value: 'บ้านเก่า',
        name: {
          th: 'บ้านเก่า',
          en: 'Ban Kao',
        },
        districtId: 222,
      },
      {
        id: '300807',
        zipcode: 36220,
        text: 'บ้านแปรง',
        value: 'บ้านแปรง',
        name: {
          th: 'บ้านแปรง',
          en: 'Ban Praeng',
        },
        districtId: 222,
      },
      {
        id: '300808',
        zipcode: 30210,
        text: 'พันชนะ',
        value: 'พันชนะ',
        name: {
          th: 'พันชนะ',
          en: 'Phan Chana',
        },
        districtId: 222,
      },
      {
        id: '300809',
        zipcode: 30210,
        text: 'สระจรเข้',
        value: 'สระจรเข้',
        name: {
          th: 'สระจรเข้',
          en: 'Sa Chorakhe',
        },
        districtId: 222,
      },
      {
        id: '300810',
        zipcode: 30210,
        text: 'หนองกราด',
        value: 'หนองกราด',
        name: {
          th: 'หนองกราด',
          en: 'Nong Krat',
        },
        districtId: 222,
      },
      {
        id: '300811',
        zipcode: 30210,
        text: 'หนองบัวตะเกียด',
        value: 'หนองบัวตะเกียด',
        name: {
          th: 'หนองบัวตะเกียด',
          en: 'Nong Bua Takiat',
        },
        districtId: 222,
      },
      {
        id: '300812',
        zipcode: 30210,
        text: 'หนองบัวละคร',
        value: 'หนองบัวละคร',
        name: {
          th: 'หนองบัวละคร',
          en: 'Nong Bua Lakhon',
        },
        districtId: 222,
      },
      {
        id: '300813',
        zipcode: 30210,
        text: 'หินดาด',
        value: 'หินดาด',
        name: {
          th: 'หินดาด',
          en: 'Hin Dat',
        },
        districtId: 222,
      },
      {
        id: '300815',
        zipcode: 30210,
        text: 'ห้วยบง',
        value: 'ห้วยบง',
        name: {
          th: 'ห้วยบง',
          en: 'Huai Bong',
        },
        districtId: 222,
      },
      {
        id: '300817',
        zipcode: 30210,
        text: 'โนนเมืองพัฒนา',
        value: 'โนนเมืองพัฒนา',
        name: {
          th: 'โนนเมืองพัฒนา',
          en: 'Non Mueang Phatthana',
        },
        districtId: 222,
      },
      {
        id: '300818',
        zipcode: 36220,
        text: 'หนองไทร',
        value: 'หนองไทร',
        name: {
          th: 'หนองไทร',
          en: 'Nong Sai',
        },
        districtId: 222,
      },
      {
        id: '300901',
        zipcode: 30220,
        text: 'โนนไทย',
        value: 'โนนไทย',
        name: {
          th: 'โนนไทย',
          en: 'Non Thai',
        },
        districtId: 223,
      },
      {
        id: '300902',
        zipcode: 30220,
        text: 'ด่านจาก',
        value: 'ด่านจาก',
        name: {
          th: 'ด่านจาก',
          en: 'Dan Chak',
        },
        districtId: 223,
      },
      {
        id: '300903',
        zipcode: 30220,
        text: 'กำปัง',
        value: 'กำปัง',
        name: {
          th: 'กำปัง',
          en: 'Kampang',
        },
        districtId: 223,
      },
      {
        id: '300904',
        zipcode: 30220,
        text: 'สำโรง',
        value: 'สำโรง',
        name: {
          th: 'สำโรง',
          en: 'Samrong',
        },
        districtId: 223,
      },
      {
        id: '300905',
        zipcode: 30220,
        text: 'ค้างพลู',
        value: 'ค้างพลู',
        name: {
          th: 'ค้างพลู',
          en: 'Khang Phlu',
        },
        districtId: 223,
      },
      {
        id: '300906',
        zipcode: 30220,
        text: 'บ้านวัง',
        value: 'บ้านวัง',
        name: {
          th: 'บ้านวัง',
          en: 'Ban Wang',
        },
        districtId: 223,
      },
      {
        id: '300907',
        zipcode: 30220,
        text: 'บัลลังก์',
        value: 'บัลลังก์',
        name: {
          th: 'บัลลังก์',
          en: 'Banlang',
        },
        districtId: 223,
      },
      {
        id: '300908',
        zipcode: 30220,
        text: 'สายออ',
        value: 'สายออ',
        name: {
          th: 'สายออ',
          en: 'Sai O',
        },
        districtId: 223,
      },
      {
        id: '300909',
        zipcode: 30220,
        text: 'ถนนโพธิ์',
        value: 'ถนนโพธิ์',
        name: {
          th: 'ถนนโพธิ์',
          en: 'Thanon Pho',
        },
        districtId: 223,
      },
      {
        id: '300910',
        zipcode: 30220,
        text: 'พังเทียม',
        value: 'พังเทียม',
        name: {
          th: 'พังเทียม',
          en: 'Phung Theam',
        },
        districtId: 223,
      },
      {
        id: '300911',
        zipcode: 30220,
        text: 'สระพระ',
        value: 'สระพระ',
        name: {
          th: 'สระพระ',
          en: 'Sra Pra',
        },
        districtId: 223,
      },
      {
        id: '300912',
        zipcode: 30220,
        text: 'ทัพรั้ง',
        value: 'ทัพรั้ง',
        name: {
          th: 'ทัพรั้ง',
          en: 'Tup Rang',
        },
        districtId: 223,
      },
      {
        id: '300913',
        zipcode: 30220,
        text: 'หนองหอย',
        value: 'หนองหอย',
        name: {
          th: 'หนองหอย',
          en: 'Nong Hoi',
        },
        districtId: 223,
      },
      {
        id: '300914',
        zipcode: 30220,
        text: 'มะค่า',
        value: 'มะค่า',
        name: {
          th: 'มะค่า',
          en: 'Makha',
        },
        districtId: 223,
      },
      {
        id: '300915',
        zipcode: 30220,
        text: 'มาบกราด',
        value: 'มาบกราด',
        name: {
          th: 'มาบกราด',
          en: 'Mab Krad',
        },
        districtId: 223,
      },
      {
        id: '301001',
        zipcode: 30160,
        text: 'โนนสูง',
        value: 'โนนสูง',
        name: {
          th: 'โนนสูง',
          en: 'Non Sung',
        },
        districtId: 224,
      },
      {
        id: '301002',
        zipcode: 30160,
        text: 'ใหม่',
        value: 'ใหม่',
        name: {
          th: 'ใหม่',
          en: 'Mai',
        },
        districtId: 224,
      },
      {
        id: '301003',
        zipcode: 30160,
        text: 'โตนด',
        value: 'โตนด',
        name: {
          th: 'โตนด',
          en: 'Tanot',
        },
        districtId: 224,
      },
      {
        id: '301004',
        zipcode: 30160,
        text: 'บิง',
        value: 'บิง',
        name: {
          th: 'บิง',
          en: 'Bing',
        },
        districtId: 224,
      },
      {
        id: '301005',
        zipcode: 30160,
        text: 'ดอนชมพู',
        value: 'ดอนชมพู',
        name: {
          th: 'ดอนชมพู',
          en: 'Don Chomphu',
        },
        districtId: 224,
      },
      {
        id: '301006',
        zipcode: 30240,
        text: 'ธารปราสาท',
        value: 'ธารปราสาท',
        name: {
          th: 'ธารปราสาท',
          en: 'Than Prasat',
        },
        districtId: 224,
      },
      {
        id: '301007',
        zipcode: 30160,
        text: 'หลุมข้าว',
        value: 'หลุมข้าว',
        name: {
          th: 'หลุมข้าว',
          en: 'Lum Khao',
        },
        districtId: 224,
      },
      {
        id: '301008',
        zipcode: 30160,
        text: 'มะค่า',
        value: 'มะค่า',
        name: {
          th: 'มะค่า',
          en: 'Makha',
        },
        districtId: 224,
      },
      {
        id: '301009',
        zipcode: 30160,
        text: 'พลสงคราม',
        value: 'พลสงคราม',
        name: {
          th: 'พลสงคราม',
          en: 'Phon Songkhram',
        },
        districtId: 224,
      },
      {
        id: '301010',
        zipcode: 30160,
        text: 'จันอัด',
        value: 'จันอัด',
        name: {
          th: 'จันอัด',
          en: 'Chan-at',
        },
        districtId: 224,
      },
      {
        id: '301011',
        zipcode: 30160,
        text: 'ขามเฒ่า',
        value: 'ขามเฒ่า',
        name: {
          th: 'ขามเฒ่า',
          en: 'Kham Thao',
        },
        districtId: 224,
      },
      {
        id: '301012',
        zipcode: 30160,
        text: 'ด่านคล้า',
        value: 'ด่านคล้า',
        name: {
          th: 'ด่านคล้า',
          en: 'Dan Khla',
        },
        districtId: 224,
      },
      {
        id: '301013',
        zipcode: 30160,
        text: 'ลำคอหงษ์',
        value: 'ลำคอหงษ์',
        name: {
          th: 'ลำคอหงษ์',
          en: 'Lam Kho Hong',
        },
        districtId: 224,
      },
      {
        id: '301014',
        zipcode: 30160,
        text: 'เมืองปราสาท',
        value: 'เมืองปราสาท',
        name: {
          th: 'เมืองปราสาท',
          en: 'Mueang Prasat',
        },
        districtId: 224,
      },
      {
        id: '301015',
        zipcode: 30160,
        text: 'ดอนหวาย',
        value: 'ดอนหวาย',
        name: {
          th: 'ดอนหวาย',
          en: 'Don Wai',
        },
        districtId: 224,
      },
      {
        id: '301016',
        zipcode: 30160,
        text: 'ลำมูล',
        value: 'ลำมูล',
        name: {
          th: 'ลำมูล',
          en: 'Lam Mun',
        },
        districtId: 224,
      },
      {
        id: '301101',
        zipcode: 30290,
        text: 'ขามสะแกแสง',
        value: 'ขามสะแกแสง',
        name: {
          th: 'ขามสะแกแสง',
          en: 'Kham Sakaesaeng',
        },
        districtId: 225,
      },
      {
        id: '301102',
        zipcode: 30290,
        text: 'โนนเมือง',
        value: 'โนนเมือง',
        name: {
          th: 'โนนเมือง',
          en: 'Non Mueang',
        },
        districtId: 225,
      },
      {
        id: '301103',
        zipcode: 30290,
        text: 'เมืองนาท',
        value: 'เมืองนาท',
        name: {
          th: 'เมืองนาท',
          en: 'Mueang Nat',
        },
        districtId: 225,
      },
      {
        id: '301104',
        zipcode: 30290,
        text: 'ชีวึก',
        value: 'ชีวึก',
        name: {
          th: 'ชีวึก',
          en: 'Chiwuek',
        },
        districtId: 225,
      },
      {
        id: '301105',
        zipcode: 30290,
        text: 'พะงาด',
        value: 'พะงาด',
        name: {
          th: 'พะงาด',
          en: 'Pha-ngat',
        },
        districtId: 225,
      },
      {
        id: '301106',
        zipcode: 30290,
        text: 'หนองหัวฟาน',
        value: 'หนองหัวฟาน',
        name: {
          th: 'หนองหัวฟาน',
          en: 'Nong Hua Fan',
        },
        districtId: 225,
      },
      {
        id: '301107',
        zipcode: 30290,
        text: 'เมืองเกษตร',
        value: 'เมืองเกษตร',
        name: {
          th: 'เมืองเกษตร',
          en: 'Mueang Kaset',
        },
        districtId: 225,
      },
      {
        id: '301201',
        zipcode: 30120,
        text: 'บัวใหญ่',
        value: 'บัวใหญ่',
        name: {
          th: 'บัวใหญ่',
          en: 'Bua Yai',
        },
        districtId: 226,
      },
      {
        id: '301203',
        zipcode: 30120,
        text: 'ห้วยยาง',
        value: 'ห้วยยาง',
        name: {
          th: 'ห้วยยาง',
          en: 'Huai Yang',
        },
        districtId: 226,
      },
      {
        id: '301204',
        zipcode: 30120,
        text: 'เสมาใหญ่',
        value: 'เสมาใหญ่',
        name: {
          th: 'เสมาใหญ่',
          en: 'Sema Yai',
        },
        districtId: 226,
      },
      {
        id: '301206',
        zipcode: 30120,
        text: 'ดอนตะหนิน',
        value: 'ดอนตะหนิน',
        name: {
          th: 'ดอนตะหนิน',
          en: 'Don Tanin',
        },
        districtId: 226,
      },
      {
        id: '301207',
        zipcode: 30120,
        text: 'หนองบัวสะอาด',
        value: 'หนองบัวสะอาด',
        name: {
          th: 'หนองบัวสะอาด',
          en: 'Nong Bua Sa-at',
        },
        districtId: 226,
      },
      {
        id: '301208',
        zipcode: 30120,
        text: 'โนนทองหลาง',
        value: 'โนนทองหลาง',
        name: {
          th: 'โนนทองหลาง',
          en: 'Non Thonglang',
        },
        districtId: 226,
      },
      {
        id: '301209',
        zipcode: 30120,
        text: 'หนองหว้า',
        value: 'หนองหว้า',
        name: {
          th: 'หนองหว้า',
          en: 'Nong Wha',
        },
        districtId: 226,
      },
      {
        id: '301210',
        zipcode: 30120,
        text: 'บัวลาย',
        value: 'บัวลาย',
        name: {
          th: 'บัวลาย',
          en: 'Bua Lai',
        },
        districtId: 226,
      },
      {
        id: '301211',
        zipcode: 30120,
        text: 'สีดา',
        value: 'สีดา',
        name: {
          th: 'สีดา',
          en: 'Sri Da',
        },
        districtId: 226,
      },
      {
        id: '301212',
        zipcode: 30120,
        text: 'โพนทอง',
        value: 'โพนทอง',
        name: {
          th: 'โพนทอง',
          en: 'Pon Thong',
        },
        districtId: 226,
      },
      {
        id: '301214',
        zipcode: 30120,
        text: 'กุดจอก',
        value: 'กุดจอก',
        name: {
          th: 'กุดจอก',
          en: 'Kut Chok',
        },
        districtId: 226,
      },
      {
        id: '301215',
        zipcode: 30120,
        text: 'ด่านช้าง',
        value: 'ด่านช้าง',
        name: {
          th: 'ด่านช้าง',
          en: 'Dan Chang',
        },
        districtId: 226,
      },
      {
        id: '301216',
        zipcode: 30120,
        text: 'โนนจาน',
        value: 'โนนจาน',
        name: {
          th: 'โนนจาน',
          en: 'Non Jan',
        },
        districtId: 226,
      },
      {
        id: '301218',
        zipcode: 30120,
        text: 'สามเมือง',
        value: 'สามเมือง',
        name: {
          th: 'สามเมือง',
          en: 'Sam Muang',
        },
        districtId: 226,
      },
      {
        id: '301220',
        zipcode: 30120,
        text: 'ขุนทอง',
        value: 'ขุนทอง',
        name: {
          th: 'ขุนทอง',
          en: 'Khun Thong',
        },
        districtId: 226,
      },
      {
        id: '301221',
        zipcode: 30120,
        text: 'หนองตาดใหญ่',
        value: 'หนองตาดใหญ่',
        name: {
          th: 'หนองตาดใหญ่',
          en: 'Nong Tad Yai',
        },
        districtId: 226,
      },
      {
        id: '301222',
        zipcode: 30120,
        text: 'เมืองพะไล',
        value: 'เมืองพะไล',
        name: {
          th: 'เมืองพะไล',
          en: 'Mueang Pa Lai',
        },
        districtId: 226,
      },
      {
        id: '301223',
        zipcode: 30120,
        text: 'โนนประดู่',
        value: 'โนนประดู่',
        name: {
          th: 'โนนประดู่',
          en: 'Non Pradoo',
        },
        districtId: 226,
      },
      {
        id: '301224',
        zipcode: 30120,
        text: 'หนองแจ้งใหญ่',
        value: 'หนองแจ้งใหญ่',
        name: {
          th: 'หนองแจ้งใหญ่',
          en: 'Nong Chaeng Yai',
        },
        districtId: 226,
      },
      {
        id: '301301',
        zipcode: 30180,
        text: 'ประทาย',
        value: 'ประทาย',
        name: {
          th: 'ประทาย',
          en: 'Prathai',
        },
        districtId: 227,
      },
      {
        id: '301303',
        zipcode: 30180,
        text: 'กระทุ่มราย',
        value: 'กระทุ่มราย',
        name: {
          th: 'กระทุ่มราย',
          en: 'Krathum Rai',
        },
        districtId: 227,
      },
      {
        id: '301304',
        zipcode: 30180,
        text: 'วังไม้แดง',
        value: 'วังไม้แดง',
        name: {
          th: 'วังไม้แดง',
          en: 'Wang Mai Daeng',
        },
        districtId: 227,
      },
      {
        id: '301306',
        zipcode: 30180,
        text: 'ตลาดไทร',
        value: 'ตลาดไทร',
        name: {
          th: 'ตลาดไทร',
          en: 'Talat Sai',
        },
        districtId: 227,
      },
      {
        id: '301307',
        zipcode: 30180,
        text: 'หนองพลวง',
        value: 'หนองพลวง',
        name: {
          th: 'หนองพลวง',
          en: 'Nong Phluang',
        },
        districtId: 227,
      },
      {
        id: '301308',
        zipcode: 30180,
        text: 'หนองค่าย',
        value: 'หนองค่าย',
        name: {
          th: 'หนองค่าย',
          en: 'Nong Khai',
        },
        districtId: 227,
      },
      {
        id: '301309',
        zipcode: 30180,
        text: 'หันห้วยทราย',
        value: 'หันห้วยทราย',
        name: {
          th: 'หันห้วยทราย',
          en: 'Han Huai Sai',
        },
        districtId: 227,
      },
      {
        id: '301310',
        zipcode: 30180,
        text: 'ดอนมัน',
        value: 'ดอนมัน',
        name: {
          th: 'ดอนมัน',
          en: 'Don Man',
        },
        districtId: 227,
      },
      {
        id: '301313',
        zipcode: 30180,
        text: 'นางรำ',
        value: 'นางรำ',
        name: {
          th: 'นางรำ',
          en: 'Nang Ram',
        },
        districtId: 227,
      },
      {
        id: '301314',
        zipcode: 30180,
        text: 'โนนเพ็ด',
        value: 'โนนเพ็ด',
        name: {
          th: 'โนนเพ็ด',
          en: 'Non Phet',
        },
        districtId: 227,
      },
      {
        id: '301315',
        zipcode: 30180,
        text: 'ทุ่งสว่าง',
        value: 'ทุ่งสว่าง',
        name: {
          th: 'ทุ่งสว่าง',
          en: 'Thung Sawang',
        },
        districtId: 227,
      },
      {
        id: '301317',
        zipcode: 30180,
        text: 'โคกกลาง',
        value: 'โคกกลาง',
        name: {
          th: 'โคกกลาง',
          en: 'Khok Klang',
        },
        districtId: 227,
      },
      {
        id: '301318',
        zipcode: 30180,
        text: 'เมืองโดน',
        value: 'เมืองโดน',
        name: {
          th: 'เมืองโดน',
          en: 'Mueang Don',
        },
        districtId: 227,
      },
      {
        id: '301401',
        zipcode: 30150,
        text: 'เมืองปัก',
        value: 'เมืองปัก',
        name: {
          th: 'เมืองปัก',
          en: 'Mueang Pak',
        },
        districtId: 228,
      },
      {
        id: '301402',
        zipcode: 30150,
        text: 'ตะคุ',
        value: 'ตะคุ',
        name: {
          th: 'ตะคุ',
          en: 'Takhu',
        },
        districtId: 228,
      },
      {
        id: '301403',
        zipcode: 30150,
        text: 'โคกไทย',
        value: 'โคกไทย',
        name: {
          th: 'โคกไทย',
          en: 'Khok Thai',
        },
        districtId: 228,
      },
      {
        id: '301404',
        zipcode: 30150,
        text: 'สำโรง',
        value: 'สำโรง',
        name: {
          th: 'สำโรง',
          en: 'Samrong',
        },
        districtId: 228,
      },
      {
        id: '301405',
        zipcode: 30150,
        text: 'ตะขบ',
        value: 'ตะขบ',
        name: {
          th: 'ตะขบ',
          en: 'Takhop',
        },
        districtId: 228,
      },
      {
        id: '301406',
        zipcode: 30150,
        text: 'นกออก',
        value: 'นกออก',
        name: {
          th: 'นกออก',
          en: 'Nok Ok',
        },
        districtId: 228,
      },
      {
        id: '301407',
        zipcode: 30150,
        text: 'ดอน',
        value: 'ดอน',
        name: {
          th: 'ดอน',
          en: 'Don',
        },
        districtId: 228,
      },
      {
        id: '301409',
        zipcode: 30150,
        text: 'ตูม',
        value: 'ตูม',
        name: {
          th: 'ตูม',
          en: 'Tum',
        },
        districtId: 228,
      },
      {
        id: '301410',
        zipcode: 30150,
        text: 'งิ้ว',
        value: 'งิ้ว',
        name: {
          th: 'งิ้ว',
          en: 'Ngio',
        },
        districtId: 228,
      },
      {
        id: '301411',
        zipcode: 30150,
        text: 'สะแกราช',
        value: 'สะแกราช',
        name: {
          th: 'สะแกราช',
          en: 'Sakae Rat',
        },
        districtId: 228,
      },
      {
        id: '301412',
        zipcode: 30150,
        text: 'ลำนางแก้ว',
        value: 'ลำนางแก้ว',
        name: {
          th: 'ลำนางแก้ว',
          en: 'Lam Nang Kaeo',
        },
        districtId: 228,
      },
      {
        id: '301416',
        zipcode: 30150,
        text: 'ภูหลวง',
        value: 'ภูหลวง',
        name: {
          th: 'ภูหลวง',
          en: 'Phu Luang',
        },
        districtId: 228,
      },
      {
        id: '301417',
        zipcode: 30150,
        text: 'ธงชัยเหนือ',
        value: 'ธงชัยเหนือ',
        name: {
          th: 'ธงชัยเหนือ',
          en: 'Thong Chai Nuea',
        },
        districtId: 228,
      },
      {
        id: '301418',
        zipcode: 30150,
        text: 'สุขเกษม',
        value: 'สุขเกษม',
        name: {
          th: 'สุขเกษม',
          en: 'Suk Kasem',
        },
        districtId: 228,
      },
      {
        id: '301419',
        zipcode: 30150,
        text: 'เกษมทรัพย์',
        value: 'เกษมทรัพย์',
        name: {
          th: 'เกษมทรัพย์',
          en: 'Kasem Sap',
        },
        districtId: 228,
      },
      {
        id: '301420',
        zipcode: 30150,
        text: 'บ่อปลาทอง',
        value: 'บ่อปลาทอง',
        name: {
          th: 'บ่อปลาทอง',
          en: 'Bo Pla Thong',
        },
        districtId: 228,
      },
      {
        id: '301501',
        zipcode: 30110,
        text: 'ในเมือง',
        value: 'ในเมือง',
        name: {
          th: 'ในเมือง',
          en: 'Nai Mueang',
        },
        districtId: 229,
      },
      {
        id: '301502',
        zipcode: 30110,
        text: 'สัมฤทธิ์',
        value: 'สัมฤทธิ์',
        name: {
          th: 'สัมฤทธิ์',
          en: 'Samrit',
        },
        districtId: 229,
      },
      {
        id: '301503',
        zipcode: 30110,
        text: 'โบสถ์',
        value: 'โบสถ์',
        name: {
          th: 'โบสถ์',
          en: 'Bot',
        },
        districtId: 229,
      },
      {
        id: '301504',
        zipcode: 30110,
        text: 'กระเบื้องใหญ่',
        value: 'กระเบื้องใหญ่',
        name: {
          th: 'กระเบื้องใหญ่',
          en: 'Krabueang Yai',
        },
        districtId: 229,
      },
      {
        id: '301505',
        zipcode: 30110,
        text: 'ท่าหลวง',
        value: 'ท่าหลวง',
        name: {
          th: 'ท่าหลวง',
          en: 'Tha Luang',
        },
        districtId: 229,
      },
      {
        id: '301506',
        zipcode: 30110,
        text: 'รังกาใหญ่',
        value: 'รังกาใหญ่',
        name: {
          th: 'รังกาใหญ่',
          en: 'Rang Ka Yai',
        },
        districtId: 229,
      },
      {
        id: '301507',
        zipcode: 30110,
        text: 'ชีวาน',
        value: 'ชีวาน',
        name: {
          th: 'ชีวาน',
          en: 'Chiwan',
        },
        districtId: 229,
      },
      {
        id: '301508',
        zipcode: 30110,
        text: 'นิคมสร้างตนเอง',
        value: 'นิคมสร้างตนเอง',
        name: {
          th: 'นิคมสร้างตนเอง',
          en: 'Nikhom Sang Ton-eng',
        },
        districtId: 229,
      },
      {
        id: '301509',
        zipcode: 30110,
        text: 'กระชอน',
        value: 'กระชอน',
        name: {
          th: 'กระชอน',
          en: 'Krachon',
        },
        districtId: 229,
      },
      {
        id: '301510',
        zipcode: 30110,
        text: 'ดงใหญ่',
        value: 'ดงใหญ่',
        name: {
          th: 'ดงใหญ่',
          en: 'Dong Yai',
        },
        districtId: 229,
      },
      {
        id: '301511',
        zipcode: 30110,
        text: 'ธารละหลอด',
        value: 'ธารละหลอด',
        name: {
          th: 'ธารละหลอด',
          en: 'Than Lalot',
        },
        districtId: 229,
      },
      {
        id: '301512',
        zipcode: 30110,
        text: 'หนองระเวียง',
        value: 'หนองระเวียง',
        name: {
          th: 'หนองระเวียง',
          en: 'Nong Rawiang',
        },
        districtId: 229,
      },
      {
        id: '301601',
        zipcode: 30240,
        text: 'ห้วยแถลง',
        value: 'ห้วยแถลง',
        name: {
          th: 'ห้วยแถลง',
          en: 'Huai Thalaeng',
        },
        districtId: 230,
      },
      {
        id: '301602',
        zipcode: 30240,
        text: 'ทับสวาย',
        value: 'ทับสวาย',
        name: {
          th: 'ทับสวาย',
          en: 'Thap Sawai',
        },
        districtId: 230,
      },
      {
        id: '301603',
        zipcode: 30240,
        text: 'เมืองพลับพลา',
        value: 'เมืองพลับพลา',
        name: {
          th: 'เมืองพลับพลา',
          en: 'Mueang Phlapphla',
        },
        districtId: 230,
      },
      {
        id: '301604',
        zipcode: 30240,
        text: 'หลุ่งตะเคียน',
        value: 'หลุ่งตะเคียน',
        name: {
          th: 'หลุ่งตะเคียน',
          en: 'Lung Takhian',
        },
        districtId: 230,
      },
      {
        id: '301605',
        zipcode: 30240,
        text: 'หินดาด',
        value: 'หินดาด',
        name: {
          th: 'หินดาด',
          en: 'Hin Dat',
        },
        districtId: 230,
      },
      {
        id: '301606',
        zipcode: 30240,
        text: 'งิ้ว',
        value: 'งิ้ว',
        name: {
          th: 'งิ้ว',
          en: 'Ngio',
        },
        districtId: 230,
      },
      {
        id: '301607',
        zipcode: 30240,
        text: 'กงรถ',
        value: 'กงรถ',
        name: {
          th: 'กงรถ',
          en: 'Kong Rot',
        },
        districtId: 230,
      },
      {
        id: '301608',
        zipcode: 30240,
        text: 'หลุ่งประดู่',
        value: 'หลุ่งประดู่',
        name: {
          th: 'หลุ่งประดู่',
          en: 'Lung Pradu',
        },
        districtId: 230,
      },
      {
        id: '301609',
        zipcode: 30240,
        text: 'ตะโก',
        value: 'ตะโก',
        name: {
          th: 'ตะโก',
          en: 'Tako',
        },
        districtId: 230,
      },
      {
        id: '301610',
        zipcode: 30240,
        text: 'ห้วยแคน',
        value: 'ห้วยแคน',
        name: {
          th: 'ห้วยแคน',
          en: 'Huai Khaen',
        },
        districtId: 230,
      },
      {
        id: '301701',
        zipcode: 30270,
        text: 'ชุมพวง',
        value: 'ชุมพวง',
        name: {
          th: 'ชุมพวง',
          en: 'Chum Phuang',
        },
        districtId: 231,
      },
      {
        id: '301702',
        zipcode: 30270,
        text: 'ประสุข',
        value: 'ประสุข',
        name: {
          th: 'ประสุข',
          en: 'Prasuk',
        },
        districtId: 231,
      },
      {
        id: '301703',
        zipcode: 30270,
        text: 'ท่าลาด',
        value: 'ท่าลาด',
        name: {
          th: 'ท่าลาด',
          en: 'Tha Lat',
        },
        districtId: 231,
      },
      {
        id: '301704',
        zipcode: 30270,
        text: 'สาหร่าย',
        value: 'สาหร่าย',
        name: {
          th: 'สาหร่าย',
          en: 'Sarai',
        },
        districtId: 231,
      },
      {
        id: '301705',
        zipcode: 30270,
        text: 'ตลาดไทร',
        value: 'ตลาดไทร',
        name: {
          th: 'ตลาดไทร',
          en: 'Talat Sai',
        },
        districtId: 231,
      },
      {
        id: '301706',
        zipcode: 30270,
        text: 'ช่องแมว',
        value: 'ช่องแมว',
        name: {
          th: 'ช่องแมว',
          en: 'Chong Maew',
        },
        districtId: 231,
      },
      {
        id: '301707',
        zipcode: 30270,
        text: 'ขุย',
        value: 'ขุย',
        name: {
          th: 'ขุย',
          en: 'Kui',
        },
        districtId: 231,
      },
      {
        id: '301710',
        zipcode: 30270,
        text: 'โนนรัง',
        value: 'โนนรัง',
        name: {
          th: 'โนนรัง',
          en: 'Non Rang',
        },
        districtId: 231,
      },
      {
        id: '301711',
        zipcode: 30270,
        text: 'บ้านยาง',
        value: 'บ้านยาง',
        name: {
          th: 'บ้านยาง',
          en: 'Ban Yang',
        },
        districtId: 231,
      },
      {
        id: '301714',
        zipcode: 30270,
        text: 'หนองหลัก',
        value: 'หนองหลัก',
        name: {
          th: 'หนองหลัก',
          en: 'Nong Lak',
        },
        districtId: 231,
      },
      {
        id: '301715',
        zipcode: 30270,
        text: 'ไพล',
        value: 'ไพล',
        name: {
          th: 'ไพล',
          en: 'Plai',
        },
        districtId: 231,
      },
      {
        id: '301716',
        zipcode: 30270,
        text: 'โนนตูม',
        value: 'โนนตูม',
        name: {
          th: 'โนนตูม',
          en: 'Non Tum',
        },
        districtId: 231,
      },
      {
        id: '301717',
        zipcode: 30270,
        text: 'โนนยอ',
        value: 'โนนยอ',
        name: {
          th: 'โนนยอ',
          en: 'Non Yo',
        },
        districtId: 231,
      },
      {
        id: '301801',
        zipcode: 30170,
        text: 'สูงเนิน',
        value: 'สูงเนิน',
        name: {
          th: 'สูงเนิน',
          en: 'Sung Noen',
        },
        districtId: 232,
      },
      {
        id: '301802',
        zipcode: 30170,
        text: 'เสมา',
        value: 'เสมา',
        name: {
          th: 'เสมา',
          en: 'Sema',
        },
        districtId: 232,
      },
      {
        id: '301803',
        zipcode: 30170,
        text: 'โคราช',
        value: 'โคราช',
        name: {
          th: 'โคราช',
          en: 'Khorat',
        },
        districtId: 232,
      },
      {
        id: '301804',
        zipcode: 30170,
        text: 'บุ่งขี้เหล็ก',
        value: 'บุ่งขี้เหล็ก',
        name: {
          th: 'บุ่งขี้เหล็ก',
          en: 'Bung Khilek',
        },
        districtId: 232,
      },
      {
        id: '301805',
        zipcode: 30170,
        text: 'โนนค่า',
        value: 'โนนค่า',
        name: {
          th: 'โนนค่า',
          en: 'Non Kha',
        },
        districtId: 232,
      },
      {
        id: '301806',
           zipcode: 30170,
           text: 'โค้งยาง',
           value: 'โค้งยาง',
           name: {
             th: 'โค้งยาง',
             en: 'Khong Yang',
           },
           districtId: 232,
        },
      {
        id: '301807',
        zipcode: 30170,
        text: 'มะเกลือเก่า',
        value: 'มะเกลือเก่า',
        name: {
          th: 'มะเกลือเก่า',
          en: 'Makluea Kao',
        },
        districtId: 232,
      },
      {
        id: '301808',
        zipcode: 30170,
        text: 'มะเกลือใหม่',
        value: 'มะเกลือใหม่',
        name: {
          th: 'มะเกลือใหม่',
          en: 'Makluea Mai',
        },
        districtId: 232,
      },
      {
        id: '301809',
        zipcode: 30380,
        text: 'นากลาง',
        value: 'นากลาง',
        name: {
          th: 'นากลาง',
          en: 'Na Klang',
        },
        districtId: 232,
      },
      {
        id: '301810',
        zipcode: 30380,
        text: 'หนองตะไก้',
        value: 'หนองตะไก้',
        name: {
          th: 'หนองตะไก้',
          en: 'Nong Takai',
        },
        districtId: 232,
      },
      {
        id: '301811',
        zipcode: 30380,
        text: 'กุดจิก',
        value: 'กุดจิก',
        name: {
          th: 'กุดจิก',
          en: 'Kut Chik',
        },
        districtId: 232,
      },
      {
        id: '301901',
        zipcode: 30280,
        text: 'ขามทะเลสอ',
        value: 'ขามทะเลสอ',
        name: {
          th: 'ขามทะเลสอ',
          en: 'Kham Thale So',
        },
        districtId: 233,
      },
      {
        id: '301902',
        zipcode: 30280,
        text: 'โป่งแดง',
        value: 'โป่งแดง',
        name: {
          th: 'โป่งแดง',
          en: 'Pong Daeng',
        },
        districtId: 233,
      },
      {
        id: '301903',
        zipcode: 30280,
        text: 'พันดุง',
        value: 'พันดุง',
        name: {
          th: 'พันดุง',
          en: 'Phan Dung',
        },
        districtId: 233,
      },
      {
        id: '301904',
        zipcode: 30280,
        text: 'หนองสรวง',
        value: 'หนองสรวง',
        name: {
          th: 'หนองสรวง',
          en: 'Nong Suang',
        },
        districtId: 233,
      },
      {
        id: '301905',
        zipcode: 30280,
        text: 'บึงอ้อ',
        value: 'บึงอ้อ',
        name: {
          th: 'บึงอ้อ',
          en: 'Bueng O',
        },
        districtId: 233,
      },
      {
        id: '302001',
        zipcode: 30140,
        text: 'สีคิ้ว',
        value: 'สีคิ้ว',
        name: {
          th: 'สีคิ้ว',
          en: 'Sikhio',
        },
        districtId: 234,
      },
      {
        id: '302002',
        zipcode: 30140,
        text: 'บ้านหัน',
        value: 'บ้านหัน',
        name: {
          th: 'บ้านหัน',
          en: 'Ban Han',
        },
        districtId: 234,
      },
      {
        id: '302003',
        zipcode: 30140,
        text: 'กฤษณา',
        value: 'กฤษณา',
        name: {
          th: 'กฤษณา',
          en: 'Kritsana',
        },
        districtId: 234,
      },
      {
        id: '302004',
        zipcode: 30340,
        text: 'ลาดบัวขาว',
        value: 'ลาดบัวขาว',
        name: {
          th: 'ลาดบัวขาว',
          en: 'Lat Bua Khao',
        },
        districtId: 234,
      },
      {
        id: '302005',
        zipcode: 30140,
        text: 'หนองหญ้าขาว',
        value: 'หนองหญ้าขาว',
        name: {
          th: 'หนองหญ้าขาว',
          en: 'Nong Ya Khao',
        },
        districtId: 234,
      },
      {
        id: '302006',
        zipcode: 30140,
        text: 'กุดน้อย',
        value: 'กุดน้อย',
        name: {
          th: 'กุดน้อย',
          en: 'Kut Noi',
        },
        districtId: 234,
      },
      {
        id: '302007',
        zipcode: 30140,
        text: 'หนองน้ำใส',
        value: 'หนองน้ำใส',
        name: {
          th: 'หนองน้ำใส',
          en: 'Nong Nam Sai',
        },
        districtId: 234,
      },
      {
        id: '302008',
        zipcode: 30140,
        text: 'วังโรงใหญ่',
        value: 'วังโรงใหญ่',
        name: {
          th: 'วังโรงใหญ่',
          en: 'Wang Rong Yai',
        },
        districtId: 234,
      },
      {
        id: '302009',
        zipcode: 30140,
        text: 'มิตรภาพ',
        value: 'มิตรภาพ',
        name: {
          th: 'มิตรภาพ',
          en: 'Mittraphap',
        },
        districtId: 234,
      },
      {
        id: '302010',
        zipcode: 30340,
        text: 'คลองไผ่',
        value: 'คลองไผ่',
        name: {
          th: 'คลองไผ่',
          en: 'Khlong Phai',
        },
        districtId: 234,
      },
      {
        id: '302011',
        zipcode: 30140,
        text: 'ดอนเมือง',
        value: 'ดอนเมือง',
        name: {
          th: 'ดอนเมือง',
          en: 'Don Mueang',
        },
        districtId: 234,
      },
      {
        id: '302012',
        zipcode: 30140,
        text: 'หนองบัวน้อย',
        value: 'หนองบัวน้อย',
        name: {
          th: 'หนองบัวน้อย',
          en: 'Nong Bua Noi',
        },
        districtId: 234,
      },
      {
        id: '302101',
        zipcode: 30130,
        text: 'ปากช่อง',
        value: 'ปากช่อง',
        name: {
          th: 'ปากช่อง',
          en: 'Pak Chong',
        },
        districtId: 235,
      },
      {
        id: '302102',
        zipcode: 30320,
        text: 'กลางดง',
        value: 'กลางดง',
        name: {
          th: 'กลางดง',
          en: 'Klang Dong',
        },
        districtId: 235,
      },
      {
        id: '302103',
        zipcode: 30130,
        text: 'จันทึก',
        value: 'จันทึก',
        name: {
          th: 'จันทึก',
          en: 'Chanthuek',
        },
        districtId: 235,
      },
      {
        id: '302104',
        zipcode: 30130,
        text: 'วังกะทะ',
        value: 'วังกะทะ',
        name: {
          th: 'วังกะทะ',
          en: 'Wang Katha',
        },
        districtId: 235,
      },
      {
        id: '302105',
        zipcode: 30130,
        text: 'หมูสี',
        value: 'หมูสี',
        name: {
          th: 'หมูสี',
          en: 'Mu Si',
        },
        districtId: 235,
      },
      {
        id: '302106',
        zipcode: 30130,
        text: 'หนองสาหร่าย',
        value: 'หนองสาหร่าย',
        name: {
          th: 'หนองสาหร่าย',
          en: 'Nong Sarai',
        },
        districtId: 235,
      },
      {
        id: '302107',
        zipcode: 30130,
        text: 'ขนงพระ',
        value: 'ขนงพระ',
        name: {
          th: 'ขนงพระ',
          en: 'Khanong Phra',
        },
        districtId: 235,
      },
      {
        id: '302108',
        zipcode: 30130,
        text: 'โป่งตาลอง',
        value: 'โป่งตาลอง',
        name: {
          th: 'โป่งตาลอง',
          en: 'Pong Talong',
        },
        districtId: 235,
      },
      {
        id: '302109',
        zipcode: 30130,
        text: 'คลองม่วง',
        value: 'คลองม่วง',
        name: {
          th: 'คลองม่วง',
          en: 'Khlong Muang',
        },
        districtId: 235,
      },
      {
        id: '302110',
        zipcode: 30130,
        text: 'หนองน้ำแดง',
        value: 'หนองน้ำแดง',
        name: {
          th: 'หนองน้ำแดง',
          en: 'Nong Nam Daeng',
        },
        districtId: 235,
      },
      {
        id: '302111',
        zipcode: 30130,
        text: 'วังไทร',
        value: 'วังไทร',
        name: {
          th: 'วังไทร',
          en: 'Wang Sai',
        },
        districtId: 235,
      },
      {
        id: '302112',
        zipcode: 30320,
        text: 'พญาเย็น',
        value: 'พญาเย็น',
        name: {
          th: 'พญาเย็น',
          en: 'Phaya Yen',
        },
        districtId: 235,
      },
      {
        id: '302201',
        zipcode: 30410,
        text: 'หนองบุนนาก',
        value: 'หนองบุนนาก',
        name: {
          th: 'หนองบุนนาก',
          en: 'Nong Bunnak',
        },
        districtId: 236,
      },
      {
        id: '302202',
        zipcode: 30410,
        text: 'สารภี',
        value: 'สารภี',
        name: {
          th: 'สารภี',
          en: 'Saraphi',
        },
        districtId: 236,
      },
      {
        id: '302203',
        zipcode: 30410,
        text: 'ไทยเจริญ',
        value: 'ไทยเจริญ',
        name: {
          th: 'ไทยเจริญ',
          en: 'Thai Charoen',
        },
        districtId: 236,
      },
      {
        id: '302204',
        zipcode: 30410,
        text: 'หนองหัวแรต',
        value: 'หนองหัวแรต',
        name: {
          th: 'หนองหัวแรต',
          en: 'Nong Hua Raet',
        },
        districtId: 236,
      },
      {
        id: '302205',
        zipcode: 30410,
        text: 'แหลมทอง',
        value: 'แหลมทอง',
        name: {
          th: 'แหลมทอง',
          en: 'Laem Thong',
        },
        districtId: 236,
      },
      {
        id: '302206',
        zipcode: 30410,
        text: 'หนองตะไก้',
        value: 'หนองตะไก้',
        name: {
          th: 'หนองตะไก้',
          en: 'Nong Takai',
        },
        districtId: 236,
      },
      {
        id: '302207',
        zipcode: 30410,
        text: 'ลุงเขว้า',
        value: 'ลุงเขว้า',
        name: {
          th: 'ลุงเขว้า',
          en: 'Lung Khwao',
        },
        districtId: 236,
      },
      {
        id: '302208',
        zipcode: 30410,
        text: 'หนองไม้ไผ่',
        value: 'หนองไม้ไผ่',
        name: {
          th: 'หนองไม้ไผ่',
          en: 'Nong Mai Phai',
        },
        districtId: 236,
      },
      {
        id: '302209',
        zipcode: 30410,
        text: 'บ้านใหม่',
        value: 'บ้านใหม่',
        name: {
          th: 'บ้านใหม่',
          en: 'Ban Mai',
        },
        districtId: 236,
      },
      {
        id: '302301',
        zipcode: 30440,
        text: 'แก้งสนามนาง',
        value: 'แก้งสนามนาง',
        name: {
          th: 'แก้งสนามนาง',
          en: 'Kaeng Sanam Nang',
        },
        districtId: 237,
      },
      {
        id: '302302',
        zipcode: 30440,
        text: 'โนนสำราญ',
        value: 'โนนสำราญ',
        name: {
          th: 'โนนสำราญ',
          en: 'Non Samran',
        },
        districtId: 237,
      },
      {
        id: '302303',
        zipcode: 30440,
        text: 'บึงพะไล',
        value: 'บึงพะไล',
        name: {
          th: 'บึงพะไล',
          en: 'Bueng Phalai',
        },
        districtId: 237,
      },
      {
        id: '302304',
        zipcode: 30440,
        text: 'สีสุก',
        value: 'สีสุก',
        name: {
          th: 'สีสุก',
          en: 'Si Suk',
        },
        districtId: 237,
      },
      {
        id: '302305',
        zipcode: 30440,
        text: 'บึงสำโรง',
        value: 'บึงสำโรง',
        name: {
          th: 'บึงสำโรง',
          en: 'Bueng Samrong',
        },
        districtId: 237,
      },
      {
        id: '302401',
        zipcode: 30360,
        text: 'โนนแดง',
        value: 'โนนแดง',
        name: {
          th: 'โนนแดง',
          en: 'Non Daeng',
        },
        districtId: 238,
      },
      {
        id: '302402',
        zipcode: 30360,
        text: 'โนนตาเถร',
        value: 'โนนตาเถร',
        name: {
          th: 'โนนตาเถร',
          en: 'Non Ta Then',
        },
        districtId: 238,
      },
      {
        id: '302403',
        zipcode: 30360,
        text: 'สำพะเนียง',
        value: 'สำพะเนียง',
        name: {
          th: 'สำพะเนียง',
          en: 'Samphaniang',
        },
        districtId: 238,
      },
      {
        id: '302404',
        zipcode: 30360,
        text: 'วังหิน',
        value: 'วังหิน',
        name: {
          th: 'วังหิน',
          en: 'Wang Hin',
        },
        districtId: 238,
      },
      {
        id: '302405',
        zipcode: 30360,
        text: 'ดอนยาวใหญ่',
        value: 'ดอนยาวใหญ่',
        name: {
          th: 'ดอนยาวใหญ่',
          en: 'Don Yao Yai',
        },
        districtId: 238,
      },
      {
        id: '302501',
        zipcode: 30370,
        text: 'วังน้ำเขียว',
        value: 'วังน้ำเขียว',
        name: {
          th: 'วังน้ำเขียว',
          en: 'Wang Nam Khiao',
        },
        districtId: 239,
      },
      {
        id: '302502',
        zipcode: 30370,
        text: 'วังหมี',
        value: 'วังหมี',
        name: {
          th: 'วังหมี',
          en: 'Wang Mi',
        },
        districtId: 239,
      },
      {
        id: '302503',
        zipcode: 30150,
        text: 'ระเริง',
        value: 'ระเริง',
        name: {
          th: 'ระเริง',
          en: 'Raroeng',
        },
        districtId: 239,
      },
      {
        id: '302504',
        zipcode: 30370,
        text: 'อุดมทรัพย์',
        value: 'อุดมทรัพย์',
        name: {
          th: 'อุดมทรัพย์',
          en: 'Udom Sap',
        },
        districtId: 239,
      },
      {
        id: '302505',
        zipcode: 30370,
        text: 'ไทยสามัคคี',
        value: 'ไทยสามัคคี',
        name: {
          th: 'ไทยสามัคคี',
          en: 'Thai Samakkhi',
        },
        districtId: 239,
      },
      {
        id: '302601',
        zipcode: 30210,
        text: 'สำนักตะคร้อ',
        value: 'สำนักตะคร้อ',
        name: {
          th: 'สำนักตะคร้อ',
          en: 'Samnak Takhro',
        },
        districtId: 240,
      },
      {
        id: '302602',
        zipcode: 30210,
        text: 'หนองแวง',
        value: 'หนองแวง',
        name: {
          th: 'หนองแวง',
          en: 'Nong Waeng',
        },
        districtId: 240,
      },
      {
        id: '302603',
        zipcode: 30210,
        text: 'บึงปรือ',
        value: 'บึงปรือ',
        name: {
          th: 'บึงปรือ',
          en: 'Bueng Prue',
        },
        districtId: 240,
      },
      {
        id: '302604',
        zipcode: 30210,
        text: 'วังยายทอง',
        value: 'วังยายทอง',
        name: {
          th: 'วังยายทอง',
          en: 'Wang Yai Thong',
        },
        districtId: 240,
      },
      {
        id: '302701',
        zipcode: 30270,
        text: 'เมืองยาง',
        value: 'เมืองยาง',
        name: {
          th: 'เมืองยาง',
          en: 'Mueang Yang',
        },
        districtId: 241,
      },
      {
        id: '302702',
        zipcode: 30270,
        text: 'กระเบื้องนอก',
        value: 'กระเบื้องนอก',
        name: {
          th: 'กระเบื้องนอก',
          en: 'Krabueang Nok',
        },
        districtId: 241,
      },
      {
        id: '302703',
        zipcode: 30270,
        text: 'ละหานปลาค้าว',
        value: 'ละหานปลาค้าว',
        name: {
          th: 'ละหานปลาค้าว',
          en: 'Lahan Pla Khao',
        },
        districtId: 241,
      },
      {
        id: '302704',
        zipcode: 30270,
        text: 'โนนอุดม',
        value: 'โนนอุดม',
        name: {
          th: 'โนนอุดม',
          en: 'Non Udom',
        },
        districtId: 241,
      },
      {
        id: '302801',
        zipcode: 30220,
        text: 'สระพระ',
        value: 'สระพระ',
        name: {
          th: 'สระพระ',
          en: 'Sa Phra',
        },
        districtId: 242,
      },
      {
        id: '302802',
        zipcode: 30220,
        text: 'มาบกราด',
        value: 'มาบกราด',
        name: {
          th: 'มาบกราด',
          en: 'Map Krat',
        },
        districtId: 242,
      },
      {
        id: '302803',
        zipcode: 30220,
        text: 'พังเทียม',
        value: 'พังเทียม',
        name: {
          th: 'พังเทียม',
          en: 'Phang Thiam',
        },
        districtId: 242,
      },
      {
        id: '302804',
        zipcode: 30220,
        text: 'ทัพรั้ง',
        value: 'ทัพรั้ง',
        name: {
          th: 'ทัพรั้ง',
          en: 'Thap Rang',
        },
        districtId: 242,
      },
      {
        id: '302805',
        zipcode: 30220,
        text: 'หนองหอย',
        value: 'หนองหอย',
        name: {
          th: 'หนองหอย',
          en: 'Nong Hoi',
        },
        districtId: 242,
      },
      {
        id: '302901',
        zipcode: 30270,
        text: 'ขุย',
        value: 'ขุย',
        name: {
          th: 'ขุย',
          en: 'Khui',
        },
        districtId: 243,
      },
      {
        id: '302902',
        zipcode: 30270,
        text: 'บ้านยาง',
        value: 'บ้านยาง',
        name: {
          th: 'บ้านยาง',
          en: 'Ban Yang',
        },
        districtId: 243,
      },
      {
        id: '302903',
        zipcode: 30270,
        text: 'ช่องแมว',
        value: 'ช่องแมว',
        name: {
          th: 'ช่องแมว',
          en: 'Chong Maeo',
        },
        districtId: 243,
      },
      {
        id: '302904',
        zipcode: 30270,
        text: 'ไพล',
        value: 'ไพล',
        name: {
          th: 'ไพล',
          en: 'Phlai',
        },
        districtId: 243,
      },
      {
        id: '303001',
        zipcode: 30120,
        text: 'เมืองพะไล',
        value: 'เมืองพะไล',
        name: {
          th: 'เมืองพะไล',
          en: 'Mueang Phalai',
        },
        districtId: 244,
      },
      {
        id: '303002',
        zipcode: 30120,
        text: 'โนนจาน',
        value: 'โนนจาน',
        name: {
          th: 'โนนจาน',
          en: 'Non Chan',
        },
        districtId: 244,
      },
      {
        id: '303003',
        zipcode: 30120,
        text: 'บัวลาย',
        value: 'บัวลาย',
        name: {
          th: 'บัวลาย',
          en: 'Bua Lai',
        },
        districtId: 244,
      },
      {
        id: '303004',
        zipcode: 30120,
        text: 'หนองหว้า',
        value: 'หนองหว้า',
        name: {
          th: 'หนองหว้า',
          en: 'Nong Wa',
        },
        districtId: 244,
      },
      {
        id: '303101',
        zipcode: 30430,
        text: 'สีดา',
        value: 'สีดา',
        name: {
          th: 'สีดา',
          en: 'Sida',
        },
        districtId: 245,
      },
      {
        id: '303102',
        zipcode: 30430,
        text: 'โพนทอง',
        value: 'โพนทอง',
        name: {
          th: 'โพนทอง',
          en: 'Phon Thong',
        },
        districtId: 245,
      },
      {
        id: '303103',
        zipcode: 30430,
        text: 'โนนประดู่',
        value: 'โนนประดู่',
        name: {
          th: 'โนนประดู่',
          en: 'Non Pradu',
        },
        districtId: 245,
      },
      {
        id: '303104',
        zipcode: 30430,
        text: 'สามเมือง',
        value: 'สามเมือง',
        name: {
          th: 'สามเมือง',
          en: 'Sam Mueang',
        },
        districtId: 245,
      },
      {
        id: '303105',
        zipcode: 30430,
        text: 'หนองตาดใหญ่',
        value: 'หนองตาดใหญ่',
        name: {
          th: 'หนองตาดใหญ่',
          en: 'Nong Tat Yai',
        },
        districtId: 245,
      },
      {
        id: '303201',
        zipcode: 30230,
        text: 'ช้างทอง',
        value: 'ช้างทอง',
        name: {
          th: 'ช้างทอง',
          en: 'Chang Thong',
        },
        districtId: 246,
      },
      {
        id: '303202',
        zipcode: 30230,
        text: 'ท่าช้าง',
        value: 'ท่าช้าง',
        name: {
          th: 'ท่าช้าง',
          en: 'Tha Chang',
        },
        districtId: 246,
      },
      {
        id: '303203',
        zipcode: 30230,
        text: 'พระพุทธ',
        value: 'พระพุทธ',
        name: {
          th: 'พระพุทธ',
          en: 'Phra Phut',
        },
        districtId: 246,
      },
      {
        id: '303204',
        zipcode: 30000,
        text: 'หนองงูเหลือม',
        value: 'หนองงูเหลือม',
        name: {
          th: 'หนองงูเหลือม',
          en: 'Nong Ngu Lueam',
        },
        districtId: 246,
      },
      {
        id: '303205',
        zipcode: 30230,
        text: 'หนองยาง',
        value: 'หนองยาง',
        name: {
          th: 'หนองยาง',
          en: 'Nong Yang',
        },
        districtId: 246,
      },
      {
        id: '310101',
        zipcode: 31000,
        text: 'ในเมือง',
        value: 'ในเมือง',
        name: {
          th: 'ในเมือง',
          en: 'Nai Mueang',
        },
        districtId: 250,
      },
      {
        id: '310102',
        zipcode: 31000,
        text: 'อิสาณ',
        value: 'อิสาณ',
        name: {
          th: 'อิสาณ',
          en: 'Isan',
        },
        districtId: 250,
      },
      {
        id: '310103',
        zipcode: 31000,
        text: 'เสม็ด',
        value: 'เสม็ด',
        name: {
          th: 'เสม็ด',
          en: 'Samet',
        },
        districtId: 250,
      },
      {
        id: '310104',
        zipcode: 31000,
        text: 'บ้านบัว',
        value: 'บ้านบัว',
        name: {
          th: 'บ้านบัว',
          en: 'Ban Bua',
        },
        districtId: 250,
      },
      {
        id: '310105',
        zipcode: 31000,
        text: 'สะแกโพรง',
        value: 'สะแกโพรง',
        name: {
          th: 'สะแกโพรง',
          en: 'Sakae Phrong',
        },
        districtId: 250,
      },
      {
        id: '310106',
        zipcode: 31000,
        text: 'สวายจีก',
        value: 'สวายจีก',
        name: {
          th: 'สวายจีก',
          en: 'Sawai Chik',
        },
        districtId: 250,
      },
      {
        id: '310108',
        zipcode: 31000,
        text: 'บ้านยาง',
        value: 'บ้านยาง',
        name: {
          th: 'บ้านยาง',
          en: 'Ban Yang',
        },
        districtId: 250,
      },
      {
        id: '310112',
        zipcode: 31000,
        text: 'พระครู',
        value: 'พระครู',
        name: {
          th: 'พระครู',
          en: 'Phra Khru',
        },
        districtId: 250,
      },
      {
        id: '310113',
        zipcode: 31000,
        text: 'ถลุงเหล็ก',
        value: 'ถลุงเหล็ก',
        name: {
          th: 'ถลุงเหล็ก',
          en: 'Thalung Lek',
        },
        districtId: 250,
      },
      {
        id: '310114',
        zipcode: 31000,
        text: 'หนองตาด',
        value: 'หนองตาด',
        name: {
          th: 'หนองตาด',
          en: 'Nong Tat',
        },
        districtId: 250,
      },
      {
        id: '310117',
        zipcode: 31000,
        text: 'ลุมปุ๊ก',
        value: 'ลุมปุ๊ก',
        name: {
          th: 'ลุมปุ๊ก',
          en: 'Lumpuk',
        },
        districtId: 250,
      },
      {
        id: '310118',
        zipcode: 31000,
        text: 'สองห้อง',
        value: 'สองห้อง',
        name: {
          th: 'สองห้อง',
          en: 'Song Hong',
        },
        districtId: 250,
      },
      {
        id: '310119',
        zipcode: 31000,
        text: 'บัวทอง',
        value: 'บัวทอง',
        name: {
          th: 'บัวทอง',
          en: 'Bua Thong',
        },
        districtId: 250,
      },
      {
        id: '310120',
        zipcode: 31000,
        text: 'ชุมเห็ด',
        value: 'ชุมเห็ด',
        name: {
          th: 'ชุมเห็ด',
          en: 'Chum Het',
        },
        districtId: 250,
      },
      {
        id: '310122',
        zipcode: 31000,
        text: 'หลักเขต',
        value: 'หลักเขต',
        name: {
          th: 'หลักเขต',
          en: 'Lak Khet',
        },
        districtId: 250,
      },
      {
        id: '310125',
        zipcode: 31000,
        text: 'สะแกซำ',
        value: 'สะแกซำ',
        name: {
          th: 'สะแกซำ',
          en: 'Sakae Sam',
        },
        districtId: 250,
      },
      {
        id: '310126',
        zipcode: 31000,
        text: 'กลันทา',
        value: 'กลันทา',
        name: {
          th: 'กลันทา',
          en: 'Kalantha',
        },
        districtId: 250,
      },
      {
        id: '310127',
        zipcode: 31000,
        text: 'กระสัง',
        value: 'กระสัง',
        name: {
          th: 'กระสัง',
          en: 'Krasang',
        },
        districtId: 250,
      },
      {
        id: '310128',
        zipcode: 31000,
        text: 'เมืองฝาง',
        value: 'เมืองฝาง',
        name: {
          th: 'เมืองฝาง',
          en: 'Mueang Fang',
        },
        districtId: 250,
      },
      {
        id: '310201',
        zipcode: 31190,
        text: 'คูเมือง',
        value: 'คูเมือง',
        name: {
          th: 'คูเมือง',
          en: 'Khu Mueang',
        },
        districtId: 251,
      },
      {
        id: '310202',
        zipcode: 31190,
        text: 'ปะเคียบ',
        value: 'ปะเคียบ',
        name: {
          th: 'ปะเคียบ',
          en: 'Pakhiap',
        },
        districtId: 251,
      },
      {
        id: '310203',
        zipcode: 31190,
        text: 'บ้านแพ',
        value: 'บ้านแพ',
        name: {
          th: 'บ้านแพ',
          en: 'Ban Phae',
        },
        districtId: 251,
      },
      {
        id: '310204',
        zipcode: 31190,
        text: 'พรสำราญ',
        value: 'พรสำราญ',
        name: {
          th: 'พรสำราญ',
          en: 'Phon Samran',
        },
        districtId: 251,
      },
      {
        id: '310205',
        zipcode: 31190,
        text: 'หินเหล็กไฟ',
        value: 'หินเหล็กไฟ',
        name: {
          th: 'หินเหล็กไฟ',
          en: 'Hin Lek Fai',
        },
        districtId: 251,
      },
      {
        id: '310206',
        zipcode: 31190,
        text: 'ตูมใหญ่',
        value: 'ตูมใหญ่',
        name: {
          th: 'ตูมใหญ่',
          en: 'Tum Yai',
        },
        districtId: 251,
      },
      {
        id: '310207',
        zipcode: 31190,
        text: 'หนองขมาร',
        value: 'หนองขมาร',
        name: {
          th: 'หนองขมาร',
          en: 'Nong Khaman',
        },
        districtId: 251,
      },
      {
        id: '310301',
        zipcode: 31160,
        text: 'กระสัง',
        value: 'กระสัง',
        name: {
          th: 'กระสัง',
          en: 'Krasang',
        },
        districtId: 252,
      },
      {
        id: '310302',
        zipcode: 31160,
        text: 'ลำดวน',
        value: 'ลำดวน',
        name: {
          th: 'ลำดวน',
          en: 'Lamduan',
        },
        districtId: 252,
      },
      {
        id: '310303',
        zipcode: 31160,
        text: 'สองชั้น',
        value: 'สองชั้น',
        name: {
          th: 'สองชั้น',
          en: 'Song Chan',
        },
        districtId: 252,
      },
      {
        id: '310304',
        zipcode: 31160,
        text: 'สูงเนิน',
        value: 'สูงเนิน',
        name: {
          th: 'สูงเนิน',
          en: 'Sung Noen',
        },
        districtId: 252,
      },
      {
        id: '310305',
        zipcode: 31160,
        text: 'หนองเต็ง',
        value: 'หนองเต็ง',
        name: {
          th: 'หนองเต็ง',
          en: 'Nong Teng',
        },
        districtId: 252,
      },
      {
        id: '310306',
        zipcode: 31160,
        text: 'เมืองไผ่',
        value: 'เมืองไผ่',
        name: {
          th: 'เมืองไผ่',
          en: 'Mueang Phai',
        },
        districtId: 252,
      },
      {
        id: '310307',
        zipcode: 31160,
        text: 'ชุมแสง',
        value: 'ชุมแสง',
        name: {
          th: 'ชุมแสง',
          en: 'Chum Saeng',
        },
        districtId: 252,
      },
      {
        id: '310308',
        zipcode: 31160,
        text: 'บ้านปรือ',
        value: 'บ้านปรือ',
        name: {
          th: 'บ้านปรือ',
          en: 'Ban Prue',
        },
        districtId: 252,
      },
      {
        id: '310309',
        zipcode: 31160,
        text: 'ห้วยสำราญ',
        value: 'ห้วยสำราญ',
        name: {
          th: 'ห้วยสำราญ',
          en: 'Huai Samran',
        },
        districtId: 252,
      },
      {
        id: '310310',
        zipcode: 31160,
        text: 'กันทรารมย์',
        value: 'กันทรารมย์',
        name: {
          th: 'กันทรารมย์',
          en: 'Kanthararom',
        },
        districtId: 252,
      },
      {
        id: '310311',
        zipcode: 31160,
        text: 'ศรีภูมิ',
        value: 'ศรีภูมิ',
        name: {
          th: 'ศรีภูมิ',
          en: 'Si Phum',
        },
        districtId: 252,
      },
      {
        id: '310401',
        zipcode: 31110,
        text: 'นางรอง',
        value: 'นางรอง',
        name: {
          th: 'นางรอง',
          en: 'Nang Rong',
        },
        districtId: 253,
      },
      {
        id: '310403',
        zipcode: 31110,
        text: 'สะเดา',
        value: 'สะเดา',
        name: {
          th: 'สะเดา',
          en: 'Sadao',
        },
        districtId: 253,
      },
      {
        id: '310405',
        zipcode: 31110,
        text: 'ชุมแสง',
        value: 'ชุมแสง',
        name: {
          th: 'ชุมแสง',
          en: 'Chum Saeng',
        },
        districtId: 253,
      },
      {
        id: '310406',
        zipcode: 31110,
        text: 'หนองโบสถ์',
        value: 'หนองโบสถ์',
        name: {
          th: 'หนองโบสถ์',
          en: 'Nong Bot',
        },
        districtId: 253,
      },
      {
        id: '310408',
        zipcode: 31110,
        text: 'หนองกง',
        value: 'หนองกง',
        name: {
          th: 'หนองกง',
          en: 'Nong Kong',
        },
        districtId: 253,
      },
      {
        id: '310413',
        zipcode: 31110,
        text: 'ถนนหัก',
        value: 'ถนนหัก',
        name: {
          th: 'ถนนหัก',
          en: 'Thanon Hak',
        },
        districtId: 253,
      },
      {
        id: '310414',
        zipcode: 31110,
        text: 'หนองไทร',
        value: 'หนองไทร',
        name: {
          th: 'หนองไทร',
          en: 'Nong Sai',
        },
        districtId: 253,
      },
      {
        id: '310415',
        zipcode: 31110,
        text: 'ก้านเหลือง',
        value: 'ก้านเหลือง',
        name: {
          th: 'ก้านเหลือง',
          en: 'Kan Lueang',
        },
        districtId: 253,
      },
      {
        id: '310416',
        zipcode: 31110,
        text: 'บ้านสิงห์',
        value: 'บ้านสิงห์',
        name: {
          th: 'บ้านสิงห์',
          en: 'Ban Sing',
        },
        districtId: 253,
      },
      {
        id: '310417',
        zipcode: 31110,
        text: 'ลำไทรโยง',
        value: 'ลำไทรโยง',
        name: {
          th: 'ลำไทรโยง',
          en: 'Lam Sai Yong',
        },
        districtId: 253,
      },
      {
        id: '310418',
        zipcode: 31110,
        text: 'ทรัพย์พระยา',
        value: 'ทรัพย์พระยา',
        name: {
          th: 'ทรัพย์พระยา',
          en: 'Sap Phraya',
        },
        districtId: 253,
      },
      {
        id: '310424',
        zipcode: 31110,
        text: 'หนองยายพิมพ์',
        value: 'หนองยายพิมพ์',
        name: {
          th: 'หนองยายพิมพ์',
          en: 'Nong Yai Phim',
        },
        districtId: 253,
      },
      {
        id: '310425',
        zipcode: 31110,
        text: 'หัวถนน',
        value: 'หัวถนน',
        name: {
          th: 'หัวถนน',
          en: 'Hua Thanon',
        },
        districtId: 253,
      },
      {
        id: '310426',
        zipcode: 31110,
        text: 'ทุ่งแสงทอง',
        value: 'ทุ่งแสงทอง',
        name: {
          th: 'ทุ่งแสงทอง',
          en: 'Thung Saeng Thong',
        },
        districtId: 253,
      },
      {
        id: '310427',
        zipcode: 31110,
        text: 'หนองโสน',
        value: 'หนองโสน',
        name: {
          th: 'หนองโสน',
          en: 'Nong Sano',
        },
        districtId: 253,
      },
      {
        id: '310501',
        zipcode: 31210,
        text: 'หนองกี่',
        value: 'หนองกี่',
        name: {
          th: 'หนองกี่',
          en: 'Nong Ki',
        },
        districtId: 254,
      },
      {
        id: '310502',
        zipcode: 31210,
        text: 'เย้ยปราสาท',
        value: 'เย้ยปราสาท',
        name: {
          th: 'เย้ยปราสาท',
          en: 'Yoei Prasat',
        },
        districtId: 254,
      },
      {
        id: '310503',
        zipcode: 31210,
        text: 'เมืองไผ่',
        value: 'เมืองไผ่',
        name: {
          th: 'เมืองไผ่',
          en: 'Mueang Phai',
        },
        districtId: 254,
      },
      {
        id: '310504',
        zipcode: 31210,
        text: 'ดอนอะราง',
        value: 'ดอนอะราง',
        name: {
          th: 'ดอนอะราง',
          en: 'Don Arang',
        },
        districtId: 254,
      },
      {
        id: '310505',
        zipcode: 31210,
        text: 'โคกสว่าง',
        value: 'โคกสว่าง',
        name: {
          th: 'โคกสว่าง',
          en: 'Khok Sawang',
        },
        districtId: 254,
      },
      {
        id: '310506',
        zipcode: 31210,
        text: 'ทุ่งกระตาดพัฒนา',
        value: 'ทุ่งกระตาดพัฒนา',
        name: {
          th: 'ทุ่งกระตาดพัฒนา',
          en: 'Thung Kratat Phatthana',
        },
        districtId: 254,
      },
      {
        id: '310507',
        zipcode: 31210,
        text: 'ทุ่งกระเต็น',
        value: 'ทุ่งกระเต็น',
        name: {
          th: 'ทุ่งกระเต็น',
          en: 'Thung Kraten',
        },
        districtId: 254,
      },
      {
        id: '310508',
        zipcode: 31210,
        text: 'ท่าโพธิ์ชัย',
        value: 'ท่าโพธิ์ชัย',
        name: {
          th: 'ท่าโพธิ์ชัย',
          en: 'Tha Pho Chai',
        },
        districtId: 254,
      },
      {
        id: '310509',
        zipcode: 31210,
        text: 'โคกสูง',
        value: 'โคกสูง',
        name: {
          th: 'โคกสูง',
          en: 'Khok Sung',
        },
        districtId: 254,
      },
      {
        id: '310510',
        zipcode: 31210,
        text: 'บุกระสัง',
        value: 'บุกระสัง',
        name: {
          th: 'บุกระสัง',
          en: 'Bu Krasang',
        },
        districtId: 254,
      },
      {
        id: '310601',
        zipcode: 31170,
        text: 'ละหานทราย',
        value: 'ละหานทราย',
        name: {
          th: 'ละหานทราย',
          en: 'Lahan Sai',
        },
        districtId: 255,
      },
      {
        id: '310603',
        zipcode: 31170,
        text: 'ตาจง',
        value: 'ตาจง',
        name: {
          th: 'ตาจง',
          en: 'Ta Chong',
        },
        districtId: 255,
      },
      {
        id: '310604',
        zipcode: 31170,
        text: 'สำโรงใหม่',
        value: 'สำโรงใหม่',
        name: {
          th: 'สำโรงใหม่',
          en: 'Samrong Mai',
        },
        districtId: 255,
      },
      {
        id: '310607',
        zipcode: 31170,
        text: 'หนองแวง',
        value: 'หนองแวง',
        name: {
          th: 'หนองแวง',
          en: 'Nong Waeng',
        },
        districtId: 255,
      },
      {
        id: '310610',
        zipcode: 31170,
        text: 'หนองตะครอง',
        value: 'หนองตะครอง',
        name: {
          th: 'หนองตะครอง',
          en: 'Nong Trakhrong',
        },
        districtId: 255,
      },
      {
        id: '310611',
        zipcode: 31170,
        text: 'โคกว่าน',
        value: 'โคกว่าน',
        name: {
          th: 'โคกว่าน',
          en: 'Khok Wan',
        },
        districtId: 255,
      },
      {
        id: '310701',
        zipcode: 31140,
        text: 'ประโคนชัย',
        value: 'ประโคนชัย',
        name: {
          th: 'ประโคนชัย',
          en: 'Prakhon Chai',
        },
        districtId: 256,
      },
      {
        id: '310702',
        zipcode: 31140,
        text: 'แสลงโทน',
        value: 'แสลงโทน',
        name: {
          th: 'แสลงโทน',
          en: 'Salaeng Thon',
        },
        districtId: 256,
      },
      {
        id: '310703',
        zipcode: 31140,
        text: 'บ้านไทร',
        value: 'บ้านไทร',
        name: {
          th: 'บ้านไทร',
          en: 'Ban Sai',
        },
        districtId: 256,
      },
      {
        id: '310705',
        zipcode: 31140,
        text: 'ละเวี้ย',
        value: 'ละเวี้ย',
        name: {
          th: 'ละเวี้ย',
          en: 'Lawia',
        },
        districtId: 256,
      },
      {
        id: '310706',
        zipcode: 31140,
        text: 'จรเข้มาก',
        value: 'จรเข้มาก',
        name: {
          th: 'จรเข้มาก',
          en: 'Chorakhe Mak',
        },
        districtId: 256,
      },
      {
        id: '310707',
        zipcode: 31140,
        text: 'ปังกู',
        value: 'ปังกู',
        name: {
          th: 'ปังกู',
          en: 'Pang Ku',
        },
        districtId: 256,
      },
      {
        id: '310708',
        zipcode: 31140,
        text: 'โคกย่าง',
        value: 'โคกย่าง',
        name: {
          th: 'โคกย่าง',
          en: 'Khok Yang',
        },
        districtId: 256,
      },
      {
        id: '310710',
        zipcode: 31140,
        text: 'โคกม้า',
        value: 'โคกม้า',
        name: {
          th: 'โคกม้า',
          en: 'Khok Ma',
        },
        districtId: 256,
      },
      {
        id: '310713',
        zipcode: 31140,
        text: 'ไพศาล',
        value: 'ไพศาล',
        name: {
          th: 'ไพศาล',
          en: 'Phaisan',
        },
        districtId: 256,
      },
      {
        id: '310714',
        zipcode: 31140,
        text: 'ตะโกตาพิ',
        value: 'ตะโกตาพิ',
        name: {
          th: 'ตะโกตาพิ',
          en: 'Tako Taphi',
        },
        districtId: 256,
      },
      {
        id: '310715',
        zipcode: 31140,
        text: 'เขาคอก',
        value: 'เขาคอก',
        name: {
          th: 'เขาคอก',
          en: 'Khao Khok',
        },
        districtId: 256,
      },
      {
        id: '310716',
        zipcode: 31140,
        text: 'หนองบอน',
        value: 'หนองบอน',
        name: {
          th: 'หนองบอน',
          en: 'Nong Bon',
        },
        districtId: 256,
      },
      {
        id: '310718',
        zipcode: 31140,
        text: 'โคกมะขาม',
        value: 'โคกมะขาม',
        name: {
          th: 'โคกมะขาม',
          en: 'Khok Makham',
        },
        districtId: 256,
      },
      {
        id: '310719',
        zipcode: 31140,
        text: 'โคกตูม',
        value: 'โคกตูม',
        name: {
          th: 'โคกตูม',
          en: 'Khok Tum',
        },
        districtId: 256,
      },
      {
        id: '310720',
        zipcode: 31140,
        text: 'ประทัดบุ',
        value: 'ประทัดบุ',
        name: {
          th: 'ประทัดบุ',
          en: 'Prathat Bu',
        },
        districtId: 256,
      },
      {
        id: '310721',
        zipcode: 31140,
        text: 'สี่เหลี่ยม',
        value: 'สี่เหลี่ยม',
        name: {
          th: 'สี่เหลี่ยม',
          en: 'Si Liam',
        },
        districtId: 256,
      },
      {
        id: '310801',
        zipcode: 31180,
        text: 'บ้านกรวด',
        value: 'บ้านกรวด',
        name: {
          th: 'บ้านกรวด',
          en: 'Ban Kruat',
        },
        districtId: 257,
      },
      {
        id: '310802',
        zipcode: 31180,
        text: 'โนนเจริญ',
        value: 'โนนเจริญ',
        name: {
          th: 'โนนเจริญ',
          en: 'Non Charoen',
        },
        districtId: 257,
      },
      {
        id: '310803',
        zipcode: 31180,
        text: 'หนองไม้งาม',
        value: 'หนองไม้งาม',
        name: {
          th: 'หนองไม้งาม',
          en: 'Nong Mai Ngam',
        },
        districtId: 257,
      },
      {
        id: '310804',
        zipcode: 31180,
        text: 'ปราสาท',
        value: 'ปราสาท',
        name: {
          th: 'ปราสาท',
          en: 'Prasat',
        },
        districtId: 257,
      },
      {
        id: '310805',
        zipcode: 31180,
        text: 'สายตะกู',
        value: 'สายตะกู',
        name: {
          th: 'สายตะกู',
          en: 'Sai Taku',
        },
        districtId: 257,
      },
      {
        id: '310806',
        zipcode: 31180,
        text: 'หินลาด',
        value: 'หินลาด',
        name: {
          th: 'หินลาด',
          en: 'Hin Lat',
        },
        districtId: 257,
      },
      {
        id: '310807',
        zipcode: 31180,
        text: 'บึงเจริญ',
        value: 'บึงเจริญ',
        name: {
          th: 'บึงเจริญ',
          en: 'Bueng Charoen',
        },
        districtId: 257,
      },
      {
        id: '310808',
        zipcode: 31180,
        text: 'จันทบเพชร',
        value: 'จันทบเพชร',
        name: {
          th: 'จันทบเพชร',
          en: 'Chanthop Phet',
        },
        districtId: 257,
      },
      {
        id: '310809',
        zipcode: 31180,
        text: 'เขาดินเหนือ',
        value: 'เขาดินเหนือ',
        name: {
          th: 'เขาดินเหนือ',
          en: 'Khao Din Nuea',
        },
        districtId: 257,
      },
      {
        id: '310901',
        zipcode: 31120,
        text: 'พุทไธสง',
        value: 'พุทไธสง',
        name: {
          th: 'พุทไธสง',
          en: 'Phutthaisong',
        },
        districtId: 258,
      },
      {
        id: '310902',
        zipcode: 31120,
        text: 'มะเฟือง',
        value: 'มะเฟือง',
        name: {
          th: 'มะเฟือง',
          en: 'Mafueang',
        },
        districtId: 258,
      },
      {
        id: '310903',
        zipcode: 31120,
        text: 'บ้านจาน',
        value: 'บ้านจาน',
        name: {
          th: 'บ้านจาน',
          en: 'Ban Chan',
        },
        districtId: 258,
      },
      {
        id: '310906',
        zipcode: 31120,
        text: 'บ้านเป้า',
        value: 'บ้านเป้า',
        name: {
          th: 'บ้านเป้า',
          en: 'Ban Pao',
        },
        districtId: 258,
      },
      {
        id: '310907',
        zipcode: 31120,
        text: 'บ้านแวง',
        value: 'บ้านแวง',
        name: {
          th: 'บ้านแวง',
          en: 'Ban Waeng',
        },
        districtId: 258,
      },
      {
        id: '310909',
        zipcode: 31120,
        text: 'บ้านยาง',
        value: 'บ้านยาง',
        name: {
          th: 'บ้านยาง',
          en: 'Ban Yang',
        },
        districtId: 258,
      },
      {
        id: '310910',
        zipcode: 31120,
        text: 'หายโศก',
        value: 'หายโศก',
        name: {
          th: 'หายโศก',
          en: 'Hai Sok',
        },
        districtId: 258,
      },
      {
        id: '311001',
        zipcode: 31130,
        text: 'ลำปลายมาศ',
        value: 'ลำปลายมาศ',
        name: {
          th: 'ลำปลายมาศ',
          en: 'Lam Plai Mat',
        },
        districtId: 259,
      },
      {
        id: '311002',
        zipcode: 31130,
        text: 'หนองคู',
        value: 'หนองคู',
        name: {
          th: 'หนองคู',
          en: 'Nong Khu',
        },
        districtId: 259,
      },
      {
        id: '311003',
        zipcode: 31130,
        text: 'แสลงพัน',
        value: 'แสลงพัน',
        name: {
          th: 'แสลงพัน',
          en: 'Salaeng Phan',
        },
        districtId: 259,
      },
      {
        id: '311004',
        zipcode: 31130,
        text: 'ทะเมนชัย',
        value: 'ทะเมนชัย',
        name: {
          th: 'ทะเมนชัย',
          en: 'Thamen Chai',
        },
        districtId: 259,
      },
      {
        id: '311005',
        zipcode: 31130,
        text: 'ตลาดโพธิ์',
        value: 'ตลาดโพธิ์',
        name: {
          th: 'ตลาดโพธิ์',
          en: 'Talat Pho',
        },
        districtId: 259,
      },
      {
        id: '311006',
        zipcode: 31130,
        text: 'หนองกะทิง',
        value: 'หนองกะทิง',
        name: {
          th: 'หนองกะทิง',
          en: 'Nong Kathing',
        },
        districtId: 259,
      },
      {
        id: '311007',
        zipcode: 31130,
        text: 'โคกกลาง',
        value: 'โคกกลาง',
        name: {
          th: 'โคกกลาง',
          en: 'Khok Klang',
        },
        districtId: 259,
      },
      {
        id: '311008',
        zipcode: 31130,
        text: 'โคกสะอาด',
        value: 'โคกสะอาด',
        name: {
          th: 'โคกสะอาด',
          en: 'Khok Sa-at',
        },
        districtId: 259,
      },
      {
        id: '311009',
        zipcode: 31130,
        text: 'เมืองแฝก',
        value: 'เมืองแฝก',
        name: {
          th: 'เมืองแฝก',
          en: 'Mueang Faek',
        },
        districtId: 259,
      },
      {
        id: '311010',
        zipcode: 31130,
        text: 'บ้านยาง',
        value: 'บ้านยาง',
        name: {
          th: 'บ้านยาง',
          en: 'Ban Yang',
        },
        districtId: 259,
      },
      {
        id: '311011',
        zipcode: 31130,
        text: 'ผไทรินทร์',
        value: 'ผไทรินทร์',
        name: {
          th: 'ผไทรินทร์',
          en: 'Phathairin',
        },
        districtId: 259,
      },
      {
        id: '311012',
        zipcode: 31130,
        text: 'โคกล่าม',
        value: 'โคกล่าม',
        name: {
          th: 'โคกล่าม',
          en: 'Khok Lam',
        },
        districtId: 259,
      },
      {
        id: '311013',
        zipcode: 31130,
        text: 'หินโคน',
        value: 'หินโคน',
        name: {
          th: 'หินโคน',
          en: 'Hin Khon',
        },
        districtId: 259,
      },
      {
        id: '311014',
        zipcode: 31130,
        text: 'หนองบัวโคก',
        value: 'หนองบัวโคก',
        name: {
          th: 'หนองบัวโคก',
          en: 'Nong Bua Khok',
        },
        districtId: 259,
      },
      {
        id: '311015',
        zipcode: 31130,
        text: 'บุโพธิ์',
        value: 'บุโพธิ์',
        name: {
          th: 'บุโพธิ์',
          en: 'Bu Pho',
        },
        districtId: 259,
      },
      {
        id: '311016',
        zipcode: 31130,
        text: 'หนองโดน',
        value: 'หนองโดน',
        name: {
          th: 'หนองโดน',
          en: 'Nong Don',
        },
        districtId: 259,
      },
      {
        id: '311101',
        zipcode: 31150,
        text: 'สตึก',
        value: 'สตึก',
        name: {
          th: 'สตึก',
          en: 'Satuek',
        },
        districtId: 260,
      },
      {
        id: '311102',
        zipcode: 31150,
        text: 'นิคม',
        value: 'นิคม',
        name: {
          th: 'นิคม',
          en: 'Nikhom',
        },
        districtId: 260,
      },
      {
        id: '311103',
        zipcode: 31150,
        text: 'ทุ่งวัง',
        value: 'ทุ่งวัง',
        name: {
          th: 'ทุ่งวัง',
          en: 'Thung Wang',
        },
        districtId: 260,
      },
      {
        id: '311104',
        zipcode: 31150,
        text: 'เมืองแก',
        value: 'เมืองแก',
        name: {
          th: 'เมืองแก',
          en: 'Mueang Kae',
        },
        districtId: 260,
      },
      {
        id: '311105',
        zipcode: 31150,
        text: 'หนองใหญ่',
        value: 'หนองใหญ่',
        name: {
          th: 'หนองใหญ่',
          en: 'Nong Yai',
        },
        districtId: 260,
      },
      {
        id: '311106',
        zipcode: 31150,
        text: 'ร่อนทอง',
        value: 'ร่อนทอง',
        name: {
          th: 'ร่อนทอง',
          en: 'Ron Thong',
        },
        districtId: 260,
      },
      {
        id: '311109',
        zipcode: 31150,
        text: 'ดอนมนต์',
        value: 'ดอนมนต์',
        name: {
          th: 'ดอนมนต์',
          en: 'Don Mon',
        },
        districtId: 260,
      },
      {
        id: '311110',
        zipcode: 31150,
        text: 'ชุมแสง',
        value: 'ชุมแสง',
        name: {
          th: 'ชุมแสง',
          en: 'Chum Saeng',
        },
        districtId: 260,
      },
      {
        id: '311111',
        zipcode: 31150,
        text: 'ท่าม่วง',
        value: 'ท่าม่วง',
        name: {
          th: 'ท่าม่วง',
          en: 'Tha Muang',
        },
        districtId: 260,
      },
      {
        id: '311112',
        zipcode: 31150,
        text: 'สะแก',
        value: 'สะแก',
        name: {
          th: 'สะแก',
          en: 'Sakae',
        },
        districtId: 260,
      },
      {
        id: '311114',
        zipcode: 31150,
        text: 'สนามชัย',
        value: 'สนามชัย',
        name: {
          th: 'สนามชัย',
          en: 'Sanam Chai',
        },
        districtId: 260,
      },
      {
        id: '311115',
        zipcode: 31150,
        text: 'กระสัง',
        value: 'กระสัง',
        name: {
          th: 'กระสัง',
          en: 'Krasang',
        },
        districtId: 260,
      },
      {
        id: '311201',
        zipcode: 31220,
        text: 'ปะคำ',
        value: 'ปะคำ',
        name: {
          th: 'ปะคำ',
          en: 'Pakham',
        },
        districtId: 261,
      },
      {
        id: '311202',
        zipcode: 31220,
        text: 'ไทยเจริญ',
        value: 'ไทยเจริญ',
        name: {
          th: 'ไทยเจริญ',
          en: 'Thai Charoen',
        },
        districtId: 261,
      },
      {
        id: '311203',
        zipcode: 31220,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 261,
      },
      {
        id: '311204',
        zipcode: 31220,
        text: 'โคกมะม่วง',
        value: 'โคกมะม่วง',
        name: {
          th: 'โคกมะม่วง',
          en: 'Khok Mamuang',
        },
        districtId: 261,
      },
      {
        id: '311205',
        zipcode: 31220,
        text: 'หูทำนบ',
        value: 'หูทำนบ',
        name: {
          th: 'หูทำนบ',
          en: 'Hu Thamnop',
        },
        districtId: 261,
      },
      {
        id: '311301',
        zipcode: 31230,
        text: 'นาโพธิ์',
        value: 'นาโพธิ์',
        name: {
          th: 'นาโพธิ์',
          en: 'Na Pho',
        },
        districtId: 262,
      },
      {
        id: '311302',
        zipcode: 31230,
        text: 'บ้านคู',
        value: 'บ้านคู',
        name: {
          th: 'บ้านคู',
          en: 'Ban Khu',
        },
        districtId: 262,
      },
      {
        id: '311303',
        zipcode: 31230,
        text: 'บ้านดู่',
        value: 'บ้านดู่',
        name: {
          th: 'บ้านดู่',
          en: 'Ban Du',
        },
        districtId: 262,
      },
      {
        id: '311304',
        zipcode: 31230,
        text: 'ดอนกอก',
        value: 'ดอนกอก',
        name: {
          th: 'ดอนกอก',
          en: 'Don Kok',
        },
        districtId: 262,
      },
      {
        id: '311305',
        zipcode: 31230,
        text: 'ศรีสว่าง',
        value: 'ศรีสว่าง',
        name: {
          th: 'ศรีสว่าง',
          en: 'Si Sawang',
        },
        districtId: 262,
      },
      {
        id: '311401',
        zipcode: 31240,
        text: 'สระแก้ว',
        value: 'สระแก้ว',
        name: {
          th: 'สระแก้ว',
          en: 'Sa Kaeo',
        },
        districtId: 263,
      },
      {
        id: '311402',
        zipcode: 31240,
        text: 'ห้วยหิน',
        value: 'ห้วยหิน',
        name: {
          th: 'ห้วยหิน',
          en: 'Huai Hin',
        },
        districtId: 263,
      },
      {
        id: '311403',
        zipcode: 31240,
        text: 'ไทยสามัคคี',
        value: 'ไทยสามัคคี',
        name: {
          th: 'ไทยสามัคคี',
          en: 'Thai Samakkhi',
        },
        districtId: 263,
      },
      {
        id: '311404',
        zipcode: 31240,
        text: 'หนองชัยศรี',
        value: 'หนองชัยศรี',
        name: {
          th: 'หนองชัยศรี',
          en: 'Nong Chai Si',
        },
        districtId: 263,
      },
      {
        id: '311405',
        zipcode: 31240,
        text: 'เสาเดียว',
        value: 'เสาเดียว',
        name: {
          th: 'เสาเดียว',
          en: 'Sao Diao',
        },
        districtId: 263,
      },
      {
        id: '311406',
        zipcode: 31240,
        text: 'เมืองฝ้าย',
        value: 'เมืองฝ้าย',
        name: {
          th: 'เมืองฝ้าย',
          en: 'Mueang Fai',
        },
        districtId: 263,
      },
      {
        id: '311407',
        zipcode: 31240,
        text: 'สระทอง',
        value: 'สระทอง',
        name: {
          th: 'สระทอง',
          en: 'Sa Thong',
        },
        districtId: 263,
      },
      {
        id: '311501',
        zipcode: 31250,
        text: 'จันดุม',
        value: 'จันดุม',
        name: {
          th: 'จันดุม',
          en: 'Chan Dum',
        },
        districtId: 264,
      },
      {
        id: '311502',
        zipcode: 31250,
        text: 'โคกขมิ้น',
        value: 'โคกขมิ้น',
        name: {
          th: 'โคกขมิ้น',
          en: 'Khok Khamin',
        },
        districtId: 264,
      },
      {
        id: '311503',
        zipcode: 31250,
        text: 'ป่าชัน',
        value: 'ป่าชัน',
        name: {
          th: 'ป่าชัน',
          en: 'Pa Chan',
        },
        districtId: 264,
      },
      {
        id: '311504',
        zipcode: 31250,
        text: 'สะเดา',
        value: 'สะเดา',
        name: {
          th: 'สะเดา',
          en: 'Sadao',
        },
        districtId: 264,
      },
      {
        id: '311505',
        zipcode: 31250,
        text: 'สำโรง',
        value: 'สำโรง',
        name: {
          th: 'สำโรง',
          en: 'Samrong',
        },
        districtId: 264,
      },
      {
        id: '311601',
        zipcode: 31000,
        text: 'ห้วยราช',
        value: 'ห้วยราช',
        name: {
          th: 'ห้วยราช',
          en: 'Huai Rat',
        },
        districtId: 265,
      },
      {
        id: '311602',
        zipcode: 31000,
        text: 'สามแวง',
        value: 'สามแวง',
        name: {
          th: 'สามแวง',
          en: 'Sam Waeng',
        },
        districtId: 265,
      },
      {
        id: '311603',
        zipcode: 31000,
        text: 'ตาเสา',
        value: 'ตาเสา',
        name: {
          th: 'ตาเสา',
          en: 'Ta Sao',
        },
        districtId: 265,
      },
      {
        id: '311604',
        zipcode: 31000,
        text: 'บ้านตะโก',
        value: 'บ้านตะโก',
        name: {
          th: 'บ้านตะโก',
          en: 'Ban Tako',
        },
        districtId: 265,
      },
      {
        id: '311605',
        zipcode: 31000,
        text: 'สนวน',
        value: 'สนวน',
        name: {
          th: 'สนวน',
          en: 'Sanuan',
        },
        districtId: 265,
      },
      {
        id: '311606',
        zipcode: 31000,
        text: 'โคกเหล็ก',
        value: 'โคกเหล็ก',
        name: {
          th: 'โคกเหล็ก',
          en: 'Khok Lek',
        },
        districtId: 265,
      },
      {
        id: '311607',
        zipcode: 31000,
        text: 'เมืองโพธิ์',
        value: 'เมืองโพธิ์',
        name: {
          th: 'เมืองโพธิ์',
          en: 'Mueang Pho',
        },
        districtId: 265,
      },
      {
        id: '311608',
        zipcode: 31000,
        text: 'ห้วยราชา',
        value: 'ห้วยราชา',
        name: {
          th: 'ห้วยราชา',
          en: 'Huai Racha',
        },
        districtId: 265,
      },
      {
        id: '311701',
        zipcode: 31110,
        text: 'โนนสุวรรณ',
        value: 'โนนสุวรรณ',
        name: {
          th: 'โนนสุวรรณ',
          en: 'Non Suwan',
        },
        districtId: 266,
      },
      {
        id: '311702',
        zipcode: 31110,
        text: 'ทุ่งจังหัน',
        value: 'ทุ่งจังหัน',
        name: {
          th: 'ทุ่งจังหัน',
          en: 'Thung Changhan',
        },
        districtId: 266,
      },
      {
        id: '311703',
        zipcode: 31110,
        text: 'โกรกแก้ว',
        value: 'โกรกแก้ว',
        name: {
          th: 'โกรกแก้ว',
          en: 'Krok Kaeo',
        },
        districtId: 266,
      },
      {
        id: '311704',
        zipcode: 31110,
        text: 'ดงอีจาน',
        value: 'ดงอีจาน',
        name: {
          th: 'ดงอีจาน',
          en: 'Dong I Chan',
        },
        districtId: 266,
      },
      {
        id: '311801',
        zipcode: 31110,
        text: 'ชำนิ',
        value: 'ชำนิ',
        name: {
          th: 'ชำนิ',
          en: 'Chamni',
        },
        districtId: 267,
      },
      {
        id: '311802',
        zipcode: 31110,
        text: 'หนองปล่อง',
        value: 'หนองปล่อง',
        name: {
          th: 'หนองปล่อง',
          en: 'Nong Plong',
        },
        districtId: 267,
      },
      {
        id: '311803',
        zipcode: 31110,
        text: 'เมืองยาง',
        value: 'เมืองยาง',
        name: {
          th: 'เมืองยาง',
          en: 'Mueang Yang',
        },
        districtId: 267,
      },
      {
        id: '311804',
        zipcode: 31110,
        text: 'ช่อผกา',
        value: 'ช่อผกา',
        name: {
          th: 'ช่อผกา',
          en: 'Cho Phaka',
        },
        districtId: 267,
      },
      {
        id: '311805',
        zipcode: 31110,
        text: 'ละลวด',
        value: 'ละลวด',
        name: {
          th: 'ละลวด',
          en: 'Laluat',
        },
        districtId: 267,
      },
      {
        id: '311806',
        zipcode: 31110,
        text: 'โคกสนวน',
        value: 'โคกสนวน',
        name: {
          th: 'โคกสนวน',
          en: 'Khok Sanuan',
        },
        districtId: 267,
      },
      {
        id: '311901',
        zipcode: 31120,
        text: 'หนองแวง',
        value: 'หนองแวง',
        name: {
          th: 'หนองแวง',
          en: 'Nong Waeng',
        },
        districtId: 268,
      },
      {
        id: '311902',
        zipcode: 31120,
        text: 'ทองหลาง',
        value: 'ทองหลาง',
        name: {
          th: 'ทองหลาง',
          en: 'Thonglang',
        },
        districtId: 268,
      },
      {
        id: '311903',
        zipcode: 31120,
        text: 'แดงใหญ่',
        value: 'แดงใหญ่',
        name: {
          th: 'แดงใหญ่',
          en: 'Daeng Yai',
        },
        districtId: 268,
      },
      {
        id: '311904',
        zipcode: 31120,
        text: 'กู่สวนแตง',
        value: 'กู่สวนแตง',
        name: {
          th: 'กู่สวนแตง',
          en: 'Ku Suan Taeng',
        },
        districtId: 268,
      },
      {
        id: '311905',
        zipcode: 31120,
        text: 'หนองเยือง',
        value: 'หนองเยือง',
        name: {
          th: 'หนองเยือง',
          en: 'Nong Yueang',
        },
        districtId: 268,
      },
      {
        id: '312001',
        zipcode: 31260,
        text: 'โนนดินแดง',
        value: 'โนนดินแดง',
        name: {
          th: 'โนนดินแดง',
          en: 'Non Din Daeng',
        },
        districtId: 269,
      },
      {
        id: '312002',
        zipcode: 31260,
        text: 'ส้มป่อย',
        value: 'ส้มป่อย',
        name: {
          th: 'ส้มป่อย',
          en: 'Som Poi',
        },
        districtId: 269,
      },
      {
        id: '312003',
        zipcode: 31260,
        text: 'ลำนางรอง',
        value: 'ลำนางรอง',
        name: {
          th: 'ลำนางรอง',
          en: 'Lam Nang Rong',
        },
        districtId: 269,
      },
      {
        id: '312101',
        zipcode: 31000,
        text: 'บ้านด่าน',
        value: 'บ้านด่าน',
        name: {
          th: 'บ้านด่าน',
          en: 'Ban Dan',
        },
        districtId: 270,
      },
      {
        id: '312102',
        zipcode: 31000,
        text: 'ปราสาท',
        value: 'ปราสาท',
        name: {
          th: 'ปราสาท',
          en: 'Prasat',
        },
        districtId: 270,
      },
      {
        id: '312103',
        zipcode: 31000,
        text: 'วังเหนือ',
        value: 'วังเหนือ',
        name: {
          th: 'วังเหนือ',
          en: 'Wang Nuea',
        },
        districtId: 270,
      },
      {
        id: '312104',
        zipcode: 31000,
        text: 'โนนขวาง',
        value: 'โนนขวาง',
        name: {
          th: 'โนนขวาง',
          en: 'Non Khwang',
        },
        districtId: 270,
      },
      {
        id: '312201',
        zipcode: 31150,
        text: 'แคนดง',
        value: 'แคนดง',
        name: {
          th: 'แคนดง',
          en: 'Khaen Dong',
        },
        districtId: 271,
      },
      {
        id: '312202',
        zipcode: 31150,
        text: 'ดงพลอง',
        value: 'ดงพลอง',
        name: {
          th: 'ดงพลอง',
          en: 'Dong Phlong',
        },
        districtId: 271,
      },
      {
        id: '312203',
        zipcode: 31150,
        text: 'สระบัว',
        value: 'สระบัว',
        name: {
          th: 'สระบัว',
          en: 'Sa Bua',
        },
        districtId: 271,
      },
      {
        id: '312204',
        zipcode: 31150,
        text: 'หัวฝาย',
        value: 'หัวฝาย',
        name: {
          th: 'หัวฝาย',
          en: 'Hua Fai',
        },
        districtId: 271,
      },
      {
        id: '312301',
        zipcode: 31110,
        text: 'เจริญสุข',
        value: 'เจริญสุข',
        name: {
          th: 'เจริญสุข',
          en: 'Charoen Suk',
        },
        districtId: 272,
      },
      {
        id: '312302',
        zipcode: 31110,
        text: 'ตาเป๊ก',
        value: 'ตาเป๊ก',
        name: {
          th: 'ตาเป๊ก',
          en: 'Ta Pek',
        },
        districtId: 272,
      },
      {
        id: '312303',
        zipcode: 31110,
        text: 'อีสานเขต',
        value: 'อีสานเขต',
        name: {
          th: 'อีสานเขต',
          en: 'Isan Khet',
        },
        districtId: 272,
      },
      {
        id: '312304',
        zipcode: 31170,
        text: 'ถาวร',
        value: 'ถาวร',
        name: {
          th: 'ถาวร',
          en: 'Thawon',
        },
        districtId: 272,
      },
      {
        id: '312305',
        zipcode: 31170,
        text: 'ยายแย้มวัฒนา',
        value: 'ยายแย้มวัฒนา',
        name: {
          th: 'ยายแย้มวัฒนา',
          en: 'Yai Yaem Watthana',
        },
        districtId: 272,
      },
      {
        id: '320101',
        zipcode: 32000,
        text: 'ในเมือง',
        value: 'ในเมือง',
        name: {
          th: 'ในเมือง',
          en: 'Nai Mueang',
        },
        districtId: 273,
      },
      {
        id: '320102',
        zipcode: 32000,
        text: 'ตั้งใจ',
        value: 'ตั้งใจ',
        name: {
          th: 'ตั้งใจ',
          en: 'Tang Chai',
        },
        districtId: 273,
      },
      {
        id: '320103',
        zipcode: 32000,
        text: 'เพี้ยราม',
        value: 'เพี้ยราม',
        name: {
          th: 'เพี้ยราม',
          en: 'Phia Ram',
        },
        districtId: 273,
      },
      {
        id: '320104',
        zipcode: 32000,
        text: 'นาดี',
        value: 'นาดี',
        name: {
          th: 'นาดี',
          en: 'Na Di',
        },
        districtId: 273,
      },
      {
        id: '320105',
        zipcode: 32000,
        text: 'ท่าสว่าง',
        value: 'ท่าสว่าง',
        name: {
          th: 'ท่าสว่าง',
          en: 'Tha Sawang',
        },
        districtId: 273,
      },
      {
        id: '320106',
        zipcode: 32000,
        text: 'สลักได',
        value: 'สลักได',
        name: {
          th: 'สลักได',
          en: 'Salakdai',
        },
        districtId: 273,
      },
      {
        id: '320107',
        zipcode: 32000,
        text: 'ตาอ็อง',
        value: 'ตาอ็อง',
        name: {
          th: 'ตาอ็อง',
          en: 'Ta Ong',
        },
        districtId: 273,
      },
      {
        id: '320109',
        zipcode: 32000,
        text: 'สำโรง',
        value: 'สำโรง',
        name: {
          th: 'สำโรง',
          en: 'Samrong',
        },
        districtId: 273,
      },
      {
        id: '320110',
        zipcode: 32000,
        text: 'แกใหญ่',
        value: 'แกใหญ่',
        name: {
          th: 'แกใหญ่',
          en: 'Kae Yai',
        },
        districtId: 273,
      },
      {
        id: '320111',
        zipcode: 32000,
        text: 'นอกเมือง',
        value: 'นอกเมือง',
        name: {
          th: 'นอกเมือง',
          en: 'Nok Mueang',
        },
        districtId: 273,
      },
      {
        id: '320112',
        zipcode: 32000,
        text: 'คอโค',
        value: 'คอโค',
        name: {
          th: 'คอโค',
          en: 'Kho Kho',
        },
        districtId: 273,
      },
      {
        id: '320113',
        zipcode: 32000,
        text: 'สวาย',
        value: 'สวาย',
        name: {
          th: 'สวาย',
          en: 'Sawai',
        },
        districtId: 273,
      },
      {
        id: '320114',
        zipcode: 32000,
        text: 'เฉนียง',
        value: 'เฉนียง',
        name: {
          th: 'เฉนียง',
          en: 'Chaniang',
        },
        districtId: 273,
      },
      {
        id: '320116',
        zipcode: 32000,
        text: 'เทนมีย์',
        value: 'เทนมีย์',
        name: {
          th: 'เทนมีย์',
          en: 'Thenmi',
        },
        districtId: 273,
      },
      {
        id: '320118',
        zipcode: 32000,
        text: 'นาบัว',
        value: 'นาบัว',
        name: {
          th: 'นาบัว',
          en: 'Na Bua',
        },
        districtId: 273,
      },
      {
        id: '320119',
        zipcode: 32000,
        text: 'เมืองที',
        value: 'เมืองที',
        name: {
          th: 'เมืองที',
          en: 'Mueang Thi',
        },
        districtId: 273,
      },
      {
        id: '320120',
        zipcode: 32000,
        text: 'ราม',
        value: 'ราม',
        name: {
          th: 'ราม',
          en: 'Ram',
        },
        districtId: 273,
      },
      {
        id: '320121',
        zipcode: 32000,
        text: 'บุฤาษี',
        value: 'บุฤาษี',
        name: {
          th: 'บุฤาษี',
          en: 'Bu Ruesi',
        },
        districtId: 273,
      },
      {
        id: '320122',
        zipcode: 32000,
        text: 'ตระแสง',
        value: 'ตระแสง',
        name: {
          th: 'ตระแสง',
          en: 'Trasaeng',
        },
        districtId: 273,
      },
      {
        id: '320125',
        zipcode: 32000,
        text: 'แสลงพันธ์',
        value: 'แสลงพันธ์',
        name: {
          th: 'แสลงพันธ์',
          en: 'Salaeng Phan',
        },
        districtId: 273,
      },
      {
        id: '320126',
        zipcode: 32000,
        text: 'กาเกาะ',
        value: 'กาเกาะ',
        name: {
          th: 'กาเกาะ',
          en: 'Ka Ko',
        },
        districtId: 273,
      },
      {
        id: '320201',
        zipcode: 32190,
        text: 'ชุมพลบุรี',
        value: 'ชุมพลบุรี',
        name: {
          th: 'ชุมพลบุรี',
          en: 'Chumphon Buri',
        },
        districtId: 274,
      },
      {
        id: '320202',
        zipcode: 32190,
        text: 'นาหนองไผ่',
        value: 'นาหนองไผ่',
        name: {
          th: 'นาหนองไผ่',
          en: 'Na Nong Phai',
        },
        districtId: 274,
      },
      {
        id: '320203',
        zipcode: 32190,
        text: 'ไพรขลา',
        value: 'ไพรขลา',
        name: {
          th: 'ไพรขลา',
          en: 'Phrai Khla',
        },
        districtId: 274,
      },
      {
        id: '320204',
        zipcode: 32190,
        text: 'ศรีณรงค์',
        value: 'ศรีณรงค์',
        name: {
          th: 'ศรีณรงค์',
          en: 'Si Narong',
        },
        districtId: 274,
      },
      {
        id: '320205',
        zipcode: 32190,
        text: 'ยะวึก',
        value: 'ยะวึก',
        name: {
          th: 'ยะวึก',
          en: 'Yawuek',
        },
        districtId: 274,
      },
      {
        id: '320206',
        zipcode: 32190,
        text: 'เมืองบัว',
        value: 'เมืองบัว',
        name: {
          th: 'เมืองบัว',
          en: 'Mueang Bua',
        },
        districtId: 274,
      },
      {
        id: '320207',
        zipcode: 32190,
        text: 'สระขุด',
        value: 'สระขุด',
        name: {
          th: 'สระขุด',
          en: 'Sa Khut',
        },
        districtId: 274,
      },
      {
        id: '320208',
        zipcode: 32190,
        text: 'กระเบื้อง',
        value: 'กระเบื้อง',
        name: {
          th: 'กระเบื้อง',
          en: 'Krabueang',
        },
        districtId: 274,
      },
      {
        id: '320209',
        zipcode: 32190,
        text: 'หนองเรือ',
        value: 'หนองเรือ',
        name: {
          th: 'หนองเรือ',
          en: 'Nong Ruea',
        },
        districtId: 274,
      },
      {
        id: '320301',
        zipcode: 32120,
        text: 'ท่าตูม',
        value: 'ท่าตูม',
        name: {
          th: 'ท่าตูม',
          en: 'Tha Tum',
        },
        districtId: 275,
      },
      {
        id: '320302',
        zipcode: 32120,
        text: 'กระโพ',
        value: 'กระโพ',
        name: {
          th: 'กระโพ',
          en: 'Krapho',
        },
        districtId: 275,
      },
      {
        id: '320303',
        zipcode: 32120,
        text: 'พรมเทพ',
        value: 'พรมเทพ',
        name: {
          th: 'พรมเทพ',
          en: 'Phrom Thep',
        },
        districtId: 275,
      },
      {
        id: '320304',
        zipcode: 32120,
        text: 'โพนครก',
        value: 'โพนครก',
        name: {
          th: 'โพนครก',
          en: 'Phon Khrok',
        },
        districtId: 275,
      },
      {
        id: '320305',
        zipcode: 32120,
        text: 'เมืองแก',
        value: 'เมืองแก',
        name: {
          th: 'เมืองแก',
          en: 'Mueang Kae',
        },
        districtId: 275,
      },
      {
        id: '320306',
        zipcode: 32120,
        text: 'บะ',
        value: 'บะ',
        name: {
          th: 'บะ',
          en: 'Ba',
        },
        districtId: 275,
      },
      {
        id: '320307',
        zipcode: 32120,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 275,
      },
      {
        id: '320308',
        zipcode: 32120,
        text: 'บัวโคก',
        value: 'บัวโคก',
        name: {
          th: 'บัวโคก',
          en: 'Bua Khok',
        },
        districtId: 275,
      },
      {
        id: '320309',
        zipcode: 32120,
        text: 'หนองเมธี',
        value: 'หนองเมธี',
        name: {
          th: 'หนองเมธี',
          en: 'Nong Methi',
        },
        districtId: 275,
      },
      {
        id: '320310',
        zipcode: 32120,
        text: 'ทุ่งกุลา',
        value: 'ทุ่งกุลา',
        name: {
          th: 'ทุ่งกุลา',
          en: 'Thung Kula',
        },
        districtId: 275,
      },
      {
        id: '320401',
        zipcode: 32180,
        text: 'จอมพระ',
        value: 'จอมพระ',
        name: {
          th: 'จอมพระ',
          en: 'Chom Phra',
        },
        districtId: 276,
      },
      {
        id: '320402',
        zipcode: 32180,
        text: 'เมืองลีง',
        value: 'เมืองลีง',
        name: {
          th: 'เมืองลีง',
          en: 'Mueang Ling',
        },
        districtId: 276,
      },
      {
        id: '320403',
        zipcode: 32180,
        text: 'กระหาด',
        value: 'กระหาด',
        name: {
          th: 'กระหาด',
          en: 'Krahat',
        },
        districtId: 276,
      },
      {
        id: '320404',
        zipcode: 32180,
        text: 'บุแกรง',
        value: 'บุแกรง',
        name: {
          th: 'บุแกรง',
          en: 'Bu Kraeng',
        },
        districtId: 276,
      },
      {
        id: '320405',
        zipcode: 32180,
        text: 'หนองสนิท',
        value: 'หนองสนิท',
        name: {
          th: 'หนองสนิท',
          en: 'Nong Sanit',
        },
        districtId: 276,
      },
      {
        id: '320406',
        zipcode: 32180,
        text: 'บ้านผือ',
        value: 'บ้านผือ',
        name: {
          th: 'บ้านผือ',
          en: 'Ban Phue',
        },
        districtId: 276,
      },
      {
        id: '320407',
        zipcode: 32180,
        text: 'ลุ่มระวี',
        value: 'ลุ่มระวี',
        name: {
          th: 'ลุ่มระวี',
          en: 'Lum Rawi',
        },
        districtId: 276,
      },
      {
        id: '320408',
        zipcode: 32180,
        text: 'ชุมแสง',
        value: 'ชุมแสง',
        name: {
          th: 'ชุมแสง',
          en: 'Chum Saeng',
        },
        districtId: 276,
      },
      {
        id: '320409',
        zipcode: 32180,
        text: 'เป็นสุข',
        value: 'เป็นสุข',
        name: {
          th: 'เป็นสุข',
          en: 'Pen Suk',
        },
        districtId: 276,
      },
      {
        id: '320501',
        zipcode: 32140,
        text: 'กังแอน',
        value: 'กังแอน',
        name: {
          th: 'กังแอน',
          en: 'Kang-aen',
        },
        districtId: 277,
      },
      {
        id: '320502',
        zipcode: 32140,
        text: 'ทมอ',
        value: 'ทมอ',
        name: {
          th: 'ทมอ',
          en: 'Thamo',
        },
        districtId: 277,
      },
      {
        id: '320503',
        zipcode: 32140,
        text: 'ไพล',
        value: 'ไพล',
        name: {
          th: 'ไพล',
          en: 'Phlai',
        },
        districtId: 277,
      },
      {
        id: '320504',
        zipcode: 32140,
        text: 'ปรือ',
        value: 'ปรือ',
        name: {
          th: 'ปรือ',
          en: 'Prue',
        },
        districtId: 277,
      },
      {
        id: '320505',
        zipcode: 32140,
        text: 'ทุ่งมน',
        value: 'ทุ่งมน',
        name: {
          th: 'ทุ่งมน',
          en: 'Thung Mon',
        },
        districtId: 277,
      },
      {
        id: '320506',
        zipcode: 32140,
        text: 'ตาเบา',
        value: 'ตาเบา',
        name: {
          th: 'ตาเบา',
          en: 'Ta Bao',
        },
        districtId: 277,
      },
      {
        id: '320507',
        zipcode: 32140,
        text: 'หนองใหญ่',
        value: 'หนองใหญ่',
        name: {
          th: 'หนองใหญ่',
          en: 'Nong Yai',
        },
        districtId: 277,
      },
      {
        id: '320508',
        zipcode: 32140,
        text: 'โคกยาง',
        value: 'โคกยาง',
        name: {
          th: 'โคกยาง',
          en: 'Khok Yang',
        },
        districtId: 277,
      },
      {
        id: '320509',
        zipcode: 32140,
        text: 'โคกสะอาด',
        value: 'โคกสะอาด',
        name: {
          th: 'โคกสะอาด',
          en: 'Khok Sa-at',
        },
        districtId: 277,
      },
      {
        id: '320510',
        zipcode: 32140,
        text: 'บ้านไทร',
        value: 'บ้านไทร',
        name: {
          th: 'บ้านไทร',
          en: 'Ban Sai',
        },
        districtId: 277,
      },
      {
        id: '320511',
        zipcode: 32140,
        text: 'โชคนาสาม',
        value: 'โชคนาสาม',
        name: {
          th: 'โชคนาสาม',
          en: 'Chok Na Sam',
        },
        districtId: 277,
      },
      {
        id: '320512',
        zipcode: 32140,
        text: 'เชื้อเพลิง',
        value: 'เชื้อเพลิง',
        name: {
          th: 'เชื้อเพลิง',
          en: 'Chuea Phloeng',
        },
        districtId: 277,
      },
      {
        id: '320513',
        zipcode: 32140,
        text: 'ปราสาททนง',
        value: 'ปราสาททนง',
        name: {
          th: 'ปราสาททนง',
          en: 'Prasat Thanong',
        },
        districtId: 277,
      },
      {
        id: '320514',
        zipcode: 32140,
        text: 'ตานี',
        value: 'ตานี',
        name: {
          th: 'ตานี',
          en: 'Tani',
        },
        districtId: 277,
      },
      {
        id: '320515',
        zipcode: 32140,
        text: 'บ้านพลวง',
        value: 'บ้านพลวง',
        name: {
          th: 'บ้านพลวง',
          en: 'Ban Phluang',
        },
        districtId: 277,
      },
      {
        id: '320516',
        zipcode: 32140,
        text: 'กันตวจระมวล',
        value: 'กันตวจระมวล',
        name: {
          th: 'กันตวจระมวล',
          en: 'Kantuat Ramuan',
        },
        districtId: 277,
      },
      {
        id: '320517',
        zipcode: 32140,
        text: 'สมุด',
        value: 'สมุด',
        name: {
          th: 'สมุด',
          en: 'Samut',
        },
        districtId: 277,
      },
      {
        id: '320518',
        zipcode: 32140,
        text: 'ประทัดบุ',
        value: 'ประทัดบุ',
        name: {
          th: 'ประทัดบุ',
          en: 'Prathat Bu',
        },
        districtId: 277,
      },
      {
        id: '320601',
        zipcode: 32210,
        text: 'กาบเชิง',
        value: 'กาบเชิง',
        name: {
          th: 'กาบเชิง',
          en: 'Kap Choeng',
        },
        districtId: 278,
      },
      {
        id: '320604',
        zipcode: 32210,
        text: 'คูตัน',
        value: 'คูตัน',
        name: {
          th: 'คูตัน',
          en: 'Khu Tan',
        },
        districtId: 278,
      },
      {
        id: '320605',
        zipcode: 32210,
        text: 'ด่าน',
        value: 'ด่าน',
        name: {
          th: 'ด่าน',
          en: 'Dan',
        },
        districtId: 278,
      },
      {
        id: '320606',
        zipcode: 32210,
        text: 'แนงมุด',
        value: 'แนงมุด',
        name: {
          th: 'แนงมุด',
          en: 'Naeng Mut',
        },
        districtId: 278,
      },
      {
        id: '320607',
        zipcode: 32210,
        text: 'โคกตะเคียน',
        value: 'โคกตะเคียน',
        name: {
          th: 'โคกตะเคียน',
          en: 'Khok Takhian',
        },
        districtId: 278,
      },
      {
        id: '320610',
        zipcode: 32210,
        text: 'ตะเคียน',
        value: 'ตะเคียน',
        name: {
          th: 'ตะเคียน',
          en: 'Takhian',
        },
        districtId: 278,
      },
      {
        id: '320701',
        zipcode: 32130,
        text: 'รัตนบุรี',
        value: 'รัตนบุรี',
        name: {
          th: 'รัตนบุรี',
          en: 'Rattanaburi',
        },
        districtId: 279,
      },
      {
        id: '320702',
        zipcode: 32130,
        text: 'ธาตุ',
        value: 'ธาตุ',
        name: {
          th: 'ธาตุ',
          en: 'That',
        },
        districtId: 279,
      },
      {
        id: '320703',
        zipcode: 32130,
        text: 'แก',
        value: 'แก',
        name: {
          th: 'แก',
          en: 'Kae',
        },
        districtId: 279,
      },
      {
        id: '320704',
        zipcode: 32130,
        text: 'ดอนแรด',
        value: 'ดอนแรด',
        name: {
          th: 'ดอนแรด',
          en: 'Don Raet',
        },
        districtId: 279,
      },
      {
        id: '320705',
        zipcode: 32130,
        text: 'หนองบัวทอง',
        value: 'หนองบัวทอง',
        name: {
          th: 'หนองบัวทอง',
          en: 'Nong Bua Thong',
        },
        districtId: 279,
      },
      {
        id: '320706',
        zipcode: 32130,
        text: 'หนองบัวบาน',
        value: 'หนองบัวบาน',
        name: {
          th: 'หนองบัวบาน',
          en: 'Nong Bua Ban',
        },
        districtId: 279,
      },
      {
        id: '320709',
        zipcode: 32130,
        text: 'ไผ่',
        value: 'ไผ่',
        name: {
          th: 'ไผ่',
          en: 'Phai',
        },
        districtId: 279,
      },
      {
        id: '320711',
        zipcode: 32130,
        text: 'เบิด',
        value: 'เบิด',
        name: {
          th: 'เบิด',
          en: 'Boet',
        },
        districtId: 279,
      },
      {
        id: '320713',
        zipcode: 32130,
        text: 'น้ำเขียว',
        value: 'น้ำเขียว',
        name: {
          th: 'น้ำเขียว',
          en: 'Nam Khiao',
        },
        districtId: 279,
      },
      {
        id: '320714',
        zipcode: 32130,
        text: 'กุดขาคีม',
        value: 'กุดขาคีม',
        name: {
          th: 'กุดขาคีม',
          en: 'Kut Kha Khim',
        },
        districtId: 279,
      },
      {
        id: '320715',
        zipcode: 32130,
        text: 'ยางสว่าง',
        value: 'ยางสว่าง',
        name: {
          th: 'ยางสว่าง',
          en: 'Yang Sawang',
        },
        districtId: 279,
      },
      {
        id: '320716',
        zipcode: 32130,
        text: 'ทับใหญ่',
        value: 'ทับใหญ่',
        name: {
          th: 'ทับใหญ่',
          en: 'Thap Ya',
        },
        districtId: 279,
      },
      {
        id: '320801',
        zipcode: 32160,
        text: 'สนม',
        value: 'สนม',
        name: {
          th: 'สนม',
          en: 'Sanom',
        },
        districtId: 280,
      },
      {
        id: '320802',
        zipcode: 32160,
        text: 'โพนโก',
        value: 'โพนโก',
        name: {
          th: 'โพนโก',
          en: 'Phon Ko',
        },
        districtId: 280,
      },
      {
        id: '320803',
        zipcode: 32160,
        text: 'หนองระฆัง',
        value: 'หนองระฆัง',
        name: {
          th: 'หนองระฆัง',
          en: 'Nong Rakhang',
        },
        districtId: 280,
      },
      {
        id: '320804',
        zipcode: 32160,
        text: 'นานวน',
        value: 'นานวน',
        name: {
          th: 'นานวน',
          en: 'Na Nuan',
        },
        districtId: 280,
      },
      {
        id: '320805',
        zipcode: 32160,
        text: 'แคน',
        value: 'แคน',
        name: {
          th: 'แคน',
          en: 'Khaen',
        },
        districtId: 280,
      },
      {
        id: '320806',
        zipcode: 32160,
        text: 'หัวงัว',
        value: 'หัวงัว',
        name: {
          th: 'หัวงัว',
          en: 'Hua Ngua',
        },
        districtId: 280,
      },
      {
        id: '320807',
        zipcode: 32160,
        text: 'หนองอียอ',
        value: 'หนองอียอ',
        name: {
          th: 'หนองอียอ',
          en: 'Nong I Yo)',
        },
        districtId: 280,
      },
      {
        id: '320901',
        zipcode: 32110,
        text: 'ระแงง',
        value: 'ระแงง',
        name: {
          th: 'ระแงง',
          en: 'Ra-ngaeng',
        },
        districtId: 281,
      },
      {
        id: '320902',
        zipcode: 32110,
        text: 'ตรึม',
        value: 'ตรึม',
        name: {
          th: 'ตรึม',
          en: 'Truem',
        },
        districtId: 281,
      },
      {
        id: '320903',
        zipcode: 32110,
        text: 'จารพัต',
        value: 'จารพัต',
        name: {
          th: 'จารพัต',
          en: 'Charaphat',
        },
        districtId: 281,
      },
      {
        id: '320904',
        zipcode: 32110,
        text: 'ยาง',
        value: 'ยาง',
        name: {
          th: 'ยาง',
          en: 'Yang',
        },
        districtId: 281,
      },
      {
        id: '320905',
        zipcode: 32110,
        text: 'แตล',
        value: 'แตล',
        name: {
          th: 'แตล',
          en: 'Taen',
        },
        districtId: 281,
      },
      {
        id: '320906',
        zipcode: 32110,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 281,
      },
      {
        id: '320907',
        zipcode: 32110,
        text: 'คาละแมะ',
        value: 'คาละแมะ',
        name: {
          th: 'คาละแมะ',
          en: 'Khalamae',
        },
        districtId: 281,
      },
      {
        id: '320908',
        zipcode: 32110,
        text: 'หนองเหล็ก',
        value: 'หนองเหล็ก',
        name: {
          th: 'หนองเหล็ก',
          en: 'Nong Lek',
        },
        districtId: 281,
      },
      {
        id: '320909',
        zipcode: 32110,
        text: 'หนองขวาว',
        value: 'หนองขวาว',
        name: {
          th: 'หนองขวาว',
          en: 'Nong Khwao',
        },
        districtId: 281,
      },
      {
        id: '320910',
        zipcode: 32110,
        text: 'ช่างปี่',
        value: 'ช่างปี่',
        name: {
          th: 'ช่างปี่',
          en: 'Chang Pi',
        },
        districtId: 281,
      },
      {
        id: '320911',
        zipcode: 32110,
        text: 'กุดหวาย',
        value: 'กุดหวาย',
        name: {
          th: 'กุดหวาย',
          en: 'Kut Wai',
        },
        districtId: 281,
      },
      {
        id: '320912',
        zipcode: 32110,
        text: 'ขวาวใหญ่',
        value: 'ขวาวใหญ่',
        name: {
          th: 'ขวาวใหญ่',
          en: 'Khwao Yai',
        },
        districtId: 281,
      },
      {
        id: '320913',
        zipcode: 32110,
        text: 'นารุ่ง',
        value: 'นารุ่ง',
        name: {
          th: 'นารุ่ง',
          en: 'Na Rung',
        },
        districtId: 281,
      },
      {
        id: '320914',
        zipcode: 32110,
        text: 'ตรมไพร',
        value: 'ตรมไพร',
        name: {
          th: 'ตรมไพร',
          en: 'Trom Phrai',
        },
        districtId: 281,
      },
      {
        id: '320915',
        zipcode: 32110,
        text: 'ผักไหม',
        value: 'ผักไหม',
        name: {
          th: 'ผักไหม',
          en: 'Phak Mai',
        },
        districtId: 281,
      },
      {
        id: '321001',
        zipcode: 32150,
        text: 'สังขะ',
        value: 'สังขะ',
        name: {
          th: 'สังขะ',
          en: 'Sangkha',
        },
        districtId: 282,
      },
      {
        id: '321002',
        zipcode: 32150,
        text: 'ขอนแตก',
        value: 'ขอนแตก',
        name: {
          th: 'ขอนแตก',
          en: 'Khon Taek',
        },
        districtId: 282,
      },
      {
        id: '321006',
        zipcode: 32150,
        text: 'ดม',
        value: 'ดม',
        name: {
          th: 'ดม',
          en: 'Dom',
        },
        districtId: 282,
      },
      {
        id: '321007',
        zipcode: 32150,
        text: 'พระแก้ว',
        value: 'พระแก้ว',
        name: {
          th: 'พระแก้ว',
          en: 'Phra Kaeo',
        },
        districtId: 282,
      },
      {
        id: '321008',
        zipcode: 32150,
        text: 'บ้านจารย์',
        value: 'บ้านจารย์',
        name: {
          th: 'บ้านจารย์',
          en: 'Ban Chan',
        },
        districtId: 282,
      },
      {
        id: '321009',
        zipcode: 32150,
        text: 'กระเทียม',
        value: 'กระเทียม',
        name: {
          th: 'กระเทียม',
          en: 'Krathiam',
        },
        districtId: 282,
      },
      {
        id: '321010',
        zipcode: 32150,
        text: 'สะกาด',
        value: 'สะกาด',
        name: {
          th: 'สะกาด',
          en: 'Sakat',
        },
        districtId: 282,
      },
      {
        id: '321011',
        zipcode: 32150,
        text: 'ตาตุม',
        value: 'ตาตุม',
        name: {
          th: 'ตาตุม',
          en: 'Ta Tum',
        },
        districtId: 282,
      },
      {
        id: '321012',
        zipcode: 32150,
        text: 'ทับทัน',
        value: 'ทับทัน',
        name: {
          th: 'ทับทัน',
          en: 'Thap Than',
        },
        districtId: 282,
      },
      {
        id: '321013',
        zipcode: 32150,
        text: 'ตาคง',
        value: 'ตาคง',
        name: {
          th: 'ตาคง',
          en: 'Ta Khong',
        },
        districtId: 282,
      },
      {
        id: '321015',
        zipcode: 32150,
        text: 'บ้านชบ',
        value: 'บ้านชบ',
        name: {
          th: 'บ้านชบ',
          en: 'Ban Chop',
        },
        districtId: 282,
      },
      {
        id: '321017',
        zipcode: 32150,
        text: 'เทพรักษา',
        value: 'เทพรักษา',
        name: {
          th: 'เทพรักษา',
          en: 'Thep Raksa',
        },
        districtId: 282,
      },
      {
        id: '321101',
        zipcode: 32220,
        text: 'ลำดวน',
        value: 'ลำดวน',
        name: {
          th: 'ลำดวน',
          en: 'Lamduan',
        },
        districtId: 283,
      },
      {
        id: '321102',
        zipcode: 32220,
        text: 'โชคเหนือ',
        value: 'โชคเหนือ',
        name: {
          th: 'โชคเหนือ',
          en: 'Chok Nuea',
        },
        districtId: 283,
      },
      {
        id: '321103',
        zipcode: 32220,
        text: 'อู่โลก',
        value: 'อู่โลก',
        name: {
          th: 'อู่โลก',
          en: 'U Lok',
        },
        districtId: 283,
      },
      {
        id: '321104',
        zipcode: 32220,
        text: 'ตรำดม',
        value: 'ตรำดม',
        name: {
          th: 'ตรำดม',
          en: 'Tram Dom',
        },
        districtId: 283,
      },
      {
        id: '321105',
        zipcode: 32220,
        text: 'ตระเปียงเตีย',
        value: 'ตระเปียงเตีย',
        name: {
          th: 'ตระเปียงเตีย',
          en: 'Trapiang Tia',
        },
        districtId: 283,
      },
      {
        id: '321201',
        zipcode: 32170,
        text: 'สำโรงทาบ',
        value: 'สำโรงทาบ',
        name: {
          th: 'สำโรงทาบ',
          en: 'Samrong Thap',
        },
        districtId: 284,
      },
      {
        id: '321202',
        zipcode: 32170,
        text: 'หนองไผ่ล้อม',
        value: 'หนองไผ่ล้อม',
        name: {
          th: 'หนองไผ่ล้อม',
          en: 'Nong Phai Lom',
        },
        districtId: 284,
      },
      {
        id: '321203',
        zipcode: 32170,
        text: 'กระออม',
        value: 'กระออม',
        name: {
          th: 'กระออม',
          en: 'Kra-om',
        },
        districtId: 284,
      },
      {
        id: '321204',
        zipcode: 32170,
        text: 'หนองฮะ',
        value: 'หนองฮะ',
        name: {
          th: 'หนองฮะ',
          en: 'Nong Ha',
        },
        districtId: 284,
      },
      {
        id: '321205',
        zipcode: 32170,
        text: 'ศรีสุข',
        value: 'ศรีสุข',
        name: {
          th: 'ศรีสุข',
          en: 'Si Suk',
        },
        districtId: 284,
      },
      {
        id: '321206',
        zipcode: 32170,
        text: 'เกาะแก้ว',
        value: 'เกาะแก้ว',
        name: {
          th: 'เกาะแก้ว',
          en: 'Ko Kaeo',
        },
        districtId: 284,
      },
      {
        id: '321207',
        zipcode: 32170,
        text: 'หมื่นศรี',
        value: 'หมื่นศรี',
        name: {
          th: 'หมื่นศรี',
          en: 'Muen Si',
        },
        districtId: 284,
      },
      {
        id: '321208',
        zipcode: 32170,
        text: 'เสม็จ',
        value: 'เสม็จ',
        name: {
          th: 'เสม็จ',
          en: 'Samet',
        },
        districtId: 284,
      },
      {
        id: '321209',
        zipcode: 32170,
        text: 'สะโน',
        value: 'สะโน',
        name: {
          th: 'สะโน',
          en: 'Sano',
        },
        districtId: 284,
      },
      {
        id: '321210',
        zipcode: 32170,
        text: 'ประดู่',
        value: 'ประดู่',
        name: {
          th: 'ประดู่',
          en: 'Pradu',
        },
        districtId: 284,
      },
      {
        id: '321301',
        zipcode: 32230,
        text: 'บัวเชด',
        value: 'บัวเชด',
        name: {
          th: 'บัวเชด',
          en: 'Buachet',
        },
        districtId: 285,
      },
      {
        id: '321302',
        zipcode: 32230,
        text: 'สะเดา',
        value: 'สะเดา',
        name: {
          th: 'สะเดา',
          en: 'Sadao',
        },
        districtId: 285,
      },
      {
        id: '321303',
        zipcode: 32230,
        text: 'จรัส',
        value: 'จรัส',
        name: {
          th: 'จรัส',
          en: 'Charat',
        },
        districtId: 285,
      },
      {
        id: '321304',
        zipcode: 32230,
        text: 'ตาวัง',
        value: 'ตาวัง',
        name: {
          th: 'ตาวัง',
          en: 'Ta Wang',
        },
        districtId: 285,
      },
      {
        id: '321305',
        zipcode: 32230,
        text: 'อาโพน',
        value: 'อาโพน',
        name: {
          th: 'อาโพน',
          en: 'A Phon',
        },
        districtId: 285,
      },
      {
        id: '321306',
        zipcode: 32230,
        text: 'สำเภาลูน',
        value: 'สำเภาลูน',
        name: {
          th: 'สำเภาลูน',
          en: 'Samphao Lun',
        },
        districtId: 285,
      },
      {
        id: '321401',
        zipcode: 32140,
        text: 'บักได',
        value: 'บักได',
        name: {
          th: 'บักได',
          en: 'Bakdai',
        },
        districtId: 286,
      },
      {
        id: '321402',
        zipcode: 32140,
        text: 'โคกกลาง',
        value: 'โคกกลาง',
        name: {
          th: 'โคกกลาง',
          en: 'Khok Klang',
        },
        districtId: 286,
      },
      {
        id: '321403',
        zipcode: 32140,
        text: 'จีกแดก',
        value: 'จีกแดก',
        name: {
          th: 'จีกแดก',
          en: 'Chik Daek',
        },
        districtId: 286,
      },
      {
        id: '321404',
        zipcode: 32140,
        text: 'ตาเมียง',
        value: 'ตาเมียง',
        name: {
          th: 'ตาเมียง',
          en: 'Ta Miang',
        },
        districtId: 286,
      },
      {
        id: '321501',
        zipcode: 32150,
        text: 'ณรงค์',
        value: 'ณรงค์',
        name: {
          th: 'ณรงค์',
          en: 'Narong',
        },
        districtId: 287,
      },
      {
        id: '321502',
        zipcode: 32150,
        text: 'แจนแวน',
        value: 'แจนแวน',
        name: {
          th: 'แจนแวน',
          en: 'Chaenwaen',
        },
        districtId: 287,
      },
      {
        id: '321503',
        zipcode: 32150,
        text: 'ตรวจ',
        value: 'ตรวจ',
        name: {
          th: 'ตรวจ',
          en: 'Truat',
        },
        districtId: 287,
      },
      {
        id: '321504',
        zipcode: 32150,
        text: 'หนองแวง',
        value: 'หนองแวง',
        name: {
          th: 'หนองแวง',
          en: 'Nong Waeng',
        },
        districtId: 287,
      },
      {
        id: '321505',
        zipcode: 32150,
        text: 'ศรีสุข',
        value: 'ศรีสุข',
        name: {
          th: 'ศรีสุข',
          en: 'Si Suk',
        },
        districtId: 287,
      },
      {
        id: '321601',
        zipcode: 32000,
        text: 'เขวาสินรินทร์',
        value: 'เขวาสินรินทร์',
        name: {
          th: 'เขวาสินรินทร์',
          en: 'Khwao Sinarin',
        },
        districtId: 288,
      },
      {
        id: '321602',
        zipcode: 32000,
        text: 'บึง',
        value: 'บึง',
        name: {
          th: 'บึง',
          en: 'Bueng',
        },
        districtId: 288,
      },
      {
        id: '321603',
        zipcode: 32000,
        text: 'ตากูก',
        value: 'ตากูก',
        name: {
          th: 'ตากูก',
          en: 'Ta Kuk',
        },
        districtId: 288,
      },
      {
        id: '321604',
        zipcode: 32000,
        text: 'ปราสาททอง',
        value: 'ปราสาททอง',
        name: {
          th: 'ปราสาททอง',
          en: 'Prasat Thong',
        },
        districtId: 288,
      },
      {
        id: '321605',
        zipcode: 32000,
        text: 'บ้านแร่',
        value: 'บ้านแร่',
        name: {
          th: 'บ้านแร่',
          en: 'Ban Rae',
        },
        districtId: 288,
      },
      {
        id: '321701',
        zipcode: 32130,
        text: 'หนองหลวง',
        value: 'หนองหลวง',
        name: {
          th: 'หนองหลวง',
          en: 'Nong Luang',
        },
        districtId: 289,
      },
      {
        id: '321702',
        zipcode: 32130,
        text: 'คำผง',
        value: 'คำผง',
        name: {
          th: 'คำผง',
          en: 'Kham Phong',
        },
        districtId: 289,
      },
      {
        id: '321703',
        zipcode: 32130,
        text: 'โนน',
        value: 'โนน',
        name: {
          th: 'โนน',
          en: 'Non',
        },
        districtId: 289,
      },
      {
        id: '321704',
        zipcode: 32130,
        text: 'ระเวียง',
        value: 'ระเวียง',
        name: {
          th: 'ระเวียง',
          en: 'Rawiang',
        },
        districtId: 289,
      },
      {
        id: '321705',
        zipcode: 32130,
        text: 'หนองเทพ',
        value: 'หนองเทพ',
        name: {
          th: 'หนองเทพ',
          en: 'Nong Thep',
        },
        districtId: 289,
      },
      {
        id: '330101',
        zipcode: 33000,
        text: 'เมืองเหนือ',
        value: 'เมืองเหนือ',
        name: {
          th: 'เมืองเหนือ',
          en: 'Mueang Nuea',
        },
        districtId: 290,
      },
      {
        id: '330102',
        zipcode: 33000,
        text: 'เมืองใต้',
        value: 'เมืองใต้',
        name: {
          th: 'เมืองใต้',
          en: 'Mueang Tai',
        },
        districtId: 290,
      },
      {
        id: '330103',
        zipcode: 33000,
        text: 'คูซอด',
        value: 'คูซอด',
        name: {
          th: 'คูซอด',
          en: 'Khu Sot',
        },
        districtId: 290,
      },
      {
        id: '330104',
        zipcode: 33000,
        text: 'ซำ',
        value: 'ซำ',
        name: {
          th: 'ซำ',
          en: 'Sam',
        },
        districtId: 290,
      },
      {
        id: '330105',
        zipcode: 33000,
        text: 'จาน',
        value: 'จาน',
        name: {
          th: 'จาน',
          en: 'Chan',
        },
        districtId: 290,
      },
      {
        id: '330106',
        zipcode: 33000,
        text: 'ตะดอบ',
        value: 'ตะดอบ',
        name: {
          th: 'ตะดอบ',
          en: 'Tadop',
        },
        districtId: 290,
      },
      {
        id: '330107',
        zipcode: 33000,
        text: 'หนองครก',
        value: 'หนองครก',
        name: {
          th: 'หนองครก',
          en: 'Nong Khrok',
        },
        districtId: 290,
      },
      {
        id: '330111',
        zipcode: 33000,
        text: 'โพนข่า',
        value: 'โพนข่า',
        name: {
          th: 'โพนข่า',
          en: 'Phon Kha',
        },
        districtId: 290,
      },
      {
        id: '330112',
        zipcode: 33000,
        text: 'โพนค้อ',
        value: 'โพนค้อ',
        name: {
          th: 'โพนค้อ',
          en: 'Phon Kho',
        },
        districtId: 290,
      },
      {
        id: '330115',
        zipcode: 33000,
        text: 'โพนเขวา',
        value: 'โพนเขวา',
        name: {
          th: 'โพนเขวา',
          en: 'Phon Khwao',
        },
        districtId: 290,
      },
      {
        id: '330116',
        zipcode: 33000,
        text: 'หญ้าปล้อง',
        value: 'หญ้าปล้อง',
        name: {
          th: 'หญ้าปล้อง',
          en: 'Ya Plong',
        },
        districtId: 290,
      },
      {
        id: '330118',
        zipcode: 33000,
        text: 'ทุ่ม',
        value: 'ทุ่ม',
        name: {
          th: 'ทุ่ม',
          en: 'Thum',
        },
        districtId: 290,
      },
      {
        id: '330119',
        zipcode: 33000,
        text: 'หนองไฮ',
        value: 'หนองไฮ',
        name: {
          th: 'หนองไฮ',
          en: 'Nong Hai',
        },
        districtId: 290,
      },
      {
        id: '330121',
        zipcode: 33000,
        text: 'หนองแก้ว',
        value: 'หนองแก้ว',
        name: {
          th: 'หนองแก้ว',
          en: 'Nong Kaeo',
        },
        districtId: 290,
      },
      {
        id: '330122',
        zipcode: 33000,
        text: 'น้ำคำ',
        value: 'น้ำคำ',
        name: {
          th: 'น้ำคำ',
          en: 'Nam Kham',
        },
        districtId: 290,
      },
      {
        id: '330123',
        zipcode: 33000,
        text: 'โพธิ์',
        value: 'โพธิ์',
        name: {
          th: 'โพธิ์',
          en: 'Pho',
        },
        districtId: 290,
      },
      {
        id: '330124',
        zipcode: 33000,
        text: 'หมากเขียบ',
        value: 'หมากเขียบ',
        name: {
          th: 'หมากเขียบ',
          en: 'Mak Khiap',
        },
        districtId: 290,
      },
      {
        id: '330127',
        zipcode: 33000,
        text: 'หนองไผ่',
        value: 'หนองไผ่',
        name: {
          th: 'หนองไผ่',
          en: 'Nong Phai',
        },
        districtId: 290,
      },
      {
        id: '330201',
        zipcode: 33190,
        text: 'ยางชุมน้อย',
        value: 'ยางชุมน้อย',
        name: {
          th: 'ยางชุมน้อย',
          en: 'Yang Chum Noi',
        },
        districtId: 291,
      },
      {
        id: '330202',
        zipcode: 33190,
        text: 'ลิ้นฟ้า',
        value: 'ลิ้นฟ้า',
        name: {
          th: 'ลิ้นฟ้า',
          en: 'Lin Fa',
        },
        districtId: 291,
      },
      {
        id: '330203',
        zipcode: 33190,
        text: 'คอนกาม',
        value: 'คอนกาม',
        name: {
          th: 'คอนกาม',
          en: 'Khon Kam',
        },
        districtId: 291,
      },
      {
        id: '330204',
        zipcode: 33190,
        text: 'โนนคูณ',
        value: 'โนนคูณ',
        name: {
          th: 'โนนคูณ',
          en: 'Non Khun',
        },
        districtId: 291,
      },
      {
        id: '330205',
        zipcode: 33190,
        text: 'กุดเมืองฮาม',
        value: 'กุดเมืองฮาม',
        name: {
          th: 'กุดเมืองฮาม',
          en: 'Kut Mueang Ham',
        },
        districtId: 291,
      },
      {
        id: '330206',
        zipcode: 33190,
        text: 'บึงบอน',
        value: 'บึงบอน',
        name: {
          th: 'บึงบอน',
          en: 'Bueng Bon',
        },
        districtId: 291,
      },
      {
        id: '330207',
        zipcode: 33190,
        text: 'ยางชุมใหญ่',
        value: 'ยางชุมใหญ่',
        name: {
          th: 'ยางชุมใหญ่',
          en: 'Yang Chum Yai',
        },
        districtId: 291,
      },
      {
        id: '330301',
        zipcode: 33130,
        text: 'ดูน',
        value: 'ดูน',
        name: {
          th: 'ดูน',
          en: 'Dun',
        },
        districtId: 292,
      },
      {
        id: '330302',
        zipcode: 33130,
        text: 'โนนสัง',
        value: 'โนนสัง',
        name: {
          th: 'โนนสัง',
          en: 'Non Sang',
        },
        districtId: 292,
      },
      {
        id: '330303',
        zipcode: 33130,
        text: 'หนองหัวช้าง',
        value: 'หนองหัวช้าง',
        name: {
          th: 'หนองหัวช้าง',
          en: 'Nong Hua Chang',
        },
        districtId: 292,
      },
      {
        id: '330304',
        zipcode: 33130,
        text: 'ยาง',
        value: 'ยาง',
        name: {
          th: 'ยาง',
          en: 'Yang',
        },
        districtId: 292,
      },
      {
        id: '330305',
        zipcode: 33130,
        text: 'หนองแวง',
        value: 'หนองแวง',
        name: {
          th: 'หนองแวง',
          en: 'Nong Waeng',
        },
        districtId: 292,
      },
      {
        id: '330306',
        zipcode: 33130,
        text: 'หนองแก้ว',
        value: 'หนองแก้ว',
        name: {
          th: 'หนองแก้ว',
          en: 'Nong Kaeo',
        },
        districtId: 292,
      },
      {
        id: '330307',
        zipcode: 33130,
        text: 'ทาม',
        value: 'ทาม',
        name: {
          th: 'ทาม',
          en: 'Tham',
        },
        districtId: 292,
      },
      {
        id: '330308',
        zipcode: 33130,
        text: 'ละทาย',
        value: 'ละทาย',
        name: {
          th: 'ละทาย',
          en: 'Lathai',
        },
        districtId: 292,
      },
      {
        id: '330309',
        zipcode: 33130,
        text: 'เมืองน้อย',
        value: 'เมืองน้อย',
        name: {
          th: 'เมืองน้อย',
          en: 'Mueang Noi',
        },
        districtId: 292,
      },
      {
        id: '330310',
        zipcode: 33130,
        text: 'อีปาด',
        value: 'อีปาด',
        name: {
          th: 'อีปาด',
          en: 'I Pat',
        },
        districtId: 292,
      },
      {
        id: '330311',
        zipcode: 33130,
        text: 'บัวน้อย',
        value: 'บัวน้อย',
        name: {
          th: 'บัวน้อย',
          en: 'Bua Noi',
        },
        districtId: 292,
      },
      {
        id: '330312',
        zipcode: 33130,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 292,
      },
      {
        id: '330313',
        zipcode: 33130,
        text: 'ดู่',
        value: 'ดู่',
        name: {
          th: 'ดู่',
          en: 'Du',
        },
        districtId: 292,
      },
      {
        id: '330314',
        zipcode: 33130,
        text: 'ผักแพว',
        value: 'ผักแพว',
        name: {
          th: 'ผักแพว',
          en: 'Phak Phaeo',
        },
        districtId: 292,
      },
      {
        id: '330315',
        zipcode: 33130,
        text: 'จาน',
        value: 'จาน',
        name: {
          th: 'จาน',
          en: 'Chan',
        },
        districtId: 292,
      },
      {
        id: '330320',
        zipcode: 33130,
        text: 'คำเนียม',
        value: 'คำเนียม',
        name: {
          th: 'คำเนียม',
          en: 'Kham Niam',
        },
        districtId: 292,
      },
      {
        id: '330401',
        zipcode: 33110,
        text: 'บึงมะลู',
        value: 'บึงมะลู',
        name: {
          th: 'บึงมะลู',
          en: 'Bueng Malu',
        },
        districtId: 293,
      },
      {
        id: '330402',
        zipcode: 33110,
        text: 'กุดเสลา',
        value: 'กุดเสลา',
        name: {
          th: 'กุดเสลา',
          en: 'Kut Salao',
        },
        districtId: 293,
      },
      {
        id: '330403',
        zipcode: 33110,
        text: 'เมือง',
        value: 'เมือง',
        name: {
          th: 'เมือง',
          en: 'Mueang',
        },
        districtId: 293,
      },
      {
        id: '330405',
        zipcode: 33110,
        text: 'สังเม็ก',
        value: 'สังเม็ก',
        name: {
          th: 'สังเม็ก',
          en: 'Sang Mek',
        },
        districtId: 293,
      },
      {
        id: '330406',
        zipcode: 33110,
        text: 'น้ำอ้อม',
        value: 'น้ำอ้อม',
        name: {
          th: 'น้ำอ้อม',
          en: 'Nam Om',
        },
        districtId: 293,
      },
      {
        id: '330407',
        zipcode: 33110,
        text: 'ละลาย',
        value: 'ละลาย',
        name: {
          th: 'ละลาย',
          en: 'Lalai',
        },
        districtId: 293,
      },
      {
        id: '330408',
        zipcode: 33110,
        text: 'รุง',
        value: 'รุง',
        name: {
          th: 'รุง',
          en: 'Rung',
        },
        districtId: 293,
      },
      {
        id: '330409',
        zipcode: 33110,
        text: 'ตระกาจ',
        value: 'ตระกาจ',
        name: {
          th: 'ตระกาจ',
          en: 'Trakat',
        },
        districtId: 293,
      },
      {
        id: '330411',
        zipcode: 33110,
        text: 'จานใหญ่',
        value: 'จานใหญ่',
        name: {
          th: 'จานใหญ่',
          en: 'Chan Yai)',
        },
        districtId: 293,
      },
      {
        id: '330412',
        zipcode: 33110,
        text: 'ภูเงิน',
        value: 'ภูเงิน',
        name: {
          th: 'ภูเงิน',
          en: 'Phu Ngoen',
        },
        districtId: 293,
      },
      {
        id: '330413',
        zipcode: 33110,
        text: 'ชำ',
        value: 'ชำ',
        name: {
          th: 'ชำ',
          en: 'Cham',
        },
        districtId: 293,
      },
      {
        id: '330414',
        zipcode: 33110,
        text: 'กระแชง',
        value: 'กระแชง',
        name: {
          th: 'กระแชง',
          en: 'Krachaeng',
        },
        districtId: 293,
      },
      {
        id: '330415',
        zipcode: 33110,
        text: 'โนนสำราญ',
        value: 'โนนสำราญ',
        name: {
          th: 'โนนสำราญ',
          en: 'Non Samran',
        },
        districtId: 293,
      },
      {
        id: '330416',
        zipcode: 33110,
        text: 'หนองหญ้าลาด',
        value: 'หนองหญ้าลาด',
        name: {
          th: 'หนองหญ้าลาด',
          en: 'Nong Ya Lat',
        },
        districtId: 293,
      },
      {
        id: '330419',
        zipcode: 33110,
        text: 'เสาธงชัย',
        value: 'เสาธงชัย',
        name: {
          th: 'เสาธงชัย',
          en: 'Sao Thong Chai',
        },
        districtId: 293,
      },
      {
        id: '330420',
        zipcode: 33110,
        text: 'ขนุน',
        value: 'ขนุน',
        name: {
          th: 'ขนุน',
          en: 'Khanun',
        },
        districtId: 293,
      },
      {
        id: '330421',
        zipcode: 33110,
        text: 'สวนกล้วย',
        value: 'สวนกล้วย',
        name: {
          th: 'สวนกล้วย',
          en: 'Suan Kluai',
        },
        districtId: 293,
      },
      {
        id: '330423',
        zipcode: 33110,
        text: 'เวียงเหนือ',
        value: 'เวียงเหนือ',
        name: {
          th: 'เวียงเหนือ',
          en: 'Wiang Nuea',
        },
        districtId: 293,
      },
      {
        id: '330424',
        zipcode: 33110,
        text: 'ทุ่งใหญ่',
        value: 'ทุ่งใหญ่',
        name: {
          th: 'ทุ่งใหญ่',
          en: 'Thung Yai',
        },
        districtId: 293,
      },
      {
        id: '330425',
        zipcode: 33110,
        text: 'ภูผาหมอก',
        value: 'ภูผาหมอก',
        name: {
          th: 'ภูผาหมอก',
          en: 'Phu Pha Mok',
        },
        districtId: 293,
      },
      {
        id: '330501',
        zipcode: 33140,
        text: 'กันทรารมย์',
        value: 'กันทรารมย์',
        name: {
          th: 'กันทรารมย์',
          en: 'Kanthararom',
        },
        districtId: 294,
      },
      {
        id: '330502',
        zipcode: 33140,
        text: 'จะกง',
        value: 'จะกง',
        name: {
          th: 'จะกง',
          en: 'Chakong',
        },
        districtId: 294,
      },
      {
        id: '330503',
        zipcode: 33140,
        text: 'ใจดี',
        value: 'ใจดี',
        name: {
          th: 'ใจดี',
          en: 'Chai Di',
        },
        districtId: 294,
      },
      {
        id: '330504',
        zipcode: 33140,
        text: 'ดองกำเม็ด',
        value: 'ดองกำเม็ด',
        name: {
          th: 'ดองกำเม็ด',
          en: 'Dong Kammet',
        },
        districtId: 294,
      },
      {
        id: '330505',
        zipcode: 33140,
        text: 'โสน',
        value: 'โสน',
        name: {
          th: 'โสน',
          en: 'Sano',
        },
        districtId: 294,
      },
      {
        id: '330506',
        zipcode: 33140,
        text: 'ปรือใหญ่',
        value: 'ปรือใหญ่',
        name: {
          th: 'ปรือใหญ่',
          en: 'Prue Yai',
        },
        districtId: 294,
      },
      {
        id: '330507',
        zipcode: 33140,
        text: 'สะเดาใหญ่',
        value: 'สะเดาใหญ่',
        name: {
          th: 'สะเดาใหญ่',
          en: 'Sadao Yai',
        },
        districtId: 294,
      },
      {
        id: '330508',
        zipcode: 33140,
        text: 'ตาอุด',
        value: 'ตาอุด',
        name: {
          th: 'ตาอุด',
          en: 'Ta Ut',
        },
        districtId: 294,
      },
      {
        id: '330509',
        zipcode: 33140,
        text: 'ห้วยเหนือ',
        value: 'ห้วยเหนือ',
        name: {
          th: 'ห้วยเหนือ',
          en: 'Huai Nuea',
        },
        districtId: 294,
      },
      {
        id: '330510',
        zipcode: 33140,
        text: 'ห้วยใต้',
        value: 'ห้วยใต้',
        name: {
          th: 'ห้วยใต้',
          en: 'Huai Tai',
        },
        districtId: 294,
      },
      {
        id: '330511',
        zipcode: 33140,
        text: 'หัวเสือ',
        value: 'หัวเสือ',
        name: {
          th: 'หัวเสือ',
          en: 'Hua Suea',
        },
        districtId: 294,
      },
      {
        id: '330513',
        zipcode: 33140,
        text: 'ตะเคียน',
        value: 'ตะเคียน',
        name: {
          th: 'ตะเคียน',
          en: 'Takhian',
        },
        districtId: 294,
      },
      {
        id: '330515',
        zipcode: 33140,
        text: 'นิคมพัฒนา',
        value: 'นิคมพัฒนา',
        name: {
          th: 'นิคมพัฒนา',
          en: 'Nikhom Phatthana',
        },
        districtId: 294,
      },
      {
        id: '330517',
        zipcode: 33140,
        text: 'โคกเพชร',
        value: 'โคกเพชร',
        name: {
          th: 'โคกเพชร',
          en: 'Khok Phet',
        },
        districtId: 294,
      },
      {
        id: '330518',
        zipcode: 33140,
        text: 'ปราสาท',
        value: 'ปราสาท',
        name: {
          th: 'ปราสาท',
          en: 'Prasat',
        },
        districtId: 294,
      },
      {
        id: '330521',
        zipcode: 33140,
        text: 'สำโรงตาเจ็น',
        value: 'สำโรงตาเจ็น',
        name: {
          th: 'สำโรงตาเจ็น',
          en: 'Samrong Ta Chen',
        },
        districtId: 294,
      },
      {
        id: '330522',
        zipcode: 33140,
        text: 'ห้วยสำราญ',
        value: 'ห้วยสำราญ',
        name: {
          th: 'ห้วยสำราญ',
          en: 'Huai Samran',
        },
        districtId: 294,
      },
      {
        id: '330524',
        zipcode: 33140,
        text: 'กฤษณา',
        value: 'กฤษณา',
        name: {
          th: 'กฤษณา',
          en: 'Kritsana',
        },
        districtId: 294,
      },
      {
        id: '330525',
        zipcode: 33140,
        text: 'ลมศักดิ์',
        value: 'ลมศักดิ์',
        name: {
          th: 'ลมศักดิ์',
          en: 'Lom Sak',
        },
        districtId: 294,
      },
      {
        id: '330526',
        zipcode: 33140,
        text: 'หนองฉลอง',
        value: 'หนองฉลอง',
        name: {
          th: 'หนองฉลอง',
          en: 'Nong Chalong',
        },
        districtId: 294,
      },
      {
        id: '330527',
        zipcode: 33140,
        text: 'ศรีตระกูล',
        value: 'ศรีตระกูล',
        name: {
          th: 'ศรีตระกูล',
          en: 'Si Trakun',
        },
        districtId: 294,
      },
      {
        id: '330528',
        zipcode: 33140,
        text: 'ศรีสะอาด',
        value: 'ศรีสะอาด',
        name: {
          th: 'ศรีสะอาด',
          en: 'Si Sa-at',
        },
        districtId: 294,
      },
      {
        id: '330601',
        zipcode: 33180,
        text: 'ไพรบึง',
        value: 'ไพรบึง',
        name: {
          th: 'ไพรบึง',
          en: 'Phrai Bueng',
        },
        districtId: 295,
      },
      {
        id: '330602',
        zipcode: 33180,
        text: 'ดินแดง',
        value: 'ดินแดง',
        name: {
          th: 'ดินแดง',
          en: 'Din Daeng',
        },
        districtId: 295,
      },
      {
        id: '330603',
        zipcode: 33180,
        text: 'ปราสาทเยอ',
        value: 'ปราสาทเยอ',
        name: {
          th: 'ปราสาทเยอ',
          en: 'Prasat Yoe',
        },
        districtId: 295,
      },
      {
        id: '330604',
        zipcode: 33180,
        text: 'สำโรงพลัน',
        value: 'สำโรงพลัน',
        name: {
          th: 'สำโรงพลัน',
          en: 'Samrong Phlan',
        },
        districtId: 295,
      },
      {
        id: '330605',
        zipcode: 33180,
        text: 'สุขสวัสดิ์',
        value: 'สุขสวัสดิ์',
        name: {
          th: 'สุขสวัสดิ์',
          en: 'Suk Sawat',
        },
        districtId: 295,
      },
      {
        id: '330606',
        zipcode: 33180,
        text: 'โนนปูน',
        value: 'โนนปูน',
        name: {
          th: 'โนนปูน',
          en: 'Non Pun',
        },
        districtId: 295,
      },
      {
        id: '330701',
        zipcode: 33170,
        text: 'พิมาย',
        value: 'พิมาย',
        name: {
          th: 'พิมาย',
          en: 'Phimai',
        },
        districtId: 296,
      },
      {
        id: '330702',
        zipcode: 33170,
        text: 'กู่',
        value: 'กู่',
        name: {
          th: 'กู่',
          en: 'Ku',
        },
        districtId: 296,
      },
      {
        id: '330703',
        zipcode: 33170,
        text: 'หนองเชียงทูน',
        value: 'หนองเชียงทูน',
        name: {
          th: 'หนองเชียงทูน',
          en: 'Nong Chiang Thun',
        },
        districtId: 296,
      },
      {
        id: '330704',
        zipcode: 33170,
        text: 'ตูม',
        value: 'ตูม',
        name: {
          th: 'ตูม',
          en: 'Tum',
        },
        districtId: 296,
      },
      {
        id: '330705',
        zipcode: 33170,
        text: 'สมอ',
        value: 'สมอ',
        name: {
          th: 'สมอ',
          en: 'Samo',
        },
        districtId: 296,
      },
      {
        id: '330706',
        zipcode: 33170,
        text: 'โพธิ์ศรี',
        value: 'โพธิ์ศรี',
        name: {
          th: 'โพธิ์ศรี',
          en: 'Pho Si',
        },
        districtId: 296,
      },
      {
        id: '330707',
        zipcode: 33170,
        text: 'สำโรงปราสาท',
        value: 'สำโรงปราสาท',
        name: {
          th: 'สำโรงปราสาท',
          en: 'Samrong Prasat',
        },
        districtId: 296,
      },
      {
        id: '330708',
        zipcode: 33170,
        text: 'ดู่',
        value: 'ดู่',
        name: {
          th: 'ดู่',
          en: 'Du',
        },
        districtId: 296,
      },
      {
        id: '330709',
        zipcode: 33170,
        text: 'สวาย',
        value: 'สวาย',
        name: {
          th: 'สวาย',
          en: 'Sawai',
        },
        districtId: 296,
      },
      {
        id: '330710',
        zipcode: 33170,
        text: 'พิมายเหนือ',
        value: 'พิมายเหนือ',
        name: {
          th: 'พิมายเหนือ',
          en: 'Phimai Nuea',
        },
        districtId: 296,
      },
      {
        id: '330801',
        zipcode: 33150,
        text: 'สิ',
        value: 'สิ',
        name: {
          th: 'สิ',
          en: 'Si',
        },
        districtId: 297,
      },
      {
        id: '330802',
        zipcode: 33150,
        text: 'บักดอง',
        value: 'บักดอง',
        name: {
          th: 'บักดอง',
          en: 'Bak Dong',
        },
        districtId: 297,
      },
      {
        id: '330803',
        zipcode: 33150,
        text: 'พราน',
        value: 'พราน',
        name: {
          th: 'พราน',
          en: 'Phran',
        },
        districtId: 297,
      },
      {
        id: '330804',
        zipcode: 33150,
        text: 'โพธิ์วงศ์',
        value: 'โพธิ์วงศ์',
        name: {
          th: 'โพธิ์วงศ์',
          en: 'Pho Wong',
        },
        districtId: 297,
      },
      {
        id: '330805',
        zipcode: 33150,
        text: 'ไพร',
        value: 'ไพร',
        name: {
          th: 'ไพร',
          en: 'Phrai',
        },
        districtId: 297,
      },
      {
        id: '330806',
        zipcode: 33150,
        text: 'กระหวัน',
        value: 'กระหวัน',
        name: {
          th: 'กระหวัน',
          en: 'Krawan',
        },
        districtId: 297,
      },
      {
        id: '330807',
        zipcode: 33150,
        text: 'ขุนหาญ',
        value: 'ขุนหาญ',
        name: {
          th: 'ขุนหาญ',
          en: 'Khun Han',
        },
        districtId: 297,
      },
      {
        id: '330808',
        zipcode: 33150,
        text: 'โนนสูง',
        value: 'โนนสูง',
        name: {
          th: 'โนนสูง',
          en: 'Non Sung',
        },
        districtId: 297,
      },
      {
        id: '330809',
        zipcode: 33150,
        text: 'กันทรอม',
        value: 'กันทรอม',
        name: {
          th: 'กันทรอม',
          en: 'Kanthrom',
        },
        districtId: 297,
      },
      {
        id: '330810',
        zipcode: 33150,
        text: 'ภูฝ้าย',
        value: 'ภูฝ้าย',
        name: {
          th: 'ภูฝ้าย',
          en: 'Phu Fai',
        },
        districtId: 297,
      },
      {
        id: '330811',
        zipcode: 33150,
        text: 'โพธิ์กระสังข์',
        value: 'โพธิ์กระสังข์',
        name: {
          th: 'โพธิ์กระสังข์',
          en: 'Pho Krasang',
        },
        districtId: 297,
      },
      {
        id: '330812',
        zipcode: 33150,
        text: 'ห้วยจันทร์',
        value: 'ห้วยจันทร์',
        name: {
          th: 'ห้วยจันทร์',
          en: 'Huai Chan',
        },
        districtId: 297,
      },
      {
        id: '330901',
        zipcode: 33160,
        text: 'เมืองคง',
        value: 'เมืองคง',
        name: {
          th: 'เมืองคง',
          en: 'Mueang Khong',
        },
        districtId: 298,
      },
      {
        id: '330902',
        zipcode: 33160,
        text: 'เมืองแคน',
        value: 'เมืองแคน',
        name: {
          th: 'เมืองแคน',
          en: 'Muang Khaen',
        },
        districtId: 298,
      },
      {
        id: '330903',
        zipcode: 33160,
        text: 'หนองแค',
        value: 'หนองแค',
        name: {
          th: 'หนองแค',
          en: 'Nong Khae',
        },
        districtId: 298,
      },
      {
        id: '330906',
        zipcode: 33160,
        text: 'จิกสังข์ทอง',
        value: 'จิกสังข์ทอง',
        name: {
          th: 'จิกสังข์ทอง',
          en: 'Chik Sang Thong',
        },
        districtId: 298,
      },
      {
        id: '330907',
        zipcode: 33160,
        text: 'ด่าน',
        value: 'ด่าน',
        name: {
          th: 'ด่าน',
          en: 'Dan',
        },
        districtId: 298,
      },
      {
        id: '330908',
        zipcode: 33160,
        text: 'ดู่',
        value: 'ดู่',
        name: {
          th: 'ดู่',
          en: 'Du',
        },
        districtId: 298,
      },
      {
        id: '330909',
        zipcode: 33160,
        text: 'หนองอึ่ง',
        value: 'หนองอึ่ง',
        name: {
          th: 'หนองอึ่ง',
          en: 'Nong Ueng',
        },
        districtId: 298,
      },
      {
        id: '330910',
        zipcode: 33160,
        text: 'บัวหุ่ง',
        value: 'บัวหุ่ง',
        name: {
          th: 'บัวหุ่ง',
          en: 'Bua Hung',
        },
        districtId: 298,
      },
      {
        id: '330911',
        zipcode: 33160,
        text: 'ไผ่',
        value: 'ไผ่',
        name: {
          th: 'ไผ่',
          en: 'Phai',
        },
        districtId: 298,
      },
      {
        id: '330912',
        zipcode: 33160,
        text: 'ส้มป่อย',
        value: 'ส้มป่อย',
        name: {
          th: 'ส้มป่อย',
          en: 'Som Poi',
        },
        districtId: 298,
      },
      {
        id: '330913',
        zipcode: 33160,
        text: 'หนองหมี',
        value: 'หนองหมี',
        name: {
          th: 'หนองหมี',
          en: 'Nong Mi',
        },
        districtId: 298,
      },
      {
        id: '330914',
        zipcode: 33160,
        text: 'หว้านคำ',
        value: 'หว้านคำ',
        name: {
          th: 'หว้านคำ',
          en: 'Wan Kham',
        },
        districtId: 298,
      },
      {
        id: '330915',
        zipcode: 33160,
        text: 'สร้างปี่',
        value: 'สร้างปี่',
        name: {
          th: 'สร้างปี่',
          en: 'Sang Pi',
        },
        districtId: 298,
      },
      {
        id: '331001',
        zipcode: 33120,
        text: 'กำแพง',
        value: 'กำแพง',
        name: {
          th: 'กำแพง',
          en: 'Kamphaeng',
        },
        districtId: 299,
      },
      {
        id: '331002',
        zipcode: 33120,
        text: 'อี่หล่ำ',
        value: 'อี่หล่ำ',
        name: {
          th: 'อี่หล่ำ',
          en: 'I Lam',
        },
        districtId: 299,
      },
      {
        id: '331003',
        zipcode: 33120,
        text: 'ก้านเหลือง',
        value: 'ก้านเหลือง',
        name: {
          th: 'ก้านเหลือง',
          en: 'Kan Lueang',
        },
        districtId: 299,
      },
      {
        id: '331004',
        zipcode: 33120,
        text: 'ทุ่งไชย',
        value: 'ทุ่งไชย',
        name: {
          th: 'ทุ่งไชย',
          en: 'Thung Chai',
        },
        districtId: 299,
      },
      {
        id: '331005',
        zipcode: 33120,
        text: 'สำโรง',
        value: 'สำโรง',
        name: {
          th: 'สำโรง',
          en: 'Samrong',
        },
        districtId: 299,
      },
      {
        id: '331006',
        zipcode: 33120,
        text: 'แขม',
        value: 'แขม',
        name: {
          th: 'แขม',
          en: 'Khaem',
        },
        districtId: 299,
      },
      {
        id: '331007',
        zipcode: 33120,
        text: 'หนองไฮ',
        value: 'หนองไฮ',
        name: {
          th: 'หนองไฮ',
          en: 'Nong Hai',
        },
        districtId: 299,
      },
      {
        id: '331008',
        zipcode: 33120,
        text: 'ขะยูง',
        value: 'ขะยูง',
        name: {
          th: 'ขะยูง',
          en: 'Khayung',
        },
        districtId: 299,
      },
      {
        id: '331010',
        zipcode: 33120,
        text: 'ตาเกษ',
        value: 'ตาเกษ',
        name: {
          th: 'ตาเกษ',
          en: 'Ta Ket',
        },
        districtId: 299,
      },
      {
        id: '331011',
        zipcode: 33120,
        text: 'หัวช้าง',
        value: 'หัวช้าง',
        name: {
          th: 'หัวช้าง',
          en: 'Hua Chang',
        },
        districtId: 299,
      },
      {
        id: '331012',
        zipcode: 33120,
        text: 'รังแร้ง',
        value: 'รังแร้ง',
        name: {
          th: 'รังแร้ง',
          en: 'Rang Raeng',
        },
        districtId: 299,
      },
      {
        id: '331014',
        zipcode: 33120,
        text: 'แต้',
        value: 'แต้',
        name: {
          th: 'แต้',
          en: 'Tae',
        },
        districtId: 299,
      },
      {
        id: '331015',
        zipcode: 33120,
        text: 'แข้',
        value: 'แข้',
        name: {
          th: 'แข้',
          en: 'Khae',
        },
        districtId: 299,
      },
      {
        id: '331016',
        zipcode: 33120,
        text: 'โพธิ์ชัย',
        value: 'โพธิ์ชัย',
        name: {
          th: 'โพธิ์ชัย',
          en: 'Pho Chai',
        },
        districtId: 299,
      },
      {
        id: '331017',
        zipcode: 33120,
        text: 'ปะอาว',
        value: 'ปะอาว',
        name: {
          th: 'ปะอาว',
          en: 'Pa Ao',
        },
        districtId: 299,
      },
      {
        id: '331018',
        zipcode: 33120,
        text: 'หนองห้าง',
        value: 'หนองห้าง',
        name: {
          th: 'หนองห้าง',
          en: 'Nong Hang',
        },
        districtId: 299,
      },
      {
        id: '331022',
        zipcode: 33120,
        text: 'สระกำแพงใหญ่',
        value: 'สระกำแพงใหญ่',
        name: {
          th: 'สระกำแพงใหญ่',
          en: 'Sa Kamphaeng Yai',
        },
        districtId: 299,
      },
      {
        id: '331024',
        zipcode: 33120,
        text: 'โคกหล่าม',
        value: 'โคกหล่าม',
        name: {
          th: 'โคกหล่าม',
          en: 'Khok Lam',
        },
        districtId: 299,
      },
      {
        id: '331025',
        zipcode: 33120,
        text: 'โคกจาน',
        value: 'โคกจาน',
        name: {
          th: 'โคกจาน',
          en: 'Khok Chan',
        },
        districtId: 299,
      },
      {
        id: '331101',
        zipcode: 33220,
        text: 'เป๊าะ',
        value: 'เป๊าะ',
        name: {
          th: 'เป๊าะ',
          en: 'Po',
        },
        districtId: 300,
      },
      {
        id: '331102',
        zipcode: 33220,
        text: 'บึงบูรพ์',
        value: 'บึงบูรพ์',
        name: {
          th: 'บึงบูรพ์',
          en: 'Bueng Bun',
        },
        districtId: 300,
      },
      {
        id: '331201',
        zipcode: 33210,
        text: 'ห้วยทับทัน',
        value: 'ห้วยทับทัน',
        name: {
          th: 'ห้วยทับทัน',
          en: 'Huai Thap Than',
        },
        districtId: 301,
      },
      {
        id: '331202',
        zipcode: 33210,
        text: 'เมืองหลวง',
        value: 'เมืองหลวง',
        name: {
          th: 'เมืองหลวง',
          en: 'Mueang Luang',
        },
        districtId: 301,
      },
      {
        id: '331203',
        zipcode: 33210,
        text: 'กล้วยกว้าง',
        value: 'กล้วยกว้าง',
        name: {
          th: 'กล้วยกว้าง',
          en: 'Kluai Kwang',
        },
        districtId: 301,
      },
      {
        id: '331204',
        zipcode: 33210,
        text: 'ผักไหม',
        value: 'ผักไหม',
        name: {
          th: 'ผักไหม',
          en: 'Phak Mai',
        },
        districtId: 301,
      },
      {
        id: '331205',
        zipcode: 33210,
        text: 'จานแสนไชย',
        value: 'จานแสนไชย',
        name: {
          th: 'จานแสนไชย',
          en: 'Chan Saen Chai',
        },
        districtId: 301,
      },
      {
        id: '331206',
        zipcode: 33210,
        text: 'ปราสาท',
        value: 'ปราสาท',
        name: {
          th: 'ปราสาท',
          en: 'Prasat',
        },
        districtId: 301,
      },
      {
        id: '331301',
        zipcode: 33250,
        text: 'โนนค้อ',
        value: 'โนนค้อ',
        name: {
          th: 'โนนค้อ',
          en: 'Non Kho',
        },
        districtId: 302,
      },
      {
        id: '331302',
        zipcode: 33250,
        text: 'บก',
        value: 'บก',
        name: {
          th: 'บก',
          en: 'Bok',
        },
        districtId: 302,
      },
      {
        id: '331303',
        zipcode: 33250,
        text: 'โพธิ์',
        value: 'โพธิ์',
        name: {
          th: 'โพธิ์',
          en: 'Pho',
        },
        districtId: 302,
      },
      {
        id: '331304',
        zipcode: 33250,
        text: 'หนองกุง',
        value: 'หนองกุง',
        name: {
          th: 'หนองกุง',
          en: 'Nong Kung',
        },
        districtId: 302,
      },
      {
        id: '331305',
        zipcode: 33250,
        text: 'เหล่ากวาง',
        value: 'เหล่ากวาง',
        name: {
          th: 'เหล่ากวาง',
          en: 'Lao Kwang',
        },
        districtId: 302,
      },
      {
        id: '331401',
        zipcode: 33240,
        text: 'ศรีแก้ว',
        value: 'ศรีแก้ว',
        name: {
          th: 'ศรีแก้ว',
          en: 'Si Kaeo',
        },
        districtId: 303,
      },
      {
        id: '331402',
        zipcode: 33240,
        text: 'พิงพวย',
        value: 'พิงพวย',
        name: {
          th: 'พิงพวย',
          en: 'Phing Phuai',
        },
        districtId: 303,
      },
      {
        id: '331403',
        zipcode: 33240,
        text: 'สระเยาว์',
        value: 'สระเยาว์',
        name: {
          th: 'สระเยาว์',
          en: 'Sa Yao',
        },
        districtId: 303,
      },
      {
        id: '331404',
        zipcode: 33240,
        text: 'ตูม',
        value: 'ตูม',
        name: {
          th: 'ตูม',
          en: 'Tum',
        },
        districtId: 303,
      },
      {
        id: '331405',
        zipcode: 33240,
        text: 'เสื่องข้าว',
        value: 'เสื่องข้าว',
        name: {
          th: 'เสื่องข้าว',
          en: 'Sueang Khao',
        },
        districtId: 303,
      },
      {
        id: '331406',
        zipcode: 33240,
        text: 'ศรีโนนงาม',
        value: 'ศรีโนนงาม',
        name: {
          th: 'ศรีโนนงาม',
          en: 'Si Non Ngam',
        },
        districtId: 303,
      },
      {
        id: '331407',
        zipcode: 33240,
        text: 'สะพุง',
        value: 'สะพุง',
        name: {
          th: 'สะพุง',
          en: 'Saphung',
        },
        districtId: 303,
      },
      {
        id: '331501',
        zipcode: 33130,
        text: 'น้ำเกลี้ยง',
        value: 'น้ำเกลี้ยง',
        name: {
          th: 'น้ำเกลี้ยง',
          en: 'Nam Kliang',
        },
        districtId: 304,
      },
      {
        id: '331502',
        zipcode: 33130,
        text: 'ละเอาะ',
        value: 'ละเอาะ',
        name: {
          th: 'ละเอาะ',
          en: 'La-o',
        },
        districtId: 304,
      },
      {
        id: '331503',
        zipcode: 33130,
        text: 'ตองปิด',
        value: 'ตองปิด',
        name: {
          th: 'ตองปิด',
          en: 'Tong Pit',
        },
        districtId: 304,
      },
      {
        id: '331504',
        zipcode: 33130,
        text: 'เขิน',
        value: 'เขิน',
        name: {
          th: 'เขิน',
          en: 'Khoen',
        },
        districtId: 304,
      },
      {
        id: '331505',
        zipcode: 33130,
        text: 'รุ่งระวี',
        value: 'รุ่งระวี',
        name: {
          th: 'รุ่งระวี',
          en: 'Rung Rawi',
        },
        districtId: 304,
      },
      {
        id: '331506',
        zipcode: 33130,
        text: 'คูบ',
        value: 'คูบ',
        name: {
          th: 'คูบ',
          en: 'Khup',
        },
        districtId: 304,
      },
      {
        id: '331601',
        zipcode: 33270,
        text: 'บุสูง',
        value: 'บุสูง',
        name: {
          th: 'บุสูง',
          en: 'Bu Sung',
        },
        districtId: 305,
      },
      {
        id: '331602',
        zipcode: 33270,
        text: 'ธาตุ',
        value: 'ธาตุ',
        name: {
          th: 'ธาตุ',
          en: 'That',
        },
        districtId: 305,
      },
      {
        id: '331603',
        zipcode: 33270,
        text: 'ดวนใหญ่',
        value: 'ดวนใหญ่',
        name: {
          th: 'ดวนใหญ่',
          en: 'Duan Yai',
        },
        districtId: 305,
      },
      {
        id: '331604',
        zipcode: 33270,
        text: 'บ่อแก้ว',
        value: 'บ่อแก้ว',
        name: {
          th: 'บ่อแก้ว',
          en: 'Bo Kaeo',
        },
        districtId: 305,
      },
      {
        id: '331605',
        zipcode: 33270,
        text: 'ศรีสำราญ',
        value: 'ศรีสำราญ',
        name: {
          th: 'ศรีสำราญ',
          en: 'Si Samran',
        },
        districtId: 305,
      },
      {
        id: '331606',
        zipcode: 33270,
        text: 'ทุ่งสว่าง',
        value: 'ทุ่งสว่าง',
        name: {
          th: 'ทุ่งสว่าง',
          en: 'Thung Sawang',
        },
        districtId: 305,
      },
      {
        id: '331607',
        zipcode: 33270,
        text: 'วังหิน',
        value: 'วังหิน',
        name: {
          th: 'วังหิน',
          en: 'Wang Hin',
        },
        districtId: 305,
      },
      {
        id: '331608',
        zipcode: 33270,
        text: 'โพนยาง',
        value: 'โพนยาง',
        name: {
          th: 'โพนยาง',
          en: 'Phon Yang',
        },
        districtId: 305,
      },
      {
        id: '331701',
        zipcode: 33140,
        text: 'โคกตาล',
        value: 'โคกตาล',
        name: {
          th: 'โคกตาล',
          en: 'Khok Tan',
        },
        districtId: 306,
      },
      {
        id: '331702',
        zipcode: 33140,
        text: 'ห้วยตามอญ',
        value: 'ห้วยตามอญ',
        name: {
          th: 'ห้วยตามอญ',
          en: 'Huai Ta Mon',
        },
        districtId: 306,
      },
      {
        id: '331703',
        zipcode: 33140,
        text: 'ห้วยตึ๊กชู',
        value: 'ห้วยตึ๊กชู',
        name: {
          th: 'ห้วยตึ๊กชู',
          en: 'Huai Tuekchu',
        },
        districtId: 306,
      },
      {
        id: '331704',
        zipcode: 33140,
        text: 'ละลม',
        value: 'ละลม',
        name: {
          th: 'ละลม',
          en: 'Lalom',
        },
        districtId: 306,
      },
      {
        id: '331705',
        zipcode: 33140,
        text: 'ตะเคียนราม',
        value: 'ตะเคียนราม',
        name: {
          th: 'ตะเคียนราม',
          en: 'Takhian Ram',
        },
        districtId: 306,
      },
      {
        id: '331706',
        zipcode: 33140,
        text: 'ดงรัก',
        value: 'ดงรัก',
        name: {
          th: 'ดงรัก',
          en: 'Dong Rak',
        },
        districtId: 306,
      },
      {
        id: '331707',
        zipcode: 33140,
        text: 'ไพรพัฒนา',
        value: 'ไพรพัฒนา',
        name: {
          th: 'ไพรพัฒนา',
          en: 'Phrai Phatthana',
        },
        districtId: 306,
      },
      {
        id: '331801',
        zipcode: 33120,
        text: 'เมืองจันทร์',
        value: 'เมืองจันทร์',
        name: {
          th: 'เมืองจันทร์',
          en: 'Mueang Chan',
        },
        districtId: 307,
      },
      {
        id: '331802',
        zipcode: 33120,
        text: 'ตาโกน',
        value: 'ตาโกน',
        name: {
          th: 'ตาโกน',
          en: 'Takon',
        },
        districtId: 307,
      },
      {
        id: '331803',
        zipcode: 33120,
        text: 'หนองใหญ่',
        value: 'หนองใหญ่',
        name: {
          th: 'หนองใหญ่',
          en: 'Nong Yai',
        },
        districtId: 307,
      },
      {
        id: '331901',
        zipcode: 33110,
        text: 'เสียว',
        value: 'เสียว',
        name: {
          th: 'เสียว',
          en: 'Siao',
        },
        districtId: 308,
      },
      {
        id: '331902',
        zipcode: 33110,
        text: 'หนองหว้า',
        value: 'หนองหว้า',
        name: {
          th: 'หนองหว้า',
          en: 'Nong Wa',
        },
        districtId: 308,
      },
      {
        id: '331903',
        zipcode: 33110,
        text: 'หนองงูเหลือม',
        value: 'หนองงูเหลือม',
        name: {
          th: 'หนองงูเหลือม',
          en: 'Nong Ngu Lueam',
        },
        districtId: 308,
      },
      {
        id: '331904',
        zipcode: 33110,
        text: 'หนองฮาง',
        value: 'หนองฮาง',
        name: {
          th: 'หนองฮาง',
          en: 'Nong Hang',
        },
        districtId: 308,
      },
      {
        id: '331905',
        zipcode: 33110,
        text: 'ท่าคล้อ',
        value: 'ท่าคล้อ',
        name: {
          th: 'ท่าคล้อ',
          en: 'Tha Khlo',
        },
        districtId: 308,
      },
      {
        id: '332001',
        zipcode: 33230,
        text: 'พยุห์',
        value: 'พยุห์',
        name: {
          th: 'พยุห์',
          en: 'Phayu',
        },
        districtId: 309,
      },
      {
        id: '332002',
        zipcode: 33230,
        text: 'พรหมสวัสดิ์',
        value: 'พรหมสวัสดิ์',
        name: {
          th: 'พรหมสวัสดิ์',
          en: 'Phrom Sawat',
        },
        districtId: 309,
      },
      {
        id: '332003',
        zipcode: 33230,
        text: 'ตำแย',
        value: 'ตำแย',
        name: {
          th: 'ตำแย',
          en: 'Tamyae',
        },
        districtId: 309,
      },
      {
        id: '332004',
        zipcode: 33230,
        text: 'โนนเพ็ก',
        value: 'โนนเพ็ก',
        name: {
          th: 'โนนเพ็ก',
          en: 'Non Phek',
        },
        districtId: 309,
      },
      {
        id: '332005',
        zipcode: 33230,
        text: 'หนองค้า',
        value: 'หนองค้า',
        name: {
          th: 'หนองค้า',
          en: 'Nong Kha',
        },
        districtId: 309,
      },
      {
        id: '332101',
        zipcode: 33120,
        text: 'โดด',
        value: 'โดด',
        name: {
          th: 'โดด',
          en: 'Dot',
        },
        districtId: 310,
      },
      {
        id: '332102',
        zipcode: 33120,
        text: 'เสียว',
        value: 'เสียว',
        name: {
          th: 'เสียว',
          en: 'Siao',
        },
        districtId: 310,
      },
      {
        id: '332103',
        zipcode: 33120,
        text: 'หนองม้า',
        value: 'หนองม้า',
        name: {
          th: 'หนองม้า',
          en: 'Nong Ma',
        },
        districtId: 310,
      },
      {
        id: '332104',
        zipcode: 33120,
        text: 'ผือใหญ่',
        value: 'ผือใหญ่',
        name: {
          th: 'ผือใหญ่',
          en: 'Phue Yai',
        },
        districtId: 310,
      },
      {
        id: '332105',
        zipcode: 33120,
        text: 'อีเซ',
        value: 'อีเซ',
        name: {
          th: 'อีเซ',
          en: 'I Se',
        },
        districtId: 310,
      },
      {
        id: '332201',
        zipcode: 33160,
        text: 'กุง',
        value: 'กุง',
        name: {
          th: 'กุง',
          en: 'Kung',
        },
        districtId: 311,
      },
      {
        id: '332202',
        zipcode: 33160,
        text: 'คลีกลิ้ง',
        value: 'คลีกลิ้ง',
        name: {
          th: 'คลีกลิ้ง',
          en: 'Kleek Ling',
        },
        districtId: 311,
      },
      {
        id: '332203',
        zipcode: 33160,
        text: 'หนองบัวดง',
        value: 'หนองบัวดง',
        name: {
          th: 'หนองบัวดง',
          en: 'Nong Bua Dong',
        },
        districtId: 311,
      },
      {
        id: '332204',
        zipcode: 33160,
        text: 'โจดม่วง',
        value: 'โจดม่วง',
        name: {
          th: 'โจดม่วง',
          en: 'Jod Maung',
        },
        districtId: 311,
      },
      {
        id: '340101',
        zipcode: 34000,
        text: 'ในเมือง',
        value: 'ในเมือง',
        name: {
          th: 'ในเมือง',
          en: 'Nai Mueang',
        },
        districtId: 312,
      },
      {
        id: '340104',
        zipcode: 34000,
        text: 'หัวเรือ',
        value: 'หัวเรือ',
        name: {
          th: 'หัวเรือ',
          en: 'Hua Ruea',
        },
        districtId: 312,
      },
      {
        id: '340105',
        zipcode: 34000,
        text: 'หนองขอน',
        value: 'หนองขอน',
        name: {
          th: 'หนองขอน',
          en: 'Nong Khon',
        },
        districtId: 312,
      },
      {
        id: '340107',
        zipcode: 34000,
        text: 'ปทุม',
        value: 'ปทุม',
        name: {
          th: 'ปทุม',
          en: 'Pathum',
        },
        districtId: 312,
      },
      {
        id: '340108',
        zipcode: 34000,
        text: 'ขามใหญ่',
        value: 'ขามใหญ่',
        name: {
          th: 'ขามใหญ่',
          en: 'Kham Yai',
        },
        districtId: 312,
      },
      {
        id: '340109',
        zipcode: 34000,
        text: 'แจระแม',
        value: 'แจระแม',
        name: {
          th: 'แจระแม',
          en: 'Chaeramae',
        },
        districtId: 312,
      },
      {
        id: '340111',
        zipcode: 34000,
        text: 'หนองบ่อ',
        value: 'หนองบ่อ',
        name: {
          th: 'หนองบ่อ',
          en: 'Nong Bo',
        },
        districtId: 312,
      },
      {
        id: '340112',
        zipcode: 34000,
        text: 'ไร่น้อย',
        value: 'ไร่น้อย',
        name: {
          th: 'ไร่น้อย',
          en: 'Rai Noi',
        },
        districtId: 312,
      },
      {
        id: '340113',
        zipcode: 34000,
        text: 'กระโสบ',
        value: 'กระโสบ',
        name: {
          th: 'กระโสบ',
          en: 'Krasop',
        },
        districtId: 312,
      },
      {
        id: '340116',
        zipcode: 34000,
        text: 'กุดลาด',
        value: 'กุดลาด',
        name: {
          th: 'กุดลาด',
          en: 'Kut Lat',
        },
        districtId: 312,
      },
      {
        id: '340119',
        zipcode: 34000,
        text: 'ขี้เหล็ก',
        value: 'ขี้เหล็ก',
        name: {
          th: 'ขี้เหล็ก',
          en: 'Khilek',
        },
        districtId: 312,
      },
      {
        id: '340120',
        zipcode: 34000,
        text: 'ปะอาว',
        value: 'ปะอาว',
        name: {
          th: 'ปะอาว',
          en: 'Pa-ao',
        },
        districtId: 312,
      },
      {
        id: '340201',
        zipcode: 34250,
        text: 'นาคำ',
        value: 'นาคำ',
        name: {
          th: 'นาคำ',
          en: 'Na Kham',
        },
        districtId: 313,
      },
      {
        id: '340202',
        zipcode: 34250,
        text: 'แก้งกอก',
        value: 'แก้งกอก',
        name: {
          th: 'แก้งกอก',
          en: 'Kaeng Kok',
        },
        districtId: 313,
      },
      {
        id: '340203',
        zipcode: 34250,
        text: 'เอือดใหญ่',
        value: 'เอือดใหญ่',
        name: {
          th: 'เอือดใหญ่',
          en: 'Ueat Yai',
        },
        districtId: 313,
      },
      {
        id: '340204',
        zipcode: 34250,
        text: 'วาริน',
        value: 'วาริน',
        name: {
          th: 'วาริน',
          en: 'Warin',
        },
        districtId: 313,
      },
      {
        id: '340205',
        zipcode: 34250,
        text: 'ลาดควาย',
        value: 'ลาดควาย',
        name: {
          th: 'ลาดควาย',
          en: 'Lat Khwai',
        },
        districtId: 313,
      },
      {
        id: '340206',
        zipcode: 34250,
        text: 'สงยาง',
        value: 'สงยาง',
        name: {
          th: 'สงยาง',
          en: 'Song Yang',
        },
        districtId: 313,
      },
      {
        id: '340207',
        zipcode: 34250,
        text: 'ตะบ่าย',
        value: 'ตะบ่าย',
        name: {
          th: 'ตะบ่าย',
          en: 'Ta Bai',
        },
        districtId: 313,
      },
      {
        id: '340208',
        zipcode: 34250,
        text: 'คำไหล',
        value: 'คำไหล',
        name: {
          th: 'คำไหล',
          en: 'Kham Lai',
        },
        districtId: 313,
      },
      {
        id: '340209',
        zipcode: 34250,
        text: 'หนามแท่ง',
        value: 'หนามแท่ง',
        name: {
          th: 'หนามแท่ง',
          en: 'Nam Thaeng',
        },
        districtId: 313,
      },
      {
        id: '340210',
        zipcode: 34250,
        text: 'นาเลิน',
        value: 'นาเลิน',
        name: {
          th: 'นาเลิน',
          en: 'Na Loen',
        },
        districtId: 313,
      },
      {
        id: '340211',
        zipcode: 34250,
        text: 'ดอนใหญ่',
        value: 'ดอนใหญ่',
        name: {
          th: 'ดอนใหญ่',
          en: 'Don Yai',
        },
        districtId: 313,
      },
      {
        id: '340301',
        zipcode: 34220,
        text: 'โขงเจียม',
        value: 'โขงเจียม',
        name: {
          th: 'โขงเจียม',
          en: 'Khong Chiam',
        },
        districtId: 314,
      },
      {
        id: '340302',
        zipcode: 34220,
        text: 'ห้วยยาง',
        value: 'ห้วยยาง',
        name: {
          th: 'ห้วยยาง',
          en: 'Huai Yang',
        },
        districtId: 314,
      },
      {
        id: '340303',
        zipcode: 34220,
        text: 'นาโพธิ์กลาง',
        value: 'นาโพธิ์กลาง',
        name: {
          th: 'นาโพธิ์กลาง',
          en: 'Na Pho Klang',
        },
        districtId: 314,
      },
      {
        id: '340304',
        zipcode: 34220,
        text: 'หนองแสงใหญ่',
        value: 'หนองแสงใหญ่',
        name: {
          th: 'หนองแสงใหญ่',
          en: 'Nong Saeng Yai',
        },
        districtId: 314,
      },
      {
        id: '340305',
        zipcode: 34220,
        text: 'ห้วยไผ่',
        value: 'ห้วยไผ่',
        name: {
          th: 'ห้วยไผ่',
          en: 'Huai Phai',
        },
        districtId: 314,
      },
      {
        id: '340306',
        zipcode: 34220,
        text: 'คำเขื่อนแก้ว',
        value: 'คำเขื่อนแก้ว',
        name: {
          th: 'คำเขื่อนแก้ว',
          en: 'Kham Khuen Kaew',
        },
        districtId: 314,
      },
      {
        id: '340401',
        zipcode: 34150,
        text: 'เขื่องใน',
        value: 'เขื่องใน',
        name: {
          th: 'เขื่องใน',
          en: 'Khueang Nai',
        },
        districtId: 315,
      },
      {
        id: '340402',
        zipcode: 34150,
        text: 'สร้างถ่อ',
        value: 'สร้างถ่อ',
        name: {
          th: 'สร้างถ่อ',
          en: 'Sang Tho',
        },
        districtId: 315,
      },
      {
        id: '340403',
        zipcode: 34150,
        text: 'ค้อทอง',
        value: 'ค้อทอง',
        name: {
          th: 'ค้อทอง',
          en: 'Kho Thong',
        },
        districtId: 315,
      },
      {
        id: '340404',
        zipcode: 34150,
        text: 'ก่อเอ้',
        value: 'ก่อเอ้',
        name: {
          th: 'ก่อเอ้',
          en: 'Ko E',
        },
        districtId: 315,
      },
      {
        id: '340405',
        zipcode: 34150,
        text: 'หัวดอน',
        value: 'หัวดอน',
        name: {
          th: 'หัวดอน',
          en: 'Hua Don',
        },
        districtId: 315,
      },
      {
        id: '340406',
        zipcode: 34150,
        text: 'ชีทวน',
        value: 'ชีทวน',
        name: {
          th: 'ชีทวน',
          en: 'Chi Thuan',
        },
        districtId: 315,
      },
      {
        id: '340407',
        zipcode: 34150,
        text: 'ท่าไห',
        value: 'ท่าไห',
        name: {
          th: 'ท่าไห',
          en: 'Tha Hai',
        },
        districtId: 315,
      },
      {
        id: '340408',
        zipcode: 34150,
        text: 'นาคำใหญ่',
        value: 'นาคำใหญ่',
        name: {
          th: 'นาคำใหญ่',
          en: 'Na Kham Yai',
        },
        districtId: 315,
      },
      {
        id: '340409',
        zipcode: 34150,
        text: 'แดงหม้อ',
        value: 'แดงหม้อ',
        name: {
          th: 'แดงหม้อ',
          en: 'Daeng Mo',
        },
        districtId: 315,
      },
      {
        id: '340410',
        zipcode: 34150,
        text: 'ธาตุน้อย',
        value: 'ธาตุน้อย',
        name: {
          th: 'ธาตุน้อย',
          en: 'That Noi',
        },
        districtId: 315,
      },
      {
        id: '340411',
        zipcode: 34320,
        text: 'บ้านไทย',
        value: 'บ้านไทย',
        name: {
          th: 'บ้านไทย',
          en: 'Ban Thai',
        },
        districtId: 315,
      },
      {
        id: '340412',
        zipcode: 34320,
        text: 'บ้านกอก',
        value: 'บ้านกอก',
        name: {
          th: 'บ้านกอก',
          en: 'Ban Kok',
        },
        districtId: 315,
      },
      {
        id: '340413',
        zipcode: 34320,
        text: 'กลางใหญ่',
        value: 'กลางใหญ่',
        name: {
          th: 'กลางใหญ่',
          en: 'Klang Yai',
        },
        districtId: 315,
      },
      {
        id: '340414',
        zipcode: 34320,
        text: 'โนนรัง',
        value: 'โนนรัง',
        name: {
          th: 'โนนรัง',
          en: 'Non Rang',
        },
        districtId: 315,
      },
      {
        id: '340415',
        zipcode: 34150,
        text: 'ยางขี้นก',
        value: 'ยางขี้นก',
        name: {
          th: 'ยางขี้นก',
          en: 'Yang Khi Nok',
        },
        districtId: 315,
      },
      {
        id: '340416',
        zipcode: 34150,
        text: 'ศรีสุข',
        value: 'ศรีสุข',
        name: {
          th: 'ศรีสุข',
          en: 'Si Suk',
        },
        districtId: 315,
      },
      {
        id: '340417',
        zipcode: 34150,
        text: 'สหธาตุ',
        value: 'สหธาตุ',
        name: {
          th: 'สหธาตุ',
          en: 'Sahathat',
        },
        districtId: 315,
      },
      {
        id: '340418',
        zipcode: 34150,
        text: 'หนองเหล่า',
        value: 'หนองเหล่า',
        name: {
          th: 'หนองเหล่า',
          en: 'Nong Lao',
        },
        districtId: 315,
      },
      {
        id: '340501',
        zipcode: 34170,
        text: 'เขมราฐ',
        value: 'เขมราฐ',
        name: {
          th: 'เขมราฐ',
          en: 'Khemarat',
        },
        districtId: 316,
      },
      {
        id: '340503',
        zipcode: 34170,
        text: 'ขามป้อม',
        value: 'ขามป้อม',
        name: {
          th: 'ขามป้อม',
          en: 'Kham Pom',
        },
        districtId: 316,
      },
      {
        id: '340504',
        zipcode: 34170,
        text: 'เจียด',
        value: 'เจียด',
        name: {
          th: 'เจียด',
          en: 'Chiat',
        },
        districtId: 316,
      },
      {
        id: '340507',
        zipcode: 34170,
        text: 'หนองผือ',
        value: 'หนองผือ',
        name: {
          th: 'หนองผือ',
          en: 'Nong Phue',
        },
        districtId: 316,
      },
      {
        id: '340508',
        zipcode: 34170,
        text: 'นาแวง',
        value: 'นาแวง',
        name: {
          th: 'นาแวง',
          en: 'Na Waeng',
        },
        districtId: 316,
      },
      {
        id: '340510',
        zipcode: 34170,
        text: 'แก้งเหนือ',
        value: 'แก้งเหนือ',
        name: {
          th: 'แก้งเหนือ',
          en: 'Kaeng Nuea',
        },
        districtId: 316,
      },
      {
        id: '340511',
        zipcode: 34170,
        text: 'หนองนกทา',
        value: 'หนองนกทา',
        name: {
          th: 'หนองนกทา',
          en: 'Nong Nok Tha',
        },
        districtId: 316,
      },
      {
        id: '340512',
        zipcode: 34170,
        text: 'หนองสิม',
        value: 'หนองสิม',
        name: {
          th: 'หนองสิม',
          en: 'Nong Sim',
        },
        districtId: 316,
      },
      {
        id: '340513',
        zipcode: 34170,
        text: 'หัวนา',
        value: 'หัวนา',
        name: {
          th: 'หัวนา',
          en: 'Hua Na',
        },
        districtId: 316,
      },
      {
        id: '340701',
        zipcode: 34160,
        text: 'เมืองเดช',
        value: 'เมืองเดช',
        name: {
          th: 'เมืองเดช',
          en: 'Mueang Det',
        },
        districtId: 318,
      },
      {
        id: '340702',
        zipcode: 34160,
        text: 'นาส่วง',
        value: 'นาส่วง',
        name: {
          th: 'นาส่วง',
          en: 'Na Suang',
        },
        districtId: 318,
      },
      {
        id: '340704',
        zipcode: 34160,
        text: 'นาเจริญ',
        value: 'นาเจริญ',
        name: {
          th: 'นาเจริญ',
          en: 'Na Charoen',
        },
        districtId: 318,
      },
      {
        id: '340706',
        zipcode: 34160,
        text: 'ทุ่งเทิง',
        value: 'ทุ่งเทิง',
        name: {
          th: 'ทุ่งเทิง',
          en: 'Thung Thoeng',
        },
        districtId: 318,
      },
      {
        id: '340708',
        zipcode: 34160,
        text: 'สมสะอาด',
        value: 'สมสะอาด',
        name: {
          th: 'สมสะอาด',
          en: 'Som Sa-at',
        },
        districtId: 318,
      },
      {
        id: '340709',
        zipcode: 34160,
        text: 'กุดประทาย',
        value: 'กุดประทาย',
        name: {
          th: 'กุดประทาย',
          en: 'Kut Prathai',
        },
        districtId: 318,
      },
      {
        id: '340710',
        zipcode: 34160,
        text: 'ตบหู',
        value: 'ตบหู',
        name: {
          th: 'ตบหู',
          en: 'Top Hu',
        },
        districtId: 318,
      },
      {
        id: '340711',
        zipcode: 34160,
        text: 'กลาง',
        value: 'กลาง',
        name: {
          th: 'กลาง',
          en: 'Klang',
        },
        districtId: 318,
      },
      {
        id: '340712',
        zipcode: 34160,
        text: 'แก้ง',
        value: 'แก้ง',
        name: {
          th: 'แก้ง',
          en: 'Kaeng',
        },
        districtId: 318,
      },
      {
        id: '340713',
        zipcode: 34160,
        text: 'ท่าโพธิ์ศรี',
        value: 'ท่าโพธิ์ศรี',
        name: {
          th: 'ท่าโพธิ์ศรี',
          en: 'Tha Pho Si',
        },
        districtId: 318,
      },
      {
        id: '340715',
        zipcode: 34160,
        text: 'บัวงาม',
        value: 'บัวงาม',
        name: {
          th: 'บัวงาม',
          en: 'Bua Ngam',
        },
        districtId: 318,
      },
      {
        id: '340716',
        zipcode: 34160,
        text: 'คำครั่ง',
        value: 'คำครั่ง',
        name: {
          th: 'คำครั่ง',
          en: 'Kham Khrang',
        },
        districtId: 318,
      },
      {
        id: '340717',
        zipcode: 34160,
        text: 'นากระแซง',
        value: 'นากระแซง',
        name: {
          th: 'นากระแซง',
          en: 'Na Krasaeng',
        },
        districtId: 318,
      },
      {
        id: '340720',
        zipcode: 34160,
        text: 'โพนงาม',
        value: 'โพนงาม',
        name: {
          th: 'โพนงาม',
          en: 'Phon Ngam',
        },
        districtId: 318,
      },
      {
        id: '340721',
        zipcode: 34160,
        text: 'ป่าโมง',
        value: 'ป่าโมง',
        name: {
          th: 'ป่าโมง',
          en: 'Pa Mong',
        },
        districtId: 318,
      },
      {
        id: '340723',
        zipcode: 34160,
        text: 'โนนสมบูรณ์',
        value: 'โนนสมบูรณ์',
        name: {
          th: 'โนนสมบูรณ์',
          en: 'Non Sombun',
        },
        districtId: 318,
      },
      {
        id: '340801',
        zipcode: 34280,
        text: 'นาจะหลวย',
        value: 'นาจะหลวย',
        name: {
          th: 'นาจะหลวย',
          en: 'Na Chaluai',
        },
        districtId: 319,
      },
      {
        id: '340802',
        zipcode: 34280,
        text: 'โนนสมบูรณ์',
        value: 'โนนสมบูรณ์',
        name: {
          th: 'โนนสมบูรณ์',
          en: 'Non Sombun',
        },
        districtId: 319,
      },
      {
        id: '340803',
        zipcode: 34280,
        text: 'พรสวรรค์',
        value: 'พรสวรรค์',
        name: {
          th: 'พรสวรรค์',
          en: 'Phon Sawan',
        },
        districtId: 319,
      },
      {
        id: '340804',
        zipcode: 34280,
        text: 'บ้านตูม',
        value: 'บ้านตูม',
        name: {
          th: 'บ้านตูม',
          en: 'Ban Tum',
        },
        districtId: 319,
      },
      {
        id: '340805',
        zipcode: 34280,
        text: 'โสกแสง',
        value: 'โสกแสง',
        name: {
          th: 'โสกแสง',
          en: 'Sok Saeng',
        },
        districtId: 319,
      },
      {
        id: '340806',
        zipcode: 34280,
        text: 'โนนสวรรค์',
        value: 'โนนสวรรค์',
        name: {
          th: 'โนนสวรรค์',
          en: 'Non Sawan',
        },
        districtId: 319,
      },
      {
        id: '340901',
        zipcode: 34260,
        text: 'โซง',
        value: 'โซง',
        name: {
          th: 'โซง',
          en: 'Song',
        },
        districtId: 320,
      },
      {
        id: '340903',
        zipcode: 34260,
        text: 'ยาง',
        value: 'ยาง',
        name: {
          th: 'ยาง',
          en: 'Yang',
        },
        districtId: 320,
      },
      {
        id: '340904',
        zipcode: 34260,
        text: 'โดมประดิษฐ์',
        value: 'โดมประดิษฐ์',
        name: {
          th: 'โดมประดิษฐ์',
          en: 'Dom Pradit',
        },
        districtId: 320,
      },
      {
        id: '340906',
        zipcode: 34260,
        text: 'บุเปือย',
        value: 'บุเปือย',
        name: {
          th: 'บุเปือย',
          en: 'Bu Pueai',
        },
        districtId: 320,
      },
      {
        id: '340907',
        zipcode: 34260,
        text: 'สีวิเชียร',
        value: 'สีวิเชียร',
        name: {
          th: 'สีวิเชียร',
          en: 'Si Wichian',
        },
        districtId: 320,
      },
      {
        id: '340909',
        zipcode: 34260,
        text: 'ยางใหญ่',
        value: 'ยางใหญ่',
        name: {
          th: 'ยางใหญ่',
          en: 'Yang Yai',
        },
        districtId: 320,
      },
      {
        id: '340911',
        zipcode: 34260,
        text: 'เก่าขาม',
        value: 'เก่าขาม',
        name: {
          th: 'เก่าขาม',
          en: 'Kao Kham',
        },
        districtId: 320,
      },
      {
        id: '341001',
        zipcode: 34230,
        text: 'โพนงาม',
        value: 'โพนงาม',
        name: {
          th: 'โพนงาม',
          en: 'Phon Ngam',
        },
        districtId: 321,
      },
      {
        id: '341002',
        zipcode: 34230,
        text: 'ห้วยข่า',
        value: 'ห้วยข่า',
        name: {
          th: 'ห้วยข่า',
          en: 'Huai Kha',
        },
        districtId: 321,
      },
      {
        id: '341003',
        zipcode: 34230,
        text: 'คอแลน',
        value: 'คอแลน',
        name: {
          th: 'คอแลน',
          en: 'Kho Laen',
        },
        districtId: 321,
      },
      {
        id: '341004',
        zipcode: 34230,
        text: 'นาโพธิ์',
        value: 'นาโพธิ์',
        name: {
          th: 'นาโพธิ์',
          en: 'Na Pho',
        },
        districtId: 321,
      },
      {
        id: '341005',
        zipcode: 34230,
        text: 'หนองสะโน',
        value: 'หนองสะโน',
        name: {
          th: 'หนองสะโน',
          en: 'Nong Sano',
        },
        districtId: 321,
      },
      {
        id: '341006',
        zipcode: 34230,
        text: 'โนนค้อ',
        value: 'โนนค้อ',
        name: {
          th: 'โนนค้อ',
          en: 'Non Kho',
        },
        districtId: 321,
      },
      {
        id: '341007',
        zipcode: 34230,
        text: 'บัวงาม',
        value: 'บัวงาม',
        name: {
          th: 'บัวงาม',
          en: 'Bua Ngam',
        },
        districtId: 321,
      },
      {
        id: '341008',
        zipcode: 34230,
        text: 'บ้านแมด',
        value: 'บ้านแมด',
        name: {
          th: 'บ้านแมด',
          en: 'Ban Maet',
        },
        districtId: 321,
      },
      {
        id: '341101',
        zipcode: 34130,
        text: 'ขุหลุ',
        value: 'ขุหลุ',
        name: {
          th: 'ขุหลุ',
          en: 'Khulu',
        },
        districtId: 322,
      },
      {
        id: '341102',
        zipcode: 34130,
        text: 'กระเดียน',
        value: 'กระเดียน',
        name: {
          th: 'กระเดียน',
          en: 'Kradian',
        },
        districtId: 322,
      },
      {
        id: '341103',
        zipcode: 34130,
        text: 'เกษม',
        value: 'เกษม',
        name: {
          th: 'เกษม',
          en: 'Kasem',
        },
        districtId: 322,
      },
      {
        id: '341104',
        zipcode: 34130,
        text: 'กุศกร',
        value: 'กุศกร',
        name: {
          th: 'กุศกร',
          en: 'Kutsakon',
        },
        districtId: 322,
      },
      {
        id: '341105',
        zipcode: 34130,
        text: 'ขามเปี้ย',
        value: 'ขามเปี้ย',
        name: {
          th: 'ขามเปี้ย',
          en: 'Kham Pia',
        },
        districtId: 322,
      },
      {
        id: '341106',
        zipcode: 34130,
        text: 'คอนสาย',
        value: 'คอนสาย',
        name: {
          th: 'คอนสาย',
          en: 'Khon Sai',
        },
        districtId: 322,
      },
      {
        id: '341107',
        zipcode: 34130,
        text: 'โคกจาน',
        value: 'โคกจาน',
        name: {
          th: 'โคกจาน',
          en: 'Khok Chan',
        },
        districtId: 322,
      },
      {
        id: '341108',
        zipcode: 34130,
        text: 'นาพิน',
        value: 'นาพิน',
        name: {
          th: 'นาพิน',
          en: 'Na Phin',
        },
        districtId: 322,
      },
      {
        id: '341109',
        zipcode: 34130,
        text: 'นาสะไม',
        value: 'นาสะไม',
        name: {
          th: 'นาสะไม',
          en: 'Na Samai',
        },
        districtId: 322,
      },
      {
        id: '341110',
        zipcode: 34130,
        text: 'โนนกุง',
        value: 'โนนกุง',
        name: {
          th: 'โนนกุง',
          en: 'Non Kung',
        },
        districtId: 322,
      },
      {
        id: '341111',
        zipcode: 34130,
        text: 'ตระการ',
        value: 'ตระการ',
        name: {
          th: 'ตระการ',
          en: 'Trakan',
        },
        districtId: 322,
      },
      {
        id: '341112',
        zipcode: 34130,
        text: 'ตากแดด',
        value: 'ตากแดด',
        name: {
          th: 'ตากแดด',
          en: 'Tak Daet',
        },
        districtId: 322,
      },
      {
        id: '341113',
        zipcode: 34130,
        text: 'ไหล่ทุ่ง',
        value: 'ไหล่ทุ่ง',
        name: {
          th: 'ไหล่ทุ่ง',
          en: 'Lai Thung',
        },
        districtId: 322,
      },
      {
        id: '341114',
        zipcode: 34130,
        text: 'เป้า',
        value: 'เป้า',
        name: {
          th: 'เป้า',
          en: 'Pao',
        },
        districtId: 322,
      },
      {
        id: '341115',
        zipcode: 34130,
        text: 'เซเป็ด',
        value: 'เซเป็ด',
        name: {
          th: 'เซเป็ด',
          en: 'Se Pet',
        },
        districtId: 322,
      },
      {
        id: '341116',
        zipcode: 34130,
        text: 'สะพือ',
        value: 'สะพือ',
        name: {
          th: 'สะพือ',
          en: 'Saphue',
        },
        districtId: 322,
      },
      {
        id: '341117',
        zipcode: 34130,
        text: 'หนองเต่า',
        value: 'หนองเต่า',
        name: {
          th: 'หนองเต่า',
          en: 'Nong Tao',
        },
        districtId: 322,
      },
      {
        id: '341118',
        zipcode: 34130,
        text: 'ถ้ำแข้',
        value: 'ถ้ำแข้',
        name: {
          th: 'ถ้ำแข้',
          en: 'Tham Khae',
        },
        districtId: 322,
      },
      {
        id: '341119',
        zipcode: 34130,
        text: 'ท่าหลวง',
        value: 'ท่าหลวง',
        name: {
          th: 'ท่าหลวง',
          en: 'Tha Luang',
        },
        districtId: 322,
      },
      {
        id: '341120',
        zipcode: 34130,
        text: 'ห้วยฝ้ายพัฒนา',
        value: 'ห้วยฝ้ายพัฒนา',
        name: {
          th: 'ห้วยฝ้ายพัฒนา',
          en: 'Huai Fai Phatthana',
        },
        districtId: 322,
      },
      {
        id: '341121',
        zipcode: 34130,
        text: 'กุดยาลวน',
        value: 'กุดยาลวน',
        name: {
          th: 'กุดยาลวน',
          en: 'Kut Ya Luan',
        },
        districtId: 322,
      },
      {
        id: '341122',
        zipcode: 34130,
        text: 'บ้านแดง',
        value: 'บ้านแดง',
        name: {
          th: 'บ้านแดง',
          en: 'Ban Daeng',
        },
        districtId: 322,
      },
      {
        id: '341123',
        zipcode: 34130,
        text: 'คำเจริญ',
        value: 'คำเจริญ',
        name: {
          th: 'คำเจริญ',
          en: 'Kham Charoen',
        },
        districtId: 322,
      },
      {
        id: '341201',
        zipcode: 34270,
        text: 'ข้าวปุ้น',
        value: 'ข้าวปุ้น',
        name: {
          th: 'ข้าวปุ้น',
          en: 'Khaopun',
        },
        districtId: 323,
      },
      {
        id: '341202',
        zipcode: 34270,
        text: 'โนนสวาง',
        value: 'โนนสวาง',
        name: {
          th: 'โนนสวาง',
          en: 'Non Sawang',
        },
        districtId: 323,
      },
      {
        id: '341203',
        zipcode: 34270,
        text: 'แก่งเค็ง',
        value: 'แก่งเค็ง',
        name: {
          th: 'แก่งเค็ง',
          en: 'Kaeng Kheng',
        },
        districtId: 323,
      },
      {
        id: '341204',
        zipcode: 34270,
        text: 'กาบิน',
        value: 'กาบิน',
        name: {
          th: 'กาบิน',
          en: 'Ka Bin',
        },
        districtId: 323,
      },
      {
        id: '341205',
        zipcode: 34270,
        text: 'หนองทันน้ำ',
        value: 'หนองทันน้ำ',
        name: {
          th: 'หนองทันน้ำ',
          en: 'Nong Than Nam',
        },
        districtId: 323,
      },
      {
        id: '341401',
        zipcode: 34140,
        text: 'ม่วงสามสิบ',
        value: 'ม่วงสามสิบ',
        name: {
          th: 'ม่วงสามสิบ',
          en: 'Muang Sam Sip',
        },
        districtId: 325,
      },
      {
        id: '341402',
        zipcode: 34140,
        text: 'เหล่าบก',
        value: 'เหล่าบก',
        name: {
          th: 'เหล่าบก',
          en: 'Lao Bok',
        },
        districtId: 325,
      },
      {
        id: '341403',
        zipcode: 34140,
        text: 'ดุมใหญ่',
        value: 'ดุมใหญ่',
        name: {
          th: 'ดุมใหญ่',
          en: 'Dum Yai',
        },
        districtId: 325,
      },
      {
        id: '341404',
        zipcode: 34140,
        text: 'หนองช้างใหญ่',
        value: 'หนองช้างใหญ่',
        name: {
          th: 'หนองช้างใหญ่',
          en: 'Non Chang Yai',
        },
        districtId: 325,
      },
      {
        id: '341405',
        zipcode: 34140,
        text: 'หนองเมือง',
        value: 'หนองเมือง',
        name: {
          th: 'หนองเมือง',
          en: 'Nong Mueang',
        },
        districtId: 325,
      },
      {
        id: '341406',
        zipcode: 34140,
        text: 'เตย',
        value: 'เตย',
        name: {
          th: 'เตย',
          en: 'Toei',
        },
        districtId: 325,
      },
      {
        id: '341407',
        zipcode: 34140,
        text: 'ยางสักกระโพหลุ่ม',
        value: 'ยางสักกระโพหลุ่ม',
        name: {
          th: 'ยางสักกระโพหลุ่ม',
          en: 'Yang Sak Krapho Lum',
        },
        districtId: 325,
      },
      {
        id: '341408',
        zipcode: 34140,
        text: 'หนองไข่นก',
        value: 'หนองไข่นก',
        name: {
          th: 'หนองไข่นก',
          en: 'Nong Khai Nok',
        },
        districtId: 325,
      },
      {
        id: '341409',
        zipcode: 34140,
        text: 'หนองเหล่า',
        value: 'หนองเหล่า',
        name: {
          th: 'หนองเหล่า',
          en: 'Nong Lao',
        },
        districtId: 325,
      },
      {
        id: '341410',
        zipcode: 34140,
        text: 'หนองฮาง',
        value: 'หนองฮาง',
        name: {
          th: 'หนองฮาง',
          en: 'Nong Hang',
        },
        districtId: 325,
      },
      {
        id: '341411',
        zipcode: 34140,
        text: 'ยางโยภาพ',
        value: 'ยางโยภาพ',
        name: {
          th: 'ยางโยภาพ',
          en: 'Yang Yo Phap',
        },
        districtId: 325,
      },
      {
        id: '341412',
        zipcode: 34140,
        text: 'ไผ่ใหญ่',
        value: 'ไผ่ใหญ่',
        name: {
          th: 'ไผ่ใหญ่',
          en: 'Phai Yai',
        },
        districtId: 325,
      },
      {
        id: '341413',
        zipcode: 34140,
        text: 'นาเลิง',
        value: 'นาเลิง',
        name: {
          th: 'นาเลิง',
          en: 'Na Loeng',
        },
        districtId: 325,
      },
      {
        id: '341414',
        zipcode: 34140,
        text: 'โพนแพง',
        value: 'โพนแพง',
        name: {
          th: 'โพนแพง',
          en: 'Phon Phaeng',
        },
        districtId: 325,
      },
      {
        id: '341501',
        zipcode: 34190,
        text: 'วารินชำราบ',
        value: 'วารินชำราบ',
        name: {
          th: 'วารินชำราบ',
          en: 'Warin Chamrap',
        },
        districtId: 326,
      },
      {
        id: '341502',
        zipcode: 34190,
        text: 'ธาตุ',
        value: 'ธาตุ',
        name: {
          th: 'ธาตุ',
          en: 'That',
        },
        districtId: 326,
      },
      {
        id: '341504',
        zipcode: 34310,
        text: 'ท่าลาด',
        value: 'ท่าลาด',
        name: {
          th: 'ท่าลาด',
          en: 'Tha Lat',
        },
        districtId: 326,
      },
      {
        id: '341505',
        zipcode: 34190,
        text: 'โนนโหนน',
        value: 'โนนโหนน',
        name: {
          th: 'โนนโหนน',
          en: 'Non Non',
        },
        districtId: 326,
      },
      {
        id: '341507',
        zipcode: 34190,
        text: 'คูเมือง',
        value: 'คูเมือง',
        name: {
          th: 'คูเมือง',
          en: 'Khu Mueang',
        },
        districtId: 326,
      },
      {
        id: '341508',
        zipcode: 34190,
        text: 'สระสมิง',
        value: 'สระสมิง',
        name: {
          th: 'สระสมิง',
          en: 'Sa Saming',
        },
        districtId: 326,
      },
      {
        id: '341510',
        zipcode: 34190,
        text: 'คำน้ำแซบ',
        value: 'คำน้ำแซบ',
        name: {
          th: 'คำน้ำแซบ',
          en: 'Kham Nam Saep',
        },
        districtId: 326,
      },
      {
        id: '341511',
        zipcode: 34310,
        text: 'บุ่งหวาย',
        value: 'บุ่งหวาย',
        name: {
          th: 'บุ่งหวาย',
          en: 'Bung Wai',
        },
        districtId: 326,
      },
      {
        id: '341515',
        zipcode: 34190,
        text: 'คำขวาง',
        value: 'คำขวาง',
        name: {
          th: 'คำขวาง',
          en: 'Kham Khwang',
        },
        districtId: 326,
      },
      {
        id: '341516',
        zipcode: 34190,
        text: 'โพธิ์ใหญ่',
        value: 'โพธิ์ใหญ่',
        name: {
          th: 'โพธิ์ใหญ่',
          en: 'Pho Yai',
        },
        districtId: 326,
      },
      {
        id: '341518',
        zipcode: 34190,
        text: 'แสนสุข',
        value: 'แสนสุข',
        name: {
          th: 'แสนสุข',
          en: 'Saen Suk',
        },
        districtId: 326,
      },
      {
        id: '341520',
        zipcode: 34190,
        text: 'หนองกินเพล',
        value: 'หนองกินเพล',
        name: {
          th: 'หนองกินเพล',
          en: 'Nong Kin Phen',
        },
        districtId: 326,
      },
      {
        id: '341521',
        zipcode: 34190,
        text: 'โนนผึ้ง',
        value: 'โนนผึ้ง',
        name: {
          th: 'โนนผึ้ง',
          en: 'Non Phueng',
        },
        districtId: 326,
      },
      {
        id: '341522',
        zipcode: 34190,
        text: 'เมืองศรีไค',
        value: 'เมืองศรีไค',
        name: {
          th: 'เมืองศรีไค',
          en: 'Mueang Si Khai',
        },
        districtId: 326,
      },
      {
        id: '341524',
        zipcode: 34310,
        text: 'ห้วยขะยูง',
        value: 'ห้วยขะยูง',
        name: {
          th: 'ห้วยขะยูง',
          en: 'Huai Khayung',
        },
        districtId: 326,
      },
      {
        id: '341526',
        zipcode: 34190,
        text: 'บุ่งไหม',
        value: 'บุ่งไหม',
        name: {
          th: 'บุ่งไหม',
          en: 'Bung Mai',
        },
        districtId: 326,
      },
      {
        id: '341901',
        zipcode: 34110,
        text: 'พิบูล',
        value: 'พิบูล',
        name: {
          th: 'พิบูล',
          en: 'Phibun',
        },
        districtId: 330,
      },
      {
        id: '341902',
        zipcode: 34110,
        text: 'กุดชมภู',
        value: 'กุดชมภู',
        name: {
          th: 'กุดชมภู',
          en: 'Kut Chom Phu',
        },
        districtId: 330,
      },
      {
        id: '341904',
        zipcode: 34110,
        text: 'ดอนจิก',
        value: 'ดอนจิก',
        name: {
          th: 'ดอนจิก',
          en: 'Don Chik',
        },
        districtId: 330,
      },
      {
        id: '341905',
        zipcode: 34110,
        text: 'ทรายมูล',
        value: 'ทรายมูล',
        name: {
          th: 'ทรายมูล',
          en: 'Sai Mun',
        },
        districtId: 330,
      },
      {
        id: '341906',
        zipcode: 34110,
        text: 'นาโพธิ์',
        value: 'นาโพธิ์',
        name: {
          th: 'นาโพธิ์',
          en: 'Na Pho',
        },
        districtId: 330,
      },
      {
        id: '341907',
        zipcode: 34110,
        text: 'โนนกลาง',
        value: 'โนนกลาง',
        name: {
          th: 'โนนกลาง',
          en: 'Non Klang',
        },
        districtId: 330,
      },
      {
        id: '341909',
        zipcode: 34110,
        text: 'โพธิ์ไทร',
        value: 'โพธิ์ไทร',
        name: {
          th: 'โพธิ์ไทร',
          en: 'Pho Sai',
        },
        districtId: 330,
      },
      {
        id: '341910',
        zipcode: 34110,
        text: 'โพธิ์ศรี',
        value: 'โพธิ์ศรี',
        name: {
          th: 'โพธิ์ศรี',
          en: 'Pho Si',
        },
        districtId: 330,
      },
      {
        id: '341911',
        zipcode: 34110,
        text: 'ระเว',
        value: 'ระเว',
        name: {
          th: 'ระเว',
          en: 'Rawe',
        },
        districtId: 330,
      },
      {
        id: '341912',
        zipcode: 34110,
        text: 'ไร่ใต้',
        value: 'ไร่ใต้',
        name: {
          th: 'ไร่ใต้',
          en: 'Rai Tai',
        },
        districtId: 330,
      },
      {
        id: '341913',
        zipcode: 34110,
        text: 'หนองบัวฮี',
        value: 'หนองบัวฮี',
        name: {
          th: 'หนองบัวฮี',
          en: 'Nong Bua Hi',
        },
        districtId: 330,
      },
      {
        id: '341914',
        zipcode: 34110,
        text: 'อ่างศิลา',
        value: 'อ่างศิลา',
        name: {
          th: 'อ่างศิลา',
          en: 'Ang Sila',
        },
        districtId: 330,
      },
      {
        id: '341918',
        zipcode: 34110,
        text: 'โนนกาหลง',
        value: 'โนนกาหลง',
        name: {
          th: 'โนนกาหลง',
          en: 'Non Kalong',
        },
        districtId: 330,
      },
      {
        id: '341919',
        zipcode: 34110,
        text: 'บ้านแขม',
        value: 'บ้านแขม',
        name: {
          th: 'บ้านแขม',
          en: 'Ban Khaem',
        },
        districtId: 330,
      },
      {
        id: '342001',
        zipcode: 34330,
        text: 'ตาลสุม',
        value: 'ตาลสุม',
        name: {
          th: 'ตาลสุม',
          en: 'Tan Sum',
        },
        districtId: 331,
      },
      {
        id: '342002',
        zipcode: 34330,
        text: 'สำโรง',
        value: 'สำโรง',
        name: {
          th: 'สำโรง',
          en: 'Samrong',
        },
        districtId: 331,
      },
      {
        id: '342003',
        zipcode: 34330,
        text: 'จิกเทิง',
        value: 'จิกเทิง',
        name: {
          th: 'จิกเทิง',
          en: 'Chik Thoeng',
        },
        districtId: 331,
      },
      {
        id: '342004',
        zipcode: 34330,
        text: 'หนองกุง',
        value: 'หนองกุง',
        name: {
          th: 'หนองกุง',
          en: 'Nong Kung',
        },
        districtId: 331,
      },
      {
        id: '342005',
        zipcode: 34330,
        text: 'นาคาย',
        value: 'นาคาย',
        name: {
          th: 'นาคาย',
          en: 'Na Khai',
        },
        districtId: 331,
      },
      {
        id: '342006',
        zipcode: 34330,
        text: 'คำหว้า',
        value: 'คำหว้า',
        name: {
          th: 'คำหว้า',
          en: 'Kham Wa',
        },
        districtId: 331,
      },
      {
        id: '342101',
        zipcode: 34340,
        text: 'โพธิ์ไทร',
        value: 'โพธิ์ไทร',
        name: {
          th: 'โพธิ์ไทร',
          en: 'Pho Sai',
        },
        districtId: 332,
      },
      {
        id: '342102',
        zipcode: 34340,
        text: 'ม่วงใหญ่',
        value: 'ม่วงใหญ่',
        name: {
          th: 'ม่วงใหญ่',
          en: 'Muang Yai',
        },
        districtId: 332,
      },
      {
        id: '342103',
        zipcode: 34340,
        text: 'สำโรง',
        value: 'สำโรง',
        name: {
          th: 'สำโรง',
          en: 'Sam Rong',
        },
        districtId: 332,
      },
      {
        id: '342104',
        zipcode: 34340,
        text: 'สองคอน',
        value: 'สองคอน',
        name: {
          th: 'สองคอน',
          en: 'Song Khon',
        },
        districtId: 332,
      },
      {
        id: '342105',
        zipcode: 34340,
        text: 'สารภี',
        value: 'สารภี',
        name: {
          th: 'สารภี',
          en: 'Saraphi',
        },
        districtId: 332,
      },
      {
        id: '342106',
        zipcode: 34340,
        text: 'เหล่างาม',
        value: 'เหล่างาม',
        name: {
          th: 'เหล่างาม',
          en: 'Lao Ngam',
        },
        districtId: 332,
      },
      {
        id: '342201',
        zipcode: 34360,
        text: 'สำโรง',
        value: 'สำโรง',
        name: {
          th: 'สำโรง',
          en: 'Samrong',
        },
        districtId: 333,
      },
      {
        id: '342202',
        zipcode: 34360,
        text: 'โคกก่อง',
        value: 'โคกก่อง',
        name: {
          th: 'โคกก่อง',
          en: 'Khok Kong',
        },
        districtId: 333,
      },
      {
        id: '342203',
        zipcode: 34360,
        text: 'หนองไฮ',
        value: 'หนองไฮ',
        name: {
          th: 'หนองไฮ',
          en: 'Nong Hai',
        },
        districtId: 333,
      },
      {
        id: '342204',
        zipcode: 34360,
        text: 'ค้อน้อย',
        value: 'ค้อน้อย',
        name: {
          th: 'ค้อน้อย',
          en: 'Kho Noi',
        },
        districtId: 333,
      },
      {
        id: '342205',
        zipcode: 34360,
        text: 'โนนกาเล็น',
        value: 'โนนกาเล็น',
        name: {
          th: 'โนนกาเล็น',
          en: 'Non Ka Len',
        },
        districtId: 333,
      },
      {
        id: '342206',
        zipcode: 34360,
        text: 'โคกสว่าง',
        value: 'โคกสว่าง',
        name: {
          th: 'โคกสว่าง',
          en: 'Khok Sawang',
        },
        districtId: 333,
      },
      {
        id: '342207',
        zipcode: 34360,
        text: 'โนนกลาง',
        value: 'โนนกลาง',
        name: {
          th: 'โนนกลาง',
          en: 'Non Klang',
        },
        districtId: 333,
      },
      {
        id: '342208',
        zipcode: 34360,
        text: 'บอน',
        value: 'บอน',
        name: {
          th: 'บอน',
          en: 'Bon',
        },
        districtId: 333,
      },
      {
        id: '342209',
        zipcode: 34360,
        text: 'ขามป้อม',
        value: 'ขามป้อม',
        name: {
          th: 'ขามป้อม',
          en: 'Kham Pom',
        },
        districtId: 333,
      },
      {
        id: '342401',
        zipcode: 34000,
        text: 'ดอนมดแดง',
        value: 'ดอนมดแดง',
        name: {
          th: 'ดอนมดแดง',
          en: 'Don Mot Daeng',
        },
        districtId: 335,
      },
      {
        id: '342402',
        zipcode: 34000,
        text: 'เหล่าแดง',
        value: 'เหล่าแดง',
        name: {
          th: 'เหล่าแดง',
          en: 'Lao Daeng',
        },
        districtId: 335,
      },
      {
        id: '342403',
        zipcode: 34000,
        text: 'ท่าเมือง',
        value: 'ท่าเมือง',
        name: {
          th: 'ท่าเมือง',
          en: 'Tha Mueang',
        },
        districtId: 335,
      },
      {
        id: '342404',
        zipcode: 34000,
        text: 'คำไฮใหญ่',
        value: 'คำไฮใหญ่',
        name: {
          th: 'คำไฮใหญ่',
          en: 'Kham Hai Yai',
        },
        districtId: 335,
      },
      {
        id: '342501',
        zipcode: 34350,
        text: 'คันไร่',
        value: 'คันไร่',
        name: {
          th: 'คันไร่',
          en: 'Khan Rai',
        },
        districtId: 336,
      },
      {
        id: '342502',
        zipcode: 34350,
        text: 'ช่องเม็ก',
        value: 'ช่องเม็ก',
        name: {
          th: 'ช่องเม็ก',
          en: 'Chong Mek',
        },
        districtId: 336,
      },
      {
        id: '342503',
        zipcode: 34350,
        text: 'โนนก่อ',
        value: 'โนนก่อ',
        name: {
          th: 'โนนก่อ',
          en: 'Non Ko',
        },
        districtId: 336,
      },
      {
        id: '342504',
        zipcode: 34350,
        text: 'นิคมสร้างตนเองลำโดมน้อย',
        value: 'นิคมสร้างตนเองลำโดมน้อย',
        name: {
          th: 'นิคมสร้างตนเองลำโดมน้อย',
          en: 'Nikhom Sang Ton Eng Lam Dom Noi',
        },
        districtId: 336,
      },
      {
        id: '342505',
        zipcode: 34350,
        text: 'ฝางคำ',
        value: 'ฝางคำ',
        name: {
          th: 'ฝางคำ',
          en: 'Fang Kham',
        },
        districtId: 336,
      },
      {
        id: '342506',
        zipcode: 34350,
        text: 'คำเขื่อนแก้ว',
        value: 'คำเขื่อนแก้ว',
        name: {
          th: 'คำเขื่อนแก้ว',
          en: 'Kham Khuean Kaeo',
        },
        districtId: 336,
      },
      {
        id: '342602',
        zipcode: 34160,
        text: 'หนองอ้ม',
        value: 'หนองอ้ม',
        name: {
          th: 'หนองอ้ม',
          en: 'Nong Om',
        },
        districtId: 337,
      },
      {
        id: '342603',
        zipcode: 34160,
        text: 'นาเกษม',
        value: 'นาเกษม',
        name: {
          th: 'นาเกษม',
          en: 'Na Kasem',
        },
        districtId: 337,
      },
      {
        id: '342604',
        zipcode: 34160,
        text: 'กุดเรือ',
        value: 'กุดเรือ',
        name: {
          th: 'กุดเรือ',
          en: 'Kut Ruea',
        },
        districtId: 337,
      },
      {
        id: '342605',
        zipcode: 34160,
        text: 'โคกชำแระ',
        value: 'โคกชำแระ',
        name: {
          th: 'โคกชำแระ',
          en: 'Khok Chamrae',
        },
        districtId: 337,
      },
      {
        id: '342606',
        zipcode: 34160,
        text: 'นาห่อม',
        value: 'นาห่อม',
        name: {
          th: 'นาห่อม',
          en: 'Na Hom',
        },
        districtId: 337,
      },
      {
        id: '342901',
        zipcode: 34160,
        text: 'นาเยีย',
        value: 'นาเยีย',
        name: {
          th: 'นาเยีย',
          en: 'Na Yia',
        },
        districtId: 340,
      },
      {
        id: '342902',
        zipcode: 34160,
        text: 'นาดี',
        value: 'นาดี',
        name: {
          th: 'นาดี',
          en: 'Na Di',
        },
        districtId: 340,
      },
      {
        id: '342903',
        zipcode: 34160,
        text: 'นาเรือง',
        value: 'นาเรือง',
        name: {
          th: 'นาเรือง',
          en: 'Na Rueang',
        },
        districtId: 340,
      },
      {
        id: '343001',
        zipcode: 34170,
        text: 'นาตาล',
        value: 'นาตาล',
        name: {
          th: 'นาตาล',
          en: 'Na Tan',
        },
        districtId: 341,
      },
      {
        id: '343002',
        zipcode: 34170,
        text: 'พะลาน',
        value: 'พะลาน',
        name: {
          th: 'พะลาน',
          en: 'Phalan',
        },
        districtId: 341,
      },
      {
        id: '343003',
        zipcode: 34170,
        text: 'กองโพน',
        value: 'กองโพน',
        name: {
          th: 'กองโพน',
          en: 'Kong Phon',
        },
        districtId: 341,
      },
      {
        id: '343004',
        zipcode: 34170,
        text: 'พังเคน',
        value: 'พังเคน',
        name: {
          th: 'พังเคน',
          en: 'Phang Khen',
        },
        districtId: 341,
      },
      {
        id: '343101',
        zipcode: 34000,
        text: 'เหล่าเสือโก้ก',
        value: 'เหล่าเสือโก้ก',
        name: {
          th: 'เหล่าเสือโก้ก',
          en: 'Lao Suea Kok',
        },
        districtId: 342,
      },
      {
        id: '343102',
        zipcode: 34000,
        text: 'โพนเมือง',
        value: 'โพนเมือง',
        name: {
          th: 'โพนเมือง',
          en: 'Phon Mueang',
        },
        districtId: 342,
      },
      {
        id: '343103',
        zipcode: 34000,
        text: 'แพงใหญ่',
        value: 'แพงใหญ่',
        name: {
          th: 'แพงใหญ่',
          en: 'Phaeng Yai',
        },
        districtId: 342,
      },
      {
        id: '343104',
        zipcode: 34000,
        text: 'หนองบก',
        value: 'หนองบก',
        name: {
          th: 'หนองบก',
          en: 'Nong Bok',
        },
        districtId: 342,
      },
      {
        id: '343201',
        zipcode: 34190,
        text: 'แก่งโดม',
        value: 'แก่งโดม',
        name: {
          th: 'แก่งโดม',
          en: 'Kaeng Dom',
        },
        districtId: 343,
      },
      {
        id: '343202',
        zipcode: 34190,
        text: 'ท่าช้าง',
        value: 'ท่าช้าง',
        name: {
          th: 'ท่าช้าง',
          en: 'Tha Chang',
        },
        districtId: 343,
      },
      {
        id: '343203',
        zipcode: 34190,
        text: 'บุ่งมะแลง',
        value: 'บุ่งมะแลง',
        name: {
          th: 'บุ่งมะแลง',
          en: 'Bung Malaeng',
        },
        districtId: 343,
      },
      {
        id: '343204',
        zipcode: 34190,
        text: 'สว่าง',
        value: 'สว่าง',
        name: {
          th: 'สว่าง',
          en: 'Sawang',
        },
        districtId: 343,
      },
      {
        id: '343301',
        zipcode: 34260,
        text: 'ตาเกา',
        value: 'ตาเกา',
        name: {
          th: 'ตาเกา',
          en: 'Ta Kao',
        },
        districtId: 344,
      },
      {
        id: '343302',
        zipcode: 34260,
        text: 'ไพบูลย์',
        value: 'ไพบูลย์',
        name: {
          th: 'ไพบูลย์',
          en: 'Phaibun',
        },
        districtId: 344,
      },
      {
        id: '343303',
        zipcode: 34260,
        text: 'ขี้เหล็ก',
        value: 'ขี้เหล็ก',
        name: {
          th: 'ขี้เหล็ก',
          en: 'Khilek',
        },
        districtId: 344,
      },
      {
        id: '343304',
        zipcode: 34260,
        text: 'โคกสะอาด',
        value: 'โคกสะอาด',
        name: {
          th: 'โคกสะอาด',
          en: 'Khok Sa-at',
        },
        districtId: 344,
      },
      {
        id: '350101',
        zipcode: 35000,
        text: 'ในเมือง',
        value: 'ในเมือง',
        name: {
          th: 'ในเมือง',
          en: 'Nai Mueang',
        },
        districtId: 346,
      },
      {
        id: '350102',
        zipcode: 35000,
        text: 'น้ำคำใหญ่',
        value: 'น้ำคำใหญ่',
        name: {
          th: 'น้ำคำใหญ่',
          en: 'Nam Kham Yai',
        },
        districtId: 346,
      },
      {
        id: '350103',
        zipcode: 35000,
        text: 'ตาดทอง',
        value: 'ตาดทอง',
        name: {
          th: 'ตาดทอง',
          en: 'Tat Thong',
        },
        districtId: 346,
      },
      {
        id: '350104',
        zipcode: 35000,
        text: 'สำราญ',
        value: 'สำราญ',
        name: {
          th: 'สำราญ',
          en: 'Samran',
        },
        districtId: 346,
      },
      {
        id: '350105',
        zipcode: 35000,
        text: 'ค้อเหนือ',
        value: 'ค้อเหนือ',
        name: {
          th: 'ค้อเหนือ',
          en: 'Kho Nuea',
        },
        districtId: 346,
      },
      {
        id: '350106',
        zipcode: 35000,
        text: 'ดู่ทุ่ง',
        value: 'ดู่ทุ่ง',
        name: {
          th: 'ดู่ทุ่ง',
          en: 'Du Thung',
        },
        districtId: 346,
      },
      {
        id: '350107',
        zipcode: 35000,
        text: 'เดิด',
        value: 'เดิด',
        name: {
          th: 'เดิด',
          en: 'Doet',
        },
        districtId: 346,
      },
      {
        id: '350108',
        zipcode: 35000,
        text: 'ขั้นไดใหญ่',
        value: 'ขั้นไดใหญ่',
        name: {
          th: 'ขั้นไดใหญ่',
          en: 'Khandai Yai',
        },
        districtId: 346,
      },
      {
        id: '350109',
        zipcode: 35000,
        text: 'ทุ่งแต้',
        value: 'ทุ่งแต้',
        name: {
          th: 'ทุ่งแต้',
          en: 'Thung Tae',
        },
        districtId: 346,
      },
      {
        id: '350110',
        zipcode: 35000,
        text: 'สิงห์',
        value: 'สิงห์',
        name: {
          th: 'สิงห์',
          en: 'Sing',
        },
        districtId: 346,
      },
      {
        id: '350111',
        zipcode: 35000,
        text: 'นาสะไมย์',
        value: 'นาสะไมย์',
        name: {
          th: 'นาสะไมย์',
          en: 'Na Samai',
        },
        districtId: 346,
      },
      {
        id: '350112',
        zipcode: 35000,
        text: 'เขื่องคำ',
        value: 'เขื่องคำ',
        name: {
          th: 'เขื่องคำ',
          en: 'Khueang Kham',
        },
        districtId: 346,
      },
      {
        id: '350113',
        zipcode: 35000,
        text: 'หนองหิน',
        value: 'หนองหิน',
        name: {
          th: 'หนองหิน',
          en: 'Nong Hin',
        },
        districtId: 346,
      },
      {
        id: '350114',
        zipcode: 35000,
        text: 'หนองคู',
        value: 'หนองคู',
        name: {
          th: 'หนองคู',
          en: 'Nong Khu',
        },
        districtId: 346,
      },
      {
        id: '350115',
        zipcode: 35000,
        text: 'ขุมเงิน',
        value: 'ขุมเงิน',
        name: {
          th: 'ขุมเงิน',
          en: 'Khum Ngoen',
        },
        districtId: 346,
      },
      {
        id: '350116',
        zipcode: 35000,
        text: 'ทุ่งนางโอก',
        value: 'ทุ่งนางโอก',
        name: {
          th: 'ทุ่งนางโอก',
          en: 'Thung Nang Ok',
        },
        districtId: 346,
      },
      {
        id: '350117',
        zipcode: 35000,
        text: 'หนองเรือ',
        value: 'หนองเรือ',
        name: {
          th: 'หนองเรือ',
          en: 'Nong Ruea',
        },
        districtId: 346,
      },
      {
        id: '350118',
        zipcode: 35000,
        text: 'หนองเป็ด',
        value: 'หนองเป็ด',
        name: {
          th: 'หนองเป็ด',
          en: 'Nong Pet',
        },
        districtId: 346,
      },
      {
        id: '350201',
        zipcode: 35170,
        text: 'ทรายมูล',
        value: 'ทรายมูล',
        name: {
          th: 'ทรายมูล',
          en: 'Sai Mun',
        },
        districtId: 347,
      },
      {
        id: '350202',
        zipcode: 35170,
        text: 'ดู่ลาด',
        value: 'ดู่ลาด',
        name: {
          th: 'ดู่ลาด',
          en: 'Du Lat',
        },
        districtId: 347,
      },
      {
        id: '350203',
        zipcode: 35170,
        text: 'ดงมะไฟ',
        value: 'ดงมะไฟ',
        name: {
          th: 'ดงมะไฟ',
          en: 'Dong Mafai',
        },
        districtId: 347,
      },
      {
        id: '350204',
        zipcode: 35170,
        text: 'นาเวียง',
        value: 'นาเวียง',
        name: {
          th: 'นาเวียง',
          en: 'Na Wiang',
        },
        districtId: 347,
      },
      {
        id: '350205',
        zipcode: 35170,
        text: 'ไผ่',
        value: 'ไผ่',
        name: {
          th: 'ไผ่',
          en: 'Phai',
        },
        districtId: 347,
      },
      {
        id: '350301',
        zipcode: 35140,
        text: 'กุดชุม',
        value: 'กุดชุม',
        name: {
          th: 'กุดชุม',
          en: 'Kut Chum',
        },
        districtId: 348,
      },
      {
        id: '350302',
        zipcode: 35140,
        text: 'โนนเปือย',
        value: 'โนนเปือย',
        name: {
          th: 'โนนเปือย',
          en: 'Non Pueai',
        },
        districtId: 348,
      },
      {
        id: '350303',
        zipcode: 35140,
        text: 'กำแมด',
        value: 'กำแมด',
        name: {
          th: 'กำแมด',
          en: 'Kammaet',
        },
        districtId: 348,
      },
      {
        id: '350304',
        zipcode: 35140,
        text: 'นาโส่',
        value: 'นาโส่',
        name: {
          th: 'นาโส่',
          en: 'Na So',
        },
        districtId: 348,
      },
      {
        id: '350305',
        zipcode: 35140,
        text: 'ห้วยแก้ง',
        value: 'ห้วยแก้ง',
        name: {
          th: 'ห้วยแก้ง',
          en: 'Huai Kaeng',
        },
        districtId: 348,
      },
      {
        id: '350306',
        zipcode: 35140,
        text: 'หนองหมี',
        value: 'หนองหมี',
        name: {
          th: 'หนองหมี',
          en: 'Nong Mi',
        },
        districtId: 348,
      },
      {
        id: '350307',
        zipcode: 35140,
        text: 'โพนงาม',
        value: 'โพนงาม',
        name: {
          th: 'โพนงาม',
          en: 'Phon Ngam',
        },
        districtId: 348,
      },
      {
        id: '350308',
        zipcode: 35140,
        text: 'คำน้ำสร้าง',
        value: 'คำน้ำสร้าง',
        name: {
          th: 'คำน้ำสร้าง',
          en: 'Kham Nam Sang',
        },
        districtId: 348,
      },
      {
        id: '350309',
        zipcode: 35140,
        text: 'หนองแหน',
        value: 'หนองแหน',
        name: {
          th: 'หนองแหน',
          en: 'Nong Nae',
        },
        districtId: 348,
      },
      {
        id: '350401',
        zipcode: 35110,
        text: 'ลุมพุก',
        value: 'ลุมพุก',
        name: {
          th: 'ลุมพุก',
          en: 'Lumphuk',
        },
        districtId: 349,
      },
      {
        id: '350402',
        zipcode: 35110,
        text: 'ย่อ',
        value: 'ย่อ',
        name: {
          th: 'ย่อ',
          en: 'Yo',
        },
        districtId: 349,
      },
      {
        id: '350403',
        zipcode: 35110,
        text: 'สงเปือย',
        value: 'สงเปือย',
        name: {
          th: 'สงเปือย',
          en: 'Song Pueai',
        },
        districtId: 349,
      },
      {
        id: '350404',
        zipcode: 35110,
        text: 'โพนทัน',
        value: 'โพนทัน',
        name: {
          th: 'โพนทัน',
          en: 'Phon Than',
        },
        districtId: 349,
      },
      {
        id: '350405',
        zipcode: 35110,
        text: 'ทุ่งมน',
        value: 'ทุ่งมน',
        name: {
          th: 'ทุ่งมน',
          en: 'Thung Mon',
        },
        districtId: 349,
      },
      {
        id: '350406',
        zipcode: 35180,
        text: 'นาคำ',
        value: 'นาคำ',
        name: {
          th: 'นาคำ',
          en: 'Na Kham',
        },
        districtId: 349,
      },
      {
        id: '350407',
        zipcode: 35180,
        text: 'ดงแคนใหญ่',
        value: 'ดงแคนใหญ่',
        name: {
          th: 'ดงแคนใหญ่',
          en: 'Dong Khaen Yai',
        },
        districtId: 349,
      },
      {
        id: '350408',
        zipcode: 35110,
        text: 'กู่จาน',
        value: 'กู่จาน',
        name: {
          th: 'กู่จาน',
          en: 'Ku Chan',
        },
        districtId: 349,
      },
      {
        id: '350409',
        zipcode: 35180,
        text: 'นาแก',
        value: 'นาแก',
        name: {
          th: 'นาแก',
          en: 'Na Kae',
        },
        districtId: 349,
      },
      {
        id: '350410',
        zipcode: 35110,
        text: 'กุดกุง',
        value: 'กุดกุง',
        name: {
          th: 'กุดกุง',
          en: 'Kut Kung',
        },
        districtId: 349,
      },
      {
        id: '350411',
        zipcode: 35110,
        text: 'เหล่าไฮ',
        value: 'เหล่าไฮ',
        name: {
          th: 'เหล่าไฮ',
          en: 'Lao Hai',
        },
        districtId: 349,
      },
      {
        id: '350412',
        zipcode: 35180,
        text: 'แคนน้อย',
        value: 'แคนน้อย',
        name: {
          th: 'แคนน้อย',
          en: 'Khaen Noi',
        },
        districtId: 349,
      },
      {
        id: '350413',
        zipcode: 35110,
        text: 'ดงเจริญ',
        value: 'ดงเจริญ',
        name: {
          th: 'ดงเจริญ',
          en: 'Dong Charoen',
        },
        districtId: 349,
      },
      {
        id: '350501',
        zipcode: 35150,
        text: 'โพธิ์ไทร',
        value: 'โพธิ์ไทร',
        name: {
          th: 'โพธิ์ไทร',
          en: 'Pho Sai',
        },
        districtId: 350,
      },
      {
        id: '350502',
        zipcode: 35150,
        text: 'กระจาย',
        value: 'กระจาย',
        name: {
          th: 'กระจาย',
          en: 'Krachai',
        },
        districtId: 350,
      },
      {
        id: '350503',
        zipcode: 35150,
        text: 'โคกนาโก',
        value: 'โคกนาโก',
        name: {
          th: 'โคกนาโก',
          en: 'Khok Na Ko',
        },
        districtId: 350,
      },
      {
        id: '350504',
        zipcode: 35150,
        text: 'เชียงเพ็ง',
        value: 'เชียงเพ็ง',
        name: {
          th: 'เชียงเพ็ง',
          en: 'Chiang Pheng',
        },
        districtId: 350,
      },
      {
        id: '350505',
        zipcode: 35150,
        text: 'ศรีฐาน',
        value: 'ศรีฐาน',
        name: {
          th: 'ศรีฐาน',
          en: 'Si Than',
        },
        districtId: 350,
      },
      {
        id: '350601',
        zipcode: 35130,
        text: 'ฟ้าหยาด',
        value: 'ฟ้าหยาด',
        name: {
          th: 'ฟ้าหยาด',
          en: 'Fa Yat',
        },
        districtId: 351,
      },
      {
        id: '350602',
        zipcode: 35130,
        text: 'หัวเมือง',
        value: 'หัวเมือง',
        name: {
          th: 'หัวเมือง',
          en: 'Hua Mueang',
        },
        districtId: 351,
      },
      {
        id: '350603',
        zipcode: 35130,
        text: 'คูเมือง',
        value: 'คูเมือง',
        name: {
          th: 'คูเมือง',
          en: 'Khu Mueang',
        },
        districtId: 351,
      },
      {
        id: '350604',
        zipcode: 35130,
        text: 'ผือฮี',
        value: 'ผือฮี',
        name: {
          th: 'ผือฮี',
          en: 'Phue Hi',
        },
        districtId: 351,
      },
      {
        id: '350605',
        zipcode: 35130,
        text: 'บากเรือ',
        value: 'บากเรือ',
        name: {
          th: 'บากเรือ',
          en: 'Bak Ruea',
        },
        districtId: 351,
      },
      {
        id: '350606',
        zipcode: 35130,
        text: 'ม่วง',
        value: 'ม่วง',
        name: {
          th: 'ม่วง',
          en: 'Muang',
        },
        districtId: 351,
      },
      {
        id: '350607',
        zipcode: 35130,
        text: 'โนนทราย',
        value: 'โนนทราย',
        name: {
          th: 'โนนทราย',
          en: 'Non Sai',
        },
        districtId: 351,
      },
      {
        id: '350608',
        zipcode: 35130,
        text: 'บึงแก',
        value: 'บึงแก',
        name: {
          th: 'บึงแก',
          en: 'Bueng Kae',
        },
        districtId: 351,
      },
      {
        id: '350609',
        zipcode: 35130,
        text: 'พระเสาร์',
        value: 'พระเสาร์',
        name: {
          th: 'พระเสาร์',
          en: 'Phra Sao',
        },
        districtId: 351,
      },
      {
        id: '350610',
        zipcode: 35130,
        text: 'สงยาง',
        value: 'สงยาง',
        name: {
          th: 'สงยาง',
          en: 'Song Yang',
        },
        districtId: 351,
      },
      {
        id: '350701',
        zipcode: 35160,
        text: 'ฟ้าห่วน',
        value: 'ฟ้าห่วน',
        name: {
          th: 'ฟ้าห่วน',
          en: 'Fa Huan',
        },
        districtId: 352,
      },
      {
        id: '350702',
        zipcode: 35160,
        text: 'กุดน้ำใส',
        value: 'กุดน้ำใส',
        name: {
          th: 'กุดน้ำใส',
          en: 'Kut Nam Sai',
        },
        districtId: 352,
      },
      {
        id: '350703',
        zipcode: 35160,
        text: 'น้ำอ้อม',
        value: 'น้ำอ้อม',
        name: {
          th: 'น้ำอ้อม',
          en: 'Nam Om',
        },
        districtId: 352,
      },
      {
        id: '350704',
        zipcode: 35160,
        text: 'ค้อวัง',
        value: 'ค้อวัง',
        name: {
          th: 'ค้อวัง',
          en: 'Kho Wang',
        },
        districtId: 352,
      },
      {
        id: '350802',
        zipcode: 35120,
        text: 'บุ่งค้า',
        value: 'บุ่งค้า',
        name: {
          th: 'บุ่งค้า',
          en: 'Bung Kha',
        },
        districtId: 353,
      },
      {
        id: '350803',
        zipcode: 35120,
        text: 'สวาท',
        value: 'สวาท',
        name: {
          th: 'สวาท',
          en: 'Sawat',
        },
        districtId: 353,
      },
      {
        id: '350805',
        zipcode: 35120,
        text: 'ห้องแซง',
        value: 'ห้องแซง',
        name: {
          th: 'ห้องแซง',
          en: 'Hong Saeng',
        },
        districtId: 353,
      },
      {
        id: '350806',
        zipcode: 35120,
        text: 'สามัคคี',
        value: 'สามัคคี',
        name: {
          th: 'สามัคคี',
          en: 'Samakkhi',
        },
        districtId: 353,
      },
      {
        id: '350807',
        zipcode: 35120,
        text: 'กุดเชียงหมี',
        value: 'กุดเชียงหมี',
        name: {
          th: 'กุดเชียงหมี',
          en: 'Kut Chiang Mi',
        },
        districtId: 353,
      },
      {
        id: '350810',
        zipcode: 35120,
        text: 'สามแยก',
        value: 'สามแยก',
        name: {
          th: 'สามแยก',
          en: 'Sam Yaek',
        },
        districtId: 353,
      },
      {
        id: '350811',
        zipcode: 35120,
        text: 'กุดแห่',
        value: 'กุดแห่',
        name: {
          th: 'กุดแห่',
          en: 'Kut Hae',
        },
        districtId: 353,
      },
      {
        id: '350812',
        zipcode: 35120,
        text: 'โคกสำราญ',
        value: 'โคกสำราญ',
        name: {
          th: 'โคกสำราญ',
          en: 'Khok Samran',
        },
        districtId: 353,
      },
      {
        id: '350813',
        zipcode: 35120,
        text: 'สร้างมิ่ง',
        value: 'สร้างมิ่ง',
        name: {
          th: 'สร้างมิ่ง',
          en: 'Sang Ming',
        },
        districtId: 353,
      },
      {
        id: '350814',
        zipcode: 35120,
        text: 'ศรีแก้ว',
        value: 'ศรีแก้ว',
        name: {
          th: 'ศรีแก้ว',
          en: 'Si Kaeo',
        },
        districtId: 353,
      },
      {
        id: '350901',
        zipcode: 35120,
        text: 'ไทยเจริญ',
        value: 'ไทยเจริญ',
        name: {
          th: 'ไทยเจริญ',
          en: 'Thai Charoen',
        },
        districtId: 354,
      },
      {
        id: '350902',
        zipcode: 35120,
        text: 'น้ำคำ',
        value: 'น้ำคำ',
        name: {
          th: 'น้ำคำ',
          en: 'Nam Kham',
        },
        districtId: 354,
      },
      {
        id: '350903',
        zipcode: 35120,
        text: 'ส้มผ่อ',
        value: 'ส้มผ่อ',
        name: {
          th: 'ส้มผ่อ',
          en: 'Som Pho',
        },
        districtId: 354,
      },
      {
        id: '350904',
        zipcode: 35120,
        text: 'คำเตย',
        value: 'คำเตย',
        name: {
          th: 'คำเตย',
          en: 'Kham Toei',
        },
        districtId: 354,
      },
      {
        id: '350905',
        zipcode: 35120,
        text: 'คำไผ่',
        value: 'คำไผ่',
        name: {
          th: 'คำไผ่',
          en: 'Kham Phai',
        },
        districtId: 354,
      },
      {
        id: '360101',
        zipcode: 36000,
        text: 'ในเมือง',
        value: 'ในเมือง',
        name: {
          th: 'ในเมือง',
          en: 'Nai Mueang',
        },
        districtId: 355,
      },
      {
        id: '360102',
        zipcode: 36000,
        text: 'รอบเมือง',
        value: 'รอบเมือง',
        name: {
          th: 'รอบเมือง',
          en: 'Rop Mueang',
        },
        districtId: 355,
      },
      {
        id: '360103',
        zipcode: 36000,
        text: 'โพนทอง',
        value: 'โพนทอง',
        name: {
          th: 'โพนทอง',
          en: 'Phon Thong',
        },
        districtId: 355,
      },
      {
        id: '360104',
        zipcode: 36000,
        text: 'นาฝาย',
        value: 'นาฝาย',
        name: {
          th: 'นาฝาย',
          en: 'Na Fai',
        },
        districtId: 355,
      },
      {
        id: '360105',
        zipcode: 36240,
        text: 'บ้านค่าย',
        value: 'บ้านค่าย',
        name: {
          th: 'บ้านค่าย',
          en: 'Ban Khai',
        },
        districtId: 355,
      },
      {
        id: '360106',
        zipcode: 36000,
        text: 'กุดตุ้ม',
        value: 'กุดตุ้ม',
        name: {
          th: 'กุดตุ้ม',
          en: 'Kut Tum',
        },
        districtId: 355,
      },
      {
        id: '360107',
        zipcode: 36000,
        text: 'ชีลอง',
        value: 'ชีลอง',
        name: {
          th: 'ชีลอง',
          en: 'Chi Long',
        },
        districtId: 355,
      },
      {
        id: '360108',
        zipcode: 36000,
        text: 'บ้านเล่า',
        value: 'บ้านเล่า',
        name: {
          th: 'บ้านเล่า',
          en: 'Ban Lao',
        },
        districtId: 355,
      },
      {
        id: '360109',
        zipcode: 36000,
        text: 'นาเสียว',
        value: 'นาเสียว',
        name: {
          th: 'นาเสียว',
          en: 'Na Siao',
        },
        districtId: 355,
      },
      {
        id: '360110',
        zipcode: 36000,
        text: 'หนองนาแซง',
        value: 'หนองนาแซง',
        name: {
          th: 'หนองนาแซง',
          en: 'Nong Na Saeng',
        },
        districtId: 355,
      },
      {
        id: '360111',
        zipcode: 36000,
        text: 'ลาดใหญ่',
        value: 'ลาดใหญ่',
        name: {
          th: 'ลาดใหญ่',
          en: 'Lat Yai',
        },
        districtId: 355,
      },
      {
        id: '360112',
        zipcode: 36240,
        text: 'หนองไผ่',
        value: 'หนองไผ่',
        name: {
          th: 'หนองไผ่',
          en: 'Nong Phai',
        },
        districtId: 355,
      },
      {
        id: '360113',
        zipcode: 36000,
        text: 'ท่าหินโงม',
        value: 'ท่าหินโงม',
        name: {
          th: 'ท่าหินโงม',
          en: 'Tha Hin Ngom',
        },
        districtId: 355,
      },
      {
        id: '360114',
        zipcode: 36000,
        text: 'ห้วยต้อน',
        value: 'ห้วยต้อน',
        name: {
          th: 'ห้วยต้อน',
          en: 'Huai Ton',
        },
        districtId: 355,
      },
      {
        id: '360115',
        zipcode: 36000,
        text: 'ห้วยบง',
        value: 'ห้วยบง',
        name: {
          th: 'ห้วยบง',
          en: 'Huai Bong',
        },
        districtId: 355,
      },
      {
        id: '360116',
        zipcode: 36240,
        text: 'โนนสำราญ',
        value: 'โนนสำราญ',
        name: {
          th: 'โนนสำราญ',
          en: 'Non Samran',
        },
        districtId: 355,
      },
      {
        id: '360117',
        zipcode: 36000,
        text: 'โคกสูง',
        value: 'โคกสูง',
        name: {
          th: 'โคกสูง',
          en: 'Khok Sung',
        },
        districtId: 355,
      },
      {
        id: '360118',
        zipcode: 36000,
        text: 'บุ่งคล้า',
        value: 'บุ่งคล้า',
        name: {
          th: 'บุ่งคล้า',
          en: 'Bung Khla',
        },
        districtId: 355,
      },
      {
        id: '360119',
        zipcode: 36000,
        text: 'ซับสีทอง',
        value: 'ซับสีทอง',
        name: {
          th: 'ซับสีทอง',
          en: 'Sap Si Thong',
        },
        districtId: 355,
      },
      {
        id: '360201',
        zipcode: 36170,
        text: 'บ้านเขว้า',
        value: 'บ้านเขว้า',
        name: {
          th: 'บ้านเขว้า',
          en: 'Ban Khwao',
        },
        districtId: 356,
      },
      {
        id: '360202',
        zipcode: 36170,
        text: 'ตลาดแร้ง',
        value: 'ตลาดแร้ง',
        name: {
          th: 'ตลาดแร้ง',
          en: 'Talat Raeng',
        },
        districtId: 356,
      },
      {
        id: '360203',
        zipcode: 36170,
        text: 'ลุ่มลำชี',
        value: 'ลุ่มลำชี',
        name: {
          th: 'ลุ่มลำชี',
          en: 'Lum Lam Chi',
        },
        districtId: 356,
      },
      {
        id: '360204',
        zipcode: 36170,
        text: 'ชีบน',
        value: 'ชีบน',
        name: {
          th: 'ชีบน',
          en: 'Chi Bon',
        },
        districtId: 356,
      },
      {
        id: '360205',
        zipcode: 36170,
        text: 'ภูแลนคา',
        value: 'ภูแลนคา',
        name: {
          th: 'ภูแลนคา',
          en: 'Phu Laen Kha',
        },
        districtId: 356,
      },
      {
        id: '360206',
        zipcode: 36170,
        text: 'โนนแดง',
        value: 'โนนแดง',
        name: {
          th: 'โนนแดง',
          en: 'Non Dang',
        },
        districtId: 356,
      },
      {
        id: '360301',
        zipcode: 36140,
        text: 'คอนสวรรค์',
        value: 'คอนสวรรค์',
        name: {
          th: 'คอนสวรรค์',
          en: 'Khon Sawan',
        },
        districtId: 357,
      },
      {
        id: '360302',
        zipcode: 36140,
        text: 'ยางหวาย',
        value: 'ยางหวาย',
        name: {
          th: 'ยางหวาย',
          en: 'Yang Wai',
        },
        districtId: 357,
      },
      {
        id: '360303',
        zipcode: 36140,
        text: 'ช่องสามหมอ',
        value: 'ช่องสามหมอ',
        name: {
          th: 'ช่องสามหมอ',
          en: 'Chong Sam Mo)',
        },
        districtId: 357,
      },
      {
        id: '360304',
        zipcode: 36140,
        text: 'โนนสะอาด',
        value: 'โนนสะอาด',
        name: {
          th: 'โนนสะอาด',
          en: 'Non Sa-at',
        },
        districtId: 357,
      },
      {
        id: '360305',
        zipcode: 36140,
        text: 'ห้วยไร่',
        value: 'ห้วยไร่',
        name: {
          th: 'ห้วยไร่',
          en: 'Huai Rai',
        },
        districtId: 357,
      },
      {
        id: '360306',
        zipcode: 36140,
        text: 'บ้านโสก',
        value: 'บ้านโสก',
        name: {
          th: 'บ้านโสก',
          en: 'Ban Sok',
        },
        districtId: 357,
      },
      {
        id: '360307',
        zipcode: 36140,
        text: 'โคกมั่งงอย',
        value: 'โคกมั่งงอย',
        name: {
          th: 'โคกมั่งงอย',
          en: 'Khok Mang Ngoi',
        },
        districtId: 357,
      },
      {
        id: '360308',
        zipcode: 36140,
        text: 'หนองขาม',
        value: 'หนองขาม',
        name: {
          th: 'หนองขาม',
          en: 'Nong Kham',
        },
        districtId: 357,
      },
      {
        id: '360309',
        zipcode: 36140,
        text: 'ศรีสำราญ',
        value: 'ศรีสำราญ',
        name: {
          th: 'ศรีสำราญ',
          en: 'Si Samran',
        },
        districtId: 357,
      },
      {
        id: '360401',
        zipcode: 36120,
        text: 'บ้านยาง',
        value: 'บ้านยาง',
        name: {
          th: 'บ้านยาง',
          en: 'Ban Yang',
        },
        districtId: 358,
      },
      {
        id: '360402',
        zipcode: 36120,
        text: 'บ้านหัน',
        value: 'บ้านหัน',
        name: {
          th: 'บ้านหัน',
          en: 'Ban Han',
        },
        districtId: 358,
      },
      {
        id: '360403',
        zipcode: 36120,
        text: 'บ้านเดื่อ',
        value: 'บ้านเดื่อ',
        name: {
          th: 'บ้านเดื่อ',
          en: 'Ban Duea',
        },
        districtId: 358,
      },
      {
        id: '360404',
        zipcode: 36120,
        text: 'บ้านเป้า',
        value: 'บ้านเป้า',
        name: {
          th: 'บ้านเป้า',
          en: 'Ban Pao',
        },
        districtId: 358,
      },
      {
        id: '360405',
        zipcode: 36120,
        text: 'กุดเลาะ',
        value: 'กุดเลาะ',
        name: {
          th: 'กุดเลาะ',
          en: 'Kut Lo',
        },
        districtId: 358,
      },
      {
        id: '360406',
        zipcode: 36120,
        text: 'โนนกอก',
        value: 'โนนกอก',
        name: {
          th: 'โนนกอก',
          en: 'Non Kok',
        },
        districtId: 358,
      },
      {
        id: '360407',
        zipcode: 36120,
        text: 'สระโพนทอง',
        value: 'สระโพนทอง',
        name: {
          th: 'สระโพนทอง',
          en: 'Sa Phon Thong',
        },
        districtId: 358,
      },
      {
        id: '360408',
        zipcode: 36120,
        text: 'หนองข่า',
        value: 'หนองข่า',
        name: {
          th: 'หนองข่า',
          en: 'Nong Kha',
        },
        districtId: 358,
      },
      {
        id: '360409',
        zipcode: 36120,
        text: 'หนองโพนงาม',
        value: 'หนองโพนงาม',
        name: {
          th: 'หนองโพนงาม',
          en: 'Nong Phon Ngam',
        },
        districtId: 358,
      },
      {
        id: '360410',
        zipcode: 36120,
        text: 'บ้านบัว',
        value: 'บ้านบัว',
        name: {
          th: 'บ้านบัว',
          en: 'Ban Bua',
        },
        districtId: 358,
      },
      {
        id: '360411',
        zipcode: 36000,
        text: 'ซับสีทอง*',
        value: 'ซับสีทอง*',
        name: {
          th: 'ซับสีทอง*',
          en: '*Sup See Thong',
        },
        districtId: 358,
      },
      {
        id: '360412',
        zipcode: 36120,
        text: 'โนนทอง',
        value: 'โนนทอง',
        name: {
          th: 'โนนทอง',
          en: 'Non Thong',
        },
        districtId: 358,
      },
      {
        id: '360501',
        zipcode: 36210,
        text: 'หนองบัวแดง',
        value: 'หนองบัวแดง',
        name: {
          th: 'หนองบัวแดง',
          en: 'Nong Bua Daeng',
        },
        districtId: 359,
      },
      {
        id: '360502',
        zipcode: 36210,
        text: 'กุดชุมแสง',
        value: 'กุดชุมแสง',
        name: {
          th: 'กุดชุมแสง',
          en: 'Kut Chum Saeng',
        },
        districtId: 359,
      },
      {
        id: '360503',
        zipcode: 36210,
        text: 'ถ้ำวัวแดง',
        value: 'ถ้ำวัวแดง',
        name: {
          th: 'ถ้ำวัวแดง',
          en: 'Tham Wua Daeng',
        },
        districtId: 359,
      },
      {
        id: '360504',
        zipcode: 36210,
        text: 'นางแดด',
        value: 'นางแดด',
        name: {
          th: 'นางแดด',
          en: 'Nang Daet',
        },
        districtId: 359,
      },
      {
        id: '360507',
        zipcode: 36210,
        text: 'หนองแวง',
        value: 'หนองแวง',
        name: {
          th: 'หนองแวง',
          en: 'Nong Waeng',
        },
        districtId: 359,
      },
      {
        id: '360508',
        zipcode: 36210,
        text: 'คูเมือง',
        value: 'คูเมือง',
        name: {
          th: 'คูเมือง',
          en: 'Khu Mueang',
        },
        districtId: 359,
      },
      {
        id: '360509',
        zipcode: 36210,
        text: 'ท่าใหญ่',
        value: 'ท่าใหญ่',
        name: {
          th: 'ท่าใหญ่',
          en: 'Tha Yai',
        },
        districtId: 359,
      },
      {
        id: '360511',
        zipcode: 36210,
        text: 'วังชมภู',
        value: 'วังชมภู',
        name: {
          th: 'วังชมภู',
          en: 'Wang Chomphu',
        },
        districtId: 359,
      },
      {
        id: '360601',
        zipcode: 36130,
        text: 'บ้านกอก',
        value: 'บ้านกอก',
        name: {
          th: 'บ้านกอก',
          en: 'Ban Kok',
        },
        districtId: 360,
      },
      {
        id: '360602',
        zipcode: 36130,
        text: 'หนองบัวบาน',
        value: 'หนองบัวบาน',
        name: {
          th: 'หนองบัวบาน',
          en: 'Nong Bua Ban',
        },
        districtId: 360,
      },
      {
        id: '360603',
        zipcode: 36130,
        text: 'บ้านขาม',
        value: 'บ้านขาม',
        name: {
          th: 'บ้านขาม',
          en: 'Ban Kham',
        },
        districtId: 360,
      },
      {
        id: '360605',
        zipcode: 36130,
        text: 'กุดน้ำใส',
        value: 'กุดน้ำใส',
        name: {
          th: 'กุดน้ำใส',
          en: 'Kut Nam Sai',
        },
        districtId: 360,
      },
      {
        id: '360606',
        zipcode: 36130,
        text: 'หนองโดน',
        value: 'หนองโดน',
        name: {
          th: 'หนองโดน',
          en: 'Nong Don',
        },
        districtId: 360,
      },
      {
        id: '360607',
        zipcode: 36130,
        text: 'ละหาน',
        value: 'ละหาน',
        name: {
          th: 'ละหาน',
          en: 'Lahan',
        },
        districtId: 360,
      },
      {
        id: '360610',
        zipcode: 36130,
        text: 'หนองบัวใหญ่',
        value: 'หนองบัวใหญ่',
        name: {
          th: 'หนองบัวใหญ่',
          en: 'Nong Bua Yai',
        },
        districtId: 360,
      },
      {
        id: '360611',
        zipcode: 36220,
        text: 'หนองบัวโคก',
        value: 'หนองบัวโคก',
        name: {
          th: 'หนองบัวโคก',
          en: 'Nong Bua Khok',
        },
        districtId: 360,
      },
      {
        id: '360613',
        zipcode: 36130,
        text: 'ส้มป่อย',
        value: 'ส้มป่อย',
        name: {
          th: 'ส้มป่อย',
          en: 'Sompoi',
        },
        districtId: 360,
      },
      {
        id: '360701',
        zipcode: 36160,
        text: 'บ้านชวน',
        value: 'บ้านชวน',
        name: {
          th: 'บ้านชวน',
          en: 'Ban Chuan',
        },
        districtId: 361,
      },
      {
        id: '360702',
        zipcode: 36160,
        text: 'บ้านเพชร',
        value: 'บ้านเพชร',
        name: {
          th: 'บ้านเพชร',
          en: 'Ban Phet',
        },
        districtId: 361,
      },
      {
        id: '360703',
        zipcode: 36220,
        text: 'บ้านตาล',
        value: 'บ้านตาล',
        name: {
          th: 'บ้านตาล',
          en: 'Ban Tan',
        },
        districtId: 361,
      },
      {
        id: '360704',
        zipcode: 36220,
        text: 'หัวทะเล',
        value: 'หัวทะเล',
        name: {
          th: 'หัวทะเล',
          en: 'Hua Thale',
        },
        districtId: 361,
      },
      {
        id: '360705',
        zipcode: 36160,
        text: 'โคกเริงรมย์',
        value: 'โคกเริงรมย์',
        name: {
          th: 'โคกเริงรมย์',
          en: 'Khok Roeng Rom',
        },
        districtId: 361,
      },
      {
        id: '360706',
        zipcode: 36160,
        text: 'เกาะมะนาว',
        value: 'เกาะมะนาว',
        name: {
          th: 'เกาะมะนาว',
          en: 'Ko Manao',
        },
        districtId: 361,
      },
      {
        id: '360707',
        zipcode: 36160,
        text: 'โคกเพชรพัฒนา',
        value: 'โคกเพชรพัฒนา',
        name: {
          th: 'โคกเพชรพัฒนา',
          en: 'Khok Phet Phatthana',
        },
        districtId: 361,
      },
      {
        id: '360801',
        zipcode: 36250,
        text: 'หนองบัวระเหว',
        value: 'หนองบัวระเหว',
        name: {
          th: 'หนองบัวระเหว',
          en: 'Nong Bua Rawe',
        },
        districtId: 362,
      },
      {
        id: '360802',
        zipcode: 36250,
        text: 'วังตะเฆ่',
        value: 'วังตะเฆ่',
        name: {
          th: 'วังตะเฆ่',
          en: 'Wang Takhe',
        },
        districtId: 362,
      },
      {
        id: '360803',
        zipcode: 36250,
        text: 'ห้วยแย้',
        value: 'ห้วยแย้',
        name: {
          th: 'ห้วยแย้',
          en: 'Huai Yae',
        },
        districtId: 362,
      },
      {
        id: '360804',
        zipcode: 36250,
        text: 'โคกสะอาด',
        value: 'โคกสะอาด',
        name: {
          th: 'โคกสะอาด',
          en: 'Khok Sa-at',
        },
        districtId: 362,
      },
      {
        id: '360805',
        zipcode: 36250,
        text: 'โสกปลาดุก',
        value: 'โสกปลาดุก',
        name: {
          th: 'โสกปลาดุก',
          en: 'Sok Pla Duk',
        },
        districtId: 362,
      },
      {
        id: '360901',
        zipcode: 36230,
        text: 'วะตะแบก',
        value: 'วะตะแบก',
        name: {
          th: 'วะตะแบก',
          en: 'Wa Tabaek',
        },
        districtId: 363,
      },
      {
        id: '360902',
        zipcode: 36230,
        text: 'ห้วยยายจิ๋ว',
        value: 'ห้วยยายจิ๋ว',
        name: {
          th: 'ห้วยยายจิ๋ว',
          en: 'Huai Yai Chio',
        },
        districtId: 363,
      },
      {
        id: '360903',
        zipcode: 36230,
        text: 'นายางกลัก',
        value: 'นายางกลัก',
        name: {
          th: 'นายางกลัก',
          en: 'Na Yang Klak',
        },
        districtId: 363,
      },
      {
        id: '360904',
        zipcode: 36230,
        text: 'บ้านไร่',
        value: 'บ้านไร่',
        name: {
          th: 'บ้านไร่',
          en: 'Ban Rai',
        },
        districtId: 363,
      },
      {
        id: '360905',
        zipcode: 36230,
        text: 'โป่งนก',
        value: 'โป่งนก',
        name: {
          th: 'โป่งนก',
          en: 'Pong Nok',
        },
        districtId: 363,
      },
      {
        id: '361001',
        zipcode: 36110,
        text: 'ผักปัง',
        value: 'ผักปัง',
        name: {
          th: 'ผักปัง',
          en: 'Phak Pang',
        },
        districtId: 364,
      },
      {
        id: '361002',
        zipcode: 36110,
        text: 'กวางโจน',
        value: 'กวางโจน',
        name: {
          th: 'กวางโจน',
          en: 'Kwang Chon',
        },
        districtId: 364,
      },
      {
        id: '361003',
        zipcode: 36110,
        text: 'หนองคอนไทย',
        value: 'หนองคอนไทย',
        name: {
          th: 'หนองคอนไทย',
          en: 'Nong Khon Thai',
        },
        districtId: 364,
      },
      {
        id: '361004',
        zipcode: 36110,
        text: 'บ้านแก้ง',
        value: 'บ้านแก้ง',
        name: {
          th: 'บ้านแก้ง',
          en: 'Ban Kaeng',
        },
        districtId: 364,
      },
      {
        id: '361005',
        zipcode: 36110,
        text: 'กุดยม',
        value: 'กุดยม',
        name: {
          th: 'กุดยม',
          en: 'Kut Yom',
        },
        districtId: 364,
      },
      {
        id: '361006',
        zipcode: 36110,
        text: 'บ้านเพชร',
        value: 'บ้านเพชร',
        name: {
          th: 'บ้านเพชร',
          en: 'Ban Phet',
        },
        districtId: 364,
      },
      {
        id: '361007',
        zipcode: 36110,
        text: 'โคกสะอาด',
        value: 'โคกสะอาด',
        name: {
          th: 'โคกสะอาด',
          en: 'Khok Sa-at',
        },
        districtId: 364,
      },
      {
        id: '361008',
        zipcode: 36110,
        text: 'หนองตูม',
        value: 'หนองตูม',
        name: {
          th: 'หนองตูม',
          en: 'Nong Tum',
        },
        districtId: 364,
      },
      {
        id: '361009',
        zipcode: 36110,
        text: 'โอโล',
        value: 'โอโล',
        name: {
          th: 'โอโล',
          en: 'Olo',
        },
        districtId: 364,
      },
      {
        id: '361010',
        zipcode: 36110,
        text: 'ธาตุทอง',
        value: 'ธาตุทอง',
        name: {
          th: 'ธาตุทอง',
          en: 'That Thong',
        },
        districtId: 364,
      },
      {
        id: '361011',
        zipcode: 36110,
        text: 'บ้านดอน',
        value: 'บ้านดอน',
        name: {
          th: 'บ้านดอน',
          en: 'Ban Don',
        },
        districtId: 364,
      },
      {
        id: '361101',
        zipcode: 36190,
        text: 'บ้านแท่น',
        value: 'บ้านแท่น',
        name: {
          th: 'บ้านแท่น',
          en: 'Ban Thaen',
        },
        districtId: 365,
      },
      {
        id: '361102',
        zipcode: 36190,
        text: 'สามสวน',
        value: 'สามสวน',
        name: {
          th: 'สามสวน',
          en: 'Sam Suan',
        },
        districtId: 365,
      },
      {
        id: '361103',
        zipcode: 36190,
        text: 'สระพัง',
        value: 'สระพัง',
        name: {
          th: 'สระพัง',
          en: 'Sa Phang',
        },
        districtId: 365,
      },
      {
        id: '361104',
        zipcode: 36190,
        text: 'บ้านเต่า',
        value: 'บ้านเต่า',
        name: {
          th: 'บ้านเต่า',
          en: 'Ban Tao',
        },
        districtId: 365,
      },
      {
        id: '361105',
        zipcode: 36190,
        text: 'หนองคู',
        value: 'หนองคู',
        name: {
          th: 'หนองคู',
          en: 'Nong Khu',
        },
        districtId: 365,
      },
      {
        id: '361201',
        zipcode: 36150,
        text: 'ช่องสามหมอ',
        value: 'ช่องสามหมอ',
        name: {
          th: 'ช่องสามหมอ',
          en: 'Chong Sam Mo',
        },
        districtId: 366,
      },
      {
        id: '361202',
        zipcode: 36150,
        text: 'หนองขาม',
        value: 'หนองขาม',
        name: {
          th: 'หนองขาม',
          en: 'Nong Kham',
        },
        districtId: 366,
      },
      {
        id: '361203',
        zipcode: 36150,
        text: 'นาหนองทุ่ม',
        value: 'นาหนองทุ่ม',
        name: {
          th: 'นาหนองทุ่ม',
          en: 'Na Nong Thum',
        },
        districtId: 366,
      },
      {
        id: '361204',
        zipcode: 36150,
        text: 'บ้านแก้ง',
        value: 'บ้านแก้ง',
        name: {
          th: 'บ้านแก้ง',
          en: 'Ban Kaeng',
        },
        districtId: 366,
      },
      {
        id: '361205',
        zipcode: 36150,
        text: 'หนองสังข์',
        value: 'หนองสังข์',
        name: {
          th: 'หนองสังข์',
          en: 'Nong Sang',
        },
        districtId: 366,
      },
      {
        id: '361206',
        zipcode: 36150,
        text: 'หลุบคา',
        value: 'หลุบคา',
        name: {
          th: 'หลุบคา',
          en: 'Lup Kha',
        },
        districtId: 366,
      },
      {
        id: '361207',
        zipcode: 36150,
        text: 'โคกกุง',
        value: 'โคกกุง',
        name: {
          th: 'โคกกุง',
          en: 'Khok Kung',
        },
        districtId: 366,
      },
      {
        id: '361208',
        zipcode: 36150,
        text: 'เก่าย่าดี',
        value: 'เก่าย่าดี',
        name: {
          th: 'เก่าย่าดี',
          en: 'Kao Ya Di',
        },
        districtId: 366,
      },
      {
        id: '361209',
        zipcode: 36150,
        text: 'ท่ามะไฟหวาน',
        value: 'ท่ามะไฟหวาน',
        name: {
          th: 'ท่ามะไฟหวาน',
          en: 'Tha Mafai Wan',
        },
        districtId: 366,
      },
      {
        id: '361210',
        zipcode: 36150,
        text: 'หนองไผ่',
        value: 'หนองไผ่',
        name: {
          th: 'หนองไผ่',
          en: 'Nong Phai)',
        },
        districtId: 366,
      },
      {
        id: '361301',
        zipcode: 36180,
        text: 'คอนสาร',
        value: 'คอนสาร',
        name: {
          th: 'คอนสาร',
          en: 'Khon San',
        },
        districtId: 367,
      },
      {
        id: '361302',
        zipcode: 36180,
        text: 'ทุ่งพระ',
        value: 'ทุ่งพระ',
        name: {
          th: 'ทุ่งพระ',
          en: 'Thung Phra',
        },
        districtId: 367,
      },
      {
        id: '361303',
        zipcode: 36180,
        text: 'โนนคูณ',
        value: 'โนนคูณ',
        name: {
          th: 'โนนคูณ',
          en: 'Non Khun',
        },
        districtId: 367,
      },
      {
        id: '361304',
        zipcode: 36180,
        text: 'ห้วยยาง',
        value: 'ห้วยยาง',
        name: {
          th: 'ห้วยยาง',
          en: 'Huai Yang',
        },
        districtId: 367,
      },
      {
        id: '361305',
        zipcode: 36180,
        text: 'ทุ่งลุยลาย',
        value: 'ทุ่งลุยลาย',
        name: {
          th: 'ทุ่งลุยลาย',
          en: 'Thung Luilai',
        },
        districtId: 367,
      },
      {
        id: '361306',
        zipcode: 36180,
        text: 'ดงบัง',
        value: 'ดงบัง',
        name: {
          th: 'ดงบัง',
          en: 'Dong Bang',
        },
        districtId: 367,
      },
      {
        id: '361307',
        zipcode: 36180,
        text: 'ทุ่งนาเลา',
        value: 'ทุ่งนาเลา',
        name: {
          th: 'ทุ่งนาเลา',
          en: 'Thung Na Lao',
        },
        districtId: 367,
      },
      {
        id: '361308',
        zipcode: 36180,
        text: 'ดงกลาง',
        value: 'ดงกลาง',
        name: {
          th: 'ดงกลาง',
          en: 'Dong Klang',
        },
        districtId: 367,
      },
      {
        id: '361401',
        zipcode: 36260,
        text: 'บ้านเจียง',
        value: 'บ้านเจียง',
        name: {
          th: 'บ้านเจียง',
          en: 'Chao Thong',
        },
        districtId: 368,
      },
      {
        id: '361402',
        zipcode: 36260,
        text: 'เจาทอง',
        value: 'เจาทอง',
        name: {
          th: 'เจาทอง',
          en: 'Ban Chiang',
        },
        districtId: 368,
      },
      {
        id: '361403',
        zipcode: 36260,
        text: 'วังทอง',
        value: 'วังทอง',
        name: {
          th: 'วังทอง',
          en: 'Wang Thong',
        },
        districtId: 368,
      },
      {
        id: '361404',
        zipcode: 36260,
        text: 'แหลมทอง',
        value: 'แหลมทอง',
        name: {
          th: 'แหลมทอง',
          en: 'Laem Thong',
        },
        districtId: 368,
      },
      {
        id: '361501',
        zipcode: 36130,
        text: 'หนองฉิม',
        value: 'หนองฉิม',
        name: {
          th: 'หนองฉิม',
          en: 'Nong Chim',
        },
        districtId: 369,
      },
      {
        id: '361502',
        zipcode: 36130,
        text: 'ตาเนิน',
        value: 'ตาเนิน',
        name: {
          th: 'ตาเนิน',
          en: 'Ta Noen',
        },
        districtId: 369,
      },
      {
        id: '361503',
        zipcode: 36130,
        text: 'กะฮาด',
        value: 'กะฮาด',
        name: {
          th: 'กะฮาด',
          en: 'Kahat',
        },
        districtId: 369,
      },
      {
        id: '361504',
        zipcode: 36130,
        text: 'รังงาม',
        value: 'รังงาม',
        name: {
          th: 'รังงาม',
          en: 'Rang Ngam',
        },
        districtId: 369,
      },
      {
        id: '361601',
        zipcode: 36130,
        text: 'ซับใหญ่',
        value: 'ซับใหญ่',
        name: {
          th: 'ซับใหญ่',
          en: 'Sap Yai',
        },
        districtId: 370,
      },
      {
        id: '361602',
        zipcode: 36130,
        text: 'ท่ากูบ',
        value: 'ท่ากูบ',
        name: {
          th: 'ท่ากูบ',
          en: 'Tha Kup',
        },
        districtId: 370,
      },
      {
        id: '361603',
        zipcode: 36130,
        text: 'ตะโกทอง',
        value: 'ตะโกทอง',
        name: {
          th: 'ตะโกทอง',
          en: 'Tako Thong',
        },
        districtId: 370,
      },
      {
        id: '370101',
        zipcode: 37000,
        text: 'บุ่ง',
        value: 'บุ่ง',
        name: {
          th: 'บุ่ง',
          en: 'Bung',
        },
        districtId: 380,
      },
      {
        id: '370102',
        zipcode: 37000,
        text: 'ไก่คำ',
        value: 'ไก่คำ',
        name: {
          th: 'ไก่คำ',
          en: 'Kai Kham',
        },
        districtId: 380,
      },
      {
        id: '370103',
        zipcode: 37000,
        text: 'นาจิก',
        value: 'นาจิก',
        name: {
          th: 'นาจิก',
          en: 'Na Chik',
        },
        districtId: 380,
      },
      {
        id: '370104',
        zipcode: 37000,
        text: 'ปลาค้าว',
        value: 'ปลาค้าว',
        name: {
          th: 'ปลาค้าว',
          en: 'Pla Khao',
        },
        districtId: 380,
      },
      {
        id: '370105',
        zipcode: 37000,
        text: 'เหล่าพรวน',
        value: 'เหล่าพรวน',
        name: {
          th: 'เหล่าพรวน',
          en: 'Lao Pruan',
        },
        districtId: 380,
      },
      {
        id: '370106',
        zipcode: 37000,
        text: 'สร้างนกทา',
        value: 'สร้างนกทา',
        name: {
          th: 'สร้างนกทา',
          en: 'Sang Nok Tha',
        },
        districtId: 380,
      },
      {
        id: '370107',
        zipcode: 37000,
        text: 'คึมใหญ่',
        value: 'คึมใหญ่',
        name: {
          th: 'คึมใหญ่',
          en: 'Khuem Yai',
        },
        districtId: 380,
      },
      {
        id: '370108',
        zipcode: 37000,
        text: 'นาผือ',
        value: 'นาผือ',
        name: {
          th: 'นาผือ',
          en: 'Na Phue',
        },
        districtId: 380,
      },
      {
        id: '370109',
        zipcode: 37000,
        text: 'น้ำปลีก',
        value: 'น้ำปลีก',
        name: {
          th: 'น้ำปลีก',
          en: 'Nam Plik',
        },
        districtId: 380,
      },
      {
        id: '370110',
        zipcode: 37000,
        text: 'นาวัง',
        value: 'นาวัง',
        name: {
          th: 'นาวัง',
          en: 'Na Wang',
        },
        districtId: 380,
      },
      {
        id: '370111',
        zipcode: 37000,
        text: 'นาหมอม้า',
        value: 'นาหมอม้า',
        name: {
          th: 'นาหมอม้า',
          en: 'Na Mo Ma',
        },
        districtId: 380,
      },
      {
        id: '370112',
        zipcode: 37000,
        text: 'โนนโพธิ์',
        value: 'โนนโพธิ์',
        name: {
          th: 'โนนโพธิ์',
          en: 'Non Pho',
        },
        districtId: 380,
      },
      {
        id: '370113',
        zipcode: 37000,
        text: 'โนนหนามแท่ง',
        value: 'โนนหนามแท่ง',
        name: {
          th: 'โนนหนามแท่ง',
          en: 'Non Nam Thaeng',
        },
        districtId: 380,
      },
      {
        id: '370114',
        zipcode: 37000,
        text: 'ห้วยไร่',
        value: 'ห้วยไร่',
        name: {
          th: 'ห้วยไร่',
          en: 'Huai Rai',
        },
        districtId: 380,
      },
      {
        id: '370115',
        zipcode: 37000,
        text: 'หนองมะแซว',
        value: 'หนองมะแซว',
        name: {
          th: 'หนองมะแซว',
          en: 'Nong Masaeo',
        },
        districtId: 380,
      },
      {
        id: '370116',
        zipcode: 37000,
        text: 'กุดปลาดุก',
        value: 'กุดปลาดุก',
        name: {
          th: 'กุดปลาดุก',
          en: 'Kut Pla Duk',
        },
        districtId: 380,
      },
      {
        id: '370117',
        zipcode: 37000,
        text: 'ดอนเมย',
        value: 'ดอนเมย',
        name: {
          th: 'ดอนเมย',
          en: 'Don Moei',
        },
        districtId: 380,
      },
      {
        id: '370118',
        zipcode: 37000,
        text: 'นายม',
        value: 'นายม',
        name: {
          th: 'นายม',
          en: 'Na Yom',
        },
        districtId: 380,
      },
      {
        id: '370119',
        zipcode: 37000,
        text: 'นาแต้',
        value: 'นาแต้',
        name: {
          th: 'นาแต้',
          en: 'Na Tae',
        },
        districtId: 380,
      },
      {
        id: '370201',
        zipcode: 37210,
        text: 'ชานุมาน',
        value: 'ชานุมาน',
        name: {
          th: 'ชานุมาน',
          en: 'Chanuman',
        },
        districtId: 381,
      },
      {
        id: '370202',
        zipcode: 37210,
        text: 'โคกสาร',
        value: 'โคกสาร',
        name: {
          th: 'โคกสาร',
          en: 'Khok San',
        },
        districtId: 381,
      },
      {
        id: '370203',
        zipcode: 37210,
        text: 'คำเขื่อนแก้ว',
        value: 'คำเขื่อนแก้ว',
        name: {
          th: 'คำเขื่อนแก้ว',
          en: 'Kham Khuean Kaeo',
        },
        districtId: 381,
      },
      {
        id: '370204',
        zipcode: 37210,
        text: 'โคกก่ง',
        value: 'โคกก่ง',
        name: {
          th: 'โคกก่ง',
          en: 'Khok Kong',
        },
        districtId: 381,
      },
      {
        id: '370205',
        zipcode: 37210,
        text: 'ป่าก่อ',
        value: 'ป่าก่อ',
        name: {
          th: 'ป่าก่อ',
          en: 'Pa Ko',
        },
        districtId: 381,
      },
      {
        id: '370301',
        zipcode: 37110,
        text: 'หนองข่า',
        value: 'หนองข่า',
        name: {
          th: 'หนองข่า',
          en: 'Nong Kha',
        },
        districtId: 382,
      },
      {
        id: '370302',
        zipcode: 37110,
        text: 'คำโพน',
        value: 'คำโพน',
        name: {
          th: 'คำโพน',
          en: 'Kham Phon',
        },
        districtId: 382,
      },
      {
        id: '370303',
        zipcode: 37110,
        text: 'นาหว้า',
        value: 'นาหว้า',
        name: {
          th: 'นาหว้า',
          en: 'Na Wa',
        },
        districtId: 382,
      },
      {
        id: '370304',
        zipcode: 37110,
        text: 'ลือ',
        value: 'ลือ',
        name: {
          th: 'ลือ',
          en: 'Lue',
        },
        districtId: 382,
      },
      {
        id: '370305',
        zipcode: 37110,
        text: 'ห้วย',
        value: 'ห้วย',
        name: {
          th: 'ห้วย',
          en: 'Huai',
        },
        districtId: 382,
      },
      {
        id: '370306',
        zipcode: 37110,
        text: 'โนนงาม',
        value: 'โนนงาม',
        name: {
          th: 'โนนงาม',
          en: 'Non Ngam',
        },
        districtId: 382,
      },
      {
        id: '370307',
        zipcode: 37110,
        text: 'นาป่าแซง',
        value: 'นาป่าแซง',
        name: {
          th: 'นาป่าแซง',
          en: 'Na Pa Saeng',
        },
        districtId: 382,
      },
      {
        id: '370401',
        zipcode: 37180,
        text: 'พนา',
        value: 'พนา',
        name: {
          th: 'พนา',
          en: 'Phana',
        },
        districtId: 383,
      },
      {
        id: '370402',
        zipcode: 37180,
        text: 'จานลาน',
        value: 'จานลาน',
        name: {
          th: 'จานลาน',
          en: 'Chan Lan',
        },
        districtId: 383,
      },
      {
        id: '370403',
        zipcode: 37180,
        text: 'ไม้กลอน',
        value: 'ไม้กลอน',
        name: {
          th: 'ไม้กลอน',
          en: 'Mai Klon',
        },
        districtId: 383,
      },
      {
        id: '370404',
        zipcode: 37180,
        text: 'พระเหลา',
        value: 'พระเหลา',
        name: {
          th: 'พระเหลา',
          en: 'Phra Lao',
        },
        districtId: 383,
      },
      {
        id: '370501',
        zipcode: 37290,
        text: 'เสนางคนิคม',
        value: 'เสนางคนิคม',
        name: {
          th: 'เสนางคนิคม',
          en: 'Senangkhanikhom',
        },
        districtId: 384,
      },
      {
        id: '370502',
        zipcode: 37290,
        text: 'โพนทอง',
        value: 'โพนทอง',
        name: {
          th: 'โพนทอง',
          en: 'Phon Thong',
        },
        districtId: 384,
      },
      {
        id: '370503',
        zipcode: 37290,
        text: 'ไร่สีสุก',
        value: 'ไร่สีสุก',
        name: {
          th: 'ไร่สีสุก',
          en: 'Rai Si Suk',
        },
        districtId: 384,
      },
      {
        id: '370504',
        zipcode: 37290,
        text: 'นาเวียง',
        value: 'นาเวียง',
        name: {
          th: 'นาเวียง',
          en: 'Na Wiang',
        },
        districtId: 384,
      },
      {
        id: '370505',
        zipcode: 37290,
        text: 'หนองไฮ',
        value: 'หนองไฮ',
        name: {
          th: 'หนองไฮ',
          en: 'Nong Hai',
        },
        districtId: 384,
      },
      {
        id: '370506',
        zipcode: 37290,
        text: 'หนองสามสี',
        value: 'หนองสามสี',
        name: {
          th: 'หนองสามสี',
          en: 'Nong Sam Si',
        },
        districtId: 384,
      },
      {
        id: '370601',
        zipcode: 37240,
        text: 'หัวตะพาน',
        value: 'หัวตะพาน',
        name: {
          th: 'หัวตะพาน',
          en: 'Hua Taphan',
        },
        districtId: 385,
      },
      {
        id: '370602',
        zipcode: 37240,
        text: 'คำพระ',
        value: 'คำพระ',
        name: {
          th: 'คำพระ',
          en: 'Kham Phra',
        },
        districtId: 385,
      },
      {
        id: '370603',
        zipcode: 37240,
        text: 'เค็งใหญ่',
        value: 'เค็งใหญ่',
        name: {
          th: 'เค็งใหญ่',
          en: 'Kheng Yai',
        },
        districtId: 385,
      },
      {
        id: '370604',
        zipcode: 37240,
        text: 'หนองแก้ว',
        value: 'หนองแก้ว',
        name: {
          th: 'หนองแก้ว',
          en: 'Nong Kaeo',
        },
        districtId: 385,
      },
      {
        id: '370605',
        zipcode: 37240,
        text: 'โพนเมืองน้อย',
        value: 'โพนเมืองน้อย',
        name: {
          th: 'โพนเมืองน้อย',
          en: 'Phon Mueang Noi',
        },
        districtId: 385,
      },
      {
        id: '370606',
        zipcode: 37240,
        text: 'สร้างถ่อน้อย',
        value: 'สร้างถ่อน้อย',
        name: {
          th: 'สร้างถ่อน้อย',
          en: 'Sang Tho Noi',
        },
        districtId: 385,
      },
      {
        id: '370607',
        zipcode: 37240,
        text: 'จิกดู่',
        value: 'จิกดู่',
        name: {
          th: 'จิกดู่',
          en: 'Chik Du',
        },
        districtId: 385,
      },
      {
        id: '370608',
        zipcode: 37240,
        text: 'รัตนวารี',
        value: 'รัตนวารี',
        name: {
          th: 'รัตนวารี',
          en: 'Rattanawari',
        },
        districtId: 385,
      },
      {
        id: '370701',
        zipcode: 37000,
        text: 'อำนาจ',
        value: 'อำนาจ',
        name: {
          th: 'อำนาจ',
          en: 'Amnat',
        },
        districtId: 386,
      },
      {
        id: '370702',
        zipcode: 37000,
        text: 'ดงมะยาง',
        value: 'ดงมะยาง',
        name: {
          th: 'ดงมะยาง',
          en: 'Dong Mayang',
        },
        districtId: 386,
      },
      {
        id: '370703',
        zipcode: 37000,
        text: 'เปือย',
        value: 'เปือย',
        name: {
          th: 'เปือย',
          en: 'Pueai',
        },
        districtId: 386,
      },
      {
        id: '370704',
        zipcode: 37000,
        text: 'ดงบัง',
        value: 'ดงบัง',
        name: {
          th: 'ดงบัง',
          en: 'Dong Bang',
        },
        districtId: 386,
      },
      {
        id: '370705',
        zipcode: 37000,
        text: 'ไร่ขี',
        value: 'ไร่ขี',
        name: {
          th: 'ไร่ขี',
          en: 'Rai Khi',
        },
        districtId: 386,
      },
      {
        id: '370706',
        zipcode: 37000,
        text: 'แมด',
        value: 'แมด',
        name: {
          th: 'แมด',
          en: 'Maet',
        },
        districtId: 386,
      },
      {
        id: '370707',
        zipcode: 37000,
        text: 'โคกกลาง',
        value: 'โคกกลาง',
        name: {
          th: 'โคกกลาง',
          en: 'Khok Klang',
        },
        districtId: 386,
      },
      {
        id: '390101',
        zipcode: 39000,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 387,
      },
      {
        id: '390102',
        zipcode: 39000,
        text: 'หนองภัยศูนย์',
        value: 'หนองภัยศูนย์',
        name: {
          th: 'หนองภัยศูนย์',
          en: 'Nong Phai Sun',
        },
        districtId: 387,
      },
      {
        id: '390103',
        zipcode: 39000,
        text: 'โพธิ์ชัย',
        value: 'โพธิ์ชัย',
        name: {
          th: 'โพธิ์ชัย',
          en: 'Pho Chai',
        },
        districtId: 387,
      },
      {
        id: '390104',
        zipcode: 39000,
        text: 'หนองสวรรค์',
        value: 'หนองสวรรค์',
        name: {
          th: 'หนองสวรรค์',
          en: 'Nong Sawan',
        },
        districtId: 387,
      },
      {
        id: '390105',
        zipcode: 39000,
        text: 'หัวนา',
        value: 'หัวนา',
        name: {
          th: 'หัวนา',
          en: 'Hua Na',
        },
        districtId: 387,
      },
      {
        id: '390106',
        zipcode: 39000,
        text: 'บ้านขาม',
        value: 'บ้านขาม',
        name: {
          th: 'บ้านขาม',
          en: 'Ban Kham',
        },
        districtId: 387,
      },
      {
        id: '390107',
        zipcode: 39000,
        text: 'นามะเฟือง',
        value: 'นามะเฟือง',
        name: {
          th: 'นามะเฟือง',
          en: 'Na Mafueang',
        },
        districtId: 387,
      },
      {
        id: '390108',
        zipcode: 39000,
        text: 'บ้านพร้าว',
        value: 'บ้านพร้าว',
        name: {
          th: 'บ้านพร้าว',
          en: 'Ban Phrao',
        },
        districtId: 387,
      },
      {
        id: '390109',
        zipcode: 39000,
        text: 'โนนขมิ้น',
        value: 'โนนขมิ้น',
        name: {
          th: 'โนนขมิ้น',
          en: 'Non Khamin',
        },
        districtId: 387,
      },
      {
        id: '390110',
        zipcode: 39000,
        text: 'ลำภู',
        value: 'ลำภู',
        name: {
          th: 'ลำภู',
          en: 'Lam Phu',
        },
        districtId: 387,
      },
      {
        id: '390111',
        zipcode: 39000,
        text: 'กุดจิก',
        value: 'กุดจิก',
        name: {
          th: 'กุดจิก',
          en: 'Kut Chik',
        },
        districtId: 387,
      },
      {
        id: '390112',
        zipcode: 39000,
        text: 'โนนทัน',
        value: 'โนนทัน',
        name: {
          th: 'โนนทัน',
          en: 'Non Than',
        },
        districtId: 387,
      },
      {
        id: '390113',
        zipcode: 39000,
        text: 'นาคำไฮ',
        value: 'นาคำไฮ',
        name: {
          th: 'นาคำไฮ',
          en: 'Na Kham Hai',
        },
        districtId: 387,
      },
      {
        id: '390114',
        zipcode: 39000,
        text: 'ป่าไม้งาม',
        value: 'ป่าไม้งาม',
        name: {
          th: 'ป่าไม้งาม',
          en: 'Pa Mai Ngam',
        },
        districtId: 387,
      },
      {
        id: '390115',
        zipcode: 39000,
        text: 'หนองหว้า',
        value: 'หนองหว้า',
        name: {
          th: 'หนองหว้า',
          en: 'Nong Wa',
        },
        districtId: 387,
      },
      {
        id: '390201',
        zipcode: 39170,
        text: 'นากลาง',
        value: 'นากลาง',
        name: {
          th: 'นากลาง',
          en: 'Na Klang',
        },
        districtId: 388,
      },
      {
        id: '390202',
        zipcode: 39170,
        text: 'ด่านช้าง',
        value: 'ด่านช้าง',
        name: {
          th: 'ด่านช้าง',
          en: 'Dan Chang',
        },
        districtId: 388,
      },
      {
        id: '390205',
        zipcode: 39350,
        text: 'กุดดินจี่',
        value: 'กุดดินจี่',
        name: {
          th: 'กุดดินจี่',
          en: 'Kut Din Chi',
        },
        districtId: 388,
      },
      {
        id: '390206',
        zipcode: 39170,
        text: 'ฝั่งแดง',
        value: 'ฝั่งแดง',
        name: {
          th: 'ฝั่งแดง',
          en: 'Fang Daeng',
        },
        districtId: 388,
      },
      {
        id: '390207',
        zipcode: 39350,
        text: 'เก่ากลอย',
        value: 'เก่ากลอย',
        name: {
          th: 'เก่ากลอย',
          en: 'Kao Kloi',
        },
        districtId: 388,
      },
      {
        id: '390209',
        zipcode: 39170,
        text: 'โนนเมือง',
        value: 'โนนเมือง',
        name: {
          th: 'โนนเมือง',
          en: 'Non Mueang',
        },
        districtId: 388,
      },
      {
        id: '390210',
        zipcode: 39170,
        text: 'อุทัยสวรรค์',
        value: 'อุทัยสวรรค์',
        name: {
          th: 'อุทัยสวรรค์',
          en: 'Uthai Sawan',
        },
        districtId: 388,
      },
      {
        id: '390211',
        zipcode: 39350,
        text: 'ดงสวรรค์',
        value: 'ดงสวรรค์',
        name: {
          th: 'ดงสวรรค์',
          en: 'Dong Sawan',
        },
        districtId: 388,
      },
      {
        id: '390213',
        zipcode: 39170,
        text: 'กุดแห่',
        value: 'กุดแห่',
        name: {
          th: 'กุดแห่',
          en: 'Kut Hae',
        },
        districtId: 388,
      },
      {
        id: '390301',
        zipcode: 39140,
        text: 'โนนสัง',
        value: 'โนนสัง',
        name: {
          th: 'โนนสัง',
          en: 'Non Sang',
        },
        districtId: 389,
      },
      {
        id: '390302',
        zipcode: 39140,
        text: 'บ้านถิ่น',
        value: 'บ้านถิ่น',
        name: {
          th: 'บ้านถิ่น',
          en: 'Ban Thin',
        },
        districtId: 389,
      },
      {
        id: '390303',
        zipcode: 39140,
        text: 'หนองเรือ',
        value: 'หนองเรือ',
        name: {
          th: 'หนองเรือ',
          en: 'Nong Ruea',
        },
        districtId: 389,
      },
      {
        id: '390304',
        zipcode: 39140,
        text: 'กุดดู่',
        value: 'กุดดู่',
        name: {
          th: 'กุดดู่',
          en: 'Kut Du',
        },
        districtId: 389,
      },
      {
        id: '390305',
        zipcode: 39140,
        text: 'บ้านค้อ',
        value: 'บ้านค้อ',
        name: {
          th: 'บ้านค้อ',
          en: 'Ban Kho',
        },
        districtId: 389,
      },
      {
        id: '390306',
        zipcode: 39140,
        text: 'โนนเมือง',
        value: 'โนนเมือง',
        name: {
          th: 'โนนเมือง',
          en: 'Non Mueang',
        },
        districtId: 389,
      },
      {
        id: '390307',
        zipcode: 39140,
        text: 'โคกใหญ่',
        value: 'โคกใหญ่',
        name: {
          th: 'โคกใหญ่',
          en: 'Khok Yai',
        },
        districtId: 389,
      },
      {
        id: '390308',
        zipcode: 39140,
        text: 'โคกม่วง',
        value: 'โคกม่วง',
        name: {
          th: 'โคกม่วง',
          en: 'Khok Muang',
        },
        districtId: 389,
      },
      {
        id: '390309',
        zipcode: 39140,
        text: 'นิคมพัฒนา',
        value: 'นิคมพัฒนา',
        name: {
          th: 'นิคมพัฒนา',
          en: 'Nikhom Phatthana',
        },
        districtId: 389,
      },
      {
        id: '390310',
        zipcode: 39140,
        text: 'ปางกู่',
        value: 'ปางกู่',
        name: {
          th: 'ปางกู่',
          en: 'Pang Ku',
        },
        districtId: 389,
      },
      {
        id: '390401',
        zipcode: 39180,
        text: 'เมืองใหม่',
        value: 'เมืองใหม่',
        name: {
          th: 'เมืองใหม่',
          en: 'Mueang Mai',
        },
        districtId: 390,
      },
      {
        id: '390402',
        zipcode: 39180,
        text: 'ศรีบุญเรือง',
        value: 'ศรีบุญเรือง',
        name: {
          th: 'ศรีบุญเรือง',
          en: 'Si Bun Rueang',
        },
        districtId: 390,
      },
      {
        id: '390403',
        zipcode: 39180,
        text: 'หนองบัวใต้',
        value: 'หนองบัวใต้',
        name: {
          th: 'หนองบัวใต้',
          en: 'Nong Bua Tai',
        },
        districtId: 390,
      },
      {
        id: '390404',
        zipcode: 39180,
        text: 'กุดสะเทียน',
        value: 'กุดสะเทียน',
        name: {
          th: 'กุดสะเทียน',
          en: 'Kut Sathian',
        },
        districtId: 390,
      },
      {
        id: '390405',
        zipcode: 39180,
        text: 'นากอก',
        value: 'นากอก',
        name: {
          th: 'นากอก',
          en: 'Na Kok',
        },
        districtId: 390,
      },
      {
        id: '390406',
        zipcode: 39180,
        text: 'โนนสะอาด',
        value: 'โนนสะอาด',
        name: {
          th: 'โนนสะอาด',
          en: 'Non Sa-at',
        },
        districtId: 390,
      },
      {
        id: '390407',
        zipcode: 39180,
        text: 'ยางหล่อ',
        value: 'ยางหล่อ',
        name: {
          th: 'ยางหล่อ',
          en: 'Yang Lo',
        },
        districtId: 390,
      },
      {
        id: '390408',
        zipcode: 39180,
        text: 'โนนม่วง',
        value: 'โนนม่วง',
        name: {
          th: 'โนนม่วง',
          en: 'Non Muang',
        },
        districtId: 390,
      },
      {
        id: '390409',
        zipcode: 39180,
        text: 'หนองกุงแก้ว',
        value: 'หนองกุงแก้ว',
        name: {
          th: 'หนองกุงแก้ว',
          en: 'Nong Kung Kaeo',
        },
        districtId: 390,
      },
      {
        id: '390410',
        zipcode: 39180,
        text: 'หนองแก',
        value: 'หนองแก',
        name: {
          th: 'หนองแก',
          en: 'Nong Kae',
        },
        districtId: 390,
      },
      {
        id: '390411',
        zipcode: 39180,
        text: 'ทรายทอง',
        value: 'ทรายทอง',
        name: {
          th: 'ทรายทอง',
          en: 'Sai Thong',
        },
        districtId: 390,
      },
      {
        id: '390412',
        zipcode: 39180,
        text: 'หันนางาม',
        value: 'หันนางาม',
        name: {
          th: 'หันนางาม',
          en: 'Han Na Ngam',
        },
        districtId: 390,
      },
      {
        id: '390501',
        zipcode: 39270,
        text: 'นาสี',
        value: 'นาสี',
        name: {
          th: 'นาสี',
          en: 'Nasi',
        },
        districtId: 391,
      },
      {
        id: '390502',
        zipcode: 39270,
        text: 'บ้านโคก',
        value: 'บ้านโคก',
        name: {
          th: 'บ้านโคก',
          en: 'Ban Khok',
        },
        districtId: 391,
      },
      {
        id: '390503',
        zipcode: 39270,
        text: 'นาดี',
        value: 'นาดี',
        name: {
          th: 'นาดี',
          en: 'Na Di',
        },
        districtId: 391,
      },
      {
        id: '390504',
        zipcode: 39270,
        text: 'นาด่าน',
        value: 'นาด่าน',
        name: {
          th: 'นาด่าน',
          en: 'Na Dan',
        },
        districtId: 391,
      },
      {
        id: '390505',
        zipcode: 39270,
        text: 'ดงมะไฟ',
        value: 'ดงมะไฟ',
        name: {
          th: 'ดงมะไฟ',
          en: 'Dong Mafai',
        },
        districtId: 391,
      },
      {
        id: '390506',
        zipcode: 39270,
        text: 'สุวรรณคูหา',
        value: 'สุวรรณคูหา',
        name: {
          th: 'สุวรรณคูหา',
          en: 'Suwannakhuha',
        },
        districtId: 391,
      },
      {
        id: '390507',
        zipcode: 39270,
        text: 'บุญทัน',
        value: 'บุญทัน',
        name: {
          th: 'บุญทัน',
          en: 'Bun Than',
        },
        districtId: 391,
      },
      {
        id: '390508',
        zipcode: 39270,
        text: 'กุดผึ้ง',
        value: 'กุดผึ้ง',
        name: {
          th: 'กุดผึ้ง',
          en: 'Kut Phueng',
        },
        districtId: 391,
      },
      {
        id: '390601',
        zipcode: 39170,
        text: 'นาเหล่า',
        value: 'นาเหล่า',
        name: {
          th: 'นาเหล่า',
          en: 'Na Lao',
        },
        districtId: 392,
      },
      {
        id: '390602',
        zipcode: 39170,
        text: 'นาแก',
        value: 'นาแก',
        name: {
          th: 'นาแก',
          en: 'Na Kae',
        },
        districtId: 392,
      },
      {
        id: '390603',
        zipcode: 39170,
        text: 'วังทอง',
        value: 'วังทอง',
        name: {
          th: 'วังทอง',
          en: 'Wang Thong',
        },
        districtId: 392,
      },
      {
        id: '390604',
        zipcode: 39170,
        text: 'วังปลาป้อม',
        value: 'วังปลาป้อม',
        name: {
          th: 'วังปลาป้อม',
          en: 'Wang Pla Pom',
        },
        districtId: 392,
      },
      {
        id: '390605',
        zipcode: 39170,
        text: 'เทพคีรี',
        value: 'เทพคีรี',
        name: {
          th: 'เทพคีรี',
          en: 'Thep Khiri',
        },
        districtId: 392,
      },
      {
        id: '400101',
        zipcode: 40000,
        text: 'ในเมือง',
        value: 'ในเมือง',
        name: {
          th: 'ในเมือง',
          en: 'Nai Mueang',
        },
        districtId: 393,
      },
      {
        id: '400102',
        zipcode: 40000,
        text: 'สำราญ',
        value: 'สำราญ',
        name: {
          th: 'สำราญ',
          en: 'Samran',
        },
        districtId: 393,
      },
      {
        id: '400103',
        zipcode: 40000,
        text: 'โคกสี',
        value: 'โคกสี',
        name: {
          th: 'โคกสี',
          en: 'Khok Si',
        },
        districtId: 393,
      },
      {
        id: '400104',
        zipcode: 40260,
        text: 'ท่าพระ',
        value: 'ท่าพระ',
        name: {
          th: 'ท่าพระ',
          en: 'Tha Phra',
        },
        districtId: 393,
      },
      {
        id: '400105',
        zipcode: 40000,
        text: 'บ้านทุ่ม',
        value: 'บ้านทุ่ม',
        name: {
          th: 'บ้านทุ่ม',
          en: 'Ban Thum',
        },
        districtId: 393,
      },
      {
        id: '400106',
        zipcode: 40000,
        text: 'เมืองเก่า',
        value: 'เมืองเก่า',
        name: {
          th: 'เมืองเก่า',
          en: 'Mueang Kao',
        },
        districtId: 393,
      },
      {
        id: '400107',
        zipcode: 40000,
        text: 'พระลับ',
        value: 'พระลับ',
        name: {
          th: 'พระลับ',
          en: 'Phra Lap',
        },
        districtId: 393,
      },
      {
        id: '400108',
        zipcode: 40000,
        text: 'สาวะถี',
        value: 'สาวะถี',
        name: {
          th: 'สาวะถี',
          en: 'Sawathi',
        },
        districtId: 393,
      },
      {
        id: '400109',
        zipcode: 40000,
        text: 'บ้านหว้า',
        value: 'บ้านหว้า',
        name: {
          th: 'บ้านหว้า',
          en: 'Ban Wa',
        },
        districtId: 393,
      },
      {
        id: '400110',
        zipcode: 40000,
        text: 'บ้านค้อ',
        value: 'บ้านค้อ',
        name: {
          th: 'บ้านค้อ',
          en: 'Ban Kho',
        },
        districtId: 393,
      },
      {
        id: '400111',
        zipcode: 40000,
        text: 'แดงใหญ่',
        value: 'แดงใหญ่',
        name: {
          th: 'แดงใหญ่',
          en: 'Daeng Yai',
        },
        districtId: 393,
      },
      {
        id: '400112',
        zipcode: 40000,
        text: 'ดอนช้าง',
        value: 'ดอนช้าง',
        name: {
          th: 'ดอนช้าง',
          en: 'Don Chang',
        },
        districtId: 393,
      },
      {
        id: '400113',
        zipcode: 40260,
        text: 'ดอนหัน',
        value: 'ดอนหัน',
        name: {
          th: 'ดอนหัน',
          en: 'Don Han',
        },
        districtId: 393,
      },
      {
        id: '400114',
        zipcode: 40000,
        text: 'ศิลา',
        value: 'ศิลา',
        name: {
          th: 'ศิลา',
          en: 'Sila',
        },
        districtId: 393,
      },
      {
        id: '400115',
        zipcode: 40000,
        text: 'บ้านเป็ด',
        value: 'บ้านเป็ด',
        name: {
          th: 'บ้านเป็ด',
          en: 'Ban Pet',
        },
        districtId: 393,
      },
      {
        id: '400116',
        zipcode: 40000,
        text: 'หนองตูม',
        value: 'หนองตูม',
        name: {
          th: 'หนองตูม',
          en: 'Nong Tum',
        },
        districtId: 393,
      },
      {
        id: '400117',
        zipcode: 40000,
        text: 'บึงเนียม',
        value: 'บึงเนียม',
        name: {
          th: 'บึงเนียม',
          en: 'Bueng Niam',
        },
        districtId: 393,
      },
      {
        id: '400118',
        zipcode: 40000,
        text: 'โนนท่อน',
        value: 'โนนท่อน',
        name: {
          th: 'โนนท่อน',
          en: 'Non Thon',
        },
        districtId: 393,
      },
      {
        id: '400201',
        zipcode: 40270,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 394,
      },
      {
        id: '400202',
        zipcode: 40270,
        text: 'ป่าหวายนั่ง',
        value: 'ป่าหวายนั่ง',
        name: {
          th: 'ป่าหวายนั่ง',
          en: 'Pa Wai Nang',
        },
        districtId: 394,
      },
      {
        id: '400203',
        zipcode: 40270,
        text: 'โนนฆ้อง',
        value: 'โนนฆ้อง',
        name: {
          th: 'โนนฆ้อง',
          en: 'Non Khong',
        },
        districtId: 394,
      },
      {
        id: '400204',
        zipcode: 40270,
        text: 'บ้านเหล่า',
        value: 'บ้านเหล่า',
        name: {
          th: 'บ้านเหล่า',
          en: 'Ban Lao',
        },
        districtId: 394,
      },
      {
        id: '400205',
        zipcode: 40270,
        text: 'ป่ามะนาว',
        value: 'ป่ามะนาว',
        name: {
          th: 'ป่ามะนาว',
          en: 'Pa Manao',
        },
        districtId: 394,
      },
      {
        id: '400206',
        zipcode: 40270,
        text: 'บ้านฝาง',
        value: 'บ้านฝาง',
        name: {
          th: 'บ้านฝาง',
          en: 'Ban Fang',
        },
        districtId: 394,
      },
      {
        id: '400207',
        zipcode: 40270,
        text: 'โคกงาม',
        value: 'โคกงาม',
        name: {
          th: 'โคกงาม',
          en: 'Khok Ngam',
        },
        districtId: 394,
      },
      {
        id: '400301',
        zipcode: 40320,
        text: 'พระยืน',
        value: 'พระยืน',
        name: {
          th: 'พระยืน',
          en: 'Phra Yuen',
        },
        districtId: 395,
      },
      {
        id: '400302',
        zipcode: 40320,
        text: 'พระบุ',
        value: 'พระบุ',
        name: {
          th: 'พระบุ',
          en: 'Phra Bu',
        },
        districtId: 395,
      },
      {
        id: '400303',
        zipcode: 40320,
        text: 'บ้านโต้น',
        value: 'บ้านโต้น',
        name: {
          th: 'บ้านโต้น',
          en: 'Ban Ton',
        },
        districtId: 395,
      },
      {
        id: '400304',
        zipcode: 40320,
        text: 'หนองแวง',
        value: 'หนองแวง',
        name: {
          th: 'หนองแวง',
          en: 'Nong Waeng',
        },
        districtId: 395,
      },
      {
        id: '400305',
        zipcode: 40320,
        text: 'ขามป้อม',
        value: 'ขามป้อม',
        name: {
          th: 'ขามป้อม',
          en: 'Kham Pom',
        },
        districtId: 395,
      },
      {
        id: '400401',
        zipcode: 40210,
        text: 'หนองเรือ',
        value: 'หนองเรือ',
        name: {
          th: 'หนองเรือ',
          en: 'Nong Ruea',
        },
        districtId: 396,
      },
      {
        id: '400402',
        zipcode: 40210,
        text: 'บ้านเม็ง',
        value: 'บ้านเม็ง',
        name: {
          th: 'บ้านเม็ง',
          en: 'Ban Meng',
        },
        districtId: 396,
      },
      {
        id: '400403',
        zipcode: 40240,
        text: 'บ้านกง',
        value: 'บ้านกง',
        name: {
          th: 'บ้านกง',
          en: 'Ban Kong',
        },
        districtId: 396,
      },
      {
        id: '400404',
        zipcode: 40240,
        text: 'ยางคำ',
        value: 'ยางคำ',
        name: {
          th: 'ยางคำ',
          en: 'Yang Kham',
        },
        districtId: 396,
      },
      {
        id: '400405',
        zipcode: 40240,
        text: 'จระเข้',
        value: 'จระเข้',
        name: {
          th: 'จระเข้',
          en: 'Chorakhe',
        },
        districtId: 396,
      },
      {
        id: '400406',
        zipcode: 40210,
        text: 'โนนทอง',
        value: 'โนนทอง',
        name: {
          th: 'โนนทอง',
          en: 'Non Thong',
        },
        districtId: 396,
      },
      {
        id: '400407',
        zipcode: 40210,
        text: 'กุดกว้าง',
        value: 'กุดกว้าง',
        name: {
          th: 'กุดกว้าง',
          en: 'Kut Kwang',
        },
        districtId: 396,
      },
      {
        id: '400408',
        zipcode: 40210,
        text: 'โนนทัน',
        value: 'โนนทัน',
        name: {
          th: 'โนนทัน',
          en: 'Non Than',
        },
        districtId: 396,
      },
      {
        id: '400409',
        zipcode: 40210,
        text: 'โนนสะอาด',
        value: 'โนนสะอาด',
        name: {
          th: 'โนนสะอาด',
          en: 'Non Sa-at',
        },
        districtId: 396,
      },
      {
        id: '400410',
        zipcode: 40240,
        text: 'บ้านผือ',
        value: 'บ้านผือ',
        name: {
          th: 'บ้านผือ',
          en: 'Ban Phue',
        },
        districtId: 396,
      },
      {
        id: '400501',
        zipcode: 40130,
        text: 'ชุมแพ',
        value: 'ชุมแพ',
        name: {
          th: 'ชุมแพ',
          en: 'Chum Phae',
        },
        districtId: 397,
      },
      {
        id: '400502',
        zipcode: 40290,
        text: 'โนนหัน',
        value: 'โนนหัน',
        name: {
          th: 'โนนหัน',
          en: 'Non Han',
        },
        districtId: 397,
      },
      {
        id: '400503',
        zipcode: 40290,
        text: 'นาหนองทุ่ม',
        value: 'นาหนองทุ่ม',
        name: {
          th: 'นาหนองทุ่ม',
          en: 'Na Nong Thum',
        },
        districtId: 397,
      },
      {
        id: '400504',
        zipcode: 40130,
        text: 'โนนอุดม',
        value: 'โนนอุดม',
        name: {
          th: 'โนนอุดม',
          en: 'Non Udom',
        },
        districtId: 397,
      },
      {
        id: '400505',
        zipcode: 40130,
        text: 'ขัวเรียง',
        value: 'ขัวเรียง',
        name: {
          th: 'ขัวเรียง',
          en: 'Khua Riang',
        },
        districtId: 397,
      },
      {
        id: '400506',
        zipcode: 40130,
        text: 'หนองไผ่',
        value: 'หนองไผ่',
        name: {
          th: 'หนองไผ่',
          en: 'Nong Phai',
        },
        districtId: 397,
      },
      {
        id: '400507',
        zipcode: 40130,
        text: 'ไชยสอ',
        value: 'ไชยสอ',
        name: {
          th: 'ไชยสอ',
          en: 'Chai So',
        },
        districtId: 397,
      },
      {
        id: '400508',
        zipcode: 40130,
        text: 'วังหินลาด',
        value: 'วังหินลาด',
        name: {
          th: 'วังหินลาด',
          en: 'Wang Hin Lat',
        },
        districtId: 397,
      },
      {
        id: '400509',
        zipcode: 40130,
        text: 'นาเพียง',
        value: 'นาเพียง',
        name: {
          th: 'นาเพียง',
          en: 'Na Phiang',
        },
        districtId: 397,
      },
      {
        id: '400510',
        zipcode: 40290,
        text: 'หนองเขียด',
        value: 'หนองเขียด',
        name: {
          th: 'หนองเขียด',
          en: 'Nong Khiat',
        },
        districtId: 397,
      },
      {
        id: '400511',
        zipcode: 40130,
        text: 'หนองเสาเล้า',
        value: 'หนองเสาเล้า',
        name: {
          th: 'หนองเสาเล้า',
          en: 'Nong Sao Lao',
        },
        districtId: 397,
      },
      {
        id: '400512',
        zipcode: 40290,
        text: 'โนนสะอาด',
        value: 'โนนสะอาด',
        name: {
          th: 'โนนสะอาด',
          en: 'Non Sa-at',
        },
        districtId: 397,
      },
      {
        id: '400601',
        zipcode: 40220,
        text: 'สีชมพู',
        value: 'สีชมพู',
        name: {
          th: 'สีชมพู',
          en: 'Si Chomphu',
        },
        districtId: 398,
      },
      {
        id: '400602',
        zipcode: 40220,
        text: 'ศรีสุข',
        value: 'ศรีสุข',
        name: {
          th: 'ศรีสุข',
          en: 'Si Suk',
        },
        districtId: 398,
      },
      {
        id: '400603',
        zipcode: 40220,
        text: 'นาจาน',
        value: 'นาจาน',
        name: {
          th: 'นาจาน',
          en: 'Na Chan',
        },
        districtId: 398,
      },
      {
        id: '400604',
        zipcode: 40220,
        text: 'วังเพิ่ม',
        value: 'วังเพิ่ม',
        name: {
          th: 'วังเพิ่ม',
          en: 'Wang Phoem',
        },
        districtId: 398,
      },
      {
        id: '400605',
        zipcode: 40220,
        text: 'ซำยาง',
        value: 'ซำยาง',
        name: {
          th: 'ซำยาง',
          en: 'Sam Yang',
        },
        districtId: 398,
      },
      {
        id: '400606',
        zipcode: 40220,
        text: 'หนองแดง',
        value: 'หนองแดง',
        name: {
          th: 'หนองแดง',
          en: 'Nong Daeng',
        },
        districtId: 398,
      },
      {
        id: '400607',
        zipcode: 40220,
        text: 'ดงลาน',
        value: 'ดงลาน',
        name: {
          th: 'ดงลาน',
          en: 'Dong Lan',
        },
        districtId: 398,
      },
      {
        id: '400608',
        zipcode: 40220,
        text: 'บริบูรณ์',
        value: 'บริบูรณ์',
        name: {
          th: 'บริบูรณ์',
          en: 'Boribun',
        },
        districtId: 398,
      },
      {
        id: '400609',
        zipcode: 40220,
        text: 'บ้านใหม่',
        value: 'บ้านใหม่',
        name: {
          th: 'บ้านใหม่',
          en: 'Ban Mai',
        },
        districtId: 398,
      },
      {
        id: '400610',
        zipcode: 40220,
        text: 'ภูห่าน',
        value: 'ภูห่าน',
        name: {
          th: 'ภูห่าน',
          en: 'Phu Han',
        },
        districtId: 398,
      },
      {
        id: '400701',
        zipcode: 40140,
        text: 'น้ำพอง',
        value: 'น้ำพอง',
        name: {
          th: 'น้ำพอง',
          en: 'Nam Phong',
        },
        districtId: 399,
      },
      {
        id: '400702',
        zipcode: 40140,
        text: 'วังชัย',
        value: 'วังชัย',
        name: {
          th: 'วังชัย',
          en: 'Wang Chai',
        },
        districtId: 399,
      },
      {
        id: '400703',
        zipcode: 40140,
        text: 'หนองกุง',
        value: 'หนองกุง',
        name: {
          th: 'หนองกุง',
          en: 'Nong Kung',
        },
        districtId: 399,
      },
      {
        id: '400704',
        zipcode: 40140,
        text: 'บัวใหญ่',
        value: 'บัวใหญ่',
        name: {
          th: 'บัวใหญ่',
          en: 'Bua Yai',
        },
        districtId: 399,
      },
      {
        id: '400705',
        zipcode: 40310,
        text: 'สะอาด',
        value: 'สะอาด',
        name: {
          th: 'สะอาด',
          en: 'Sa-at',
        },
        districtId: 399,
      },
      {
        id: '400706',
        zipcode: 40310,
        text: 'ม่วงหวาน',
        value: 'ม่วงหวาน',
        name: {
          th: 'ม่วงหวาน',
          en: 'Muang Wan',
        },
        districtId: 399,
      },
      {
        id: '400707',
        zipcode: 40140,
        text: 'บ้านขาม',
        value: 'บ้านขาม',
        name: {
          th: 'บ้านขาม',
          en: 'Ban Kham',
        },
        districtId: 399,
      },
      {
        id: '400708',
        zipcode: 40140,
        text: 'บัวเงิน',
        value: 'บัวเงิน',
        name: {
          th: 'บัวเงิน',
          en: 'Bua Ngoen',
        },
        districtId: 399,
      },
      {
        id: '400709',
        zipcode: 40140,
        text: 'ทรายมูล',
        value: 'ทรายมูล',
        name: {
          th: 'ทรายมูล',
          en: 'Sai Mun',
        },
        districtId: 399,
      },
      {
        id: '400710',
        zipcode: 40140,
        text: 'ท่ากระเสริม',
        value: 'ท่ากระเสริม',
        name: {
          th: 'ท่ากระเสริม',
          en: 'Tha Krasoem',
        },
        districtId: 399,
      },
      {
        id: '400711',
        zipcode: 40140,
        text: 'พังทุย',
        value: 'พังทุย',
        name: {
          th: 'พังทุย',
          en: 'Phang Thui',
        },
        districtId: 399,
      },
      {
        id: '400712',
        zipcode: 40140,
        text: 'กุดน้ำใส',
        value: 'กุดน้ำใส',
        name: {
          th: 'กุดน้ำใส',
          en: 'Kut Nam Sai',
        },
        districtId: 399,
      },
      {
        id: '400801',
        zipcode: 40250,
        text: 'โคกสูง',
        value: 'โคกสูง',
        name: {
          th: 'โคกสูง',
          en: 'Khok Sung',
        },
        districtId: 400,
      },
      {
        id: '400802',
        zipcode: 40250,
        text: 'บ้านดง',
        value: 'บ้านดง',
        name: {
          th: 'บ้านดง',
          en: 'Ban Dong',
        },
        districtId: 400,
      },
      {
        id: '400803',
        zipcode: 40250,
        text: 'เขื่อนอุบลรัตน์',
        value: 'เขื่อนอุบลรัตน์',
        name: {
          th: 'เขื่อนอุบลรัตน์',
          en: 'Khuean Ubolratana',
        },
        districtId: 400,
      },
      {
        id: '400804',
        zipcode: 40250,
        text: 'นาคำ',
        value: 'นาคำ',
        name: {
          th: 'นาคำ',
          en: 'Na Kham',
        },
        districtId: 400,
      },
      {
        id: '400805',
        zipcode: 40250,
        text: 'ศรีสุขสำราญ',
        value: 'ศรีสุขสำราญ',
        name: {
          th: 'ศรีสุขสำราญ',
          en: 'Si Suk Samran',
        },
        districtId: 400,
      },
      {
        id: '400806',
        zipcode: 40250,
        text: 'ทุ่งโป่ง',
        value: 'ทุ่งโป่ง',
        name: {
          th: 'ทุ่งโป่ง',
          en: 'Thung Pong',
        },
        districtId: 400,
      },
      {
        id: '400901',
        zipcode: 40170,
        text: 'หนองโก',
        value: 'หนองโก',
        name: {
          th: 'หนองโก',
          en: 'Nong Ko',
        },
        districtId: 401,
      },
      {
        id: '400902',
        zipcode: 40170,
        text: 'หนองกุงใหญ่',
        value: 'หนองกุงใหญ่',
        name: {
          th: 'หนองกุงใหญ่',
          en: 'Nong Kung Yai',
        },
        districtId: 401,
      },
      {
        id: '400905',
        zipcode: 40170,
        text: 'ห้วยโจด',
        value: 'ห้วยโจด',
        name: {
          th: 'ห้วยโจด',
          en: 'Huai Chot',
        },
        districtId: 401,
      },
      {
        id: '400906',
        zipcode: 40170,
        text: 'ห้วยยาง',
        value: 'ห้วยยาง',
        name: {
          th: 'ห้วยยาง',
          en: 'Huai Yang',
        },
        districtId: 401,
      },
      {
        id: '400907',
        zipcode: 40170,
        text: 'บ้านฝาง',
        value: 'บ้านฝาง',
        name: {
          th: 'บ้านฝาง',
          en: 'Ban Fang',
        },
        districtId: 401,
      },
      {
        id: '400909',
        zipcode: 40170,
        text: 'ดูนสาด',
        value: 'ดูนสาด',
        name: {
          th: 'ดูนสาด',
          en: 'Dun Sat',
        },
        districtId: 401,
      },
      {
        id: '400910',
        zipcode: 40170,
        text: 'หนองโน',
        value: 'หนองโน',
        name: {
          th: 'หนองโน',
          en: 'Nong No',
        },
        districtId: 401,
      },
      {
        id: '400911',
        zipcode: 40170,
        text: 'น้ำอ้อม',
        value: 'น้ำอ้อม',
        name: {
          th: 'น้ำอ้อม',
          en: 'Nam Om',
        },
        districtId: 401,
      },
      {
        id: '400912',
        zipcode: 40170,
        text: 'หัวนาคำ',
        value: 'หัวนาคำ',
        name: {
          th: 'หัวนาคำ',
          en: 'Hua Na Kham',
        },
        districtId: 401,
      },
      {
        id: '401001',
        zipcode: 40110,
        text: 'บ้านไผ่',
        value: 'บ้านไผ่',
        name: {
          th: 'บ้านไผ่',
          en: 'Ban Phai',
        },
        districtId: 402,
      },
      {
        id: '401002',
        zipcode: 40110,
        text: 'ในเมือง',
        value: 'ในเมือง',
        name: {
          th: 'ในเมือง',
          en: 'Nai Mueang',
        },
        districtId: 402,
      },
      {
        id: '401005',
        zipcode: 40110,
        text: 'เมืองเพีย',
        value: 'เมืองเพีย',
        name: {
          th: 'เมืองเพีย',
          en: 'Mueang Phia',
        },
        districtId: 402,
      },
      {
        id: '401009',
        zipcode: 40110,
        text: 'บ้านลาน',
        value: 'บ้านลาน',
        name: {
          th: 'บ้านลาน',
          en: 'Ban Lan',
        },
        districtId: 402,
      },
      {
        id: '401010',
        zipcode: 40110,
        text: 'แคนเหนือ',
        value: 'แคนเหนือ',
        name: {
          th: 'แคนเหนือ',
          en: 'Khaen Nuea',
        },
        districtId: 402,
      },
      {
        id: '401011',
        zipcode: 40110,
        text: 'ภูเหล็ก',
        value: 'ภูเหล็ก',
        name: {
          th: 'ภูเหล็ก',
          en: 'Phu Lek',
        },
        districtId: 402,
      },
      {
        id: '401013',
        zipcode: 40110,
        text: 'ป่าปอ',
        value: 'ป่าปอ',
        name: {
          th: 'ป่าปอ',
          en: 'Pa Po',
        },
        districtId: 402,
      },
      {
        id: '401014',
        zipcode: 40110,
        text: 'หินตั้ง',
        value: 'หินตั้ง',
        name: {
          th: 'หินตั้ง',
          en: 'Hin Tang',
        },
        districtId: 402,
      },
      {
        id: '401016',
        zipcode: 40110,
        text: 'หนองน้ำใส',
        value: 'หนองน้ำใส',
        name: {
          th: 'หนองน้ำใส',
          en: 'Nong Nam Sai',
        },
        districtId: 402,
      },
      {
        id: '401017',
        zipcode: 40110,
        text: 'หัวหนอง',
        value: 'หัวหนอง',
        name: {
          th: 'หัวหนอง',
          en: 'Hua Nong',
        },
        districtId: 402,
      },
      {
        id: '401101',
        zipcode: 40340,
        text: 'เปือยน้อย',
        value: 'เปือยน้อย',
        name: {
          th: 'เปือยน้อย',
          en: 'Pueai Noi',
        },
        districtId: 403,
      },
      {
        id: '401102',
        zipcode: 40340,
        text: 'วังม่วง',
        value: 'วังม่วง',
        name: {
          th: 'วังม่วง',
          en: 'Wang Muang',
        },
        districtId: 403,
      },
      {
        id: '401103',
        zipcode: 40340,
        text: 'ขามป้อม',
        value: 'ขามป้อม',
        name: {
          th: 'ขามป้อม',
          en: 'Kham Pom',
        },
        districtId: 403,
      },
      {
        id: '401104',
        zipcode: 40340,
        text: 'สระแก้ว',
        value: 'สระแก้ว',
        name: {
          th: 'สระแก้ว',
          en: 'Sa Kaeo',
        },
        districtId: 403,
      },
      {
        id: '401201',
        zipcode: 40120,
        text: 'เมืองพล',
        value: 'เมืองพล',
        name: {
          th: 'เมืองพล',
          en: 'Mueang Phon',
        },
        districtId: 404,
      },
      {
        id: '401203',
        zipcode: 40120,
        text: 'โจดหนองแก',
        value: 'โจดหนองแก',
        name: {
          th: 'โจดหนองแก',
          en: 'Chot Nong Kae',
        },
        districtId: 404,
      },
      {
        id: '401204',
        zipcode: 40120,
        text: 'เก่างิ้ว',
        value: 'เก่างิ้ว',
        name: {
          th: 'เก่างิ้ว',
          en: 'Kao Ngio',
        },
        districtId: 404,
      },
      {
        id: '401205',
        zipcode: 40120,
        text: 'หนองมะเขือ',
        value: 'หนองมะเขือ',
        name: {
          th: 'หนองมะเขือ',
          en: 'Nong Makhuea',
        },
        districtId: 404,
      },
      {
        id: '401206',
        zipcode: 40120,
        text: 'หนองแวงโสกพระ',
        value: 'หนองแวงโสกพระ',
        name: {
          th: 'หนองแวงโสกพระ',
          en: 'Nong Waeng Sok Phra',
        },
        districtId: 404,
      },
      {
        id: '401207',
        zipcode: 40120,
        text: 'เพ็กใหญ่',
        value: 'เพ็กใหญ่',
        name: {
          th: 'เพ็กใหญ่',
          en: 'Phek Yai',
        },
        districtId: 404,
      },
      {
        id: '401208',
        zipcode: 40120,
        text: 'โคกสง่า',
        value: 'โคกสง่า',
        name: {
          th: 'โคกสง่า',
          en: 'Khok Sa-nga',
        },
        districtId: 404,
      },
      {
        id: '401209',
        zipcode: 40120,
        text: 'หนองแวงนางเบ้า',
        value: 'หนองแวงนางเบ้า',
        name: {
          th: 'หนองแวงนางเบ้า',
          en: 'Nong Waeng Nang Bao',
        },
        districtId: 404,
      },
      {
        id: '401210',
        zipcode: 40120,
        text: 'ลอมคอม',
        value: 'ลอมคอม',
        name: {
          th: 'ลอมคอม',
          en: 'Lom Khom',
        },
        districtId: 404,
      },
      {
        id: '401211',
        zipcode: 40120,
        text: 'โนนข่า',
        value: 'โนนข่า',
        name: {
          th: 'โนนข่า',
          en: 'Non Kha',
        },
        districtId: 404,
      },
      {
        id: '401212',
        zipcode: 40120,
        text: 'โสกนกเต็น',
        value: 'โสกนกเต็น',
        name: {
          th: 'โสกนกเต็น',
          en: 'Sok Nok Ten',
        },
        districtId: 404,
      },
      {
        id: '401213',
        zipcode: 40120,
        text: 'หัวทุ่ง',
        value: 'หัวทุ่ง',
        name: {
          th: 'หัวทุ่ง',
          en: 'Hua Thung',
        },
        districtId: 404,
      },
      {
        id: '401301',
        zipcode: 40330,
        text: 'คอนฉิม',
        value: 'คอนฉิม',
        name: {
          th: 'คอนฉิม',
          en: 'Khon Chim',
        },
        districtId: 405,
      },
      {
        id: '401302',
        zipcode: 40330,
        text: 'ใหม่นาเพียง',
        value: 'ใหม่นาเพียง',
        name: {
          th: 'ใหม่นาเพียง',
          en: 'Mai Na Phiang',
        },
        districtId: 405,
      },
      {
        id: '401303',
        zipcode: 40330,
        text: 'โนนทอง',
        value: 'โนนทอง',
        name: {
          th: 'โนนทอง',
          en: 'Non Thong',
        },
        districtId: 405,
      },
      {
        id: '401304',
        zipcode: 40330,
        text: 'แวงใหญ่',
        value: 'แวงใหญ่',
        name: {
          th: 'แวงใหญ่',
          en: 'Waeng Yai',
        },
        districtId: 405,
      },
      {
        id: '401305',
        zipcode: 40330,
        text: 'โนนสะอาด',
        value: 'โนนสะอาด',
        name: {
          th: 'โนนสะอาด',
          en: 'Non Sa-at',
        },
        districtId: 405,
      },
      {
        id: '401401',
        zipcode: 40230,
        text: 'แวงน้อย',
        value: 'แวงน้อย',
        name: {
          th: 'แวงน้อย',
          en: 'Waeng Noi',
        },
        districtId: 406,
      },
      {
        id: '401402',
        zipcode: 40230,
        text: 'ก้านเหลือง',
        value: 'ก้านเหลือง',
        name: {
          th: 'ก้านเหลือง',
          en: 'Kan Lueang',
        },
        districtId: 406,
      },
      {
        id: '401403',
        zipcode: 40230,
        text: 'ท่านางแนว',
        value: 'ท่านางแนว',
        name: {
          th: 'ท่านางแนว',
          en: 'Tha Nang Naeo',
        },
        districtId: 406,
      },
      {
        id: '401404',
        zipcode: 40230,
        text: 'ละหานนา',
        value: 'ละหานนา',
        name: {
          th: 'ละหานนา',
          en: 'Lahan Na',
        },
        districtId: 406,
      },
      {
        id: '401405',
        zipcode: 40230,
        text: 'ท่าวัด',
        value: 'ท่าวัด',
        name: {
          th: 'ท่าวัด',
          en: 'Tha Wat',
        },
        districtId: 406,
      },
      {
        id: '401406',
        zipcode: 40230,
        text: 'ทางขวาง',
        value: 'ทางขวาง',
        name: {
          th: 'ทางขวาง',
          en: 'Thang Khwang',
        },
        districtId: 406,
      },
      {
        id: '401501',
        zipcode: 40190,
        text: 'หนองสองห้อง',
        value: 'หนองสองห้อง',
        name: {
          th: 'หนองสองห้อง',
          en: 'Nong Song Hong',
        },
        districtId: 407,
      },
      {
        id: '401502',
        zipcode: 40190,
        text: 'คึมชาด',
        value: 'คึมชาด',
        name: {
          th: 'คึมชาด',
          en: 'Khuemchat',
        },
        districtId: 407,
      },
      {
        id: '401503',
        zipcode: 40190,
        text: 'โนนธาตุ',
        value: 'โนนธาตุ',
        name: {
          th: 'โนนธาตุ',
          en: 'Non That',
        },
        districtId: 407,
      },
      {
        id: '401504',
        zipcode: 40190,
        text: 'ตะกั่วป่า',
        value: 'ตะกั่วป่า',
        name: {
          th: 'ตะกั่วป่า',
          en: 'Takua Pa',
        },
        districtId: 407,
      },
      {
        id: '401505',
        zipcode: 40190,
        text: 'สำโรง',
        value: 'สำโรง',
        name: {
          th: 'สำโรง',
          en: 'Samrong',
        },
        districtId: 407,
      },
      {
        id: '401506',
        zipcode: 40190,
        text: 'หนองเม็ก',
        value: 'หนองเม็ก',
        name: {
          th: 'หนองเม็ก',
          en: 'Nong Mek',
        },
        districtId: 407,
      },
      {
        id: '401507',
        zipcode: 40190,
        text: 'ดอนดู่',
        value: 'ดอนดู่',
        name: {
          th: 'ดอนดู่',
          en: 'Don Du',
        },
        districtId: 407,
      },
      {
        id: '401508',
        zipcode: 40190,
        text: 'ดงเค็ง',
        value: 'ดงเค็ง',
        name: {
          th: 'ดงเค็ง',
          en: 'Dong Kheng',
        },
        districtId: 407,
      },
      {
        id: '401509',
        zipcode: 40190,
        text: 'หันโจด',
        value: 'หันโจด',
        name: {
          th: 'หันโจด',
          en: 'Han Chot',
        },
        districtId: 407,
      },
      {
        id: '401510',
        zipcode: 40190,
        text: 'ดอนดั่ง',
        value: 'ดอนดั่ง',
        name: {
          th: 'ดอนดั่ง',
          en: 'Don Dang',
        },
        districtId: 407,
      },
      {
        id: '401511',
        zipcode: 40190,
        text: 'วังหิน',
        value: 'วังหิน',
        name: {
          th: 'วังหิน',
          en: 'Wang Hin',
        },
        districtId: 407,
      },
      {
        id: '401512',
        zipcode: 40190,
        text: 'หนองไผ่ล้อม',
        value: 'หนองไผ่ล้อม',
        name: {
          th: 'หนองไผ่ล้อม',
          en: 'Nong Phai Lom',
        },
        districtId: 407,
      },
      {
        id: '401601',
        zipcode: 40150,
        text: 'บ้านเรือ',
        value: 'บ้านเรือ',
        name: {
          th: 'บ้านเรือ',
          en: 'Ban Ruea',
        },
        districtId: 408,
      },
      {
        id: '401602',
        zipcode: 40150,
        text: 'ในเมือง*',
        value: 'ในเมือง*',
        name: {
          th: 'ในเมือง*',
          en: 'Na Mmuang*',
        },
        districtId: 408,
      },
      {
        id: '401604',
        zipcode: 40150,
        text: 'หว้าทอง',
        value: 'หว้าทอง',
        name: {
          th: 'หว้าทอง',
          en: 'Wa Thong',
        },
        districtId: 408,
      },
      {
        id: '401605',
        zipcode: 40150,
        text: 'กุดขอนแก่น',
        value: 'กุดขอนแก่น',
        name: {
          th: 'กุดขอนแก่น',
          en: 'Kut Khon Kaen',
        },
        districtId: 408,
      },
      {
        id: '401606',
        zipcode: 40150,
        text: 'นาชุมแสง',
        value: 'นาชุมแสง',
        name: {
          th: 'นาชุมแสง',
          en: 'Na Chum Saeng',
        },
        districtId: 408,
      },
      {
        id: '401607',
        zipcode: 40150,
        text: 'นาหว้า',
        value: 'นาหว้า',
        name: {
          th: 'นาหว้า',
          en: 'Na Wa',
        },
        districtId: 408,
      },
      {
        id: '401608',
        zipcode: 40150,
        text: 'เขาน้อย*',
        value: 'เขาน้อย*',
        name: {
          th: 'เขาน้อย*',
          en: 'Khao Noi*',
        },
        districtId: 408,
      },
      {
        id: '401610',
        zipcode: 40150,
        text: 'หนองกุงธนสาร',
        value: 'หนองกุงธนสาร',
        name: {
          th: 'หนองกุงธนสาร',
          en: 'Nong Kung Thanasan',
        },
        districtId: 408,
      },
      {
        id: '401612',
        zipcode: 40150,
        text: 'หนองกุงเซิน',
        value: 'หนองกุงเซิน',
        name: {
          th: 'หนองกุงเซิน',
          en: 'Nong Kung Soen',
        },
        districtId: 408,
      },
      {
        id: '401613',
        zipcode: 40150,
        text: 'สงเปือย',
        value: 'สงเปือย',
        name: {
          th: 'สงเปือย',
          en: 'Song Pueai',
        },
        districtId: 408,
      },
      {
        id: '401614',
        zipcode: 40150,
        text: 'ทุ่งชมพู',
        value: 'ทุ่งชมพู',
        name: {
          th: 'ทุ่งชมพู',
          en: 'Thung Chomphu',
        },
        districtId: 408,
      },
      {
        id: '401615',
        zipcode: 40150,
        text: 'เมืองเก่าพัฒนา*',
        value: 'เมืองเก่าพัฒนา*',
        name: {
          th: 'เมืองเก่าพัฒนา*',
          en: 'Mueang Kao Pattana*',
        },
        districtId: 408,
      },
      {
        id: '401616',
        zipcode: 40150,
        text: 'ดินดำ',
        value: 'ดินดำ',
        name: {
          th: 'ดินดำ',
          en: 'Din Dam',
        },
        districtId: 408,
      },
      {
        id: '401617',
        zipcode: 40150,
        text: 'ภูเวียง',
        value: 'ภูเวียง',
        name: {
          th: 'ภูเวียง',
          en: 'Phu Wiang',
        },
        districtId: 408,
      },
      {
        id: '401701',
        zipcode: 40160,
        text: 'กุดเค้า',
        value: 'กุดเค้า',
        name: {
          th: 'กุดเค้า',
          en: 'Kut Khao',
        },
        districtId: 409,
      },
      {
        id: '401702',
        zipcode: 40160,
        text: 'สวนหม่อน',
        value: 'สวนหม่อน',
        name: {
          th: 'สวนหม่อน',
          en: 'Suan Mon',
        },
        districtId: 409,
      },
      {
        id: '401703',
        zipcode: 40160,
        text: 'หนองแปน',
        value: 'หนองแปน',
        name: {
          th: 'หนองแปน',
          en: 'Nong Paen',
        },
        districtId: 409,
      },
      {
        id: '401704',
        zipcode: 40160,
        text: 'โพนเพ็ก',
        value: 'โพนเพ็ก',
        name: {
          th: 'โพนเพ็ก',
          en: 'Phon Phek',
        },
        districtId: 409,
      },
      {
        id: '401705',
        zipcode: 40160,
        text: 'คำแคน',
        value: 'คำแคน',
        name: {
          th: 'คำแคน',
          en: 'Kham Khaen',
        },
        districtId: 409,
      },
      {
        id: '401706',
        zipcode: 40160,
        text: 'นาข่า',
        value: 'นาข่า',
        name: {
          th: 'นาข่า',
          en: 'Na Kha',
        },
        districtId: 409,
      },
      {
        id: '401707',
        zipcode: 40160,
        text: 'นางาม',
        value: 'นางาม',
        name: {
          th: 'นางาม',
          en: 'Na Ngam',
        },
        districtId: 409,
      },
      {
        id: '401710',
        zipcode: 40160,
        text: 'ท่าศาลา',
        value: 'ท่าศาลา',
        name: {
          th: 'ท่าศาลา',
          en: 'Tha Sala',
        },
        districtId: 409,
      },
      {
        id: '401801',
        zipcode: 40180,
        text: 'ชนบท',
        value: 'ชนบท',
        name: {
          th: 'ชนบท',
          en: 'Chonnabot',
        },
        districtId: 410,
      },
      {
        id: '401802',
        zipcode: 40180,
        text: 'กุดเพียขอม',
        value: 'กุดเพียขอม',
        name: {
          th: 'กุดเพียขอม',
          en: 'Kut Phia Khom',
        },
        districtId: 410,
      },
      {
        id: '401803',
        zipcode: 40180,
        text: 'วังแสง',
        value: 'วังแสง',
        name: {
          th: 'วังแสง',
          en: 'Wang Saeng',
        },
        districtId: 410,
      },
      {
        id: '401804',
        zipcode: 40180,
        text: 'ห้วยแก',
        value: 'ห้วยแก',
        name: {
          th: 'ห้วยแก',
          en: 'Huai Kae',
        },
        districtId: 410,
      },
      {
        id: '401805',
        zipcode: 40180,
        text: 'บ้านแท่น',
        value: 'บ้านแท่น',
        name: {
          th: 'บ้านแท่น',
          en: 'Ban Thaen',
        },
        districtId: 410,
      },
      {
        id: '401806',
        zipcode: 40180,
        text: 'ศรีบุญเรือง',
        value: 'ศรีบุญเรือง',
        name: {
          th: 'ศรีบุญเรือง',
          en: 'Si Bun Rueang',
        },
        districtId: 410,
      },
      {
        id: '401807',
        zipcode: 40180,
        text: 'โนนพะยอม',
        value: 'โนนพะยอม',
        name: {
          th: 'โนนพะยอม',
          en: 'Non Phayom',
        },
        districtId: 410,
      },
      {
        id: '401808',
        zipcode: 40180,
        text: 'ปอแดง',
        value: 'ปอแดง',
        name: {
          th: 'ปอแดง',
          en: 'Po Daeng',
        },
        districtId: 410,
      },
      {
        id: '401901',
        zipcode: 40280,
        text: 'เขาสวนกวาง',
        value: 'เขาสวนกวาง',
        name: {
          th: 'เขาสวนกวาง',
          en: 'Khao Suan Kwang',
        },
        districtId: 411,
      },
      {
        id: '401902',
        zipcode: 40280,
        text: 'ดงเมืองแอม',
        value: 'ดงเมืองแอม',
        name: {
          th: 'ดงเมืองแอม',
          en: 'Dong Mueang Aem',
        },
        districtId: 411,
      },
      {
        id: '401903',
        zipcode: 40280,
        text: 'นางิ้ว',
        value: 'นางิ้ว',
        name: {
          th: 'นางิ้ว',
          en: 'Na Ngio',
        },
        districtId: 411,
      },
      {
        id: '401904',
        zipcode: 40280,
        text: 'โนนสมบูรณ์',
        value: 'โนนสมบูรณ์',
        name: {
          th: 'โนนสมบูรณ์',
          en: 'Non Sombun',
        },
        districtId: 411,
      },
      {
        id: '401905',
        zipcode: 40280,
        text: 'คำม่วง',
        value: 'คำม่วง',
        name: {
          th: 'คำม่วง',
          en: 'Kham Muang',
        },
        districtId: 411,
      },
      {
        id: '402001',
        zipcode: 40350,
        text: 'โนนคอม',
        value: 'โนนคอม',
        name: {
          th: 'โนนคอม',
          en: 'Non Khom',
        },
        districtId: 412,
      },
      {
        id: '402002',
        zipcode: 40350,
        text: 'นาฝาย',
        value: 'นาฝาย',
        name: {
          th: 'นาฝาย',
          en: 'Na Fai',
        },
        districtId: 412,
      },
      {
        id: '402003',
        zipcode: 40350,
        text: 'ภูผาม่าน',
        value: 'ภูผาม่าน',
        name: {
          th: 'ภูผาม่าน',
          en: 'Phu Pha Man',
        },
        districtId: 412,
      },
      {
        id: '402004',
        zipcode: 40350,
        text: 'วังสวาบ',
        value: 'วังสวาบ',
        name: {
          th: 'วังสวาบ',
          en: 'Wang Sawap',
        },
        districtId: 412,
      },
      {
        id: '402005',
        zipcode: 40350,
        text: 'ห้วยม่วง',
        value: 'ห้วยม่วง',
        name: {
          th: 'ห้วยม่วง',
          en: 'Huai Muang',
        },
        districtId: 412,
      },
      {
        id: '402101',
        zipcode: 40170,
        text: 'กระนวน',
        value: 'กระนวน',
        name: {
          th: 'กระนวน',
          en: 'Kranuan',
        },
        districtId: 413,
      },
      {
        id: '402102',
        zipcode: 40170,
        text: 'คำแมด',
        value: 'คำแมด',
        name: {
          th: 'คำแมด',
          en: 'Kham Maet',
        },
        districtId: 413,
      },
      {
        id: '402103',
        zipcode: 40170,
        text: 'บ้านโนน',
        value: 'บ้านโนน',
        name: {
          th: 'บ้านโนน',
          en: 'Ban Non',
        },
        districtId: 413,
      },
      {
        id: '402104',
        zipcode: 40170,
        text: 'คูคำ',
        value: 'คูคำ',
        name: {
          th: 'คูคำ',
          en: 'Khu Kham',
        },
        districtId: 413,
      },
      {
        id: '402105',
        zipcode: 40170,
        text: 'ห้วยเตย',
        value: 'ห้วยเตย',
        name: {
          th: 'ห้วยเตย',
          en: 'Huai Toei',
        },
        districtId: 413,
      },
      {
        id: '402201',
        zipcode: 40160,
        text: 'บ้านโคก',
        value: 'บ้านโคก',
        name: {
          th: 'บ้านโคก',
          en: 'Ban Khok',
        },
        districtId: 414,
      },
      {
        id: '402202',
        zipcode: 40160,
        text: 'โพธิ์ไชย',
        value: 'โพธิ์ไชย',
        name: {
          th: 'โพธิ์ไชย',
          en: 'Pho Chai',
        },
        districtId: 414,
      },
      {
        id: '402203',
        zipcode: 40160,
        text: 'ซับสมบูรณ์',
        value: 'ซับสมบูรณ์',
        name: {
          th: 'ซับสมบูรณ์',
          en: 'Sap Sombun',
        },
        districtId: 414,
      },
      {
        id: '402204',
        zipcode: 40160,
        text: 'นาแพง',
        value: 'นาแพง',
        name: {
          th: 'นาแพง',
          en: 'Na Phaeng',
        },
        districtId: 414,
      },
      {
        id: '402301',
        zipcode: 40150,
        text: 'กุดธาตุ',
        value: 'กุดธาตุ',
        name: {
          th: 'กุดธาตุ',
          en: 'Kut That',
        },
        districtId: 415,
      },
      {
        id: '402302',
        zipcode: 40150,
        text: 'บ้านโคก',
        value: 'บ้านโคก',
        name: {
          th: 'บ้านโคก',
          en: 'Ban Khok',
        },
        districtId: 415,
      },
      {
        id: '402303',
        zipcode: 40150,
        text: 'ขนวน',
        value: 'ขนวน',
        name: {
          th: 'ขนวน',
          en: 'Khanuan',
        },
        districtId: 415,
      },
      {
        id: '402401',
        zipcode: 40110,
        text: 'บ้านแฮด',
        value: 'บ้านแฮด',
        name: {
          th: 'บ้านแฮด',
          en: 'Ban Haet',
        },
        districtId: 416,
      },
      {
        id: '402402',
        zipcode: 40110,
        text: 'โคกสำราญ',
        value: 'โคกสำราญ',
        name: {
          th: 'โคกสำราญ',
          en: 'Khok Samran',
        },
        districtId: 416,
      },
      {
        id: '402403',
        zipcode: 40110,
        text: 'โนนสมบูรณ์',
        value: 'โนนสมบูรณ์',
        name: {
          th: 'โนนสมบูรณ์',
          en: 'Non Sombun',
        },
        districtId: 416,
      },
      {
        id: '402404',
        zipcode: 40110,
        text: 'หนองแซง',
        value: 'หนองแซง',
        name: {
          th: 'หนองแซง',
          en: 'Nong Saeng',
        },
        districtId: 416,
      },
      {
        id: '402501',
        zipcode: 40110,
        text: 'โนนศิลา',
        value: 'โนนศิลา',
        name: {
          th: 'โนนศิลา',
          en: 'Non Sila',
        },
        districtId: 417,
      },
      {
        id: '402502',
        zipcode: 40110,
        text: 'หนองปลาหมอ',
        value: 'หนองปลาหมอ',
        name: {
          th: 'หนองปลาหมอ',
          en: 'Nong Pla Mo',
        },
        districtId: 417,
      },
      {
        id: '402503',
        zipcode: 40110,
        text: 'บ้านหัน',
        value: 'บ้านหัน',
        name: {
          th: 'บ้านหัน',
          en: 'Ban Han',
        },
        districtId: 417,
      },
      {
        id: '402504',
        zipcode: 40110,
        text: 'เปือยใหญ่',
        value: 'เปือยใหญ่',
        name: {
          th: 'เปือยใหญ่',
          en: 'Pueai Yai',
        },
        districtId: 417,
      },
      {
        id: '402505',
        zipcode: 40110,
        text: 'โนนแดง',
        value: 'โนนแดง',
        name: {
          th: 'โนนแดง',
          en: 'Non Daeng',
        },
        districtId: 417,
      },
      {
        id: '410101',
        zipcode: 41000,
        text: 'หมากแข้ง',
        value: 'หมากแข้ง',
        name: {
          th: 'หมากแข้ง',
          en: 'Mak Khaeng',
        },
        districtId: 421,
      },
      {
        id: '410102',
        zipcode: 41000,
        text: 'นิคมสงเคราะห์',
        value: 'นิคมสงเคราะห์',
        name: {
          th: 'นิคมสงเคราะห์',
          en: 'Nikhom Songkhro',
        },
        districtId: 421,
      },
      {
        id: '410103',
        zipcode: 41000,
        text: 'บ้านขาว',
        value: 'บ้านขาว',
        name: {
          th: 'บ้านขาว',
          en: 'Ban Khao',
        },
        districtId: 421,
      },
      {
        id: '410104',
        zipcode: 41000,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 421,
      },
      {
        id: '410105',
        zipcode: 41000,
        text: 'บ้านตาด',
        value: 'บ้านตาด',
        name: {
          th: 'บ้านตาด',
          en: 'Ban Tat',
        },
        districtId: 421,
      },
      {
        id: '410106',
        zipcode: 41330,
        text: 'โนนสูง',
        value: 'โนนสูง',
        name: {
          th: 'โนนสูง',
          en: 'Non Sung',
        },
        districtId: 421,
      },
      {
        id: '410107',
        zipcode: 41000,
        text: 'หมูม่น',
        value: 'หมูม่น',
        name: {
          th: 'หมูม่น',
          en: 'Mu Mon',
        },
        districtId: 421,
      },
      {
        id: '410108',
        zipcode: 41000,
        text: 'เชียงยืน',
        value: 'เชียงยืน',
        name: {
          th: 'เชียงยืน',
          en: 'Chiang Yuen',
        },
        districtId: 421,
      },
      {
        id: '410109',
        zipcode: 41000,
        text: 'หนองนาคำ',
        value: 'หนองนาคำ',
        name: {
          th: 'หนองนาคำ',
          en: 'Nong Na Kham',
        },
        districtId: 421,
      },
      {
        id: '410110',
        zipcode: 41000,
        text: 'กุดสระ',
        value: 'กุดสระ',
        name: {
          th: 'กุดสระ',
          en: 'Kut Sa',
        },
        districtId: 421,
      },
      {
        id: '410111',
        zipcode: 41000,
        text: 'นาดี',
        value: 'นาดี',
        name: {
          th: 'นาดี',
          en: 'Na Di',
        },
        districtId: 421,
      },
      {
        id: '410112',
        zipcode: 41000,
        text: 'บ้านเลื่อม',
        value: 'บ้านเลื่อม',
        name: {
          th: 'บ้านเลื่อม',
          en: 'Ban Lueam',
        },
        districtId: 421,
      },
      {
        id: '410113',
        zipcode: 41000,
        text: 'เชียงพิณ',
        value: 'เชียงพิณ',
        name: {
          th: 'เชียงพิณ',
          en: 'Chiang Phin',
        },
        districtId: 421,
      },
      {
        id: '410114',
        zipcode: 41000,
        text: 'สามพร้าว',
        value: 'สามพร้าว',
        name: {
          th: 'สามพร้าว',
          en: 'Sam Phrao',
        },
        districtId: 421,
      },
      {
        id: '410115',
        zipcode: 41000,
        text: 'หนองไฮ',
        value: 'หนองไฮ',
        name: {
          th: 'หนองไฮ',
          en: 'Nong Hai',
        },
        districtId: 421,
      },
      {
        id: '410116',
        zipcode: 41000,
        text: 'นาข่า',
        value: 'นาข่า',
        name: {
          th: 'นาข่า',
          en: 'Na Kha',
        },
        districtId: 421,
      },
      {
        id: '410117',
        zipcode: 41000,
        text: 'บ้านจั่น',
        value: 'บ้านจั่น',
        name: {
          th: 'บ้านจั่น',
          en: 'Ban Chan',
        },
        districtId: 421,
      },
      {
        id: '410118',
        zipcode: 41000,
        text: 'หนองขอนกว้าง',
        value: 'หนองขอนกว้าง',
        name: {
          th: 'หนองขอนกว้าง',
          en: 'Nong Khon Kwang',
        },
        districtId: 421,
      },
      {
        id: '410119',
        zipcode: 41000,
        text: 'โคกสะอาด',
        value: 'โคกสะอาด',
        name: {
          th: 'โคกสะอาด',
          en: 'Khok Sa-at',
        },
        districtId: 421,
      },
      {
        id: '410120',
        zipcode: 41000,
        text: 'นากว้าง',
        value: 'นากว้าง',
        name: {
          th: 'นากว้าง',
          en: 'Na Kwang',
        },
        districtId: 421,
      },
      {
        id: '410121',
        zipcode: 41330,
        text: 'หนองไผ่',
        value: 'หนองไผ่',
        name: {
          th: 'หนองไผ่',
          en: 'Nong Phai',
        },
        districtId: 421,
      },
      {
        id: '410201',
        zipcode: 41250,
        text: 'กุดจับ',
        value: 'กุดจับ',
        name: {
          th: 'กุดจับ',
          en: 'Kut Chap',
        },
        districtId: 422,
      },
      {
        id: '410202',
        zipcode: 41250,
        text: 'ปะโค',
        value: 'ปะโค',
        name: {
          th: 'ปะโค',
          en: 'Pakho',
        },
        districtId: 422,
      },
      {
        id: '410203',
        zipcode: 41250,
        text: 'ขอนยูง',
        value: 'ขอนยูง',
        name: {
          th: 'ขอนยูง',
          en: 'Khon Yung',
        },
        districtId: 422,
      },
      {
        id: '410204',
        zipcode: 41250,
        text: 'เชียงเพ็ง',
        value: 'เชียงเพ็ง',
        name: {
          th: 'เชียงเพ็ง',
          en: 'Chiang Pheng',
        },
        districtId: 422,
      },
      {
        id: '410205',
        zipcode: 41250,
        text: 'สร้างก่อ',
        value: 'สร้างก่อ',
        name: {
          th: 'สร้างก่อ',
          en: 'Sang Ko',
        },
        districtId: 422,
      },
      {
        id: '410206',
        zipcode: 41250,
        text: 'เมืองเพีย',
        value: 'เมืองเพีย',
        name: {
          th: 'เมืองเพีย',
          en: 'Mueang Phia',
        },
        districtId: 422,
      },
      {
        id: '410207',
        zipcode: 41250,
        text: 'ตาลเลียน',
        value: 'ตาลเลียน',
        name: {
          th: 'ตาลเลียน',
          en: 'Tan Lian',
        },
        districtId: 422,
      },
      {
        id: '410301',
        zipcode: 41360,
        text: 'หมากหญ้า',
        value: 'หมากหญ้า',
        name: {
          th: 'หมากหญ้า',
          en: 'Mak Ya',
        },
        districtId: 423,
      },
      {
        id: '410302',
        zipcode: 41220,
        text: 'หนองอ้อ',
        value: 'หนองอ้อ',
        name: {
          th: 'หนองอ้อ',
          en: 'Nong O',
        },
        districtId: 423,
      },
      {
        id: '410303',
        zipcode: 41220,
        text: 'อูบมุง',
        value: 'อูบมุง',
        name: {
          th: 'อูบมุง',
          en: 'Up Mung',
        },
        districtId: 423,
      },
      {
        id: '410304',
        zipcode: 41220,
        text: 'กุดหมากไฟ',
        value: 'กุดหมากไฟ',
        name: {
          th: 'กุดหมากไฟ',
          en: 'Kut Mak Fai',
        },
        districtId: 423,
      },
      {
        id: '410305',
        zipcode: 41360,
        text: 'น้ำพ่น',
        value: 'น้ำพ่น',
        name: {
          th: 'น้ำพ่น',
          en: 'Nam Phon',
        },
        districtId: 423,
      },
      {
        id: '410306',
        zipcode: 41360,
        text: 'หนองบัวบาน',
        value: 'หนองบัวบาน',
        name: {
          th: 'หนองบัวบาน',
          en: 'Nong Bua Ban',
        },
        districtId: 423,
      },
      {
        id: '410307',
        zipcode: 41220,
        text: 'โนนหวาย',
        value: 'โนนหวาย',
        name: {
          th: 'โนนหวาย',
          en: 'Non Wai',
        },
        districtId: 423,
      },
      {
        id: '410308',
        zipcode: 41360,
        text: 'หนองวัวซอ',
        value: 'หนองวัวซอ',
        name: {
          th: 'หนองวัวซอ',
          en: 'Nong Wua So',
        },
        districtId: 423,
      },
      {
        id: '410401',
        zipcode: 41110,
        text: 'ตูมใต้',
        value: 'ตูมใต้',
        name: {
          th: 'ตูมใต้',
          en: 'Tum Tai',
        },
        districtId: 424,
      },
      {
        id: '410402',
        zipcode: 41370,
        text: 'พันดอน',
        value: 'พันดอน',
        name: {
          th: 'พันดอน',
          en: 'Phan Don',
        },
        districtId: 424,
      },
      {
        id: '410403',
        zipcode: 41110,
        text: 'เวียงคำ',
        value: 'เวียงคำ',
        name: {
          th: 'เวียงคำ',
          en: 'Wiang Kham',
        },
        districtId: 424,
      },
      {
        id: '410404',
        zipcode: 41110,
        text: 'แชแล',
        value: 'แชแล',
        name: {
          th: 'แชแล',
          en: 'Chaelae',
        },
        districtId: 424,
      },
      {
        id: '410406',
        zipcode: 41110,
        text: 'เชียงแหว',
        value: 'เชียงแหว',
        name: {
          th: 'เชียงแหว',
          en: 'Chiang Wae',
        },
        districtId: 424,
      },
      {
        id: '410407',
        zipcode: 41110,
        text: 'ห้วยเกิ้ง',
        value: 'ห้วยเกิ้ง',
        name: {
          th: 'ห้วยเกิ้ง',
          en: 'Huai Koeng',
        },
        districtId: 424,
      },
      {
        id: '410409',
        zipcode: 41370,
        text: 'เสอเพลอ',
        value: 'เสอเพลอ',
        name: {
          th: 'เสอเพลอ',
          en: 'Soephloe',
        },
        districtId: 424,
      },
      {
        id: '410410',
        zipcode: 41110,
        text: 'สีออ',
        value: 'สีออ',
        name: {
          th: 'สีออ',
          en: 'Si O',
        },
        districtId: 424,
      },
      {
        id: '410411',
        zipcode: 41370,
        text: 'ปะโค',
        value: 'ปะโค',
        name: {
          th: 'ปะโค',
          en: 'Pa Kho',
        },
        districtId: 424,
      },
      {
        id: '410413',
        zipcode: 41370,
        text: 'ผาสุก',
        value: 'ผาสุก',
        name: {
          th: 'ผาสุก',
          en: 'Phasuk',
        },
        districtId: 424,
      },
      {
        id: '410414',
        zipcode: 41110,
        text: 'ท่าลี่',
        value: 'ท่าลี่',
        name: {
          th: 'ท่าลี่',
          en: 'Tha Li',
        },
        districtId: 424,
      },
      {
        id: '410415',
        zipcode: 41110,
        text: 'กุมภวาปี',
        value: 'กุมภวาปี',
        name: {
          th: 'กุมภวาปี',
          en: 'Kumphawapi',
        },
        districtId: 424,
      },
      {
        id: '410416',
        zipcode: 41110,
        text: 'หนองหว้า',
        value: 'หนองหว้า',
        name: {
          th: 'หนองหว้า',
          en: 'Nong Wa',
        },
        districtId: 424,
      },
      {
        id: '410495',
        zipcode: 0,
        text: '*โนนสะอาด',
        value: '*โนนสะอาด',
        name: {
          th: '*โนนสะอาด',
          en: '*Non Sa-ard',
        },
        districtId: 424,
      },
      {
        id: '410501',
        zipcode: 41240,
        text: 'โนนสะอาด',
        value: 'โนนสะอาด',
        name: {
          th: 'โนนสะอาด',
          en: 'Non Sa-at',
        },
        districtId: 425,
      },
      {
        id: '410502',
        zipcode: 41240,
        text: 'บุ่งแก้ว',
        value: 'บุ่งแก้ว',
        name: {
          th: 'บุ่งแก้ว',
          en: 'Bung Kaeo',
        },
        districtId: 425,
      },
      {
        id: '410503',
        zipcode: 41240,
        text: 'โพธิ์ศรีสำราญ',
        value: 'โพธิ์ศรีสำราญ',
        name: {
          th: 'โพธิ์ศรีสำราญ',
          en: 'Pho Si Samran',
        },
        districtId: 425,
      },
      {
        id: '410504',
        zipcode: 41240,
        text: 'ทมนางาม',
        value: 'ทมนางาม',
        name: {
          th: 'ทมนางาม',
          en: 'Thom Na Ngam',
        },
        districtId: 425,
      },
      {
        id: '410505',
        zipcode: 41240,
        text: 'หนองกุงศรี',
        value: 'หนองกุงศรี',
        name: {
          th: 'หนองกุงศรี',
          en: 'Nong Kung Si',
        },
        districtId: 425,
      },
      {
        id: '410506',
        zipcode: 41240,
        text: 'โคกกลาง',
        value: 'โคกกลาง',
        name: {
          th: 'โคกกลาง',
          en: 'Khok Klang',
        },
        districtId: 425,
      },
      {
        id: '410601',
        zipcode: 41130,
        text: 'หนองหาน',
        value: 'หนองหาน',
        name: {
          th: 'หนองหาน',
          en: 'Nong Han',
        },
        districtId: 426,
      },
      {
        id: '410602',
        zipcode: 41130,
        text: 'หนองเม็ก',
        value: 'หนองเม็ก',
        name: {
          th: 'หนองเม็ก',
          en: 'Nong Mek',
        },
        districtId: 426,
      },
      {
        id: '410605',
        zipcode: 41130,
        text: 'พังงู',
        value: 'พังงู',
        name: {
          th: 'พังงู',
          en: 'Phang Ngu',
        },
        districtId: 426,
      },
      {
        id: '410606',
        zipcode: 41130,
        text: 'สะแบง',
        value: 'สะแบง',
        name: {
          th: 'สะแบง',
          en: 'Sabaeng',
        },
        districtId: 426,
      },
      {
        id: '410607',
        zipcode: 41130,
        text: 'สร้อยพร้าว',
        value: 'สร้อยพร้าว',
        name: {
          th: 'สร้อยพร้าว',
          en: 'Soi Phrao',
        },
        districtId: 426,
      },
      {
        id: '410609',
        zipcode: 41320,
        text: 'บ้านเชียง',
        value: 'บ้านเชียง',
        name: {
          th: 'บ้านเชียง',
          en: 'Ban Chiang',
        },
        districtId: 426,
      },
      {
        id: '410610',
        zipcode: 41320,
        text: 'บ้านยา',
        value: 'บ้านยา',
        name: {
          th: 'บ้านยา',
          en: 'Ban Ya',
        },
        districtId: 426,
      },
      {
        id: '410611',
        zipcode: 41130,
        text: 'โพนงาม',
        value: 'โพนงาม',
        name: {
          th: 'โพนงาม',
          en: 'Phon Ngam',
        },
        districtId: 426,
      },
      {
        id: '410612',
        zipcode: 41130,
        text: 'ผักตบ',
        value: 'ผักตบ',
        name: {
          th: 'ผักตบ',
          en: 'Phak Top',
        },
        districtId: 426,
      },
      {
        id: '410614',
        zipcode: 41130,
        text: 'หนองไผ่',
        value: 'หนองไผ่',
        name: {
          th: 'หนองไผ่',
          en: 'Nong Phai',
        },
        districtId: 426,
      },
      {
        id: '410617',
        zipcode: 41130,
        text: 'ดอนหายโศก',
        value: 'ดอนหายโศก',
        name: {
          th: 'ดอนหายโศก',
          en: 'Don Hai Sok',
        },
        districtId: 426,
      },
      {
        id: '410618',
        zipcode: 41320,
        text: 'หนองสระปลา',
        value: 'หนองสระปลา',
        name: {
          th: 'หนองสระปลา',
          en: 'Nong Sa Pla)',
        },
        districtId: 426,
      },
      {
        id: '410701',
        zipcode: 41310,
        text: 'ทุ่งฝน',
        value: 'ทุ่งฝน',
        name: {
          th: 'ทุ่งฝน',
          en: 'Thung Fon',
        },
        districtId: 427,
      },
      {
        id: '410702',
        zipcode: 41310,
        text: 'ทุ่งใหญ่',
        value: 'ทุ่งใหญ่',
        name: {
          th: 'ทุ่งใหญ่',
          en: 'Thung Yai',
        },
        districtId: 427,
      },
      {
        id: '410703',
        zipcode: 41310,
        text: 'นาชุมแสง',
        value: 'นาชุมแสง',
        name: {
          th: 'นาชุมแสง',
          en: 'Na Chum Saeng',
        },
        districtId: 427,
      },
      {
        id: '410704',
        zipcode: 41310,
        text: 'นาทม',
        value: 'นาทม',
        name: {
          th: 'นาทม',
          en: 'Na Thom',
        },
        districtId: 427,
      },
      {
        id: '410801',
        zipcode: 41290,
        text: 'ไชยวาน',
        value: 'ไชยวาน',
        name: {
          th: 'ไชยวาน',
          en: 'Chai Wan',
        },
        districtId: 428,
      },
      {
        id: '410802',
        zipcode: 41290,
        text: 'หนองหลัก',
        value: 'หนองหลัก',
        name: {
          th: 'หนองหลัก',
          en: 'Nong Lak',
        },
        districtId: 428,
      },
      {
        id: '410803',
        zipcode: 41290,
        text: 'คำเลาะ',
        value: 'คำเลาะ',
        name: {
          th: 'คำเลาะ',
          en: 'Kham Lo',
        },
        districtId: 428,
      },
      {
        id: '410804',
        zipcode: 41290,
        text: 'โพนสูง',
        value: 'โพนสูง',
        name: {
          th: 'โพนสูง',
          en: 'Phon Sung',
        },
        districtId: 428,
      },
      {
        id: '410901',
        zipcode: 41230,
        text: 'ศรีธาตุ',
        value: 'ศรีธาตุ',
        name: {
          th: 'ศรีธาตุ',
          en: 'Si That',
        },
        districtId: 429,
      },
      {
        id: '410902',
        zipcode: 41230,
        text: 'จำปี',
        value: 'จำปี',
        name: {
          th: 'จำปี',
          en: 'Champi',
        },
        districtId: 429,
      },
      {
        id: '410903',
        zipcode: 41230,
        text: 'บ้านโปร่ง',
        value: 'บ้านโปร่ง',
        name: {
          th: 'บ้านโปร่ง',
          en: 'Ban Prong',
        },
        districtId: 429,
      },
      {
        id: '410904',
        zipcode: 41230,
        text: 'หัวนาคำ',
        value: 'หัวนาคำ',
        name: {
          th: 'หัวนาคำ',
          en: 'Hua Na Kham',
        },
        districtId: 429,
      },
      {
        id: '410905',
        zipcode: 41230,
        text: 'หนองนกเขียน',
        value: 'หนองนกเขียน',
        name: {
          th: 'หนองนกเขียน',
          en: 'Nong Nok Khian',
        },
        districtId: 429,
      },
      {
        id: '410906',
        zipcode: 41230,
        text: 'นายูง',
        value: 'นายูง',
        name: {
          th: 'นายูง',
          en: 'Na Yung',
        },
        districtId: 429,
      },
      {
        id: '410907',
        zipcode: 41230,
        text: 'ตาดทอง',
        value: 'ตาดทอง',
        name: {
          th: 'ตาดทอง',
          en: 'Tat Thong',
        },
        districtId: 429,
      },
      {
        id: '411001',
        zipcode: 41280,
        text: 'หนองกุงทับม้า',
        value: 'หนองกุงทับม้า',
        name: {
          th: 'หนองกุงทับม้า',
          en: 'Nong Kung Thap Ma',
        },
        districtId: 430,
      },
      {
        id: '411002',
        zipcode: 41280,
        text: 'หนองหญ้าไซ',
        value: 'หนองหญ้าไซ',
        name: {
          th: 'หนองหญ้าไซ',
          en: 'Nong Ya Sai',
        },
        districtId: 430,
      },
      {
        id: '411003',
        zipcode: 41280,
        text: 'บะยาว',
        value: 'บะยาว',
        name: {
          th: 'บะยาว',
          en: 'Ba Yao',
        },
        districtId: 430,
      },
      {
        id: '411004',
        zipcode: 41280,
        text: 'ผาสุก',
        value: 'ผาสุก',
        name: {
          th: 'ผาสุก',
          en: 'Phasuk',
        },
        districtId: 430,
      },
      {
        id: '411005',
        zipcode: 41280,
        text: 'คำโคกสูง',
        value: 'คำโคกสูง',
        name: {
          th: 'คำโคกสูง',
          en: 'Kham Khok Sung',
        },
        districtId: 430,
      },
      {
        id: '411006',
        zipcode: 41280,
        text: 'วังสามหมอ',
        value: 'วังสามหมอ',
        name: {
          th: 'วังสามหมอ',
          en: 'Wang Sam Mo',
        },
        districtId: 430,
      },
      {
        id: '411101',
        zipcode: 41190,
        text: 'ศรีสุทโธ',
        value: 'ศรีสุทโธ',
        name: {
          th: 'ศรีสุทโธ',
          en: 'Si Suttho',
        },
        districtId: 431,
      },
      {
        id: '411102',
        zipcode: 41190,
        text: 'บ้านดุง',
        value: 'บ้านดุง',
        name: {
          th: 'บ้านดุง',
          en: 'Ban Dung',
        },
        districtId: 431,
      },
      {
        id: '411103',
        zipcode: 41190,
        text: 'ดงเย็น',
        value: 'ดงเย็น',
        name: {
          th: 'ดงเย็น',
          en: 'Dong Yen',
        },
        districtId: 431,
      },
      {
        id: '411104',
        zipcode: 41190,
        text: 'โพนสูง',
        value: 'โพนสูง',
        name: {
          th: 'โพนสูง',
          en: 'Phon Sung',
        },
        districtId: 431,
      },
      {
        id: '411105',
        zipcode: 41190,
        text: 'อ้อมกอ',
        value: 'อ้อมกอ',
        name: {
          th: 'อ้อมกอ',
          en: 'Om Ko',
        },
        districtId: 431,
      },
      {
        id: '411106',
        zipcode: 41190,
        text: 'บ้านจันทน์',
        value: 'บ้านจันทน์',
        name: {
          th: 'บ้านจันทน์',
          en: 'Ban Chan',
        },
        districtId: 431,
      },
      {
        id: '411107',
        zipcode: 41190,
        text: 'บ้านชัย',
        value: 'บ้านชัย',
        name: {
          th: 'บ้านชัย',
          en: 'Ban Chai',
        },
        districtId: 431,
      },
      {
        id: '411108',
        zipcode: 41190,
        text: 'นาไหม',
        value: 'นาไหม',
        name: {
          th: 'นาไหม',
          en: 'Na Mai',
        },
        districtId: 431,
      },
      {
        id: '411109',
        zipcode: 41190,
        text: 'ถ่อนนาลับ',
        value: 'ถ่อนนาลับ',
        name: {
          th: 'ถ่อนนาลับ',
          en: 'Thon Na Lap',
        },
        districtId: 431,
      },
      {
        id: '411110',
        zipcode: 41190,
        text: 'วังทอง',
        value: 'วังทอง',
        name: {
          th: 'วังทอง',
          en: 'Wang Thong',
        },
        districtId: 431,
      },
      {
        id: '411111',
        zipcode: 41190,
        text: 'บ้านม่วง',
        value: 'บ้านม่วง',
        name: {
          th: 'บ้านม่วง',
          en: 'Ban Muang',
        },
        districtId: 431,
      },
      {
        id: '411112',
        zipcode: 41190,
        text: 'บ้านตาด',
        value: 'บ้านตาด',
        name: {
          th: 'บ้านตาด',
          en: 'Ban Tat',
        },
        districtId: 431,
      },
      {
        id: '411113',
        zipcode: 41190,
        text: 'นาคำ',
        value: 'นาคำ',
        name: {
          th: 'นาคำ',
          en: 'Na Kham',
        },
        districtId: 431,
      },
      {
        id: '411304',
        zipcode: 0,
        text: '*กุดสะเทียน',
        value: '*กุดสะเทียน',
        name: {
          th: '*กุดสะเทียน',
          en: '*Kud Sa-Tian',
        },
        districtId: 433,
      },
      {
        id: '411306',
        zipcode: 0,
        text: '*โนนสะอาด',
        value: '*โนนสะอาด',
        name: {
          th: '*โนนสะอาด',
          en: '*Non Sa-ard',
        },
        districtId: 433,
      },
      {
        id: '411701',
        zipcode: 41160,
        text: 'บ้านผือ',
        value: 'บ้านผือ',
        name: {
          th: 'บ้านผือ',
          en: 'Ban Phue',
        },
        districtId: 437,
      },
      {
        id: '411702',
        zipcode: 41160,
        text: 'หายโศก',
        value: 'หายโศก',
        name: {
          th: 'หายโศก',
          en: 'Hai Sok',
        },
        districtId: 437,
      },
      {
        id: '411703',
        zipcode: 41160,
        text: 'เขือน้ำ',
        value: 'เขือน้ำ',
        name: {
          th: 'เขือน้ำ',
          en: 'Khuea Nam',
        },
        districtId: 437,
      },
      {
        id: '411704',
        zipcode: 41160,
        text: 'คำบง',
        value: 'คำบง',
        name: {
          th: 'คำบง',
          en: 'Kham Bong',
        },
        districtId: 437,
      },
      {
        id: '411705',
        zipcode: 41160,
        text: 'โนนทอง',
        value: 'โนนทอง',
        name: {
          th: 'โนนทอง',
          en: 'Non Thong',
        },
        districtId: 437,
      },
      {
        id: '411706',
        zipcode: 41160,
        text: 'ข้าวสาร',
        value: 'ข้าวสาร',
        name: {
          th: 'ข้าวสาร',
          en: 'Khao San',
        },
        districtId: 437,
      },
      {
        id: '411707',
        zipcode: 41160,
        text: 'จำปาโมง',
        value: 'จำปาโมง',
        name: {
          th: 'จำปาโมง',
          en: 'Champa Mong',
        },
        districtId: 437,
      },
      {
        id: '411708',
        zipcode: 41160,
        text: 'กลางใหญ่',
        value: 'กลางใหญ่',
        name: {
          th: 'กลางใหญ่',
          en: 'Klang Yai',
        },
        districtId: 437,
      },
      {
        id: '411709',
        zipcode: 41160,
        text: 'เมืองพาน',
        value: 'เมืองพาน',
        name: {
          th: 'เมืองพาน',
          en: 'Mueang Phan',
        },
        districtId: 437,
      },
      {
        id: '411710',
        zipcode: 41160,
        text: 'คำด้วง',
        value: 'คำด้วง',
        name: {
          th: 'คำด้วง',
          en: 'Kham Duang',
        },
        districtId: 437,
      },
      {
        id: '411711',
        zipcode: 41160,
        text: 'หนองหัวคู',
        value: 'หนองหัวคู',
        name: {
          th: 'หนองหัวคู',
          en: 'Nong Hua Khu',
        },
        districtId: 437,
      },
      {
        id: '411712',
        zipcode: 41160,
        text: 'บ้านค้อ',
        value: 'บ้านค้อ',
        name: {
          th: 'บ้านค้อ',
          en: 'Ban Kho',
        },
        districtId: 437,
      },
      {
        id: '411713',
        zipcode: 41160,
        text: 'หนองแวง',
        value: 'หนองแวง',
        name: {
          th: 'หนองแวง',
          en: 'Nong Waeng',
        },
        districtId: 437,
      },
      {
        id: '411801',
        zipcode: 41210,
        text: 'นางัว',
        value: 'นางัว',
        name: {
          th: 'นางัว',
          en: 'Na Ngua',
        },
        districtId: 438,
      },
      {
        id: '411802',
        zipcode: 41210,
        text: 'น้ำโสม',
        value: 'น้ำโสม',
        name: {
          th: 'น้ำโสม',
          en: 'Nam Som',
        },
        districtId: 438,
      },
      {
        id: '411805',
        zipcode: 41210,
        text: 'หนองแวง',
        value: 'หนองแวง',
        name: {
          th: 'หนองแวง',
          en: 'Nong Waeng',
        },
        districtId: 438,
      },
      {
        id: '411806',
        zipcode: 41210,
        text: 'บ้านหยวก',
        value: 'บ้านหยวก',
        name: {
          th: 'บ้านหยวก',
          en: 'Ban Yuak',
        },
        districtId: 438,
      },
      {
        id: '411807',
        zipcode: 41210,
        text: 'โสมเยี่ยม',
        value: 'โสมเยี่ยม',
        name: {
          th: 'โสมเยี่ยม',
          en: 'Som Yiam',
        },
        districtId: 438,
      },
      {
        id: '411810',
        zipcode: 41210,
        text: 'ศรีสำราญ',
        value: 'ศรีสำราญ',
        name: {
          th: 'ศรีสำราญ',
          en: 'Si Samran',
        },
        districtId: 438,
      },
      {
        id: '411812',
        zipcode: 41210,
        text: 'สามัคคี',
        value: 'สามัคคี',
        name: {
          th: 'สามัคคี',
          en: 'Samakkhi',
        },
        districtId: 438,
      },
      {
        id: '411901',
        zipcode: 41150,
        text: 'เพ็ญ',
        value: 'เพ็ญ',
        name: {
          th: 'เพ็ญ',
          en: 'Phen',
        },
        districtId: 439,
      },
      {
        id: '411902',
        zipcode: 41150,
        text: 'บ้านธาตุ',
        value: 'บ้านธาตุ',
        name: {
          th: 'บ้านธาตุ',
          en: 'Ban That',
        },
        districtId: 439,
      },
      {
        id: '411903',
        zipcode: 41150,
        text: 'นาพู่',
        value: 'นาพู่',
        name: {
          th: 'นาพู่',
          en: 'Na Phu',
        },
        districtId: 439,
      },
      {
        id: '411904',
        zipcode: 41150,
        text: 'เชียงหวาง',
        value: 'เชียงหวาง',
        name: {
          th: 'เชียงหวาง',
          en: 'Chiang Wang',
        },
        districtId: 439,
      },
      {
        id: '411905',
        zipcode: 41150,
        text: 'สุมเส้า',
        value: 'สุมเส้า',
        name: {
          th: 'สุมเส้า',
          en: 'Sum Sao',
        },
        districtId: 439,
      },
      {
        id: '411906',
        zipcode: 41150,
        text: 'นาบัว',
        value: 'นาบัว',
        name: {
          th: 'นาบัว',
          en: 'Na Bua',
        },
        districtId: 439,
      },
      {
        id: '411907',
        zipcode: 41150,
        text: 'บ้านเหล่า',
        value: 'บ้านเหล่า',
        name: {
          th: 'บ้านเหล่า',
          en: 'Ban Lao',
        },
        districtId: 439,
      },
      {
        id: '411908',
        zipcode: 41150,
        text: 'จอมศรี',
        value: 'จอมศรี',
        name: {
          th: 'จอมศรี',
          en: 'Chom Si',
        },
        districtId: 439,
      },
      {
        id: '411909',
        zipcode: 41150,
        text: 'เตาไห',
        value: 'เตาไห',
        name: {
          th: 'เตาไห',
          en: 'Tao Hai',
        },
        districtId: 439,
      },
      {
        id: '411910',
        zipcode: 41150,
        text: 'โคกกลาง',
        value: 'โคกกลาง',
        name: {
          th: 'โคกกลาง',
          en: 'Khok Klang',
        },
        districtId: 439,
      },
      {
        id: '411911',
        zipcode: 41150,
        text: 'สร้างแป้น',
        value: 'สร้างแป้น',
        name: {
          th: 'สร้างแป้น',
          en: 'Sang Paen',
        },
        districtId: 439,
      },
      {
        id: '412001',
        zipcode: 41260,
        text: 'สร้างคอม',
        value: 'สร้างคอม',
        name: {
          th: 'สร้างคอม',
          en: 'Sang Khom',
        },
        districtId: 440,
      },
      {
        id: '412002',
        zipcode: 41260,
        text: 'เชียงดา',
        value: 'เชียงดา',
        name: {
          th: 'เชียงดา',
          en: 'Chiang Da',
        },
        districtId: 440,
      },
      {
        id: '412003',
        zipcode: 41260,
        text: 'บ้านยวด',
        value: 'บ้านยวด',
        name: {
          th: 'บ้านยวด',
          en: 'Ban Yuat',
        },
        districtId: 440,
      },
      {
        id: '412004',
        zipcode: 41260,
        text: 'บ้านโคก',
        value: 'บ้านโคก',
        name: {
          th: 'บ้านโคก',
          en: 'Ban Khok',
        },
        districtId: 440,
      },
      {
        id: '412005',
        zipcode: 41260,
        text: 'นาสะอาด',
        value: 'นาสะอาด',
        name: {
          th: 'นาสะอาด',
          en: 'Na Sa-at',
        },
        districtId: 440,
      },
      {
        id: '412006',
        zipcode: 41260,
        text: 'บ้านหินโงม',
        value: 'บ้านหินโงม',
        name: {
          th: 'บ้านหินโงม',
          en: 'Ban Hin Ngom',
        },
        districtId: 440,
      },
      {
        id: '412101',
        zipcode: 41340,
        text: 'หนองแสง',
        value: 'หนองแสง',
        name: {
          th: 'หนองแสง',
          en: 'Nong Saeng',
        },
        districtId: 441,
      },
      {
        id: '412102',
        zipcode: 41340,
        text: 'แสงสว่าง',
        value: 'แสงสว่าง',
        name: {
          th: 'แสงสว่าง',
          en: 'Saeng Sawang',
        },
        districtId: 441,
      },
      {
        id: '412103',
        zipcode: 41340,
        text: 'นาดี',
        value: 'นาดี',
        name: {
          th: 'นาดี',
          en: 'Na Di',
        },
        districtId: 441,
      },
      {
        id: '412104',
        zipcode: 41340,
        text: 'ทับกุง',
        value: 'ทับกุง',
        name: {
          th: 'ทับกุง',
          en: 'Thap Kung',
        },
        districtId: 441,
      },
      {
        id: '412201',
        zipcode: 41380,
        text: 'นายูง',
        value: 'นายูง',
        name: {
          th: 'นายูง',
          en: 'Na Yung',
        },
        districtId: 442,
      },
      {
        id: '412202',
        zipcode: 41380,
        text: 'บ้านก้อง',
        value: 'บ้านก้อง',
        name: {
          th: 'บ้านก้อง',
          en: 'Ban Kong',
        },
        districtId: 442,
      },
      {
        id: '412203',
        zipcode: 41380,
        text: 'นาแค',
        value: 'นาแค',
        name: {
          th: 'นาแค',
          en: 'Na Khae',
        },
        districtId: 442,
      },
      {
        id: '412204',
        zipcode: 41380,
        text: 'โนนทอง',
        value: 'โนนทอง',
        name: {
          th: 'โนนทอง',
          en: 'Non Thong',
        },
        districtId: 442,
      },
      {
        id: '412301',
        zipcode: 41130,
        text: 'บ้านแดง',
        value: 'บ้านแดง',
        name: {
          th: 'บ้านแดง',
          en: 'Ban Daeng',
        },
        districtId: 443,
      },
      {
        id: '412302',
        zipcode: 41130,
        text: 'นาทราย',
        value: 'นาทราย',
        name: {
          th: 'นาทราย',
          en: 'Na Sai',
        },
        districtId: 443,
      },
      {
        id: '412303',
        zipcode: 41130,
        text: 'ดอนกลอย',
        value: 'ดอนกลอย',
        name: {
          th: 'ดอนกลอย',
          en: 'Don Kloi',
        },
        districtId: 443,
      },
      {
        id: '412401',
        zipcode: 41130,
        text: 'บ้านจีต',
        value: 'บ้านจีต',
        name: {
          th: 'บ้านจีต',
          en: 'Ban Chit',
        },
        districtId: 444,
      },
      {
        id: '412402',
        zipcode: 41130,
        text: 'โนนทองอินทร์',
        value: 'โนนทองอินทร์',
        name: {
          th: 'โนนทองอินทร์',
          en: 'Non Thong In',
        },
        districtId: 444,
      },
      {
        id: '412403',
        zipcode: 41130,
        text: 'ค้อใหญ่',
        value: 'ค้อใหญ่',
        name: {
          th: 'ค้อใหญ่',
          en: 'Kho Yai',
        },
        districtId: 444,
      },
      {
        id: '412404',
        zipcode: 41130,
        text: 'คอนสาย',
        value: 'คอนสาย',
        name: {
          th: 'คอนสาย',
          en: 'Khon Sai',
        },
        districtId: 444,
      },
      {
        id: '412501',
        zipcode: 41110,
        text: 'นาม่วง',
        value: 'นาม่วง',
        name: {
          th: 'นาม่วง',
          en: 'Na Muang',
        },
        districtId: 445,
      },
      {
        id: '412502',
        zipcode: 41110,
        text: 'ห้วยสามพาด',
        value: 'ห้วยสามพาด',
        name: {
          th: 'ห้วยสามพาด',
          en: 'Huai Sam Phat',
        },
        districtId: 445,
      },
      {
        id: '412503',
        zipcode: 41110,
        text: 'อุ่มจาน',
        value: 'อุ่มจาน',
        name: {
          th: 'อุ่มจาน',
          en: 'Um Chan',
        },
        districtId: 445,
      },
      {
        id: '420101',
        zipcode: 42000,
        text: 'กุดป่อง',
        value: 'กุดป่อง',
        name: {
          th: 'กุดป่อง',
          en: 'Kut Pong',
        },
        districtId: 446,
      },
      {
        id: '420102',
        zipcode: 42000,
        text: 'เมือง',
        value: 'เมือง',
        name: {
          th: 'เมือง',
          en: 'Mueang',
        },
        districtId: 446,
      },
      {
        id: '420103',
        zipcode: 42100,
        text: 'นาอ้อ',
        value: 'นาอ้อ',
        name: {
          th: 'นาอ้อ',
          en: 'Na O',
        },
        districtId: 446,
      },
      {
        id: '420104',
        zipcode: 42000,
        text: 'กกดู่',
        value: 'กกดู่',
        name: {
          th: 'กกดู่',
          en: 'Kok Du',
        },
        districtId: 446,
      },
      {
        id: '420105',
        zipcode: 42000,
        text: 'น้ำหมาน',
        value: 'น้ำหมาน',
        name: {
          th: 'น้ำหมาน',
          en: 'Nam Man',
        },
        districtId: 446,
      },
      {
        id: '420106',
        zipcode: 42000,
        text: 'เสี้ยว',
        value: 'เสี้ยว',
        name: {
          th: 'เสี้ยว',
          en: 'Siao',
        },
        districtId: 446,
      },
      {
        id: '420107',
        zipcode: 42000,
        text: 'นาอาน',
        value: 'นาอาน',
        name: {
          th: 'นาอาน',
          en: 'Na An',
        },
        districtId: 446,
      },
      {
        id: '420108',
        zipcode: 42000,
        text: 'นาโป่ง',
        value: 'นาโป่ง',
        name: {
          th: 'นาโป่ง',
          en: 'Na Pong',
        },
        districtId: 446,
      },
      {
        id: '420109',
        zipcode: 42000,
        text: 'นาดินดำ',
        value: 'นาดินดำ',
        name: {
          th: 'นาดินดำ',
          en: 'Na Din Dam',
        },
        districtId: 446,
      },
      {
        id: '420110',
        zipcode: 42000,
        text: 'น้ำสวย',
        value: 'น้ำสวย',
        name: {
          th: 'น้ำสวย',
          en: 'Nam Suai',
        },
        districtId: 446,
      },
      {
        id: '420111',
        zipcode: 42000,
        text: 'ชัยพฤกษ์',
        value: 'ชัยพฤกษ์',
        name: {
          th: 'ชัยพฤกษ์',
          en: 'Chaiyaphruek',
        },
        districtId: 446,
      },
      {
        id: '420112',
        zipcode: 42000,
        text: 'นาแขม',
        value: 'นาแขม',
        name: {
          th: 'นาแขม',
          en: 'Na Khaem',
        },
        districtId: 446,
      },
      {
        id: '420113',
        zipcode: 42100,
        text: 'ศรีสองรัก',
        value: 'ศรีสองรัก',
        name: {
          th: 'ศรีสองรัก',
          en: 'Si Song Rak',
        },
        districtId: 446,
      },
      {
        id: '420114',
        zipcode: 42000,
        text: 'กกทอง',
        value: 'กกทอง',
        name: {
          th: 'กกทอง',
          en: 'Kok Thong',
        },
        districtId: 446,
      },
      {
        id: '420201',
        zipcode: 42210,
        text: 'นาด้วง',
        value: 'นาด้วง',
        name: {
          th: 'นาด้วง',
          en: 'Na Duang',
        },
        districtId: 447,
      },
      {
        id: '420202',
        zipcode: 42210,
        text: 'นาดอกคำ',
        value: 'นาดอกคำ',
        name: {
          th: 'นาดอกคำ',
          en: 'Na Dok Kham',
        },
        districtId: 447,
      },
      {
        id: '420203',
        zipcode: 42210,
        text: 'ท่าสะอาด',
        value: 'ท่าสะอาด',
        name: {
          th: 'ท่าสะอาด',
          en: 'Tha Sa-at',
        },
        districtId: 447,
      },
      {
        id: '420204',
        zipcode: 42210,
        text: 'ท่าสวรรค์',
        value: 'ท่าสวรรค์',
        name: {
          th: 'ท่าสวรรค์',
          en: 'Tha Sawan',
        },
        districtId: 447,
      },
      {
        id: '420301',
        zipcode: 42110,
        text: 'เชียงคาน',
        value: 'เชียงคาน',
        name: {
          th: 'เชียงคาน',
          en: 'Chiang Khan',
        },
        districtId: 448,
      },
      {
        id: '420302',
        zipcode: 42110,
        text: 'ธาตุ',
        value: 'ธาตุ',
        name: {
          th: 'ธาตุ',
          en: 'That',
        },
        districtId: 448,
      },
      {
        id: '420303',
        zipcode: 42110,
        text: 'นาซ่าว',
        value: 'นาซ่าว',
        name: {
          th: 'นาซ่าว',
          en: 'Na Sao',
        },
        districtId: 448,
      },
      {
        id: '420304',
        zipcode: 42110,
        text: 'เขาแก้ว',
        value: 'เขาแก้ว',
        name: {
          th: 'เขาแก้ว',
          en: 'Khao Kaeo',
        },
        districtId: 448,
      },
      {
        id: '420305',
        zipcode: 42110,
        text: 'ปากตม',
        value: 'ปากตม',
        name: {
          th: 'ปากตม',
          en: 'Pak Tom',
        },
        districtId: 448,
      },
      {
        id: '420306',
        zipcode: 42110,
        text: 'บุฮม',
        value: 'บุฮม',
        name: {
          th: 'บุฮม',
          en: 'Bu Hom',
        },
        districtId: 448,
      },
      {
        id: '420307',
        zipcode: 42110,
        text: 'จอมศรี',
        value: 'จอมศรี',
        name: {
          th: 'จอมศรี',
          en: 'Chom Si',
        },
        districtId: 448,
      },
      {
        id: '420308',
        zipcode: 42110,
        text: 'หาดทรายขาว',
        value: 'หาดทรายขาว',
        name: {
          th: 'หาดทรายขาว',
          en: 'Hat Sai Khao',
        },
        districtId: 448,
      },
      {
        id: '420401',
        zipcode: 42150,
        text: 'ปากชม',
        value: 'ปากชม',
        name: {
          th: 'ปากชม',
          en: 'Pak Chom',
        },
        districtId: 449,
      },
      {
        id: '420402',
        zipcode: 42150,
        text: 'เชียงกลม',
        value: 'เชียงกลม',
        name: {
          th: 'เชียงกลม',
          en: 'Chiang Klom',
        },
        districtId: 449,
      },
      {
        id: '420403',
        zipcode: 42150,
        text: 'หาดคัมภีร์',
        value: 'หาดคัมภีร์',
        name: {
          th: 'หาดคัมภีร์',
          en: 'Hat Khamphi',
        },
        districtId: 449,
      },
      {
        id: '420404',
        zipcode: 42150,
        text: 'ห้วยบ่อซืน',
        value: 'ห้วยบ่อซืน',
        name: {
          th: 'ห้วยบ่อซืน',
          en: 'Huai Bo Suen',
        },
        districtId: 449,
      },
      {
        id: '420405',
        zipcode: 42150,
        text: 'ห้วยพิชัย',
        value: 'ห้วยพิชัย',
        name: {
          th: 'ห้วยพิชัย',
          en: 'Huai Phichai',
        },
        districtId: 449,
      },
      {
        id: '420406',
        zipcode: 42150,
        text: 'ชมเจริญ',
        value: 'ชมเจริญ',
        name: {
          th: 'ชมเจริญ',
          en: 'Chom Charoen',
        },
        districtId: 449,
      },
      {
        id: '420501',
        zipcode: 42120,
        text: 'ด่านซ้าย',
        value: 'ด่านซ้าย',
        name: {
          th: 'ด่านซ้าย',
          en: 'Dan Sai',
        },
        districtId: 450,
      },
      {
        id: '420502',
        zipcode: 42120,
        text: 'ปากหมัน',
        value: 'ปากหมัน',
        name: {
          th: 'ปากหมัน',
          en: 'Pak Man',
        },
        districtId: 450,
      },
      {
        id: '420503',
        zipcode: 42120,
        text: 'นาดี',
        value: 'นาดี',
        name: {
          th: 'นาดี',
          en: 'Na Di',
        },
        districtId: 450,
      },
      {
        id: '420504',
        zipcode: 42120,
        text: 'โคกงาม',
        value: 'โคกงาม',
        name: {
          th: 'โคกงาม',
          en: 'Khok Ngam',
        },
        districtId: 450,
      },
      {
        id: '420505',
        zipcode: 42120,
        text: 'โพนสูง',
        value: 'โพนสูง',
        name: {
          th: 'โพนสูง',
          en: 'Phon Sung',
        },
        districtId: 450,
      },
      {
        id: '420506',
        zipcode: 42120,
        text: 'อิปุ่ม',
        value: 'อิปุ่ม',
        name: {
          th: 'อิปุ่ม',
          en: 'Ipum',
        },
        districtId: 450,
      },
      {
        id: '420507',
        zipcode: 42120,
        text: 'กกสะทอน',
        value: 'กกสะทอน',
        name: {
          th: 'กกสะทอน',
          en: 'Kok Sathon',
        },
        districtId: 450,
      },
      {
        id: '420508',
        zipcode: 42120,
        text: 'โป่ง',
        value: 'โป่ง',
        name: {
          th: 'โป่ง',
          en: 'Pong',
        },
        districtId: 450,
      },
      {
        id: '420509',
        zipcode: 42120,
        text: 'วังยาว',
        value: 'วังยาว',
        name: {
          th: 'วังยาว',
          en: 'Wang Yao',
        },
        districtId: 450,
      },
      {
        id: '420510',
        zipcode: 42120,
        text: 'นาหอ',
        value: 'นาหอ',
        name: {
          th: 'นาหอ',
          en: 'Na Ho',
        },
        districtId: 450,
      },
      {
        id: '420601',
        zipcode: 42170,
        text: 'นาแห้ว',
        value: 'นาแห้ว',
        name: {
          th: 'นาแห้ว',
          en: 'Na Haeo',
        },
        districtId: 451,
      },
      {
        id: '420602',
        zipcode: 42170,
        text: 'แสงภา',
        value: 'แสงภา',
        name: {
          th: 'แสงภา',
          en: 'Saeng Pha',
        },
        districtId: 451,
      },
      {
        id: '420603',
        zipcode: 42170,
        text: 'นาพึง',
        value: 'นาพึง',
        name: {
          th: 'นาพึง',
          en: 'Na Phueng',
        },
        districtId: 451,
      },
      {
        id: '420604',
        zipcode: 42170,
        text: 'นามาลา',
        value: 'นามาลา',
        name: {
          th: 'นามาลา',
          en: 'Na Ma La',
        },
        districtId: 451,
      },
      {
        id: '420605',
        zipcode: 42170,
        text: 'เหล่ากอหก',
        value: 'เหล่ากอหก',
        name: {
          th: 'เหล่ากอหก',
          en: 'Lao Ko Hok',
        },
        districtId: 451,
      },
      {
        id: '420701',
        zipcode: 42160,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 452,
      },
      {
        id: '420702',
        zipcode: 42160,
        text: 'ท่าศาลา',
        value: 'ท่าศาลา',
        name: {
          th: 'ท่าศาลา',
          en: 'Tha Sala',
        },
        districtId: 452,
      },
      {
        id: '420703',
        zipcode: 42160,
        text: 'ร่องจิก',
        value: 'ร่องจิก',
        name: {
          th: 'ร่องจิก',
          en: 'Rong Chik',
        },
        districtId: 452,
      },
      {
        id: '420704',
        zipcode: 42160,
        text: 'ปลาบ่า',
        value: 'ปลาบ่า',
        name: {
          th: 'ปลาบ่า',
          en: 'Pla Ba',
        },
        districtId: 452,
      },
      {
        id: '420705',
        zipcode: 42160,
        text: 'ลาดค่าง',
        value: 'ลาดค่าง',
        name: {
          th: 'ลาดค่าง',
          en: 'Lat Khang',
        },
        districtId: 452,
      },
      {
        id: '420706',
        zipcode: 42160,
        text: 'สานตม',
        value: 'สานตม',
        name: {
          th: 'สานตม',
          en: 'San Tom',
        },
        districtId: 452,
      },
      {
        id: '420801',
        zipcode: 42140,
        text: 'ท่าลี่',
        value: 'ท่าลี่',
        name: {
          th: 'ท่าลี่',
          en: 'Tha Li',
        },
        districtId: 453,
      },
      {
        id: '420802',
        zipcode: 42140,
        text: 'หนองผือ',
        value: 'หนองผือ',
        name: {
          th: 'หนองผือ',
          en: 'Nong Phue',
        },
        districtId: 453,
      },
      {
        id: '420803',
        zipcode: 42140,
        text: 'อาฮี',
        value: 'อาฮี',
        name: {
          th: 'อาฮี',
          en: 'A Hi',
        },
        districtId: 453,
      },
      {
        id: '420804',
        zipcode: 42140,
        text: 'น้ำแคม',
        value: 'น้ำแคม',
        name: {
          th: 'น้ำแคม',
          en: 'Nam Khaem',
        },
        districtId: 453,
      },
      {
        id: '420805',
        zipcode: 42140,
        text: 'โคกใหญ่',
        value: 'โคกใหญ่',
        name: {
          th: 'โคกใหญ่',
          en: 'Khok Yai',
        },
        districtId: 453,
      },
      {
        id: '420806',
        zipcode: 42140,
        text: 'น้ำทูน',
        value: 'น้ำทูน',
        name: {
          th: 'น้ำทูน',
          en: 'Nam Thun',
        },
        districtId: 453,
      },
      {
        id: '420901',
        zipcode: 42130,
        text: 'วังสะพุง',
        value: 'วังสะพุง',
        name: {
          th: 'วังสะพุง',
          en: 'Wang Saphung',
        },
        districtId: 454,
      },
      {
        id: '420902',
        zipcode: 42130,
        text: 'ทรายขาว',
        value: 'ทรายขาว',
        name: {
          th: 'ทรายขาว',
          en: 'Sai Khao',
        },
        districtId: 454,
      },
      {
        id: '420903',
        zipcode: 42130,
        text: 'หนองหญ้าปล้อง',
        value: 'หนองหญ้าปล้อง',
        name: {
          th: 'หนองหญ้าปล้อง',
          en: 'Nong Ya Plong',
        },
        districtId: 454,
      },
      {
        id: '420904',
        zipcode: 42130,
        text: 'หนองงิ้ว',
        value: 'หนองงิ้ว',
        name: {
          th: 'หนองงิ้ว',
          en: 'Nong Ngio',
        },
        districtId: 454,
      },
      {
        id: '420905',
        zipcode: 42130,
        text: 'ปากปวน',
        value: 'ปากปวน',
        name: {
          th: 'ปากปวน',
          en: 'Pak Puan',
        },
        districtId: 454,
      },
      {
        id: '420906',
        zipcode: 42130,
        text: 'ผาน้อย',
        value: 'ผาน้อย',
        name: {
          th: 'ผาน้อย',
          en: 'Pha Noi',
        },
        districtId: 454,
      },
      {
        id: '420910',
        zipcode: 42130,
        text: 'ผาบิ้ง',
        value: 'ผาบิ้ง',
        name: {
          th: 'ผาบิ้ง',
          en: 'Pha Bing',
        },
        districtId: 454,
      },
      {
        id: '420911',
        zipcode: 42130,
        text: 'เขาหลวง',
        value: 'เขาหลวง',
        name: {
          th: 'เขาหลวง',
          en: 'Khao Luang',
        },
        districtId: 454,
      },
      {
        id: '420912',
        zipcode: 42130,
        text: 'โคกขมิ้น',
        value: 'โคกขมิ้น',
        name: {
          th: 'โคกขมิ้น',
          en: 'Khok Khamin',
        },
        districtId: 454,
      },
      {
        id: '420913',
        zipcode: 42130,
        text: 'ศรีสงคราม',
        value: 'ศรีสงคราม',
        name: {
          th: 'ศรีสงคราม',
          en: 'Si Songkhram',
        },
        districtId: 454,
      },
      {
        id: '421001',
        zipcode: 42180,
        text: 'ศรีฐาน',
        value: 'ศรีฐาน',
        name: {
          th: 'ศรีฐาน',
          en: 'Si Than',
        },
        districtId: 455,
      },
      {
        id: '421005',
        zipcode: 42180,
        text: 'ผานกเค้า',
        value: 'ผานกเค้า',
        name: {
          th: 'ผานกเค้า',
          en: 'Pha Nok Khao',
        },
        districtId: 455,
      },
      {
        id: '421007',
        zipcode: 42180,
        text: 'ภูกระดึง',
        value: 'ภูกระดึง',
        name: {
          th: 'ภูกระดึง',
          en: 'Phu Kradueng',
        },
        districtId: 455,
      },
      {
        id: '421010',
        zipcode: 42180,
        text: 'ห้วยส้ม',
        value: 'ห้วยส้ม',
        name: {
          th: 'ห้วยส้ม',
          en: 'Huai Som',
        },
        districtId: 455,
      },
      {
        id: '421101',
        zipcode: 42230,
        text: 'ภูหอ',
        value: 'ภูหอ',
        name: {
          th: 'ภูหอ',
          en: 'Phu Ho',
        },
        districtId: 456,
      },
      {
        id: '421102',
        zipcode: 42230,
        text: 'หนองคัน',
        value: 'หนองคัน',
        name: {
          th: 'หนองคัน',
          en: 'Nong Khan',
        },
        districtId: 456,
      },
      {
        id: '421104',
        zipcode: 42230,
        text: 'ห้วยสีเสียด',
        value: 'ห้วยสีเสียด',
        name: {
          th: 'ห้วยสีเสียด',
          en: 'Huai Sisiat',
        },
        districtId: 456,
      },
      {
        id: '421105',
        zipcode: 42230,
        text: 'เลยวังไสย์',
        value: 'เลยวังไสย์',
        name: {
          th: 'เลยวังไสย์',
          en: 'Loei Wang Sai',
        },
        districtId: 456,
      },
      {
        id: '421106',
        zipcode: 42230,
        text: 'แก่งศรีภูมิ',
        value: 'แก่งศรีภูมิ',
        name: {
          th: 'แก่งศรีภูมิ',
          en: 'Kaeng Si Phum',
        },
        districtId: 456,
      },
      {
        id: '421201',
        zipcode: 42240,
        text: 'ผาขาว',
        value: 'ผาขาว',
        name: {
          th: 'ผาขาว',
          en: 'Pha Khao',
        },
        districtId: 457,
      },
      {
        id: '421202',
        zipcode: 42240,
        text: 'ท่าช้างคล้อง',
        value: 'ท่าช้างคล้อง',
        name: {
          th: 'ท่าช้างคล้อง',
          en: 'Tha Chang Khlong',
        },
        districtId: 457,
      },
      {
        id: '421203',
        zipcode: 42240,
        text: 'โนนปอแดง',
        value: 'โนนปอแดง',
        name: {
          th: 'โนนปอแดง',
          en: 'Non Po Daeng',
        },
        districtId: 457,
      },
      {
        id: '421204',
        zipcode: 42240,
        text: 'โนนป่าซาง',
        value: 'โนนป่าซาง',
        name: {
          th: 'โนนป่าซาง',
          en: 'Non Pa Sang',
        },
        districtId: 457,
      },
      {
        id: '421205',
        zipcode: 42240,
        text: 'บ้านเพิ่ม',
        value: 'บ้านเพิ่ม',
        name: {
          th: 'บ้านเพิ่ม',
          en: 'Ban Phoem',
        },
        districtId: 457,
      },
      {
        id: '421301',
        zipcode: 42220,
        text: 'เอราวัณ',
        value: 'เอราวัณ',
        name: {
          th: 'เอราวัณ',
          en: 'Erawan',
        },
        districtId: 458,
      },
      {
        id: '421302',
        zipcode: 42220,
        text: 'ผาอินทร์แปลง',
        value: 'ผาอินทร์แปลง',
        name: {
          th: 'ผาอินทร์แปลง',
          en: 'Pha In Plaeng',
        },
        districtId: 458,
      },
      {
        id: '421303',
        zipcode: 42220,
        text: 'ผาสามยอด',
        value: 'ผาสามยอด',
        name: {
          th: 'ผาสามยอด',
          en: 'Pha Sam Yot',
        },
        districtId: 458,
      },
      {
        id: '421304',
        zipcode: 42220,
        text: 'ทรัพย์ไพวัลย์',
        value: 'ทรัพย์ไพวัลย์',
        name: {
          th: 'ทรัพย์ไพวัลย์',
          en: 'Sap Phaiwan',
        },
        districtId: 458,
      },
      {
        id: '421401',
        zipcode: 42190,
        text: 'หนองหิน',
        value: 'หนองหิน',
        name: {
          th: 'หนองหิน',
          en: 'Nong Hin',
        },
        districtId: 459,
      },
      {
        id: '421402',
        zipcode: 42190,
        text: 'ตาดข่า',
        value: 'ตาดข่า',
        name: {
          th: 'ตาดข่า',
          en: 'Tat Kha',
        },
        districtId: 459,
      },
      {
        id: '421403',
        zipcode: 42190,
        text: 'ปวนพุ',
        value: 'ปวนพุ',
        name: {
          th: 'ปวนพุ',
          en: 'Puan Phu',
        },
        districtId: 459,
      },
      {
        id: '430101',
        zipcode: 43000,
        text: 'ในเมือง',
        value: 'ในเมือง',
        name: {
          th: 'ในเมือง',
          en: 'Nai Mueang',
        },
        districtId: 460,
      },
      {
        id: '430102',
        zipcode: 43000,
        text: 'มีชัย',
        value: 'มีชัย',
        name: {
          th: 'มีชัย',
          en: 'Mi Chai',
        },
        districtId: 460,
      },
      {
        id: '430103',
        zipcode: 43000,
        text: 'โพธิ์ชัย',
        value: 'โพธิ์ชัย',
        name: {
          th: 'โพธิ์ชัย',
          en: 'Pho Chai',
        },
        districtId: 460,
      },
      {
        id: '430104',
        zipcode: 43000,
        text: 'กวนวัน',
        value: 'กวนวัน',
        name: {
          th: 'กวนวัน',
          en: 'Kuan Wan',
        },
        districtId: 460,
      },
      {
        id: '430105',
        zipcode: 43000,
        text: 'เวียงคุก',
        value: 'เวียงคุก',
        name: {
          th: 'เวียงคุก',
          en: 'Wiang Khuk',
        },
        districtId: 460,
      },
      {
        id: '430106',
        zipcode: 43000,
        text: 'วัดธาตุ',
        value: 'วัดธาตุ',
        name: {
          th: 'วัดธาตุ',
          en: 'Wat That',
        },
        districtId: 460,
      },
      {
        id: '430107',
        zipcode: 43000,
        text: 'หาดคำ',
        value: 'หาดคำ',
        name: {
          th: 'หาดคำ',
          en: 'Hat Kham',
        },
        districtId: 460,
      },
      {
        id: '430108',
        zipcode: 43000,
        text: 'หินโงม',
        value: 'หินโงม',
        name: {
          th: 'หินโงม',
          en: 'Hin Ngom',
        },
        districtId: 460,
      },
      {
        id: '430109',
        zipcode: 43000,
        text: 'บ้านเดื่อ',
        value: 'บ้านเดื่อ',
        name: {
          th: 'บ้านเดื่อ',
          en: 'Ban Duea',
        },
        districtId: 460,
      },
      {
        id: '430110',
        zipcode: 43100,
        text: 'ค่ายบกหวาน',
        value: 'ค่ายบกหวาน',
        name: {
          th: 'ค่ายบกหวาน',
          en: 'Khai Bok Wan',
        },
        districtId: 460,
      },
      {
        id: '430111',
        zipcode: 43100,
        text: 'สองห้อง',
        value: 'สองห้อง',
        name: {
          th: 'สองห้อง',
          en: 'Song Hong',
        },
        districtId: 460,
      },
      {
        id: '430113',
        zipcode: 43100,
        text: 'พระธาตุบังพวน',
        value: 'พระธาตุบังพวน',
        name: {
          th: 'พระธาตุบังพวน',
          en: 'Phra That Bang Phuan',
        },
        districtId: 460,
      },
      {
        id: '430116',
        zipcode: 43000,
        text: 'หนองกอมเกาะ',
        value: 'หนองกอมเกาะ',
        name: {
          th: 'หนองกอมเกาะ',
          en: 'Nong Kom Ko',
        },
        districtId: 460,
      },
      {
        id: '430117',
        zipcode: 43000,
        text: 'ปะโค',
        value: 'ปะโค',
        name: {
          th: 'ปะโค',
          en: 'Pa Kho',
        },
        districtId: 460,
      },
      {
        id: '430118',
        zipcode: 43000,
        text: 'เมืองหมี',
        value: 'เมืองหมี',
        name: {
          th: 'เมืองหมี',
          en: 'Mueang Mi',
        },
        districtId: 460,
      },
      {
        id: '430119',
        zipcode: 43000,
        text: 'สีกาย',
        value: 'สีกาย',
        name: {
          th: 'สีกาย',
          en: 'Si Kai',
        },
        districtId: 460,
      },
      {
        id: '430201',
        zipcode: 43110,
        text: 'ท่าบ่อ',
        value: 'ท่าบ่อ',
        name: {
          th: 'ท่าบ่อ',
          en: 'Tha Bo',
        },
        districtId: 461,
      },
      {
        id: '430202',
        zipcode: 43110,
        text: 'น้ำโมง',
        value: 'น้ำโมง',
        name: {
          th: 'น้ำโมง',
          en: 'Nam Mong',
        },
        districtId: 461,
      },
      {
        id: '430203',
        zipcode: 43110,
        text: 'กองนาง',
        value: 'กองนาง',
        name: {
          th: 'กองนาง',
          en: 'Kong Nang',
        },
        districtId: 461,
      },
      {
        id: '430204',
        zipcode: 43110,
        text: 'โคกคอน',
        value: 'โคกคอน',
        name: {
          th: 'โคกคอน',
          en: 'Khok Khon',
        },
        districtId: 461,
      },
      {
        id: '430205',
        zipcode: 43110,
        text: 'บ้านเดื่อ',
        value: 'บ้านเดื่อ',
        name: {
          th: 'บ้านเดื่อ',
          en: 'Ban Duea',
        },
        districtId: 461,
      },
      {
        id: '430206',
        zipcode: 43110,
        text: 'บ้านถ่อน',
        value: 'บ้านถ่อน',
        name: {
          th: 'บ้านถ่อน',
          en: 'Ban Thon',
        },
        districtId: 461,
      },
      {
        id: '430207',
        zipcode: 43110,
        text: 'บ้านว่าน',
        value: 'บ้านว่าน',
        name: {
          th: 'บ้านว่าน',
          en: 'Ban Wan',
        },
        districtId: 461,
      },
      {
        id: '430208',
        zipcode: 43110,
        text: 'นาข่า',
        value: 'นาข่า',
        name: {
          th: 'นาข่า',
          en: 'Na Kha',
        },
        districtId: 461,
      },
      {
        id: '430209',
        zipcode: 43110,
        text: 'โพนสา',
        value: 'โพนสา',
        name: {
          th: 'โพนสา',
          en: 'Phon Sa',
        },
        districtId: 461,
      },
      {
        id: '430210',
        zipcode: 43110,
        text: 'หนองนาง',
        value: 'หนองนาง',
        name: {
          th: 'หนองนาง',
          en: 'Nong Nang',
        },
        districtId: 461,
      },
      {
        id: '430501',
        zipcode: 43120,
        text: 'จุมพล',
        value: 'จุมพล',
        name: {
          th: 'จุมพล',
          en: 'Chumphon',
        },
        districtId: 464,
      },
      {
        id: '430502',
        zipcode: 43120,
        text: 'วัดหลวง',
        value: 'วัดหลวง',
        name: {
          th: 'วัดหลวง',
          en: 'Wat Luang',
        },
        districtId: 464,
      },
      {
        id: '430503',
        zipcode: 43120,
        text: 'กุดบง',
        value: 'กุดบง',
        name: {
          th: 'กุดบง',
          en: 'Kut Bong',
        },
        districtId: 464,
      },
      {
        id: '430504',
        zipcode: 43120,
        text: 'ชุมช้าง',
        value: 'ชุมช้าง',
        name: {
          th: 'ชุมช้าง',
          en: 'Chum Chang',
        },
        districtId: 464,
      },
      {
        id: '430506',
        zipcode: 43120,
        text: 'ทุ่งหลวง',
        value: 'ทุ่งหลวง',
        name: {
          th: 'ทุ่งหลวง',
          en: 'Thung Luang',
        },
        districtId: 464,
      },
      {
        id: '430507',
        zipcode: 43120,
        text: 'เหล่าต่างคำ',
        value: 'เหล่าต่างคำ',
        name: {
          th: 'เหล่าต่างคำ',
          en: 'Lao Tang Kham',
        },
        districtId: 464,
      },
      {
        id: '430508',
        zipcode: 43120,
        text: 'นาหนัง',
        value: 'นาหนัง',
        name: {
          th: 'นาหนัง',
          en: 'Na Nang',
        },
        districtId: 464,
      },
      {
        id: '430509',
        zipcode: 43120,
        text: 'เซิม',
        value: 'เซิม',
        name: {
          th: 'เซิม',
          en: 'Soem',
        },
        districtId: 464,
      },
      {
        id: '430513',
        zipcode: 43120,
        text: 'บ้านโพธิ์',
        value: 'บ้านโพธิ์',
        name: {
          th: 'บ้านโพธิ์',
          en: 'Ban Pho',
        },
        districtId: 464,
      },
      {
        id: '430521',
        zipcode: 43120,
        text: 'บ้านผือ',
        value: 'บ้านผือ',
        name: {
          th: 'บ้านผือ',
          en: 'Ban Phue',
        },
        districtId: 464,
      },
      {
        id: '430522',
        zipcode: 43120,
        text: 'สร้างนางขาว',
        value: 'สร้างนางขาว',
        name: {
          th: 'สร้างนางขาว',
          en: 'Sang Nang Khao',
        },
        districtId: 464,
      },
      {
        id: '430701',
        zipcode: 43130,
        text: 'พานพร้าว',
        value: 'พานพร้าว',
        name: {
          th: 'พานพร้าว',
          en: 'Phan Phrao',
        },
        districtId: 466,
      },
      {
        id: '430703',
        zipcode: 43130,
        text: 'บ้านหม้อ',
        value: 'บ้านหม้อ',
        name: {
          th: 'บ้านหม้อ',
          en: 'Ban Mo',
        },
        districtId: 466,
      },
      {
        id: '430704',
        zipcode: 43130,
        text: 'พระพุทธบาท',
        value: 'พระพุทธบาท',
        name: {
          th: 'พระพุทธบาท',
          en: 'Phra Phutthabat',
        },
        districtId: 466,
      },
      {
        id: '430705',
        zipcode: 43130,
        text: 'หนองปลาปาก',
        value: 'หนองปลาปาก',
        name: {
          th: 'หนองปลาปาก',
          en: 'Nong Pla Pak',
        },
        districtId: 466,
      },
      {
        id: '430801',
        zipcode: 43160,
        text: 'แก้งไก่',
        value: 'แก้งไก่',
        name: {
          th: 'แก้งไก่',
          en: 'Kaeng Kai',
        },
        districtId: 467,
      },
      {
        id: '430802',
        zipcode: 43160,
        text: 'ผาตั้ง',
        value: 'ผาตั้ง',
        name: {
          th: 'ผาตั้ง',
          en: 'Pha Tang',
        },
        districtId: 467,
      },
      {
        id: '430803',
        zipcode: 43160,
        text: 'บ้านม่วง',
        value: 'บ้านม่วง',
        name: {
          th: 'บ้านม่วง',
          en: 'Ban Muang',
        },
        districtId: 467,
      },
      {
        id: '430804',
        zipcode: 43160,
        text: 'นางิ้ว',
        value: 'นางิ้ว',
        name: {
          th: 'นางิ้ว',
          en: 'Na Ngio',
        },
        districtId: 467,
      },
      {
        id: '430805',
        zipcode: 43160,
        text: 'สังคม',
        value: 'สังคม',
        name: {
          th: 'สังคม',
          en: 'Sangkhom',
        },
        districtId: 467,
      },
      {
        id: '431401',
        zipcode: 43100,
        text: 'สระใคร',
        value: 'สระใคร',
        name: {
          th: 'สระใคร',
          en: 'Sakhrai',
        },
        districtId: 473,
      },
      {
        id: '431402',
        zipcode: 43100,
        text: 'คอกช้าง',
        value: 'คอกช้าง',
        name: {
          th: 'คอกช้าง',
          en: 'Khok Chang',
        },
        districtId: 473,
      },
      {
        id: '431403',
        zipcode: 43100,
        text: 'บ้านฝาง',
        value: 'บ้านฝาง',
        name: {
          th: 'บ้านฝาง',
          en: 'Ban Fang',
        },
        districtId: 473,
      },
      {
        id: '431501',
        zipcode: 43120,
        text: 'เฝ้าไร่',
        value: 'เฝ้าไร่',
        name: {
          th: 'เฝ้าไร่',
          en: 'Fao Rai',
        },
        districtId: 474,
      },
      {
        id: '431502',
        zipcode: 43120,
        text: 'นาดี',
        value: 'นาดี',
        name: {
          th: 'นาดี',
          en: 'Na Di',
        },
        districtId: 474,
      },
      {
        id: '431503',
        zipcode: 43120,
        text: 'หนองหลวง',
        value: 'หนองหลวง',
        name: {
          th: 'หนองหลวง',
          en: 'Nong Luang',
        },
        districtId: 474,
      },
      {
        id: '431504',
        zipcode: 43120,
        text: 'วังหลวง',
        value: 'วังหลวง',
        name: {
          th: 'วังหลวง',
          en: 'Wang Luang',
        },
        districtId: 474,
      },
      {
        id: '431505',
        zipcode: 43120,
        text: 'อุดมพร',
        value: 'อุดมพร',
        name: {
          th: 'อุดมพร',
          en: 'Udom Phon',
        },
        districtId: 474,
      },
      {
        id: '431601',
        zipcode: 43120,
        text: 'รัตนวาปี',
        value: 'รัตนวาปี',
        name: {
          th: 'รัตนวาปี',
          en: 'Rattanawapi',
        },
        districtId: 475,
      },
      {
        id: '431602',
        zipcode: 43120,
        text: 'นาทับไฮ',
        value: 'นาทับไฮ',
        name: {
          th: 'นาทับไฮ',
          en: 'Na Thap Hai',
        },
        districtId: 475,
      },
      {
        id: '431603',
        zipcode: 43120,
        text: 'บ้านต้อน',
        value: 'บ้านต้อน',
        name: {
          th: 'บ้านต้อน',
          en: 'Ban Ton',
        },
        districtId: 475,
      },
      {
        id: '431604',
        zipcode: 43120,
        text: 'พระบาทนาสิงห์',
        value: 'พระบาทนาสิงห์',
        name: {
          th: 'พระบาทนาสิงห์',
          en: 'Phra Bat Na Sing',
        },
        districtId: 475,
      },
      {
        id: '431605',
        zipcode: 43120,
        text: 'โพนแพง',
        value: 'โพนแพง',
        name: {
          th: 'โพนแพง',
          en: 'Phon Phaeng',
        },
        districtId: 475,
      },
      {
        id: '431701',
        zipcode: 43130,
        text: 'โพธิ์ตาก',
        value: 'โพธิ์ตาก',
        name: {
          th: 'โพธิ์ตาก',
          en: 'Pho Tak',
        },
        districtId: 476,
      },
      {
        id: '431702',
        zipcode: 43130,
        text: 'โพนทอง',
        value: 'โพนทอง',
        name: {
          th: 'โพนทอง',
          en: 'Phon Thong',
        },
        districtId: 476,
      },
      {
        id: '431703',
        zipcode: 43130,
        text: 'ด่านศรีสุข',
        value: 'ด่านศรีสุข',
        name: {
          th: 'ด่านศรีสุข',
          en: 'Dan Si Suk',
        },
        districtId: 476,
      },
      {
        id: '440101',
        zipcode: 44000,
        text: 'ตลาด',
        value: 'ตลาด',
        name: {
          th: 'ตลาด',
          en: 'Talat',
        },
        districtId: 477,
      },
      {
        id: '440102',
        zipcode: 44000,
        text: 'เขวา',
        value: 'เขวา',
        name: {
          th: 'เขวา',
          en: 'Khwao',
        },
        districtId: 477,
      },
      {
        id: '440103',
        zipcode: 44000,
        text: 'ท่าตูม',
        value: 'ท่าตูม',
        name: {
          th: 'ท่าตูม',
          en: 'Tha Tum',
        },
        districtId: 477,
      },
      {
        id: '440104',
        zipcode: 44000,
        text: 'แวงน่าง',
        value: 'แวงน่าง',
        name: {
          th: 'แวงน่าง',
          en: 'Waeng Nang',
        },
        districtId: 477,
      },
      {
        id: '440105',
        zipcode: 44000,
        text: 'โคกก่อ',
        value: 'โคกก่อ',
        name: {
          th: 'โคกก่อ',
          en: 'Khok Ko',
        },
        districtId: 477,
      },
      {
        id: '440106',
        zipcode: 44000,
        text: 'ดอนหว่าน',
        value: 'ดอนหว่าน',
        name: {
          th: 'ดอนหว่าน',
          en: 'Don Wan',
        },
        districtId: 477,
      },
      {
        id: '440107',
        zipcode: 44000,
        text: 'เกิ้ง',
        value: 'เกิ้ง',
        name: {
          th: 'เกิ้ง',
          en: 'Koeng',
        },
        districtId: 477,
      },
      {
        id: '440108',
        zipcode: 44000,
        text: 'แก่งเลิงจาน',
        value: 'แก่งเลิงจาน',
        name: {
          th: 'แก่งเลิงจาน',
          en: 'Kaeng Loeng Chan',
        },
        districtId: 477,
      },
      {
        id: '440109',
        zipcode: 44000,
        text: 'ท่าสองคอน',
        value: 'ท่าสองคอน',
        name: {
          th: 'ท่าสองคอน',
          en: 'Tha Song Khon',
        },
        districtId: 477,
      },
      {
        id: '440110',
        zipcode: 44000,
        text: 'ลาดพัฒนา',
        value: 'ลาดพัฒนา',
        name: {
          th: 'ลาดพัฒนา',
          en: 'Lat Phatthana',
        },
        districtId: 477,
      },
      {
        id: '440111',
        zipcode: 44000,
        text: 'หนองปลิง',
        value: 'หนองปลิง',
        name: {
          th: 'หนองปลิง',
          en: 'Nong Pling',
        },
        districtId: 477,
      },
      {
        id: '440112',
        zipcode: 44000,
        text: 'ห้วยแอ่ง',
        value: 'ห้วยแอ่ง',
        name: {
          th: 'ห้วยแอ่ง',
          en: 'Huai Aeng',
        },
        districtId: 477,
      },
      {
        id: '440113',
        zipcode: 44000,
        text: 'หนองโน',
        value: 'หนองโน',
        name: {
          th: 'หนองโน',
          en: 'Nong No',
        },
        districtId: 477,
      },
      {
        id: '440114',
        zipcode: 44000,
        text: 'บัวค้อ',
        value: 'บัวค้อ',
        name: {
          th: 'บัวค้อ',
          en: 'Bua Kho',
        },
        districtId: 477,
      },
      {
        id: '440201',
        zipcode: 44190,
        text: 'แกดำ',
        value: 'แกดำ',
        name: {
          th: 'แกดำ',
          en: 'Kae Dam',
        },
        districtId: 478,
      },
      {
        id: '440202',
        zipcode: 44190,
        text: 'วังแสง',
        value: 'วังแสง',
        name: {
          th: 'วังแสง',
          en: 'Wang Saeng',
        },
        districtId: 478,
      },
      {
        id: '440203',
        zipcode: 44190,
        text: 'มิตรภาพ',
        value: 'มิตรภาพ',
        name: {
          th: 'มิตรภาพ',
          en: 'Mittraphap',
        },
        districtId: 478,
      },
      {
        id: '440204',
        zipcode: 44190,
        text: 'หนองกุง',
        value: 'หนองกุง',
        name: {
          th: 'หนองกุง',
          en: 'Nong Kung',
        },
        districtId: 478,
      },
      {
        id: '440205',
        zipcode: 44190,
        text: 'โนนภิบาล',
        value: 'โนนภิบาล',
        name: {
          th: 'โนนภิบาล',
          en: 'Non Phiban',
        },
        districtId: 478,
      },
      {
        id: '440301',
        zipcode: 44140,
        text: 'หัวขวาง',
        value: 'หัวขวาง',
        name: {
          th: 'หัวขวาง',
          en: 'Hua Khwang',
        },
        districtId: 479,
      },
      {
        id: '440302',
        zipcode: 44140,
        text: 'ยางน้อย',
        value: 'ยางน้อย',
        name: {
          th: 'ยางน้อย',
          en: 'Yang Noi',
        },
        districtId: 479,
      },
      {
        id: '440303',
        zipcode: 44140,
        text: 'วังยาว',
        value: 'วังยาว',
        name: {
          th: 'วังยาว',
          en: 'Wang Yao',
        },
        districtId: 479,
      },
      {
        id: '440304',
        zipcode: 44140,
        text: 'เขวาไร่',
        value: 'เขวาไร่',
        name: {
          th: 'เขวาไร่',
          en: 'Khwao Rai',
        },
        districtId: 479,
      },
      {
        id: '440305',
        zipcode: 44140,
        text: 'แพง',
        value: 'แพง',
        name: {
          th: 'แพง',
          en: 'Phaeng',
        },
        districtId: 479,
      },
      {
        id: '440306',
        zipcode: 44140,
        text: 'แก้งแก',
        value: 'แก้งแก',
        name: {
          th: 'แก้งแก',
          en: 'Kaeng Kae',
        },
        districtId: 479,
      },
      {
        id: '440307',
        zipcode: 44140,
        text: 'หนองเหล็ก',
        value: 'หนองเหล็ก',
        name: {
          th: 'หนองเหล็ก',
          en: 'Nong Lek',
        },
        districtId: 479,
      },
      {
        id: '440308',
        zipcode: 44140,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 479,
      },
      {
        id: '440309',
        zipcode: 44140,
        text: 'เหล่า',
        value: 'เหล่า',
        name: {
          th: 'เหล่า',
          en: 'Lao',
        },
        districtId: 479,
      },
      {
        id: '440310',
        zipcode: 44140,
        text: 'เขื่อน',
        value: 'เขื่อน',
        name: {
          th: 'เขื่อน',
          en: 'Khuean',
        },
        districtId: 479,
      },
      {
        id: '440311',
        zipcode: 44140,
        text: 'หนองบอน',
        value: 'หนองบอน',
        name: {
          th: 'หนองบอน',
          en: 'Nong Bua',
        },
        districtId: 479,
      },
      {
        id: '440312',
        zipcode: 44140,
        text: 'โพนงาม',
        value: 'โพนงาม',
        name: {
          th: 'โพนงาม',
          en: 'Phon Ngam',
        },
        districtId: 479,
      },
      {
        id: '440313',
        zipcode: 44140,
        text: 'ยางท่าแจ้ง',
        value: 'ยางท่าแจ้ง',
        name: {
          th: 'ยางท่าแจ้ง',
          en: 'Yang Tha Chaeng',
        },
        districtId: 479,
      },
      {
        id: '440314',
        zipcode: 44140,
        text: 'แห่ใต้',
        value: 'แห่ใต้',
        name: {
          th: 'แห่ใต้',
          en: 'Hae Tai',
        },
        districtId: 479,
      },
      {
        id: '440315',
        zipcode: 44140,
        text: 'หนองกุงสวรรค์',
        value: 'หนองกุงสวรรค์',
        name: {
          th: 'หนองกุงสวรรค์',
          en: 'Nong Kung Sawan',
        },
        districtId: 479,
      },
      {
        id: '440316',
        zipcode: 44140,
        text: 'เลิงใต้',
        value: 'เลิงใต้',
        name: {
          th: 'เลิงใต้',
          en: 'Loeng Tai',
        },
        districtId: 479,
      },
      {
        id: '440317',
        zipcode: 44140,
        text: 'ดอนกลาง',
        value: 'ดอนกลาง',
        name: {
          th: 'ดอนกลาง',
          en: 'Don Klang',
        },
        districtId: 479,
      },
      {
        id: '440401',
        zipcode: 44150,
        text: 'โคกพระ',
        value: 'โคกพระ',
        name: {
          th: 'โคกพระ',
          en: 'Khok Phra',
        },
        districtId: 480,
      },
      {
        id: '440402',
        zipcode: 44150,
        text: 'คันธารราษฎร์',
        value: 'คันธารราษฎร์',
        name: {
          th: 'คันธารราษฎร์',
          en: 'Khanthararat',
        },
        districtId: 480,
      },
      {
        id: '440403',
        zipcode: 44150,
        text: 'มะค่า',
        value: 'มะค่า',
        name: {
          th: 'มะค่า',
          en: 'Makha',
        },
        districtId: 480,
      },
      {
        id: '440404',
        zipcode: 44150,
        text: 'ท่าขอนยาง',
        value: 'ท่าขอนยาง',
        name: {
          th: 'ท่าขอนยาง',
          en: 'Tha Khon Yang',
        },
        districtId: 480,
      },
      {
        id: '440405',
        zipcode: 44150,
        text: 'นาสีนวน',
        value: 'นาสีนวน',
        name: {
          th: 'นาสีนวน',
          en: 'Na Si Nuan',
        },
        districtId: 480,
      },
      {
        id: '440406',
        zipcode: 44150,
        text: 'ขามเรียง',
        value: 'ขามเรียง',
        name: {
          th: 'ขามเรียง',
          en: 'Kham Riang',
        },
        districtId: 480,
      },
      {
        id: '440407',
        zipcode: 44150,
        text: 'เขวาใหญ่',
        value: 'เขวาใหญ่',
        name: {
          th: 'เขวาใหญ่',
          en: 'Khwao Yai',
        },
        districtId: 480,
      },
      {
        id: '440408',
        zipcode: 44150,
        text: 'ศรีสุข',
        value: 'ศรีสุข',
        name: {
          th: 'ศรีสุข',
          en: 'Si Suk',
        },
        districtId: 480,
      },
      {
        id: '440409',
        zipcode: 44150,
        text: 'กุดใส้จ่อ',
        value: 'กุดใส้จ่อ',
        name: {
          th: 'กุดใส้จ่อ',
          en: 'Kut Sai Cho',
        },
        districtId: 480,
      },
      {
        id: '440410',
        zipcode: 44150,
        text: 'ขามเฒ่าพัฒนา',
        value: 'ขามเฒ่าพัฒนา',
        name: {
          th: 'ขามเฒ่าพัฒนา',
          en: 'Kham Thao Phatthana',
        },
        districtId: 480,
      },
      {
        id: '440501',
        zipcode: 44160,
        text: 'เชียงยืน',
        value: 'เชียงยืน',
        name: {
          th: 'เชียงยืน',
          en: 'Chiang Yuen',
        },
        districtId: 481,
      },
      {
        id: '440503',
        zipcode: 44160,
        text: 'หนองซอน',
        value: 'หนองซอน',
        name: {
          th: 'หนองซอน',
          en: 'Nong Son',
        },
        districtId: 481,
      },
      {
        id: '440505',
        zipcode: 44160,
        text: 'ดอนเงิน',
        value: 'ดอนเงิน',
        name: {
          th: 'ดอนเงิน',
          en: 'Don Ngoen',
        },
        districtId: 481,
      },
      {
        id: '440506',
        zipcode: 44160,
        text: 'กู่ทอง',
        value: 'กู่ทอง',
        name: {
          th: 'กู่ทอง',
          en: 'Ku Thong',
        },
        districtId: 481,
      },
      {
        id: '440507',
        zipcode: 44160,
        text: 'นาทอง',
        value: 'นาทอง',
        name: {
          th: 'นาทอง',
          en: 'Na Thong',
        },
        districtId: 481,
      },
      {
        id: '440508',
        zipcode: 44160,
        text: 'เสือเฒ่า',
        value: 'เสือเฒ่า',
        name: {
          th: 'เสือเฒ่า',
          en: 'Suea Thao',
        },
        districtId: 481,
      },
      {
        id: '440511',
        zipcode: 44160,
        text: 'โพนทอง',
        value: 'โพนทอง',
        name: {
          th: 'โพนทอง',
          en: 'Phon Thong',
        },
        districtId: 481,
      },
      {
        id: '440512',
        zipcode: 44160,
        text: 'เหล่าบัวบาน',
        value: 'เหล่าบัวบาน',
        name: {
          th: 'เหล่าบัวบาน',
          en: 'Lao Bua Ban',
        },
        districtId: 481,
      },
      {
        id: '440601',
        zipcode: 44130,
        text: 'บรบือ',
        value: 'บรบือ',
        name: {
          th: 'บรบือ',
          en: 'Borabue',
        },
        districtId: 482,
      },
      {
        id: '440602',
        zipcode: 44130,
        text: 'บ่อใหญ่',
        value: 'บ่อใหญ่',
        name: {
          th: 'บ่อใหญ่',
          en: 'Bo Yai',
        },
        districtId: 482,
      },
      {
        id: '440604',
        zipcode: 44130,
        text: 'วังไชย',
        value: 'วังไชย',
        name: {
          th: 'วังไชย',
          en: 'Wang Chai',
        },
        districtId: 482,
      },
      {
        id: '440605',
        zipcode: 44130,
        text: 'หนองม่วง',
        value: 'หนองม่วง',
        name: {
          th: 'หนองม่วง',
          en: 'Nong Muang',
        },
        districtId: 482,
      },
      {
        id: '440606',
        zipcode: 44130,
        text: 'กำพี้',
        value: 'กำพี้',
        name: {
          th: 'กำพี้',
          en: 'Kamphi',
        },
        districtId: 482,
      },
      {
        id: '440607',
        zipcode: 44130,
        text: 'โนนราษี',
        value: 'โนนราษี',
        name: {
          th: 'โนนราษี',
          en: 'Non Rasi',
        },
        districtId: 482,
      },
      {
        id: '440608',
        zipcode: 44130,
        text: 'โนนแดง',
        value: 'โนนแดง',
        name: {
          th: 'โนนแดง',
          en: 'Non Daeng',
        },
        districtId: 482,
      },
      {
        id: '440610',
        zipcode: 44130,
        text: 'หนองจิก',
        value: 'หนองจิก',
        name: {
          th: 'หนองจิก',
          en: 'Nong Chik',
        },
        districtId: 482,
      },
      {
        id: '440611',
        zipcode: 44130,
        text: 'บัวมาศ',
        value: 'บัวมาศ',
        name: {
          th: 'บัวมาศ',
          en: 'Bua Mat',
        },
        districtId: 482,
      },
      {
        id: '440613',
        zipcode: 44130,
        text: 'หนองคูขาด',
        value: 'หนองคูขาด',
        name: {
          th: 'หนองคูขาด',
          en: 'Nong Khu Khat',
        },
        districtId: 482,
      },
      {
        id: '440615',
        zipcode: 44130,
        text: 'วังใหม่',
        value: 'วังใหม่',
        name: {
          th: 'วังใหม่',
          en: 'Wang Mai',
        },
        districtId: 482,
      },
      {
        id: '440616',
        zipcode: 44130,
        text: 'ยาง',
        value: 'ยาง',
        name: {
          th: 'ยาง',
          en: 'Yang',
        },
        districtId: 482,
      },
      {
        id: '440618',
        zipcode: 44130,
        text: 'หนองสิม',
        value: 'หนองสิม',
        name: {
          th: 'หนองสิม',
          en: 'Nong Sim',
        },
        districtId: 482,
      },
      {
        id: '440619',
        zipcode: 44130,
        text: 'หนองโก',
        value: 'หนองโก',
        name: {
          th: 'หนองโก',
          en: 'Nong Ko',
        },
        districtId: 482,
      },
      {
        id: '440620',
        zipcode: 44130,
        text: 'ดอนงัว',
        value: 'ดอนงัว',
        name: {
          th: 'ดอนงัว',
          en: 'Don Ngua',
        },
        districtId: 482,
      },
      {
        id: '440701',
        zipcode: 44170,
        text: 'นาเชือก',
        value: 'นาเชือก',
        name: {
          th: 'นาเชือก',
          en: 'Na Chueak',
        },
        districtId: 483,
      },
      {
        id: '440702',
        zipcode: 44170,
        text: 'สำโรง',
        value: 'สำโรง',
        name: {
          th: 'สำโรง',
          en: 'Samrong',
        },
        districtId: 483,
      },
      {
        id: '440703',
        zipcode: 44170,
        text: 'หนองแดง',
        value: 'หนองแดง',
        name: {
          th: 'หนองแดง',
          en: 'Nong Daeng',
        },
        districtId: 483,
      },
      {
        id: '440704',
        zipcode: 44170,
        text: 'เขวาไร่',
        value: 'เขวาไร่',
        name: {
          th: 'เขวาไร่',
          en: 'Khwao Rai',
        },
        districtId: 483,
      },
      {
        id: '440705',
        zipcode: 44170,
        text: 'หนองโพธิ์',
        value: 'หนองโพธิ์',
        name: {
          th: 'หนองโพธิ์',
          en: 'Nong Pho',
        },
        districtId: 483,
      },
      {
        id: '440706',
        zipcode: 44170,
        text: 'ปอพาน',
        value: 'ปอพาน',
        name: {
          th: 'ปอพาน',
          en: 'Po Phan',
        },
        districtId: 483,
      },
      {
        id: '440707',
        zipcode: 44170,
        text: 'หนองเม็ก',
        value: 'หนองเม็ก',
        name: {
          th: 'หนองเม็ก',
          en: 'Nong Mek',
        },
        districtId: 483,
      },
      {
        id: '440708',
        zipcode: 44170,
        text: 'หนองเรือ',
        value: 'หนองเรือ',
        name: {
          th: 'หนองเรือ',
          en: 'Nong Ruea',
        },
        districtId: 483,
      },
      {
        id: '440709',
        zipcode: 44170,
        text: 'หนองกุง',
        value: 'หนองกุง',
        name: {
          th: 'หนองกุง',
          en: 'Nong Kung',
        },
        districtId: 483,
      },
      {
        id: '440710',
        zipcode: 44170,
        text: 'สันป่าตอง',
        value: 'สันป่าตอง',
        name: {
          th: 'สันป่าตอง',
          en: 'San Pa Ton',
        },
        districtId: 483,
      },
      {
        id: '440801',
        zipcode: 44110,
        text: 'ปะหลาน',
        value: 'ปะหลาน',
        name: {
          th: 'ปะหลาน',
          en: 'Palan',
        },
        districtId: 484,
      },
      {
        id: '440802',
        zipcode: 44110,
        text: 'ก้ามปู',
        value: 'ก้ามปู',
        name: {
          th: 'ก้ามปู',
          en: 'Kam Pu',
        },
        districtId: 484,
      },
      {
        id: '440803',
        zipcode: 44110,
        text: 'เวียงสะอาด',
        value: 'เวียงสะอาด',
        name: {
          th: 'เวียงสะอาด',
          en: 'Wiang Sa-at',
        },
        districtId: 484,
      },
      {
        id: '440804',
        zipcode: 44110,
        text: 'เม็กดำ',
        value: 'เม็กดำ',
        name: {
          th: 'เม็กดำ',
          en: 'Mek Dam',
        },
        districtId: 484,
      },
      {
        id: '440805',
        zipcode: 44110,
        text: 'นาสีนวล',
        value: 'นาสีนวล',
        name: {
          th: 'นาสีนวล',
          en: 'Na Si Nuan',
        },
        districtId: 484,
      },
      {
        id: '440809',
        zipcode: 44110,
        text: 'ราษฎร์เจริญ',
        value: 'ราษฎร์เจริญ',
        name: {
          th: 'ราษฎร์เจริญ',
          en: 'Rat Charoen',
        },
        districtId: 484,
      },
      {
        id: '440810',
        zipcode: 44110,
        text: 'หนองบัวแก้ว',
        value: 'หนองบัวแก้ว',
        name: {
          th: 'หนองบัวแก้ว',
          en: 'Nong Bua Kaeo',
        },
        districtId: 484,
      },
      {
        id: '440812',
        zipcode: 44110,
        text: 'เมืองเตา',
        value: 'เมืองเตา',
        name: {
          th: 'เมืองเตา',
          en: 'Mueang Tao',
        },
        districtId: 484,
      },
      {
        id: '440815',
        zipcode: 44110,
        text: 'ลานสะแก',
        value: 'ลานสะแก',
        name: {
          th: 'ลานสะแก',
          en: 'Lan Sakae',
        },
        districtId: 484,
      },
      {
        id: '440816',
        zipcode: 44110,
        text: 'เวียงชัย',
        value: 'เวียงชัย',
        name: {
          th: 'เวียงชัย',
          en: 'Wiang Chai',
        },
        districtId: 484,
      },
      {
        id: '440817',
        zipcode: 44110,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 484,
      },
      {
        id: '440818',
        zipcode: 44110,
        text: 'ราษฎร์พัฒนา',
        value: 'ราษฎร์พัฒนา',
        name: {
          th: 'ราษฎร์พัฒนา',
          en: 'Rat Phatthana',
        },
        districtId: 484,
      },
      {
        id: '440819',
        zipcode: 44110,
        text: 'เมืองเสือ',
        value: 'เมืองเสือ',
        name: {
          th: 'เมืองเสือ',
          en: 'Mueang Suea',
        },
        districtId: 484,
      },
      {
        id: '440820',
        zipcode: 44110,
        text: 'ภารแอ่น',
        value: 'ภารแอ่น',
        name: {
          th: 'ภารแอ่น',
          en: 'Phan Aen',
        },
        districtId: 484,
      },
      {
        id: '440901',
        zipcode: 44120,
        text: 'หนองแสง',
        value: 'หนองแสง',
        name: {
          th: 'หนองแสง',
          en: 'Nong Saeng',
        },
        districtId: 485,
      },
      {
        id: '440902',
        zipcode: 44120,
        text: 'ขามป้อม',
        value: 'ขามป้อม',
        name: {
          th: 'ขามป้อม',
          en: 'Kham Pom',
        },
        districtId: 485,
      },
      {
        id: '440903',
        zipcode: 44120,
        text: 'เสือโก้ก',
        value: 'เสือโก้ก',
        name: {
          th: 'เสือโก้ก',
          en: 'Suea Kok',
        },
        districtId: 485,
      },
      {
        id: '440904',
        zipcode: 44120,
        text: 'ดงใหญ่',
        value: 'ดงใหญ่',
        name: {
          th: 'ดงใหญ่',
          en: 'Dong Yai',
        },
        districtId: 485,
      },
      {
        id: '440905',
        zipcode: 44120,
        text: 'โพธิ์ชัย',
        value: 'โพธิ์ชัย',
        name: {
          th: 'โพธิ์ชัย',
          en: 'Pho Chai',
        },
        districtId: 485,
      },
      {
        id: '440906',
        zipcode: 44120,
        text: 'หัวเรือ',
        value: 'หัวเรือ',
        name: {
          th: 'หัวเรือ',
          en: 'Hua Ruea',
        },
        districtId: 485,
      },
      {
        id: '440907',
        zipcode: 44120,
        text: 'แคน',
        value: 'แคน',
        name: {
          th: 'แคน',
          en: 'Khaen',
        },
        districtId: 485,
      },
      {
        id: '440908',
        zipcode: 44120,
        text: 'งัวบา',
        value: 'งัวบา',
        name: {
          th: 'งัวบา',
          en: 'Ngua Ba',
        },
        districtId: 485,
      },
      {
        id: '440909',
        zipcode: 44120,
        text: 'นาข่า',
        value: 'นาข่า',
        name: {
          th: 'นาข่า',
          en: 'Na Kha',
        },
        districtId: 485,
      },
      {
        id: '440910',
        zipcode: 44120,
        text: 'บ้านหวาย',
        value: 'บ้านหวาย',
        name: {
          th: 'บ้านหวาย',
          en: 'Ban Wai',
        },
        districtId: 485,
      },
      {
        id: '440911',
        zipcode: 44120,
        text: 'หนองไฮ',
        value: 'หนองไฮ',
        name: {
          th: 'หนองไฮ',
          en: 'Nong Hai',
        },
        districtId: 485,
      },
      {
        id: '440912',
        zipcode: 44120,
        text: 'ประชาพัฒนา',
        value: 'ประชาพัฒนา',
        name: {
          th: 'ประชาพัฒนา',
          en: 'Pracha Phatthana',
        },
        districtId: 485,
      },
      {
        id: '440913',
        zipcode: 44120,
        text: 'หนองทุ่ม',
        value: 'หนองทุ่ม',
        name: {
          th: 'หนองทุ่ม',
          en: 'Nong Thum',
        },
        districtId: 485,
      },
      {
        id: '440914',
        zipcode: 44120,
        text: 'หนองแสน',
        value: 'หนองแสน',
        name: {
          th: 'หนองแสน',
          en: 'Nong Saen',
        },
        districtId: 485,
      },
      {
        id: '440915',
        zipcode: 44120,
        text: 'โคกสีทองหลาง',
        value: 'โคกสีทองหลาง',
        name: {
          th: 'โคกสีทองหลาง',
          en: 'Khok Si Thonglang',
        },
        districtId: 485,
      },
      {
        id: '441001',
        zipcode: 44180,
        text: 'นาดูน',
        value: 'นาดูน',
        name: {
          th: 'นาดูน',
          en: 'Na Dun',
        },
        districtId: 486,
      },
      {
        id: '441002',
        zipcode: 44180,
        text: 'หนองไผ่',
        value: 'หนองไผ่',
        name: {
          th: 'หนองไผ่',
          en: 'Nong Phai',
        },
        districtId: 486,
      },
      {
        id: '441003',
        zipcode: 44180,
        text: 'หนองคู',
        value: 'หนองคู',
        name: {
          th: 'หนองคู',
          en: 'Nong Khu',
        },
        districtId: 486,
      },
      {
        id: '441004',
        zipcode: 44180,
        text: 'ดงบัง',
        value: 'ดงบัง',
        name: {
          th: 'ดงบัง',
          en: 'Dong Bang',
        },
        districtId: 486,
      },
      {
        id: '441005',
        zipcode: 44180,
        text: 'ดงดวน',
        value: 'ดงดวน',
        name: {
          th: 'ดงดวน',
          en: 'Dong Duan',
        },
        districtId: 486,
      },
      {
        id: '441006',
        zipcode: 44180,
        text: 'หัวดง',
        value: 'หัวดง',
        name: {
          th: 'หัวดง',
          en: 'Hua Dong',
        },
        districtId: 486,
      },
      {
        id: '441007',
        zipcode: 44180,
        text: 'ดงยาง',
        value: 'ดงยาง',
        name: {
          th: 'ดงยาง',
          en: 'Dong Yang',
        },
        districtId: 486,
      },
      {
        id: '441008',
        zipcode: 44180,
        text: 'กู่สันตรัตน์',
        value: 'กู่สันตรัตน์',
        name: {
          th: 'กู่สันตรัตน์',
          en: 'Ku Santarat',
        },
        districtId: 486,
      },
      {
        id: '441009',
        zipcode: 44180,
        text: 'พระธาตุ',
        value: 'พระธาตุ',
        name: {
          th: 'พระธาตุ',
          en: 'Phra That',
        },
        districtId: 486,
      },
      {
        id: '441101',
        zipcode: 44210,
        text: 'ยางสีสุราช',
        value: 'ยางสีสุราช',
        name: {
          th: 'ยางสีสุราช',
          en: 'Yang Sisurat',
        },
        districtId: 487,
      },
      {
        id: '441102',
        zipcode: 44210,
        text: 'นาภู',
        value: 'นาภู',
        name: {
          th: 'นาภู',
          en: 'Na Phu',
        },
        districtId: 487,
      },
      {
        id: '441103',
        zipcode: 44210,
        text: 'แวงดง',
        value: 'แวงดง',
        name: {
          th: 'แวงดง',
          en: 'Waeng Dong',
        },
        districtId: 487,
      },
      {
        id: '441104',
        zipcode: 44210,
        text: 'บ้านกู่',
        value: 'บ้านกู่',
        name: {
          th: 'บ้านกู่',
          en: 'Ban Ku',
        },
        districtId: 487,
      },
      {
        id: '441105',
        zipcode: 44210,
        text: 'ดงเมือง',
        value: 'ดงเมือง',
        name: {
          th: 'ดงเมือง',
          en: 'Dong Mueang',
        },
        districtId: 487,
      },
      {
        id: '441106',
        zipcode: 44210,
        text: 'ขามเรียน',
        value: 'ขามเรียน',
        name: {
          th: 'ขามเรียน',
          en: 'Sang Saeng',
        },
        districtId: 487,
      },
      {
        id: '441107',
        zipcode: 44210,
        text: 'หนองบัวสันตุ',
        value: 'หนองบัวสันตุ',
        name: {
          th: 'หนองบัวสันตุ',
          en: 'Nong Bua Santu',
        },
        districtId: 487,
      },
      {
        id: '441201',
        zipcode: 44130,
        text: 'กุดรัง',
        value: 'กุดรัง',
        name: {
          th: 'กุดรัง',
          en: 'Kud Rang',
        },
        districtId: 488,
      },
      {
        id: '441202',
        zipcode: 44130,
        text: 'นาโพธิ์',
        value: 'นาโพธิ์',
        name: {
          th: 'นาโพธิ์',
          en: 'Na Pho',
        },
        districtId: 488,
      },
      {
        id: '441203',
        zipcode: 44130,
        text: 'เลิงแฝก',
        value: 'เลิงแฝก',
        name: {
          th: 'เลิงแฝก',
          en: 'Loeng Faek',
        },
        districtId: 488,
      },
      {
        id: '441204',
        zipcode: 44130,
        text: 'หนองแวง',
        value: 'หนองแวง',
        name: {
          th: 'หนองแวง',
          en: 'Nong Waeng',
        },
        districtId: 488,
      },
      {
        id: '441205',
        zipcode: 44130,
        text: 'ห้วยเตย',
        value: 'ห้วยเตย',
        name: {
          th: 'ห้วยเตย',
          en: 'Huai Toei',
        },
        districtId: 488,
      },
      {
        id: '441301',
        zipcode: 44160,
        text: 'ชื่นชม',
        value: 'ชื่นชม',
        name: {
          th: 'ชื่นชม',
          en: 'Chuen Chom',
        },
        districtId: 489,
      },
      {
        id: '441302',
        zipcode: 44160,
        text: 'กุดปลาดุก',
        value: 'กุดปลาดุก',
        name: {
          th: 'กุดปลาดุก',
          en: 'Kut Pla Duk',
        },
        districtId: 489,
      },
      {
        id: '441303',
        zipcode: 44160,
        text: 'เหล่าดอกไม้',
        value: 'เหล่าดอกไม้',
        name: {
          th: 'เหล่าดอกไม้',
          en: 'Lao Dok Mai',
        },
        districtId: 489,
      },
      {
        id: '441304',
        zipcode: 44160,
        text: 'หนองกุง',
        value: 'หนองกุง',
        name: {
          th: 'หนองกุง',
          en: 'Nong Kung',
        },
        districtId: 489,
      },
      {
        id: '450101',
        zipcode: 45000,
        text: 'ในเมือง',
        value: 'ในเมือง',
        name: {
          th: 'ในเมือง',
          en: 'Nai Mueang',
        },
        districtId: 491,
      },
      {
        id: '450102',
        zipcode: 45000,
        text: 'รอบเมือง',
        value: 'รอบเมือง',
        name: {
          th: 'รอบเมือง',
          en: 'Rop Mueang',
        },
        districtId: 491,
      },
      {
        id: '450103',
        zipcode: 45000,
        text: 'เหนือเมือง',
        value: 'เหนือเมือง',
        name: {
          th: 'เหนือเมือง',
          en: 'Nuea Mueang',
        },
        districtId: 491,
      },
      {
        id: '450104',
        zipcode: 45000,
        text: 'ขอนแก่น',
        value: 'ขอนแก่น',
        name: {
          th: 'ขอนแก่น',
          en: 'Khon Kaen',
        },
        districtId: 491,
      },
      {
        id: '450105',
        zipcode: 45000,
        text: 'นาโพธิ์',
        value: 'นาโพธิ์',
        name: {
          th: 'นาโพธิ์',
          en: 'Na Pho',
        },
        districtId: 491,
      },
      {
        id: '450106',
        zipcode: 45000,
        text: 'สะอาดสมบูรณ์',
        value: 'สะอาดสมบูรณ์',
        name: {
          th: 'สะอาดสมบูรณ์',
          en: 'Sa-at Sombun',
        },
        districtId: 491,
      },
      {
        id: '450108',
        zipcode: 45000,
        text: 'สีแก้ว',
        value: 'สีแก้ว',
        name: {
          th: 'สีแก้ว',
          en: 'Si Kaeo',
        },
        districtId: 491,
      },
      {
        id: '450109',
        zipcode: 45000,
        text: 'ปอภาร (ปอพาน)',
        value: 'ปอภาร (ปอพาน)',
        name: {
          th: 'ปอภาร (ปอพาน)',
          en: 'Po Phan',
        },
        districtId: 491,
      },
      {
        id: '450110',
        zipcode: 45000,
        text: 'โนนรัง',
        value: 'โนนรัง',
        name: {
          th: 'โนนรัง',
          en: 'Non Rang',
        },
        districtId: 491,
      },
      {
        id: '450117',
        zipcode: 45000,
        text: 'หนองแก้ว',
        value: 'หนองแก้ว',
        name: {
          th: 'หนองแก้ว',
          en: 'Nong Kaeo',
        },
        districtId: 491,
      },
      {
        id: '450118',
        zipcode: 45000,
        text: 'หนองแวง',
        value: 'หนองแวง',
        name: {
          th: 'หนองแวง',
          en: 'Nong Waeng',
        },
        districtId: 491,
      },
      {
        id: '450120',
        zipcode: 45000,
        text: 'ดงลาน',
        value: 'ดงลาน',
        name: {
          th: 'ดงลาน',
          en: 'Dong Lan',
        },
        districtId: 491,
      },
      {
        id: '450123',
        zipcode: 45000,
        text: 'แคนใหญ่',
        value: 'แคนใหญ่',
        name: {
          th: 'แคนใหญ่',
          en: 'Khaen Yai',
        },
        districtId: 491,
      },
      {
        id: '450124',
        zipcode: 45000,
        text: 'โนนตาล',
        value: 'โนนตาล',
        name: {
          th: 'โนนตาล',
          en: 'Non Tan',
        },
        districtId: 491,
      },
      {
        id: '450125',
        zipcode: 45000,
        text: 'เมืองทอง',
        value: 'เมืองทอง',
        name: {
          th: 'เมืองทอง',
          en: 'Mueang Thong',
        },
        districtId: 491,
      },
      {
        id: '450201',
        zipcode: 45150,
        text: 'เกษตรวิสัย',
        value: 'เกษตรวิสัย',
        name: {
          th: 'เกษตรวิสัย',
          en: 'Kaset Wisai',
        },
        districtId: 492,
      },
      {
        id: '450202',
        zipcode: 45150,
        text: 'เมืองบัว',
        value: 'เมืองบัว',
        name: {
          th: 'เมืองบัว',
          en: 'Mueang Bua',
        },
        districtId: 492,
      },
      {
        id: '450203',
        zipcode: 45150,
        text: 'เหล่าหลวง',
        value: 'เหล่าหลวง',
        name: {
          th: 'เหล่าหลวง',
          en: 'Lao Luang',
        },
        districtId: 492,
      },
      {
        id: '450204',
        zipcode: 45150,
        text: 'สิงห์โคก',
        value: 'สิงห์โคก',
        name: {
          th: 'สิงห์โคก',
          en: 'Sing Khok',
        },
        districtId: 492,
      },
      {
        id: '450205',
        zipcode: 45150,
        text: 'ดงครั่งใหญ่',
        value: 'ดงครั่งใหญ่',
        name: {
          th: 'ดงครั่งใหญ่',
          en: 'Dong Khrang Yai',
        },
        districtId: 492,
      },
      {
        id: '450206',
        zipcode: 45150,
        text: 'บ้านฝาง',
        value: 'บ้านฝาง',
        name: {
          th: 'บ้านฝาง',
          en: 'Ban Fang',
        },
        districtId: 492,
      },
      {
        id: '450207',
        zipcode: 45150,
        text: 'หนองแวง',
        value: 'หนองแวง',
        name: {
          th: 'หนองแวง',
          en: 'Nong Waeng',
        },
        districtId: 492,
      },
      {
        id: '450208',
        zipcode: 45150,
        text: 'กำแพง',
        value: 'กำแพง',
        name: {
          th: 'กำแพง',
          en: 'Kamphaeng',
        },
        districtId: 492,
      },
      {
        id: '450209',
        zipcode: 45150,
        text: 'กู่กาสิงห์',
        value: 'กู่กาสิงห์',
        name: {
          th: 'กู่กาสิงห์',
          en: 'Ku Ka Sing',
        },
        districtId: 492,
      },
      {
        id: '450210',
        zipcode: 45150,
        text: 'น้ำอ้อม',
        value: 'น้ำอ้อม',
        name: {
          th: 'น้ำอ้อม',
          en: 'Nam Om',
        },
        districtId: 492,
      },
      {
        id: '450211',
        zipcode: 45150,
        text: 'โนนสว่าง',
        value: 'โนนสว่าง',
        name: {
          th: 'โนนสว่าง',
          en: 'Non Sawang',
        },
        districtId: 492,
      },
      {
        id: '450212',
        zipcode: 45150,
        text: 'ทุ่งทอง',
        value: 'ทุ่งทอง',
        name: {
          th: 'ทุ่งทอง',
          en: 'Thung Thong',
        },
        districtId: 492,
      },
      {
        id: '450213',
        zipcode: 45150,
        text: 'ดงครั่งน้อย',
        value: 'ดงครั่งน้อย',
        name: {
          th: 'ดงครั่งน้อย',
          en: 'Dong Khrang Noi',
        },
        districtId: 492,
      },
      {
        id: '450301',
        zipcode: 45190,
        text: 'บัวแดง',
        value: 'บัวแดง',
        name: {
          th: 'บัวแดง',
          en: 'Bua Daeng',
        },
        districtId: 493,
      },
      {
        id: '450302',
        zipcode: 45190,
        text: 'ดอกล้ำ',
        value: 'ดอกล้ำ',
        name: {
          th: 'ดอกล้ำ',
          en: 'Dok Lam',
        },
        districtId: 493,
      },
      {
        id: '450303',
        zipcode: 45190,
        text: 'หนองแคน',
        value: 'หนองแคน',
        name: {
          th: 'หนองแคน',
          en: 'Nong Khaen',
        },
        districtId: 493,
      },
      {
        id: '450304',
        zipcode: 45190,
        text: 'โพนสูง',
        value: 'โพนสูง',
        name: {
          th: 'โพนสูง',
          en: 'Phon Sung',
        },
        districtId: 493,
      },
      {
        id: '450305',
        zipcode: 45190,
        text: 'โนนสวรรค์',
        value: 'โนนสวรรค์',
        name: {
          th: 'โนนสวรรค์',
          en: 'Non Sawan',
        },
        districtId: 493,
      },
      {
        id: '450306',
        zipcode: 45190,
        text: 'สระบัว',
        value: 'สระบัว',
        name: {
          th: 'สระบัว',
          en: 'Sa Bua',
        },
        districtId: 493,
      },
      {
        id: '450307',
        zipcode: 45190,
        text: 'โนนสง่า',
        value: 'โนนสง่า',
        name: {
          th: 'โนนสง่า',
          en: 'Non Sa-nga',
        },
        districtId: 493,
      },
      {
        id: '450308',
        zipcode: 45190,
        text: 'ขี้เหล็ก',
        value: 'ขี้เหล็ก',
        name: {
          th: 'ขี้เหล็ก',
          en: 'Khilek',
        },
        districtId: 493,
      },
      {
        id: '450401',
        zipcode: 45180,
        text: 'หัวช้าง',
        value: 'หัวช้าง',
        name: {
          th: 'หัวช้าง',
          en: 'Hua Chang',
        },
        districtId: 494,
      },
      {
        id: '450402',
        zipcode: 45180,
        text: 'หนองผือ',
        value: 'หนองผือ',
        name: {
          th: 'หนองผือ',
          en: 'Nong Phue',
        },
        districtId: 494,
      },
      {
        id: '450403',
        zipcode: 45180,
        text: 'เมืองหงส์',
        value: 'เมืองหงส์',
        name: {
          th: 'เมืองหงส์',
          en: 'Mueang Hong',
        },
        districtId: 494,
      },
      {
        id: '450404',
        zipcode: 45180,
        text: 'โคกล่าม',
        value: 'โคกล่าม',
        name: {
          th: 'โคกล่าม',
          en: 'Khok Lam',
        },
        districtId: 494,
      },
      {
        id: '450405',
        zipcode: 45180,
        text: 'น้ำใส',
        value: 'น้ำใส',
        name: {
          th: 'น้ำใส',
          en: 'Nam Sai',
        },
        districtId: 494,
      },
      {
        id: '450406',
        zipcode: 45180,
        text: 'ดงแดง',
        value: 'ดงแดง',
        name: {
          th: 'ดงแดง',
          en: 'Dong Daeng',
        },
        districtId: 494,
      },
      {
        id: '450407',
        zipcode: 45180,
        text: 'ดงกลาง',
        value: 'ดงกลาง',
        name: {
          th: 'ดงกลาง',
          en: 'Dong Klang',
        },
        districtId: 494,
      },
      {
        id: '450408',
        zipcode: 45180,
        text: 'ป่าสังข์',
        value: 'ป่าสังข์',
        name: {
          th: 'ป่าสังข์',
          en: 'Pa Sang',
        },
        districtId: 494,
      },
      {
        id: '450409',
        zipcode: 45180,
        text: 'อีง่อง',
        value: 'อีง่อง',
        name: {
          th: 'อีง่อง',
          en: 'I Ngong',
        },
        districtId: 494,
      },
      {
        id: '450410',
        zipcode: 45180,
        text: 'ลิ้นฟ้า',
        value: 'ลิ้นฟ้า',
        name: {
          th: 'ลิ้นฟ้า',
          en: 'Lin Fa',
        },
        districtId: 494,
      },
      {
        id: '450411',
        zipcode: 45180,
        text: 'ดู่น้อย',
        value: 'ดู่น้อย',
        name: {
          th: 'ดู่น้อย',
          en: 'Du Noi',
        },
        districtId: 494,
      },
      {
        id: '450412',
        zipcode: 45180,
        text: 'ศรีโคตร',
        value: 'ศรีโคตร',
        name: {
          th: 'ศรีโคตร',
          en: 'Si Khot',
        },
        districtId: 494,
      },
      {
        id: '450501',
        zipcode: 45170,
        text: 'นิเวศน์',
        value: 'นิเวศน์',
        name: {
          th: 'นิเวศน์',
          en: 'Niwet',
        },
        districtId: 495,
      },
      {
        id: '450502',
        zipcode: 45170,
        text: 'ธงธานี',
        value: 'ธงธานี',
        name: {
          th: 'ธงธานี',
          en: 'Thong Thani',
        },
        districtId: 495,
      },
      {
        id: '450503',
        zipcode: 45170,
        text: 'หนองไผ่',
        value: 'หนองไผ่',
        name: {
          th: 'หนองไผ่',
          en: 'Nong Phai',
        },
        districtId: 495,
      },
      {
        id: '450504',
        zipcode: 45170,
        text: 'ธวัชบุรี',
        value: 'ธวัชบุรี',
        name: {
          th: 'ธวัชบุรี',
          en: 'Thawat Buri',
        },
        districtId: 495,
      },
      {
        id: '450506',
        zipcode: 45170,
        text: 'อุ่มเม้า',
        value: 'อุ่มเม้า',
        name: {
          th: 'อุ่มเม้า',
          en: 'Um Mao',
        },
        districtId: 495,
      },
      {
        id: '450507',
        zipcode: 45170,
        text: 'มะอึ',
        value: 'มะอึ',
        name: {
          th: 'มะอึ',
          en: 'Ma-ue',
        },
        districtId: 495,
      },
      {
        id: '450510',
        zipcode: 45170,
        text: 'เขวาทุ่ง',
        value: 'เขวาทุ่ง',
        name: {
          th: 'เขวาทุ่ง',
          en: 'Khwao Thung',
        },
        districtId: 495,
      },
      {
        id: '450515',
        zipcode: 45170,
        text: 'ไพศาล',
        value: 'ไพศาล',
        name: {
          th: 'ไพศาล',
          en: 'Phaisan',
        },
        districtId: 495,
      },
      {
        id: '450517',
        zipcode: 45170,
        text: 'เมืองน้อย',
        value: 'เมืองน้อย',
        name: {
          th: 'เมืองน้อย',
          en: 'Mueang Noi',
        },
        districtId: 495,
      },
      {
        id: '450520',
        zipcode: 45170,
        text: 'บึงนคร',
        value: 'บึงนคร',
        name: {
          th: 'บึงนคร',
          en: 'Bueng Nakhon',
        },
        districtId: 495,
      },
      {
        id: '450522',
        zipcode: 45170,
        text: 'ราชธานี',
        value: 'ราชธานี',
        name: {
          th: 'ราชธานี',
          en: 'Ratchathani',
        },
        districtId: 495,
      },
      {
        id: '450524',
        zipcode: 45170,
        text: 'หนองพอก',
        value: 'หนองพอก',
        name: {
          th: 'หนองพอก',
          en: 'Nong Phok',
        },
        districtId: 495,
      },
      {
        id: '450601',
        zipcode: 45140,
        text: 'พนมไพร',
        value: 'พนมไพร',
        name: {
          th: 'พนมไพร',
          en: 'Phanom Phrai',
        },
        districtId: 496,
      },
      {
        id: '450602',
        zipcode: 45140,
        text: 'แสนสุข',
        value: 'แสนสุข',
        name: {
          th: 'แสนสุข',
          en: 'Saen Suk',
        },
        districtId: 496,
      },
      {
        id: '450603',
        zipcode: 45140,
        text: 'กุดน้ำใส',
        value: 'กุดน้ำใส',
        name: {
          th: 'กุดน้ำใส',
          en: 'Kut Nam Sai',
        },
        districtId: 496,
      },
      {
        id: '450604',
        zipcode: 45140,
        text: 'หนองทัพไทย',
        value: 'หนองทัพไทย',
        name: {
          th: 'หนองทัพไทย',
          en: 'Nong Thap Thai',
        },
        districtId: 496,
      },
      {
        id: '450605',
        zipcode: 45140,
        text: 'โพธิ์ใหญ่',
        value: 'โพธิ์ใหญ่',
        name: {
          th: 'โพธิ์ใหญ่',
          en: 'Pho Yai',
        },
        districtId: 496,
      },
      {
        id: '450606',
        zipcode: 45140,
        text: 'วารีสวัสดิ์',
        value: 'วารีสวัสดิ์',
        name: {
          th: 'วารีสวัสดิ์',
          en: 'Wari Sawat',
        },
        districtId: 496,
      },
      {
        id: '450607',
        zipcode: 45140,
        text: 'โคกสว่าง',
        value: 'โคกสว่าง',
        name: {
          th: 'โคกสว่าง',
          en: 'Khok Sawang',
        },
        districtId: 496,
      },
      {
        id: '450611',
        zipcode: 45140,
        text: 'โพธิ์ชัย',
        value: 'โพธิ์ชัย',
        name: {
          th: 'โพธิ์ชัย',
          en: 'Pho Chai',
        },
        districtId: 496,
      },
      {
        id: '450612',
        zipcode: 45140,
        text: 'นานวล',
        value: 'นานวล',
        name: {
          th: 'นานวล',
          en: 'Na Nuan',
        },
        districtId: 496,
      },
      {
        id: '450613',
        zipcode: 45140,
        text: 'คำไฮ',
        value: 'คำไฮ',
        name: {
          th: 'คำไฮ',
          en: 'Kham Hai',
        },
        districtId: 496,
      },
      {
        id: '450614',
        zipcode: 45140,
        text: 'สระแก้ว',
        value: 'สระแก้ว',
        name: {
          th: 'สระแก้ว',
          en: 'Sa Kaeo',
        },
        districtId: 496,
      },
      {
        id: '450615',
        zipcode: 45140,
        text: 'ค้อใหญ่',
        value: 'ค้อใหญ่',
        name: {
          th: 'ค้อใหญ่',
          en: 'Kho Yai',
        },
        districtId: 496,
      },
      {
        id: '450617',
        zipcode: 45140,
        text: 'ชานุวรรณ',
        value: 'ชานุวรรณ',
        name: {
          th: 'ชานุวรรณ',
          en: 'Chanuwan',
        },
        districtId: 496,
      },
      {
        id: '450701',
        zipcode: 45110,
        text: 'แวง',
        value: 'แวง',
        name: {
          th: 'แวง',
          en: 'Waeng',
        },
        districtId: 497,
      },
      {
        id: '450702',
        zipcode: 45110,
        text: 'โคกกกม่วง',
        value: 'โคกกกม่วง',
        name: {
          th: 'โคกกกม่วง',
          en: 'Khok Kok Muang',
        },
        districtId: 497,
      },
      {
        id: '450703',
        zipcode: 45110,
        text: 'นาอุดม',
        value: 'นาอุดม',
        name: {
          th: 'นาอุดม',
          en: 'Na Udom',
        },
        districtId: 497,
      },
      {
        id: '450704',
        zipcode: 45110,
        text: 'สว่าง',
        value: 'สว่าง',
        name: {
          th: 'สว่าง',
          en: 'Sawang',
        },
        districtId: 497,
      },
      {
        id: '450705',
        zipcode: 45110,
        text: 'หนองใหญ่',
        value: 'หนองใหญ่',
        name: {
          th: 'หนองใหญ่',
          en: 'Nong Yai',
        },
        districtId: 497,
      },
      {
        id: '450706',
        zipcode: 45110,
        text: 'โพธิ์ทอง',
        value: 'โพธิ์ทอง',
        name: {
          th: 'โพธิ์ทอง',
          en: 'Pho Thong',
        },
        districtId: 497,
      },
      {
        id: '450707',
        zipcode: 45110,
        text: 'โนนชัยศรี',
        value: 'โนนชัยศรี',
        name: {
          th: 'โนนชัยศรี',
          en: 'Non Chai Si',
        },
        districtId: 497,
      },
      {
        id: '450708',
        zipcode: 45110,
        text: 'โพธิ์ศรีสว่าง',
        value: 'โพธิ์ศรีสว่าง',
        name: {
          th: 'โพธิ์ศรีสว่าง',
          en: 'Pho Si Sawang',
        },
        districtId: 497,
      },
      {
        id: '450709',
        zipcode: 45110,
        text: 'อุ่มเม่า',
        value: 'อุ่มเม่า',
        name: {
          th: 'อุ่มเม่า',
          en: 'Um Mao',
        },
        districtId: 497,
      },
      {
        id: '450710',
        zipcode: 45110,
        text: 'คำนาดี',
        value: 'คำนาดี',
        name: {
          th: 'คำนาดี',
          en: 'Kham Na Di',
        },
        districtId: 497,
      },
      {
        id: '450711',
        zipcode: 45110,
        text: 'พรมสวรรค์',
        value: 'พรมสวรรค์',
        name: {
          th: 'พรมสวรรค์',
          en: 'Phrom Sawan',
        },
        districtId: 497,
      },
      {
        id: '450712',
        zipcode: 45110,
        text: 'สระนกแก้ว',
        value: 'สระนกแก้ว',
        name: {
          th: 'สระนกแก้ว',
          en: 'Sa Nok Kaeo',
        },
        districtId: 497,
      },
      {
        id: '450713',
        zipcode: 45110,
        text: 'วังสามัคคี',
        value: 'วังสามัคคี',
        name: {
          th: 'วังสามัคคี',
          en: 'Wang Samakkhi',
        },
        districtId: 497,
      },
      {
        id: '450714',
        zipcode: 45110,
        text: 'โคกสูง',
        value: 'โคกสูง',
        name: {
          th: 'โคกสูง',
          en: 'Khok Sung',
        },
        districtId: 497,
      },
      {
        id: '450801',
        zipcode: 45230,
        text: 'ขามเปี้ย',
        value: 'ขามเปี้ย',
        name: {
          th: 'ขามเปี้ย',
          en: 'Kham Pia',
        },
        districtId: 498,
      },
      {
        id: '450802',
        zipcode: 45230,
        text: 'เชียงใหม่',
        value: 'เชียงใหม่',
        name: {
          th: 'เชียงใหม่',
          en: 'Chiang Mai',
        },
        districtId: 498,
      },
      {
        id: '450803',
        zipcode: 45230,
        text: 'บัวคำ',
        value: 'บัวคำ',
        name: {
          th: 'บัวคำ',
          en: 'Bua Kham',
        },
        districtId: 498,
      },
      {
        id: '450804',
        zipcode: 45230,
        text: 'อัคคะคำ',
        value: 'อัคคะคำ',
        name: {
          th: 'อัคคะคำ',
          en: 'Akkha Kham',
        },
        districtId: 498,
      },
      {
        id: '450805',
        zipcode: 45230,
        text: 'สะอาด',
        value: 'สะอาด',
        name: {
          th: 'สะอาด',
          en: 'Sa-at',
        },
        districtId: 498,
      },
      {
        id: '450806',
        zipcode: 45230,
        text: 'คำพอุง',
        value: 'คำพอุง',
        name: {
          th: 'คำพอุง',
          en: 'Kham Pha-ung',
        },
        districtId: 498,
      },
      {
        id: '450807',
        zipcode: 45230,
        text: 'หนองตาไก้',
        value: 'หนองตาไก้',
        name: {
          th: 'หนองตาไก้',
          en: 'Nong Ta Kai',
        },
        districtId: 498,
      },
      {
        id: '450808',
        zipcode: 45230,
        text: 'ดอนโอง',
        value: 'ดอนโอง',
        name: {
          th: 'ดอนโอง',
          en: 'Don Ong',
        },
        districtId: 498,
      },
      {
        id: '450809',
        zipcode: 45230,
        text: 'โพธิ์ศรี',
        value: 'โพธิ์ศรี',
        name: {
          th: 'โพธิ์ศรี',
          en: 'Pho Si',
        },
        districtId: 498,
      },
      {
        id: '450901',
        zipcode: 45210,
        text: 'หนองพอก',
        value: 'หนองพอก',
        name: {
          th: 'หนองพอก',
          en: 'Nong Phok',
        },
        districtId: 499,
      },
      {
        id: '450902',
        zipcode: 45210,
        text: 'บึงงาม',
        value: 'บึงงาม',
        name: {
          th: 'บึงงาม',
          en: 'Bueng Ngam',
        },
        districtId: 499,
      },
      {
        id: '450903',
        zipcode: 45210,
        text: 'ภูเขาทอง',
        value: 'ภูเขาทอง',
        name: {
          th: 'ภูเขาทอง',
          en: 'Phukhao Thong',
        },
        districtId: 499,
      },
      {
        id: '450904',
        zipcode: 45210,
        text: 'กกโพธิ์',
        value: 'กกโพธิ์',
        name: {
          th: 'กกโพธิ์',
          en: 'Kok Pho',
        },
        districtId: 499,
      },
      {
        id: '450905',
        zipcode: 45210,
        text: 'โคกสว่าง',
        value: 'โคกสว่าง',
        name: {
          th: 'โคกสว่าง',
          en: 'Khok Sawang',
        },
        districtId: 499,
      },
      {
        id: '450906',
        zipcode: 45210,
        text: 'หนองขุ่นใหญ่',
        value: 'หนองขุ่นใหญ่',
        name: {
          th: 'หนองขุ่นใหญ่',
          en: 'Nong Khun Yai',
        },
        districtId: 499,
      },
      {
        id: '450907',
        zipcode: 45210,
        text: 'รอบเมือง',
        value: 'รอบเมือง',
        name: {
          th: 'รอบเมือง',
          en: 'Rop Mueang',
        },
        districtId: 499,
      },
      {
        id: '450908',
        zipcode: 45210,
        text: 'ผาน้ำย้อย',
        value: 'ผาน้ำย้อย',
        name: {
          th: 'ผาน้ำย้อย',
          en: 'Pha Nam Yoi',
        },
        districtId: 499,
      },
      {
        id: '450909',
        zipcode: 45210,
        text: 'ท่าสีดา',
        value: 'ท่าสีดา',
        name: {
          th: 'ท่าสีดา',
          en: 'Ta See Da',
        },
        districtId: 499,
      },
      {
        id: '451001',
        zipcode: 45120,
        text: 'กลาง',
        value: 'กลาง',
        name: {
          th: 'กลาง',
          en: 'Klang',
        },
        districtId: 500,
      },
      {
        id: '451002',
        zipcode: 45120,
        text: 'นางาม',
        value: 'นางาม',
        name: {
          th: 'นางาม',
          en: 'Na Ngam',
        },
        districtId: 500,
      },
      {
        id: '451003',
        zipcode: 45120,
        text: 'เมืองไพร',
        value: 'เมืองไพร',
        name: {
          th: 'เมืองไพร',
          en: 'Mueang Phrai',
        },
        districtId: 500,
      },
      {
        id: '451004',
        zipcode: 45120,
        text: 'นาแซง',
        value: 'นาแซง',
        name: {
          th: 'นาแซง',
          en: 'Na Saeng',
        },
        districtId: 500,
      },
      {
        id: '451005',
        zipcode: 45120,
        text: 'นาเมือง',
        value: 'นาเมือง',
        name: {
          th: 'นาเมือง',
          en: 'Na Mueang',
        },
        districtId: 500,
      },
      {
        id: '451006',
        zipcode: 45120,
        text: 'วังหลวง',
        value: 'วังหลวง',
        name: {
          th: 'วังหลวง',
          en: 'Wang Luang',
        },
        districtId: 500,
      },
      {
        id: '451007',
        zipcode: 45120,
        text: 'ท่าม่วง',
        value: 'ท่าม่วง',
        name: {
          th: 'ท่าม่วง',
          en: 'Tha Muang',
        },
        districtId: 500,
      },
      {
        id: '451008',
        zipcode: 45120,
        text: 'ขวาว',
        value: 'ขวาว',
        name: {
          th: 'ขวาว',
          en: 'Khwao',
        },
        districtId: 500,
      },
      {
        id: '451009',
        zipcode: 45120,
        text: 'โพธิ์ทอง',
        value: 'โพธิ์ทอง',
        name: {
          th: 'โพธิ์ทอง',
          en: 'Pho Thong',
        },
        districtId: 500,
      },
      {
        id: '451010',
        zipcode: 45120,
        text: 'ภูเงิน',
        value: 'ภูเงิน',
        name: {
          th: 'ภูเงิน',
          en: 'Phu Ngoen',
        },
        districtId: 500,
      },
      {
        id: '451011',
        zipcode: 45120,
        text: 'เกาะแก้ว',
        value: 'เกาะแก้ว',
        name: {
          th: 'เกาะแก้ว',
          en: 'Ko Kaeo',
        },
        districtId: 500,
      },
      {
        id: '451012',
        zipcode: 45120,
        text: 'นาเลิง',
        value: 'นาเลิง',
        name: {
          th: 'นาเลิง',
          en: 'Na Loeng',
        },
        districtId: 500,
      },
      {
        id: '451013',
        zipcode: 45120,
        text: 'เหล่าน้อย',
        value: 'เหล่าน้อย',
        name: {
          th: 'เหล่าน้อย',
          en: 'Lao Noi',
        },
        districtId: 500,
      },
      {
        id: '451014',
        zipcode: 45120,
        text: 'ศรีวิลัย',
        value: 'ศรีวิลัย',
        name: {
          th: 'ศรีวิลัย',
          en: 'Si Wilai',
        },
        districtId: 500,
      },
      {
        id: '451015',
        zipcode: 45120,
        text: 'หนองหลวง',
        value: 'หนองหลวง',
        name: {
          th: 'หนองหลวง',
          en: 'Nong Luang',
        },
        districtId: 500,
      },
      {
        id: '451016',
        zipcode: 45120,
        text: 'พรสวรรค์',
        value: 'พรสวรรค์',
        name: {
          th: 'พรสวรรค์',
          en: 'Phon Sawan',
        },
        districtId: 500,
      },
      {
        id: '451017',
        zipcode: 45120,
        text: 'ขวัญเมือง',
        value: 'ขวัญเมือง',
        name: {
          th: 'ขวัญเมือง',
          en: 'Khwan Mueang',
        },
        districtId: 500,
      },
      {
        id: '451018',
        zipcode: 45120,
        text: 'บึงเกลือ',
        value: 'บึงเกลือ',
        name: {
          th: 'บึงเกลือ',
          en: 'Bueng Kluea',
        },
        districtId: 500,
      },
      {
        id: '451101',
        zipcode: 45130,
        text: 'สระคู',
        value: 'สระคู',
        name: {
          th: 'สระคู',
          en: 'Sa Khu',
        },
        districtId: 501,
      },
      {
        id: '451102',
        zipcode: 45130,
        text: 'ดอกไม้',
        value: 'ดอกไม้',
        name: {
          th: 'ดอกไม้',
          en: 'Dok Mai',
        },
        districtId: 501,
      },
      {
        id: '451103',
        zipcode: 45130,
        text: 'นาใหญ่',
        value: 'นาใหญ่',
        name: {
          th: 'นาใหญ่',
          en: 'Na Yai',
        },
        districtId: 501,
      },
      {
        id: '451104',
        zipcode: 45130,
        text: 'หินกอง',
        value: 'หินกอง',
        name: {
          th: 'หินกอง',
          en: 'Hin Kong',
        },
        districtId: 501,
      },
      {
        id: '451105',
        zipcode: 45130,
        text: 'เมืองทุ่ง',
        value: 'เมืองทุ่ง',
        name: {
          th: 'เมืองทุ่ง',
          en: 'Mueang Thung',
        },
        districtId: 501,
      },
      {
        id: '451106',
        zipcode: 45130,
        text: 'หัวโทน',
        value: 'หัวโทน',
        name: {
          th: 'หัวโทน',
          en: 'Hua Thon',
        },
        districtId: 501,
      },
      {
        id: '451107',
        zipcode: 45130,
        text: 'บ่อพันขัน',
        value: 'บ่อพันขัน',
        name: {
          th: 'บ่อพันขัน',
          en: 'Bo Phan Khan',
        },
        districtId: 501,
      },
      {
        id: '451108',
        zipcode: 45130,
        text: 'ทุ่งหลวง',
        value: 'ทุ่งหลวง',
        name: {
          th: 'ทุ่งหลวง',
          en: 'Thung Luang',
        },
        districtId: 501,
      },
      {
        id: '451109',
        zipcode: 45130,
        text: 'หัวช้าง',
        value: 'หัวช้าง',
        name: {
          th: 'หัวช้าง',
          en: 'Hua Chang',
        },
        districtId: 501,
      },
      {
        id: '451110',
        zipcode: 45130,
        text: 'น้ำคำ',
        value: 'น้ำคำ',
        name: {
          th: 'น้ำคำ',
          en: 'Nam Kham',
        },
        districtId: 501,
      },
      {
        id: '451111',
        zipcode: 45130,
        text: 'ห้วยหินลาด',
        value: 'ห้วยหินลาด',
        name: {
          th: 'ห้วยหินลาด',
          en: 'Huai Hin Lat',
        },
        districtId: 501,
      },
      {
        id: '451112',
        zipcode: 45130,
        text: 'ช้างเผือก',
        value: 'ช้างเผือก',
        name: {
          th: 'ช้างเผือก',
          en: 'Chang Phueak',
        },
        districtId: 501,
      },
      {
        id: '451113',
        zipcode: 45130,
        text: 'ทุ่งกุลา',
        value: 'ทุ่งกุลา',
        name: {
          th: 'ทุ่งกุลา',
          en: 'Thung Kula',
        },
        districtId: 501,
      },
      {
        id: '451114',
        zipcode: 45130,
        text: 'ทุ่งศรีเมือง',
        value: 'ทุ่งศรีเมือง',
        name: {
          th: 'ทุ่งศรีเมือง',
          en: 'Thung Si Mueang',
        },
        districtId: 501,
      },
      {
        id: '451115',
        zipcode: 45130,
        text: 'จำปาขัน',
        value: 'จำปาขัน',
        name: {
          th: 'จำปาขัน',
          en: 'Champa Khan',
        },
        districtId: 501,
      },
      {
        id: '451201',
        zipcode: 45220,
        text: 'หนองผือ',
        value: 'หนองผือ',
        name: {
          th: 'หนองผือ',
          en: 'Nong Phue',
        },
        districtId: 502,
      },
      {
        id: '451202',
        zipcode: 45220,
        text: 'หนองหิน',
        value: 'หนองหิน',
        name: {
          th: 'หนองหิน',
          en: 'Nong Hin',
        },
        districtId: 502,
      },
      {
        id: '451203',
        zipcode: 45220,
        text: 'คูเมือง',
        value: 'คูเมือง',
        name: {
          th: 'คูเมือง',
          en: 'Khu Mueang',
        },
        districtId: 502,
      },
      {
        id: '451204',
        zipcode: 45220,
        text: 'กกกุง',
        value: 'กกกุง',
        name: {
          th: 'กกกุง',
          en: 'Kok Kung',
        },
        districtId: 502,
      },
      {
        id: '451205',
        zipcode: 45220,
        text: 'เมืองสรวง',
        value: 'เมืองสรวง',
        name: {
          th: 'เมืองสรวง',
          en: 'Mueang Suang',
        },
        districtId: 502,
      },
      {
        id: '451301',
        zipcode: 45240,
        text: 'โพนทราย',
        value: 'โพนทราย',
        name: {
          th: 'โพนทราย',
          en: 'Phon Sai',
        },
        districtId: 503,
      },
      {
        id: '451302',
        zipcode: 45240,
        text: 'สามขา',
        value: 'สามขา',
        name: {
          th: 'สามขา',
          en: 'Sam Kha',
        },
        districtId: 503,
      },
      {
        id: '451303',
        zipcode: 45240,
        text: 'ศรีสว่าง',
        value: 'ศรีสว่าง',
        name: {
          th: 'ศรีสว่าง',
          en: 'Si Sawang',
        },
        districtId: 503,
      },
      {
        id: '451304',
        zipcode: 45240,
        text: 'ยางคำ',
        value: 'ยางคำ',
        name: {
          th: 'ยางคำ',
          en: 'Yang Kham',
        },
        districtId: 503,
      },
      {
        id: '451305',
        zipcode: 45240,
        text: 'ท่าหาดยาว',
        value: 'ท่าหาดยาว',
        name: {
          th: 'ท่าหาดยาว',
          en: 'Tha Hat Yao',
        },
        districtId: 503,
      },
      {
        id: '451401',
        zipcode: 45160,
        text: 'อาจสามารถ',
        value: 'อาจสามารถ',
        name: {
          th: 'อาจสามารถ',
          en: 'At Samat',
        },
        districtId: 504,
      },
      {
        id: '451402',
        zipcode: 45160,
        text: 'โพนเมือง',
        value: 'โพนเมือง',
        name: {
          th: 'โพนเมือง',
          en: 'Phon Mueang',
        },
        districtId: 504,
      },
      {
        id: '451403',
        zipcode: 45160,
        text: 'บ้านแจ้ง',
        value: 'บ้านแจ้ง',
        name: {
          th: 'บ้านแจ้ง',
          en: 'Ban Chaeng',
        },
        districtId: 504,
      },
      {
        id: '451404',
        zipcode: 45160,
        text: 'หน่อม',
        value: 'หน่อม',
        name: {
          th: 'หน่อม',
          en: 'Nom',
        },
        districtId: 504,
      },
      {
        id: '451405',
        zipcode: 45160,
        text: 'หนองหมื่นถ่าน',
        value: 'หนองหมื่นถ่าน',
        name: {
          th: 'หนองหมื่นถ่าน',
          en: 'Nong Muen Than',
        },
        districtId: 504,
      },
      {
        id: '451406',
        zipcode: 45160,
        text: 'หนองขาม',
        value: 'หนองขาม',
        name: {
          th: 'หนองขาม',
          en: 'Nong Kham',
        },
        districtId: 504,
      },
      {
        id: '451407',
        zipcode: 45160,
        text: 'โหรา',
        value: 'โหรา',
        name: {
          th: 'โหรา',
          en: 'Hora',
        },
        districtId: 504,
      },
      {
        id: '451408',
        zipcode: 45160,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 504,
      },
      {
        id: '451409',
        zipcode: 45160,
        text: 'ขี้เหล็ก',
        value: 'ขี้เหล็ก',
        name: {
          th: 'ขี้เหล็ก',
          en: 'Khilek',
        },
        districtId: 504,
      },
      {
        id: '451410',
        zipcode: 45160,
        text: 'บ้านดู่',
        value: 'บ้านดู่',
        name: {
          th: 'บ้านดู่',
          en: 'Ban Du',
        },
        districtId: 504,
      },
      {
        id: '451501',
        zipcode: 45250,
        text: 'เมยวดี',
        value: 'เมยวดี',
        name: {
          th: 'เมยวดี',
          en: 'Moei Wadi',
        },
        districtId: 505,
      },
      {
        id: '451502',
        zipcode: 45250,
        text: 'ชุมพร',
        value: 'ชุมพร',
        name: {
          th: 'ชุมพร',
          en: 'Chumphon',
        },
        districtId: 505,
      },
      {
        id: '451503',
        zipcode: 45250,
        text: 'บุ่งเลิศ',
        value: 'บุ่งเลิศ',
        name: {
          th: 'บุ่งเลิศ',
          en: 'Bung Loet',
        },
        districtId: 505,
      },
      {
        id: '451504',
        zipcode: 45250,
        text: 'ชมสะอาด',
        value: 'ชมสะอาด',
        name: {
          th: 'ชมสะอาด',
          en: 'Chom Sa-at',
        },
        districtId: 505,
      },
      {
        id: '451601',
        zipcode: 45000,
        text: 'โพธิ์ทอง',
        value: 'โพธิ์ทอง',
        name: {
          th: 'โพธิ์ทอง',
          en: 'Pho Thong',
        },
        districtId: 506,
      },
      {
        id: '451602',
        zipcode: 45000,
        text: 'ศรีสมเด็จ',
        value: 'ศรีสมเด็จ',
        name: {
          th: 'ศรีสมเด็จ',
          en: 'Si Somdet',
        },
        districtId: 506,
      },
      {
        id: '451603',
        zipcode: 45000,
        text: 'เมืองเปลือย',
        value: 'เมืองเปลือย',
        name: {
          th: 'เมืองเปลือย',
          en: 'Mueang Plueai',
        },
        districtId: 506,
      },
      {
        id: '451604',
        zipcode: 45000,
        text: 'หนองใหญ่',
        value: 'หนองใหญ่',
        name: {
          th: 'หนองใหญ่',
          en: 'Nong Yai',
        },
        districtId: 506,
      },
      {
        id: '451605',
        zipcode: 45280,
        text: 'สวนจิก',
        value: 'สวนจิก',
        name: {
          th: 'สวนจิก',
          en: 'Suan Chik',
        },
        districtId: 506,
      },
      {
        id: '451606',
        zipcode: 45280,
        text: 'โพธิ์สัย',
        value: 'โพธิ์สัย',
        name: {
          th: 'โพธิ์สัย',
          en: 'Pho Sai',
        },
        districtId: 506,
      },
      {
        id: '451607',
        zipcode: 45000,
        text: 'หนองแวงควง',
        value: 'หนองแวงควง',
        name: {
          th: 'หนองแวงควง',
          en: 'Nong Waeng Khuang',
        },
        districtId: 506,
      },
      {
        id: '451608',
        zipcode: 45000,
        text: 'บ้านบาก',
        value: 'บ้านบาก',
        name: {
          th: 'บ้านบาก',
          en: 'Ban Bak',
        },
        districtId: 506,
      },
      {
        id: '451701',
        zipcode: 45000,
        text: 'ดินดำ',
        value: 'ดินดำ',
        name: {
          th: 'ดินดำ',
          en: 'Din Dam',
        },
        districtId: 507,
      },
      {
        id: '451702',
        zipcode: 45000,
        text: 'ปาฝา',
        value: 'ปาฝา',
        name: {
          th: 'ปาฝา',
          en: 'Pa Fa',
        },
        districtId: 507,
      },
      {
        id: '451703',
        zipcode: 45000,
        text: 'ม่วงลาด',
        value: 'ม่วงลาด',
        name: {
          th: 'ม่วงลาด',
          en: 'Muang Lat',
        },
        districtId: 507,
      },
      {
        id: '451704',
        zipcode: 45000,
        text: 'จังหาร',
        value: 'จังหาร',
        name: {
          th: 'จังหาร',
          en: 'Changhan',
        },
        districtId: 507,
      },
      {
        id: '451705',
        zipcode: 45000,
        text: 'ดงสิงห์',
        value: 'ดงสิงห์',
        name: {
          th: 'ดงสิงห์',
          en: 'Dong Sing',
        },
        districtId: 507,
      },
      {
        id: '451706',
        zipcode: 45000,
        text: 'ยางใหญ่',
        value: 'ยางใหญ่',
        name: {
          th: 'ยางใหญ่',
          en: 'Yang Yai',
        },
        districtId: 507,
      },
      {
        id: '451707',
        zipcode: 45000,
        text: 'ผักแว่น',
        value: 'ผักแว่น',
        name: {
          th: 'ผักแว่น',
          en: 'Phak Waen',
        },
        districtId: 507,
      },
      {
        id: '451708',
        zipcode: 45000,
        text: 'แสนชาติ',
        value: 'แสนชาติ',
        name: {
          th: 'แสนชาติ',
          en: 'Saen Chat',
        },
        districtId: 507,
      },
      {
        id: '451801',
        zipcode: 45000,
        text: 'เชียงขวัญ',
        value: 'เชียงขวัญ',
        name: {
          th: 'เชียงขวัญ',
          en: 'Chiang Khwan',
        },
        districtId: 508,
      },
      {
        id: '451802',
        zipcode: 45170,
        text: 'พลับพลา',
        value: 'พลับพลา',
        name: {
          th: 'พลับพลา',
          en: 'Phlapphla',
        },
        districtId: 508,
      },
      {
        id: '451803',
        zipcode: 45000,
        text: 'พระธาตุ',
        value: 'พระธาตุ',
        name: {
          th: 'พระธาตุ',
          en: 'Phra That',
        },
        districtId: 508,
      },
      {
        id: '451804',
        zipcode: 45000,
        text: 'พระเจ้า',
        value: 'พระเจ้า',
        name: {
          th: 'พระเจ้า',
          en: 'Phra Chao',
        },
        districtId: 508,
      },
      {
        id: '451805',
        zipcode: 45170,
        text: 'หมูม้น',
        value: 'หมูม้น',
        name: {
          th: 'หมูม้น',
          en: 'Mu Mon',
        },
        districtId: 508,
      },
      {
        id: '451806',
        zipcode: 45000,
        text: 'บ้านเขือง',
        value: 'บ้านเขือง',
        name: {
          th: 'บ้านเขือง',
          en: 'Ban Khueang',
        },
        districtId: 508,
      },
      {
        id: '451901',
        zipcode: 45140,
        text: 'หนองฮี',
        value: 'หนองฮี',
        name: {
          th: 'หนองฮี',
          en: 'Nong Hi',
        },
        districtId: 509,
      },
      {
        id: '451902',
        zipcode: 45140,
        text: 'สาวแห',
        value: 'สาวแห',
        name: {
          th: 'สาวแห',
          en: 'Sao Hae',
        },
        districtId: 509,
      },
      {
        id: '451903',
        zipcode: 45140,
        text: 'ดูกอึ่ง',
        value: 'ดูกอึ่ง',
        name: {
          th: 'ดูกอึ่ง',
          en: 'Duk Ueng',
        },
        districtId: 509,
      },
      {
        id: '451904',
        zipcode: 45140,
        text: 'เด่นราษฎร์',
        value: 'เด่นราษฎร์',
        name: {
          th: 'เด่นราษฎร์',
          en: 'Den Rat',
        },
        districtId: 509,
      },
      {
        id: '452001',
        zipcode: 45170,
        text: 'ทุ่งเขาหลวง',
        value: 'ทุ่งเขาหลวง',
        name: {
          th: 'ทุ่งเขาหลวง',
          en: 'Thung Khao Luang',
        },
        districtId: 510,
      },
      {
        id: '452002',
        zipcode: 45170,
        text: 'เทอดไทย',
        value: 'เทอดไทย',
        name: {
          th: 'เทอดไทย',
          en: 'Thoet Thai',
        },
        districtId: 510,
      },
      {
        id: '452003',
        zipcode: 45170,
        text: 'บึงงาม',
        value: 'บึงงาม',
        name: {
          th: 'บึงงาม',
          en: 'Bueng Ngam',
        },
        districtId: 510,
      },
      {
        id: '452004',
        zipcode: 45170,
        text: 'มะบ้า',
        value: 'มะบ้า',
        name: {
          th: 'มะบ้า',
          en: 'Maba',
        },
        districtId: 510,
      },
      {
        id: '452005',
        zipcode: 45170,
        text: 'เหล่า',
        value: 'เหล่า',
        name: {
          th: 'เหล่า',
          en: 'Lao',
        },
        districtId: 510,
      },
      {
        id: '460101',
        zipcode: 46000,
        text: 'กาฬสินธุ์',
        value: 'กาฬสินธุ์',
        name: {
          th: 'กาฬสินธุ์',
          en: 'Kalasin',
        },
        districtId: 511,
      },
      {
        id: '460102',
        zipcode: 46000,
        text: 'เหนือ',
        value: 'เหนือ',
        name: {
          th: 'เหนือ',
          en: 'Nuea',
        },
        districtId: 511,
      },
      {
        id: '460103',
        zipcode: 46000,
        text: 'หลุบ',
        value: 'หลุบ',
        name: {
          th: 'หลุบ',
          en: 'Lup',
        },
        districtId: 511,
      },
      {
        id: '460104',
        zipcode: 46000,
        text: 'ไผ่',
        value: 'ไผ่',
        name: {
          th: 'ไผ่',
          en: 'Phai',
        },
        districtId: 511,
      },
      {
        id: '460105',
        zipcode: 46000,
        text: 'ลำปาว',
        value: 'ลำปาว',
        name: {
          th: 'ลำปาว',
          en: 'Lam Pao',
        },
        districtId: 511,
      },
      {
        id: '460106',
        zipcode: 46000,
        text: 'ลำพาน',
        value: 'ลำพาน',
        name: {
          th: 'ลำพาน',
          en: 'Lam Phan',
        },
        districtId: 511,
      },
      {
        id: '460107',
        zipcode: 46000,
        text: 'เชียงเครือ',
        value: 'เชียงเครือ',
        name: {
          th: 'เชียงเครือ',
          en: 'Chiang Khruea',
        },
        districtId: 511,
      },
      {
        id: '460108',
        zipcode: 46000,
        text: 'บึงวิชัย',
        value: 'บึงวิชัย',
        name: {
          th: 'บึงวิชัย',
          en: 'Bueng Wichai',
        },
        districtId: 511,
      },
      {
        id: '460109',
        zipcode: 46000,
        text: 'ห้วยโพธิ์',
        value: 'ห้วยโพธิ์',
        name: {
          th: 'ห้วยโพธิ์',
          en: 'Huai Pho',
        },
        districtId: 511,
      },
      {
        id: '460111',
        zipcode: 46000,
        text: 'ภูปอ',
        value: 'ภูปอ',
        name: {
          th: 'ภูปอ',
          en: 'Phu Po',
        },
        districtId: 511,
      },
      {
        id: '460113',
        zipcode: 46000,
        text: 'ภูดิน',
        value: 'ภูดิน',
        name: {
          th: 'ภูดิน',
          en: 'Phu Din',
        },
        districtId: 511,
      },
      {
        id: '460115',
        zipcode: 46000,
        text: 'หนองกุง',
        value: 'หนองกุง',
        name: {
          th: 'หนองกุง',
          en: 'Nong Kung',
        },
        districtId: 511,
      },
      {
        id: '460116',
        zipcode: 46000,
        text: 'กลางหมื่น',
        value: 'กลางหมื่น',
        name: {
          th: 'กลางหมื่น',
          en: 'Klang Muen',
        },
        districtId: 511,
      },
      {
        id: '460117',
        zipcode: 46000,
        text: 'ขมิ้น',
        value: 'ขมิ้น',
        name: {
          th: 'ขมิ้น',
          en: 'Khamin',
        },
        districtId: 511,
      },
      {
        id: '460119',
        zipcode: 46000,
        text: 'โพนทอง',
        value: 'โพนทอง',
        name: {
          th: 'โพนทอง',
          en: 'Phon Thong',
        },
        districtId: 511,
      },
      {
        id: '460120',
        zipcode: 46000,
        text: 'นาจารย์',
        value: 'นาจารย์',
        name: {
          th: 'นาจารย์',
          en: 'Na Chan',
        },
        districtId: 511,
      },
      {
        id: '460121',
        zipcode: 46000,
        text: 'ลำคลอง',
        value: 'ลำคลอง',
        name: {
          th: 'ลำคลอง',
          en: 'Lam Khlong',
        },
        districtId: 511,
      },
      {
        id: '460122',
        zipcode: 0,
        text: 'สะอาดไชยศรี*',
        value: 'สะอาดไชยศรี*',
        name: {
          th: 'สะอาดไชยศรี*',
          en: 'Sa-art Chai Sri*',
        },
        districtId: 511,
      },
      {
        id: '460201',
        zipcode: 46230,
        text: 'นามน',
        value: 'นามน',
        name: {
          th: 'นามน',
          en: 'Na Mon',
        },
        districtId: 512,
      },
      {
        id: '460202',
        zipcode: 46230,
        text: 'ยอดแกง',
        value: 'ยอดแกง',
        name: {
          th: 'ยอดแกง',
          en: 'Yot Kaeng',
        },
        districtId: 512,
      },
      {
        id: '460203',
        zipcode: 46230,
        text: 'สงเปลือย',
        value: 'สงเปลือย',
        name: {
          th: 'สงเปลือย',
          en: 'Song Plueai',
        },
        districtId: 512,
      },
      {
        id: '460204',
        zipcode: 46230,
        text: 'หลักเหลี่ยม',
        value: 'หลักเหลี่ยม',
        name: {
          th: 'หลักเหลี่ยม',
          en: 'Lak Liam',
        },
        districtId: 512,
      },
      {
        id: '460205',
        zipcode: 46230,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 512,
      },
      {
        id: '460301',
        zipcode: 46130,
        text: 'กมลาไสย',
        value: 'กมลาไสย',
        name: {
          th: 'กมลาไสย',
          en: 'Kamalasai',
        },
        districtId: 513,
      },
      {
        id: '460302',
        zipcode: 46130,
        text: 'หลักเมือง',
        value: 'หลักเมือง',
        name: {
          th: 'หลักเมือง',
          en: 'Lak Mueang',
        },
        districtId: 513,
      },
      {
        id: '460303',
        zipcode: 46130,
        text: 'โพนงาม',
        value: 'โพนงาม',
        name: {
          th: 'โพนงาม',
          en: 'Phon Ngam',
        },
        districtId: 513,
      },
      {
        id: '460304',
        zipcode: 46130,
        text: 'ดงลิง',
        value: 'ดงลิง',
        name: {
          th: 'ดงลิง',
          en: 'Dong Ling',
        },
        districtId: 513,
      },
      {
        id: '460305',
        zipcode: 46130,
        text: 'ธัญญา',
        value: 'ธัญญา',
        name: {
          th: 'ธัญญา',
          en: 'Thanya',
        },
        districtId: 513,
      },
      {
        id: '460308',
        zipcode: 46130,
        text: 'หนองแปน',
        value: 'หนองแปน',
        name: {
          th: 'หนองแปน',
          en: 'Nong Paen',
        },
        districtId: 513,
      },
      {
        id: '460309',
        zipcode: 0,
        text: 'โคกสะอาด*',
        value: 'โคกสะอาด*',
        name: {
          th: 'โคกสะอาด*',
          en: 'Khok Sa-art*',
        },
        districtId: 513,
      },
      {
        id: '460310',
        zipcode: 46130,
        text: 'เจ้าท่า',
        value: 'เจ้าท่า',
        name: {
          th: 'เจ้าท่า',
          en: 'Chao Tha',
        },
        districtId: 513,
      },
      {
        id: '460311',
        zipcode: 46130,
        text: 'โคกสมบูรณ์',
        value: 'โคกสมบูรณ์',
        name: {
          th: 'โคกสมบูรณ์',
          en: 'Khok Sombun',
        },
        districtId: 513,
      },
      {
        id: '460401',
        zipcode: 46210,
        text: 'ร่องคำ',
        value: 'ร่องคำ',
        name: {
          th: 'ร่องคำ',
          en: 'Rong Kham',
        },
        districtId: 514,
      },
      {
        id: '460402',
        zipcode: 46210,
        text: 'สามัคคี',
        value: 'สามัคคี',
        name: {
          th: 'สามัคคี',
          en: 'Samakkhi',
        },
        districtId: 514,
      },
      {
        id: '460403',
        zipcode: 46210,
        text: 'เหล่าอ้อย',
        value: 'เหล่าอ้อย',
        name: {
          th: 'เหล่าอ้อย',
          en: 'Lao Oi',
        },
        districtId: 514,
      },
      {
        id: '460501',
        zipcode: 46110,
        text: 'บัวขาว',
        value: 'บัวขาว',
        name: {
          th: 'บัวขาว',
          en: 'Bua Khao',
        },
        districtId: 515,
      },
      {
        id: '460502',
        zipcode: 46110,
        text: 'แจนแลน',
        value: 'แจนแลน',
        name: {
          th: 'แจนแลน',
          en: 'Chaen Laen',
        },
        districtId: 515,
      },
      {
        id: '460503',
        zipcode: 46110,
        text: 'เหล่าใหญ่',
        value: 'เหล่าใหญ่',
        name: {
          th: 'เหล่าใหญ่',
          en: 'Lao Yai',
        },
        districtId: 515,
      },
      {
        id: '460504',
        zipcode: 46110,
        text: 'จุมจัง',
        value: 'จุมจัง',
        name: {
          th: 'จุมจัง',
          en: 'Chum Chang',
        },
        districtId: 515,
      },
      {
        id: '460505',
        zipcode: 46110,
        text: 'เหล่าไฮงาม',
        value: 'เหล่าไฮงาม',
        name: {
          th: 'เหล่าไฮงาม',
          en: 'Lao Hai Ngam',
        },
        districtId: 515,
      },
      {
        id: '460506',
        zipcode: 46110,
        text: 'กุดหว้า',
        value: 'กุดหว้า',
        name: {
          th: 'กุดหว้า',
          en: 'Kut Wa',
        },
        districtId: 515,
      },
      {
        id: '460507',
        zipcode: 46110,
        text: 'สามขา',
        value: 'สามขา',
        name: {
          th: 'สามขา',
          en: 'Sam Kha',
        },
        districtId: 515,
      },
      {
        id: '460508',
        zipcode: 46110,
        text: 'นาขาม',
        value: 'นาขาม',
        name: {
          th: 'นาขาม',
          en: 'Na Kham',
        },
        districtId: 515,
      },
      {
        id: '460509',
        zipcode: 46110,
        text: 'หนองห้าง',
        value: 'หนองห้าง',
        name: {
          th: 'หนองห้าง',
          en: 'Nong Hang',
        },
        districtId: 515,
      },
      {
        id: '460510',
        zipcode: 46110,
        text: 'นาโก',
        value: 'นาโก',
        name: {
          th: 'นาโก',
          en: 'Na Ko',
        },
        districtId: 515,
      },
      {
        id: '460511',
        zipcode: 46110,
        text: 'สมสะอาด',
        value: 'สมสะอาด',
        name: {
          th: 'สมสะอาด',
          en: 'Som Sa-at',
        },
        districtId: 515,
      },
      {
        id: '460512',
        zipcode: 46110,
        text: 'กุดค้าว',
        value: 'กุดค้าว',
        name: {
          th: 'กุดค้าว',
          en: 'Kut Khao',
        },
        districtId: 515,
      },
      {
        id: '460601',
        zipcode: 46160,
        text: 'คุ้มเก่า',
        value: 'คุ้มเก่า',
        name: {
          th: 'คุ้มเก่า',
          en: 'Khum Kao',
        },
        districtId: 516,
      },
      {
        id: '460602',
        zipcode: 46160,
        text: 'สงเปลือย',
        value: 'สงเปลือย',
        name: {
          th: 'สงเปลือย',
          en: 'Song Plueai',
        },
        districtId: 516,
      },
      {
        id: '460603',
        zipcode: 46160,
        text: 'หนองผือ',
        value: 'หนองผือ',
        name: {
          th: 'หนองผือ',
          en: 'Nong Phue',
        },
        districtId: 516,
      },
      {
        id: '460606',
        zipcode: 46160,
        text: 'กุดสิมคุ้มใหม่',
        value: 'กุดสิมคุ้มใหม่',
        name: {
          th: 'กุดสิมคุ้มใหม่',
          en: 'Kut Sim Khum Mai',
        },
        districtId: 516,
      },
      {
        id: '460608',
        zipcode: 46160,
        text: 'สระพังทอง',
        value: 'สระพังทอง',
        name: {
          th: 'สระพังทอง',
          en: 'Saphang Thong',
        },
        districtId: 516,
      },
      {
        id: '460611',
        zipcode: 46160,
        text: 'กุดปลาค้าว',
        value: 'กุดปลาค้าว',
        name: {
          th: 'กุดปลาค้าว',
          en: 'Kut Pla Khao',
        },
        districtId: 516,
      },
      {
        id: '460701',
        zipcode: 46120,
        text: 'ยางตลาด',
        value: 'ยางตลาด',
        name: {
          th: 'ยางตลาด',
          en: 'Yang Talat',
        },
        districtId: 517,
      },
      {
        id: '460702',
        zipcode: 46120,
        text: 'หัวงัว',
        value: 'หัวงัว',
        name: {
          th: 'หัวงัว',
          en: 'Hua Ngua',
        },
        districtId: 517,
      },
      {
        id: '460703',
        zipcode: 46120,
        text: 'อุ่มเม่า',
        value: 'อุ่มเม่า',
        name: {
          th: 'อุ่มเม่า',
          en: 'Um Mao',
        },
        districtId: 517,
      },
      {
        id: '460704',
        zipcode: 46120,
        text: 'บัวบาน',
        value: 'บัวบาน',
        name: {
          th: 'บัวบาน',
          en: 'Bua Ban',
        },
        districtId: 517,
      },
      {
        id: '460705',
        zipcode: 46120,
        text: 'เว่อ',
        value: 'เว่อ',
        name: {
          th: 'เว่อ',
          en: 'Woe',
        },
        districtId: 517,
      },
      {
        id: '460706',
        zipcode: 46120,
        text: 'อิตื้อ',
        value: 'อิตื้อ',
        name: {
          th: 'อิตื้อ',
          en: 'Itue',
        },
        districtId: 517,
      },
      {
        id: '460707',
        zipcode: 46120,
        text: 'หัวนาคำ',
        value: 'หัวนาคำ',
        name: {
          th: 'หัวนาคำ',
          en: 'Hua Na Kham',
        },
        districtId: 517,
      },
      {
        id: '460708',
        zipcode: 46120,
        text: 'หนองอิเฒ่า',
        value: 'หนองอิเฒ่า',
        name: {
          th: 'หนองอิเฒ่า',
          en: 'Nong I Thao',
        },
        districtId: 517,
      },
      {
        id: '460709',
        zipcode: 46120,
        text: 'ดอนสมบูรณ์',
        value: 'ดอนสมบูรณ์',
        name: {
          th: 'ดอนสมบูรณ์',
          en: 'Don Sombun',
        },
        districtId: 517,
      },
      {
        id: '460710',
        zipcode: 46120,
        text: 'นาเชือก',
        value: 'นาเชือก',
        name: {
          th: 'นาเชือก',
          en: 'Na Chueak',
        },
        districtId: 517,
      },
      {
        id: '460711',
        zipcode: 46120,
        text: 'คลองขาม',
        value: 'คลองขาม',
        name: {
          th: 'คลองขาม',
          en: 'Khlong Kham',
        },
        districtId: 517,
      },
      {
        id: '460712',
        zipcode: 46120,
        text: 'เขาพระนอน',
        value: 'เขาพระนอน',
        name: {
          th: 'เขาพระนอน',
          en: 'Khao Phra Non',
        },
        districtId: 517,
      },
      {
        id: '460713',
        zipcode: 46120,
        text: 'นาดี',
        value: 'นาดี',
        name: {
          th: 'นาดี',
          en: 'Na Di',
        },
        districtId: 517,
      },
      {
        id: '460714',
        zipcode: 46120,
        text: 'โนนสูง',
        value: 'โนนสูง',
        name: {
          th: 'โนนสูง',
          en: 'Non Sung',
        },
        districtId: 517,
      },
      {
        id: '460715',
        zipcode: 46120,
        text: 'หนองตอกแป้น',
        value: 'หนองตอกแป้น',
        name: {
          th: 'หนองตอกแป้น',
          en: 'Nong Tok Paen',
        },
        districtId: 517,
      },
      {
        id: '460801',
        zipcode: 46170,
        text: 'ห้วยเม็ก',
        value: 'ห้วยเม็ก',
        name: {
          th: 'ห้วยเม็ก',
          en: 'Huai Mek',
        },
        districtId: 518,
      },
      {
        id: '460802',
        zipcode: 46170,
        text: 'คำใหญ่',
        value: 'คำใหญ่',
        name: {
          th: 'คำใหญ่',
          en: 'Kham Yai',
        },
        districtId: 518,
      },
      {
        id: '460803',
        zipcode: 46170,
        text: 'กุดโดน',
        value: 'กุดโดน',
        name: {
          th: 'กุดโดน',
          en: 'Kut Don',
        },
        districtId: 518,
      },
      {
        id: '460804',
        zipcode: 46170,
        text: 'บึงนาเรียง',
        value: 'บึงนาเรียง',
        name: {
          th: 'บึงนาเรียง',
          en: 'Bueng Na Riang',
        },
        districtId: 518,
      },
      {
        id: '460805',
        zipcode: 46170,
        text: 'หัวหิน',
        value: 'หัวหิน',
        name: {
          th: 'หัวหิน',
          en: 'Hua Hin',
        },
        districtId: 518,
      },
      {
        id: '460806',
        zipcode: 46170,
        text: 'พิมูล',
        value: 'พิมูล',
        name: {
          th: 'พิมูล',
          en: 'Phimun',
        },
        districtId: 518,
      },
      {
        id: '460807',
        zipcode: 46170,
        text: 'คำเหมือดแก้ว',
        value: 'คำเหมือดแก้ว',
        name: {
          th: 'คำเหมือดแก้ว',
          en: 'Kham Mueat Kaeo',
        },
        districtId: 518,
      },
      {
        id: '460808',
        zipcode: 46170,
        text: 'โนนสะอาด',
        value: 'โนนสะอาด',
        name: {
          th: 'โนนสะอาด',
          en: 'Non Sa-at',
        },
        districtId: 518,
      },
      {
        id: '460809',
        zipcode: 46170,
        text: 'ทรายทอง',
        value: 'ทรายทอง',
        name: {
          th: 'ทรายทอง',
          en: 'Sai Thong',
        },
        districtId: 518,
      },
      {
        id: '460901',
        zipcode: 46140,
        text: 'ภูสิงห์',
        value: 'ภูสิงห์',
        name: {
          th: 'ภูสิงห์',
          en: 'Phu Sing',
        },
        districtId: 519,
      },
      {
        id: '460902',
        zipcode: 46140,
        text: 'สหัสขันธ์',
        value: 'สหัสขันธ์',
        name: {
          th: 'สหัสขันธ์',
          en: 'Sahatsakhan',
        },
        districtId: 519,
      },
      {
        id: '460903',
        zipcode: 46140,
        text: 'นามะเขือ',
        value: 'นามะเขือ',
        name: {
          th: 'นามะเขือ',
          en: 'Na Makhuea',
        },
        districtId: 519,
      },
      {
        id: '460904',
        zipcode: 46140,
        text: 'โนนศิลา',
        value: 'โนนศิลา',
        name: {
          th: 'โนนศิลา',
          en: 'Non Sila',
        },
        districtId: 519,
      },
      {
        id: '460905',
        zipcode: 46140,
        text: 'นิคม',
        value: 'นิคม',
        name: {
          th: 'นิคม',
          en: 'Nikhom',
        },
        districtId: 519,
      },
      {
        id: '460906',
        zipcode: 46140,
        text: 'โนนแหลมทอง',
        value: 'โนนแหลมทอง',
        name: {
          th: 'โนนแหลมทอง',
          en: 'Non Laem Thong',
        },
        districtId: 519,
      },
      {
        id: '460907',
        zipcode: 46140,
        text: 'โนนบุรี',
        value: 'โนนบุรี',
        name: {
          th: 'โนนบุรี',
          en: 'Non Buri',
        },
        districtId: 519,
      },
      {
        id: '460908',
        zipcode: 46140,
        text: 'โนนน้ำเกลี้ยง',
        value: 'โนนน้ำเกลี้ยง',
        name: {
          th: 'โนนน้ำเกลี้ยง',
          en: 'Non Nam Kliang',
        },
        districtId: 519,
      },
      {
        id: '461001',
        zipcode: 46180,
        text: 'ทุ่งคลอง',
        value: 'ทุ่งคลอง',
        name: {
          th: 'ทุ่งคลอง',
          en: 'Thung Khlong',
        },
        districtId: 520,
      },
      {
        id: '461002',
        zipcode: 46180,
        text: 'โพน',
        value: 'โพน',
        name: {
          th: 'โพน',
          en: 'Phon',
        },
        districtId: 520,
      },
      {
        id: '461005',
        zipcode: 46180,
        text: 'ดินจี่',
        value: 'ดินจี่',
        name: {
          th: 'ดินจี่',
          en: 'Din Chi',
        },
        districtId: 520,
      },
      {
        id: '461006',
        zipcode: 46180,
        text: 'นาบอน',
        value: 'นาบอน',
        name: {
          th: 'นาบอน',
          en: 'Na Bon',
        },
        districtId: 520,
      },
      {
        id: '461007',
        zipcode: 46180,
        text: 'นาทัน',
        value: 'นาทัน',
        name: {
          th: 'นาทัน',
          en: 'Na Than',
        },
        districtId: 520,
      },
      {
        id: '461009',
        zipcode: 46180,
        text: 'เนินยาง',
        value: 'เนินยาง',
        name: {
          th: 'เนินยาง',
          en: 'Noen Yang',
        },
        districtId: 520,
      },
      {
        id: '461101',
        zipcode: 46190,
        text: 'ท่าคันโท',
        value: 'ท่าคันโท',
        name: {
          th: 'ท่าคันโท',
          en: 'Tha Khantho',
        },
        districtId: 521,
      },
      {
        id: '461102',
        zipcode: 46190,
        text: 'กุงเก่า',
        value: 'กุงเก่า',
        name: {
          th: 'กุงเก่า',
          en: 'Kung Kao',
        },
        districtId: 521,
      },
      {
        id: '461103',
        zipcode: 46190,
        text: 'ยางอู้ม',
        value: 'ยางอู้ม',
        name: {
          th: 'ยางอู้ม',
          en: 'Yang Um',
        },
        districtId: 521,
      },
      {
        id: '461104',
        zipcode: 46190,
        text: 'กุดจิก',
        value: 'กุดจิก',
        name: {
          th: 'กุดจิก',
          en: 'Kut Chik',
        },
        districtId: 521,
      },
      {
        id: '461105',
        zipcode: 46190,
        text: 'นาตาล',
        value: 'นาตาล',
        name: {
          th: 'นาตาล',
          en: 'Na Tan',
        },
        districtId: 521,
      },
      {
        id: '461106',
        zipcode: 46190,
        text: 'ดงสมบูรณ์',
        value: 'ดงสมบูรณ์',
        name: {
          th: 'ดงสมบูรณ์',
          en: 'Dong Sombun',
        },
        districtId: 521,
      },
      {
        id: '461201',
        zipcode: 46220,
        text: 'หนองกุงศรี',
        value: 'หนองกุงศรี',
        name: {
          th: 'หนองกุงศรี',
          en: 'Nong Kung Si',
        },
        districtId: 522,
      },
      {
        id: '461202',
        zipcode: 46220,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 522,
      },
      {
        id: '461203',
        zipcode: 46220,
        text: 'โคกเครือ',
        value: 'โคกเครือ',
        name: {
          th: 'โคกเครือ',
          en: 'Khok Khruea',
        },
        districtId: 522,
      },
      {
        id: '461204',
        zipcode: 46220,
        text: 'หนองสรวง',
        value: 'หนองสรวง',
        name: {
          th: 'หนองสรวง',
          en: 'Nong Suang',
        },
        districtId: 522,
      },
      {
        id: '461205',
        zipcode: 46220,
        text: 'เสาเล้า',
        value: 'เสาเล้า',
        name: {
          th: 'เสาเล้า',
          en: 'Sao Lao',
        },
        districtId: 522,
      },
      {
        id: '461206',
        zipcode: 46220,
        text: 'หนองใหญ่',
        value: 'หนองใหญ่',
        name: {
          th: 'หนองใหญ่',
          en: 'Nong Yai',
        },
        districtId: 522,
      },
      {
        id: '461207',
        zipcode: 46220,
        text: 'ดงมูล',
        value: 'ดงมูล',
        name: {
          th: 'ดงมูล',
          en: 'Dong Mun',
        },
        districtId: 522,
      },
      {
        id: '461208',
        zipcode: 46220,
        text: 'ลำหนองแสน',
        value: 'ลำหนองแสน',
        name: {
          th: 'ลำหนองแสน',
          en: 'Lam Nong Saen',
        },
        districtId: 522,
      },
      {
        id: '461209',
        zipcode: 46220,
        text: 'หนองหิน',
        value: 'หนองหิน',
        name: {
          th: 'หนองหิน',
          en: 'Nong Hin',
        },
        districtId: 522,
      },
      {
        id: '461301',
        zipcode: 46150,
        text: 'สมเด็จ',
        value: 'สมเด็จ',
        name: {
          th: 'สมเด็จ',
          en: 'Somdet',
        },
        districtId: 523,
      },
      {
        id: '461302',
        zipcode: 46150,
        text: 'หนองแวง',
        value: 'หนองแวง',
        name: {
          th: 'หนองแวง',
          en: 'Nong Waeng',
        },
        districtId: 523,
      },
      {
        id: '461303',
        zipcode: 46150,
        text: 'แซงบาดาล',
        value: 'แซงบาดาล',
        name: {
          th: 'แซงบาดาล',
          en: 'Saeng Badan',
        },
        districtId: 523,
      },
      {
        id: '461304',
        zipcode: 46150,
        text: 'มหาไชย',
        value: 'มหาไชย',
        name: {
          th: 'มหาไชย',
          en: 'Maha Chai',
        },
        districtId: 523,
      },
      {
        id: '461305',
        zipcode: 46150,
        text: 'หมูม่น',
        value: 'หมูม่น',
        name: {
          th: 'หมูม่น',
          en: 'Mu Mon',
        },
        districtId: 523,
      },
      {
        id: '461306',
        zipcode: 46150,
        text: 'ผาเสวย',
        value: 'ผาเสวย',
        name: {
          th: 'ผาเสวย',
          en: 'Pha Sawoei',
        },
        districtId: 523,
      },
      {
        id: '461307',
        zipcode: 46150,
        text: 'ศรีสมเด็จ',
        value: 'ศรีสมเด็จ',
        name: {
          th: 'ศรีสมเด็จ',
          en: 'Si Somdet',
        },
        districtId: 523,
      },
      {
        id: '461308',
        zipcode: 46150,
        text: 'ลำห้วยหลัว',
        value: 'ลำห้วยหลัว',
        name: {
          th: 'ลำห้วยหลัว',
          en: 'Lam Huai Lua',
        },
        districtId: 523,
      },
      {
        id: '461401',
        zipcode: 46240,
        text: 'คำบง',
        value: 'คำบง',
        name: {
          th: 'คำบง',
          en: 'Kham Bong',
        },
        districtId: 524,
      },
      {
        id: '461402',
        zipcode: 46240,
        text: 'ไค้นุ่น',
        value: 'ไค้นุ่น',
        name: {
          th: 'ไค้นุ่น',
          en: 'Khai Nun',
        },
        districtId: 524,
      },
      {
        id: '461403',
        zipcode: 46240,
        text: 'นิคมห้วยผึ้ง',
        value: 'นิคมห้วยผึ้ง',
        name: {
          th: 'นิคมห้วยผึ้ง',
          en: 'Nikhom Huai Phueng',
        },
        districtId: 524,
      },
      {
        id: '461404',
        zipcode: 46240,
        text: 'หนองอีบุตร',
        value: 'หนองอีบุตร',
        name: {
          th: 'หนองอีบุตร',
          en: 'Nong I But',
        },
        districtId: 524,
      },
      {
        id: '461501',
        zipcode: 46180,
        text: 'สำราญ',
        value: 'สำราญ',
        name: {
          th: 'สำราญ',
          en: 'Samran',
        },
        districtId: 525,
      },
      {
        id: '461502',
        zipcode: 46180,
        text: 'สำราญใต้',
        value: 'สำราญใต้',
        name: {
          th: 'สำราญใต้',
          en: 'Samran Tai',
        },
        districtId: 525,
      },
      {
        id: '461503',
        zipcode: 46180,
        text: 'คำสร้างเที่ยง',
        value: 'คำสร้างเที่ยง',
        name: {
          th: 'คำสร้างเที่ยง',
          en: 'Kham Sang Thiang',
        },
        districtId: 525,
      },
      {
        id: '461504',
        zipcode: 46180,
        text: 'หนองช้าง',
        value: 'หนองช้าง',
        name: {
          th: 'หนองช้าง',
          en: 'Nong Chang',
        },
        districtId: 525,
      },
      {
        id: '461601',
        zipcode: 46160,
        text: 'นาคู',
        value: 'นาคู',
        name: {
          th: 'นาคู',
          en: 'Na Khu',
        },
        districtId: 526,
      },
      {
        id: '461602',
        zipcode: 46160,
        text: 'สายนาวัง',
        value: 'สายนาวัง',
        name: {
          th: 'สายนาวัง',
          en: 'Sai Na Wang',
        },
        districtId: 526,
      },
      {
        id: '461603',
        zipcode: 46160,
        text: 'โนนนาจาน',
        value: 'โนนนาจาน',
        name: {
          th: 'โนนนาจาน',
          en: 'Non Na Chan',
        },
        districtId: 526,
      },
      {
        id: '461604',
        zipcode: 46160,
        text: 'บ่อแก้ว',
        value: 'บ่อแก้ว',
        name: {
          th: 'บ่อแก้ว',
          en: 'Bo Kaeo',
        },
        districtId: 526,
      },
      {
        id: '461605',
        zipcode: 46160,
        text: 'ภูแล่นช้าง',
        value: 'ภูแล่นช้าง',
        name: {
          th: 'ภูแล่นช้าง',
          en: 'Phu Laen Chang',
        },
        districtId: 526,
      },
      {
        id: '461701',
        zipcode: 46000,
        text: 'ดอนจาน',
        value: 'ดอนจาน',
        name: {
          th: 'ดอนจาน',
          en: 'Don Chan',
        },
        districtId: 527,
      },
      {
        id: '461702',
        zipcode: 46000,
        text: 'สะอาดไชยศรี',
        value: 'สะอาดไชยศรี',
        name: {
          th: 'สะอาดไชยศรี',
          en: 'Sa-at Chai Si',
        },
        districtId: 527,
      },
      {
        id: '461703',
        zipcode: 46000,
        text: 'ดงพยุง',
        value: 'ดงพยุง',
        name: {
          th: 'ดงพยุง',
          en: 'Dong Phayung',
        },
        districtId: 527,
      },
      {
        id: '461704',
        zipcode: 46000,
        text: 'ม่วงนา',
        value: 'ม่วงนา',
        name: {
          th: 'ม่วงนา',
          en: 'Muang Na',
        },
        districtId: 527,
      },
      {
        id: '461705',
        zipcode: 46000,
        text: 'นาจำปา',
        value: 'นาจำปา',
        name: {
          th: 'นาจำปา',
          en: 'Na Champa',
        },
        districtId: 527,
      },
      {
        id: '461801',
        zipcode: 46130,
        text: 'ฆ้องชัยพัฒนา',
        value: 'ฆ้องชัยพัฒนา',
        name: {
          th: 'ฆ้องชัยพัฒนา',
          en: 'Khong Chai Phatthana',
        },
        districtId: 528,
      },
      {
        id: '461802',
        zipcode: 46130,
        text: 'เหล่ากลาง',
        value: 'เหล่ากลาง',
        name: {
          th: 'เหล่ากลาง',
          en: 'Lao Klang',
        },
        districtId: 528,
      },
      {
        id: '461803',
        zipcode: 46130,
        text: 'โคกสะอาด',
        value: 'โคกสะอาด',
        name: {
          th: 'โคกสะอาด',
          en: 'Khok Sa-at',
        },
        districtId: 528,
      },
      {
        id: '461804',
        zipcode: 46130,
        text: 'โนนศิลาเลิง',
        value: 'โนนศิลาเลิง',
        name: {
          th: 'โนนศิลาเลิง',
          en: 'Non Sila Loeng',
        },
        districtId: 528,
      },
      {
        id: '461805',
        zipcode: 46130,
        text: 'ลำชี',
        value: 'ลำชี',
        name: {
          th: 'ลำชี',
          en: 'Lam Chi',
        },
        districtId: 528,
      },
      {
        id: '470101',
        zipcode: 47000,
        text: 'ธาตุเชิงชุม',
        value: 'ธาตุเชิงชุม',
        name: {
          th: 'ธาตุเชิงชุม',
          en: 'That Choeng Chum',
        },
        districtId: 529,
      },
      {
        id: '470102',
        zipcode: 47220,
        text: 'ขมิ้น',
        value: 'ขมิ้น',
        name: {
          th: 'ขมิ้น',
          en: 'Khamin',
        },
        districtId: 529,
      },
      {
        id: '470103',
        zipcode: 47000,
        text: 'งิ้วด่อน',
        value: 'งิ้วด่อน',
        name: {
          th: 'งิ้วด่อน',
          en: 'Ngio Don',
        },
        districtId: 529,
      },
      {
        id: '470104',
        zipcode: 47000,
        text: 'โนนหอม',
        value: 'โนนหอม',
        name: {
          th: 'โนนหอม',
          en: 'Non Hom',
        },
        districtId: 529,
      },
      {
        id: '470106',
        zipcode: 47000,
        text: 'เชียงเครือ',
        value: 'เชียงเครือ',
        name: {
          th: 'เชียงเครือ',
          en: 'Chiang Khruea',
        },
        districtId: 529,
      },
      {
        id: '470107',
        zipcode: 47000,
        text: 'ท่าแร่',
        value: 'ท่าแร่',
        name: {
          th: 'ท่าแร่',
          en: 'Tha Rae',
        },
        districtId: 529,
      },
      {
        id: '470109',
        zipcode: 47000,
        text: 'ม่วงลาย',
        value: 'ม่วงลาย',
        name: {
          th: 'ม่วงลาย',
          en: 'Muang Lai',
        },
        districtId: 529,
      },
      {
        id: '470111',
        zipcode: 47000,
        text: 'ดงชน',
        value: 'ดงชน',
        name: {
          th: 'ดงชน',
          en: 'Dong Chon',
        },
        districtId: 529,
      },
      {
        id: '470112',
        zipcode: 47000,
        text: 'ห้วยยาง',
        value: 'ห้วยยาง',
        name: {
          th: 'ห้วยยาง',
          en: 'Huai Yang',
        },
        districtId: 529,
      },
      {
        id: '470113',
        zipcode: 47000,
        text: 'พังขว้าง',
        value: 'พังขว้าง',
        name: {
          th: 'พังขว้าง',
          en: 'Phang Khwang',
        },
        districtId: 529,
      },
      {
        id: '470115',
        zipcode: 47000,
        text: 'ดงมะไฟ',
        value: 'ดงมะไฟ',
        name: {
          th: 'ดงมะไฟ',
          en: 'Dong Mafai',
        },
        districtId: 529,
      },
      {
        id: '470116',
        zipcode: 47000,
        text: 'ธาตุนาเวง',
        value: 'ธาตุนาเวง',
        name: {
          th: 'ธาตุนาเวง',
          en: 'That Na Weng',
        },
        districtId: 529,
      },
      {
        id: '470117',
        zipcode: 47000,
        text: 'เหล่าปอแดง',
        value: 'เหล่าปอแดง',
        name: {
          th: 'เหล่าปอแดง',
          en: 'Lao Po Daeng',
        },
        districtId: 529,
      },
      {
        id: '470118',
        zipcode: 47220,
        text: 'หนองลาด',
        value: 'หนองลาด',
        name: {
          th: 'หนองลาด',
          en: 'Nong Lat',
        },
        districtId: 529,
      },
      {
        id: '470120',
        zipcode: 47000,
        text: 'ฮางโฮง',
        value: 'ฮางโฮง',
        name: {
          th: 'ฮางโฮง',
          en: 'Hang Hong',
        },
        districtId: 529,
      },
      {
        id: '470121',
        zipcode: 47000,
        text: 'โคกก่อง',
        value: 'โคกก่อง',
        name: {
          th: 'โคกก่อง',
          en: 'Khok Kong',
        },
        districtId: 529,
      },
      {
        id: '470201',
        zipcode: 47210,
        text: 'กุสุมาลย์',
        value: 'กุสุมาลย์',
        name: {
          th: 'กุสุมาลย์',
          en: 'Kusuman',
        },
        districtId: 530,
      },
      {
        id: '470202',
        zipcode: 47210,
        text: 'นาโพธิ์',
        value: 'นาโพธิ์',
        name: {
          th: 'นาโพธิ์',
          en: 'Na Pho',
        },
        districtId: 530,
      },
      {
        id: '470203',
        zipcode: 47230,
        text: 'นาเพียง',
        value: 'นาเพียง',
        name: {
          th: 'นาเพียง',
          en: 'Na Phiang',
        },
        districtId: 530,
      },
      {
        id: '470204',
        zipcode: 47210,
        text: 'โพธิไพศาล',
        value: 'โพธิไพศาล',
        name: {
          th: 'โพธิไพศาล',
          en: 'Phothi Phaisan',
        },
        districtId: 530,
      },
      {
        id: '470205',
        zipcode: 47230,
        text: 'อุ่มจาน',
        value: 'อุ่มจาน',
        name: {
          th: 'อุ่มจาน',
          en: 'Um Chan',
        },
        districtId: 530,
      },
      {
        id: '470301',
        zipcode: 47180,
        text: 'กุดบาก',
        value: 'กุดบาก',
        name: {
          th: 'กุดบาก',
          en: 'Kut Bak',
        },
        districtId: 531,
      },
      {
        id: '470303',
        zipcode: 47180,
        text: 'นาม่อง',
        value: 'นาม่อง',
        name: {
          th: 'นาม่อง',
          en: 'Na Mong',
        },
        districtId: 531,
      },
      {
        id: '470305',
        zipcode: 47180,
        text: 'กุดไห',
        value: 'กุดไห',
        name: {
          th: 'กุดไห',
          en: 'Kut Hai',
        },
        districtId: 531,
      },
      {
        id: '470401',
        zipcode: 47130,
        text: 'พรรณา',
        value: 'พรรณา',
        name: {
          th: 'พรรณา',
          en: 'Phanna',
        },
        districtId: 532,
      },
      {
        id: '470402',
        zipcode: 47130,
        text: 'วังยาง',
        value: 'วังยาง',
        name: {
          th: 'วังยาง',
          en: 'Wang Yang',
        },
        districtId: 532,
      },
      {
        id: '470403',
        zipcode: 47220,
        text: 'พอกน้อย',
        value: 'พอกน้อย',
        name: {
          th: 'พอกน้อย',
          en: 'Phok Noi',
        },
        districtId: 532,
      },
      {
        id: '470404',
        zipcode: 47220,
        text: 'นาหัวบ่อ',
        value: 'นาหัวบ่อ',
        name: {
          th: 'นาหัวบ่อ',
          en: 'Na Hua Bo',
        },
        districtId: 532,
      },
      {
        id: '470405',
        zipcode: 47130,
        text: 'ไร่',
        value: 'ไร่',
        name: {
          th: 'ไร่',
          en: 'Rai',
        },
        districtId: 532,
      },
      {
        id: '470406',
        zipcode: 47130,
        text: 'ช้างมิ่ง',
        value: 'ช้างมิ่ง',
        name: {
          th: 'ช้างมิ่ง',
          en: 'Chang Ming',
        },
        districtId: 532,
      },
      {
        id: '470407',
        zipcode: 47130,
        text: 'นาใน',
        value: 'นาใน',
        name: {
          th: 'นาใน',
          en: 'Na Nai',
        },
        districtId: 532,
      },
      {
        id: '470408',
        zipcode: 47130,
        text: 'สว่าง',
        value: 'สว่าง',
        name: {
          th: 'สว่าง',
          en: 'Sawang',
        },
        districtId: 532,
      },
      {
        id: '470409',
        zipcode: 47130,
        text: 'บะฮี',
        value: 'บะฮี',
        name: {
          th: 'บะฮี',
          en: 'Ba Hi',
        },
        districtId: 532,
      },
      {
        id: '470410',
        zipcode: 47130,
        text: 'เชิงชุม',
        value: 'เชิงชุม',
        name: {
          th: 'เชิงชุม',
          en: 'Choeng Chum',
        },
        districtId: 532,
      },
      {
        id: '470501',
        zipcode: 47160,
        text: 'พังโคน',
        value: 'พังโคน',
        name: {
          th: 'พังโคน',
          en: 'Phang Khon',
        },
        districtId: 533,
      },
      {
        id: '470502',
        zipcode: 47160,
        text: 'ม่วงไข่',
        value: 'ม่วงไข่',
        name: {
          th: 'ม่วงไข่',
          en: 'Muang Khai',
        },
        districtId: 533,
      },
      {
        id: '470503',
        zipcode: 47160,
        text: 'แร่',
        value: 'แร่',
        name: {
          th: 'แร่',
          en: 'Rae',
        },
        districtId: 533,
      },
      {
        id: '470504',
        zipcode: 47160,
        text: 'ไฮหย่อง',
        value: 'ไฮหย่อง',
        name: {
          th: 'ไฮหย่อง',
          en: 'Hai Yong',
        },
        districtId: 533,
      },
      {
        id: '470505',
        zipcode: 47160,
        text: 'ต้นผึ้ง',
        value: 'ต้นผึ้ง',
        name: {
          th: 'ต้นผึ้ง',
          en: 'Ton Phueng',
        },
        districtId: 533,
      },
      {
        id: '470601',
        zipcode: 47150,
        text: 'วาริชภูมิ',
        value: 'วาริชภูมิ',
        name: {
          th: 'วาริชภูมิ',
          en: 'Waritchaphum',
        },
        districtId: 534,
      },
      {
        id: '470602',
        zipcode: 47150,
        text: 'ปลาโหล',
        value: 'ปลาโหล',
        name: {
          th: 'ปลาโหล',
          en: 'Pla Lo',
        },
        districtId: 534,
      },
      {
        id: '470603',
        zipcode: 47150,
        text: 'หนองลาด',
        value: 'หนองลาด',
        name: {
          th: 'หนองลาด',
          en: 'Nong Lat',
        },
        districtId: 534,
      },
      {
        id: '470604',
        zipcode: 47150,
        text: 'คำบ่อ',
        value: 'คำบ่อ',
        name: {
          th: 'คำบ่อ',
          en: 'Kham Bo',
        },
        districtId: 534,
      },
      {
        id: '470605',
        zipcode: 47150,
        text: 'ค้อเขียว',
        value: 'ค้อเขียว',
        name: {
          th: 'ค้อเขียว',
          en: 'Kho Khiao',
        },
        districtId: 534,
      },
      {
        id: '470701',
        zipcode: 47270,
        text: 'นิคมน้ำอูน',
        value: 'นิคมน้ำอูน',
        name: {
          th: 'นิคมน้ำอูน',
          en: 'Nikhom Nam Un',
        },
        districtId: 535,
      },
      {
        id: '470702',
        zipcode: 47270,
        text: 'หนองปลิง',
        value: 'หนองปลิง',
        name: {
          th: 'หนองปลิง',
          en: 'Nong Pling',
        },
        districtId: 535,
      },
      {
        id: '470703',
        zipcode: 47270,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 535,
      },
      {
        id: '470704',
        zipcode: 47270,
        text: 'สุวรรณคาม',
        value: 'สุวรรณคาม',
        name: {
          th: 'สุวรรณคาม',
          en: '*Suwannakarm',
        },
        districtId: 535,
      },
      {
        id: '470801',
        zipcode: 47120,
        text: 'วานรนิวาส',
        value: 'วานรนิวาส',
        name: {
          th: 'วานรนิวาส',
          en: 'Wanon Niwat',
        },
        districtId: 536,
      },
      {
        id: '470802',
        zipcode: 47120,
        text: 'เดื่อศรีคันไชย',
        value: 'เดื่อศรีคันไชย',
        name: {
          th: 'เดื่อศรีคันไชย',
          en: 'Duea Si Khan Chai',
        },
        districtId: 536,
      },
      {
        id: '470803',
        zipcode: 47120,
        text: 'ขัวก่าย',
        value: 'ขัวก่าย',
        name: {
          th: 'ขัวก่าย',
          en: 'Khua Kai',
        },
        districtId: 536,
      },
      {
        id: '470804',
        zipcode: 47120,
        text: 'หนองสนม',
        value: 'หนองสนม',
        name: {
          th: 'หนองสนม',
          en: 'Nong Sanom',
        },
        districtId: 536,
      },
      {
        id: '470805',
        zipcode: 47120,
        text: 'คูสะคาม',
        value: 'คูสะคาม',
        name: {
          th: 'คูสะคาม',
          en: 'Khu Sakham',
        },
        districtId: 536,
      },
      {
        id: '470806',
        zipcode: 47120,
        text: 'ธาตุ',
        value: 'ธาตุ',
        name: {
          th: 'ธาตุ',
          en: 'That',
        },
        districtId: 536,
      },
      {
        id: '470807',
        zipcode: 47120,
        text: 'หนองแวง',
        value: 'หนองแวง',
        name: {
          th: 'หนองแวง',
          en: 'Nong Waeng',
        },
        districtId: 536,
      },
      {
        id: '470808',
        zipcode: 47120,
        text: 'ศรีวิชัย',
        value: 'ศรีวิชัย',
        name: {
          th: 'ศรีวิชัย',
          en: 'Si Wichai',
        },
        districtId: 536,
      },
      {
        id: '470809',
        zipcode: 47120,
        text: 'นาซอ',
        value: 'นาซอ',
        name: {
          th: 'นาซอ',
          en: 'Na So',
        },
        districtId: 536,
      },
      {
        id: '470810',
        zipcode: 47120,
        text: 'อินทร์แปลง',
        value: 'อินทร์แปลง',
        name: {
          th: 'อินทร์แปลง',
          en: 'In Plaeng',
        },
        districtId: 536,
      },
      {
        id: '470811',
        zipcode: 47120,
        text: 'นาคำ',
        value: 'นาคำ',
        name: {
          th: 'นาคำ',
          en: 'Na Kham',
        },
        districtId: 536,
      },
      {
        id: '470812',
        zipcode: 47120,
        text: 'คอนสวรรค์',
        value: 'คอนสวรรค์',
        name: {
          th: 'คอนสวรรค์',
          en: 'Khon Sawan',
        },
        districtId: 536,
      },
      {
        id: '470813',
        zipcode: 47120,
        text: 'กุดเรือคำ',
        value: 'กุดเรือคำ',
        name: {
          th: 'กุดเรือคำ',
          en: 'Kut Ruea Kham',
        },
        districtId: 536,
      },
      {
        id: '470814',
        zipcode: 47120,
        text: 'หนองแวงใต้',
        value: 'หนองแวงใต้',
        name: {
          th: 'หนองแวงใต้',
          en: 'Nong Waeng Tai',
        },
        districtId: 536,
      },
      {
        id: '470901',
        zipcode: 47250,
        text: 'คำตากล้า',
        value: 'คำตากล้า',
        name: {
          th: 'คำตากล้า',
          en: 'Kham Ta Kla',
        },
        districtId: 537,
      },
      {
        id: '470902',
        zipcode: 47250,
        text: 'หนองบัวสิม',
        value: 'หนองบัวสิม',
        name: {
          th: 'หนองบัวสิม',
          en: 'Nong Bua Sim',
        },
        districtId: 537,
      },
      {
        id: '470903',
        zipcode: 47250,
        text: 'นาแต้',
        value: 'นาแต้',
        name: {
          th: 'นาแต้',
          en: 'Na Tae',
        },
        districtId: 537,
      },
      {
        id: '470904',
        zipcode: 47250,
        text: 'แพด',
        value: 'แพด',
        name: {
          th: 'แพด',
          en: 'Phaet',
        },
        districtId: 537,
      },
      {
        id: '471001',
        zipcode: 47140,
        text: 'ม่วง',
        value: 'ม่วง',
        name: {
          th: 'ม่วง',
          en: 'Muang',
        },
        districtId: 538,
      },
      {
        id: '471002',
        zipcode: 47140,
        text: 'มาย',
        value: 'มาย',
        name: {
          th: 'มาย',
          en: 'Mai',
        },
        districtId: 538,
      },
      {
        id: '471003',
        zipcode: 47140,
        text: 'ดงหม้อทอง',
        value: 'ดงหม้อทอง',
        name: {
          th: 'ดงหม้อทอง',
          en: 'Dong Mo Thong',
        },
        districtId: 538,
      },
      {
        id: '471004',
        zipcode: 47140,
        text: 'ดงเหนือ',
        value: 'ดงเหนือ',
        name: {
          th: 'ดงเหนือ',
          en: 'Dong Nuea',
        },
        districtId: 538,
      },
      {
        id: '471005',
        zipcode: 47140,
        text: 'ดงหม้อทองใต้',
        value: 'ดงหม้อทองใต้',
        name: {
          th: 'ดงหม้อทองใต้',
          en: 'Dong Mo Thong Tai',
        },
        districtId: 538,
      },
      {
        id: '471006',
        zipcode: 47140,
        text: 'ห้วยหลัว',
        value: 'ห้วยหลัว',
        name: {
          th: 'ห้วยหลัว',
          en: 'Huai Lua',
        },
        districtId: 538,
      },
      {
        id: '471007',
        zipcode: 47140,
        text: 'โนนสะอาด',
        value: 'โนนสะอาด',
        name: {
          th: 'โนนสะอาด',
          en: 'Non Sa-at',
        },
        districtId: 538,
      },
      {
        id: '471008',
        zipcode: 47140,
        text: 'หนองกวั่ง',
        value: 'หนองกวั่ง',
        name: {
          th: 'หนองกวั่ง',
          en: 'Nong Kwang',
        },
        districtId: 538,
      },
      {
        id: '471009',
        zipcode: 47140,
        text: 'บ่อแก้ว',
        value: 'บ่อแก้ว',
        name: {
          th: 'บ่อแก้ว',
          en: 'Bo Kaeo',
        },
        districtId: 538,
      },
      {
        id: '471101',
        zipcode: 47170,
        text: 'อากาศ',
        value: 'อากาศ',
        name: {
          th: 'อากาศ',
          en: 'Akat',
        },
        districtId: 539,
      },
      {
        id: '471102',
        zipcode: 47170,
        text: 'โพนแพง',
        value: 'โพนแพง',
        name: {
          th: 'โพนแพง',
          en: 'Phon Phaeng',
        },
        districtId: 539,
      },
      {
        id: '471103',
        zipcode: 47170,
        text: 'วาใหญ่',
        value: 'วาใหญ่',
        name: {
          th: 'วาใหญ่',
          en: 'Wa Yai',
        },
        districtId: 539,
      },
      {
        id: '471104',
        zipcode: 47170,
        text: 'โพนงาม',
        value: 'โพนงาม',
        name: {
          th: 'โพนงาม',
          en: 'Phon Ngam',
        },
        districtId: 539,
      },
      {
        id: '471105',
        zipcode: 47170,
        text: 'ท่าก้อน',
        value: 'ท่าก้อน',
        name: {
          th: 'ท่าก้อน',
          en: 'Tha Kon',
        },
        districtId: 539,
      },
      {
        id: '471106',
        zipcode: 47170,
        text: 'นาฮี',
        value: 'นาฮี',
        name: {
          th: 'นาฮี',
          en: 'Na Hi',
        },
        districtId: 539,
      },
      {
        id: '471107',
        zipcode: 47170,
        text: 'บะหว้า',
        value: 'บะหว้า',
        name: {
          th: 'บะหว้า',
          en: 'Ba Wa',
        },
        districtId: 539,
      },
      {
        id: '471108',
        zipcode: 47170,
        text: 'สามัคคีพัฒนา',
        value: 'สามัคคีพัฒนา',
        name: {
          th: 'สามัคคีพัฒนา',
          en: 'Samakkhi Phatthana',
        },
        districtId: 539,
      },
      {
        id: '471201',
        zipcode: 47110,
        text: 'สว่างแดนดิน',
        value: 'สว่างแดนดิน',
        name: {
          th: 'สว่างแดนดิน',
          en: 'Sawang Daen Din',
        },
        districtId: 540,
      },
      {
        id: '471203',
        zipcode: 47110,
        text: 'คำสะอาด',
        value: 'คำสะอาด',
        name: {
          th: 'คำสะอาด',
          en: 'Kham Sa-at',
        },
        districtId: 540,
      },
      {
        id: '471204',
        zipcode: 47110,
        text: 'บ้านต้าย',
        value: 'บ้านต้าย',
        name: {
          th: 'บ้านต้าย',
          en: 'Ban Tai',
        },
        districtId: 540,
      },
      {
        id: '471206',
        zipcode: 47110,
        text: 'บงเหนือ',
        value: 'บงเหนือ',
        name: {
          th: 'บงเหนือ',
          en: 'Bong Nuea',
        },
        districtId: 540,
      },
      {
        id: '471207',
        zipcode: 47110,
        text: 'โพนสูง',
        value: 'โพนสูง',
        name: {
          th: 'โพนสูง',
          en: 'Phon Sung',
        },
        districtId: 540,
      },
      {
        id: '471208',
        zipcode: 47110,
        text: 'โคกสี',
        value: 'โคกสี',
        name: {
          th: 'โคกสี',
          en: 'Khok Si',
        },
        districtId: 540,
      },
      {
        id: '471210',
        zipcode: 47110,
        text: 'หนองหลวง',
        value: 'หนองหลวง',
        name: {
          th: 'หนองหลวง',
          en: 'Nong Luang',
        },
        districtId: 540,
      },
      {
        id: '471211',
        zipcode: 47110,
        text: 'บงใต้',
        value: 'บงใต้',
        name: {
          th: 'บงใต้',
          en: 'Bong Tai',
        },
        districtId: 540,
      },
      {
        id: '471212',
        zipcode: 47110,
        text: 'ค้อใต้',
        value: 'ค้อใต้',
        name: {
          th: 'ค้อใต้',
          en: 'Kho Tai',
        },
        districtId: 540,
      },
      {
        id: '471213',
        zipcode: 47240,
        text: 'พันนา',
        value: 'พันนา',
        name: {
          th: 'พันนา',
          en: 'Phan Na',
        },
        districtId: 540,
      },
      {
        id: '471214',
        zipcode: 47240,
        text: 'แวง',
        value: 'แวง',
        name: {
          th: 'แวง',
          en: 'Waeng',
        },
        districtId: 540,
      },
      {
        id: '471215',
        zipcode: 47110,
        text: 'ทรายมูล',
        value: 'ทรายมูล',
        name: {
          th: 'ทรายมูล',
          en: 'Sai Mun',
        },
        districtId: 540,
      },
      {
        id: '471216',
        zipcode: 47240,
        text: 'ตาลโกน',
        value: 'ตาลโกน',
        name: {
          th: 'ตาลโกน',
          en: 'Tan Kon',
        },
        districtId: 540,
      },
      {
        id: '471217',
        zipcode: 47240,
        text: 'ตาลเนิ้ง',
        value: 'ตาลเนิ้ง',
        name: {
          th: 'ตาลเนิ้ง',
          en: 'Tan Noeng',
        },
        districtId: 540,
      },
      {
        id: '471220',
        zipcode: 47240,
        text: 'ธาตุทอง',
        value: 'ธาตุทอง',
        name: {
          th: 'ธาตุทอง',
          en: 'That Thong',
        },
        districtId: 540,
      },
      {
        id: '471221',
        zipcode: 47110,
        text: 'บ้านถ่อน',
        value: 'บ้านถ่อน',
        name: {
          th: 'บ้านถ่อน',
          en: 'Ban Thon',
        },
        districtId: 540,
      },
      {
        id: '471301',
        zipcode: 47190,
        text: 'ส่องดาว',
        value: 'ส่องดาว',
        name: {
          th: 'ส่องดาว',
          en: 'Song Dao',
        },
        districtId: 541,
      },
      {
        id: '471302',
        zipcode: 47190,
        text: 'ท่าศิลา',
        value: 'ท่าศิลา',
        name: {
          th: 'ท่าศิลา',
          en: 'Tha Sila',
        },
        districtId: 541,
      },
      {
        id: '471303',
        zipcode: 47190,
        text: 'วัฒนา',
        value: 'วัฒนา',
        name: {
          th: 'วัฒนา',
          en: 'Watthana',
        },
        districtId: 541,
      },
      {
        id: '471304',
        zipcode: 47190,
        text: 'ปทุมวาปี',
        value: 'ปทุมวาปี',
        name: {
          th: 'ปทุมวาปี',
          en: 'Pathum Wapi',
        },
        districtId: 541,
      },
      {
        id: '471401',
        zipcode: 47260,
        text: 'เต่างอย',
        value: 'เต่างอย',
        name: {
          th: 'เต่างอย',
          en: 'Tao Ngoi',
        },
        districtId: 542,
      },
      {
        id: '471402',
        zipcode: 47260,
        text: 'บึงทวาย',
        value: 'บึงทวาย',
        name: {
          th: 'บึงทวาย',
          en: 'Bueng Thawai',
        },
        districtId: 542,
      },
      {
        id: '471403',
        zipcode: 47260,
        text: 'นาตาล',
        value: 'นาตาล',
        name: {
          th: 'นาตาล',
          en: 'Na Tan',
        },
        districtId: 542,
      },
      {
        id: '471404',
        zipcode: 47260,
        text: 'จันทร์เพ็ญ',
        value: 'จันทร์เพ็ญ',
        name: {
          th: 'จันทร์เพ็ญ',
          en: 'Chan Phen',
        },
        districtId: 542,
      },
      {
        id: '471501',
        zipcode: 47280,
        text: 'ตองโขบ',
        value: 'ตองโขบ',
        name: {
          th: 'ตองโขบ',
          en: 'Tong Khop',
        },
        districtId: 543,
      },
      {
        id: '471502',
        zipcode: 47280,
        text: 'เหล่าโพนค้อ',
        value: 'เหล่าโพนค้อ',
        name: {
          th: 'เหล่าโพนค้อ',
          en: 'Lao Phon Kho',
        },
        districtId: 543,
      },
      {
        id: '471503',
        zipcode: 47280,
        text: 'ด่านม่วงคำ',
        value: 'ด่านม่วงคำ',
        name: {
          th: 'ด่านม่วงคำ',
          en: 'Dan Muang Kham',
        },
        districtId: 543,
      },
      {
        id: '471504',
        zipcode: 47280,
        text: 'แมดนาท่ม',
        value: 'แมดนาท่ม',
        name: {
          th: 'แมดนาท่ม',
          en: 'Maet Na Thom',
        },
        districtId: 543,
      },
      {
        id: '471601',
        zipcode: 47290,
        text: 'บ้านเหล่า',
        value: 'บ้านเหล่า',
        name: {
          th: 'บ้านเหล่า',
          en: 'Ban Lao',
        },
        districtId: 544,
      },
      {
        id: '471602',
        zipcode: 47290,
        text: 'เจริญศิลป์',
        value: 'เจริญศิลป์',
        name: {
          th: 'เจริญศิลป์',
          en: 'Charoen Sin',
        },
        districtId: 544,
      },
      {
        id: '471603',
        zipcode: 47290,
        text: 'ทุ่งแก',
        value: 'ทุ่งแก',
        name: {
          th: 'ทุ่งแก',
          en: 'Thung Kae',
        },
        districtId: 544,
      },
      {
        id: '471604',
        zipcode: 47290,
        text: 'โคกศิลา',
        value: 'โคกศิลา',
        name: {
          th: 'โคกศิลา',
          en: 'Khok Sila',
        },
        districtId: 544,
      },
      {
        id: '471605',
        zipcode: 47290,
        text: 'หนองแปน',
        value: 'หนองแปน',
        name: {
          th: 'หนองแปน',
          en: 'Nong Paen',
        },
        districtId: 544,
      },
      {
        id: '471701',
        zipcode: 47230,
        text: 'บ้านโพน',
        value: 'บ้านโพน',
        name: {
          th: 'บ้านโพน',
          en: 'Ban Phon',
        },
        districtId: 545,
      },
      {
        id: '471702',
        zipcode: 47230,
        text: 'นาแก้ว',
        value: 'นาแก้ว',
        name: {
          th: 'นาแก้ว',
          en: 'Na Kaeo',
        },
        districtId: 545,
      },
      {
        id: '471703',
        zipcode: 47230,
        text: 'นาตงวัฒนา',
        value: 'นาตงวัฒนา',
        name: {
          th: 'นาตงวัฒนา',
          en: 'Na Tong Watthana',
        },
        districtId: 545,
      },
      {
        id: '471704',
        zipcode: 47230,
        text: 'บ้านแป้น',
        value: 'บ้านแป้น',
        name: {
          th: 'บ้านแป้น',
          en: 'Ban Paen',
        },
        districtId: 545,
      },
      {
        id: '471705',
        zipcode: 47230,
        text: 'เชียงสือ',
        value: 'เชียงสือ',
        name: {
          th: 'เชียงสือ',
          en: 'Chiang Sue',
        },
        districtId: 545,
      },
      {
        id: '471801',
        zipcode: 47180,
        text: 'สร้างค้อ',
        value: 'สร้างค้อ',
        name: {
          th: 'สร้างค้อ',
          en: 'Sang Kho',
        },
        districtId: 546,
      },
      {
        id: '471802',
        zipcode: 47180,
        text: 'หลุบเลา',
        value: 'หลุบเลา',
        name: {
          th: 'หลุบเลา',
          en: 'Lup Lao',
        },
        districtId: 546,
      },
      {
        id: '471803',
        zipcode: 47180,
        text: 'โคกภู',
        value: 'โคกภู',
        name: {
          th: 'โคกภู',
          en: 'Khok Phu',
        },
        districtId: 546,
      },
      {
        id: '471804',
        zipcode: 47180,
        text: 'กกปลาซิว',
        value: 'กกปลาซิว',
        name: {
          th: 'กกปลาซิว',
          en: 'Kok Pla Sio',
        },
        districtId: 546,
      },
      {
        id: '480101',
        zipcode: 48000,
        text: 'ในเมือง',
        value: 'ในเมือง',
        name: {
          th: 'ในเมือง',
          en: 'Nai Mueang',
        },
        districtId: 549,
      },
      {
        id: '480102',
        zipcode: 48000,
        text: 'หนองแสง',
        value: 'หนองแสง',
        name: {
          th: 'หนองแสง',
          en: 'Nong Saeng',
        },
        districtId: 549,
      },
      {
        id: '480103',
        zipcode: 48000,
        text: 'นาทราย',
        value: 'นาทราย',
        name: {
          th: 'นาทราย',
          en: 'Na Sai',
        },
        districtId: 549,
      },
      {
        id: '480104',
        zipcode: 48000,
        text: 'นาราชควาย',
        value: 'นาราชควาย',
        name: {
          th: 'นาราชควาย',
          en: 'Na Rat Khwai',
        },
        districtId: 549,
      },
      {
        id: '480105',
        zipcode: 48000,
        text: 'กุรุคุ',
        value: 'กุรุคุ',
        name: {
          th: 'กุรุคุ',
          en: 'Kurukhu',
        },
        districtId: 549,
      },
      {
        id: '480106',
        zipcode: 48000,
        text: 'บ้านผึ้ง',
        value: 'บ้านผึ้ง',
        name: {
          th: 'บ้านผึ้ง',
          en: 'Ban Phueng',
        },
        districtId: 549,
      },
      {
        id: '480107',
        zipcode: 48000,
        text: 'อาจสามารถ',
        value: 'อาจสามารถ',
        name: {
          th: 'อาจสามารถ',
          en: 'At Samat',
        },
        districtId: 549,
      },
      {
        id: '480108',
        zipcode: 48000,
        text: 'ขามเฒ่า',
        value: 'ขามเฒ่า',
        name: {
          th: 'ขามเฒ่า',
          en: 'Kham Thao',
        },
        districtId: 549,
      },
      {
        id: '480109',
        zipcode: 48000,
        text: 'บ้านกลาง',
        value: 'บ้านกลาง',
        name: {
          th: 'บ้านกลาง',
          en: 'Ban Klang',
        },
        districtId: 549,
      },
      {
        id: '480110',
        zipcode: 48000,
        text: 'ท่าค้อ',
        value: 'ท่าค้อ',
        name: {
          th: 'ท่าค้อ',
          en: 'Tha Kho',
        },
        districtId: 549,
      },
      {
        id: '480111',
        zipcode: 48000,
        text: 'คำเตย',
        value: 'คำเตย',
        name: {
          th: 'คำเตย',
          en: 'Kham Toei',
        },
        districtId: 549,
      },
      {
        id: '480112',
        zipcode: 48000,
        text: 'หนองญาติ',
        value: 'หนองญาติ',
        name: {
          th: 'หนองญาติ',
          en: 'Nong Yat',
        },
        districtId: 549,
      },
      {
        id: '480113',
        zipcode: 48000,
        text: 'ดงขวาง',
        value: 'ดงขวาง',
        name: {
          th: 'ดงขวาง',
          en: 'Dong Khwang',
        },
        districtId: 549,
      },
      {
        id: '480114',
        zipcode: 48000,
        text: 'วังตามัว',
        value: 'วังตามัว',
        name: {
          th: 'วังตามัว',
          en: 'Wang Ta Mua',
        },
        districtId: 549,
      },
      {
        id: '480115',
        zipcode: 48000,
        text: 'โพธิ์ตาก',
        value: 'โพธิ์ตาก',
        name: {
          th: 'โพธิ์ตาก',
          en: 'Pho Tak',
        },
        districtId: 549,
      },
      {
        id: '480201',
        zipcode: 48160,
        text: 'ปลาปาก',
        value: 'ปลาปาก',
        name: {
          th: 'ปลาปาก',
          en: 'Pla Pak',
        },
        districtId: 550,
      },
      {
        id: '480202',
        zipcode: 48160,
        text: 'หนองฮี',
        value: 'หนองฮี',
        name: {
          th: 'หนองฮี',
          en: 'Nong Hi',
        },
        districtId: 550,
      },
      {
        id: '480203',
        zipcode: 48160,
        text: 'กุตาไก้',
        value: 'กุตาไก้',
        name: {
          th: 'กุตาไก้',
          en: 'Kutakai',
        },
        districtId: 550,
      },
      {
        id: '480204',
        zipcode: 48160,
        text: 'โคกสว่าง',
        value: 'โคกสว่าง',
        name: {
          th: 'โคกสว่าง',
          en: 'Khok Sawan',
        },
        districtId: 550,
      },
      {
        id: '480205',
        zipcode: 48160,
        text: 'โคกสูง',
        value: 'โคกสูง',
        name: {
          th: 'โคกสูง',
          en: 'Khok Sung',
        },
        districtId: 550,
      },
      {
        id: '480206',
        zipcode: 48160,
        text: 'มหาชัย',
        value: 'มหาชัย',
        name: {
          th: 'มหาชัย',
          en: 'Maha Chai',
        },
        districtId: 550,
      },
      {
        id: '480207',
        zipcode: 48160,
        text: 'นามะเขือ',
        value: 'นามะเขือ',
        name: {
          th: 'นามะเขือ',
          en: 'Na Makhuea',
        },
        districtId: 550,
      },
      {
        id: '480208',
        zipcode: 48160,
        text: 'หนองเทาใหญ่',
        value: 'หนองเทาใหญ่',
        name: {
          th: 'หนองเทาใหญ่',
          en: 'Nong Thao Yai',
        },
        districtId: 550,
      },
      {
        id: '480301',
        zipcode: 48120,
        text: 'ท่าอุเทน',
        value: 'ท่าอุเทน',
        name: {
          th: 'ท่าอุเทน',
          en: 'Tha Uthen',
        },
        districtId: 551,
      },
      {
        id: '480302',
        zipcode: 48120,
        text: 'โนนตาล',
        value: 'โนนตาล',
        name: {
          th: 'โนนตาล',
          en: 'Non Tan',
        },
        districtId: 551,
      },
      {
        id: '480303',
        zipcode: 48120,
        text: 'ท่าจำปา',
        value: 'ท่าจำปา',
        name: {
          th: 'ท่าจำปา',
          en: 'Tha Champa',
        },
        districtId: 551,
      },
      {
        id: '480304',
        zipcode: 48120,
        text: 'ไชยบุรี',
        value: 'ไชยบุรี',
        name: {
          th: 'ไชยบุรี',
          en: 'Chai Buri',
        },
        districtId: 551,
      },
      {
        id: '480305',
        zipcode: 48120,
        text: 'พนอม',
        value: 'พนอม',
        name: {
          th: 'พนอม',
          en: 'Phanom',
        },
        districtId: 551,
      },
      {
        id: '480306',
        zipcode: 48120,
        text: 'พะทาย',
        value: 'พะทาย',
        name: {
          th: 'พะทาย',
          en: 'Phathai',
        },
        districtId: 551,
      },
      {
        id: '480311',
        zipcode: 48120,
        text: 'เวินพระบาท',
        value: 'เวินพระบาท',
        name: {
          th: 'เวินพระบาท',
          en: 'Woen Phra Bat',
        },
        districtId: 551,
      },
      {
        id: '480312',
        zipcode: 48120,
        text: 'รามราช',
        value: 'รามราช',
        name: {
          th: 'รามราช',
          en: 'Ram Rat',
        },
        districtId: 551,
      },
      {
        id: '480314',
        zipcode: 48120,
        text: 'หนองเทา',
        value: 'หนองเทา',
        name: {
          th: 'หนองเทา',
          en: 'Nong Thao',
        },
        districtId: 551,
      },
      {
        id: '480401',
        zipcode: 48140,
        text: 'บ้านแพง',
        value: 'บ้านแพง',
        name: {
          th: 'บ้านแพง',
          en: 'Ban Phaeng',
        },
        districtId: 552,
      },
      {
        id: '480402',
        zipcode: 48140,
        text: 'ไผ่ล้อม',
        value: 'ไผ่ล้อม',
        name: {
          th: 'ไผ่ล้อม',
          en: 'Phai Lom',
        },
        districtId: 552,
      },
      {
        id: '480403',
        zipcode: 48140,
        text: 'โพนทอง',
        value: 'โพนทอง',
        name: {
          th: 'โพนทอง',
          en: 'Phon Thong',
        },
        districtId: 552,
      },
      {
        id: '480404',
        zipcode: 48140,
        text: 'หนองแวง',
        value: 'หนองแวง',
        name: {
          th: 'หนองแวง',
          en: 'Nong Waeng',
        },
        districtId: 552,
      },
      {
        id: '480408',
        zipcode: 48140,
        text: 'นางัว',
        value: 'นางัว',
        name: {
          th: 'นางัว',
          en: 'Na Ngua',
        },
        districtId: 552,
      },
      {
        id: '480409',
        zipcode: 48140,
        text: 'นาเข',
        value: 'นาเข',
        name: {
          th: 'นาเข',
          en: 'Na Khe',
        },
        districtId: 552,
      },
      {
        id: '480501',
        zipcode: 48110,
        text: 'ธาตุพนม',
        value: 'ธาตุพนม',
        name: {
          th: 'ธาตุพนม',
          en: 'That Phanom',
        },
        districtId: 553,
      },
      {
        id: '480502',
        zipcode: 48110,
        text: 'ฝั่งแดง',
        value: 'ฝั่งแดง',
        name: {
          th: 'ฝั่งแดง',
          en: 'Fang Daeng',
        },
        districtId: 553,
      },
      {
        id: '480503',
        zipcode: 48110,
        text: 'โพนแพง',
        value: 'โพนแพง',
        name: {
          th: 'โพนแพง',
          en: 'Phon Phaeng',
        },
        districtId: 553,
      },
      {
        id: '480504',
        zipcode: 48110,
        text: 'พระกลางทุ่ง',
        value: 'พระกลางทุ่ง',
        name: {
          th: 'พระกลางทุ่ง',
          en: 'Phra Klang Thung',
        },
        districtId: 553,
      },
      {
        id: '480505',
        zipcode: 48110,
        text: 'นาถ่อน',
        value: 'นาถ่อน',
        name: {
          th: 'นาถ่อน',
          en: 'Na Thon',
        },
        districtId: 553,
      },
      {
        id: '480506',
        zipcode: 48110,
        text: 'แสนพัน',
        value: 'แสนพัน',
        name: {
          th: 'แสนพัน',
          en: 'Saen Phan',
        },
        districtId: 553,
      },
      {
        id: '480507',
        zipcode: 48110,
        text: 'ดอนนางหงส์',
        value: 'ดอนนางหงส์',
        name: {
          th: 'ดอนนางหงส์',
          en: 'Don Nang Hong',
        },
        districtId: 553,
      },
      {
        id: '480508',
        zipcode: 48110,
        text: 'น้ำก่ำ',
        value: 'น้ำก่ำ',
        name: {
          th: 'น้ำก่ำ',
          en: 'Nam Kam',
        },
        districtId: 553,
      },
      {
        id: '480509',
        zipcode: 48110,
        text: 'อุ่มเหม้า',
        value: 'อุ่มเหม้า',
        name: {
          th: 'อุ่มเหม้า',
          en: 'Um Mao',
        },
        districtId: 553,
      },
      {
        id: '480510',
        zipcode: 48110,
        text: 'นาหนาด',
        value: 'นาหนาด',
        name: {
          th: 'นาหนาด',
          en: 'Na Nat',
        },
        districtId: 553,
      },
      {
        id: '480511',
        zipcode: 48110,
        text: 'กุดฉิม',
        value: 'กุดฉิม',
        name: {
          th: 'กุดฉิม',
          en: 'Kut Chim',
        },
        districtId: 553,
      },
      {
        id: '480512',
        zipcode: 48110,
        text: 'ธาตุพนมเหนือ',
        value: 'ธาตุพนมเหนือ',
        name: {
          th: 'ธาตุพนมเหนือ',
          en: 'That Phanom Nuea',
        },
        districtId: 553,
      },
      {
        id: '480601',
        zipcode: 48170,
        text: 'เรณู',
        value: 'เรณู',
        name: {
          th: 'เรณู',
          en: 'Renu',
        },
        districtId: 554,
      },
      {
        id: '480602',
        zipcode: 48170,
        text: 'โพนทอง',
        value: 'โพนทอง',
        name: {
          th: 'โพนทอง',
          en: 'Phon Thong',
        },
        districtId: 554,
      },
      {
        id: '480603',
        zipcode: 48170,
        text: 'ท่าลาด',
        value: 'ท่าลาด',
        name: {
          th: 'ท่าลาด',
          en: 'Tha Lat',
        },
        districtId: 554,
      },
      {
        id: '480604',
        zipcode: 48170,
        text: 'นางาม',
        value: 'นางาม',
        name: {
          th: 'นางาม',
          en: 'Na Ngam',
        },
        districtId: 554,
      },
      {
        id: '480605',
        zipcode: 48170,
        text: 'โคกหินแฮ่',
        value: 'โคกหินแฮ่',
        name: {
          th: 'โคกหินแฮ่',
          en: 'Khok Hin Hae',
        },
        districtId: 554,
      },
      {
        id: '480607',
        zipcode: 48170,
        text: 'หนองย่างชิ้น',
        value: 'หนองย่างชิ้น',
        name: {
          th: 'หนองย่างชิ้น',
          en: 'Nong Yang Chin',
        },
        districtId: 554,
      },
      {
        id: '480608',
        zipcode: 48170,
        text: 'เรณูใต้',
        value: 'เรณูใต้',
        name: {
          th: 'เรณูใต้',
          en: 'Renu Tai',
        },
        districtId: 554,
      },
      {
        id: '480609',
        zipcode: 48170,
        text: 'นาขาม',
        value: 'นาขาม',
        name: {
          th: 'นาขาม',
          en: 'Na Kham',
        },
        districtId: 554,
      },
      {
        id: '480701',
        zipcode: 48130,
        text: 'นาแก',
        value: 'นาแก',
        name: {
          th: 'นาแก',
          en: 'Na Kae',
        },
        districtId: 555,
      },
      {
        id: '480702',
        zipcode: 48130,
        text: 'พระซอง',
        value: 'พระซอง',
        name: {
          th: 'พระซอง',
          en: 'Phra Song',
        },
        districtId: 555,
      },
      {
        id: '480703',
        zipcode: 48130,
        text: 'หนองสังข์',
        value: 'หนองสังข์',
        name: {
          th: 'หนองสังข์',
          en: 'Nong Sang',
        },
        districtId: 555,
      },
      {
        id: '480704',
        zipcode: 48130,
        text: 'นาคู่',
        value: 'นาคู่',
        name: {
          th: 'นาคู่',
          en: 'Na Khu',
        },
        districtId: 555,
      },
      {
        id: '480705',
        zipcode: 48130,
        text: 'พิมาน',
        value: 'พิมาน',
        name: {
          th: 'พิมาน',
          en: 'Phiman',
        },
        districtId: 555,
      },
      {
        id: '480706',
        zipcode: 48130,
        text: 'พุ่มแก',
        value: 'พุ่มแก',
        name: {
          th: 'พุ่มแก',
          en: 'Phum Kae',
        },
        districtId: 555,
      },
      {
        id: '480707',
        zipcode: 48130,
        text: 'ก้านเหลือง',
        value: 'ก้านเหลือง',
        name: {
          th: 'ก้านเหลือง',
          en: 'Kan Lueang',
        },
        districtId: 555,
      },
      {
        id: '480708',
        zipcode: 48130,
        text: 'หนองบ่อ',
        value: 'หนองบ่อ',
        name: {
          th: 'หนองบ่อ',
          en: 'Nong Bo',
        },
        districtId: 555,
      },
      {
        id: '480709',
        zipcode: 48130,
        text: 'นาเลียง',
        value: 'นาเลียง',
        name: {
          th: 'นาเลียง',
          en: 'Na Liang',
        },
        districtId: 555,
      },
      {
        id: '480712',
        zipcode: 48130,
        text: 'บ้านแก้ง',
        value: 'บ้านแก้ง',
        name: {
          th: 'บ้านแก้ง',
          en: 'Ban Kaeng',
        },
        districtId: 555,
      },
      {
        id: '480713',
        zipcode: 48130,
        text: 'คำพี้',
        value: 'คำพี้',
        name: {
          th: 'คำพี้',
          en: 'Kham Phi',
        },
        districtId: 555,
      },
      {
        id: '480715',
        zipcode: 48130,
        text: 'สีชมพู',
        value: 'สีชมพู',
        name: {
          th: 'สีชมพู',
          en: 'Si Chomphu',
        },
        districtId: 555,
      },
      {
        id: '480801',
        zipcode: 48150,
        text: 'ศรีสงคราม',
        value: 'ศรีสงคราม',
        name: {
          th: 'ศรีสงคราม',
          en: 'Si Songkhram',
        },
        districtId: 556,
      },
      {
        id: '480802',
        zipcode: 48150,
        text: 'นาเดื่อ',
        value: 'นาเดื่อ',
        name: {
          th: 'นาเดื่อ',
          en: 'Na Duea',
        },
        districtId: 556,
      },
      {
        id: '480803',
        zipcode: 48150,
        text: 'บ้านเอื้อง',
        value: 'บ้านเอื้อง',
        name: {
          th: 'บ้านเอื้อง',
          en: 'Ban Ueang',
        },
        districtId: 556,
      },
      {
        id: '480804',
        zipcode: 48150,
        text: 'สามผง',
        value: 'สามผง',
        name: {
          th: 'สามผง',
          en: 'Sam Phong',
        },
        districtId: 556,
      },
      {
        id: '480805',
        zipcode: 48150,
        text: 'ท่าบ่อสงคราม',
        value: 'ท่าบ่อสงคราม',
        name: {
          th: 'ท่าบ่อสงคราม',
          en: 'Tha Bo Songkhram',
        },
        districtId: 556,
      },
      {
        id: '480806',
        zipcode: 48150,
        text: 'บ้านข่า',
        value: 'บ้านข่า',
        name: {
          th: 'บ้านข่า',
          en: 'Ban Kha',
        },
        districtId: 556,
      },
      {
        id: '480807',
        zipcode: 48150,
        text: 'นาคำ',
        value: 'นาคำ',
        name: {
          th: 'นาคำ',
          en: 'Na Kham',
        },
        districtId: 556,
      },
      {
        id: '480808',
        zipcode: 48150,
        text: 'โพนสว่าง',
        value: 'โพนสว่าง',
        name: {
          th: 'โพนสว่าง',
          en: 'Phon Sawang',
        },
        districtId: 556,
      },
      {
        id: '480809',
        zipcode: 48150,
        text: 'หาดแพง',
        value: 'หาดแพง',
        name: {
          th: 'หาดแพง',
          en: 'Hat Phaeng',
        },
        districtId: 556,
      },
      {
        id: '480901',
        zipcode: 48180,
        text: 'นาหว้า',
        value: 'นาหว้า',
        name: {
          th: 'นาหว้า',
          en: 'Na Wa',
        },
        districtId: 557,
      },
      {
        id: '480902',
        zipcode: 48180,
        text: 'นางัว',
        value: 'นางัว',
        name: {
          th: 'นางัว',
          en: 'Na Ngua',
        },
        districtId: 557,
      },
      {
        id: '480903',
        zipcode: 48180,
        text: 'บ้านเสียว',
        value: 'บ้านเสียว',
        name: {
          th: 'บ้านเสียว',
          en: 'Ban Siao',
        },
        districtId: 557,
      },
      {
        id: '480904',
        zipcode: 48180,
        text: 'นาคูณใหญ่',
        value: 'นาคูณใหญ่',
        name: {
          th: 'นาคูณใหญ่',
          en: 'Na Khun Yai',
        },
        districtId: 557,
      },
      {
        id: '480905',
        zipcode: 48180,
        text: 'เหล่าพัฒนา',
        value: 'เหล่าพัฒนา',
        name: {
          th: 'เหล่าพัฒนา',
          en: 'Lao Phatthana',
        },
        districtId: 557,
      },
      {
        id: '480906',
        zipcode: 48180,
        text: 'ท่าเรือ',
        value: 'ท่าเรือ',
        name: {
          th: 'ท่าเรือ',
          en: 'Tha Ruea',
        },
        districtId: 557,
      },
      {
        id: '481001',
        zipcode: 48190,
        text: 'โพนสวรรค์',
        value: 'โพนสวรรค์',
        name: {
          th: 'โพนสวรรค์',
          en: 'Phon Sawan',
        },
        districtId: 558,
      },
      {
        id: '481002',
        zipcode: 48190,
        text: 'นาหัวบ่อ',
        value: 'นาหัวบ่อ',
        name: {
          th: 'นาหัวบ่อ',
          en: 'Na Hua Bo',
        },
        districtId: 558,
      },
      {
        id: '481003',
        zipcode: 48190,
        text: 'นาขมิ้น',
        value: 'นาขมิ้น',
        name: {
          th: 'นาขมิ้น',
          en: 'Na Khamin',
        },
        districtId: 558,
      },
      {
        id: '481004',
        zipcode: 48190,
        text: 'โพนบก',
        value: 'โพนบก',
        name: {
          th: 'โพนบก',
          en: 'Phon Bok',
        },
        districtId: 558,
      },
      {
        id: '481005',
        zipcode: 48190,
        text: 'บ้านค้อ',
        value: 'บ้านค้อ',
        name: {
          th: 'บ้านค้อ',
          en: 'Ban Kho',
        },
        districtId: 558,
      },
      {
        id: '481006',
        zipcode: 48190,
        text: 'โพนจาน',
        value: 'โพนจาน',
        name: {
          th: 'โพนจาน',
          en: 'Phon Chan',
        },
        districtId: 558,
      },
      {
        id: '481007',
        zipcode: 48190,
        text: 'นาใน',
        value: 'นาใน',
        name: {
          th: 'นาใน',
          en: 'Na Nai',
        },
        districtId: 558,
      },
      {
        id: '481101',
        zipcode: 48140,
        text: 'นาทม',
        value: 'นาทม',
        name: {
          th: 'นาทม',
          en: 'Na Thom',
        },
        districtId: 559,
      },
      {
        id: '481102',
        zipcode: 48140,
        text: 'หนองซน',
        value: 'หนองซน',
        name: {
          th: 'หนองซน',
          en: 'Nong Son',
        },
        districtId: 559,
      },
      {
        id: '481103',
        zipcode: 48140,
        text: 'ดอนเตย',
        value: 'ดอนเตย',
        name: {
          th: 'ดอนเตย',
          en: 'Don Toei',
        },
        districtId: 559,
      },
      {
        id: '481201',
        zipcode: 48130,
        text: 'วังยาง',
        value: 'วังยาง',
        name: {
          th: 'วังยาง',
          en: 'Wang Yang',
        },
        districtId: 560,
      },
      {
        id: '481202',
        zipcode: 48130,
        text: 'โคกสี',
        value: 'โคกสี',
        name: {
          th: 'โคกสี',
          en: 'Khok Si',
        },
        districtId: 560,
      },
      {
        id: '481203',
        zipcode: 48130,
        text: 'ยอดชาด',
        value: 'ยอดชาด',
        name: {
          th: 'ยอดชาด',
          en: 'Yot Chat',
        },
        districtId: 560,
      },
      {
        id: '481204',
        zipcode: 48130,
        text: 'หนองโพธิ์',
        value: 'หนองโพธิ์',
        name: {
          th: 'หนองโพธิ์',
          en: 'Nong Pho',
        },
        districtId: 560,
      },
      {
        id: '490101',
        zipcode: 49000,
        text: 'มุกดาหาร',
        value: 'มุกดาหาร',
        name: {
          th: 'มุกดาหาร',
          en: 'Mukdahan',
        },
        districtId: 561,
      },
      {
        id: '490102',
        zipcode: 49000,
        text: 'ศรีบุญเรือง',
        value: 'ศรีบุญเรือง',
        name: {
          th: 'ศรีบุญเรือง',
          en: 'Si Bun Rueang',
        },
        districtId: 561,
      },
      {
        id: '490103',
        zipcode: 49000,
        text: 'บ้านโคก',
        value: 'บ้านโคก',
        name: {
          th: 'บ้านโคก',
          en: 'Ban Khok',
        },
        districtId: 561,
      },
      {
        id: '490104',
        zipcode: 49000,
        text: 'บางทรายใหญ่',
        value: 'บางทรายใหญ่',
        name: {
          th: 'บางทรายใหญ่',
          en: 'Bang Sai Yai',
        },
        districtId: 561,
      },
      {
        id: '490105',
        zipcode: 49000,
        text: 'โพนทราย',
        value: 'โพนทราย',
        name: {
          th: 'โพนทราย',
          en: 'Phon Sai',
        },
        districtId: 561,
      },
      {
        id: '490106',
        zipcode: 49000,
        text: 'ผึ่งแดด',
        value: 'ผึ่งแดด',
        name: {
          th: 'ผึ่งแดด',
          en: 'Phueng Daet',
        },
        districtId: 561,
      },
      {
        id: '490107',
        zipcode: 49000,
        text: 'นาโสก',
        value: 'นาโสก',
        name: {
          th: 'นาโสก',
          en: 'Na Sok',
        },
        districtId: 561,
      },
      {
        id: '490108',
        zipcode: 49000,
        text: 'นาสีนวน',
        value: 'นาสีนวน',
        name: {
          th: 'นาสีนวน',
          en: 'Na Si Nuan',
        },
        districtId: 561,
      },
      {
        id: '490109',
        zipcode: 49000,
        text: 'คำป่าหลาย',
        value: 'คำป่าหลาย',
        name: {
          th: 'คำป่าหลาย',
          en: 'Kham Pa Lai',
        },
        districtId: 561,
      },
      {
        id: '490110',
        zipcode: 49000,
        text: 'คำอาฮวน',
        value: 'คำอาฮวน',
        name: {
          th: 'คำอาฮวน',
          en: 'Kham Ahuan',
        },
        districtId: 561,
      },
      {
        id: '490111',
        zipcode: 49000,
        text: 'ดงเย็น',
        value: 'ดงเย็น',
        name: {
          th: 'ดงเย็น',
          en: 'Dong Yen',
        },
        districtId: 561,
      },
      {
        id: '490112',
        zipcode: 49000,
        text: 'ดงมอน',
        value: 'ดงมอน',
        name: {
          th: 'ดงมอน',
          en: 'Dong Mon',
        },
        districtId: 561,
      },
      {
        id: '490113',
        zipcode: 49000,
        text: 'กุดแข้',
        value: 'กุดแข้',
        name: {
          th: 'กุดแข้',
          en: 'Kut Khae',
        },
        districtId: 561,
      },
      {
        id: '490201',
        zipcode: 49130,
        text: 'นิคมคำสร้อย',
        value: 'นิคมคำสร้อย',
        name: {
          th: 'นิคมคำสร้อย',
          en: 'Nikhom Kham Soi',
        },
        districtId: 562,
      },
      {
        id: '490202',
        zipcode: 49130,
        text: 'นากอก',
        value: 'นากอก',
        name: {
          th: 'นากอก',
          en: 'Na Kok',
        },
        districtId: 562,
      },
      {
        id: '490203',
        zipcode: 49130,
        text: 'หนองแวง',
        value: 'หนองแวง',
        name: {
          th: 'หนองแวง',
          en: 'Nong Waeng',
        },
        districtId: 562,
      },
      {
        id: '490204',
        zipcode: 49130,
        text: 'กกแดง',
        value: 'กกแดง',
        name: {
          th: 'กกแดง',
          en: 'Kok Daeng',
        },
        districtId: 562,
      },
      {
        id: '490205',
        zipcode: 49130,
        text: 'นาอุดม',
        value: 'นาอุดม',
        name: {
          th: 'นาอุดม',
          en: 'Na Udom',
        },
        districtId: 562,
      },
      {
        id: '490206',
        zipcode: 49130,
        text: 'โชคชัย',
        value: 'โชคชัย',
        name: {
          th: 'โชคชัย',
          en: 'Chok Chai',
        },
        districtId: 562,
      },
      {
        id: '490207',
        zipcode: 49130,
        text: 'ร่มเกล้า',
        value: 'ร่มเกล้า',
        name: {
          th: 'ร่มเกล้า',
          en: 'Rom Klao',
        },
        districtId: 562,
      },
      {
        id: '490301',
        zipcode: 49120,
        text: 'ดอนตาล',
        value: 'ดอนตาล',
        name: {
          th: 'ดอนตาล',
          en: 'Don Tan',
        },
        districtId: 563,
      },
      {
        id: '490302',
        zipcode: 49120,
        text: 'โพธิ์ไทร',
        value: 'โพธิ์ไทร',
        name: {
          th: 'โพธิ์ไทร',
          en: 'Pho Sai',
        },
        districtId: 563,
      },
      {
        id: '490303',
        zipcode: 49120,
        text: 'ป่าไร่',
        value: 'ป่าไร่',
        name: {
          th: 'ป่าไร่',
          en: 'Pa Rai',
        },
        districtId: 563,
      },
      {
        id: '490304',
        zipcode: 49120,
        text: 'เหล่าหมี',
        value: 'เหล่าหมี',
        name: {
          th: 'เหล่าหมี',
          en: 'Lao Mi',
        },
        districtId: 563,
      },
      {
        id: '490305',
        zipcode: 49120,
        text: 'บ้านบาก',
        value: 'บ้านบาก',
        name: {
          th: 'บ้านบาก',
          en: 'Ban Bak',
        },
        districtId: 563,
      },
      {
        id: '490306',
        zipcode: 49120,
        text: 'นาสะเม็ง',
        value: 'นาสะเม็ง',
        name: {
          th: 'นาสะเม็ง',
          en: 'Na Sameng',
        },
        districtId: 563,
      },
      {
        id: '490307',
        zipcode: 49120,
        text: 'บ้านแก้ง',
        value: 'บ้านแก้ง',
        name: {
          th: 'บ้านแก้ง',
          en: 'Ban Kaeng',
        },
        districtId: 563,
      },
      {
        id: '490401',
        zipcode: 49140,
        text: 'ดงหลวง',
        value: 'ดงหลวง',
        name: {
          th: 'ดงหลวง',
          en: 'Dong Luang',
        },
        districtId: 564,
      },
      {
        id: '490402',
        zipcode: 49140,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 564,
      },
      {
        id: '490403',
        zipcode: 49140,
        text: 'กกตูม',
        value: 'กกตูม',
        name: {
          th: 'กกตูม',
          en: 'Kok Tum',
        },
        districtId: 564,
      },
      {
        id: '490404',
        zipcode: 49140,
        text: 'หนองแคน',
        value: 'หนองแคน',
        name: {
          th: 'หนองแคน',
          en: 'Nong Khaen',
        },
        districtId: 564,
      },
      {
        id: '490405',
        zipcode: 49140,
        text: 'ชะโนดน้อย',
        value: 'ชะโนดน้อย',
        name: {
          th: 'ชะโนดน้อย',
          en: 'Chanot Noi',
        },
        districtId: 564,
      },
      {
        id: '490406',
        zipcode: 49140,
        text: 'พังแดง',
        value: 'พังแดง',
        name: {
          th: 'พังแดง',
          en: 'Phang Daeng',
        },
        districtId: 564,
      },
      {
        id: '490503',
        zipcode: 49110,
        text: 'บ้านซ่ง',
        value: 'บ้านซ่ง',
        name: {
          th: 'บ้านซ่ง',
          en: 'Ban Song',
        },
        districtId: 565,
      },
      {
        id: '490504',
        zipcode: 49110,
        text: 'คำชะอี',
        value: 'คำชะอี',
        name: {
          th: 'คำชะอี',
          en: 'Khamcha-i',
        },
        districtId: 565,
      },
      {
        id: '490505',
        zipcode: 49110,
        text: 'หนองเอี่ยน',
        value: 'หนองเอี่ยน',
        name: {
          th: 'หนองเอี่ยน',
          en: 'Nong Ian',
        },
        districtId: 565,
      },
      {
        id: '490506',
        zipcode: 49110,
        text: 'บ้านค้อ',
        value: 'บ้านค้อ',
        name: {
          th: 'บ้านค้อ',
          en: 'Ban Kho',
        },
        districtId: 565,
      },
      {
        id: '490507',
        zipcode: 49110,
        text: 'บ้านเหล่า',
        value: 'บ้านเหล่า',
        name: {
          th: 'บ้านเหล่า',
          en: 'Ban Lao',
        },
        districtId: 565,
      },
      {
        id: '490508',
        zipcode: 49110,
        text: 'โพนงาม',
        value: 'โพนงาม',
        name: {
          th: 'โพนงาม',
          en: 'Phon Ngam',
        },
        districtId: 565,
      },
      {
        id: '490511',
        zipcode: 49110,
        text: 'เหล่าสร้างถ่อ',
        value: 'เหล่าสร้างถ่อ',
        name: {
          th: 'เหล่าสร้างถ่อ',
          en: 'Lao Sang Tho',
        },
        districtId: 565,
      },
      {
        id: '490512',
        zipcode: 49110,
        text: 'คำบก',
        value: 'คำบก',
        name: {
          th: 'คำบก',
          en: 'Kham Bok',
        },
        districtId: 565,
      },
      {
        id: '490514',
        zipcode: 49110,
        text: 'น้ำเที่ยง',
        value: 'น้ำเที่ยง',
        name: {
          th: 'น้ำเที่ยง',
          en: 'Nam Thiang',
        },
        districtId: 565,
      },
      {
        id: '490601',
        zipcode: 49150,
        text: 'หว้านใหญ่',
        value: 'หว้านใหญ่',
        name: {
          th: 'หว้านใหญ่',
          en: 'Wan Yai',
        },
        districtId: 566,
      },
      {
        id: '490602',
        zipcode: 49150,
        text: 'ป่งขาม',
        value: 'ป่งขาม',
        name: {
          th: 'ป่งขาม',
          en: 'Pong Kham',
        },
        districtId: 566,
      },
      {
        id: '490603',
        zipcode: 49150,
        text: 'บางทรายน้อย',
        value: 'บางทรายน้อย',
        name: {
          th: 'บางทรายน้อย',
          en: 'Bang Sai Noi',
        },
        districtId: 566,
      },
      {
        id: '490604',
        zipcode: 49150,
        text: 'ชะโนด',
        value: 'ชะโนด',
        name: {
          th: 'ชะโนด',
          en: 'Chanot',
        },
        districtId: 566,
      },
      {
        id: '490605',
        zipcode: 49150,
        text: 'ดงหมู',
        value: 'ดงหมู',
        name: {
          th: 'ดงหมู',
          en: 'Dong Mu',
        },
        districtId: 566,
      },
      {
        id: '490701',
        zipcode: 49160,
        text: 'หนองสูง',
        value: 'หนองสูง',
        name: {
          th: 'หนองสูง',
          en: 'Nong Sung',
        },
        districtId: 567,
      },
      {
        id: '490702',
        zipcode: 49160,
        text: 'โนนยาง',
        value: 'โนนยาง',
        name: {
          th: 'โนนยาง',
          en: 'Non Yang',
        },
        districtId: 567,
      },
      {
        id: '490703',
        zipcode: 49160,
        text: 'ภูวง',
        value: 'ภูวง',
        name: {
          th: 'ภูวง',
          en: 'Phu Wong',
        },
        districtId: 567,
      },
      {
        id: '490704',
        zipcode: 49160,
        text: 'บ้านเป้า',
        value: 'บ้านเป้า',
        name: {
          th: 'บ้านเป้า',
          en: 'Ban Pao',
        },
        districtId: 567,
      },
      {
        id: '490705',
        zipcode: 49160,
        text: 'หนองสูงใต้',
        value: 'หนองสูงใต้',
        name: {
          th: 'หนองสูงใต้',
          en: 'Nong Sung Tai',
        },
        districtId: 567,
      },
      {
        id: '490706',
        zipcode: 49160,
        text: 'หนองสูงเหนือ',
        value: 'หนองสูงเหนือ',
        name: {
          th: 'หนองสูงเหนือ',
          en: 'Nong Sung Nuea',
        },
        districtId: 567,
      },
      {
        id: '500101',
        zipcode: 50200,
        text: 'ศรีภูมิ',
        value: 'ศรีภูมิ',
        name: {
          th: 'ศรีภูมิ',
          en: 'Si Phum',
        },
        districtId: 568,
      },
      {
        id: '500102',
        zipcode: 50200,
        text: 'พระสิงห์',
        value: 'พระสิงห์',
        name: {
          th: 'พระสิงห์',
          en: 'Phra Sing',
        },
        districtId: 568,
      },
      {
        id: '500103',
        zipcode: 50100,
        text: 'หายยา',
        value: 'หายยา',
        name: {
          th: 'หายยา',
          en: 'Haiya',
        },
        districtId: 568,
      },
      {
        id: '500104',
        zipcode: 50300,
        text: 'ช้างม่อย',
        value: 'ช้างม่อย',
        name: {
          th: 'ช้างม่อย',
          en: 'Chang Moi',
        },
        districtId: 568,
      },
      {
        id: '500105',
        zipcode: 50100,
        text: 'ช้างคลาน',
        value: 'ช้างคลาน',
        name: {
          th: 'ช้างคลาน',
          en: 'Chang Khlan',
        },
        districtId: 568,
      },
      {
        id: '500106',
        zipcode: 50000,
        text: 'วัดเกต',
        value: 'วัดเกต',
        name: {
          th: 'วัดเกต',
          en: 'Wat Ket',
        },
        districtId: 568,
      },
      {
        id: '500107',
        zipcode: 50300,
        text: 'ช้างเผือก',
        value: 'ช้างเผือก',
        name: {
          th: 'ช้างเผือก',
          en: 'Chang Phueak',
        },
        districtId: 568,
      },
      {
        id: '500108',
        zipcode: 50200,
        text: 'สุเทพ',
        value: 'สุเทพ',
        name: {
          th: 'สุเทพ',
          en: 'Suthep',
        },
        districtId: 568,
      },
      {
        id: '500109',
        zipcode: 50100,
        text: 'แม่เหียะ',
        value: 'แม่เหียะ',
        name: {
          th: 'แม่เหียะ',
          en: 'Mae Hia',
        },
        districtId: 568,
      },
      {
        id: '500110',
        zipcode: 50100,
        text: 'ป่าแดด',
        value: 'ป่าแดด',
        name: {
          th: 'ป่าแดด',
          en: 'Pa Daet',
        },
        districtId: 568,
      },
      {
        id: '500111',
        zipcode: 50000,
        text: 'หนองหอย',
        value: 'หนองหอย',
        name: {
          th: 'หนองหอย',
          en: 'Nong Hoi',
        },
        districtId: 568,
      },
      {
        id: '500112',
        zipcode: 50000,
        text: 'ท่าศาลา',
        value: 'ท่าศาลา',
        name: {
          th: 'ท่าศาลา',
          en: 'Tha Sala',
        },
        districtId: 568,
      },
      {
        id: '500113',
        zipcode: 50000,
        text: 'หนองป่าครั่ง',
        value: 'หนองป่าครั่ง',
        name: {
          th: 'หนองป่าครั่ง',
          en: 'Nong Pa Khrang	',
        },
        districtId: 568,
      },
      {
        id: '500114',
        zipcode: 50000,
        text: 'ฟ้าฮ่าม',
        value: 'ฟ้าฮ่าม',
        name: {
          th: 'ฟ้าฮ่าม',
          en: 'Fa Ham',
        },
        districtId: 568,
      },
      {
        id: '500115',
        zipcode: 50300,
        text: 'ป่าตัน',
        value: 'ป่าตัน',
        name: {
          th: 'ป่าตัน',
          en: 'Pa Tan',
        },
        districtId: 568,
      },
      {
        id: '500116',
        zipcode: 50300,
        text: 'สันผีเสื้อ',
        value: 'สันผีเสื้อ',
        name: {
          th: 'สันผีเสื้อ',
          en: 'San Phi Suea',
        },
        districtId: 568,
      },
      {
        id: '500203',
        zipcode: 50160,
        text: 'บ้านหลวง',
        value: 'บ้านหลวง',
        name: {
          th: 'บ้านหลวง',
          en: 'Ban Luang',
        },
        districtId: 569,
      },
      {
        id: '500204',
        zipcode: 50160,
        text: 'ข่วงเปา',
        value: 'ข่วงเปา',
        name: {
          th: 'ข่วงเปา',
          en: 'Khuang Pao',
        },
        districtId: 569,
      },
      {
        id: '500205',
        zipcode: 50160,
        text: 'สบเตี๊ยะ',
        value: 'สบเตี๊ยะ',
        name: {
          th: 'สบเตี๊ยะ',
          en: 'Sop Tia',
        },
        districtId: 569,
      },
      {
        id: '500206',
        zipcode: 50240,
        text: 'บ้านแปะ',
        value: 'บ้านแปะ',
        name: {
          th: 'บ้านแปะ',
          en: 'Ban Pae',
        },
        districtId: 569,
      },
      {
        id: '500207',
        zipcode: 50160,
        text: 'ดอยแก้ว',
        value: 'ดอยแก้ว',
        name: {
          th: 'ดอยแก้ว',
          en: 'Doi Kaeo',
        },
        districtId: 569,
      },
      {
        id: '500209',
        zipcode: 50240,
        text: 'แม่สอย',
        value: 'แม่สอย',
        name: {
          th: 'แม่สอย',
          en: 'Mae Soi',
        },
        districtId: 569,
      },
      {
        id: '500301',
        zipcode: 50270,
        text: 'ช่างเคิ่ง',
        value: 'ช่างเคิ่ง',
        name: {
          th: 'ช่างเคิ่ง',
          en: 'Chang Khoeng',
        },
        districtId: 570,
      },
      {
        id: '500302',
        zipcode: 50270,
        text: 'ท่าผา',
        value: 'ท่าผา',
        name: {
          th: 'ท่าผา',
          en: 'Tha Pha',
        },
        districtId: 570,
      },
      {
        id: '500303',
        zipcode: 50270,
        text: 'บ้านทับ',
        value: 'บ้านทับ',
        name: {
          th: 'บ้านทับ',
          en: 'Ban Thap',
        },
        districtId: 570,
      },
      {
        id: '500304',
        zipcode: 50270,
        text: 'แม่ศึก',
        value: 'แม่ศึก',
        name: {
          th: 'แม่ศึก',
          en: 'Mae Suek',
        },
        districtId: 570,
      },
      {
        id: '500305',
        zipcode: 50270,
        text: 'แม่นาจร',
        value: 'แม่นาจร',
        name: {
          th: 'แม่นาจร',
          en: 'Mae Na Chon',
        },
        districtId: 570,
      },
      {
        id: '500306',
        zipcode: 58130,
        text: 'บ้านจันทร์',
        value: 'บ้านจันทร์',
        name: {
          th: 'บ้านจันทร์',
          en: 'Ban Chan',
        },
        districtId: 570,
      },
      {
        id: '500307',
        zipcode: 50270,
        text: 'ปางหินฝน',
        value: 'ปางหินฝน',
        name: {
          th: 'ปางหินฝน',
          en: 'Pang Hin Fon',
        },
        districtId: 570,
      },
      {
        id: '500308',
        zipcode: 50270,
        text: 'กองแขก',
        value: 'กองแขก',
        name: {
          th: 'กองแขก',
          en: 'Kong Khaek',
        },
        districtId: 570,
      },
      {
        id: '500309',
        zipcode: 58130,
        text: 'แม่แดด',
        value: 'แม่แดด',
        name: {
          th: 'แม่แดด',
          en: 'Mae Dad',
        },
        districtId: 570,
      },
      {
        id: '500310',
        zipcode: 58130,
        text: 'แจ่มหลวง',
        value: 'แจ่มหลวง',
        name: {
          th: 'แจ่มหลวง',
          en: 'Chaem Luang',
        },
        districtId: 570,
      },
      {
        id: '500401',
        zipcode: 50170,
        text: 'เชียงดาว',
        value: 'เชียงดาว',
        name: {
          th: 'เชียงดาว',
          en: 'Chiang Dao',
        },
        districtId: 571,
      },
      {
        id: '500402',
        zipcode: 50170,
        text: 'เมืองนะ',
        value: 'เมืองนะ',
        name: {
          th: 'เมืองนะ',
          en: 'Mueang Na',
        },
        districtId: 571,
      },
      {
        id: '500403',
        zipcode: 50170,
        text: 'เมืองงาย',
        value: 'เมืองงาย',
        name: {
          th: 'เมืองงาย',
          en: 'Mueang Ngai',
        },
        districtId: 571,
      },
      {
        id: '500404',
        zipcode: 50170,
        text: 'แม่นะ',
        value: 'แม่นะ',
        name: {
          th: 'แม่นะ',
          en: 'Mae Na',
        },
        districtId: 571,
      },
      {
        id: '500405',
        zipcode: 50170,
        text: 'เมืองคอง',
        value: 'เมืองคอง',
        name: {
          th: 'เมืองคอง',
          en: 'Mueang Khong',
        },
        districtId: 571,
      },
      {
        id: '500406',
        zipcode: 50170,
        text: 'ปิงโค้ง',
        value: 'ปิงโค้ง',
        name: {
          th: 'ปิงโค้ง',
          en: 'Ping Khong',
        },
        districtId: 571,
      },
      {
        id: '500407',
        zipcode: 50170,
        text: 'ทุ่งข้าวพวง',
        value: 'ทุ่งข้าวพวง',
        name: {
          th: 'ทุ่งข้าวพวง',
          en: 'Thung Khao Phuang',
        },
        districtId: 571,
      },
      {
        id: '500501',
        zipcode: 50220,
        text: 'เชิงดอย',
        value: 'เชิงดอย',
        name: {
          th: 'เชิงดอย',
          en: 'Choeng Doi',
        },
        districtId: 572,
      },
      {
        id: '500502',
        zipcode: 50220,
        text: 'สันปูเลย',
        value: 'สันปูเลย',
        name: {
          th: 'สันปูเลย',
          en: 'San Pu Loei',
        },
        districtId: 572,
      },
      {
        id: '500503',
        zipcode: 50220,
        text: 'ลวงเหนือ',
        value: 'ลวงเหนือ',
        name: {
          th: 'ลวงเหนือ',
          en: 'Luang Nuea',
        },
        districtId: 572,
      },
      {
        id: '500504',
        zipcode: 50220,
        text: 'ป่าป้อง',
        value: 'ป่าป้อง',
        name: {
          th: 'ป่าป้อง',
          en: 'Pa Pong',
        },
        districtId: 572,
      },
      {
        id: '500505',
        zipcode: 50220,
        text: 'สง่าบ้าน',
        value: 'สง่าบ้าน',
        name: {
          th: 'สง่าบ้าน',
          en: 'Sa-nga Ban',
        },
        districtId: 572,
      },
      {
        id: '500506',
        zipcode: 50220,
        text: 'ป่าลาน',
        value: 'ป่าลาน',
        name: {
          th: 'ป่าลาน',
          en: 'Pa Lan',
        },
        districtId: 572,
      },
      {
        id: '500507',
        zipcode: 50220,
        text: 'ตลาดขวัญ',
        value: 'ตลาดขวัญ',
        name: {
          th: 'ตลาดขวัญ',
          en: 'Talat Khwan',
        },
        districtId: 572,
      },
      {
        id: '500508',
        zipcode: 50220,
        text: 'สำราญราษฎร์',
        value: 'สำราญราษฎร์',
        name: {
          th: 'สำราญราษฎร์',
          en: 'Samran Rat',
        },
        districtId: 572,
      },
      {
        id: '500509',
        zipcode: 50220,
        text: 'แม่คือ',
        value: 'แม่คือ',
        name: {
          th: 'แม่คือ',
          en: 'Mae Khue',
        },
        districtId: 572,
      },
      {
        id: '500510',
        zipcode: 50220,
        text: 'ตลาดใหญ่',
        value: 'ตลาดใหญ่',
        name: {
          th: 'ตลาดใหญ่',
          en: 'Talat Yai',
        },
        districtId: 572,
      },
      {
        id: '500511',
        zipcode: 50220,
        text: 'แม่ฮ้อยเงิน',
        value: 'แม่ฮ้อยเงิน',
        name: {
          th: 'แม่ฮ้อยเงิน',
          en: 'Mae Hoi Ngoen	',
        },
        districtId: 572,
      },
      {
        id: '500512',
        zipcode: 50220,
        text: 'แม่โป่ง',
        value: 'แม่โป่ง',
        name: {
          th: 'แม่โป่ง',
          en: 'Mae Pong',
        },
        districtId: 572,
      },
      {
        id: '500513',
        zipcode: 50220,
        text: 'ป่าเมี่ยง',
        value: 'ป่าเมี่ยง',
        name: {
          th: 'ป่าเมี่ยง',
          en: 'Pa Miang',
        },
        districtId: 572,
      },
      {
        id: '500514',
        zipcode: 50220,
        text: 'เทพเสด็จ',
        value: 'เทพเสด็จ',
        name: {
          th: 'เทพเสด็จ',
          en: 'Thep Sadet',
        },
        districtId: 572,
      },
      {
        id: '500601',
        zipcode: 50150,
        text: 'สันมหาพน',
        value: 'สันมหาพน',
        name: {
          th: 'สันมหาพน',
          en: 'San Maha Phon',
        },
        districtId: 573,
      },
      {
        id: '500602',
        zipcode: 50150,
        text: 'แม่แตง',
        value: 'แม่แตง',
        name: {
          th: 'แม่แตง',
          en: 'Mae Taeng',
        },
        districtId: 573,
      },
      {
        id: '500603',
        zipcode: 50150,
        text: 'ขี้เหล็ก',
        value: 'ขี้เหล็ก',
        name: {
          th: 'ขี้เหล็ก',
          en: 'Khilek',
        },
        districtId: 573,
      },
      {
        id: '500604',
        zipcode: 50150,
        text: 'ช่อแล',
        value: 'ช่อแล',
        name: {
          th: 'ช่อแล',
          en: 'Cho Lae',
        },
        districtId: 573,
      },
      {
        id: '500605',
        zipcode: 50150,
        text: 'แม่หอพระ',
        value: 'แม่หอพระ',
        name: {
          th: 'แม่หอพระ',
          en: 'Mae Ho Phra',
        },
        districtId: 573,
      },
      {
        id: '500606',
        zipcode: 50150,
        text: 'สบเปิง',
        value: 'สบเปิง',
        name: {
          th: 'สบเปิง',
          en: 'Sop Poeng',
        },
        districtId: 573,
      },
      {
        id: '500607',
        zipcode: 50150,
        text: 'บ้านเป้า',
        value: 'บ้านเป้า',
        name: {
          th: 'บ้านเป้า',
          en: 'Ban Pao',
        },
        districtId: 573,
      },
      {
        id: '500608',
        zipcode: 50330,
        text: 'สันป่ายาง',
        value: 'สันป่ายาง',
        name: {
          th: 'สันป่ายาง',
          en: 'San Pa Yang',
        },
        districtId: 573,
      },
      {
        id: '500609',
        zipcode: 50150,
        text: 'ป่าแป๋',
        value: 'ป่าแป๋',
        name: {
          th: 'ป่าแป๋',
          en: 'Pa Pae',
        },
        districtId: 573,
      },
      {
        id: '500610',
        zipcode: 50150,
        text: 'เมืองก๋าย',
        value: 'เมืองก๋าย',
        name: {
          th: 'เมืองก๋าย',
          en: 'Mueang Kai',
        },
        districtId: 573,
      },
      {
        id: '500611',
        zipcode: 50150,
        text: 'บ้านช้าง',
        value: 'บ้านช้าง',
        name: {
          th: 'บ้านช้าง',
          en: 'Ban Chang',
        },
        districtId: 573,
      },
      {
        id: '500612',
        zipcode: 50150,
        text: 'กื้ดช้าง',
        value: 'กื้ดช้าง',
        name: {
          th: 'กื้ดช้าง',
          en: 'Kuet Chang',
        },
        districtId: 573,
      },
      {
        id: '500613',
        zipcode: 50150,
        text: 'อินทขิล',
        value: 'อินทขิล',
        name: {
          th: 'อินทขิล',
          en: 'Inthakhin',
        },
        districtId: 573,
      },
      {
        id: '500614',
        zipcode: 50150,
        text: 'สมก๋าย',
        value: 'สมก๋าย',
        name: {
          th: 'สมก๋าย',
          en: 'Som Kai',
        },
        districtId: 573,
      },
      {
        id: '500701',
        zipcode: 50180,
        text: 'ริมใต้',
        value: 'ริมใต้',
        name: {
          th: 'ริมใต้',
          en: 'Rim Tai',
        },
        districtId: 574,
      },
      {
        id: '500702',
        zipcode: 50180,
        text: 'ริมเหนือ',
        value: 'ริมเหนือ',
        name: {
          th: 'ริมเหนือ',
          en: 'Rim Nuea',
        },
        districtId: 574,
      },
      {
        id: '500703',
        zipcode: 50180,
        text: 'สันโป่ง',
        value: 'สันโป่ง',
        name: {
          th: 'สันโป่ง',
          en: 'San Pong',
        },
        districtId: 574,
      },
      {
        id: '500704',
        zipcode: 50180,
        text: 'ขี้เหล็ก',
        value: 'ขี้เหล็ก',
        name: {
          th: 'ขี้เหล็ก',
          en: 'Khilek',
        },
        districtId: 574,
      },
      {
        id: '500705',
        zipcode: 50330,
        text: 'สะลวง',
        value: 'สะลวง',
        name: {
          th: 'สะลวง',
          en: 'Saluang',
        },
        districtId: 574,
      },
      {
        id: '500706',
        zipcode: 50180,
        text: 'ห้วยทราย',
        value: 'ห้วยทราย',
        name: {
          th: 'ห้วยทราย',
          en: 'Huai Sai',
        },
        districtId: 574,
      },
      {
        id: '500707',
        zipcode: 50180,
        text: 'แม่แรม',
        value: 'แม่แรม',
        name: {
          th: 'แม่แรม',
          en: 'Mae Raem',
        },
        districtId: 574,
      },
      {
        id: '500708',
        zipcode: 50180,
        text: 'โป่งแยง',
        value: 'โป่งแยง',
        name: {
          th: 'โป่งแยง',
          en: 'Pong Yaeng',
        },
        districtId: 574,
      },
      {
        id: '500709',
        zipcode: 50180,
        text: 'แม่สา',
        value: 'แม่สา',
        name: {
          th: 'แม่สา',
          en: 'Mae Sa',
        },
        districtId: 574,
      },
      {
        id: '500710',
        zipcode: 50180,
        text: 'ดอนแก้ว',
        value: 'ดอนแก้ว',
        name: {
          th: 'ดอนแก้ว',
          en: 'Don Kaeo',
        },
        districtId: 574,
      },
      {
        id: '500711',
        zipcode: 50180,
        text: 'เหมืองแก้ว',
        value: 'เหมืองแก้ว',
        name: {
          th: 'เหมืองแก้ว',
          en: 'Mueang Kaeo',
        },
        districtId: 574,
      },
      {
        id: '500801',
        zipcode: 50250,
        text: 'สะเมิงใต้',
        value: 'สะเมิงใต้',
        name: {
          th: 'สะเมิงใต้',
          en: 'Samoeng Tai',
        },
        districtId: 575,
      },
      {
        id: '500802',
        zipcode: 50250,
        text: 'สะเมิงเหนือ',
        value: 'สะเมิงเหนือ',
        name: {
          th: 'สะเมิงเหนือ',
          en: 'Samoeng Nuea',
        },
        districtId: 575,
      },
      {
        id: '500803',
        zipcode: 50250,
        text: 'แม่สาบ',
        value: 'แม่สาบ',
        name: {
          th: 'แม่สาบ',
          en: 'Mae Sap',
        },
        districtId: 575,
      },
      {
        id: '500804',
        zipcode: 50250,
        text: 'บ่อแก้ว',
        value: 'บ่อแก้ว',
        name: {
          th: 'บ่อแก้ว',
          en: 'Bo Kaeo',
        },
        districtId: 575,
      },
      {
        id: '500805',
        zipcode: 50250,
        text: 'ยั้งเมิน',
        value: 'ยั้งเมิน',
        name: {
          th: 'ยั้งเมิน',
          en: 'Yang Moen',
        },
        districtId: 575,
      },
      {
        id: '500901',
        zipcode: 50110,
        text: 'เวียง',
        value: 'เวียง',
        name: {
          th: 'เวียง',
          en: 'Wiang',
        },
        districtId: 576,
      },
      {
        id: '500903',
        zipcode: 50110,
        text: 'ม่อนปิ่น',
        value: 'ม่อนปิ่น',
        name: {
          th: 'ม่อนปิ่น',
          en: 'Mon Pin',
        },
        districtId: 576,
      },
      {
        id: '500904',
        zipcode: 50320,
        text: 'แม่งอน',
        value: 'แม่งอน',
        name: {
          th: 'แม่งอน',
          en: 'Mae Ngon',
        },
        districtId: 576,
      },
      {
        id: '500905',
        zipcode: 50110,
        text: 'แม่สูน',
        value: 'แม่สูน',
        name: {
          th: 'แม่สูน',
          en: 'Mae Sun',
        },
        districtId: 576,
      },
      {
        id: '500906',
        zipcode: 50110,
        text: 'สันทราย',
        value: 'สันทราย',
        name: {
          th: 'สันทราย',
          en: 'San Sai',
        },
        districtId: 576,
      },
      {
        id: '500910',
        zipcode: 50110,
        text: 'แม่คะ',
        value: 'แม่คะ',
        name: {
          th: 'แม่คะ',
          en: 'Mae Kha',
        },
        districtId: 576,
      },
      {
        id: '500911',
        zipcode: 50320,
        text: 'แม่ข่า',
        value: 'แม่ข่า',
        name: {
          th: 'แม่ข่า',
          en: 'Mae Kha',
        },
        districtId: 576,
      },
      {
        id: '500912',
        zipcode: 50110,
        text: 'โป่งน้ำร้อน',
        value: 'โป่งน้ำร้อน',
        name: {
          th: 'โป่งน้ำร้อน',
          en: 'Pong Nam Ron',
        },
        districtId: 576,
      },
      {
        id: '500998',
        zipcode: 0,
        text: '*ศรีดงเย็น ',
        value: '*ศรีดงเย็น ',
        name: {
          th: '*ศรีดงเย็น ',
          en: '*Sri Dong Yen',
        },
        districtId: 576,
      },
      {
        id: '501001',
        zipcode: 50280,
        text: 'แม่อาย',
        value: 'แม่อาย',
        name: {
          th: 'แม่อาย',
          en: 'Mae Ai',
        },
        districtId: 577,
      },
      {
        id: '501002',
        zipcode: 50280,
        text: 'แม่สาว',
        value: 'แม่สาว',
        name: {
          th: 'แม่สาว',
          en: 'Mae Sao',
        },
        districtId: 577,
      },
      {
        id: '501003',
        zipcode: 50280,
        text: 'สันต้นหมื้อ',
        value: 'สันต้นหมื้อ',
        name: {
          th: 'สันต้นหมื้อ',
          en: 'San Ton Mue',
        },
        districtId: 577,
      },
      {
        id: '501004',
        zipcode: 50280,
        text: 'แม่นาวาง',
        value: 'แม่นาวาง',
        name: {
          th: 'แม่นาวาง',
          en: 'Mae Na Wang',
        },
        districtId: 577,
      },
      {
        id: '501005',
        zipcode: 50280,
        text: 'ท่าตอน',
        value: 'ท่าตอน',
        name: {
          th: 'ท่าตอน',
          en: 'Tha Ton',
        },
        districtId: 577,
      },
      {
        id: '501006',
        zipcode: 50280,
        text: 'บ้านหลวง',
        value: 'บ้านหลวง',
        name: {
          th: 'บ้านหลวง',
          en: 'Ban Luang',
        },
        districtId: 577,
      },
      {
        id: '501007',
        zipcode: 50280,
        text: 'มะลิกา',
        value: 'มะลิกา',
        name: {
          th: 'มะลิกา',
          en: 'Malika',
        },
        districtId: 577,
      },
      {
        id: '501101',
        zipcode: 50190,
        text: 'เวียง',
        value: 'เวียง',
        name: {
          th: 'เวียง',
          en: 'Wiang',
        },
        districtId: 578,
      },
      {
        id: '501102',
        zipcode: 50190,
        text: 'ทุ่งหลวง',
        value: 'ทุ่งหลวง',
        name: {
          th: 'ทุ่งหลวง',
          en: 'Thung Luang',
        },
        districtId: 578,
      },
      {
        id: '501103',
        zipcode: 50190,
        text: 'ป่าตุ้ม',
        value: 'ป่าตุ้ม',
        name: {
          th: 'ป่าตุ้ม',
          en: 'Pa Tum',
        },
        districtId: 578,
      },
      {
        id: '501104',
        zipcode: 50190,
        text: 'ป่าไหน่',
        value: 'ป่าไหน่',
        name: {
          th: 'ป่าไหน่',
          en: 'Pa Nai',
        },
        districtId: 578,
      },
      {
        id: '501105',
        zipcode: 50190,
        text: 'สันทราย',
        value: 'สันทราย',
        name: {
          th: 'สันทราย',
          en: 'San Sai',
        },
        districtId: 578,
      },
      {
        id: '501106',
        zipcode: 50190,
        text: 'บ้านโป่ง',
        value: 'บ้านโป่ง',
        name: {
          th: 'บ้านโป่ง',
          en: 'Ban Pong',
        },
        districtId: 578,
      },
      {
        id: '501107',
        zipcode: 50190,
        text: 'น้ำแพร่',
        value: 'น้ำแพร่',
        name: {
          th: 'น้ำแพร่',
          en: 'Nam Phrae',
        },
        districtId: 578,
      },
      {
        id: '501108',
        zipcode: 50190,
        text: 'เขื่อนผาก',
        value: 'เขื่อนผาก',
        name: {
          th: 'เขื่อนผาก',
          en: 'Khuean Phak',
        },
        districtId: 578,
      },
      {
        id: '501109',
        zipcode: 50190,
        text: 'แม่แวน',
        value: 'แม่แวน',
        name: {
          th: 'แม่แวน',
          en: 'Mae Waen',
        },
        districtId: 578,
      },
      {
        id: '501110',
        zipcode: 50190,
        text: 'แม่ปั๋ง',
        value: 'แม่ปั๋ง',
        name: {
          th: 'แม่ปั๋ง',
          en: 'Mae Pang',
        },
        districtId: 578,
      },
      {
        id: '501111',
        zipcode: 50190,
        text: 'โหล่งขอด',
        value: 'โหล่งขอด',
        name: {
          th: 'โหล่งขอด',
          en: 'Long Khot',
        },
        districtId: 578,
      },
      {
        id: '501201',
        zipcode: 50120,
        text: 'ยุหว่า',
        value: 'ยุหว่า',
        name: {
          th: 'ยุหว่า',
          en: 'Yu Wa',
        },
        districtId: 579,
      },
      {
        id: '501202',
        zipcode: 50120,
        text: 'สันกลาง',
        value: 'สันกลาง',
        name: {
          th: 'สันกลาง',
          en: 'San Klang',
        },
        districtId: 579,
      },
      {
        id: '501203',
        zipcode: 50120,
        text: 'ท่าวังพร้าว',
        value: 'ท่าวังพร้าว',
        name: {
          th: 'ท่าวังพร้าว',
          en: 'Tha Wang Phrao',
        },
        districtId: 579,
      },
      {
        id: '501204',
        zipcode: 50120,
        text: 'มะขามหลวง',
        value: 'มะขามหลวง',
        name: {
          th: 'มะขามหลวง',
          en: 'Makham Luang',
        },
        districtId: 579,
      },
      {
        id: '501205',
        zipcode: 50120,
        text: 'แม่ก๊า',
        value: 'แม่ก๊า',
        name: {
          th: 'แม่ก๊า',
          en: 'Mae Ka',
        },
        districtId: 579,
      },
      {
        id: '501206',
        zipcode: 50120,
        text: 'บ้านแม',
        value: 'บ้านแม',
        name: {
          th: 'บ้านแม',
          en: 'Ban Mae',
        },
        districtId: 579,
      },
      {
        id: '501207',
        zipcode: 50120,
        text: 'บ้านกลาง',
        value: 'บ้านกลาง',
        name: {
          th: 'บ้านกลาง',
          en: 'Ban Klang',
        },
        districtId: 579,
      },
      {
        id: '501208',
        zipcode: 50120,
        text: 'ทุ่งสะโตก',
        value: 'ทุ่งสะโตก',
        name: {
          th: 'ทุ่งสะโตก',
          en: 'Thung Satok',
        },
        districtId: 579,
      },
      {
        id: '501210',
        zipcode: 50120,
        text: 'ทุ่งต้อม',
        value: 'ทุ่งต้อม',
        name: {
          th: 'ทุ่งต้อม',
          en: 'Thung Tom',
        },
        districtId: 579,
      },
      {
        id: '501211',
        zipcode: 0,
        text: '*บ้านกาด ',
        value: '*บ้านกาด ',
        name: {
          th: '*บ้านกาด ',
          en: '*Ban Kad',
        },
        districtId: 579,
      },
      {
        id: '501214',
        zipcode: 50120,
        text: 'น้ำบ่อหลวง',
        value: 'น้ำบ่อหลวง',
        name: {
          th: 'น้ำบ่อหลวง',
          en: 'Nam Bo Luang',
        },
        districtId: 579,
      },
      {
        id: '501215',
        zipcode: 50120,
        text: 'มะขุนหวาน',
        value: 'มะขุนหวาน',
        name: {
          th: 'มะขุนหวาน',
          en: 'Makhun Wan',
        },
        districtId: 579,
      },
      {
        id: '501301',
        zipcode: 50130,
        text: 'สันกำแพง',
        value: 'สันกำแพง',
        name: {
          th: 'สันกำแพง',
          en: 'San Kamphaeng',
        },
        districtId: 580,
      },
      {
        id: '501302',
        zipcode: 50130,
        text: 'ทรายมูล',
        value: 'ทรายมูล',
        name: {
          th: 'ทรายมูล',
          en: 'Sai Mun',
        },
        districtId: 580,
      },
      {
        id: '501303',
        zipcode: 50130,
        text: 'ร้องวัวแดง',
        value: 'ร้องวัวแดง',
        name: {
          th: 'ร้องวัวแดง',
          en: 'Rong Wua Daeng',
        },
        districtId: 580,
      },
      {
        id: '501304',
        zipcode: 50130,
        text: 'บวกค้าง',
        value: 'บวกค้าง',
        name: {
          th: 'บวกค้าง',
          en: 'Buak Khang',
        },
        districtId: 580,
      },
      {
        id: '501305',
        zipcode: 50130,
        text: 'แช่ช้าง',
        value: 'แช่ช้าง',
        name: {
          th: 'แช่ช้าง',
          en: 'Chae Chang',
        },
        districtId: 580,
      },
      {
        id: '501306',
        zipcode: 50130,
        text: 'ออนใต้',
        value: 'ออนใต้',
        name: {
          th: 'ออนใต้',
          en: 'On Tai',
        },
        districtId: 580,
      },
      {
        id: '501310',
        zipcode: 50130,
        text: 'แม่ปูคา',
        value: 'แม่ปูคา',
        name: {
          th: 'แม่ปูคา',
          en: 'Mae Pu Kha',
        },
        districtId: 580,
      },
      {
        id: '501311',
        zipcode: 50130,
        text: 'ห้วยทราย',
        value: 'ห้วยทราย',
        name: {
          th: 'ห้วยทราย',
          en: 'Huai Sai',
        },
        districtId: 580,
      },
      {
        id: '501312',
        zipcode: 50130,
        text: 'ต้นเปา',
        value: 'ต้นเปา',
        name: {
          th: 'ต้นเปา',
          en: 'Ton Pao',
        },
        districtId: 580,
      },
      {
        id: '501313',
        zipcode: 50130,
        text: 'สันกลาง',
        value: 'สันกลาง',
        name: {
          th: 'สันกลาง',
          en: 'San Klang',
        },
        districtId: 580,
      },
      {
        id: '501401',
        zipcode: 50210,
        text: 'สันทรายหลวง',
        value: 'สันทรายหลวง',
        name: {
          th: 'สันทรายหลวง',
          en: 'San Sai Luang',
        },
        districtId: 581,
      },
      {
        id: '501402',
        zipcode: 50210,
        text: 'สันทรายน้อย',
        value: 'สันทรายน้อย',
        name: {
          th: 'สันทรายน้อย',
          en: 'San Sai Noi',
        },
        districtId: 581,
      },
      {
        id: '501403',
        zipcode: 50210,
        text: 'สันพระเนตร',
        value: 'สันพระเนตร',
        name: {
          th: 'สันพระเนตร',
          en: 'San Phranet',
        },
        districtId: 581,
      },
      {
        id: '501404',
        zipcode: 50210,
        text: 'สันนาเม็ง',
        value: 'สันนาเม็ง',
        name: {
          th: 'สันนาเม็ง',
          en: 'San Na Meng',
        },
        districtId: 581,
      },
      {
        id: '501405',
        zipcode: 50210,
        text: 'สันป่าเปา',
        value: 'สันป่าเปา',
        name: {
          th: 'สันป่าเปา',
          en: 'San Pa Pao',
        },
        districtId: 581,
      },
      {
        id: '501406',
        zipcode: 50210,
        text: 'หนองแหย่ง',
        value: 'หนองแหย่ง',
        name: {
          th: 'หนองแหย่ง',
          en: 'Nong Yaeng',
        },
        districtId: 581,
      },
      {
        id: '501407',
        zipcode: 50210,
        text: 'หนองจ๊อม',
        value: 'หนองจ๊อม',
        name: {
          th: 'หนองจ๊อม',
          en: 'Nong Chom',
        },
        districtId: 581,
      },
      {
        id: '501408',
        zipcode: 50290,
        text: 'หนองหาร',
        value: 'หนองหาร',
        name: {
          th: 'หนองหาร',
          en: 'Nong Han',
        },
        districtId: 581,
      },
      {
        id: '501409',
        zipcode: 50290,
        text: 'แม่แฝก',
        value: 'แม่แฝก',
        name: {
          th: 'แม่แฝก',
          en: 'Mae Faek',
        },
        districtId: 581,
      },
      {
        id: '501410',
        zipcode: 50290,
        text: 'แม่แฝกใหม่',
        value: 'แม่แฝกใหม่',
        name: {
          th: 'แม่แฝกใหม่',
          en: 'Mae Faek Mai',
        },
        districtId: 581,
      },
      {
        id: '501411',
        zipcode: 50210,
        text: 'เมืองเล็น',
        value: 'เมืองเล็น',
        name: {
          th: 'เมืองเล็น',
          en: 'Mueang Len',
        },
        districtId: 581,
      },
      {
        id: '501412',
        zipcode: 50210,
        text: 'ป่าไผ่',
        value: 'ป่าไผ่',
        name: {
          th: 'ป่าไผ่',
          en: 'Pa Phai',
        },
        districtId: 581,
      },
      {
        id: '501501',
        zipcode: 50230,
        text: 'หางดง',
        value: 'หางดง',
        name: {
          th: 'หางดง',
          en: 'Hang Dong',
        },
        districtId: 582,
      },
      {
        id: '501502',
        zipcode: 50230,
        text: 'หนองแก๋ว',
        value: 'หนองแก๋ว',
        name: {
          th: 'หนองแก๋ว',
          en: 'Nong Kaeo',
        },
        districtId: 582,
      },
      {
        id: '501503',
        zipcode: 50230,
        text: 'หารแก้ว',
        value: 'หารแก้ว',
        name: {
          th: 'หารแก้ว',
          en: 'Han Kaeo',
        },
        districtId: 582,
      },
      {
        id: '501504',
        zipcode: 50340,
        text: 'หนองตอง',
        value: 'หนองตอง',
        name: {
          th: 'หนองตอง',
          en: 'Nong Tong',
        },
        districtId: 582,
      },
      {
        id: '501505',
        zipcode: 50230,
        text: 'ขุนคง',
        value: 'ขุนคง',
        name: {
          th: 'ขุนคง',
          en: 'Khun Khong',
        },
        districtId: 582,
      },
      {
        id: '501506',
        zipcode: 50230,
        text: 'สบแม่ข่า',
        value: 'สบแม่ข่า',
        name: {
          th: 'สบแม่ข่า',
          en: 'Sop Mae Kha',
        },
        districtId: 582,
      },
      {
        id: '501507',
        zipcode: 50230,
        text: 'บ้านแหวน',
        value: 'บ้านแหวน',
        name: {
          th: 'บ้านแหวน',
          en: 'Ban Waen',
        },
        districtId: 582,
      },
      {
        id: '501508',
        zipcode: 50230,
        text: 'สันผักหวาน',
        value: 'สันผักหวาน',
        name: {
          th: 'สันผักหวาน',
          en: 'San Phak Wan',
        },
        districtId: 582,
      },
      {
        id: '501509',
        zipcode: 50230,
        text: 'หนองควาย',
        value: 'หนองควาย',
        name: {
          th: 'หนองควาย',
          en: 'Nong Khwai',
        },
        districtId: 582,
      },
      {
        id: '501510',
        zipcode: 50230,
        text: 'บ้านปง',
        value: 'บ้านปง',
        name: {
          th: 'บ้านปง',
          en: 'Ban Pong',
        },
        districtId: 582,
      },
      {
        id: '501511',
        zipcode: 50230,
        text: 'น้ำแพร่',
        value: 'น้ำแพร่',
        name: {
          th: 'น้ำแพร่',
          en: 'Nam Phrae',
        },
        districtId: 582,
      },
      {
        id: '501601',
        zipcode: 50240,
        text: 'หางดง',
        value: 'หางดง',
        name: {
          th: 'หางดง',
          en: 'Hang Dong',
        },
        districtId: 583,
      },
      {
        id: '501602',
        zipcode: 50240,
        text: 'ฮอด',
        value: 'ฮอด',
        name: {
          th: 'ฮอด',
          en: 'Hot',
        },
        districtId: 583,
      },
      {
        id: '501603',
        zipcode: 50240,
        text: 'บ้านตาล',
        value: 'บ้านตาล',
        name: {
          th: 'บ้านตาล',
          en: 'Ban Tan',
        },
        districtId: 583,
      },
      {
        id: '501604',
        zipcode: 50240,
        text: 'บ่อหลวง',
        value: 'บ่อหลวง',
        name: {
          th: 'บ่อหลวง',
          en: 'Bo Luang',
        },
        districtId: 583,
      },
      {
        id: '501605',
        zipcode: 50240,
        text: 'บ่อสลี',
        value: 'บ่อสลี',
        name: {
          th: 'บ่อสลี',
          en: 'Bo Sali',
        },
        districtId: 583,
      },
      {
        id: '501606',
        zipcode: 50240,
        text: 'นาคอเรือ',
        value: 'นาคอเรือ',
        name: {
          th: 'นาคอเรือ',
          en: 'Na Kho Ruea',
        },
        districtId: 583,
      },
      {
        id: '501701',
        zipcode: 50260,
        text: 'ดอยเต่า',
        value: 'ดอยเต่า',
        name: {
          th: 'ดอยเต่า',
          en: 'Doi Tao',
        },
        districtId: 584,
      },
      {
        id: '501702',
        zipcode: 50260,
        text: 'ท่าเดื่อ',
        value: 'ท่าเดื่อ',
        name: {
          th: 'ท่าเดื่อ',
          en: 'Tha Duea',
        },
        districtId: 584,
      },
      {
        id: '501703',
        zipcode: 50260,
        text: 'มืดกา',
        value: 'มืดกา',
        name: {
          th: 'มืดกา',
          en: 'Muet Ka',
        },
        districtId: 584,
      },
      {
        id: '501704',
        zipcode: 50260,
        text: 'บ้านแอ่น',
        value: 'บ้านแอ่น',
        name: {
          th: 'บ้านแอ่น',
          en: 'Ban Aen',
        },
        districtId: 584,
      },
      {
        id: '501705',
        zipcode: 50260,
        text: 'บงตัน',
        value: 'บงตัน',
        name: {
          th: 'บงตัน',
          en: 'Bong Tan',
        },
        districtId: 584,
      },
      {
        id: '501706',
        zipcode: 50260,
        text: 'โปงทุ่ง',
        value: 'โปงทุ่ง',
        name: {
          th: 'โปงทุ่ง',
          en: 'Pong Thung',
        },
        districtId: 584,
      },
      {
        id: '501801',
        zipcode: 50310,
        text: 'อมก๋อย',
        value: 'อมก๋อย',
        name: {
          th: 'อมก๋อย',
          en: 'Omkoi',
        },
        districtId: 585,
      },
      {
        id: '501802',
        zipcode: 50310,
        text: 'ยางเปียง',
        value: 'ยางเปียง',
        name: {
          th: 'ยางเปียง',
          en: 'Yang Piang',
        },
        districtId: 585,
      },
      {
        id: '501803',
        zipcode: 50310,
        text: 'แม่ตื่น',
        value: 'แม่ตื่น',
        name: {
          th: 'แม่ตื่น',
          en: 'Mae Tuen',
        },
        districtId: 585,
      },
      {
        id: '501804',
        zipcode: 50310,
        text: 'ม่อนจอง',
        value: 'ม่อนจอง',
        name: {
          th: 'ม่อนจอง',
          en: 'Mon Chong',
        },
        districtId: 585,
      },
      {
        id: '501805',
        zipcode: 50310,
        text: 'สบโขง',
        value: 'สบโขง',
        name: {
          th: 'สบโขง',
          en: 'Sop Khong',
        },
        districtId: 585,
      },
      {
        id: '501806',
        zipcode: 50310,
        text: 'นาเกียน',
        value: 'นาเกียน',
        name: {
          th: 'นาเกียน',
          en: 'Na Kian',
        },
        districtId: 585,
      },
      {
        id: '501901',
        zipcode: 50140,
        text: 'ยางเนิ้ง',
        value: 'ยางเนิ้ง',
        name: {
          th: 'ยางเนิ้ง',
          en: 'Yang Noeng',
        },
        districtId: 586,
      },
      {
        id: '501902',
        zipcode: 50140,
        text: 'สารภี',
        value: 'สารภี',
        name: {
          th: 'สารภี',
          en: 'Saraphi',
        },
        districtId: 586,
      },
      {
        id: '501903',
        zipcode: 50140,
        text: 'ชมภู',
        value: 'ชมภู',
        name: {
          th: 'ชมภู',
          en: 'Chom Phu',
        },
        districtId: 586,
      },
      {
        id: '501904',
        zipcode: 50140,
        text: 'ไชยสถาน',
        value: 'ไชยสถาน',
        name: {
          th: 'ไชยสถาน',
          en: 'Chai Sathan',
        },
        districtId: 586,
      },
      {
        id: '501905',
        zipcode: 50140,
        text: 'ขัวมุง',
        value: 'ขัวมุง',
        name: {
          th: 'ขัวมุง',
          en: 'Khua Mung',
        },
        districtId: 586,
      },
      {
        id: '501906',
        zipcode: 50140,
        text: 'หนองแฝก',
        value: 'หนองแฝก',
        name: {
          th: 'หนองแฝก',
          en: 'Nong Faek',
        },
        districtId: 586,
      },
      {
        id: '501907',
        zipcode: 50140,
        text: 'หนองผึ้ง',
        value: 'หนองผึ้ง',
        name: {
          th: 'หนองผึ้ง',
          en: 'Nong Phueng',
        },
        districtId: 586,
      },
      {
        id: '501908',
        zipcode: 50140,
        text: 'ท่ากว้าง',
        value: 'ท่ากว้าง',
        name: {
          th: 'ท่ากว้าง',
          en: 'Tha Kwang',
        },
        districtId: 586,
      },
      {
        id: '501909',
        zipcode: 50140,
        text: 'ดอนแก้ว',
        value: 'ดอนแก้ว',
        name: {
          th: 'ดอนแก้ว',
          en: 'Don Kaeo',
        },
        districtId: 586,
      },
      {
        id: '501910',
        zipcode: 50140,
        text: 'ท่าวังตาล',
        value: 'ท่าวังตาล',
        name: {
          th: 'ท่าวังตาล',
          en: 'Tha Wang Tan',
        },
        districtId: 586,
      },
      {
        id: '501911',
        zipcode: 50140,
        text: 'สันทราย',
        value: 'สันทราย',
        name: {
          th: 'สันทราย',
          en: 'San Sai',
        },
        districtId: 586,
      },
      {
        id: '501912',
        zipcode: 50140,
        text: 'ป่าบง',
        value: 'ป่าบง',
        name: {
          th: 'ป่าบง',
          en: 'Pa Bong',
        },
        districtId: 586,
      },
      {
        id: '502001',
        zipcode: 50350,
        text: 'เมืองแหง',
        value: 'เมืองแหง',
        name: {
          th: 'เมืองแหง',
          en: 'Mueang Haeng',
        },
        districtId: 587,
      },
      {
        id: '502002',
        zipcode: 50350,
        text: 'เปียงหลวง',
        value: 'เปียงหลวง',
        name: {
          th: 'เปียงหลวง',
          en: 'Piang Luang',
        },
        districtId: 587,
      },
      {
        id: '502003',
        zipcode: 50350,
        text: 'แสนไห',
        value: 'แสนไห',
        name: {
          th: 'แสนไห',
          en: 'Saen Hai',
        },
        districtId: 587,
      },
      {
        id: '502101',
        zipcode: 50320,
        text: 'ปงตำ',
        value: 'ปงตำ',
        name: {
          th: 'ปงตำ',
          en: 'Pong Tam',
        },
        districtId: 588,
      },
      {
        id: '502102',
        zipcode: 50320,
        text: 'ศรีดงเย็น',
        value: 'ศรีดงเย็น',
        name: {
          th: 'ศรีดงเย็น',
          en: 'Si Dong Yen',
        },
        districtId: 588,
      },
      {
        id: '502103',
        zipcode: 50320,
        text: 'แม่ทะลบ',
        value: 'แม่ทะลบ',
        name: {
          th: 'แม่ทะลบ',
          en: 'Mae Thalop',
        },
        districtId: 588,
      },
      {
        id: '502104',
        zipcode: 50320,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 588,
      },
      {
        id: '502201',
        zipcode: 50360,
        text: 'บ้านกาด',
        value: 'บ้านกาด',
        name: {
          th: 'บ้านกาด',
          en: 'Ban Kat',
        },
        districtId: 589,
      },
      {
        id: '502202',
        zipcode: 50360,
        text: 'ทุ่งปี้',
        value: 'ทุ่งปี้',
        name: {
          th: 'ทุ่งปี้',
          en: 'Thung Pi',
        },
        districtId: 589,
      },
      {
        id: '502203',
        zipcode: 50360,
        text: 'ทุ่งรวงทอง',
        value: 'ทุ่งรวงทอง',
        name: {
          th: 'ทุ่งรวงทอง',
          en: 'Thung Ruang Thong',
        },
        districtId: 589,
      },
      {
        id: '502204',
        zipcode: 50360,
        text: 'แม่วิน',
        value: 'แม่วิน',
        name: {
          th: 'แม่วิน',
          en: 'Mae Win',
        },
        districtId: 589,
      },
      {
        id: '502205',
        zipcode: 50360,
        text: 'ดอนเปา',
        value: 'ดอนเปา',
        name: {
          th: 'ดอนเปา',
          en: 'Don Pao',
        },
        districtId: 589,
      },
      {
        id: '502301',
        zipcode: 50130,
        text: 'ออนเหนือ',
        value: 'ออนเหนือ',
        name: {
          th: 'ออนเหนือ',
          en: 'On Nuea',
        },
        districtId: 590,
      },
      {
        id: '502302',
        zipcode: 50130,
        text: 'ออนกลาง',
        value: 'ออนกลาง',
        name: {
          th: 'ออนกลาง',
          en: 'On Klang',
        },
        districtId: 590,
      },
      {
        id: '502303',
        zipcode: 50130,
        text: 'บ้านสหกรณ์',
        value: 'บ้านสหกรณ์',
        name: {
          th: 'บ้านสหกรณ์',
          en: 'Ban Sahakon',
        },
        districtId: 590,
      },
      {
        id: '502304',
        zipcode: 50130,
        text: 'ห้วยแก้ว',
        value: 'ห้วยแก้ว',
        name: {
          th: 'ห้วยแก้ว',
          en: 'Huai Kaeo',
        },
        districtId: 590,
      },
      {
        id: '502305',
        zipcode: 50130,
        text: 'แม่ทา',
        value: 'แม่ทา',
        name: {
          th: 'แม่ทา',
          en: 'Mae Tha',
        },
        districtId: 590,
      },
      {
        id: '502306',
        zipcode: 50130,
        text: 'ทาเหนือ',
        value: 'ทาเหนือ',
        name: {
          th: 'ทาเหนือ',
          en: 'Tha Nuea',
        },
        districtId: 590,
      },
      {
        id: '502401',
        zipcode: 50160,
        text: 'ดอยหล่อ',
        value: 'ดอยหล่อ',
        name: {
          th: 'ดอยหล่อ',
          en: 'Doi Lo',
        },
        districtId: 591,
      },
      {
        id: '502402',
        zipcode: 50160,
        text: 'สองแคว',
        value: 'สองแคว',
        name: {
          th: 'สองแคว',
          en: 'Song Khwae',
        },
        districtId: 591,
      },
      {
        id: '502403',
        zipcode: 50160,
        text: 'ยางคราม',
        value: 'ยางคราม',
        name: {
          th: 'ยางคราม',
          en: 'Yang Khram',
        },
        districtId: 591,
      },
      {
        id: '502404',
        zipcode: 50160,
        text: 'สันติสุข',
        value: 'สันติสุข',
        name: {
          th: 'สันติสุข',
          en: 'Santi Suk',
        },
        districtId: 591,
      },
      {
        id: '510101',
        zipcode: 51000,
        text: 'ในเมือง',
        value: 'ในเมือง',
        name: {
          th: 'ในเมือง',
          en: 'Nai Mueang',
        },
        districtId: 595,
      },
      {
        id: '510102',
        zipcode: 51000,
        text: 'เหมืองง่า',
        value: 'เหมืองง่า',
        name: {
          th: 'เหมืองง่า',
          en: 'Mueang Nga',
        },
        districtId: 595,
      },
      {
        id: '510103',
        zipcode: 51150,
        text: 'อุโมงค์',
        value: 'อุโมงค์',
        name: {
          th: 'อุโมงค์',
          en: 'Umong',
        },
        districtId: 595,
      },
      {
        id: '510104',
        zipcode: 51150,
        text: 'หนองช้างคืน',
        value: 'หนองช้างคืน',
        name: {
          th: 'หนองช้างคืน',
          en: 'Nong Chang Khuen',
        },
        districtId: 595,
      },
      {
        id: '510105',
        zipcode: 51000,
        text: 'ประตูป่า',
        value: 'ประตูป่า',
        name: {
          th: 'ประตูป่า',
          en: 'Pratu Pa',
        },
        districtId: 595,
      },
      {
        id: '510106',
        zipcode: 51000,
        text: 'ริมปิง',
        value: 'ริมปิง',
        name: {
          th: 'ริมปิง',
          en: 'Rim Ping',
        },
        districtId: 595,
      },
      {
        id: '510107',
        zipcode: 51000,
        text: 'ต้นธง',
        value: 'ต้นธง',
        name: {
          th: 'ต้นธง',
          en: 'Ton Thong',
        },
        districtId: 595,
      },
      {
        id: '510108',
        zipcode: 51000,
        text: 'บ้านแป้น',
        value: 'บ้านแป้น',
        name: {
          th: 'บ้านแป้น',
          en: 'Ban Paen',
        },
        districtId: 595,
      },
      {
        id: '510109',
        zipcode: 51000,
        text: 'เหมืองจี้',
        value: 'เหมืองจี้',
        name: {
          th: 'เหมืองจี้',
          en: 'Mueang Chi',
        },
        districtId: 595,
      },
      {
        id: '510110',
        zipcode: 51000,
        text: 'ป่าสัก',
        value: 'ป่าสัก',
        name: {
          th: 'ป่าสัก',
          en: 'Pa Sak',
        },
        districtId: 595,
      },
      {
        id: '510111',
        zipcode: 51000,
        text: 'เวียงยอง',
        value: 'เวียงยอง',
        name: {
          th: 'เวียงยอง',
          en: 'Wiang Yong',
        },
        districtId: 595,
      },
      {
        id: '510112',
        zipcode: 51000,
        text: 'บ้านกลาง',
        value: 'บ้านกลาง',
        name: {
          th: 'บ้านกลาง',
          en: 'Ban Klang',
        },
        districtId: 595,
      },
      {
        id: '510113',
        zipcode: 51000,
        text: 'มะเขือแจ้',
        value: 'มะเขือแจ้',
        name: {
          th: 'มะเขือแจ้',
          en: 'Makhuea Chae',
        },
        districtId: 595,
      },
      {
        id: '510116',
        zipcode: 51000,
        text: 'ศรีบัวบาน',
        value: 'ศรีบัวบาน',
        name: {
          th: 'ศรีบัวบาน',
          en: 'Si Bua Ban',
        },
        districtId: 595,
      },
      {
        id: '510117',
        zipcode: 51000,
        text: 'หนองหนาม',
        value: 'หนองหนาม',
        name: {
          th: 'หนองหนาม',
          en: 'Nong Nam',
        },
        districtId: 595,
      },
      {
        id: '510201',
        zipcode: 51140,
        text: 'ทาปลาดุก',
        value: 'ทาปลาดุก',
        name: {
          th: 'ทาปลาดุก',
          en: 'Tha Pla Duk',
        },
        districtId: 596,
      },
      {
        id: '510202',
        zipcode: 51140,
        text: 'ทาสบเส้า',
        value: 'ทาสบเส้า',
        name: {
          th: 'ทาสบเส้า',
          en: 'Tha Sop Sao',
        },
        districtId: 596,
      },
      {
        id: '510203',
        zipcode: 51170,
        text: 'ทากาศ',
        value: 'ทากาศ',
        name: {
          th: 'ทากาศ',
          en: 'Tha Kat',
        },
        districtId: 596,
      },
      {
        id: '510204',
        zipcode: 51170,
        text: 'ทาขุมเงิน',
        value: 'ทาขุมเงิน',
        name: {
          th: 'ทาขุมเงิน',
          en: 'Tha Khum Ngoen',
        },
        districtId: 596,
      },
      {
        id: '510205',
        zipcode: 51170,
        text: 'ทาทุ่งหลวง',
        value: 'ทาทุ่งหลวง',
        name: {
          th: 'ทาทุ่งหลวง',
          en: 'Tha Thung Luang',
        },
        districtId: 596,
      },
      {
        id: '510206',
        zipcode: 51170,
        text: 'ทาแม่ลอบ',
        value: 'ทาแม่ลอบ',
        name: {
          th: 'ทาแม่ลอบ',
          en: 'Tha Mae Lop',
        },
        districtId: 596,
      },
      {
        id: '510301',
        zipcode: 51130,
        text: 'บ้านโฮ่ง',
        value: 'บ้านโฮ่ง',
        name: {
          th: 'บ้านโฮ่ง',
          en: 'Ban Hong',
        },
        districtId: 597,
      },
      {
        id: '510302',
        zipcode: 51130,
        text: 'ป่าพลู',
        value: 'ป่าพลู',
        name: {
          th: 'ป่าพลู',
          en: 'Pa Phlu',
        },
        districtId: 597,
      },
      {
        id: '510303',
        zipcode: 51130,
        text: 'เหล่ายาว',
        value: 'เหล่ายาว',
        name: {
          th: 'เหล่ายาว',
          en: 'Lao Yao',
        },
        districtId: 597,
      },
      {
        id: '510304',
        zipcode: 51130,
        text: 'ศรีเตี้ย',
        value: 'ศรีเตี้ย',
        name: {
          th: 'ศรีเตี้ย',
          en: 'Si Tia',
        },
        districtId: 597,
      },
      {
        id: '510305',
        zipcode: 51130,
        text: 'หนองปลาสะวาย',
        value: 'หนองปลาสะวาย',
        name: {
          th: 'หนองปลาสะวาย',
          en: 'Nong Pla Sawai',
        },
        districtId: 597,
      },
      {
        id: '510401',
        zipcode: 51110,
        text: 'ลี้',
        value: 'ลี้',
        name: {
          th: 'ลี้',
          en: 'Li',
        },
        districtId: 598,
      },
      {
        id: '510402',
        zipcode: 51110,
        text: 'แม่ตืน',
        value: 'แม่ตืน',
        name: {
          th: 'แม่ตืน',
          en: 'Mae Tuen',
        },
        districtId: 598,
      },
      {
        id: '510403',
        zipcode: 51110,
        text: 'นาทราย',
        value: 'นาทราย',
        name: {
          th: 'นาทราย',
          en: 'Na Sai',
        },
        districtId: 598,
      },
      {
        id: '510404',
        zipcode: 51110,
        text: 'ดงดำ',
        value: 'ดงดำ',
        name: {
          th: 'ดงดำ',
          en: 'Dong Dam',
        },
        districtId: 598,
      },
      {
        id: '510405',
        zipcode: 51110,
        text: 'ก้อ',
        value: 'ก้อ',
        name: {
          th: 'ก้อ',
          en: 'Ko',
        },
        districtId: 598,
      },
      {
        id: '510406',
        zipcode: 51110,
        text: 'แม่ลาน',
        value: 'แม่ลาน',
        name: {
          th: 'แม่ลาน',
          en: 'Mae Lan',
        },
        districtId: 598,
      },
      {
        id: '510408',
        zipcode: 51110,
        text: 'ป่าไผ่',
        value: 'ป่าไผ่',
        name: {
          th: 'ป่าไผ่',
          en: 'Pa Phai',
        },
        districtId: 598,
      },
      {
        id: '510409',
        zipcode: 51110,
        text: 'ศรีวิชัย',
        value: 'ศรีวิชัย',
        name: {
          th: 'ศรีวิชัย',
          en: 'Si Wichai',
        },
        districtId: 598,
      },
      {
        id: '510501',
        zipcode: 51160,
        text: 'ทุ่งหัวช้าง',
        value: 'ทุ่งหัวช้าง',
        name: {
          th: 'ทุ่งหัวช้าง',
          en: 'Thung Hua Chang',
        },
        districtId: 599,
      },
      {
        id: '510502',
        zipcode: 51160,
        text: 'บ้านปวง',
        value: 'บ้านปวง',
        name: {
          th: 'บ้านปวง',
          en: 'Ban Puang',
        },
        districtId: 599,
      },
      {
        id: '510503',
        zipcode: 51160,
        text: 'ตะเคียนปม',
        value: 'ตะเคียนปม',
        name: {
          th: 'ตะเคียนปม',
          en: 'Takhian Pom',
        },
        districtId: 599,
      },
      {
        id: '510601',
        zipcode: 51120,
        text: 'ปากบ่อง',
        value: 'ปากบ่อง',
        name: {
          th: 'ปากบ่อง',
          en: 'Pak Bong',
        },
        districtId: 600,
      },
      {
        id: '510602',
        zipcode: 51120,
        text: 'ป่าซาง',
        value: 'ป่าซาง',
        name: {
          th: 'ป่าซาง',
          en: 'Pa Sang',
        },
        districtId: 600,
      },
      {
        id: '510603',
        zipcode: 51120,
        text: 'แม่แรง',
        value: 'แม่แรง',
        name: {
          th: 'แม่แรง',
          en: 'Mae Raeng',
        },
        districtId: 600,
      },
      {
        id: '510604',
        zipcode: 51120,
        text: 'ม่วงน้อย',
        value: 'ม่วงน้อย',
        name: {
          th: 'ม่วงน้อย',
          en: 'Muang Noi',
        },
        districtId: 600,
      },
      {
        id: '510605',
        zipcode: 51120,
        text: 'บ้านเรือน',
        value: 'บ้านเรือน',
        name: {
          th: 'บ้านเรือน',
          en: 'Ban Ruean',
        },
        districtId: 600,
      },
      {
        id: '510606',
        zipcode: 51120,
        text: 'มะกอก',
        value: 'มะกอก',
        name: {
          th: 'มะกอก',
          en: 'Makok',
        },
        districtId: 600,
      },
      {
        id: '510607',
        zipcode: 51120,
        text: 'ท่าตุ้ม',
        value: 'ท่าตุ้ม',
        name: {
          th: 'ท่าตุ้ม',
          en: 'Tha Tum',
        },
        districtId: 600,
      },
      {
        id: '510608',
        zipcode: 51120,
        text: 'น้ำดิบ',
        value: 'น้ำดิบ',
        name: {
          th: 'น้ำดิบ',
          en: 'Nam Dip',
        },
        districtId: 600,
      },
      {
        id: '510611',
        zipcode: 51120,
        text: 'นครเจดีย์',
        value: 'นครเจดีย์',
        name: {
          th: 'นครเจดีย์',
          en: 'Nakhon Chedi',
        },
        districtId: 600,
      },
      {
        id: '510701',
        zipcode: 51180,
        text: 'บ้านธิ',
        value: 'บ้านธิ',
        name: {
          th: 'บ้านธิ',
          en: 'Ban Thi',
        },
        districtId: 601,
      },
      {
        id: '510702',
        zipcode: 51180,
        text: 'ห้วยยาบ',
        value: 'ห้วยยาบ',
        name: {
          th: 'ห้วยยาบ',
          en: 'Huai Yap',
        },
        districtId: 601,
      },
      {
        id: '510801',
        zipcode: 51120,
        text: 'หนองล่อง',
        value: 'หนองล่อง',
        name: {
          th: 'หนองล่อง',
          en: 'Nong Long',
        },
        districtId: 602,
      },
      {
        id: '510802',
        zipcode: 51120,
        text: 'หนองยวง',
        value: 'หนองยวง',
        name: {
          th: 'หนองยวง',
          en: 'Nong Yuang',
        },
        districtId: 602,
      },
      {
        id: '510803',
        zipcode: 51120,
        text: 'วังผาง',
        value: 'วังผาง',
        name: {
          th: 'วังผาง',
          en: 'Wang Phang',
        },
        districtId: 602,
      },
      {
        id: '520101',
        zipcode: 52000,
        text: 'เวียงเหนือ',
        value: 'เวียงเหนือ',
        name: {
          th: 'เวียงเหนือ',
          en: 'Wiang Nuea',
        },
        districtId: 603,
      },
      {
        id: '520102',
        zipcode: 52000,
        text: 'หัวเวียง',
        value: 'หัวเวียง',
        name: {
          th: 'หัวเวียง',
          en: 'Hua Wiang',
        },
        districtId: 603,
      },
      {
        id: '520103',
        zipcode: 52100,
        text: 'สวนดอก',
        value: 'สวนดอก',
        name: {
          th: 'สวนดอก',
          en: 'Suan Dok',
        },
        districtId: 603,
      },
      {
        id: '520104',
        zipcode: 52100,
        text: 'สบตุ๋ย',
        value: 'สบตุ๋ย',
        name: {
          th: 'สบตุ๋ย',
          en: 'Sop Tui',
        },
        districtId: 603,
      },
      {
        id: '520105',
        zipcode: 52000,
        text: 'พระบาท',
        value: 'พระบาท',
        name: {
          th: 'พระบาท',
          en: 'Phra Bat',
        },
        districtId: 603,
      },
      {
        id: '520106',
        zipcode: 52100,
        text: 'ชมพู',
        value: 'ชมพู',
        name: {
          th: 'ชมพู',
          en: 'Chomphu',
        },
        districtId: 603,
      },
      {
        id: '520107',
        zipcode: 52000,
        text: 'กล้วยแพะ',
        value: 'กล้วยแพะ',
        name: {
          th: 'กล้วยแพะ',
          en: 'Kluai Phae',
        },
        districtId: 603,
      },
      {
        id: '520108',
        zipcode: 52100,
        text: 'ปงแสนทอง',
        value: 'ปงแสนทอง',
        name: {
          th: 'ปงแสนทอง',
          en: 'Pong Saen Thong',
        },
        districtId: 603,
      },
      {
        id: '520109',
        zipcode: 52000,
        text: 'บ้านแลง',
        value: 'บ้านแลง',
        name: {
          th: 'บ้านแลง',
          en: 'Ban Laeng',
        },
        districtId: 603,
      },
      {
        id: '520110',
        zipcode: 52000,
        text: 'บ้านเสด็จ',
        value: 'บ้านเสด็จ',
        name: {
          th: 'บ้านเสด็จ',
          en: 'Ban Sadet',
        },
        districtId: 603,
      },
      {
        id: '520111',
        zipcode: 52000,
        text: 'พิชัย',
        value: 'พิชัย',
        name: {
          th: 'พิชัย',
          en: 'Phichai',
        },
        districtId: 603,
      },
      {
        id: '520112',
        zipcode: 52000,
        text: 'ทุ่งฝาย',
        value: 'ทุ่งฝาย',
        name: {
          th: 'ทุ่งฝาย',
          en: 'Thung Fai',
        },
        districtId: 603,
      },
      {
        id: '520113',
        zipcode: 52100,
        text: 'บ้านเอื้อม',
        value: 'บ้านเอื้อม',
        name: {
          th: 'บ้านเอื้อม',
          en: 'Ban Ueam',
        },
        districtId: 603,
      },
      {
        id: '520114',
        zipcode: 52100,
        text: 'บ้านเป้า',
        value: 'บ้านเป้า',
        name: {
          th: 'บ้านเป้า',
          en: 'Ban Pao',
        },
        districtId: 603,
      },
      {
        id: '520115',
        zipcode: 52100,
        text: 'บ้านค่า',
        value: 'บ้านค่า',
        name: {
          th: 'บ้านค่า',
          en: 'Ban Kha',
        },
        districtId: 603,
      },
      {
        id: '520116',
        zipcode: 52100,
        text: 'บ่อแฮ้ว',
        value: 'บ่อแฮ้ว',
        name: {
          th: 'บ่อแฮ้ว',
          en: 'Bo Haeo',
        },
        districtId: 603,
      },
      {
        id: '520117',
        zipcode: 52000,
        text: 'ต้นธงชัย',
        value: 'ต้นธงชัย',
        name: {
          th: 'ต้นธงชัย',
          en: 'Ton Thong Chai',
        },
        districtId: 603,
      },
      {
        id: '520118',
        zipcode: 52000,
        text: 'นิคมพัฒนา',
        value: 'นิคมพัฒนา',
        name: {
          th: 'นิคมพัฒนา',
          en: 'Nikhom Phatthana',
        },
        districtId: 603,
      },
      {
        id: '520119',
        zipcode: 52000,
        text: 'บุญนาคพัฒนา',
        value: 'บุญนาคพัฒนา',
        name: {
          th: 'บุญนาคพัฒนา',
          en: 'Bunnak Phatthana',
        },
        districtId: 603,
      },
      {
        id: '520201',
        zipcode: 52220,
        text: 'บ้านดง',
        value: 'บ้านดง',
        name: {
          th: 'บ้านดง',
          en: 'Ban Dong',
        },
        districtId: 604,
      },
      {
        id: '520202',
        zipcode: 52220,
        text: 'นาสัก',
        value: 'นาสัก',
        name: {
          th: 'นาสัก',
          en: 'Na Sak',
        },
        districtId: 604,
      },
      {
        id: '520203',
        zipcode: 52220,
        text: 'จางเหนือ',
        value: 'จางเหนือ',
        name: {
          th: 'จางเหนือ',
          en: 'Chang Nuea',
        },
        districtId: 604,
      },
      {
        id: '520204',
        zipcode: 52220,
        text: 'แม่เมาะ',
        value: 'แม่เมาะ',
        name: {
          th: 'แม่เมาะ',
          en: 'Mae Mo',
        },
        districtId: 604,
      },
      {
        id: '520205',
        zipcode: 52220,
        text: 'สบป้าด',
        value: 'สบป้าด',
        name: {
          th: 'สบป้าด',
          en: 'Sop Pat',
        },
        districtId: 604,
      },
      {
        id: '520301',
        zipcode: 52130,
        text: 'ลำปางหลวง',
        value: 'ลำปางหลวง',
        name: {
          th: 'ลำปางหลวง',
          en: 'Lampang Luang',
        },
        districtId: 605,
      },
      {
        id: '520302',
        zipcode: 52130,
        text: 'นาแก้ว',
        value: 'นาแก้ว',
        name: {
          th: 'นาแก้ว',
          en: 'Na Kaeo',
        },
        districtId: 605,
      },
      {
        id: '520303',
        zipcode: 52130,
        text: 'ไหล่หิน',
        value: 'ไหล่หิน',
        name: {
          th: 'ไหล่หิน',
          en: 'Lai Hin',
        },
        districtId: 605,
      },
      {
        id: '520304',
        zipcode: 52130,
        text: 'วังพร้าว',
        value: 'วังพร้าว',
        name: {
          th: 'วังพร้าว',
          en: 'Wang Phrao',
        },
        districtId: 605,
      },
      {
        id: '520305',
        zipcode: 52130,
        text: 'ศาลา',
        value: 'ศาลา',
        name: {
          th: 'ศาลา',
          en: 'Sala',
        },
        districtId: 605,
      },
      {
        id: '520306',
        zipcode: 52130,
        text: 'เกาะคา',
        value: 'เกาะคา',
        name: {
          th: 'เกาะคา',
          en: 'Ko Kha',
        },
        districtId: 605,
      },
      {
        id: '520307',
        zipcode: 52130,
        text: 'นาแส่ง',
        value: 'นาแส่ง',
        name: {
          th: 'นาแส่ง',
          en: 'Na Saeng',
        },
        districtId: 605,
      },
      {
        id: '520308',
        zipcode: 52130,
        text: 'ท่าผา',
        value: 'ท่าผา',
        name: {
          th: 'ท่าผา',
          en: 'Tha Pha',
        },
        districtId: 605,
      },
      {
        id: '520309',
        zipcode: 52130,
        text: 'ใหม่พัฒนา',
        value: 'ใหม่พัฒนา',
        name: {
          th: 'ใหม่พัฒนา',
          en: 'Mai Phatthana',
        },
        districtId: 605,
      },
      {
        id: '520401',
        zipcode: 52210,
        text: 'ทุ่งงาม',
        value: 'ทุ่งงาม',
        name: {
          th: 'ทุ่งงาม',
          en: 'Thung Ngam',
        },
        districtId: 606,
      },
      {
        id: '520402',
        zipcode: 52210,
        text: 'เสริมขวา',
        value: 'เสริมขวา',
        name: {
          th: 'เสริมขวา',
          en: 'Soem Khwa',
        },
        districtId: 606,
      },
      {
        id: '520403',
        zipcode: 52210,
        text: 'เสริมซ้าย',
        value: 'เสริมซ้าย',
        name: {
          th: 'เสริมซ้าย',
          en: 'Soem Sai',
        },
        districtId: 606,
      },
      {
        id: '520404',
        zipcode: 52210,
        text: 'เสริมกลาง',
        value: 'เสริมกลาง',
        name: {
          th: 'เสริมกลาง',
          en: 'Soem Klang',
        },
        districtId: 606,
      },
      {
        id: '520501',
        zipcode: 52110,
        text: 'หลวงเหนือ',
        value: 'หลวงเหนือ',
        name: {
          th: 'หลวงเหนือ',
          en: 'Luang Nuea',
        },
        districtId: 607,
      },
      {
        id: '520502',
        zipcode: 52110,
        text: 'หลวงใต้',
        value: 'หลวงใต้',
        name: {
          th: 'หลวงใต้',
          en: 'Luang Tai',
        },
        districtId: 607,
      },
      {
        id: '520503',
        zipcode: 52110,
        text: 'บ้านโป่ง',
        value: 'บ้านโป่ง',
        name: {
          th: 'บ้านโป่ง',
          en: 'Ban Pong',
        },
        districtId: 607,
      },
      {
        id: '520504',
        zipcode: 52110,
        text: 'บ้านร้อง',
        value: 'บ้านร้อง',
        name: {
          th: 'บ้านร้อง',
          en: 'Ban Rong',
        },
        districtId: 607,
      },
      {
        id: '520505',
        zipcode: 52110,
        text: 'ปงเตา',
        value: 'ปงเตา',
        name: {
          th: 'ปงเตา',
          en: 'Pong Tao',
        },
        districtId: 607,
      },
      {
        id: '520506',
        zipcode: 52110,
        text: 'นาแก',
        value: 'นาแก',
        name: {
          th: 'นาแก',
          en: 'Na Kae',
        },
        districtId: 607,
      },
      {
        id: '520507',
        zipcode: 52110,
        text: 'บ้านอ้อน',
        value: 'บ้านอ้อน',
        name: {
          th: 'บ้านอ้อน',
          en: 'Ban On',
        },
        districtId: 607,
      },
      {
        id: '520508',
        zipcode: 52110,
        text: 'บ้านแหง',
        value: 'บ้านแหง',
        name: {
          th: 'บ้านแหง',
          en: 'Ban Haeng',
        },
        districtId: 607,
      },
      {
        id: '520509',
        zipcode: 52110,
        text: 'บ้านหวด',
        value: 'บ้านหวด',
        name: {
          th: 'บ้านหวด',
          en: 'Ban Huat',
        },
        districtId: 607,
      },
      {
        id: '520510',
        zipcode: 52110,
        text: 'แม่ตีบ',
        value: 'แม่ตีบ',
        name: {
          th: 'แม่ตีบ',
          en: 'Mae Tip',
        },
        districtId: 607,
      },
      {
        id: '520601',
        zipcode: 52120,
        text: 'แจ้ห่ม',
        value: 'แจ้ห่ม',
        name: {
          th: 'แจ้ห่ม',
          en: 'Chae Hom',
        },
        districtId: 608,
      },
      {
        id: '520602',
        zipcode: 52120,
        text: 'บ้านสา',
        value: 'บ้านสา',
        name: {
          th: 'บ้านสา',
          en: 'Ban Sa',
        },
        districtId: 608,
      },
      {
        id: '520603',
        zipcode: 52120,
        text: 'ปงดอน',
        value: 'ปงดอน',
        name: {
          th: 'ปงดอน',
          en: 'Pong Don',
        },
        districtId: 608,
      },
      {
        id: '520604',
        zipcode: 52120,
        text: 'แม่สุก',
        value: 'แม่สุก',
        name: {
          th: 'แม่สุก',
          en: 'Mae Suk',
        },
        districtId: 608,
      },
      {
        id: '520605',
        zipcode: 52120,
        text: 'เมืองมาย',
        value: 'เมืองมาย',
        name: {
          th: 'เมืองมาย',
          en: 'Mueang Mai',
        },
        districtId: 608,
      },
      {
        id: '520606',
        zipcode: 52120,
        text: 'ทุ่งผึ้ง',
        value: 'ทุ่งผึ้ง',
        name: {
          th: 'ทุ่งผึ้ง',
          en: 'Thung Phueng',
        },
        districtId: 608,
      },
      {
        id: '520607',
        zipcode: 52120,
        text: 'วิเชตนคร',
        value: 'วิเชตนคร',
        name: {
          th: 'วิเชตนคร',
          en: 'Wichet Nakhon',
        },
        districtId: 608,
      },
      {
        id: '520701',
        zipcode: 52140,
        text: 'ทุ่งฮั้ว',
        value: 'ทุ่งฮั้ว',
        name: {
          th: 'ทุ่งฮั้ว',
          en: 'Thung Hua',
        },
        districtId: 609,
      },
      {
        id: '520702',
        zipcode: 52140,
        text: 'วังเหนือ',
        value: 'วังเหนือ',
        name: {
          th: 'วังเหนือ',
          en: 'Wang Nuea',
        },
        districtId: 609,
      },
      {
        id: '520703',
        zipcode: 52140,
        text: 'วังใต้',
        value: 'วังใต้',
        name: {
          th: 'วังใต้',
          en: 'Wang Tai',
        },
        districtId: 609,
      },
      {
        id: '520704',
        zipcode: 52140,
        text: 'ร่องเคาะ',
        value: 'ร่องเคาะ',
        name: {
          th: 'ร่องเคาะ',
          en: 'Rong Kho',
        },
        districtId: 609,
      },
      {
        id: '520705',
        zipcode: 52140,
        text: 'วังทอง',
        value: 'วังทอง',
        name: {
          th: 'วังทอง',
          en: 'Wang Thong',
        },
        districtId: 609,
      },
      {
        id: '520706',
        zipcode: 52140,
        text: 'วังซ้าย',
        value: 'วังซ้าย',
        name: {
          th: 'วังซ้าย',
          en: 'Wang Sai',
        },
        districtId: 609,
      },
      {
        id: '520707',
        zipcode: 52140,
        text: 'วังแก้ว',
        value: 'วังแก้ว',
        name: {
          th: 'วังแก้ว',
          en: 'Wang Kaeo',
        },
        districtId: 609,
      },
      {
        id: '520708',
        zipcode: 52140,
        text: 'วังทรายคำ',
        value: 'วังทรายคำ',
        name: {
          th: 'วังทรายคำ',
          en: 'Wang Sai Kham',
        },
        districtId: 609,
      },
      {
        id: '520801',
        zipcode: 52160,
        text: 'ล้อมแรด',
        value: 'ล้อมแรด',
        name: {
          th: 'ล้อมแรด',
          en: 'Lom Raet',
        },
        districtId: 610,
      },
      {
        id: '520802',
        zipcode: 52230,
        text: 'แม่วะ',
        value: 'แม่วะ',
        name: {
          th: 'แม่วะ',
          en: 'Mae Wa',
        },
        districtId: 610,
      },
      {
        id: '520803',
        zipcode: 52160,
        text: 'แม่ปะ',
        value: 'แม่ปะ',
        name: {
          th: 'แม่ปะ',
          en: 'Mae Pa',
        },
        districtId: 610,
      },
      {
        id: '520804',
        zipcode: 52160,
        text: 'แม่มอก',
        value: 'แม่มอก',
        name: {
          th: 'แม่มอก',
          en: 'Mae Mok',
        },
        districtId: 610,
      },
      {
        id: '520805',
        zipcode: 52160,
        text: 'เวียงมอก',
        value: 'เวียงมอก',
        name: {
          th: 'เวียงมอก',
          en: 'Wiang Mok',
        },
        districtId: 610,
      },
      {
        id: '520806',
        zipcode: 52160,
        text: 'นาโป่ง',
        value: 'นาโป่ง',
        name: {
          th: 'นาโป่ง',
          en: 'Na Pong',
        },
        districtId: 610,
      },
      {
        id: '520807',
        zipcode: 52160,
        text: 'แม่ถอด',
        value: 'แม่ถอด',
        name: {
          th: 'แม่ถอด',
          en: 'Mae Thot',
        },
        districtId: 610,
      },
      {
        id: '520808',
        zipcode: 52160,
        text: 'เถินบุรี',
        value: 'เถินบุรี',
        name: {
          th: 'เถินบุรี',
          en: 'Thoen Buri',
        },
        districtId: 610,
      },
      {
        id: '520901',
        zipcode: 52180,
        text: 'แม่พริก',
        value: 'แม่พริก',
        name: {
          th: 'แม่พริก',
          en: 'Mae Phrik',
        },
        districtId: 611,
      },
      {
        id: '520902',
        zipcode: 52180,
        text: 'ผาปัง',
        value: 'ผาปัง',
        name: {
          th: 'ผาปัง',
          en: 'Pha Pang',
        },
        districtId: 611,
      },
      {
        id: '520903',
        zipcode: 52180,
        text: 'แม่ปุ',
        value: 'แม่ปุ',
        name: {
          th: 'แม่ปุ',
          en: 'Mae Pu',
        },
        districtId: 611,
      },
      {
        id: '520904',
        zipcode: 52180,
        text: 'พระบาทวังตวง',
        value: 'พระบาทวังตวง',
        name: {
          th: 'พระบาทวังตวง',
          en: 'Phra Bat Wang Tuang',
        },
        districtId: 611,
      },
      {
        id: '521001',
        zipcode: 52150,
        text: 'แม่ทะ',
        value: 'แม่ทะ',
        name: {
          th: 'แม่ทะ',
          en: 'Mae Tha',
        },
        districtId: 612,
      },
      {
        id: '521002',
        zipcode: 52150,
        text: 'นาครัว',
        value: 'นาครัว',
        name: {
          th: 'นาครัว',
          en: 'Na Khrua',
        },
        districtId: 612,
      },
      {
        id: '521003',
        zipcode: 52150,
        text: 'ป่าตัน',
        value: 'ป่าตัน',
        name: {
          th: 'ป่าตัน',
          en: 'Pa Tan',
        },
        districtId: 612,
      },
      {
        id: '521004',
        zipcode: 52150,
        text: 'บ้านกิ่ว',
        value: 'บ้านกิ่ว',
        name: {
          th: 'บ้านกิ่ว',
          en: 'Ban Kio',
        },
        districtId: 612,
      },
      {
        id: '521005',
        zipcode: 52150,
        text: 'บ้านบอม',
        value: 'บ้านบอม',
        name: {
          th: 'บ้านบอม',
          en: 'Ban Bom',
        },
        districtId: 612,
      },
      {
        id: '521006',
        zipcode: 52150,
        text: 'น้ำโจ้',
        value: 'น้ำโจ้',
        name: {
          th: 'น้ำโจ้',
          en: 'Nam Cho',
        },
        districtId: 612,
      },
      {
        id: '521007',
        zipcode: 52150,
        text: 'ดอนไฟ',
        value: 'ดอนไฟ',
        name: {
          th: 'ดอนไฟ',
          en: 'Don Fai',
        },
        districtId: 612,
      },
      {
        id: '521008',
        zipcode: 52150,
        text: 'หัวเสือ',
        value: 'หัวเสือ',
        name: {
          th: 'หัวเสือ',
          en: 'Hua Suea',
        },
        districtId: 612,
      },
      {
        id: '521010',
        zipcode: 52150,
        text: 'วังเงิน',
        value: 'วังเงิน',
        name: {
          th: 'วังเงิน',
          en: 'Wang Ngoen',
        },
        districtId: 612,
      },
      {
        id: '521011',
        zipcode: 52150,
        text: 'สันดอนแก้ว',
        value: 'สันดอนแก้ว',
        name: {
          th: 'สันดอนแก้ว',
          en: 'San Don Kaeo',
        },
        districtId: 612,
      },
      {
        id: '521101',
        zipcode: 52170,
        text: 'สบปราบ',
        value: 'สบปราบ',
        name: {
          th: 'สบปราบ',
          en: 'Sop Prap',
        },
        districtId: 613,
      },
      {
        id: '521102',
        zipcode: 52170,
        text: 'สมัย',
        value: 'สมัย',
        name: {
          th: 'สมัย',
          en: 'Samai',
        },
        districtId: 613,
      },
      {
        id: '521103',
        zipcode: 52170,
        text: 'แม่กัวะ',
        value: 'แม่กัวะ',
        name: {
          th: 'แม่กัวะ',
          en: 'Mae Kua',
        },
        districtId: 613,
      },
      {
        id: '521104',
        zipcode: 52170,
        text: 'นายาง',
        value: 'นายาง',
        name: {
          th: 'นายาง',
          en: 'Na Yang',
        },
        districtId: 613,
      },
      {
        id: '521201',
        zipcode: 52190,
        text: 'ห้างฉัตร',
        value: 'ห้างฉัตร',
        name: {
          th: 'ห้างฉัตร',
          en: 'Hang Chat',
        },
        districtId: 614,
      },
      {
        id: '521202',
        zipcode: 52190,
        text: 'หนองหล่ม',
        value: 'หนองหล่ม',
        name: {
          th: 'หนองหล่ม',
          en: 'Nong Lom',
        },
        districtId: 614,
      },
      {
        id: '521203',
        zipcode: 52190,
        text: 'เมืองยาว',
        value: 'เมืองยาว',
        name: {
          th: 'เมืองยาว',
          en: 'Mueang Yao',
        },
        districtId: 614,
      },
      {
        id: '521204',
        zipcode: 52190,
        text: 'ปงยางคก',
        value: 'ปงยางคก',
        name: {
          th: 'ปงยางคก',
          en: 'Pong Yang Khok',
        },
        districtId: 614,
      },
      {
        id: '521205',
        zipcode: 52190,
        text: 'เวียงตาล',
        value: 'เวียงตาล',
        name: {
          th: 'เวียงตาล',
          en: 'Wiang Tan',
        },
        districtId: 614,
      },
      {
        id: '521206',
        zipcode: 52190,
        text: 'แม่สัน',
        value: 'แม่สัน',
        name: {
          th: 'แม่สัน',
          en: 'Mae San',
        },
        districtId: 614,
      },
      {
        id: '521207',
        zipcode: 52190,
        text: 'วอแก้ว',
        value: 'วอแก้ว',
        name: {
          th: 'วอแก้ว',
          en: 'Wo Kaeo',
        },
        districtId: 614,
      },
      {
        id: '521301',
        zipcode: 52240,
        text: 'เมืองปาน',
        value: 'เมืองปาน',
        name: {
          th: 'เมืองปาน',
          en: 'Mueang Pan',
        },
        districtId: 615,
      },
      {
        id: '521302',
        zipcode: 52240,
        text: 'บ้านขอ',
        value: 'บ้านขอ',
        name: {
          th: 'บ้านขอ',
          en: 'Ban Kho',
        },
        districtId: 615,
      },
      {
        id: '521303',
        zipcode: 52240,
        text: 'ทุ่งกว๋าว',
        value: 'ทุ่งกว๋าว',
        name: {
          th: 'ทุ่งกว๋าว',
          en: 'Thung Kwao',
        },
        districtId: 615,
      },
      {
        id: '521304',
        zipcode: 52240,
        text: 'แจ้ซ้อน',
        value: 'แจ้ซ้อน',
        name: {
          th: 'แจ้ซ้อน',
          en: 'Chae Son',
        },
        districtId: 615,
      },
      {
        id: '521305',
        zipcode: 52240,
        text: 'หัวเมือง',
        value: 'หัวเมือง',
        name: {
          th: 'หัวเมือง',
          en: 'Hua Mueang',
        },
        districtId: 615,
      },
      {
        id: '530101',
        zipcode: 53000,
        text: 'ท่าอิฐ',
        value: 'ท่าอิฐ',
        name: {
          th: 'ท่าอิฐ',
          en: 'Tha It',
        },
        districtId: 616,
      },
      {
        id: '530102',
        zipcode: 53000,
        text: 'ท่าเสา',
        value: 'ท่าเสา',
        name: {
          th: 'ท่าเสา',
          en: 'Tha Sao',
        },
        districtId: 616,
      },
      {
        id: '530103',
        zipcode: 53000,
        text: 'บ้านเกาะ',
        value: 'บ้านเกาะ',
        name: {
          th: 'บ้านเกาะ',
          en: 'Ban Ko',
        },
        districtId: 616,
      },
      {
        id: '530104',
        zipcode: 53000,
        text: 'ป่าเซ่า',
        value: 'ป่าเซ่า',
        name: {
          th: 'ป่าเซ่า',
          en: 'Pa Sao',
        },
        districtId: 616,
      },
      {
        id: '530105',
        zipcode: 53000,
        text: 'คุ้งตะเภา',
        value: 'คุ้งตะเภา',
        name: {
          th: 'คุ้งตะเภา',
          en: 'Khung Taphao',
        },
        districtId: 616,
      },
      {
        id: '530106',
        zipcode: 53170,
        text: 'วังกะพี้',
        value: 'วังกะพี้',
        name: {
          th: 'วังกะพี้',
          en: 'Wang Kaphi',
        },
        districtId: 616,
      },
      {
        id: '530107',
        zipcode: 53000,
        text: 'หาดกรวด',
        value: 'หาดกรวด',
        name: {
          th: 'หาดกรวด',
          en: 'Hat Kruat',
        },
        districtId: 616,
      },
      {
        id: '530108',
        zipcode: 53000,
        text: 'น้ำริด',
        value: 'น้ำริด',
        name: {
          th: 'น้ำริด',
          en: 'Nam Rit',
        },
        districtId: 616,
      },
      {
        id: '530109',
        zipcode: 53000,
        text: 'งิ้วงาม',
        value: 'งิ้วงาม',
        name: {
          th: 'งิ้วงาม',
          en: 'Ngio Ngam',
        },
        districtId: 616,
      },
      {
        id: '530110',
        zipcode: 53000,
        text: 'บ้านด่านนาขาม',
        value: 'บ้านด่านนาขาม',
        name: {
          th: 'บ้านด่านนาขาม',
          en: 'Ban Dan Na Kham',
        },
        districtId: 616,
      },
      {
        id: '530111',
        zipcode: 53000,
        text: 'บ้านด่าน',
        value: 'บ้านด่าน',
        name: {
          th: 'บ้านด่าน',
          en: 'Ban Dan',
        },
        districtId: 616,
      },
      {
        id: '530112',
        zipcode: 53000,
        text: 'ผาจุก',
        value: 'ผาจุก',
        name: {
          th: 'ผาจุก',
          en: 'Pha Chuk',
        },
        districtId: 616,
      },
      {
        id: '530113',
        zipcode: 53000,
        text: 'วังดิน',
        value: 'วังดิน',
        name: {
          th: 'วังดิน',
          en: 'Wang Din',
        },
        districtId: 616,
      },
      {
        id: '530114',
        zipcode: 53000,
        text: 'แสนตอ',
        value: 'แสนตอ',
        name: {
          th: 'แสนตอ',
          en: 'Saen To',
        },
        districtId: 616,
      },
      {
        id: '530115',
        zipcode: 53000,
        text: 'หาดงิ้ว',
        value: 'หาดงิ้ว',
        name: {
          th: 'หาดงิ้ว',
          en: 'Hat Ngio',
        },
        districtId: 616,
      },
      {
        id: '530116',
        zipcode: 53000,
        text: 'ขุนฝาง',
        value: 'ขุนฝาง',
        name: {
          th: 'ขุนฝาง',
          en: 'Khun Fang',
        },
        districtId: 616,
      },
      {
        id: '530117',
        zipcode: 53000,
        text: 'ถ้ำฉลอง',
        value: 'ถ้ำฉลอง',
        name: {
          th: 'ถ้ำฉลอง',
          en: 'Tham Chalong',
        },
        districtId: 616,
      },
      {
        id: '530201',
        zipcode: 53140,
        text: 'วังแดง',
        value: 'วังแดง',
        name: {
          th: 'วังแดง',
          en: 'Wang Daeng',
        },
        districtId: 617,
      },
      {
        id: '530202',
        zipcode: 53140,
        text: 'บ้านแก่ง',
        value: 'บ้านแก่ง',
        name: {
          th: 'บ้านแก่ง',
          en: 'Ban Kaeng',
        },
        districtId: 617,
      },
      {
        id: '530203',
        zipcode: 53140,
        text: 'หาดสองแคว',
        value: 'หาดสองแคว',
        name: {
          th: 'หาดสองแคว',
          en: 'Hat Song Khwae',
        },
        districtId: 617,
      },
      {
        id: '530204',
        zipcode: 53140,
        text: 'น้ำอ่าง',
        value: 'น้ำอ่าง',
        name: {
          th: 'น้ำอ่าง',
          en: 'Nam Ang',
        },
        districtId: 617,
      },
      {
        id: '530205',
        zipcode: 53140,
        text: 'ข่อยสูง',
        value: 'ข่อยสูง',
        name: {
          th: 'ข่อยสูง',
          en: 'Khoi Sung',
        },
        districtId: 617,
      },
      {
        id: '530301',
        zipcode: 53150,
        text: 'ท่าปลา',
        value: 'ท่าปลา',
        name: {
          th: 'ท่าปลา',
          en: 'Tha Pla',
        },
        districtId: 618,
      },
      {
        id: '530302',
        zipcode: 53150,
        text: 'หาดล้า',
        value: 'หาดล้า',
        name: {
          th: 'หาดล้า',
          en: 'Hat La',
        },
        districtId: 618,
      },
      {
        id: '530303',
        zipcode: 53190,
        text: 'ผาเลือด',
        value: 'ผาเลือด',
        name: {
          th: 'ผาเลือด',
          en: 'Pha Lueat',
        },
        districtId: 618,
      },
      {
        id: '530304',
        zipcode: 53150,
        text: 'จริม',
        value: 'จริม',
        name: {
          th: 'จริม',
          en: 'Charim',
        },
        districtId: 618,
      },
      {
        id: '530305',
        zipcode: 53150,
        text: 'น้ำหมัน',
        value: 'น้ำหมัน',
        name: {
          th: 'น้ำหมัน',
          en: 'Nam Man',
        },
        districtId: 618,
      },
      {
        id: '530306',
        zipcode: 53110,
        text: 'ท่าแฝก',
        value: 'ท่าแฝก',
        name: {
          th: 'ท่าแฝก',
          en: 'Tha Faek',
        },
        districtId: 618,
      },
      {
        id: '530307',
        zipcode: 53150,
        text: 'นางพญา',
        value: 'นางพญา',
        name: {
          th: 'นางพญา',
          en: 'Nang Phaya',
        },
        districtId: 618,
      },
      {
        id: '530308',
        zipcode: 53190,
        text: 'ร่วมจิต',
        value: 'ร่วมจิต',
        name: {
          th: 'ร่วมจิต',
          en: 'Ruam Chit',
        },
        districtId: 618,
      },
      {
        id: '530401',
        zipcode: 53110,
        text: 'แสนตอ',
        value: 'แสนตอ',
        name: {
          th: 'แสนตอ',
          en: 'Saen To',
        },
        districtId: 619,
      },
      {
        id: '530402',
        zipcode: 53110,
        text: 'บ้านฝาย',
        value: 'บ้านฝาย',
        name: {
          th: 'บ้านฝาย',
          en: 'Ban Fai',
        },
        districtId: 619,
      },
      {
        id: '530403',
        zipcode: 53110,
        text: 'เด่นเหล็ก',
        value: 'เด่นเหล็ก',
        name: {
          th: 'เด่นเหล็ก',
          en: 'Den Lek',
        },
        districtId: 619,
      },
      {
        id: '530404',
        zipcode: 53110,
        text: 'น้ำไคร้',
        value: 'น้ำไคร้',
        name: {
          th: 'น้ำไคร้',
          en: 'Nam Khrai',
        },
        districtId: 619,
      },
      {
        id: '530405',
        zipcode: 53110,
        text: 'น้ำไผ่',
        value: 'น้ำไผ่',
        name: {
          th: 'น้ำไผ่',
          en: 'Nam Phai',
        },
        districtId: 619,
      },
      {
        id: '530406',
        zipcode: 53110,
        text: 'ห้วยมุ่น',
        value: 'ห้วยมุ่น',
        name: {
          th: 'ห้วยมุ่น',
          en: 'Huai Mun',
        },
        districtId: 619,
      },
      {
        id: '530501',
        zipcode: 53160,
        text: 'ฟากท่า',
        value: 'ฟากท่า',
        name: {
          th: 'ฟากท่า',
          en: 'Fak Tha',
        },
        districtId: 620,
      },
      {
        id: '530502',
        zipcode: 53160,
        text: 'สองคอน',
        value: 'สองคอน',
        name: {
          th: 'สองคอน',
          en: 'Song Khon',
        },
        districtId: 620,
      },
      {
        id: '530503',
        zipcode: 53160,
        text: 'บ้านเสี้ยว',
        value: 'บ้านเสี้ยว',
        name: {
          th: 'บ้านเสี้ยว',
          en: 'Ban Siao',
        },
        districtId: 620,
      },
      {
        id: '530504',
        zipcode: 53160,
        text: 'สองห้อง',
        value: 'สองห้อง',
        name: {
          th: 'สองห้อง',
          en: 'Song Hong',
        },
        districtId: 620,
      },
      {
        id: '530601',
        zipcode: 53180,
        text: 'ม่วงเจ็ดต้น',
        value: 'ม่วงเจ็ดต้น',
        name: {
          th: 'ม่วงเจ็ดต้น',
          en: 'Muang Chet Ton',
        },
        districtId: 621,
      },
      {
        id: '530602',
        zipcode: 53180,
        text: 'บ้านโคก',
        value: 'บ้านโคก',
        name: {
          th: 'บ้านโคก',
          en: 'Ban Khok',
        },
        districtId: 621,
      },
      {
        id: '530603',
        zipcode: 53180,
        text: 'นาขุม',
        value: 'นาขุม',
        name: {
          th: 'นาขุม',
          en: 'Na Khum',
        },
        districtId: 621,
      },
      {
        id: '530604',
        zipcode: 53180,
        text: 'บ่อเบี้ย',
        value: 'บ่อเบี้ย',
        name: {
          th: 'บ่อเบี้ย',
          en: 'Bo Bia',
        },
        districtId: 621,
      },
      {
        id: '530701',
        zipcode: 53120,
        text: 'ในเมือง',
        value: 'ในเมือง',
        name: {
          th: 'ในเมือง',
          en: 'Nai Mueang',
        },
        districtId: 622,
      },
      {
        id: '530702',
        zipcode: 53220,
        text: 'บ้านดารา',
        value: 'บ้านดารา',
        name: {
          th: 'บ้านดารา',
          en: 'Ban Dara',
        },
        districtId: 622,
      },
      {
        id: '530703',
        zipcode: 53120,
        text: 'ไร่อ้อย',
        value: 'ไร่อ้อย',
        name: {
          th: 'ไร่อ้อย',
          en: 'Rai Oi',
        },
        districtId: 622,
      },
      {
        id: '530704',
        zipcode: 53220,
        text: 'ท่าสัก',
        value: 'ท่าสัก',
        name: {
          th: 'ท่าสัก',
          en: 'Tha Sak',
        },
        districtId: 622,
      },
      {
        id: '530705',
        zipcode: 53120,
        text: 'คอรุม',
        value: 'คอรุม',
        name: {
          th: 'คอรุม',
          en: 'Kho Rum',
        },
        districtId: 622,
      },
      {
        id: '530706',
        zipcode: 53120,
        text: 'บ้านหม้อ',
        value: 'บ้านหม้อ',
        name: {
          th: 'บ้านหม้อ',
          en: 'Ban Mo',
        },
        districtId: 622,
      },
      {
        id: '530707',
        zipcode: 53120,
        text: 'ท่ามะเฟือง',
        value: 'ท่ามะเฟือง',
        name: {
          th: 'ท่ามะเฟือง',
          en: 'Tha Mafueang',
        },
        districtId: 622,
      },
      {
        id: '530708',
        zipcode: 53120,
        text: 'บ้านโคน',
        value: 'บ้านโคน',
        name: {
          th: 'บ้านโคน',
          en: 'Ban Khon',
        },
        districtId: 622,
      },
      {
        id: '530709',
        zipcode: 53120,
        text: 'พญาแมน',
        value: 'พญาแมน',
        name: {
          th: 'พญาแมน',
          en: 'Phaya Maen',
        },
        districtId: 622,
      },
      {
        id: '530710',
        zipcode: 53120,
        text: 'นาอิน',
        value: 'นาอิน',
        name: {
          th: 'นาอิน',
          en: 'Na In',
        },
        districtId: 622,
      },
      {
        id: '530711',
        zipcode: 53120,
        text: 'นายาง',
        value: 'นายาง',
        name: {
          th: 'นายาง',
          en: 'Na Yang',
        },
        districtId: 622,
      },
      {
        id: '530801',
        zipcode: 53130,
        text: 'ศรีพนมมาศ',
        value: 'ศรีพนมมาศ',
        name: {
          th: 'ศรีพนมมาศ',
          en: 'Si Phanom Mat',
        },
        districtId: 623,
      },
      {
        id: '530802',
        zipcode: 53130,
        text: 'แม่พูล',
        value: 'แม่พูล',
        name: {
          th: 'แม่พูล',
          en: 'Mae Phun',
        },
        districtId: 623,
      },
      {
        id: '530803',
        zipcode: 53130,
        text: 'นานกกก',
        value: 'นานกกก',
        name: {
          th: 'นานกกก',
          en: 'Na Nok Kok',
        },
        districtId: 623,
      },
      {
        id: '530804',
        zipcode: 53130,
        text: 'ฝายหลวง',
        value: 'ฝายหลวง',
        name: {
          th: 'ฝายหลวง',
          en: 'Fai Luang',
        },
        districtId: 623,
      },
      {
        id: '530805',
        zipcode: 53130,
        text: 'ชัยจุมพล',
        value: 'ชัยจุมพล',
        name: {
          th: 'ชัยจุมพล',
          en: 'Chai Chumphon',
        },
        districtId: 623,
      },
      {
        id: '530806',
        zipcode: 53210,
        text: 'ไผ่ล้อม',
        value: 'ไผ่ล้อม',
        name: {
          th: 'ไผ่ล้อม',
          en: 'Phai Lom',
        },
        districtId: 623,
      },
      {
        id: '530807',
        zipcode: 53210,
        text: 'ทุ่งยั้ง',
        value: 'ทุ่งยั้ง',
        name: {
          th: 'ทุ่งยั้ง',
          en: 'Thung Yang',
        },
        districtId: 623,
      },
      {
        id: '530808',
        zipcode: 53210,
        text: 'ด่านแม่คำมัน',
        value: 'ด่านแม่คำมัน',
        name: {
          th: 'ด่านแม่คำมัน',
          en: 'Dan Mae Kham Man',
        },
        districtId: 623,
      },
      {
        id: '530901',
        zipcode: 53230,
        text: 'ผักขวง',
        value: 'ผักขวง',
        name: {
          th: 'ผักขวง',
          en: 'Phak Khuang',
        },
        districtId: 624,
      },
      {
        id: '530902',
        zipcode: 53230,
        text: 'บ่อทอง',
        value: 'บ่อทอง',
        name: {
          th: 'บ่อทอง',
          en: 'Bo Thong',
        },
        districtId: 624,
      },
      {
        id: '530903',
        zipcode: 53230,
        text: 'ป่าคาย',
        value: 'ป่าคาย',
        name: {
          th: 'ป่าคาย',
          en: 'Pa Khai',
        },
        districtId: 624,
      },
      {
        id: '530904',
        zipcode: 53230,
        text: 'น้ำพี้',
        value: 'น้ำพี้',
        name: {
          th: 'น้ำพี้',
          en: 'Nam Phi',
        },
        districtId: 624,
      },
      {
        id: '540101',
        zipcode: 54000,
        text: 'ในเวียง',
        value: 'ในเวียง',
        name: {
          th: 'ในเวียง',
          en: 'Nai Wiang',
        },
        districtId: 625,
      },
      {
        id: '540102',
        zipcode: 54000,
        text: 'นาจักร',
        value: 'นาจักร',
        name: {
          th: 'นาจักร',
          en: 'Na Chak',
        },
        districtId: 625,
      },
      {
        id: '540103',
        zipcode: 54000,
        text: 'น้ำชำ',
        value: 'น้ำชำ',
        name: {
          th: 'น้ำชำ',
          en: 'Nam Cham',
        },
        districtId: 625,
      },
      {
        id: '540104',
        zipcode: 54000,
        text: 'ป่าแดง',
        value: 'ป่าแดง',
        name: {
          th: 'ป่าแดง',
          en: 'Pa Daeng',
        },
        districtId: 625,
      },
      {
        id: '540105',
        zipcode: 54000,
        text: 'ทุ่งโฮ้ง',
        value: 'ทุ่งโฮ้ง',
        name: {
          th: 'ทุ่งโฮ้ง',
          en: 'Thung Hong',
        },
        districtId: 625,
      },
      {
        id: '540106',
        zipcode: 54000,
        text: 'เหมืองหม้อ',
        value: 'เหมืองหม้อ',
        name: {
          th: 'เหมืองหม้อ',
          en: 'Mueang Mo',
        },
        districtId: 625,
      },
      {
        id: '540107',
        zipcode: 54000,
        text: 'วังธง',
        value: 'วังธง',
        name: {
          th: 'วังธง',
          en: 'Wang Thong',
        },
        districtId: 625,
      },
      {
        id: '540108',
        zipcode: 54000,
        text: 'แม่หล่าย',
        value: 'แม่หล่าย',
        name: {
          th: 'แม่หล่าย',
          en: 'Mae Lai',
        },
        districtId: 625,
      },
      {
        id: '540109',
        zipcode: 54000,
        text: 'ห้วยม้า',
        value: 'ห้วยม้า',
        name: {
          th: 'ห้วยม้า',
          en: 'Huai Ma',
        },
        districtId: 625,
      },
      {
        id: '540110',
        zipcode: 54000,
        text: 'ป่าแมต',
        value: 'ป่าแมต',
        name: {
          th: 'ป่าแมต',
          en: 'Pa Maet',
        },
        districtId: 625,
      },
      {
        id: '540111',
        zipcode: 54000,
        text: 'บ้านถิ่น',
        value: 'บ้านถิ่น',
        name: {
          th: 'บ้านถิ่น',
          en: 'Ban Thin',
        },
        districtId: 625,
      },
      {
        id: '540112',
        zipcode: 54000,
        text: 'สวนเขื่อน',
        value: 'สวนเขื่อน',
        name: {
          th: 'สวนเขื่อน',
          en: 'Suan Khuean',
        },
        districtId: 625,
      },
      {
        id: '540113',
        zipcode: 54000,
        text: 'วังหงส์',
        value: 'วังหงส์',
        name: {
          th: 'วังหงส์',
          en: 'Wang Hong',
        },
        districtId: 625,
      },
      {
        id: '540114',
        zipcode: 54000,
        text: 'แม่คำมี',
        value: 'แม่คำมี',
        name: {
          th: 'แม่คำมี',
          en: 'Mae Kham Mi',
        },
        districtId: 625,
      },
      {
        id: '540115',
        zipcode: 54000,
        text: 'ทุ่งกวาว',
        value: 'ทุ่งกวาว',
        name: {
          th: 'ทุ่งกวาว',
          en: 'Thung Kwao',
        },
        districtId: 625,
      },
      {
        id: '540116',
        zipcode: 54000,
        text: 'ท่าข้าม',
        value: 'ท่าข้าม',
        name: {
          th: 'ท่าข้าม',
          en: 'Tha Kham',
        },
        districtId: 625,
      },
      {
        id: '540117',
        zipcode: 54000,
        text: 'แม่ยม',
        value: 'แม่ยม',
        name: {
          th: 'แม่ยม',
          en: 'Mae Yom',
        },
        districtId: 625,
      },
      {
        id: '540118',
        zipcode: 54000,
        text: 'ช่อแฮ',
        value: 'ช่อแฮ',
        name: {
          th: 'ช่อแฮ',
          en: 'Cho Hae',
        },
        districtId: 625,
      },
      {
        id: '540119',
        zipcode: 54000,
        text: 'ร่องฟอง',
        value: 'ร่องฟอง',
        name: {
          th: 'ร่องฟอง',
          en: 'Rong Fong',
        },
        districtId: 625,
      },
      {
        id: '540120',
        zipcode: 54000,
        text: 'กาญจนา',
        value: 'กาญจนา',
        name: {
          th: 'กาญจนา',
          en: 'Kanchana',
        },
        districtId: 625,
      },
      {
        id: '540201',
        zipcode: 54140,
        text: 'ร้องกวาง',
        value: 'ร้องกวาง',
        name: {
          th: 'ร้องกวาง',
          en: 'Rong Kwang',
        },
        districtId: 626,
      },
      {
        id: '540204',
        zipcode: 54140,
        text: 'ร้องเข็ม',
        value: 'ร้องเข็ม',
        name: {
          th: 'ร้องเข็ม',
          en: 'Rong Khem',
        },
        districtId: 626,
      },
      {
        id: '540205',
        zipcode: 54140,
        text: 'น้ำเลา',
        value: 'น้ำเลา',
        name: {
          th: 'น้ำเลา',
          en: 'Nam Lao',
        },
        districtId: 626,
      },
      {
        id: '540206',
        zipcode: 54140,
        text: 'บ้านเวียง',
        value: 'บ้านเวียง',
        name: {
          th: 'บ้านเวียง',
          en: 'Ban Wiang',
        },
        districtId: 626,
      },
      {
        id: '540207',
        zipcode: 54140,
        text: 'ทุ่งศรี',
        value: 'ทุ่งศรี',
        name: {
          th: 'ทุ่งศรี',
          en: 'Thung Si',
        },
        districtId: 626,
      },
      {
        id: '540208',
        zipcode: 54140,
        text: 'แม่ยางตาล',
        value: 'แม่ยางตาล',
        name: {
          th: 'แม่ยางตาล',
          en: 'Mae Yang Tan',
        },
        districtId: 626,
      },
      {
        id: '540209',
        zipcode: 54140,
        text: 'แม่ยางฮ่อ',
        value: 'แม่ยางฮ่อ',
        name: {
          th: 'แม่ยางฮ่อ',
          en: 'Mae Yang Ho',
        },
        districtId: 626,
      },
      {
        id: '540210',
        zipcode: 54140,
        text: 'ไผ่โทน',
        value: 'ไผ่โทน',
        name: {
          th: 'ไผ่โทน',
          en: 'Phai Thon',
        },
        districtId: 626,
      },
      {
        id: '540213',
        zipcode: 54140,
        text: 'ห้วยโรง',
        value: 'ห้วยโรง',
        name: {
          th: 'ห้วยโรง',
          en: 'Huai Rong',
        },
        districtId: 626,
      },
      {
        id: '540214',
        zipcode: 54140,
        text: 'แม่ทราย',
        value: 'แม่ทราย',
        name: {
          th: 'แม่ทราย',
          en: 'Mae Sai',
        },
        districtId: 626,
      },
      {
        id: '540215',
        zipcode: 54140,
        text: 'แม่ยางร้อง',
        value: 'แม่ยางร้อง',
        name: {
          th: 'แม่ยางร้อง',
          en: 'Mae Yang Rong',
        },
        districtId: 626,
      },
      {
        id: '540301',
        zipcode: 54150,
        text: 'ห้วยอ้อ',
        value: 'ห้วยอ้อ',
        name: {
          th: 'ห้วยอ้อ',
          en: 'Huai O',
        },
        districtId: 627,
      },
      {
        id: '540302',
        zipcode: 54150,
        text: 'บ้านปิน',
        value: 'บ้านปิน',
        name: {
          th: 'บ้านปิน',
          en: 'Ban Pin',
        },
        districtId: 627,
      },
      {
        id: '540303',
        zipcode: 54150,
        text: 'ต้าผามอก',
        value: 'ต้าผามอก',
        name: {
          th: 'ต้าผามอก',
          en: 'Ta Pha Mok',
        },
        districtId: 627,
      },
      {
        id: '540304',
        zipcode: 54150,
        text: 'เวียงต้า',
        value: 'เวียงต้า',
        name: {
          th: 'เวียงต้า',
          en: 'Wiang Ta',
        },
        districtId: 627,
      },
      {
        id: '540305',
        zipcode: 54150,
        text: 'ปากกาง',
        value: 'ปากกาง',
        name: {
          th: 'ปากกาง',
          en: 'Pak Kang',
        },
        districtId: 627,
      },
      {
        id: '540306',
        zipcode: 54150,
        text: 'หัวทุ่ง',
        value: 'หัวทุ่ง',
        name: {
          th: 'หัวทุ่ง',
          en: 'Hua Thung',
        },
        districtId: 627,
      },
      {
        id: '540307',
        zipcode: 54150,
        text: 'ทุ่งแล้ง',
        value: 'ทุ่งแล้ง',
        name: {
          th: 'ทุ่งแล้ง',
          en: 'Thung Laeng',
        },
        districtId: 627,
      },
      {
        id: '540308',
        zipcode: 54150,
        text: 'บ่อเหล็กลอง',
        value: 'บ่อเหล็กลอง',
        name: {
          th: 'บ่อเหล็กลอง',
          en: 'Bo Lek Long',
        },
        districtId: 627,
      },
      {
        id: '540309',
        zipcode: 54150,
        text: 'แม่ปาน',
        value: 'แม่ปาน',
        name: {
          th: 'แม่ปาน',
          en: 'Mae Pan',
        },
        districtId: 627,
      },
      {
        id: '540401',
        zipcode: 54130,
        text: 'สูงเม่น',
        value: 'สูงเม่น',
        name: {
          th: 'สูงเม่น',
          en: 'Sung Men',
        },
        districtId: 628,
      },
      {
        id: '540402',
        zipcode: 54130,
        text: 'น้ำชำ',
        value: 'น้ำชำ',
        name: {
          th: 'น้ำชำ',
          en: 'Nam Cham',
        },
        districtId: 628,
      },
      {
        id: '540403',
        zipcode: 54130,
        text: 'หัวฝาย',
        value: 'หัวฝาย',
        name: {
          th: 'หัวฝาย',
          en: 'Hua Fai',
        },
        districtId: 628,
      },
      {
        id: '540404',
        zipcode: 54130,
        text: 'ดอนมูล',
        value: 'ดอนมูล',
        name: {
          th: 'ดอนมูล',
          en: 'Don Mun',
        },
        districtId: 628,
      },
      {
        id: '540405',
        zipcode: 54130,
        text: 'บ้านเหล่า',
        value: 'บ้านเหล่า',
        name: {
          th: 'บ้านเหล่า',
          en: 'Ban Lao',
        },
        districtId: 628,
      },
      {
        id: '540406',
        zipcode: 54130,
        text: 'บ้านกวาง',
        value: 'บ้านกวาง',
        name: {
          th: 'บ้านกวาง',
          en: 'Ban Kwang',
        },
        districtId: 628,
      },
      {
        id: '540407',
        zipcode: 54130,
        text: 'บ้านปง',
        value: 'บ้านปง',
        name: {
          th: 'บ้านปง',
          en: 'Ban Pong',
        },
        districtId: 628,
      },
      {
        id: '540408',
        zipcode: 54130,
        text: 'บ้านกาศ',
        value: 'บ้านกาศ',
        name: {
          th: 'บ้านกาศ',
          en: 'Ban Kat',
        },
        districtId: 628,
      },
      {
        id: '540409',
        zipcode: 54130,
        text: 'ร่องกาศ',
        value: 'ร่องกาศ',
        name: {
          th: 'ร่องกาศ',
          en: 'Rong Kat',
        },
        districtId: 628,
      },
      {
        id: '540410',
        zipcode: 54130,
        text: 'สบสาย',
        value: 'สบสาย',
        name: {
          th: 'สบสาย',
          en: 'Sop Sai',
        },
        districtId: 628,
      },
      {
        id: '540411',
        zipcode: 54000,
        text: 'เวียงทอง',
        value: 'เวียงทอง',
        name: {
          th: 'เวียงทอง',
          en: 'Wiang Thong',
        },
        districtId: 628,
      },
      {
        id: '540412',
        zipcode: 54130,
        text: 'พระหลวง',
        value: 'พระหลวง',
        name: {
          th: 'พระหลวง',
          en: 'Phra Luang',
        },
        districtId: 628,
      },
      {
        id: '540501',
        zipcode: 54110,
        text: 'เด่นชัย',
        value: 'เด่นชัย',
        name: {
          th: 'เด่นชัย',
          en: 'Den Chai',
        },
        districtId: 629,
      },
      {
        id: '540502',
        zipcode: 54110,
        text: 'แม่จั๊วะ',
        value: 'แม่จั๊วะ',
        name: {
          th: 'แม่จั๊วะ',
          en: 'Mae Chua',
        },
        districtId: 629,
      },
      {
        id: '540503',
        zipcode: 54110,
        text: 'ไทรย้อย',
        value: 'ไทรย้อย',
        name: {
          th: 'ไทรย้อย',
          en: 'Sai Yoi',
        },
        districtId: 629,
      },
      {
        id: '540504',
        zipcode: 54110,
        text: 'ห้วยไร่',
        value: 'ห้วยไร่',
        name: {
          th: 'ห้วยไร่',
          en: 'Huai Rai',
        },
        districtId: 629,
      },
      {
        id: '540505',
        zipcode: 54110,
        text: 'ปงป่าหวาย',
        value: 'ปงป่าหวาย',
        name: {
          th: 'ปงป่าหวาย',
          en: 'Pong Pa Wai',
        },
        districtId: 629,
      },
      {
        id: '540601',
        zipcode: 54120,
        text: 'บ้านหนุน',
        value: 'บ้านหนุน',
        name: {
          th: 'บ้านหนุน',
          en: 'Ban Nun',
        },
        districtId: 630,
      },
      {
        id: '540602',
        zipcode: 54120,
        text: 'บ้านกลาง',
        value: 'บ้านกลาง',
        name: {
          th: 'บ้านกลาง',
          en: 'Ban Klang',
        },
        districtId: 630,
      },
      {
        id: '540603',
        zipcode: 54120,
        text: 'ห้วยหม้าย',
        value: 'ห้วยหม้าย',
        name: {
          th: 'ห้วยหม้าย',
          en: 'Huai Mai',
        },
        districtId: 630,
      },
      {
        id: '540604',
        zipcode: 54120,
        text: 'เตาปูน',
        value: 'เตาปูน',
        name: {
          th: 'เตาปูน',
          en: 'Tao Pun',
        },
        districtId: 630,
      },
      {
        id: '540605',
        zipcode: 54120,
        text: 'หัวเมือง',
        value: 'หัวเมือง',
        name: {
          th: 'หัวเมือง',
          en: 'Hua Mueang',
        },
        districtId: 630,
      },
      {
        id: '540606',
        zipcode: 54120,
        text: 'สะเอียบ',
        value: 'สะเอียบ',
        name: {
          th: 'สะเอียบ',
          en: 'Sa-iap',
        },
        districtId: 630,
      },
      {
        id: '540607',
        zipcode: 54120,
        text: 'แดนชุมพล',
        value: 'แดนชุมพล',
        name: {
          th: 'แดนชุมพล',
          en: 'Daen Chumphon',
        },
        districtId: 630,
      },
      {
        id: '540608',
        zipcode: 54120,
        text: 'ทุ่งน้าว',
        value: 'ทุ่งน้าว',
        name: {
          th: 'ทุ่งน้าว',
          en: 'Thung Nao',
        },
        districtId: 630,
      },
      {
        id: '540701',
        zipcode: 54160,
        text: 'วังชิ้น',
        value: 'วังชิ้น',
        name: {
          th: 'วังชิ้น',
          en: 'Wang Chin',
        },
        districtId: 631,
      },
      {
        id: '540702',
        zipcode: 54160,
        text: 'สรอย',
        value: 'สรอย',
        name: {
          th: 'สรอย',
          en: 'Saroi',
        },
        districtId: 631,
      },
      {
        id: '540703',
        zipcode: 54160,
        text: 'แม่ป้าก',
        value: 'แม่ป้าก',
        name: {
          th: 'แม่ป้าก',
          en: 'Mae Pak',
        },
        districtId: 631,
      },
      {
        id: '540704',
        zipcode: 54160,
        text: 'นาพูน',
        value: 'นาพูน',
        name: {
          th: 'นาพูน',
          en: 'Na Phun',
        },
        districtId: 631,
      },
      {
        id: '540705',
        zipcode: 54160,
        text: 'แม่พุง',
        value: 'แม่พุง',
        name: {
          th: 'แม่พุง',
          en: 'Mae Phung',
        },
        districtId: 631,
      },
      {
        id: '540706',
        zipcode: 54160,
        text: 'ป่าสัก',
        value: 'ป่าสัก',
        name: {
          th: 'ป่าสัก',
          en: 'Pa Sak',
        },
        districtId: 631,
      },
      {
        id: '540707',
        zipcode: 54160,
        text: 'แม่เกิ๋ง',
        value: 'แม่เกิ๋ง',
        name: {
          th: 'แม่เกิ๋ง',
          en: 'Mae Koeng',
        },
        districtId: 631,
      },
      {
        id: '540801',
        zipcode: 54170,
        text: 'แม่คำมี',
        value: 'แม่คำมี',
        name: {
          th: 'แม่คำมี',
          en: 'Mae Kham Mi',
        },
        districtId: 632,
      },
      {
        id: '540802',
        zipcode: 54170,
        text: 'หนองม่วงไข่',
        value: 'หนองม่วงไข่',
        name: {
          th: 'หนองม่วงไข่',
          en: 'Nong Muang Khai',
        },
        districtId: 632,
      },
      {
        id: '540803',
        zipcode: 54170,
        text: 'น้ำรัด',
        value: 'น้ำรัด',
        name: {
          th: 'น้ำรัด',
          en: 'Nam Rat',
        },
        districtId: 632,
      },
      {
        id: '540804',
        zipcode: 54170,
        text: 'วังหลวง',
        value: 'วังหลวง',
        name: {
          th: 'วังหลวง',
          en: 'Wang Luang',
        },
        districtId: 632,
      },
      {
        id: '540805',
        zipcode: 54170,
        text: 'ตำหนักธรรม',
        value: 'ตำหนักธรรม',
        name: {
          th: 'ตำหนักธรรม',
          en: 'Tamnak Tham',
        },
        districtId: 632,
      },
      {
        id: '540806',
        zipcode: 54170,
        text: 'ทุ่งแค้ว',
        value: 'ทุ่งแค้ว',
        name: {
          th: 'ทุ่งแค้ว',
          en: 'Thung Khaeo',
        },
        districtId: 632,
      },
      {
        id: '550101',
        zipcode: 55000,
        text: 'ในเวียง',
        value: 'ในเวียง',
        name: {
          th: 'ในเวียง',
          en: 'Nai Wiang',
        },
        districtId: 633,
      },
      {
        id: '550102',
        zipcode: 55000,
        text: 'บ่อ',
        value: 'บ่อ',
        name: {
          th: 'บ่อ',
          en: 'Bo',
        },
        districtId: 633,
      },
      {
        id: '550103',
        zipcode: 55000,
        text: 'ผาสิงห์',
        value: 'ผาสิงห์',
        name: {
          th: 'ผาสิงห์',
          en: 'Pha Sing',
        },
        districtId: 633,
      },
      {
        id: '550104',
        zipcode: 55000,
        text: 'ไชยสถาน',
        value: 'ไชยสถาน',
        name: {
          th: 'ไชยสถาน',
          en: 'Chai Sathan',
        },
        districtId: 633,
      },
      {
        id: '550105',
        zipcode: 55000,
        text: 'ถืมตอง',
        value: 'ถืมตอง',
        name: {
          th: 'ถืมตอง',
          en: 'Thuem Tong',
        },
        districtId: 633,
      },
      {
        id: '550106',
        zipcode: 55000,
        text: 'เรือง',
        value: 'เรือง',
        name: {
          th: 'เรือง',
          en: 'Rueang',
        },
        districtId: 633,
      },
      {
        id: '550107',
        zipcode: 55000,
        text: 'นาซาว',
        value: 'นาซาว',
        name: {
          th: 'นาซาว',
          en: 'Na Sao',
        },
        districtId: 633,
      },
      {
        id: '550108',
        zipcode: 55000,
        text: 'ดู่ใต้',
        value: 'ดู่ใต้',
        name: {
          th: 'ดู่ใต้',
          en: 'Du Tai',
        },
        districtId: 633,
      },
      {
        id: '550109',
        zipcode: 55000,
        text: 'กองควาย',
        value: 'กองควาย',
        name: {
          th: 'กองควาย',
          en: 'Kong Khwai',
        },
        districtId: 633,
      },
      {
        id: '550116',
        zipcode: 55000,
        text: 'สวก',
        value: 'สวก',
        name: {
          th: 'สวก',
          en: 'Suak',
        },
        districtId: 633,
      },
      {
        id: '550117',
        zipcode: 55000,
        text: 'สะเนียน',
        value: 'สะเนียน',
        name: {
          th: 'สะเนียน',
          en: 'Sanian',
        },
        districtId: 633,
      },
      {
        id: '550202',
        zipcode: 55170,
        text: 'หนองแดง',
        value: 'หนองแดง',
        name: {
          th: 'หนองแดง',
          en: 'Nong Daeng',
        },
        districtId: 634,
      },
      {
        id: '550203',
        zipcode: 55170,
        text: 'หมอเมือง',
        value: 'หมอเมือง',
        name: {
          th: 'หมอเมือง',
          en: 'Mo Mueang',
        },
        districtId: 634,
      },
      {
        id: '550204',
        zipcode: 55170,
        text: 'น้ำพาง',
        value: 'น้ำพาง',
        name: {
          th: 'น้ำพาง',
          en: 'Nam Phang',
        },
        districtId: 634,
      },
      {
        id: '550205',
        zipcode: 55170,
        text: 'น้ำปาย',
        value: 'น้ำปาย',
        name: {
          th: 'น้ำปาย',
          en: 'Nam Pai',
        },
        districtId: 634,
      },
      {
        id: '550206',
        zipcode: 55170,
        text: 'แม่จริม',
        value: 'แม่จริม',
        name: {
          th: 'แม่จริม',
          en: 'Mae Charim',
        },
        districtId: 634,
      },
      {
        id: '550301',
        zipcode: 55190,
        text: 'บ้านฟ้า',
        value: 'บ้านฟ้า',
        name: {
          th: 'บ้านฟ้า',
          en: 'Ban Fa',
        },
        districtId: 635,
      },
      {
        id: '550302',
        zipcode: 55190,
        text: 'ป่าคาหลวง',
        value: 'ป่าคาหลวง',
        name: {
          th: 'ป่าคาหลวง',
          en: 'Pa Kha Luang',
        },
        districtId: 635,
      },
      {
        id: '550303',
        zipcode: 55190,
        text: 'สวด',
        value: 'สวด',
        name: {
          th: 'สวด',
          en: 'Suat',
        },
        districtId: 635,
      },
      {
        id: '550304',
        zipcode: 55190,
        text: 'บ้านพี้',
        value: 'บ้านพี้',
        name: {
          th: 'บ้านพี้',
          en: 'Ban Phi',
        },
        districtId: 635,
      },
      {
        id: '550401',
        zipcode: 55150,
        text: 'นาน้อย',
        value: 'นาน้อย',
        name: {
          th: 'นาน้อย',
          en: 'Na Noi',
        },
        districtId: 636,
      },
      {
        id: '550402',
        zipcode: 55150,
        text: 'เชียงของ',
        value: 'เชียงของ',
        name: {
          th: 'เชียงของ',
          en: 'Chiang Khong',
        },
        districtId: 636,
      },
      {
        id: '550403',
        zipcode: 55150,
        text: 'ศรีษะเกษ',
        value: 'ศรีษะเกษ',
        name: {
          th: 'ศรีษะเกษ',
          en: 'Sisaket',
        },
        districtId: 636,
      },
      {
        id: '550404',
        zipcode: 55150,
        text: 'สถาน',
        value: 'สถาน',
        name: {
          th: 'สถาน',
          en: 'Sathan',
        },
        districtId: 636,
      },
      {
        id: '550405',
        zipcode: 55150,
        text: 'สันทะ',
        value: 'สันทะ',
        name: {
          th: 'สันทะ',
          en: 'Santha',
        },
        districtId: 636,
      },
      {
        id: '550406',
        zipcode: 55150,
        text: 'บัวใหญ่',
        value: 'บัวใหญ่',
        name: {
          th: 'บัวใหญ่',
          en: 'Bua Yai',
        },
        districtId: 636,
      },
      {
        id: '550407',
        zipcode: 55150,
        text: 'น้ำตก',
        value: 'น้ำตก',
        name: {
          th: 'น้ำตก',
          en: 'Nam Tok',
        },
        districtId: 636,
      },
      {
        id: '550501',
        zipcode: 55120,
        text: 'ปัว',
        value: 'ปัว',
        name: {
          th: 'ปัว',
          en: 'Pua',
        },
        districtId: 637,
      },
      {
        id: '550502',
        zipcode: 55120,
        text: 'แงง',
        value: 'แงง',
        name: {
          th: 'แงง',
          en: 'Ngaeng',
        },
        districtId: 637,
      },
      {
        id: '550503',
        zipcode: 55120,
        text: 'สถาน',
        value: 'สถาน',
        name: {
          th: 'สถาน',
          en: 'Sathan',
        },
        districtId: 637,
      },
      {
        id: '550504',
        zipcode: 55120,
        text: 'ศิลาแลง',
        value: 'ศิลาแลง',
        name: {
          th: 'ศิลาแลง',
          en: 'Sila Laeng',
        },
        districtId: 637,
      },
      {
        id: '550505',
        zipcode: 55120,
        text: 'ศิลาเพชร',
        value: 'ศิลาเพชร',
        name: {
          th: 'ศิลาเพชร',
          en: 'Sila Phet',
        },
        districtId: 637,
      },
      {
        id: '550506',
        zipcode: 55120,
        text: 'อวน',
        value: 'อวน',
        name: {
          th: 'อวน',
          en: 'Uan',
        },
        districtId: 637,
      },
      {
        id: '550509',
        zipcode: 55120,
        text: 'ไชยวัฒนา',
        value: 'ไชยวัฒนา',
        name: {
          th: 'ไชยวัฒนา',
          en: 'Chai Watthana',
        },
        districtId: 637,
      },
      {
        id: '550510',
        zipcode: 55120,
        text: 'เจดีย์ชัย',
        value: 'เจดีย์ชัย',
        name: {
          th: 'เจดีย์ชัย',
          en: 'Chedi Chai',
        },
        districtId: 637,
      },
      {
        id: '550511',
        zipcode: 55120,
        text: 'ภูคา',
        value: 'ภูคา',
        name: {
          th: 'ภูคา',
          en: 'Phu Kha',
        },
        districtId: 637,
      },
      {
        id: '550512',
        zipcode: 55120,
        text: 'สกาด',
        value: 'สกาด',
        name: {
          th: 'สกาด',
          en: 'Sakat',
        },
        districtId: 637,
      },
      {
        id: '550513',
        zipcode: 55120,
        text: 'ป่ากลาง',
        value: 'ป่ากลาง',
        name: {
          th: 'ป่ากลาง',
          en: 'Pa Klang',
        },
        districtId: 637,
      },
      {
        id: '550514',
        zipcode: 55120,
        text: 'วรนคร',
        value: 'วรนคร',
        name: {
          th: 'วรนคร',
          en: 'Woranakhon',
        },
        districtId: 637,
      },
      {
        id: '550601',
        zipcode: 55140,
        text: 'ริม',
        value: 'ริม',
        name: {
          th: 'ริม',
          en: 'Rim',
        },
        districtId: 638,
      },
      {
        id: '550602',
        zipcode: 55140,
        text: 'ป่าคา',
        value: 'ป่าคา',
        name: {
          th: 'ป่าคา',
          en: 'Pa Kha',
        },
        districtId: 638,
      },
      {
        id: '550603',
        zipcode: 55140,
        text: 'ผาตอ',
        value: 'ผาตอ',
        name: {
          th: 'ผาตอ',
          en: 'Pha To',
        },
        districtId: 638,
      },
      {
        id: '550604',
        zipcode: 55140,
        text: 'ยม',
        value: 'ยม',
        name: {
          th: 'ยม',
          en: 'Yom',
        },
        districtId: 638,
      },
      {
        id: '550605',
        zipcode: 55140,
        text: 'ตาลชุม',
        value: 'ตาลชุม',
        name: {
          th: 'ตาลชุม',
          en: 'Tan Chum',
        },
        districtId: 638,
      },
      {
        id: '550606',
        zipcode: 55140,
        text: 'ศรีภูมิ',
        value: 'ศรีภูมิ',
        name: {
          th: 'ศรีภูมิ',
          en: 'Si Phum',
        },
        districtId: 638,
      },
      {
        id: '550607',
        zipcode: 55140,
        text: 'จอมพระ',
        value: 'จอมพระ',
        name: {
          th: 'จอมพระ',
          en: 'Chom Phra',
        },
        districtId: 638,
      },
      {
        id: '550608',
        zipcode: 55140,
        text: 'แสนทอง',
        value: 'แสนทอง',
        name: {
          th: 'แสนทอง',
          en: 'Saen Thong',
        },
        districtId: 638,
      },
      {
        id: '550609',
        zipcode: 55140,
        text: 'ท่าวังผา',
        value: 'ท่าวังผา',
        name: {
          th: 'ท่าวังผา',
          en: 'Tha Wang Pha',
        },
        districtId: 638,
      },
      {
        id: '550610',
        zipcode: 55140,
        text: 'ผาทอง',
        value: 'ผาทอง',
        name: {
          th: 'ผาทอง',
          en: 'Pha Thong',
        },
        districtId: 638,
      },
      {
        id: '550701',
        zipcode: 55110,
        text: 'กลางเวียง',
        value: 'กลางเวียง',
        name: {
          th: 'กลางเวียง',
          en: 'Klang Wiang',
        },
        districtId: 639,
      },
      {
        id: '550702',
        zipcode: 55110,
        text: 'ขึ่ง',
        value: 'ขึ่ง',
        name: {
          th: 'ขึ่ง',
          en: 'Khueng',
        },
        districtId: 639,
      },
      {
        id: '550703',
        zipcode: 55110,
        text: 'ไหล่น่าน',
        value: 'ไหล่น่าน',
        name: {
          th: 'ไหล่น่าน',
          en: 'Lai Nan',
        },
        districtId: 639,
      },
      {
        id: '550704',
        zipcode: 55110,
        text: 'ตาลชุม',
        value: 'ตาลชุม',
        name: {
          th: 'ตาลชุม',
          en: 'Tan Chum',
        },
        districtId: 639,
      },
      {
        id: '550705',
        zipcode: 55110,
        text: 'นาเหลือง',
        value: 'นาเหลือง',
        name: {
          th: 'นาเหลือง',
          en: 'Na Lueang',
        },
        districtId: 639,
      },
      {
        id: '550706',
        zipcode: 55110,
        text: 'ส้าน',
        value: 'ส้าน',
        name: {
          th: 'ส้าน',
          en: 'San',
        },
        districtId: 639,
      },
      {
        id: '550707',
        zipcode: 55110,
        text: 'น้ำมวบ',
        value: 'น้ำมวบ',
        name: {
          th: 'น้ำมวบ',
          en: 'Nam Muap',
        },
        districtId: 639,
      },
      {
        id: '550708',
        zipcode: 55110,
        text: 'น้ำปั้ว',
        value: 'น้ำปั้ว',
        name: {
          th: 'น้ำปั้ว',
          en: 'Nam Pua',
        },
        districtId: 639,
      },
      {
        id: '550709',
        zipcode: 55110,
        text: 'ยาบหัวนา',
        value: 'ยาบหัวนา',
        name: {
          th: 'ยาบหัวนา',
          en: 'Yap Hua Na',
        },
        districtId: 639,
      },
      {
        id: '550710',
        zipcode: 55110,
        text: 'ปงสนุก',
        value: 'ปงสนุก',
        name: {
          th: 'ปงสนุก',
          en: 'Pong Sanuk',
        },
        districtId: 639,
      },
      {
        id: '550711',
        zipcode: 55110,
        text: 'อ่ายนาไลย',
        value: 'อ่ายนาไลย',
        name: {
          th: 'อ่ายนาไลย',
          en: 'Ai Na Lai',
        },
        districtId: 639,
      },
      {
        id: '550712',
        zipcode: 55110,
        text: 'ส้านนาหนองใหม่',
        value: 'ส้านนาหนองใหม่',
        name: {
          th: 'ส้านนาหนองใหม่',
          en: 'San Na Nong Mai',
        },
        districtId: 639,
      },
      {
        id: '550713',
        zipcode: 55110,
        text: 'แม่ขะนิง',
        value: 'แม่ขะนิง',
        name: {
          th: 'แม่ขะนิง',
          en: 'Mae Khaning',
        },
        districtId: 639,
      },
      {
        id: '550714',
        zipcode: 55110,
        text: 'แม่สาคร',
        value: 'แม่สาคร',
        name: {
          th: 'แม่สาคร',
          en: 'Mae Sakhon',
        },
        districtId: 639,
      },
      {
        id: '550715',
        zipcode: 55110,
        text: 'จอมจันทร์',
        value: 'จอมจันทร์',
        name: {
          th: 'จอมจันทร์',
          en: 'Chom Chan',
        },
        districtId: 639,
      },
      {
        id: '550716',
        zipcode: 55110,
        text: 'แม่สา',
        value: 'แม่สา',
        name: {
          th: 'แม่สา',
          en: 'Mae Sa',
        },
        districtId: 639,
      },
      {
        id: '550717',
        zipcode: 55110,
        text: 'ทุ่งศรีทอง',
        value: 'ทุ่งศรีทอง',
        name: {
          th: 'ทุ่งศรีทอง',
          en: 'Thung Si Thong',
        },
        districtId: 639,
      },
      {
        id: '550801',
        zipcode: 55130,
        text: 'ปอน',
        value: 'ปอน',
        name: {
          th: 'ปอน',
          en: 'Pon',
        },
        districtId: 640,
      },
      {
        id: '550802',
        zipcode: 55130,
        text: 'งอบ',
        value: 'งอบ',
        name: {
          th: 'งอบ',
          en: 'Ngop',
        },
        districtId: 640,
      },
      {
        id: '550803',
        zipcode: 55130,
        text: 'และ',
        value: 'และ',
        name: {
          th: 'และ',
          en: 'Lae',
        },
        districtId: 640,
      },
      {
        id: '550804',
        zipcode: 55130,
        text: 'ทุ่งช้าง',
        value: 'ทุ่งช้าง',
        name: {
          th: 'ทุ่งช้าง',
          en: 'Thung Chang',
        },
        districtId: 640,
      },
      {
        id: '550901',
        zipcode: 55160,
        text: 'เชียงกลาง',
        value: 'เชียงกลาง',
        name: {
          th: 'เชียงกลาง',
          en: 'Chiang Klang',
        },
        districtId: 641,
      },
      {
        id: '550902',
        zipcode: 55160,
        text: 'เปือ',
        value: 'เปือ',
        name: {
          th: 'เปือ',
          en: 'Puea',
        },
        districtId: 641,
      },
      {
        id: '550903',
        zipcode: 55160,
        text: 'เชียงคาน',
        value: 'เชียงคาน',
        name: {
          th: 'เชียงคาน',
          en: 'Chiang Khan',
        },
        districtId: 641,
      },
      {
        id: '550904',
        zipcode: 55160,
        text: 'พระธาตุ',
        value: 'พระธาตุ',
        name: {
          th: 'พระธาตุ',
          en: 'Phra That',
        },
        districtId: 641,
      },
      {
        id: '550908',
        zipcode: 55160,
        text: 'พญาแก้ว',
        value: 'พญาแก้ว',
        name: {
          th: 'พญาแก้ว',
          en: 'Phaya Kaeo',
        },
        districtId: 641,
      },
      {
        id: '550909',
        zipcode: 55160,
        text: 'พระพุทธบาท',
        value: 'พระพุทธบาท',
        name: {
          th: 'พระพุทธบาท',
          en: 'Phra Phutthabat',
        },
        districtId: 641,
      },
      {
        id: '551001',
        zipcode: 55180,
        text: 'นาทะนุง',
        value: 'นาทะนุง',
        name: {
          th: 'นาทะนุง',
          en: 'Na Thanung',
        },
        districtId: 642,
      },
      {
        id: '551002',
        zipcode: 55180,
        text: 'บ่อแก้ว',
        value: 'บ่อแก้ว',
        name: {
          th: 'บ่อแก้ว',
          en: 'Bo Kaeo',
        },
        districtId: 642,
      },
      {
        id: '551003',
        zipcode: 55180,
        text: 'เมืองลี',
        value: 'เมืองลี',
        name: {
          th: 'เมืองลี',
          en: 'Mueang Li',
        },
        districtId: 642,
      },
      {
        id: '551004',
        zipcode: 55180,
        text: 'ปิงหลวง',
        value: 'ปิงหลวง',
        name: {
          th: 'ปิงหลวง',
          en: 'Ping Luang',
        },
        districtId: 642,
      },
      {
        id: '551101',
        zipcode: 55210,
        text: 'ดู่พงษ์',
        value: 'ดู่พงษ์',
        name: {
          th: 'ดู่พงษ์',
          en: 'Du Phong',
        },
        districtId: 643,
      },
      {
        id: '551102',
        zipcode: 55210,
        text: 'ป่าแลวหลวง',
        value: 'ป่าแลวหลวง',
        name: {
          th: 'ป่าแลวหลวง',
          en: 'Pa Laeo Luang',
        },
        districtId: 643,
      },
      {
        id: '551103',
        zipcode: 55210,
        text: 'พงษ์',
        value: 'พงษ์',
        name: {
          th: 'พงษ์',
          en: 'Phong',
        },
        districtId: 643,
      },
      {
        id: '551201',
        zipcode: 55220,
        text: 'บ่อเกลือเหนือ',
        value: 'บ่อเกลือเหนือ',
        name: {
          th: 'บ่อเกลือเหนือ',
          en: 'Bo Kluea Nuea',
        },
        districtId: 644,
      },
      {
        id: '551202',
        zipcode: 55220,
        text: 'บ่อเกลือใต้',
        value: 'บ่อเกลือใต้',
        name: {
          th: 'บ่อเกลือใต้',
          en: 'Bo Kluea Tai',
        },
        districtId: 644,
      },
      {
        id: '551204',
        zipcode: 55220,
        text: 'ภูฟ้า',
        value: 'ภูฟ้า',
        name: {
          th: 'ภูฟ้า',
          en: 'Phu Fa',
        },
        districtId: 644,
      },
      {
        id: '551205',
        zipcode: 55220,
        text: 'ดงพญา',
        value: 'ดงพญา',
        name: {
          th: 'ดงพญา',
          en: 'Dong Phaya',
        },
        districtId: 644,
      },
      {
        id: '551301',
        zipcode: 55160,
        text: 'นาไร่หลวง',
        value: 'นาไร่หลวง',
        name: {
          th: 'นาไร่หลวง',
          en: 'Na Rai Luang',
        },
        districtId: 645,
      },
      {
        id: '551302',
        zipcode: 55160,
        text: 'ชนแดน',
        value: 'ชนแดน',
        name: {
          th: 'ชนแดน',
          en: 'Chon Daen',
        },
        districtId: 645,
      },
      {
        id: '551303',
        zipcode: 55160,
        text: 'ยอด',
        value: 'ยอด',
        name: {
          th: 'ยอด',
          en: 'Yot',
        },
        districtId: 645,
      },
      {
        id: '551401',
        zipcode: 55000,
        text: 'ม่วงตึ๊ด',
        value: 'ม่วงตึ๊ด',
        name: {
          th: 'ม่วงตึ๊ด',
          en: 'Muang Tuet',
        },
        districtId: 646,
      },
      {
        id: '551402',
        zipcode: 55000,
        text: 'นาปัง',
        value: 'นาปัง',
        name: {
          th: 'นาปัง',
          en: 'Na Pang',
        },
        districtId: 646,
      },
      {
        id: '551403',
        zipcode: 55000,
        text: 'น้ำแก่น',
        value: 'น้ำแก่น',
        name: {
          th: 'น้ำแก่น',
          en: 'Nam Kaen',
        },
        districtId: 646,
      },
      {
        id: '551404',
        zipcode: 55000,
        text: 'น้ำเกี๋ยน',
        value: 'น้ำเกี๋ยน',
        name: {
          th: 'น้ำเกี๋ยน',
          en: 'Nam Kian',
        },
        districtId: 646,
      },
      {
        id: '551405',
        zipcode: 55000,
        text: 'เมืองจัง',
        value: 'เมืองจัง',
        name: {
          th: 'เมืองจัง',
          en: 'Mueang Chang',
        },
        districtId: 646,
      },
      {
        id: '551406',
        zipcode: 55000,
        text: 'ท่าน้าว',
        value: 'ท่าน้าว',
        name: {
          th: 'ท่าน้าว',
          en: 'Tha Nao',
        },
        districtId: 646,
      },
      {
        id: '551407',
        zipcode: 55000,
        text: 'ฝายแก้ว',
        value: 'ฝายแก้ว',
        name: {
          th: 'ฝายแก้ว',
          en: 'Fai Kaeo',
        },
        districtId: 646,
      },
      {
        id: '551501',
        zipcode: 55130,
        text: 'ห้วยโก๋น',
        value: 'ห้วยโก๋น',
        name: {
          th: 'ห้วยโก๋น',
          en: 'Huai Kon',
        },
        districtId: 647,
      },
      {
        id: '551502',
        zipcode: 55130,
        text: 'ขุนน่าน',
        value: 'ขุนน่าน',
        name: {
          th: 'ขุนน่าน',
          en: 'Khun Nan',
        },
        districtId: 647,
      },
      {
        id: '560101',
        zipcode: 56000,
        text: 'เวียง',
        value: 'เวียง',
        name: {
          th: 'เวียง',
          en: 'Wiang',
        },
        districtId: 648,
      },
      {
        id: '560102',
        zipcode: 56000,
        text: 'แม่ต๋ำ',
        value: 'แม่ต๋ำ',
        name: {
          th: 'แม่ต๋ำ',
          en: 'Mae Tam',
        },
        districtId: 648,
      },
      {
        id: '560104',
        zipcode: 56000,
        text: 'แม่นาเรือ',
        value: 'แม่นาเรือ',
        name: {
          th: 'แม่นาเรือ',
          en: 'Mae Na Ruea',
        },
        districtId: 648,
      },
      {
        id: '560105',
        zipcode: 56000,
        text: 'บ้านตุ่น',
        value: 'บ้านตุ่น',
        name: {
          th: 'บ้านตุ่น',
          en: 'Ban Tun',
        },
        districtId: 648,
      },
      {
        id: '560106',
        zipcode: 56000,
        text: 'บ้านต๊ำ',
        value: 'บ้านต๊ำ',
        name: {
          th: 'บ้านต๊ำ',
          en: 'Ban Tam',
        },
        districtId: 648,
      },
      {
        id: '560107',
        zipcode: 56000,
        text: 'บ้านต๋อม',
        value: 'บ้านต๋อม',
        name: {
          th: 'บ้านต๋อม',
          en: 'Ban Tom',
        },
        districtId: 648,
      },
      {
        id: '560108',
        zipcode: 56000,
        text: 'แม่ปืม',
        value: 'แม่ปืม',
        name: {
          th: 'แม่ปืม',
          en: 'Mae Puem',
        },
        districtId: 648,
      },
      {
        id: '560110',
        zipcode: 56000,
        text: 'แม่กา',
        value: 'แม่กา',
        name: {
          th: 'แม่กา',
          en: 'Mae Ka',
        },
        districtId: 648,
      },
      {
        id: '560111',
        zipcode: 56000,
        text: 'บ้านใหม่',
        value: 'บ้านใหม่',
        name: {
          th: 'บ้านใหม่',
          en: 'Ban Mai',
        },
        districtId: 648,
      },
      {
        id: '560112',
        zipcode: 56000,
        text: 'จำป่าหวาย',
        value: 'จำป่าหวาย',
        name: {
          th: 'จำป่าหวาย',
          en: 'Cham Pa Wai',
        },
        districtId: 648,
      },
      {
        id: '560113',
        zipcode: 56000,
        text: 'ท่าวังทอง',
        value: 'ท่าวังทอง',
        name: {
          th: 'ท่าวังทอง',
          en: 'Tha Wang Thong',
        },
        districtId: 648,
      },
      {
        id: '560114',
        zipcode: 56000,
        text: 'แม่ใส',
        value: 'แม่ใส',
        name: {
          th: 'แม่ใส',
          en: 'Mae Sai',
        },
        districtId: 648,
      },
      {
        id: '560115',
        zipcode: 56000,
        text: 'บ้านสาง',
        value: 'บ้านสาง',
        name: {
          th: 'บ้านสาง',
          en: 'Ban Sang',
        },
        districtId: 648,
      },
      {
        id: '560116',
        zipcode: 56000,
        text: 'ท่าจำปี',
        value: 'ท่าจำปี',
        name: {
          th: 'ท่าจำปี',
          en: 'Tha Champi',
        },
        districtId: 648,
      },
      {
        id: '560118',
        zipcode: 56000,
        text: 'สันป่าม่วง',
        value: 'สันป่าม่วง',
        name: {
          th: 'สันป่าม่วง',
          en: 'San Pa Muang',
        },
        districtId: 648,
      },
      {
        id: '560201',
        zipcode: 56150,
        text: 'ห้วยข้าวก่ำ',
        value: 'ห้วยข้าวก่ำ',
        name: {
          th: 'ห้วยข้าวก่ำ',
          en: 'Huai Khao Kam',
        },
        districtId: 649,
      },
      {
        id: '560202',
        zipcode: 56150,
        text: 'จุน',
        value: 'จุน',
        name: {
          th: 'จุน',
          en: 'Chun',
        },
        districtId: 649,
      },
      {
        id: '560203',
        zipcode: 56150,
        text: 'ลอ',
        value: 'ลอ',
        name: {
          th: 'ลอ',
          en: 'Lo',
        },
        districtId: 649,
      },
      {
        id: '560204',
        zipcode: 56150,
        text: 'หงส์หิน',
        value: 'หงส์หิน',
        name: {
          th: 'หงส์หิน',
          en: 'Hong Hin',
        },
        districtId: 649,
      },
      {
        id: '560205',
        zipcode: 56150,
        text: 'ทุ่งรวงทอง',
        value: 'ทุ่งรวงทอง',
        name: {
          th: 'ทุ่งรวงทอง',
          en: 'Thung Ruang Thong',
        },
        districtId: 649,
      },
      {
        id: '560206',
        zipcode: 56150,
        text: 'ห้วยยางขาม',
        value: 'ห้วยยางขาม',
        name: {
          th: 'ห้วยยางขาม',
          en: 'Huai Yang Kham',
        },
        districtId: 649,
      },
      {
        id: '560207',
        zipcode: 56150,
        text: 'พระธาตุขิงแกง',
        value: 'พระธาตุขิงแกง',
        name: {
          th: 'พระธาตุขิงแกง',
          en: 'Phra That Khing Kaeng',
        },
        districtId: 649,
      },
      {
        id: '560301',
        zipcode: 56110,
        text: 'หย่วน',
        value: 'หย่วน',
        name: {
          th: 'หย่วน',
          en: 'Yuan',
        },
        districtId: 650,
      },
      {
        id: '560306',
        zipcode: 56110,
        text: 'น้ำแวน',
        value: 'น้ำแวน',
        name: {
          th: 'น้ำแวน',
          en: 'Nam Waen',
        },
        districtId: 650,
      },
      {
        id: '560307',
        zipcode: 56110,
        text: 'เวียง',
        value: 'เวียง',
        name: {
          th: 'เวียง',
          en: 'Wiang',
        },
        districtId: 650,
      },
      {
        id: '560308',
        zipcode: 56110,
        text: 'ฝายกวาง',
        value: 'ฝายกวาง',
        name: {
          th: 'ฝายกวาง',
          en: 'Fai Kwang',
        },
        districtId: 650,
      },
      {
        id: '560309',
        zipcode: 56110,
        text: 'เจดีย์คำ',
        value: 'เจดีย์คำ',
        name: {
          th: 'เจดีย์คำ',
          en: 'Chedi Kham',
        },
        districtId: 650,
      },
      {
        id: '560310',
        zipcode: 56110,
        text: 'ร่มเย็น',
        value: 'ร่มเย็น',
        name: {
          th: 'ร่มเย็น',
          en: 'Rom Yen',
        },
        districtId: 650,
      },
      {
        id: '560311',
        zipcode: 56110,
        text: 'เชียงบาน',
        value: 'เชียงบาน',
        name: {
          th: 'เชียงบาน',
          en: 'Chiang Ban',
        },
        districtId: 650,
      },
      {
        id: '560312',
        zipcode: 56110,
        text: 'แม่ลาว',
        value: 'แม่ลาว',
        name: {
          th: 'แม่ลาว',
          en: 'Mae Lao',
        },
        districtId: 650,
      },
      {
        id: '560313',
        zipcode: 56110,
        text: 'อ่างทอง',
        value: 'อ่างทอง',
        name: {
          th: 'อ่างทอง',
          en: 'Ang Thong',
        },
        districtId: 650,
      },
      {
        id: '560314',
        zipcode: 56110,
        text: 'ทุ่งผาสุข',
        value: 'ทุ่งผาสุข',
        name: {
          th: 'ทุ่งผาสุข',
          en: 'Thung Pha Suk',
        },
        districtId: 650,
      },
      {
        id: '560401',
        zipcode: 56160,
        text: 'เชียงม่วน',
        value: 'เชียงม่วน',
        name: {
          th: 'เชียงม่วน',
          en: 'Chiang Muan',
        },
        districtId: 651,
      },
      {
        id: '560402',
        zipcode: 56160,
        text: 'บ้านมาง',
        value: 'บ้านมาง',
        name: {
          th: 'บ้านมาง',
          en: 'Ban Mang',
        },
        districtId: 651,
      },
      {
        id: '560403',
        zipcode: 56160,
        text: 'สระ',
        value: 'สระ',
        name: {
          th: 'สระ',
          en: 'Sa',
        },
        districtId: 651,
      },
      {
        id: '560501',
        zipcode: 56120,
        text: 'ดอกคำใต้',
        value: 'ดอกคำใต้',
        name: {
          th: 'ดอกคำใต้',
          en: 'Dok Khamtai',
        },
        districtId: 652,
      },
      {
        id: '560502',
        zipcode: 56120,
        text: 'ดอนศรีชุม',
        value: 'ดอนศรีชุม',
        name: {
          th: 'ดอนศรีชุม',
          en: 'Don Si Chum',
        },
        districtId: 652,
      },
      {
        id: '560503',
        zipcode: 56120,
        text: 'บ้านถ้ำ',
        value: 'บ้านถ้ำ',
        name: {
          th: 'บ้านถ้ำ',
          en: 'Ban Tham',
        },
        districtId: 652,
      },
      {
        id: '560504',
        zipcode: 56120,
        text: 'บ้านปิน',
        value: 'บ้านปิน',
        name: {
          th: 'บ้านปิน',
          en: 'Ban Pin',
        },
        districtId: 652,
      },
      {
        id: '560505',
        zipcode: 56120,
        text: 'ห้วยลาน',
        value: 'ห้วยลาน',
        name: {
          th: 'ห้วยลาน',
          en: 'Huai Lan',
        },
        districtId: 652,
      },
      {
        id: '560506',
        zipcode: 56120,
        text: 'สันโค้ง',
        value: 'สันโค้ง',
        name: {
          th: 'สันโค้ง',
          en: 'San Khong',
        },
        districtId: 652,
      },
      {
        id: '560507',
        zipcode: 56120,
        text: 'ป่าซาง',
        value: 'ป่าซาง',
        name: {
          th: 'ป่าซาง',
          en: 'Pa Sang',
        },
        districtId: 652,
      },
      {
        id: '560508',
        zipcode: 56120,
        text: 'หนองหล่ม',
        value: 'หนองหล่ม',
        name: {
          th: 'หนองหล่ม',
          en: 'Nong Lom',
        },
        districtId: 652,
      },
      {
        id: '560509',
        zipcode: 56120,
        text: 'ดงสุวรรณ',
        value: 'ดงสุวรรณ',
        name: {
          th: 'ดงสุวรรณ',
          en: 'Dong Suwan',
        },
        districtId: 652,
      },
      {
        id: '560510',
        zipcode: 56120,
        text: 'บุญเกิด',
        value: 'บุญเกิด',
        name: {
          th: 'บุญเกิด',
          en: 'Bun Koet',
        },
        districtId: 652,
      },
      {
        id: '560511',
        zipcode: 56120,
        text: 'สว่างอารมณ์',
        value: 'สว่างอารมณ์',
        name: {
          th: 'สว่างอารมณ์',
          en: 'Sawang Arom',
        },
        districtId: 652,
      },
      {
        id: '560512',
        zipcode: 56120,
        text: 'คือเวียง',
        value: 'คือเวียง',
        name: {
          th: 'คือเวียง',
          en: 'Khue Wiang',
        },
        districtId: 652,
      },
      {
        id: '560601',
        zipcode: 56140,
        text: 'ปง',
        value: 'ปง',
        name: {
          th: 'ปง',
          en: 'Pong',
        },
        districtId: 653,
      },
      {
        id: '560602',
        zipcode: 56140,
        text: 'ควร',
        value: 'ควร',
        name: {
          th: 'ควร',
          en: 'Khuan',
        },
        districtId: 653,
      },
      {
        id: '560603',
        zipcode: 56140,
        text: 'ออย',
        value: 'ออย',
        name: {
          th: 'ออย',
          en: 'Oi',
        },
        districtId: 653,
      },
      {
        id: '560604',
        zipcode: 56140,
        text: 'งิม',
        value: 'งิม',
        name: {
          th: 'งิม',
          en: 'Ngim',
        },
        districtId: 653,
      },
      {
        id: '560605',
        zipcode: 56140,
        text: 'ผาช้างน้อย',
        value: 'ผาช้างน้อย',
        name: {
          th: 'ผาช้างน้อย',
          en: 'Pha Chang Noi',
        },
        districtId: 653,
      },
      {
        id: '560606',
        zipcode: 56140,
        text: 'นาปรัง',
        value: 'นาปรัง',
        name: {
          th: 'นาปรัง',
          en: 'Na Prang',
        },
        districtId: 653,
      },
      {
        id: '560607',
        zipcode: 56140,
        text: 'ขุนควร',
        value: 'ขุนควร',
        name: {
          th: 'ขุนควร',
          en: 'Khun Khuan',
        },
        districtId: 653,
      },
      {
        id: '560701',
        zipcode: 56130,
        text: 'แม่ใจ',
        value: 'แม่ใจ',
        name: {
          th: 'แม่ใจ',
          en: 'Mae Chai',
        },
        districtId: 654,
      },
      {
        id: '560702',
        zipcode: 56130,
        text: 'ศรีถ้อย',
        value: 'ศรีถ้อย',
        name: {
          th: 'ศรีถ้อย',
          en: 'Si Thoi',
        },
        districtId: 654,
      },
      {
        id: '560703',
        zipcode: 56130,
        text: 'แม่สุก',
        value: 'แม่สุก',
        name: {
          th: 'แม่สุก',
          en: 'Mae Suk',
        },
        districtId: 654,
      },
      {
        id: '560704',
        zipcode: 56130,
        text: 'ป่าแฝก',
        value: 'ป่าแฝก',
        name: {
          th: 'ป่าแฝก',
          en: 'Pa Faek',
        },
        districtId: 654,
      },
      {
        id: '560705',
        zipcode: 56130,
        text: 'บ้านเหล่า',
        value: 'บ้านเหล่า',
        name: {
          th: 'บ้านเหล่า',
          en: 'Ban Lao',
        },
        districtId: 654,
      },
      {
        id: '560706',
        zipcode: 56130,
        text: 'เจริญราษฎร์',
        value: 'เจริญราษฎร์',
        name: {
          th: 'เจริญราษฎร์',
          en: 'Charoen Rat',
        },
        districtId: 654,
      },
      {
        id: '560801',
        zipcode: 56110,
        text: 'ภูซาง',
        value: 'ภูซาง',
        name: {
          th: 'ภูซาง',
          en: 'Phu Sang',
        },
        districtId: 655,
      },
      {
        id: '560802',
        zipcode: 56110,
        text: 'ป่าสัก',
        value: 'ป่าสัก',
        name: {
          th: 'ป่าสัก',
          en: 'Pa Sak',
        },
        districtId: 655,
      },
      {
        id: '560803',
        zipcode: 56110,
        text: 'ทุ่งกล้วย',
        value: 'ทุ่งกล้วย',
        name: {
          th: 'ทุ่งกล้วย',
          en: 'Thung Kluai',
        },
        districtId: 655,
      },
      {
        id: '560804',
        zipcode: 56110,
        text: 'เชียงแรง',
        value: 'เชียงแรง',
        name: {
          th: 'เชียงแรง',
          en: 'Chiang Raeng',
        },
        districtId: 655,
      },
      {
        id: '560805',
        zipcode: 56110,
        text: 'สบบง',
        value: 'สบบง',
        name: {
          th: 'สบบง',
          en: 'Sop Bong',
        },
        districtId: 655,
      },
      {
        id: '560901',
        zipcode: 56000,
        text: 'ห้วยแก้ว',
        value: 'ห้วยแก้ว',
        name: {
          th: 'ห้วยแก้ว',
          en: 'Huai Kaeo',
        },
        districtId: 656,
      },
      {
        id: '560902',
        zipcode: 56000,
        text: 'ดงเจน',
        value: 'ดงเจน',
        name: {
          th: 'ดงเจน',
          en: 'Dong Chen',
        },
        districtId: 656,
      },
      {
        id: '560903',
        zipcode: 56000,
        text: 'แม่อิง',
        value: 'แม่อิง',
        name: {
          th: 'แม่อิง',
          en: 'Mae Ing',
        },
        districtId: 656,
      },
      {
        id: '570101',
        zipcode: 57000,
        text: 'เวียง',
        value: 'เวียง',
        name: {
          th: 'เวียง',
          en: 'Wiang',
        },
        districtId: 657,
      },
      {
        id: '570102',
        zipcode: 57000,
        text: 'รอบเวียง',
        value: 'รอบเวียง',
        name: {
          th: 'รอบเวียง',
          en: 'Rop Wiang',
        },
        districtId: 657,
      },
      {
        id: '570103',
        zipcode: 57100,
        text: 'บ้านดู่',
        value: 'บ้านดู่',
        name: {
          th: 'บ้านดู่',
          en: 'Ban Du',
        },
        districtId: 657,
      },
      {
        id: '570104',
        zipcode: 57100,
        text: 'นางแล',
        value: 'นางแล',
        name: {
          th: 'นางแล',
          en: 'Nang Lae',
        },
        districtId: 657,
      },
      {
        id: '570105',
        zipcode: 57100,
        text: 'แม่ข้าวต้ม',
        value: 'แม่ข้าวต้ม',
        name: {
          th: 'แม่ข้าวต้ม',
          en: 'Mae Khao Tom',
        },
        districtId: 657,
      },
      {
        id: '570106',
        zipcode: 57100,
        text: 'แม่ยาว',
        value: 'แม่ยาว',
        name: {
          th: 'แม่ยาว',
          en: 'Mae Yao',
        },
        districtId: 657,
      },
      {
        id: '570107',
        zipcode: 57000,
        text: 'สันทราย',
        value: 'สันทราย',
        name: {
          th: 'สันทราย',
          en: 'San Sai',
        },
        districtId: 657,
      },
      {
        id: '570111',
        zipcode: 57000,
        text: 'แม่กรณ์',
        value: 'แม่กรณ์',
        name: {
          th: 'แม่กรณ์',
          en: 'Mae Kon',
        },
        districtId: 657,
      },
      {
        id: '570112',
        zipcode: 57000,
        text: 'ห้วยชมภู',
        value: 'ห้วยชมภู',
        name: {
          th: 'ห้วยชมภู',
          en: 'Huai Chomphu',
        },
        districtId: 657,
      },
      {
        id: '570113',
        zipcode: 57000,
        text: 'ห้วยสัก',
        value: 'ห้วยสัก',
        name: {
          th: 'ห้วยสัก',
          en: 'Huai Sak',
        },
        districtId: 657,
      },
      {
        id: '570114',
        zipcode: 57100,
        text: 'ริมกก',
        value: 'ริมกก',
        name: {
          th: 'ริมกก',
          en: 'Rim Kok',
        },
        districtId: 657,
      },
      {
        id: '570115',
        zipcode: 57000,
        text: 'ดอยลาน',
        value: 'ดอยลาน',
        name: {
          th: 'ดอยลาน',
          en: 'Doi Lan',
        },
        districtId: 657,
      },
      {
        id: '570116',
        zipcode: 57000,
        text: 'ป่าอ้อดอนชัย',
        value: 'ป่าอ้อดอนชัย',
        name: {
          th: 'ป่าอ้อดอนชัย',
          en: 'Pa O Don Chai',
        },
        districtId: 657,
      },
      {
        id: '570118',
        zipcode: 57000,
        text: 'ท่าสาย',
        value: 'ท่าสาย',
        name: {
          th: 'ท่าสาย',
          en: 'Tha Sai',
        },
        districtId: 657,
      },
      {
        id: '570120',
        zipcode: 57000,
        text: 'ดอยฮาง',
        value: 'ดอยฮาง',
        name: {
          th: 'ดอยฮาง',
          en: 'Doi Hang',
        },
        districtId: 657,
      },
      {
        id: '570121',
        zipcode: 57100,
        text: 'ท่าสุด',
        value: 'ท่าสุด',
        name: {
          th: 'ท่าสุด',
          en: 'Tha Sut',
        },
        districtId: 657,
      },
      {
        id: '570202',
        zipcode: 57210,
        text: 'เวียงชัย',
        value: 'เวียงชัย',
        name: {
          th: 'เวียงชัย',
          en: 'Wiang Chai',
        },
        districtId: 658,
      },
      {
        id: '570203',
        zipcode: 57210,
        text: 'ผางาม',
        value: 'ผางาม',
        name: {
          th: 'ผางาม',
          en: 'Pha Ngam',
        },
        districtId: 658,
      },
      {
        id: '570204',
        zipcode: 57210,
        text: 'เวียงเหนือ',
        value: 'เวียงเหนือ',
        name: {
          th: 'เวียงเหนือ',
          en: 'Wiang Nuea',
        },
        districtId: 658,
      },
      {
        id: '570206',
        zipcode: 57210,
        text: 'ดอนศิลา',
        value: 'ดอนศิลา',
        name: {
          th: 'ดอนศิลา',
          en: 'Don Sila',
        },
        districtId: 658,
      },
      {
        id: '570208',
        zipcode: 57210,
        text: 'เมืองชุม',
        value: 'เมืองชุม',
        name: {
          th: 'เมืองชุม',
          en: 'Mueang Chum',
        },
        districtId: 658,
      },
      {
        id: '570301',
        zipcode: 57140,
        text: 'เวียง',
        value: 'เวียง',
        name: {
          th: 'เวียง',
          en: 'Wiang',
        },
        districtId: 659,
      },
      {
        id: '570302',
        zipcode: 57140,
        text: 'สถาน',
        value: 'สถาน',
        name: {
          th: 'สถาน',
          en: 'Sathan',
        },
        districtId: 659,
      },
      {
        id: '570303',
        zipcode: 57140,
        text: 'ครึ่ง',
        value: 'ครึ่ง',
        name: {
          th: 'ครึ่ง',
          en: 'Khrueng',
        },
        districtId: 659,
      },
      {
        id: '570304',
        zipcode: 57140,
        text: 'บุญเรือง',
        value: 'บุญเรือง',
        name: {
          th: 'บุญเรือง',
          en: 'Bun Rueang',
        },
        districtId: 659,
      },
      {
        id: '570305',
        zipcode: 57140,
        text: 'ห้วยซ้อ',
        value: 'ห้วยซ้อ',
        name: {
          th: 'ห้วยซ้อ',
          en: 'Huai So',
        },
        districtId: 659,
      },
      {
        id: '570308',
        zipcode: 57230,
        text: 'ศรีดอนชัย',
        value: 'ศรีดอนชัย',
        name: {
          th: 'ศรีดอนชัย',
          en: 'Si Don Chai',
        },
        districtId: 659,
      },
      {
        id: '570310',
        zipcode: 57140,
        text: 'ริมโขง',
        value: 'ริมโขง',
        name: {
          th: 'ริมโขง',
          en: 'Rim Khong',
        },
        districtId: 659,
      },
      {
        id: '570401',
        zipcode: 57160,
        text: 'เวียง',
        value: 'เวียง',
        name: {
          th: 'เวียง',
          en: 'Wiang',
        },
        districtId: 660,
      },
      {
        id: '570402',
        zipcode: 57160,
        text: 'งิ้ว',
        value: 'งิ้ว',
        name: {
          th: 'งิ้ว',
          en: 'Ngio',
        },
        districtId: 660,
      },
      {
        id: '570403',
        zipcode: 57230,
        text: 'ปล้อง',
        value: 'ปล้อง',
        name: {
          th: 'ปล้อง',
          en: 'Plong',
        },
        districtId: 660,
      },
      {
        id: '570404',
        zipcode: 57230,
        text: 'แม่ลอย',
        value: 'แม่ลอย',
        name: {
          th: 'แม่ลอย',
          en: 'Mae Loi',
        },
        districtId: 660,
      },
      {
        id: '570405',
        zipcode: 57230,
        text: 'เชียงเคี่ยน',
        value: 'เชียงเคี่ยน',
        name: {
          th: 'เชียงเคี่ยน',
          en: 'Chiang Khian',
        },
        districtId: 660,
      },
      {
        id: '570409',
        zipcode: 57160,
        text: 'ตับเต่า',
        value: 'ตับเต่า',
        name: {
          th: 'ตับเต่า',
          en: 'Tap Tao',
        },
        districtId: 660,
      },
      {
        id: '570410',
        zipcode: 57160,
        text: 'หงาว',
        value: 'หงาว',
        name: {
          th: 'หงาว',
          en: 'Ngao',
        },
        districtId: 660,
      },
      {
        id: '570411',
        zipcode: 57160,
        text: 'สันทรายงาม',
        value: 'สันทรายงาม',
        name: {
          th: 'สันทรายงาม',
          en: 'San Sai Ngam',
        },
        districtId: 660,
      },
      {
        id: '570412',
        zipcode: 57160,
        text: 'ศรีดอนไชย',
        value: 'ศรีดอนไชย',
        name: {
          th: 'ศรีดอนไชย',
          en: 'Si Don Chai',
        },
        districtId: 660,
      },
      {
        id: '570413',
        zipcode: 57160,
        text: 'หนองแรด',
        value: 'หนองแรด',
        name: {
          th: 'หนองแรด',
          en: 'Nong Raet',
        },
        districtId: 660,
      },
      {
        id: '570501',
        zipcode: 57120,
        text: 'สันมะเค็ด',
        value: 'สันมะเค็ด',
        name: {
          th: 'สันมะเค็ด',
          en: 'San Makhet',
        },
        districtId: 661,
      },
      {
        id: '570502',
        zipcode: 57120,
        text: 'แม่อ้อ',
        value: 'แม่อ้อ',
        name: {
          th: 'แม่อ้อ',
          en: 'Mae O',
        },
        districtId: 661,
      },
      {
        id: '570503',
        zipcode: 57250,
        text: 'ธารทอง',
        value: 'ธารทอง',
        name: {
          th: 'ธารทอง',
          en: 'Than Thong',
        },
        districtId: 661,
      },
      {
        id: '570504',
        zipcode: 57120,
        text: 'สันติสุข',
        value: 'สันติสุข',
        name: {
          th: 'สันติสุข',
          en: 'Santi Suk',
        },
        districtId: 661,
      },
      {
        id: '570505',
        zipcode: 57120,
        text: 'ดอยงาม',
        value: 'ดอยงาม',
        name: {
          th: 'ดอยงาม',
          en: 'Doi Ngam',
        },
        districtId: 661,
      },
      {
        id: '570506',
        zipcode: 57120,
        text: 'หัวง้ม',
        value: 'หัวง้ม',
        name: {
          th: 'หัวง้ม',
          en: 'Hua Ngom',
        },
        districtId: 661,
      },
      {
        id: '570507',
        zipcode: 57120,
        text: 'เจริญเมือง',
        value: 'เจริญเมือง',
        name: {
          th: 'เจริญเมือง',
          en: 'Charoen Mueang',
        },
        districtId: 661,
      },
      {
        id: '570508',
        zipcode: 57120,
        text: 'ป่าหุ่ง',
        value: 'ป่าหุ่ง',
        name: {
          th: 'ป่าหุ่ง',
          en: 'Pa Hung',
        },
        districtId: 661,
      },
      {
        id: '570509',
        zipcode: 57120,
        text: 'ม่วงคำ',
        value: 'ม่วงคำ',
        name: {
          th: 'ม่วงคำ',
          en: 'Muang Kham',
        },
        districtId: 661,
      },
      {
        id: '570510',
        zipcode: 57120,
        text: 'ทรายขาว',
        value: 'ทรายขาว',
        name: {
          th: 'ทรายขาว',
          en: 'Sai Khao',
        },
        districtId: 661,
      },
      {
        id: '570511',
        zipcode: 57120,
        text: 'สันกลาง',
        value: 'สันกลาง',
        name: {
          th: 'สันกลาง',
          en: 'San Klang',
        },
        districtId: 661,
      },
      {
        id: '570512',
        zipcode: 57280,
        text: 'แม่เย็น',
        value: 'แม่เย็น',
        name: {
          th: 'แม่เย็น',
          en: 'Mae Yen',
        },
        districtId: 661,
      },
      {
        id: '570513',
        zipcode: 57120,
        text: 'เมืองพาน',
        value: 'เมืองพาน',
        name: {
          th: 'เมืองพาน',
          en: 'Mueang Phan',
        },
        districtId: 661,
      },
      {
        id: '570514',
        zipcode: 57280,
        text: 'ทานตะวัน',
        value: 'ทานตะวัน',
        name: {
          th: 'ทานตะวัน',
          en: 'Than Tawan',
        },
        districtId: 661,
      },
      {
        id: '570515',
        zipcode: 57120,
        text: 'เวียงห้าว',
        value: 'เวียงห้าว',
        name: {
          th: 'เวียงห้าว',
          en: 'Wiang Hao',
        },
        districtId: 661,
      },
      {
        id: '570601',
        zipcode: 57190,
        text: 'ป่าแดด',
        value: 'ป่าแดด',
        name: {
          th: 'ป่าแดด',
          en: 'Pa Daet',
        },
        districtId: 662,
      },
      {
        id: '570602',
        zipcode: 57190,
        text: 'ป่าแงะ',
        value: 'ป่าแงะ',
        name: {
          th: 'ป่าแงะ',
          en: 'Pa Ngae',
        },
        districtId: 662,
      },
      {
        id: '570603',
        zipcode: 57190,
        text: 'สันมะค่า',
        value: 'สันมะค่า',
        name: {
          th: 'สันมะค่า',
          en: 'San Makha',
        },
        districtId: 662,
      },
      {
        id: '570605',
        zipcode: 57190,
        text: 'โรงช้าง',
        value: 'โรงช้าง',
        name: {
          th: 'โรงช้าง',
          en: 'Rong Chang',
        },
        districtId: 662,
      },
      {
        id: '570606',
        zipcode: 57190,
        text: 'ศรีโพธิ์เงิน',
        value: 'ศรีโพธิ์เงิน',
        name: {
          th: 'ศรีโพธิ์เงิน',
          en: 'Si Pho Ngoen',
        },
        districtId: 662,
      },
      {
        id: '570701',
        zipcode: 57110,
        text: 'แม่จัน',
        value: 'แม่จัน',
        name: {
          th: 'แม่จัน',
          en: 'Mae Chan',
        },
        districtId: 663,
      },
      {
        id: '570702',
        zipcode: 57270,
        text: 'จันจว้า',
        value: 'จันจว้า',
        name: {
          th: 'จันจว้า',
          en: 'Chan Chwa',
        },
        districtId: 663,
      },
      {
        id: '570703',
        zipcode: 57240,
        text: 'แม่คำ',
        value: 'แม่คำ',
        name: {
          th: 'แม่คำ',
          en: 'Mae Kham',
        },
        districtId: 663,
      },
      {
        id: '570704',
        zipcode: 57110,
        text: 'ป่าซาง',
        value: 'ป่าซาง',
        name: {
          th: 'ป่าซาง',
          en: 'Pa Sang',
        },
        districtId: 663,
      },
      {
        id: '570705',
        zipcode: 57110,
        text: 'สันทราย',
        value: 'สันทราย',
        name: {
          th: 'สันทราย',
          en: 'San Sai',
        },
        districtId: 663,
      },
      {
        id: '570706',
        zipcode: 57110,
        text: 'ท่าข้าวเปลือก',
        value: 'ท่าข้าวเปลือก',
        name: {
          th: 'ท่าข้าวเปลือก',
          en: 'Tha Khao Plueak',
        },
        districtId: 663,
      },
      {
        id: '570708',
        zipcode: 57110,
        text: 'ป่าตึง',
        value: 'ป่าตึง',
        name: {
          th: 'ป่าตึง',
          en: 'Pa Tueng',
        },
        districtId: 663,
      },
      {
        id: '570710',
        zipcode: 57240,
        text: 'แม่ไร่',
        value: 'แม่ไร่',
        name: {
          th: 'แม่ไร่',
          en: 'Mae Rai',
        },
        districtId: 663,
      },
      {
        id: '570711',
        zipcode: 57110,
        text: 'ศรีค้ำ',
        value: 'ศรีค้ำ',
        name: {
          th: 'ศรีค้ำ',
          en: 'Si Kham',
        },
        districtId: 663,
      },
      {
        id: '570712',
        zipcode: 57270,
        text: 'จันจว้าใต้',
        value: 'จันจว้าใต้',
        name: {
          th: 'จันจว้าใต้',
          en: 'Chan Chwa Tai',
        },
        districtId: 663,
      },
      {
        id: '570713',
        zipcode: 57110,
        text: 'จอมสวรรค์',
        value: 'จอมสวรรค์',
        name: {
          th: 'จอมสวรรค์',
          en: 'Chom Sawan',
        },
        districtId: 663,
      },
      {
        id: '570801',
        zipcode: 57150,
        text: 'เวียง',
        value: 'เวียง',
        name: {
          th: 'เวียง',
          en: 'Wiang',
        },
        districtId: 664,
      },
      {
        id: '570802',
        zipcode: 57150,
        text: 'ป่าสัก',
        value: 'ป่าสัก',
        name: {
          th: 'ป่าสัก',
          en: 'Pa Sak',
        },
        districtId: 664,
      },
      {
        id: '570803',
        zipcode: 57150,
        text: 'บ้านแซว',
        value: 'บ้านแซว',
        name: {
          th: 'บ้านแซว',
          en: 'Ban Saeo',
        },
        districtId: 664,
      },
      {
        id: '570804',
        zipcode: 57150,
        text: 'ศรีดอนมูล',
        value: 'ศรีดอนมูล',
        name: {
          th: 'ศรีดอนมูล',
          en: 'Si Don Mun',
        },
        districtId: 664,
      },
      {
        id: '570805',
        zipcode: 57150,
        text: 'แม่เงิน',
        value: 'แม่เงิน',
        name: {
          th: 'แม่เงิน',
          en: 'Mae Ngoen',
        },
        districtId: 664,
      },
      {
        id: '570806',
        zipcode: 57150,
        text: 'โยนก',
        value: 'โยนก',
        name: {
          th: 'โยนก',
          en: 'Yonok',
        },
        districtId: 664,
      },
      {
        id: '570901',
        zipcode: 57130,
        text: 'แม่สาย',
        value: 'แม่สาย',
        name: {
          th: 'แม่สาย',
          en: 'Mae Sai',
        },
        districtId: 665,
      },
      {
        id: '570902',
        zipcode: 57220,
        text: 'ห้วยไคร้',
        value: 'ห้วยไคร้',
        name: {
          th: 'ห้วยไคร้',
          en: 'Huai Khrai',
        },
        districtId: 665,
      },
      {
        id: '570903',
        zipcode: 57130,
        text: 'เกาะช้าง',
        value: 'เกาะช้าง',
        name: {
          th: 'เกาะช้าง',
          en: 'Ko Chang',
        },
        districtId: 665,
      },
      {
        id: '570904',
        zipcode: 57130,
        text: 'โป่งผา',
        value: 'โป่งผา',
        name: {
          th: 'โป่งผา',
          en: 'Pong Pha',
        },
        districtId: 665,
      },
      {
        id: '570905',
        zipcode: 57130,
        text: 'ศรีเมืองชุม',
        value: 'ศรีเมืองชุม',
        name: {
          th: 'ศรีเมืองชุม',
          en: 'Si Mueang Chum',
        },
        districtId: 665,
      },
      {
        id: '570906',
        zipcode: 57130,
        text: 'เวียงพางคำ',
        value: 'เวียงพางคำ',
        name: {
          th: 'เวียงพางคำ',
          en: 'Wiang Phang Kham',
        },
        districtId: 665,
      },
      {
        id: '570908',
        zipcode: 57220,
        text: 'บ้านด้าย',
        value: 'บ้านด้าย',
        name: {
          th: 'บ้านด้าย',
          en: 'Ban Dai',
        },
        districtId: 665,
      },
      {
        id: '570909',
        zipcode: 57130,
        text: 'โป่งงาม',
        value: 'โป่งงาม',
        name: {
          th: 'โป่งงาม',
          en: 'Pong Ngam',
        },
        districtId: 665,
      },
      {
        id: '571001',
        zipcode: 57180,
        text: 'แม่สรวย',
        value: 'แม่สรวย',
        name: {
          th: 'แม่สรวย',
          en: 'Mae Suai',
        },
        districtId: 666,
      },
      {
        id: '571002',
        zipcode: 57180,
        text: 'ป่าแดด',
        value: 'ป่าแดด',
        name: {
          th: 'ป่าแดด',
          en: 'Pa Daet',
        },
        districtId: 666,
      },
      {
        id: '571003',
        zipcode: 57180,
        text: 'แม่พริก',
        value: 'แม่พริก',
        name: {
          th: 'แม่พริก',
          en: 'Mae Phrik',
        },
        districtId: 666,
      },
      {
        id: '571004',
        zipcode: 57180,
        text: 'ศรีถ้อย',
        value: 'ศรีถ้อย',
        name: {
          th: 'ศรีถ้อย',
          en: 'Si Thoi',
        },
        districtId: 666,
      },
      {
        id: '571005',
        zipcode: 57180,
        text: 'ท่าก๊อ',
        value: 'ท่าก๊อ',
        name: {
          th: 'ท่าก๊อ',
          en: 'Tha Ko',
        },
        districtId: 666,
      },
      {
        id: '571006',
        zipcode: 57180,
        text: 'วาวี',
        value: 'วาวี',
        name: {
          th: 'วาวี',
          en: 'Wawi',
        },
        districtId: 666,
      },
      {
        id: '571007',
        zipcode: 57180,
        text: 'เจดีย์หลวง',
        value: 'เจดีย์หลวง',
        name: {
          th: 'เจดีย์หลวง',
          en: 'Chedi Luang',
        },
        districtId: 666,
      },
      {
        id: '571101',
        zipcode: 57170,
        text: 'สันสลี',
        value: 'สันสลี',
        name: {
          th: 'สันสลี',
          en: 'San Sali',
        },
        districtId: 667,
      },
      {
        id: '571102',
        zipcode: 57170,
        text: 'เวียง',
        value: 'เวียง',
        name: {
          th: 'เวียง',
          en: 'Wiang',
        },
        districtId: 667,
      },
      {
        id: '571103',
        zipcode: 57170,
        text: 'บ้านโป่ง',
        value: 'บ้านโป่ง',
        name: {
          th: 'บ้านโป่ง',
          en: 'Ban Pong',
        },
        districtId: 667,
      },
      {
        id: '571104',
        zipcode: 57170,
        text: 'ป่างิ้ว',
        value: 'ป่างิ้ว',
        name: {
          th: 'ป่างิ้ว',
          en: 'Pa Ngio',
        },
        districtId: 667,
      },
      {
        id: '571105',
        zipcode: 57260,
        text: 'เวียงกาหลง',
        value: 'เวียงกาหลง',
        name: {
          th: 'เวียงกาหลง',
          en: 'Wiang Kalong',
        },
        districtId: 667,
      },
      {
        id: '571106',
        zipcode: 57260,
        text: 'แม่เจดีย์',
        value: 'แม่เจดีย์',
        name: {
          th: 'แม่เจดีย์',
          en: 'Mae Chedi',
        },
        districtId: 667,
      },
      {
        id: '571107',
        zipcode: 57260,
        text: 'แม่เจดีย์ใหม่',
        value: 'แม่เจดีย์ใหม่',
        name: {
          th: 'แม่เจดีย์ใหม่',
          en: 'Mae Chedi Mai',
        },
        districtId: 667,
      },
      {
        id: '571201',
        zipcode: 57290,
        text: 'แม่เปา',
        value: 'แม่เปา',
        name: {
          th: 'แม่เปา',
          en: 'Mae Pao',
        },
        districtId: 668,
      },
      {
        id: '571202',
        zipcode: 57290,
        text: 'แม่ต๋ำ',
        value: 'แม่ต๋ำ',
        name: {
          th: 'แม่ต๋ำ',
          en: 'Mae Tam',
        },
        districtId: 668,
      },
      {
        id: '571203',
        zipcode: 57290,
        text: 'ไม้ยา',
        value: 'ไม้ยา',
        name: {
          th: 'ไม้ยา',
          en: 'Mai Ya',
        },
        districtId: 668,
      },
      {
        id: '571204',
        zipcode: 57290,
        text: 'เม็งราย',
        value: 'เม็งราย',
        name: {
          th: 'เม็งราย',
          en: 'Mengrai',
        },
        districtId: 668,
      },
      {
        id: '571205',
        zipcode: 57290,
        text: 'ตาดควัน',
        value: 'ตาดควัน',
        name: {
          th: 'ตาดควัน',
          en: 'Tat Khwan',
        },
        districtId: 668,
      },
      {
        id: '571301',
        zipcode: 57310,
        text: 'ม่วงยาย',
        value: 'ม่วงยาย',
        name: {
          th: 'ม่วงยาย',
          en: 'Muang Yai',
        },
        districtId: 669,
      },
      {
        id: '571302',
        zipcode: 57310,
        text: 'ปอ',
        value: 'ปอ',
        name: {
          th: 'ปอ',
          en: 'Por',
        },
        districtId: 669,
      },
      {
        id: '571303',
        zipcode: 57310,
        text: 'หล่ายงาว',
        value: 'หล่ายงาว',
        name: {
          th: 'หล่ายงาว',
          en: 'Lai Ngao',
        },
        districtId: 669,
      },
      {
        id: '571304',
        zipcode: 57310,
        text: 'ท่าข้าม',
        value: 'ท่าข้าม',
        name: {
          th: 'ท่าข้าม',
          en: 'Tha Kham',
        },
        districtId: 669,
      },
      {
        id: '571401',
        zipcode: 57340,
        text: 'ต้า',
        value: 'ต้า',
        name: {
          th: 'ต้า',
          en: 'Ta',
        },
        districtId: 670,
      },
      {
        id: '571402',
        zipcode: 57340,
        text: 'ป่าตาล',
        value: 'ป่าตาล',
        name: {
          th: 'ป่าตาล',
          en: 'Pa Tan',
        },
        districtId: 670,
      },
      {
        id: '571403',
        zipcode: 57340,
        text: 'ยางฮอม',
        value: 'ยางฮอม',
        name: {
          th: 'ยางฮอม',
          en: 'Yang Hom',
        },
        districtId: 670,
      },
      {
        id: '571501',
        zipcode: 57240,
        text: 'เทอดไทย',
        value: 'เทอดไทย',
        name: {
          th: 'เทอดไทย',
          en: 'Thoet Thai',
        },
        districtId: 671,
      },
      {
        id: '571502',
        zipcode: 57110,
        text: 'แม่สลองใน',
        value: 'แม่สลองใน',
        name: {
          th: 'แม่สลองใน',
          en: 'Mae Salong Nai',
        },
        districtId: 671,
      },
      {
        id: '571503',
        zipcode: 57110,
        text: 'แม่สลองนอก',
        value: 'แม่สลองนอก',
        name: {
          th: 'แม่สลองนอก',
          en: 'Mae Salong Nok',
        },
        districtId: 671,
      },
      {
        id: '571504',
        zipcode: 57240,
        text: 'แม่ฟ้าหลวง',
        value: 'แม่ฟ้าหลวง',
        name: {
          th: 'แม่ฟ้าหลวง',
          en: 'Mae Fa Luang',
        },
        districtId: 671,
      },
      {
        id: '571601',
        zipcode: 57250,
        text: 'ดงมะดะ',
        value: 'ดงมะดะ',
        name: {
          th: 'ดงมะดะ',
          en: 'Dong Mada',
        },
        districtId: 672,
      },
      {
        id: '571602',
        zipcode: 57250,
        text: 'จอมหมอกแก้ว',
        value: 'จอมหมอกแก้ว',
        name: {
          th: 'จอมหมอกแก้ว',
          en: 'Chom Mok Kaeo',
        },
        districtId: 672,
      },
      {
        id: '571603',
        zipcode: 57250,
        text: 'บัวสลี',
        value: 'บัวสลี',
        name: {
          th: 'บัวสลี',
          en: 'Bua Sali',
        },
        districtId: 672,
      },
      {
        id: '571604',
        zipcode: 57250,
        text: 'ป่าก่อดำ',
        value: 'ป่าก่อดำ',
        name: {
          th: 'ป่าก่อดำ',
          en: 'Pa Ko Dam',
        },
        districtId: 672,
      },
      {
        id: '571605',
        zipcode: 57000,
        text: 'โป่งแพร่',
        value: 'โป่งแพร่',
        name: {
          th: 'โป่งแพร่',
          en: 'Pong Phrae',
        },
        districtId: 672,
      },
      {
        id: '571701',
        zipcode: 57210,
        text: 'ทุ่งก่อ',
        value: 'ทุ่งก่อ',
        name: {
          th: 'ทุ่งก่อ',
          en: 'Thung Ko',
        },
        districtId: 673,
      },
      {
        id: '571702',
        zipcode: 57210,
        text: 'ดงมหาวัน',
        value: 'ดงมหาวัน',
        name: {
          th: 'ดงมหาวัน',
          en: 'Dong Maha Wan',
        },
        districtId: 673,
      },
      {
        id: '571703',
        zipcode: 57210,
        text: 'ป่าซาง',
        value: 'ป่าซาง',
        name: {
          th: 'ป่าซาง',
          en: 'Pa Sang',
        },
        districtId: 673,
      },
      {
        id: '571801',
        zipcode: 57110,
        text: 'ปงน้อย',
        value: 'ปงน้อย',
        name: {
          th: 'ปงน้อย',
          en: 'Pong Noi',
        },
        districtId: 674,
      },
      {
        id: '571802',
        zipcode: 57110,
        text: 'โชคชัย',
        value: 'โชคชัย',
        name: {
          th: 'โชคชัย',
          en: 'Chok Chai',
        },
        districtId: 674,
      },
      {
        id: '571803',
        zipcode: 57110,
        text: 'หนองป่าก่อ',
        value: 'หนองป่าก่อ',
        name: {
          th: 'หนองป่าก่อ',
          en: 'Nong Pa Ko',
        },
        districtId: 674,
      },
      {
        id: '580101',
        zipcode: 58000,
        text: 'จองคำ',
        value: 'จองคำ',
        name: {
          th: 'จองคำ',
          en: 'Chong Kham',
        },
        districtId: 675,
      },
      {
        id: '580102',
        zipcode: 58000,
        text: 'ห้วยโป่ง',
        value: 'ห้วยโป่ง',
        name: {
          th: 'ห้วยโป่ง',
          en: 'Huai Pong',
        },
        districtId: 675,
      },
      {
        id: '580103',
        zipcode: 58000,
        text: 'ผาบ่อง',
        value: 'ผาบ่อง',
        name: {
          th: 'ผาบ่อง',
          en: 'Pha Bong',
        },
        districtId: 675,
      },
      {
        id: '580104',
        zipcode: 58000,
        text: 'ปางหมู',
        value: 'ปางหมู',
        name: {
          th: 'ปางหมู',
          en: 'Pang Mu',
        },
        districtId: 675,
      },
      {
        id: '580105',
        zipcode: 58000,
        text: 'หมอกจำแป่',
        value: 'หมอกจำแป่',
        name: {
          th: 'หมอกจำแป่',
          en: 'Mok Champae',
        },
        districtId: 675,
      },
      {
        id: '580106',
        zipcode: 58000,
        text: 'ห้วยผา',
        value: 'ห้วยผา',
        name: {
          th: 'ห้วยผา',
          en: 'Huai Pha',
        },
        districtId: 675,
      },
      {
        id: '580109',
        zipcode: 58000,
        text: 'ห้วยปูลิง',
        value: 'ห้วยปูลิง',
        name: {
          th: 'ห้วยปูลิง',
          en: 'Huai Pu Ling',
        },
        districtId: 675,
      },
      {
        id: '580201',
        zipcode: 58140,
        text: 'ขุนยวม',
        value: 'ขุนยวม',
        name: {
          th: 'ขุนยวม',
          en: 'Khun Yuam',
        },
        districtId: 676,
      },
      {
        id: '580202',
        zipcode: 58140,
        text: 'แม่เงา',
        value: 'แม่เงา',
        name: {
          th: 'แม่เงา',
          en: 'Mae Ngao',
        },
        districtId: 676,
      },
      {
        id: '580203',
        zipcode: 58140,
        text: 'เมืองปอน',
        value: 'เมืองปอน',
        name: {
          th: 'เมืองปอน',
          en: 'Mueang Pon',
        },
        districtId: 676,
      },
      {
        id: '580204',
        zipcode: 58140,
        text: 'แม่ยวมน้อย',
        value: 'แม่ยวมน้อย',
        name: {
          th: 'แม่ยวมน้อย',
          en: 'Mae Yuam Noi',
        },
        districtId: 676,
      },
      {
        id: '580205',
        zipcode: 58140,
        text: 'แม่กิ๊',
        value: 'แม่กิ๊',
        name: {
          th: 'แม่กิ๊',
          en: 'Mae Ki',
        },
        districtId: 676,
      },
      {
        id: '580206',
        zipcode: 58140,
        text: 'แม่อูคอ',
        value: 'แม่อูคอ',
        name: {
          th: 'แม่อูคอ',
          en: 'Mae Uo Kor',
        },
        districtId: 676,
      },
      {
        id: '580301',
        zipcode: 58130,
        text: 'เวียงใต้',
        value: 'เวียงใต้',
        name: {
          th: 'เวียงใต้',
          en: 'Wiang Tai',
        },
        districtId: 677,
      },
      {
        id: '580302',
        zipcode: 58130,
        text: 'เวียงเหนือ',
        value: 'เวียงเหนือ',
        name: {
          th: 'เวียงเหนือ',
          en: 'Wiang Nuea',
        },
        districtId: 677,
      },
      {
        id: '580303',
        zipcode: 58130,
        text: 'แม่นาเติง',
        value: 'แม่นาเติง',
        name: {
          th: 'แม่นาเติง',
          en: 'Mae Na Toeng',
        },
        districtId: 677,
      },
      {
        id: '580304',
        zipcode: 58130,
        text: 'แม่ฮี้',
        value: 'แม่ฮี้',
        name: {
          th: 'แม่ฮี้',
          en: 'Mae Hi',
        },
        districtId: 677,
      },
      {
        id: '580305',
        zipcode: 58130,
        text: 'ทุ่งยาว',
        value: 'ทุ่งยาว',
        name: {
          th: 'ทุ่งยาว',
          en: 'Thung Yao',
        },
        districtId: 677,
      },
      {
        id: '580306',
        zipcode: 58130,
        text: 'เมืองแปง',
        value: 'เมืองแปง',
        name: {
          th: 'เมืองแปง',
          en: 'Mueang Paeng',
        },
        districtId: 677,
      },
      {
        id: '580307',
        zipcode: 58130,
        text: 'โป่งสา',
        value: 'โป่งสา',
        name: {
          th: 'โป่งสา',
          en: 'Pong Sa',
        },
        districtId: 677,
      },
      {
        id: '580401',
        zipcode: 58110,
        text: 'บ้านกาศ',
        value: 'บ้านกาศ',
        name: {
          th: 'บ้านกาศ',
          en: 'Ban Kat',
        },
        districtId: 678,
      },
      {
        id: '580402',
        zipcode: 58110,
        text: 'แม่สะเรียง',
        value: 'แม่สะเรียง',
        name: {
          th: 'แม่สะเรียง',
          en: 'Mae Sariang',
        },
        districtId: 678,
      },
      {
        id: '580403',
        zipcode: 58110,
        text: 'แม่คง',
        value: 'แม่คง',
        name: {
          th: 'แม่คง',
          en: 'Mae Khong',
        },
        districtId: 678,
      },
      {
        id: '580404',
        zipcode: 58110,
        text: 'แม่เหาะ',
        value: 'แม่เหาะ',
        name: {
          th: 'แม่เหาะ',
          en: 'Mae Ho',
        },
        districtId: 678,
      },
      {
        id: '580405',
        zipcode: 58110,
        text: 'แม่ยวม',
        value: 'แม่ยวม',
        name: {
          th: 'แม่ยวม',
          en: 'Mae Yuam',
        },
        districtId: 678,
      },
      {
        id: '580406',
        zipcode: 58110,
        text: 'เสาหิน',
        value: 'เสาหิน',
        name: {
          th: 'เสาหิน',
          en: 'Sao Hin',
        },
        districtId: 678,
      },
      {
        id: '580408',
        zipcode: 58110,
        text: 'ป่าแป๋',
        value: 'ป่าแป๋',
        name: {
          th: 'ป่าแป๋',
          en: 'Pa Pae',
        },
        districtId: 678,
      },
      {
        id: '580501',
        zipcode: 58120,
        text: 'แม่ลาน้อย',
        value: 'แม่ลาน้อย',
        name: {
          th: 'แม่ลาน้อย',
          en: 'Mae La Noi',
        },
        districtId: 679,
      },
      {
        id: '580502',
        zipcode: 58120,
        text: 'แม่ลาหลวง',
        value: 'แม่ลาหลวง',
        name: {
          th: 'แม่ลาหลวง',
          en: 'Mae La Luang',
        },
        districtId: 679,
      },
      {
        id: '580503',
        zipcode: 58120,
        text: 'ท่าผาปุ้ม',
        value: 'ท่าผาปุ้ม',
        name: {
          th: 'ท่าผาปุ้ม',
          en: 'Tha Pha Pum',
        },
        districtId: 679,
      },
      {
        id: '580504',
        zipcode: 58120,
        text: 'แม่โถ',
        value: 'แม่โถ',
        name: {
          th: 'แม่โถ',
          en: 'Mae Tho',
        },
        districtId: 679,
      },
      {
        id: '580505',
        zipcode: 58120,
        text: 'ห้วยห้อม',
        value: 'ห้วยห้อม',
        name: {
          th: 'ห้วยห้อม',
          en: 'Huai Hom',
        },
        districtId: 679,
      },
      {
        id: '580506',
        zipcode: 58120,
        text: 'แม่นาจาง',
        value: 'แม่นาจาง',
        name: {
          th: 'แม่นาจาง',
          en: 'Mae Na Chang',
        },
        districtId: 679,
      },
      {
        id: '580507',
        zipcode: 58120,
        text: 'สันติคีรี',
        value: 'สันติคีรี',
        name: {
          th: 'สันติคีรี',
          en: 'Santi Khiri',
        },
        districtId: 679,
      },
      {
        id: '580508',
        zipcode: 58120,
        text: 'ขุนแม่ลาน้อย',
        value: 'ขุนแม่ลาน้อย',
        name: {
          th: 'ขุนแม่ลาน้อย',
          en: 'Khun Mae La Noi',
        },
        districtId: 679,
      },
      {
        id: '580601',
        zipcode: 58110,
        text: 'สบเมย',
        value: 'สบเมย',
        name: {
          th: 'สบเมย',
          en: 'Sop Moei',
        },
        districtId: 680,
      },
      {
        id: '580602',
        zipcode: 58110,
        text: 'แม่คะตวน',
        value: 'แม่คะตวน',
        name: {
          th: 'แม่คะตวน',
          en: 'Mae Khatuan',
        },
        districtId: 680,
      },
      {
        id: '580603',
        zipcode: 58110,
        text: 'กองก๋อย',
        value: 'กองก๋อย',
        name: {
          th: 'กองก๋อย',
          en: 'Kong Koi',
        },
        districtId: 680,
      },
      {
        id: '580604',
        zipcode: 58110,
        text: 'แม่สวด',
        value: 'แม่สวด',
        name: {
          th: 'แม่สวด',
          en: 'Mae Suat',
        },
        districtId: 680,
      },
      {
        id: '580605',
        zipcode: 58110,
        text: 'ป่าโปง',
        value: 'ป่าโปง',
        name: {
          th: 'ป่าโปง',
          en: 'Pa Pong',
        },
        districtId: 680,
      },
      {
        id: '580606',
        zipcode: 58110,
        text: 'แม่สามแลบ',
        value: 'แม่สามแลบ',
        name: {
          th: 'แม่สามแลบ',
          en: 'Mae Sam Laep',
        },
        districtId: 680,
      },
      {
        id: '580701',
        zipcode: 58150,
        text: 'สบป่อง',
        value: 'สบป่อง',
        name: {
          th: 'สบป่อง',
          en: 'Sop Pong',
        },
        districtId: 681,
      },
      {
        id: '580702',
        zipcode: 58150,
        text: 'ปางมะผ้า',
        value: 'ปางมะผ้า',
        name: {
          th: 'ปางมะผ้า',
          en: 'Pang Mapha',
        },
        districtId: 681,
      },
      {
        id: '580703',
        zipcode: 58150,
        text: 'ถ้ำลอด',
        value: 'ถ้ำลอด',
        name: {
          th: 'ถ้ำลอด',
          en: 'Tham Lot',
        },
        districtId: 681,
      },
      {
        id: '580704',
        zipcode: 58150,
        text: 'นาปู่ป้อม',
        value: 'นาปู่ป้อม',
        name: {
          th: 'นาปู่ป้อม',
          en: 'Na Pu Pom',
        },
        districtId: 681,
      },
      {
        id: '600101',
        zipcode: 60000,
        text: 'ปากน้ำโพ',
        value: 'ปากน้ำโพ',
        name: {
          th: 'ปากน้ำโพ',
          en: 'Paknam Pho',
        },
        districtId: 683,
      },
      {
        id: '600102',
        zipcode: 60000,
        text: 'กลางแดด',
        value: 'กลางแดด',
        name: {
          th: 'กลางแดด',
          en: 'Klang Daet',
        },
        districtId: 683,
      },
      {
        id: '600103',
        zipcode: 60000,
        text: 'เกรียงไกร',
        value: 'เกรียงไกร',
        name: {
          th: 'เกรียงไกร',
          en: 'Kriangkrai',
        },
        districtId: 683,
      },
      {
        id: '600104',
        zipcode: 60000,
        text: 'แควใหญ่',
        value: 'แควใหญ่',
        name: {
          th: 'แควใหญ่',
          en: 'Khwae Yai',
        },
        districtId: 683,
      },
      {
        id: '600105',
        zipcode: 60000,
        text: 'ตะเคียนเลื่อน',
        value: 'ตะเคียนเลื่อน',
        name: {
          th: 'ตะเคียนเลื่อน',
          en: 'Takhian Luean',
        },
        districtId: 683,
      },
      {
        id: '600106',
        zipcode: 60000,
        text: 'นครสวรรค์ตก',
        value: 'นครสวรรค์ตก',
        name: {
          th: 'นครสวรรค์ตก',
          en: 'Nakhon Sawan Tok',
        },
        districtId: 683,
      },
      {
        id: '600107',
        zipcode: 60000,
        text: 'นครสวรรค์ออก',
        value: 'นครสวรรค์ออก',
        name: {
          th: 'นครสวรรค์ออก',
          en: 'Nakhon Sawan Ok',
        },
        districtId: 683,
      },
      {
        id: '600108',
        zipcode: 60000,
        text: 'บางพระหลวง',
        value: 'บางพระหลวง',
        name: {
          th: 'บางพระหลวง',
          en: 'Bang Phra Luang',
        },
        districtId: 683,
      },
      {
        id: '600109',
        zipcode: 60000,
        text: 'บางม่วง',
        value: 'บางม่วง',
        name: {
          th: 'บางม่วง',
          en: 'Bang Muang',
        },
        districtId: 683,
      },
      {
        id: '600110',
        zipcode: 60000,
        text: 'บ้านมะเกลือ',
        value: 'บ้านมะเกลือ',
        name: {
          th: 'บ้านมะเกลือ',
          en: 'Ban Makluea',
        },
        districtId: 683,
      },
      {
        id: '600111',
        zipcode: 60000,
        text: 'บ้านแก่ง',
        value: 'บ้านแก่ง',
        name: {
          th: 'บ้านแก่ง',
          en: 'Ban Kaeng',
        },
        districtId: 683,
      },
      {
        id: '600112',
        zipcode: 60000,
        text: 'พระนอน',
        value: 'พระนอน',
        name: {
          th: 'พระนอน',
          en: 'Phra Non',
        },
        districtId: 683,
      },
      {
        id: '600113',
        zipcode: 60000,
        text: 'วัดไทร',
        value: 'วัดไทร',
        name: {
          th: 'วัดไทร',
          en: 'Wat Sai',
        },
        districtId: 683,
      },
      {
        id: '600114',
        zipcode: 60240,
        text: 'หนองกรด',
        value: 'หนองกรด',
        name: {
          th: 'หนองกรด',
          en: 'Nong Krot',
        },
        districtId: 683,
      },
      {
        id: '600115',
        zipcode: 60240,
        text: 'หนองกระโดน',
        value: 'หนองกระโดน',
        name: {
          th: 'หนองกระโดน',
          en: 'Nong Kradon',
        },
        districtId: 683,
      },
      {
        id: '600116',
        zipcode: 60000,
        text: 'หนองปลิง',
        value: 'หนองปลิง',
        name: {
          th: 'หนองปลิง',
          en: 'Nong Pling',
        },
        districtId: 683,
      },
      {
        id: '600117',
        zipcode: 60000,
        text: 'บึงเสนาท',
        value: 'บึงเสนาท',
        name: {
          th: 'บึงเสนาท',
          en: 'Bueng Senat',
        },
        districtId: 683,
      },
      {
        id: '600201',
        zipcode: 60170,
        text: 'โกรกพระ',
        value: 'โกรกพระ',
        name: {
          th: 'โกรกพระ',
          en: 'Krok Phra',
        },
        districtId: 684,
      },
      {
        id: '600202',
        zipcode: 60170,
        text: 'ยางตาล',
        value: 'ยางตาล',
        name: {
          th: 'ยางตาล',
          en: 'Yang Tan',
        },
        districtId: 684,
      },
      {
        id: '600203',
        zipcode: 60170,
        text: 'บางมะฝ่อ',
        value: 'บางมะฝ่อ',
        name: {
          th: 'บางมะฝ่อ',
          en: 'Bang Mafo',
        },
        districtId: 684,
      },
      {
        id: '600204',
        zipcode: 60170,
        text: 'บางประมุง',
        value: 'บางประมุง',
        name: {
          th: 'บางประมุง',
          en: 'Bang Pramung',
        },
        districtId: 684,
      },
      {
        id: '600205',
        zipcode: 60170,
        text: 'นากลาง',
        value: 'นากลาง',
        name: {
          th: 'นากลาง',
          en: 'Na Klang',
        },
        districtId: 684,
      },
      {
        id: '600206',
        zipcode: 60170,
        text: 'ศาลาแดง',
        value: 'ศาลาแดง',
        name: {
          th: 'ศาลาแดง',
          en: 'Sala Daeng',
        },
        districtId: 684,
      },
      {
        id: '600207',
        zipcode: 60170,
        text: 'เนินกว้าว',
        value: 'เนินกว้าว',
        name: {
          th: 'เนินกว้าว',
          en: 'Noen Kwao',
        },
        districtId: 684,
      },
      {
        id: '600208',
        zipcode: 60170,
        text: 'เนินศาลา',
        value: 'เนินศาลา',
        name: {
          th: 'เนินศาลา',
          en: 'Noen Sala',
        },
        districtId: 684,
      },
      {
        id: '600209',
        zipcode: 60170,
        text: 'หาดสูง',
        value: 'หาดสูง',
        name: {
          th: 'หาดสูง',
          en: 'Hat Sung',
        },
        districtId: 684,
      },
      {
        id: '600301',
        zipcode: 60120,
        text: 'ชุมแสง',
        value: 'ชุมแสง',
        name: {
          th: 'ชุมแสง',
          en: 'Chum Saeng',
        },
        districtId: 685,
      },
      {
        id: '600302',
        zipcode: 60250,
        text: 'ทับกฤช',
        value: 'ทับกฤช',
        name: {
          th: 'ทับกฤช',
          en: 'Thap Krit',
        },
        districtId: 685,
      },
      {
        id: '600303',
        zipcode: 60120,
        text: 'พิกุล',
        value: 'พิกุล',
        name: {
          th: 'พิกุล',
          en: 'Phikun',
        },
        districtId: 685,
      },
      {
        id: '600304',
        zipcode: 60120,
        text: 'เกยไชย',
        value: 'เกยไชย',
        name: {
          th: 'เกยไชย',
          en: 'Koei Chai',
        },
        districtId: 685,
      },
      {
        id: '600305',
        zipcode: 60120,
        text: 'ท่าไม้',
        value: 'ท่าไม้',
        name: {
          th: 'ท่าไม้',
          en: 'Tha Mai',
        },
        districtId:  685,
      },
      {
        id: '600306',
        zipcode: 60120,
        text: 'บางเคียน',
        value: 'บางเคียน',
        name: {
          th: 'บางเคียน',
          en: 'Bang Khian',
        },
        districtId: 685,
      },
      {
        id: '600307',
        zipcode: 60120,
        text: 'หนองกระเจา',
        value: 'หนองกระเจา',
        name: {
          th: 'หนองกระเจา',
          en: 'Nong Krachao',
        },
        districtId: 685,
      },
      {
        id: '600308',
        zipcode: 60250,
        text: 'พันลาน',
        value: 'พันลาน',
        name: {
          th: 'พันลาน',
          en: 'Phan Lan',
        },
        districtId: 685,
      },
      {
        id: '600309',
        zipcode: 60120,
        text: 'โคกหม้อ',
        value: 'โคกหม้อ',
        name: {
          th: 'โคกหม้อ',
          en: 'Khok Mo',
        },
        districtId: 685,
      },
      {
        id: '600310',
        zipcode: 60120,
        text: 'ไผ่สิงห์',
        value: 'ไผ่สิงห์',
        name: {
          th: 'ไผ่สิงห์',
          en: 'Phai Sing',
        },
        districtId: 685,
      },
      {
        id: '600311',
        zipcode: 60120,
        text: 'ฆะมัง',
        value: 'ฆะมัง',
        name: {
          th: 'ฆะมัง',
          en: 'Khamang',
        },
        districtId: 685,
      },
      {
        id: '600312',
        zipcode: 60250,
        text: 'ทับกฤชใต้',
        value: 'ทับกฤชใต้',
        name: {
          th: 'ทับกฤชใต้',
          en: 'Thap Krit Tai',
        },
        districtId: 685,
      },
      {
        id: '600401',
        zipcode: 60110,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 686,
      },
      {
        id: '600402',
        zipcode: 60110,
        text: 'หนองกลับ',
        value: 'หนองกลับ',
        name: {
          th: 'หนองกลับ',
          en: 'Nong Klap',
        },
        districtId: 686,
      },
      {
        id: '600403',
        zipcode: 60110,
        text: 'ธารทหาร',
        value: 'ธารทหาร',
        name: {
          th: 'ธารทหาร',
          en: 'Than Thahan',
        },
        districtId: 686,
      },
      {
        id: '600404',
        zipcode: 60110,
        text: 'ห้วยร่วม',
        value: 'ห้วยร่วม',
        name: {
          th: 'ห้วยร่วม',
          en: 'Huai Ruam',
        },
        districtId: 686,
      },
      {
        id: '600405',
        zipcode: 60110,
        text: 'ห้วยถั่วใต้',
        value: 'ห้วยถั่วใต้',
        name: {
          th: 'ห้วยถั่วใต้',
          en: 'Huai Thua Tai',
        },
        districtId: 686,
      },
      {
        id: '600406',
        zipcode: 60110,
        text: 'ห้วยถั่วเหนือ',
        value: 'ห้วยถั่วเหนือ',
        name: {
          th: 'ห้วยถั่วเหนือ',
          en: 'Huai Thua Nuea',
        },
        districtId: 686,
      },
      {
        id: '600407',
        zipcode: 60110,
        text: 'ห้วยใหญ่',
        value: 'ห้วยใหญ่',
        name: {
          th: 'ห้วยใหญ่',
          en: 'Huai Yai',
        },
        districtId: 686,
      },
      {
        id: '600408',
        zipcode: 60110,
        text: 'ทุ่งทอง',
        value: 'ทุ่งทอง',
        name: {
          th: 'ทุ่งทอง',
          en: 'Thung Thong',
        },
        districtId: 686,
      },
      {
        id: '600409',
        zipcode: 60110,
        text: 'วังบ่อ',
        value: 'วังบ่อ',
        name: {
          th: 'วังบ่อ',
          en: 'Wang Bo',
        },
        districtId: 686,
      },
      {
        id: '600501',
        zipcode: 60180,
        text: 'ท่างิ้ว',
        value: 'ท่างิ้ว',
        name: {
          th: 'ท่างิ้ว',
          en: 'Tha Ngio',
        },
        districtId: 687,
      },
      {
        id: '600502',
        zipcode: 60180,
        text: 'บางตาหงาย',
        value: 'บางตาหงาย',
        name: {
          th: 'บางตาหงาย',
          en: 'Bang Ta Ngai',
        },
        districtId: 687,
      },
      {
        id: '600503',
        zipcode: 60180,
        text: 'หูกวาง',
        value: 'หูกวาง',
        name: {
          th: 'หูกวาง',
          en: 'Hukwang',
        },
        districtId: 687,
      },
      {
        id: '600504',
        zipcode: 60180,
        text: 'อ่างทอง',
        value: 'อ่างทอง',
        name: {
          th: 'อ่างทอง',
          en: 'Ang Thong',
        },
        districtId: 687,
      },
      {
        id: '600505',
        zipcode: 60180,
        text: 'บ้านแดน',
        value: 'บ้านแดน',
        name: {
          th: 'บ้านแดน',
          en: 'Ban Daen',
        },
        districtId: 687,
      },
      {
        id: '600506',
        zipcode: 60180,
        text: 'บางแก้ว',
        value: 'บางแก้ว',
        name: {
          th: 'บางแก้ว',
          en: 'Bang Kaeo',
        },
        districtId: 687,
      },
      {
        id: '600507',
        zipcode: 60180,
        text: 'ตาขีด',
        value: 'ตาขีด',
        name: {
          th: 'ตาขีด',
          en: 'Ta Khit',
        },
        districtId: 687,
      },
      {
        id: '600508',
        zipcode: 60180,
        text: 'ตาสัง',
        value: 'ตาสัง',
        name: {
          th: 'ตาสัง',
          en: 'Ta Sang',
        },
        districtId: 687,
      },
      {
        id: '600509',
        zipcode: 60180,
        text: 'ด่านช้าง',
        value: 'ด่านช้าง',
        name: {
          th: 'ด่านช้าง',
          en: 'Dan Chang',
        },
        districtId: 687,
      },
      {
        id: '600510',
        zipcode: 60180,
        text: 'หนองกรด',
        value: 'หนองกรด',
        name: {
          th: 'หนองกรด',
          en: 'Nong Krot',
        },
        districtId: 687,
      },
      {
        id: '600511',
        zipcode: 60180,
        text: 'หนองตางู',
        value: 'หนองตางู',
        name: {
          th: 'หนองตางู',
          en: 'Nong Ta Ngu',
        },
        districtId: 687,
      },
      {
        id: '600512',
        zipcode: 60180,
        text: 'บึงปลาทู',
        value: 'บึงปลาทู',
        name: {
          th: 'บึงปลาทู',
          en: 'Bueng Pla Thu',
        },
        districtId: 687,
      },
      {
        id: '600513',
        zipcode: 60180,
        text: 'เจริญผล',
        value: 'เจริญผล',
        name: {
          th: 'เจริญผล',
          en: 'Charoen Phon',
        },
        districtId: 687,
      },
      {
        id: '600601',
        zipcode: 60230,
        text: 'มหาโพธิ',
        value: 'มหาโพธิ',
        name: {
          th: 'มหาโพธิ',
          en: 'Maha Phot',
        },
        districtId: 688,
      },
      {
        id: '600602',
        zipcode: 60230,
        text: 'เก้าเลี้ยว',
        value: 'เก้าเลี้ยว',
        name: {
          th: 'เก้าเลี้ยว',
          en: 'Kao Liao',
        },
        districtId: 688,
      },
      {
        id: '600603',
        zipcode: 60230,
        text: 'หนองเต่า',
        value: 'หนองเต่า',
        name: {
          th: 'หนองเต่า',
          en: 'Nong Tao',
        },
        districtId: 688,
      },
      {
        id: '600604',
        zipcode: 60230,
        text: 'เขาดิน',
        value: 'เขาดิน',
        name: {
          th: 'เขาดิน',
          en: 'Khao Din',
        },
        districtId: 688,
      },
      {
        id: '600605',
        zipcode: 60230,
        text: 'หัวดง',
        value: 'หัวดง',
        name: {
          th: 'หัวดง',
          en: 'Hua Dong',
        },
        districtId: 688,
      },
      {
        id: '600701',
        zipcode: 60140,
        text: 'ตาคลี',
        value: 'ตาคลี',
        name: {
          th: 'ตาคลี',
          en: 'Takhli',
        },
        districtId: 689,
      },
      {
        id: '600702',
        zipcode: 60210,
        text: 'ช่องแค',
        value: 'ช่องแค',
        name: {
          th: 'ช่องแค',
          en: 'Chong Khae',
        },
        districtId: 689,
      },
      {
        id: '600703',
        zipcode: 60260,
        text: 'จันเสน',
        value: 'จันเสน',
        name: {
          th: 'จันเสน',
          en: 'Chan Sen',
        },
        districtId: 689,
      },
      {
        id: '600704',
        zipcode: 60210,
        text: 'ห้วยหอม',
        value: 'ห้วยหอม',
        name: {
          th: 'ห้วยหอม',
          en: 'Huai Hom',
        },
        districtId: 689,
      },
      {
        id: '600705',
        zipcode: 60140,
        text: 'หัวหวาย',
        value: 'หัวหวาย',
        name: {
          th: 'หัวหวาย',
          en: 'Hua Wai',
        },
        districtId: 689,
      },
      {
        id: '600706',
        zipcode: 60140,
        text: 'หนองโพ',
        value: 'หนองโพ',
        name: {
          th: 'หนองโพ',
          en: 'Nong Pho',
        },
        districtId: 689,
      },
      {
        id: '600707',
        zipcode: 60140,
        text: 'หนองหม้อ',
        value: 'หนองหม้อ',
        name: {
          th: 'หนองหม้อ',
          en: 'Nong Mo',
        },
        districtId: 689,
      },
      {
        id: '600708',
        zipcode: 60210,
        text: 'สร้อยทอง',
        value: 'สร้อยทอง',
        name: {
          th: 'สร้อยทอง',
          en: 'Soi Thong',
        },
        districtId: 689,
      },
      {
        id: '600709',
        zipcode: 60260,
        text: 'ลาดทิพรส',
        value: 'ลาดทิพรส',
        name: {
          th: 'ลาดทิพรส',
          en: 'Lat Thippharot',
        },
        districtId: 689,
      },
      {
        id: '600710',
        zipcode: 60210,
        text: 'พรหมนิมิต',
        value: 'พรหมนิมิต',
        name: {
          th: 'พรหมนิมิต',
          en: 'Phrom Nimit',
        },
        districtId: 689,
      },
      {
        id: '600801',
        zipcode: 60160,
        text: 'ท่าตะโก',
        value: 'ท่าตะโก',
        name: {
          th: 'ท่าตะโก',
          en: 'Tha Tako',
        },
        districtId: 690,
      },
      {
        id: '600802',
        zipcode: 60160,
        text: 'พนมรอก',
        value: 'พนมรอก',
        name: {
          th: 'พนมรอก',
          en: 'Phanom Rok',
        },
        districtId: 690,
      },
      {
        id: '600803',
        zipcode: 60160,
        text: 'หัวถนน',
        value: 'หัวถนน',
        name: {
          th: 'หัวถนน',
          en: 'Hua Thanon',
        },
        districtId: 690,
      },
      {
        id: '600804',
        zipcode: 60160,
        text: 'สายลำโพง',
        value: 'สายลำโพง',
        name: {
          th: 'สายลำโพง',
          en: 'Sai Lamphong',
        },
        districtId: 690,
      },
      {
        id: '600805',
        zipcode: 60160,
        text: 'วังมหากร',
        value: 'วังมหากร',
        name: {
          th: 'วังมหากร',
          en: 'Wang Mahakon',
        },
        districtId: 690,
      },
      {
        id: '600806',
        zipcode: 60160,
        text: 'ดอนคา',
        value: 'ดอนคา',
        name: {
          th: 'ดอนคา',
          en: 'Don Kha',
        },
        districtId: 690,
      },
      {
        id: '600807',
        zipcode: 60160,
        text: 'ทำนบ',
        value: 'ทำนบ',
        name: {
          th: 'ทำนบ',
          en: 'Thamnop',
        },
        districtId: 690,
      },
      {
        id: '600808',
        zipcode: 60160,
        text: 'วังใหญ่',
        value: 'วังใหญ่',
        name: {
          th: 'วังใหญ่',
          en: 'Wang Yai',
        },
        districtId: 690,
      },
      {
        id: '600809',
        zipcode: 60160,
        text: 'พนมเศษ',
        value: 'พนมเศษ',
        name: {
          th: 'พนมเศษ',
          en: 'Phanom Set',
        },
        districtId: 690,
      },
      {
        id: '600810',
        zipcode: 60160,
        text: 'หนองหลวง',
        value: 'หนองหลวง',
        name: {
          th: 'หนองหลวง',
          en: 'Nong Luang',
        },
        districtId: 690,
      },
      {
        id: '600901',
        zipcode: 60220,
        text: 'โคกเดื่อ',
        value: 'โคกเดื่อ',
        name: {
          th: 'โคกเดื่อ',
          en: 'Khok Duea',
        },
        districtId: 691,
      },
      {
        id: '600902',
        zipcode: 60220,
        text: 'สำโรงชัย',
        value: 'สำโรงชัย',
        name: {
          th: 'สำโรงชัย',
          en: 'Samrong Chai',
        },
        districtId: 691,
      },
      {
        id: '600903',
        zipcode: 60220,
        text: 'วังน้ำลัด',
        value: 'วังน้ำลัด',
        name: {
          th: 'วังน้ำลัด',
          en: 'Wang Nam Lat',
        },
        districtId: 691,
      },
      {
        id: '600904',
        zipcode: 60220,
        text: 'ตะคร้อ',
        value: 'ตะคร้อ',
        name: {
          th: 'ตะคร้อ',
          en: 'Takhro',
        },
        districtId: 691,
      },
      {
        id: '600905',
        zipcode: 60220,
        text: 'โพธิ์ประสาท',
        value: 'โพธิ์ประสาท',
        name: {
          th: 'โพธิ์ประสาท',
          en: 'Pho Prasat',
        },
        districtId: 691,
      },
      {
        id: '600906',
        zipcode: 60220,
        text: 'วังข่อย',
        value: 'วังข่อย',
        name: {
          th: 'วังข่อย',
          en: 'Wang Khoi',
        },
        districtId: 691,
      },
      {
        id: '600907',
        zipcode: 60220,
        text: 'นาขอม',
        value: 'นาขอม',
        name: {
          th: 'นาขอม',
          en: 'Na Khom',
        },
        districtId: 691,
      },
      {
        id: '600908',
        zipcode: 60220,
        text: 'ไพศาลี',
        value: 'ไพศาลี',
        name: {
          th: 'ไพศาลี',
          en: 'Phaisali',
        },
        districtId: 691,
      },
      {
        id: '601001',
        zipcode: 60130,
        text: 'พยุหะ',
        value: 'พยุหะ',
        name: {
          th: 'พยุหะ',
          en: 'Phayuha',
        },
        districtId: 692,
      },
      {
        id: '601002',
        zipcode: 60130,
        text: 'เนินมะกอก',
        value: 'เนินมะกอก',
        name: {
          th: 'เนินมะกอก',
          en: 'Noen Makok',
        },
        districtId: 692,
      },
      {
        id: '601003',
        zipcode: 60130,
        text: 'นิคมเขาบ่อแก้ว',
        value: 'นิคมเขาบ่อแก้ว',
        name: {
          th: 'นิคมเขาบ่อแก้ว',
          en: 'Nikhom Khao Bo Kaeo',
        },
        districtId: 692,
      },
      {
        id: '601004',
        zipcode: 60130,
        text: 'ม่วงหัก',
        value: 'ม่วงหัก',
        name: {
          th: 'ม่วงหัก',
          en: 'Muang Hak',
        },
        districtId: 692,
      },
      {
        id: '601005',
        zipcode: 60130,
        text: 'ยางขาว',
        value: 'ยางขาว',
        name: {
          th: 'ยางขาว',
          en: 'Yang Khao',
        },
        districtId: 692,
      },
      {
        id: '601006',
        zipcode: 60130,
        text: 'ย่านมัทรี',
        value: 'ย่านมัทรี',
        name: {
          th: 'ย่านมัทรี',
          en: 'Yan Matsi',
        },
        districtId: 692,
      },
      {
        id: '601007',
        zipcode: 60130,
        text: 'เขาทอง',
        value: 'เขาทอง',
        name: {
          th: 'เขาทอง',
          en: 'Khao Thong',
        },
        districtId: 692,
      },
      {
        id: '601008',
        zipcode: 60130,
        text: 'ท่าน้ำอ้อย',
        value: 'ท่าน้ำอ้อย',
        name: {
          th: 'ท่าน้ำอ้อย',
          en: 'Tha Nam Oi',
        },
        districtId: 692,
      },
      {
        id: '601009',
        zipcode: 60130,
        text: 'น้ำทรง',
        value: 'น้ำทรง',
        name: {
          th: 'น้ำทรง',
          en: 'Nam Song',
        },
        districtId: 692,
      },
      {
        id: '601010',
        zipcode: 60130,
        text: 'เขากะลา',
        value: 'เขากะลา',
        name: {
          th: 'เขากะลา',
          en: 'Khao Kala',
        },
        districtId: 692,
      },
      {
        id: '601011',
        zipcode: 60130,
        text: 'สระทะเล',
        value: 'สระทะเล',
        name: {
          th: 'สระทะเล',
          en: 'Sa Thale',
        },
        districtId: 692,
      },
      {
        id: '601101',
        zipcode: 60150,
        text: 'ลาดยาว',
        value: 'ลาดยาว',
        name: {
          th: 'ลาดยาว',
          en: 'Lat Yao',
        },
        districtId: 693,
      },
      {
        id: '601102',
        zipcode: 60150,
        text: 'ห้วยน้ำหอม',
        value: 'ห้วยน้ำหอม',
        name: {
          th: 'ห้วยน้ำหอม',
          en: 'Huai Nam Hom',
        },
        districtId: 693,
      },
      {
        id: '601103',
        zipcode: 60150,
        text: 'วังม้า',
        value: 'วังม้า',
        name: {
          th: 'วังม้า',
          en: 'Wang Ma',
        },
        districtId: 693,
      },
      {
        id: '601104',
        zipcode: 60150,
        text: 'วังเมือง',
        value: 'วังเมือง',
        name: {
          th: 'วังเมือง',
          en: 'Wang Mueang',
        },
        districtId: 693,
      },
      {
        id: '601105',
        zipcode: 60150,
        text: 'สร้อยละคร',
        value: 'สร้อยละคร',
        name: {
          th: 'สร้อยละคร',
          en: 'Soi Lakhon',
        },
        districtId: 693,
      },
      {
        id: '601106',
        zipcode: 60150,
        text: 'มาบแก',
        value: 'มาบแก',
        name: {
          th: 'มาบแก',
          en: 'Map Kae',
        },
        districtId: 693,
      },
      {
        id: '601107',
        zipcode: 60150,
        text: 'หนองยาว',
        value: 'หนองยาว',
        name: {
          th: 'หนองยาว',
          en: 'Nong Yao',
        },
        districtId: 693,
      },
      {
        id: '601108',
        zipcode: 60150,
        text: 'หนองนมวัว',
        value: 'หนองนมวัว',
        name: {
          th: 'หนองนมวัว',
          en: 'Nong Nom Wua',
        },
        districtId: 693,
      },
      {
        id: '601109',
        zipcode: 60150,
        text: 'บ้านไร่',
        value: 'บ้านไร่',
        name: {
          th: 'บ้านไร่',
          en: 'Ban Rai',
        },
        districtId: 693,
      },
      {
        id: '601110',
        zipcode: 60150,
        text: 'เนินขี้เหล็ก',
        value: 'เนินขี้เหล็ก',
        name: {
          th: 'เนินขี้เหล็ก',
          en: 'Noen Khilek',
        },
        districtId: 693,
      },
      {
        id: '601116',
        zipcode: 60150,
        text: 'ศาลเจ้าไก่ต่อ',
        value: 'ศาลเจ้าไก่ต่อ',
        name: {
          th: 'ศาลเจ้าไก่ต่อ',
          en: 'San Chao Kai To',
        },
        districtId: 693,
      },
      {
        id: '601117',
        zipcode: 60150,
        text: 'สระแก้ว',
        value: 'สระแก้ว',
        name: {
          th: 'สระแก้ว',
          en: 'Sa Kaeo',
        },
        districtId: 693,
      },
      {
        id: '601201',
        zipcode: 60190,
        text: 'ตากฟ้า',
        value: 'ตากฟ้า',
        name: {
          th: 'ตากฟ้า',
          en: 'Tak Fa',
        },
        districtId: 694,
      },
      {
        id: '601202',
        zipcode: 60190,
        text: 'ลำพยนต์',
        value: 'ลำพยนต์',
        name: {
          th: 'ลำพยนต์',
          en: 'Lam Phayon',
        },
        districtId: 694,
      },
      {
        id: '601203',
        zipcode: 60190,
        text: 'สุขสำราญ',
        value: 'สุขสำราญ',
        name: {
          th: 'สุขสำราญ',
          en: 'Suk Samran',
        },
        districtId: 694,
      },
      {
        id: '601204',
        zipcode: 60190,
        text: 'หนองพิกุล',
        value: 'หนองพิกุล',
        name: {
          th: 'หนองพิกุล',
          en: 'Nong Phikun',
        },
        districtId: 694,
      },
      {
        id: '601205',
        zipcode: 60190,
        text: 'พุนกยูง',
        value: 'พุนกยูง',
        name: {
          th: 'พุนกยูง',
          en: 'Phu Nok Yung',
        },
        districtId: 694,
      },
      {
        id: '601206',
        zipcode: 60190,
        text: 'อุดมธัญญา',
        value: 'อุดมธัญญา',
        name: {
          th: 'อุดมธัญญา',
          en: 'Udom Thanya',
        },
        districtId: 694,
      },
      {
        id: '601207',
        zipcode: 60190,
        text: 'เขาชายธง',
        value: 'เขาชายธง',
        name: {
          th: 'เขาชายธง',
          en: 'Khao Chai Thong',
        },
        districtId: 694,
      },
      {
        id: '601301',
        zipcode: 60150,
        text: 'แม่วงก์',
        value: 'แม่วงก์',
        name: {
          th: 'แม่วงก์',
          en: 'Mae Wong',
        },
        districtId: 695,
      },
      {
        id: '601303',
        zipcode: 60150,
        text: 'แม่เล่ย์',
        value: 'แม่เล่ย์',
        name: {
          th: 'แม่เล่ย์',
          en: 'Mae Le',
        },
        districtId: 695,
      },
      {
        id: '601304',
        zipcode: 60150,
        text: 'วังซ่าน',
        value: 'วังซ่าน',
        name: {
          th: 'วังซ่าน',
          en: 'Wang San',
        },
        districtId: 695,
      },
      {
        id: '601305',
        zipcode: 60150,
        text: 'เขาชนกัน',
        value: 'เขาชนกัน',
        name: {
          th: 'เขาชนกัน',
          en: 'Khao Chon Kan',
        },
        districtId: 695,
      },
      {
        id: '601401',
        zipcode: 60150,
        text: 'แม่เปิน',
        value: 'แม่เปิน',
        name: {
          th: 'แม่เปิน',
          en: 'Mae Poen)',
        },
        districtId: 696,
      },
      {
        id: '601501',
        zipcode: 60150,
        text: 'ชุมตาบง',
        value: 'ชุมตาบง',
        name: {
          th: 'ชุมตาบง',
          en: 'Chum Ta Bong',
        },
        districtId: 697,
      },
      {
        id: '601502',
        zipcode: 60150,
        text: 'ปางสวรรค์',
        value: 'ปางสวรรค์',
        name: {
          th: 'ปางสวรรค์',
          en: 'Pang Sawan',
        },
        districtId: 697,
      },
      {
        id: '610101',
        zipcode: 61000,
        text: 'อุทัยใหม่',
        value: 'อุทัยใหม่',
        name: {
          th: 'อุทัยใหม่',
          en: 'Uthai Mai',
        },
        districtId: 701,
      },
      {
        id: '610102',
        zipcode: 61000,
        text: 'น้ำซึม',
        value: 'น้ำซึม',
        name: {
          th: 'น้ำซึม',
          en: 'Nam Suem',
        },
        districtId: 701,
      },
      {
        id: '610103',
        zipcode: 61000,
        text: 'สะแกกรัง',
        value: 'สะแกกรัง',
        name: {
          th: 'สะแกกรัง',
          en: 'Sakae Krang',
        },
        districtId: 701,
      },
      {
        id: '610104',
        zipcode: 61000,
        text: 'ดอนขวาง',
        value: 'ดอนขวาง',
        name: {
          th: 'ดอนขวาง',
          en: 'Don Khwang',
        },
        districtId: 701,
      },
      {
        id: '610105',
        zipcode: 61000,
        text: 'หาดทนง',
        value: 'หาดทนง',
        name: {
          th: 'หาดทนง',
          en: 'Hat Thanong',
        },
        districtId: 701,
      },
      {
        id: '610106',
        zipcode: 61000,
        text: 'เกาะเทโพ',
        value: 'เกาะเทโพ',
        name: {
          th: 'เกาะเทโพ',
          en: 'Ko Thepho',
        },
        districtId: 701,
      },
      {
        id: '610107',
        zipcode: 61000,
        text: 'ท่าซุง',
        value: 'ท่าซุง',
        name: {
          th: 'ท่าซุง',
          en: 'Tha Sung',
        },
        districtId: 701,
      },
      {
        id: '610108',
        zipcode: 61000,
        text: 'หนองแก',
        value: 'หนองแก',
        name: {
          th: 'หนองแก',
          en: 'Nong Kae',
        },
        districtId: 701,
      },
      {
        id: '610109',
        zipcode: 61000,
        text: 'โนนเหล็ก',
        value: 'โนนเหล็ก',
        name: {
          th: 'โนนเหล็ก',
          en: 'Non Lek',
        },
        districtId: 701,
      },
      {
        id: '610110',
        zipcode: 61000,
        text: 'หนองเต่า',
        value: 'หนองเต่า',
        name: {
          th: 'หนองเต่า',
          en: 'Nong Tao',
        },
        districtId: 701,
      },
      {
        id: '610111',
        zipcode: 61000,
        text: 'หนองไผ่แบน',
        value: 'หนองไผ่แบน',
        name: {
          th: 'หนองไผ่แบน',
          en: 'Nong Phai Baen',
        },
        districtId: 701,
      },
      {
        id: '610112',
        zipcode: 61000,
        text: 'หนองพังค่า',
        value: 'หนองพังค่า',
        name: {
          th: 'หนองพังค่า',
          en: 'Nong Phang Kha',
        },
        districtId: 701,
      },
      {
        id: '610113',
        zipcode: 61000,
        text: 'ทุ่งใหญ่',
        value: 'ทุ่งใหญ่',
        name: {
          th: 'ทุ่งใหญ่',
          en: 'Thung Yai',
        },
        districtId: 701,
      },
      {
        id: '610114',
        zipcode: 61000,
        text: 'เนินแจง',
        value: 'เนินแจง',
        name: {
          th: 'เนินแจง',
          en: 'Noen Chaeng',
        },
        districtId: 701,
      },
      {
        id: '610201',
        zipcode: 61120,
        text: 'ทัพทัน',
        value: 'ทัพทัน',
        name: {
          th: 'ทัพทัน',
          en: 'Thap Than',
        },
        districtId: 702,
      },
      {
        id: '610202',
        zipcode: 61120,
        text: 'ทุ่งนาไทย',
        value: 'ทุ่งนาไทย',
        name: {
          th: 'ทุ่งนาไทย',
          en: 'Thung Na Thai',
        },
        districtId: 702,
      },
      {
        id: '610203',
        zipcode: 61120,
        text: 'เขาขี้ฝอย',
        value: 'เขาขี้ฝอย',
        name: {
          th: 'เขาขี้ฝอย',
          en: 'Khao Khi Foi',
        },
        districtId: 702,
      },
      {
        id: '610204',
        zipcode: 61120,
        text: 'หนองหญ้าปล้อง',
        value: 'หนองหญ้าปล้อง',
        name: {
          th: 'หนองหญ้าปล้อง',
          en: 'Nong Ya Plong',
        },
        districtId: 702,
      },
      {
        id: '610205',
        zipcode: 61120,
        text: 'โคกหม้อ',
        value: 'โคกหม้อ',
        name: {
          th: 'โคกหม้อ',
          en: 'Khok Mo',
        },
        districtId: 702,
      },
      {
        id: '610206',
        zipcode: 61120,
        text: 'หนองยายดา',
        value: 'หนองยายดา',
        name: {
          th: 'หนองยายดา',
          en: 'Nong Yai Da',
        },
        districtId: 702,
      },
      {
        id: '610207',
        zipcode: 61120,
        text: 'หนองกลางดง',
        value: 'หนองกลางดง',
        name: {
          th: 'หนองกลางดง',
          en: 'Nong Klang Dong',
        },
        districtId: 702,
      },
      {
        id: '610208',
        zipcode: 61120,
        text: 'หนองกระทุ่ม',
        value: 'หนองกระทุ่ม',
        name: {
          th: 'หนองกระทุ่ม',
          en: 'Nong Krathum',
        },
        districtId: 702,
      },
      {
        id: '610209',
        zipcode: 61120,
        text: 'หนองสระ',
        value: 'หนองสระ',
        name: {
          th: 'หนองสระ',
          en: 'Nong Sa',
        },
        districtId: 702,
      },
      {
        id: '610210',
        zipcode: 61120,
        text: 'ตลุกดู่',
        value: 'ตลุกดู่',
        name: {
          th: 'ตลุกดู่',
          en: 'Taluk Du',
        },
        districtId: 702,
      },
      {
        id: '610301',
        zipcode: 61150,
        text: 'สว่างอารมณ์',
        value: 'สว่างอารมณ์',
        name: {
          th: 'สว่างอารมณ์',
          en: 'Sawang Arom',
        },
        districtId: 703,
      },
      {
        id: '610302',
        zipcode: 61150,
        text: 'หนองหลวง',
        value: 'หนองหลวง',
        name: {
          th: 'หนองหลวง',
          en: 'Nong Luang',
        },
        districtId: 703,
      },
      {
        id: '610303',
        zipcode: 61150,
        text: 'พลวงสองนาง',
        value: 'พลวงสองนาง',
        name: {
          th: 'พลวงสองนาง',
          en: 'Phluang Song Nang',
        },
        districtId: 703,
      },
      {
        id: '610304',
        zipcode: 61150,
        text: 'ไผ่เขียว',
        value: 'ไผ่เขียว',
        name: {
          th: 'ไผ่เขียว',
          en: 'Phai Khiao',
        },
        districtId: 703,
      },
      {
        id: '610305',
        zipcode: 61150,
        text: 'บ่อยาง',
        value: 'บ่อยาง',
        name: {
          th: 'บ่อยาง',
          en: 'Bor Yang',
        },
        districtId: 703,
      },
      {
        id: '610401',
        zipcode: 61110,
        text: 'หนองฉาง',
        value: 'หนองฉาง',
        name: {
          th: 'หนองฉาง',
          en: 'Nong Chang',
        },
        districtId: 704,
      },
      {
        id: '610402',
        zipcode: 61110,
        text: 'หนองยาง',
        value: 'หนองยาง',
        name: {
          th: 'หนองยาง',
          en: 'Nong Yang',
        },
        districtId: 704,
      },
      {
        id: '610403',
        zipcode: 61110,
        text: 'หนองนางนวล',
        value: 'หนองนางนวล',
        name: {
          th: 'หนองนางนวล',
          en: 'Nong Nang Nuan',
        },
        districtId: 704,
      },
      {
        id: '610404',
        zipcode: 61110,
        text: 'หนองสรวง',
        value: 'หนองสรวง',
        name: {
          th: 'หนองสรวง',
          en: 'Nong Suang',
        },
        districtId: 704,
      },
      {
        id: '610405',
        zipcode: 61110,
        text: 'บ้านเก่า',
        value: 'บ้านเก่า',
        name: {
          th: 'บ้านเก่า',
          en: 'Ban Kao',
        },
        districtId: 704,
      },
      {
        id: '610406',
        zipcode: 61110,
        text: 'อุทัยเก่า',
        value: 'อุทัยเก่า',
        name: {
          th: 'อุทัยเก่า',
          en: 'Uthai Kao',
        },
        districtId: 704,
      },
      {
        id: '610407',
        zipcode: 61110,
        text: 'ทุ่งโพ',
        value: 'ทุ่งโพ',
        name: {
          th: 'ทุ่งโพ',
          en: 'Thung Pho',
        },
        districtId: 704,
      },
      {
        id: '610408',
        zipcode: 61110,
        text: 'ทุ่งพง',
        value: 'ทุ่งพง',
        name: {
          th: 'ทุ่งพง',
          en: 'Thung Phong',
        },
        districtId: 704,
      },
      {
        id: '610409',
        zipcode: 61170,
        text: 'เขาบางแกรก',
        value: 'เขาบางแกรก',
        name: {
          th: 'เขาบางแกรก',
          en: 'Khao Bang Kraek',
        },
        districtId: 704,
      },
      {
        id: '610410',
        zipcode: 61110,
        text: 'เขากวางทอง',
        value: 'เขากวางทอง',
        name: {
          th: 'เขากวางทอง',
          en: 'Khao Kwang Thong',
        },
        districtId: 704,
      },
      {
        id: '610501',
        zipcode: 61130,
        text: 'หนองขาหย่าง',
        value: 'หนองขาหย่าง',
        name: {
          th: 'หนองขาหย่าง',
          en: 'Nong Khayang',
        },
        districtId: 705,
      },
      {
        id: '610502',
        zipcode: 61130,
        text: 'หนองไผ่',
        value: 'หนองไผ่',
        name: {
          th: 'หนองไผ่',
          en: 'Nong Phai',
        },
        districtId: 705,
      },
      {
        id: '610503',
        zipcode: 61130,
        text: 'ดอนกลอย',
        value: 'ดอนกลอย',
        name: {
          th: 'ดอนกลอย',
          en: 'Don Kloi',
        },
        districtId: 705,
      },
      {
        id: '610504',
        zipcode: 61130,
        text: 'ห้วยรอบ',
        value: 'ห้วยรอบ',
        name: {
          th: 'ห้วยรอบ',
          en: 'Huai Rop',
        },
        districtId: 705,
      },
      {
        id: '610505',
        zipcode: 61130,
        text: 'ทุ่งพึ่ง',
        value: 'ทุ่งพึ่ง',
        name: {
          th: 'ทุ่งพึ่ง',
          en: 'Thung Phueng',
        },
        districtId: 705,
      },
      {
        id: '610506',
        zipcode: 61130,
        text: 'ท่าโพ',
        value: 'ท่าโพ',
        name: {
          th: 'ท่าโพ',
          en: 'Tha Pho',
        },
        districtId: 705,
      },
      {
        id: '610507',
        zipcode: 61130,
        text: 'หมกแถว',
        value: 'หมกแถว',
        name: {
          th: 'หมกแถว',
          en: 'Mok Thaeo',
        },
        districtId: 705,
      },
      {
        id: '610508',
        zipcode: 61130,
        text: 'หลุมเข้า',
        value: 'หลุมเข้า',
        name: {
          th: 'หลุมเข้า',
          en: 'Lum Khao',
        },
        districtId: 705,
      },
      {
        id: '610509',
        zipcode: 61130,
        text: 'ดงขวาง',
        value: 'ดงขวาง',
        name: {
          th: 'ดงขวาง',
          en: 'Dong Kwang',
        },
        districtId: 705,
      },
      {
        id: '610601',
        zipcode: 61140,
        text: 'บ้านไร่',
        value: 'บ้านไร่',
        name: {
          th: 'บ้านไร่',
          en: 'Ban Rai',
        },
        districtId: 706,
      },
      {
        id: '610602',
        zipcode: 61140,
        text: 'ทัพหลวง',
        value: 'ทัพหลวง',
        name: {
          th: 'ทัพหลวง',
          en: 'Thap Luang',
        },
        districtId: 706,
      },
      {
        id: '610603',
        zipcode: 61140,
        text: 'ห้วยแห้ง',
        value: 'ห้วยแห้ง',
        name: {
          th: 'ห้วยแห้ง',
          en: 'Huai Haeng',
        },
        districtId: 706,
      },
      {
        id: '610604',
        zipcode: 61140,
        text: 'คอกควาย',
        value: 'คอกควาย',
        name: {
          th: 'คอกควาย',
          en: 'Khok Khwai',
        },
        districtId: 706,
      },
      {
        id: '610605',
        zipcode: 61180,
        text: 'วังหิน',
        value: 'วังหิน',
        name: {
          th: 'วังหิน',
          en: 'Wang Hin',
        },
        districtId: 706,
      },
      {
        id: '610606',
        zipcode: 61180,
        text: 'เมืองการุ้ง',
        value: 'เมืองการุ้ง',
        name: {
          th: 'เมืองการุ้ง',
          en: 'Mueang Ka Rung',
        },
        districtId: 706,
      },
      {
        id: '610607',
        zipcode: 61140,
        text: 'แก่นมะกรูด',
        value: 'แก่นมะกรูด',
        name: {
          th: 'แก่นมะกรูด',
          en: 'Kaen Makrut',
        },
        districtId: 706,
      },
      {
        id: '610609',
        zipcode: 61180,
        text: 'หนองจอก',
        value: 'หนองจอก',
        name: {
          th: 'หนองจอก',
          en: 'Nong Chok',
        },
        districtId: 706,
      },
      {
        id: '610610',
        zipcode: 61180,
        text: 'หูช้าง',
        value: 'หูช้าง',
        name: {
          th: 'หูช้าง',
          en: 'Hu Chang',
        },
        districtId: 706,
      },
      {
        id: '610611',
        zipcode: 61140,
        text: 'บ้านบึง',
        value: 'บ้านบึง',
        name: {
          th: 'บ้านบึง',
          en: 'Ban Bueng',
        },
        districtId: 706,
      },
      {
        id: '610612',
        zipcode: 61180,
        text: 'บ้านใหม่คลองเคียน',
        value: 'บ้านใหม่คลองเคียน',
        name: {
          th: 'บ้านใหม่คลองเคียน',
          en: 'Ban Mai Khlong Khian',
        },
        districtId: 706,
      },
      {
        id: '610613',
        zipcode: 61180,
        text: 'หนองบ่มกล้วย',
        value: 'หนองบ่มกล้วย',
        name: {
          th: 'หนองบ่มกล้วย',
          en: 'Nong Bom Kluai',
        },
        districtId: 706,
      },
      {
        id: '610614',
        zipcode: 61140,
        text: 'เจ้าวัด',
        value: 'เจ้าวัด',
        name: {
          th: 'เจ้าวัด',
          en: 'Chao Wat',
        },
        districtId: 706,
      },
      {
        id: '610701',
        zipcode: 61160,
        text: 'ลานสัก',
        value: 'ลานสัก',
        name: {
          th: 'ลานสัก',
          en: 'Lan Sak',
        },
        districtId: 707,
      },
      {
        id: '610702',
        zipcode: 61160,
        text: 'ประดู่ยืน',
        value: 'ประดู่ยืน',
        name: {
          th: 'ประดู่ยืน',
          en: 'Pradu Yuen',
        },
        districtId: 707,
      },
      {
        id: '610703',
        zipcode: 61160,
        text: 'ป่าอ้อ',
        value: 'ป่าอ้อ',
        name: {
          th: 'ป่าอ้อ',
          en: 'Pa O',
        },
        districtId: 707,
      },
      {
        id: '610704',
        zipcode: 61160,
        text: 'ระบำ',
        value: 'ระบำ',
        name: {
          th: 'ระบำ',
          en: 'Rabam',
        },
        districtId: 707,
      },
      {
        id: '610705',
        zipcode: 61160,
        text: 'น้ำรอบ',
        value: 'น้ำรอบ',
        name: {
          th: 'น้ำรอบ',
          en: 'Nam Rop',
        },
        districtId: 707,
      },
      {
        id: '610706',
        zipcode: 61160,
        text: 'ทุ่งนางาม',
        value: 'ทุ่งนางาม',
        name: {
          th: 'ทุ่งนางาม',
          en: 'Thung Na Ngam',
        },
        districtId: 707,
      },
      {
        id: '610801',
        zipcode: 61170,
        text: 'สุขฤทัย',
        value: 'สุขฤทัย',
        name: {
          th: 'สุขฤทัย',
          en: 'Suk Ruethai',
        },
        districtId: 708,
      },
      {
        id: '610802',
        zipcode: 61170,
        text: 'ทองหลาง',
        value: 'ทองหลาง',
        name: {
          th: 'ทองหลาง',
          en: 'Thonglang',
        },
        districtId: 708,
      },
      {
        id: '610803',
        zipcode: 61170,
        text: 'ห้วยคต',
        value: 'ห้วยคต',
        name: {
          th: 'ห้วยคต',
          en: 'Huai Khot',
        },
        districtId: 708,
      },
      {
        id: '620101',
        zipcode: 62000,
        text: 'ในเมือง',
        value: 'ในเมือง',
        name: {
          th: 'ในเมือง',
          en: 'Nai Mueang',
        },
        districtId: 709,
      },
      {
        id: '620102',
        zipcode: 62160,
        text: 'ไตรตรึงษ์',
        value: 'ไตรตรึงษ์',
        name: {
          th: 'ไตรตรึงษ์',
          en: 'Trai Trueng',
        },
        districtId: 709,
      },
      {
        id: '620103',
        zipcode: 62000,
        text: 'อ่างทอง',
        value: 'อ่างทอง',
        name: {
          th: 'อ่างทอง',
          en: 'Ang Thong',
        },
        districtId: 709,
      },
      {
        id: '620104',
        zipcode: 62000,
        text: 'นาบ่อคำ',
        value: 'นาบ่อคำ',
        name: {
          th: 'นาบ่อคำ',
          en: 'Na Bo Kham',
        },
        districtId: 709,
      },
      {
        id: '620105',
        zipcode: 62000,
        text: 'นครชุม',
        value: 'นครชุม',
        name: {
          th: 'นครชุม',
          en: 'Nakhon Chum',
        },
        districtId: 709,
      },
      {
        id: '620106',
        zipcode: 62000,
        text: 'ทรงธรรม',
        value: 'ทรงธรรม',
        name: {
          th: 'ทรงธรรม',
          en: 'Song Tham',
        },
        districtId: 709,
      },
      {
        id: '620107',
        zipcode: 62000,
        text: 'ลานดอกไม้',
        value: 'ลานดอกไม้',
        name: {
          th: 'ลานดอกไม้',
          en: 'Lan Dokmai',
        },
        districtId: 709,
      },
      {
        id: '620110',
        zipcode: 62000,
        text: 'หนองปลิง',
        value: 'หนองปลิง',
        name: {
          th: 'หนองปลิง',
          en: 'Nong Pling',
        },
        districtId: 709,
      },
      {
        id: '620111',
        zipcode: 62000,
        text: 'คณฑี',
        value: 'คณฑี',
        name: {
          th: 'คณฑี',
          en: 'Khonthi',
        },
        districtId: 709,
      },
      {
        id: '620112',
        zipcode: 62000,
        text: 'นิคมทุ่งโพธิ์ทะเล',
        value: 'นิคมทุ่งโพธิ์ทะเล',
        name: {
          th: 'นิคมทุ่งโพธิ์ทะเล',
          en: 'Nikhom Thung Pho Thale',
        },
        districtId: 709,
      },
      {
        id: '620113',
        zipcode: 62000,
        text: 'เทพนคร',
        value: 'เทพนคร',
        name: {
          th: 'เทพนคร',
          en: 'Thep Nakhon',
        },
        districtId: 709,
      },
      {
        id: '620114',
        zipcode: 62000,
        text: 'วังทอง',
        value: 'วังทอง',
        name: {
          th: 'วังทอง',
          en: 'Wang Thong',
        },
        districtId: 709,
      },
      {
        id: '620115',
        zipcode: 62000,
        text: 'ท่าขุนราม',
        value: 'ท่าขุนราม',
        name: {
          th: 'ท่าขุนราม',
          en: 'Tha Khun Ram',
        },
        districtId: 709,
      },
      {
        id: '620117',
        zipcode: 62000,
        text: 'คลองแม่ลาย',
        value: 'คลองแม่ลาย',
        name: {
          th: 'คลองแม่ลาย',
          en: 'Khlong Mae Lai',
        },
        districtId: 709,
      },
      {
        id: '620118',
        zipcode: 62160,
        text: 'ธำมรงค์',
        value: 'ธำมรงค์',
        name: {
          th: 'ธำมรงค์',
          en: 'Thammarong',
        },
        districtId: 709,
      },
      {
        id: '620119',
        zipcode: 62000,
        text: 'สระแก้ว',
        value: 'สระแก้ว',
        name: {
          th: 'สระแก้ว',
          en: 'Sa Kaeo',
        },
        districtId: 709,
      },
      {
        id: '620201',
        zipcode: 62150,
        text: 'ไทรงาม',
        value: 'ไทรงาม',
        name: {
          th: 'ไทรงาม',
          en: 'Sai Ngam',
        },
        districtId: 710,
      },
      {
        id: '620202',
        zipcode: 62150,
        text: 'หนองคล้า',
        value: 'หนองคล้า',
        name: {
          th: 'หนองคล้า',
          en: 'Nong Khla',
        },
        districtId: 710,
      },
      {
        id: '620203',
        zipcode: 62150,
        text: 'หนองทอง',
        value: 'หนองทอง',
        name: {
          th: 'หนองทอง',
          en: 'Nong Thong',
        },
        districtId: 710,
      },
      {
        id: '620204',
        zipcode: 62150,
        text: 'หนองไม้กอง',
        value: 'หนองไม้กอง',
        name: {
          th: 'หนองไม้กอง',
          en: 'Nong Mai Kong',
        },
        districtId: 710,
      },
      {
        id: '620205',
        zipcode: 62150,
        text: 'มหาชัย',
        value: 'มหาชัย',
        name: {
          th: 'มหาชัย',
          en: 'Maha Chai',
        },
        districtId: 710,
      },
      {
        id: '620206',
        zipcode: 62150,
        text: 'พานทอง',
        value: 'พานทอง',
        name: {
          th: 'พานทอง',
          en: 'Phan Thong',
        },
        districtId: 710,
      },
      {
        id: '620207',
        zipcode: 62150,
        text: 'หนองแม่แตง',
        value: 'หนองแม่แตง',
        name: {
          th: 'หนองแม่แตง',
          en: 'Nong Mae Taeng',
        },
        districtId: 710,
      },
      {
        id: '620301',
        zipcode: 62180,
        text: 'คลองน้ำไหล',
        value: 'คลองน้ำไหล',
        name: {
          th: 'คลองน้ำไหล',
          en: 'Khlong Nam Lai',
        },
        districtId: 711,
      },
      {
        id: '620302',
        zipcode: 62180,
        text: 'โป่งน้ำร้อน',
        value: 'โป่งน้ำร้อน',
        name: {
          th: 'โป่งน้ำร้อน',
          en: 'Pong Nam Ron',
        },
        districtId: 711,
      },
      {
        id: '620303',
        zipcode: 62180,
        text: 'คลองลานพัฒนา',
        value: 'คลองลานพัฒนา',
        name: {
          th: 'คลองลานพัฒนา',
          en: 'Khlong Lan Phatthana',
        },
        districtId: 711,
      },
      {
        id: '620304',
        zipcode: 62180,
        text: 'สักงาม',
        value: 'สักงาม',
        name: {
          th: 'สักงาม',
          en: 'Sak Ngam',
        },
        districtId: 711,
      },
      {
        id: '620401',
        zipcode: 0,
        text: '*วังชะโอน',
        value: '*วังชะโอน',
        name: {
          th: '*วังชะโอน',
          en: '*Wang Cha-on',
        },
        districtId: 712,
      },
      {
        id: '620403',
        zipcode: 62130,
        text: 'ยางสูง',
        value: 'ยางสูง',
        name: {
          th: 'ยางสูง',
          en: 'Yang Sung',
        },
        districtId: 712,
      },
      {
        id: '620404',
        zipcode: 62130,
        text: 'ป่าพุทรา',
        value: 'ป่าพุทรา',
        name: {
          th: 'ป่าพุทรา',
          en: 'Pa Phutsa',
        },
        districtId: 712,
      },
      {
        id: '620405',
        zipcode: 62130,
        text: 'แสนตอ',
        value: 'แสนตอ',
        name: {
          th: 'แสนตอ',
          en: 'Saen To',
        },
        districtId: 712,
      },
      {
        id: '620406',
        zipcode: 62140,
        text: 'สลกบาตร',
        value: 'สลกบาตร',
        name: {
          th: 'สลกบาตร',
          en: 'Salok Bat',
        },
        districtId: 712,
      },
      {
        id: '620407',
        zipcode: 62140,
        text: 'บ่อถ้ำ',
        value: 'บ่อถ้ำ',
        name: {
          th: 'บ่อถ้ำ',
          en: 'Bo Tham',
        },
        districtId: 712,
      },
      {
        id: '620408',
        zipcode: 62140,
        text: 'ดอนแตง',
        value: 'ดอนแตง',
        name: {
          th: 'ดอนแตง',
          en: 'Don Taeng',
        },
        districtId: 712,
      },
      {
        id: '620409',
        zipcode: 62140,
        text: 'วังชะพลู',
        value: 'วังชะพลู',
        name: {
          th: 'วังชะพลู',
          en: 'Wang Chaphlu',
        },
        districtId: 712,
      },
      {
        id: '620410',
        zipcode: 62140,
        text: 'โค้งไผ่',
        value: 'โค้งไผ่',
        name: {
          th: 'โค้งไผ่',
          en: 'Khong Phai',
        },
        districtId: 712,
      },
      {
        id: '620411',
        zipcode: 62140,
        text: 'ปางมะค่า',
        value: 'ปางมะค่า',
        name: {
          th: 'ปางมะค่า',
          en: 'Pang Makha',
        },
        districtId: 712,
      },
      {
        id: '620412',
        zipcode: 62140,
        text: 'วังหามแห',
        value: 'วังหามแห',
        name: {
          th: 'วังหามแห',
          en: 'Wang Ham Hae',
        },
        districtId: 712,
      },
      {
        id: '620413',
        zipcode: 62130,
        text: 'เกาะตาล',
        value: 'เกาะตาล',
        name: {
          th: 'เกาะตาล',
          en: 'Ko Tan',
        },
        districtId: 712,
      },
      {
        id: '620501',
        zipcode: 62120,
        text: 'คลองขลุง',
        value: 'คลองขลุง',
        name: {
          th: 'คลองขลุง',
          en: 'Khlong Khlung',
        },
        districtId: 713,
      },
      {
        id: '620502',
        zipcode: 62120,
        text: 'ท่ามะเขือ',
        value: 'ท่ามะเขือ',
        name: {
          th: 'ท่ามะเขือ',
          en: 'Tha Makhuea',
        },
        districtId: 713,
      },
      {
        id: '620504',
        zipcode: 62120,
        text: 'ท่าพุทรา',
        value: 'ท่าพุทรา',
        name: {
          th: 'ท่าพุทรา',
          en: 'Tha Phutsa',
        },
        districtId: 713,
      },
      {
        id: '620505',
        zipcode: 62120,
        text: 'แม่ลาด',
        value: 'แม่ลาด',
        name: {
          th: 'แม่ลาด',
          en: 'Mae Lat',
        },
        districtId: 713,
      },
      {
        id: '620506',
        zipcode: 62120,
        text: 'วังยาง',
        value: 'วังยาง',
        name: {
          th: 'วังยาง',
          en: 'Wang Yang',
        },
        districtId: 713,
      },
      {
        id: '620507',
        zipcode: 62120,
        text: 'วังแขม',
        value: 'วังแขม',
        name: {
          th: 'วังแขม',
          en: 'Wang Khaem',
        },
        districtId: 713,
      },
      {
        id: '620508',
        zipcode: 62120,
        text: 'หัวถนน',
        value: 'หัวถนน',
        name: {
          th: 'หัวถนน',
          en: 'Hua Thanon',
        },
        districtId: 713,
      },
      {
        id: '620509',
        zipcode: 62120,
        text: 'วังไทร',
        value: 'วังไทร',
        name: {
          th: 'วังไทร',
          en: 'Wang Sai',
        },
        districtId: 713,
      },
      {
        id: '620513',
        zipcode: 62120,
        text: 'วังบัว',
        value: 'วังบัว',
        name: {
          th: 'วังบัว',
          en: 'Wang Bua',
        },
        districtId: 713,
      },
      {
        id: '620516',
        zipcode: 62120,
        text: 'คลองสมบูรณ์',
        value: 'คลองสมบูรณ์',
        name: {
          th: 'คลองสมบูรณ์',
          en: 'Khlong Sombun',
        },
        districtId: 713,
      },
      {
        id: '620601',
        zipcode: 62110,
        text: 'พรานกระต่าย',
        value: 'พรานกระต่าย',
        name: {
          th: 'พรานกระต่าย',
          en: 'Phran Kratai',
        },
        districtId: 714,
      },
      {
        id: '620602',
        zipcode: 62110,
        text: 'หนองหัววัว',
        value: 'หนองหัววัว',
        name: {
          th: 'หนองหัววัว',
          en: 'Nong Hua Wua',
        },
        districtId: 714,
      },
      {
        id: '620603',
        zipcode: 62110,
        text: 'ท่าไม้',
        value: 'ท่าไม้',
        name: {
          th: 'ท่าไม้',
          en: 'Tha Mai',
        },
        districtId: 714,
      },
      {
        id: '620604',
        zipcode: 62110,
        text: 'วังควง',
        value: 'วังควง',
        name: {
          th: 'วังควง',
          en: 'Wang Khuang',
        },
        districtId: 714,
      },
      {
        id: '620605',
        zipcode: 62110,
        text: 'วังตะแบก',
        value: 'วังตะแบก',
        name: {
          th: 'วังตะแบก',
          en: 'Wang Tabaek',
        },
        districtId: 714,
      },
      {
        id: '620606',
        zipcode: 62110,
        text: 'เขาคีริส',
        value: 'เขาคีริส',
        name: {
          th: 'เขาคีริส',
          en: 'Khao Khirit',
        },
        districtId: 714,
      },
      {
        id: '620607',
        zipcode: 62110,
        text: 'คุยบ้านโอง',
        value: 'คุยบ้านโอง',
        name: {
          th: 'คุยบ้านโอง',
          en: 'Khui Ban Ong',
        },
        districtId: 714,
      },
      {
        id: '620608',
        zipcode: 62110,
        text: 'คลองพิไกร',
        value: 'คลองพิไกร',
        name: {
          th: 'คลองพิไกร',
          en: 'Khlong Phikrai',
        },
        districtId: 714,
      },
      {
        id: '620609',
        zipcode: 62110,
        text: 'ถ้ำกระต่ายทอง',
        value: 'ถ้ำกระต่ายทอง',
        name: {
          th: 'ถ้ำกระต่ายทอง',
          en: 'Tham Kratai Thong',
        },
        districtId: 714,
      },
      {
        id: '620610',
        zipcode: 62110,
        text: 'ห้วยยั้ง',
        value: 'ห้วยยั้ง',
        name: {
          th: 'ห้วยยั้ง',
          en: 'Huai Yang',
        },
        districtId: 714,
      },
      {
        id: '620701',
        zipcode: 62170,
        text: 'ลานกระบือ',
        value: 'ลานกระบือ',
        name: {
          th: 'ลานกระบือ',
          en: 'Lan Krabue',
        },
        districtId: 715,
      },
      {
        id: '620702',
        zipcode: 62170,
        text: 'ช่องลม',
        value: 'ช่องลม',
        name: {
          th: 'ช่องลม',
          en: 'Chong Lom',
        },
        districtId: 715,
      },
      {
        id: '620703',
        zipcode: 62170,
        text: 'หนองหลวง',
        value: 'หนองหลวง',
        name: {
          th: 'หนองหลวง',
          en: 'Nong Luang',
        },
        districtId: 715,
      },
      {
        id: '620704',
        zipcode: 62170,
        text: 'โนนพลวง',
        value: 'โนนพลวง',
        name: {
          th: 'โนนพลวง',
          en: 'Non Phluang',
        },
        districtId: 715,
      },
      {
        id: '620705',
        zipcode: 62170,
        text: 'ประชาสุขสันต์',
        value: 'ประชาสุขสันต์',
        name: {
          th: 'ประชาสุขสันต์',
          en: 'Pracha Suk San',
        },
        districtId: 715,
      },
      {
        id: '620706',
        zipcode: 62170,
        text: 'บึงทับแรต',
        value: 'บึงทับแรต',
        name: {
          th: 'บึงทับแรต',
          en: 'Bueng Thap Raet',
        },
        districtId: 715,
      },
      {
        id: '620707',
        zipcode: 62170,
        text: 'จันทิมา',
        value: 'จันทิมา',
        name: {
          th: 'จันทิมา',
          en: 'Chanthima',
        },
        districtId: 715,
      },
      {
        id: '620801',
        zipcode: 62190,
        text: 'ทุ่งทราย',
        value: 'ทุ่งทราย',
        name: {
          th: 'ทุ่งทราย',
          en: 'Thung Sai',
        },
        districtId: 716,
      },
      {
        id: '620802',
        zipcode: 62190,
        text: 'ทุ่งทอง',
        value: 'ทุ่งทอง',
        name: {
          th: 'ทุ่งทอง',
          en: 'Thung Thong',
        },
        districtId: 716,
      },
      {
        id: '620803',
        zipcode: 62190,
        text: 'ถาวรวัฒนา',
        value: 'ถาวรวัฒนา',
        name: {
          th: 'ถาวรวัฒนา',
          en: 'Thawon Watthana',
        },
        districtId: 716,
      },
      {
        id: '620901',
        zipcode: 62120,
        text: 'โพธิ์ทอง',
        value: 'โพธิ์ทอง',
        name: {
          th: 'โพธิ์ทอง',
          en: 'Pho Thong',
        },
        districtId: 717,
      },
      {
        id: '620902',
        zipcode: 62120,
        text: 'หินดาต',
        value: 'หินดาต',
        name: {
          th: 'หินดาต',
          en: 'Hin Dat',
        },
        districtId: 717,
      },
      {
        id: '620903',
        zipcode: 62120,
        text: 'ปางตาไว',
        value: 'ปางตาไว',
        name: {
          th: 'ปางตาไว',
          en: 'Pang Ta Wai',
        },
        districtId: 717,
      },
      {
        id: '621001',
        zipcode: 62210,
        text: 'บึงสามัคคี',
        value: 'บึงสามัคคี',
        name: {
          th: 'บึงสามัคคี',
          en: 'Bueng Samakkhi',
        },
        districtId: 718,
      },
      {
        id: '621002',
        zipcode: 62210,
        text: 'วังชะโอน',
        value: 'วังชะโอน',
        name: {
          th: 'วังชะโอน',
          en: 'Wang Cha-on',
        },
        districtId: 718,
      },
      {
        id: '621003',
        zipcode: 62210,
        text: 'ระหาน',
        value: 'ระหาน',
        name: {
          th: 'ระหาน',
          en: 'Rahan',
        },
        districtId: 718,
      },
      {
        id: '621004',
        zipcode: 62210,
        text: 'เทพนิมิต',
        value: 'เทพนิมิต',
        name: {
          th: 'เทพนิมิต',
          en: 'Thep Nimit',
        },
        districtId: 718,
      },
      {
        id: '621101',
        zipcode: 62000,
        text: 'โกสัมพี',
        value: 'โกสัมพี',
        name: {
          th: 'โกสัมพี',
          en: 'Kosamphi',
        },
        districtId: 719,
      },
      {
        id: '621102',
        zipcode: 62000,
        text: 'เพชรชมภู',
        value: 'เพชรชมภู',
        name: {
          th: 'เพชรชมภู',
          en: 'Phet Chomphu',
        },
        districtId: 719,
      },
      {
        id: '621103',
        zipcode: 62000,
        text: 'ลานดอกไม้ตก',
        value: 'ลานดอกไม้ตก',
        name: {
          th: 'ลานดอกไม้ตก',
          en: 'Lan Dokmai Tok',
        },
        districtId: 719,
      },
      {
        id: '630101',
        zipcode: 63000,
        text: 'ระแหง',
        value: 'ระแหง',
        name: {
          th: 'ระแหง',
          en: 'Rahaeng',
        },
        districtId: 720,
      },
      {
        id: '630102',
        zipcode: 63000,
        text: 'หนองหลวง',
        value: 'หนองหลวง',
        name: {
          th: 'หนองหลวง',
          en: 'Nong Luang',
        },
        districtId: 720,
      },
      {
        id: '630103',
        zipcode: 63000,
        text: 'เชียงเงิน',
        value: 'เชียงเงิน',
        name: {
          th: 'เชียงเงิน',
          en: 'Chiang Ngoen',
        },
        districtId: 720,
      },
      {
        id: '630104',
        zipcode: 63000,
        text: 'หัวเดียด',
        value: 'หัวเดียด',
        name: {
          th: 'หัวเดียด',
          en: 'Hua Diat',
        },
        districtId: 720,
      },
      {
        id: '630105',
        zipcode: 63000,
        text: 'หนองบัวเหนือ',
        value: 'หนองบัวเหนือ',
        name: {
          th: 'หนองบัวเหนือ',
          en: 'Nong Bua Nuea',
        },
        districtId: 720,
      },
      {
        id: '630106',
        zipcode: 63000,
        text: 'ไม้งาม',
        value: 'ไม้งาม',
        name: {
          th: 'ไม้งาม',
          en: 'Mai Ngam',
        },
        districtId: 720,
      },
      {
        id: '630107',
        zipcode: 63000,
        text: 'โป่งแดง',
        value: 'โป่งแดง',
        name: {
          th: 'โป่งแดง',
          en: 'Pong Daeng',
        },
        districtId: 720,
      },
      {
        id: '630108',
        zipcode: 63000,
        text: 'น้ำรึม',
        value: 'น้ำรึม',
        name: {
          th: 'น้ำรึม',
          en: 'Nam Ruem',
        },
        districtId: 720,
      },
      {
        id: '630109',
        zipcode: 63000,
        text: 'วังหิน',
        value: 'วังหิน',
        name: {
          th: 'วังหิน',
          en: 'Wang Hin',
        },
        districtId: 720,
      },
      {
        id: '630111',
        zipcode: 63000,
        text: 'แม่ท้อ',
        value: 'แม่ท้อ',
        name: {
          th: 'แม่ท้อ',
          en: 'Mae Tho',
        },
        districtId: 720,
      },
      {
        id: '630112',
        zipcode: 63000,
        text: 'ป่ามะม่วง',
        value: 'ป่ามะม่วง',
        name: {
          th: 'ป่ามะม่วง',
          en: 'Pa Mamuang',
        },
        districtId: 720,
      },
      {
        id: '630113',
        zipcode: 63000,
        text: 'หนองบัวใต้',
        value: 'หนองบัวใต้',
        name: {
          th: 'หนองบัวใต้',
          en: 'Nong Bua Tai',
        },
        districtId: 720,
      },
      {
        id: '630114',
        zipcode: 63000,
        text: 'วังประจบ',
        value: 'วังประจบ',
        name: {
          th: 'วังประจบ',
          en: 'Wang Prachop',
        },
        districtId: 720,
      },
      {
        id: '630115',
        zipcode: 63000,
        text: 'ตลุกกลางทุ่ง',
        value: 'ตลุกกลางทุ่ง',
        name: {
          th: 'ตลุกกลางทุ่ง',
          en: 'Taluk Klang Thung',
        },
        districtId: 720,
      },
      {
        id: '630201',
        zipcode: 63120,
        text: 'ตากออก',
        value: 'ตากออก',
        name: {
          th: 'ตากออก',
          en: 'Tak Ok',
        },
        districtId: 721,
      },
      {
        id: '630202',
        zipcode: 63120,
        text: 'สมอโคน',
        value: 'สมอโคน',
        name: {
          th: 'สมอโคน',
          en: 'Samo Khon',
        },
        districtId: 721,
      },
      {
        id: '630203',
        zipcode: 63120,
        text: 'แม่สลิด',
        value: 'แม่สลิด',
        name: {
          th: 'แม่สลิด',
          en: 'Mae Salit',
        },
        districtId: 721,
      },
      {
        id: '630204',
        zipcode: 63120,
        text: 'ตากตก',
        value: 'ตากตก',
        name: {
          th: 'ตากตก',
          en: 'Tak Tok',
        },
        districtId: 721,
      },
      {
        id: '630205',
        zipcode: 63120,
        text: 'เกาะตะเภา',
        value: 'เกาะตะเภา',
        name: {
          th: 'เกาะตะเภา',
          en: 'Ko Taphao',
        },
        districtId: 721,
      },
      {
        id: '630206',
        zipcode: 63120,
        text: 'ทุ่งกระเชาะ',
        value: 'ทุ่งกระเชาะ',
        name: {
          th: 'ทุ่งกระเชาะ',
          en: 'Thung Kracho',
        },
        districtId: 721,
      },
      {
        id: '630207',
        zipcode: 63120,
        text: 'ท้องฟ้า',
        value: 'ท้องฟ้า',
        name: {
          th: 'ท้องฟ้า',
          en: 'Thong Fa',
        },
        districtId: 721,
      },
      {
        id: '630301',
        zipcode: 63130,
        text: 'สามเงา',
        value: 'สามเงา',
        name: {
          th: 'สามเงา',
          en: 'Sam Ngao',
        },
        districtId: 722,
      },
      {
        id: '630302',
        zipcode: 63130,
        text: 'วังหมัน',
        value: 'วังหมัน',
        name: {
          th: 'วังหมัน',
          en: 'Wang Man',
        },
        districtId: 722,
      },
      {
        id: '630303',
        zipcode: 63130,
        text: 'ยกกระบัตร',
        value: 'ยกกระบัตร',
        name: {
          th: 'ยกกระบัตร',
          en: 'Yokkrabat',
        },
        districtId: 722,
      },
      {
        id: '630304',
        zipcode: 63130,
        text: 'ย่านรี',
        value: 'ย่านรี',
        name: {
          th: 'ย่านรี',
          en: 'Yan Ri',
        },
        districtId: 722,
      },
      {
        id: '630305',
        zipcode: 63130,
        text: 'บ้านนา',
        value: 'บ้านนา',
        name: {
          th: 'บ้านนา',
          en: 'Ban Na',
        },
        districtId: 722,
      },
      {
        id: '630306',
        zipcode: 63130,
        text: 'วังจันทร์',
        value: 'วังจันทร์',
        name: {
          th: 'วังจันทร์',
          en: 'Wang Chan',
        },
        districtId: 722,
      },
      {
        id: '630401',
        zipcode: 63140,
        text: 'แม่ระมาด',
        value: 'แม่ระมาด',
        name: {
          th: 'แม่ระมาด',
          en: 'Mae Ramat',
        },
        districtId: 723,
      },
      {
        id: '630402',
        zipcode: 63140,
        text: 'แม่จะเรา',
        value: 'แม่จะเรา',
        name: {
          th: 'แม่จะเรา',
          en: 'Mae Charao',
        },
        districtId: 723,
      },
      {
        id: '630403',
        zipcode: 63140,
        text: 'ขะเนจื้อ',
        value: 'ขะเนจื้อ',
        name: {
          th: 'ขะเนจื้อ',
          en: 'Khane Chue',
        },
        districtId: 723,
      },
      {
        id: '630404',
        zipcode: 63140,
        text: 'แม่ตื่น',
        value: 'แม่ตื่น',
        name: {
          th: 'แม่ตื่น',
          en: 'Mae Tuen',
        },
        districtId: 723,
      },
      {
        id: '630405',
        zipcode: 63140,
        text: 'สามหมื่น',
        value: 'สามหมื่น',
        name: {
          th: 'สามหมื่น',
          en: 'Sam Muen',
        },
        districtId: 723,
      },
      {
        id: '630406',
        zipcode: 63140,
        text: 'พระธาตุ',
        value: 'พระธาตุ',
        name: {
          th: 'พระธาตุ',
          en: 'Phra That',
        },
        districtId: 723,
      },
      {
        id: '630501',
        zipcode: 63150,
        text: 'ท่าสองยาง',
        value: 'ท่าสองยาง',
        name: {
          th: 'ท่าสองยาง',
          en: 'Tha Song Yang',
        },
        districtId: 724,
      },
      {
        id: '630502',
        zipcode: 63150,
        text: 'แม่ต้าน',
        value: 'แม่ต้าน',
        name: {
          th: 'แม่ต้าน',
          en: 'Mae Tan',
        },
        districtId: 724,
      },
      {
        id: '630503',
        zipcode: 63150,
        text: 'แม่สอง',
        value: 'แม่สอง',
        name: {
          th: 'แม่สอง',
          en: 'Mae Song',
        },
        districtId: 724,
      },
      {
        id: '630504',
        zipcode: 63150,
        text: 'แม่หละ',
        value: 'แม่หละ',
        name: {
          th: 'แม่หละ',
          en: 'Mae La',
        },
        districtId: 724,
      },
      {
        id: '630505',
        zipcode: 63150,
        text: 'แม่วะหลวง',
        value: 'แม่วะหลวง',
        name: {
          th: 'แม่วะหลวง',
          en: 'Mae Wa Luang',
        },
        districtId: 724,
      },
      {
        id: '630506',
        zipcode: 63150,
        text: 'แม่อุสุ',
        value: 'แม่อุสุ',
        name: {
          th: 'แม่อุสุ',
          en: 'Mae Usu',
        },
        districtId: 724,
      },
      {
        id: '630601',
        zipcode: 63110,
        text: 'แม่สอด',
        value: 'แม่สอด',
        name: {
          th: 'แม่สอด',
          en: 'Mae Sot',
        },
        districtId: 725,
      },
      {
        id: '630602',
        zipcode: 63110,
        text: 'แม่กุ',
        value: 'แม่กุ',
        name: {
          th: 'แม่กุ',
          en: 'Mae Ku',
        },
        districtId: 725,
      },
      {
        id: '630603',
        zipcode: 63110,
        text: 'พะวอ',
        value: 'พะวอ',
        name: {
          th: 'พะวอ',
          en: 'Phawo',
        },
        districtId: 725,
      },
      {
        id: '630604',
        zipcode: 63110,
        text: 'แม่ตาว',
        value: 'แม่ตาว',
        name: {
          th: 'แม่ตาว',
          en: 'Mae Tao',
        },
        districtId: 725,
      },
      {
        id: '630605',
        zipcode: 63110,
        text: 'แม่กาษา',
        value: 'แม่กาษา',
        name: {
          th: 'แม่กาษา',
          en: 'Mae Kasa',
        },
        districtId: 725,
      },
      {
        id: '630606',
        zipcode: 63110,
        text: 'ท่าสายลวด',
        value: 'ท่าสายลวด',
        name: {
          th: 'ท่าสายลวด',
          en: 'Tha Sai Luat',
        },
        districtId: 725,
      },
      {
        id: '630607',
        zipcode: 63110,
        text: 'แม่ปะ',
        value: 'แม่ปะ',
        name: {
          th: 'แม่ปะ',
          en: 'Mae Pa',
        },
        districtId: 725,
      },
      {
        id: '630608',
        zipcode: 63110,
        text: 'มหาวัน',
        value: 'มหาวัน',
        name: {
          th: 'มหาวัน',
          en: 'Mahawan',
        },
        districtId: 725,
      },
      {
        id: '630609',
        zipcode: 63110,
        text: 'ด่านแม่ละเมา',
        value: 'ด่านแม่ละเมา',
        name: {
          th: 'ด่านแม่ละเมา',
          en: 'Dan Mae Lamao',
        },
        districtId: 725,
      },
      {
        id: '630610',
        zipcode: 63110,
        text: 'พระธาตุผาแดง',
        value: 'พระธาตุผาแดง',
        name: {
          th: 'พระธาตุผาแดง',
          en: 'Phra That Pha Daeng',
        },
        districtId: 725,
      },
      {
        id: '630701',
        zipcode: 63160,
        text: 'พบพระ',
        value: 'พบพระ',
        name: {
          th: 'พบพระ',
          en: 'Phop Phra',
        },
        districtId: 726,
      },
      {
        id: '630702',
        zipcode: 63160,
        text: 'ช่องแคบ',
        value: 'ช่องแคบ',
        name: {
          th: 'ช่องแคบ',
          en: 'Chong Khaep',
        },
        districtId: 726,
      },
      {
        id: '630703',
        zipcode: 63160,
        text: 'คีรีราษฎร์',
        value: 'คีรีราษฎร์',
        name: {
          th: 'คีรีราษฎร์',
          en: 'Khiri Rat',
        },
        districtId: 726,
      },
      {
        id: '630704',
        zipcode: 63160,
        text: 'วาเล่ย์',
        value: 'วาเล่ย์',
        name: {
          th: 'วาเล่ย์',
          en: 'Wale',
        },
        districtId: 726,
      },
      {
        id: '630705',
        zipcode: 63160,
        text: 'รวมไทยพัฒนา',
        value: 'รวมไทยพัฒนา',
        name: {
          th: 'รวมไทยพัฒนา',
          en: 'Ruam Thai Phatthana',
        },
        districtId: 726,
      },
      {
        id: '630801',
        zipcode: 63170,
        text: 'อุ้มผาง',
        value: 'อุ้มผาง',
        name: {
          th: 'อุ้มผาง',
          en: 'Umphang',
        },
        districtId: 727,
      },
      {
        id: '630802',
        zipcode: 63170,
        text: 'หนองหลวง',
        value: 'หนองหลวง',
        name: {
          th: 'หนองหลวง',
          en: 'Nong Luang',
        },
        districtId: 727,
      },
      {
        id: '630803',
        zipcode: 63170,
        text: 'โมโกร',
        value: 'โมโกร',
        name: {
          th: 'โมโกร',
          en: 'Mokro',
        },
        districtId: 727,
      },
      {
        id: '630804',
        zipcode: 63170,
        text: 'แม่จัน',
        value: 'แม่จัน',
        name: {
          th: 'แม่จัน',
          en: 'Mae Chan',
        },
        districtId: 727,
      },
      {
        id: '630805',
        zipcode: 63170,
        text: 'แม่ละมุ้ง',
        value: 'แม่ละมุ้ง',
        name: {
          th: 'แม่ละมุ้ง',
          en: 'Mae Lamung',
        },
        districtId: 727,
      },
      {
        id: '630806',
        zipcode: 63170,
        text: 'แม่กลอง',
        value: 'แม่กลอง',
        name: {
          th: 'แม่กลอง',
          en: 'Mae Klong',
        },
        districtId: 727,
      },
      {
        id: '630901',
        zipcode: 63000,
        text: 'เชียงทอง',
        value: 'เชียงทอง',
        name: {
          th: 'เชียงทอง',
          en: 'Chiang Thong',
        },
        districtId: 728,
      },
      {
        id: '630902',
        zipcode: 63000,
        text: 'นาโบสถ์',
        value: 'นาโบสถ์',
        name: {
          th: 'นาโบสถ์',
          en: 'Na Bot',
        },
        districtId: 728,
      },
      {
        id: '630903',
        zipcode: 63000,
        text: 'ประดาง',
        value: 'ประดาง',
        name: {
          th: 'ประดาง',
          en: 'Pradang',
        },
        districtId: 728,
      },
      {
        id: '640101',
        zipcode: 64000,
        text: 'ธานี',
        value: 'ธานี',
        name: {
          th: 'ธานี',
          en: 'Thani',
        },
        districtId: 730,
      },
      {
        id: '640102',
        zipcode: 64220,
        text: 'บ้านสวน',
        value: 'บ้านสวน',
        name: {
          th: 'บ้านสวน',
          en: 'Ban Suan',
        },
        districtId: 730,
      },
      {
        id: '640103',
        zipcode: 64210,
        text: 'เมืองเก่า',
        value: 'เมืองเก่า',
        name: {
          th: 'เมืองเก่า',
          en: 'Mueang Kao',
        },
        districtId: 730,
      },
      {
        id: '640104',
        zipcode: 64000,
        text: 'ปากแคว',
        value: 'ปากแคว',
        name: {
          th: 'ปากแคว',
          en: 'Pak Khwae',
        },
        districtId: 730,
      },
      {
        id: '640105',
        zipcode: 64000,
        text: 'ยางซ้าย',
        value: 'ยางซ้าย',
        name: {
          th: 'ยางซ้าย',
          en: 'Yang Sai',
        },
        districtId: 730,
      },
      {
        id: '640106',
        zipcode: 64000,
        text: 'บ้านกล้วย',
        value: 'บ้านกล้วย',
        name: {
          th: 'บ้านกล้วย',
          en: 'Ban Kluai',
        },
        districtId: 730,
      },
      {
        id: '640107',
        zipcode: 64000,
        text: 'บ้านหลุม',
        value: 'บ้านหลุม',
        name: {
          th: 'บ้านหลุม',
          en: 'Ban Lum',
        },
        districtId: 730,
      },
      {
        id: '640108',
        zipcode: 64220,
        text: 'ตาลเตี้ย',
        value: 'ตาลเตี้ย',
        name: {
          th: 'ตาลเตี้ย',
          en: 'Tan Tia',
        },
        districtId: 730,
      },
      {
        id: '640109',
        zipcode: 64000,
        text: 'ปากพระ',
        value: 'ปากพระ',
        name: {
          th: 'ปากพระ',
          en: 'Pak Phra',
        },
        districtId: 730,
      },
      {
        id: '640110',
        zipcode: 64210,
        text: 'วังทองแดง',
        value: 'วังทองแดง',
        name: {
          th: 'วังทองแดง',
          en: 'Wang Thongdaeng',
        },
        districtId: 730,
      },
      {
        id: '640201',
        zipcode: 64140,
        text: 'ลานหอย',
        value: 'ลานหอย',
        name: {
          th: 'ลานหอย',
          en: 'Lan Hoi',
        },
        districtId: 731,
      },
      {
        id: '640202',
        zipcode: 64140,
        text: 'บ้านด่าน',
        value: 'บ้านด่าน',
        name: {
          th: 'บ้านด่าน',
          en: 'Ban Dan',
        },
        districtId: 731,
      },
      {
        id: '640203',
        zipcode: 64140,
        text: 'วังตะคร้อ',
        value: 'วังตะคร้อ',
        name: {
          th: 'วังตะคร้อ',
          en: 'Wang Takhro',
        },
        districtId: 731,
      },
      {
        id: '640204',
        zipcode: 64140,
        text: 'วังน้ำขาว',
        value: 'วังน้ำขาว',
        name: {
          th: 'วังน้ำขาว',
          en: 'Wang Nam Khao',
        },
        districtId: 731,
      },
      {
        id: '640205',
        zipcode: 64140,
        text: 'ตลิ่งชัน',
        value: 'ตลิ่งชัน',
        name: {
          th: 'ตลิ่งชัน',
          en: 'Taling Chan',
        },
        districtId: 731,
      },
      {
        id: '640206',
        zipcode: 64140,
        text: 'หนองหญ้าปล้อง',
        value: 'หนองหญ้าปล้อง',
        name: {
          th: 'หนองหญ้าปล้อง',
          en: 'Nong Ya Plong',
        },
        districtId: 731,
      },
      {
        id: '640207',
        zipcode: 64140,
        text: 'วังลึก',
        value: 'วังลึก',
        name: {
          th: 'วังลึก',
          en: 'Wang Luek',
        },
        districtId: 731,
      },
      {
        id: '640301',
        zipcode: 64160,
        text: 'โตนด',
        value: 'โตนด',
        name: {
          th: 'โตนด',
          en: 'Tanot',
        },
        districtId: 732,
      },
      {
        id: '640302',
        zipcode: 64160,
        text: 'ทุ่งหลวง',
        value: 'ทุ่งหลวง',
        name: {
          th: 'ทุ่งหลวง',
          en: 'Thung Luang',
        },
        districtId: 732,
      },
      {
        id: '640303',
        zipcode: 64160,
        text: 'บ้านป้อม',
        value: 'บ้านป้อม',
        name: {
          th: 'บ้านป้อม',
          en: 'Ban Pom',
        },
        districtId: 732,
      },
      {
        id: '640304',
        zipcode: 64160,
        text: 'สามพวง',
        value: 'สามพวง',
        name: {
          th: 'สามพวง',
          en: 'Sam Phuang',
        },
        districtId: 732,
      },
      {
        id: '640305',
        zipcode: 64160,
        text: 'ศรีคีรีมาศ',
        value: 'ศรีคีรีมาศ',
        name: {
          th: 'ศรีคีรีมาศ',
          en: 'Si Khiri Mat',
        },
        districtId: 732,
      },
      {
        id: '640306',
        zipcode: 64160,
        text: 'หนองจิก',
        value: 'หนองจิก',
        name: {
          th: 'หนองจิก',
          en: 'Nong Chik',
        },
        districtId: 732,
      },
      {
        id: '640307',
        zipcode: 64160,
        text: 'นาเชิงคีรี',
        value: 'นาเชิงคีรี',
        name: {
          th: 'นาเชิงคีรี',
          en: 'Na Choeng Khiri',
        },
        districtId: 732,
      },
      {
        id: '640308',
        zipcode: 64160,
        text: 'หนองกระดิ่ง',
        value: 'หนองกระดิ่ง',
        name: {
          th: 'หนองกระดิ่ง',
          en: 'Nong Krading',
        },
        districtId: 732,
      },
      {
        id: '640309',
        zipcode: 64160,
        text: 'บ้านน้ำพุ',
        value: 'บ้านน้ำพุ',
        name: {
          th: 'บ้านน้ำพุ',
          en: 'Ban Nam Phu',
        },
        districtId: 732,
      },
      {
        id: '640310',
        zipcode: 64160,
        text: 'ทุ่งยางเมือง',
        value: 'ทุ่งยางเมือง',
        name: {
          th: 'ทุ่งยางเมือง',
          en: 'Thung Yang Mueang',
        },
        districtId: 732,
      },
      {
        id: '640401',
        zipcode: 64170,
        text: 'กง',
        value: 'กง',
        name: {
          th: 'กง',
          en: 'Kong',
        },
        districtId: 733,
      },
      {
        id: '640402',
        zipcode: 64170,
        text: 'บ้านกร่าง',
        value: 'บ้านกร่าง',
        name: {
          th: 'บ้านกร่าง',
          en: 'Ban Krang',
        },
        districtId: 733,
      },
      {
        id: '640403',
        zipcode: 64170,
        text: 'ไกรนอก',
        value: 'ไกรนอก',
        name: {
          th: 'ไกรนอก',
          en: 'Krai Nok',
        },
        districtId: 733,
      },
      {
        id: '640404',
        zipcode: 64170,
        text: 'ไกรกลาง',
        value: 'ไกรกลาง',
        name: {
          th: 'ไกรกลาง',
          en: 'Krai Klang',
        },
        districtId: 733,
      },
      {
        id: '640405',
        zipcode: 64170,
        text: 'ไกรใน',
        value: 'ไกรใน',
        name: {
          th: 'ไกรใน',
          en: 'Krai Nai',
        },
        districtId: 733,
      },
      {
        id: '640406',
        zipcode: 64170,
        text: 'ดงเดือย',
        value: 'ดงเดือย',
        name: {
          th: 'ดงเดือย',
          en: 'Dong Dueai',
        },
        districtId: 733,
      },
      {
        id: '640407',
        zipcode: 64170,
        text: 'ป่าแฝก',
        value: 'ป่าแฝก',
        name: {
          th: 'ป่าแฝก',
          en: 'Pa Faek',
        },
        districtId: 733,
      },
      {
        id: '640408',
        zipcode: 64170,
        text: 'กกแรต',
        value: 'กกแรต',
        name: {
          th: 'กกแรต',
          en: 'Kok Raet',
        },
        districtId: 733,
      },
      {
        id: '640409',
        zipcode: 64170,
        text: 'ท่าฉนวน',
        value: 'ท่าฉนวน',
        name: {
          th: 'ท่าฉนวน',
          en: 'Tha Chanuan',
        },
        districtId: 733,
      },
      {
        id: '640410',
        zipcode: 64170,
        text: 'หนองตูม',
        value: 'หนองตูม',
        name: {
          th: 'หนองตูม',
          en: 'Nong Tum',
        },
        districtId: 733,
      },
      {
        id: '640411',
        zipcode: 64170,
        text: 'บ้านใหม่สุขเกษม',
        value: 'บ้านใหม่สุขเกษม',
        name: {
          th: 'บ้านใหม่สุขเกษม',
          en: 'Ban Mai Suk Kasem',
        },
        districtId: 733,
      },
      {
        id: '640501',
        zipcode: 64130,
        text: 'หาดเสี้ยว',
        value: 'หาดเสี้ยว',
        name: {
          th: 'หาดเสี้ยว',
          en: 'Hat Siao',
        },
        districtId: 734,
      },
      {
        id: '640502',
        zipcode: 64130,
        text: 'ป่างิ้ว',
        value: 'ป่างิ้ว',
        name: {
          th: 'ป่างิ้ว',
          en: 'Pa Ngio',
        },
        districtId: 734,
      },
      {
        id: '640503',
        zipcode: 64130,
        text: 'แม่สำ',
        value: 'แม่สำ',
        name: {
          th: 'แม่สำ',
          en: 'Mae Sam',
        },
        districtId: 734,
      },
      {
        id: '640504',
        zipcode: 64130,
        text: 'แม่สิน',
        value: 'แม่สิน',
        name: {
          th: 'แม่สิน',
          en: 'Mae Sin',
        },
        districtId: 734,
      },
      {
        id: '640505',
        zipcode: 64130,
        text: 'บ้านตึก',
        value: 'บ้านตึก',
        name: {
          th: 'บ้านตึก',
          en: 'Ban Tuek',
        },
        districtId: 734,
      },
      {
        id: '640506',
        zipcode: 64130,
        text: 'หนองอ้อ',
        value: 'หนองอ้อ',
        name: {
          th: 'หนองอ้อ',
          en: 'Nong O',
        },
        districtId: 734,
      },
      {
        id: '640507',
        zipcode: 64190,
        text: 'ท่าชัย',
        value: 'ท่าชัย',
        name: {
          th: 'ท่าชัย',
          en: 'Tha Chai',
        },
        districtId: 734,
      },
      {
        id: '640508',
        zipcode: 64190,
        text: 'ศรีสัชนาลัย',
        value: 'ศรีสัชนาลัย',
        name: {
          th: 'ศรีสัชนาลัย',
          en: 'Si Satchanalai',
        },
        districtId: 734,
      },
      {
        id: '640509',
        zipcode: 64130,
        text: 'ดงคู่',
        value: 'ดงคู่',
        name: {
          th: 'ดงคู่',
          en: 'Dong Khu',
        },
        districtId: 734,
      },
      {
        id: '640510',
        zipcode: 64130,
        text: 'บ้านแก่ง',
        value: 'บ้านแก่ง',
        name: {
          th: 'บ้านแก่ง',
          en: 'Ban Kaeng',
        },
        districtId: 734,
      },
      {
        id: '640511',
        zipcode: 64130,
        text: 'สารจิตร',
        value: 'สารจิตร',
        name: {
          th: 'สารจิตร',
          en: 'San Chit',
        },
        districtId: 734,
      },
      {
        id: '640601',
        zipcode: 64120,
        text: 'คลองตาล',
        value: 'คลองตาล',
        name: {
          th: 'คลองตาล',
          en: 'Khlong Tan',
        },
        districtId: 735,
      },
      {
        id: '640602',
        zipcode: 64120,
        text: 'วังลึก',
        value: 'วังลึก',
        name: {
          th: 'วังลึก',
          en: 'Wang Luek',
        },
        districtId: 735,
      },
      {
        id: '640603',
        zipcode: 64120,
        text: 'สามเรือน',
        value: 'สามเรือน',
        name: {
          th: 'สามเรือน',
          en: 'Sam Ruean',
        },
        districtId: 735,
      },
      {
        id: '640604',
        zipcode: 64120,
        text: 'บ้านนา',
        value: 'บ้านนา',
        name: {
          th: 'บ้านนา',
          en: 'Ban Na',
        },
        districtId: 735,
      },
      {
        id: '640605',
        zipcode: 64120,
        text: 'วังทอง',
        value: 'วังทอง',
        name: {
          th: 'วังทอง',
          en: 'Wang Thong',
        },
        districtId: 735,
      },
      {
        id: '640606',
        zipcode: 64120,
        text: 'นาขุนไกร',
        value: 'นาขุนไกร',
        name: {
          th: 'นาขุนไกร',
          en: 'Na Khun Krai',
        },
        districtId: 735,
      },
      {
        id: '640607',
        zipcode: 64120,
        text: 'เกาะตาเลี้ยง',
        value: 'เกาะตาเลี้ยง',
        name: {
          th: 'เกาะตาเลี้ยง',
          en: 'Ko Ta Liang',
        },
        districtId: 735,
      },
      {
        id: '640608',
        zipcode: 64120,
        text: 'วัดเกาะ',
        value: 'วัดเกาะ',
        name: {
          th: 'วัดเกาะ',
          en: 'Wat Ko',
        },
        districtId: 735,
      },
      {
        id: '640609',
        zipcode: 64120,
        text: 'บ้านไร่',
        value: 'บ้านไร่',
        name: {
          th: 'บ้านไร่',
          en: 'Ban Rai',
        },
        districtId: 735,
      },
      {
        id: '640610',
        zipcode: 64120,
        text: 'ทับผึ้ง',
        value: 'ทับผึ้ง',
        name: {
          th: 'ทับผึ้ง',
          en: 'Thap Phueng',
        },
        districtId: 735,
      },
      {
        id: '640611',
        zipcode: 64120,
        text: 'บ้านซ่าน',
        value: 'บ้านซ่าน',
        name: {
          th: 'บ้านซ่าน',
          en: 'Ban San',
        },
        districtId: 735,
      },
      {
        id: '640612',
        zipcode: 64120,
        text: 'วังใหญ่',
        value: 'วังใหญ่',
        name: {
          th: 'วังใหญ่',
          en: 'Wang Yai',
        },
        districtId: 735,
      },
      {
        id: '640613',
        zipcode: 64120,
        text: 'ราวต้นจันทร์',
        value: 'ราวต้นจันทร์',
        name: {
          th: 'ราวต้นจันทร์',
          en: 'Rao Ton Chan',
        },
        districtId: 735,
      },
      {
        id: '640701',
        zipcode: 64110,
        text: 'เมืองสวรรคโลก',
        value: 'เมืองสวรรคโลก',
        name: {
          th: 'เมืองสวรรคโลก',
          en: 'Mueang Sawankhalok',
        },
        districtId: 736,
      },
      {
        id: '640702',
        zipcode: 64110,
        text: 'ในเมือง',
        value: 'ในเมือง',
        name: {
          th: 'ในเมือง',
          en: 'Nai Mueang',
        },
        districtId: 736,
      },
      {
        id: '640703',
        zipcode: 64110,
        text: 'คลองกระจง',
        value: 'คลองกระจง',
        name: {
          th: 'คลองกระจง',
          en: 'Khlong Krachong',
        },
        districtId: 736,
      },
      {
        id: '640704',
        zipcode: 64110,
        text: 'วังพิณพาทย์',
        value: 'วังพิณพาทย์',
        name: {
          th: 'วังพิณพาทย์',
          en: 'Wang Phinphat',
        },
        districtId: 736,
      },
      {
        id: '640705',
        zipcode: 64110,
        text: 'วังไม้ขอน',
        value: 'วังไม้ขอน',
        name: {
          th: 'วังไม้ขอน',
          en: 'Wang Mai Khon',
        },
        districtId: 736,
      },
      {
        id: '640706',
        zipcode: 64110,
        text: 'ย่านยาว',
        value: 'ย่านยาว',
        name: {
          th: 'ย่านยาว',
          en: 'Yan Yao',
        },
        districtId: 736,
      },
      {
        id: '640707',
        zipcode: 64110,
        text: 'นาทุ่ง',
        value: 'นาทุ่ง',
        name: {
          th: 'นาทุ่ง',
          en: 'Na Thung',
        },
        districtId: 736,
      },
      {
        id: '640708',
        zipcode: 64110,
        text: 'คลองยาง',
        value: 'คลองยาง',
        name: {
          th: 'คลองยาง',
          en: 'Khlong Yao',
        },
        districtId: 736,
      },
      {
        id: '640709',
        zipcode: 64110,
        text: 'เมืองบางยม',
        value: 'เมืองบางยม',
        name: {
          th: 'เมืองบางยม',
          en: 'Mueang Bang Yom',
        },
        districtId: 736,
      },
      {
        id: '640710',
        zipcode: 64110,
        text: 'ท่าทอง',
        value: 'ท่าทอง',
        name: {
          th: 'ท่าทอง',
          en: 'Tha Thong',
        },
        districtId: 736,
      },
      {
        id: '640711',
        zipcode: 64110,
        text: 'ปากน้ำ',
        value: 'ปากน้ำ',
        name: {
          th: 'ปากน้ำ',
          en: 'Pak Nam',
        },
        districtId: 736,
      },
      {
        id: '640712',
        zipcode: 64110,
        text: 'ป่ากุมเกาะ',
        value: 'ป่ากุมเกาะ',
        name: {
          th: 'ป่ากุมเกาะ',
          en: 'Pa Kum Ko',
        },
        districtId: 736,
      },
      {
        id: '640713',
        zipcode: 64110,
        text: 'เมืองบางขลัง',
        value: 'เมืองบางขลัง',
        name: {
          th: 'เมืองบางขลัง',
          en: 'Mueang Bang Khlang',
        },
        districtId: 736,
      },
      {
        id: '640714',
        zipcode: 64110,
        text: 'หนองกลับ',
        value: 'หนองกลับ',
        name: {
          th: 'หนองกลับ',
          en: 'Nong Klap',
        },
        districtId: 736,
      },
      {
        id: '640801',
        zipcode: 64180,
        text: 'ศรีนคร',
        value: 'ศรีนคร',
        name: {
          th: 'ศรีนคร',
          en: 'Si Nakhon',
        },
        districtId: 737,
      },
      {
        id: '640802',
        zipcode: 64180,
        text: 'นครเดิฐ',
        value: 'นครเดิฐ',
        name: {
          th: 'นครเดิฐ',
          en: 'Nakhon Doet',
        },
        districtId: 737,
      },
      {
        id: '640803',
        zipcode: 64180,
        text: 'น้ำขุม',
        value: 'น้ำขุม',
        name: {
          th: 'น้ำขุม',
          en: 'Nam Khum',
        },
        districtId: 737,
      },
      {
        id: '640804',
        zipcode: 64180,
        text: 'คลองมะพลับ',
        value: 'คลองมะพลับ',
        name: {
          th: 'คลองมะพลับ',
          en: 'Khlong Maphlap',
        },
        districtId: 737,
      },
      {
        id: '640805',
        zipcode: 64180,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 737,
      },
      {
        id: '640901',
        zipcode: 64230,
        text: 'บ้านใหม่ไชยมงคล',
        value: 'บ้านใหม่ไชยมงคล',
        name: {
          th: 'บ้านใหม่ไชยมงคล',
          en: 'Ban Mai Chai Mongkhon',
        },
        districtId: 738,
      },
      {
        id: '640902',
        zipcode: 64150,
        text: 'ไทยชนะศึก',
        value: 'ไทยชนะศึก',
        name: {
          th: 'ไทยชนะศึก',
          en: 'Thai Chana Suek',
        },
        districtId: 738,
      },
      {
        id: '640903',
        zipcode: 64150,
        text: 'ทุ่งเสลี่ยม',
        value: 'ทุ่งเสลี่ยม',
        name: {
          th: 'ทุ่งเสลี่ยม',
          en: 'Thung Saliam',
        },
        districtId: 738,
      },
      {
        id: '640904',
        zipcode: 64150,
        text: 'กลางดง',
        value: 'กลางดง',
        name: {
          th: 'กลางดง',
          en: 'Klang Dong',
        },
        districtId: 738,
      },
      {
        id: '640905',
        zipcode: 64230,
        text: 'เขาแก้วศรีสมบูรณ์',
        value: 'เขาแก้วศรีสมบูรณ์',
        name: {
          th: 'เขาแก้วศรีสมบูรณ์',
          en: 'Khaokaw Si Somboon',
        },
        districtId: 738,
      },
      {
        id: '650101',
        zipcode: 65000,
        text: 'ในเมือง',
        value: 'ในเมือง',
        name: {
          th: 'ในเมือง',
          en: 'Nai Mueang',
        },
        districtId: 739,
      },
      {
        id: '650102',
        zipcode: 65230,
        text: 'วังน้ำคู้',
        value: 'วังน้ำคู้',
        name: {
          th: 'วังน้ำคู้',
          en: 'Wang Nam Khu',
        },
        districtId: 739,
      },
      {
        id: '650103',
        zipcode: 65000,
        text: 'วัดจันทร์',
        value: 'วัดจันทร์',
        name: {
          th: 'วัดจันทร์',
          en: 'Wat Chan',
        },
        districtId: 739,
      },
      {
        id: '650104',
        zipcode: 65230,
        text: 'วัดพริก',
        value: 'วัดพริก',
        name: {
          th: 'วัดพริก',
          en: 'Wat Phrik',
        },
        districtId: 739,
      },
      {
        id: '650105',
        zipcode: 65000,
        text: 'ท่าทอง',
        value: 'ท่าทอง',
        name: {
          th: 'ท่าทอง',
          en: 'Tha Thong',
        },
        districtId: 739,
      },
      {
        id: '650106',
        zipcode: 65000,
        text: 'ท่าโพธิ์',
        value: 'ท่าโพธิ์',
        name: {
          th: 'ท่าโพธิ์',
          en: 'Tha Pho',
        },
        districtId: 739,
      },
      {
        id: '650107',
        zipcode: 65000,
        text: 'สมอแข',
        value: 'สมอแข',
        name: {
          th: 'สมอแข',
          en: 'Samo Khae',
        },
        districtId: 739,
      },
      {
        id: '650108',
        zipcode: 65000,
        text: 'ดอนทอง',
        value: 'ดอนทอง',
        name: {
          th: 'ดอนทอง',
          en: 'Don Thong',
        },
        districtId: 739,
      },
      {
        id: '650109',
        zipcode: 65000,
        text: 'บ้านป่า',
        value: 'บ้านป่า',
        name: {
          th: 'บ้านป่า',
          en: 'Ban Pa',
        },
        districtId: 739,
      },
      {
        id: '650110',
        zipcode: 65000,
        text: 'ปากโทก',
        value: 'ปากโทก',
        name: {
          th: 'ปากโทก',
          en: 'Pak Thok',
        },
        districtId: 739,
      },
      {
        id: '650111',
        zipcode: 65000,
        text: 'หัวรอ',
        value: 'หัวรอ',
        name: {
          th: 'หัวรอ',
          en: 'Hua Ro',
        },
        districtId: 739,
      },
      {
        id: '650112',
        zipcode: 65000,
        text: 'จอมทอง',
        value: 'จอมทอง',
        name: {
          th: 'จอมทอง',
          en: 'Chom Thong',
        },
        districtId: 739,
      },
      {
        id: '650113',
        zipcode: 65000,
        text: 'บ้านกร่าง',
        value: 'บ้านกร่าง',
        name: {
          th: 'บ้านกร่าง',
          en: 'Ban Krang',
        },
        districtId: 739,
      },
      {
        id: '650114',
        zipcode: 65000,
        text: 'บ้านคลอง',
        value: 'บ้านคลอง',
        name: {
          th: 'บ้านคลอง',
          en: 'Ban Khlong',
        },
        districtId: 739,
      },
      {
        id: '650115',
        zipcode: 65000,
        text: 'พลายชุมพล',
        value: 'พลายชุมพล',
        name: {
          th: 'พลายชุมพล',
          en: 'Phlai Chumphon',
        },
        districtId: 739,
      },
      {
        id: '650116',
        zipcode: 65000,
        text: 'มะขามสูง',
        value: 'มะขามสูง',
        name: {
          th: 'มะขามสูง',
          en: 'Makham Sung',
        },
        districtId: 739,
      },
      {
        id: '650117',
        zipcode: 65000,
        text: 'อรัญญิก',
        value: 'อรัญญิก',
        name: {
          th: 'อรัญญิก',
          en: 'Aranyik',
        },
        districtId: 739,
      },
      {
        id: '650118',
        zipcode: 65000,
        text: 'บึงพระ',
        value: 'บึงพระ',
        name: {
          th: 'บึงพระ',
          en: 'Bueng Phra',
        },
        districtId: 739,
      },
      {
        id: '650119',
        zipcode: 65000,
        text: 'ไผ่ขอดอน',
        value: 'ไผ่ขอดอน',
        name: {
          th: 'ไผ่ขอดอน',
          en: 'Phai Kho Don',
        },
        districtId: 739,
      },
      {
        id: '650120',
        zipcode: 65230,
        text: 'งิ้วงาม',
        value: 'งิ้วงาม',
        name: {
          th: 'งิ้วงาม',
          en: 'Ngio Ngam',
        },
        districtId: 739,
      },
      {
        id: '650201',
        zipcode: 65120,
        text: 'นครไทย',
        value: 'นครไทย',
        name: {
          th: 'นครไทย',
          en: 'Nakhon Thai',
        },
        districtId: 740,
      },
      {
        id: '650202',
        zipcode: 65120,
        text: 'หนองกะท้าว',
        value: 'หนองกะท้าว',
        name: {
          th: 'หนองกะท้าว',
          en: 'Nong Kathao',
        },
        districtId: 740,
      },
      {
        id: '650203',
        zipcode: 65120,
        text: 'บ้านแยง',
        value: 'บ้านแยง',
        name: {
          th: 'บ้านแยง',
          en: 'Ban Yaeng',
        },
        districtId: 740,
      },
      {
        id: '650204',
        zipcode: 65120,
        text: 'เนินเพิ่ม',
        value: 'เนินเพิ่ม',
        name: {
          th: 'เนินเพิ่ม',
          en: 'Noen Phoem',
        },
        districtId: 740,
      },
      {
        id: '650205',
        zipcode: 65120,
        text: 'นาบัว',
        value: 'นาบัว',
        name: {
          th: 'นาบัว',
          en: 'Na Bua',
        },
        districtId: 740,
      },
      {
        id: '650206',
        zipcode: 65120,
        text: 'นครชุม',
        value: 'นครชุม',
        name: {
          th: 'นครชุม',
          en: 'Nakhon Chum',
        },
        districtId: 740,
      },
      {
        id: '650207',
        zipcode: 65120,
        text: 'น้ำกุ่ม',
        value: 'น้ำกุ่ม',
        name: {
          th: 'น้ำกุ่ม',
          en: 'Nam Kum',
        },
        districtId: 740,
      },
      {
        id: '650208',
        zipcode: 65120,
        text: 'ยางโกลน',
        value: 'ยางโกลน',
        name: {
          th: 'ยางโกลน',
          en: 'Yang Klon',
        },
        districtId: 740,
      },
      {
        id: '650209',
        zipcode: 65120,
        text: 'บ่อโพธิ์',
        value: 'บ่อโพธิ์',
        name: {
          th: 'บ่อโพธิ์',
          en: 'Bo Pho',
        },
        districtId: 740,
      },
      {
        id: '650210',
        zipcode: 65120,
        text: 'บ้านพร้าว',
        value: 'บ้านพร้าว',
        name: {
          th: 'บ้านพร้าว',
          en: 'Ban Phrao',
        },
        districtId: 740,
      },
      {
        id: '650211',
        zipcode: 65120,
        text: 'ห้วยเฮี้ย',
        value: 'ห้วยเฮี้ย',
        name: {
          th: 'ห้วยเฮี้ย',
          en: 'Huai Hia',
        },
        districtId: 740,
      },
      {
        id: '650301',
        zipcode: 65170,
        text: 'ป่าแดง',
        value: 'ป่าแดง',
        name: {
          th: 'ป่าแดง',
          en: 'Pa Daeng',
        },
        districtId: 741,
      },
      {
        id: '650302',
        zipcode: 65170,
        text: 'ชาติตระการ',
        value: 'ชาติตระการ',
        name: {
          th: 'ชาติตระการ',
          en: 'Chat Trakan',
        },
        districtId: 741,
      },
      {
        id: '650303',
        zipcode: 65170,
        text: 'สวนเมี่ยง',
        value: 'สวนเมี่ยง',
        name: {
          th: 'สวนเมี่ยง',
          en: 'Suan Miang',
        },
        districtId: 741,
      },
      {
        id: '650304',
        zipcode: 65170,
        text: 'บ้านดง',
        value: 'บ้านดง',
        name: {
          th: 'บ้านดง',
          en: 'Ban Dong',
        },
        districtId: 741,
      },
      {
        id: '650305',
        zipcode: 65170,
        text: 'บ่อภาค',
        value: 'บ่อภาค',
        name: {
          th: 'บ่อภาค',
          en: 'Bo Phak',
        },
        districtId: 741,
      },
      {
        id: '650306',
        zipcode: 65170,
        text: 'ท่าสะแก',
        value: 'ท่าสะแก',
        name: {
          th: 'ท่าสะแก',
          en: 'Tha Sakae',
        },
        districtId: 741,
      },
      {
        id: '650401',
        zipcode: 65140,
        text: 'บางระกำ',
        value: 'บางระกำ',
        name: {
          th: 'บางระกำ',
          en: 'Bang Rakam',
        },
        districtId: 742,
      },
      {
        id: '650402',
        zipcode: 65140,
        text: 'ปลักแรด',
        value: 'ปลักแรด',
        name: {
          th: 'ปลักแรด',
          en: 'Plak Raet',
        },
        districtId: 742,
      },
      {
        id: '650403',
        zipcode: 65140,
        text: 'พันเสา',
        value: 'พันเสา',
        name: {
          th: 'พันเสา',
          en: 'Phan Sao',
        },
        districtId: 742,
      },
      {
        id: '650404',
        zipcode: 65140,
        text: 'วังอิทก',
        value: 'วังอิทก',
        name: {
          th: 'วังอิทก',
          en: 'Wang Ithok',
        },
        districtId: 742,
      },
      {
        id: '650405',
        zipcode: 65140,
        text: 'บึงกอก',
        value: 'บึงกอก',
        name: {
          th: 'บึงกอก',
          en: 'Bueng Kok',
        },
        districtId: 742,
      },
      {
        id: '650406',
        zipcode: 65140,
        text: 'หนองกุลา',
        value: 'หนองกุลา',
        name: {
          th: 'หนองกุลา',
          en: 'Nong Kula',
        },
        districtId: 742,
      },
      {
        id: '650407',
        zipcode: 65240,
        text: 'ชุมแสงสงคราม',
        value: 'ชุมแสงสงคราม',
        name: {
          th: 'ชุมแสงสงคราม',
          en: 'Chum Saeng Songkhram',
        },
        districtId: 742,
      },
      {
        id: '650408',
        zipcode: 65140,
        text: 'นิคมพัฒนา',
        value: 'นิคมพัฒนา',
        name: {
          th: 'นิคมพัฒนา',
          en: 'Nikhom Phatthana',
        },
        districtId: 742,
      },
      {
        id: '650409',
        zipcode: 65140,
        text: 'บ่อทอง',
        value: 'บ่อทอง',
        name: {
          th: 'บ่อทอง',
          en: 'Bo Thong',
        },
        districtId: 742,
      },
      {
        id: '650410',
        zipcode: 65140,
        text: 'ท่านางงาม',
        value: 'ท่านางงาม',
        name: {
          th: 'ท่านางงาม',
          en: 'Tha Nang Ngam',
        },
        districtId: 742,
      },
      {
        id: '650411',
        zipcode: 65240,
        text: 'คุยม่วง',
        value: 'คุยม่วง',
        name: {
          th: 'คุยม่วง',
          en: 'Khui Muang',
        },
        districtId: 742,
      },
      {
        id: '650501',
        zipcode: 65110,
        text: 'บางกระทุ่ม',
        value: 'บางกระทุ่ม',
        name: {
          th: 'บางกระทุ่ม',
          en: 'Bang Krathum',
        },
        districtId: 743,
      },
      {
        id: '650502',
        zipcode: 65110,
        text: 'บ้านไร่',
        value: 'บ้านไร่',
        name: {
          th: 'บ้านไร่',
          en: 'Ban Rai',
        },
        districtId: 743,
      },
      {
        id: '650503',
        zipcode: 65110,
        text: 'โคกสลุด',
        value: 'โคกสลุด',
        name: {
          th: 'โคกสลุด',
          en: 'Khok Salut',
        },
        districtId: 743,
      },
      {
        id: '650504',
        zipcode: 65110,
        text: 'สนามคลี',
        value: 'สนามคลี',
        name: {
          th: 'สนามคลี',
          en: 'Sanam Khli',
        },
        districtId: 743,
      },
      {
        id: '650505',
        zipcode: 65110,
        text: 'ท่าตาล',
        value: 'ท่าตาล',
        name: {
          th: 'ท่าตาล',
          en: 'Tha Tan',
        },
        districtId: 743,
      },
      {
        id: '650506',
        zipcode: 65110,
        text: 'ไผ่ล้อม',
        value: 'ไผ่ล้อม',
        name: {
          th: 'ไผ่ล้อม',
          en: 'Phai Lom',
        },
        districtId: 743,
      },
      {
        id: '650507',
        zipcode: 65110,
        text: 'นครป่าหมาก',
        value: 'นครป่าหมาก',
        name: {
          th: 'นครป่าหมาก',
          en: 'Nakhon Pa Mak',
        },
        districtId: 743,
      },
      {
        id: '650508',
        zipcode: 65210,
        text: 'เนินกุ่ม',
        value: 'เนินกุ่ม',
        name: {
          th: 'เนินกุ่ม',
          en: 'Noen Kum',
        },
        districtId: 743,
      },
      {
        id: '650509',
        zipcode: 65210,
        text: 'วัดตายม',
        value: 'วัดตายม',
        name: {
          th: 'วัดตายม',
          en: 'Wat Ta Yom',
        },
        districtId: 743,
      },
      {
        id: '650601',
        zipcode: 65150,
        text: 'พรหมพิราม',
        value: 'พรหมพิราม',
        name: {
          th: 'พรหมพิราม',
          en: 'Phrom Phiram',
        },
        districtId: 744,
      },
      {
        id: '650602',
        zipcode: 65150,
        text: 'ท่าช้าง',
        value: 'ท่าช้าง',
        name: {
          th: 'ท่าช้าง',
          en: 'Tha Chang',
        },
        districtId: 744,
      },
      {
        id: '650603',
        zipcode: 65180,
        text: 'วงฆ้อง',
        value: 'วงฆ้อง',
        name: {
          th: 'วงฆ้อง',
          en: 'Wong Khong',
        },
        districtId: 744,
      },
      {
        id: '650604',
        zipcode: 65150,
        text: 'มะตูม',
        value: 'มะตูม',
        name: {
          th: 'มะตูม',
          en: 'Matum',
        },
        districtId: 744,
      },
      {
        id: '650605',
        zipcode: 65150,
        text: 'หอกลอง',
        value: 'หอกลอง',
        name: {
          th: 'หอกลอง',
          en: 'Ho Klong',
        },
        districtId: 744,
      },
      {
        id: '650606',
        zipcode: 65180,
        text: 'ศรีภิรมย์',
        value: 'ศรีภิรมย์',
        name: {
          th: 'ศรีภิรมย์',
          en: 'Si Phirom',
        },
        districtId: 744,
      },
      {
        id: '650607',
        zipcode: 65180,
        text: 'ตลุกเทียม',
        value: 'ตลุกเทียม',
        name: {
          th: 'ตลุกเทียม',
          en: 'Taluk Thiam',
        },
        districtId: 744,
      },
      {
        id: '650608',
        zipcode: 65150,
        text: 'วังวน',
        value: 'วังวน',
        name: {
          th: 'วังวน',
          en: 'Wang Won',
        },
        districtId: 744,
      },
      {
        id: '650609',
        zipcode: 65150,
        text: 'หนองแขม',
        value: 'หนองแขม',
        name: {
          th: 'หนองแขม',
          en: 'Nong Khaem',
        },
        districtId: 744,
      },
      {
        id: '650610',
        zipcode: 65180,
        text: 'มะต้อง',
        value: 'มะต้อง',
        name: {
          th: 'มะต้อง',
          en: 'Matong',
        },
        districtId: 744,
      },
      {
        id: '650611',
        zipcode: 65150,
        text: 'ทับยายเชียง',
        value: 'ทับยายเชียง',
        name: {
          th: 'ทับยายเชียง',
          en: 'Thap Yai Chiang',
        },
        districtId: 744,
      },
      {
        id: '650612',
        zipcode: 65180,
        text: 'ดงประคำ',
        value: 'ดงประคำ',
        name: {
          th: 'ดงประคำ',
          en: 'Dong Prakham',
        },
        districtId: 744,
      },
      {
        id: '650701',
        zipcode: 65160,
        text: 'วัดโบสถ์',
        value: 'วัดโบสถ์',
        name: {
          th: 'วัดโบสถ์',
          en: 'Wat Bot',
        },
        districtId: 745,
      },
      {
        id: '650702',
        zipcode: 65160,
        text: 'ท่างาม',
        value: 'ท่างาม',
        name: {
          th: 'ท่างาม',
          en: 'Tha Ngam',
        },
        districtId: 745,
      },
      {
        id: '650703',
        zipcode: 65160,
        text: 'ท้อแท้',
        value: 'ท้อแท้',
        name: {
          th: 'ท้อแท้',
          en: 'Thothae',
        },
        districtId: 745,
      },
      {
        id: '650704',
        zipcode: 65160,
        text: 'บ้านยาง',
        value: 'บ้านยาง',
        name: {
          th: 'บ้านยาง',
          en: 'Ban Yang',
        },
        districtId: 745,
      },
      {
        id: '650705',
        zipcode: 65160,
        text: 'หินลาด',
        value: 'หินลาด',
        name: {
          th: 'หินลาด',
          en: 'Hin Lat',
        },
        districtId: 745,
      },
      {
        id: '650706',
        zipcode: 65160,
        text: 'คันโช้ง',
        value: 'คันโช้ง',
        name: {
          th: 'คันโช้ง',
          en: 'Khan Chong',
        },
        districtId: 745,
      },
      {
        id: '650801',
        zipcode: 65130,
        text: 'วังทอง',
        value: 'วังทอง',
        name: {
          th: 'วังทอง',
          en: 'Wang Thong',
        },
        districtId: 746,
      },
      {
        id: '650802',
        zipcode: 65130,
        text: 'พันชาลี',
        value: 'พันชาลี',
        name: {
          th: 'พันชาลี',
          en: 'Phan Chali',
        },
        districtId: 746,
      },
      {
        id: '650803',
        zipcode: 65130,
        text: 'แม่ระกา',
        value: 'แม่ระกา',
        name: {
          th: 'แม่ระกา',
          en: 'Mae Raka',
        },
        districtId: 746,
      },
      {
        id: '650804',
        zipcode: 65220,
        text: 'บ้านกลาง',
        value: 'บ้านกลาง',
        name: {
          th: 'บ้านกลาง',
          en: 'Ban Klang',
        },
        districtId: 746,
      },
      {
        id: '650805',
        zipcode: 65130,
        text: 'วังพิกุล',
        value: 'วังพิกุล',
        name: {
          th: 'วังพิกุล',
          en: 'Wang Phikun',
        },
        districtId: 746,
      },
      {
        id: '650806',
        zipcode: 65220,
        text: 'แก่งโสภา',
        value: 'แก่งโสภา',
        name: {
          th: 'แก่งโสภา',
          en: 'Kaeng Sopha',
        },
        districtId: 746,
      },
      {
        id: '650807',
        zipcode: 65130,
        text: 'ท่าหมื่นราม',
        value: 'ท่าหมื่นราม',
        name: {
          th: 'ท่าหมื่นราม',
          en: 'Tha Muen Ram',
        },
        districtId: 746,
      },
      {
        id: '650808',
        zipcode: 65130,
        text: 'วังนกแอ่น',
        value: 'วังนกแอ่น',
        name: {
          th: 'วังนกแอ่น',
          en: 'Wang Nok Aen',
        },
        districtId: 746,
      },
      {
        id: '650809',
        zipcode: 65130,
        text: 'หนองพระ',
        value: 'หนองพระ',
        name: {
          th: 'หนองพระ',
          en: 'Nong Phra',
        },
        districtId: 746,
      },
      {
        id: '650810',
        zipcode: 65130,
        text: 'ชัยนาม',
        value: 'ชัยนาม',
        name: {
          th: 'ชัยนาม',
          en: 'Chaiyanam',
        },
        districtId: 746,
      },
      {
        id: '650811',
        zipcode: 65130,
        text: 'ดินทอง',
        value: 'ดินทอง',
        name: {
          th: 'ดินทอง',
          en: 'Din Thong',
        },
        districtId: 746,
      },
      {
        id: '650901',
        zipcode: 65190,
        text: 'ชมพู',
        value: 'ชมพู',
        name: {
          th: 'ชมพู',
          en: 'Chomphu',
        },
        districtId: 747,
      },
      {
        id: '650902',
        zipcode: 65190,
        text: 'บ้านมุง',
        value: 'บ้านมุง',
        name: {
          th: 'บ้านมุง',
          en: 'Ban Mung',
        },
        districtId: 747,
      },
      {
        id: '650903',
        zipcode: 65190,
        text: 'ไทรย้อย',
        value: 'ไทรย้อย',
        name: {
          th: 'ไทรย้อย',
          en: 'Sai Yoi',
        },
        districtId: 747,
      },
      {
        id: '650904',
        zipcode: 65190,
        text: 'วังโพรง',
        value: 'วังโพรง',
        name: {
          th: 'วังโพรง',
          en: 'Wang Phrong',
        },
        districtId: 747,
      },
      {
        id: '650905',
        zipcode: 65190,
        text: 'บ้านน้อยซุ้มขี้เหล็ก',
        value: 'บ้านน้อยซุ้มขี้เหล็ก',
        name: {
          th: 'บ้านน้อยซุ้มขี้เหล็ก',
          en: 'Ban Noi Sum Khilek',
        },
        districtId: 747,
      },
      {
        id: '650906',
        zipcode: 65190,
        text: 'เนินมะปราง',
        value: 'เนินมะปราง',
        name: {
          th: 'เนินมะปราง',
          en: 'Noen Maprang',
        },
        districtId: 747,
      },
      {
        id: '650907',
        zipcode: 65190,
        text: 'วังยาง',
        value: 'วังยาง',
        name: {
          th: 'วังยาง',
          en: 'Wang Yang',
        },
        districtId: 747,
      },
      {
        id: '650908',
        zipcode: 65190,
        text: 'โคกแหลม',
        value: 'โคกแหลม',
        name: {
          th: 'โคกแหลม',
          en: 'Khok Laem',
        },
        districtId: 747,
      },
      {
        id: '660101',
        zipcode: 66000,
        text: 'ในเมือง',
        value: 'ในเมือง',
        name: {
          th: 'ในเมือง',
          en: 'Nai Mueang',
        },
        districtId: 748,
      },
      {
        id: '660102',
        zipcode: 66000,
        text: 'ไผ่ขวาง',
        value: 'ไผ่ขวาง',
        name: {
          th: 'ไผ่ขวาง',
          en: 'Phai Khwang',
        },
        districtId: 748,
      },
      {
        id: '660103',
        zipcode: 66000,
        text: 'ย่านยาว',
        value: 'ย่านยาว',
        name: {
          th: 'ย่านยาว',
          en: 'Yan Yao',
        },
        districtId: 748,
      },
      {
        id: '660104',
        zipcode: 66000,
        text: 'ท่าฬ่อ',
        value: 'ท่าฬ่อ',
        name: {
          th: 'ท่าฬ่อ',
          en: 'Tha Lo',
        },
        districtId: 748,
      },
      {
        id: '660105',
        zipcode: 66000,
        text: 'ปากทาง',
        value: 'ปากทาง',
        name: {
          th: 'ปากทาง',
          en: 'Pak Thang',
        },
        districtId: 748,
      },
      {
        id: '660106',
        zipcode: 66000,
        text: 'คลองคะเชนทร์',
        value: 'คลองคะเชนทร์',
        name: {
          th: 'คลองคะเชนทร์',
          en: 'Khlong Khachen',
        },
        districtId: 748,
      },
      {
        id: '660107',
        zipcode: 66000,
        text: 'โรงช้าง',
        value: 'โรงช้าง',
        name: {
          th: 'โรงช้าง',
          en: 'Rong Chang',
        },
        districtId: 748,
      },
      {
        id: '660108',
        zipcode: 66000,
        text: 'เมืองเก่า',
        value: 'เมืองเก่า',
        name: {
          th: 'เมืองเก่า',
          en: 'Mueang Kao',
        },
        districtId: 748,
      },
      {
        id: '660109',
        zipcode: 66000,
        text: 'ท่าหลวง',
        value: 'ท่าหลวง',
        name: {
          th: 'ท่าหลวง',
          en: 'Tha Luang',
        },
        districtId: 748,
      },
      {
        id: '660110',
        zipcode: 66000,
        text: 'บ้านบุ่ง',
        value: 'บ้านบุ่ง',
        name: {
          th: 'บ้านบุ่ง',
          en: 'Ban Bung',
        },
        districtId: 748,
      },
      {
        id: '660111',
        zipcode: 66000,
        text: 'ฆะมัง',
        value: 'ฆะมัง',
        name: {
          th: 'ฆะมัง',
          en: 'Khamang',
        },
        districtId: 748,
      },
      {
        id: '660112',
        zipcode: 66170,
        text: 'ดงป่าคำ',
        value: 'ดงป่าคำ',
        name: {
          th: 'ดงป่าคำ',
          en: 'Dong Pa Kham',
        },
        districtId: 748,
      },
      {
        id: '660113',
        zipcode: 66170,
        text: 'หัวดง',
        value: 'หัวดง',
        name: {
          th: 'หัวดง',
          en: 'Hua Dong',
        },
        districtId: 748,
      },
      {
        id: '660115',
        zipcode: 66000,
        text: 'ป่ามะคาบ',
        value: 'ป่ามะคาบ',
        name: {
          th: 'ป่ามะคาบ',
          en: 'Pa Makhap',
        },
        districtId: 748,
      },
      {
        id: '660119',
        zipcode: 66000,
        text: 'สายคำโห้',
        value: 'สายคำโห้',
        name: {
          th: 'สายคำโห้',
          en: 'Sai Kham Ho',
        },
        districtId: 748,
      },
      {
        id: '660120',
        zipcode: 66170,
        text: 'ดงกลาง',
        value: 'ดงกลาง',
        name: {
          th: 'ดงกลาง',
          en: 'Dong Klang',
        },
        districtId: 748,
      },
      {
        id: '660201',
        zipcode: 66180,
        text: 'วังทรายพูน',
        value: 'วังทรายพูน',
        name: {
          th: 'วังทรายพูน',
          en: 'Wang Sai Phun',
        },
        districtId: 749,
      },
      {
        id: '660202',
        zipcode: 66180,
        text: 'หนองปลาไหล',
        value: 'หนองปลาไหล',
        name: {
          th: 'หนองปลาไหล',
          en: 'Nong Pla Lai',
        },
        districtId: 749,
      },
      {
        id: '660203',
        zipcode: 66180,
        text: 'หนองพระ',
        value: 'หนองพระ',
        name: {
          th: 'หนองพระ',
          en: 'Nong Phra',
        },
        districtId: 749,
      },
      {
        id: '660204',
        zipcode: 66180,
        text: 'หนองปล้อง',
        value: 'หนองปล้อง',
        name: {
          th: 'หนองปล้อง',
          en: 'Nong Plong',
        },
        districtId: 749,
      },
      {
        id: '660301',
        zipcode: 66190,
        text: 'โพธิ์ประทับช้าง',
        value: 'โพธิ์ประทับช้าง',
        name: {
          th: 'โพธิ์ประทับช้าง',
          en: 'Pho Prathap Chang',
        },
        districtId: 750,
      },
      {
        id: '660302',
        zipcode: 66190,
        text: 'ไผ่ท่าโพ',
        value: 'ไผ่ท่าโพ',
        name: {
          th: 'ไผ่ท่าโพ',
          en: 'Phai Tha Pho',
        },
        districtId: 750,
      },
      {
        id: '660303',
        zipcode: 66190,
        text: 'วังจิก',
        value: 'วังจิก',
        name: {
          th: 'วังจิก',
          en: 'Wang Chik',
        },
        districtId: 750,
      },
      {
        id: '660304',
        zipcode: 66190,
        text: 'ไผ่รอบ',
        value: 'ไผ่รอบ',
        name: {
          th: 'ไผ่รอบ',
          en: 'Phai Rop',
        },
        districtId: 750,
      },
      {
        id: '660305',
        zipcode: 66190,
        text: 'ดงเสือเหลือง',
        value: 'ดงเสือเหลือง',
        name: {
          th: 'ดงเสือเหลือง',
          en: 'Dong Suea Lueang',
        },
        districtId: 750,
      },
      {
        id: '660306',
        zipcode: 66190,
        text: 'เนินสว่าง',
        value: 'เนินสว่าง',
        name: {
          th: 'เนินสว่าง',
          en: 'Noen Sawang',
        },
        districtId: 750,
      },
      {
        id: '660307',
        zipcode: 66190,
        text: 'ทุ่งใหญ่',
        value: 'ทุ่งใหญ่',
        name: {
          th: 'ทุ่งใหญ่',
          en: 'Thung Yai',
        },
        districtId: 750,
      },
      {
        id: '660401',
        zipcode: 66110,
        text: 'ตะพานหิน',
        value: 'ตะพานหิน',
        name: {
          th: 'ตะพานหิน',
          en: 'Taphan Hin',
        },
        districtId: 751,
      },
      {
        id: '660402',
        zipcode: 66110,
        text: 'งิ้วราย',
        value: 'งิ้วราย',
        name: {
          th: 'งิ้วราย',
          en: 'Ngio Rai',
        },
        districtId: 751,
      },
      {
        id: '660403',
        zipcode: 66110,
        text: 'ห้วยเกตุ',
        value: 'ห้วยเกตุ',
        name: {
          th: 'ห้วยเกตุ',
          en: 'Huai Ket',
        },
        districtId: 751,
      },
      {
        id: '660404',
        zipcode: 66110,
        text: 'ไทรโรงโขน',
        value: 'ไทรโรงโขน',
        name: {
          th: 'ไทรโรงโขน',
          en: 'Sai Rong Khon',
        },
        districtId: 751,
      },
      {
        id: '660405',
        zipcode: 66110,
        text: 'หนองพยอม',
        value: 'หนองพยอม',
        name: {
          th: 'หนองพยอม',
          en: 'Nong Phayom',
        },
        districtId: 751,
      },
      {
        id: '660406',
        zipcode: 66150,
        text: 'ทุ่งโพธิ์',
        value: 'ทุ่งโพธิ์',
        name: {
          th: 'ทุ่งโพธิ์',
          en: 'Tung Pho',
        },
        districtId: 751,
      },
      {
        id: '660407',
        zipcode: 66110,
        text: 'ดงตะขบ',
        value: 'ดงตะขบ',
        name: {
          th: 'ดงตะขบ',
          en: 'Dong Takhop',
        },
        districtId: 751,
      },
      {
        id: '660408',
        zipcode: 66110,
        text: 'คลองคูณ',
        value: 'คลองคูณ',
        name: {
          th: 'คลองคูณ',
          en: 'Khlong Khun',
        },
        districtId: 751,
      },
      {
        id: '660409',
        zipcode: 66110,
        text: 'วังสำโรง',
        value: 'วังสำโรง',
        name: {
          th: 'วังสำโรง',
          en: 'Wang Samrong',
        },
        districtId: 751,
      },
      {
        id: '660410',
        zipcode: 66110,
        text: 'วังหว้า',
        value: 'วังหว้า',
        name: {
          th: 'วังหว้า',
          en: 'Wang Wa',
        },
        districtId: 751,
      },
      {
        id: '660411',
        zipcode: 66150,
        text: 'วังหลุม',
        value: 'วังหลุม',
        name: {
          th: 'วังหลุม',
          en: 'Wang Lum',
        },
        districtId: 751,
      },
      {
        id: '660412',
        zipcode: 66110,
        text: 'ทับหมัน',
        value: 'ทับหมัน',
        name: {
          th: 'ทับหมัน',
          en: 'Thap Man',
        },
        districtId: 751,
      },
      {
        id: '660413',
        zipcode: 66110,
        text: 'ไผ่หลวง',
        value: 'ไผ่หลวง',
        name: {
          th: 'ไผ่หลวง',
          en: 'Phai Luang',
        },
        districtId: 751,
      },
      {
        id: '660501',
        zipcode: 66120,
        text: 'บางมูลนาก',
        value: 'บางมูลนาก',
        name: {
          th: 'บางมูลนาก',
          en: 'Bang Mun Nak',
        },
        districtId: 752,
      },
      {
        id: '660502',
        zipcode: 66120,
        text: 'บางไผ่',
        value: 'บางไผ่',
        name: {
          th: 'บางไผ่',
          en: 'Bang Phai',
        },
        districtId: 752,
      },
      {
        id: '660503',
        zipcode: 66120,
        text: 'หอไกร',
        value: 'หอไกร',
        name: {
          th: 'หอไกร',
          en: 'Ho Krai',
        },
        districtId: 752,
      },
      {
        id: '660504',
        zipcode: 66120,
        text: 'เนินมะกอก',
        value: 'เนินมะกอก',
        name: {
          th: 'เนินมะกอก',
          en: 'Noen Makok',
        },
        districtId: 752,
      },
      {
        id: '660505',
        zipcode: 66120,
        text: 'วังสำโรง',
        value: 'วังสำโรง',
        name: {
          th: 'วังสำโรง',
          en: 'Wang Samrong',
        },
        districtId: 752,
      },
      {
        id: '660506',
        zipcode: 66120,
        text: 'ภูมิ',
        value: 'ภูมิ',
        name: {
          th: 'ภูมิ',
          en: 'Phum',
        },
        districtId: 752,
      },
      {
        id: '660507',
        zipcode: 66120,
        text: 'วังกรด',
        value: 'วังกรด',
        name: {
          th: 'วังกรด',
          en: 'Wang Krot',
        },
        districtId: 752,
      },
      {
        id: '660508',
        zipcode: 66120,
        text: 'ห้วยเขน',
        value: 'ห้วยเขน',
        name: {
          th: 'ห้วยเขน',
          en: 'Huai Khen',
        },
        districtId: 752,
      },
      {
        id: '660509',
        zipcode: 66210,
        text: 'วังตะกู',
        value: 'วังตะกู',
        name: {
          th: 'วังตะกู',
          en: 'Wang Taku',
        },
        districtId: 752,
      },
      {
        id: '660514',
        zipcode: 66120,
        text: 'ลำประดา',
        value: 'ลำประดา',
        name: {
          th: 'ลำประดา',
          en: 'Lam Prad',
        },
        districtId: 752,
      },
      {
        id: '660601',
        zipcode: 66130,
        text: 'โพทะเล',
        value: 'โพทะเล',
        name: {
          th: 'โพทะเล',
          en: 'Pho Thale',
        },
        districtId: 753,
      },
      {
        id: '660602',
        zipcode: 66130,
        text: 'ท้ายน้ำ',
        value: 'ท้ายน้ำ',
        name: {
          th: 'ท้ายน้ำ',
          en: 'Thai Nam',
        },
        districtId: 753,
      },
      {
        id: '660603',
        zipcode: 66130,
        text: 'ทะนง',
        value: 'ทะนง',
        name: {
          th: 'ทะนง',
          en: 'Thanong',
        },
        districtId: 753,
      },
      {
        id: '660604',
        zipcode: 66130,
        text: 'ท่าบัว',
        value: 'ท่าบัว',
        name: {
          th: 'ท่าบัว',
          en: 'Tha Bua',
        },
        districtId: 753,
      },
      {
        id: '660605',
        zipcode: 66130,
        text: 'ทุ่งน้อย',
        value: 'ทุ่งน้อย',
        name: {
          th: 'ทุ่งน้อย',
          en: 'Thung Noi',
        },
        districtId: 753,
      },
      {
        id: '660606',
        zipcode: 66130,
        text: 'ท่าขมิ้น',
        value: 'ท่าขมิ้น',
        name: {
          th: 'ท่าขมิ้น',
          en: 'Tha Khamin',
        },
        districtId: 753,
      },
      {
        id: '660607',
        zipcode: 66130,
        text: 'ท่าเสา',
        value: 'ท่าเสา',
        name: {
          th: 'ท่าเสา',
          en: 'Tha Sao',
        },
        districtId: 753,
      },
      {
        id: '660608',
        zipcode: 66130,
        text: 'บางคลาน',
        value: 'บางคลาน',
        name: {
          th: 'บางคลาน',
          en: 'Bang Khlan',
        },
        districtId: 753,
      },
      {
        id: '660611',
        zipcode: 66130,
        text: 'ท่านั่ง',
        value: 'ท่านั่ง',
        name: {
          th: 'ท่านั่ง',
          en: 'Tha Nang',
        },
        districtId: 753,
      },
      {
        id: '660612',
        zipcode: 66130,
        text: 'บ้านน้อย',
        value: 'บ้านน้อย',
        name: {
          th: 'บ้านน้อย',
          en: 'Ban Noi',
        },
        districtId: 753,
      },
      {
        id: '660613',
        zipcode: 66130,
        text: 'วัดขวาง',
        value: 'วัดขวาง',
        name: {
          th: 'วัดขวาง',
          en: 'Wat Khwang',
        },
        districtId: 753,
      },
      {
        id: '660701',
        zipcode: 66140,
        text: 'สามง่าม',
        value: 'สามง่าม',
        name: {
          th: 'สามง่าม',
          en: 'Sam Ngam',
        },
        districtId: 754,
      },
      {
        id: '660702',
        zipcode: 66140,
        text: 'กำแพงดิน',
        value: 'กำแพงดิน',
        name: {
          th: 'กำแพงดิน',
          en: 'Kamphaeng Din',
        },
        districtId: 754,
      },
      {
        id: '660703',
        zipcode: 66140,
        text: 'รังนก',
        value: 'รังนก',
        name: {
          th: 'รังนก',
          en: 'Rang Nok',
        },
        districtId: 754,
      },
      {
        id: '660706',
        zipcode: 66140,
        text: 'เนินปอ',
        value: 'เนินปอ',
        name: {
          th: 'เนินปอ',
          en: 'Noen Po',
        },
        districtId: 754,
      },
      {
        id: '660707',
        zipcode: 66140,
        text: 'หนองโสน',
        value: 'หนองโสน',
        name: {
          th: 'หนองโสน',
          en: 'Nong Sano',
        },
        districtId: 754,
      },
      {
        id: '660801',
        zipcode: 66150,
        text: 'ทับคล้อ',
        value: 'ทับคล้อ',
        name: {
          th: 'ทับคล้อ',
          en: 'Thap Khlo',
        },
        districtId: 755,
      },
      {
        id: '660802',
        zipcode: 66230,
        text: 'เขาทราย',
        value: 'เขาทราย',
        name: {
          th: 'เขาทราย',
          en: 'Khao Sai',
        },
        districtId: 755,
      },
      {
        id: '660803',
        zipcode: 66230,
        text: 'เขาเจ็ดลูก',
        value: 'เขาเจ็ดลูก',
        name: {
          th: 'เขาเจ็ดลูก',
          en: 'Khao Chet Luk',
        },
        districtId: 755,
      },
      {
        id: '660804',
        zipcode: 66150,
        text: 'ท้ายทุ่ง',
        value: 'ท้ายทุ่ง',
        name: {
          th: 'ท้ายทุ่ง',
          en: 'Tai Toong',
        },
        districtId: 755,
      },
      {
        id: '660901',
        zipcode: 66160,
        text: 'สากเหล็ก',
        value: 'สากเหล็ก',
        name: {
          th: 'สากเหล็ก',
          en: 'Sak Lek',
        },
        districtId: 756,
      },
      {
        id: '660902',
        zipcode: 66160,
        text: 'ท่าเยี่ยม',
        value: 'ท่าเยี่ยม',
        name: {
          th: 'ท่าเยี่ยม',
          en: 'Tha Yiam',
        },
        districtId: 756,
      },
      {
        id: '660903',
        zipcode: 66160,
        text: 'คลองทราย',
        value: 'คลองทราย',
        name: {
          th: 'คลองทราย',
          en: 'Khlong Sai',
        },
        districtId: 756,
      },
      {
        id: '660904',
        zipcode: 66160,
        text: 'หนองหญ้าไทร',
        value: 'หนองหญ้าไทร',
        name: {
          th: 'หนองหญ้าไทร',
          en: 'Nong Ya Sai',
        },
        districtId: 756,
      },
      {
        id: '660905',
        zipcode: 66160,
        text: 'วังทับไทร',
        value: 'วังทับไทร',
        name: {
          th: 'วังทับไทร',
          en: 'Wang Thap Sai',
        },
        districtId: 756,
      },
      {
        id: '661001',
        zipcode: 66130,
        text: 'ห้วยแก้ว',
        value: 'ห้วยแก้ว',
        name: {
          th: 'ห้วยแก้ว',
          en: 'Huai Kaeo',
        },
        districtId: 757,
      },
      {
        id: '661002',
        zipcode: 66130,
        text: 'โพธิ์ไทรงาม',
        value: 'โพธิ์ไทรงาม',
        name: {
          th: 'โพธิ์ไทรงาม',
          en: 'Pho Sai Ngam',
        },
        districtId: 757,
      },
      {
        id: '661003',
        zipcode: 66130,
        text: 'แหลมรัง',
        value: 'แหลมรัง',
        name: {
          th: 'แหลมรัง',
          en: 'Laem Rang',
        },
        districtId: 757,
      },
      {
        id: '661004',
        zipcode: 66130,
        text: 'บางลาย',
        value: 'บางลาย',
        name: {
          th: 'บางลาย',
          en: 'Bang Lai',
        },
        districtId: 757,
      },
      {
        id: '661005',
        zipcode: 66130,
        text: 'บึงนาราง',
        value: 'บึงนาราง',
        name: {
          th: 'บึงนาราง',
          en: 'Bueng Na Rang',
        },
        districtId: 757,
      },
      {
        id: '661101',
        zipcode: 66210,
        text: 'วังงิ้วใต้',
        value: 'วังงิ้วใต้',
        name: {
          th: 'วังงิ้วใต้',
          en: 'Wang Ngio Tai',
        },
        districtId: 758,
      },
      {
        id: '661102',
        zipcode: 66210,
        text: 'วังงิ้ว',
        value: 'วังงิ้ว',
        name: {
          th: 'วังงิ้ว',
          en: 'Wang Ngio',
        },
        districtId: 758,
      },
      {
        id: '661103',
        zipcode: 66210,
        text: 'ห้วยร่วม',
        value: 'ห้วยร่วม',
        name: {
          th: 'ห้วยร่วม',
          en: 'Huai Ruam',
        },
        districtId: 758,
      },
      {
        id: '661104',
        zipcode: 66210,
        text: 'ห้วยพุก',
        value: 'ห้วยพุก',
        name: {
          th: 'ห้วยพุก',
          en: 'Huai Phuk',
        },
        districtId: 758,
      },
      {
        id: '661105',
        zipcode: 66210,
        text: 'สำนักขุนเณร',
        value: 'สำนักขุนเณร',
        name: {
          th: 'สำนักขุนเณร',
          en: 'Samnak Khun Nen',
        },
        districtId: 758,
      },
      {
        id: '661201',
        zipcode: 66140,
        text: 'บ้านนา',
        value: 'บ้านนา',
        name: {
          th: 'บ้านนา',
          en: 'Ban Na',
        },
        districtId: 759,
      },
      {
        id: '661202',
        zipcode: 66140,
        text: 'บึงบัว',
        value: 'บึงบัว',
        name: {
          th: 'บึงบัว',
          en: 'Bueng Bua',
        },
        districtId: 759,
      },
      {
        id: '661203',
        zipcode: 66140,
        text: 'วังโมกข์',
        value: 'วังโมกข์',
        name: {
          th: 'วังโมกข์',
          en: 'Wang Mok',
        },
        districtId: 759,
      },
      {
        id: '661204',
        zipcode: 66220,
        text: 'หนองหลุม',
        value: 'หนองหลุม',
        name: {
          th: 'หนองหลุม',
          en: 'Nong Lum',
        },
        districtId: 759,
      },
      {
        id: '670101',
        zipcode: 67000,
        text: 'ในเมือง',
        value: 'ในเมือง',
        name: {
          th: 'ในเมือง',
          en: 'Nai Mueang',
        },
        districtId: 760,
      },
      {
        id: '670102',
        zipcode: 67000,
        text: 'ตะเบาะ',
        value: 'ตะเบาะ',
        name: {
          th: 'ตะเบาะ',
          en: 'Tabo',
        },
        districtId: 760,
      },
      {
        id: '670103',
        zipcode: 67000,
        text: 'บ้านโตก',
        value: 'บ้านโตก',
        name: {
          th: 'บ้านโตก',
          en: 'Ban Tok',
        },
        districtId: 760,
      },
      {
        id: '670104',
        zipcode: 67000,
        text: 'สะเดียง',
        value: 'สะเดียง',
        name: {
          th: 'สะเดียง',
          en: 'Sadiang',
        },
        districtId: 760,
      },
      {
        id: '670105',
        zipcode: 67000,
        text: 'ป่าเลา',
        value: 'ป่าเลา',
        name: {
          th: 'ป่าเลา',
          en: 'Pa Lao',
        },
        districtId: 760,
      },
      {
        id: '670106',
        zipcode: 67000,
        text: 'นางั่ว',
        value: 'นางั่ว',
        name: {
          th: 'นางั่ว',
          en: 'Na Ngua',
        },
        districtId: 760,
      },
      {
        id: '670107',
        zipcode: 67250,
        text: 'ท่าพล',
        value: 'ท่าพล',
        name: {
          th: 'ท่าพล',
          en: 'Tha Phon',
        },
        districtId: 760,
      },
      {
        id: '670108',
        zipcode: 67000,
        text: 'ดงมูลเหล็ก',
        value: 'ดงมูลเหล็ก',
        name: {
          th: 'ดงมูลเหล็ก',
          en: 'Dong Mun Lek',
        },
        districtId: 760,
      },
      {
        id: '670109',
        zipcode: 67000,
        text: 'บ้านโคก',
        value: 'บ้านโคก',
        name: {
          th: 'บ้านโคก',
          en: 'Ban Khok',
        },
        districtId: 760,
      },
      {
        id: '670110',
        zipcode: 67000,
        text: 'ชอนไพร',
        value: 'ชอนไพร',
        name: {
          th: 'ชอนไพร',
          en: 'Chon Phrai',
        },
        districtId: 760,
      },
      {
        id: '670111',
        zipcode: 67000,
        text: 'นาป่า',
        value: 'นาป่า',
        name: {
          th: 'นาป่า',
          en: 'Na Pa',
        },
        districtId: 760,
      },
      {
        id: '670112',
        zipcode: 67210,
        text: 'นายม',
        value: 'นายม',
        name: {
          th: 'นายม',
          en: 'Na Yom',
        },
        districtId: 760,
      },
      {
        id: '670113',
        zipcode: 67210,
        text: 'วังชมภู',
        value: 'วังชมภู',
        name: {
          th: 'วังชมภู',
          en: 'Wang Chomphu',
        },
        districtId: 760,
      },
      {
        id: '670114',
        zipcode: 67000,
        text: 'น้ำร้อน',
        value: 'น้ำร้อน',
        name: {
          th: 'น้ำร้อน',
          en: 'Nam Ron',
        },
        districtId: 760,
      },
      {
        id: '670115',
        zipcode: 67210,
        text: 'ห้วยสะแก',
        value: 'ห้วยสะแก',
        name: {
          th: 'ห้วยสะแก',
          en: 'Huai Sakae',
        },
        districtId: 760,
      },
      {
        id: '670116',
        zipcode: 67000,
        text: 'ห้วยใหญ่',
        value: 'ห้วยใหญ่',
        name: {
          th: 'ห้วยใหญ่',
          en: 'Huai Yai',
        },
        districtId: 760,
      },
      {
        id: '670117',
        zipcode: 67210,
        text: 'ระวิง',
        value: 'ระวิง',
        name: {
          th: 'ระวิง',
          en: 'Rawing',
        },
        districtId: 760,
      },
      {
        id: '670201',
        zipcode: 67150,
        text: 'ชนแดน',
        value: 'ชนแดน',
        name: {
          th: 'ชนแดน',
          en: 'Chon Daen',
        },
        districtId: 761,
      },
      {
        id: '670202',
        zipcode: 67190,
        text: 'ดงขุย',
        value: 'ดงขุย',
        name: {
          th: 'ดงขุย',
          en: 'Dong Khui',
        },
        districtId: 761,
      },
      {
        id: '670203',
        zipcode: 67150,
        text: 'ท่าข้าม',
        value: 'ท่าข้าม',
        name: {
          th: 'ท่าข้าม',
          en: 'Tha Kham',
        },
        districtId: 761,
      },
      {
        id: '670204',
        zipcode: 67150,
        text: 'พุทธบาท',
        value: 'พุทธบาท',
        name: {
          th: 'พุทธบาท',
          en: 'Phutthabat',
        },
        districtId: 761,
      },
      {
        id: '670205',
        zipcode: 67150,
        text: 'ลาดแค',
        value: 'ลาดแค',
        name: {
          th: 'ลาดแค',
          en: 'Lat Khae',
        },
        districtId: 761,
      },
      {
        id: '670206',
        zipcode: 67190,
        text: 'บ้านกล้วย',
        value: 'บ้านกล้วย',
        name: {
          th: 'บ้านกล้วย',
          en: 'Ban Kluai',
        },
        districtId: 761,
      },
      {
        id: '670208',
        zipcode: 67150,
        text: 'ซับพุทรา',
        value: 'ซับพุทรา',
        name: {
          th: 'ซับพุทรา',
          en: 'Sap Phutsa',
        },
        districtId: 761,
      },
      {
        id: '670209',
        zipcode: 67190,
        text: 'ตะกุดไร',
        value: 'ตะกุดไร',
        name: {
          th: 'ตะกุดไร',
          en: 'Takut Rai',
        },
        districtId: 761,
      },
      {
        id: '670210',
        zipcode: 67150,
        text: 'ศาลาลาย',
        value: 'ศาลาลาย',
        name: {
          th: 'ศาลาลาย',
          en: 'Sala Lai',
        },
        districtId: 761,
      },
      {
        id: '670301',
        zipcode: 67110,
        text: 'หล่มสัก',
        value: 'หล่มสัก',
        name: {
          th: 'หล่มสัก',
          en: 'Lom Sak',
        },
        districtId: 762,
      },
      {
        id: '670302',
        zipcode: 67110,
        text: 'วัดป่า',
        value: 'วัดป่า',
        name: {
          th: 'วัดป่า',
          en: 'Wat Pa',
        },
        districtId: 762,
      },
      {
        id: '670303',
        zipcode: 67110,
        text: 'ตาลเดี่ยว',
        value: 'ตาลเดี่ยว',
        name: {
          th: 'ตาลเดี่ยว',
          en: 'Tan Diao',
        },
        districtId: 762,
      },
      {
        id: '670304',
        zipcode: 67110,
        text: 'ฝายนาแซง',
        value: 'ฝายนาแซง',
        name: {
          th: 'ฝายนาแซง',
          en: 'Fai Na Saeng',
        },
        districtId: 762,
      },
      {
        id: '670305',
        zipcode: 67110,
        text: 'หนองสว่าง',
        value: 'หนองสว่าง',
        name: {
          th: 'หนองสว่าง',
          en: 'Nong Sawang',
        },
        districtId: 762,
      },
      {
        id: '670306',
        zipcode: 67110,
        text: 'น้ำเฮี้ย',
        value: 'น้ำเฮี้ย',
        name: {
          th: 'น้ำเฮี้ย',
          en: 'Nam Hia',
        },
        districtId: 762,
      },
      {
        id: '670307',
        zipcode: 67110,
        text: 'สักหลง',
        value: 'สักหลง',
        name: {
          th: 'สักหลง',
          en: 'Sak Long',
        },
        districtId: 762,
      },
      {
        id: '670308',
        zipcode: 67110,
        text: 'ท่าอิบุญ',
        value: 'ท่าอิบุญ',
        name: {
          th: 'ท่าอิบุญ',
          en: 'Tha Ibun',
        },
        districtId: 762,
      },
      {
        id: '670309',
        zipcode: 67110,
        text: 'บ้านโสก',
        value: 'บ้านโสก',
        name: {
          th: 'บ้านโสก',
          en: 'Ban Sok',
        },
        districtId: 762,
      },
      {
        id: '670310',
        zipcode: 67110,
        text: 'บ้านติ้ว',
        value: 'บ้านติ้ว',
        name: {
          th: 'บ้านติ้ว',
          en: 'Ban Tio',
        },
        districtId: 762,
      },
      {
        id: '670311',
        zipcode: 67110,
        text: 'ห้วยไร่',
        value: 'ห้วยไร่',
        name: {
          th: 'ห้วยไร่',
          en: 'Huai Rai',
        },
        districtId: 762,
      },
      {
        id: '670312',
        zipcode: 67110,
        text: 'น้ำก้อ',
        value: 'น้ำก้อ',
        name: {
          th: 'น้ำก้อ',
          en: 'Nam Ko',
        },
        districtId: 762,
      },
      {
        id: '670313',
        zipcode: 67110,
        text: 'ปากช่อง',
        value: 'ปากช่อง',
        name: {
          th: 'ปากช่อง',
          en: 'Pak Chong',
        },
        districtId: 762,
      },
      {
        id: '670314',
        zipcode: 67110,
        text: 'น้ำชุน',
        value: 'น้ำชุน',
        name: {
          th: 'น้ำชุน',
          en: 'Nam Chun',
        },
        districtId: 762,
      },
      {
        id: '670315',
        zipcode: 67110,
        text: 'หนองไขว่',
        value: 'หนองไขว่',
        name: {
          th: 'หนองไขว่',
          en: 'Nong Khwai',
        },
        districtId: 762,
      },
      {
        id: '670316',
        zipcode: 67110,
        text: 'ลานบ่า',
        value: 'ลานบ่า',
        name: {
          th: 'ลานบ่า',
          en: 'Lan Ba',
        },
        districtId: 762,
      },
      {
        id: '670317',
        zipcode: 67110,
        text: 'บุ่งคล้า',
        value: 'บุ่งคล้า',
        name: {
          th: 'บุ่งคล้า',
          en: 'Bung Khla',
        },
        districtId: 762,
      },
      {
        id: '670318',
        zipcode: 67110,
        text: 'บุ่งน้ำเต้า',
        value: 'บุ่งน้ำเต้า',
        name: {
          th: 'บุ่งน้ำเต้า',
          en: 'Bung Namtao',
        },
        districtId: 762,
      },
      {
        id: '670319',
        zipcode: 67110,
        text: 'บ้านกลาง',
        value: 'บ้านกลาง',
        name: {
          th: 'บ้านกลาง',
          en: 'Ban Klang',
        },
        districtId: 762,
      },
      {
        id: '670320',
        zipcode: 67110,
        text: 'ช้างตะลูด',
        value: 'ช้างตะลูด',
        name: {
          th: 'ช้างตะลูด',
          en: 'Chang Talut',
        },
        districtId: 762,
      },
      {
        id: '670321',
        zipcode: 67110,
        text: 'บ้านไร่',
        value: 'บ้านไร่',
        name: {
          th: 'บ้านไร่',
          en: 'Ban Rai',
        },
        districtId: 762,
      },
      {
        id: '670322',
        zipcode: 67110,
        text: 'ปากดุก',
        value: 'ปากดุก',
        name: {
          th: 'ปากดุก',
          en: 'Pak Duk',
        },
        districtId: 762,
      },
      {
        id: '670323',
        zipcode: 67110,
        text: 'บ้านหวาย',
        value: 'บ้านหวาย',
        name: {
          th: 'บ้านหวาย',
          en: 'Ban Wai',
        },
        districtId: 762,
      },
      {
        id: '670401',
        zipcode: 67120,
        text: 'หล่มเก่า',
        value: 'หล่มเก่า',
        name: {
          th: 'หล่มเก่า',
          en: 'Lom Kao',
        },
        districtId: 763,
      },
      {
        id: '670402',
        zipcode: 67120,
        text: 'นาซำ',
        value: 'นาซำ',
        name: {
          th: 'นาซำ',
          en: 'Na Sam',
        },
        districtId: 763,
      },
      {
        id: '670403',
        zipcode: 67120,
        text: 'หินฮาว',
        value: 'หินฮาว',
        name: {
          th: 'หินฮาว',
          en: 'Hin Hao',
        },
        districtId: 763,
      },
      {
        id: '670404',
        zipcode: 67120,
        text: 'บ้านเนิน',
        value: 'บ้านเนิน',
        name: {
          th: 'บ้านเนิน',
          en: 'Ban Noen',
        },
        districtId: 763,
      },
      {
        id: '670405',
        zipcode: 67120,
        text: 'ศิลา',
        value: 'ศิลา',
        name: {
          th: 'ศิลา',
          en: 'Sila',
        },
        districtId: 763,
      },
      {
        id: '670406',
        zipcode: 67120,
        text: 'นาแซง',
        value: 'นาแซง',
        name: {
          th: 'นาแซง',
          en: 'Na Saeng',
        },
        districtId: 763,
      },
      {
        id: '670407',
        zipcode: 67120,
        text: 'วังบาล',
        value: 'วังบาล',
        name: {
          th: 'วังบาล',
          en: 'Wang Ban',
        },
        districtId: 763,
      },
      {
        id: '670408',
        zipcode: 67120,
        text: 'นาเกาะ',
        value: 'นาเกาะ',
        name: {
          th: 'นาเกาะ',
          en: 'Na Ko',
        },
        districtId: 763,
      },
      {
        id: '670409',
        zipcode: 67120,
        text: 'ตาดกลอย',
        value: 'ตาดกลอย',
        name: {
          th: 'ตาดกลอย',
          en: 'Tat Kloi',
        },
        districtId: 763,
      },
      {
        id: '670501',
        zipcode: 67130,
        text: 'ท่าโรง',
        value: 'ท่าโรง',
        name: {
          th: 'ท่าโรง',
          en: 'Tha Rong',
        },
        districtId: 764,
      },
      {
        id: '670502',
        zipcode: 67130,
        text: 'สระประดู่',
        value: 'สระประดู่',
        name: {
          th: 'สระประดู่',
          en: 'Sa Pradu',
        },
        districtId: 764,
      },
      {
        id: '670503',
        zipcode: 67130,
        text: 'สามแยก',
        value: 'สามแยก',
        name: {
          th: 'สามแยก',
          en: 'Sam Yaek',
        },
        districtId: 764,
      },
      {
        id: '670504',
        zipcode: 67130,
        text: 'โคกปรง',
        value: 'โคกปรง',
        name: {
          th: 'โคกปรง',
          en: 'Khok Prong',
        },
        districtId: 764,
      },
      {
        id: '670505',
        zipcode: 67130,
        text: 'น้ำร้อน',
        value: 'น้ำร้อน',
        name: {
          th: 'น้ำร้อน',
          en: 'Nam Ron',
        },
        districtId: 764,
      },
      {
        id: '670506',
        zipcode: 67130,
        text: 'บ่อรัง',
        value: 'บ่อรัง',
        name: {
          th: 'บ่อรัง',
          en: 'Bo Rang',
        },
        districtId: 764,
      },
      {
        id: '670507',
        zipcode: 67180,
        text: 'พุเตย',
        value: 'พุเตย',
        name: {
          th: 'พุเตย',
          en: 'Phu Toei',
        },
        districtId: 764,
      },
      {
        id: '670508',
        zipcode: 67180,
        text: 'พุขาม',
        value: 'พุขาม',
        name: {
          th: 'พุขาม',
          en: 'Phu Kham',
        },
        districtId: 764,
      },
      {
        id: '670509',
        zipcode: 67180,
        text: 'ภูน้ำหยด',
        value: 'ภูน้ำหยด',
        name: {
          th: 'ภูน้ำหยด',
          en: 'Phu Nam Yot',
        },
        districtId: 764,
      },
      {
        id: '670510',
        zipcode: 67180,
        text: 'ซับสมบูรณ์',
        value: 'ซับสมบูรณ์',
        name: {
          th: 'ซับสมบูรณ์',
          en: 'Sap Sombun',
        },
        districtId: 764,
      },
      {
        id: '670511',
        zipcode: 67130,
        text: 'บึงกระจับ',
        value: 'บึงกระจับ',
        name: {
          th: 'บึงกระจับ',
          en: 'Bueng Krachap',
        },
        districtId: 764,
      },
      {
        id: '670512',
        zipcode: 67180,
        text: 'วังใหญ่',
        value: 'วังใหญ่',
        name: {
          th: 'วังใหญ่',
          en: 'Wang Yai',
        },
        districtId: 764,
      },
      {
        id: '670513',
        zipcode: 67130,
        text: 'ยางสาว',
        value: 'ยางสาว',
        name: {
          th: 'ยางสาว',
          en: 'Yang Sao',
        },
        districtId: 764,
      },
      {
        id: '670514',
        zipcode: 67180,
        text: 'ซับน้อย',
        value: 'ซับน้อย',
        name: {
          th: 'ซับน้อย',
          en: 'Sap Noi',
        },
        districtId: 764,
      },
      {
        id: '670601',
        zipcode: 67170,
        text: 'ศรีเทพ',
        value: 'ศรีเทพ',
        name: {
          th: 'ศรีเทพ',
          en: 'Si Thep',
        },
        districtId: 765,
      },
      {
        id: '670602',
        zipcode: 67170,
        text: 'สระกรวด',
        value: 'สระกรวด',
        name: {
          th: 'สระกรวด',
          en: 'Sa Kruat',
        },
        districtId: 765,
      },
      {
        id: '670603',
        zipcode: 67170,
        text: 'คลองกระจัง',
        value: 'คลองกระจัง',
        name: {
          th: 'คลองกระจัง',
          en: 'Khlong Krachang',
        },
        districtId: 765,
      },
      {
        id: '670604',
        zipcode: 67170,
        text: 'นาสนุ่น',
        value: 'นาสนุ่น',
        name: {
          th: 'นาสนุ่น',
          en: 'Na Sanun',
        },
        districtId: 765,
      },
      {
        id: '670605',
        zipcode: 67170,
        text: 'โคกสะอาด',
        value: 'โคกสะอาด',
        name: {
          th: 'โคกสะอาด',
          en: 'Khok Sa-at',
        },
        districtId: 765,
      },
      {
        id: '670606',
        zipcode: 67170,
        text: 'หนองย่างทอย',
        value: 'หนองย่างทอย',
        name: {
          th: 'หนองย่างทอย',
          en: 'Nong Yang Thoi',
        },
        districtId: 765,
      },
      {
        id: '670607',
        zipcode: 67170,
        text: 'ประดู่งาม',
        value: 'ประดู่งาม',
        name: {
          th: 'ประดู่งาม',
          en: 'Pradu Ngam',
        },
        districtId: 765,
      },
      {
        id: '670701',
        zipcode: 67140,
        text: 'กองทูล',
        value: 'กองทูล',
        name: {
          th: 'กองทูล',
          en: 'Kong Thun',
        },
        districtId: 766,
      },
      {
        id: '670702',
        zipcode: 67220,
        text: 'นาเฉลียง',
        value: 'นาเฉลียง',
        name: {
          th: 'นาเฉลียง',
          en: 'Na Chaliang',
        },
        districtId: 766,
      },
      {
        id: '670703',
        zipcode: 67140,
        text: 'บ้านโภชน์',
        value: 'บ้านโภชน์',
        name: {
          th: 'บ้านโภชน์',
          en: 'Ban Phot',
        },
        districtId: 766,
      },
      {
        id: '670704',
        zipcode: 67140,
        text: 'ท่าแดง',
        value: 'ท่าแดง',
        name: {
          th: 'ท่าแดง',
          en: 'Tha Daeng',
        },
        districtId: 766,
      },
      {
        id: '670705',
        zipcode: 67140,
        text: 'เพชรละคร',
        value: 'เพชรละคร',
        name: {
          th: 'เพชรละคร',
          en: 'Phet Lakhon',
        },
        districtId: 766,
      },
      {
        id: '670706',
        zipcode: 67140,
        text: 'บ่อไทย',
        value: 'บ่อไทย',
        name: {
          th: 'บ่อไทย',
          en: 'Bo Thai',
        },
        districtId: 766,
      },
      {
        id: '670707',
        zipcode: 67220,
        text: 'ห้วยโป่ง',
        value: 'ห้วยโป่ง',
        name: {
          th: 'ห้วยโป่ง',
          en: 'Huai Pong',
        },
        districtId: 766,
      },
      {
        id: '670708',
        zipcode: 67140,
        text: 'วังท่าดี',
        value: 'วังท่าดี',
        name: {
          th: 'วังท่าดี',
          en: 'Wang Tha Di',
        },
        districtId: 766,
      },
      {
        id: '670709',
        zipcode: 67140,
        text: 'บัววัฒนา',
        value: 'บัววัฒนา',
        name: {
          th: 'บัววัฒนา',
          en: 'Bua Watthana',
        },
        districtId: 766,
      },
      {
        id: '670710',
        zipcode: 67140,
        text: 'หนองไผ่',
        value: 'หนองไผ่',
        name: {
          th: 'หนองไผ่',
          en: 'Nong Phai',
        },
        districtId: 766,
      },
      {
        id: '670711',
        zipcode: 67140,
        text: 'วังโบสถ์',
        value: 'วังโบสถ์',
        name: {
          th: 'วังโบสถ์',
          en: 'Wang Bot',
        },
        districtId: 766,
      },
      {
        id: '670712',
        zipcode: 67220,
        text: 'ยางงาม',
        value: 'ยางงาม',
        name: {
          th: 'ยางงาม',
          en: 'Yang Ngam',
        },
        districtId: 766,
      },
      {
        id: '670713',
        zipcode: 67140,
        text: 'ท่าด้วง',
        value: 'ท่าด้วง',
        name: {
          th: 'ท่าด้วง',
          en: 'Tha Duang',
        },
        districtId: 766,
      },
      {
        id: '670801',
        zipcode: 67160,
        text: 'ซับสมอทอด',
        value: 'ซับสมอทอด',
        name: {
          th: 'ซับสมอทอด',
          en: 'Sap Samo Thot',
        },
        districtId: 767,
      },
      {
        id: '670802',
        zipcode: 67160,
        text: 'ซับไม้แดง',
        value: 'ซับไม้แดง',
        name: {
          th: 'ซับไม้แดง',
          en: 'Sap Mai Daeng',
        },
        districtId: 767,
      },
      {
        id: '670803',
        zipcode: 67160,
        text: 'หนองแจง',
        value: 'หนองแจง',
        name: {
          th: 'หนองแจง',
          en: 'Nong Chaeng',
        },
        districtId: 767,
      },
      {
        id: '670804',
        zipcode: 67160,
        text: 'กันจุ',
        value: 'กันจุ',
        name: {
          th: 'กันจุ',
          en: 'Kan Chu',
        },
        districtId: 767,
      },
      {
        id: '670805',
        zipcode: 67230,
        text: 'วังพิกุล',
        value: 'วังพิกุล',
        name: {
          th: 'วังพิกุล',
          en: 'Wang Phikun',
        },
        districtId: 767,
      },
      {
        id: '670806',
        zipcode: 67160,
        text: 'พญาวัง',
        value: 'พญาวัง',
        name: {
          th: 'พญาวัง',
          en: 'Phaya Wang',
        },
        districtId: 767,
      },
      {
        id: '670807',
        zipcode: 67160,
        text: 'ศรีมงคล',
        value: 'ศรีมงคล',
        name: {
          th: 'ศรีมงคล',
          en: 'Si Mongkhon',
        },
        districtId: 767,
      },
      {
        id: '670808',
        zipcode: 67160,
        text: 'สระแก้ว',
        value: 'สระแก้ว',
        name: {
          th: 'สระแก้ว',
          en: 'Sa Kaeo',
        },
        districtId: 767,
      },
      {
        id: '670809',
        zipcode: 67160,
        text: 'บึงสามพัน',
        value: 'บึงสามพัน',
        name: {
          th: 'บึงสามพัน',
          en: 'Bueng Sam Phan',
        },
        districtId: 767,
      },
      {
        id: '670901',
        zipcode: 67260,
        text: 'น้ำหนาว',
        value: 'น้ำหนาว',
        name: {
          th: 'น้ำหนาว',
          en: 'Nam Nao',
        },
        districtId: 768,
      },
      {
        id: '670902',
        zipcode: 67260,
        text: 'หลักด่าน',
        value: 'หลักด่าน',
        name: {
          th: 'หลักด่าน',
          en: 'Lak Dan',
        },
        districtId: 768,
      },
      {
        id: '670903',
        zipcode: 67260,
        text: 'วังกวาง',
        value: 'วังกวาง',
        name: {
          th: 'วังกวาง',
          en: 'Wang Kwang',
        },
        districtId: 768,
      },
      {
        id: '670904',
        zipcode: 67260,
        text: 'โคกมน',
        value: 'โคกมน',
        name: {
          th: 'โคกมน',
          en: 'Khok Mon',
        },
        districtId: 768,
      },
      {
        id: '671001',
        zipcode: 67240,
        text: 'วังโป่ง',
        value: 'วังโป่ง',
        name: {
          th: 'วังโป่ง',
          en: 'Wang Pong',
        },
        districtId: 769,
      },
      {
        id: '671002',
        zipcode: 67240,
        text: 'ท้ายดง',
        value: 'ท้ายดง',
        name: {
          th: 'ท้ายดง',
          en: 'Thai Dong',
        },
        districtId: 769,
      },
      {
        id: '671003',
        zipcode: 67240,
        text: 'ซับเปิบ',
        value: 'ซับเปิบ',
        name: {
          th: 'ซับเปิบ',
          en: 'Sap Poep',
        },
        districtId: 769,
      },
      {
        id: '671004',
        zipcode: 67240,
        text: 'วังหิน',
        value: 'วังหิน',
        name: {
          th: 'วังหิน',
          en: 'Wang Hin',
        },
        districtId: 769,
      },
      {
        id: '671005',
        zipcode: 67240,
        text: 'วังศาล',
        value: 'วังศาล',
        name: {
          th: 'วังศาล',
          en: 'Wang San',
        },
        districtId: 769,
      },
      {
        id: '671101',
        zipcode: 67270,
        text: 'ทุ่งสมอ',
        value: 'ทุ่งสมอ',
        name: {
          th: 'ทุ่งสมอ',
          en: 'Khao Kho',
        },
        districtId: 770,
      },
      {
        id: '671102',
        zipcode: 67280,
        text: 'แคมป์สน',
        value: 'แคมป์สน',
        name: {
          th: 'แคมป์สน',
          en: 'Khaem Son',
        },
        districtId: 770,
      },
      {
        id: '671103',
        zipcode: 67270,
        text: 'เขาค้อ',
        value: 'เขาค้อ',
        name: {
          th: 'เขาค้อ',
          en: 'Thung Samo',
        },
        districtId: 770,
      },
      {
        id: '671104',
        zipcode: 67270,
        text: 'ริมสีม่วง',
        value: 'ริมสีม่วง',
        name: {
          th: 'ริมสีม่วง',
          en: 'Rim Si Muang',
        },
        districtId: 770,
      },
      {
        id: '671105',
        zipcode: 67270,
        text: 'สะเดาะพง',
        value: 'สะเดาะพง',
        name: {
          th: 'สะเดาะพง',
          en: 'Sado Phong',
        },
        districtId: 770,
      },
      {
        id: '671106',
        zipcode: 67270,
        text: 'หนองแม่นา',
        value: 'หนองแม่นา',
        name: {
          th: 'หนองแม่นา',
          en: 'Nong Mae Na',
        },
        districtId: 770,
      },
      {
        id: '671107',
        zipcode: 67280,
        text: 'เข็กน้อย',
        value: 'เข็กน้อย',
        name: {
          th: 'เข็กน้อย',
          en: 'Khek Noi',
        },
        districtId: 770,
      },
      {
        id: '700101',
        zipcode: 70000,
        text: 'หน้าเมือง',
        value: 'หน้าเมือง',
        name: {
          th: 'หน้าเมือง',
          en: 'Na Mueang',
        },
        districtId: 771,
      },
      {
        id: '700102',
        zipcode: 70000,
        text: 'เจดีย์หัก',
        value: 'เจดีย์หัก',
        name: {
          th: 'เจดีย์หัก',
          en: 'Chedi Hak',
        },
        districtId: 771,
      },
      {
        id: '700103',
        zipcode: 70000,
        text: 'ดอนตะโก',
        value: 'ดอนตะโก',
        name: {
          th: 'ดอนตะโก',
          en: 'Don Tako',
        },
        districtId: 771,
      },
      {
        id: '700104',
        zipcode: 70000,
        text: 'หนองกลางนา',
        value: 'หนองกลางนา',
        name: {
          th: 'หนองกลางนา',
          en: 'Nong Klang Na',
        },
        districtId: 771,
      },
      {
        id: '700105',
        zipcode: 70000,
        text: 'ห้วยไผ่',
        value: 'ห้วยไผ่',
        name: {
          th: 'ห้วยไผ่',
          en: 'Huai Phai',
        },
        districtId: 771,
      },
      {
        id: '700106',
        zipcode: 70000,
        text: 'คุ้งน้ำวน',
        value: 'คุ้งน้ำวน',
        name: {
          th: 'คุ้งน้ำวน',
          en: 'Khung Nam Won',
        },
        districtId: 771,
      },
      {
        id: '700107',
        zipcode: 70000,
        text: 'คุ้งกระถิน',
        value: 'คุ้งกระถิน',
        name: {
          th: 'คุ้งกระถิน',
          en: 'Khung Krathin',
        },
        districtId: 771,
      },
      {
        id: '700108',
        zipcode: 70000,
        text: 'อ่างทอง',
        value: 'อ่างทอง',
        name: {
          th: 'อ่างทอง',
          en: 'Ang Thong',
        },
        districtId: 771,
      },
      {
        id: '700109',
        zipcode: 70000,
        text: 'โคกหม้อ',
        value: 'โคกหม้อ',
        name: {
          th: 'โคกหม้อ',
          en: 'Khok Mo',
        },
        districtId: 771,
      },
      {
        id: '700110',
        zipcode: 70000,
        text: 'สามเรือน',
        value: 'สามเรือน',
        name: {
          th: 'สามเรือน',
          en: 'Sam Ruean',
        },
        districtId: 771,
      },
      {
        id: '700111',
        zipcode: 70000,
        text: 'พิกุลทอง',
        value: 'พิกุลทอง',
        name: {
          th: 'พิกุลทอง',
          en: 'Phikun Thong',
        },
        districtId: 771,
      },
      {
        id: '700112',
        zipcode: 70000,
        text: 'น้ำพุ',
        value: 'น้ำพุ',
        name: {
          th: 'น้ำพุ',
          en: 'Nam Phu',
        },
        districtId: 771,
      },
      {
        id: '700113',
        zipcode: 70000,
        text: 'ดอนแร่',
        value: 'ดอนแร่',
        name: {
          th: 'ดอนแร่',
          en: 'Don Rae',
        },
        districtId: 771,
      },
      {
        id: '700114',
        zipcode: 70000,
        text: 'หินกอง',
        value: 'หินกอง',
        name: {
          th: 'หินกอง',
          en: 'Hin Kong',
        },
        districtId: 771,
      },
      {
        id: '700115',
        zipcode: 70000,
        text: 'เขาแร้ง',
        value: 'เขาแร้ง',
        name: {
          th: 'เขาแร้ง',
          en: 'Khao Raeng',
        },
        districtId: 771,
      },
      {
        id: '700116',
        zipcode: 70000,
        text: 'เกาะพลับพลา',
        value: 'เกาะพลับพลา',
        name: {
          th: 'เกาะพลับพลา',
          en: 'Ko Phlapphla',
        },
        districtId: 771,
      },
      {
        id: '700117',
        zipcode: 70000,
        text: 'หลุมดิน',
        value: 'หลุมดิน',
        name: {
          th: 'หลุมดิน',
          en: 'Lum Din',
        },
        districtId: 771,
      },
      {
        id: '700118',
        zipcode: 70000,
        text: 'บางป่า',
        value: 'บางป่า',
        name: {
          th: 'บางป่า',
          en: 'Bang Pa',
        },
        districtId: 771,
      },
      {
        id: '700119',
        zipcode: 70000,
        text: 'พงสวาย',
        value: 'พงสวาย',
        name: {
          th: 'พงสวาย',
          en: 'Phong Sawai',
        },
        districtId: 771,
      },
      {
        id: '700120',
        zipcode: 70000,
        text: 'คูบัว',
        value: 'คูบัว',
        name: {
          th: 'คูบัว',
          en: 'Khu Bua',
        },
        districtId: 771,
      },
      {
        id: '700121',
        zipcode: 70000,
        text: 'ท่าราบ',
        value: 'ท่าราบ',
        name: {
          th: 'ท่าราบ',
          en: 'Tha Rap',
        },
        districtId: 771,
      },
      {
        id: '700122',
        zipcode: 70000,
        text: 'บ้านไร่',
        value: 'บ้านไร่',
        name: {
          th: 'บ้านไร่',
          en: 'Ban Rai',
        },
        districtId: 771,
      },
      {
        id: '700201',
        zipcode: 70150,
        text: 'จอมบึง',
        value: 'จอมบึง',
        name: {
          th: 'จอมบึง',
          en: 'Chom Bueng',
        },
        districtId: 772,
      },
      {
        id: '700202',
        zipcode: 70150,
        text: 'ปากช่อง',
        value: 'ปากช่อง',
        name: {
          th: 'ปากช่อง',
          en: 'Pak Chong',
        },
        districtId: 772,
      },
      {
        id: '700203',
        zipcode: 70150,
        text: 'เบิกไพร',
        value: 'เบิกไพร',
        name: {
          th: 'เบิกไพร',
          en: 'Boek Phrai',
        },
        districtId: 772,
      },
      {
        id: '700204',
        zipcode: 70150,
        text: 'ด่านทับตะโก',
        value: 'ด่านทับตะโก',
        name: {
          th: 'ด่านทับตะโก',
          en: 'Dan Thap Tako',
        },
        districtId: 772,
      },
      {
        id: '700205',
        zipcode: 70150,
        text: 'แก้มอ้น',
        value: 'แก้มอ้น',
        name: {
          th: 'แก้มอ้น',
          en: 'Kaem On',
        },
        districtId: 772,
      },
      {
        id: '700206',
        zipcode: 70150,
        text: 'รางบัว',
        value: 'รางบัว',
        name: {
          th: 'รางบัว',
          en: 'Rang Bua',
        },
        districtId: 772,
      },
      {
        id: '700301',
        zipcode: 70180,
        text: 'สวนผึ้ง',
        value: 'สวนผึ้ง',
        name: {
          th: 'สวนผึ้ง',
          en: 'Suan Phueng',
        },
        districtId: 773,
      },
      {
        id: '700302',
        zipcode: 70180,
        text: 'ป่าหวาย',
        value: 'ป่าหวาย',
        name: {
          th: 'ป่าหวาย',
          en: 'Pa Wai',
        },
        districtId: 773,
      },
      {
        id: '700304',
        zipcode: 70180,
        text: 'ท่าเคย',
        value: 'ท่าเคย',
        name: {
          th: 'ท่าเคย',
          en: 'Tha Khoei',
        },
        districtId: 773,
      },
      {
        id: '700307',
        zipcode: 70180,
        text: 'ตะนาวศรี',
        value: 'ตะนาวศรี',
        name: {
          th: 'ตะนาวศรี',
          en: 'Tanao Si',
        },
        districtId: 773,
      },
      {
        id: '700401',
        zipcode: 70130,
        text: 'ดำเนินสะดวก',
        value: 'ดำเนินสะดวก',
        name: {
          th: 'ดำเนินสะดวก',
          en: 'Damnoen Saduak',
        },
        districtId: 774,
      },
      {
        id: '700402',
        zipcode: 70210,
        text: 'ประสาทสิทธิ์',
        value: 'ประสาทสิทธิ์',
        name: {
          th: 'ประสาทสิทธิ์',
          en: 'Prasat Sit',
        },
        districtId: 774,
      },
      {
        id: '700403',
        zipcode: 70130,
        text: 'ศรีสุราษฎร์',
        value: 'ศรีสุราษฎร์',
        name: {
          th: 'ศรีสุราษฎร์',
          en: 'Si Surat',
        },
        districtId: 774,
      },
      {
        id: '700404',
        zipcode: 70130,
        text: 'ตาหลวง',
        value: 'ตาหลวง',
        name: {
          th: 'ตาหลวง',
          en: 'Ta Luang',
        },
        districtId: 774,
      },
      {
        id: '700405',
        zipcode: 70130,
        text: 'ดอนกรวย',
        value: 'ดอนกรวย',
        name: {
          th: 'ดอนกรวย',
          en: 'Don Kruai',
        },
        districtId: 774,
      },
      {
        id: '700406',
        zipcode: 70130,
        text: 'ดอนคลัง',
        value: 'ดอนคลัง',
        name: {
          th: 'ดอนคลัง',
          en: 'Don Khlang',
        },
        districtId: 774,
      },
      {
        id: '700407',
        zipcode: 70210,
        text: 'บัวงาม',
        value: 'บัวงาม',
        name: {
          th: 'บัวงาม',
          en: 'Bua Ngam',
        },
        districtId: 774,
      },
      {
        id: '700408',
        zipcode: 70130,
        text: 'บ้านไร่',
        value: 'บ้านไร่',
        name: {
          th: 'บ้านไร่',
          en: 'Ban Rai',
        },
        districtId: 774,
      },
      {
        id: '700409',
        zipcode: 70130,
        text: 'แพงพวย',
        value: 'แพงพวย',
        name: {
          th: 'แพงพวย',
          en: 'Phaengphuai',
        },
        districtId: 774,
      },
      {
        id: '700410',
        zipcode: 70130,
        text: 'สี่หมื่น',
        value: 'สี่หมื่น',
        name: {
          th: 'สี่หมื่น',
          en: 'Si Muen',
        },
        districtId: 774,
      },
      {
        id: '700411',
        zipcode: 70130,
        text: 'ท่านัด',
        value: 'ท่านัด',
        name: {
          th: 'ท่านัด',
          en: 'Tha Nat',
        },
        districtId: 774,
      },
      {
        id: '700412',
        zipcode: 70130,
        text: 'ขุนพิทักษ์',
        value: 'ขุนพิทักษ์',
        name: {
          th: 'ขุนพิทักษ์',
          en: 'Khun Phithak',
        },
        districtId: 774,
      },
      {
        id: '700413',
        zipcode: 70130,
        text: 'ดอนไผ่',
        value: 'ดอนไผ่',
        name: {
          th: 'ดอนไผ่',
          en: 'Don Phai',
        },
        districtId: 774,
      },
      {
        id: '700501',
        zipcode: 70110,
        text: 'บ้านโป่ง',
        value: 'บ้านโป่ง',
        name: {
          th: 'บ้านโป่ง',
          en: 'Ban Pong',
        },
        districtId: 775,
      },
      {
        id: '700502',
        zipcode: 70110,
        text: 'ท่าผา',
        value: 'ท่าผา',
        name: {
          th: 'ท่าผา',
          en: 'Tha Pha',
        },
        districtId: 775,
      },
      {
        id: '700503',
        zipcode: 70190,
        text: 'กรับใหญ่',
        value: 'กรับใหญ่',
        name: {
          th: 'กรับใหญ่',
          en: 'Krap Yai',
        },
        districtId: 775,
      },
      {
        id: '700504',
        zipcode: 70110,
        text: 'ปากแรต',
        value: 'ปากแรต',
        name: {
          th: 'ปากแรต',
          en: 'Pak Raet',
        },
        districtId: 775,
      },
      {
        id: '700505',
        zipcode: 70110,
        text: 'หนองกบ',
        value: 'หนองกบ',
        name: {
          th: 'หนองกบ',
          en: 'Nong Kop',
        },
        districtId: 775,
      },
      {
        id: '700506',
        zipcode: 70110,
        text: 'หนองอ้อ',
        value: 'หนองอ้อ',
        name: {
          th: 'หนองอ้อ',
          en: 'Nong O',
        },
        districtId: 775,
      },
      {
        id: '700507',
        zipcode: 70110,
        text: 'ดอนกระเบื้อง',
        value: 'ดอนกระเบื้อง',
        name: {
          th: 'ดอนกระเบื้อง',
          en: 'Don Krabueang',
        },
        districtId: 775,
      },
      {
        id: '700508',
        zipcode: 70110,
        text: 'สวนกล้วย',
        value: 'สวนกล้วย',
        name: {
          th: 'สวนกล้วย',
          en: 'Suan Kluai',
        },
        districtId: 775,
      },
      {
        id: '700509',
        zipcode: 70110,
        text: 'นครชุมน์',
        value: 'นครชุมน์',
        name: {
          th: 'นครชุมน์',
          en: 'Nakhon Chum',
        },
        districtId: 775,
      },
      {
        id: '700510',
        zipcode: 70110,
        text: 'บ้านม่วง',
        value: 'บ้านม่วง',
        name: {
          th: 'บ้านม่วง',
          en: 'Ban Muang',
        },
        districtId: 775,
      },
      {
        id: '700511',
        zipcode: 70110,
        text: 'คุ้งพยอม',
        value: 'คุ้งพยอม',
        name: {
          th: 'คุ้งพยอม',
          en: 'Khung Phayom',
        },
        districtId: 775,
      },
      {
        id: '700512',
        zipcode: 70110,
        text: 'หนองปลาหมอ',
        value: 'หนองปลาหมอ',
        name: {
          th: 'หนองปลาหมอ',
          en: 'Nong Pla Mo',
        },
        districtId: 775,
      },
      {
        id: '700513',
        zipcode: 70110,
        text: 'เขาขลุง',
        value: 'เขาขลุง',
        name: {
          th: 'เขาขลุง',
          en: 'Khao Khlung',
        },
        districtId: 775,
      },
      {
        id: '700514',
        zipcode: 70110,
        text: 'เบิกไพร',
        value: 'เบิกไพร',
        name: {
          th: 'เบิกไพร',
          en: 'Boek Phrai',
        },
        districtId: 775,
      },
      {
        id: '700515',
        zipcode: 70110,
        text: 'ลาดบัวขาว',
        value: 'ลาดบัวขาว',
        name: {
          th: 'ลาดบัวขาว',
          en: 'Lat Bua Khao',
        },
        districtId: 775,
      },
      {
        id: '700601',
        zipcode: 70160,
        text: 'บางแพ',
        value: 'บางแพ',
        name: {
          th: 'บางแพ',
          en: 'Bang Phae',
        },
        districtId: 776,
      },
      {
        id: '700602',
        zipcode: 70160,
        text: 'วังเย็น',
        value: 'วังเย็น',
        name: {
          th: 'วังเย็น',
          en: 'Wang Yen',
        },
        districtId: 776,
      },
      {
        id: '700603',
        zipcode: 70160,
        text: 'หัวโพ',
        value: 'หัวโพ',
        name: {
          th: 'หัวโพ',
          en: 'Hua Pho',
        },
        districtId: 776,
      },
      {
        id: '700604',
        zipcode: 70160,
        text: 'วัดแก้ว',
        value: 'วัดแก้ว',
        name: {
          th: 'วัดแก้ว',
          en: 'Wat Kaeo',
        },
        districtId: 776,
      },
      {
        id: '700605',
        zipcode: 70160,
        text: 'ดอนใหญ่',
        value: 'ดอนใหญ่',
        name: {
          th: 'ดอนใหญ่',
          en: 'Don Yai',
        },
        districtId: 776,
      },
      {
        id: '700606',
        zipcode: 70160,
        text: 'ดอนคา',
        value: 'ดอนคา',
        name: {
          th: 'ดอนคา',
          en: 'Don Kha',
        },
        districtId: 776,
      },
      {
        id: '700607',
        zipcode: 70160,
        text: 'โพหัก',
        value: 'โพหัก',
        name: {
          th: 'โพหัก',
          en: 'Pho Hak',
        },
        districtId: 776,
      },
      {
        id: '700701',
        zipcode: 70120,
        text: 'โพธาราม',
        value: 'โพธาราม',
        name: {
          th: 'โพธาราม',
          en: 'Photharam',
        },
        districtId: 777,
      },
      {
        id: '700702',
        zipcode: 70120,
        text: 'ดอนกระเบื้อง',
        value: 'ดอนกระเบื้อง',
        name: {
          th: 'ดอนกระเบื้อง',
          en: 'Don Krabueang',
        },
        districtId: 777,
      },
      {
        id: '700703',
        zipcode: 70120,
        text: 'หนองโพ',
        value: 'หนองโพ',
        name: {
          th: 'หนองโพ',
          en: 'Nong Pho',
        },
        districtId: 777,
      },
      {
        id: '700704',
        zipcode: 70120,
        text: 'บ้านเลือก',
        value: 'บ้านเลือก',
        name: {
          th: 'บ้านเลือก',
          en: 'Ban Lueak',
        },
        districtId: 777,
      },
      {
        id: '700705',
        zipcode: 70120,
        text: 'คลองตาคต',
        value: 'คลองตาคต',
        name: {
          th: 'คลองตาคต',
          en: 'Khlong Ta Khot',
        },
        districtId: 777,
      },
      {
        id: '700706',
        zipcode: 70120,
        text: 'บ้านฆ้อง',
        value: 'บ้านฆ้อง',
        name: {
          th: 'บ้านฆ้อง',
          en: 'Ban Khong',
        },
        districtId: 777,
      },
      {
        id: '700707',
        zipcode: 70120,
        text: 'บ้านสิงห์',
        value: 'บ้านสิงห์',
        name: {
          th: 'บ้านสิงห์',
          en: 'Ban Sing',
        },
        districtId: 777,
      },
      {
        id: '700708',
        zipcode: 70120,
        text: 'ดอนทราย',
        value: 'ดอนทราย',
        name: {
          th: 'ดอนทราย',
          en: 'Don Sai',
        },
        districtId: 777,
      },
      {
        id: '700709',
        zipcode: 70120,
        text: 'เจ็ดเสมียน',
        value: 'เจ็ดเสมียน',
        name: {
          th: 'เจ็ดเสมียน',
          en: 'Chet Samian',
        },
        districtId: 777,
      },
      {
        id: '700710',
        zipcode: 70120,
        text: 'คลองข่อย',
        value: 'คลองข่อย',
        name: {
          th: 'คลองข่อย',
          en: 'Khlong Khoi',
        },
        districtId: 777,
      },
      {
        id: '700711',
        zipcode: 70120,
        text: 'ชำแระ',
        value: 'ชำแระ',
        name: {
          th: 'ชำแระ',
          en: 'Chamrae',
        },
        districtId: 777,
      },
      {
        id: '700712',
        zipcode: 70120,
        text: 'สร้อยฟ้า',
        value: 'สร้อยฟ้า',
        name: {
          th: 'สร้อยฟ้า',
          en: 'Soi Fa',
        },
        districtId: 777,
      },
      {
        id: '700713',
        zipcode: 70120,
        text: 'ท่าชุมพล',
        value: 'ท่าชุมพล',
        name: {
          th: 'ท่าชุมพล',
          en: 'Tha Chumphon',
        },
        districtId: 777,
      },
      {
        id: '700714',
        zipcode: 70120,
        text: 'บางโตนด',
        value: 'บางโตนด',
        name: {
          th: 'บางโตนด',
          en: 'Bang Tanot',
        },
        districtId: 777,
      },
      {
        id: '700715',
        zipcode: 70120,
        text: 'เตาปูน',
        value: 'เตาปูน',
        name: {
          th: 'เตาปูน',
          en: 'Tao Pun',
        },
        districtId: 777,
      },
      {
        id: '700716',
        zipcode: 70120,
        text: 'นางแก้ว',
        value: 'นางแก้ว',
        name: {
          th: 'นางแก้ว',
          en: 'Nang Kaeo',
        },
        districtId: 777,
      },
      {
        id: '700717',
        zipcode: 70120,
        text: 'ธรรมเสน',
        value: 'ธรรมเสน',
        name: {
          th: 'ธรรมเสน',
          en: 'Thammasen',
        },
        districtId: 777,
      },
      {
        id: '700718',
        zipcode: 70120,
        text: 'เขาชะงุ้ม',
        value: 'เขาชะงุ้ม',
        name: {
          th: 'เขาชะงุ้ม',
          en: 'Khao Cha-ngum',
        },
        districtId: 777,
      },
      {
        id: '700719',
        zipcode: 70120,
        text: 'หนองกวาง',
        value: 'หนองกวาง',
        name: {
          th: 'หนองกวาง',
          en: 'Nong Kwang',
        },
        districtId: 777,
      },
      {
        id: '700801',
        zipcode: 70140,
        text: 'ทุ่งหลวง',
        value: 'ทุ่งหลวง',
        name: {
          th: 'ทุ่งหลวง',
          en: 'Thung Luang',
        },
        districtId: 778,
      },
      {
        id: '700802',
        zipcode: 70140,
        text: 'วังมะนาว',
        value: 'วังมะนาว',
        name: {
          th: 'วังมะนาว',
          en: 'Wang Manao',
        },
        districtId: 778,
      },
      {
        id: '700803',
        zipcode: 70140,
        text: 'ดอนทราย',
        value: 'ดอนทราย',
        name: {
          th: 'ดอนทราย',
          en: 'Don Sai',
        },
        districtId: 778,
      },
      {
        id: '700804',
        zipcode: 70140,
        text: 'หนองกระทุ่ม',
        value: 'หนองกระทุ่ม',
        name: {
          th: 'หนองกระทุ่ม',
          en: 'Nong Krathum',
        },
        districtId: 778,
      },
      {
        id: '700805',
        zipcode: 70140,
        text: 'ปากท่อ',
        value: 'ปากท่อ',
        name: {
          th: 'ปากท่อ',
          en: 'Pak Tho',
        },
        districtId: 778,
      },
      {
        id: '700806',
        zipcode: 70140,
        text: 'ป่าไก่',
        value: 'ป่าไก่',
        name: {
          th: 'ป่าไก่',
          en: 'Pa Kai',
        },
        districtId: 778,
      },
      {
        id: '700807',
        zipcode: 70140,
        text: 'วัดยางงาม',
        value: 'วัดยางงาม',
        name: {
          th: 'วัดยางงาม',
          en: 'Wat Yang Ngam',
        },
        districtId: 778,
      },
      {
        id: '700808',
        zipcode: 70140,
        text: 'อ่างหิน',
        value: 'อ่างหิน',
        name: {
          th: 'อ่างหิน',
          en: 'Ang Hin',
        },
        districtId: 778,
      },
      {
        id: '700809',
        zipcode: 70140,
        text: 'บ่อกระดาน',
        value: 'บ่อกระดาน',
        name: {
          th: 'บ่อกระดาน',
          en: 'Bo Kradan',
        },
        districtId: 778,
      },
      {
        id: '700810',
        zipcode: 70140,
        text: 'ยางหัก',
        value: 'ยางหัก',
        name: {
          th: 'ยางหัก',
          en: 'Yang Hak',
        },
        districtId: 778,
      },
      {
        id: '700811',
        zipcode: 70140,
        text: 'วันดาว',
        value: 'วันดาว',
        name: {
          th: 'วันดาว',
          en: 'Wan Dao',
        },
        districtId: 778,
      },
      {
        id: '700812',
        zipcode: 70140,
        text: 'ห้วยยางโทน',
        value: 'ห้วยยางโทน',
        name: {
          th: 'ห้วยยางโทน',
          en: 'Huai Yang Thon',
        },
        districtId: 778,
      },
      {
        id: '700901',
        zipcode: 70170,
        text: 'เกาะศาลพระ',
        value: 'เกาะศาลพระ',
        name: {
          th: 'เกาะศาลพระ',
          en: 'Ko San Phra',
        },
        districtId: 779,
      },
      {
        id: '700902',
        zipcode: 70170,
        text: 'จอมประทัด',
        value: 'จอมประทัด',
        name: {
          th: 'จอมประทัด',
          en: 'Chom Prathat',
        },
        districtId: 779,
      },
      {
        id: '700903',
        zipcode: 70170,
        text: 'วัดเพลง',
        value: 'วัดเพลง',
        name: {
          th: 'วัดเพลง',
          en: 'Wat Pleng',
        },
        districtId: 779,
      },
      {
        id: '701001',
        zipcode: 70180,
        text: 'บ้านคา',
        value: 'บ้านคา',
        name: {
          th: 'บ้านคา',
          en: 'Ban Kha',
        },
        districtId: 780,
      },
      {
        id: '701002',
        zipcode: 70180,
        text: 'บ้านบึง',
        value: 'บ้านบึง',
        name: {
          th: 'บ้านบึง',
          en: 'Ban Bueng',
        },
        districtId: 780,
      },
      {
        id: '701003',
        zipcode: 70180,
        text: 'หนองพันจันทร์',
        value: 'หนองพันจันทร์',
        name: {
          th: 'หนองพันจันทร์',
          en: 'Nong Phan Chan',
        },
        districtId: 780,
      },
      {
        id: '710101',
        zipcode: 71000,
        text: 'บ้านเหนือ',
        value: 'บ้านเหนือ',
        name: {
          th: 'บ้านเหนือ',
          en: 'Ban Nuea',
        },
        districtId: 782,
      },
      {
        id: '710102',
        zipcode: 71000,
        text: 'บ้านใต้',
        value: 'บ้านใต้',
        name: {
          th: 'บ้านใต้',
          en: 'Ban Tai',
        },
        districtId: 782,
      },
      {
        id: '710103',
        zipcode: 71000,
        text: 'ปากแพรก',
        value: 'ปากแพรก',
        name: {
          th: 'ปากแพรก',
          en: 'Pak Phraek',
        },
        districtId: 782,
      },
      {
        id: '710104',
        zipcode: 71000,
        text: 'ท่ามะขาม',
        value: 'ท่ามะขาม',
        name: {
          th: 'ท่ามะขาม',
          en: 'Tha Makham',
        },
        districtId: 782,
      },
      {
        id: '710105',
        zipcode: 71000,
        text: 'แก่งเสี้ยน',
        value: 'แก่งเสี้ยน',
        name: {
          th: 'แก่งเสี้ยน',
          en: 'Kaeng Sian',
        },
        districtId: 782,
      },
      {
        id: '710106',
        zipcode: 71190,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 782,
      },
      {
        id: '710107',
        zipcode: 71190,
        text: 'ลาดหญ้า',
        value: 'ลาดหญ้า',
        name: {
          th: 'ลาดหญ้า',
          en: 'Lat Ya',
        },
        districtId: 782,
      },
      {
        id: '710108',
        zipcode: 71190,
        text: 'วังด้ง',
        value: 'วังด้ง',
        name: {
          th: 'วังด้ง',
          en: 'Wang Dong',
        },
        districtId: 782,
      },
      {
        id: '710109',
        zipcode: 71190,
        text: 'ช่องสะเดา',
        value: 'ช่องสะเดา',
        name: {
          th: 'ช่องสะเดา',
          en: 'Chong Sadao',
        },
        districtId: 782,
      },
      {
        id: '710110',
        zipcode: 71000,
        text: 'หนองหญ้า',
        value: 'หนองหญ้า',
        name: {
          th: 'หนองหญ้า',
          en: 'Nong Ya',
        },
        districtId: 782,
      },
      {
        id: '710111',
        zipcode: 71000,
        text: 'เกาะสำโรง',
        value: 'เกาะสำโรง',
        name: {
          th: 'เกาะสำโรง',
          en: 'Ko Samrong',
        },
        districtId: 782,
      },
      {
        id: '710113',
        zipcode: 71000,
        text: 'บ้านเก่า',
        value: 'บ้านเก่า',
        name: {
          th: 'บ้านเก่า',
          en: 'Ban Kao',
        },
        districtId: 782,
      },
      {
        id: '710116',
        zipcode: 71000,
        text: 'วังเย็น',
        value: 'วังเย็น',
        name: {
          th: 'วังเย็น',
          en: 'Wang Yen',
        },
        districtId: 782,
      },
      {
        id: '710201',
        zipcode: 71150,
        text: 'ลุ่มสุ่ม',
        value: 'ลุ่มสุ่ม',
        name: {
          th: 'ลุ่มสุ่ม',
          en: 'Lum Sum',
        },
        districtId: 783,
      },
      {
        id: '710202',
        zipcode: 71150,
        text: 'ท่าเสา',
        value: 'ท่าเสา',
        name: {
          th: 'ท่าเสา',
          en: 'Tha Sao',
        },
        districtId: 783,
      },
      {
        id: '710203',
        zipcode: 71150,
        text: 'สิงห์',
        value: 'สิงห์',
        name: {
          th: 'สิงห์',
          en: 'Sing',
        },
        districtId: 783,
      },
      {
        id: '710204',
        zipcode: 71150,
        text: 'ไทรโยค',
        value: 'ไทรโยค',
        name: {
          th: 'ไทรโยค',
          en: 'Sai Yok',
        },
        districtId: 783,
      },
      {
        id: '710205',
        zipcode: 71150,
        text: 'วังกระแจะ',
        value: 'วังกระแจะ',
        name: {
          th: 'วังกระแจะ',
          en: 'Wang Krachae',
        },
        districtId: 783,
      },
      {
        id: '710206',
        zipcode: 71150,
        text: 'ศรีมงคล',
        value: 'ศรีมงคล',
        name: {
          th: 'ศรีมงคล',
          en: 'Si Mongkhon',
        },
        districtId: 783,
      },
      {
        id: '710207',
        zipcode: 71150,
        text: 'บ้องตี้',
        value: 'บ้องตี้',
        name: {
          th: 'บ้องตี้',
          en: 'Bongti',
        },
        districtId: 783,
      },
      {
        id: '710301',
        zipcode: 71160,
        text: 'บ่อพลอย',
        value: 'บ่อพลอย',
        name: {
          th: 'บ่อพลอย',
          en: 'Bo Phloi',
        },
        districtId: 784,
      },
      {
        id: '710302',
        zipcode: 71160,
        text: 'หนองกุ่ม',
        value: 'หนองกุ่ม',
        name: {
          th: 'หนองกุ่ม',
          en: 'Nong Kum',
        },
        districtId: 784,
      },
      {
        id: '710303',
        zipcode: 71220,
        text: 'หนองรี',
        value: 'หนองรี',
        name: {
          th: 'หนองรี',
          en: 'Nong Ri',
        },
        districtId: 784,
      },
      {
        id: '710305',
        zipcode: 71160,
        text: 'หลุมรัง',
        value: 'หลุมรัง',
        name: {
          th: 'หลุมรัง',
          en: 'Lum Rang',
        },
        districtId: 784,
      },
      {
        id: '710308',
        zipcode: 71160,
        text: 'ช่องด่าน',
        value: 'ช่องด่าน',
        name: {
          th: 'ช่องด่าน',
          en: 'Chong Dan',
        },
        districtId: 784,
      },
      {
        id: '710309',
        zipcode: 71220,
        text: 'หนองกร่าง',
        value: 'หนองกร่าง',
        name: {
          th: 'หนองกร่าง',
          en: 'Nong Krang',
        },
        districtId: 784,
      },
      {
        id: '710401',
        zipcode: 71250,
        text: 'นาสวน',
        value: 'นาสวน',
        name: {
          th: 'นาสวน',
          en: 'Na Suan',
        },
        districtId: 785,
      },
      {
        id: '710402',
        zipcode: 71250,
        text: 'ด่านแม่แฉลบ',
        value: 'ด่านแม่แฉลบ',
        name: {
          th: 'ด่านแม่แฉลบ',
          en: 'Dan Mae Chalaep',
        },
        districtId: 785,
      },
      {
        id: '710403',
        zipcode: 71250,
        text: 'หนองเป็ด',
        value: 'หนองเป็ด',
        name: {
          th: 'หนองเป็ด',
          en: 'Nong Pet',
        },
        districtId: 785,
      },
      {
        id: '710404',
        zipcode: 71250,
        text: 'ท่ากระดาน',
        value: 'ท่ากระดาน',
        name: {
          th: 'ท่ากระดาน',
          en: 'Tha Kradan',
        },
        districtId: 785,
      },
      {
        id: '710405',
        zipcode: 71220,
        text: 'เขาโจด',
        value: 'เขาโจด',
        name: {
          th: 'เขาโจด',
          en: 'Khao Chot',
        },
        districtId: 785,
      },
      {
        id: '710406',
        zipcode: 71250,
        text: 'แม่กระบุง',
        value: 'แม่กระบุง',
        name: {
          th: 'แม่กระบุง',
          en: 'Mae Krabung',
        },
        districtId: 785,
      },
      {
        id: '710501',
        zipcode: 71120,
        text: 'พงตึก',
        value: 'พงตึก',
        name: {
          th: 'พงตึก',
          en: 'Phong Tuek',
        },
        districtId: 786,
      },
      {
        id: '710502',
        zipcode: 71120,
        text: 'ยางม่วง',
        value: 'ยางม่วง',
        name: {
          th: 'ยางม่วง',
          en: 'Yang Muang',
        },
        districtId: 786,
      },
      {
        id: '710503',
        zipcode: 71130,
        text: 'ดอนชะเอม',
        value: 'ดอนชะเอม',
        name: {
          th: 'ดอนชะเอม',
          en: 'Don Cha-em',
        },
        districtId: 786,
      },
      {
        id: '710504',
        zipcode: 71120,
        text: 'ท่าไม้',
        value: 'ท่าไม้',
        name: {
          th: 'ท่าไม้',
          en: 'Tha Mai',
        },
        districtId: 786,
      },
      {
        id: '710505',
        zipcode: 71130,
        text: 'ตะคร้ำเอน',
        value: 'ตะคร้ำเอน',
        name: {
          th: 'ตะคร้ำเอน',
          en: 'Takhram En',
        },
        districtId: 786,
      },
      {
        id: '710506',
        zipcode: 71120,
        text: 'ท่ามะกา',
        value: 'ท่ามะกา',
        name: {
          th: 'ท่ามะกา',
          en: 'Tha Maka',
        },
        districtId: 786,
      },
      {
        id: '710507',
        zipcode: 71130,
        text: 'ท่าเรือ',
        value: 'ท่าเรือ',
        name: {
          th: 'ท่าเรือ',
          en: 'Tha Ruea',
        },
        districtId: 786,
      },
      {
        id: '710508',
        zipcode: 71120,
        text: 'โคกตะบอง',
        value: 'โคกตะบอง',
        name: {
          th: 'โคกตะบอง',
          en: 'Khok Tabong',
        },
        districtId: 786,
      },
      {
        id: '710509',
        zipcode: 71120,
        text: 'ดอนขมิ้น',
        value: 'ดอนขมิ้น',
        name: {
          th: 'ดอนขมิ้น',
          en: 'Don Khamin',
        },
        districtId: 786,
      },
      {
        id: '710510',
        zipcode: 71130,
        text: 'อุโลกสี่หมื่น',
        value: 'อุโลกสี่หมื่น',
        name: {
          th: 'อุโลกสี่หมื่น',
          en: 'Ulok Si Muen',
        },
        districtId: 786,
      },
      {
        id: '710511',
        zipcode: 71120,
        text: 'เขาสามสิบหาบ',
        value: 'เขาสามสิบหาบ',
        name: {
          th: 'เขาสามสิบหาบ',
          en: 'Khao Samsip Hap',
        },
        districtId: 786,
      },
      {
        id: '710512',
        zipcode: 71130,
        text: 'พระแท่น',
        value: 'พระแท่น',
        name: {
          th: 'พระแท่น',
          en: 'Phra Thaen',
        },
        districtId: 786,
      },
      {
        id: '710513',
        zipcode: 71120,
        text: 'หวายเหนียว',
        value: 'หวายเหนียว',
        name: {
          th: 'หวายเหนียว',
          en: 'Wai Niao',
        },
        districtId: 786,
      },
      {
        id: '710514',
        zipcode: 71130,
        text: 'แสนตอ',
        value: 'แสนตอ',
        name: {
          th: 'แสนตอ',
          en: 'Saen To',
        },
        districtId: 786,
      },
      {
        id: '710515',
        zipcode: 70190,
        text: 'สนามแย้',
        value: 'สนามแย้',
        name: {
          th: 'สนามแย้',
          en: 'Sanam Yae',
        },
        districtId: 786,
      },
      {
        id: '710516',
        zipcode: 71120,
        text: 'ท่าเสา',
        value: 'ท่าเสา',
        name: {
          th: 'ท่าเสา',
          en: 'Tha Sao',
        },
        districtId: 786,
      },
      {
        id: '710517',
        zipcode: 71130,
        text: 'หนองลาน',
        value: 'หนองลาน',
        name: {
          th: 'หนองลาน',
          en: 'Nong Lan',
        },
        districtId: 786,
      },
      {
        id: '710601',
        zipcode: 71110,
        text: 'ท่าม่วง',
        value: 'ท่าม่วง',
        name: {
          th: 'ท่าม่วง',
          en: 'Tha Muang',
        },
        districtId: 787,
      },
      {
        id: '710602',
        zipcode: 71110,
        text: 'วังขนาย',
        value: 'วังขนาย',
        name: {
          th: 'วังขนาย',
          en: 'Wang Khanai',
        },
        districtId: 787,
      },
      {
        id: '710603',
        zipcode: 71110,
        text: 'วังศาลา',
        value: 'วังศาลา',
        name: {
          th: 'วังศาลา',
          en: 'Wang Sala',
        },
        districtId: 787,
      },
      {
        id: '710604',
        zipcode: 71110,
        text: 'ท่าล้อ',
        value: 'ท่าล้อ',
        name: {
          th: 'ท่าล้อ',
          en: 'Tha Lo',
        },
        districtId: 787,
      },
      {
        id: '710605',
        zipcode: 71110,
        text: 'หนองขาว',
        value: 'หนองขาว',
        name: {
          th: 'หนองขาว',
          en: 'Nong Khao',
        },
        districtId: 787,
      },
      {
        id: '710606',
        zipcode: 71110,
        text: 'ทุ่งทอง',
        value: 'ทุ่งทอง',
        name: {
          th: 'ทุ่งทอง',
          en: 'Thung Thong',
        },
        districtId: 787,
      },
      {
        id: '710607',
        zipcode: 71110,
        text: 'เขาน้อย',
        value: 'เขาน้อย',
        name: {
          th: 'เขาน้อย',
          en: 'Khao Noi',
        },
        districtId: 787,
      },
      {
        id: '710608',
        zipcode: 71110,
        text: 'ม่วงชุม',
        value: 'ม่วงชุม',
        name: {
          th: 'ม่วงชุม',
          en: 'Muang Chum',
        },
        districtId: 787,
      },
      {
        id: '710609',
        zipcode: 71110,
        text: 'บ้านใหม่',
        value: 'บ้านใหม่',
        name: {
          th: 'บ้านใหม่',
          en: 'Ban Mai',
        },
        districtId: 787,
      },
      {
        id: '710610',
        zipcode: 71110,
        text: 'พังตรุ',
        value: 'พังตรุ',
        name: {
          th: 'พังตรุ',
          en: 'Phang Tru',
        },
        districtId: 787,
      },
      {
        id: '710611',
        zipcode: 71130,
        text: 'ท่าตะคร้อ',
        value: 'ท่าตะคร้อ',
        name: {
          th: 'ท่าตะคร้อ',
          en: 'Tha Takhro',
        },
        districtId: 787,
      },
      {
        id: '710612',
        zipcode: 71110,
        text: 'รางสาลี่',
        value: 'รางสาลี่',
        name: {
          th: 'รางสาลี่',
          en: 'Rang Sali',
        },
        districtId: 787,
      },
      {
        id: '710613',
        zipcode: 71110,
        text: 'หนองตากยา',
        value: 'หนองตากยา',
        name: {
          th: 'หนองตากยา',
          en: 'Nong Tak Ya',
        },
        districtId: 787,
      },
      {
        id: '710701',
        zipcode: 71180,
        text: 'ท่าขนุน',
        value: 'ท่าขนุน',
        name: {
          th: 'ท่าขนุน',
          en: 'Tha Khanun',
        },
        districtId: 788,
      },
      {
        id: '710702',
        zipcode: 71180,
        text: 'ปิล๊อก',
        value: 'ปิล๊อก',
        name: {
          th: 'ปิล๊อก',
          en: 'Pilok',
        },
        districtId: 788,
      },
      {
        id: '710703',
        zipcode: 71180,
        text: 'หินดาด',
        value: 'หินดาด',
        name: {
          th: 'หินดาด',
          en: 'Hin Dat',
        },
        districtId: 788,
      },
      {
        id: '710704',
        zipcode: 71180,
        text: 'ลิ่นถิ่น',
        value: 'ลิ่นถิ่น',
        name: {
          th: 'ลิ่นถิ่น',
          en: 'Linthin',
        },
        districtId: 788,
      },
      {
        id: '710705',
        zipcode: 71180,
        text: 'ชะแล',
        value: 'ชะแล',
        name: {
          th: 'ชะแล',
          en: 'Chalae',
        },
        districtId: 788,
      },
      {
        id: '710706',
        zipcode: 71180,
        text: 'ห้วยเขย่ง',
        value: 'ห้วยเขย่ง',
        name: {
          th: 'ห้วยเขย่ง',
          en: 'Huai Khayeng',
        },
        districtId: 788,
      },
      {
        id: '710707',
        zipcode: 71180,
        text: 'สหกรณ์นิคม',
        value: 'สหกรณ์นิคม',
        name: {
          th: 'สหกรณ์นิคม',
          en: 'Sahakon Nikhom',
        },
        districtId: 788,
      },
      {
        id: '710801',
        zipcode: 71240,
        text: 'หนองลู',
        value: 'หนองลู',
        name: {
          th: 'หนองลู',
          en: 'Nong Lu',
        },
        districtId: 789,
      },
      {
        id: '710802',
        zipcode: 71240,
        text: 'ปรังเผล',
        value: 'ปรังเผล',
        name: {
          th: 'ปรังเผล',
          en: 'Prangphle',
        },
        districtId: 789,
      },
      {
        id: '710803',
        zipcode: 71240,
        text: 'ไล่โว่',
        value: 'ไล่โว่',
        name: {
          th: 'ไล่โว่',
          en: 'Lai Wo',
        },
        districtId: 789,
      },
      {
        id: '710901',
        zipcode: 71140,
        text: 'พนมทวน',
        value: 'พนมทวน',
        name: {
          th: 'พนมทวน',
          en: 'Phanom Thuan',
        },
        districtId: 790,
      },
      {
        id: '710902',
        zipcode: 71140,
        text: 'หนองโรง',
        value: 'หนองโรง',
        name: {
          th: 'หนองโรง',
          en: 'Nong Rong',
        },
        districtId: 790,
      },
      {
        id: '710903',
        zipcode: 71140,
        text: 'ทุ่งสมอ',
        value: 'ทุ่งสมอ',
        name: {
          th: 'ทุ่งสมอ',
          en: 'Thung Samo',
        },
        districtId: 790,
      },
      {
        id: '710904',
        zipcode: 71140,
        text: 'ดอนเจดีย์',
        value: 'ดอนเจดีย์',
        name: {
          th: 'ดอนเจดีย์',
          en: 'Don Chedi',
        },
        districtId: 790,
      },
      {
        id: '710905',
        zipcode: 71140,
        text: 'พังตรุ',
        value: 'พังตรุ',
        name: {
          th: 'พังตรุ',
          en: 'Phang Tru',
        },
        districtId: 790,
      },
      {
        id: '710906',
        zipcode: 71170,
        text: 'รางหวาย',
        value: 'รางหวาย',
        name: {
          th: 'รางหวาย',
          en: 'Rang Wai',
        },
        districtId: 790,
      },
      {
        id: '710911',
        zipcode: 71140,
        text: 'หนองสาหร่าย',
        value: 'หนองสาหร่าย',
        name: {
          th: 'หนองสาหร่าย',
          en: 'Nong Sarai',
        },
        districtId: 790,
      },
      {
        id: '710912',
        zipcode: 71140,
        text: 'ดอนตาเพชร',
        value: 'ดอนตาเพชร',
        name: {
          th: 'ดอนตาเพชร',
          en: 'Don Ta Phet',
        },
        districtId: 790,
      },
      {
        id: '711001',
        zipcode: 71210,
        text: 'เลาขวัญ',
        value: 'เลาขวัญ',
        name: {
          th: 'เลาขวัญ',
          en: 'Lao Khwan',
        },
        districtId: 791,
      },
      {
        id: '711002',
        zipcode: 71210,
        text: 'หนองโสน',
        value: 'หนองโสน',
        name: {
          th: 'หนองโสน',
          en: 'Nong Sano',
        },
        districtId: 791,
      },
      {
        id: '711003',
        zipcode: 71210,
        text: 'หนองประดู่',
        value: 'หนองประดู่',
        name: {
          th: 'หนองประดู่',
          en: 'Nong Pradu',
        },
        districtId: 791,
      },
      {
        id: '711004',
        zipcode: 71210,
        text: 'หนองปลิง',
        value: 'หนองปลิง',
        name: {
          th: 'หนองปลิง',
          en: 'Nong Pling',
        },
        districtId: 791,
      },
      {
        id: '711005',
        zipcode: 71210,
        text: 'หนองนกแก้ว',
        value: 'หนองนกแก้ว',
        name: {
          th: 'หนองนกแก้ว',
          en: 'Nong Nok Kaeo',
        },
        districtId: 791,
      },
      {
        id: '711006',
        zipcode: 71210,
        text: 'ทุ่งกระบ่ำ',
        value: 'ทุ่งกระบ่ำ',
        name: {
          th: 'ทุ่งกระบ่ำ',
          en: 'Thung Krabam',
        },
        districtId: 791,
      },
      {
        id: '711007',
        zipcode: 71210,
        text: 'หนองฝ้าย',
        value: 'หนองฝ้าย',
        name: {
          th: 'หนองฝ้าย',
          en: 'Nong Fai',
        },
        districtId: 791,
      },
      {
        id: '711101',
        zipcode: 71260,
        text: 'ด่านมะขามเตี้ย',
        value: 'ด่านมะขามเตี้ย',
        name: {
          th: 'ด่านมะขามเตี้ย',
          en: 'Dan Makham Tia',
        },
        districtId: 792,
      },
      {
        id: '711102',
        zipcode: 71260,
        text: 'กลอนโด',
        value: 'กลอนโด',
        name: {
          th: 'กลอนโด',
          en: 'Klondo',
        },
        districtId: 792,
      },
      {
        id: '711103',
        zipcode: 71260,
        text: 'จรเข้เผือก',
        value: 'จรเข้เผือก',
        name: {
          th: 'จรเข้เผือก',
          en: 'Chorakhe Phueak',
        },
        districtId: 792,
      },
      {
        id: '711104',
        zipcode: 71260,
        text: 'หนองไผ่',
        value: 'หนองไผ่',
        name: {
          th: 'หนองไผ่',
          en: 'Nong Phai',
        },
        districtId: 792,
      },
      {
        id: '711201',
        zipcode: 71220,
        text: 'หนองปรือ',
        value: 'หนองปรือ',
        name: {
          th: 'หนองปรือ',
          en: 'Nong Prue',
        },
        districtId: 793,
      },
      {
        id: '711202',
        zipcode: 71220,
        text: 'หนองปลาไหล',
        value: 'หนองปลาไหล',
        name: {
          th: 'หนองปลาไหล',
          en: 'Nong Pla Lai',
        },
        districtId: 793,
      },
      {
        id: '711203',
        zipcode: 71220,
        text: 'สมเด็จเจริญ',
        value: 'สมเด็จเจริญ',
        name: {
          th: 'สมเด็จเจริญ',
          en: 'Somdet Charoen',
        },
        districtId: 793,
      },
      {
        id: '711301',
        zipcode: 71170,
        text: 'ห้วยกระเจา',
        value: 'ห้วยกระเจา',
        name: {
          th: 'ห้วยกระเจา',
          en: 'Huai Krachao',
        },
        districtId: 794,
      },
      {
        id: '711302',
        zipcode: 71170,
        text: 'วังไผ่',
        value: 'วังไผ่',
        name: {
          th: 'วังไผ่',
          en: 'Wang Phai',
        },
        districtId: 794,
      },
      {
        id: '711303',
        zipcode: 71170,
        text: 'ดอนแสลบ',
        value: 'ดอนแสลบ',
        name: {
          th: 'ดอนแสลบ',
          en: 'Don Salaep',
        },
        districtId: 794,
      },
      {
        id: '711304',
        zipcode: 71170,
        text: 'สระลงเรือ',
        value: 'สระลงเรือ',
        name: {
          th: 'สระลงเรือ',
          en: 'Sa Long Ruea',
        },
        districtId: 794,
      },
      {
        id: '720101',
        zipcode: 72000,
        text: 'ท่าพี่เลี้ยง',
        value: 'ท่าพี่เลี้ยง',
        name: {
          th: 'ท่าพี่เลี้ยง',
          en: 'Tha Phi Liang',
        },
        districtId: 797,
      },
      {
        id: '720102',
        zipcode: 72000,
        text: 'รั้วใหญ่',
        value: 'รั้วใหญ่',
        name: {
          th: 'รั้วใหญ่',
          en: 'Rua Yai',
        },
        districtId: 797,
      },
      {
        id: '720103',
        zipcode: 72000,
        text: 'ทับตีเหล็ก',
        value: 'ทับตีเหล็ก',
        name: {
          th: 'ทับตีเหล็ก',
          en: 'Thap Ti Lek',
        },
        districtId: 797,
      },
      {
        id: '720104',
        zipcode: 72000,
        text: 'ท่าระหัด',
        value: 'ท่าระหัด',
        name: {
          th: 'ท่าระหัด',
          en: 'Tha Rahat',
        },
        districtId: 797,
      },
      {
        id: '720105',
        zipcode: 72000,
        text: 'ไผ่ขวาง',
        value: 'ไผ่ขวาง',
        name: {
          th: 'ไผ่ขวาง',
          en: 'Phai Kwang',
        },
        districtId: 797,
      },
      {
        id: '720106',
        zipcode: 72000,
        text: 'โคกโคเฒ่า',
        value: 'โคกโคเฒ่า',
        name: {
          th: 'โคกโคเฒ่า',
          en: 'Khok Kho Thao',
        },
        districtId: 797,
      },
      {
        id: '720107',
        zipcode: 72000,
        text: 'ดอนตาล',
        value: 'ดอนตาล',
        name: {
          th: 'ดอนตาล',
          en: 'Don Tan',
        },
        districtId: 797,
      },
      {
        id: '720108',
        zipcode: 72000,
        text: 'ดอนมะสังข์',
        value: 'ดอนมะสังข์',
        name: {
          th: 'ดอนมะสังข์',
          en: 'Don Masang',
        },
        districtId: 797,
      },
      {
        id: '720109',
        zipcode: 72000,
        text: 'พิหารแดง',
        value: 'พิหารแดง',
        name: {
          th: 'พิหารแดง',
          en: 'Phihan Daeng',
        },
        districtId: 797,
      },
      {
        id: '720110',
        zipcode: 72000,
        text: 'ดอนกำยาน',
        value: 'ดอนกำยาน',
        name: {
          th: 'ดอนกำยาน',
          en: 'Don Kamyan',
        },
        districtId: 797,
      },
      {
        id: '720111',
        zipcode: 72000,
        text: 'ดอนโพธิ์ทอง',
        value: 'ดอนโพธิ์ทอง',
        name: {
          th: 'ดอนโพธิ์ทอง',
          en: 'Don Pho Thong',
        },
        districtId: 797,
      },
      {
        id: '720112',
        zipcode: 72000,
        text: 'บ้านโพธิ์',
        value: 'บ้านโพธิ์',
        name: {
          th: 'บ้านโพธิ์',
          en: 'Ban Pho',
        },
        districtId: 797,
      },
      {
        id: '720113',
        zipcode: 72230,
        text: 'สระแก้ว',
        value: 'สระแก้ว',
        name: {
          th: 'สระแก้ว',
          en: 'Sa Kaeo',
        },
        districtId: 797,
      },
      {
        id: '720114',
        zipcode: 72230,
        text: 'ตลิ่งชัน',
        value: 'ตลิ่งชัน',
        name: {
          th: 'ตลิ่งชัน',
          en: 'Taling Chan',
        },
        districtId: 797,
      },
      {
        id: '720115',
        zipcode: 72210,
        text: 'บางกุ้ง',
        value: 'บางกุ้ง',
        name: {
          th: 'บางกุ้ง',
          en: 'Bang Kung',
        },
        districtId: 797,
      },
      {
        id: '720116',
        zipcode: 72210,
        text: 'ศาลาขาว',
        value: 'ศาลาขาว',
        name: {
          th: 'ศาลาขาว',
          en: 'Sala Khao',
        },
        districtId: 797,
      },
      {
        id: '720117',
        zipcode: 72210,
        text: 'สวนแตง',
        value: 'สวนแตง',
        name: {
          th: 'สวนแตง',
          en: 'Suan Taeng',
        },
        districtId: 797,
      },
      {
        id: '720118',
        zipcode: 72000,
        text: 'สนามชัย',
        value: 'สนามชัย',
        name: {
          th: 'สนามชัย',
          en: 'Sanam Chai',
        },
        districtId: 797,
      },
      {
        id: '720119',
        zipcode: 72000,
        text: 'โพธิ์พระยา',
        value: 'โพธิ์พระยา',
        name: {
          th: 'โพธิ์พระยา',
          en: 'Pho Phraya',
        },
        districtId: 797,
      },
      {
        id: '720120',
        zipcode: 72230,
        text: 'สนามคลี',
        value: 'สนามคลี',
        name: {
          th: 'สนามคลี',
          en: 'Sanam Klee',
        },
        districtId: 797,
      },
      {
        id: '720201',
        zipcode: 72120,
        text: 'เขาพระ',
        value: 'เขาพระ',
        name: {
          th: 'เขาพระ',
          en: 'Khao Phra',
        },
        districtId: 798,
      },
      {
        id: '720202',
        zipcode: 72120,
        text: 'เดิมบาง',
        value: 'เดิมบาง',
        name: {
          th: 'เดิมบาง',
          en: 'Doem Bang',
        },
        districtId: 798,
      },
      {
        id: '720203',
        zipcode: 72120,
        text: 'นางบวช',
        value: 'นางบวช',
        name: {
          th: 'นางบวช',
          en: 'Nang Buat',
        },
        districtId: 798,
      },
      {
        id: '720204',
        zipcode: 72120,
        text: 'เขาดิน',
        value: 'เขาดิน',
        name: {
          th: 'เขาดิน',
          en: 'Khao Din',
        },
        districtId: 798,
      },
      {
        id: '720205',
        zipcode: 72120,
        text: 'ปากน้ำ',
        value: 'ปากน้ำ',
        name: {
          th: 'ปากน้ำ',
          en: 'Pak Nam',
        },
        districtId: 798,
      },
      {
        id: '720206',
        zipcode: 72120,
        text: 'ทุ่งคลี',
        value: 'ทุ่งคลี',
        name: {
          th: 'ทุ่งคลี',
          en: 'Thung Khli',
        },
        districtId: 798,
      },
      {
        id: '720207',
        zipcode: 72120,
        text: 'โคกช้าง',
        value: 'โคกช้าง',
        name: {
          th: 'โคกช้าง',
          en: 'Khok Chang',
        },
        districtId: 798,
      },
      {
        id: '720208',
        zipcode: 72120,
        text: 'หัวเขา',
        value: 'หัวเขา',
        name: {
          th: 'หัวเขา',
          en: 'Hua Khao',
        },
        districtId: 798,
      },
      {
        id: '720209',
        zipcode: 72120,
        text: 'หัวนา',
        value: 'หัวนา',
        name: {
          th: 'หัวนา',
          en: 'Hua Na',
        },
        districtId: 798,
      },
      {
        id: '720210',
        zipcode: 72120,
        text: 'บ่อกรุ',
        value: 'บ่อกรุ',
        name: {
          th: 'บ่อกรุ',
          en: 'Bo Kru',
        },
        districtId: 798,
      },
      {
        id: '720211',
        zipcode: 72120,
        text: 'วังศรีราช',
        value: 'วังศรีราช',
        name: {
          th: 'วังศรีราช',
          en: 'Wang Si Rat',
        },
        districtId: 798,
      },
      {
        id: '720212',
        zipcode: 72120,
        text: 'ป่าสะแก',
        value: 'ป่าสะแก',
        name: {
          th: 'ป่าสะแก',
          en: 'Pa Sakae',
        },
        districtId: 798,
      },
      {
        id: '720213',
        zipcode: 72120,
        text: 'ยางนอน',
        value: 'ยางนอน',
        name: {
          th: 'ยางนอน',
          en: 'Yang Non',
        },
        districtId: 798,
      },
      {
        id: '720214',
        zipcode: 72120,
        text: 'หนองกระทุ่ม',
        value: 'หนองกระทุ่ม',
        name: {
          th: 'หนองกระทุ่ม',
          en: 'Nong Krathum',
        },
        districtId: 798,
      },
      {
        id: '720301',
        zipcode: 72180,
        text: 'หนองมะค่าโมง',
        value: 'หนองมะค่าโมง',
        name: {
          th: 'หนองมะค่าโมง',
          en: 'Nong Makha Mong',
        },
        districtId: 799,
      },
      {
        id: '720302',
        zipcode: 72180,
        text: 'ด่านช้าง',
        value: 'ด่านช้าง',
        name: {
          th: 'ด่านช้าง',
          en: 'Dan Chang',
        },
        districtId: 799,
      },
      {
        id: '720303',
        zipcode: 72180,
        text: 'ห้วยขมิ้น',
        value: 'ห้วยขมิ้น',
        name: {
          th: 'ห้วยขมิ้น',
          en: 'Huai Khamin',
        },
        districtId: 799,
      },
      {
        id: '720304',
        zipcode: 72180,
        text: 'องค์พระ',
        value: 'องค์พระ',
        name: {
          th: 'องค์พระ',
          en: 'Ong Phra',
        },
        districtId: 799,
      },
      {
        id: '720305',
        zipcode: 72180,
        text: 'วังคัน',
        value: 'วังคัน',
        name: {
          th: 'วังคัน',
          en: 'Wang Khan',
        },
        districtId: 799,
      },
      {
        id: '720306',
        zipcode: 72180,
        text: 'นิคมกระเสียว',
        value: 'นิคมกระเสียว',
        name: {
          th: 'นิคมกระเสียว',
          en: 'Nikhom Krasiao',
        },
        districtId: 799,
      },
      {
        id: '720307',
        zipcode: 72180,
        text: 'วังยาว',
        value: 'วังยาว',
        name: {
          th: 'วังยาว',
          en: 'Wang Yao',
        },
        districtId: 799,
      },
      {
        id: '720401',
        zipcode: 72150,
        text: 'โคกคราม',
        value: 'โคกคราม',
        name: {
          th: 'โคกคราม',
          en: 'Khok Khram',
        },
        districtId: 800,
      },
      {
        id: '720402',
        zipcode: 72150,
        text: 'บางปลาม้า',
        value: 'บางปลาม้า',
        name: {
          th: 'บางปลาม้า',
          en: 'Bang Pla Ma',
        },
        districtId: 800,
      },
      {
        id: '720403',
        zipcode: 72150,
        text: 'ตะค่า',
        value: 'ตะค่า',
        name: {
          th: 'ตะค่า',
          en: 'Takha',
        },
        districtId: 800,
      },
      {
        id: '720404',
        zipcode: 72150,
        text: 'บางใหญ่',
        value: 'บางใหญ่',
        name: {
          th: 'บางใหญ่',
          en: 'Bang Yai',
        },
        districtId: 800,
      },
      {
        id: '720405',
        zipcode: 72150,
        text: 'กฤษณา',
        value: 'กฤษณา',
        name: {
          th: 'กฤษณา',
          en: 'Kritsana',
        },
        districtId: 800,
      },
      {
        id: '720406',
        zipcode: 72150,
        text: 'สาลี',
        value: 'สาลี',
        name: {
          th: 'สาลี',
          en: 'Sali',
        },
        districtId: 800,
      },
      {
        id: '720407',
        zipcode: 72150,
        text: 'ไผ่กองดิน',
        value: 'ไผ่กองดิน',
        name: {
          th: 'ไผ่กองดิน',
          en: 'Phai Kong Din',
        },
        districtId: 800,
      },
      {
        id: '720408',
        zipcode: 72150,
        text: 'องครักษ์',
        value: 'องครักษ์',
        name: {
          th: 'องครักษ์',
          en: 'Ongkharak',
        },
        districtId: 800,
      },
      {
        id: '720409',
        zipcode: 72150,
        text: 'จรเข้ใหญ่',
        value: 'จรเข้ใหญ่',
        name: {
          th: 'จรเข้ใหญ่',
          en: 'Chorakhe Yai',
        },
        districtId: 800,
      },
      {
        id: '720410',
        zipcode: 72150,
        text: 'บ้านแหลม',
        value: 'บ้านแหลม',
        name: {
          th: 'บ้านแหลม',
          en: 'Ban Laem',
        },
        districtId: 800,
      },
      {
        id: '720411',
        zipcode: 72150,
        text: 'มะขามล้ม',
        value: 'มะขามล้ม',
        name: {
          th: 'มะขามล้ม',
          en: 'Makham Lom',
        },
        districtId: 800,
      },
      {
        id: '720412',
        zipcode: 72150,
        text: 'วังน้ำเย็น',
        value: 'วังน้ำเย็น',
        name: {
          th: 'วังน้ำเย็น',
          en: 'Wang Nam Yen',
        },
        districtId: 800,
      },
      {
        id: '720413',
        zipcode: 72150,
        text: 'วัดโบสถ์',
        value: 'วัดโบสถ์',
        name: {
          th: 'วัดโบสถ์',
          en: 'Wat Bot',
        },
        districtId: 800,
      },
      {
        id: '720414',
        zipcode: 72150,
        text: 'วัดดาว',
        value: 'วัดดาว',
        name: {
          th: 'วัดดาว',
          en: 'Wad Daw',
        },
        districtId: 800,
      },
      {
        id: '720501',
        zipcode: 72140,
        text: 'ศรีประจันต์',
        value: 'ศรีประจันต์',
        name: {
          th: 'ศรีประจันต์',
          en: 'Si Prachan',
        },
        districtId: 801,
      },
      {
        id: '720502',
        zipcode: 72140,
        text: 'บ้านกร่าง',
        value: 'บ้านกร่าง',
        name: {
          th: 'บ้านกร่าง',
          en: 'Ban Krang',
        },
        districtId: 801,
      },
      {
        id: '720503',
        zipcode: 72140,
        text: 'มดแดง',
        value: 'มดแดง',
        name: {
          th: 'มดแดง',
          en: 'Mot Daeng',
        },
        districtId: 801,
      },
      {
        id: '720504',
        zipcode: 72140,
        text: 'บางงาม',
        value: 'บางงาม',
        name: {
          th: 'บางงาม',
          en: 'Bang Ngam',
        },
        districtId: 801,
      },
      {
        id: '720505',
        zipcode: 72140,
        text: 'ดอนปรู',
        value: 'ดอนปรู',
        name: {
          th: 'ดอนปรู',
          en: 'Don Pru',
        },
        districtId: 801,
      },
      {
        id: '720506',
        zipcode: 72140,
        text: 'ปลายนา',
        value: 'ปลายนา',
        name: {
          th: 'ปลายนา',
          en: 'Plai Na',
        },
        districtId: 801,
      },
      {
        id: '720507',
        zipcode: 72140,
        text: 'วังหว้า',
        value: 'วังหว้า',
        name: {
          th: 'วังหว้า',
          en: 'Wang Wa',
        },
        districtId: 801,
      },
      {
        id: '720508',
        zipcode: 72140,
        text: 'วังน้ำซับ',
        value: 'วังน้ำซับ',
        name: {
          th: 'วังน้ำซับ',
          en: 'Wang Nam Sap',
        },
        districtId: 801,
      },
      {
        id: '720509',
        zipcode: 72140,
        text: 'วังยาง',
        value: 'วังยาง',
        name: {
          th: 'วังยาง',
          en: 'Wang Yang',
        },
        districtId: 801,
      },
      {
        id: '720601',
        zipcode: 72170,
        text: 'ดอนเจดีย์',
        value: 'ดอนเจดีย์',
        name: {
          th: 'ดอนเจดีย์',
          en: 'Don Chedi',
        },
        districtId: 802,
      },
      {
        id: '720602',
        zipcode: 72170,
        text: 'หนองสาหร่าย',
        value: 'หนองสาหร่าย',
        name: {
          th: 'หนองสาหร่าย',
          en: 'Nong Sarai',
        },
        districtId: 802,
      },
      {
        id: '720603',
        zipcode: 72170,
        text: 'ไร่รถ',
        value: 'ไร่รถ',
        name: {
          th: 'ไร่รถ',
          en: 'Rai Rot',
        },
        districtId: 802,
      },
      {
        id: '720604',
        zipcode: 72250,
        text: 'สระกระโจม',
        value: 'สระกระโจม',
        name: {
          th: 'สระกระโจม',
          en: 'Sa Krachom',
        },
        districtId: 802,
      },
      {
        id: '720605',
        zipcode: 72250,
        text: 'ทะเลบก',
        value: 'ทะเลบก',
        name: {
          th: 'ทะเลบก',
          en: 'Talae Bok',
        },
        districtId: 802,
      },
      {
        id: '720701',
        zipcode: 72110,
        text: 'สองพี่น้อง',
        value: 'สองพี่น้อง',
        name: {
          th: 'สองพี่น้อง',
          en: 'Song Phi Nong',
        },
        districtId: 803,
      },
      {
        id: '720702',
        zipcode: 72110,
        text: 'บางเลน',
        value: 'บางเลน',
        name: {
          th: 'บางเลน',
          en: 'Bang Len',
        },
        districtId: 803,
      },
      {
        id: '720703',
        zipcode: 72110,
        text: 'บางตาเถร',
        value: 'บางตาเถร',
        name: {
          th: 'บางตาเถร',
          en: 'Bang Ta Then',
        },
        districtId: 803,
      },
      {
        id: '720704',
        zipcode: 72110,
        text: 'บางตะเคียน',
        value: 'บางตะเคียน',
        name: {
          th: 'บางตะเคียน',
          en: 'Bang Takhian',
        },
        districtId: 803,
      },
      {
        id: '720705',
        zipcode: 72110,
        text: 'บ้านกุ่ม',
        value: 'บ้านกุ่ม',
        name: {
          th: 'บ้านกุ่ม',
          en: 'Ban Kum',
        },
        districtId: 803,
      },
      {
        id: '720706',
        zipcode: 72110,
        text: 'หัวโพธิ์',
        value: 'หัวโพธิ์',
        name: {
          th: 'หัวโพธิ์',
          en: 'Hua Pho',
        },
        districtId: 803,
      },
      {
        id: '720707',
        zipcode: 72110,
        text: 'บางพลับ',
        value: 'บางพลับ',
        name: {
          th: 'บางพลับ',
          en: 'Bang Phlap',
        },
        districtId: 803,
      },
      {
        id: '720708',
        zipcode: 72110,
        text: 'เนินพระปรางค์',
        value: 'เนินพระปรางค์',
        name: {
          th: 'เนินพระปรางค์',
          en: 'Noen Phra Prang',
        },
        districtId: 803,
      },
      {
        id: '720709',
        zipcode: 72110,
        text: 'บ้านช้าง',
        value: 'บ้านช้าง',
        name: {
          th: 'บ้านช้าง',
          en: 'Ban Chang',
        },
        districtId: 803,
      },
      {
        id: '720710',
        zipcode: 72110,
        text: 'ต้นตาล',
        value: 'ต้นตาล',
        name: {
          th: 'ต้นตาล',
          en: 'Ton Tan',
        },
        districtId: 803,
      },
      {
        id: '720711',
        zipcode: 72110,
        text: 'ศรีสำราญ',
        value: 'ศรีสำราญ',
        name: {
          th: 'ศรีสำราญ',
          en: 'Si Samran',
        },
        districtId: 803,
      },
      {
        id: '720712',
        zipcode: 72190,
        text: 'ทุ่งคอก',
        value: 'ทุ่งคอก',
        name: {
          th: 'ทุ่งคอก',
          en: 'Thung Khok',
        },
        districtId: 803,
      },
      {
        id: '720713',
        zipcode: 72110,
        text: 'หนองบ่อ',
        value: 'หนองบ่อ',
        name: {
          th: 'หนองบ่อ',
          en: 'Nong Bo',
        },
        districtId: 803,
      },
      {
        id: '720714',
        zipcode: 72190,
        text: 'บ่อสุพรรณ',
        value: 'บ่อสุพรรณ',
        name: {
          th: 'บ่อสุพรรณ',
          en: 'Bo Suphan',
        },
        districtId: 803,
      },
      {
        id: '720715',
        zipcode: 72110,
        text: 'ดอนมะนาว',
        value: 'ดอนมะนาว',
        name: {
          th: 'ดอนมะนาว',
          en: 'Don Manao',
        },
        districtId: 803,
      },
      {
        id: '720801',
        zipcode: 72130,
        text: 'ย่านยาว',
        value: 'ย่านยาว',
        name: {
          th: 'ย่านยาว',
          en: 'Yan Yao',
        },
        districtId: 804,
      },
      {
        id: '720802',
        zipcode: 72130,
        text: 'วังลึก',
        value: 'วังลึก',
        name: {
          th: 'วังลึก',
          en: 'Wang Luek',
        },
        districtId: 804,
      },
      {
        id: '720803',
        zipcode: 72130,
        text: 'สามชุก',
        value: 'สามชุก',
        name: {
          th: 'สามชุก',
          en: 'Sam Chuk',
        },
        districtId: 804,
      },
      {
        id: '720804',
        zipcode: 72130,
        text: 'หนองผักนาก',
        value: 'หนองผักนาก',
        name: {
          th: 'หนองผักนาก',
          en: 'Nong Phak Nak',
        },
        districtId: 804,
      },
      {
        id: '720805',
        zipcode: 72130,
        text: 'บ้านสระ',
        value: 'บ้านสระ',
        name: {
          th: 'บ้านสระ',
          en: 'Ban Sa',
        },
        districtId: 804,
      },
      {
        id: '720806',
        zipcode: 72130,
        text: 'หนองสะเดา',
        value: 'หนองสะเดา',
        name: {
          th: 'หนองสะเดา',
          en: 'Nong Sadao',
        },
        districtId: 804,
      },
      {
        id: '720807',
        zipcode: 72130,
        text: 'กระเสียว',
        value: 'กระเสียว',
        name: {
          th: 'กระเสียว',
          en: 'Krasiao',
        },
        districtId: 804,
      },
      {
        id: '720901',
        zipcode: 72160,
        text: 'อู่ทอง',
        value: 'อู่ทอง',
        name: {
          th: 'อู่ทอง',
          en: 'U Thong',
        },
        districtId: 805,
      },
      {
        id: '720902',
        zipcode: 72220,
        text: 'สระยายโสม',
        value: 'สระยายโสม',
        name: {
          th: 'สระยายโสม',
          en: 'Sa Yai Som',
        },
        districtId: 805,
      },
      {
        id: '720903',
        zipcode: 72160,
        text: 'จรเข้สามพัน',
        value: 'จรเข้สามพัน',
        name: {
          th: 'จรเข้สามพัน',
          en: 'Chorakhe Sam Phan',
        },
        districtId: 805,
      },
      {
        id: '720904',
        zipcode: 72160,
        text: 'บ้านดอน',
        value: 'บ้านดอน',
        name: {
          th: 'บ้านดอน',
          en: 'Ban Don',
        },
        districtId: 805,
      },
      {
        id: '720905',
        zipcode: 72160,
        text: 'ยุ้งทะลาย',
        value: 'ยุ้งทะลาย',
        name: {
          th: 'ยุ้งทะลาย',
          en: 'Yung Thalai',
        },
        districtId: 805,
      },
      {
        id: '720906',
        zipcode: 72220,
        text: 'ดอนมะเกลือ',
        value: 'ดอนมะเกลือ',
        name: {
          th: 'ดอนมะเกลือ',
          en: 'Don Makluea',
        },
        districtId: 805,
      },
      {
        id: '720907',
        zipcode: 72160,
        text: 'หนองโอ่ง',
        value: 'หนองโอ่ง',
        name: {
          th: 'หนองโอ่ง',
          en: 'Nong Ong',
        },
        districtId: 805,
      },
      {
        id: '720908',
        zipcode: 72160,
        text: 'ดอนคา',
        value: 'ดอนคา',
        name: {
          th: 'ดอนคา',
          en: 'Don Kha',
        },
        districtId: 805,
      },
      {
        id: '720909',
        zipcode: 72160,
        text: 'พลับพลาไชย',
        value: 'พลับพลาไชย',
        name: {
          th: 'พลับพลาไชย',
          en: 'Phlapphla Chai',
        },
        districtId: 805,
      },
      {
        id: '720910',
        zipcode: 72160,
        text: 'บ้านโข้ง',
        value: 'บ้านโข้ง',
        name: {
          th: 'บ้านโข้ง',
          en: 'Ban Khong',
        },
        districtId: 805,
      },
      {
        id: '720911',
        zipcode: 72160,
        text: 'เจดีย์',
        value: 'เจดีย์',
        name: {
          th: 'เจดีย์',
          en: 'Chedi',
        },
        districtId: 805,
      },
      {
        id: '720912',
        zipcode: 72220,
        text: 'สระพังลาน',
        value: 'สระพังลาน',
        name: {
          th: 'สระพังลาน',
          en: 'Sa Phang Lan',
        },
        districtId: 805,
      },
      {
        id: '720913',
        zipcode: 72160,
        text: 'กระจัน',
        value: 'กระจัน',
        name: {
          th: 'กระจัน',
          en: 'Krachan',
        },
        districtId: 805,
      },
      {
        id: '721001',
        zipcode: 72240,
        text: 'หนองหญ้าไซ',
        value: 'หนองหญ้าไซ',
        name: {
          th: 'หนองหญ้าไซ',
          en: 'Nong Ya Sai',
        },
        districtId: 806,
      },
      {
        id: '721002',
        zipcode: 72240,
        text: 'หนองราชวัตร',
        value: 'หนองราชวัตร',
        name: {
          th: 'หนองราชวัตร',
          en: 'Nong Ratchawat',
        },
        districtId: 806,
      },
      {
        id: '721003',
        zipcode: 72240,
        text: 'หนองโพธิ์',
        value: 'หนองโพธิ์',
        name: {
          th: 'หนองโพธิ์',
          en: 'Nong Pho',
        },
        districtId: 806,
      },
      {
        id: '721004',
        zipcode: 72240,
        text: 'แจงงาม',
        value: 'แจงงาม',
        name: {
          th: 'แจงงาม',
          en: 'Chaeng Ngam',
        },
        districtId: 806,
      },
      {
        id: '721005',
        zipcode: 72240,
        text: 'หนองขาม',
        value: 'หนองขาม',
        name: {
          th: 'หนองขาม',
          en: 'Nong Kham',
        },
        districtId: 806,
      },
      {
        id: '721006',
        zipcode: 72240,
        text: 'ทัพหลวง',
        value: 'ทัพหลวง',
        name: {
          th: 'ทัพหลวง',
          en: 'Thap Luang',
        },
        districtId: 806,
      },
      {
        id: '730101',
        zipcode: 73000,
        text: 'พระปฐมเจดีย์',
        value: 'พระปฐมเจดีย์',
        name: {
          th: 'พระปฐมเจดีย์',
          en: 'Phra Pathom Chedi',
        },
        districtId: 807,
      },
      {
        id: '730102',
        zipcode: 73000,
        text: 'บางแขม',
        value: 'บางแขม',
        name: {
          th: 'บางแขม',
          en: 'Bang Khaem',
        },
        districtId: 807,
      },
      {
        id: '730103',
        zipcode: 73000,
        text: 'พระประโทน',
        value: 'พระประโทน',
        name: {
          th: 'พระประโทน',
          en: 'Phra Prathon',
        },
        districtId: 807,
      },
      {
        id: '730104',
        zipcode: 73000,
        text: 'ธรรมศาลา',
        value: 'ธรรมศาลา',
        name: {
          th: 'ธรรมศาลา',
          en: 'Thammasala',
        },
        districtId: 807,
      },
      {
        id: '730105',
        zipcode: 73000,
        text: 'ตาก้อง',
        value: 'ตาก้อง',
        name: {
          th: 'ตาก้อง',
          en: 'Ta Kong',
        },
        districtId: 807,
      },
      {
        id: '730106',
        zipcode: 73000,
        text: 'มาบแค',
        value: 'มาบแค',
        name: {
          th: 'มาบแค',
          en: 'Map Khae',
        },
        districtId: 807,
      },
      {
        id: '730107',
        zipcode: 73000,
        text: 'สนามจันทร์',
        value: 'สนามจันทร์',
        name: {
          th: 'สนามจันทร์',
          en: 'Sanam Chan',
        },
        districtId: 807,
      },
      {
        id: '730108',
        zipcode: 73000,
        text: 'ดอนยายหอม',
        value: 'ดอนยายหอม',
        name: {
          th: 'ดอนยายหอม',
          en: 'Don Yai Hom',
        },
        districtId: 807,
      },
      {
        id: '730109',
        zipcode: 73000,
        text: 'ถนนขาด',
        value: 'ถนนขาด',
        name: {
          th: 'ถนนขาด',
          en: 'Thanon Khat',
        },
        districtId: 807,
      },
      {
        id: '730110',
        zipcode: 73000,
        text: 'บ่อพลับ',
        value: 'บ่อพลับ',
        name: {
          th: 'บ่อพลับ',
          en: 'Bo Phlap',
        },
        districtId: 807,
      },
      {
        id: '730111',
        zipcode: 73000,
        text: 'นครปฐม',
        value: 'นครปฐม',
        name: {
          th: 'นครปฐม',
          en: 'Nakhon Pathom',
        },
        districtId: 807,
      },
      {
        id: '730112',
        zipcode: 73000,
        text: 'วังตะกู',
        value: 'วังตะกู',
        name: {
          th: 'วังตะกู',
          en: 'Wang Taku',
        },
        districtId: 807,
      },
      {
        id: '730113',
        zipcode: 73000,
        text: 'หนองปากโลง',
        value: 'หนองปากโลง',
        name: {
          th: 'หนองปากโลง',
          en: 'Nong Pak Long',
        },
        districtId: 807,
      },
      {
        id: '730114',
        zipcode: 73000,
        text: 'สามควายเผือก',
        value: 'สามควายเผือก',
        name: {
          th: 'สามควายเผือก',
          en: 'Sam Khwai Phueak',
        },
        districtId: 807,
      },
      {
        id: '730115',
        zipcode: 73000,
        text: 'ทุ่งน้อย',
        value: 'ทุ่งน้อย',
        name: {
          th: 'ทุ่งน้อย',
          en: 'Thung Noi',
        },
        districtId: 807,
      },
      {
        id: '730116',
        zipcode: 73000,
        text: 'หนองดินแดง',
        value: 'หนองดินแดง',
        name: {
          th: 'หนองดินแดง',
          en: 'Nong Din Daeng',
        },
        districtId: 807,
      },
      {
        id: '730117',
        zipcode: 73000,
        text: 'วังเย็น',
        value: 'วังเย็น',
        name: {
          th: 'วังเย็น',
          en: 'Wang Yen',
        },
        districtId: 807,
      },
      {
        id: '730118',
        zipcode: 73000,
        text: 'โพรงมะเดื่อ',
        value: 'โพรงมะเดื่อ',
        name: {
          th: 'โพรงมะเดื่อ',
          en: 'Phrong Maduea',
        },
        districtId: 807,
      },
      {
        id: '730119',
        zipcode: 73000,
        text: 'ลำพยา',
        value: 'ลำพยา',
        name: {
          th: 'ลำพยา',
          en: 'Lam Phaya',
        },
        districtId: 807,
      },
      {
        id: '730120',
        zipcode: 73000,
        text: 'สระกะเทียม',
        value: 'สระกะเทียม',
        name: {
          th: 'สระกะเทียม',
          en: 'Sa Kathiam',
        },
        districtId: 807,
      },
      {
        id: '730121',
        zipcode: 73000,
        text: 'สวนป่าน',
        value: 'สวนป่าน',
        name: {
          th: 'สวนป่าน',
          en: 'Suan Pan',
        },
        districtId: 807,
      },
      {
        id: '730122',
        zipcode: 73000,
        text: 'ห้วยจรเข้',
        value: 'ห้วยจรเข้',
        name: {
          th: 'ห้วยจรเข้',
          en: 'Huai Chorakhe',
        },
        districtId: 807,
      },
      {
        id: '730123',
        zipcode: 73000,
        text: 'ทัพหลวง',
        value: 'ทัพหลวง',
        name: {
          th: 'ทัพหลวง',
          en: 'Thap Luang',
        },
        districtId: 807,
      },
      {
        id: '730124',
        zipcode: 73000,
        text: 'หนองงูเหลือม',
        value: 'หนองงูเหลือม',
        name: {
          th: 'หนองงูเหลือม',
          en: 'Nong Ngulueam',
        },
        districtId: 807,
      },
      {
        id: '730125',
        zipcode: 73000,
        text: 'บ้านยาง',
        value: 'บ้านยาง',
        name: {
          th: 'บ้านยาง',
          en: 'Ban Yang',
        },
        districtId: 807,
      },
      {
        id: '730201',
        zipcode: 73140,
        text: 'ทุ่งกระพังโหม',
        value: 'ทุ่งกระพังโหม',
        name: {
          th: 'ทุ่งกระพังโหม',
          en: 'Thung Kraphanghom',
        },
        districtId: 808,
      },
      {
        id: '730202',
        zipcode: 73180,
        text: 'กระตีบ',
        value: 'กระตีบ',
        name: {
          th: 'กระตีบ',
          en: 'Kratip',
        },
        districtId: 808,
      },
      {
        id: '730203',
        zipcode: 73140,
        text: 'ทุ่งลูกนก',
        value: 'ทุ่งลูกนก',
        name: {
          th: 'ทุ่งลูกนก',
          en: 'Thung Luk Nok',
        },
        districtId: 808,
      },
      {
        id: '730204',
        zipcode: 73140,
        text: 'ห้วยขวาง',
        value: 'ห้วยขวาง',
        name: {
          th: 'ห้วยขวาง',
          en: 'Huai Khwang',
        },
        districtId: 808,
      },
      {
        id: '730205',
        zipcode: 73140,
        text: 'ทุ่งขวาง',
        value: 'ทุ่งขวาง',
        name: {
          th: 'ทุ่งขวาง',
          en: 'Thung Khwang',
        },
        districtId: 808,
      },
      {
        id: '730206',
        zipcode: 73140,
        text: 'สระสี่มุม',
        value: 'สระสี่มุม',
        name: {
          th: 'สระสี่มุม',
          en: 'Sa Si Mum',
        },
        districtId: 808,
      },
      {
        id: '730207',
        zipcode: 73140,
        text: 'ทุ่งบัว',
        value: 'ทุ่งบัว',
        name: {
          th: 'ทุ่งบัว',
          en: 'Thung Bua',
        },
        districtId: 808,
      },
      {
        id: '730208',
        zipcode: 73140,
        text: 'ดอนข่อย',
        value: 'ดอนข่อย',
        name: {
          th: 'ดอนข่อย',
          en: 'Don Khoi',
        },
        districtId: 808,
      },
      {
        id: '730209',
        zipcode: 73180,
        text: 'สระพัฒนา',
        value: 'สระพัฒนา',
        name: {
          th: 'สระพัฒนา',
          en: 'Sa Phatthana',
        },
        districtId: 808,
      },
      {
        id: '730210',
        zipcode: 73140,
        text: 'ห้วยหมอนทอง',
        value: 'ห้วยหมอนทอง',
        name: {
          th: 'ห้วยหมอนทอง',
          en: 'Huai Mon Thong',
        },
        districtId: 808,
      },
      {
        id: '730211',
        zipcode: 73180,
        text: 'ห้วยม่วง',
        value: 'ห้วยม่วง',
        name: {
          th: 'ห้วยม่วง',
          en: 'Huai Muang',
        },
        districtId: 808,
      },
      {
        id: '730212',
        zipcode: 73140,
        text: 'กำแพงแสน',
        value: 'กำแพงแสน',
        name: {
          th: 'กำแพงแสน',
          en: 'Kamphaeng Saen',
        },
        districtId: 808,
      },
      {
        id: '730213',
        zipcode: 73140,
        text: 'รางพิกุล',
        value: 'รางพิกุล',
        name: {
          th: 'รางพิกุล',
          en: 'Rang Phikun',
        },
        districtId: 808,
      },
      {
        id: '730214',
        zipcode: 73140,
        text: 'หนองกระทุ่ม',
        value: 'หนองกระทุ่ม',
        name: {
          th: 'หนองกระทุ่ม',
          en: 'Nong Krathum',
        },
        districtId: 808,
      },
      {
        id: '730215',
        zipcode: 73140,
        text: 'วังน้ำเขียว',
        value: 'วังน้ำเขียว',
        name: {
          th: 'วังน้ำเขียว',
          en: 'Wang Nam Khiao',
        },
        districtId: 808,
      },
      {
        id: '730301',
        zipcode: 73120,
        text: 'นครชัยศรี',
        value: 'นครชัยศรี',
        name: {
          th: 'นครชัยศรี',
          en: 'Nakhon Chai Si',
        },
        districtId: 809,
      },
      {
        id: '730302',
        zipcode: 73120,
        text: 'บางกระเบา',
        value: 'บางกระเบา',
        name: {
          th: 'บางกระเบา',
          en: 'Bang Krabao',
        },
        districtId: 809,
      },
      {
        id: '730303',
        zipcode: 73120,
        text: 'วัดแค',
        value: 'วัดแค',
        name: {
          th: 'วัดแค',
          en: 'Wat Khae',
        },
        districtId: 809,
      },
      {
        id: '730304',
        zipcode: 73120,
        text: 'ท่าตำหนัก',
        value: 'ท่าตำหนัก',
        name: {
          th: 'ท่าตำหนัก',
          en: 'Tha Tamnak',
        },
        districtId: 809,
      },
      {
        id: '730305',
        zipcode: 73120,
        text: 'บางแก้ว',
        value: 'บางแก้ว',
        name: {
          th: 'บางแก้ว',
          en: 'Bang Kaeo',
        },
        districtId: 809,
      },
      {
        id: '730306',
        zipcode: 73120,
        text: 'ท่ากระชับ',
        value: 'ท่ากระชับ',
        name: {
          th: 'ท่ากระชับ',
          en: 'Tha Krachap',
        },
        districtId: 809,
      },
      {
        id: '730307',
        zipcode: 73120,
        text: 'ขุนแก้ว',
        value: 'ขุนแก้ว',
        name: {
          th: 'ขุนแก้ว',
          en: 'Khun Kaeo',
        },
        districtId: 809,
      },
      {
        id: '730308',
        zipcode: 73120,
        text: 'ท่าพระยา',
        value: 'ท่าพระยา',
        name: {
          th: 'ท่าพระยา',
          en: 'Tha Phraya',
        },
        districtId: 809,
      },
      {
        id: '730309',
        zipcode: 73120,
        text: 'พะเนียด',
        value: 'พะเนียด',
        name: {
          th: 'พะเนียด',
          en: 'Phaniat',
        },
        districtId: 809,
      },
      {
        id: '730310',
        zipcode: 73120,
        text: 'บางระกำ',
        value: 'บางระกำ',
        name: {
          th: 'บางระกำ',
          en: 'Bang Rakam',
        },
        districtId: 809,
      },
      {
        id: '730311',
        zipcode: 73120,
        text: 'โคกพระเจดีย์',
        value: 'โคกพระเจดีย์',
        name: {
          th: 'โคกพระเจดีย์',
          en: 'Khok Phra Chedi',
        },
        districtId: 809,
      },
      {
        id: '730312',
        zipcode: 73120,
        text: 'ศรีษะทอง',
        value: 'ศรีษะทอง',
        name: {
          th: 'ศรีษะทอง',
          en: 'Sisa Thong',
        },
        districtId: 809,
      },
      {
        id: '730313',
        zipcode: 73120,
        text: 'แหลมบัว',
        value: 'แหลมบัว',
        name: {
          th: 'แหลมบัว',
          en: 'Laem Bua',
        },
        districtId: 809,
      },
      {
        id: '730314',
        zipcode: 73120,
        text: 'ศรีมหาโพธิ์',
        value: 'ศรีมหาโพธิ์',
        name: {
          th: 'ศรีมหาโพธิ์',
          en: 'Si Maha Pho',
        },
        districtId: 809,
      },
      {
        id: '730315',
        zipcode: 73120,
        text: 'สัมปทวน',
        value: 'สัมปทวน',
        name: {
          th: 'สัมปทวน',
          en: 'Sampathuan',
        },
        districtId: 809,
      },
      {
        id: '730316',
        zipcode: 73120,
        text: 'วัดสำโรง',
        value: 'วัดสำโรง',
        name: {
          th: 'วัดสำโรง',
          en: 'Wat Samrong',
        },
        districtId: 809,
      },
      {
        id: '730317',
        zipcode: 73120,
        text: 'ดอนแฝก',
        value: 'ดอนแฝก',
        name: {
          th: 'ดอนแฝก',
          en: 'Don Faek',
        },
        districtId: 809,
      },
      {
        id: '730318',
        zipcode: 73120,
        text: 'ห้วยพลู',
        value: 'ห้วยพลู',
        name: {
          th: 'ห้วยพลู',
          en: 'Huai Phlu',
        },
        districtId: 809,
      },
      {
        id: '730319',
        zipcode: 73120,
        text: 'วัดละมุด',
        value: 'วัดละมุด',
        name: {
          th: 'วัดละมุด',
          en: 'Wat Lamut',
        },
        districtId: 809,
      },
      {
        id: '730320',
        zipcode: 73120,
        text: 'บางพระ',
        value: 'บางพระ',
        name: {
          th: 'บางพระ',
          en: 'Bang Phra',
        },
        districtId: 809,
      },
      {
        id: '730321',
        zipcode: 73120,
        text: 'บางแก้วฟ้า',
        value: 'บางแก้วฟ้า',
        name: {
          th: 'บางแก้วฟ้า',
          en: 'Bang Kaeo Fa',
        },
        districtId: 809,
      },
      {
        id: '730322',
        zipcode: 73120,
        text: 'ลานตากฟ้า',
        value: 'ลานตากฟ้า',
        name: {
          th: 'ลานตากฟ้า',
          en: 'Lan Tak Fa',
        },
        districtId: 809,
      },
      {
        id: '730323',
        zipcode: 73120,
        text: 'งิ้วราย',
        value: 'งิ้วราย',
        name: {
          th: 'งิ้วราย',
          en: 'Ngio Rai',
        },
        districtId: 809,
      },
      {
        id: '730324',
        zipcode: 73120,
        text: 'ไทยาวาส',
        value: 'ไทยาวาส',
        name: {
          th: 'ไทยาวาส',
          en: 'Thaiyawat',
        },
        districtId: 809,
      },
      {
        id: '730401',
        zipcode: 73150,
        text: 'สามง่าม',
        value: 'สามง่าม',
        name: {
          th: 'สามง่าม',
          en: 'Sam Ngam',
        },
        districtId: 810,
      },
      {
        id: '730402',
        zipcode: 73150,
        text: 'ห้วยพระ',
        value: 'ห้วยพระ',
        name: {
          th: 'ห้วยพระ',
          en: 'Huai Phra',
        },
        districtId: 810,
      },
      {
        id: '730403',
        zipcode: 73150,
        text: 'ลำเหย',
        value: 'ลำเหย',
        name: {
          th: 'ลำเหย',
          en: 'Lam Hoei',
        },
        districtId: 810,
      },
      {
        id: '730404',
        zipcode: 73150,
        text: 'ดอนพุทรา',
        value: 'ดอนพุทรา',
        name: {
          th: 'ดอนพุทรา',
          en: 'Don Phutsa',
        },
        districtId: 810,
      },
      {
        id: '730405',
        zipcode: 73150,
        text: 'บ้านหลวง',
        value: 'บ้านหลวง',
        name: {
          th: 'บ้านหลวง',
          en: 'Ban Luang',
        },
        districtId: 810,
      },
      {
        id: '730406',
        zipcode: 73150,
        text: 'ดอนรวก',
        value: 'ดอนรวก',
        name: {
          th: 'ดอนรวก',
          en: 'Don Ruak',
        },
        districtId: 810,
      },
      {
        id: '730407',
        zipcode: 73150,
        text: 'ห้วยด้วน',
        value: 'ห้วยด้วน',
        name: {
          th: 'ห้วยด้วน',
          en: 'Huai Duan',
        },
        districtId: 810,
      },
      {
        id: '730408',
        zipcode: 73150,
        text: 'ลำลูกบัว',
        value: 'ลำลูกบัว',
        name: {
          th: 'ลำลูกบัว',
          en: 'Lam Luk Bua',
        },
        districtId: 810,
      },
      {
        id: '730501',
        zipcode: 73130,
        text: 'บางเลน',
        value: 'บางเลน',
        name: {
          th: 'บางเลน',
          en: 'Bang Len',
        },
        districtId: 811,
      },
      {
        id: '730502',
        zipcode: 73130,
        text: 'บางปลา',
        value: 'บางปลา',
        name: {
          th: 'บางปลา',
          en: 'Bang Pla',
        },
        districtId: 811,
      },
      {
        id: '730503',
        zipcode: 73190,
        text: 'บางหลวง',
        value: 'บางหลวง',
        name: {
          th: 'บางหลวง',
          en: 'Bang Luang',
        },
        districtId: 811,
      },
      {
        id: '730504',
        zipcode: 73130,
        text: 'บางภาษี',
        value: 'บางภาษี',
        name: {
          th: 'บางภาษี',
          en: 'Bang Phasi',
        },
        districtId: 811,
      },
      {
        id: '730505',
        zipcode: 73130,
        text: 'บางระกำ',
        value: 'บางระกำ',
        name: {
          th: 'บางระกำ',
          en: 'Bang Rakam',
        },
        districtId: 811,
      },
      {
        id: '730506',
        zipcode: 73130,
        text: 'บางไทรป่า',
        value: 'บางไทรป่า',
        name: {
          th: 'บางไทรป่า',
          en: 'Bang Sai Pa',
        },
        districtId: 811,
      },
      {
        id: '730507',
        zipcode: 73190,
        text: 'หินมูล',
        value: 'หินมูล',
        name: {
          th: 'หินมูล',
          en: 'Hin Mun',
        },
        districtId: 811,
      },
      {
        id: '730508',
        zipcode: 73130,
        text: 'ไทรงาม',
        value: 'ไทรงาม',
        name: {
          th: 'ไทรงาม',
          en: 'Sai Ngam',
        },
        districtId: 811,
      },
      {
        id: '730509',
        zipcode: 73130,
        text: 'ดอนตูม',
        value: 'ดอนตูม',
        name: {
          th: 'ดอนตูม',
          en: 'Don Tum',
        },
        districtId: 811,
      },
      {
        id: '730510',
        zipcode: 73130,
        text: 'นิลเพชร',
        value: 'นิลเพชร',
        name: {
          th: 'นิลเพชร',
          en: 'Ninlaphet',
        },
        districtId: 811,
      },
      {
        id: '730511',
        zipcode: 73130,
        text: 'บัวปากท่า',
        value: 'บัวปากท่า',
        name: {
          th: 'บัวปากท่า',
          en: 'Bua Pak Tha',
        },
        districtId: 811,
      },
      {
        id: '730512',
        zipcode: 73130,
        text: 'คลองนกกระทุง',
        value: 'คลองนกกระทุง',
        name: {
          th: 'คลองนกกระทุง',
          en: 'Khlong Nok Krathung',
        },
        districtId: 811,
      },
      {
        id: '730513',
        zipcode: 73130,
        text: 'นราภิรมย์',
        value: 'นราภิรมย์',
        name: {
          th: 'นราภิรมย์',
          en: 'Naraphirom',
        },
        districtId: 811,
      },
      {
        id: '730514',
        zipcode: 73130,
        text: 'ลำพญา',
        value: 'ลำพญา',
        name: {
          th: 'ลำพญา',
          en: 'Lam Phaya',
        },
        districtId: 811,
      },
      {
        id: '730515',
        zipcode: 73130,
        text: 'ไผ่หูช้าง',
        value: 'ไผ่หูช้าง',
        name: {
          th: 'ไผ่หูช้าง',
          en: 'Phai Hu Chang',
        },
        districtId: 811,
      },
      {
        id: '730601',
        zipcode: 73110,
        text: 'ท่าข้าม',
        value: 'ท่าข้าม',
        name: {
          th: 'ท่าข้าม',
          en: 'Tha Kham',
        },
        districtId: 812,
      },
      {
        id: '730602',
        zipcode: 73210,
        text: 'ทรงคนอง',
        value: 'ทรงคนอง',
        name: {
          th: 'ทรงคนอง',
          en: 'Song Khanong',
        },
        districtId: 812,
      },
      {
        id: '730603',
        zipcode: 73110,
        text: 'หอมเกร็ด',
        value: 'หอมเกร็ด',
        name: {
          th: 'หอมเกร็ด',
          en: 'Hom Kret',
        },
        districtId: 812,
      },
      {
        id: '730604',
        zipcode: 73210,
        text: 'บางกระทึก',
        value: 'บางกระทึก',
        name: {
          th: 'บางกระทึก',
          en: 'Bang Krathuek',
        },
        districtId: 812,
      },
      {
        id: '730605',
        zipcode: 73210,
        text: 'บางเตย',
        value: 'บางเตย',
        name: {
          th: 'บางเตย',
          en: 'Bang Toei',
        },
        districtId: 812,
      },
      {
        id: '730606',
        zipcode: 73110,
        text: 'สามพราน',
        value: 'สามพราน',
        name: {
          th: 'สามพราน',
          en: 'Sam Phran',
        },
        districtId: 812,
      },
      {
        id: '730607',
        zipcode: 73110,
        text: 'บางช้าง',
        value: 'บางช้าง',
        name: {
          th: 'บางช้าง',
          en: 'Bang Chang',
        },
        districtId: 812,
      },
      {
        id: '730608',
        zipcode: 73210,
        text: 'ไร่ขิง',
        value: 'ไร่ขิง',
        name: {
          th: 'ไร่ขิง',
          en: 'Rai Khing',
        },
        districtId: 812,
      },
      {
        id: '730609',
        zipcode: 73110,
        text: 'ท่าตลาด',
        value: 'ท่าตลาด',
        name: {
          th: 'ท่าตลาด',
          en: 'Tha Talat',
        },
        districtId: 812,
      },
      {
        id: '730610',
        zipcode: 73220,
        text: 'กระทุ่มล้ม',
        value: 'กระทุ่มล้ม',
        name: {
          th: 'กระทุ่มล้ม',
          en: 'Krathum Lom',
        },
        districtId: 812,
      },
      {
        id: '730611',
        zipcode: 73110,
        text: 'คลองใหม่',
        value: 'คลองใหม่',
        name: {
          th: 'คลองใหม่',
          en: 'Khlong Mai',
        },
        districtId: 812,
      },
      {
        id: '730612',
        zipcode: 73110,
        text: 'ตลาดจินดา',
        value: 'ตลาดจินดา',
        name: {
          th: 'ตลาดจินดา',
          en: 'Talat Chinda',
        },
        districtId: 812,
      },
      {
        id: '730613',
        zipcode: 73110,
        text: 'คลองจินดา',
        value: 'คลองจินดา',
        name: {
          th: 'คลองจินดา',
          en: 'Khlong Chinda',
        },
        districtId: 812,
      },
      {
        id: '730614',
        zipcode: 73110,
        text: 'ยายชา',
        value: 'ยายชา',
        name: {
          th: 'ยายชา',
          en: 'Yai Cha',
        },
        districtId: 812,
      },
      {
        id: '730615',
        zipcode: 73110,
        text: 'บ้านใหม่',
        value: 'บ้านใหม่',
        name: {
          th: 'บ้านใหม่',
          en: 'Ban Mai',
        },
        districtId: 812,
      },
      {
        id: '730616',
        zipcode: 73160,
        text: 'อ้อมใหญ่',
        value: 'อ้อมใหญ่',
        name: {
          th: 'อ้อมใหญ่',
          en: 'Om Yai',
        },
        districtId: 812,
      },
      {
        id: '730701',
        zipcode: 73170,
        text: 'ศาลายา',
        value: 'ศาลายา',
        name: {
          th: 'ศาลายา',
          en: 'Sala Ya',
        },
        districtId: 813,
      },
      {
        id: '730702',
        zipcode: 73170,
        text: 'คลองโยง',
        value: 'คลองโยง',
        name: {
          th: 'คลองโยง',
          en: 'Khlong Yong',
        },
        districtId: 813,
      },
      {
        id: '730703',
        zipcode: 73170,
        text: 'มหาสวัสดิ์',
        value: 'มหาสวัสดิ์',
        name: {
          th: 'มหาสวัสดิ์',
          en: 'Maha Sawat',
        },
        districtId: 813,
      },
      {
        id: '740101',
        zipcode: 74000,
        text: 'มหาชัย',
        value: 'มหาชัย',
        name: {
          th: 'มหาชัย',
          en: 'Maha Chai',
        },
        districtId: 814,
      },
      {
        id: '740102',
        zipcode: 74000,
        text: 'ท่าฉลอม',
        value: 'ท่าฉลอม',
        name: {
          th: 'ท่าฉลอม',
          en: 'Tha Chalom',
        },
        districtId: 814,
      },
      {
        id: '740103',
        zipcode: 74000,
        text: 'โกรกกราก',
        value: 'โกรกกราก',
        name: {
          th: 'โกรกกราก',
          en: 'Krok Krak',
        },
        districtId: 814,
      },
      {
        id: '740104',
        zipcode: 74000,
        text: 'บ้านบ่อ',
        value: 'บ้านบ่อ',
        name: {
          th: 'บ้านบ่อ',
          en: 'Ban Bo',
        },
        districtId: 814,
      },
      {
        id: '740105',
        zipcode: 74000,
        text: 'บางโทรัด',
        value: 'บางโทรัด',
        name: {
          th: 'บางโทรัด',
          en: 'Bang Tho Rat',
        },
        districtId: 814,
      },
      {
        id: '740106',
        zipcode: 74000,
        text: 'กาหลง',
        value: 'กาหลง',
        name: {
          th: 'กาหลง',
          en: 'Ka Long',
        },
        districtId: 814,
      },
      {
        id: '740107',
        zipcode: 74000,
        text: 'นาโคก',
        value: 'นาโคก',
        name: {
          th: 'นาโคก',
          en: 'Na Khok',
        },
        districtId: 814,
      },
      {
        id: '740108',
        zipcode: 74000,
        text: 'ท่าจีน',
        value: 'ท่าจีน',
        name: {
          th: 'ท่าจีน',
          en: 'Tha Chin',
        },
        districtId: 814,
      },
      {
        id: '740109',
        zipcode: 74000,
        text: 'นาดี',
        value: 'นาดี',
        name: {
          th: 'นาดี',
          en: 'Na Di',
        },
        districtId: 814,
      },
      {
        id: '740110',
        zipcode: 74000,
        text: 'ท่าทราย',
        value: 'ท่าทราย',
        name: {
          th: 'ท่าทราย',
          en: 'Tha Sai',
        },
        districtId: 814,
      },
      {
        id: '740111',
        zipcode: 74000,
        text: 'คอกกระบือ',
        value: 'คอกกระบือ',
        name: {
          th: 'คอกกระบือ',
          en: 'Khok Krabue',
        },
        districtId: 814,
      },
      {
        id: '740112',
        zipcode: 74000,
        text: 'บางน้ำจืด',
        value: 'บางน้ำจืด',
        name: {
          th: 'บางน้ำจืด',
          en: 'Bang Nam Chuet',
        },
        districtId: 814,
      },
      {
        id: '740113',
        zipcode: 74000,
        text: 'พันท้ายนรสิงห์',
        value: 'พันท้ายนรสิงห์',
        name: {
          th: 'พันท้ายนรสิงห์',
          en: 'Phan Thai Norasing',
        },
        districtId: 814,
      },
      {
        id: '740114',
        zipcode: 74000,
        text: 'โคกขาม',
        value: 'โคกขาม',
        name: {
          th: 'โคกขาม',
          en: 'Khok Kham',
        },
        districtId: 814,
      },
      {
        id: '740115',
        zipcode: 74000,
        text: 'บ้านเกาะ',
        value: 'บ้านเกาะ',
        name: {
          th: 'บ้านเกาะ',
          en: 'Ban Ko',
        },
        districtId: 814,
      },
      {
        id: '740116',
        zipcode: 74000,
        text: 'บางกระเจ้า',
        value: 'บางกระเจ้า',
        name: {
          th: 'บางกระเจ้า',
          en: 'Bang Krachao',
        },
        districtId: 814,
      },
      {
        id: '740117',
        zipcode: 74000,
        text: 'บางหญ้าแพรก',
        value: 'บางหญ้าแพรก',
        name: {
          th: 'บางหญ้าแพรก',
          en: 'Bang Ya Phraek',
        },
        districtId: 814,
      },
      {
        id: '740118',
        zipcode: 74000,
        text: 'ชัยมงคล',
        value: 'ชัยมงคล',
        name: {
          th: 'ชัยมงคล',
          en: 'Chai Mongkon',
        },
        districtId: 814,
      },
      {
        id: '740201',
        zipcode: 74110,
        text: 'ตลาดกระทุ่มแบน',
        value: 'ตลาดกระทุ่มแบน',
        name: {
          th: 'ตลาดกระทุ่มแบน',
          en: 'Talat Krathum Baen',
        },
        districtId: 815,
      },
      {
        id: '740202',
        zipcode: 74130,
        text: 'อ้อมน้อย',
        value: 'อ้อมน้อย',
        name: {
          th: 'อ้อมน้อย',
          en: 'Om Noi',
        },
        districtId: 815,
      },
      {
        id: '740203',
        zipcode: 74110,
        text: 'ท่าไม้',
        value: 'ท่าไม้',
        name: {
          th: 'ท่าไม้',
          en: 'Tha Mai',
        },
        districtId: 815,
      },
      {
        id: '740204',
        zipcode: 74110,
        text: 'สวนหลวง',
        value: 'สวนหลวง',
        name: {
          th: 'สวนหลวง',
          en: 'Suan Luang',
        },
        districtId: 815,
      },
      {
        id: '740205',
        zipcode: 74110,
        text: 'บางยาง',
        value: 'บางยาง',
        name: {
          th: 'บางยาง',
          en: 'Bang Yang',
        },
        districtId: 815,
      },
      {
        id: '740206',
        zipcode: 74110,
        text: 'คลองมะเดื่อ',
        value: 'คลองมะเดื่อ',
        name: {
          th: 'คลองมะเดื่อ',
          en: 'Khlong Maduea',
        },
        districtId: 815,
      },
      {
        id: '740207',
        zipcode: 74110,
        text: 'หนองนกไข่',
        value: 'หนองนกไข่',
        name: {
          th: 'หนองนกไข่',
          en: 'Nong Nok Khai',
        },
        districtId: 815,
      },
      {
        id: '740208',
        zipcode: 74110,
        text: 'ดอนไก่ดี',
        value: 'ดอนไก่ดี',
        name: {
          th: 'ดอนไก่ดี',
          en: 'Don Kai Di',
        },
        districtId: 815,
      },
      {
        id: '740209',
        zipcode: 74110,
        text: 'แคราย',
        value: 'แคราย',
        name: {
          th: 'แคราย',
          en: 'Khae Rai',
        },
        districtId: 815,
      },
      {
        id: '740210',
        zipcode: 74110,
        text: 'ท่าเสา',
        value: 'ท่าเสา',
        name: {
          th: 'ท่าเสา',
          en: 'Tha Sao',
        },
        districtId: 815,
      },
      {
        id: '740301',
        zipcode: 74120,
        text: 'บ้านแพ้ว',
        value: 'บ้านแพ้ว',
        name: {
          th: 'บ้านแพ้ว',
          en: 'Ban Phaeo',
        },
        districtId: 816,
      },
      {
        id: '740302',
        zipcode: 74120,
        text: 'หลักสาม',
        value: 'หลักสาม',
        name: {
          th: 'หลักสาม',
          en: 'Lak Sam',
        },
        districtId: 816,
      },
      {
        id: '740303',
        zipcode: 74120,
        text: 'ยกกระบัตร',
        value: 'ยกกระบัตร',
        name: {
          th: 'ยกกระบัตร',
          en: 'Yokkrabat',
        },
        districtId: 816,
      },
      {
        id: '740304',
        zipcode: 74120,
        text: 'โรงเข้',
        value: 'โรงเข้',
        name: {
          th: 'โรงเข้',
          en: 'Rong Khe',
        },
        districtId: 816,
      },
      {
        id: '740305',
        zipcode: 74120,
        text: 'หนองสองห้อง',
        value: 'หนองสองห้อง',
        name: {
          th: 'หนองสองห้อง',
          en: 'Nong Song Hong',
        },
        districtId: 816,
      },
      {
        id: '740306',
        zipcode: 74120,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 816,
      },
      {
        id: '740307',
        zipcode: 74120,
        text: 'หลักสอง',
        value: 'หลักสอง',
        name: {
          th: 'หลักสอง',
          en: 'Lak Song',
        },
        districtId: 816,
      },
      {
        id: '740308',
        zipcode: 74120,
        text: 'เจ็ดริ้ว',
        value: 'เจ็ดริ้ว',
        name: {
          th: 'เจ็ดริ้ว',
          en: 'Chet Rio',
        },
        districtId: 816,
      },
      {
        id: '740309',
        zipcode: 74120,
        text: 'คลองตัน',
        value: 'คลองตัน',
        name: {
          th: 'คลองตัน',
          en: 'Khlong Tan',
        },
        districtId: 816,
      },
      {
        id: '740310',
        zipcode: 74120,
        text: 'อำแพง',
        value: 'อำแพง',
        name: {
          th: 'อำแพง',
          en: 'Amphaeng',
        },
        districtId: 816,
      },
      {
        id: '740311',
        zipcode: 74120,
        text: 'สวนส้ม',
        value: 'สวนส้ม',
        name: {
          th: 'สวนส้ม',
          en: 'Suan Som',
        },
        districtId: 816,
      },
      {
        id: '740312',
        zipcode: 74120,
        text: 'เกษตรพัฒนา',
        value: 'เกษตรพัฒนา',
        name: {
          th: 'เกษตรพัฒนา',
          en: 'Kaset Phatthana',
        },
        districtId: 816,
      },
      {
        id: '750101',
        zipcode: 75000,
        text: 'แม่กลอง',
        value: 'แม่กลอง',
        name: {
          th: 'แม่กลอง',
          en: 'Mae Klong',
        },
        districtId: 817,
      },
      {
        id: '750102',
        zipcode: 75000,
        text: 'บางขันแตก',
        value: 'บางขันแตก',
        name: {
          th: 'บางขันแตก',
          en: 'Bang Khan Taek',
        },
        districtId: 817,
      },
      {
        id: '750103',
        zipcode: 75000,
        text: 'ลาดใหญ่',
        value: 'ลาดใหญ่',
        name: {
          th: 'ลาดใหญ่',
          en: 'Lat Yai',
        },
        districtId: 817,
      },
      {
        id: '750104',
        zipcode: 75000,
        text: 'บ้านปรก',
        value: 'บ้านปรก',
        name: {
          th: 'บ้านปรก',
          en: 'Ban Prok',
        },
        districtId: 817,
      },
      {
        id: '750105',
        zipcode: 75000,
        text: 'บางแก้ว',
        value: 'บางแก้ว',
        name: {
          th: 'บางแก้ว',
          en: 'Bang Kaeo',
        },
        districtId: 817,
      },
      {
        id: '750106',
        zipcode: 75000,
        text: 'ท้ายหาด',
        value: 'ท้ายหาด',
        name: {
          th: 'ท้ายหาด',
          en: 'Thai Hat',
        },
        districtId: 817,
      },
      {
        id: '750107',
        zipcode: 75000,
        text: 'แหลมใหญ่',
        value: 'แหลมใหญ่',
        name: {
          th: 'แหลมใหญ่',
          en: 'Laem Yai',
        },
        districtId: 817,
      },
      {
        id: '750108',
        zipcode: 75000,
        text: 'คลองเขิน',
        value: 'คลองเขิน',
        name: {
          th: 'คลองเขิน',
          en: 'Khlong Khoen',
        },
        districtId: 817,
      },
      {
        id: '750109',
        zipcode: 75000,
        text: 'คลองโคน',
        value: 'คลองโคน',
        name: {
          th: 'คลองโคน',
          en: 'Khlong Khon',
        },
        districtId: 817,
      },
      {
        id: '750110',
        zipcode: 75000,
        text: 'นางตะเคียน',
        value: 'นางตะเคียน',
        name: {
          th: 'นางตะเคียน',
          en: 'Nang Takhian',
        },
        districtId: 817,
      },
      {
        id: '750111',
        zipcode: 75000,
        text: 'บางจะเกร็ง',
        value: 'บางจะเกร็ง',
        name: {
          th: 'บางจะเกร็ง',
          en: 'Bang Chakreng',
        },
        districtId: 817,
      },
      {
        id: '750201',
        zipcode: 75120,
        text: 'กระดังงา',
        value: 'กระดังงา',
        name: {
          th: 'กระดังงา',
          en: 'Kradangnga',
        },
        districtId: 818,
      },
      {
        id: '750202',
        zipcode: 75120,
        text: 'บางสะแก',
        value: 'บางสะแก',
        name: {
          th: 'บางสะแก',
          en: 'Bang Sakae',
        },
        districtId: 818,
      },
      {
        id: '750203',
        zipcode: 75120,
        text: 'บางยี่รงค์',
        value: 'บางยี่รงค์',
        name: {
          th: 'บางยี่รงค์',
          en: 'Bang Yi Rong',
        },
        districtId: 818,
      },
      {
        id: '750204',
        zipcode: 75120,
        text: 'โรงหีบ',
        value: 'โรงหีบ',
        name: {
          th: 'โรงหีบ',
          en: 'Rong Hip',
        },
        districtId: 818,
      },
      {
        id: '750205',
        zipcode: 75120,
        text: 'บางคนที',
        value: 'บางคนที',
        name: {
          th: 'บางคนที',
          en: 'Bang Khonthi',
        },
        districtId: 818,
      },
      {
        id: '750206',
        zipcode: 75120,
        text: 'ดอนมะโนรา',
        value: 'ดอนมะโนรา',
        name: {
          th: 'ดอนมะโนรา',
          en: 'Don Manora',
        },
        districtId: 818,
      },
      {
        id: '750207',
        zipcode: 75120,
        text: 'บางพรม',
        value: 'บางพรม',
        name: {
          th: 'บางพรม',
          en: 'Bang Phrom',
        },
        districtId: 818,
      },
      {
        id: '750208',
        zipcode: 75120,
        text: 'บางกุ้ง',
        value: 'บางกุ้ง',
        name: {
          th: 'บางกุ้ง',
          en: 'Bang Kung',
        },
        districtId: 818,
      },
      {
        id: '750209',
        zipcode: 75120,
        text: 'จอมปลวก',
        value: 'จอมปลวก',
        name: {
          th: 'จอมปลวก',
          en: 'Chom Pluak',
        },
        districtId: 818,
      },
      {
        id: '750210',
        zipcode: 75120,
        text: 'บางนกแขวก',
        value: 'บางนกแขวก',
        name: {
          th: 'บางนกแขวก',
          en: 'Bang Nok Khwaek',
        },
        districtId: 818,
      },
      {
        id: '750211',
        zipcode: 75120,
        text: 'ยายแพง',
        value: 'ยายแพง',
        name: {
          th: 'ยายแพง',
          en: 'Yai Phaeng',
        },
        districtId: 818,
      },
      {
        id: '750212',
        zipcode: 75120,
        text: 'บางกระบือ',
        value: 'บางกระบือ',
        name: {
          th: 'บางกระบือ',
          en: 'Bang Krabue',
        },
        districtId: 818,
      },
      {
        id: '750213',
        zipcode: 75120,
        text: 'บ้านปราโมทย์',
        value: 'บ้านปราโมทย์',
        name: {
          th: 'บ้านปราโมทย์',
          en: 'Ban Pramot',
        },
        districtId: 818,
      },
      {
        id: '750301',
        zipcode: 75110,
        text: 'อัมพวา',
        value: 'อัมพวา',
        name: {
          th: 'อัมพวา',
          en: 'Amphawa',
        },
        districtId: 819,
      },
      {
        id: '750302',
        zipcode: 75110,
        text: 'สวนหลวง',
        value: 'สวนหลวง',
        name: {
          th: 'สวนหลวง',
          en: 'Suan Luang',
        },
        districtId: 819,
      },
      {
        id: '750303',
        zipcode: 75110,
        text: 'ท่าคา',
        value: 'ท่าคา',
        name: {
          th: 'ท่าคา',
          en: 'Tha Kha',
        },
        districtId: 819,
      },
      {
        id: '750304',
        zipcode: 75110,
        text: 'วัดประดู่',
        value: 'วัดประดู่',
        name: {
          th: 'วัดประดู่',
          en: 'Wat Pradu',
        },
        districtId: 819,
      },
      {
        id: '750305',
        zipcode: 75110,
        text: 'เหมืองใหม่',
        value: 'เหมืองใหม่',
        name: {
          th: 'เหมืองใหม่',
          en: 'Mueang Mai',
        },
        districtId: 819,
      },
      {
        id: '750306',
        zipcode: 75110,
        text: 'บางช้าง',
        value: 'บางช้าง',
        name: {
          th: 'บางช้าง',
          en: 'Bang Chang',
        },
        districtId: 819,
      },
      {
        id: '750307',
        zipcode: 75110,
        text: 'แควอ้อม',
        value: 'แควอ้อม',
        name: {
          th: 'แควอ้อม',
          en: 'Khwae Om',
        },
        districtId: 819,
      },
      {
        id: '750308',
        zipcode: 75110,
        text: 'ปลายโพงพาง',
        value: 'ปลายโพงพาง',
        name: {
          th: 'ปลายโพงพาง',
          en: 'Plai Phongphang',
        },
        districtId: 819,
      },
      {
        id: '750309',
        zipcode: 75110,
        text: 'บางแค',
        value: 'บางแค',
        name: {
          th: 'บางแค',
          en: 'Bang Khae',
        },
        districtId: 819,
      },
      {
        id: '750310',
        zipcode: 75110,
        text: 'แพรกหนามแดง',
        value: 'แพรกหนามแดง',
        name: {
          th: 'แพรกหนามแดง',
          en: 'Phraek Nam Daeng',
        },
        districtId: 819,
      },
      {
        id: '750311',
        zipcode: 75110,
        text: 'ยี่สาร',
        value: 'ยี่สาร',
        name: {
          th: 'ยี่สาร',
          en: 'Yi San',
        },
        districtId: 819,
      },
      {
        id: '750312',
        zipcode: 75110,
        text: 'บางนางลี่',
        value: 'บางนางลี่',
        name: {
          th: 'บางนางลี่',
          en: 'Bang Nang Lee',
        },
        districtId: 819,
      },
      {
        id: '760101',
        zipcode: 76000,
        text: 'ท่าราบ',
        value: 'ท่าราบ',
        name: {
          th: 'ท่าราบ',
          en: 'Tha Rap',
        },
        districtId: 820,
      },
      {
        id: '760102',
        zipcode: 76000,
        text: 'คลองกระแชง',
        value: 'คลองกระแชง',
        name: {
          th: 'คลองกระแชง',
          en: 'Khlong Krachaeng',
        },
        districtId: 820,
      },
      {
        id: '760103',
        zipcode: 76000,
        text: 'บางจาน',
        value: 'บางจาน',
        name: {
          th: 'บางจาน',
          en: 'Bang Chan',
        },
        districtId: 820,
      },
      {
        id: '760104',
        zipcode: 76000,
        text: 'นาพันสาม',
        value: 'นาพันสาม',
        name: {
          th: 'นาพันสาม',
          en: 'Na Phan Sam',
        },
        districtId: 820,
      },
      {
        id: '760105',
        zipcode: 76000,
        text: 'ธงชัย',
        value: 'ธงชัย',
        name: {
          th: 'ธงชัย',
          en: 'Thong Chai',
        },
        districtId: 820,
      },
      {
        id: '760106',
        zipcode: 76000,
        text: 'บ้านกุ่ม',
        value: 'บ้านกุ่ม',
        name: {
          th: 'บ้านกุ่ม',
          en: 'Ban Kum',
        },
        districtId: 820,
      },
      {
        id: '760107',
        zipcode: 76000,
        text: 'หนองโสน',
        value: 'หนองโสน',
        name: {
          th: 'หนองโสน',
          en: 'Nong Sano',
        },
        districtId: 820,
      },
      {
        id: '760108',
        zipcode: 76000,
        text: 'ไร่ส้ม',
        value: 'ไร่ส้ม',
        name: {
          th: 'ไร่ส้ม',
          en: 'Rai Som',
        },
        districtId: 820,
      },
      {
        id: '760109',
        zipcode: 76000,
        text: 'เวียงคอย',
        value: 'เวียงคอย',
        name: {
          th: 'เวียงคอย',
          en: 'Wiang Khoi',
        },
        districtId: 820,
      },
      {
        id: '760110',
        zipcode: 76000,
        text: 'บางจาก',
        value: 'บางจาก',
        name: {
          th: 'บางจาก',
          en: 'Bang Chak',
        },
        districtId: 820,
      },
      {
        id: '760111',
        zipcode: 76000,
        text: 'บ้านหม้อ',
        value: 'บ้านหม้อ',
        name: {
          th: 'บ้านหม้อ',
          en: 'Ban Mo',
        },
        districtId: 820,
      },
      {
        id: '760112',
        zipcode: 76000,
        text: 'ต้นมะม่วง',
        value: 'ต้นมะม่วง',
        name: {
          th: 'ต้นมะม่วง',
          en: 'Ton Mamuang',
        },
        districtId: 820,
      },
      {
        id: '760113',
        zipcode: 76000,
        text: 'ช่องสะแก',
        value: 'ช่องสะแก',
        name: {
          th: 'ช่องสะแก',
          en: 'Chong Sakae',
        },
        districtId: 820,
      },
      {
        id: '760114',
        zipcode: 76000,
        text: 'นาวุ้ง',
        value: 'นาวุ้ง',
        name: {
          th: 'นาวุ้ง',
          en: 'Na Wung',
        },
        districtId: 820,
      },
      {
        id: '760115',
        zipcode: 76000,
        text: 'สำมะโรง',
        value: 'สำมะโรง',
        name: {
          th: 'สำมะโรง',
          en: 'Sam Marong',
        },
        districtId: 820,
      },
      {
        id: '760116',
        zipcode: 76000,
        text: 'โพพระ',
        value: 'โพพระ',
        name: {
          th: 'โพพระ',
          en: 'Pho Phra',
        },
        districtId: 820,
      },
      {
        id: '760117',
        zipcode: 76100,
        text: 'หาดเจ้าสำราญ',
        value: 'หาดเจ้าสำราญ',
        name: {
          th: 'หาดเจ้าสำราญ',
          en: 'Hat Chao Samran',
        },
        districtId: 820,
      },
      {
        id: '760118',
        zipcode: 76000,
        text: 'หัวสะพาน',
        value: 'หัวสะพาน',
        name: {
          th: 'หัวสะพาน',
          en: 'Hua Saphan',
        },
        districtId: 820,
      },
      {
        id: '760119',
        zipcode: 76000,
        text: 'ต้นมะพร้าว',
        value: 'ต้นมะพร้าว',
        name: {
          th: 'ต้นมะพร้าว',
          en: 'Ton Maphrao',
        },
        districtId: 820,
      },
      {
        id: '760120',
        zipcode: 76000,
        text: 'วังตะโก',
        value: 'วังตะโก',
        name: {
          th: 'วังตะโก',
          en: 'Wang Tako',
        },
        districtId: 820,
      },
      {
        id: '760121',
        zipcode: 76000,
        text: 'โพไร่หวาน',
        value: 'โพไร่หวาน',
        name: {
          th: 'โพไร่หวาน',
          en: 'Pho Rai Wan',
        },
        districtId: 820,
      },
      {
        id: '760122',
        zipcode: 76000,
        text: 'ดอนยาง',
        value: 'ดอนยาง',
        name: {
          th: 'ดอนยาง',
          en: 'Don Yang',
        },
        districtId: 820,
      },
      {
        id: '760123',
        zipcode: 76000,
        text: 'หนองขนาน',
        value: 'หนองขนาน',
        name: {
          th: 'หนองขนาน',
          en: 'Nong Khanan',
        },
        districtId: 820,
      },
      {
        id: '760124',
        zipcode: 76000,
        text: 'หนองพลับ',
        value: 'หนองพลับ',
        name: {
          th: 'หนองพลับ',
          en: 'Nong Phlap',
        },
        districtId: 820,
      },
      {
        id: '760201',
        zipcode: 76140,
        text: 'เขาย้อย',
        value: 'เขาย้อย',
        name: {
          th: 'เขาย้อย',
          en: 'Khao Yoi',
        },
        districtId: 821,
      },
      {
        id: '760202',
        zipcode: 76140,
        text: 'สระพัง',
        value: 'สระพัง',
        name: {
          th: 'สระพัง',
          en: 'Sa Phang',
        },
        districtId: 821,
      },
      {
        id: '760203',
        zipcode: 76140,
        text: 'บางเค็ม',
        value: 'บางเค็ม',
        name: {
          th: 'บางเค็ม',
          en: 'Bang Khem',
        },
        districtId: 821,
      },
      {
        id: '760204',
        zipcode: 76140,
        text: 'ทับคาง',
        value: 'ทับคาง',
        name: {
          th: 'ทับคาง',
          en: 'Thap Khang',
        },
        districtId: 821,
      },
      {
        id: '760205',
        zipcode: 76140,
        text: 'หนองปลาไหล',
        value: 'หนองปลาไหล',
        name: {
          th: 'หนองปลาไหล',
          en: 'Nong Pla Lai',
        },
        districtId: 821,
      },
      {
        id: '760206',
        zipcode: 76140,
        text: 'หนองปรง',
        value: 'หนองปรง',
        name: {
          th: 'หนองปรง',
          en: 'Nong Prong',
        },
        districtId: 821,
      },
      {
        id: '760207',
        zipcode: 76140,
        text: 'หนองชุมพล',
        value: 'หนองชุมพล',
        name: {
          th: 'หนองชุมพล',
          en: 'Nong Chumphon',
        },
        districtId: 821,
      },
      {
        id: '760208',
        zipcode: 76140,
        text: 'ห้วยโรง',
        value: 'ห้วยโรง',
        name: {
          th: 'ห้วยโรง',
          en: 'Huai Rong',
        },
        districtId: 821,
      },
      {
        id: '760209',
        zipcode: 76140,
        text: 'ห้วยท่าช้าง',
        value: 'ห้วยท่าช้าง',
        name: {
          th: 'ห้วยท่าช้าง',
          en: 'Huai Tha Chang',
        },
        districtId: 821,
      },
      {
        id: '760210',
        zipcode: 76140,
        text: 'หนองชุมพลเหนือ',
        value: 'หนองชุมพลเหนือ',
        name: {
          th: 'หนองชุมพลเหนือ',
          en: 'Nong Chumphon Nuea',
        },
        districtId: 821,
      },
      {
        id: '760301',
        zipcode: 76160,
        text: 'หนองหญ้าปล้อง',
        value: 'หนองหญ้าปล้อง',
        name: {
          th: 'หนองหญ้าปล้อง',
          en: 'Nong Ya Plong',
        },
        districtId: 822,
      },
      {
        id: '760302',
        zipcode: 76160,
        text: 'ยางน้ำกลัดเหนือ',
        value: 'ยางน้ำกลัดเหนือ',
        name: {
          th: 'ยางน้ำกลัดเหนือ',
          en: 'Yang Nam Klat Nuea',
        },
        districtId: 822,
      },
      {
        id: '760303',
        zipcode: 76160,
        text: 'ยางน้ำกลัดใต้',
        value: 'ยางน้ำกลัดใต้',
        name: {
          th: 'ยางน้ำกลัดใต้',
          en: 'Yang Nam Klat Tai',
        },
        districtId: 822,
      },
      {
        id: '760304',
        zipcode: 76160,
        text: 'ท่าตะคร้อ',
        value: 'ท่าตะคร้อ',
        name: {
          th: 'ท่าตะคร้อ',
          en: 'Tha Takror',
        },
        districtId: 822,
      },
      {
        id: '760401',
        zipcode: 76120,
        text: 'ชะอำ',
        value: 'ชะอำ',
        name: {
          th: 'ชะอำ',
          en: 'Cha-am',
        },
        districtId: 823,
      },
      {
        id: '760402',
        zipcode: 76120,
        text: 'บางเก่า',
        value: 'บางเก่า',
        name: {
          th: 'บางเก่า',
          en: 'Bang Kao',
        },
        districtId: 823,
      },
      {
        id: '760403',
        zipcode: 76120,
        text: 'นายาง',
        value: 'นายาง',
        name: {
          th: 'นายาง',
          en: 'Na Yang',
        },
        districtId: 823,
      },
      {
        id: '760404',
        zipcode: 76120,
        text: 'เขาใหญ่',
        value: 'เขาใหญ่',
        name: {
          th: 'เขาใหญ่',
          en: 'Khao Yai',
        },
        districtId: 823,
      },
      {
        id: '760405',
        zipcode: 76120,
        text: 'หนองศาลา',
        value: 'หนองศาลา',
        name: {
          th: 'หนองศาลา',
          en: 'Nong Sala',
        },
        districtId: 823,
      },
      {
        id: '760406',
        zipcode: 76120,
        text: 'ห้วยทรายเหนือ',
        value: 'ห้วยทรายเหนือ',
        name: {
          th: 'ห้วยทรายเหนือ',
          en: 'Huai Sai Nuea',
        },
        districtId: 823,
      },
      {
        id: '760407',
        zipcode: 76120,
        text: 'ไร่ใหม่พัฒนา',
        value: 'ไร่ใหม่พัฒนา',
        name: {
          th: 'ไร่ใหม่พัฒนา',
          en: 'Rai Mai Phatthana',
        },
        districtId: 823,
      },
      {
        id: '760408',
        zipcode: 76120,
        text: 'สามพระยา',
        value: 'สามพระยา',
        name: {
          th: 'สามพระยา',
          en: 'Sam Phraya',
        },
        districtId: 823,
      },
      {
        id: '760409',
        zipcode: 76120,
        text: 'ดอนขุนห้วย',
        value: 'ดอนขุนห้วย',
        name: {
          th: 'ดอนขุนห้วย',
          en: 'Don Khun Huai',
        },
        districtId: 823,
      },
      {
        id: '760501',
        zipcode: 76130,
        text: 'ท่ายาง',
        value: 'ท่ายาง',
        name: {
          th: 'ท่ายาง',
          en: 'Tha Yang',
        },
        districtId: 824,
      },
      {
        id: '760502',
        zipcode: 76130,
        text: 'ท่าคอย',
        value: 'ท่าคอย',
        name: {
          th: 'ท่าคอย',
          en: 'Tha Khoi',
        },
        districtId: 824,
      },
      {
        id: '760503',
        zipcode: 76130,
        text: 'ยางหย่อง',
        value: 'ยางหย่อง',
        name: {
          th: 'ยางหย่อง',
          en: 'Yang Yong',
        },
        districtId: 824,
      },
      {
        id: '760504',
        zipcode: 76130,
        text: 'หนองจอก',
        value: 'หนองจอก',
        name: {
          th: 'หนองจอก',
          en: 'Nong Chok',
        },
        districtId: 824,
      },
      {
        id: '760505',
        zipcode: 76130,
        text: 'มาบปลาเค้า',
        value: 'มาบปลาเค้า',
        name: {
          th: 'มาบปลาเค้า',
          en: 'Map Pla Khao',
        },
        districtId: 824,
      },
      {
        id: '760506',
        zipcode: 76130,
        text: 'ท่าไม้รวก',
        value: 'ท่าไม้รวก',
        name: {
          th: 'ท่าไม้รวก',
          en: 'Tha Mai Ruak',
        },
        districtId: 824,
      },
      {
        id: '760507',
        zipcode: 76130,
        text: 'วังไคร้',
        value: 'วังไคร้',
        name: {
          th: 'วังไคร้',
          en: 'Wang Khrai',
        },
        districtId: 824,
      },
      {
        id: '760511',
        zipcode: 76130,
        text: 'กลัดหลวง',
        value: 'กลัดหลวง',
        name: {
          th: 'กลัดหลวง',
          en: 'Klat Luang',
        },
        districtId: 824,
      },
      {
        id: '760512',
        zipcode: 76130,
        text: 'ปึกเตียน',
        value: 'ปึกเตียน',
        name: {
          th: 'ปึกเตียน',
          en: 'Puek Tian',
        },
        districtId: 824,
      },
      {
        id: '760513',
        zipcode: 76130,
        text: 'เขากระปุก',
        value: 'เขากระปุก',
        name: {
          th: 'เขากระปุก',
          en: 'Khao Krapuk',
        },
        districtId: 824,
      },
      {
        id: '760514',
        zipcode: 76130,
        text: 'ท่าแลง',
        value: 'ท่าแลง',
        name: {
          th: 'ท่าแลง',
          en: 'Tha Laeng',
        },
        districtId: 824,
      },
      {
        id: '760515',
        zipcode: 76130,
        text: 'บ้านในดง',
        value: 'บ้านในดง',
        name: {
          th: 'บ้านในดง',
          en: 'Ban Nai Dong',
        },
        districtId: 824,
      },
      {
        id: '760601',
        zipcode: 76150,
        text: 'บ้านลาด',
        value: 'บ้านลาด',
        name: {
          th: 'บ้านลาด',
          en: 'Ban Lat',
        },
        districtId: 825,
      },
      {
        id: '760602',
        zipcode: 76150,
        text: 'บ้านหาด',
        value: 'บ้านหาด',
        name: {
          th: 'บ้านหาด',
          en: 'Ban Hat',
        },
        districtId: 825,
      },
      {
        id: '760603',
        zipcode: 76150,
        text: 'บ้านทาน',
        value: 'บ้านทาน',
        name: {
          th: 'บ้านทาน',
          en: 'Ban Than',
        },
        districtId: 825,
      },
      {
        id: '760604',
        zipcode: 76150,
        text: 'ตำหรุ',
        value: 'ตำหรุ',
        name: {
          th: 'ตำหรุ',
          en: 'Tamru',
        },
        districtId: 825,
      },
      {
        id: '760605',
        zipcode: 76150,
        text: 'สมอพลือ',
        value: 'สมอพลือ',
        name: {
          th: 'สมอพลือ',
          en: 'Samo Phlue',
        },
        districtId: 825,
      },
      {
        id: '760606',
        zipcode: 76150,
        text: 'ไร่มะขาม',
        value: 'ไร่มะขาม',
        name: {
          th: 'ไร่มะขาม',
          en: 'Rai Makham',
        },
        districtId: 825,
      },
      {
        id: '760607',
        zipcode: 76150,
        text: 'ท่าเสน',
        value: 'ท่าเสน',
        name: {
          th: 'ท่าเสน',
          en: 'Tha Sen',
        },
        districtId: 825,
      },
      {
        id: '760608',
        zipcode: 76150,
        text: 'หนองกระเจ็ด',
        value: 'หนองกระเจ็ด',
        name: {
          th: 'หนองกระเจ็ด',
          en: 'Nong Krachet',
        },
        districtId: 825,
      },
      {
        id: '760609',
        zipcode: 76150,
        text: 'หนองกะปุ',
        value: 'หนองกะปุ',
        name: {
          th: 'หนองกะปุ',
          en: 'Nong Kapu',
        },
        districtId: 825,
      },
      {
        id: '760610',
        zipcode: 76150,
        text: 'ลาดโพธิ์',
        value: 'ลาดโพธิ์',
        name: {
          th: 'ลาดโพธิ์',
          en: 'Lat Pho',
        },
        districtId: 825,
      },
      {
        id: '760611',
        zipcode: 76150,
        text: 'สะพานไกร',
        value: 'สะพานไกร',
        name: {
          th: 'สะพานไกร',
          en: 'Saphan Krai',
        },
        districtId: 825,
      },
      {
        id: '760612',
        zipcode: 76150,
        text: 'ไร่โคก',
        value: 'ไร่โคก',
        name: {
          th: 'ไร่โคก',
          en: 'Rai Khok',
        },
        districtId: 825,
      },
      {
        id: '760613',
        zipcode: 76150,
        text: 'โรงเข้',
        value: 'โรงเข้',
        name: {
          th: 'โรงเข้',
          en: 'Rong Khe',
        },
        districtId: 825,
      },
      {
        id: '760614',
        zipcode: 76150,
        text: 'ไร่สะท้อน',
        value: 'ไร่สะท้อน',
        name: {
          th: 'ไร่สะท้อน',
          en: 'Rai Sathon',
        },
        districtId: 825,
      },
      {
        id: '760615',
        zipcode: 76150,
        text: 'ห้วยข้อง',
        value: 'ห้วยข้อง',
        name: {
          th: 'ห้วยข้อง',
          en: 'Huai Khong',
        },
        districtId: 825,
      },
      {
        id: '760616',
        zipcode: 76150,
        text: 'ท่าช้าง',
        value: 'ท่าช้าง',
        name: {
          th: 'ท่าช้าง',
          en: 'Tha Chang',
        },
        districtId: 825,
      },
      {
        id: '760617',
        zipcode: 76150,
        text: 'ถ้ำรงค์',
        value: 'ถ้ำรงค์',
        name: {
          th: 'ถ้ำรงค์',
          en: 'Tham Rong',
        },
        districtId: 825,
      },
      {
        id: '760618',
        zipcode: 76150,
        text: 'ห้วยลึก',
        value: 'ห้วยลึก',
        name: {
          th: 'ห้วยลึก',
          en: 'Huay Lueg',
        },
        districtId: 825,
      },
      {
        id: '760701',
        zipcode: 76110,
        text: 'บ้านแหลม',
        value: 'บ้านแหลม',
        name: {
          th: 'บ้านแหลม',
          en: 'Ban Laem',
        },
        districtId: 826,
      },
      {
        id: '760702',
        zipcode: 76110,
        text: 'บางขุนไทร',
        value: 'บางขุนไทร',
        name: {
          th: 'บางขุนไทร',
          en: 'Bang Khun Sai',
        },
        districtId: 826,
      },
      {
        id: '760703',
        zipcode: 76110,
        text: 'ปากทะเล',
        value: 'ปากทะเล',
        name: {
          th: 'ปากทะเล',
          en: 'Pak Thale',
        },
        districtId: 826,
      },
      {
        id: '760704',
        zipcode: 76110,
        text: 'บางแก้ว',
        value: 'บางแก้ว',
        name: {
          th: 'บางแก้ว',
          en: 'Bang Kaeo',
        },
        districtId: 826,
      },
      {
        id: '760705',
        zipcode: 76100,
        text: 'แหลมผักเบี้ย',
        value: 'แหลมผักเบี้ย',
        name: {
          th: 'แหลมผักเบี้ย',
          en: 'Laem Phak Bia',
        },
        districtId: 826,
      },
      {
        id: '760706',
        zipcode: 76110,
        text: 'บางตะบูน',
        value: 'บางตะบูน',
        name: {
          th: 'บางตะบูน',
          en: 'Bang Tabun',
        },
        districtId: 826,
      },
      {
        id: '760707',
        zipcode: 76110,
        text: 'บางตะบูนออก',
        value: 'บางตะบูนออก',
        name: {
          th: 'บางตะบูนออก',
          en: 'Bang Tabun Ok',
        },
        districtId: 826,
      },
      {
        id: '760708',
        zipcode: 76110,
        text: 'บางครก',
        value: 'บางครก',
        name: {
          th: 'บางครก',
          en: 'Bang Khrok',
        },
        districtId: 826,
      },
      {
        id: '760709',
        zipcode: 76110,
        text: 'ท่าแร้ง',
        value: 'ท่าแร้ง',
        name: {
          th: 'ท่าแร้ง',
          en: 'Tha Raeng',
        },
        districtId: 826,
      },
      {
        id: '760710',
        zipcode: 76110,
        text: 'ท่าแร้งออก',
        value: 'ท่าแร้งออก',
        name: {
          th: 'ท่าแร้งออก',
          en: 'Tha Raeng Ok',
        },
        districtId: 826,
      },
      {
        id: '760801',
        zipcode: 76170,
        text: 'แก่งกระจาน',
        value: 'แก่งกระจาน',
        name: {
          th: 'แก่งกระจาน',
          en: 'Kaeng Krachan',
        },
        districtId: 827,
      },
      {
        id: '760802',
        zipcode: 76170,
        text: 'สองพี่น้อง',
        value: 'สองพี่น้อง',
        name: {
          th: 'สองพี่น้อง',
          en: 'Song Phi Nong',
        },
        districtId: 827,
      },
      {
        id: '760803',
        zipcode: 76170,
        text: 'วังจันทร์',
        value: 'วังจันทร์',
        name: {
          th: 'วังจันทร์',
          en: 'Wang Chan',
        },
        districtId: 827,
      },
      {
        id: '760804',
        zipcode: 76170,
        text: 'ป่าเด็ง',
        value: 'ป่าเด็ง',
        name: {
          th: 'ป่าเด็ง',
          en: 'Pa Deng',
        },
        districtId: 827,
      },
      {
        id: '760805',
        zipcode: 76170,
        text: 'พุสวรรค์',
        value: 'พุสวรรค์',
        name: {
          th: 'พุสวรรค์',
          en: 'Phu Sawan',
        },
        districtId: 827,
      },
      {
        id: '760806',
        zipcode: 76170,
        text: 'ห้วยแม่เพรียง',
        value: 'ห้วยแม่เพรียง',
        name: {
          th: 'ห้วยแม่เพรียง',
          en: 'Huai Mae Phriang',
        },
        districtId: 827,
      },
      {
        id: '770101',
        zipcode: 77000,
        text: 'ประจวบคีรีขันธ์',
        value: 'ประจวบคีรีขันธ์',
        name: {
          th: 'ประจวบคีรีขันธ์',
          en: 'Prachuap Khiri Khan',
        },
        districtId: 828,
      },
      {
        id: '770102',
        zipcode: 77000,
        text: 'เกาะหลัก',
        value: 'เกาะหลัก',
        name: {
          th: 'เกาะหลัก',
          en: 'Ko Lak',
        },
        districtId: 828,
      },
      {
        id: '770103',
        zipcode: 77000,
        text: 'คลองวาฬ',
        value: 'คลองวาฬ',
        name: {
          th: 'คลองวาฬ',
          en: 'Khlong Wan',
        },
        districtId: 828,
      },
      {
        id: '770104',
        zipcode: 77000,
        text: 'ห้วยทราย',
        value: 'ห้วยทราย',
        name: {
          th: 'ห้วยทราย',
          en: 'Huai Sai',
        },
        districtId: 828,
      },
      {
        id: '770105',
        zipcode: 77000,
        text: 'อ่าวน้อย',
        value: 'อ่าวน้อย',
        name: {
          th: 'อ่าวน้อย',
          en: 'Ao Noi',
        },
        districtId: 828,
      },
      {
        id: '770106',
        zipcode: 77210,
        text: 'บ่อนอก',
        value: 'บ่อนอก',
        name: {
          th: 'บ่อนอก',
          en: 'Bo Nok',
        },
        districtId: 828,
      },
      {
        id: '770201',
        zipcode: 77150,
        text: 'กุยบุรี',
        value: 'กุยบุรี',
        name: {
          th: 'กุยบุรี',
          en: 'Kui Buri',
        },
        districtId: 829,
      },
      {
        id: '770202',
        zipcode: 77150,
        text: 'กุยเหนือ',
        value: 'กุยเหนือ',
        name: {
          th: 'กุยเหนือ',
          en: 'Kui Nuea',
        },
        districtId: 829,
      },
      {
        id: '770203',
        zipcode: 77150,
        text: 'เขาแดง',
        value: 'เขาแดง',
        name: {
          th: 'เขาแดง',
          en: 'Khao Daeng',
        },
        districtId: 829,
      },
      {
        id: '770204',
        zipcode: 77150,
        text: 'ดอนยายหนู',
        value: 'ดอนยายหนู',
        name: {
          th: 'ดอนยายหนู',
          en: 'Don Yai Nu',
        },
        districtId: 829,
      },
      {
        id: '770206',
        zipcode: 77150,
        text: 'สามกระทาย',
        value: 'สามกระทาย',
        name: {
          th: 'สามกระทาย',
          en: 'Sam Krathai',
        },
        districtId: 829,
      },
      {
        id: '770207',
        zipcode: 77150,
        text: 'หาดขาม',
        value: 'หาดขาม',
        name: {
          th: 'หาดขาม',
          en: 'Hat Kham',
        },
        districtId: 829,
      },
      {
        id: '770301',
        zipcode: 77130,
        text: 'ทับสะแก',
        value: 'ทับสะแก',
        name: {
          th: 'ทับสะแก',
          en: 'Thap Sakae',
        },
        districtId: 830,
      },
      {
        id: '770302',
        zipcode: 77130,
        text: 'อ่างทอง',
        value: 'อ่างทอง',
        name: {
          th: 'อ่างทอง',
          en: 'Ang Thong',
        },
        districtId: 830,
      },
      {
        id: '770303',
        zipcode: 77130,
        text: 'นาหูกวาง',
        value: 'นาหูกวาง',
        name: {
          th: 'นาหูกวาง',
          en: 'Na Hukwang',
        },
        districtId: 830,
      },
      {
        id: '770304',
        zipcode: 77130,
        text: 'เขาล้าน',
        value: 'เขาล้าน',
        name: {
          th: 'เขาล้าน',
          en: 'Khao Lan',
        },
        districtId: 830,
      },
      {
        id: '770305',
        zipcode: 77130,
        text: 'ห้วยยาง',
        value: 'ห้วยยาง',
        name: {
          th: 'ห้วยยาง',
          en: 'Huai Yang',
        },
        districtId: 830,
      },
      {
        id: '770306',
        zipcode: 77130,
        text: 'แสงอรุณ',
        value: 'แสงอรุณ',
        name: {
          th: 'แสงอรุณ',
          en: 'Saeng Arun',
        },
        districtId: 830,
      },
      {
        id: '770401',
        zipcode: 77140,
        text: 'กำเนิดนพคุณ',
        value: 'กำเนิดนพคุณ',
        name: {
          th: 'กำเนิดนพคุณ',
          en: 'Kamnoet Nopphakhun',
        },
        districtId: 831,
      },
      {
        id: '770402',
        zipcode: 77140,
        text: 'พงศ์ประศาสน์',
        value: 'พงศ์ประศาสน์',
        name: {
          th: 'พงศ์ประศาสน์',
          en: 'Phong Prasat',
        },
        districtId: 831,
      },
      {
        id: '770403',
        zipcode: 77230,
        text: 'ร่อนทอง',
        value: 'ร่อนทอง',
        name: {
          th: 'ร่อนทอง',
          en: 'Ron Thong',
        },
        districtId: 831,
      },
      {
        id: '770404',
        zipcode: 77190,
        text: 'ธงชัย',
        value: 'ธงชัย',
        name: {
          th: 'ธงชัย',
          en: 'Thong Chai',
        },
        districtId: 831,
      },
      {
        id: '770405',
        zipcode: 77190,
        text: 'ชัยเกษม',
        value: 'ชัยเกษม',
        name: {
          th: 'ชัยเกษม',
          en: 'Chai Kasem',
        },
        districtId: 831,
      },
      {
        id: '770406',
        zipcode: 77230,
        text: 'ทองมงคล',
        value: 'ทองมงคล',
        name: {
          th: 'ทองมงคล',
          en: 'Thong Mongkhon',
        },
        districtId: 831,
      },
      {
        id: '770407',
        zipcode: 77140,
        text: 'แม่รำพึง',
        value: 'แม่รำพึง',
        name: {
          th: 'แม่รำพึง',
          en: 'Mae Ramphueng',
        },
        districtId: 831,
      },
      {
        id: '770501',
        zipcode: 77170,
        text: 'ปากแพรก',
        value: 'ปากแพรก',
        name: {
          th: 'ปากแพรก',
          en: 'Pak Phraek',
        },
        districtId: 832,
      },
      {
        id: '770502',
        zipcode: 77170,
        text: 'บางสะพาน',
        value: 'บางสะพาน',
        name: {
          th: 'บางสะพาน',
          en: 'Bang Saphan',
        },
        districtId: 832,
      },
      {
        id: '770503',
        zipcode: 77170,
        text: 'ทรายทอง',
        value: 'ทรายทอง',
        name: {
          th: 'ทรายทอง',
          en: 'Sai Thong',
        },
        districtId: 832,
      },
      {
        id: '770504',
        zipcode: 77170,
        text: 'ช้างแรก',
        value: 'ช้างแรก',
        name: {
          th: 'ช้างแรก',
          en: 'Chang Raek',
        },
        districtId: 832,
      },
      {
        id: '770505',
        zipcode: 77170,
        text: 'ไชยราช',
        value: 'ไชยราช',
        name: {
          th: 'ไชยราช',
          en: 'Chaiyarat',
        },
        districtId: 832,
      },
      {
        id: '770601',
        zipcode: 77120,
        text: 'ปราณบุรี',
        value: 'ปราณบุรี',
        name: {
          th: 'ปราณบุรี',
          en: 'Pran Buri',
        },
        districtId: 833,
      },
      {
        id: '770602',
        zipcode: 77120,
        text: 'เขาน้อย',
        value: 'เขาน้อย',
        name: {
          th: 'เขาน้อย',
          en: 'Khao Noi',
        },
        districtId: 833,
      },
      {
        id: '770604',
        zipcode: 77220,
        text: 'ปากน้ำปราณ',
        value: 'ปากน้ำปราณ',
        name: {
          th: 'ปากน้ำปราณ',
          en: 'Pak Nam Pran',
        },
        districtId: 833,
      },
      {
        id: '770607',
        zipcode: 77120,
        text: 'หนองตาแต้ม',
        value: 'หนองตาแต้ม',
        name: {
          th: 'หนองตาแต้ม',
          en: 'Nong Ta Taem',
        },
        districtId: 833,
      },
      {
        id: '770608',
        zipcode: 77120,
        text: 'วังก์พง',
        value: 'วังก์พง',
        name: {
          th: 'วังก์พง',
          en: 'Wang Phong',
        },
        districtId: 833,
      },
      {
        id: '770609',
        zipcode: 77120,
        text: 'เขาจ้าว',
        value: 'เขาจ้าว',
        name: {
          th: 'เขาจ้าว',
          en: 'Khao Chao',
        },
        districtId: 833,
      },
      {
        id: '770701',
        zipcode: 77110,
        text: 'หัวหิน',
        value: 'หัวหิน',
        name: {
          th: 'หัวหิน',
          en: 'Hua Hin',
        },
        districtId: 834,
      },
      {
        id: '770702',
        zipcode: 77110,
        text: 'หนองแก',
        value: 'หนองแก',
        name: {
          th: 'หนองแก',
          en: 'Nong Kae',
        },
        districtId: 834,
      },
      {
        id: '770703',
        zipcode: 77110,
        text: 'หินเหล็กไฟ',
        value: 'หินเหล็กไฟ',
        name: {
          th: 'หินเหล็กไฟ',
          en: 'Hin Lek Fai',
        },
        districtId: 834,
      },
      {
        id: '770704',
        zipcode: 77110,
        text: 'หนองพลับ',
        value: 'หนองพลับ',
        name: {
          th: 'หนองพลับ',
          en: 'Nong Phlap',
        },
        districtId: 834,
      },
      {
        id: '770705',
        zipcode: 77110,
        text: 'ทับใต้',
        value: 'ทับใต้',
        name: {
          th: 'ทับใต้',
          en: 'Thap Tai',
        },
        districtId: 834,
      },
      {
        id: '770706',
        zipcode: 77110,
        text: 'ห้วยสัตว์ใหญ่',
        value: 'ห้วยสัตว์ใหญ่',
        name: {
          th: 'ห้วยสัตว์ใหญ่',
          en: 'Huai Sat Yai',
        },
        districtId: 834,
      },
      {
        id: '770707',
        zipcode: 77110,
        text: 'บึงนคร',
        value: 'บึงนคร',
        name: {
          th: 'บึงนคร',
          en: 'Bueng Nakhon',
        },
        districtId: 834,
      },
      {
        id: '770801',
        zipcode: 77120,
        text: 'สามร้อยยอด',
        value: 'สามร้อยยอด',
        name: {
          th: 'สามร้อยยอด',
          en: 'Sam Roi Yot',
        },
        districtId: 835,
      },
      {
        id: '770802',
        zipcode: 77180,
        text: 'ศิลาลอย',
        value: 'ศิลาลอย',
        name: {
          th: 'ศิลาลอย',
          en: 'Sila Loi',
        },
        districtId: 835,
      },
      {
        id: '770803',
        zipcode: 77180,
        text: 'ไร่เก่า',
        value: 'ไร่เก่า',
        name: {
          th: 'ไร่เก่า',
          en: 'Rai Kao',
        },
        districtId: 835,
      },
      {
        id: '770804',
        zipcode: 77180,
        text: 'ศาลาลัย',
        value: 'ศาลาลัย',
        name: {
          th: 'ศาลาลัย',
          en: 'Salalai',
        },
        districtId: 835,
      },
      {
        id: '770805',
        zipcode: 77180,
        text: 'ไร่ใหม่',
        value: 'ไร่ใหม่',
        name: {
          th: 'ไร่ใหม่',
          en: 'Rai Mai',
        },
        districtId: 835,
      },
      {
        id: '800101',
        zipcode: 80000,
        text: 'ในเมือง',
        value: 'ในเมือง',
        name: {
          th: 'ในเมือง',
          en: 'Nai Mueang',
        },
        districtId: 836,
      },
      {
        id: '800102',
        zipcode: 80000,
        text: 'ท่าวัง',
        value: 'ท่าวัง',
        name: {
          th: 'ท่าวัง',
          en: 'Tha Wang',
        },
        districtId: 836,
      },
      {
        id: '800103',
        zipcode: 80000,
        text: 'คลัง',
        value: 'คลัง',
        name: {
          th: 'คลัง',
          en: 'Khlang',
        },
        districtId: 836,
      },
      {
        id: '800106',
        zipcode: 80000,
        text: 'ท่าไร่',
        value: 'ท่าไร่',
        name: {
          th: 'ท่าไร่',
          en: 'Tha Rai',
        },
        districtId: 836,
      },
      {
        id: '800107',
        zipcode: 80000,
        text: 'ปากนคร',
        value: 'ปากนคร',
        name: {
          th: 'ปากนคร',
          en: 'Pak Nakhon',
        },
        districtId: 836,
      },
      {
        id: '800108',
        zipcode: 80280,
        text: 'นาทราย',
        value: 'นาทราย',
        name: {
          th: 'นาทราย',
          en: 'Na Sai',
        },
        districtId: 836,
      },
      {
        id: '800112',
        zipcode: 80280,
        text: 'กำแพงเซา',
        value: 'กำแพงเซา',
        name: {
          th: 'กำแพงเซา',
          en: 'Kamphaeng Sao',
        },
        districtId: 836,
      },
      {
        id: '800113',
        zipcode: 80000,
        text: 'ไชยมนตรี',
        value: 'ไชยมนตรี',
        name: {
          th: 'ไชยมนตรี',
          en: 'Chai Montri',
        },
        districtId: 836,
      },
      {
        id: '800114',
        zipcode: 80000,
        text: 'มะม่วงสองต้น',
        value: 'มะม่วงสองต้น',
        name: {
          th: 'มะม่วงสองต้น',
          en: 'Mamuang Song Ton',
        },
        districtId: 836,
      },
      {
        id: '800115',
        zipcode: 80000,
        text: 'นาเคียน',
        value: 'นาเคียน',
        name: {
          th: 'นาเคียน',
          en: 'Na Khian',
        },
        districtId: 836,
      },
      {
        id: '800116',
        zipcode: 80280,
        text: 'ท่างิ้ว',
        value: 'ท่างิ้ว',
        name: {
          th: 'ท่างิ้ว',
          en: 'Tha Ngio',
        },
        districtId: 836,
      },
      {
        id: '800118',
        zipcode: 80000,
        text: 'โพธิ์เสด็จ',
        value: 'โพธิ์เสด็จ',
        name: {
          th: 'โพธิ์เสด็จ',
          en: 'Pho Sadet',
        },
        districtId: 836,
      },
      {
        id: '800119',
        zipcode: 80330,
        text: 'บางจาก',
        value: 'บางจาก',
        name: {
          th: 'บางจาก',
          en: 'Bang Chak',
        },
        districtId: 836,
      },
      {
        id: '800120',
        zipcode: 80000,
        text: 'ปากพูน',
        value: 'ปากพูน',
        name: {
          th: 'ปากพูน',
          en: 'Pak Phun',
        },
        districtId: 836,
      },
      {
        id: '800121',
        zipcode: 80000,
        text: 'ท่าซัก',
        value: 'ท่าซัก',
        name: {
          th: 'ท่าซัก',
          en: 'Tha Sak',
        },
        districtId: 836,
      },
      {
        id: '800122',
        zipcode: 80290,
        text: 'ท่าเรือ',
        value: 'ท่าเรือ',
        name: {
          th: 'ท่าเรือ',
          en: 'Tha Ruea',
        },
        districtId: 836,
      },
      {
        id: '800201',
        zipcode: 80320,
        text: 'พรหมโลก',
        value: 'พรหมโลก',
        name: {
          th: 'พรหมโลก',
          en: 'Phrommalok',
        },
        districtId: 837,
      },
      {
        id: '800202',
        zipcode: 80320,
        text: 'บ้านเกาะ',
        value: 'บ้านเกาะ',
        name: {
          th: 'บ้านเกาะ',
          en: 'Ban Ko',
        },
        districtId: 837,
      },
      {
        id: '800203',
        zipcode: 80320,
        text: 'อินคีรี',
        value: 'อินคีรี',
        name: {
          th: 'อินคีรี',
          en: 'In Khiri',
        },
        districtId: 837,
      },
      {
        id: '800204',
        zipcode: 80320,
        text: 'ทอนหงส์',
        value: 'ทอนหงส์',
        name: {
          th: 'ทอนหงส์',
          en: 'Thon Hong',
        },
        districtId: 837,
      },
      {
        id: '800205',
        zipcode: 80320,
        text: 'นาเรียง',
        value: 'นาเรียง',
        name: {
          th: 'นาเรียง',
          en: 'Na Reang',
        },
        districtId: 837,
      },
      {
        id: '800301',
        zipcode: 80230,
        text: 'เขาแก้ว',
        value: 'เขาแก้ว',
        name: {
          th: 'เขาแก้ว',
          en: 'Khao Kaeo',
        },
        districtId: 838,
      },
      {
        id: '800302',
        zipcode: 80230,
        text: 'ลานสกา',
        value: 'ลานสกา',
        name: {
          th: 'ลานสกา',
          en: 'Lan Saka',
        },
        districtId: 838,
      },
      {
        id: '800303',
        zipcode: 80230,
        text: 'ท่าดี',
        value: 'ท่าดี',
        name: {
          th: 'ท่าดี',
          en: 'Tha Di',
        },
        districtId: 838,
      },
      {
        id: '800304',
        zipcode: 80230,
        text: 'กำโลน',
        value: 'กำโลน',
        name: {
          th: 'กำโลน',
          en: 'Kamlon',
        },
        districtId: 838,
      },
      {
        id: '800305',
        zipcode: 80230,
        text: 'ขุนทะเล',
        value: 'ขุนทะเล',
        name: {
          th: 'ขุนทะเล',
          en: 'Khun Thale',
        },
        districtId: 838,
      },
      {
        id: '800401',
        zipcode: 80150,
        text: 'ฉวาง',
        value: 'ฉวาง',
        name: {
          th: 'ฉวาง',
          en: 'Chawang',
        },
        districtId: 839,
      },
      {
        id: '800403',
        zipcode: 80250,
        text: 'ละอาย',
        value: 'ละอาย',
        name: {
          th: 'ละอาย',
          en: 'La-ai',
        },
        districtId: 839,
      },
      {
        id: '800404',
        zipcode: 80260,
        text: 'นาแว',
        value: 'นาแว',
        name: {
          th: 'นาแว',
          en: 'Na Wae',
        },
        districtId: 839,
      },
      {
        id: '800405',
        zipcode: 80150,
        text: 'ไม้เรียง',
        value: 'ไม้เรียง',
        name: {
          th: 'ไม้เรียง',
          en: 'Mai Riang',
        },
        districtId: 839,
      },
      {
        id: '800406',
        zipcode: 80260,
        text: 'กะเปียด',
        value: 'กะเปียด',
        name: {
          th: 'กะเปียด',
          en: 'Kapiat',
        },
        districtId: 839,
      },
      {
        id: '800407',
        zipcode: 80150,
        text: 'นากะชะ',
        value: 'นากะชะ',
        name: {
          th: 'นากะชะ',
          en: 'Na Kacha',
        },
        districtId: 839,
      },
      {
        id: '800409',
        zipcode: 80260,
        text: 'ห้วยปริก',
        value: 'ห้วยปริก',
        name: {
          th: 'ห้วยปริก',
          en: 'Huai Prik',
        },
        districtId: 839,
      },
      {
        id: '800410',
        zipcode: 80150,
        text: 'ไสหร้า',
        value: 'ไสหร้า',
        name: {
          th: 'ไสหร้า',
          en: 'Saira',
        },
        districtId: 839,
      },
      {
        id: '800415',
        zipcode: 80260,
        text: 'นาเขลียง',
        value: 'นาเขลียง',
        name: {
          th: 'นาเขลียง',
          en: 'Na Khliang',
        },
        districtId: 839,
      },
      {
        id: '800416',
        zipcode: 80250,
        text: 'จันดี',
        value: 'จันดี',
        name: {
          th: 'จันดี',
          en: 'Chan Di',
        },
        districtId: 839,
      },
      {
        id: '800501',
        zipcode: 80270,
        text: 'พิปูน',
        value: 'พิปูน',
        name: {
          th: 'พิปูน',
          en: 'Phipun',
        },
        districtId: 840,
      },
      {
        id: '800502',
        zipcode: 80270,
        text: 'กะทูน',
        value: 'กะทูน',
        name: {
          th: 'กะทูน',
          en: 'Kathun',
        },
        districtId: 840,
      },
      {
        id: '800503',
        zipcode: 80270,
        text: 'เขาพระ',
        value: 'เขาพระ',
        name: {
          th: 'เขาพระ',
          en: 'Khao Phra',
        },
        districtId: 840,
      },
      {
        id: '800504',
        zipcode: 80270,
        text: 'ยางค้อม',
        value: 'ยางค้อม',
        name: {
          th: 'ยางค้อม',
          en: 'Yang Khom',
        },
        districtId: 840,
      },
      {
        id: '800505',
        zipcode: 80270,
        text: 'ควนกลาง',
        value: 'ควนกลาง',
        name: {
          th: 'ควนกลาง',
          en: 'Khuan Klang',
        },
        districtId: 840,
      },
      {
        id: '800601',
        zipcode: 80190,
        text: 'เชียรใหญ่',
        value: 'เชียรใหญ่',
        name: {
          th: 'เชียรใหญ่',
          en: 'Chian Yai',
        },
        districtId: 841,
      },
      {
        id: '800603',
        zipcode: 80190,
        text: 'ท่าขนาน',
        value: 'ท่าขนาน',
        name: {
          th: 'ท่าขนาน',
          en: 'Tha Khanan',
        },
        districtId: 841,
      },
      {
        id: '800604',
        zipcode: 80190,
        text: 'บ้านกลาง',
        value: 'บ้านกลาง',
        name: {
          th: 'บ้านกลาง',
          en: 'Ban Klang',
        },
        districtId: 841,
      },
      {
        id: '800605',
        zipcode: 80190,
        text: 'บ้านเนิน',
        value: 'บ้านเนิน',
        name: {
          th: 'บ้านเนิน',
          en: 'Ban Noen',
        },
        districtId: 841,
      },
      {
        id: '800606',
        zipcode: 80190,
        text: 'ไสหมาก',
        value: 'ไสหมาก',
        name: {
          th: 'ไสหมาก',
          en: 'Sai Mak',
        },
        districtId: 841,
      },
      {
        id: '800607',
        zipcode: 80190,
        text: 'ท้องลำเจียก',
        value: 'ท้องลำเจียก',
        name: {
          th: 'ท้องลำเจียก',
          en: 'Thong Lamchiak',
        },
        districtId: 841,
      },
      {
        id: '800610',
        zipcode: 80190,
        text: 'เสือหึง',
        value: 'เสือหึง',
        name: {
          th: 'เสือหึง',
          en: 'Suea Hueng',
        },
        districtId: 841,
      },
      {
        id: '800611',
        zipcode: 80190,
        text: 'การะเกด',
        value: 'การะเกด',
        name: {
          th: 'การะเกด',
          en: 'Karaket',
        },
        districtId: 841,
      },
      {
        id: '800612',
        zipcode: 80190,
        text: 'เขาพระบาท',
        value: 'เขาพระบาท',
        name: {
          th: 'เขาพระบาท',
          en: 'Khao Phra Bat',
        },
        districtId: 841,
      },
      {
        id: '800613',
        zipcode: 80190,
        text: 'แม่เจ้าอยู่หัว',
        value: 'แม่เจ้าอยู่หัว',
        name: {
          th: 'แม่เจ้าอยู่หัว',
          en: 'Mae Chao Yu Hua',
        },
        districtId: 841,
      },
      {
        id: '800701',
        zipcode: 80180,
        text: 'ชะอวด',
        value: 'ชะอวด',
        name: {
          th: 'ชะอวด',
          en: 'Cha-uat',
        },
        districtId: 842,
      },
      {
        id: '800702',
        zipcode: 80180,
        text: 'ท่าเสม็ด',
        value: 'ท่าเสม็ด',
        name: {
          th: 'ท่าเสม็ด',
          en: 'Tha Samet',
        },
        districtId: 842,
      },
      {
        id: '800703',
        zipcode: 80180,
        text: 'ท่าประจะ',
        value: 'ท่าประจะ',
        name: {
          th: 'ท่าประจะ',
          en: 'Tha Pracha',
        },
        districtId: 842,
      },
      {
        id: '800704',
        zipcode: 80180,
        text: 'เคร็ง',
        value: 'เคร็ง',
        name: {
          th: 'เคร็ง',
          en: 'Khreng',
        },
        districtId: 842,
      },
      {
        id: '800705',
        zipcode: 80180,
        text: 'วังอ่าง',
        value: 'วังอ่าง',
        name: {
          th: 'วังอ่าง',
          en: 'Wang Ang',
        },
        districtId: 842,
      },
      {
        id: '800706',
        zipcode: 80180,
        text: 'บ้านตูล',
        value: 'บ้านตูล',
        name: {
          th: 'บ้านตูล',
          en: 'Ban Tun',
        },
        districtId: 842,
      },
      {
        id: '800707',
        zipcode: 80180,
        text: 'ขอนหาด',
        value: 'ขอนหาด',
        name: {
          th: 'ขอนหาด',
          en: 'Khon Hat',
        },
        districtId: 842,
      },
      {
        id: '800708',
        zipcode: 80180,
        text: 'เกาะขันธ์',
        value: 'เกาะขันธ์',
        name: {
          th: 'เกาะขันธ์',
          en: 'Khuan Nong Hong',
        },
        districtId: 842,
      },
      {
        id: '800709',
        zipcode: 80180,
        text: 'ควนหนองหงษ์',
        value: 'ควนหนองหงษ์',
        name: {
          th: 'ควนหนองหงษ์',
          en: 'Khao Phra Thong',
        },
        districtId: 842,
      },
      {
        id: '800710',
        zipcode: 80180,
        text: 'เขาพระทอง',
        value: 'เขาพระทอง',
        name: {
          th: 'เขาพระทอง',
          en: 'Nang Long',
        },
        districtId: 842,
      },
      {
        id: '800711',
        zipcode: 80180,
        text: 'นางหลง',
        value: 'นางหลง',
        name: {
          th: 'นางหลง',
          en: 'Nang Long',
        },
        districtId: 842,
      },
      {
        id: '800801',
        zipcode: 80160,
        text: 'ท่าศาลา',
        value: 'ท่าศาลา',
        name: {
          th: 'ท่าศาลา',
          en: 'Tha Sala',
        },
        districtId: 843,
      },
      {
        id: '800802',
        zipcode: 80160,
        text: 'กลาย',
        value: 'กลาย',
        name: {
          th: 'กลาย',
          en: 'Klai',
        },
        districtId: 843,
      },
      {
        id: '800803',
        zipcode: 80160,
        text: 'ท่าขึ้น',
        value: 'ท่าขึ้น',
        name: {
          th: 'ท่าขึ้น',
          en: 'Tha Khuen',
        },
        districtId: 843,
      },
      {
        id: '800804',
        zipcode: 80160,
        text: 'หัวตะพาน',
        value: 'หัวตะพาน',
        name: {
          th: 'หัวตะพาน',
          en: 'Hua Taphan',
        },
        districtId: 843,
      },
      {
        id: '800806',
        zipcode: 80160,
        text: 'สระแก้ว',
        value: 'สระแก้ว',
        name: {
          th: 'สระแก้ว',
          en: 'Sa Kaeo',
        },
        districtId: 843,
      },
      {
        id: '800807',
        zipcode: 80160,
        text: 'โมคลาน',
        value: 'โมคลาน',
        name: {
          th: 'โมคลาน',
          en: 'Mokkhalan',
        },
        districtId: 843,
      },
      {
        id: '800809',
        zipcode: 80160,
        text: 'ไทยบุรี',
        value: 'ไทยบุรี',
        name: {
          th: 'ไทยบุรี',
          en: 'Thai buri',
        },
        districtId: 843,
      },
      {
        id: '800810',
        zipcode: 80160,
        text: 'ดอนตะโก',
        value: 'ดอนตะโก',
        name: {
          th: 'ดอนตะโก',
          en: 'Don tako',
        },
        districtId: 843,
      },
      {
        id: '800811',
        zipcode: 80160,
        text: 'ตลิ่งชัน',
        value: 'ตลิ่งชัน',
        name: {
          th: 'ตลิ่งชัน',
          en: 'Taling Chan',
        },
        districtId: 843,
      },
      {
        id: '800813',
        zipcode: 80160,
        text: 'โพธิ์ทอง',
        value: 'โพธิ์ทอง',
        name: {
          th: 'โพธิ์ทอง',
          en: 'Pho Thong',
        },
        districtId: 843,
      },
      {
        id: '800901',
        zipcode: 80110,
        text: 'ปากแพรก',
        value: 'ปากแพรก',
        name: {
          th: 'ปากแพรก',
          en: 'Pak Phraek',
        },
        districtId: 844,
      },
      {
        id: '800902',
        zipcode: 80110,
        text: 'ชะมาย',
        value: 'ชะมาย',
        name: {
          th: 'ชะมาย',
          en: 'Chamai',
        },
        districtId: 844,
      },
      {
        id: '800903',
        zipcode: 80110,
        text: 'หนองหงส์',
        value: 'หนองหงส์',
        name: {
          th: 'หนองหงส์',
          en: 'Nong Hong',
        },
        districtId: 844,
      },
      {
        id: '800904',
        zipcode: 80110,
        text: 'ควนกรด',
        value: 'ควนกรด',
        name: {
          th: 'ควนกรด',
          en: 'Khuan Krot',
        },
        districtId: 844,
      },
      {
        id: '800905',
        zipcode: 80110,
        text: 'นาไม้ไผ่',
        value: 'นาไม้ไผ่',
        name: {
          th: 'นาไม้ไผ่',
          en: 'Na Mai Phai',
        },
        districtId: 844,
      },
      {
        id: '800906',
        zipcode: 80110,
        text: 'นาหลวงเสน',
        value: 'นาหลวงเสน',
        name: {
          th: 'นาหลวงเสน',
          en: 'Na Luang Sen',
        },
        districtId: 844,
      },
      {
        id: '800907',
        zipcode: 80110,
        text: 'เขาโร',
        value: 'เขาโร',
        name: {
          th: 'เขาโร',
          en: 'Khao Ro',
        },
        districtId: 844,
      },
      {
        id: '800908',
        zipcode: 80310,
        text: 'กะปาง',
        value: 'กะปาง',
        name: {
          th: 'กะปาง',
          en: 'Kapang',
        },
        districtId: 844,
      },
      {
        id: '800909',
        zipcode: 80110,
        text: 'ที่วัง',
        value: 'ที่วัง',
        name: {
          th: 'ที่วัง',
          en: 'Thi Wang',
        },
        districtId: 844,
      },
      {
        id: '800910',
        zipcode: 80110,
        text: 'น้ำตก',
        value: 'น้ำตก',
        name: {
          th: 'น้ำตก',
          en: 'Namtok',
        },
        districtId: 844,
      },
      {
        id: '800911',
        zipcode: 80110,
        text: 'ถ้ำใหญ่',
        value: 'ถ้ำใหญ่',
        name: {
          th: 'ถ้ำใหญ่',
          en: 'Tham Yai',
        },
        districtId: 844,
      },
      {
        id: '800912',
        zipcode: 80110,
        text: 'นาโพธิ์',
        value: 'นาโพธิ์',
        name: {
          th: 'นาโพธิ์',
          en: 'Na Pho',
        },
        districtId: 844,
      },
      {
        id: '800913',
        zipcode: 80110,
        text: 'เขาขาว',
        value: 'เขาขาว',
        name: {
          th: 'เขาขาว',
          en: 'Khao Khao',
        },
        districtId: 844,
      },
      {
        id: '801001',
        zipcode: 80220,
        text: 'นาบอน',
        value: 'นาบอน',
        name: {
          th: 'นาบอน',
          en: 'Na Bon',
        },
        districtId: 845,
      },
      {
        id: '801002',
        zipcode: 80220,
        text: 'ทุ่งสง',
        value: 'ทุ่งสง',
        name: {
          th: 'ทุ่งสง',
          en: 'Thung Song',
        },
        districtId: 845,
      },
      {
        id: '801003',
        zipcode: 80220,
        text: 'แก้วแสน',
        value: 'แก้วแสน',
        name: {
          th: 'แก้วแสน',
          en: 'Kaeo Saen',
        },
        districtId: 845,
      },
      {
        id: '801101',
        zipcode: 80240,
        text: 'ท่ายาง',
        value: 'ท่ายาง',
        name: {
          th: 'ท่ายาง',
          en: 'Tha Yang',
        },
        districtId: 846,
      },
      {
        id: '801102',
        zipcode: 80240,
        text: 'ทุ่งสัง',
        value: 'ทุ่งสัง',
        name: {
          th: 'ทุ่งสัง',
          en: 'Thung Sang',
        },
        districtId: 846,
      },
      {
        id: '801103',
        zipcode: 80240,
        text: 'ทุ่งใหญ่',
        value: 'ทุ่งใหญ่',
        name: {
          th: 'ทุ่งใหญ่',
          en: 'Thung Yai',
        },
        districtId: 846,
      },
      {
        id: '801104',
        zipcode: 80240,
        text: 'กุแหระ',
        value: 'กุแหระ',
        name: {
          th: 'กุแหระ',
          en: 'Kurae',
        },
        districtId: 846,
      },
      {
        id: '801105',
        zipcode: 80240,
        text: 'ปริก',
        value: 'ปริก',
        name: {
          th: 'ปริก',
          en: 'Prik',
        },
        districtId: 846,
      },
      {
        id: '801106',
        zipcode: 80240,
        text: 'บางรูป',
        value: 'บางรูป',
        name: {
          th: 'บางรูป',
          en: 'Bang Rup',
        },
        districtId: 846,
      },
      {
        id: '801107',
        zipcode: 80240,
        text: 'กรุงหยัน',
        value: 'กรุงหยัน',
        name: {
          th: 'กรุงหยัน',
          en: 'Krung Yan',
        },
        districtId: 846,
      },
      {
        id: '801201',
        zipcode: 80140,
        text: 'ปากพนัง',
        value: 'ปากพนัง',
        name: {
          th: 'ปากพนัง',
          en: 'Pak Phanang',
        },
        districtId: 847,
      },
      {
        id: '801202',
        zipcode: 80330,
        text: 'คลองน้อย',
        value: 'คลองน้อย',
        name: {
          th: 'คลองน้อย',
          en: 'Khlong Noi',
        },
        districtId: 847,
      },
      {
        id: '801203',
        zipcode: 80140,
        text: 'ป่าระกำ',
        value: 'ป่าระกำ',
        name: {
          th: 'ป่าระกำ',
          en: 'Pa Rakam',
        },
        districtId: 847,
      },
      {
        id: '801204',
        zipcode: 80330,
        text: 'ชะเมา',
        value: 'ชะเมา',
        name: {
          th: 'ชะเมา',
          en: 'Chamao',
        },
        districtId: 847,
      },
      {
        id: '801205',
        zipcode: 80140,
        text: 'คลองกระบือ',
        value: 'คลองกระบือ',
        name: {
          th: 'คลองกระบือ',
          en: 'Khlong Krabue',
        },
        districtId: 847,
      },
      {
        id: '801206',
        zipcode: 80330,
        text: 'เกาะทวด',
        value: 'เกาะทวด',
        name: {
          th: 'เกาะทวด',
          en: 'Ko Thuat',
        },
        districtId: 847,
      },
      {
        id: '801207',
        zipcode: 80140,
        text: 'บ้านใหม่',
        value: 'บ้านใหม่',
        name: {
          th: 'บ้านใหม่',
          en: 'Ban Mai',
        },
        districtId: 847,
      },
      {
        id: '801208',
        zipcode: 80140,
        text: 'หูล่อง',
        value: 'หูล่อง',
        name: {
          th: 'หูล่อง',
          en: 'Hu Long',
        },
        districtId: 847,
      },
      {
        id: '801209',
        zipcode: 80140,
        text: 'แหลมตะลุมพุก',
        value: 'แหลมตะลุมพุก',
        name: {
          th: 'แหลมตะลุมพุก',
          en: 'Laem Talumphuk',
        },
        districtId: 847,
      },
      {
        id: '801210',
        zipcode: 80140,
        text: 'ปากพนังฝั่งตะวันตก',
        value: 'ปากพนังฝั่งตะวันตก',
        name: {
          th: 'ปากพนังฝั่งตะวันตก',
          en: 'Pak Phanang Fang Tawantok',
        },
        districtId: 847,
      },
      {
        id: '801211',
        zipcode: 80140,
        text: 'บางศาลา',
        value: 'บางศาลา',
        name: {
          th: 'บางศาลา',
          en: 'Bang Sala',
        },
        districtId: 847,
      },
      {
        id: '801212',
        zipcode: 80140,
        text: 'บางพระ',
        value: 'บางพระ',
        name: {
          th: 'บางพระ',
          en: 'Bang Phra',
        },
        districtId: 847,
      },
      {
        id: '801213',
        zipcode: 80140,
        text: 'บางตะพง',
        value: 'บางตะพง',
        name: {
          th: 'บางตะพง',
          en: 'Bang Taphong',
        },
        districtId: 847,
      },
      {
        id: '801214',
        zipcode: 80140,
        text: 'ปากพนังฝั่งตะวันออก',
        value: 'ปากพนังฝั่งตะวันออก',
        name: {
          th: 'ปากพนังฝั่งตะวันออก',
          en: 'Pak Phanang Fang Tawan-ok',
        },
        districtId: 847,
      },
      {
        id: '801215',
        zipcode: 80140,
        text: 'บ้านเพิง',
        value: 'บ้านเพิง',
        name: {
          th: 'บ้านเพิง',
          en: 'Ban Phoeng',
        },
        districtId: 847,
      },
      {
        id: '801216',
        zipcode: 80140,
        text: 'ท่าพยา',
        value: 'ท่าพยา',
        name: {
          th: 'ท่าพยา',
          en: 'Tha Phaya',
        },
        districtId: 847,
      },
      {
        id: '801217',
        zipcode: 80140,
        text: 'ปากแพรก',
        value: 'ปากแพรก',
        name: {
          th: 'ปากแพรก',
          en: 'Pak Phraek',
        },
        districtId: 847,
      },
      {
        id: '801218',
        zipcode: 80140,
        text: 'ขนาบนาก',
        value: 'ขนาบนาก',
        name: {
          th: 'ขนาบนาก',
          en: 'Khanap Nak',
        },
        districtId: 847,
      },
      {
        id: '801301',
        zipcode: 80130,
        text: 'ร่อนพิบูลย์',
        value: 'ร่อนพิบูลย์',
        name: {
          th: 'ร่อนพิบูลย์',
          en: 'Ron Phibun',
        },
        districtId: 848,
      },
      {
        id: '801302',
        zipcode: 80350,
        text: 'หินตก',
        value: 'หินตก',
        name: {
          th: 'หินตก',
          en: 'Hin Tok',
        },
        districtId: 848,
      },
      {
        id: '801303',
        zipcode: 80350,
        text: 'เสาธง',
        value: 'เสาธง',
        name: {
          th: 'เสาธง',
          en: 'Sao Thong',
        },
        districtId: 848,
      },
      {
        id: '801304',
        zipcode: 80130,
        text: 'ควนเกย',
        value: 'ควนเกย',
        name: {
          th: 'ควนเกย',
          en: 'Khuan Koei',
        },
        districtId: 848,
      },
      {
        id: '801305',
        zipcode: 80130,
        text: 'ควนพัง',
        value: 'ควนพัง',
        name: {
          th: 'ควนพัง',
          en: 'Khuan Phang',
        },
        districtId: 848,
      },
      {
        id: '801306',
        zipcode: 80130,
        text: 'ควนชุม',
        value: 'ควนชุม',
        name: {
          th: 'ควนชุม',
          en: 'Khuan Chum',
        },
        districtId: 848,
      },
      {
        id: '801401',
        zipcode: 80120,
        text: 'สิชล',
        value: 'สิชล',
        name: {
          th: 'สิชล',
          en: 'Sichon',
        },
        districtId: 849,
      },
      {
        id: '801402',
        zipcode: 80120,
        text: 'ทุ่งปรัง',
        value: 'ทุ่งปรัง',
        name: {
          th: 'ทุ่งปรัง',
          en: 'Thung Prang',
        },
        districtId: 849,
      },
      {
        id: '801403',
        zipcode: 80120,
        text: 'ฉลอง',
        value: 'ฉลอง',
        name: {
          th: 'ฉลอง',
          en: 'Chalong',
        },
        districtId: 849,
      },
      {
        id: '801404',
        zipcode: 80340,
        text: 'เสาเภา',
        value: 'เสาเภา',
        name: {
          th: 'เสาเภา',
          en: 'Sao Phao',
        },
        districtId: 849,
      },
      {
        id: '801405',
        zipcode: 80120,
        text: 'เปลี่ยน',
        value: 'เปลี่ยน',
        name: {
          th: 'เปลี่ยน',
          en: 'Plian',
        },
        districtId: 849,
      },
      {
        id: '801406',
        zipcode: 80120,
        text: 'สี่ขีด',
        value: 'สี่ขีด',
        name: {
          th: 'สี่ขีด',
          en: 'Si Khit',
        },
        districtId: 849,
      },
      {
        id: '801407',
        zipcode: 80340,
        text: 'เทพราช',
        value: 'เทพราช',
        name: {
          th: 'เทพราช',
          en: 'Theppharat',
        },
        districtId: 849,
      },
      {
        id: '801408',
        zipcode: 80120,
        text: 'เขาน้อย',
        value: 'เขาน้อย',
        name: {
          th: 'เขาน้อย',
          en: 'Khao Noi',
        },
        districtId: 849,
      },
      {
        id: '801409',
        zipcode: 80120,
        text: 'ทุ่งใส',
        value: 'ทุ่งใส',
        name: {
          th: 'ทุ่งใส',
          en: 'Thung Sai',
        },
        districtId: 849,
      },
      {
        id: '801501',
        zipcode: 80210,
        text: 'ขนอม',
        value: 'ขนอม',
        name: {
          th: 'ขนอม',
          en: 'Khanom',
        },
        districtId: 850,
      },
      {
        id: '801502',
        zipcode: 80210,
        text: 'ควนทอง',
        value: 'ควนทอง',
        name: {
          th: 'ควนทอง',
          en: 'Khuan Thong',
        },
        districtId: 850,
      },
      {
        id: '801503',
        zipcode: 80210,
        text: 'ท้องเนียน',
        value: 'ท้องเนียน',
        name: {
          th: 'ท้องเนียน',
          en: 'Thong Nian',
        },
        districtId: 850,
      },
      {
        id: '801601',
        zipcode: 80170,
        text: 'หัวไทร',
        value: 'หัวไทร',
        name: {
          th: 'หัวไทร',
          en: 'Hua Sai',
        },
        districtId: 851,
      },
      {
        id: '801602',
        zipcode: 80170,
        text: 'หน้าสตน',
        value: 'หน้าสตน',
        name: {
          th: 'หน้าสตน',
          en: 'Na Saton',
        },
        districtId: 851,
      },
      {
        id: '801603',
        zipcode: 80170,
        text: 'ทรายขาว',
        value: 'ทรายขาว',
        name: {
          th: 'ทรายขาว',
          en: 'Sai Khao',
        },
        districtId: 851,
      },
      {
        id: '801604',
        zipcode: 80170,
        text: 'แหลม',
        value: 'แหลม',
        name: {
          th: 'แหลม',
          en: 'Laem',
        },
        districtId: 851,
      },
      {
        id: '801605',
        zipcode: 80170,
        text: 'เขาพังไกร',
        value: 'เขาพังไกร',
        name: {
          th: 'เขาพังไกร',
          en: 'Khao Phang Krai',
        },
        districtId: 851,
      },
      {
        id: '801606',
        zipcode: 80170,
        text: 'บ้านราม',
        value: 'บ้านราม',
        name: {
          th: 'บ้านราม',
          en: 'Ban Ram',
        },
        districtId: 851,
      },
      {
        id: '801607',
        zipcode: 80170,
        text: 'บางนบ',
        value: 'บางนบ',
        name: {
          th: 'บางนบ',
          en: 'Bang Nop',
        },
        districtId: 851,
      },
      {
        id: '801608',
        zipcode: 80170,
        text: 'ท่าซอม',
        value: 'ท่าซอม',
        name: {
          th: 'ท่าซอม',
          en: 'Tha Som',
        },
        districtId: 851,
      },
      {
        id: '801609',
        zipcode: 80170,
        text: 'ควนชะลิก',
        value: 'ควนชะลิก',
        name: {
          th: 'ควนชะลิก',
          en: 'Khuan Chalik',
        },
        districtId: 851,
      },
      {
        id: '801610',
        zipcode: 80170,
        text: 'รามแก้ว',
        value: 'รามแก้ว',
        name: {
          th: 'รามแก้ว',
          en: 'Ram Kaeo',
        },
        districtId: 851,
      },
      {
        id: '801611',
        zipcode: 80170,
        text: 'เกาะเพชร',
        value: 'เกาะเพชร',
        name: {
          th: 'เกาะเพชร',
          en: 'Ko Phet',
        },
        districtId: 851,
      },
      {
        id: '801701',
        zipcode: 80360,
        text: 'บางขัน',
        value: 'บางขัน',
        name: {
          th: 'บางขัน',
          en: 'Bang Khan',
        },
        districtId: 852,
      },
      {
        id: '801702',
        zipcode: 80360,
        text: 'บ้านลำนาว',
        value: 'บ้านลำนาว',
        name: {
          th: 'บ้านลำนาว',
          en: 'Ban Lamnao',
        },
        districtId: 852,
      },
      {
        id: '801703',
        zipcode: 80360,
        text: 'วังหิน',
        value: 'วังหิน',
        name: {
          th: 'วังหิน',
          en: 'Wang Hin',
        },
        districtId: 852,
      },
      {
        id: '801704',
        zipcode: 80360,
        text: 'บ้านนิคม',
        value: 'บ้านนิคม',
        name: {
          th: 'บ้านนิคม',
          en: 'Ban Nikhom',
        },
        districtId: 852,
      },
      {
        id: '801801',
        zipcode: 80260,
        text: 'ถ้ำพรรณรา',
        value: 'ถ้ำพรรณรา',
        name: {
          th: 'ถ้ำพรรณรา',
          en: 'Tham Phannara',
        },
        districtId: 853,
      },
      {
        id: '801802',
        zipcode: 80260,
        text: 'คลองเส',
        value: 'คลองเส',
        name: {
          th: 'คลองเส',
          en: 'Khlong Se',
        },
        districtId: 853,
      },
      {
        id: '801803',
        zipcode: 80260,
        text: 'ดุสิต',
        value: 'ดุสิต',
        name: {
          th: 'ดุสิต',
          en: 'Dusit',
        },
        districtId: 853,
      },
      {
        id: '801901',
        zipcode: 80180,
        text: 'บ้านควนมุด',
        value: 'บ้านควนมุด',
        name: {
          th: 'บ้านควนมุด',
          en: 'Ban Khuan Mut',
        },
        districtId: 854,
      },
      {
        id: '801902',
        zipcode: 80180,
        text: 'บ้านชะอวด',
        value: 'บ้านชะอวด',
        name: {
          th: 'บ้านชะอวด',
          en: 'Ban Cha-uat',
        },
        districtId: 854,
      },
      {
        id: '801903',
        zipcode: 80130,
        text: 'ควนหนองคว้า',
        value: 'ควนหนองคว้า',
        name: {
          th: 'ควนหนองคว้า',
          en: 'Khuan Nong Khwa',
        },
        districtId: 854,
      },
      {
        id: '801904',
        zipcode: 80130,
        text: 'ทุ่งโพธิ์',
        value: 'ทุ่งโพธิ์',
        name: {
          th: 'ทุ่งโพธิ์',
          en: 'Thung Pho',
        },
        districtId: 854,
      },
      {
        id: '801905',
        zipcode: 80130,
        text: 'นาหมอบุญ',
        value: 'นาหมอบุญ',
        name: {
          th: 'นาหมอบุญ',
          en: 'Na Mo Bun',
        },
        districtId: 854,
      },
      {
        id: '801906',
        zipcode: 80130,
        text: 'สามตำบล',
        value: 'สามตำบล',
        name: {
          th: 'สามตำบล',
          en: 'Sam Tambon',
        },
        districtId: 854,
      },
      {
        id: '802001',
        zipcode: 80000,
        text: 'นาพรุ',
        value: 'นาพรุ',
        name: {
          th: 'นาพรุ',
          en: 'Na Phru',
        },
        districtId: 855,
      },
      {
        id: '802002',
        zipcode: 80000,
        text: 'นาสาร',
        value: 'นาสาร',
        name: {
          th: 'นาสาร',
          en: 'Na San',
        },
        districtId: 855,
      },
      {
        id: '802003',
        zipcode: 80000,
        text: 'ท้ายสำเภา',
        value: 'ท้ายสำเภา',
        name: {
          th: 'ท้ายสำเภา',
          en: 'Thai Samphao',
        },
        districtId: 855,
      },
      {
        id: '802004',
        zipcode: 80000,
        text: 'ช้างซ้าย',
        value: 'ช้างซ้าย',
        name: {
          th: 'ช้างซ้าย',
          en: 'Chang Sai',
        },
        districtId: 855,
      },
      {
        id: '802101',
        zipcode: 80160,
        text: 'นบพิตำ',
        value: 'นบพิตำ',
        name: {
          th: 'นบพิตำ',
          en: 'Nopphitam',
        },
        districtId: 856,
      },
      {
        id: '802102',
        zipcode: 80160,
        text: 'กรุงชิง',
        value: 'กรุงชิง',
        name: {
          th: 'กรุงชิง',
          en: 'Krung Ching',
        },
        districtId: 856,
      },
      {
        id: '802103',
        zipcode: 80160,
        text: 'กะหรอ',
        value: 'กะหรอ',
        name: {
          th: 'กะหรอ',
          en: 'Karo',
        },
        districtId: 856,
      },
      {
        id: '802104',
        zipcode: 80160,
        text: 'นาเหรง',
        value: 'นาเหรง',
        name: {
          th: 'นาเหรง',
          en: 'Na Reng',
        },
        districtId: 856,
      },
      {
        id: '802201',
        zipcode: 80250,
        text: 'ช้างกลาง',
        value: 'ช้างกลาง',
        name: {
          th: 'ช้างกลาง',
          en: 'Chang Klang',
        },
        districtId: 857,
      },
      {
        id: '802202',
        zipcode: 80250,
        text: 'หลักช้าง',
        value: 'หลักช้าง',
        name: {
          th: 'หลักช้าง',
          en: 'Lak Chang',
        },
        districtId: 857,
      },
      {
        id: '802203',
        zipcode: 80250,
        text: 'สวนขัน',
        value: 'สวนขัน',
        name: {
          th: 'สวนขัน',
          en: 'Suan Kan',
        },
        districtId: 857,
      },
      {
        id: '802301',
        zipcode: 80190,
        text: 'เชียรเขา',
        value: 'เชียรเขา',
        name: {
          th: 'เชียรเขา',
          en: 'Chian Khao',
        },
        districtId: 858,
      },
      {
        id: '802302',
        zipcode: 80290,
        text: 'ดอนตรอ',
        value: 'ดอนตรอ',
        name: {
          th: 'ดอนตรอ',
          en: 'Don Tro',
        },
        districtId: 858,
      },
      {
        id: '802303',
        zipcode: 80190,
        text: 'สวนหลวง',
        value: 'สวนหลวง',
        name: {
          th: 'สวนหลวง',
          en: 'Suan Luang',
        },
        districtId: 858,
      },
      {
        id: '802304',
        zipcode: 80190,
        text: 'ทางพูน',
        value: 'ทางพูน',
        name: {
          th: 'ทางพูน',
          en: 'Thang Phun',
        },
        districtId: 858,
      },
      {
        id: '810101',
        zipcode: 81000,
        text: 'ปากน้ำ',
        value: 'ปากน้ำ',
        name: {
          th: 'ปากน้ำ',
          en: 'Pak Nam',
        },
        districtId: 864,
      },
      {
        id: '810102',
        zipcode: 81000,
        text: 'กระบี่ใหญ่',
        value: 'กระบี่ใหญ่',
        name: {
          th: 'กระบี่ใหญ่',
          en: 'Krabi Yai',
        },
        districtId: 864,
      },
      {
        id: '810103',
        zipcode: 81000,
        text: 'กระบี่น้อย',
        value: 'กระบี่น้อย',
        name: {
          th: 'กระบี่น้อย',
          en: 'Krabi Noi',
        },
        districtId: 864,
      },
      {
        id: '810105',
        zipcode: 81000,
        text: 'เขาคราม',
        value: 'เขาคราม',
        name: {
          th: 'เขาคราม',
          en: 'Khao Khram',
        },
        districtId: 864,
      },
      {
        id: '810106',
        zipcode: 81000,
        text: 'เขาทอง',
        value: 'เขาทอง',
        name: {
          th: 'เขาทอง',
          en: 'Khao Thong',
        },
        districtId: 864,
      },
      {
        id: '810111',
        zipcode: 81000,
        text: 'ทับปริก',
        value: 'ทับปริก',
        name: {
          th: 'ทับปริก',
          en: 'Thap Prik',
        },
        districtId: 864,
      },
      {
        id: '810115',
        zipcode: 81000,
        text: 'ไสไทย',
        value: 'ไสไทย',
        name: {
          th: 'ไสไทย',
          en: 'Sai Thai',
        },
        districtId: 864,
      },
      {
        id: '810116',
        zipcode: 81000,
        text: 'อ่าวนาง',
        value: 'อ่าวนาง',
        name: {
          th: 'อ่าวนาง',
          en: 'Ao Nang',
        },
        districtId: 864,
      },
      {
        id: '810117',
        zipcode: 81000,
        text: 'หนองทะเล',
        value: 'หนองทะเล',
        name: {
          th: 'หนองทะเล',
          en: 'Nong Thale',
        },
        districtId: 864,
      },
      {
        id: '810118',
        zipcode: 81000,
        text: 'คลองประสงค์',
        value: 'คลองประสงค์',
        name: {
          th: 'คลองประสงค์',
          en: 'Khlong Prasong',
        },
        districtId: 864,
      },
      {
        id: '810201',
        zipcode: 81140,
        text: 'เขาพนม',
        value: 'เขาพนม',
        name: {
          th: 'เขาพนม',
          en: 'Khao Phanom',
        },
        districtId: 865,
      },
      {
        id: '810202',
        zipcode: 81140,
        text: 'เขาดิน',
        value: 'เขาดิน',
        name: {
          th: 'เขาดิน',
          en: 'Khao Din',
        },
        districtId: 865,
      },
      {
        id: '810203',
        zipcode: 80240,
        text: 'สินปุน',
        value: 'สินปุน',
        name: {
          th: 'สินปุน',
          en: 'Sin Pun',
        },
        districtId: 865,
      },
      {
        id: '810204',
        zipcode: 81140,
        text: 'พรุเตียว',
        value: 'พรุเตียว',
        name: {
          th: 'พรุเตียว',
          en: 'Phru Tiao',
        },
        districtId: 865,
      },
      {
        id: '810205',
        zipcode: 81140,
        text: 'หน้าเขา',
        value: 'หน้าเขา',
        name: {
          th: 'หน้าเขา',
          en: 'Na Khao',
        },
        districtId: 865,
      },
      {
        id: '810206',
        zipcode: 80240,
        text: 'โคกหาร',
        value: 'โคกหาร',
        name: {
          th: 'โคกหาร',
          en: 'Khok Han',
        },
        districtId: 865,
      },
      {
        id: '810301',
        zipcode: 81150,
        text: 'เกาะลันตาใหญ่',
        value: 'เกาะลันตาใหญ่',
        name: {
          th: 'เกาะลันตาใหญ่',
          en: 'Ko Lanta Yai',
        },
        districtId: 866,
      },
      {
        id: '810302',
        zipcode: 81150,
        text: 'เกาะลันตาน้อย',
        value: 'เกาะลันตาน้อย',
        name: {
          th: 'เกาะลันตาน้อย',
          en: 'Ko Lanta Noi',
        },
        districtId: 866,
      },
      {
        id: '810303',
        zipcode: 81120,
        text: 'เกาะกลาง',
        value: 'เกาะกลาง',
        name: {
          th: 'เกาะกลาง',
          en: 'Ko Klang',
        },
        districtId: 866,
      },
      {
        id: '810304',
        zipcode: 81120,
        text: 'คลองยาง',
        value: 'คลองยาง',
        name: {
          th: 'คลองยาง',
          en: 'Khlong Yang',
        },
        districtId: 866,
      },
      {
        id: '810305',
        zipcode: 81150,
        text: 'ศาลาด่าน',
        value: 'ศาลาด่าน',
        name: {
          th: 'ศาลาด่าน',
          en: 'Sala Dan',
        },
        districtId: 866,
      },
      {
        id: '810401',
        zipcode: 81120,
        text: 'คลองท่อมใต้',
        value: 'คลองท่อมใต้',
        name: {
          th: 'คลองท่อมใต้',
          en: 'Khlong Thom Tai',
        },
        districtId: 867,
      },
      {
        id: '810402',
        zipcode: 81120,
        text: 'คลองท่อมเหนือ',
        value: 'คลองท่อมเหนือ',
        name: {
          th: 'คลองท่อมเหนือ',
          en: 'Khlong Thom Nuea',
        },
        districtId: 867,
      },
      {
        id: '810403',
        zipcode: 81170,
        text: 'คลองพน',
        value: 'คลองพน',
        name: {
          th: 'คลองพน',
          en: 'Khlong Phon',
        },
        districtId: 867,
      },
      {
        id: '810404',
        zipcode: 81170,
        text: 'ทรายขาว',
        value: 'ทรายขาว',
        name: {
          th: 'ทรายขาว',
          en: 'Sai Khao',
        },
        districtId: 867,
      },
      {
        id: '810405',
        zipcode: 81120,
        text: 'ห้วยน้ำขาว',
        value: 'ห้วยน้ำขาว',
        name: {
          th: 'ห้วยน้ำขาว',
          en: 'Huai Nam Khao',
        },
        districtId: 867,
      },
      {
        id: '810406',
        zipcode: 81120,
        text: 'พรุดินนา',
        value: 'พรุดินนา',
        name: {
          th: 'พรุดินนา',
          en: 'Phru Din Na',
        },
        districtId: 867,
      },
      {
        id: '810407',
        zipcode: 81120,
        text: 'เพหลา',
        value: 'เพหลา',
        name: {
          th: 'เพหลา',
          en: 'Phela',
        },
        districtId: 867,
      },
      {
        id: '810501',
        zipcode: 81110,
        text: 'อ่าวลึกใต้',
        value: 'อ่าวลึกใต้',
        name: {
          th: 'อ่าวลึกใต้',
          en: 'Ao Luek Tai',
        },
        districtId: 868,
      },
      {
        id: '810502',
        zipcode: 81110,
        text: 'แหลมสัก',
        value: 'แหลมสัก',
        name: {
          th: 'แหลมสัก',
          en: 'Laem Sak',
        },
        districtId: 868,
      },
      {
        id: '810503',
        zipcode: 81110,
        text: 'นาเหนือ',
        value: 'นาเหนือ',
        name: {
          th: 'นาเหนือ',
          en: 'Na Nuea',
        },
        districtId: 868,
      },
      {
        id: '810504',
        zipcode: 81110,
        text: 'คลองหิน',
        value: 'คลองหิน',
        name: {
          th: 'คลองหิน',
          en: 'Khlong Hin',
        },
        districtId: 868,
      },
      {
        id: '810505',
        zipcode: 81110,
        text: 'อ่าวลึกน้อย',
        value: 'อ่าวลึกน้อย',
        name: {
          th: 'อ่าวลึกน้อย',
          en: 'Ao Luek Noi',
        },
        districtId: 868,
      },
      {
        id: '810506',
        zipcode: 81110,
        text: 'อ่าวลึกเหนือ',
        value: 'อ่าวลึกเหนือ',
        name: {
          th: 'อ่าวลึกเหนือ',
          en: 'Ao Luek Nuea',
        },
        districtId: 868,
      },
      {
        id: '810507',
        zipcode: 81110,
        text: 'เขาใหญ่',
        value: 'เขาใหญ่',
        name: {
          th: 'เขาใหญ่',
          en: 'Khao Yai',
        },
        districtId: 868,
      },
      {
        id: '810508',
        zipcode: 81110,
        text: 'คลองยา',
        value: 'คลองยา',
        name: {
          th: 'คลองยา',
          en: 'Khlong Ya',
        },
        districtId: 868,
      },
      {
        id: '810509',
        zipcode: 81110,
        text: 'บ้านกลาง',
        value: 'บ้านกลาง',
        name: {
          th: 'บ้านกลาง',
          en: 'Ban Klang',
        },
        districtId: 868,
      },
      {
        id: '810601',
        zipcode: 81160,
        text: 'ปลายพระยา',
        value: 'ปลายพระยา',
        name: {
          th: 'ปลายพระยา',
          en: 'Plai Phraya',
        },
        districtId: 869,
      },
      {
        id: '810602',
        zipcode: 81160,
        text: 'เขาเขน',
        value: 'เขาเขน',
        name: {
          th: 'เขาเขน',
          en: 'Khao Khen',
        },
        districtId: 869,
      },
      {
        id: '810603',
        zipcode: 81160,
        text: 'เขาต่อ',
        value: 'เขาต่อ',
        name: {
          th: 'เขาต่อ',
          en: 'Khao To',
        },
        districtId: 869,
      },
      {
        id: '810604',
        zipcode: 81160,
        text: 'คีรีวง',
        value: 'คีรีวง',
        name: {
          th: 'คีรีวง',
          en: 'Khiri Wong',
        },
        districtId: 869,
      },
      {
        id: '810701',
        zipcode: 81120,
        text: 'ลำทับ',
        value: 'ลำทับ',
        name: {
          th: 'ลำทับ',
          en: 'Lam Thap',
        },
        districtId: 870,
      },
      {
        id: '810702',
        zipcode: 81120,
        text: 'ดินอุดม',
        value: 'ดินอุดม',
        name: {
          th: 'ดินอุดม',
          en: 'Din Udom',
        },
        districtId: 870,
      },
      {
        id: '810703',
        zipcode: 81120,
        text: 'ทุ่งไทรทอง',
        value: 'ทุ่งไทรทอง',
        name: {
          th: 'ทุ่งไทรทอง',
          en: 'Thung Sai Thong',
        },
        districtId: 870,
      },
      {
        id: '810704',
        zipcode: 81120,
        text: 'ดินแดง',
        value: 'ดินแดง',
        name: {
          th: 'ดินแดง',
          en: 'Din Daeng',
        },
        districtId: 870,
      },
      {
        id: '810801',
        zipcode: 81130,
        text: 'เหนือคลอง',
        value: 'เหนือคลอง',
        name: {
          th: 'เหนือคลอง',
          en: 'Nuea Khlong',
        },
        districtId: 871,
      },
      {
        id: '810802',
        zipcode: 81130,
        text: 'เกาะศรีบอยา',
        value: 'เกาะศรีบอยา',
        name: {
          th: 'เกาะศรีบอยา',
          en: 'Ko Si Boya',
        },
        districtId: 871,
      },
      {
        id: '810803',
        zipcode: 81130,
        text: 'คลองขนาน',
        value: 'คลองขนาน',
        name: {
          th: 'คลองขนาน',
          en: 'Khlong Khanan',
        },
        districtId: 871,
      },
      {
        id: '810804',
        zipcode: 81130,
        text: 'คลองเขม้า',
        value: 'คลองเขม้า',
        name: {
          th: 'คลองเขม้า',
          en: 'Khlong Khamao',
        },
        districtId: 871,
      },
      {
        id: '810805',
        zipcode: 81130,
        text: 'โคกยาง',
        value: 'โคกยาง',
        name: {
          th: 'โคกยาง',
          en: 'Khok Yang',
        },
        districtId: 871,
      },
      {
        id: '810806',
        zipcode: 81130,
        text: 'ตลิ่งชัน',
        value: 'ตลิ่งชัน',
        name: {
          th: 'ตลิ่งชัน',
          en: 'Taling Chan',
        },
        districtId: 871,
      },
      {
        id: '810807',
        zipcode: 81130,
        text: 'ปกาสัย',
        value: 'ปกาสัย',
        name: {
          th: 'ปกาสัย',
          en: 'Pakasai',
        },
        districtId: 871,
      },
      {
        id: '810808',
        zipcode: 81130,
        text: 'ห้วยยูง',
        value: 'ห้วยยูง',
        name: {
          th: 'ห้วยยูง',
          en: 'Huai Yung',
        },
        districtId: 871,
      },
      {
        id: '820101',
        zipcode: 82000,
        text: 'ท้ายช้าง',
        value: 'ท้ายช้าง',
        name: {
          th: 'ท้ายช้าง',
          en: 'Thai Chang',
        },
        districtId: 872,
      },
      {
        id: '820102',
        zipcode: 82000,
        text: 'นบปริง',
        value: 'นบปริง',
        name: {
          th: 'นบปริง',
          en: 'Nop Pring',
        },
        districtId: 872,
      },
      {
        id: '820103',
        zipcode: 82000,
        text: 'ถ้ำน้ำผุด',
        value: 'ถ้ำน้ำผุด',
        name: {
          th: 'ถ้ำน้ำผุด',
          en: 'Tham Nam Phut',
        },
        districtId: 872,
      },
      {
        id: '820104',
        zipcode: 82000,
        text: 'บางเตย',
        value: 'บางเตย',
        name: {
          th: 'บางเตย',
          en: 'Bang Toei',
        },
        districtId: 872,
      },
      {
        id: '820105',
        zipcode: 82000,
        text: 'ตากแดด',
        value: 'ตากแดด',
        name: {
          th: 'ตากแดด',
          en: 'Tak Daet',
        },
        districtId: 872,
      },
      {
        id: '820106',
        zipcode: 82000,
        text: 'สองแพรก',
        value: 'สองแพรก',
        name: {
          th: 'สองแพรก',
          en: 'Song Phraek',
        },
        districtId: 872,
      },
      {
        id: '820107',
        zipcode: 82000,
        text: 'ทุ่งคาโงก',
        value: 'ทุ่งคาโงก',
        name: {
          th: 'ทุ่งคาโงก',
          en: 'Thung Kha Ngok',
        },
        districtId: 872,
      },
      {
        id: '820108',
        zipcode: 82000,
        text: 'เกาะปันหยี',
        value: 'เกาะปันหยี',
        name: {
          th: 'เกาะปันหยี',
          en: 'Ko Panyi',
        },
        districtId: 872,
      },
      {
        id: '820109',
        zipcode: 82000,
        text: 'ป่ากอ',
        value: 'ป่ากอ',
        name: {
          th: 'ป่ากอ',
          en: 'Pa Ko',
        },
        districtId: 872,
      },
      {
        id: '820201',
        zipcode: 82160,
        text: 'เกาะยาวน้อย',
        value: 'เกาะยาวน้อย',
        name: {
          th: 'เกาะยาวน้อย',
          en: 'Ko Yao Noi',
        },
        districtId: 873,
      },
      {
        id: '820202',
        zipcode: 82160,
        text: 'เกาะยาวใหญ่',
        value: 'เกาะยาวใหญ่',
        name: {
          th: 'เกาะยาวใหญ่',
          en: 'Ko Yao Yai',
        },
        districtId: 873,
      },
      {
        id: '820203',
        zipcode: 83000,
        text: 'พรุใน',
        value: 'พรุใน',
        name: {
          th: 'พรุใน',
          en: 'Pru Nai',
        },
        districtId: 873,
      },
      {
        id: '820301',
        zipcode: 82170,
        text: 'กะปง',
        value: 'กะปง',
        name: {
          th: 'กะปง',
          en: 'Kapong',
        },
        districtId: 874,
      },
      {
        id: '820302',
        zipcode: 82170,
        text: 'ท่านา',
        value: 'ท่านา',
        name: {
          th: 'ท่านา',
          en: 'Tha Na',
        },
        districtId: 874,
      },
      {
        id: '820303',
        zipcode: 82170,
        text: 'เหมาะ',
        value: 'เหมาะ',
        name: {
          th: 'เหมาะ',
          en: 'Mo',
        },
        districtId: 874,
      },
      {
        id: '820304',
        zipcode: 82170,
        text: 'เหล',
        value: 'เหล',
        name: {
          th: 'เหล',
          en: 'Le',
        },
        districtId: 874,
      },
      {
        id: '820305',
        zipcode: 82170,
        text: 'รมณีย์',
        value: 'รมณีย์',
        name: {
          th: 'รมณีย์',
          en: 'Rommani',
        },
        districtId: 874,
      },
      {
        id: '820401',
        zipcode: 82130,
        text: 'ถ้ำ',
        value: 'ถ้ำ',
        name: {
          th: 'ถ้ำ',
          en: 'Tham',
        },
        districtId: 875,
      },
      {
        id: '820402',
        zipcode: 82130,
        text: 'กระโสม',
        value: 'กระโสม',
        name: {
          th: 'กระโสม',
          en: 'Krasom',
        },
        districtId: 875,
      },
      {
        id: '820403',
        zipcode: 82130,
        text: 'กะไหล',
        value: 'กะไหล',
        name: {
          th: 'กะไหล',
          en: 'Kalai',
        },
        districtId: 875,
      },
      {
        id: '820404',
        zipcode: 82130,
        text: 'ท่าอยู่',
        value: 'ท่าอยู่',
        name: {
          th: 'ท่าอยู่',
          en: 'Tha Yu',
        },
        districtId: 875,
      },
      {
        id: '820405',
        zipcode: 82140,
        text: 'หล่อยูง',
        value: 'หล่อยูง',
        name: {
          th: 'หล่อยูง',
          en: 'Lo Yung',
        },
        districtId: 875,
      },
      {
        id: '820406',
        zipcode: 82140,
        text: 'โคกกลอย',
        value: 'โคกกลอย',
        name: {
          th: 'โคกกลอย',
          en: 'Khok Kloi',
        },
        districtId: 875,
      },
      {
        id: '820407',
        zipcode: 82130,
        text: 'คลองเคียน',
        value: 'คลองเคียน',
        name: {
          th: 'คลองเคียน',
          en: 'Khlong Khian',
        },
        districtId: 875,
      },
      {
        id: '820501',
        zipcode: 82110,
        text: 'ตะกั่วป่า',
        value: 'ตะกั่วป่า',
        name: {
          th: 'ตะกั่วป่า',
          en: 'Takua Pa',
        },
        districtId: 876,
      },
      {
        id: '820502',
        zipcode: 82110,
        text: 'บางนายสี',
        value: 'บางนายสี',
        name: {
          th: 'บางนายสี',
          en: 'Bang Nai Si',
        },
        districtId: 876,
      },
      {
        id: '820503',
        zipcode: 82110,
        text: 'บางไทร',
        value: 'บางไทร',
        name: {
          th: 'บางไทร',
          en: 'Bang Sai',
        },
        districtId: 876,
      },
      {
        id: '820504',
        zipcode: 82110,
        text: 'บางม่วง',
        value: 'บางม่วง',
        name: {
          th: 'บางม่วง',
          en: 'Bang Muang',
        },
        districtId: 876,
      },
      {
        id: '820505',
        zipcode: 82110,
        text: 'ตำตัว',
        value: 'ตำตัว',
        name: {
          th: 'ตำตัว',
          en: 'Tam Tua',
        },
        districtId: 876,
      },
      {
        id: '820506',
        zipcode: 82110,
        text: 'โคกเคียน',
        value: 'โคกเคียน',
        name: {
          th: 'โคกเคียน',
          en: 'Khok Khian',
        },
        districtId: 876,
      },
      {
        id: '820507',
        zipcode: 82190,
        text: 'คึกคัก',
        value: 'คึกคัก',
        name: {
          th: 'คึกคัก',
          en: 'Khuekkhak',
        },
        districtId: 876,
      },
      {
        id: '820508',
        zipcode: 82190,
        text: 'เกาะคอเขา',
        value: 'เกาะคอเขา',
        name: {
          th: 'เกาะคอเขา',
          en: 'Ko Kho Khao',
        },
        districtId: 876,
      },
      {
        id: '820601',
        zipcode: 82150,
        text: 'คุระ',
        value: 'คุระ',
        name: {
          th: 'คุระ',
          en: 'Khura',
        },
        districtId: 877,
      },
      {
        id: '820602',
        zipcode: 82150,
        text: 'บางวัน',
        value: 'บางวัน',
        name: {
          th: 'บางวัน',
          en: 'Bang Wan',
        },
        districtId: 877,
      },
      {
        id: '820603',
        zipcode: 82150,
        text: 'เกาะพระทอง',
        value: 'เกาะพระทอง',
        name: {
          th: 'เกาะพระทอง',
          en: 'Ko Phra Thong',
        },
        districtId: 877,
      },
      {
        id: '820605',
        zipcode: 82150,
        text: 'แม่นางขาว',
        value: 'แม่นางขาว',
        name: {
          th: 'แม่นางขาว',
          en: 'Mae Nang Khao',
        },
        districtId: 877,
      },
      {
        id: '820701',
        zipcode: 82180,
        text: 'ทับปุด',
        value: 'ทับปุด',
        name: {
          th: 'ทับปุด',
          en: 'Thap Put',
        },
        districtId: 878,
      },
      {
        id: '820702',
        zipcode: 82180,
        text: 'มะรุ่ย',
        value: 'มะรุ่ย',
        name: {
          th: 'มะรุ่ย',
          en: 'Marui',
        },
        districtId: 878,
      },
      {
        id: '820703',
        zipcode: 82180,
        text: 'บ่อแสน',
        value: 'บ่อแสน',
        name: {
          th: 'บ่อแสน',
          en: 'Bo Saen',
        },
        districtId: 878,
      },
      {
        id: '820704',
        zipcode: 82180,
        text: 'ถ้ำทองหลาง',
        value: 'ถ้ำทองหลาง',
        name: {
          th: 'ถ้ำทองหลาง',
          en: 'Tham Thonglang',
        },
        districtId: 878,
      },
      {
        id: '820705',
        zipcode: 82180,
        text: 'โคกเจริญ',
        value: 'โคกเจริญ',
        name: {
          th: 'โคกเจริญ',
          en: 'Khok Charoen',
        },
        districtId: 878,
      },
      {
        id: '820706',
        zipcode: 82180,
        text: 'บางเหรียง',
        value: 'บางเหรียง',
        name: {
          th: 'บางเหรียง',
          en: 'Bang Riang',
        },
        districtId: 878,
      },
      {
        id: '820801',
        zipcode: 82120,
        text: 'ท้ายเหมือง',
        value: 'ท้ายเหมือง',
        name: {
          th: 'ท้ายเหมือง',
          en: 'Thai Mueang',
        },
        districtId: 879,
      },
      {
        id: '820802',
        zipcode: 82120,
        text: 'นาเตย',
        value: 'นาเตย',
        name: {
          th: 'นาเตย',
          en: 'Na Toei',
        },
        districtId: 879,
      },
      {
        id: '820803',
        zipcode: 82120,
        text: 'บางทอง',
        value: 'บางทอง',
        name: {
          th: 'บางทอง',
          en: 'Bang Thong',
        },
        districtId: 879,
      },
      {
        id: '820804',
        zipcode: 82120,
        text: 'ทุ่งมะพร้าว',
        value: 'ทุ่งมะพร้าว',
        name: {
          th: 'ทุ่งมะพร้าว',
          en: 'Thung Maphrao',
        },
        districtId: 879,
      },
      {
        id: '820805',
        zipcode: 82120,
        text: 'ลำภี',
        value: 'ลำภี',
        name: {
          th: 'ลำภี',
          en: 'Lam Phi',
        },
        districtId: 879,
      },
      {
        id: '820806',
        zipcode: 82120,
        text: 'ลำแก่น',
        value: 'ลำแก่น',
        name: {
          th: 'ลำแก่น',
          en: 'Lam Kaen',
        },
        districtId: 879,
      },
      {
        id: '830101',
        zipcode: 83000,
        text: 'ตลาดใหญ่',
        value: 'ตลาดใหญ่',
        name: {
          th: 'ตลาดใหญ่',
          en: 'Talat Yai',
        },
        districtId: 880,
      },
      {
        id: '830102',
        zipcode: 83000,
        text: 'ตลาดเหนือ',
        value: 'ตลาดเหนือ',
        name: {
          th: 'ตลาดเหนือ',
          en: 'Talat Nuea',
        },
        districtId: 880,
      },
      {
        id: '830103',
        zipcode: 83000,
        text: 'เกาะแก้ว',
        value: 'เกาะแก้ว',
        name: {
          th: 'เกาะแก้ว',
          en: 'Ko Kaeo',
        },
        districtId: 880,
      },
      {
        id: '830104',
        zipcode: 83000,
        text: 'รัษฎา',
        value: 'รัษฎา',
        name: {
          th: 'รัษฎา',
          en: 'Ratsada',
        },
        districtId: 880,
      },
      {
        id: '830105',
        zipcode: 83000,
        text: 'วิชิต',
        value: 'วิชิต',
        name: {
          th: 'วิชิต',
          en: 'Wichit',
        },
        districtId: 880,
      },
      {
        id: '830106',
        zipcode: 83130,
        text: 'ฉลอง',
        value: 'ฉลอง',
        name: {
          th: 'ฉลอง',
          en: 'Chalong',
        },
        districtId: 880,
      },
      {
        id: '830107',
        zipcode: 83130,
        text: 'ราไวย์',
        value: 'ราไวย์',
        name: {
          th: 'ราไวย์',
          en: 'Rawai',
        },
        districtId: 880,
      },
      {
        id: '830108',
        zipcode: 83100,
        text: 'กะรน',
        value: 'กะรน',
        name: {
          th: 'กะรน',
          en: 'Karon',
        },
        districtId: 880,
      },
      {
        id: '830201',
        zipcode: 83120,
        text: 'กะทู้',
        value: 'กะทู้',
        name: {
          th: 'กะทู้',
          en: 'Kathu',
        },
        districtId: 881,
      },
      {
        id: '830202',
        zipcode: 83150,
        text: 'ป่าตอง',
        value: 'ป่าตอง',
        name: {
          th: 'ป่าตอง',
          en: 'Pa Tong',
        },
        districtId: 881,
      },
      {
        id: '830203',
        zipcode: 83150,
        text: 'กมลา',
        value: 'กมลา',
        name: {
          th: 'กมลา',
          en: 'Kamala',
        },
        districtId: 881,
      },
      {
        id: '830301',
        zipcode: 83110,
        text: 'เทพกระษัตรี',
        value: 'เทพกระษัตรี',
        name: {
          th: 'เทพกระษัตรี',
          en: 'Thep Krasattri',
        },
        districtId: 882,
      },
      {
        id: '830302',
        zipcode: 83110,
        text: 'ศรีสุนทร',
        value: 'ศรีสุนทร',
        name: {
          th: 'ศรีสุนทร',
          en: 'Si Sunthon',
        },
        districtId: 882,
      },
      {
        id: '830303',
        zipcode: 83110,
        text: 'เชิงทะเล',
        value: 'เชิงทะเล',
        name: {
          th: 'เชิงทะเล',
          en: 'Choeng Thale',
        },
        districtId: 882,
      },
      {
        id: '830304',
        zipcode: 83110,
        text: 'ป่าคลอก',
        value: 'ป่าคลอก',
        name: {
          th: 'ป่าคลอก',
          en: 'Pa Khlok',
        },
        districtId: 882,
      },
      {
        id: '830305',
        zipcode: 83110,
        text: 'ไม้ขาว',
        value: 'ไม้ขาว',
        name: {
          th: 'ไม้ขาว',
          en: 'Mai Khao',
        },
        districtId: 882,
      },
      {
        id: '830306',
        zipcode: 83110,
        text: 'สาคู',
        value: 'สาคู',
        name: {
          th: 'สาคู',
          en: 'Sakhu',
        },
        districtId: 882,
      },
      {
        id: '840101',
        zipcode: 84000,
        text: 'ตลาด',
        value: 'ตลาด',
        name: {
          th: 'ตลาด',
          en: 'Talat',
        },
        districtId: 884,
      },
      {
        id: '840102',
        zipcode: 84000,
        text: 'มะขามเตี้ย',
        value: 'มะขามเตี้ย',
        name: {
          th: 'มะขามเตี้ย',
          en: 'Makham Tia',
        },
        districtId: 884,
      },
      {
        id: '840103',
        zipcode: 84000,
        text: 'วัดประดู่',
        value: 'วัดประดู่',
        name: {
          th: 'วัดประดู่',
          en: 'Wat Pradu',
        },
        districtId: 884,
      },
      {
        id: '840104',
        zipcode: 84100,
        text: 'ขุนทะเล',
        value: 'ขุนทะเล',
        name: {
          th: 'ขุนทะเล',
          en: 'Khun Thale',
        },
        districtId: 884,
      },
      {
        id: '840105',
        zipcode: 84000,
        text: 'บางใบไม้',
        value: 'บางใบไม้',
        name: {
          th: 'บางใบไม้',
          en: 'Bang Bai Mai',
        },
        districtId: 884,
      },
      {
        id: '840106',
        zipcode: 84000,
        text: 'บางชนะ',
        value: 'บางชนะ',
        name: {
          th: 'บางชนะ',
          en: 'Bang Chana',
        },
        districtId: 884,
      },
      {
        id: '840107',
        zipcode: 84000,
        text: 'คลองน้อย',
        value: 'คลองน้อย',
        name: {
          th: 'คลองน้อย',
          en: 'Khlong Noi',
        },
        districtId: 884,
      },
      {
        id: '840108',
        zipcode: 84000,
        text: 'บางไทร',
        value: 'บางไทร',
        name: {
          th: 'บางไทร',
          en: 'Bang Sai',
        },
        districtId: 884,
      },
      {
        id: '840109',
        zipcode: 84000,
        text: 'บางโพธิ์',
        value: 'บางโพธิ์',
        name: {
          th: 'บางโพธิ์',
          en: 'Bang Pho',
        },
        districtId: 884,
      },
      {
        id: '840110',
        zipcode: 84000,
        text: 'บางกุ้ง',
        value: 'บางกุ้ง',
        name: {
          th: 'บางกุ้ง',
          en: 'Bang Kung',
        },
        districtId: 884,
      },
      {
        id: '840111',
        zipcode: 84000,
        text: 'คลองฉนาก',
        value: 'คลองฉนาก',
        name: {
          th: 'คลองฉนาก',
          en: 'Khlong Chanak',
        },
        districtId: 884,
      },
      {
        id: '840201',
        zipcode: 84290,
        text: 'ท่าทองใหม่',
        value: 'ท่าทองใหม่',
        name: {
          th: 'ท่าทองใหม่',
          en: 'Tha Thong',
        },
        districtId: 885,
      },
      {
        id: '840202',
        zipcode: 84160,
        text: 'ท่าทอง',
        value: 'ท่าทอง',
        name: {
          th: 'ท่าทอง',
          en: 'Tha Thong Mai',
        },
        districtId: 885,
      },
      {
        id: '840203',
        zipcode: 84160,
        text: 'กะแดะ',
        value: 'กะแดะ',
        name: {
          th: 'กะแดะ',
          en: 'Kadae',
        },
        districtId: 885,
      },
      {
        id: '840204',
        zipcode: 84290,
        text: 'ทุ่งกง',
        value: 'ทุ่งกง',
        name: {
          th: 'ทุ่งกง',
          en: 'Thung Kong',
        },
        districtId: 885,
      },
      {
        id: '840205',
        zipcode: 84160,
        text: 'กรูด',
        value: 'กรูด',
        name: {
          th: 'กรูด',
          en: 'Krut',
        },
        districtId: 885,
      },
      {
        id: '840206',
        zipcode: 84160,
        text: 'ช้างซ้าย',
        value: 'ช้างซ้าย',
        name: {
          th: 'ช้างซ้าย',
          en: 'Chang Sai',
        },
        districtId: 885,
      },
      {
        id: '840207',
        zipcode: 84160,
        text: 'พลายวาส',
        value: 'พลายวาส',
        name: {
          th: 'พลายวาส',
          en: 'Phlai Wat',
        },
        districtId: 885,
      },
      {
        id: '840208',
        zipcode: 84160,
        text: 'ป่าร่อน',
        value: 'ป่าร่อน',
        name: {
          th: 'ป่าร่อน',
          en: 'Pa Ron',
        },
        districtId: 885,
      },
      {
        id: '840209',
        zipcode: 84160,
        text: 'ตะเคียนทอง',
        value: 'ตะเคียนทอง',
        name: {
          th: 'ตะเคียนทอง',
          en: 'Takhian Thong',
        },
        districtId: 885,
      },
      {
        id: '840210',
        zipcode: 84160,
        text: 'ช้างขวา',
        value: 'ช้างขวา',
        name: {
          th: 'ช้างขวา',
          en: 'Chang Khwa',
        },
        districtId: 885,
      },
      {
        id: '840211',
        zipcode: 84160,
        text: 'ท่าอุแท',
        value: 'ท่าอุแท',
        name: {
          th: 'ท่าอุแท',
          en: 'Tha Uthae',
        },
        districtId: 885,
      },
      {
        id: '840212',
        zipcode: 84290,
        text: 'ทุ่งรัง',
        value: 'ทุ่งรัง',
        name: {
          th: 'ทุ่งรัง',
          en: 'Thung Rung',
        },
        districtId: 885,
      },
      {
        id: '840213',
        zipcode: 84160,
        text: 'คลองสระ',
        value: 'คลองสระ',
        name: {
          th: 'คลองสระ',
          en: 'Khlong Sa',
        },
        districtId: 885,
      },
      {
        id: '840301',
        zipcode: 84220,
        text: 'ดอนสัก',
        value: 'ดอนสัก',
        name: {
          th: 'ดอนสัก',
          en: 'Don Sak',
        },
        districtId: 886,
      },
      {
        id: '840302',
        zipcode: 84160,
        text: 'ชลคราม',
        value: 'ชลคราม',
        name: {
          th: 'ชลคราม',
          en: 'Chonlakhram',
        },
        districtId: 886,
      },
      {
        id: '840303',
        zipcode: 84220,
        text: 'ไชยคราม',
        value: 'ไชยคราม',
        name: {
          th: 'ไชยคราม',
          en: 'Chaiyakhram',
        },
        districtId: 886,
      },
      {
        id: '840304',
        zipcode: 84340,
        text: 'ปากแพรก',
        value: 'ปากแพรก',
        name: {
          th: 'ปากแพรก',
          en: 'Pak Phraek',
        },
        districtId: 886,
      },
      {
        id: '840401',
        zipcode: 84140,
        text: 'อ่างทอง',
        value: 'อ่างทอง',
        name: {
          th: 'อ่างทอง',
          en: 'Ang Thong',
        },
        districtId: 887,
      },
      {
        id: '840402',
        zipcode: 84140,
        text: 'ลิปะน้อย',
        value: 'ลิปะน้อย',
        name: {
          th: 'ลิปะน้อย',
          en: 'Lipa Noi',
        },
        districtId: 887,
      },
      {
        id: '840403',
        zipcode: 84140,
        text: 'ตลิ่งงาม',
        value: 'ตลิ่งงาม',
        name: {
          th: 'ตลิ่งงาม',
          en: 'Taling Ngam',
        },
        districtId: 887,
      },
      {
        id: '840404',
        zipcode: 84140,
        text: 'หน้าเมือง',
        value: 'หน้าเมือง',
        name: {
          th: 'หน้าเมือง',
          en: 'Na Mueang',
        },
        districtId: 887,
      },
      {
        id: '840405',
        zipcode: 84310,
        text: 'มะเร็ต',
        value: 'มะเร็ต',
        name: {
          th: 'มะเร็ต',
          en: 'Maret',
        },
        districtId: 887,
      },
      {
        id: '840406',
        zipcode: 84320,
        text: 'บ่อผุด',
        value: 'บ่อผุด',
        name: {
          th: 'บ่อผุด',
          en: 'Bo Phut',
        },
        districtId: 887,
      },
      {
        id: '840407',
        zipcode: 84330,
        text: 'แม่น้ำ',
        value: 'แม่น้ำ',
        name: {
          th: 'แม่น้ำ',
          en: 'Mae Nam',
        },
        districtId: 887,
      },
      {
        id: '840501',
        zipcode: 84280,
        text: 'เกาะพะงัน',
        value: 'เกาะพะงัน',
        name: {
          th: 'เกาะพะงัน',
          en: 'Ko Pha-ngan',
        },
        districtId: 888,
      },
      {
        id: '840502',
        zipcode: 84280,
        text: 'บ้านใต้',
        value: 'บ้านใต้',
        name: {
          th: 'บ้านใต้',
          en: 'Ban Tai',
        },
        districtId: 888,
      },
      {
        id: '840503',
        zipcode: 84280,
        text: 'เกาะเต่า',
        value: 'เกาะเต่า',
        name: {
          th: 'เกาะเต่า',
          en: 'Koh Tao',
        },
        districtId: 888,
      },
      {
        id: '840601',
        zipcode: 84110,
        text: 'ตลาดไชยา',
        value: 'ตลาดไชยา',
        name: {
          th: 'ตลาดไชยา',
          en: 'Talat Chaiya',
        },
        districtId: 889,
      },
      {
        id: '840602',
        zipcode: 84110,
        text: 'พุมเรียง',
        value: 'พุมเรียง',
        name: {
          th: 'พุมเรียง',
          en: 'Phumriang',
        },
        districtId: 889,
      },
      {
        id: '840603',
        zipcode: 84110,
        text: 'เลม็ด',
        value: 'เลม็ด',
        name: {
          th: 'เลม็ด',
          en: 'Lamet',
        },
        districtId: 889,
      },
      {
        id: '840604',
        zipcode: 84110,
        text: 'เวียง',
        value: 'เวียง',
        name: {
          th: 'เวียง',
          en: 'Wiang',
        },
        districtId: 889,
      },
      {
        id: '840605',
        zipcode: 84110,
        text: 'ทุ่ง',
        value: 'ทุ่ง',
        name: {
          th: 'ทุ่ง',
          en: 'Thung',
        },
        districtId: 889,
      },
      {
        id: '840606',
        zipcode: 84110,
        text: 'ป่าเว',
        value: 'ป่าเว',
        name: {
          th: 'ป่าเว',
          en: 'Pa We',
        },
        districtId: 889,
      },
      {
        id: '840607',
        zipcode: 84110,
        text: 'ตะกรบ',
        value: 'ตะกรบ',
        name: {
          th: 'ตะกรบ',
          en: 'Takrop',
        },
        districtId: 889,
      },
      {
        id: '840608',
        zipcode: 84110,
        text: 'โมถ่าย',
        value: 'โมถ่าย',
        name: {
          th: 'โมถ่าย',
          en: 'Mo Thai',
        },
        districtId: 889,
      },
      {
        id: '840609',
        zipcode: 84110,
        text: 'ปากหมาก',
        value: 'ปากหมาก',
        name: {
          th: 'ปากหมาก',
          en: 'Pak Mak',
        },
        districtId: 889,
      },
      {
        id: '840701',
        zipcode: 84170,
        text: 'ท่าชนะ',
        value: 'ท่าชนะ',
        name: {
          th: 'ท่าชนะ',
          en: 'Tha Chana',
        },
        districtId: 890,
      },
      {
        id: '840702',
        zipcode: 84170,
        text: 'สมอทอง',
        value: 'สมอทอง',
        name: {
          th: 'สมอทอง',
          en: 'Samo Thong',
        },
        districtId: 890,
      },
      {
        id: '840703',
        zipcode: 84170,
        text: 'ประสงค์',
        value: 'ประสงค์',
        name: {
          th: 'ประสงค์',
          en: 'Prasong',
        },
        districtId: 890,
      },
      {
        id: '840704',
        zipcode: 84170,
        text: 'คันธุลี',
        value: 'คันธุลี',
        name: {
          th: 'คันธุลี',
          en: 'Khan Thuli',
        },
        districtId: 890,
      },
      {
        id: '840705',
        zipcode: 84170,
        text: 'วัง',
        value: 'วัง',
        name: {
          th: 'วัง',
          en: 'Wang',
        },
        districtId: 890,
      },
      {
        id: '840706',
        zipcode: 84170,
        text: 'คลองพา',
        value: 'คลองพา',
        name: {
          th: 'คลองพา',
          en: 'Khlong Pha',
        },
        districtId: 890,
      },
      {
        id: '840801',
        zipcode: 84180,
        text: 'ท่าขนอน',
        value: 'ท่าขนอน',
        name: {
          th: 'ท่าขนอน',
          en: 'Tha Khanon',
        },
        districtId: 891,
      },
      {
        id: '840802',
        zipcode: 84180,
        text: 'บ้านยาง',
        value: 'บ้านยาง',
        name: {
          th: 'บ้านยาง',
          en: 'Ban Yang',
        },
        districtId: 891,
      },
      {
        id: '840803',
        zipcode: 84180,
        text: 'น้ำหัก',
        value: 'น้ำหัก',
        name: {
          th: 'น้ำหัก',
          en: 'Nam Hak',
        },
        districtId: 891,
      },
      {
        id: '840806',
        zipcode: 84180,
        text: 'กะเปา',
        value: 'กะเปา',
        name: {
          th: 'กะเปา',
          en: 'Kapao',
        },
        districtId: 891,
      },
      {
        id: '840807',
        zipcode: 84180,
        text: 'ท่ากระดาน',
        value: 'ท่ากระดาน',
        name: {
          th: 'ท่ากระดาน',
          en: 'Tha Kradan',
        },
        districtId: 891,
      },
      {
        id: '840808',
        zipcode: 84180,
        text: 'ย่านยาว',
        value: 'ย่านยาว',
        name: {
          th: 'ย่านยาว',
          en: 'Yan Yao',
        },
        districtId: 891,
      },
      {
        id: '840809',
        zipcode: 84180,
        text: 'ถ้ำสิงขร',
        value: 'ถ้ำสิงขร',
        name: {
          th: 'ถ้ำสิงขร',
          en: 'Tham Singkhon',
        },
        districtId: 891,
      },
      {
        id: '840810',
        zipcode: 84180,
        text: 'บ้านทำเนียบ',
        value: 'บ้านทำเนียบ',
        name: {
          th: 'บ้านทำเนียบ',
          en: 'Ban Thamniap',
        },
        districtId: 891,
      },
      {
        id: '840901',
        zipcode: 84230,
        text: 'เขาวง',
        value: 'เขาวง',
        name: {
          th: 'เขาวง',
          en: 'Khao Wong',
        },
        districtId: 892,
      },
      {
        id: '840902',
        zipcode: 84230,
        text: 'พระแสง',
        value: 'พระแสง',
        name: {
          th: 'พระแสง',
          en: 'Phasaeng',
        },
        districtId: 892,
      },
      {
        id: '840903',
        zipcode: 84230,
        text: 'พรุไทย',
        value: 'พรุไทย',
        name: {
          th: 'พรุไทย',
          en: 'Phru Thai',
        },
        districtId: 892,
      },
      {
        id: '840904',
        zipcode: 84230,
        text: 'เขาพัง',
        value: 'เขาพัง',
        name: {
          th: 'เขาพัง',
          en: 'Khao Phang',
        },
        districtId: 892,
      },
      {
        id: '841001',
        zipcode: 84250,
        text: 'พนม',
        value: 'พนม',
        name: {
          th: 'พนม',
          en: 'Phanom',
        },
        districtId: 893,
      },
      {
        id: '841002',
        zipcode: 84250,
        text: 'ต้นยวน',
        value: 'ต้นยวน',
        name: {
          th: 'ต้นยวน',
          en: 'Ton Yuan',
        },
        districtId: 893,
      },
      {
        id: '841003',
        zipcode: 84250,
        text: 'คลองศก',
        value: 'คลองศก',
        name: {
          th: 'คลองศก',
          en: 'Khlong Sok',
        },
        districtId: 893,
      },
      {
        id: '841004',
        zipcode: 84250,
        text: 'พลูเถื่อน',
        value: 'พลูเถื่อน',
        name: {
          th: 'พลูเถื่อน',
          en: 'Phlu Thuean',
        },
        districtId: 893,
      },
      {
        id: '841005',
        zipcode: 84250,
        text: 'พังกาญจน์',
        value: 'พังกาญจน์',
        name: {
          th: 'พังกาญจน์',
          en: 'Phang Kan',
        },
        districtId: 893,
      },
      {
        id: '841006',
        zipcode: 84250,
        text: 'คลองชะอุ่น',
        value: 'คลองชะอุ่น',
        name: {
          th: 'คลองชะอุ่น',
          en: 'Khlong Cha-un',
        },
        districtId: 893,
      },
      {
        id: '841101',
        zipcode: 84150,
        text: 'ท่าฉาง',
        value: 'ท่าฉาง',
        name: {
          th: 'ท่าฉาง',
          en: 'Tha Chang',
        },
        districtId: 894,
      },
      {
        id: '841102',
        zipcode: 84150,
        text: 'ท่าเคย',
        value: 'ท่าเคย',
        name: {
          th: 'ท่าเคย',
          en: 'Tha Khoei',
        },
        districtId: 894,
      },
      {
        id: '841103',
        zipcode: 84150,
        text: 'คลองไทร',
        value: 'คลองไทร',
        name: {
          th: 'คลองไทร',
          en: 'Khlong Sai',
        },
        districtId: 894,
      },
      {
        id: '841104',
        zipcode: 84150,
        text: 'เขาถ่าน',
        value: 'เขาถ่าน',
        name: {
          th: 'เขาถ่าน',
          en: 'Khao Than',
        },
        districtId: 894,
      },
      {
        id: '841105',
        zipcode: 84150,
        text: 'เสวียด',
        value: 'เสวียด',
        name: {
          th: 'เสวียด',
          en: 'Sawiat',
        },
        districtId: 894,
      },
      {
        id: '841106',
        zipcode: 84150,
        text: 'ปากฉลุย',
        value: 'ปากฉลุย',
        name: {
          th: 'ปากฉลุย',
          en: 'Pak Chalui',
        },
        districtId: 894,
      },
      {
        id: '841201',
        zipcode: 84120,
        text: 'นาสาร',
        value: 'นาสาร',
        name: {
          th: 'นาสาร',
          en: 'Na San',
        },
        districtId: 895,
      },
      {
        id: '841202',
        zipcode: 84270,
        text: 'พรุพี',
        value: 'พรุพี',
        name: {
          th: 'พรุพี',
          en: 'Phru Phi',
        },
        districtId: 895,
      },
      {
        id: '841203',
        zipcode: 84120,
        text: 'ทุ่งเตา',
        value: 'ทุ่งเตา',
        name: {
          th: 'ทุ่งเตา',
          en: 'Thung Tao',
        },
        districtId: 895,
      },
      {
        id: '841204',
        zipcode: 84120,
        text: 'ลำพูน',
        value: 'ลำพูน',
        name: {
          th: 'ลำพูน',
          en: 'Lamphun',
        },
        districtId: 895,
      },
      {
        id: '841205',
        zipcode: 84120,
        text: 'ท่าชี',
        value: 'ท่าชี',
        name: {
          th: 'ท่าชี',
          en: 'Tha Chi',
        },
        districtId: 895,
      },
      {
        id: '841206',
        zipcode: 84270,
        text: 'ควนศรี',
        value: 'ควนศรี',
        name: {
          th: 'ควนศรี',
          en: 'Khuan Si',
        },
        districtId: 895,
      },
      {
        id: '841207',
        zipcode: 84120,
        text: 'ควนสุบรรณ',
        value: 'ควนสุบรรณ',
        name: {
          th: 'ควนสุบรรณ',
          en: 'Khuan Suban',
        },
        districtId: 895,
      },
      {
        id: '841208',
        zipcode: 84120,
        text: 'คลองปราบ',
        value: 'คลองปราบ',
        name: {
          th: 'คลองปราบ',
          en: 'Khlong Prap',
        },
        districtId: 895,
      },
      {
        id: '841209',
        zipcode: 84120,
        text: 'น้ำพุ',
        value: 'น้ำพุ',
        name: {
          th: 'น้ำพุ',
          en: 'Nam Phu',
        },
        districtId: 895,
      },
      {
        id: '841210',
        zipcode: 84120,
        text: 'ทุ่งเตาใหม่',
        value: 'ทุ่งเตาใหม่',
        name: {
          th: 'ทุ่งเตาใหม่',
          en: 'Thung Tao Mai)',
        },
        districtId: 895,
      },
      {
        id: '841211',
        zipcode: 84120,
        text: 'เพิ่มพูนทรัพย์',
        value: 'เพิ่มพูนทรัพย์',
        name: {
          th: 'เพิ่มพูนทรัพย์',
          en: 'Phoem Phun Sap',
        },
        districtId: 895,
      },
      {
        id: '841301',
        zipcode: 84240,
        text: 'บ้านนา',
        value: 'บ้านนา',
        name: {
          th: 'บ้านนา',
          en: 'Ban Na',
        },
        districtId: 896,
      },
      {
        id: '841302',
        zipcode: 84240,
        text: 'ท่าเรือ',
        value: 'ท่าเรือ',
        name: {
          th: 'ท่าเรือ',
          en: 'Tha Ruea',
        },
        districtId: 896,
      },
      {
        id: '841303',
        zipcode: 84240,
        text: 'ทรัพย์ทวี',
        value: 'ทรัพย์ทวี',
        name: {
          th: 'ทรัพย์ทวี',
          en: 'Sap Thawi',
        },
        districtId: 896,
      },
      {
        id: '841304',
        zipcode: 84240,
        text: 'นาใต้',
        value: 'นาใต้',
        name: {
          th: 'นาใต้',
          en: 'Na Tai',
        },
        districtId: 896,
      },
      {
        id: '841401',
        zipcode: 84260,
        text: 'เคียนซา',
        value: 'เคียนซา',
        name: {
          th: 'เคียนซา',
          en: 'Khian Sa',
        },
        districtId: 897,
      },
      {
        id: '841402',
        zipcode: 84210,
        text: 'พ่วงพรมคร',
        value: 'พ่วงพรมคร',
        name: {
          th: 'พ่วงพรมคร',
          en: 'Phuang Phromkhon',
        },
        districtId: 897,
      },
      {
        id: '841403',
        zipcode: 84260,
        text: 'เขาตอก',
        value: 'เขาตอก',
        name: {
          th: 'เขาตอก',
          en: 'Khao Tok',
        },
        districtId: 897,
      },
      {
        id: '841404',
        zipcode: 84260,
        text: 'อรัญคามวารี',
        value: 'อรัญคามวารี',
        name: {
          th: 'อรัญคามวารี',
          en: 'Aranyakham Wari',
        },
        districtId: 897,
      },
      {
        id: '841405',
        zipcode: 84260,
        text: 'บ้านเสด็จ',
        value: 'บ้านเสด็จ',
        name: {
          th: 'บ้านเสด็จ',
          en: 'Ban Sadet',
        },
        districtId: 897,
      },
      {
        id: '841501',
        zipcode: 84190,
        text: 'เวียงสระ',
        value: 'เวียงสระ',
        name: {
          th: 'เวียงสระ',
          en: 'Wiang Sa',
        },
        districtId: 898,
      },
      {
        id: '841502',
        zipcode: 84190,
        text: 'บ้านส้อง',
        value: 'บ้านส้อง',
        name: {
          th: 'บ้านส้อง',
          en: 'Ban Song',
        },
        districtId: 898,
      },
      {
        id: '841503',
        zipcode: 84190,
        text: 'คลองฉนวน',
        value: 'คลองฉนวน',
        name: {
          th: 'คลองฉนวน',
          en: 'Khlong Chanuan',
        },
        districtId: 898,
      },
      {
        id: '841504',
        zipcode: 84190,
        text: 'ทุ่งหลวง',
        value: 'ทุ่งหลวง',
        name: {
          th: 'ทุ่งหลวง',
          en: 'Thung Luang',
        },
        districtId: 898,
      },
      {
        id: '841505',
        zipcode: 84190,
        text: 'เขานิพันธ์',
        value: 'เขานิพันธ์',
        name: {
          th: 'เขานิพันธ์',
          en: '*Khao Niphan',
        },
        districtId: 898,
      },
      {
        id: '841601',
        zipcode: 84210,
        text: 'อิปัน',
        value: 'อิปัน',
        name: {
          th: 'อิปัน',
          en: 'Ipan',
        },
        districtId: 899,
      },
      {
        id: '841602',
        zipcode: 84210,
        text: 'สินปุน',
        value: 'สินปุน',
        name: {
          th: 'สินปุน',
          en: 'Sin Pun',
        },
        districtId: 899,
      },
      {
        id: '841603',
        zipcode: 84210,
        text: 'บางสวรรค์',
        value: 'บางสวรรค์',
        name: {
          th: 'บางสวรรค์',
          en: 'Bang Sawan',
        },
        districtId: 899,
      },
      {
        id: '841604',
        zipcode: 84210,
        text: 'ไทรขึง',
        value: 'ไทรขึง',
        name: {
          th: 'ไทรขึง',
          en: 'Sai Khueng',
        },
        districtId: 899,
      },
      {
        id: '841605',
        zipcode: 84210,
        text: 'สินเจริญ',
        value: 'สินเจริญ',
        name: {
          th: 'สินเจริญ',
          en: 'Sin Charoen',
        },
        districtId: 899,
      },
      {
        id: '841606',
        zipcode: 84210,
        text: 'ไทรโสภา',
        value: 'ไทรโสภา',
        name: {
          th: 'ไทรโสภา',
          en: 'Sai Sopha',
        },
        districtId: 899,
      },
      {
        id: '841607',
        zipcode: 84210,
        text: 'สาคู',
        value: 'สาคู',
        name: {
          th: 'สาคู',
          en: 'Sakhu',
        },
        districtId: 899,
      },
      {
        id: '841701',
        zipcode: 84130,
        text: 'ท่าข้าม',
        value: 'ท่าข้าม',
        name: {
          th: 'ท่าข้าม',
          en: 'Tha Kham',
        },
        districtId: 900,
      },
      {
        id: '841702',
        zipcode: 84130,
        text: 'ท่าสะท้อน',
        value: 'ท่าสะท้อน',
        name: {
          th: 'ท่าสะท้อน',
          en: 'Tha Sathon',
        },
        districtId: 900,
      },
      {
        id: '841703',
        zipcode: 84130,
        text: 'ลีเล็ด',
        value: 'ลีเล็ด',
        name: {
          th: 'ลีเล็ด',
          en: 'Lilet',
        },
        districtId: 900,
      },
      {
        id: '841704',
        zipcode: 84130,
        text: 'บางมะเดื่อ',
        value: 'บางมะเดื่อ',
        name: {
          th: 'บางมะเดื่อ',
          en: 'Bang Maduea',
        },
        districtId: 900,
      },
      {
        id: '841705',
        zipcode: 84130,
        text: 'บางเดือน',
        value: 'บางเดือน',
        name: {
          th: 'บางเดือน',
          en: 'Bang Duean)',
        },
        districtId: 900,
      },
      {
        id: '841706',
        zipcode: 84130,
        text: 'ท่าโรงช้าง',
        value: 'ท่าโรงช้าง',
        name: {
          th: 'ท่าโรงช้าง',
          en: 'Tha Rong Chang',
        },
        districtId: 900,
      },
      {
        id: '841707',
        zipcode: 84130,
        text: 'กรูด',
        value: 'กรูด',
        name: {
          th: 'กรูด',
          en: 'Krut',
        },
        districtId: 900,
      },
      {
        id: '841708',
        zipcode: 84130,
        text: 'พุนพิน',
        value: 'พุนพิน',
        name: {
          th: 'พุนพิน',
          en: 'Phunphin',
        },
        districtId: 900,
      },
      {
        id: '841709',
        zipcode: 84130,
        text: 'บางงอน',
        value: 'บางงอน',
        name: {
          th: 'บางงอน',
          en: 'Bang Ngon',
        },
        districtId: 900,
      },
      {
        id: '841710',
        zipcode: 84130,
        text: 'ศรีวิชัย',
        value: 'ศรีวิชัย',
        name: {
          th: 'ศรีวิชัย',
          en: 'Si Wichai',
        },
        districtId: 900,
      },
      {
        id: '841711',
        zipcode: 84130,
        text: 'น้ำรอบ',
        value: 'น้ำรอบ',
        name: {
          th: 'น้ำรอบ',
          en: 'Nam Rop',
        },
        districtId: 900,
      },
      {
        id: '841712',
        zipcode: 84130,
        text: 'มะลวน',
        value: 'มะลวน',
        name: {
          th: 'มะลวน',
          en: 'Maluan',
        },
        districtId: 900,
      },
      {
        id: '841713',
        zipcode: 84130,
        text: 'หัวเตย',
        value: 'หัวเตย',
        name: {
          th: 'หัวเตย',
          en: 'Hua Toei',
        },
        districtId: 900,
      },
      {
        id: '841714',
        zipcode: 84130,
        text: 'หนองไทร',
        value: 'หนองไทร',
        name: {
          th: 'หนองไทร',
          en: 'Nong Sai',
        },
        districtId: 900,
      },
      {
        id: '841715',
        zipcode: 84130,
        text: 'เขาหัวควาย',
        value: 'เขาหัวควาย',
        name: {
          th: 'เขาหัวควาย',
          en: 'Khao Hua Khwai',
        },
        districtId: 900,
      },
      {
        id: '841716',
        zipcode: 84130,
        text: 'ตะปาน',
        value: 'ตะปาน',
        name: {
          th: 'ตะปาน',
          en: 'Tapan',
        },
        districtId: 900,
      },
      {
        id: '841801',
        zipcode: 84350,
        text: 'สองแพรก',
        value: 'สองแพรก',
        name: {
          th: 'สองแพรก',
          en: 'Song Phraek',
        },
        districtId: 901,
      },
      {
        id: '841802',
        zipcode: 84350,
        text: 'ชัยบุรี',
        value: 'ชัยบุรี',
        name: {
          th: 'ชัยบุรี',
          en: 'Chai Buri',
        },
        districtId: 901,
      },
      {
        id: '841803',
        zipcode: 84350,
        text: 'คลองน้อย',
        value: 'คลองน้อย',
        name: {
          th: 'คลองน้อย',
          en: 'Khlong Noi',
        },
        districtId: 901,
      },
      {
        id: '841804',
        zipcode: 84350,
        text: 'ไทรทอง',
        value: 'ไทรทอง',
        name: {
          th: 'ไทรทอง',
          en: 'Sai Thong',
        },
        districtId: 901,
      },
      {
        id: '841901',
        zipcode: 84180,
        text: 'ตะกุกใต้',
        value: 'ตะกุกใต้',
        name: {
          th: 'ตะกุกใต้',
          en: 'Takuk Tai',
        },
        districtId: 902,
      },
      {
        id: '841902',
        zipcode: 84180,
        text: 'ตะกุกเหนือ',
        value: 'ตะกุกเหนือ',
        name: {
          th: 'ตะกุกเหนือ',
          en: 'Takuk Nuea',
        },
        districtId: 902,
      },
      {
        id: '850101',
        zipcode: 85000,
        text: 'เขานิเวศน์',
        value: 'เขานิเวศน์',
        name: {
          th: 'เขานิเวศน์',
          en: 'Khao Niwet',
        },
        districtId: 905,
      },
      {
        id: '850102',
        zipcode: 85000,
        text: 'ราชกรูด',
        value: 'ราชกรูด',
        name: {
          th: 'ราชกรูด',
          en: 'Ratchakrut',
        },
        districtId: 905,
      },
      {
        id: '850103',
        zipcode: 85000,
        text: 'หงาว',
        value: 'หงาว',
        name: {
          th: 'หงาว',
          en: 'Ngao',
        },
        districtId: 905,
      },
      {
        id: '850104',
        zipcode: 85000,
        text: 'บางริ้น',
        value: 'บางริ้น',
        name: {
          th: 'บางริ้น',
          en: 'Bang Rin',
        },
        districtId: 905,
      },
      {
        id: '850105',
        zipcode: 85000,
        text: 'ปากน้ำ',
        value: 'ปากน้ำ',
        name: {
          th: 'ปากน้ำ',
          en: 'Pak Nam',
        },
        districtId: 905,
      },
      {
        id: '850106',
        zipcode: 85000,
        text: 'บางนอน',
        value: 'บางนอน',
        name: {
          th: 'บางนอน',
          en: 'Bang Non',
        },
        districtId: 905,
      },
      {
        id: '850107',
        zipcode: 85000,
        text: 'หาดส้มแป้น',
        value: 'หาดส้มแป้น',
        name: {
          th: 'หาดส้มแป้น',
          en: 'Hat Som Paen',
        },
        districtId: 905,
      },
      {
        id: '850108',
        zipcode: 85130,
        text: 'ทรายแดง',
        value: 'ทรายแดง',
        name: {
          th: 'ทรายแดง',
          en: 'Sai Daeng',
        },
        districtId: 905,
      },
      {
        id: '850109',
        zipcode: 85000,
        text: 'เกาะพยาม',
        value: 'เกาะพยาม',
        name: {
          th: 'เกาะพยาม',
          en: 'Ko Phayam',
        },
        districtId: 905,
      },
      {
        id: '850201',
        zipcode: 85130,
        text: 'ละอุ่นใต้',
        value: 'ละอุ่นใต้',
        name: {
          th: 'ละอุ่นใต้',
          en: 'La-un Tai',
        },
        districtId: 906,
      },
      {
        id: '850202',
        zipcode: 85130,
        text: 'ละอุ่นเหนือ',
        value: 'ละอุ่นเหนือ',
        name: {
          th: 'ละอุ่นเหนือ',
          en: 'La-un Nuea',
        },
        districtId: 906,
      },
      {
        id: '850203',
        zipcode: 85130,
        text: 'บางพระใต้',
        value: 'บางพระใต้',
        name: {
          th: 'บางพระใต้',
          en: 'Bang Phra Tai',
        },
        districtId: 906,
      },
      {
        id: '850204',
        zipcode: 85130,
        text: 'บางพระเหนือ',
        value: 'บางพระเหนือ',
        name: {
          th: 'บางพระเหนือ',
          en: 'Bang Phra Nuea',
        },
        districtId: 906,
      },
      {
        id: '850205',
        zipcode: 85130,
        text: 'บางแก้ว',
        value: 'บางแก้ว',
        name: {
          th: 'บางแก้ว',
          en: 'Bang Kaeo',
        },
        districtId: 906,
      },
      {
        id: '850206',
        zipcode: 85130,
        text: 'ในวงเหนือ',
        value: 'ในวงเหนือ',
        name: {
          th: 'ในวงเหนือ',
          en: 'Nai Wong Nuea',
        },
        districtId: 906,
      },
      {
        id: '850207',
        zipcode: 85130,
        text: 'ในวงใต้',
        value: 'ในวงใต้',
        name: {
          th: 'ในวงใต้',
          en: 'Nai Wong Tai',
        },
        districtId: 906,
      },
      {
        id: '850301',
        zipcode: 85120,
        text: 'ม่วงกลวง',
        value: 'ม่วงกลวง',
        name: {
          th: 'ม่วงกลวง',
          en: 'Muang Kluang',
        },
        districtId: 907,
      },
      {
        id: '850302',
        zipcode: 85120,
        text: 'กะเปอร์',
        value: 'กะเปอร์',
        name: {
          th: 'กะเปอร์',
          en: 'Kapoe',
        },
        districtId: 907,
      },
      {
        id: '850303',
        zipcode: 85120,
        text: 'เชี่ยวเหลียง',
        value: 'เชี่ยวเหลียง',
        name: {
          th: 'เชี่ยวเหลียง',
          en: 'Chiao Liang',
        },
        districtId: 907,
      },
      {
        id: '850304',
        zipcode: 85120,
        text: 'บ้านนา',
        value: 'บ้านนา',
        name: {
          th: 'บ้านนา',
          en: 'Ban Na',
        },
        districtId: 907,
      },
      {
        id: '850305',
        zipcode: 85120,
        text: 'บางหิน',
        value: 'บางหิน',
        name: {
          th: 'บางหิน',
          en: 'Bang Hin',
        },
        districtId: 907,
      },
      {
        id: '850401',
        zipcode: 85110,
        text: 'น้ำจืด',
        value: 'น้ำจืด',
        name: {
          th: 'น้ำจืด',
          en: 'Nam Chuet',
        },
        districtId: 908,
      },
      {
        id: '850402',
        zipcode: 85110,
        text: 'น้ำจืดน้อย',
        value: 'น้ำจืดน้อย',
        name: {
          th: 'น้ำจืดน้อย',
          en: 'Nam Chuet Noi',
        },
        districtId: 908,
      },
      {
        id: '850403',
        zipcode: 85110,
        text: 'มะมุ',
        value: 'มะมุ',
        name: {
          th: 'มะมุ',
          en: 'Mamu',
        },
        districtId: 908,
      },
      {
        id: '850404',
        zipcode: 85110,
        text: 'ปากจั่น',
        value: 'ปากจั่น',
        name: {
          th: 'ปากจั่น',
          en: 'Pak Chan',
        },
        districtId: 908,
      },
      {
        id: '850405',
        zipcode: 85110,
        text: 'ลำเลียง',
        value: 'ลำเลียง',
        name: {
          th: 'ลำเลียง',
          en: 'Lamliang',
        },
        districtId: 908,
      },
      {
        id: '850406',
        zipcode: 85110,
        text: 'จ.ป.ร.',
        value: 'จ.ป.ร.',
        name: {
          th: 'จ.ป.ร.',
          en: 'Choporo',
        },
        districtId: 908,
      },
      {
        id: '850407',
        zipcode: 85110,
        text: 'บางใหญ่',
        value: 'บางใหญ่',
        name: {
          th: 'บางใหญ่',
          en: 'Bang Yai',
        },
        districtId: 908,
      },
      {
        id: '850501',
        zipcode: 85120,
        text: 'นาคา',
        value: 'นาคา',
        name: {
          th: 'นาคา',
          en: 'Nakha',
        },
        districtId: 909,
      },
      {
        id: '850502',
        zipcode: 85120,
        text: 'กำพวน',
        value: 'กำพวน',
        name: {
          th: 'กำพวน',
          en: 'Kamphuan',
        },
        districtId: 909,
      },
      {
        id: '860101',
        zipcode: 86000,
        text: 'ท่าตะเภา',
        value: 'ท่าตะเภา',
        name: {
          th: 'ท่าตะเภา',
          en: 'Tha Taphao',
        },
        districtId: 910,
      },
      {
        id: '860102',
        zipcode: 86120,
        text: 'ปากน้ำ',
        value: 'ปากน้ำ',
        name: {
          th: 'ปากน้ำ',
          en: 'Pak Nam',
        },
        districtId: 910,
      },
      {
        id: '860103',
        zipcode: 86000,
        text: 'ท่ายาง',
        value: 'ท่ายาง',
        name: {
          th: 'ท่ายาง',
          en: 'Tha Yang',
        },
        districtId: 910,
      },
      {
        id: '860104',
        zipcode: 86000,
        text: 'บางหมาก',
        value: 'บางหมาก',
        name: {
          th: 'บางหมาก',
          en: 'Bang Mak',
        },
        districtId: 910,
      },
      {
        id: '860105',
        zipcode: 86000,
        text: 'นาทุ่ง',
        value: 'นาทุ่ง',
        name: {
          th: 'นาทุ่ง',
          en: 'Na Thung',
        },
        districtId: 910,
      },
      {
        id: '860106',
        zipcode: 86000,
        text: 'นาชะอัง',
        value: 'นาชะอัง',
        name: {
          th: 'นาชะอัง',
          en: 'Na Cha-ang',
        },
        districtId: 910,
      },
      {
        id: '860107',
        zipcode: 86000,
        text: 'ตากแดด',
        value: 'ตากแดด',
        name: {
          th: 'ตากแดด',
          en: 'Tak Daet',
        },
        districtId: 910,
      },
      {
        id: '860108',
        zipcode: 86000,
        text: 'บางลึก',
        value: 'บางลึก',
        name: {
          th: 'บางลึก',
          en: 'Bang Luek',
        },
        districtId: 910,
      },
      {
        id: '860109',
        zipcode: 86000,
        text: 'หาดพันไกร',
        value: 'หาดพันไกร',
        name: {
          th: 'หาดพันไกร',
          en: 'Hat Phan Krai',
        },
        districtId: 910,
      },
      {
        id: '860110',
        zipcode: 86000,
        text: 'วังไผ่',
        value: 'วังไผ่',
        name: {
          th: 'วังไผ่',
          en: 'Wang Phai',
        },
        districtId: 910,
      },
      {
        id: '860111',
        zipcode: 86190,
        text: 'วังใหม่',
        value: 'วังใหม่',
        name: {
          th: 'วังใหม่',
          en: 'Wang Mai',
        },
        districtId: 910,
      },
      {
        id: '860112',
        zipcode: 86190,
        text: 'บ้านนา',
        value: 'บ้านนา',
        name: {
          th: 'บ้านนา',
          en: 'Ban Na',
        },
        districtId: 910,
      },
      {
        id: '860113',
        zipcode: 86000,
        text: 'ขุนกระทิง',
        value: 'ขุนกระทิง',
        name: {
          th: 'ขุนกระทิง',
          en: 'Khun Krathing',
        },
        districtId: 910,
      },
      {
        id: '860114',
        zipcode: 86100,
        text: 'ทุ่งคา',
        value: 'ทุ่งคา',
        name: {
          th: 'ทุ่งคา',
          en: 'Thung Kha',
        },
        districtId: 910,
      },
      {
        id: '860115',
        zipcode: 86100,
        text: 'วิสัยเหนือ',
        value: 'วิสัยเหนือ',
        name: {
          th: 'วิสัยเหนือ',
          en: 'Wisai Nuea',
        },
        districtId: 910,
      },
      {
        id: '860116',
        zipcode: 86120,
        text: 'หาดทรายรี',
        value: 'หาดทรายรี',
        name: {
          th: 'หาดทรายรี',
          en: 'Hat Sai Ri',
        },
        districtId: 910,
      },
      {
        id: '860117',
        zipcode: 86100,
        text: 'ถ้ำสิงห์',
        value: 'ถ้ำสิงห์',
        name: {
          th: 'ถ้ำสิงห์',
          en: 'Tham Sing',
        },
        districtId: 910,
      },
      {
        id: '860201',
        zipcode: 86140,
        text: 'ท่าแซะ',
        value: 'ท่าแซะ',
        name: {
          th: 'ท่าแซะ',
          en: 'Tha Sae',
        },
        districtId: 911,
      },
      {
        id: '860202',
        zipcode: 86140,
        text: 'คุริง',
        value: 'คุริง',
        name: {
          th: 'คุริง',
          en: 'Khuring',
        },
        districtId: 911,
      },
      {
        id: '860203',
        zipcode: 86140,
        text: 'สลุย',
        value: 'สลุย',
        name: {
          th: 'สลุย',
          en: 'Salui',
        },
        districtId: 911,
      },
      {
        id: '860204',
        zipcode: 86140,
        text: 'นากระตาม',
        value: 'นากระตาม',
        name: {
          th: 'นากระตาม',
          en: 'Na Kratam',
        },
        districtId: 911,
      },
      {
        id: '860205',
        zipcode: 86190,
        text: 'รับร่อ',
        value: 'รับร่อ',
        name: {
          th: 'รับร่อ',
          en: 'Rap Ro',
        },
        districtId: 911,
      },
      {
        id: '860206',
        zipcode: 86140,
        text: 'ท่าข้าม',
        value: 'ท่าข้าม',
        name: {
          th: 'ท่าข้าม',
          en: 'Tha Kham',
        },
        districtId: 911,
      },
      {
        id: '860207',
        zipcode: 86140,
        text: 'หงษ์เจริญ',
        value: 'หงษ์เจริญ',
        name: {
          th: 'หงษ์เจริญ',
          en: 'Hong Charoen',
        },
        districtId: 911,
      },
      {
        id: '860208',
        zipcode: 86190,
        text: 'หินแก้ว',
        value: 'หินแก้ว',
        name: {
          th: 'หินแก้ว',
          en: 'Hin Kaeo',
        },
        districtId: 911,
      },
      {
        id: '860209',
        zipcode: 86140,
        text: 'ทรัพย์อนันต์',
        value: 'ทรัพย์อนันต์',
        name: {
          th: 'ทรัพย์อนันต์',
          en: 'Sap Anan',
        },
        districtId: 911,
      },
      {
        id: '860210',
        zipcode: 86140,
        text: 'สองพี่น้อง',
        value: 'สองพี่น้อง',
        name: {
          th: 'สองพี่น้อง',
          en: 'Song Phi Nong',
        },
        districtId: 911,
      },
      {
        id: '860301',
        zipcode: 86160,
        text: 'บางสน',
        value: 'บางสน',
        name: {
          th: 'บางสน',
          en: 'Bang Song',
        },
        districtId: 912,
      },
      {
        id: '860302',
        zipcode: 86160,
        text: 'ทะเลทรัพย์',
        value: 'ทะเลทรัพย์',
        name: {
          th: 'ทะเลทรัพย์',
          en: 'Thale Sap',
        },
        districtId: 912,
      },
      {
        id: '860303',
        zipcode: 86230,
        text: 'สะพลี',
        value: 'สะพลี',
        name: {
          th: 'สะพลี',
          en: 'Saphli',
        },
        districtId: 912,
      },
      {
        id: '860304',
        zipcode: 86160,
        text: 'ชุมโค',
        value: 'ชุมโค',
        name: {
          th: 'ชุมโค',
          en: 'Chum Kho',
        },
        districtId: 912,
      },
      {
        id: '860305',
        zipcode: 86210,
        text: 'ดอนยาง',
        value: 'ดอนยาง',
        name: {
          th: 'ดอนยาง',
          en: 'Don Yang',
        },
        districtId: 912,
      },
      {
        id: '860306',
        zipcode: 86210,
        text: 'ปากคลอง',
        value: 'ปากคลอง',
        name: {
          th: 'ปากคลอง',
          en: 'Pak Khlong',
        },
        districtId: 912,
      },
      {
        id: '860307',
        zipcode: 86210,
        text: 'เขาไชยราช',
        value: 'เขาไชยราช',
        name: {
          th: 'เขาไชยราช',
          en: 'Khao Chai Rat',
        },
        districtId: 912,
      },
      {
        id: '860401',
        zipcode: 86110,
        text: 'หลังสวน',
        value: 'หลังสวน',
        name: {
          th: 'หลังสวน',
          en: 'Lang Suan',
        },
        districtId: 913,
      },
      {
        id: '860402',
        zipcode: 86110,
        text: 'ขันเงิน',
        value: 'ขันเงิน',
        name: {
          th: 'ขันเงิน',
          en: 'Khan Ngoen',
        },
        districtId: 913,
      },
      {
        id: '860403',
        zipcode: 86110,
        text: 'ท่ามะพลา',
        value: 'ท่ามะพลา',
        name: {
          th: 'ท่ามะพลา',
          en: 'Tha Maphla',
        },
        districtId: 913,
      },
      {
        id: '860404',
        zipcode: 86110,
        text: 'นาขา',
        value: 'นาขา',
        name: {
          th: 'นาขา',
          en: 'Na Kha',
        },
        districtId: 913,
      },
      {
        id: '860405',
        zipcode: 86110,
        text: 'นาพญา',
        value: 'นาพญา',
        name: {
          th: 'นาพญา',
          en: 'Na Phaya',
        },
        districtId: 913,
      },
      {
        id: '860406',
        zipcode: 86110,
        text: 'บ้านควน',
        value: 'บ้านควน',
        name: {
          th: 'บ้านควน',
          en: 'Ban Khuan',
        },
        districtId: 913,
      },
      {
        id: '860407',
        zipcode: 86110,
        text: 'บางมะพร้าว',
        value: 'บางมะพร้าว',
        name: {
          th: 'บางมะพร้าว',
          en: 'Bang Maphrao',
        },
        districtId: 913,
      },
      {
        id: '860408',
        zipcode: 86150,
        text: 'บางน้ำจืด',
        value: 'บางน้ำจืด',
        name: {
          th: 'บางน้ำจืด',
          en: 'Bang Nam Chuet',
        },
        districtId: 913,
      },
      {
        id: '860409',
        zipcode: 86150,
        text: 'ปากน้ำ',
        value: 'ปากน้ำ',
        name: {
          th: 'ปากน้ำ',
          en: 'Pak Nam',
        },
        districtId: 913,
      },
      {
        id: '860410',
        zipcode: 86110,
        text: 'พ้อแดง',
        value: 'พ้อแดง',
        name: {
          th: 'พ้อแดง',
          en: 'Pho Daeng',
        },
        districtId: 913,
      },
      {
        id: '860411',
        zipcode: 86110,
        text: 'แหลมทราย',
        value: 'แหลมทราย',
        name: {
          th: 'แหลมทราย',
          en: 'Laem Sai',
        },
        districtId: 913,
      },
      {
        id: '860412',
        zipcode: 86110,
        text: 'วังตะกอ',
        value: 'วังตะกอ',
        name: {
          th: 'วังตะกอ',
          en: 'Wang Tako',
        },
        districtId: 913,
      },
      {
        id: '860413',
        zipcode: 86110,
        text: 'หาดยาย',
        value: 'หาดยาย',
        name: {
          th: 'หาดยาย',
          en: 'Hat Yai',
        },
        districtId: 913,
      },
      {
        id: '860501',
        zipcode: 86170,
        text: 'ละแม',
        value: 'ละแม',
        name: {
          th: 'ละแม',
          en: 'Lamae',
        },
        districtId: 914,
      },
      {
        id: '860502',
        zipcode: 86170,
        text: 'ทุ่งหลวง',
        value: 'ทุ่งหลวง',
        name: {
          th: 'ทุ่งหลวง',
          en: 'Thung Luang',
        },
        districtId: 914,
      },
      {
        id: '860503',
        zipcode: 86170,
        text: 'สวนแตง',
        value: 'สวนแตง',
        name: {
          th: 'สวนแตง',
          en: 'Suan Taeng',
        },
        districtId: 914,
      },
      {
        id: '860504',
        zipcode: 86170,
        text: 'ทุ่งคาวัด',
        value: 'ทุ่งคาวัด',
        name: {
          th: 'ทุ่งคาวัด',
          en: 'Thung Kha Wat',
        },
        districtId: 914,
      },
      {
        id: '860601',
        zipcode: 86180,
        text: 'พะโต๊ะ',
        value: 'พะโต๊ะ',
        name: {
          th: 'พะโต๊ะ',
          en: 'Phato',
        },
        districtId: 915,
      },
      {
        id: '860602',
        zipcode: 86180,
        text: 'ปากทรง',
        value: 'ปากทรง',
        name: {
          th: 'ปากทรง',
          en: 'Pak Song',
        },
        districtId: 915,
      },
      {
        id: '860603',
        zipcode: 86180,
        text: 'ปังหวาน',
        value: 'ปังหวาน',
        name: {
          th: 'ปังหวาน',
          en: 'Pang Wan',
        },
        districtId: 915,
      },
      {
        id: '860604',
        zipcode: 86180,
        text: 'พระรักษ์',
        value: 'พระรักษ์',
        name: {
          th: 'พระรักษ์',
          en: 'Phra Rak',
        },
        districtId: 915,
      },
      {
        id: '860701',
        zipcode: 86130,
        text: 'นาโพธิ์',
        value: 'นาโพธิ์',
        name: {
          th: 'นาโพธิ์',
          en: 'Na Pho',
        },
        districtId: 916,
      },
      {
        id: '860702',
        zipcode: 86130,
        text: 'สวี',
        value: 'สวี',
        name: {
          th: 'สวี',
          en: 'Sawi',
        },
        districtId: 916,
      },
      {
        id: '860703',
        zipcode: 86130,
        text: 'ทุ่งระยะ',
        value: 'ทุ่งระยะ',
        name: {
          th: 'ทุ่งระยะ',
          en: 'Thung Raya',
        },
        districtId: 916,
      },
      {
        id: '860704',
        zipcode: 86130,
        text: 'ท่าหิน',
        value: 'ท่าหิน',
        name: {
          th: 'ท่าหิน',
          en: 'Tha Hin',
        },
        districtId: 916,
      },
      {
        id: '860705',
        zipcode: 86130,
        text: 'ปากแพรก',
        value: 'ปากแพรก',
        name: {
          th: 'ปากแพรก',
          en: 'Pak Phraek',
        },
        districtId: 916,
      },
      {
        id: '860706',
        zipcode: 86130,
        text: 'ด่านสวี',
        value: 'ด่านสวี',
        name: {
          th: 'ด่านสวี',
          en: 'Dan Sawi',
        },
        districtId: 916,
      },
      {
        id: '860707',
        zipcode: 86130,
        text: 'ครน',
        value: 'ครน',
        name: {
          th: 'ครน',
          en: 'Khron',
        },
        districtId: 916,
      },
      {
        id: '860708',
        zipcode: 86130,
        text: 'วิสัยใต้',
        value: 'วิสัยใต้',
        name: {
          th: 'วิสัยใต้',
          en: 'Wisai Tai',
        },
        districtId: 916,
      },
      {
        id: '860709',
        zipcode: 86130,
        text: 'นาสัก',
        value: 'นาสัก',
        name: {
          th: 'นาสัก',
          en: 'Na Sak',
        },
        districtId: 916,
      },
      {
        id: '860710',
        zipcode: 86130,
        text: 'เขาทะลุ',
        value: 'เขาทะลุ',
        name: {
          th: 'เขาทะลุ',
          en: 'Khao Thalu',
        },
        districtId: 916,
      },
      {
        id: '860711',
        zipcode: 86130,
        text: 'เขาค่าย',
        value: 'เขาค่าย',
        name: {
          th: 'เขาค่าย',
          en: 'Khao Khai',
        },
        districtId: 916,
      },
      {
        id: '860801',
        zipcode: 86220,
        text: 'ปากตะโก',
        value: 'ปากตะโก',
        name: {
          th: 'ปากตะโก',
          en: 'Pak Tako',
        },
        districtId: 917,
      },
      {
        id: '860802',
        zipcode: 86220,
        text: 'ทุ่งตะไคร',
        value: 'ทุ่งตะไคร',
        name: {
          th: 'ทุ่งตะไคร',
          en: 'Thung Takhrai',
        },
        districtId: 917,
      },
      {
        id: '860803',
        zipcode: 86220,
        text: 'ตะโก',
        value: 'ตะโก',
        name: {
          th: 'ตะโก',
          en: 'Tako',
        },
        districtId: 917,
      },
      {
        id: '860804',
        zipcode: 86220,
        text: 'ช่องไม้แก้ว',
        value: 'ช่องไม้แก้ว',
        name: {
          th: 'ช่องไม้แก้ว',
          en: 'Chong Mai Kaeo',
        },
        districtId: 917,
      },
      {
        id: '900101',
        zipcode: 90000,
        text: 'บ่อยาง',
        value: 'บ่อยาง',
        name: {
          th: 'บ่อยาง',
          en: 'Bo Yang',
        },
        districtId: 918,
      },
      {
        id: '900102',
        zipcode: 90000,
        text: 'เขารูปช้าง',
        value: 'เขารูปช้าง',
        name: {
          th: 'เขารูปช้าง',
          en: 'Khao Rup Chang',
        },
        districtId: 918,
      },
      {
        id: '900103',
        zipcode: 90000,
        text: 'เกาะแต้ว',
        value: 'เกาะแต้ว',
        name: {
          th: 'เกาะแต้ว',
          en: 'Ko Taeo',
        },
        districtId: 918,
      },
      {
        id: '900104',
        zipcode: 90100,
        text: 'พะวง',
        value: 'พะวง',
        name: {
          th: 'พะวง',
          en: 'Phawong',
        },
        districtId: 918,
      },
      {
        id: '900105',
        zipcode: 90000,
        text: 'ทุ่งหวัง',
        value: 'ทุ่งหวัง',
        name: {
          th: 'ทุ่งหวัง',
          en: 'Thung Wang',
        },
        districtId: 918,
      },
      {
        id: '900106',
        zipcode: 90100,
        text: 'เกาะยอ',
        value: 'เกาะยอ',
        name: {
          th: 'เกาะยอ',
          en: 'Ko Yo',
        },
        districtId: 918,
      },
      {
        id: '900201',
        zipcode: 90190,
        text: 'จะทิ้งพระ',
        value: 'จะทิ้งพระ',
        name: {
          th: 'จะทิ้งพระ',
          en: 'Chathing Phra',
        },
        districtId: 919,
      },
      {
        id: '900202',
        zipcode: 90190,
        text: 'กระดังงา',
        value: 'กระดังงา',
        name: {
          th: 'กระดังงา',
          en: 'Kradangnga',
        },
        districtId: 919,
      },
      {
        id: '900203',
        zipcode: 90190,
        text: 'สนามชัย',
        value: 'สนามชัย',
        name: {
          th: 'สนามชัย',
          en: 'Sanam Chai',
        },
        districtId: 919,
      },
      {
        id: '900204',
        zipcode: 90190,
        text: 'ดีหลวง',
        value: 'ดีหลวง',
        name: {
          th: 'ดีหลวง',
          en: 'Di Luang',
        },
        districtId: 919,
      },
      {
        id: '900205',
        zipcode: 90190,
        text: 'ชุมพล',
        value: 'ชุมพล',
        name: {
          th: 'ชุมพล',
          en: 'Chumphon',
        },
        districtId: 919,
      },
      {
        id: '900206',
        zipcode: 90190,
        text: 'คลองรี',
        value: 'คลองรี',
        name: {
          th: 'คลองรี',
          en: 'Khlong Ri',
        },
        districtId: 919,
      },
      {
        id: '900207',
        zipcode: 90190,
        text: 'คูขุด',
        value: 'คูขุด',
        name: {
          th: 'คูขุด',
          en: 'Khu Khut',
        },
        districtId: 919,
      },
      {
        id: '900208',
        zipcode: 90190,
        text: 'ท่าหิน',
        value: 'ท่าหิน',
        name: {
          th: 'ท่าหิน',
          en: 'Tha Hin',
        },
        districtId: 919,
      },
      {
        id: '900209',
        zipcode: 90190,
        text: 'วัดจันทร์',
        value: 'วัดจันทร์',
        name: {
          th: 'วัดจันทร์',
          en: 'Wat Chan',
        },
        districtId: 919,
      },
      {
        id: '900210',
        zipcode: 90190,
        text: 'บ่อแดง',
        value: 'บ่อแดง',
        name: {
          th: 'บ่อแดง',
          en: 'Bo Daeng',
        },
        districtId: 919,
      },
      {
        id: '900211',
        zipcode: 90190,
        text: 'บ่อดาน',
        value: 'บ่อดาน',
        name: {
          th: 'บ่อดาน',
          en: 'Bor Dan',
        },
        districtId: 919,
      },
      {
        id: '900301',
        zipcode: 90130,
        text: 'บ้านนา',
        value: 'บ้านนา',
        name: {
          th: 'บ้านนา',
          en: 'Ban Na',
        },
        districtId: 920,
      },
      {
        id: '900302',
        zipcode: 90130,
        text: 'ป่าชิง',
        value: 'ป่าชิง',
        name: {
          th: 'ป่าชิง',
          en: 'Pa Ching',
        },
        districtId: 920,
      },
      {
        id: '900303',
        zipcode: 90130,
        text: 'สะพานไม้แก่น',
        value: 'สะพานไม้แก่น',
        name: {
          th: 'สะพานไม้แก่น',
          en: 'Saphan Mai Kaen',
        },
        districtId: 920,
      },
      {
        id: '900304',
        zipcode: 90130,
        text: 'สะกอม',
        value: 'สะกอม',
        name: {
          th: 'สะกอม',
          en: 'Sakom',
        },
        districtId: 920,
      },
      {
        id: '900305',
        zipcode: 90130,
        text: 'นาหว้า',
        value: 'นาหว้า',
        name: {
          th: 'นาหว้า',
          en: 'Na Wa',
        },
        districtId: 920,
      },
      {
        id: '900306',
        zipcode: 90130,
        text: 'นาทับ',
        value: 'นาทับ',
        name: {
          th: 'นาทับ',
          en: 'Na Thap',
        },
        districtId: 920,
      },
      {
        id: '900307',
        zipcode: 90130,
        text: 'น้ำขาว',
        value: 'น้ำขาว',
        name: {
          th: 'น้ำขาว',
          en: 'Nam Khao',
        },
        districtId: 920,
      },
      {
        id: '900308',
        zipcode: 90130,
        text: 'ขุนตัดหวาย',
        value: 'ขุนตัดหวาย',
        name: {
          th: 'ขุนตัดหวาย',
          en: 'Khun Tat Wai',
        },
        districtId: 920,
      },
      {
        id: '900309',
        zipcode: 90130,
        text: 'ท่าหมอไทร',
        value: 'ท่าหมอไทร',
        name: {
          th: 'ท่าหมอไทร',
          en: 'Tha Mo Sai',
        },
        districtId: 920,
      },
      {
        id: '900310',
        zipcode: 90130,
        text: 'จะโหนง',
        value: 'จะโหนง',
        name: {
          th: 'จะโหนง',
          en: 'Chanong',
        },
        districtId: 920,
      },
      {
        id: '900311',
        zipcode: 90130,
        text: 'คู',
        value: 'คู',
        name: {
          th: 'คู',
          en: 'Khu',
        },
        districtId: 920,
      },
      {
        id: '900312',
        zipcode: 90130,
        text: 'แค',
        value: 'แค',
        name: {
          th: 'แค',
          en: 'Khae',
        },
        districtId: 920,
      },
      {
        id: '900313',
        zipcode: 90130,
        text: 'คลองเปียะ',
        value: 'คลองเปียะ',
        name: {
          th: 'คลองเปียะ',
          en: 'Khlong Pia',
        },
        districtId: 920,
      },
      {
        id: '900314',
        zipcode: 90130,
        text: 'ตลิ่งชัน',
        value: 'ตลิ่งชัน',
        name: {
          th: 'ตลิ่งชัน',
          en: 'Taling Chan',
        },
        districtId: 920,
      },
      {
        id: '900401',
        zipcode: 90160,
        text: 'นาทวี',
        value: 'นาทวี',
        name: {
          th: 'นาทวี',
          en: 'Na Thawi',
        },
        districtId: 921,
      },
      {
        id: '900402',
        zipcode: 90160,
        text: 'ฉาง',
        value: 'ฉาง',
        name: {
          th: 'ฉาง',
          en: 'Chang',
        },
        districtId: 921,
      },
      {
        id: '900403',
        zipcode: 90160,
        text: 'นาหมอศรี',
        value: 'นาหมอศรี',
        name: {
          th: 'นาหมอศรี',
          en: 'Na Mo Si',
        },
        districtId: 921,
      },
      {
        id: '900404',
        zipcode: 90160,
        text: 'คลองทราย',
        value: 'คลองทราย',
        name: {
          th: 'คลองทราย',
          en: 'Khlong Sai',
        },
        districtId: 921,
      },
      {
        id: '900405',
        zipcode: 90160,
        text: 'ปลักหนู',
        value: 'ปลักหนู',
        name: {
          th: 'ปลักหนู',
          en: 'Plak Nu',
        },
        districtId: 921,
      },
      {
        id: '900406',
        zipcode: 90160,
        text: 'ท่าประดู่',
        value: 'ท่าประดู่',
        name: {
          th: 'ท่าประดู่',
          en: 'Tha Pradu',
        },
        districtId: 921,
      },
      {
        id: '900407',
        zipcode: 90160,
        text: 'สะท้อน',
        value: 'สะท้อน',
        name: {
          th: 'สะท้อน',
          en: 'Sathon',
        },
        districtId: 921,
      },
      {
        id: '900408',
        zipcode: 90160,
        text: 'ทับช้าง',
        value: 'ทับช้าง',
        name: {
          th: 'ทับช้าง',
          en: 'Thap Chang',
        },
        districtId: 921,
      },
      {
        id: '900409',
        zipcode: 90160,
        text: 'ประกอบ',
        value: 'ประกอบ',
        name: {
          th: 'ประกอบ',
          en: 'Prakop',
        },
        districtId: 921,
      },
      {
        id: '900410',
        zipcode: 90160,
        text: 'คลองกวาง',
        value: 'คลองกวาง',
        name: {
          th: 'คลองกวาง',
          en: 'Khlong Kwang',
        },
        districtId: 921,
      },
      {
        id: '900501',
        zipcode: 90150,
        text: 'เทพา',
        value: 'เทพา',
        name: {
          th: 'เทพา',
          en: 'Thepha',
        },
        districtId: 922,
      },
      {
        id: '900502',
        zipcode: 90150,
        text: 'ปากบาง',
        value: 'ปากบาง',
        name: {
          th: 'ปากบาง',
          en: 'Pak Bang',
        },
        districtId: 922,
      },
      {
        id: '900503',
        zipcode: 90150,
        text: 'เกาะสะบ้า',
        value: 'เกาะสะบ้า',
        name: {
          th: 'เกาะสะบ้า',
          en: 'Ko Saba',
        },
        districtId: 922,
      },
      {
        id: '900504',
        zipcode: 90260,
        text: 'ลำไพล',
        value: 'ลำไพล',
        name: {
          th: 'ลำไพล',
          en: 'Lam Phlai',
        },
        districtId: 922,
      },
      {
        id: '900505',
        zipcode: 90260,
        text: 'ท่าม่วง',
        value: 'ท่าม่วง',
        name: {
          th: 'ท่าม่วง',
          en: 'Tha Muang',
        },
        districtId: 922,
      },
      {
        id: '900506',
        zipcode: 90260,
        text: 'วังใหญ่',
        value: 'วังใหญ่',
        name: {
          th: 'วังใหญ่',
          en: 'Wang Yai',
        },
        districtId: 922,
      },
      {
        id: '900507',
        zipcode: 90150,
        text: 'สะกอม',
        value: 'สะกอม',
        name: {
          th: 'สะกอม',
          en: 'Sakom',
        },
        districtId: 922,
      },
      {
        id: '900601',
        zipcode: 90210,
        text: 'สะบ้าย้อย',
        value: 'สะบ้าย้อย',
        name: {
          th: 'สะบ้าย้อย',
          en: 'Saba Yoi',
        },
        districtId: 923,
      },
      {
        id: '900602',
        zipcode: 90210,
        text: 'ทุ่งพอ',
        value: 'ทุ่งพอ',
        name: {
          th: 'ทุ่งพอ',
          en: 'Thung Pho',
        },
        districtId: 923,
      },
      {
        id: '900603',
        zipcode: 90210,
        text: 'เปียน',
        value: 'เปียน',
        name: {
          th: 'เปียน',
          en: 'Pian',
        },
        districtId: 923,
      },
      {
        id: '900604',
        zipcode: 90210,
        text: 'บ้านโหนด',
        value: 'บ้านโหนด',
        name: {
          th: 'บ้านโหนด',
          en: 'Ban Not',
        },
        districtId: 923,
      },
      {
        id: '900605',
        zipcode: 90210,
        text: 'จะแหน',
        value: 'จะแหน',
        name: {
          th: 'จะแหน',
          en: 'Chanae',
        },
        districtId: 923,
      },
      {
        id: '900606',
        zipcode: 90210,
        text: 'คูหา',
        value: 'คูหา',
        name: {
          th: 'คูหา',
          en: 'Khuha',
        },
        districtId: 923,
      },
      {
        id: '900607',
        zipcode: 90210,
        text: 'เขาแดง',
        value: 'เขาแดง',
        name: {
          th: 'เขาแดง',
          en: 'Khao Daeng',
        },
        districtId: 923,
      },
      {
        id: '900608',
        zipcode: 90210,
        text: 'บาโหย',
        value: 'บาโหย',
        name: {
          th: 'บาโหย',
          en: 'Ba Hoi',
        },
        districtId: 923,
      },
      {
        id: '900609',
        zipcode: 90210,
        text: 'ธารคีรี',
        value: 'ธารคีรี',
        name: {
          th: 'ธารคีรี',
          en: 'Than Khiri',
        },
        districtId: 923,
      },
      {
        id: '900701',
        zipcode: 90140,
        text: 'ระโนด',
        value: 'ระโนด',
        name: {
          th: 'ระโนด',
          en: 'Ranot',
        },
        districtId: 924,
      },
      {
        id: '900702',
        zipcode: 90140,
        text: 'คลองแดน',
        value: 'คลองแดน',
        name: {
          th: 'คลองแดน',
          en: 'Khlong Daen',
        },
        districtId: 924,
      },
      {
        id: '900703',
        zipcode: 90140,
        text: 'ตะเครียะ',
        value: 'ตะเครียะ',
        name: {
          th: 'ตะเครียะ',
          en: 'Takhria',
        },
        districtId: 924,
      },
      {
        id: '900704',
        zipcode: 90140,
        text: 'ท่าบอน',
        value: 'ท่าบอน',
        name: {
          th: 'ท่าบอน',
          en: 'Tha Bon',
        },
        districtId: 924,
      },
      {
        id: '900705',
        zipcode: 90140,
        text: 'บ้านใหม่',
        value: 'บ้านใหม่',
        name: {
          th: 'บ้านใหม่',
          en: 'Ban Mai',
        },
        districtId: 924,
      },
      {
        id: '900706',
        zipcode: 90140,
        text: 'บ่อตรุ',
        value: 'บ่อตรุ',
        name: {
          th: 'บ่อตรุ',
          en: 'Bo Tru',
        },
        districtId: 924,
      },
      {
        id: '900707',
        zipcode: 90140,
        text: 'ปากแตระ',
        value: 'ปากแตระ',
        name: {
          th: 'ปากแตระ',
          en: 'Pak Trae',
        },
        districtId: 924,
      },
      {
        id: '900708',
        zipcode: 90140,
        text: 'พังยาง',
        value: 'พังยาง',
        name: {
          th: 'พังยาง',
          en: 'Phang Yang',
        },
        districtId: 924,
      },
      {
        id: '900709',
        zipcode: 90140,
        text: 'ระวะ',
        value: 'ระวะ',
        name: {
          th: 'ระวะ',
          en: 'Rawa',
        },
        districtId: 924,
      },
      {
        id: '900710',
        zipcode: 90140,
        text: 'วัดสน',
        value: 'วัดสน',
        name: {
          th: 'วัดสน',
          en: 'Wat Son',
        },
        districtId: 924,
      },
      {
        id: '900711',
        zipcode: 90140,
        text: 'บ้านขาว',
        value: 'บ้านขาว',
        name: {
          th: 'บ้านขาว',
          en: 'Ban Khao',
        },
        districtId: 924,
      },
      {
        id: '900712',
        zipcode: 90140,
        text: 'แดนสงวน',
        value: 'แดนสงวน',
        name: {
          th: 'แดนสงวน',
          en: 'Daen Sa-nguan',
        },
        districtId: 924,
      },
      {
        id: '900801',
        zipcode: 90270,
        text: 'เกาะใหญ่',
        value: 'เกาะใหญ่',
        name: {
          th: 'เกาะใหญ่',
          en: 'Ko Yai',
        },
        districtId: 925,
      },
      {
        id: '900802',
        zipcode: 90270,
        text: 'โรง',
        value: 'โรง',
        name: {
          th: 'โรง',
          en: 'Rong',
        },
        districtId: 925,
      },
      {
        id: '900803',
        zipcode: 90270,
        text: 'เชิงแส',
        value: 'เชิงแส',
        name: {
          th: 'เชิงแส',
          en: 'Choeng Sae',
        },
        districtId: 925,
      },
      {
        id: '900804',
        zipcode: 90270,
        text: 'กระแสสินธุ์',
        value: 'กระแสสินธุ์',
        name: {
          th: 'กระแสสินธุ์',
          en: 'Krasae Sin',
        },
        districtId: 925,
      },
      {
        id: '900901',
        zipcode: 90180,
        text: 'กำแพงเพชร',
        value: 'กำแพงเพชร',
        name: {
          th: 'กำแพงเพชร',
          en: 'Kamphaeng Phet',
        },
        districtId: 926,
      },
      {
        id: '900902',
        zipcode: 90180,
        text: 'ท่าชะมวง',
        value: 'ท่าชะมวง',
        name: {
          th: 'ท่าชะมวง',
          en: 'Tha Chamuang',
        },
        districtId: 926,
      },
      {
        id: '900903',
        zipcode: 90180,
        text: 'คูหาใต้',
        value: 'คูหาใต้',
        name: {
          th: 'คูหาใต้',
          en: 'Khuha Tai',
        },
        districtId: 926,
      },
      {
        id: '900904',
        zipcode: 90180,
        text: 'ควนรู',
        value: 'ควนรู',
        name: {
          th: 'ควนรู',
          en: 'Khuan Ru',
        },
        districtId: 926,
      },
      {
        id: '900909',
        zipcode: 90180,
        text: 'เขาพระ',
        value: 'เขาพระ',
        name: {
          th: 'เขาพระ',
          en: 'Khao Phra',
        },
        districtId: 926,
      },
      {
        id: '901001',
        zipcode: 90120,
        text: 'สะเดา',
        value: 'สะเดา',
        name: {
          th: 'สะเดา',
          en: 'Sadao',
        },
        districtId: 927,
      },
      {
        id: '901002',
        zipcode: 90120,
        text: 'ปริก',
        value: 'ปริก',
        name: {
          th: 'ปริก',
          en: 'Prik',
        },
        districtId: 927,
      },
      {
        id: '901003',
        zipcode: 90170,
        text: 'พังลา',
        value: 'พังลา',
        name: {
          th: 'พังลา',
          en: 'Phang La',
        },
        districtId: 927,
      },
      {
        id: '901004',
        zipcode: 90120,
        text: 'สำนักแต้ว',
        value: 'สำนักแต้ว',
        name: {
          th: 'สำนักแต้ว',
          en: 'Samnak Taeo',
        },
        districtId: 927,
      },
      {
        id: '901005',
        zipcode: 90240,
        text: 'ทุ่งหมอ',
        value: 'ทุ่งหมอ',
        name: {
          th: 'ทุ่งหมอ',
          en: 'Thung Mo',
        },
        districtId: 927,
      },
      {
        id: '901006',
        zipcode: 90170,
        text: 'ท่าโพธิ์',
        value: 'ท่าโพธิ์',
        name: {
          th: 'ท่าโพธิ์',
          en: 'Tha Pho',
        },
        districtId: 927,
      },
      {
        id: '901007',
        zipcode: 90240,
        text: 'ปาดังเบซาร์',
        value: 'ปาดังเบซาร์',
        name: {
          th: 'ปาดังเบซาร์',
          en: 'Padang Besa',
        },
        districtId: 927,
      },
      {
        id: '901008',
        zipcode: 90320,
        text: 'สำนักขาม',
        value: 'สำนักขาม',
        name: {
          th: 'สำนักขาม',
          en: 'Samnak Kham',
        },
        districtId: 927,
      },
      {
        id: '901009',
        zipcode: 90170,
        text: 'เขามีเกียรติ',
        value: 'เขามีเกียรติ',
        name: {
          th: 'เขามีเกียรติ',
          en: 'Khao Mi Kiat',
        },
        districtId: 927,
      },
      {
        id: '901101',
        zipcode: 90110,
        text: 'หาดใหญ่',
        value: 'หาดใหญ่',
        name: {
          th: 'หาดใหญ่',
          en: 'Hat Yai',
        },
        districtId: 928,
      },
      {
        id: '901102',
        zipcode: 90110,
        text: 'ควนลัง',
        value: 'ควนลัง',
        name: {
          th: 'ควนลัง',
          en: 'Khuan Lang',
        },
        districtId: 928,
      },
      {
        id: '901103',
        zipcode: 90110,
        text: 'คูเต่า',
        value: 'คูเต่า',
        name: {
          th: 'คูเต่า',
          en: 'Khu Tao',
        },
        districtId: 928,
      },
      {
        id: '901104',
        zipcode: 90110,
        text: 'คอหงส์',
        value: 'คอหงส์',
        name: {
          th: 'คอหงส์',
          en: 'Kho Hong',
        },
        districtId: 928,
      },
      {
        id: '901105',
        zipcode: 90110,
        text: 'คลองแห',
        value: 'คลองแห',
        name: {
          th: 'คลองแห',
          en: 'Khlong Hae',
        },
        districtId: 928,
      },
      {
        id: '901107',
        zipcode: 90110,
        text: 'คลองอู่ตะเภา',
        value: 'คลองอู่ตะเภา',
        name: {
          th: 'คลองอู่ตะเภา',
          en: 'Khlong U Taphao',
        },
        districtId: 928,
      },
      {
        id: '901108',
        zipcode: 90110,
        text: 'ฉลุง',
        value: 'ฉลุง',
        name: {
          th: 'ฉลุง',
          en: 'Chalung',
        },
        districtId: 928,
      },
      {
        id: '901111',
        zipcode: 90110,
        text: 'ทุ่งใหญ่',
        value: 'ทุ่งใหญ่',
        name: {
          th: 'ทุ่งใหญ่',
          en: 'Thung Yai',
        },
        districtId: 928,
      },
      {
        id: '901112',
        zipcode: 90110,
        text: 'ทุ่งตำเสา',
        value: 'ทุ่งตำเสา',
        name: {
          th: 'ทุ่งตำเสา',
          en: 'Thung Tamsao',
        },
        districtId: 928,
      },
      {
        id: '901113',
        zipcode: 90110,
        text: 'ท่าข้าม',
        value: 'ท่าข้าม',
        name: {
          th: 'ท่าข้าม',
          en: 'Tha Kham',
        },
        districtId: 928,
      },
      {
        id: '901114',
        zipcode: 90110,
        text: 'น้ำน้อย',
        value: 'น้ำน้อย',
        name: {
          th: 'น้ำน้อย',
          en: 'Nam Noi',
        },
        districtId: 928,
      },
      {
        id: '901116',
        zipcode: 90250,
        text: 'บ้านพรุ',
        value: 'บ้านพรุ',
        name: {
          th: 'บ้านพรุ',
          en: 'Ban Phru',
        },
        districtId: 928,
      },
      {
        id: '901118',
        zipcode: 90230,
        text: 'พะตง',
        value: 'พะตง',
        name: {
          th: 'พะตง',
          en: 'Phatong',
        },
        districtId: 928,
      },
      {
        id: '901201',
        zipcode: 90310,
        text: 'นาหม่อม',
        value: 'นาหม่อม',
        name: {
          th: 'นาหม่อม',
          en: 'Na Mom',
        },
        districtId: 929,
      },
      {
        id: '901202',
        zipcode: 90310,
        text: 'พิจิตร',
        value: 'พิจิตร',
        name: {
          th: 'พิจิตร',
          en: 'Phichit',
        },
        districtId: 929,
      },
      {
        id: '901203',
        zipcode: 90310,
        text: 'ทุ่งขมิ้น',
        value: 'ทุ่งขมิ้น',
        name: {
          th: 'ทุ่งขมิ้น',
          en: 'Thung Khamin',
        },
        districtId: 929,
      },
      {
        id: '901204',
        zipcode: 90310,
        text: 'คลองหรัง',
        value: 'คลองหรัง',
        name: {
          th: 'คลองหรัง',
          en: 'Khlong Rhang',
        },
        districtId: 929,
      },
      {
        id: '901301',
        zipcode: 90220,
        text: 'รัตภูมิ',
        value: 'รัตภูมิ',
        name: {
          th: 'รัตภูมิ',
          en: 'Rattaphum',
        },
        districtId: 930,
      },
      {
        id: '901302',
        zipcode: 90220,
        text: 'ควนโส',
        value: 'ควนโส',
        name: {
          th: 'ควนโส',
          en: 'Khuan So',
        },
        districtId: 930,
      },
      {
        id: '901303',
        zipcode: 90220,
        text: 'ห้วยลึก',
        value: 'ห้วยลึก',
        name: {
          th: 'ห้วยลึก',
          en: 'Huai Luek',
        },
        districtId: 930,
      },
      {
        id: '901304',
        zipcode: 90220,
        text: 'บางเหรียง',
        value: 'บางเหรียง',
        name: {
          th: 'บางเหรียง',
          en: 'Bang Rieang',
        },
        districtId: 930,
      },
      {
        id: '901401',
        zipcode: 90110,
        text: 'บางกล่ำ',
        value: 'บางกล่ำ',
        name: {
          th: 'บางกล่ำ',
          en: 'Bang Klam',
        },
        districtId: 931,
      },
      {
        id: '901402',
        zipcode: 90110,
        text: 'ท่าช้าง',
        value: 'ท่าช้าง',
        name: {
          th: 'ท่าช้าง',
          en: 'Tha Chang',
        },
        districtId: 931,
      },
      {
        id: '901403',
        zipcode: 90110,
        text: 'แม่ทอม',
        value: 'แม่ทอม',
        name: {
          th: 'แม่ทอม',
          en: 'Mae Thom',
        },
        districtId: 931,
      },
      {
        id: '901404',
        zipcode: 90110,
        text: 'บ้านหาร',
        value: 'บ้านหาร',
        name: {
          th: 'บ้านหาร',
          en: 'Ban Han',
        },
        districtId: 931,
      },
      {
        id: '901501',
        zipcode: 90280,
        text: 'ชิงโค',
        value: 'ชิงโค',
        name: {
          th: 'ชิงโค',
          en: 'Ching Kho',
        },
        districtId: 932,
      },
      {
        id: '901502',
        zipcode: 90280,
        text: 'สทิงหม้อ',
        value: 'สทิงหม้อ',
        name: {
          th: 'สทิงหม้อ',
          en: 'Sathing Mo',
        },
        districtId: 932,
      },
      {
        id: '901503',
        zipcode: 90280,
        text: 'ทำนบ',
        value: 'ทำนบ',
        name: {
          th: 'ทำนบ',
          en: 'Thamnop',
        },
        districtId: 932,
      },
      {
        id: '901504',
        zipcode: 90330,
        text: 'รำแดง',
        value: 'รำแดง',
        name: {
          th: 'รำแดง',
          en: 'Ram Daeng',
        },
        districtId: 932,
      },
      {
        id: '901505',
        zipcode: 90330,
        text: 'วัดขนุน',
        value: 'วัดขนุน',
        name: {
          th: 'วัดขนุน',
          en: 'Wat Khanun',
        },
        districtId: 932,
      },
      {
        id: '901506',
        zipcode: 90330,
        text: 'ชะแล้',
        value: 'ชะแล้',
        name: {
          th: 'ชะแล้',
          en: 'Chalae',
        },
        districtId: 932,
      },
      {
        id: '901507',
        zipcode: 90330,
        text: 'ปากรอ',
        value: 'ปากรอ',
        name: {
          th: 'ปากรอ',
          en: 'Pak Ro',
        },
        districtId: 932,
      },
      {
        id: '901508',
        zipcode: 90330,
        text: 'ป่าขาด',
        value: 'ป่าขาด',
        name: {
          th: 'ป่าขาด',
          en: 'Pa Khat',
        },
        districtId: 932,
      },
      {
        id: '901509',
        zipcode: 90280,
        text: 'หัวเขา',
        value: 'หัวเขา',
        name: {
          th: 'หัวเขา',
          en: 'Hua Khao',
        },
        districtId: 932,
      },
      {
        id: '901510',
        zipcode: 90330,
        text: 'บางเขียด',
        value: 'บางเขียด',
        name: {
          th: 'บางเขียด',
          en: 'Bang Khiat',
        },
        districtId: 932,
      },
      {
        id: '901511',
        zipcode: 90330,
        text: 'ม่วงงาม',
        value: 'ม่วงงาม',
        name: {
          th: 'ม่วงงาม',
          en: 'Muang Ngam',
        },
        districtId: 932,
      },
      {
        id: '901601',
        zipcode: 90230,
        text: 'คลองหอยโข่ง',
        value: 'คลองหอยโข่ง',
        name: {
          th: 'คลองหอยโข่ง',
          en: 'Khlong Hoi Khong',
        },
        districtId: 933,
      },
      {
        id: '901602',
        zipcode: 90230,
        text: 'ทุ่งลาน',
        value: 'ทุ่งลาน',
        name: {
          th: 'ทุ่งลาน',
          en: 'Thung Lan',
        },
        districtId: 933,
      },
      {
        id: '901603',
        zipcode: 90230,
        text: 'โคกม่วง',
        value: 'โคกม่วง',
        name: {
          th: 'โคกม่วง',
          en: 'Khok Muang',
        },
        districtId: 933,
      },
      {
        id: '901604',
        zipcode: 90115,
        text: 'คลองหลา',
        value: 'คลองหลา',
        name: {
          th: 'คลองหลา',
          en: 'Khlong La',
        },
        districtId: 933,
      },
      {
        id: '910101',
        zipcode: 91000,
        text: 'พิมาน',
        value: 'พิมาน',
        name: {
          th: 'พิมาน',
          en: 'Phiman',
        },
        districtId: 936,
      },
      {
        id: '910102',
        zipcode: 91000,
        text: 'คลองขุด',
        value: 'คลองขุด',
        name: {
          th: 'คลองขุด',
          en: 'Khlong Khut',
        },
        districtId: 936,
      },
      {
        id: '910103',
        zipcode: 91000,
        text: 'ควนขัน',
        value: 'ควนขัน',
        name: {
          th: 'ควนขัน',
          en: 'Khuan Khan',
        },
        districtId: 936,
      },
      {
        id: '910104',
        zipcode: 91140,
        text: 'บ้านควน',
        value: 'บ้านควน',
        name: {
          th: 'บ้านควน',
          en: 'Ban Khuan',
        },
        districtId: 936,
      },
      {
        id: '910105',
        zipcode: 91140,
        text: 'ฉลุง',
        value: 'ฉลุง',
        name: {
          th: 'ฉลุง',
          en: 'Chalung',
        },
        districtId: 936,
      },
      {
        id: '910106',
        zipcode: 91000,
        text: 'เกาะสาหร่าย',
        value: 'เกาะสาหร่าย',
        name: {
          th: 'เกาะสาหร่าย',
          en: 'Ko Sarai',
        },
        districtId: 936,
      },
      {
        id: '910107',
        zipcode: 91000,
        text: 'ตันหยงโป',
        value: 'ตันหยงโป',
        name: {
          th: 'ตันหยงโป',
          en: 'Tanyong Po',
        },
        districtId: 936,
      },
      {
        id: '910108',
        zipcode: 91000,
        text: 'เจ๊ะบิลัง',
        value: 'เจ๊ะบิลัง',
        name: {
          th: 'เจ๊ะบิลัง',
          en: 'Che Bilang',
        },
        districtId: 936,
      },
      {
        id: '910109',
        zipcode: 91000,
        text: 'ตำมะลัง',
        value: 'ตำมะลัง',
        name: {
          th: 'ตำมะลัง',
          en: 'Tam Malang',
        },
        districtId: 936,
      },
      {
        id: '910110',
        zipcode: 91000,
        text: 'ปูยู',
        value: 'ปูยู',
        name: {
          th: 'ปูยู',
          en: 'Puyu',
        },
        districtId: 936,
      },
      {
        id: '910111',
        zipcode: 91140,
        text: 'ควนโพธิ์',
        value: 'ควนโพธิ์',
        name: {
          th: 'ควนโพธิ์',
          en: 'Khuan Pho',
        },
        districtId: 936,
      },
      {
        id: '910112',
        zipcode: 91140,
        text: 'เกตรี',
        value: 'เกตรี',
        name: {
          th: 'เกตรี',
          en: 'Ketri',
        },
        districtId: 936,
      },
      {
        id: '910201',
        zipcode: 91160,
        text: 'ควนโดน',
        value: 'ควนโดน',
        name: {
          th: 'ควนโดน',
          en: 'Khuan Don',
        },
        districtId: 937,
      },
      {
        id: '910202',
        zipcode: 91160,
        text: 'ควนสตอ',
        value: 'ควนสตอ',
        name: {
          th: 'ควนสตอ',
          en: 'Khuan Sato',
        },
        districtId: 937,
      },
      {
        id: '910203',
        zipcode: 91160,
        text: 'ย่านซื่อ',
        value: 'ย่านซื่อ',
        name: {
          th: 'ย่านซื่อ',
          en: 'Yan Sue',
        },
        districtId: 937,
      },
      {
        id: '910204',
        zipcode: 91160,
        text: 'วังประจัน',
        value: 'วังประจัน',
        name: {
          th: 'วังประจัน',
          en: 'Wang Prachan',
        },
        districtId: 937,
      },
      {
        id: '910301',
        zipcode: 91130,
        text: 'ทุ่งนุ้ย',
        value: 'ทุ่งนุ้ย',
        name: {
          th: 'ทุ่งนุ้ย',
          en: 'Thung Nui',
        },
        districtId: 938,
      },
      {
        id: '910302',
        zipcode: 91130,
        text: 'ควนกาหลง',
        value: 'ควนกาหลง',
        name: {
          th: 'ควนกาหลง',
          en: 'Khuan Kalong',
        },
        districtId: 938,
      },
      {
        id: '910303',
        zipcode: 91130,
        text: 'อุใดเจริญ',
        value: 'อุใดเจริญ',
        name: {
          th: 'อุใดเจริญ',
          en: 'Udai Charoen',
        },
        districtId: 938,
      },
      {
        id: '910401',
        zipcode: 91150,
        text: 'ท่าแพ',
        value: 'ท่าแพ',
        name: {
          th: 'ท่าแพ',
          en: 'Tha Phae',
        },
        districtId: 939,
      },
      {
        id: '910402',
        zipcode: 91150,
        text: 'แป-ระ',
        value: 'แป-ระ',
        name: {
          th: 'แป-ระ',
          en: 'Paera',
        },
        districtId: 939,
      },
      {
        id: '910403',
        zipcode: 91150,
        text: 'สาคร',
        value: 'สาคร',
        name: {
          th: 'สาคร',
          en: 'Sakhon',
        },
        districtId: 939,
      },
      {
        id: '910404',
        zipcode: 91150,
        text: 'ท่าเรือ',
        value: 'ท่าเรือ',
        name: {
          th: 'ท่าเรือ',
          en: 'Tha Rua',
        },
        districtId: 939,
      },
      {
        id: '910501',
        zipcode: 91110,
        text: 'กำแพง',
        value: 'กำแพง',
        name: {
          th: 'กำแพง',
          en: 'Kamphaeng',
        },
        districtId: 940,
      },
      {
        id: '910502',
        zipcode: 91110,
        text: 'ละงู',
        value: 'ละงู',
        name: {
          th: 'ละงู',
          en: 'La-ngu',
        },
        districtId: 940,
      },
      {
        id: '910503',
        zipcode: 91110,
        text: 'เขาขาว',
        value: 'เขาขาว',
        name: {
          th: 'เขาขาว',
          en: 'Khao Khao',
        },
        districtId: 940,
      },
      {
        id: '910504',
        zipcode: 91110,
        text: 'ปากน้ำ',
        value: 'ปากน้ำ',
        name: {
          th: 'ปากน้ำ',
          en: 'Pak Nam',
        },
        districtId: 940,
      },
      {
        id: '910505',
        zipcode: 91110,
        text: 'น้ำผุด',
        value: 'น้ำผุด',
        name: {
          th: 'น้ำผุด',
          en: 'Nam Phut',
        },
        districtId: 940,
      },
      {
        id: '910506',
        zipcode: 91110,
        text: 'แหลมสน',
        value: 'แหลมสน',
        name: {
          th: 'แหลมสน',
          en: 'Laem Son',
        },
        districtId: 940,
      },
      {
        id: '910601',
        zipcode: 91120,
        text: 'ทุ่งหว้า',
        value: 'ทุ่งหว้า',
        name: {
          th: 'ทุ่งหว้า',
          en: 'Thung Wa',
        },
        districtId: 941,
      },
      {
        id: '910602',
        zipcode: 91120,
        text: 'นาทอน',
        value: 'นาทอน',
        name: {
          th: 'นาทอน',
          en: 'Na Thon',
        },
        districtId: 941,
      },
      {
        id: '910603',
        zipcode: 91120,
        text: 'ขอนคลาน',
        value: 'ขอนคลาน',
        name: {
          th: 'ขอนคลาน',
          en: 'Khon Khlan',
        },
        districtId: 941,
      },
      {
        id: '910604',
        zipcode: 91120,
        text: 'ทุ่งบุหลัง',
        value: 'ทุ่งบุหลัง',
        name: {
          th: 'ทุ่งบุหลัง',
          en: 'Thung Bulang',
        },
        districtId: 941,
      },
      {
        id: '910605',
        zipcode: 91120,
        text: 'ป่าแก่บ่อหิน',
        value: 'ป่าแก่บ่อหิน',
        name: {
          th: 'ป่าแก่บ่อหิน',
          en: 'Pa Kae Bo Hin',
        },
        districtId: 941,
      },
      {
        id: '910701',
        zipcode: 91130,
        text: 'ปาล์มพัฒนา',
        value: 'ปาล์มพัฒนา',
        name: {
          th: 'ปาล์มพัฒนา',
          en: 'Palm Phatthana',
        },
        districtId: 942,
      },
      {
        id: '910702',
        zipcode: 91130,
        text: 'นิคมพัฒนา',
        value: 'นิคมพัฒนา',
        name: {
          th: 'นิคมพัฒนา',
          en: 'Nikhom Phatthana',
        },
        districtId: 942,
      },
      {
        id: '920101',
        zipcode: 92000,
        text: 'ทับเที่ยง',
        value: 'ทับเที่ยง',
        name: {
          th: 'ทับเที่ยง',
          en: 'Thap Thiang',
        },
        districtId: 943,
      },
      {
        id: '920104',
        zipcode: 92000,
        text: 'นาพละ',
        value: 'นาพละ',
        name: {
          th: 'นาพละ',
          en: 'Na Phala',
        },
        districtId: 943,
      },
      {
        id: '920105',
        zipcode: 92000,
        text: 'บ้านควน',
        value: 'บ้านควน',
        name: {
          th: 'บ้านควน',
          en: 'Ban Khuan',
        },
        districtId: 943,
      },
      {
        id: '920106',
        zipcode: 92000,
        text: 'นาบินหลา',
        value: 'นาบินหลา',
        name: {
          th: 'นาบินหลา',
          en: 'Na Bin La',
        },
        districtId: 943,
      },
      {
        id: '920107',
        zipcode: 92000,
        text: 'ควนปริง',
        value: 'ควนปริง',
        name: {
          th: 'ควนปริง',
          en: 'Khuan Pring',
        },
        districtId: 943,
      },
      {
        id: '920108',
        zipcode: 92170,
        text: 'นาโยงใต้',
        value: 'นาโยงใต้',
        name: {
          th: 'นาโยงใต้',
          en: 'Na Yong Tai',
        },
        districtId: 943,
      },
      {
        id: '920109',
        zipcode: 92000,
        text: 'บางรัก',
        value: 'บางรัก',
        name: {
          th: 'บางรัก',
          en: 'Bang Rak',
        },
        districtId: 943,
      },
      {
        id: '920110',
        zipcode: 92000,
        text: 'โคกหล่อ',
        value: 'โคกหล่อ',
        name: {
          th: 'โคกหล่อ',
          en: 'Khok Lo',
        },
        districtId: 943,
      },
      {
        id: '920113',
        zipcode: 92000,
        text: 'นาโต๊ะหมิง',
        value: 'นาโต๊ะหมิง',
        name: {
          th: 'นาโต๊ะหมิง',
          en: 'Na To Ming',
        },
        districtId: 943,
      },
      {
        id: '920114',
        zipcode: 92000,
        text: 'หนองตรุด',
        value: 'หนองตรุด',
        name: {
          th: 'หนองตรุด',
          en: 'Nong Trut',
        },
        districtId: 943,
      },
      {
        id: '920115',
        zipcode: 92000,
        text: 'น้ำผุด',
        value: 'น้ำผุด',
        name: {
          th: 'น้ำผุด',
          en: 'Nam Phut',
        },
        districtId: 943,
      },
      {
        id: '920117',
        zipcode: 92000,
        text: 'นาตาล่วง',
        value: 'นาตาล่วง',
        name: {
          th: 'นาตาล่วง',
          en: 'Na Ta Luang',
        },
        districtId: 943,
      },
      {
        id: '920118',
        zipcode: 92000,
        text: 'บ้านโพธิ์',
        value: 'บ้านโพธิ์',
        name: {
          th: 'บ้านโพธิ์',
          en: 'Ban Pho',
        },
        districtId: 943,
      },
      {
        id: '920119',
        zipcode: 92190,
        text: 'นาท่ามเหนือ',
        value: 'นาท่ามเหนือ',
        name: {
          th: 'นาท่ามเหนือ',
          en: 'Na Tham Nuea',
        },
        districtId: 943,
      },
      {
        id: '920120',
        zipcode: 92190,
        text: 'นาท่ามใต้',
        value: 'นาท่ามใต้',
        name: {
          th: 'นาท่ามใต้',
          en: 'Na Tham Tai',
        },
        districtId: 943,
      },
      {
        id: '920201',
        zipcode: 92110,
        text: 'กันตัง',
        value: 'กันตัง',
        name: {
          th: 'กันตัง',
          en: 'Kantang',
        },
        districtId: 944,
      },
      {
        id: '920202',
        zipcode: 92110,
        text: 'ควนธานี',
        value: 'ควนธานี',
        name: {
          th: 'ควนธานี',
          en: 'Khuan Thani',
        },
        districtId: 944,
      },
      {
        id: '920203',
        zipcode: 92110,
        text: 'บางหมาก',
        value: 'บางหมาก',
        name: {
          th: 'บางหมาก',
          en: 'Bang Mak',
        },
        districtId: 944,
      },
      {
        id: '920204',
        zipcode: 92110,
        text: 'บางเป้า',
        value: 'บางเป้า',
        name: {
          th: 'บางเป้า',
          en: 'Bang Pao',
        },
        districtId: 944,
      },
      {
        id: '920205',
        zipcode: 92110,
        text: 'วังวน',
        value: 'วังวน',
        name: {
          th: 'วังวน',
          en: 'Wang Won',
        },
        districtId: 944,
      },
      {
        id: '920206',
        zipcode: 92110,
        text: 'กันตังใต้',
        value: 'กันตังใต้',
        name: {
          th: 'กันตังใต้',
          en: 'Kantang Tai',
        },
        districtId: 944,
      },
      {
        id: '920207',
        zipcode: 92110,
        text: 'โคกยาง',
        value: 'โคกยาง',
        name: {
          th: 'โคกยาง',
          en: 'Khok Yang',
        },
        districtId: 944,
      },
      {
        id: '920208',
        zipcode: 92110,
        text: 'คลองลุ',
        value: 'คลองลุ',
        name: {
          th: 'คลองลุ',
          en: 'Khlong Lu',
        },
        districtId: 944,
      },
      {
        id: '920209',
        zipcode: 92110,
        text: 'ย่านซื่อ',
        value: 'ย่านซื่อ',
        name: {
          th: 'ย่านซื่อ',
          en: 'Yan Sue',
        },
        districtId: 944,
      },
      {
        id: '920210',
        zipcode: 92110,
        text: 'บ่อน้ำร้อน',
        value: 'บ่อน้ำร้อน',
        name: {
          th: 'บ่อน้ำร้อน',
          en: 'Bo Nam Ron',
        },
        districtId: 944,
      },
      {
        id: '920211',
        zipcode: 92110,
        text: 'บางสัก',
        value: 'บางสัก',
        name: {
          th: 'บางสัก',
          en: 'Bang Sak',
        },
        districtId: 944,
      },
      {
        id: '920212',
        zipcode: 92110,
        text: 'นาเกลือ',
        value: 'นาเกลือ',
        name: {
          th: 'นาเกลือ',
          en: 'Na Kluea',
        },
        districtId: 944,
      },
      {
        id: '920213',
        zipcode: 92110,
        text: 'เกาะลิบง',
        value: 'เกาะลิบง',
        name: {
          th: 'เกาะลิบง',
          en: 'Ko Libong',
        },
        districtId: 944,
      },
      {
        id: '920214',
        zipcode: 92110,
        text: 'คลองชีล้อม',
        value: 'คลองชีล้อม',
        name: {
          th: 'คลองชีล้อม',
          en: 'Khlong Chi Lom',
        },
        districtId: 944,
      },
      {
        id: '920301',
        zipcode: 92140,
        text: 'ย่านตาขาว',
        value: 'ย่านตาขาว',
        name: {
          th: 'ย่านตาขาว',
          en: 'Yan Ta Khao',
        },
        districtId: 945,
      },
      {
        id: '920302',
        zipcode: 92140,
        text: 'หนองบ่อ',
        value: 'หนองบ่อ',
        name: {
          th: 'หนองบ่อ',
          en: 'Nong Bo',
        },
        districtId: 945,
      },
      {
        id: '920303',
        zipcode: 92140,
        text: 'นาชุมเห็ด',
        value: 'นาชุมเห็ด',
        name: {
          th: 'นาชุมเห็ด',
          en: 'Na Chum Het',
        },
        districtId: 945,
      },
      {
        id: '920304',
        zipcode: 92140,
        text: 'ในควน',
        value: 'ในควน',
        name: {
          th: 'ในควน',
          en: 'Nai Khuan',
        },
        districtId: 945,
      },
      {
        id: '920305',
        zipcode: 92140,
        text: 'โพรงจระเข้',
        value: 'โพรงจระเข้',
        name: {
          th: 'โพรงจระเข้',
          en: 'Phrong Chorakhe',
        },
        districtId: 945,
      },
      {
        id: '920306',
        zipcode: 92140,
        text: 'ทุ่งกระบือ',
        value: 'ทุ่งกระบือ',
        name: {
          th: 'ทุ่งกระบือ',
          en: 'Thung Krabue',
        },
        districtId: 945,
      },
      {
        id: '920307',
        zipcode: 92140,
        text: 'ทุ่งค่าย',
        value: 'ทุ่งค่าย',
        name: {
          th: 'ทุ่งค่าย',
          en: 'Thung Khai',
        },
        districtId: 945,
      },
      {
        id: '920308',
        zipcode: 92140,
        text: 'เกาะเปียะ',
        value: 'เกาะเปียะ',
        name: {
          th: 'เกาะเปียะ',
          en: 'Ko Pia',
        },
        districtId: 945,
      },
      {
        id: '920401',
        zipcode: 92120,
        text: 'ท่าข้าม',
        value: 'ท่าข้าม',
        name: {
          th: 'ท่าข้าม',
          en: 'Tha Kham',
        },
        districtId: 946,
      },
      {
        id: '920402',
        zipcode: 92180,
        text: 'ทุ่งยาว',
        value: 'ทุ่งยาว',
        name: {
          th: 'ทุ่งยาว',
          en: 'Thung Yao',
        },
        districtId: 946,
      },
      {
        id: '920403',
        zipcode: 92180,
        text: 'ปะเหลียน',
        value: 'ปะเหลียน',
        name: {
          th: 'ปะเหลียน',
          en: 'Palian',
        },
        districtId: 946,
      },
      {
        id: '920404',
        zipcode: 92140,
        text: 'บางด้วน',
        value: 'บางด้วน',
        name: {
          th: 'บางด้วน',
          en: 'Bang Duan',
        },
        districtId: 946,
      },
      {
        id: '920407',
        zipcode: 92140,
        text: 'บ้านนา',
        value: 'บ้านนา',
        name: {
          th: 'บ้านนา',
          en: 'Ban Na',
        },
        districtId: 946,
      },
      {
        id: '920409',
        zipcode: 92120,
        text: 'สุโสะ',
        value: 'สุโสะ',
        name: {
          th: 'สุโสะ',
          en: 'Suso',
        },
        districtId: 946,
      },
      {
        id: '920410',
        zipcode: 92180,
        text: 'ลิพัง',
        value: 'ลิพัง',
        name: {
          th: 'ลิพัง',
          en: 'Liphang',
        },
        districtId: 946,
      },
      {
        id: '920411',
        zipcode: 92120,
        text: 'เกาะสุกร',
        value: 'เกาะสุกร',
        name: {
          th: 'เกาะสุกร',
          en: 'Ko Sukon',
        },
        districtId: 946,
      },
      {
        id: '920412',
        zipcode: 92140,
        text: 'ท่าพญา',
        value: 'ท่าพญา',
        name: {
          th: 'ท่าพญา',
          en: 'Tha Phaya',
        },
        districtId: 946,
      },
      {
        id: '920413',
        zipcode: 92180,
        text: 'แหลมสอม',
        value: 'แหลมสอม',
        name: {
          th: 'แหลมสอม',
          en: 'Laem Som',
        },
        districtId: 946,
      },
      {
        id: '920501',
        zipcode: 92150,
        text: 'บ่อหิน',
        value: 'บ่อหิน',
        name: {
          th: 'บ่อหิน',
          en: 'Bo Hin',
        },
        districtId: 947,
      },
      {
        id: '920502',
        zipcode: 92150,
        text: 'เขาไม้แก้ว',
        value: 'เขาไม้แก้ว',
        name: {
          th: 'เขาไม้แก้ว',
          en: 'Khao Mai Kaeo',
        },
        districtId: 947,
      },
      {
        id: '920503',
        zipcode: 92150,
        text: 'กะลาเส',
        value: 'กะลาเส',
        name: {
          th: 'กะลาเส',
          en: 'Kalase',
        },
        districtId: 947,
      },
      {
        id: '920504',
        zipcode: 92150,
        text: 'ไม้ฝาด',
        value: 'ไม้ฝาด',
        name: {
          th: 'ไม้ฝาด',
          en: 'Mai Fat',
        },
        districtId: 947,
      },
      {
        id: '920505',
        zipcode: 92000,
        text: 'นาเมืองเพชร',
        value: 'นาเมืองเพชร',
        name: {
          th: 'นาเมืองเพชร',
          en: 'Na Mueang Phet',
        },
        districtId: 947,
      },
      {
        id: '920598',
        zipcode: 0,
        text: '*วังมะปราง',
        value: '*วังมะปราง',
        name: {
          th: '*วังมะปราง',
          en: '*Wang Ma-Prang',
        },
        districtId: 947,
      },
      {
        id: '920601',
        zipcode: 92130,
        text: 'ห้วยยอด',
        value: 'ห้วยยอด',
        name: {
          th: 'ห้วยยอด',
          en: 'Huai Yot',
        },
        districtId: 948,
      },
      {
        id: '920602',
        zipcode: 92130,
        text: 'หนองช้างแล่น',
        value: 'หนองช้างแล่น',
        name: {
          th: 'หนองช้างแล่น',
          en: 'Nong Chang Laen',
        },
        districtId: 948,
      },
      {
        id: '920605',
        zipcode: 92210,
        text: 'บางดี',
        value: 'บางดี',
        name: {
          th: 'บางดี',
          en: 'Bang Di',
        },
        districtId: 948,
      },
      {
        id: '920606',
        zipcode: 92210,
        text: 'บางกุ้ง',
        value: 'บางกุ้ง',
        name: {
          th: 'บางกุ้ง',
          en: 'Bang Kung',
        },
        districtId: 948,
      },
      {
        id: '920607',
        zipcode: 92130,
        text: 'เขากอบ',
        value: 'เขากอบ',
        name: {
          th: 'เขากอบ',
          en: 'Khao Kop',
        },
        districtId: 948,
      },
      {
        id: '920608',
        zipcode: 92130,
        text: 'เขาขาว',
        value: 'เขาขาว',
        name: {
          th: 'เขาขาว',
          en: 'Khao Khao',
        },
        districtId: 948,
      },
      {
        id: '920609',
        zipcode: 92130,
        text: 'เขาปูน',
        value: 'เขาปูน',
        name: {
          th: 'เขาปูน',
          en: 'Khao Pun',
        },
        districtId: 948,
      },
      {
        id: '920610',
        zipcode: 92190,
        text: 'ปากแจ่ม',
        value: 'ปากแจ่ม',
        name: {
          th: 'ปากแจ่ม',
          en: 'Pak Chaem',
        },
        districtId: 948,
      },
      {
        id: '920611',
        zipcode: 92130,
        text: 'ปากคม',
        value: 'ปากคม',
        name: {
          th: 'ปากคม',
          en: 'Pak Khom',
        },
        districtId: 948,
      },
      {
        id: '920614',
        zipcode: 92130,
        text: 'ท่างิ้ว',
        value: 'ท่างิ้ว',
        name: {
          th: 'ท่างิ้ว',
          en: 'Tha Ngio',
        },
        districtId: 948,
      },
      {
        id: '920615',
        zipcode: 92190,
        text: 'ลำภูรา',
        value: 'ลำภูรา',
        name: {
          th: 'ลำภูรา',
          en: 'Lamphu Ra',
        },
        districtId: 948,
      },
      {
        id: '920616',
        zipcode: 92210,
        text: 'นาวง',
        value: 'นาวง',
        name: {
          th: 'นาวง',
          en: 'Na Wong',
        },
        districtId: 948,
      },
      {
        id: '920617',
        zipcode: 92130,
        text: 'ห้วยนาง',
        value: 'ห้วยนาง',
        name: {
          th: 'ห้วยนาง',
          en: 'Huai Nang',
        },
        districtId: 948,
      },
      {
        id: '920619',
        zipcode: 92130,
        text: 'ในเตา',
        value: 'ในเตา',
        name: {
          th: 'ในเตา',
          en: 'Nai Tao',
        },
        districtId: 948,
      },
      {
        id: '920620',
        zipcode: 92130,
        text: 'ทุ่งต่อ',
        value: 'ทุ่งต่อ',
        name: {
          th: 'ทุ่งต่อ',
          en: 'Thung To',
        },
        districtId: 948,
      },
      {
        id: '920621',
        zipcode: 92210,
        text: 'วังคีรี',
        value: 'วังคีรี',
        name: {
          th: 'วังคีรี',
          en: 'Wang Khiri',
        },
        districtId: 948,
      },
      {
        id: '920701',
        zipcode: 92220,
        text: 'เขาวิเศษ',
        value: 'เขาวิเศษ',
        name: {
          th: 'เขาวิเศษ',
          en: 'Khao Wiset',
        },
        districtId: 949,
      },
      {
        id: '920702',
        zipcode: 92220,
        text: 'วังมะปราง',
        value: 'วังมะปราง',
        name: {
          th: 'วังมะปราง',
          en: 'Wang Maprang',
        },
        districtId: 949,
      },
      {
        id: '920703',
        zipcode: 92220,
        text: 'อ่าวตง',
        value: 'อ่าวตง',
        name: {
          th: 'อ่าวตง',
          en: 'Ao Tong',
        },
        districtId: 949,
      },
      {
        id: '920704',
        zipcode: 92000,
        text: 'ท่าสะบ้า',
        value: 'ท่าสะบ้า',
        name: {
          th: 'ท่าสะบ้า',
          en: 'Tha Saba',
        },
        districtId: 949,
      },
      {
        id: '920705',
        zipcode: 92220,
        text: 'วังมะปรางเหนือ',
        value: 'วังมะปรางเหนือ',
        name: {
          th: 'วังมะปรางเหนือ',
          en: 'Wang Maprang Nuea',
        },
        districtId: 949,
      },
      {
        id: '920801',
        zipcode: 92170,
        text: 'นาโยงเหนือ',
        value: 'นาโยงเหนือ',
        name: {
          th: 'นาโยงเหนือ',
          en: 'Na Yong Nuea',
        },
        districtId: 950,
      },
      {
        id: '920802',
        zipcode: 92170,
        text: 'ช่อง',
        value: 'ช่อง',
        name: {
          th: 'ช่อง',
          en: 'Chong',
        },
        districtId: 950,
      },
      {
        id: '920803',
        zipcode: 92170,
        text: 'ละมอ',
        value: 'ละมอ',
        name: {
          th: 'ละมอ',
          en: 'Lamo',
        },
        districtId: 950,
      },
      {
        id: '920804',
        zipcode: 92170,
        text: 'โคกสะบ้า',
        value: 'โคกสะบ้า',
        name: {
          th: 'โคกสะบ้า',
          en: 'Khok Saba',
        },
        districtId: 950,
      },
      {
        id: '920805',
        zipcode: 92170,
        text: 'นาหมื่นศรี',
        value: 'นาหมื่นศรี',
        name: {
          th: 'นาหมื่นศรี',
          en: 'Na Muen Si',
        },
        districtId: 950,
      },
      {
        id: '920806',
        zipcode: 92170,
        text: 'นาข้าวเสีย',
        value: 'นาข้าวเสีย',
        name: {
          th: 'นาข้าวเสีย',
          en: 'Na Khao Sia',
        },
        districtId: 950,
      },
      {
        id: '920901',
        zipcode: 92160,
        text: 'ควนเมา',
        value: 'ควนเมา',
        name: {
          th: 'ควนเมา',
          en: 'Khuan Mao',
        },
        districtId: 951,
      },
      {
        id: '920902',
        zipcode: 92160,
        text: 'คลองปาง',
        value: 'คลองปาง',
        name: {
          th: 'คลองปาง',
          en: 'Khlong Pang',
        },
        districtId: 951,
      },
      {
        id: '920903',
        zipcode: 92160,
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        districtId: 951,
      },
      {
        id: '920904',
        zipcode: 92130,
        text: 'หนองปรือ',
        value: 'หนองปรือ',
        name: {
          th: 'หนองปรือ',
          en: 'Nong Prue',
        },
        districtId: 951,
      },
      {
        id: '920905',
        zipcode: 92160,
        text: 'เขาไพร',
        value: 'เขาไพร',
        name: {
          th: 'เขาไพร',
          en: 'Khao Phrai',
        },
        districtId: 951,
      },
      {
        id: '921001',
        zipcode: 92120,
        text: 'หาดสำราญ',
        value: 'หาดสำราญ',
        name: {
          th: 'หาดสำราญ',
          en: 'Hat Samran',
        },
        districtId: 952,
      },
      {
        id: '921002',
        zipcode: 92120,
        text: 'บ้าหวี',
        value: 'บ้าหวี',
        name: {
          th: 'บ้าหวี',
          en: 'Ba Wi',
        },
        districtId: 952,
      },
      {
        id: '921003',
        zipcode: 92120,
        text: 'ตะเสะ',
        value: 'ตะเสะ',
        name: {
          th: 'ตะเสะ',
          en: 'Ta Se',
        },
        districtId: 952,
      },
      {
        id: '930101',
        zipcode: 93000,
        text: 'คูหาสวรรค์',
        value: 'คูหาสวรรค์',
        name: {
          th: 'คูหาสวรรค์',
          en: 'Khuha Sawan',
        },
        districtId: 954,
      },
      {
        id: '930103',
        zipcode: 93000,
        text: 'เขาเจียก',
        value: 'เขาเจียก',
        name: {
          th: 'เขาเจียก',
          en: 'Khao Chiak',
        },
        districtId: 954,
      },
      {
        id: '930104',
        zipcode: 93000,
        text: 'ท่ามิหรำ',
        value: 'ท่ามิหรำ',
        name: {
          th: 'ท่ามิหรำ',
          en: 'Tha Miram',
        },
        districtId: 954,
      },
      {
        id: '930105',
        zipcode: 93000,
        text: 'โคกชะงาย',
        value: 'โคกชะงาย',
        name: {
          th: 'โคกชะงาย',
          en: 'Khok Cha-ngai',
        },
        districtId: 954,
      },
      {
        id: '930106',
        zipcode: 93000,
        text: 'นาท่อม',
        value: 'นาท่อม',
        name: {
          th: 'นาท่อม',
          en: 'Na Thom',
        },
        districtId: 954,
      },
      {
        id: '930107',
        zipcode: 93000,
        text: 'ปรางหมู่',
        value: 'ปรางหมู่',
        name: {
          th: 'ปรางหมู่',
          en: 'Prang Mu',
        },
        districtId: 954,
      },
      {
        id: '930108',
        zipcode: 93000,
        text: 'ท่าแค',
        value: 'ท่าแค',
        name: {
          th: 'ท่าแค',
          en: 'Tha Khae',
        },
        districtId: 954,
      },
      {
        id: '930109',
        zipcode: 93000,
        text: 'ลำปำ',
        value: 'ลำปำ',
        name: {
          th: 'ลำปำ',
          en: 'Lampam',
        },
        districtId: 954,
      },
      {
        id: '930110',
        zipcode: 93000,
        text: 'ตำนาน',
        value: 'ตำนาน',
        name: {
          th: 'ตำนาน',
          en: 'Tamnan',
        },
        districtId: 954,
      },
      {
        id: '930111',
        zipcode: 93000,
        text: 'ควนมะพร้าว',
        value: 'ควนมะพร้าว',
        name: {
          th: 'ควนมะพร้าว',
          en: 'Khuan Maphrao',
        },
        districtId: 954,
      },
      {
        id: '930112',
        zipcode: 93000,
        text: 'ร่มเมือง',
        value: 'ร่มเมือง',
        name: {
          th: 'ร่มเมือง',
          en: 'Rom Mueang',
        },
        districtId: 954,
      },
      {
        id: '930113',
        zipcode: 93000,
        text: 'ชัยบุรี',
        value: 'ชัยบุรี',
        name: {
          th: 'ชัยบุรี',
          en: 'Chai Buri',
        },
        districtId: 954,
      },
      {
        id: '930114',
        zipcode: 93000,
        text: 'นาโหนด',
        value: 'นาโหนด',
        name: {
          th: 'นาโหนด',
          en: 'Na Not)',
        },
        districtId: 954,
      },
      {
        id: '930115',
        zipcode: 93000,
        text: 'พญาขัน',
        value: 'พญาขัน',
        name: {
          th: 'พญาขัน',
          en: 'Phaya Khan',
        },
        districtId: 954,
      },
      {
        id: '930201',
        zipcode: 93180,
        text: 'กงหรา',
        value: 'กงหรา',
        name: {
          th: 'กงหรา',
          en: 'Kong Ra',
        },
        districtId: 955,
      },
      {
        id: '930202',
        zipcode: 93000,
        text: 'ชะรัด',
        value: 'ชะรัด',
        name: {
          th: 'ชะรัด',
          en: 'Charat',
        },
        districtId: 955,
      },
      {
        id: '930203',
        zipcode: 93180,
        text: 'คลองเฉลิม',
        value: 'คลองเฉลิม',
        name: {
          th: 'คลองเฉลิม',
          en: 'Khlong Chaloem',
        },
        districtId: 955,
      },
      {
        id: '930204',
        zipcode: 93180,
        text: 'คลองทรายขาว',
        value: 'คลองทรายขาว',
        name: {
          th: 'คลองทรายขาว',
          en: 'Khlong Sai Khao',
        },
        districtId: 955,
      },
      {
        id: '930205',
        zipcode: 93000,
        text: 'สมหวัง',
        value: 'สมหวัง',
        name: {
          th: 'สมหวัง',
          en: 'Som Wang',
        },
        districtId: 955,
      },
      {
        id: '930301',
        zipcode: 93130,
        text: 'เขาชัยสน',
        value: 'เขาชัยสน',
        name: {
          th: 'เขาชัยสน',
          en: 'Khao Chaison',
        },
        districtId: 956,
      },
      {
        id: '930302',
        zipcode: 93130,
        text: 'ควนขนุน',
        value: 'ควนขนุน',
        name: {
          th: 'ควนขนุน',
          en: 'Khuan Khanun',
        },
        districtId: 956,
      },
      {
        id: '930305',
        zipcode: 93130,
        text: 'จองถนน',
        value: 'จองถนน',
        name: {
          th: 'จองถนน',
          en: 'Chong Thanon',
        },
        districtId: 956,
      },
      {
        id: '930306',
        zipcode: 93130,
        text: 'หานโพธิ์',
        value: 'หานโพธิ์',
        name: {
          th: 'หานโพธิ์',
          en: 'Han Pho',
        },
        districtId: 956,
      },
      {
        id: '930307',
        zipcode: 93130,
        text: 'โคกม่วง',
        value: 'โคกม่วง',
        name: {
          th: 'โคกม่วง',
          en: 'Khok Muang',
        },
        districtId: 956,
      },
      {
        id: '930401',
        zipcode: 93160,
        text: 'แม่ขรี',
        value: 'แม่ขรี',
        name: {
          th: 'แม่ขรี',
          en: 'Mae Khari',
        },
        districtId: 957,
      },
      {
        id: '930402',
        zipcode: 93160,
        text: 'ตะโหมด',
        value: 'ตะโหมด',
        name: {
          th: 'ตะโหมด',
          en: 'Tamod',
        },
        districtId: 957,
      },
      {
        id: '930403',
        zipcode: 93160,
        text: 'คลองใหญ่',
        value: 'คลองใหญ่',
        name: {
          th: 'คลองใหญ่',
          en: 'Khlong Yai',
        },
        districtId: 957,
      },
      {
        id: '930501',
        zipcode: 93110,
        text: 'ควนขนุน',
        value: 'ควนขนุน',
        name: {
          th: 'ควนขนุน',
          en: 'Khuan Khanun',
        },
        districtId: 958,
      },
      {
        id: '930502',
        zipcode: 93150,
        text: 'ทะเลน้อย',
        value: 'ทะเลน้อย',
        name: {
          th: 'ทะเลน้อย',
          en: 'Thale Noi',
        },
        districtId: 958,
      },
      {
        id: '930504',
        zipcode: 93110,
        text: 'นาขยาด',
        value: 'นาขยาด',
        name: {
          th: 'นาขยาด',
          en: 'Na Khayat',
        },
        districtId: 958,
      },
      {
        id: '930505',
        zipcode: 93110,
        text: 'พนมวังก์',
        value: 'พนมวังก์',
        name: {
          th: 'พนมวังก์',
          en: 'Phanom Wang',
        },
        districtId: 958,
      },
      {
        id: '930506',
        zipcode: 93110,
        text: 'แหลมโตนด',
        value: 'แหลมโตนด',
        name: {
          th: 'แหลมโตนด',
          en: 'Laem Tanot',
        },
        districtId: 958,
      },
      {
        id: '930508',
        zipcode: 93110,
        text: 'ปันแต',
        value: 'ปันแต',
        name: {
          th: 'ปันแต',
          en: 'Pan Tae',
        },
        districtId: 958,
      },
      {
        id: '930509',
        zipcode: 93110,
        text: 'โตนดด้วน',
        value: 'โตนดด้วน',
        name: {
          th: 'โตนดด้วน',
          en: 'Tanot Duan',
        },
        districtId: 958,
      },
      {
        id: '930510',
        zipcode: 93110,
        text: 'ดอนทราย',
        value: 'ดอนทราย',
        name: {
          th: 'ดอนทราย',
          en: 'Don Sai',
        },
        districtId: 958,
      },
      {
        id: '930511',
        zipcode: 93150,
        text: 'มะกอกเหนือ',
        value: 'มะกอกเหนือ',
        name: {
          th: 'มะกอกเหนือ',
          en: 'Makok Nuea',
        },
        districtId: 958,
      },
      {
        id: '930512',
        zipcode: 93150,
        text: 'พนางตุง',
        value: 'พนางตุง',
        name: {
          th: 'พนางตุง',
          en: 'Phanang Tung',
        },
        districtId: 958,
      },
      {
        id: '930513',
        zipcode: 93110,
        text: 'ชะมวง',
        value: 'ชะมวง',
        name: {
          th: 'ชะมวง',
          en: 'Chamuang',
        },
        districtId: 958,
      },
      {
        id: '930516',
        zipcode: 93110,
        text: 'แพรกหา',
        value: 'แพรกหา',
        name: {
          th: 'แพรกหา',
          en: 'Phraek Ha',
        },
        districtId: 958,
      },
      {
        id: '930601',
        zipcode: 93120,
        text: 'ปากพะยูน',
        value: 'ปากพะยูน',
        name: {
          th: 'ปากพะยูน',
          en: 'Pak Phayun',
        },
        districtId: 959,
      },
      {
        id: '930602',
        zipcode: 93120,
        text: 'ดอนประดู่',
        value: 'ดอนประดู่',
        name: {
          th: 'ดอนประดู่',
          en: 'Don Pradu',
        },
        districtId: 959,
      },
      {
        id: '930603',
        zipcode: 93120,
        text: 'เกาะนางคำ',
        value: 'เกาะนางคำ',
        name: {
          th: 'เกาะนางคำ',
          en: 'Ko Nang Kham',
        },
        districtId: 959,
      },
      {
        id: '930604',
        zipcode: 93120,
        text: 'เกาะหมาก',
        value: 'เกาะหมาก',
        name: {
          th: 'เกาะหมาก',
          en: 'Ko Mak',
        },
        districtId: 959,
      },
      {
        id: '930605',
        zipcode: 93120,
        text: 'ฝาละมี',
        value: 'ฝาละมี',
        name: {
          th: 'ฝาละมี',
          en: 'Falami',
        },
        districtId: 959,
      },
      {
        id: '930606',
        zipcode: 93120,
        text: 'หารเทา',
        value: 'หารเทา',
        name: {
          th: 'หารเทา',
          en: 'Han Thao',
        },
        districtId: 959,
      },
      {
        id: '930607',
        zipcode: 93120,
        text: 'ดอนทราย',
        value: 'ดอนทราย',
        name: {
          th: 'ดอนทราย',
          en: 'Don Sai',
        },
        districtId: 959,
      },
      {
        id: '930701',
        zipcode: 93190,
        text: 'เขาย่า',
        value: 'เขาย่า',
        name: {
          th: 'เขาย่า',
          en: 'Khao Ya',
        },
        districtId: 960,
      },
      {
        id: '930702',
        zipcode: 93190,
        text: 'เขาปู่',
        value: 'เขาปู่',
        name: {
          th: 'เขาปู่',
          en: 'Khao Pu',
        },
        districtId: 960,
      },
      {
        id: '930703',
        zipcode: 93190,
        text: 'ตะแพน',
        value: 'ตะแพน',
        name: {
          th: 'ตะแพน',
          en: 'Taphaen',
        },
        districtId: 960,
      },
      {
        id: '930801',
        zipcode: 93170,
        text: 'ป่าบอน',
        value: 'ป่าบอน',
        name: {
          th: 'ป่าบอน',
          en: 'Pa Bon',
        },
        districtId: 961,
      },
      {
        id: '930802',
        zipcode: 93170,
        text: 'โคกทราย',
        value: 'โคกทราย',
        name: {
          th: 'โคกทราย',
          en: 'Khok Sai',
        },
        districtId: 961,
      },
      {
        id: '930803',
        zipcode: 93170,
        text: 'หนองธง',
        value: 'หนองธง',
        name: {
          th: 'หนองธง',
          en: 'Nong Thong',
        },
        districtId: 961,
      },
      {
        id: '930804',
        zipcode: 93170,
        text: 'ทุ่งนารี',
        value: 'ทุ่งนารี',
        name: {
          th: 'ทุ่งนารี',
          en: 'Thung Nari',
        },
        districtId: 961,
      },
      {
        id: '930806',
        zipcode: 93170,
        text: 'วังใหม่',
        value: 'วังใหม่',
        name: {
          th: 'วังใหม่',
          en: 'Wang Mai',
        },
        districtId: 961,
      },
      {
        id: '930901',
        zipcode: 93140,
        text: 'ท่ามะเดื่อ',
        value: 'ท่ามะเดื่อ',
        name: {
          th: 'ท่ามะเดื่อ',
          en: 'Tha Maduea',
        },
        districtId: 962,
      },
      {
        id: '930902',
        zipcode: 93140,
        text: 'นาปะขอ',
        value: 'นาปะขอ',
        name: {
          th: 'นาปะขอ',
          en: 'Na Pakho',
        },
        districtId: 962,
      },
      {
        id: '930903',
        zipcode: 93140,
        text: 'โคกสัก',
        value: 'โคกสัก',
        name: {
          th: 'โคกสัก',
          en: 'Khok Sak',
        },
        districtId: 962,
      },
      {
        id: '931001',
        zipcode: 93110,
        text: 'ป่าพะยอม',
        value: 'ป่าพะยอม',
        name: {
          th: 'ป่าพะยอม',
          en: 'Pa Phayom',
        },
        districtId: 963,
      },
      {
        id: '931002',
        zipcode: 93110,
        text: 'ลานข่อย',
        value: 'ลานข่อย',
        name: {
          th: 'ลานข่อย',
          en: 'Lan Khoi',
        },
        districtId: 963,
      },
      {
        id: '931003',
        zipcode: 93110,
        text: 'เกาะเต่า',
        value: 'เกาะเต่า',
        name: {
          th: 'เกาะเต่า',
          en: 'Ko Tao',
        },
        districtId: 963,
      },
      {
        id: '931004',
        zipcode: 93110,
        text: 'บ้านพร้าว',
        value: 'บ้านพร้าว',
        name: {
          th: 'บ้านพร้าว',
          en: 'Ban Phrao',
        },
        districtId: 963,
      },
      {
        id: '931101',
        zipcode: 93000,
        text: 'ชุมพล',
        value: 'ชุมพล',
        name: {
          th: 'ชุมพล',
          en: 'Chumphon',
        },
        districtId: 964,
      },
      {
        id: '931102',
        zipcode: 93000,
        text: 'บ้านนา',
        value: 'บ้านนา',
        name: {
          th: 'บ้านนา',
          en: 'Ban Na',
        },
        districtId: 964,
      },
      {
        id: '931103',
        zipcode: 93000,
        text: 'อ่างทอง',
        value: 'อ่างทอง',
        name: {
          th: 'อ่างทอง',
          en: 'Ang Thong',
        },
        districtId: 964,
      },
      {
        id: '931104',
        zipcode: 93000,
        text: 'ลำสินธุ์',
        value: 'ลำสินธุ์',
        name: {
          th: 'ลำสินธุ์',
          en: 'Lam Sin',
        },
        districtId: 964,
      },
      {
        id: '940101',
        zipcode: 94000,
        text: 'สะบารัง',
        value: 'สะบารัง',
        name: {
          th: 'สะบารัง',
          en: 'Sabarang',
        },
        districtId: 965,
      },
      {
        id: '940102',
        zipcode: 94000,
        text: 'อาเนาะรู',
        value: 'อาเนาะรู',
        name: {
          th: 'อาเนาะรู',
          en: 'Ano Ru',
        },
        districtId: 965,
      },
      {
        id: '940103',
        zipcode: 94000,
        text: 'จะบังติกอ',
        value: 'จะบังติกอ',
        name: {
          th: 'จะบังติกอ',
          en: 'Chabang Tiko',
        },
        districtId: 965,
      },
      {
        id: '940104',
        zipcode: 94000,
        text: 'บานา',
        value: 'บานา',
        name: {
          th: 'บานา',
          en: 'Bana',
        },
        districtId: 965,
      },
      {
        id: '940105',
        zipcode: 94000,
        text: 'ตันหยงลุโละ',
        value: 'ตันหยงลุโละ',
        name: {
          th: 'ตันหยงลุโละ',
          en: 'Tanyong Lulo',
        },
        districtId: 965,
      },
      {
        id: '940106',
        zipcode: 94000,
        text: 'คลองมานิง',
        value: 'คลองมานิง',
        name: {
          th: 'คลองมานิง',
          en: 'Khlong Maning',
        },
        districtId: 965,
      },
      {
        id: '940107',
        zipcode: 94000,
        text: 'กะมิยอ',
        value: 'กะมิยอ',
        name: {
          th: 'กะมิยอ',
          en: 'Kamiyo',
        },
        districtId: 965,
      },
      {
        id: '940108',
        zipcode: 94000,
        text: 'บาราโหม',
        value: 'บาราโหม',
        name: {
          th: 'บาราโหม',
          en: 'Barahom',
        },
        districtId: 965,
      },
      {
        id: '940109',
        zipcode: 94000,
        text: 'ปะกาฮะรัง',
        value: 'ปะกาฮะรัง',
        name: {
          th: 'ปะกาฮะรัง',
          en: 'Paka Harang',
        },
        districtId: 965,
      },
      {
        id: '940110',
        zipcode: 94000,
        text: 'รูสะมิแล',
        value: 'รูสะมิแล',
        name: {
          th: 'รูสะมิแล',
          en: 'Ru Samilae',
        },
        districtId: 965,
      },
      {
        id: '940111',
        zipcode: 94000,
        text: 'ตะลุโบะ',
        value: 'ตะลุโบะ',
        name: {
          th: 'ตะลุโบะ',
          en: 'Talubo',
        },
        districtId: 965,
      },
      {
        id: '940112',
        zipcode: 94000,
        text: 'บาราเฮาะ',
        value: 'บาราเฮาะ',
        name: {
          th: 'บาราเฮาะ',
          en: 'Baraho',
        },
        districtId: 965,
      },
      {
        id: '940113',
        zipcode: 94000,
        text: 'ปุยุด',
        value: 'ปุยุด',
        name: {
          th: 'ปุยุด',
          en: 'Puyut',
        },
        districtId: 965,
      },
      {
        id: '940201',
        zipcode: 94120,
        text: 'โคกโพธิ์',
        value: 'โคกโพธิ์',
        name: {
          th: 'โคกโพธิ์',
          en: 'Khok Pho',
        },
        districtId: 966,
      },
      {
        id: '940202',
        zipcode: 94120,
        text: 'มะกรูด',
        value: 'มะกรูด',
        name: {
          th: 'มะกรูด',
          en: 'Makrut',
        },
        districtId: 966,
      },
      {
        id: '940203',
        zipcode: 94120,
        text: 'บางโกระ',
        value: 'บางโกระ',
        name: {
          th: 'บางโกระ',
          en: 'Bang Kro',
        },
        districtId: 966,
      },
      {
        id: '940204',
        zipcode: 94120,
        text: 'ป่าบอน',
        value: 'ป่าบอน',
        name: {
          th: 'ป่าบอน',
          en: 'Pa Bon',
        },
        districtId: 966,
      },
      {
        id: '940205',
        zipcode: 94120,
        text: 'ทรายขาว',
        value: 'ทรายขาว',
        name: {
          th: 'ทรายขาว',
          en: 'Sai Khao',
        },
        districtId: 966,
      },
      {
        id: '940206',
        zipcode: 94180,
        text: 'นาประดู่',
        value: 'นาประดู่',
        name: {
          th: 'นาประดู่',
          en: 'Na Pradu',
        },
        districtId: 966,
      },
      {
        id: '940207',
        zipcode: 94180,
        text: 'ปากล่อ',
        value: 'ปากล่อ',
        name: {
          th: 'ปากล่อ',
          en: 'Pak Lo',
        },
        districtId: 966,
      },
      {
        id: '940208',
        zipcode: 94180,
        text: 'ทุ่งพลา',
        value: 'ทุ่งพลา',
        name: {
          th: 'ทุ่งพลา',
          en: 'Thung Phala',
        },
        districtId: 966,
      },
      {
        id: '940211',
        zipcode: 94120,
        text: 'ท่าเรือ',
        value: 'ท่าเรือ',
        name: {
          th: 'ท่าเรือ',
          en: 'Tha Ruea',
        },
        districtId: 966,
      },
      {
        id: '940213',
        zipcode: 94120,
        text: 'นาเกตุ',
        value: 'นาเกตุ',
        name: {
          th: 'นาเกตุ',
          en: 'Na Ket',
        },
        districtId: 966,
      },
      {
        id: '940214',
        zipcode: 94180,
        text: 'ควนโนรี',
        value: 'ควนโนรี',
        name: {
          th: 'ควนโนรี',
          en: 'Khuan Nori',
        },
        districtId: 966,
      },
      {
        id: '940215',
        zipcode: 94120,
        text: 'ช้างให้ตก',
        value: 'ช้างให้ตก',
        name: {
          th: 'ช้างให้ตก',
          en: 'Chang Hai Tok',
        },
        districtId: 966,
      },
      {
        id: '940301',
        zipcode: 94170,
        text: 'เกาะเปาะ',
        value: 'เกาะเปาะ',
        name: {
          th: 'เกาะเปาะ',
          en: 'Ko Po',
        },
        districtId: 967,
      },
      {
        id: '940302',
        zipcode: 94170,
        text: 'คอลอตันหยง',
        value: 'คอลอตันหยง',
        name: {
          th: 'คอลอตันหยง',
          en: 'Kholo Tanyong',
        },
        districtId: 967,
      },
      {
        id: '940303',
        zipcode: 94170,
        text: 'ดอนรัก',
        value: 'ดอนรัก',
        name: {
          th: 'ดอนรัก',
          en: 'Don Rak',
        },
        districtId: 967,
      },
      {
        id: '940304',
        zipcode: 94170,
        text: 'ดาโต๊ะ',
        value: 'ดาโต๊ะ',
        name: {
          th: 'ดาโต๊ะ',
          en: 'Dato',
        },
        districtId: 967,
      },
      {
        id: '940305',
        zipcode: 94170,
        text: 'ตุยง',
        value: 'ตุยง',
        name: {
          th: 'ตุยง',
          en: 'Tuyong',
        },
        districtId: 967,
      },
      {
        id: '940306',
        zipcode: 94170,
        text: 'ท่ากำชำ',
        value: 'ท่ากำชำ',
        name: {
          th: 'ท่ากำชำ',
          en: 'Tha Kamcham',
        },
        districtId: 967,
      },
      {
        id: '940307',
        zipcode: 94170,
        text: 'บ่อทอง',
        value: 'บ่อทอง',
        name: {
          th: 'บ่อทอง',
          en: 'Bo Thong',
        },
        districtId: 967,
      },
      {
        id: '940308',
        zipcode: 94170,
        text: 'บางเขา',
        value: 'บางเขา',
        name: {
          th: 'บางเขา',
          en: 'Bang Khao',
        },
        districtId: 967,
      },
      {
        id: '940309',
        zipcode: 94170,
        text: 'บางตาวา',
        value: 'บางตาวา',
        name: {
          th: 'บางตาวา',
          en: 'Bang Tawa',
        },
        districtId: 967,
      },
      {
        id: '940310',
        zipcode: 94170,
        text: 'ปุโละปุโย',
        value: 'ปุโละปุโย',
        name: {
          th: 'ปุโละปุโย',
          en: 'Pulo Puyo',
        },
        districtId: 967,
      },
      {
        id: '940311',
        zipcode: 94170,
        text: 'ยาบี',
        value: 'ยาบี',
        name: {
          th: 'ยาบี',
          en: 'Yabi',
        },
        districtId: 967,
      },
      {
        id: '940312',
        zipcode: 94170,
        text: 'ลิปะสะโง',
        value: 'ลิปะสะโง',
        name: {
          th: 'ลิปะสะโง',
          en: 'Lipa Sa-ngo',
        },
        districtId: 967,
      },
      {
        id: '940401',
        zipcode: 94130,
        text: 'ปะนาเระ',
        value: 'ปะนาเระ',
        name: {
          th: 'ปะนาเระ',
          en: 'Panare',
        },
        districtId: 968,
      },
      {
        id: '940402',
        zipcode: 94130,
        text: 'ท่าข้าม',
        value: 'ท่าข้าม',
        name: {
          th: 'ท่าข้าม',
          en: 'Tha Kham',
        },
        districtId: 968,
      },
      {
        id: '940403',
        zipcode: 94130,
        text: 'บ้านนอก',
        value: 'บ้านนอก',
        name: {
          th: 'บ้านนอก',
          en: 'Ban Nok',
        },
        districtId: 968,
      },
      {
        id: '940404',
        zipcode: 94130,
        text: 'ดอน',
        value: 'ดอน',
        name: {
          th: 'ดอน',
          en: 'Don',
        },
        districtId: 968,
      },
      {
        id: '940405',
        zipcode: 94190,
        text: 'ควน',
        value: 'ควน',
        name: {
          th: 'ควน',
          en: 'Khuan',
        },
        districtId: 968,
      },
      {
        id: '940406',
        zipcode: 94130,
        text: 'ท่าน้ำ',
        value: 'ท่าน้ำ',
        name: {
          th: 'ท่าน้ำ',
          en: 'Tha Nam',
        },
        districtId: 968,
      },
      {
        id: '940407',
        zipcode: 94130,
        text: 'คอกกระบือ',
        value: 'คอกกระบือ',
        name: {
          th: 'คอกกระบือ',
          en: 'Khok Krabue',
        },
        districtId: 968,
      },
      {
        id: '940408',
        zipcode: 94130,
        text: 'พ่อมิ่ง',
        value: 'พ่อมิ่ง',
        name: {
          th: 'พ่อมิ่ง',
          en: 'Pho Ming',
        },
        districtId: 968,
      },
      {
        id: '940409',
        zipcode: 94130,
        text: 'บ้านกลาง',
        value: 'บ้านกลาง',
        name: {
          th: 'บ้านกลาง',
          en: 'Ban Klang',
        },
        districtId: 968,
      },
      {
        id: '940410',
        zipcode: 94130,
        text: 'บ้านน้ำบ่อ',
        value: 'บ้านน้ำบ่อ',
        name: {
          th: 'บ้านน้ำบ่อ',
          en: 'Ban Nam Bo',
        },
        districtId: 968,
      },
      {
        id: '940501',
        zipcode: 94140,
        text: 'มายอ',
        value: 'มายอ',
        name: {
          th: 'มายอ',
          en: 'Mayo',
        },
        districtId: 969,
      },
      {
        id: '940502',
        zipcode: 94140,
        text: 'ถนน',
        value: 'ถนน',
        name: {
          th: 'ถนน',
          en: 'Thanon',
        },
        districtId: 969,
      },
      {
        id: '940503',
        zipcode: 94140,
        text: 'ตรัง',
        value: 'ตรัง',
        name: {
          th: 'ตรัง',
          en: 'Trang',
        },
        districtId: 969,
      },
      {
        id: '940504',
        zipcode: 94140,
        text: 'กระหวะ',
        value: 'กระหวะ',
        name: {
          th: 'กระหวะ',
          en: 'Krawa',
        },
        districtId: 969,
      },
      {
        id: '940505',
        zipcode: 94140,
        text: 'ลุโบะยิไร',
        value: 'ลุโบะยิไร',
        name: {
          th: 'ลุโบะยิไร',
          en: 'Lubo Yirai',
        },
        districtId: 969,
      },
      {
        id: '940506',
        zipcode: 94190,
        text: 'ลางา',
        value: 'ลางา',
        name: {
          th: 'ลางา',
          en: 'La-nga',
        },
        districtId: 969,
      },
      {
        id: '940507',
        zipcode: 94140,
        text: 'กระเสาะ',
        value: 'กระเสาะ',
        name: {
          th: 'กระเสาะ',
          en: 'Kra So',
        },
        districtId: 969,
      },
      {
        id: '940508',
        zipcode: 94140,
        text: 'เกาะจัน',
        value: 'เกาะจัน',
        name: {
          th: 'เกาะจัน',
          en: 'Ko Chan',
        },
        districtId: 969,
      },
      {
        id: '940509',
        zipcode: 94140,
        text: 'ปะโด',
        value: 'ปะโด',
        name: {
          th: 'ปะโด',
          en: 'Pado',
        },
        districtId: 969,
      },
      {
        id: '940510',
        zipcode: 94140,
        text: 'สาคอบน',
        value: 'สาคอบน',
        name: {
          th: 'สาคอบน',
          en: 'Sakho Bon',
        },
        districtId: 969,
      },
      {
        id: '940511',
        zipcode: 94140,
        text: 'สาคอใต้',
        value: 'สาคอใต้',
        name: {
          th: 'สาคอใต้',
          en: 'Sakho Tai',
        },
        districtId: 969,
      },
      {
        id: '940512',
        zipcode: 94140,
        text: 'สะกำ',
        value: 'สะกำ',
        name: {
          th: 'สะกำ',
          en: 'Sakam',
        },
        districtId: 969,
      },
      {
        id: '940513',
        zipcode: 94140,
        text: 'ปานัน',
        value: 'ปานัน',
        name: {
          th: 'ปานัน',
          en: 'Panan',
        },
        districtId: 969,
      },
      {
        id: '940601',
        zipcode: 94140,
        text: 'ตะโละแมะนา',
        value: 'ตะโละแมะนา',
        name: {
          th: 'ตะโละแมะนา',
          en: 'Talo Mae Na',
        },
        districtId: 970,
      },
      {
        id: '940602',
        zipcode: 94140,
        text: 'พิเทน',
        value: 'พิเทน',
        name: {
          th: 'พิเทน',
          en: 'Phithen',
        },
        districtId: 970,
      },
      {
        id: '940603',
        zipcode: 94140,
        text: 'น้ำดำ',
        value: 'น้ำดำ',
        name: {
          th: 'น้ำดำ',
          en: 'Nam Dam',
        },
        districtId: 970,
      },
      {
        id: '940604',
        zipcode: 94140,
        text: 'ปากู',
        value: 'ปากู',
        name: {
          th: 'ปากู',
          en: 'Paku',
        },
        districtId: 970,
      },
      {
        id: '940701',
        zipcode: 94110,
        text: 'ตะลุบัน',
        value: 'ตะลุบัน',
        name: {
          th: 'ตะลุบัน',
          en: 'Taluban',
        },
        districtId: 971,
      },
      {
        id: '940702',
        zipcode: 94110,
        text: 'ตะบิ้ง',
        value: 'ตะบิ้ง',
        name: {
          th: 'ตะบิ้ง',
          en: 'Tabing',
        },
        districtId: 971,
      },
      {
        id: '940703',
        zipcode: 94110,
        text: 'ปะเสยะวอ',
        value: 'ปะเสยะวอ',
        name: {
          th: 'ปะเสยะวอ',
          en: 'Pase Yawo',
        },
        districtId: 971,
      },
      {
        id: '940704',
        zipcode: 94110,
        text: 'บางเก่า',
        value: 'บางเก่า',
        name: {
          th: 'บางเก่า',
          en: 'Bang Kao',
        },
        districtId: 971,
      },
      {
        id: '940705',
        zipcode: 94110,
        text: 'บือเระ',
        value: 'บือเระ',
        name: {
          th: 'บือเระ',
          en: 'Bue Re',
        },
        districtId: 971,
      },
      {
        id: '940706',
        zipcode: 94110,
        text: 'เตราะบอน',
        value: 'เตราะบอน',
        name: {
          th: 'เตราะบอน',
          en: 'Tro Bon',
        },
        districtId: 971,
      },
      {
        id: '940707',
        zipcode: 94110,
        text: 'กะดุนง',
        value: 'กะดุนง',
        name: {
          th: 'กะดุนง',
          en: 'Kadunong',
        },
        districtId: 971,
      },
      {
        id: '940708',
        zipcode: 94110,
        text: 'ละหาร',
        value: 'ละหาร',
        name: {
          th: 'ละหาร',
          en: 'Lahan',
        },
        districtId: 971,
      },
      {
        id: '940709',
        zipcode: 94110,
        text: 'มะนังดาลำ',
        value: 'มะนังดาลำ',
        name: {
          th: 'มะนังดาลำ',
          en: 'Manang Dalam',
        },
        districtId: 971,
      },
      {
        id: '940710',
        zipcode: 94110,
        text: 'แป้น',
        value: 'แป้น',
        name: {
          th: 'แป้น',
          en: 'Paen',
        },
        districtId: 971,
      },
      {
        id: '940711',
        zipcode: 94190,
        text: 'ทุ่งคล้า',
        value: 'ทุ่งคล้า',
        name: {
          th: 'ทุ่งคล้า',
          en: 'Thung Khla',
        },
        districtId: 971,
      },
      {
        id: '940801',
        zipcode: 94220,
        text: 'ไทรทอง',
        value: 'ไทรทอง',
        name: {
          th: 'ไทรทอง',
          en: 'Sai Thong',
        },
        districtId: 972,
      },
      {
        id: '940802',
        zipcode: 94220,
        text: 'ไม้แก่น',
        value: 'ไม้แก่น',
        name: {
          th: 'ไม้แก่น',
          en: 'Mai Kaen',
        },
        districtId: 972,
      },
      {
        id: '940803',
        zipcode: 94220,
        text: 'ตะโละไกรทอง',
        value: 'ตะโละไกรทอง',
        name: {
          th: 'ตะโละไกรทอง',
          en: 'Talo Krai Thong',
        },
        districtId: 972,
      },
      {
        id: '940804',
        zipcode: 94220,
        text: 'ดอนทราย',
        value: 'ดอนทราย',
        name: {
          th: 'ดอนทราย',
          en: 'Don Sai',
        },
        districtId: 972,
      },
      {
        id: '940901',
        zipcode: 94150,
        text: 'ตะโละ',
        value: 'ตะโละ',
        name: {
          th: 'ตะโละ',
          en: 'Talo',
        },
        districtId: 973,
      },
      {
        id: '940902',
        zipcode: 94150,
        text: 'ตะโละกาโปร์',
        value: 'ตะโละกาโปร์',
        name: {
          th: 'ตะโละกาโปร์',
          en: 'Talo Kapo',
        },
        districtId: 973,
      },
      {
        id: '940903',
        zipcode: 94150,
        text: 'ตันหยงดาลอ',
        value: 'ตันหยงดาลอ',
        name: {
          th: 'ตันหยงดาลอ',
          en: 'Tanyong Dalo',
        },
        districtId: 973,
      },
      {
        id: '940904',
        zipcode: 94190,
        text: 'ตันหยงจึงงา',
        value: 'ตันหยงจึงงา',
        name: {
          th: 'ตันหยงจึงงา',
          en: 'Tanyong Chueng-nga',
        },
        districtId: 973,
      },
      {
        id: '940905',
        zipcode: 94150,
        text: 'ตอหลัง',
        value: 'ตอหลัง',
        name: {
          th: 'ตอหลัง',
          en: 'Tolang',
        },
        districtId: 973,
      },
      {
        id: '940906',
        zipcode: 94150,
        text: 'ตาแกะ',
        value: 'ตาแกะ',
        name: {
          th: 'ตาแกะ',
          en: 'Ta Kae',
        },
        districtId: 973,
      },
      {
        id: '940907',
        zipcode: 94150,
        text: 'ตาลีอายร์',
        value: 'ตาลีอายร์',
        name: {
          th: 'ตาลีอายร์',
          en: 'Tali-ai',
        },
        districtId: 973,
      },
      {
        id: '940908',
        zipcode: 94150,
        text: 'ยามู',
        value: 'ยามู',
        name: {
          th: 'ยามู',
          en: 'Yamu',
        },
        districtId: 973,
      },
      {
        id: '940909',
        zipcode: 94150,
        text: 'บางปู',
        value: 'บางปู',
        name: {
          th: 'บางปู',
          en: 'Bang Pu',
        },
        districtId: 973,
      },
      {
        id: '940910',
        zipcode: 94150,
        text: 'หนองแรต',
        value: 'หนองแรต',
        name: {
          th: 'หนองแรต',
          en: 'Nong Raet',
        },
        districtId: 973,
      },
      {
        id: '940911',
        zipcode: 94150,
        text: 'ปิยามุมัง',
        value: 'ปิยามุมัง',
        name: {
          th: 'ปิยามุมัง',
          en: 'Piya Mumang',
        },
        districtId: 973,
      },
      {
        id: '940912',
        zipcode: 94150,
        text: 'ปุลากง',
        value: 'ปุลากง',
        name: {
          th: 'ปุลากง',
          en: 'Pula Kong',
        },
        districtId: 973,
      },
      {
        id: '940913',
        zipcode: 94190,
        text: 'บาโลย',
        value: 'บาโลย',
        name: {
          th: 'บาโลย',
          en: 'Baloi',
        },
        districtId: 973,
      },
      {
        id: '940914',
        zipcode: 94150,
        text: 'สาบัน',
        value: 'สาบัน',
        name: {
          th: 'สาบัน',
          en: 'Saban',
        },
        districtId: 973,
      },
      {
        id: '940915',
        zipcode: 94150,
        text: 'มะนังยง',
        value: 'มะนังยง',
        name: {
          th: 'มะนังยง',
          en: 'Manang Yong',
        },
        districtId: 973,
      },
      {
        id: '940916',
        zipcode: 94150,
        text: 'ราตาปันยัง',
        value: 'ราตาปันยัง',
        name: {
          th: 'ราตาปันยัง',
          en: 'Rata Panyang',
        },
        districtId: 973,
      },
      {
        id: '940917',
        zipcode: 94150,
        text: 'จะรัง',
        value: 'จะรัง',
        name: {
          th: 'จะรัง',
          en: 'Charang',
        },
        districtId: 973,
      },
      {
        id: '940918',
        zipcode: 94150,
        text: 'แหลมโพธิ์',
        value: 'แหลมโพธิ์',
        name: {
          th: 'แหลมโพธิ์',
          en: 'Laem Pho',
        },
        districtId: 973,
      },
      {
        id: '941001',
        zipcode: 94160,
        text: 'ยะรัง',
        value: 'ยะรัง',
        name: {
          th: 'ยะรัง',
          en: 'Yarang',
        },
        districtId: 974,
      },
      {
        id: '941002',
        zipcode: 94160,
        text: 'สะดาวา',
        value: 'สะดาวา',
        name: {
          th: 'สะดาวา',
          en: 'Sadawa',
        },
        districtId: 974,
      },
      {
        id: '941003',
        zipcode: 94160,
        text: 'ประจัน',
        value: 'ประจัน',
        name: {
          th: 'ประจัน',
          en: 'Prachan',
        },
        districtId: 974,
      },
      {
        id: '941004',
        zipcode: 94160,
        text: 'สะนอ',
        value: 'สะนอ',
        name: {
          th: 'สะนอ',
          en: 'Sano',
        },
        districtId: 974,
      },
      {
        id: '941005',
        zipcode: 94160,
        text: 'ระแว้ง',
        value: 'ระแว้ง',
        name: {
          th: 'ระแว้ง',
          en: 'Rawaeng',
        },
        districtId: 974,
      },
      {
        id: '941006',
        zipcode: 94160,
        text: 'ปิตูมุดี',
        value: 'ปิตูมุดี',
        name: {
          th: 'ปิตูมุดี',
          en: 'Pitu Mudi',
        },
        districtId: 974,
      },
      {
        id: '941007',
        zipcode: 94160,
        text: 'วัด',
        value: 'วัด',
        name: {
          th: 'วัด',
          en: 'Wat',
        },
        districtId: 974,
      },
      {
        id: '941008',
        zipcode: 94160,
        text: 'กระโด',
        value: 'กระโด',
        name: {
          th: 'กระโด',
          en: 'Krado',
        },
        districtId: 974,
      },
      {
        id: '941009',
        zipcode: 94160,
        text: 'คลองใหม่',
        value: 'คลองใหม่',
        name: {
          th: 'คลองใหม่',
          en: 'Khlong Mai',
        },
        districtId: 974,
      },
      {
        id: '941010',
        zipcode: 94160,
        text: 'เมาะมาวี',
        value: 'เมาะมาวี',
        name: {
          th: 'เมาะมาวี',
          en: 'Mo Mawi',
        },
        districtId: 974,
      },
      {
        id: '941011',
        zipcode: 94160,
        text: 'กอลำ',
        value: 'กอลำ',
        name: {
          th: 'กอลำ',
          en: 'Kolam',
        },
        districtId: 974,
      },
      {
        id: '941012',
        zipcode: 94160,
        text: 'เขาตูม',
        value: 'เขาตูม',
        name: {
          th: 'เขาตูม',
          en: 'Khao Tum',
        },
        districtId: 974,
      },
      {
        id: '941101',
        zipcode: 94230,
        text: 'กะรุบี',
        value: 'กะรุบี',
        name: {
          th: 'กะรุบี',
          en: 'Karubi',
        },
        districtId: 975,
      },
      {
        id: '941102',
        zipcode: 94230,
        text: 'ตะโละดือรามัน',
        value: 'ตะโละดือรามัน',
        name: {
          th: 'ตะโละดือรามัน',
          en: 'Talo Due Raman',
        },
        districtId: 975,
      },
      {
        id: '941103',
        zipcode: 94230,
        text: 'ปล่องหอย',
        value: 'ปล่องหอย',
        name: {
          th: 'ปล่องหอย',
          en: 'Plong Hoi',
        },
        districtId: 975,
      },
      {
        id: '941201',
        zipcode: 94180,
        text: 'แม่ลาน',
        value: 'แม่ลาน',
        name: {
          th: 'แม่ลาน',
          en: 'Mae Lan',
        },
        districtId: 976,
      },
      {
        id: '941202',
        zipcode: 94180,
        text: 'ม่วงเตี้ย',
        value: 'ม่วงเตี้ย',
        name: {
          th: 'ม่วงเตี้ย',
          en: 'Muang Tia',
        },
        districtId: 976,
      },
      {
        id: '941203',
        zipcode: 94180,
        text: 'ป่าไร่',
        value: 'ป่าไร่',
        name: {
          th: 'ป่าไร่',
          en: 'Pa Rai',
        },
        districtId: 976,
      },
      {
        id: '950101',
        zipcode: 95000,
        text: 'สะเตง',
        value: 'สะเตง',
        name: {
          th: 'สะเตง',
          en: 'Sateng',
        },
        districtId: 977,
      },
      {
        id: '950102',
        zipcode: 95000,
        text: 'บุดี',
        value: 'บุดี',
        name: {
          th: 'บุดี',
          en: 'Budi',
        },
        districtId: 977,
      },
      {
        id: '950103',
        zipcode: 95000,
        text: 'ยุโป',
        value: 'ยุโป',
        name: {
          th: 'ยุโป',
          en: 'Yopo',
        },
        districtId: 977,
      },
      {
        id: '950104',
        zipcode: 95160,
        text: 'ลิดล',
        value: 'ลิดล',
        name: {
          th: 'ลิดล',
          en: 'Lidon',
        },
        districtId: 977,
      },
      {
        id: '950106',
        zipcode: 95000,
        text: 'ยะลา',
        value: 'ยะลา',
        name: {
          th: 'ยะลา',
          en: 'Yala',
        },
        districtId: 977,
      },
      {
        id: '950108',
        zipcode: 95000,
        text: 'ท่าสาป',
        value: 'ท่าสาป',
        name: {
          th: 'ท่าสาป',
          en: 'Tha Sap',
        },
        districtId: 977,
      },
      {
        id: '950109',
        zipcode: 95160,
        text: 'ลำใหม่',
        value: 'ลำใหม่',
        name: {
          th: 'ลำใหม่',
          en: 'Lam Mai',
        },
        districtId: 977,
      },
      {
        id: '950110',
        zipcode: 95000,
        text: 'หน้าถ้ำ',
        value: 'หน้าถ้ำ',
        name: {
          th: 'หน้าถ้ำ',
          en: 'Na Tham',
        },
        districtId: 977,
      },
      {
        id: '950111',
        zipcode: 95160,
        text: 'ลำพะยา',
        value: 'ลำพะยา',
        name: {
          th: 'ลำพะยา',
          en: 'Lam Phaya',
        },
        districtId: 977,
      },
      {
        id: '950112',
        zipcode: 95000,
        text: 'เปาะเส้ง',
        value: 'เปาะเส้ง',
        name: {
          th: 'เปาะเส้ง',
          en: 'Po Seng',
        },
        districtId: 977,
      },
      {
        id: '950114',
        zipcode: 95160,
        text: 'พร่อน',
        value: 'พร่อน',
        name: {
          th: 'พร่อน',
          en: 'Phron',
        },
        districtId: 977,
      },
      {
        id: '950115',
        zipcode: 95000,
        text: 'บันนังสาเรง',
        value: 'บันนังสาเรง',
        name: {
          th: 'บันนังสาเรง',
          en: 'Bannang Sareng',
        },
        districtId: 977,
      },
      {
        id: '950116',
        zipcode: 95000,
        text: 'สะเตงนอก',
        value: 'สะเตงนอก',
        name: {
          th: 'สะเตงนอก',
          en: 'Sateng Nok',
        },
        districtId: 977,
      },
      {
        id: '950118',
        zipcode: 95000,
        text: 'ตาเซะ',
        value: 'ตาเซะ',
        name: {
          th: 'ตาเซะ',
          en: 'Ta Se',
        },
        districtId: 977,
      },
      {
        id: '950201',
        zipcode: 95110,
        text: 'เบตง',
        value: 'เบตง',
        name: {
          th: 'เบตง',
          en: 'Betong',
        },
        districtId: 978,
      },
      {
        id: '950202',
        zipcode: 95110,
        text: 'ยะรม',
        value: 'ยะรม',
        name: {
          th: 'ยะรม',
          en: 'Yarom',
        },
        districtId: 978,
      },
      {
        id: '950203',
        zipcode: 95110,
        text: 'ตาเนาะแมเราะ',
        value: 'ตาเนาะแมเราะ',
        name: {
          th: 'ตาเนาะแมเราะ',
          en: 'Tano Maero',
        },
        districtId: 978,
      },
      {
        id: '950204',
        zipcode: 95110,
        text: 'อัยเยอร์เวง',
        value: 'อัยเยอร์เวง',
        name: {
          th: 'อัยเยอร์เวง',
          en: 'Aiyoe Weng',
        },
        districtId: 978,
      },
      {
        id: '950205',
        zipcode: 95110,
        text: 'ธารน้ำทิพย์',
        value: 'ธารน้ำทิพย์',
        name: {
          th: 'ธารน้ำทิพย์',
          en: 'Than Nam Thip',
        },
        districtId: 978,
      },
      {
        id: '950301',
        zipcode: 95130,
        text: 'บันนังสตา',
        value: 'บันนังสตา',
        name: {
          th: 'บันนังสตา',
          en: 'Bannang Sata',
        },
        districtId: 979,
      },
      {
        id: '950302',
        zipcode: 95130,
        text: 'บาเจาะ',
        value: 'บาเจาะ',
        name: {
          th: 'บาเจาะ',
          en: 'Bacho',
        },
        districtId: 979,
      },
      {
        id: '950303',
        zipcode: 95130,
        text: 'ตาเนาะปูเต๊ะ',
        value: 'ตาเนาะปูเต๊ะ',
        name: {
          th: 'ตาเนาะปูเต๊ะ',
          en: 'Tano Pute',
        },
        districtId: 979,
      },
      {
        id: '950304',
        zipcode: 95130,
        text: 'ถ้ำทะลุ',
        value: 'ถ้ำทะลุ',
        name: {
          th: 'ถ้ำทะลุ',
          en: 'Tham Thalu',
        },
        districtId: 979,
      },
      {
        id: '950305',
        zipcode: 95130,
        text: 'ตลิ่งชัน',
        value: 'ตลิ่งชัน',
        name: {
          th: 'ตลิ่งชัน',
          en: 'Taling Chan',
        },
        districtId: 979,
      },
      {
        id: '950306',
        zipcode: 95130,
        text: 'เขื่อนบางลาง',
        value: 'เขื่อนบางลาง',
        name: {
          th: 'เขื่อนบางลาง',
          en: 'Khuean Bang Lang',
        },
        districtId: 979,
      },
      {
        id: '950401',
        zipcode: 95150,
        text: 'ธารโต',
        value: 'ธารโต',
        name: {
          th: 'ธารโต',
          en: 'Than To',
        },
        districtId: 980,
      },
      {
        id: '950402',
        zipcode: 95150,
        text: 'บ้านแหร',
        value: 'บ้านแหร',
        name: {
          th: 'บ้านแหร',
          en: 'Ban Rae',
        },
        districtId: 980,
      },
      {
        id: '950403',
        zipcode: 95170,
        text: 'แม่หวาด',
        value: 'แม่หวาด',
        name: {
          th: 'แม่หวาด',
          en: 'Mae Wat',
        },
        districtId: 980,
      },
      {
        id: '950404',
        zipcode: 95150,
        text: 'คีรีเขต',
        value: 'คีรีเขต',
        name: {
          th: 'คีรีเขต',
          en: 'Khiri Khet',
        },
        districtId: 980,
      },
      {
        id: '950501',
        zipcode: 95120,
        text: 'ยะหา',
        value: 'ยะหา',
        name: {
          th: 'ยะหา',
          en: 'Yaha',
        },
        districtId: 981,
      },
      {
        id: '950502',
        zipcode: 95120,
        text: 'ละแอ',
        value: 'ละแอ',
        name: {
          th: 'ละแอ',
          en: 'La-ae',
        },
        districtId: 981,
      },
      {
        id: '950503',
        zipcode: 95120,
        text: 'ปะแต',
        value: 'ปะแต',
        name: {
          th: 'ปะแต',
          en: 'Patae',
        },
        districtId: 981,
      },
      {
        id: '950504',
        zipcode: 95120,
        text: 'บาโร๊ะ',
        value: 'บาโร๊ะ',
        name: {
          th: 'บาโร๊ะ',
          en: 'Baro',
        },
        districtId: 981,
      },
      {
        id: '950506',
        zipcode: 95120,
        text: 'ตาชี',
        value: 'ตาชี',
        name: {
          th: 'ตาชี',
          en: 'Ta Chi',
        },
        districtId: 981,
      },
      {
        id: '950507',
        zipcode: 95120,
        text: 'บาโงยซิแน',
        value: 'บาโงยซิแน',
        name: {
          th: 'บาโงยซิแน',
          en: 'Ba-ngoi Sinae',
        },
        districtId: 981,
      },
      {
        id: '950508',
        zipcode: 95120,
        text: 'กาตอง',
        value: 'กาตอง',
        name: {
          th: 'กาตอง',
          en: 'Ka Tong',
        },
        districtId: 981,
      },
      {
        id: '950601',
        zipcode: 95140,
        text: 'กายูบอเกาะ',
        value: 'กายูบอเกาะ',
        name: {
          th: 'กายูบอเกาะ',
          en: 'Kayu Boko',
        },
        districtId: 982,
      },
      {
        id: '950602',
        zipcode: 95140,
        text: 'กาลูปัง',
        value: 'กาลูปัง',
        name: {
          th: 'กาลูปัง',
          en: 'Kalupang',
        },
        districtId: 982,
      },
      {
        id: '950603',
        zipcode: 95140,
        text: 'กาลอ',
        value: 'กาลอ',
        name: {
          th: 'กาลอ',
          en: 'Kalo',
        },
        districtId: 982,
      },
      {
        id: '950604',
        zipcode: 95140,
        text: 'กอตอตือร๊ะ',
        value: 'กอตอตือร๊ะ',
        name: {
          th: 'กอตอตือร๊ะ',
          en: 'Koto Tuera',
        },
        districtId: 982,
      },
      {
        id: '950605',
        zipcode: 95140,
        text: 'โกตาบารู',
        value: 'โกตาบารู',
        name: {
          th: 'โกตาบารู',
          en: 'Kota Baru',
        },
        districtId: 982,
      },
      {
        id: '950606',
        zipcode: 95140,
        text: 'เกะรอ',
        value: 'เกะรอ',
        name: {
          th: 'เกะรอ',
          en: 'Kero',
        },
        districtId: 982,
      },
      {
        id: '950607',
        zipcode: 95140,
        text: 'จะกว๊ะ',
        value: 'จะกว๊ะ',
        name: {
          th: 'จะกว๊ะ',
          en: 'Cha-kwa',
        },
        districtId: 982,
      },
      {
        id: '950608',
        zipcode: 95140,
        text: 'ท่าธง',
        value: 'ท่าธง',
        name: {
          th: 'ท่าธง',
          en: 'Tha Thong',
        },
        districtId: 982,
      },
      {
        id: '950609',
        zipcode: 95140,
        text: 'เนินงาม',
        value: 'เนินงาม',
        name: {
          th: 'เนินงาม',
          en: 'Noen Ngam',
        },
        districtId: 982,
      },
      {
        id: '950610',
        zipcode: 95140,
        text: 'บาลอ',
        value: 'บาลอ',
        name: {
          th: 'บาลอ',
          en: 'Balo',
        },
        districtId: 982,
      },
      {
        id: '950611',
        zipcode: 95140,
        text: 'บาโงย',
        value: 'บาโงย',
        name: {
          th: 'บาโงย',
          en: 'Ba-ngoi',
        },
        districtId: 982,
      },
      {
        id: '950612',
        zipcode: 95140,
        text: 'บือมัง',
        value: 'บือมัง',
        name: {
          th: 'บือมัง',
          en: 'Buemang',
        },
        districtId: 982,
      },
      {
        id: '950613',
        zipcode: 95140,
        text: 'ยะต๊ะ',
        value: 'ยะต๊ะ',
        name: {
          th: 'ยะต๊ะ',
          en: 'Yata',
        },
        districtId: 982,
      },
      {
        id: '950614',
        zipcode: 95140,
        text: 'วังพญา',
        value: 'วังพญา',
        name: {
          th: 'วังพญา',
          en: 'Wang Phaya',
        },
        districtId: 982,
      },
      {
        id: '950615',
        zipcode: 95140,
        text: 'อาซ่อง',
        value: 'อาซ่อง',
        name: {
          th: 'อาซ่อง',
          en: 'Asong',
        },
        districtId: 982,
      },
      {
        id: '950616',
        zipcode: 95140,
        text: 'ตะโล๊ะหะลอ',
        value: 'ตะโล๊ะหะลอ',
        name: {
          th: 'ตะโล๊ะหะลอ',
          en: 'Talo Halo',
        },
        districtId: 982,
      },
      {
        id: '950701',
        zipcode: 95120,
        text: 'กาบัง',
        value: 'กาบัง',
        name: {
          th: 'กาบัง',
          en: 'Kabang',
        },
        districtId: 983,
      },
      {
        id: '950702',
        zipcode: 95120,
        text: 'บาละ',
        value: 'บาละ',
        name: {
          th: 'บาละ',
          en: 'Bala',
        },
        districtId: 983,
      },
      {
        id: '950801',
        zipcode: 95000,
        text: 'กรงปินัง',
        value: 'กรงปินัง',
        name: {
          th: 'กรงปินัง',
          en: 'Krong Pinang',
        },
        districtId: 984,
      },
      {
        id: '950802',
        zipcode: 95000,
        text: 'สะเอะ',
        value: 'สะเอะ',
        name: {
          th: 'สะเอะ',
          en: 'Sa-e',
        },
        districtId: 984,
      },
      {
        id: '950803',
        zipcode: 95000,
        text: 'ห้วยกระทิง',
        value: 'ห้วยกระทิง',
        name: {
          th: 'ห้วยกระทิง',
          en: 'Huai Krathing',
        },
        districtId: 984,
      },
      {
        id: '950804',
        zipcode: 95000,
        text: 'ปุโรง',
        value: 'ปุโรง',
        name: {
          th: 'ปุโรง',
          en: 'Purong',
        },
        districtId: 984,
      },
      {
        id: '960101',
        zipcode: 96000,
        text: 'บางนาค',
        value: 'บางนาค',
        name: {
          th: 'บางนาค',
          en: 'Bang Nak',
        },
        districtId: 985,
      },
      {
        id: '960102',
        zipcode: 96000,
        text: 'ลำภู',
        value: 'ลำภู',
        name: {
          th: 'ลำภู',
          en: 'Lam Phu',
        },
        districtId: 985,
      },
      {
        id: '960103',
        zipcode: 96000,
        text: 'มะนังตายอ',
        value: 'มะนังตายอ',
        name: {
          th: 'มะนังตายอ',
          en: 'Manang Tayo',
        },
        districtId: 985,
      },
      {
        id: '960104',
        zipcode: 96000,
        text: 'บางปอ',
        value: 'บางปอ',
        name: {
          th: 'บางปอ',
          en: 'Bang Po',
        },
        districtId: 985,
      },
      {
        id: '960105',
        zipcode: 96000,
        text: 'กะลุวอ',
        value: 'กะลุวอ',
        name: {
          th: 'กะลุวอ',
          en: 'Kaluwo',
        },
        districtId: 985,
      },
      {
        id: '960106',
        zipcode: 96000,
        text: 'กะลุวอเหนือ',
        value: 'กะลุวอเหนือ',
        name: {
          th: 'กะลุวอเหนือ',
          en: 'Kaluwo Nuea',
        },
        districtId: 985,
      },
      {
        id: '960107',
        zipcode: 96000,
        text: 'โคกเคียน',
        value: 'โคกเคียน',
        name: {
          th: 'โคกเคียน',
          en: 'Khok Khian',
        },
        districtId: 985,
      },
      {
        id: '960201',
        zipcode: 96110,
        text: 'เจ๊ะเห',
        value: 'เจ๊ะเห',
        name: {
          th: 'เจ๊ะเห',
          en: 'Chehe',
        },
        districtId: 986,
      },
      {
        id: '960202',
        zipcode: 96110,
        text: 'ไพรวัน',
        value: 'ไพรวัน',
        name: {
          th: 'ไพรวัน',
          en: 'Phrai Wan',
        },
        districtId: 986,
      },
      {
        id: '960203',
        zipcode: 96110,
        text: 'พร่อน',
        value: 'พร่อน',
        name: {
          th: 'พร่อน',
          en: 'Phron',
        },
        districtId: 986,
      },
      {
        id: '960204',
        zipcode: 96110,
        text: 'ศาลาใหม่',
        value: 'ศาลาใหม่',
        name: {
          th: 'ศาลาใหม่',
          en: 'Sala Mai',
        },
        districtId: 986,
      },
      {
        id: '960205',
        zipcode: 96110,
        text: 'บางขุนทอง',
        value: 'บางขุนทอง',
        name: {
          th: 'บางขุนทอง',
          en: 'Bang Khun Thong',
        },
        districtId: 986,
      },
      {
        id: '960206',
        zipcode: 96110,
        text: 'เกาะสะท้อน',
        value: 'เกาะสะท้อน',
        name: {
          th: 'เกาะสะท้อน',
          en: 'Ko Sathon',
        },
        districtId: 986,
      },
      {
        id: '960207',
        zipcode: 96110,
        text: 'นานาค',
        value: 'นานาค',
        name: {
          th: 'นานาค',
          en: 'Na Nak',
        },
        districtId: 986,
      },
      {
        id: '960208',
        zipcode: 96110,
        text: 'โฆษิต',
        value: 'โฆษิต',
        name: {
          th: 'โฆษิต',
          en: 'Khosit',
        },
        districtId: 986,
      },
      {
        id: '960301',
        zipcode: 96170,
        text: 'บาเจาะ',
        value: 'บาเจาะ',
        name: {
          th: 'บาเจาะ',
          en: 'Bacho',
        },
        districtId: 987,
      },
      {
        id: '960302',
        zipcode: 96170,
        text: 'ลุโบะสาวอ',
        value: 'ลุโบะสาวอ',
        name: {
          th: 'ลุโบะสาวอ',
          en: 'Lubo Sawo',
        },
        districtId: 987,
      },
      {
        id: '960303',
        zipcode: 96170,
        text: 'กาเยาะมาตี',
        value: 'กาเยาะมาตี',
        name: {
          th: 'กาเยาะมาตี',
          en: 'Kayo Mati',
        },
        districtId: 987,
      },
      {
        id: '960304',
        zipcode: 96170,
        text: 'ปะลุกาสาเมาะ',
        value: 'ปะลุกาสาเมาะ',
        name: {
          th: 'ปะลุกาสาเมาะ',
          en: 'Paluka Samo',
        },
        districtId: 987,
      },
      {
        id: '960305',
        zipcode: 96170,
        text: 'บาเระเหนือ',
        value: 'บาเระเหนือ',
        name: {
          th: 'บาเระเหนือ',
          en: 'Bare Nuea',
        },
        districtId: 987,
      },
      {
        id: '960306',
        zipcode: 96170,
        text: 'บาเระใต้',
        value: 'บาเระใต้',
        name: {
          th: 'บาเระใต้',
          en: 'Ba Re Tai',
        },
        districtId: 987,
      },
      {
        id: '960401',
        zipcode: 96180,
        text: 'ยี่งอ',
        value: 'ยี่งอ',
        name: {
          th: 'ยี่งอ',
          en: 'Yi-ngo',
        },
        districtId: 988,
      },
      {
        id: '960402',
        zipcode: 96180,
        text: 'ละหาร',
        value: 'ละหาร',
        name: {
          th: 'ละหาร',
          en: 'Lahan',
        },
        districtId: 988,
      },
      {
        id: '960403',
        zipcode: 96180,
        text: 'จอเบาะ',
        value: 'จอเบาะ',
        name: {
          th: 'จอเบาะ',
          en: 'Chobo',
        },
        districtId: 988,
      },
      {
        id: '960404',
        zipcode: 96180,
        text: 'ลุโบะบายะ',
        value: 'ลุโบะบายะ',
        name: {
          th: 'ลุโบะบายะ',
          en: 'Lubo Baya',
        },
        districtId: 988,
      },
      {
        id: '960405',
        zipcode: 96180,
        text: 'ลุโบะบือซา',
        value: 'ลุโบะบือซา',
        name: {
          th: 'ลุโบะบือซา',
          en: 'Lubo Buesa',
        },
        districtId: 988,
      },
      {
        id: '960406',
        zipcode: 96180,
        text: 'ตะปอเยาะ',
        value: 'ตะปอเยาะ',
        name: {
          th: 'ตะปอเยาะ',
          en: 'Tapoyo',
        },
        districtId: 988,
      },
      {
        id: '960501',
        zipcode: 96130,
        text: 'ตันหยงมัส',
        value: 'ตันหยงมัส',
        name: {
          th: 'ตันหยงมัส',
          en: 'Tanyong Mat',
        },
        districtId: 989,
      },
      {
        id: '960502',
        zipcode: 96130,
        text: 'ตันหยงลิมอ',
        value: 'ตันหยงลิมอ',
        name: {
          th: 'ตันหยงลิมอ',
          en: 'Tanyong Limo',
        },
        districtId: 989,
      },
      {
        id: '960506',
        zipcode: 96220,
        text: 'บองอ',
        value: 'บองอ',
        name: {
          th: 'บองอ',
          en: 'Bo-ngo',
        },
        districtId: 989,
      },
      {
        id: '960507',
        zipcode: 96130,
        text: 'กาลิซา',
        value: 'กาลิซา',
        name: {
          th: 'กาลิซา',
          en: 'Kalisa',
        },
        districtId: 989,
      },
      {
        id: '960508',
        zipcode: 96130,
        text: 'บาโงสะโต',
        value: 'บาโงสะโต',
        name: {
          th: 'บาโงสะโต',
          en: 'Ba-ngo Sato',
        },
        districtId: 989,
      },
      {
        id: '960509',
        zipcode: 96130,
        text: 'เฉลิม',
        value: 'เฉลิม',
        name: {
          th: 'เฉลิม',
          en: 'Chaloem',
        },
        districtId: 989,
      },
      {
        id: '960510',
        zipcode: 96130,
        text: 'มะรือโบตก',
        value: 'มะรือโบตก',
        name: {
          th: 'มะรือโบตก',
          en: 'Maruebo Tok',
        },
        districtId: 989,
      },
      {
        id: '960601',
        zipcode: 96150,
        text: 'รือเสาะ',
        value: 'รือเสาะ',
        name: {
          th: 'รือเสาะ',
          en: 'Rueso',
        },
        districtId: 990,
      },
      {
        id: '960602',
        zipcode: 96150,
        text: 'สาวอ',
        value: 'สาวอ',
        name: {
          th: 'สาวอ',
          en: 'Sawo',
        },
        districtId: 990,
      },
      {
        id: '960603',
        zipcode: 96150,
        text: 'เรียง',
        value: 'เรียง',
        name: {
          th: 'เรียง',
          en: 'Riang',
        },
        districtId: 990,
      },
      {
        id: '960604',
        zipcode: 96150,
        text: 'สามัคคี',
        value: 'สามัคคี',
        name: {
          th: 'สามัคคี',
          en: 'Samakkhi',
        },
        districtId: 990,
      },
      {
        id: '960605',
        zipcode: 96150,
        text: 'บาตง',
        value: 'บาตง',
        name: {
          th: 'บาตง',
          en: 'Batong',
        },
        districtId: 990,
      },
      {
        id: '960606',
        zipcode: 96150,
        text: 'ลาโละ',
        value: 'ลาโละ',
        name: {
          th: 'ลาโละ',
          en: 'Lalo',
        },
        districtId: 990,
      },
      {
        id: '960607',
        zipcode: 96150,
        text: 'รือเสาะออก',
        value: 'รือเสาะออก',
        name: {
          th: 'รือเสาะออก',
          en: 'Rueso Ok',
        },
        districtId: 990,
      },
      {
        id: '960608',
        zipcode: 96150,
        text: 'โคกสะตอ',
        value: 'โคกสะตอ',
        name: {
          th: 'โคกสะตอ',
          en: 'Khok Sato',
        },
        districtId: 990,
      },
      {
        id: '960609',
        zipcode: 96150,
        text: 'สุวารี',
        value: 'สุวารี',
        name: {
          th: 'สุวารี',
          en: 'Suwari',
        },
        districtId: 990,
      },
      {
        id: '960701',
        zipcode: 96210,
        text: 'ซากอ',
        value: 'ซากอ',
        name: {
          th: 'ซากอ',
          en: 'Sako',
        },
        districtId: 991,
      },
      {
        id: '960702',
        zipcode: 96210,
        text: 'ตะมะยูง',
        value: 'ตะมะยูง',
        name: {
          th: 'ตะมะยูง',
          en: 'Tamayung',
        },
        districtId: 991,
      },
      {
        id: '960703',
        zipcode: 96210,
        text: 'ศรีสาคร',
        value: 'ศรีสาคร',
        name: {
          th: 'ศรีสาคร',
          en: 'Si Sakhon',
        },
        districtId: 991,
      },
      {
        id: '960704',
        zipcode: 96210,
        text: 'เชิงคีรี',
        value: 'เชิงคีรี',
        name: {
          th: 'เชิงคีรี',
          en: 'Choeng Khiri',
        },
        districtId: 991,
      },
      {
        id: '960705',
        zipcode: 96210,
        text: 'กาหลง',
        value: 'กาหลง',
        name: {
          th: 'กาหลง',
          en: 'Kalong',
        },
        districtId: 991,
      },
      {
        id: '960706',
        zipcode: 96210,
        text: 'ศรีบรรพต',
        value: 'ศรีบรรพต',
        name: {
          th: 'ศรีบรรพต',
          en: 'Si Banphot',
        },
        districtId: 991,
      },
      {
        id: '960801',
        zipcode: 96160,
        text: 'แว้ง',
        value: 'แว้ง',
        name: {
          th: 'แว้ง',
          en: 'Waeng',
        },
        districtId: 992,
      },
      {
        id: '960802',
        zipcode: 96160,
        text: 'กายูคละ',
        value: 'กายูคละ',
        name: {
          th: 'กายูคละ',
          en: 'Kayu Khla',
        },
        districtId: 992,
      },
      {
        id: '960803',
        zipcode: 96160,
        text: 'ฆอเลาะ',
        value: 'ฆอเลาะ',
        name: {
          th: 'ฆอเลาะ',
          en: 'Kholo',
        },
        districtId: 992,
      },
      {
        id: '960804',
        zipcode: 96160,
        text: 'โละจูด',
        value: 'โละจูด',
        name: {
          th: 'โละจูด',
          en: 'Lochut',
        },
        districtId: 992,
      },
      {
        id: '960805',
        zipcode: 96160,
        text: 'แม่ดง',
        value: 'แม่ดง',
        name: {
          th: 'แม่ดง',
          en: 'Mae Dong',
        },
        districtId: 992,
      },
      {
        id: '960806',
        zipcode: 96160,
        text: 'เอราวัณ',
        value: 'เอราวัณ',
        name: {
          th: 'เอราวัณ',
          en: 'Erawan',
        },
        districtId: 992,
      },
      {
        id: '960901',
        zipcode: 96190,
        text: 'มาโมง',
        value: 'มาโมง',
        name: {
          th: 'มาโมง',
          en: 'Mamong',
        },
        districtId: 993,
      },
      {
        id: '960902',
        zipcode: 96190,
        text: 'สุคิริน',
        value: 'สุคิริน',
        name: {
          th: 'สุคิริน',
          en: 'Sukhirin',
        },
        districtId: 993,
      },
      {
        id: '960903',
        zipcode: 96190,
        text: 'เกียร์',
        value: 'เกียร์',
        name: {
          th: 'เกียร์',
          en: 'Kia',
        },
        districtId: 993,
      },
      {
        id: '960904',
        zipcode: 96190,
        text: 'ภูเขาทอง',
        value: 'ภูเขาทอง',
        name: {
          th: 'ภูเขาทอง',
          en: 'Phukhao Thong',
        },
        districtId: 993,
      },
      {
        id: '960905',
        zipcode: 96190,
        text: 'ร่มไทร',
        value: 'ร่มไทร',
        name: {
          th: 'ร่มไทร',
          en: 'Rom Sai',
        },
        districtId: 993,
      },
      {
        id: '961001',
        zipcode: 96120,
        text: 'สุไหงโก-ลก',
        value: 'สุไหงโก-ลก',
        name: {
          th: 'สุไหงโก-ลก',
          en: 'Su-ngai Kolok',
        },
        districtId: 994,
      },
      {
        id: '961002',
        zipcode: 96120,
        text: 'ปาเสมัส',
        value: 'ปาเสมัส',
        name: {
          th: 'ปาเสมัส',
          en: 'Pase Mat',
        },
        districtId: 994,
      },
      {
        id: '961003',
        zipcode: 96120,
        text: 'มูโนะ',
        value: 'มูโนะ',
        name: {
          th: 'มูโนะ',
          en: 'Muno',
        },
        districtId: 994,
      },
      {
        id: '961004',
        zipcode: 96120,
        text: 'ปูโยะ',
        value: 'ปูโยะ',
        name: {
          th: 'ปูโยะ',
          en: 'Puyo',
        },
        districtId: 994,
      },
      {
        id: '961101',
        zipcode: 96140,
        text: 'ปะลุรู',
        value: 'ปะลุรู',
        name: {
          th: 'ปะลุรู',
          en: 'Paluru',
        },
        districtId: 995,
      },
      {
        id: '961102',
        zipcode: 96140,
        text: 'สุไหงปาดี',
        value: 'สุไหงปาดี',
        name: {
          th: 'สุไหงปาดี',
          en: 'Su-ngai Padi',
        },
        districtId: 995,
      },
      {
        id: '961103',
        zipcode: 96140,
        text: 'โต๊ะเด็ง',
        value: 'โต๊ะเด็ง',
        name: {
          th: 'โต๊ะเด็ง',
          en: 'To Deng',
        },
        districtId: 995,
      },
      {
        id: '961104',
        zipcode: 96140,
        text: 'สากอ',
        value: 'สากอ',
        name: {
          th: 'สากอ',
          en: 'Sako',
        },
        districtId: 995,
      },
      {
        id: '961105',
        zipcode: 96140,
        text: 'ริโก๋',
        value: 'ริโก๋',
        name: {
          th: 'ริโก๋',
          en: 'Riko',
        },
        districtId: 995,
      },
      {
        id: '961106',
        zipcode: 96140,
        text: 'กาวะ',
        value: 'กาวะ',
        name: {
          th: 'กาวะ',
          en: 'Ka Wa',
        },
        districtId: 995,
      },
      {
        id: '961201',
        zipcode: 96220,
        text: 'จะแนะ',
        value: 'จะแนะ',
        name: {
          th: 'จะแนะ',
          en: 'Chanae',
        },
        districtId: 996,
      },
      {
        id: '961202',
        zipcode: 96220,
        text: 'ดุซงญอ',
        value: 'ดุซงญอ',
        name: {
          th: 'ดุซงญอ',
          en: 'Dusong Yo',
        },
        districtId: 996,
      },
      {
        id: '961203',
        zipcode: 96220,
        text: 'ผดุงมาตร',
        value: 'ผดุงมาตร',
        name: {
          th: 'ผดุงมาตร',
          en: 'Phadung Mat',
        },
        districtId: 996,
      },
      {
        id: '961204',
        zipcode: 96220,
        text: 'ช้างเผือก',
        value: 'ช้างเผือก',
        name: {
          th: 'ช้างเผือก',
          en: 'Chang Phueak',
        },
        districtId: 996,
      },
      {
        id: '961301',
        zipcode: 96130,
        text: 'จวบ',
        value: 'จวบ',
        name: {
          th: 'จวบ',
          en: 'Chuap',
        },
        districtId: 997,
      },
      {
        id: '961302',
        zipcode: 96130,
        text: 'บูกิต',
        value: 'บูกิต',
        name: {
          th: 'บูกิต',
          en: 'Bukit',
        },
        districtId: 997,
      },
      {
        id: '961303',
        zipcode: 96130,
        text: 'มะรือโบออก',
        value: 'มะรือโบออก',
        name: {
          th: 'มะรือโบออก',
          en: 'Maruebo Ok',
        },
        districtId: 997,
      },
      {
        id: '380101',
        zipcode: 38000,
        text: 'คำนาดี',
        value: 'คำนาดี',
        name: {
          th: 'คำนาดี',
          en: 'Kham Na Di',
        },
        districtId: 999,
      },
      {
        id: '380102',
        zipcode: 38000,
        text: 'บึงโขงหลง',
        value: 'บึงโขงหลง',
        name: {
          th: 'บึงโขงหลง',
          en: 'Bueng Khong Long',
        },
        districtId: 999,
      },
      {
        id: '380103',
        zipcode: 38000,
        text: 'ไคสี',
        value: 'ไคสี',
        name: {
          th: 'ไคสี',
          en: 'Khai Si',
        },
        districtId: 999,
      },
      {
        id: '380104',
        zipcode: 38000,
        text: 'ชัยพร',
        value: 'ชัยพร',
        name: {
          th: 'ชัยพร',
          en: 'Chaiyaphon',
        },
        districtId: 999,
      },
      {
        id: '380105',
        zipcode: 38000,
        text: 'นาสวรรค์',
        value: 'นาสวรรค์',
        name: {
          th: 'นาสวรรค์',
          en: 'Na Sawan',
        },
        districtId: 999,
      },
      {
        id: '380106',
        zipcode: 38000,
        text: 'โนนสมบูรณ์',
        value: 'โนนสมบูรณ์',
        name: {
          th: 'โนนสมบูรณ์',
          en: 'Non Sombun',
        },
        districtId: 999,
      },
      {
        id: '380107',
        zipcode: 38000,
        text: 'บึงกาฬ',
        value: 'บึงกาฬ',
        name: {
          th: 'บึงกาฬ',
          en: 'Bueng Kan',
        },
        districtId: 999,
      },
      {
        id: '380108',
        zipcode: 38000,
        text: 'โป่งเปื่อย',
        value: 'โป่งเปื่อย',
        name: {
          th: 'โป่งเปื่อย',
          en: 'Pong Pueai',
        },
        districtId: 999,
      },
      {
        id: '380109',
        zipcode: 38000,
        text: 'วิศิษฐ์',
        value: 'วิศิษฐ์',
        name: {
          th: 'วิศิษฐ์',
          en: 'Wisit',
        },
        districtId: 999,
      },
      {
        id: '380110',
        zipcode: 38000,
        text: 'หนองเข็ง',
        value: 'หนองเข็ง',
        name: {
          th: 'หนองเข็ง',
          en: 'Nong Keng',
        },
        districtId: 999,
      },
      {
        id: '380111',
        zipcode: 38000,
        text: 'หนองเลิง',
        value: 'หนองเลิง',
        name: {
          th: 'หนองเลิง',
          en: 'Nong Loeng',
        },
        districtId: 999,
      },
      {
        id: '380112',
        zipcode: 38000,
        text: 'หอคำ',
        value: 'หอคำ',
        name: {
          th: 'หอคำ',
          en: 'Ho Kham',
        },
        districtId: 999,
      },
      {
        id: '380201',
        zipcode: 38150,
        text: 'ซาง',
        value: 'ซาง',
        name: {
          th: 'ซาง',
          en: 'Sang',
        },
        districtId: 1000,
      },
      {
        id: '380202',
        zipcode: 38150,
        text: 'เซกา',
        value: 'เซกา',
        name: {
          th: 'เซกา',
          en: 'Seka',
        },
        districtId: 1000,
      },
      {
        id: '380203',
        zipcode: 38150,
        text: 'ท่ากกแดง',
        value: 'ท่ากกแดง',
        name: {
          th: 'ท่ากกแดง',
          en: 'Tha Kok Daeng',
        },
        districtId: 1000,
      },
      {
        id: '380204',
        zipcode: 38150,
        text: 'ท่าสะอาด',
        value: 'ท่าสะอาด',
        name: {
          th: 'ท่าสะอาด',
          en: 'Tha Sa-at',
        },
        districtId: 1000,
      },
      {
        id: '380205',
        zipcode: 38150,
        text: 'น้ำจั้น',
        value: 'น้ำจั้น',
        name: {
          th: 'น้ำจั้น',
          en: 'Nam Chan',
        },
        districtId: 1000,
      },
      {
        id: '380206',
        zipcode: 38150,
        text: 'บ้านต้อง',
        value: 'บ้านต้อง',
        name: {
          th: 'บ้านต้อง',
          en: 'Ban Tong',
        },
        districtId: 1000,
      },
      {
        id: '380207',
        zipcode: 38150,
        text: 'ป่งไฮ',
        value: 'ป่งไฮ',
        name: {
          th: 'ป่งไฮ',
          en: 'Pong Hai',
        },
        districtId: 1000,
      },
      {
        id: '380208',
        zipcode: 38150,
        text: 'โสกก่าม',
        value: 'โสกก่าม',
        name: {
          th: 'โสกก่าม',
          en: 'Sok Kam',
        },
        districtId: 1000,
      },
      {
        id: '380209',
        zipcode: 38150,
        text: 'หนองทุ่ม',
        value: 'หนองทุ่ม',
        name: {
          th: 'หนองทุ่ม',
          en: 'Nong Thum',
        },
        districtId: 1000,
      },
      {
        id: '380301',
        zipcode: 38170,
        text: 'คำแก้ว',
        value: 'คำแก้ว',
        name: {
          th: 'คำแก้ว',
          en: 'Kham Kaeo',
        },
        districtId: 1001,
      },
      {
        id: '380302',
        zipcode: 38170,
        text: 'โซ่',
        value: 'โซ่',
        name: {
          th: 'โซ่',
          en: 'So',
        },
        districtId: 1001,
      },
      {
        id: '380303',
        zipcode: 38170,
        text: 'ถ้ำเจริญ',
        value: 'ถ้ำเจริญ',
        name: {
          th: 'ถ้ำเจริญ',
          en: 'Tham Charoen',
        },
        districtId: 1001,
      },
      {
        id: '380304',
        zipcode: 38170,
        text: 'บัวตูม',
        value: 'บัวตูม',
        name: {
          th: 'บัวตูม',
          en: 'Bua Tum',
        },
        districtId: 1001,
      },
      {
        id: '380305',
        zipcode: 38170,
        text: 'ศรีชมภู',
        value: 'ศรีชมภู',
        name: {
          th: 'ศรีชมภู',
          en: 'Si Chomphu',
        },
        districtId: 1001,
      },
      {
        id: '380306',
        zipcode: 38170,
        text: 'หนองพันทา',
        value: 'หนองพันทา',
        name: {
          th: 'หนองพันทา',
          en: 'Nong Phan Tha',
        },
        districtId: 1001,
      },
      {
        id: '380307',
        zipcode: 38170,
        text: 'เหล่าทอง',
        value: 'เหล่าทอง',
        name: {
          th: 'เหล่าทอง',
          en: 'Lao Thong',
        },
        districtId: 1001,
      },
      {
        id: '380401',
        zipcode: 38180,
        text: 'ดอนหญ้านาง',
        value: 'ดอนหญ้านาง',
        name: {
          th: 'ดอนหญ้านาง',
          en: 'Don Ya Nang',
        },
        districtId: 1002,
      },
      {
        id: '380402',
        zipcode: 38180,
        text: 'ป่าแฝก',
        value: 'ป่าแฝก',
        name: {
          th: 'ป่าแฝก',
          en: 'Pa Faek',
        },
        districtId: 1002,
      },
      {
        id: '380403',
        zipcode: 38180,
        text: 'พรเจริญ',
        value: 'พรเจริญ',
        name: {
          th: 'พรเจริญ',
          en: 'Phon Charoen',
        },
        districtId: 1002,
      },
      {
        id: '380404',
        zipcode: 38180,
        text: 'วังชมภู',
        value: 'วังชมภู',
        name: {
          th: 'วังชมภู',
          en: 'Wang Chomphu',
        },
        districtId: 1002,
      },
      {
        id: '380405',
        zipcode: 38180,
        text: 'ศรีชมภู',
        value: 'ศรีชมภู',
        name: {
          th: 'ศรีชมภู',
          en: 'Si Chomphu',
        },
        districtId: 1002,
      },
      {
        id: '380406',
        zipcode: 38180,
        text: 'ศรีสำราญ',
        value: 'ศรีสำราญ',
        name: {
          th: 'ศรีสำราญ',
          en: 'Si Samran',
        },
        districtId: 1002,
      },
      {
        id: '380407',
        zipcode: 38180,
        text: 'หนองหัวช้าง',
        value: 'หนองหัวช้าง',
        name: {
          th: 'หนองหัวช้าง',
          en: 'Nong Hua Chang',
        },
        districtId: 1002,
      },
      {
        id: '380501',
        zipcode: 38210,
        text: 'ชุมภูพร',
        value: 'ชุมภูพร',
        name: {
          th: 'ชุมภูพร',
          en: 'Chumphu Phon',
        },
        districtId: 1003,
      },
      {
        id: '380502',
        zipcode: 38210,
        text: 'นาสะแบง',
        value: 'นาสะแบง',
        name: {
          th: 'นาสะแบง',
          en: 'Na Sabaeng',
        },
        districtId: 1003,
      },
      {
        id: '380503',
        zipcode: 38210,
        text: 'นาสิงห์',
        value: 'นาสิงห์',
        name: {
          th: 'นาสิงห์',
          en: 'Na Sing',
        },
        districtId: 1003,
      },
      {
        id: '380504',
        zipcode: 38210,
        text: 'นาแสง',
        value: 'นาแสง',
        name: {
          th: 'นาแสง',
          en: 'Na Saeng',
        },
        districtId: 1003,
      },
      {
        id: '380505',
        zipcode: 38210,
        text: 'ศรีวิไล',
        value: 'ศรีวิไล',
        name: {
          th: 'ศรีวิไล',
          en: 'Si Wilai',
        },
        districtId: 1003,
      },
      {
        id: '380601',
        zipcode: 38220,
        text: 'ดงบัง',
        value: 'ดงบัง',
        name: {
          th: 'ดงบัง',
          en: 'Dong Bang',
        },
        districtId: 1004,
      },
      {
        id: '380602',
        zipcode: 38220,
        text: 'ท่าดอกคำ',
        value: 'ท่าดอกคำ',
        name: {
          th: 'ท่าดอกคำ',
          en: 'Tha Dok Kham',
        },
        districtId: 1004,
      },
      {
        id: '380603',
        zipcode: 38220,
        text: 'บึงโขงหลง',
        value: 'บึงโขงหลง',
        name: {
          th: 'บึงโขงหลง',
          en: 'Bueng Khong Long',
        },
        districtId: 1004,
      },
      {
        id: '380604',
        zipcode: 38220,
        text: 'โพธิ์หมากแข้ง',
        value: 'โพธิ์หมากแข้ง',
        name: {
          th: 'โพธิ์หมากแข้ง',
          en: 'Pho Mak Khaeng',
        },
        districtId: 1004,
      },
      {
        id: '380701',
        zipcode: 38190,
        text: 'นากั้ง',
        value: 'นากั้ง',
        name: {
          th: 'นากั้ง',
          en: 'Na Kang',
        },
        districtId: 1005,
      },
      {
        id: '380702',
        zipcode: 38190,
        text: 'นาดง',
        value: 'นาดง',
        name: {
          th: 'นาดง',
          en: 'Na Dong',
        },
        districtId: 1005,
      },
      {
        id: '380703',
        zipcode: 38190,
        text: 'โนนศิลา',
        value: 'โนนศิลา',
        name: {
          th: 'โนนศิลา',
          en: 'Non Sila',
        },
        districtId: 1005,
      },
      {
        id: '380704',
        zipcode: 38190,
        text: 'ปากคาด',
        value: 'ปากคาด',
        name: {
          th: 'ปากคาด',
          en: 'Pak Khat',
        },
        districtId: 1005,
      },
      {
        id: '380705',
        zipcode: 38190,
        text: 'สมสนุก',
        value: 'สมสนุก',
        name: {
          th: 'สมสนุก',
          en: 'Som Sanuk',
        },
        districtId: 1005,
      },
      {
        id: '380706',
        zipcode: 38190,
        text: 'หนองยอง',
        value: 'หนองยอง',
        name: {
          th: 'หนองยอง',
          en: 'Nong Yong',
        },
        districtId: 1005,
      },
      {
        id: '380801',
        zipcode: 38000,
        text: 'โคกกว้าง',
        value: 'โคกกว้าง',
        name: {
          th: 'โคกกว้าง',
          en: 'Khok Kwang',
        },
        districtId: 1006,
      },
      {
        id: '380802',
        zipcode: 38000,
        text: 'บุ่งคล้า',
        value: 'บุ่งคล้า',
        name: {
          th: 'บุ่งคล้า',
          en: 'Bung Khla',
        },
        districtId: 1006,
      },
      {
        id: '380803',
        zipcode: 38000,
        text: 'หนองเดิน',
        value: 'หนองเดิน',
        name: {
         th: 'หนองเดิน',
         en: 'Nong Doen',
        },
        districtId: 1006,
       },
    ],
  }
}
